var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// stitches.config.ts
import { createStitches, defaultThemeMap } from "@stitches/react";

// design-tokens/generated/tokens.ts
var tokens_default = {
  "Color Primitives": {
    colors: {
      blue05: "#ecf3fe",
      blue10: "#e3edff",
      blue20: "#aacaff",
      blue30: "#71a8ff",
      blue40: "#3988ff",
      blue50: "#106af2",
      blue60: "#0053d2",
      blue70: "#003da6",
      blue80: "#002a79",
      blue90: "#00194d",
      amber50: "#ffbc00",
      green10: "#e3fae8",
      green20: "#aaebba",
      green30: "#71d78e",
      green40: "#3ebf65",
      green50: "#12a13d",
      green60: "#008f2b",
      green70: "#00761c",
      green80: "#005610",
      green90: "#002f07",
      neutral00: "#ffffff",
      neutral05: "#f3f7fa",
      neutral10: "#ecf1f7",
      neutral100: "#0f1317",
      neutral20: "#d7e1ed",
      neutral30: "#cad5e5",
      neutral40: "#bcc9de",
      neutral50: "#a1adc4",
      neutral60: "#7b8ba3",
      neutral70: "#505e71",
      neutral80: "#35414e",
      neutral90: "#1f272f",
      purple10: "#efe6ff",
      purple20: "#d0b8ff",
      purple30: "#b490ff",
      purple40: "#996df8",
      purple50: "#804fea",
      purple60: "#723fde",
      purple70: "#4a1aa6",
      purple80: "#330a79",
      purple90: "#1e014d",
      red10: "#ffe3e3",
      red20: "#ffaeaa",
      red30: "#fb7e76",
      red40: "#ee544a",
      red50: "#db3025",
      red60: "#be2109",
      red70: "#c7170c",
      red80: "#790000",
      red90: "#4d0000",
      yellow10: "#fff5e3",
      yellow20: "#ffdfaa",
      yellow30: "#ffc871",
      yellow40: "#ffaf39",
      yellow50: "#f0950c",
      yellow60: "#cc6e00",
      yellow70: "#994700",
      yellow80: "#662500",
      yellow90: "#330c00"
    },
    numbers: {}
  },
  "Color Semantic (System)": {
    colors: {
      accordion_icon_active: "$neutral90",
      accordion_icon_enabled: "$neutral90",
      accordion_icon_hover: "$neutral90",
      accordion_text_active: "$neutral90",
      accordion_text_enabled: "$neutral90",
      accordion_text_hover: "$neutral90",
      avatar_icon: "$neutral30",
      avatar_surface: "$neutral80",
      badge_surface_blue: "#aacaff3d",
      badge_surface_green: "#71d78e3d",
      badge_surface_neutral: "#a1adc43d",
      badge_surface_purple: "#b490ff3d",
      badge_surface_red: "#fb7e763d",
      badge_surface_yellow: "#ffc8713d",
      badge_text_blue: "$blue60",
      badge_text_green: "$green60",
      badge_text_neutral: "$neutral70",
      badge_text_purple: "$purple60",
      badge_text_red: "$red60",
      badge_text_yellow: "$yellow60",
      breadcrumb_text: "$text_secondary",
      button_danger_icon_active: "$neutral00",
      button_danger_icon_enabled: "$neutral00",
      button_danger_icon_focus: "$neutral00",
      button_danger_icon_hover: "$neutral00",
      button_danger_ring_focus: "#db30255c",
      button_danger_surface_active: "#d42c22",
      button_danger_surface_enabled: "$red50",
      button_danger_surface_focus: "$red50",
      button_danger_surface_hover: "#e45b52",
      button_danger_text_active: "$neutral00",
      button_danger_text_enabled: "$neutral00",
      button_danger_text_focus: "$neutral00",
      button_danger_text_hover: "$neutral00",
      button_default_icon_active: "$neutral80",
      button_default_icon_enabled: "$neutral80",
      button_default_icon_focus: "$neutral80",
      button_default_icon_hover: "$neutral80",
      button_default_ring_focus: "#106af25c",
      button_default_surface_active: "#cad4e0",
      button_default_surface_enabled: "$neutral20",
      button_default_surface_focus: "$neutral20",
      button_default_surface_hover: "#e1e8f1",
      button_default_text_active: "$neutral80",
      button_default_text_enabled: "$neutral80",
      button_default_text_focus: "$neutral80",
      button_default_text_hover: "$neutral80",
      button_group_default_seperator: "#35414e3d",
      button_group_disabled_seperator: "#35414e29",
      button_group_primary_seperator: "#e3edff3d",
      button_icon_disabled: "#35414e7a",
      button_primary_icon_active: "$neutral00",
      button_primary_icon_enabled: "$neutral00",
      button_primary_icon_focus: "$neutral00",
      button_primary_icon_hover: "$neutral00",
      button_primary_ring_focus: "#106af25c",
      button_primary_surface_active: "#0d60de",
      button_primary_surface_enabled: "$blue50",
      button_primary_surface_focus: "$blue50",
      button_primary_surface_hover: "#317ff4",
      button_primary_text_active: "$neutral00",
      button_primary_text_enabled: "$neutral00",
      button_primary_text_focus: "$neutral00",
      button_primary_text_hover: "$neutral00",
      button_subtle_icon_active: "$neutral70",
      button_subtle_icon_disabled: "#35414e7a",
      button_subtle_icon_enabled: "$neutral70",
      button_subtle_icon_focus: "$neutral70",
      button_subtle_icon_hover: "$neutral70",
      button_subtle_ring_focus: "#106af25c",
      button_subtle_surface_active: "#505e713d",
      button_subtle_surface_disabled: "#ffffff00",
      button_subtle_surface_enabled: "#ffffff00",
      button_subtle_surface_focus: "#ffffff00",
      button_subtle_surface_hover: "#505e7129",
      button_subtle_text_active: "$neutral70",
      button_subtle_text_disabled: "#35414e7a",
      button_subtle_text_enabled: "$neutral70",
      button_subtle_text_focus: "$neutral70",
      button_subtle_text_hover: "$neutral70",
      button_surface_disabled: "#d7e1eda3",
      button_text_disabled: "#35414e7a",
      button_warning_icon_active: "$neutral90",
      button_warning_icon_enabled: "$neutral90",
      button_warning_icon_focus: "$neutral90",
      button_warning_icon_hover: "$neutral90",
      button_warning_ring_focus: "#f0950c5c",
      button_warning_surface_active: "#e58c0b",
      button_warning_surface_enabled: "$yellow50",
      button_warning_surface_focus: "$yellow50",
      button_warning_surface_hover: "#f4ac3f",
      button_warning_text_active: "$neutral90",
      button_warning_text_enabled: "$neutral90",
      button_warning_text_focus: "$neutral90",
      button_warning_text_hover: "$neutral90",
      button_filter_empty_border_active: "#35414e3d",
      button_filter_empty_border_enabled: "#35414e3d",
      button_filter_empty_border_focus: "$blue50",
      button_filter_empty_border_hover: "#35414e3d",
      button_filter_empty_dismiss_icon: "#505e71b8",
      button_filter_empty_icon_active: "$neutral80",
      button_filter_empty_icon_enabled: "$neutral80",
      button_filter_empty_icon_focus: "$neutral80",
      button_filter_empty_icon_hover: "$neutral80",
      button_filter_empty_ring_focus: "$state_focus_ring_primary",
      button_filter_empty_surface_active: "#1f252c1f",
      button_filter_empty_surface_enabled: "#ffffff00",
      button_filter_empty_surface_focus: "#ffffff00",
      button_filter_empty_surface_hover: "#1f252c14",
      button_filter_empty_text_active: "$neutral80",
      button_filter_empty_text_enabled: "$neutral80",
      button_filter_empty_text_focus: "$neutral80",
      button_filter_empty_text_hover: "$neutral80",
      button_filter_selected_border_active: "#003da63d",
      button_filter_selected_border_enabled: "#003da63d",
      button_filter_selected_border_focus: "$blue50",
      button_filter_selected_border_hover: "#003da63d",
      button_filter_selected_icon_active: "$blue50",
      button_filter_selected_icon_enabled: "$blue50",
      button_filter_selected_icon_focus: "$blue50",
      button_filter_selected_icon_hover: "$blue50",
      button_filter_selected_ring_focus: "$state_focus_ring_primary",
      button_filter_selected_seperator_focus: "#003da63d",
      button_filter_selected_surface_active: "#aacaffb8",
      button_filter_selected_surface_enabled: "#aacaff5c",
      button_filter_selected_surface_focus: "#aacaff5c",
      button_filter_selected_surface_hover: "#aacaffa3",
      button_filter_selected_text_active: "$blue50",
      button_filter_selected_text_enabled: "$blue50",
      button_filter_selected_text_focus: "$blue50",
      button_filter_selected_text_hover: "$blue50",
      button_filter_seperator_focus: "$blue50",
      button_select_border: "#35414e3d",
      button_select_border_selected: "$blue50",
      button_select_surface_active: "$blue10",
      button_select_surface_disabled: "#d7e1eda3",
      button_select_surface_enabled: "$neutral00",
      button_select_surface_focus: "$neutral00",
      button_select_surface_hover: "$neutral00",
      button_select_surface_selected: "$blue10",
      button_select_text_active: "$blue50",
      button_select_text_disabled: "#35414e7a",
      button_select_text_enabled: "$neutral80",
      button_select_text_focus: "$neutral80",
      button_select_text_hover: "$blue50",
      button_select_text_selected: "$blue50",
      card_border: "$neutral20",
      card_border_selected: "$blue40",
      card_surface: "$neutral00",
      card_surface_active: "$neutral10",
      card_surface_hover: "$neutral05",
      card_surface_selected: "$blue05",
      card_surface_selected_active: "$neutral10",
      card_surface_selected_hover: "$blue10",
      checkbox_checked_ring_focus: "$state_focus_ring_primary",
      checkbox_checked_surface_active: "#0d60de",
      checkbox_checked_surface_enabled: "$blue50",
      checkbox_checked_surface_focus: "$blue50",
      checkbox_checked_surface_hover: "#317ff4",
      checkbox_icon_disabled: "#35414e7a",
      checkbox_icon_enabled: "$neutral00",
      checkbox_indeterminate_ring_focus: "$state_focus_ring_primary",
      checkbox_indeterminate_surface_active: "#0d60de",
      checkbox_indeterminate_surface_enabled: "$blue50",
      checkbox_indeterminate_surface_focus: "$blue50",
      checkbox_indeterminate_surface_hover: "#317ff4",
      checkbox_surface_disabled: "#a1adc43d",
      checkbox_unchecked_border_active: "$neutral50",
      checkbox_unchecked_border_enabled: "$neutral50",
      checkbox_unchecked_border_focus: "$blue50",
      checkbox_unchecked_border_hover: "$neutral50",
      checkbox_unchecked_ring_focus: "$state_focus_ring_primary",
      checkbox_unchecked_surface_active: "$neutral20",
      checkbox_unchecked_surface_enabled: "$neutral00",
      checkbox_unchecked_surface_focus: "#ffffff00",
      checkbox_unchecked_surface_hover: "$neutral10",
      chip_remove_icon_active: "#505e71",
      chip_remove_icon_enabled: "#a1adc4",
      chip_remove_icon_hover: "#7b8ba3",
      chip_surface: "#cad5e57a",
      chip_text: "$neutral70",
      code_snippet_border: "#505e711f",
      code_snippet_surface: "#505e7114",
      code_snippet_text: "$text_primary",
      counter_default_surface: "#cad5e5a3",
      counter_default_text: "$neutral70",
      counter_disabled_surface: "#d7e1eda3",
      counter_disabled_text: "#35414e7a",
      counter_primary_surface: "$blue50",
      counter_primary_text: "$neutral00",
      datepicker_day_surface_selected: "$blue50",
      datepicker_day_text_enabled: "$text_primary",
      datepicker_day_text_nextmonth_enabled: "$neutral60",
      datepicker_day_today_text_enabled: "$blue50",
      datepicker_day_today_text_selected: "$neutral00",
      datepicker_named_day: "$neutral60",
      datepicker_surface: "$surface_primary",
      dropdown_content_selected: "$blue50",
      dropdown_icon_active: "$text_primary",
      dropdown_icon_danger_active: "$red50",
      dropdown_icon_danger_enabled: "$red50",
      dropdown_icon_danger_focus: "$red50",
      dropdown_icon_danger_hover: "$red50",
      dropdown_icon_disabled: "#35414e7a",
      dropdown_icon_enabled: "$text_primary",
      dropdown_icon_focus: "$text_primary",
      dropdown_icon_hover: "$text_primary",
      dropdown_ring_focus: "$state_focus_ring_primary",
      dropdown_section_label: "$neutral60",
      dropdown_surface_active: "#505e713d",
      dropdown_surface_disabled: "$surface_transparent",
      dropdown_surface_enabled: "$surface_transparent",
      dropdown_surface_focus: "$surface_transparent",
      dropdown_surface_hover: "#505e7129",
      dropdown_surface_selected_active: "#aacaffb8",
      dropdown_surface_selected_enabled: "#aacaff5c",
      dropdown_surface_selected_hover: "#aacaffa3",
      dropdown_text_active: "$text_primary",
      dropdown_text_danger_active: "$red50",
      dropdown_text_danger_enabled: "$red50",
      dropdown_text_danger_focus: "$red50",
      dropdown_text_danger_hover: "$red50",
      dropdown_text_disabled: "#35414e7a",
      dropdown_text_enabled: "$text_primary",
      dropdown_text_focus: "$text_primary",
      dropdown_text_hover: "$text_primary",
      hint_count_text: "$neutral60",
      hint_icon_danger: "$red60",
      hint_icon_default: "$neutral60",
      hint_icon_success: "$green60",
      hint_icon_warning: "$yellow60",
      hint_text_danger: "$red60",
      hint_text_default: "$neutral60",
      hint_text_success: "$green60",
      hint_text_warning: "$yellow60",
      icon_blue: "$blue50",
      icon_control_active: "$neutral80",
      icon_control_disabled: "#505e713d",
      icon_control_enabled: "$neutral70",
      icon_control_hover: "$neutral60",
      icon_green: "$green50",
      icon_neutral: "$neutral70",
      icon_primary: "$neutral80",
      icon_purple: "$purple50",
      icon_red: "$red50",
      icon_secondary: "$text_secondary",
      icon_tertiary: "$text_tertiary",
      icon_yellow: "$yellow60",
      label_body_optional_text_disabled: "$neutral50",
      label_body_optional_text_enabled: "$neutral50",
      label_body_text_disabled: "$neutral50",
      label_body_text_enabled: "$neutral90",
      label_header_text_disabled: "$neutral50",
      label_header_text_enabled: "$neutral70",
      label_header_text_optional_disabled: "$neutral50",
      label_header_text_optional_enabled: "$neutral50",
      loader_spinner: "$blue50",
      loader_track: "#cad5e53d",
      logo_fill: "$neutral00",
      naivgation_item_text_hover: "$neutral00",
      navigation_item_icon_enabled: "$neutral50",
      navigation_item_icon_hover: "$neutral00",
      navigation_item_icon_selected: "$neutral00",
      navigation_item_text_enabled: "$neutral50",
      navigation_item_text_selected: "$neutral00",
      navigation_surface: "$neutral100",
      overlay_surface: "#1f272fa3",
      popover_surface: "$neutral00",
      radio_dot_disabled: "#35414e7a",
      radio_selected_dot_active: "$neutral00",
      radio_selected_dot_enabled: "$neutral00",
      radio_selected_dot_focus: "$neutral00",
      radio_selected_dot_hover: "$neutral00",
      radio_selected_ring_focus: "$state_focus_ring_primary",
      radio_selected_surface_active: "#0d60de",
      radio_selected_surface_enabled: "$blue50",
      radio_selected_surface_focus: "$blue50",
      radio_selected_surface_hover: "#317ff4",
      radio_surface_disabled: "#d7e1eda3",
      radio_unselected_border_active: "$neutral50",
      radio_unselected_border_enabled: "$neutral50",
      radio_unselected_border_focus: "$blue50",
      radio_unselected_border_hover: "$neutral50",
      radio_unselected_ring_focus: "$state_focus_ring_primary",
      radio_unselected_surface_active: "$neutral20",
      radio_unselected_surface_enabled: "$neutral00",
      radio_unselected_surface_focus: "$neutral00",
      radio_unselected_surface_hover: "$neutral10",
      scrollbar_handle_surface: "#505e713d",
      scrollbar_track_surface: "$neutral05",
      section_message_dismiss_icon: "$neutral70",
      section_message_icon_danger: "$red70",
      section_message_icon_default: "$neutral80",
      section_message_icon_success: "$green70",
      section_message_icon_warning: "$yellow70",
      section_message_surface_danger: "$red10",
      section_message_surface_default: "$neutral10",
      section_message_surface_success: "$green10",
      section_message_surface_warning: "$yellow10",
      section_message_text_danger: "$red70",
      section_message_text_default: "$neutral80",
      section_message_text_success: "$green70",
      section_message_text_warning: "$yellow70",
      state_focus_ring_primary: "#106af25c",
      stepper_icon_active: "$neutral50",
      stepper_icon_next: "$neutral50",
      stepper_icon_previous: "$neutral50",
      stepper_symbol_border_next: "$neutral50",
      stepper_symbol_surface_active: "$blue50",
      stepper_symbol_surface_next: "#ffffff00",
      stepper_symbol_surface_previous: "$neutral30",
      stepper_symbol_text_active: "$neutral00",
      stepper_symbol_text_next: "$neutral50",
      stepper_symbol_text_previous: "$neutral50",
      stepper_text_active: "$neutral80",
      stepper_text_next: "$neutral50",
      stepper_text_previous: "$neutral50",
      switch_off_knob_active: "$neutral50",
      switch_off_knob_disabled: "#35414e3d",
      switch_off_knob_enabled: "$neutral50",
      switch_off_knob_focus: "$neutral50",
      switch_off_knob_hover: "$neutral50",
      switch_off_ring_focus: "$state_focus_ring_primary",
      switch_off_track_border_active: "$neutral50",
      switch_off_track_border_enabled: "$neutral50",
      switch_off_track_border_focus: "$blue50",
      switch_off_track_border_hover: "$neutral50",
      switch_off_track_surface_active: "#505e713d",
      switch_off_track_surface_disabled: "#a1adc43d",
      switch_off_track_surface_enabled: "#ffffff00",
      switch_off_track_surface_focus: "#ffffff00",
      switch_off_track_surface_hover: "#505e7129",
      switch_on_knob_active: "$neutral00",
      switch_on_knob_disabled: "$neutral00",
      switch_on_knob_enabled: "$neutral00",
      switch_on_knob_focus: "$neutral00",
      switch_on_knob_hover: "$neutral00",
      switch_on_ring_focus: "$state_focus_ring_primary",
      switch_on_track_surface_active: "#0d60de",
      switch_on_track_surface_disabled: "#106af27a",
      switch_on_track_surface_enabled: "$blue50",
      switch_on_track_surface_focus: "$blue50",
      switch_on_track_surface_hover: "#317ff4",
      tab_ring_focus: "$state_focus_ring_primary",
      tab_surface_focus: "#ffffff00",
      tab_text_active: "#0d60de",
      tab_text_disabled: "#35414e7a",
      tab_text_enabled: "$neutral70",
      tab_text_focus: "$blue50",
      tab_text_hover: "#317ff4",
      tab_text_selected: "$blue50",
      tab_underline_selected: "$blue50",
      table_cell_border_selected: "$blue30",
      table_cell_surface_active: "#106af229",
      table_cell_surface_enabled: "$surface_transparent",
      table_cell_surface_hover: "#106af214",
      table_cell_surface_selected: "#106af214",
      table_header_text: "$neutral70",
      text_cursor: "$text_primary",
      text_input_danger_border: "$red50",
      text_input_default_border: "$neutral50",
      text_input_default_border_disabled: "$neutral20",
      text_input_default_border_focus: "$blue50",
      text_input_default_content: "$neutral90",
      text_input_default_content_disabled: "$neutral50",
      text_input_default_placeholder_disabled: "$neutral50",
      text_input_default_suggestion: "$neutral50",
      text_input_default_surface_disabled: "#d7e1ed7a",
      text_input_default_surface_enabled: "$neutral00",
      text_input_default_surface_focus: "$neutral00",
      text_input_default_surface_read_only: "#d7e1ed7a",
      text_input_icon_disabled: "$neutral40",
      text_input_icon_enabled: "$neutral60",
      text_input_success_border: "$green50",
      text_input_warning_border: "$yellow50",
      tooltip_surface: "$neutral90",
      tooltip_text: "$neutral00"
    },
    numbers: {}
  },
  Structure: {
    colors: {
      border_default: "$neutral20",
      separator_default: "$neutral20",
      surface_blue_subtle: "#aacaff3d",
      surface_green_subtle: "#71d78e3d",
      surface_neutral_subtle: "#a1adc43d",
      surface_primary: "$neutral00",
      surface_purple_subtle: "#b490ff3d",
      surface_red_subtle: "#fb7e763d",
      surface_secondary: "$neutral05",
      surface_transparent: "#ffffff00",
      surface_yellow_subtle: "#ffc8713d"
    },
    numbers: {
      space_4: "4px",
      space_8: "8px",
      space_12: "12px",
      space_16: "16px",
      space_24: "24px",
      space_32: "32px",
      space_48: "48px",
      space_64: "64px",
      radius_surface_4: "4px",
      space_h_subcomponent: "$space_4",
      space_v_subcomponent: "$space_4",
      radius_surface_8: "8px",
      space_h_component: "$space_8",
      space_v_component: "$space_12",
      margin_v_section: "$space_16",
      margin_h_section: "$space_24",
      space_h_group: "$space_24",
      margin_h_container: "$space_32",
      space_v_group: "$space_32"
    }
  },
  Typography: {
    colors: {
      text_danger: "$red60",
      text_link: "$blue50",
      text_primary: "$neutral90",
      text_secondary: "$neutral70",
      text_success: "$green60",
      text_tertiary: "$neutral50",
      text_warning: "$yellow60"
    },
    numbers: {}
  }
};

// stitches.config.ts
var stitchesConfig = {
  theme: {
    colors: __spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues({
      // Focus ring color
      primary_focus_ring: "rgba(16, 106, 242, 0.36)",
      // ❗ button_default_ring_focus
      danger_focus_ring: "rgba(219, 48, 37, 0.36)",
      // ❗ button_danger_ring_focus
      warning_focus_ring: "rgba(240, 149, 12, 0.36)",
      // ❗ button_warning_ring_focus
      success_focus_ring: "rgba(18, 161, 61, 0.36)",
      // ❔ unknown rgba color
      // Label colors
      label_primary_text_enabled: "$neutral100",
      label_primary_text_disabled: "$neutral50",
      label_secondary_text_enabled: "$neutral60",
      label_secondary_text_disabled: "$neutral50",
      // Input colors
      input_background_enabled: "$neutral00",
      input_background_hover: "$neutral05",
      // TODO: should be neutral0 plus Dark-alpha-0.08
      input_background_disabled: "$neutral10",
      input_background_readonly: "$neutral05",
      // TODO: need a readonly boxShadow
      input_default_border_enabled: "$neutral40",
      input_default_border_disabled: "$neutral50",
      // TODO: need this color
      input_default_border_active: "$blue50",
      input_danger_border_enabled: "$red50",
      input_warning_border_enabled: "$yellow50",
      input_success_border_enabled: "$green50",
      input_default_text_enabled: "$neutral100",
      input_default_text_disabled: "$neutral50",
      input_secondary_text_enabled: "$neutral40",
      // TODO: need a color for placeholder text in disabled state
      input_default_icon_active: "$blue50",
      input_default_icon_enabled: "$neutral60",
      input_default_caret_enabled: "$neutral100",
      input_default_icon_disabled: "$neutral50",
      input_primary_icon_readonly: "$neutral50",
      // Helper text colors
      helper_text_default: "$neutral60",
      helper_text_danger: "$red50",
      helper_text_warning: "$yellow50",
      helper_text_success: "$green50",
      helper_icon_default: "$neutral40",
      helper_icon_danger: "$red50",
      helper_icon_warning: "$yellow50",
      helper_icon_success: "$green50",
      // Loader colors
      loader_default_icon: "$blue50",
      // Checkbox colors
      checkbox_unchecked_background_enabled: "$neutral00",
      checkbox_unchecked_background_disabled: "$neutral10",
      checkbox_unchecked_background_hover: "$neutral05",
      // 💠 existing stitches config token(s)
      // checkbox_unchecked_border_enabled: '$neutral50',
      checkbox_unchecked_border_disabled: "$neutral40",
      // 💠 existing stitches config token(s)
      // checkbox_unchecked_border_focus: '$blue50',
      checkbox_checked_background_enabled: "$blue50",
      checkbox_checked_background_hover: "$blue50",
      checkbox_checked_background_disabled: "$neutral30",
      checkbox_default_icon_enabled: "$neutral00",
      checkbox_default_icon_disabled: "$neutral50",
      // Radio colors
      radio_unselected_background_enabled: "$neutral00",
      radio_unselected_background_disabled: "$neutral10",
      radio_unselected_background_hover: "$neutral05",
      // 💠 existing stitches config token(s)
      // radio_unselected_border_enabled: '$neutral50',
      // 💠 existing stitches config token(s)
      // radio_unselected_border_focus: '$blue50',
      radio_unselected_border_disabled: "$neutral40",
      radio_selected_background_disabled: "$neutral50",
      radio_selected_border_disabled: "$neutral30",
      radio_selected_border_active: "$blue50",
      radio_selected_border_hover: "$blue50",
      // Switch colors
      switch_selected_background_enabled: "$blue50",
      switch_selected_background_focus: "$blue50",
      switch_selected_background_disabled: "$blue20",
      switch_selected_thumb_enabled: "$neutral00",
      switch_unselected_background_enabled: "$neutral00",
      switch_unselected_background_focus: "$neutral00",
      switch_unselected_background_disabled: "$neutral20",
      switch_unselected_thumb_enabled: "$neutral40",
      switch_unselected_thumb_disabled: "$neutral30",
      switch_unselected_border_enabled: "$neutral40",
      switch_unselected_border_focus: "$blue50",
      // Chip colors
      // 💠 existing stitches config token(s)
      // chip_text: '$neutral70',
      // chip_surface: 'rgba(202, 213, 229, 0.48)', // ❗ chip_surface
      // chip_remove_icon_enabled: '$neutral50',
      // chip_remove_icon_hover: '$neutral60',
      // chip_remove_icon_active: '$neutral70',
      // Counter colors
      counter_default_text_enabled: "$neutral70",
      counter_default_text_disabled: "#B7BFC7",
      // ❔ unknown hex color
      counter_default_background_enabled: "rgba(202, 213, 229, 0.64)",
      // ❗ counter_default_surface
      counter_default_background_disabled: "#E9EAF0",
      // ❔ unknown hex color
      counter_strong_background_enabled: "$blue50",
      counter_strong_text_enabled: "$neutral00",
      // Dropdown colors
      dropdown_default_text_enabled: "$neutral100",
      dropdown_default_text_disabled: "$neutral40",
      dropdown_default_text_disabled_alpha: "rgba(53, 65, 78, 0.48)",
      // ❗ button_icon_disabled
      dropdown_danger_text_enabled: "$red50",
      dropdown_danger_text_disabled: "$red30",
      dropdown_action_text_enabled: "$blue50",
      dropdown_action_text_disabled: "$blue30",
      dropdown_default_sectiontext_enabled: "$neutral60",
      dropdown_default_background_enabled: "$neutral00",
      dropdown_default_background_hover: "$neutral05",
      dropdown_default_background_active: "$neutral05",
      dropdown_default_border_focus: "$blue30",
      dropdown_default_divider_enabled: "$neutral20",
      dropdown_default_icon_enabled: "$neutral100",
      dropdown_default_icon_disabled: "$neutral40",
      dropdown_danger_icon_enabled: "$red50",
      dropdown_danger_icon_disabled: "$red30",
      dropdown_action_icon_enabled: "$blue50",
      dropdown_action_icon_disabled: "$blue30",
      dropdown_default_track_enabled: "$neutral10",
      dropdown_default_handle_enabled: "$neutral40",
      // 💠 existing stitches config token(s)
      // dropdown_surface_selected_enabled: 'rgba(170, 202, 255, 0.36)', // ❗ button_filter_selected_surface_enabled
      // dropdown_surface_selected_hover: 'rgba(170, 202, 255, 0.64)', // ❗ button_filter_selected_surface_hover
      // dropdown_surface_selected_active: 'rgba(170, 202, 255, 0.72)', // ❗ button_filter_selected_surface_active
      // dropdown_ring_focus: 'rgba(16, 106, 242, 0.36)', // ❗ button_default_ring_focus
      // dropdown_content_selected: '$blue50',
      // Badge colors
      // 💠 existing stitches config token(s)
      // badge_surface_neutral: '#A1ADC43D',  // ❗ badge_surface_neutral
      // badge_text_neutral: '$neutral70',
      // badge_surface_blue: '#AACAFF3D', // ❗ badge_surface_blue
      // badge_text_blue: '$blue60',
      // badge_surface_green: '#71D78E3D', // ❗ badge_surface_green
      // badge_text_green: '$green60',
      // badge_surface_yellow: '#FFC8713D', // ❗ badge_surface_yellow
      // badge_text_yellow: '$yellow60',
      // badge_surface_red: '#FB7E763D', // ❗ badge_surface_red
      // badge_text_red: '$red60',
      // badge_surface_purple: '#B490FF3D', // ❗ badge_surface_purple
      // badge_text_purple: '$purple60',
      // Button colors
      button_primary_background_enabled: "$blue50",
      button_primary_background_hover: "#317FF4",
      // ❗ button_primary_surface_hover
      button_primary_background_active: "#0D60DE",
      // ❗ button_primary_surface_active
      button_primary_text: "$neutral00",
      button_primary_icon: "$neutral00",
      button_primary_border_focus: "rgba(16, 106, 242, 0.36)",
      // ❗ button_default_ring_focus
      button_default_background_enabled: "$neutral20",
      button_default_background_hover: "#E1E8F1",
      // ❗ button_default_surface_hover
      button_default_background_active: "#CAD4E0",
      // ❗ button_default_surface_active
      button_default_text: "$neutral80",
      button_default_icon: "$neutral80",
      button_default_border_focus: "rgba(16, 106, 242, 0.72)",
      // ❔ unknown rgba color
      button_warning_background_enabled: "$yellow50",
      button_warning_background_hover: "#F4AC3F",
      // ❗ button_warning_surface_hover
      button_warning_background_active: "#E58C0B",
      // ❗ button_warning_surface_active
      button_warning_text: "$neutral90",
      button_warning_icon: "$neutral90",
      button_warning_border_focus: "rgba(240, 149, 12, 0.36)",
      // ❗ button_warning_ring_focus
      button_danger_background_enabled: "$red50",
      button_danger_background_hover: "#E45B52",
      // ❗ button_danger_surface_hover
      button_danger_background_active: "#D42C22",
      // ❗ button_danger_surface_active
      button_danger_text: "$neutral00",
      button_danger_icon: "$neutral00",
      button_danger_border_focus: "rgba(219, 48, 37, 0.36)",
      // ❗ button_danger_ring_focus
      button_subtle_background_enabled: "$neutral00",
      button_subtle_background_hover: "rgba(80, 94, 113, 0.16)",
      // ❗ button_subtle_surface_hover
      button_subtle_background_active: "rgba(80, 94, 113, 0.24)",
      // ❗ button_subtle_surface_active
      button_subtle_text: "$neutral70",
      button_subtle_icon: "$neutral70",
      button_disabled_background: "rgba(215, 225, 237, 0.64)",
      // ❗ button_surface_disabled
      button_disabled_text: "rgba(53, 65, 78, 0.48)",
      // ❗ button_icon_disabled
      button_disabled_icon: "rgba(53, 65, 78, 0.48)",
      // ❗ button_icon_disabled
      button_disabled_subtle_background: "rgba(255, 255, 255, 0.0001)",
      button_disabled_subtle_text: "rgba(53, 65, 78, 0.48)",
      // ❗ button_icon_disabled
      button_disabled_subtle_icon: "rgba(53, 65, 78, 0.48)",
      // ❗ button_icon_disabled
      // Button Group colors
      button_group_primary_separator: "rgba(227, 237, 255, 0.24)",
      // ❗ button_group_primary_seperator
      button_group_default_separator: "rgba(53, 65, 78, 0.24)",
      // ❗ button_group_default_seperator
      button_group_disabled_separator: "rgba(53, 65, 78, 0.16)",
      // ❗ button_group_disabled_seperator
      // Filter Button colors
      filter_button_background: "$neutral00",
      filter_button_background_hover: "rgba(31, 37, 44, 0.08)",
      // ❗ button_filter_empty_surface_hover
      filter_button_background_active: "rgba(31, 37, 44, 0.12)",
      // ❗ button_filter_empty_surface_active
      filter_button_border: "2px solid transparent",
      filter_button_border_focus_color: "$blue40",
      filter_button_filters_selected_background: "rgba(170, 202, 255, 0.36)",
      // ❗ button_filter_selected_surface_enabled
      filter_button_filters_selected_background_hover: "rgba(170, 202, 255, 0.64)",
      // ❗ button_filter_selected_surface_hover
      filter_button_filters_selected_background_active: "rgba(170, 202, 255, 0.72)",
      // ❗ button_filter_selected_surface_active
      filter_button_filters_selected_background_focus: "rgba(170, 202, 255, 0.36)",
      // ❗ button_filter_selected_surface_enabled
      filter_button_filters_selected_color: "$blue50",
      filter_button_remove_border_color: "rgba(0, 61, 166, 0.24)",
      // button_filter_selected_border_active
      filter_button_remove_icon_color: "rgba(80, 94, 113, 0.72)",
      // ❗ button_filter_empty_dismiss_icon
      // Table colors
      table_row_background_hover: "rgb(16 106 242 / 8%)",
      // ❔ unknown rgba color
      table_row_background_hover_opaque: "rgb(239 243 253)",
      table_cell_background_active: "rgb(16 106 242 / 16%)",
      // ❗ table_cell_surface_active
      table_cell_background_active_opaque: "rgb(217 231 253)",
      // Scroll Container colors
      scroll_overflow_shadow_color: "rgb(15 19 23 / 16%)"
    }, tokens_default["Color Primitives"].colors), tokens_default["Color Semantic (System)"].colors), tokens_default["Structure"].colors), tokens_default["Typography"].colors), {
      // Kai AI colors
      aiBlue1: "#1860f0",
      aiPurple1: "#9b41df",
      aiPurpleGradient1: "linear-gradient(90deg, $colors$aiBlue1 0%, $colors$aiPurple1 100%)",
      aiPurpleGradient2: "linear-gradient(123deg, $colors$aiBlue1 21.67%, $colors$aiPurple1 78.94%)",
      // for backwards compatibility with existing tokens with different
      // shade naming/numbering convention
      neutral0: "$neutral00",
      neutral5: "$neutral05"
    }),
    space: __spreadValues({
      0: "0px",
      1: "4px",
      2: "8px",
      3: "12px",
      4: "16px",
      5: "24px",
      6: "32px",
      7: "48px",
      8: "64px",
      9: "96px",
      10: "128px"
    }, tokens_default["Structure"].numbers),
    fontSizes: {
      1: "12px",
      2: "14px",
      3: "16px",
      4: "20px",
      5: "24px",
      6: "32px"
    },
    fonts: {
      primary: "'Untitled Sans', sans-serif",
      code: "'Fira Code', monospace"
    },
    fontWeights: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 700
    },
    lineHeights: {
      1: "16px",
      2: "20px",
      3: "24px",
      4: "32px",
      5: "40px"
    },
    letterSpacings: {
      1: "0px",
      2: "0.4px",
      3: "0.8px"
    },
    sizes: {
      1: "4px",
      2: "8px",
      3: "12px",
      4: "16px",
      5: "20px",
      6: "24px",
      7: "32px",
      8: "48px",
      9: "64px",
      10: "80px",
      11: "120px",
      12: "160px",
      13: "240px",
      14: "320px",
      15: "480px",
      16: "720px",
      17: "960px",
      18: "1200px"
    },
    borderWidths: {},
    borderStyles: {},
    // numeric sizing for radii to be deprecated in favor of t-shirt sizing
    radii: {
      none: "0px",
      1: "4px",
      2: "8px",
      round: "50%",
      // 'round' also to be deprecated
      "rounded-none": "0px",
      "rounded-sm": "2px",
      rounded: "4px",
      "rounded-lg": "8px",
      "rounded-xl": "12px",
      "rounded-full": "9999px"
    },
    shadows: {
      1: "0 1px 4px rgba(17, 17, 17, 20%)",
      2: "0 2px 8px rgba(17, 17, 17, 20%)",
      3: "0 4px 16px rgba(17, 17, 17, 20%)",
      4: "0 6px 24px rgba(17, 17, 17, 20%)",
      elevation1: "0px 1px 4px 0px rgba(15, 19, 23, 0.24)",
      elevation2: "0px 2px 8px rgba(15, 19, 23, 0.2)",
      elevation3: "0px 4px 16px rgba(15, 19, 23, 0.16)",
      primary_focus: "0 0 0 2px $colors$primary_focus_ring",
      danger_focus: "0 0 0 2px $colors$danger_focus_ring",
      warning_focus: "0 0 0 2px $colors$warning_focus_ring",
      success_focus: "0 0 0 2px $colors$success_focus_ring",
      scroll_overflow_x_shadow_left: "4px 0 4px -2px inset",
      scroll_overflow_x_shadow_right: "8px 0 4px -6px inset",
      scroll_overflow_y_shadow_top: "0 10px 6px -4px inset",
      scroll_overflow_y_shadow_bottom: "0 -10px 6px -6px inset",
      inset_border_top_1: "0 1px inset",
      inset_border_right_1: "-1px 0 inset",
      inset_border_bottom_1: "0 -1px inset",
      inset_border_left_1: "1px 0 inset"
    },
    zIndices: {
      1: "100",
      2: "200",
      3: "300",
      4: "400",
      max: "999"
    },
    transitions: {
      default: "200ms ease-in-out",
      infinite: "1s linear infinite",
      cubicCurve: "200ms cubic-bezier(0.65,0.05,0.36,1)",
      sineCurve: "200ms cubic-bezier(0.45,0.05,0.55,0.95)"
    },
    media: {
      sm: "(min-width: 834px)",
      md: "(min-width: 1024px)",
      lg: "(min-width: 1440px)",
      xl: "(min-width: 1680px)"
    }
  },
  utils: {
    p: (value) => ({
      padding: value
    }),
    pt: (value) => ({
      paddingTop: value
    }),
    pr: (value) => ({
      paddingRight: value
    }),
    pb: (value) => ({
      paddingBottom: value
    }),
    pl: (value) => ({
      paddingLeft: value
    }),
    px: (value) => ({
      paddingLeft: value,
      paddingRight: value
    }),
    py: (value) => ({
      paddingTop: value,
      paddingBottom: value
    }),
    m: (value) => ({
      margin: value
    }),
    mt: (value) => ({
      marginTop: value
    }),
    mr: (value) => ({
      marginRight: value
    }),
    mb: (value) => ({
      marginBottom: value
    }),
    ml: (value) => ({
      marginLeft: value
    }),
    mx: (value) => ({
      marginLeft: value,
      marginRight: value
    }),
    my: (value) => ({
      marginTop: value,
      marginBottom: value
    }),
    b: (value) => ({
      border: `1px solid ${value}`
    }),
    bt: (value) => ({
      borderTop: `1px solid ${value}`
    }),
    br: (value) => ({
      borderRight: `1px solid ${value}`
    }),
    bb: (value) => ({
      borderBottom: `1px solid ${value}`
    }),
    bl: (value) => ({
      borderLeft: `1px solid ${value}`
    }),
    bx: (value) => ({
      borderLeft: `1px solid ${value}`,
      borderRight: `1px solid ${value}`
    }),
    by: (value) => ({
      borderTop: `1px solid ${value}`,
      borderBottom: `1px solid ${value}`
    }),
    fd: (value) => ({
      flexDirection: value
    }),
    bg: (value) => ({
      background: value
    }),
    size: (value) => ({
      width: value,
      height: value
    }),
    truncate: (textOverflow) => ({
      textOverflow,
      whiteSpace: "nowrap",
      overflow: "hidden",
      overflowWrap: "break-word"
    }),
    reset: (value) => value === "*" ? {
      boxSizing: "border-box",
      "*, *::before, *::after": {
        boxSizing: "border-box"
      }
    } : {
      boxSizing: "border-box"
    }
  },
  themeMap: __spreadProps(__spreadValues({}, defaultThemeMap), {
    filter: "shadows"
  })
};
var { theme, styled, config, css, keyframes } = createStitches(stitchesConfig);

// src/Icon/icons/0.tsx
import { jsx } from "react/jsx-runtime";
var Svg0 = (props) => /* @__PURE__ */ jsx(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 4.147a5.016 5.016 0 0 1 5.01 5.01v5.726a5.016 5.016 0 0 1-5.01 5.01 5.014 5.014 0 0 1-5.01-5.01V9.157A5.014 5.014 0 0 1 12 4.147ZM12 2a7.157 7.157 0 0 0-7.157 7.157v5.686a7.157 7.157 0 1 0 14.314 0V9.157A7.155 7.155 0 0 0 12 2Z",
        fill: "currentColor"
      }
    )
  })
);
var __default = Svg0;

// src/Icon/icons/00.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var Svg00 = (props) => /* @__PURE__ */ jsx2(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx2(
      "path",
      {
        d: "M11 9.5v5a4.501 4.501 0 0 1-9 0v-5a4.5 4.5 0 1 1 9 0Zm-7.5 5a3 3 0 0 0 6 0v-5c0-1.684-1.344-3-3-3-1.657 0-3 1.316-3 3v5Zm18.5-5v5a4.501 4.501 0 0 1-9 0v-5a4.5 4.5 0 0 1 9 0Zm-7.5 5c0 1.656 1.316 3 3 3a3 3 0 0 0 3-3v-5c0-1.684-1.344-3-3-3-1.684 0-3 1.316-3 3v5Z",
        fill: "currentColor"
      }
    )
  })
);
var __default2 = Svg00;

// src/Icon/icons/1.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var Svg1 = (props) => /* @__PURE__ */ jsx3(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx3(
      "path",
      {
        d: "M17.714 20.929c0 .591-.48 1.071-1.071 1.071H7.357a1.07 1.07 0 1 1 0-2.143h3.572V4.99l-3.01 1.85a1.068 1.068 0 0 1-1.474-.348 1.072 1.072 0 0 1 .35-1.475l4.643-2.857a1.073 1.073 0 0 1 1.633.912v16.786h3.572c.594 0 1.071.482 1.071 1.072Z",
        fill: "currentColor"
      }
    )
  })
);
var __default3 = Svg1;

// src/Icon/icons/2.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var Svg2 = (props) => /* @__PURE__ */ jsx4(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx4(
      "path",
      {
        d: "M18.07 22H5.93a1.072 1.072 0 0 1-.72-1.865l9.186-8.333c1.84-1.588 2.053-4.25.504-6.08a4.447 4.447 0 0 0-3.068-1.562 4.467 4.467 0 0 0-3.296 1.07L6.793 6.78A1.071 1.071 0 0 1 5.37 5.178l1.756-1.56A6.589 6.589 0 0 1 12 2.022c1.78.14 3.391.962 4.535 2.313 2.28 2.692 1.957 6.762-.72 9.07l-7.11 6.452h9.365a1.072 1.072 0 0 1 0 2.142Z",
        fill: "currentColor"
      }
    )
  })
);
var __default4 = Svg2;

// src/Icon/icons/3.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var Svg3 = (props) => /* @__PURE__ */ jsx5(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx5(
      "path",
      {
        d: "M13.264 22H9.239a4.555 4.555 0 0 1-4.327-3.118 1.071 1.071 0 1 1 2.033-.678 2.417 2.417 0 0 0 2.294 1.653h4.025A3.738 3.738 0 0 0 17 16.121a3.74 3.74 0 0 0-3.736-3.737H8.786a1.072 1.072 0 0 1-.743-1.844l6.654-6.397H5.929a1.072 1.072 0 0 1 0-2.143h11.428a1.072 1.072 0 0 1 .743 1.844l-6.653 6.397h1.818a5.887 5.887 0 0 1 5.878 5.88A5.887 5.887 0 0 1 13.263 22Z",
        fill: "currentColor"
      }
    )
  })
);
var __default5 = Svg3;

// src/Icon/icons/4.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var Svg4 = (props) => /* @__PURE__ */ jsx6(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx6(
      "path",
      {
        d: "M20.572 15.214c0 .592-.48 1.071-1.072 1.071h-1.745l-.04 4.643a1.072 1.072 0 0 1-2.143 0v-4.643H4.5a1.07 1.07 0 0 1-.947-1.572l6.43-12.144a1.072 1.072 0 0 1 1.892 1.003l-5.596 10.57h9.293V7.357c0-.59.482-1.072 1.071-1.072.59 0 1.072.482 1.072 1.072v6.785H19.5c.594 0 1.072.483 1.072 1.072Z",
        fill: "currentColor"
      }
    )
  })
);
var __default6 = Svg4;

// src/Icon/icons/5.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
var Svg5 = (props) => /* @__PURE__ */ jsx7(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx7(
      "path",
      {
        d: "M13.238 22H9.577a4.913 4.913 0 0 1-4.665-3.362 1.07 1.07 0 1 1 2.032-.678 2.776 2.776 0 0 0 2.633 1.897h3.658a3.767 3.767 0 0 0 3.766-3.763 3.767 3.767 0 0 0-3.763-3.764H5.93a1.071 1.071 0 0 1-1.056-1.254l1.429-8.188C6.392 2.375 6.838 2 7.358 2h9.286a1.07 1.07 0 1 1 0 2.143H8.259l-1.055 6.045h6.031a5.913 5.913 0 0 1 5.909 5.906A5.913 5.913 0 0 1 13.238 22Z",
        fill: "currentColor"
      }
    )
  })
);
var __default7 = Svg5;

// src/Icon/icons/6.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
var Svg6 = (props) => /* @__PURE__ */ jsx8(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx8(
      "path",
      {
        d: "M4.857 14.857C4.857 18.796 8.062 22 12 22c3.938 0 7.143-3.204 7.143-7.143 0-3.938-3.206-7.143-7.143-7.143-.245 0-.482.05-.719.072l3.332-4.034A1.071 1.071 0 1 0 12.96 2.39c-6.415 7.767-8.103 9.093-8.103 12.468Zm12.143 0c0 2.757-2.243 5-5 5s-5-2.24-5-5c0-2.759 2.243-5 5-5s5 2.246 5 5Z",
        fill: "currentColor"
      }
    )
  })
);
var __default8 = Svg6;

// src/Icon/icons/7.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
var Svg7 = (props) => /* @__PURE__ */ jsx9(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx9(
      "path",
      {
        d: "M7.356 22a1.07 1.07 0 0 1-.918-1.622l9.74-16.235H5.929a1.072 1.072 0 0 1 0-2.143h12.143a1.073 1.073 0 0 1 .92 1.622L8.275 21.48c-.201.332-.556.52-.92.52Z",
        fill: "currentColor"
      }
    )
  })
);
var __default9 = Svg7;

// src/Icon/icons/8.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
var Svg8 = (props) => /* @__PURE__ */ jsx10(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx10(
      "path",
      {
        d: "M16.45 11.741c1.202-1.018 1.979-2.513 1.979-4.205A5.541 5.541 0 0 0 12.893 2h-1.786a5.542 5.542 0 0 0-5.536 5.536c0 1.69.779 3.188 1.977 4.204-1.605.97-2.69 2.715-2.69 4.724A5.541 5.541 0 0 0 10.392 22h3.214a5.54 5.54 0 0 0 5.536-5.536c0-2.009-1.085-3.754-2.692-4.723Zm-5.343-7.598h1.786a3.397 3.397 0 0 1 3.393 3.393 3.397 3.397 0 0 1-3.393 3.393h-1.786a3.397 3.397 0 0 1-3.393-3.393 3.397 3.397 0 0 1 3.393-3.393Zm2.5 15.714h-3.214A3.396 3.396 0 0 1 7 16.464a3.397 3.397 0 0 1 3.393-3.393h3.214A3.397 3.397 0 0 1 17 16.464a3.397 3.397 0 0 1-3.393 3.393Z",
        fill: "currentColor"
      }
    )
  })
);
var __default10 = Svg8;

// src/Icon/icons/9.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
var Svg9 = (props) => /* @__PURE__ */ jsx11(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx11(
      "path",
      {
        d: "M19.143 9.143C19.143 5.204 15.938 2 12 2 8.062 2 4.857 5.204 4.857 9.143c0 3.938 3.205 7.143 7.143 7.143.247 0 .48-.049.72-.073l-3.332 4.032a1.071 1.071 0 0 0 1.652 1.366c6.415-7.767 8.103-9.093 8.103-12.468ZM7 9.143c0-2.757 2.243-5 5-5s5 2.243 5 5-2.241 5-5 5-5-2.241-5-5Z",
        fill: "currentColor"
      }
    )
  })
);
var __default11 = Svg9;

// src/Icon/icons/A.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var SvgA = (props) => /* @__PURE__ */ jsx12(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx12(
      "path",
      {
        d: "M20.512 20.509 12.99 2.599c-.334-.798-1.647-.798-1.981 0l-7.523 17.91a1.074 1.074 0 1 0 1.982.832l1.513-3.602H17.02l1.512 3.602a1.07 1.07 0 0 0 1.407.575c.547-.23.806-.861.573-1.407ZM7.886 15.588 12 5.75l4.115 9.802h-8.23v.036Z",
        fill: "currentColor"
      }
    )
  })
);
var A_default = SvgA;

// src/Icon/icons/AddressBook.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
var SvgAddressBook = (props) => /* @__PURE__ */ jsx13(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx13(
      "path",
      {
        d: "M12 13.25H9.5a3.124 3.124 0 0 0-3.125 3.125c0 .344.281.625.625.625h7.5c.345 0 .625-.28.625-.625A3.124 3.124 0 0 0 12 13.25ZM10.75 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm10 2.5h-.625v3.75h.625c.345 0 .625-.28.625-.625v-2.5a.627.627 0 0 0-.625-.625Zm0-10h-.625v3.75h.625a.627.627 0 0 0 .625-.625v-2.5a.626.626 0 0 0-.625-.625Zm0 5h-.625v3.75h.625a.627.627 0 0 0 .625-.625v-2.5a.627.627 0 0 0-.625-.625ZM16.375 2H5.125a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5h11.25a2.5 2.5 0 0 0 2.5-2.5v-15c0-1.38-1.121-2.5-2.5-2.5ZM17 19.5c0 .345-.28.625-.625.625H5.125A.625.625 0 0 1 4.5 19.5v-15c0-.345.28-.625.625-.625h11.25c.345 0 .625.28.625.625v15Z",
        fill: "currentColor"
      }
    )
  })
);
var AddressBook_default = SvgAddressBook;

// src/Icon/icons/AddressCard.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
var SvgAddressCard = (props) => /* @__PURE__ */ jsx14(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx14(
      "path",
      {
        d: "M9.222 12a2.222 2.222 0 1 0 0-4.444 2.222 2.222 0 0 0 0 4.444Zm8.89-.833h-3.334a.834.834 0 0 0 0 1.666h3.333a.834.834 0 0 0 0-1.666Zm-7.779 1.944H8.111a2.777 2.777 0 0 0-2.778 2.778c0 .305.25.555.556.555h6.667a.556.556 0 0 0 .555-.555 2.777 2.777 0 0 0-2.778-2.778Zm7.778-4.722h-3.333a.834.834 0 0 0 0 1.667h3.333a.833.833 0 0 0 0-1.667Zm1.667-4.167H4.222A2.222 2.222 0 0 0 2 6.444v11.111c0 1.228.995 2.223 2.222 2.223h15.556A2.222 2.222 0 0 0 22 17.555V6.445a2.223 2.223 0 0 0-2.222-2.223Zm.555 13.333c0 .307-.249.556-.555.556H4.222a.556.556 0 0 1-.555-.556V6.445c0-.307.249-.556.555-.556h15.556c.306 0 .555.25.555.555v11.111Z",
        fill: "currentColor"
      }
    )
  })
);
var AddressCard_default = SvgAddressCard;

// src/Icon/icons/AirConditioner.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var SvgAirConditioner = (props) => /* @__PURE__ */ jsx15(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx15(
      "path",
      {
        d: "M18.111 7.556H5.89a.557.557 0 0 0-.556.555v.556c0 .307.25.555.556.555H18.11c.306 0 .556-.25.556-.555V8.11a.557.557 0 0 0-.556-.555Zm1.667-4.445H4.222C3 3.111 2 4.111 2 5.334v4.444C2 11 3 12 4.222 12h15.556C21 12 22 11 22 9.778V5.334c0-1.223-1-2.223-2.222-2.223Zm.555 6.667a.563.563 0 0 1-.555.556H4.222a.562.562 0 0 1-.555-.556V5.334c0-.302.254-.556.555-.556h15.556c.301 0 .555.254.555.556v4.444Zm-11.11 8.056a1.39 1.39 0 1 1-1.909-1.288A.833.833 0 0 0 6.686 15a3.014 3.014 0 0 0-1.91 2.833 3.059 3.059 0 0 0 3.056 3.055 3.059 3.059 0 0 0 3.056-3.055V13.11H9.222v4.723Zm8.09-3.945a.833.833 0 0 0-.626 1.545 1.39 1.39 0 0 1-.52 2.677 1.39 1.39 0 0 1-1.39-1.389v-3.61h-1.666v3.61a3.059 3.059 0 0 0 3.056 3.056 3.059 3.059 0 0 0 3.055-3.056c0-1.28-.75-2.364-1.91-2.833Z",
        fill: "currentColor"
      }
    )
  })
);
var AirConditioner_default = SvgAirConditioner;

// src/Icon/icons/Airplay.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var SvgAirplay = (props) => /* @__PURE__ */ jsx16(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx16(
      "path",
      {
        d: "M18.944 4.222H5.056A3.059 3.059 0 0 0 2 7.278V14.5a3.06 3.06 0 0 0 3.056 3.055.834.834 0 0 0 0-1.666 1.39 1.39 0 0 1-1.39-1.39V7.279a1.39 1.39 0 0 1 1.39-1.39h13.888a1.39 1.39 0 0 1 1.39 1.39V14.5a1.39 1.39 0 0 1-1.39 1.389.834.834 0 0 0 0 1.666A3.059 3.059 0 0 0 22 14.5V7.278a3.06 3.06 0 0 0-3.056-3.056Zm-5.767 8.823a1.666 1.666 0 0 0-2.357 0l-3.889 3.889c-1.042 1.045-.303 2.844 1.18 2.844h7.774c1.48 0 2.231-1.798 1.177-2.844l-3.885-3.889ZM8.111 18.08l3.858-3.89 3.889 3.89H8.11Z",
        fill: "currentColor"
      }
    )
  })
);
var Airplay_default = SvgAirplay;

// src/Icon/icons/AlarmClock.tsx
import { jsx as jsx17 } from "react/jsx-runtime";
var SvgAlarmClock = (props) => /* @__PURE__ */ jsx17(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx17(
      "path",
      {
        d: "M8.25 2.992 2.58 7.72a3.72 3.72 0 0 1 5.67-4.727Zm4.688 9.871 1.566 1.598c.398.367.398.96 0 1.293-.332.398-.926.398-1.293 0l-1.875-1.875c-.176-.14-.274-.379-.274-.629V9.187c0-.519.418-.937.938-.937s.938.418.938.938v3.675Zm-6.426 7.203L4.85 21.691a.885.885 0 0 1-1.325 0c-.366-.332-.366-.925 0-1.293l1.66-1.66a8.75 8.75 0 1 1 13.631 0l1.625 1.66c.399.368.399.961 0 1.293-.332.399-.925.399-1.293 0l-1.66-1.625A8.73 8.73 0 0 1 12 22a8.73 8.73 0 0 1-5.488-1.934Zm5.488.059a6.875 6.875 0 1 0 0-13.75 6.875 6.875 0 0 0 0 13.75Zm9.418-12.406L15.75 2.992C16.379 2.376 17.305 2 18.281 2a3.719 3.719 0 0 1 3.137 5.719Z",
        fill: "currentColor"
      }
    )
  })
);
var AlarmClock_default = SvgAlarmClock;

// src/Icon/icons/AlarmExclamation.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
var SvgAlarmExclamation = (props) => /* @__PURE__ */ jsx18(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx18(
      "path",
      {
        d: "M2 5.72a3.72 3.72 0 0 1 6.25-2.728L2.58 7.72A3.708 3.708 0 0 1 2 5.72ZM10.75 17c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25-.559 1.25-1.25 1.25-1.25-.559-1.25-1.25Zm2.188-3.438c0 .52-.418.938-.938.938a.935.935 0 0 1-.938-.938V9.189c0-.52.418-.938.938-.938s.938.418.938.938v4.374Zm4.55 6.504A8.73 8.73 0 0 1 12 22a8.73 8.73 0 0 1-5.488-1.934L4.85 21.691a.885.885 0 0 1-1.325 0c-.366-.332-.366-.925 0-1.293l1.66-1.66a8.75 8.75 0 1 1 13.631 0l1.625 1.66c.399.368.399.961 0 1.293-.332.399-.925.399-1.293 0l-1.66-1.625ZM12 6.375a6.875 6.875 0 1 0 0 13.75 6.875 6.875 0 0 0 0-13.75ZM18.281 2a3.719 3.719 0 0 1 3.137 5.719L15.75 2.992C16.379 2.376 17.305 2 18.281 2Z",
        fill: "currentColor"
      }
    )
  })
);
var AlarmExclamation_default = SvgAlarmExclamation;

// src/Icon/icons/AlarmPlus.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
var SvgAlarmPlus = (props) => /* @__PURE__ */ jsx19(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx19(
      "path",
      {
        d: "M8.25 2.992 2.58 7.72a3.72 3.72 0 0 1 5.67-4.727ZM12 8.875c.52 0 .938.418.938.938v2.5h2.5c.519 0 .937.417.937.937s-.418.938-.938.938h-2.5v2.5c0 .519-.417.937-.937.937a.935.935 0 0 1-.938-.938v-2.5h-2.5a.935.935 0 0 1-.937-.937c0-.52.418-.938.938-.938h2.5v-2.5c0-.519.417-.937.937-.937ZM6.512 20.066 4.85 21.691a.885.885 0 0 1-1.325 0c-.366-.332-.366-.925 0-1.293l1.66-1.66a8.75 8.75 0 1 1 13.631 0l1.625 1.66c.399.368.399.961 0 1.293-.332.399-.925.399-1.293 0l-1.66-1.625A8.73 8.73 0 0 1 12 22a8.73 8.73 0 0 1-5.488-1.934Zm5.488.059a6.875 6.875 0 1 0 0-13.75 6.875 6.875 0 0 0 0 13.75Zm9.418-12.406L15.75 2.992C16.379 2.376 17.305 2 18.281 2a3.719 3.719 0 0 1 3.137 5.719Z",
        fill: "currentColor"
      }
    )
  })
);
var AlarmPlus_default = SvgAlarmPlus;

// src/Icon/icons/AlarmSnooze.tsx
import { jsx as jsx20 } from "react/jsx-runtime";
var SvgAlarmSnooze = (props) => /* @__PURE__ */ jsx20(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx20(
      "path",
      {
        d: "M8.25 2.992 2.58 7.72a3.72 3.72 0 0 1 5.67-4.727ZM14.188 9.5c.359 0 .683.203.843.527a.93.93 0 0 1-.105.985l-3.196 4.113h2.457c.52 0 .938.418.938.938 0 .519-.418.937-.938.937H9.814a.939.939 0 0 1-.844-.527.93.93 0 0 1 .105-.985l3.196-4.148H9.813a.914.914 0 0 1-.938-.938c0-.484.418-.937.938-.937l4.374.035ZM6.511 20.066 4.85 21.691a.885.885 0 0 1-1.325 0c-.366-.332-.366-.925 0-1.293l1.66-1.66a8.75 8.75 0 1 1 13.631 0l1.625 1.66c.399.368.399.961 0 1.293-.332.399-.925.399-1.293 0l-1.66-1.625A8.73 8.73 0 0 1 12 22a8.73 8.73 0 0 1-5.488-1.934Zm5.488.059a6.875 6.875 0 1 0 0-13.75 6.875 6.875 0 0 0 0 13.75Zm9.418-12.406L15.75 2.992C16.379 2.376 17.305 2 18.281 2a3.719 3.719 0 0 1 3.137 5.719Z",
        fill: "currentColor"
      }
    )
  })
);
var AlarmSnooze_default = SvgAlarmSnooze;

// src/Icon/icons/AlbumCirclePlus.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var SvgAlbumCirclePlus = (props) => /* @__PURE__ */ jsx21(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx21(
      "path",
      {
        d: "M3.667 5.889v11.11c0 .306.248.556.555.556h7.052c.268.608.601 1.17 1.01 1.667H4.223A2.223 2.223 0 0 1 2 17V5.889c0-1.228.995-2.223 2.222-2.223h11.111c1.226 0 2.223.995 2.223 2.223v3.357A5.897 5.897 0 0 0 17 9.222c-.378 0-.75.004-1.111.1V5.89a.556.556 0 0 0-.556-.556H4.223a.555.555 0 0 0-.556.556Zm6.11.555a5 5 0 0 1 4.71 3.316 6.113 6.113 0 0 0-3.522 6.542 5.001 5.001 0 0 1-6.188-4.858c0-2.76 2.24-5 5-5Zm0 3.89a1.11 1.11 0 1 0 0 2.221 1.11 1.11 0 1 0 0-2.222Zm2.223 5c0-2.761 2.24-5 5-5s5 2.239 5 5c0 2.76-2.24 5-5 5s-5-2.24-5-5Zm5.556-2.254a.579.579 0 0 0-.556-.556.579.579 0 0 0-.556.556v1.666h-1.666a.579.579 0 0 0-.556.556c0 .337.25.556.556.556h1.666v1.666c0 .337.25.556.556.556a.538.538 0 0 0 .556-.556v-1.667h1.666a.538.538 0 0 0 .556-.555.579.579 0 0 0-.556-.556h-1.666V13.08Z",
        fill: "currentColor"
      }
    )
  })
);
var AlbumCirclePlus_default = SvgAlbumCirclePlus;

// src/Icon/icons/AlbumCircleUser.tsx
import { jsx as jsx22 } from "react/jsx-runtime";
var SvgAlbumCircleUser = (props) => /* @__PURE__ */ jsx22(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx22(
      "path",
      {
        d: "M3.667 5.889v11.11c0 .306.248.556.555.556h7.052c.268.608.601 1.17 1.01 1.667H4.223A2.223 2.223 0 0 1 2 17V5.889c0-1.228.995-2.223 2.222-2.223h11.111c1.226 0 2.223.995 2.223 2.223v3.357A5.897 5.897 0 0 0 17 9.222c-.378 0-.75.004-1.111.1V5.89a.556.556 0 0 0-.556-.556H4.223a.555.555 0 0 0-.556.556Zm6.11.555a5 5 0 0 1 4.71 3.316 6.113 6.113 0 0 0-3.522 6.542 5.001 5.001 0 0 1-6.188-4.858c0-2.76 2.24-5 5-5Zm0 3.89a1.11 1.11 0 1 0 0 2.221 1.11 1.11 0 1 0 0-2.222Zm12.223 5c0 2.76-2.24 5-5 5s-5-2.24-5-5c0-2.761 2.24-5 5-5s5 2.239 5 5ZM18.132 17h-2.264c-.73 0-1.35.476-1.566 1.135A3.878 3.878 0 0 0 17 19.222a3.878 3.878 0 0 0 2.698-1.087A1.649 1.649 0 0 0 18.132 17ZM17 12.555a1.667 1.667 0 1 0 0 3.335 1.667 1.667 0 0 0 0-3.335Z",
        fill: "currentColor"
      }
    )
  })
);
var AlbumCircleUser_default = SvgAlbumCircleUser;

// src/Icon/icons/AlbumCollectionCirclePlus.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
var SvgAlbumCollectionCirclePlus = (props) => /* @__PURE__ */ jsx23(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx23(
      "path",
      {
        d: "M16.2 3.93a.756.756 0 1 1 0 1.512H3.588a.757.757 0 0 1 0-1.513h12.61ZM2.017 11.252a2.017 2.017 0 0 1 2-2.28H15.77c.754 0 1.4.41 1.747 1.01h-.057c-.826 0-1.61.179-2.314.504H4.018a.505.505 0 0 0-.5.57l.93 7.062c.032.249.246.438.5.438h7.862a5.56 5.56 0 0 0 1.46 1.513H4.947a2.017 2.017 0 0 1-2-1.756l-.93-7.061Zm8.002-.01c1.192 0 2.276.312 3.102.83a5.527 5.527 0 0 0-1.21 3.458c0 .659.113 1.29.324 1.876a6.26 6.26 0 0 1-2.244.393c-2.547 0-4.666-1.469-4.666-3.278 0-1.81 2.119-3.279 4.666-3.279h.028Zm-.126 4.288c.558 0 1.009-.338 1.009-.757 0-.42-.45-.757-1.009-.757-.558 0-1.009.338-1.009.757 0 .42.451.757 1.01.757ZM2.328 7.208c0-.418.339-.757.757-.757h13.619a.756.756 0 1 1 0 1.513H3.084a.756.756 0 0 1-.756-.756ZM12.92 15.53a4.54 4.54 0 0 1 9.079 0 4.54 4.54 0 0 1-9.08 0Zm5.044-2.046a.525.525 0 0 0-.505-.505.525.525 0 0 0-.504.505v1.513h-1.513a.525.525 0 0 0-.505.504c0 .306.227.505.505.505h1.513v1.513c0 .306.227.504.504.504a.489.489 0 0 0 .505-.504v-1.513h1.513a.489.489 0 0 0 .504-.505.525.525 0 0 0-.504-.504h-1.513v-1.513Z",
        fill: "currentColor"
      }
    )
  })
);
var AlbumCollectionCirclePlus_default = SvgAlbumCollectionCirclePlus;

// src/Icon/icons/AlbumCollectionCircleUser.tsx
import { jsx as jsx24 } from "react/jsx-runtime";
var SvgAlbumCollectionCircleUser = (props) => /* @__PURE__ */ jsx24(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx24(
      "path",
      {
        d: "M16.2 3.93a.756.756 0 1 1 0 1.512H3.588a.757.757 0 0 1 0-1.513h12.61ZM2.017 11.252a2.017 2.017 0 0 1 2-2.28H15.77c.754 0 1.4.41 1.747 1.01h-.057c-.826 0-1.61.179-2.314.504H4.018a.505.505 0 0 0-.5.57l.93 7.062c.032.249.246.438.5.438h7.862a5.56 5.56 0 0 0 1.46 1.513H4.947a2.017 2.017 0 0 1-2-1.756l-.93-7.061Zm8.002-.01c1.192 0 2.276.312 3.102.83a5.527 5.527 0 0 0-1.21 3.458c0 .659.113 1.29.324 1.876a6.26 6.26 0 0 1-2.244.393c-2.547 0-4.666-1.469-4.666-3.278 0-1.81 2.119-3.279 4.666-3.279h.028Zm-.126 4.288c.558 0 1.009-.338 1.009-.757 0-.42-.45-.757-1.009-.757-.558 0-1.009.338-1.009.757 0 .42.451.757 1.01.757ZM2.328 7.208c0-.418.339-.757.757-.757h13.619a.756.756 0 1 1 0 1.513H3.084a.756.756 0 0 1-.756-.756ZM22 15.53a4.54 4.54 0 0 1-9.08 0 4.54 4.54 0 0 1 9.08 0Zm-3.512 1.513h-2.055c-.662 0-1.227.432-1.422 1.03a3.52 3.52 0 0 0 2.45.988 3.52 3.52 0 0 0 2.449-.987 1.497 1.497 0 0 0-1.422-1.031Zm-1.028-4.035a1.514 1.514 0 1 0 .001 3.027 1.514 1.514 0 0 0 0-3.027Z",
        fill: "currentColor"
      }
    )
  })
);
var AlbumCollectionCircleUser_default = SvgAlbumCollectionCircleUser;

// src/Icon/icons/AlbumCollection.tsx
import { jsx as jsx25 } from "react/jsx-runtime";
var SvgAlbumCollection = (props) => /* @__PURE__ */ jsx25(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx25(
      "path",
      {
        d: "M4.186 2H19.81c.52 0 .937.418.937.938 0 .519-.418.937-.937.937H4.186a.935.935 0 0 1-.938-.938c0-.519.418-.937.938-.937ZM2.24 11.074A2.495 2.495 0 0 1 4.717 8.25H19.28a2.5 2.5 0 0 1 2.48 2.824l-1.152 8.75A2.502 2.502 0 0 1 18.128 22H5.87a2.503 2.503 0 0 1-2.48-2.176l-1.15-8.75Zm2.476-.949a.627.627 0 0 0-.62.707l1.151 8.75c.04.313.305.543.622.543h12.257a.63.63 0 0 0 .621-.543l1.153-8.75a.625.625 0 0 0-.621-.707H4.717Zm12.906 5c0 2.242-2.52 4.063-5.625 4.063s-5.625-1.82-5.625-4.063c0-2.242 2.52-4.063 5.625-4.063 3.106 0 5.625 1.82 5.625 4.063Zm-15-9.063c0-.519.418-.937.938-.937h16.875c.52 0 .937.418.937.938 0 .519-.418.937-.937.937H3.56a.935.935 0 0 1-.938-.938Zm9.375 10.313c.692 0 1.25-.418 1.25-.938 0-.519-.558-.937-1.25-.937-.691 0-1.25.418-1.25.938 0 .519.559.937 1.25.937Z",
        fill: "currentColor"
      }
    )
  })
);
var AlbumCollection_default = SvgAlbumCollection;

// src/Icon/icons/Album.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
var SvgAlbum = (props) => /* @__PURE__ */ jsx26(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx26(
      "path",
      {
        d: "M18.429 12A6.43 6.43 0 0 1 12 18.429 6.43 6.43 0 0 1 5.571 12 6.43 6.43 0 0 1 12 5.571 6.43 6.43 0 0 1 18.429 12ZM12 10.571c-.79 0-1.429.639-1.429 1.429s.639 1.429 1.429 1.429 1.429-.639 1.429-1.429-.639-1.429-1.429-1.429ZM2 4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857Zm2.143 0v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714H4.857a.714.714 0 0 0-.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var Album_default = SvgAlbum;

// src/Icon/icons/AlignCenter.tsx
import { jsx as jsx27 } from "react/jsx-runtime";
var SvgAlignCenter = (props) => /* @__PURE__ */ jsx27(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx27(
      "path",
      {
        d: "M16.643 2.357a1.07 1.07 0 1 1 0 2.143H7.357a1.07 1.07 0 1 1 0-2.143h9.286Zm4.286 5.714c.593 0 1.071.478 1.071 1.072 0 .593-.478 1.071-1.071 1.071H3.07a1.07 1.07 0 1 1 0-2.143H20.93ZM6.286 14.857c0-.594.477-1.071 1.071-1.071h9.286c.594 0 1.071.477 1.071 1.07 0 .595-.477 1.072-1.071 1.072H7.357a1.069 1.069 0 0 1-1.071-1.071ZM20.929 19.5c.593 0 1.071.477 1.071 1.071s-.478 1.072-1.071 1.072H3.07a1.07 1.07 0 1 1 0-2.143H20.93Z",
        fill: "currentColor"
      }
    )
  })
);
var AlignCenter_default = SvgAlignCenter;

// src/Icon/icons/AlignJustify.tsx
import { jsx as jsx28 } from "react/jsx-runtime";
var SvgAlignJustify = (props) => /* @__PURE__ */ jsx28(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx28(
      "path",
      {
        d: "M20.929 2.357a1.07 1.07 0 1 1 0 2.143H3.07a1.072 1.072 0 0 1 0-2.143H20.93Zm0 5.714c.593 0 1.071.478 1.071 1.072 0 .593-.478 1.071-1.071 1.071H3.07a1.07 1.07 0 1 1 0-2.143H20.93ZM2 14.857c0-.594.48-1.071 1.071-1.071H20.93c.593 0 1.071.477 1.071 1.07 0 .595-.478 1.072-1.071 1.072H3.07A1.07 1.07 0 0 1 2 14.857ZM20.929 19.5c.593 0 1.071.477 1.071 1.071s-.478 1.072-1.071 1.072H3.07a1.07 1.07 0 1 1 0-2.143H20.93Z",
        fill: "currentColor"
      }
    )
  })
);
var AlignJustify_default = SvgAlignJustify;

// src/Icon/icons/AlignLeft.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
var SvgAlignLeft = (props) => /* @__PURE__ */ jsx29(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx29(
      "path",
      {
        d: "M13.786 2.357a1.07 1.07 0 1 1 0 2.143H3.07a1.072 1.072 0 0 1 0-2.143h10.715Zm7.143 5.714c.593 0 1.071.478 1.071 1.072 0 .593-.478 1.071-1.071 1.071H3.07a1.07 1.07 0 1 1 0-2.143H20.93ZM2 14.857c0-.594.48-1.071 1.071-1.071h10.715c.594 0 1.071.477 1.071 1.07 0 .595-.477 1.072-1.071 1.072H3.07A1.07 1.07 0 0 1 2 14.857ZM20.929 19.5c.593 0 1.071.477 1.071 1.071s-.478 1.072-1.071 1.072H3.07a1.07 1.07 0 1 1 0-2.143H20.93Z",
        fill: "currentColor"
      }
    )
  })
);
var AlignLeft_default = SvgAlignLeft;

// src/Icon/icons/AlignRight.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
var SvgAlignRight = (props) => /* @__PURE__ */ jsx30(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx30(
      "path",
      {
        d: "M20.929 2.357a1.07 1.07 0 1 1 0 2.143H10.214a1.07 1.07 0 1 1 0-2.143H20.93Zm0 5.714c.593 0 1.071.478 1.071 1.072 0 .593-.478 1.071-1.071 1.071H3.07a1.07 1.07 0 1 1 0-2.143H20.93Zm0 7.857H10.214a1.069 1.069 0 0 1-1.071-1.071c0-.594.478-1.071 1.071-1.071H20.93c.593 0 1.071.477 1.071 1.07 0 .595-.478 1.072-1.071 1.072Zm0 3.572c.593 0 1.071.477 1.071 1.071s-.478 1.072-1.071 1.072H3.07a1.07 1.07 0 1 1 0-2.143H20.93Z",
        fill: "currentColor"
      }
    )
  })
);
var AlignRight_default = SvgAlignRight;

// src/Icon/icons/AlignSlash.tsx
import { jsx as jsx31 } from "react/jsx-runtime";
var SvgAlignSlash = (props) => /* @__PURE__ */ jsx31(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx31(
      "path",
      {
        d: "M5.095 5.635a.705.705 0 0 1 .627-.385H18.25a.75.75 0 1 1 0 1.5H6.519l3.187 2.5h8.544c.416 0 .75.334.75.75s-.334.75-.75.75h-6.628l3.187 2.5h3.44c.417 0 .75.334.75.75 0 .415-.333.75-.75.75h-1.524l4.987 3.91a.75.75 0 0 1-.925 1.18l-18.5-14.5a.75.75 0 1 1 .926-1.18l1.882 1.475Zm.627 5.087a.748.748 0 0 1-.75-.75c0-.188.097-.331.212-.463l1.575 1.213H5.722Zm0 4.028a.773.773 0 0 1-.75-.778c0-.388.362-.75.75-.75h4.21l1.905 1.528H5.722Zm0 2.5h9.287l1.903 1.5H5.722a.767.767 0 0 1-.75-.75c0-.416.362-.75.75-.75Z",
        fill: "currentColor"
      }
    )
  })
);
var AlignSlash_default = SvgAlignSlash;

// src/Icon/icons/Alt.tsx
import { jsx as jsx32 } from "react/jsx-runtime";
var SvgAlt = (props) => /* @__PURE__ */ jsx32(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx32(
      "path",
      {
        d: "M15 17.25c0 .414.336.75.75.75h5.5a.75.75 0 1 0 0-1.5h-5.5a.748.748 0 0 0-.75.75Zm7-10.5a.75.75 0 0 0-.75-.75h-4.047c-.834 0-1.612.371-2.138 1.018l-7.3 9.02c-.237.293-.59.462-.968.462H2.75a.751.751 0 0 0 0 1.5h4.047c.834 0 1.612-.371 2.138-1.018l7.3-9.02c.237-.293.59-.462.968-.462h4.047c.416 0 .75-.334.75-.75Z",
        fill: "currentColor"
      }
    )
  })
);
var Alt_default = SvgAlt;

// src/Icon/icons/Ampersand.tsx
import { jsx as jsx33 } from "react/jsx-runtime";
var SvgAmpersand = (props) => /* @__PURE__ */ jsx33(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx33(
      "path",
      {
        d: "M19.5 22c-.28 0-.558-.108-.767-.325l-2.7-2.774-.656 1.004A4.596 4.596 0 0 1 11.513 22H8.058a4.634 4.634 0 0 1-4.63-4.625 4.64 4.64 0 0 1 1.89-3.73l3.268-2.396-1.62-1.669A4.88 4.88 0 0 1 5.57 6.152 4.157 4.157 0 0 1 9.723 2h2.408a4.157 4.157 0 0 1 4.155 4.152c0 1.319-.635 2.57-1.698 3.35l-2.749 2.016 3.864 3.972 2.9-4.434a1.072 1.072 0 0 1 1.794 1.173l-3.163 4.835 3.033 3.117A1.071 1.071 0 0 1 19.5 22Zm-9.406-9.201L6.586 15.37a2.491 2.491 0 0 0-1.015 2.005 2.488 2.488 0 0 0 2.487 2.482h3.449c.843 0 1.62-.42 2.078-1.125l.92-1.404-4.411-4.529Zm-.37-8.656a2.012 2.012 0 0 0-2.01 2.009c0 .727.28 1.413.786 1.933l1.83 1.881 2.99-2.193c.515-.376.823-.983.823-1.621 0-1.107-.902-2.01-2.05-2.01h-2.37Z",
        fill: "currentColor"
      }
    )
  })
);
var Ampersand_default = SvgAmpersand;

// src/Icon/icons/AnchorCircleCheck.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var SvgAnchorCircleCheck = (props) => /* @__PURE__ */ jsx34(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx34(
      "path",
      {
        d: "M13.5 6.5c0 1.122-.74 2.072-1.76 2.387.007.038.01.075.01.113v1h1.5c.416 0 .75.334.75.75s-.334.75-.75.75h-1.5v7h.75c.128 0 .253-.006.378-.016.322.494.719.935 1.175 1.303A5.787 5.787 0 0 1 12.5 20h-3a5.752 5.752 0 0 1-5.748-5.622l-.514.44a.75.75 0 0 1-.976-1.137l1.75-1.5a.75.75 0 0 1 .976 0l1.75 1.5a.748.748 0 1 1-.976 1.138l-.509-.438A4.248 4.248 0 0 0 9.5 18.5h.75v-7h-1.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h1.5V9c0-.037.003-.075.01-.113A2.501 2.501 0 0 1 11 4a2.5 2.5 0 0 1 2.5 2.5Zm-2.5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm11 8a4.501 4.501 0 0 1-9 0 4.501 4.501 0 0 1 9 0Zm-3.103-1.353L17 16.044l-.897-.897a.496.496 0 0 0-.706 0 .496.496 0 0 0 0 .706l1.25 1.25a.496.496 0 0 0 .706 0l2.25-2.25a.496.496 0 0 0 0-.706.496.496 0 0 0-.706 0Z",
        fill: "currentColor"
      }
    )
  })
);
var AnchorCircleCheck_default = SvgAnchorCircleCheck;

// src/Icon/icons/AnchorCircleExclamation.tsx
import { jsx as jsx35 } from "react/jsx-runtime";
var SvgAnchorCircleExclamation = (props) => /* @__PURE__ */ jsx35(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx35(
      "path",
      {
        d: "M13.5 6.5c0 1.122-.74 2.072-1.76 2.387.007.038.01.075.01.113v1h1.5c.416 0 .75.334.75.75s-.334.75-.75.75h-1.5v7h.75c.128 0 .253-.006.378-.016.322.494.719.935 1.175 1.303A5.787 5.787 0 0 1 12.5 20h-3a5.752 5.752 0 0 1-5.748-5.622l-.514.44a.75.75 0 0 1-.976-1.137l1.75-1.5a.75.75 0 0 1 .976 0l1.75 1.5a.748.748 0 1 1-.976 1.138l-.509-.438A4.248 4.248 0 0 0 9.5 18.5h.75v-7h-1.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h1.5V9c0-.037.003-.075.01-.113A2.501 2.501 0 0 1 11 4a2.5 2.5 0 0 1 2.5 2.5Zm-2.5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm2 8a4.501 4.501 0 0 1 9 0 4.501 4.501 0 0 1-9 0Zm4.5 3c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75c0 .416.334.75.75.75Zm-.528-5.5v2.5c0 .275.253.5.5.5.303 0 .5-.225.5-.5V13c0-.275-.197-.5-.5-.5a.52.52 0 0 0-.5.5Z",
        fill: "currentColor"
      }
    )
  })
);
var AnchorCircleExclamation_default = SvgAnchorCircleExclamation;

// src/Icon/icons/AnchorCircleXmark.tsx
import { jsx as jsx36 } from "react/jsx-runtime";
var SvgAnchorCircleXmark = (props) => /* @__PURE__ */ jsx36(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx36(
      "path",
      {
        d: "M13.5 6.5c0 1.122-.74 2.072-1.76 2.387.007.038.01.075.01.113v1h1.5c.416 0 .75.334.75.75s-.334.75-.75.75h-1.5v7h.75c.128 0 .253-.006.378-.016.322.494.719.935 1.175 1.303A5.787 5.787 0 0 1 12.5 20h-3a5.752 5.752 0 0 1-5.748-5.622l-.514.44a.75.75 0 0 1-.976-1.137l1.75-1.5a.75.75 0 0 1 .976 0l1.75 1.5a.748.748 0 1 1-.976 1.138l-.509-.438A4.248 4.248 0 0 0 9.5 18.5h.75v-7h-1.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h1.5V9c0-.037.003-.075.01-.113A2.501 2.501 0 0 1 11 4a2.5 2.5 0 0 1 2.5 2.5Zm-2.5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm2 8a4.501 4.501 0 0 1 9 0 4.501 4.501 0 0 1-9 0Zm6.353-1.147a.496.496 0 0 0 0-.706.496.496 0 0 0-.706 0L17.5 14.794l-1.147-1.147a.496.496 0 0 0-.706 0 .496.496 0 0 0 0 .706l1.147 1.147-1.147 1.147a.496.496 0 0 0 0 .706.496.496 0 0 0 .706 0l1.147-1.147 1.147 1.147a.496.496 0 0 0 .706 0 .496.496 0 0 0 0-.706L18.206 15.5l1.147-1.147Z",
        fill: "currentColor"
      }
    )
  })
);
var AnchorCircleXmark_default = SvgAnchorCircleXmark;

// src/Icon/icons/AnchorLock.tsx
import { jsx as jsx37 } from "react/jsx-runtime";
var SvgAnchorLock = (props) => /* @__PURE__ */ jsx37(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx37(
      "path",
      {
        d: "M13.5 6.5c0 1.122-.74 2.072-1.76 2.387.007.038.01.075.01.113v1h1.5c.416 0 .75.334.75.75s-.334.75-.75.75h-1.5v7h.75c.528 0 1.034-.097 1.5-.272V19c0 .269.053.525.15.76a5.758 5.758 0 0 1-1.65.24h-3a5.752 5.752 0 0 1-5.748-5.622l-.514.44a.75.75 0 0 1-.976-1.137l1.75-1.5a.75.75 0 0 1 .976 0l1.75 1.5a.748.748 0 1 1-.976 1.138l-.509-.438A4.248 4.248 0 0 0 9.5 18.5h.75v-7h-1.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h1.5V9c0-.037.003-.075.01-.113A2.501 2.501 0 0 1 11 4a2.5 2.5 0 0 1 2.5 2.5Zm-2.5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7.5 2.5a2.5 2.5 0 0 1 2.5 2.5V14c.553 0 1 .447 1 1v4c0 .553-.447 1-1 1h-5c-.553 0-1-.447-1-1v-4c0-.553.447-1 1-1v-1.5a2.5 2.5 0 0 1 2.5-2.5Zm0 1.5c-.553 0-1 .447-1 1V14h2v-1.5c0-.553-.447-1-1-1Z",
        fill: "currentColor"
      }
    )
  })
);
var AnchorLock_default = SvgAnchorLock;

// src/Icon/icons/Anchor.tsx
import { jsx as jsx38 } from "react/jsx-runtime";
var SvgAnchor = (props) => /* @__PURE__ */ jsx38(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx38(
      "path",
      {
        d: "M14.778 5.889a2.78 2.78 0 0 1-1.955 2.653c.007.041.01.083.01.125v1.11H14.5c.462 0 .834.372.834.834a.831.831 0 0 1-.834.833h-1.666v7.778h.833a4.72 4.72 0 0 0 4.719-4.576l-.566.486a.831.831 0 1 1-1.083-1.264l1.944-1.667a.832.832 0 0 1 1.084 0l1.944 1.667a.832.832 0 1 1-1.083 1.264l-.601-.49c-.045 3.462-2.879 6.247-6.358 6.247h-3.333a6.391 6.391 0 0 1-6.388-6.246l-.57.49a.833.833 0 0 1-1.085-1.265l1.944-1.667a.834.834 0 0 1 1.085 0l1.944 1.667a.831.831 0 1 1-1.083 1.264l-.566-.486a4.72 4.72 0 0 0 4.719 4.576h.833v-7.778H9.5a.831.831 0 0 1-.833-.833c0-.462.371-.833.833-.833h1.667V8.667c0-.042.003-.084.01-.125a2.778 2.778 0 1 1 3.6-2.653ZM12 6.999a1.11 1.11 0 1 0 .001-2.22 1.11 1.11 0 0 0 0 2.22Z",
        fill: "currentColor"
      }
    )
  })
);
var Anchor_default = SvgAnchor;

// src/Icon/icons/AngleDown.tsx
import { jsx as jsx39 } from "react/jsx-runtime";
var SvgAngleDown = (props) => /* @__PURE__ */ jsx39(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx39(
      "path",
      {
        d: "m21.575 8.906-8.637 8.131c-.261.296-.602.42-.937.42-.336 0-.675-.124-.938-.372l-8.637-8.18a1.37 1.37 0 0 1-.053-1.931A1.361 1.361 0 0 1 4.3 6.923l7.7 7.29L19.7 6.917a1.363 1.363 0 0 1 1.929.053 1.377 1.377 0 0 1-.054 1.936Z",
        fill: "currentColor"
      }
    )
  })
);
var AngleDown_default = SvgAngleDown;

// src/Icon/icons/AngleLeft.tsx
import { jsx as jsx40 } from "react/jsx-runtime";
var SvgAngleLeft = (props) => /* @__PURE__ */ jsx40(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx40(
      "path",
      {
        d: "m15.074 21.575-8.13-8.637a1.36 1.36 0 0 1-.374-.937c0-.338.125-.675.373-.938l8.131-8.637a1.365 1.365 0 0 1 1.982 1.875l-7.296 7.7 7.296 7.7a1.363 1.363 0 0 1-.054 1.928 1.368 1.368 0 0 1-1.928-.054Z",
        fill: "currentColor"
      }
    )
  })
);
var AngleLeft_default = SvgAngleLeft;

// src/Icon/icons/AngleRight.tsx
import { jsx as jsx41 } from "react/jsx-runtime";
var SvgAngleRight = (props) => /* @__PURE__ */ jsx41(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx41(
      "path",
      {
        d: "m8.926 2.426 8.13 8.637a1.362 1.362 0 0 1 0 1.875l-8.13 8.638a1.366 1.366 0 0 1-1.982-1.878l7.296-7.7L6.944 4.3a1.36 1.36 0 0 1 .054-1.926 1.365 1.365 0 0 1 1.928.053Z",
        fill: "currentColor"
      }
    )
  })
);
var AngleRight_default = SvgAngleRight;

// src/Icon/icons/AngleUp.tsx
import { jsx as jsx42 } from "react/jsx-runtime";
var SvgAngleUp = (props) => /* @__PURE__ */ jsx42(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx42(
      "path",
      {
        d: "m2.426 15.122 8.637-8.13c.26-.296.602-.421.937-.421.335 0 .675.124.938.373l8.636 8.13a1.365 1.365 0 0 1-1.875 1.981l-7.7-7.295-7.698 7.295a1.362 1.362 0 0 1-1.928-.053c-.517-.494-.494-1.357.053-1.88Z",
        fill: "currentColor"
      }
    )
  })
);
var AngleUp_default = SvgAngleUp;

// src/Icon/icons/Angle.tsx
import { jsx as jsx43 } from "react/jsx-runtime";
var SvgAngle = (props) => /* @__PURE__ */ jsx43(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx43(
      "path",
      {
        d: "M4.836 19.857H20.93c.593 0 1.07.478 1.07 1.072 0 .593-.477 1.071-1.07 1.071H3.07c-.374 0-.721-.196-.915-.513a1.077 1.077 0 0 1-.035-1.054l9.285-17.856a1.072 1.072 0 0 1 1.902.989L4.836 19.857Zm7.927-11.45c1.224.874 2.268 1.995 3.143 3.21l-1.821 1.137c-.697-.897-1.429-1.705-2.29-2.41l.968-1.938Zm3.643 9.665a13.126 13.126 0 0 0-1.196-3.492l1.821-1.142a15.336 15.336 0 0 1 1.554 4.633h-2.179Z",
        fill: "currentColor"
      }
    )
  })
);
var Angle_default = SvgAngle;

// src/Icon/icons/AnglesDown.tsx
import { jsx as jsx44 } from "react/jsx-runtime";
var SvgAnglesDown = (props) => /* @__PURE__ */ jsx44(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx44(
      "path",
      {
        d: "m19.255 12.561-7.25 6.489-7.3-6.489a1.273 1.273 0 0 0-.853-.326 1.42 1.42 0 0 0-.953.378c-.423.577-.378 1.388.148 1.857l8.104 7.203c.486.436 1.22.436 1.706 0l8.103-7.203c.527-.47.572-1.232.1-1.806a1.277 1.277 0 0 0-1.805-.103Zm-8.152-1.077c.487.437 1.22.437 1.706 0l8.104-7.202c.526-.47.572-1.232.1-1.806a1.277 1.277 0 0 0-1.806-.1l-7.203 6.437-7.298-6.486A1.273 1.273 0 0 0 3.852 2a1.42 1.42 0 0 0-.953.379c-.423.574-.378 1.385.148 1.855l8.056 7.25Z",
        fill: "currentColor"
      }
    )
  })
);
var AnglesDown_default = SvgAnglesDown;

// src/Icon/icons/AnglesLeft.tsx
import { jsx as jsx45 } from "react/jsx-runtime";
var SvgAnglesLeft = (props) => /* @__PURE__ */ jsx45(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx45(
      "path",
      {
        d: "m11.465 19.26-6.473-7.236L11.46 4.79a1.27 1.27 0 0 0 .326-.852c0-.35-.143-.7-.378-.95-.572-.471-1.38-.426-1.849.099l-7.233 8.039a1.272 1.272 0 0 0 0 1.703l7.187 8.086c.47.526 1.23.57 1.802.1.574-.419.617-1.233.149-1.754Zm1.074-8.135a1.273 1.273 0 0 0 0 1.703l7.188 8.086c.469.526 1.229.57 1.802.1.527-.469.57-1.279.1-1.802l-6.424-7.188 6.47-7.235A1.27 1.27 0 0 0 22 3.937c0-.35-.143-.7-.378-.95a1.275 1.275 0 0 0-1.802.099l-7.28 8.039Z",
        fill: "currentColor"
      }
    )
  })
);
var AnglesLeft_default = SvgAnglesLeft;

// src/Icon/icons/AnglesRight.tsx
import { jsx as jsx46 } from "react/jsx-runtime";
var SvgAnglesRight = (props) => /* @__PURE__ */ jsx46(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx46(
      "path",
      {
        d: "M12.585 4.684 19.09 12l-6.498 7.267c-.219.244-.327.55-.327.855 0 .352.143.703.379.955.527.473 1.339.428 1.81-.1l7.219-8.122a1.278 1.278 0 0 0 0-1.71l-7.22-8.122c-.47-.528-1.234-.573-1.81-.1-.484.47-.527 1.286-.056 1.761Zm-1.079 8.17a1.278 1.278 0 0 0 0-1.71L4.238 3.023a1.282 1.282 0 0 0-1.81-.1c-.53.47-.573 1.287-.1 1.762L8.828 12l-6.498 7.267c-.219.244-.327.55-.327.855 0 .352.143.703.38.955.527.473 1.338.428 1.81-.1l7.312-8.122Z",
        fill: "currentColor"
      }
    )
  })
);
var AnglesRight_default = SvgAnglesRight;

// src/Icon/icons/AnglesUp.tsx
import { jsx as jsx47 } from "react/jsx-runtime";
var SvgAnglesUp = (props) => /* @__PURE__ */ jsx47(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx47(
      "path",
      {
        d: "M4.717 11.465 12 4.99l7.235 6.47c.243.217.547.325.852.325.35 0 .7-.143.95-.377a1.275 1.275 0 0 0-.099-1.802l-8.087-7.28a1.272 1.272 0 0 0-1.702 0L3.06 9.56a1.278 1.278 0 0 0-.099 1.804c.469.526 1.278.569 1.755.1Zm8.134 1.074a1.273 1.273 0 0 0-1.702 0l-8.087 7.188c-.525.469-.57 1.229-.1 1.802.47.527 1.279.57 1.803.1L12 15.205l7.235 6.47c.243.217.547.325.852.325.35 0 .7-.143.95-.378a1.275 1.275 0 0 0-.099-1.802l-8.087-7.28Z",
        fill: "currentColor"
      }
    )
  })
);
var AnglesUp_default = SvgAnglesUp;

// src/Icon/icons/Apartment.tsx
import { jsx as jsx48 } from "react/jsx-runtime";
var SvgApartment = (props) => /* @__PURE__ */ jsx48(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx48(
      "path",
      {
        d: "M13.111 14.778a.557.557 0 0 1-.555-.556v-1.11c0-.306.25-.556.555-.556h1.111c.306 0 .556.25.556.555v1.111c0 .306-.25.556-.556.556h-1.11Zm6.111 2.778c0 .305-.25.555-.555.555h-1.111a.557.557 0 0 1-.556-.555v-1.111c0-.306.25-.556.556-.556h1.11c.306 0 .556.25.556.556v1.11ZM5.333 14.778a.556.556 0 0 1-.555-.556v-1.11c0-.306.248-.556.555-.556h1.111c.306 0 .556.25.556.555v1.111c0 .306-.25.556-.556.556h-1.11ZM7 17.556c0 .305-.25.555-.556.555h-1.11a.556.556 0 0 1-.556-.555v-1.111c0-.306.248-.556.555-.556h1.111c.306 0 .556.25.556.556v1.11Zm2.778-2.778a.557.557 0 0 1-.556-.556v-1.11c0-.306.25-.556.556-.556h1.11c.306 0 .556.25.556.555v1.111c0 .306-.25.556-.555.556H9.778Zm5-7.222c0 .305-.25.555-.556.555h-1.11a.557.557 0 0 1-.556-.555V6.445c0-.307.25-.556.555-.556h1.111c.306 0 .556.249.556.556v1.11Zm-3.89-1.667c.306 0 .556.249.556.556v1.11c0 .306-.25.556-.555.556H9.778a.557.557 0 0 1-.556-.555V6.445c0-.307.25-.556.556-.556h1.11Zm3.89 5c0 .306-.25.556-.556.556h-1.11a.557.557 0 0 1-.556-.556V9.778c0-.306.25-.556.555-.556h1.111c.306 0 .556.25.556.556v1.111Zm2.778 3.889a.557.557 0 0 1-.556-.556v-1.11c0-.306.25-.556.556-.556h1.11c.306 0 .556.25.556.555v1.111c0 .306-.25.556-.555.556h-1.111ZM7 10.889c0 .306-.25.556-.556.556h-1.11a.556.556 0 0 1-.556-.556V9.778c0-.306.248-.556.555-.556h1.111c.306 0 .556.25.556.556v1.111Zm2.778.556a.557.557 0 0 1-.556-.556V9.778c0-.306.25-.556.556-.556h1.11c.306 0 .556.25.556.556v1.111c0 .306-.25.556-.555.556H9.778Zm-5.556 9.444A2.223 2.223 0 0 1 2 18.667v-10c0-1.226.995-2.222 2.222-2.222h2.222V5.334c0-1.228.997-2.223 2.223-2.223h6.666c1.226 0 2.223.995 2.223 2.223v4.444h2.222C21.004 9.778 22 10.774 22 12v6.667a2.224 2.224 0 0 1-2.222 2.222H4.222Zm3.89-12.778h-3.89a.556.556 0 0 0-.555.556v10c0 .305.248.555.555.555h6.667v-1.666a1.11 1.11 0 1 1 2.222 0v1.666h6.667c.305 0 .555-.25.555-.555V12a.557.557 0 0 0-.555-.555h-3.89V5.334a.556.556 0 0 0-.555-.556H8.667a.556.556 0 0 0-.556.556V8.11Z",
        fill: "currentColor"
      }
    )
  })
);
var Apartment_default = SvgApartment;

// src/Icon/icons/Aperture.tsx
import { jsx as jsx49 } from "react/jsx-runtime";
var SvgAperture = (props) => /* @__PURE__ */ jsx49(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx49(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm7.027 5.938H11.82l2.194-3.8a8.146 8.146 0 0 1 5.013 3.8ZM14.527 12l-1.262 2.188h-2.527L9.473 12l1.262-2.188h2.527L14.527 12ZM12 3.875l-3.61 6.25-2.195-3.8A8.1 8.1 0 0 1 12 3.874Zm-7.031 4.07 3.601 6.242H4.183A8.07 8.07 0 0 1 3.875 12c0-1.477.402-2.86 1.094-4.055Zm.005 8.117h7.207l-2.193 3.8a8.132 8.132 0 0 1-5.014-3.8ZM12 20.125l3.609-6.25 2.194 3.801A8.1 8.1 0 0 1 12 20.125Zm6.996-4.07L15.43 9.813h4.39A8.24 8.24 0 0 1 20.125 12a7.76 7.76 0 0 1-1.129 4.055Z",
        fill: "currentColor"
      }
    )
  })
);
var Aperture_default = SvgAperture;

// src/Icon/icons/ApplicationFirewall.tsx
import { jsx as jsx50 } from "react/jsx-runtime";
var SvgApplicationFirewall = (props) => /* @__PURE__ */ jsx50(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx50(
      "path",
      {
        d: "M12 21.45c-.154 0-.395-.058-.645-.193C5.887 18.177 4 16.886 4 13.371V6.006c0-1.011.443-1.339 1.252-1.676 1.135-.462 4.813-1.858 5.949-2.186.25-.067.53-.144.799-.144.27 0 .549.058.809.144 1.136.395 4.804 1.714 5.94 2.186.818.347 1.251.665 1.251 1.676v7.365c0 3.515-1.877 4.815-7.355 7.886-.24.135-.491.193-.645.193Zm0-1.743c.154 0 .318-.058.597-.23 4.447-2.707 5.872-3.486 5.872-6.462V6.304c0-.327-.057-.462-.317-.558-1.493-.51-4.313-1.531-5.767-2.11A1.129 1.129 0 0 0 12 3.55a.939.939 0 0 0-.385.087c-1.454.578-4.294 1.53-5.757 2.109-.27.105-.327.23-.327.558v6.711c0 2.976 1.424 3.765 5.872 6.461.289.173.443.231.597.231Zm.895-12.498c0-.414.405-.54.713-.327l2.378 1.608c.288.202.298.568.028.75l-2.397 1.618c-.317.212-.722.077-.722-.346v-1.02H8.178a.633.633 0 0 1-.635-.627c0-.346.289-.635.635-.635h4.717V7.21Zm-5.15 6.952c-.27-.192-.27-.558.02-.76l2.387-1.609c.298-.202.712-.077.712.328v1.03h4.717c.347 0 .626.289.626.636 0 .346-.28.625-.626.625h-4.717v1.021c0 .414-.414.549-.722.347L7.745 14.16Z",
        fill: "currentColor"
      }
    )
  })
);
var ApplicationFirewall_default = SvgApplicationFirewall;

// src/Icon/icons/Apps.tsx
import { jsx as jsx51, jsxs } from "react/jsx-runtime";
var SvgApps = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsx51(
        "path",
        {
          d: "m12.681 8.738-.272.47-.266-.47a.611.611 0 0 0-1.059.61l.622 1.08-1.992 3.451H8.16a.609.609 0 0 0-.61.61c0 .338.272.61.61.61h5.548c.266-.5-.078-1.22-.69-1.22h-1.894l2.617-4.531a.61.61 0 1 0-1.059-.61ZM9.47 16.744l.585-1.017c-.317-.383-.718-.5-1.208-.347l-.437.754a.61.61 0 1 0 1.06.61Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx51(
        "path",
        {
          d: "M16.695 13.882h-1.588l-.161-.28a850.787 850.787 0 0 0-1.637-2.83c-.362.299-.726 1.184-.215 2.066l.874 1.514 1.381 2.392a.612.612 0 0 0 1.059-.61l-.595-1.032h.882c.338 0 .61-.272.61-.61a.609.609 0 0 0-.61-.61Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx51(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2.125 17.376c0 1.8.913 2.695 2.73 2.695h14.541c1.556 0 2.469-.904 2.469-2.695V8.45c0-1.79-.921-2.694-2.73-2.694h-8.344c-.59 0-.947-.14-1.382-.513l-.53-.435C8.305 4.321 7.862 4.164 7 4.164H4.524c-1.521 0-2.399.87-2.399 2.616v10.596Zm16.985 1.295H4.872c-.87 0-1.348-.46-1.348-1.364V6.859c0-.86.452-1.304 1.287-1.304h1.834c.574 0 .921.148 1.365.521l.53.444c.565.469 1.026.634 1.886.634h8.684c.86 0 1.356.47 1.356 1.374v8.787c0 .896-.496 1.356-1.356 1.356Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
var Apps_default = SvgApps;

// src/Icon/icons/AppStore.tsx
import { jsx as jsx52 } from "react/jsx-runtime";
var SvgAppStore = (props) => /* @__PURE__ */ jsx52(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx52(
      "path",
      {
        d: "M10.9061 4.69756L11.2731 4.0645C11.4989 3.66933 12.0029 3.53627 12.3981 3.76208C12.7932 3.98788 12.9263 4.49192 12.7005 4.88708L9.17225 10.9959H11.7247C12.5513 10.9959 13.015 11.9677 12.6561 12.6411H5.17629C4.72064 12.6411 4.3537 12.2742 4.3537 11.8185C4.3537 11.3629 4.72064 10.9959 5.17629 10.9959H7.27306L9.95854 6.34272L9.11983 4.88708C8.89403 4.49192 9.02709 3.99192 9.42225 3.76208C9.81741 3.53627 10.3174 3.66933 10.5473 4.0645L10.9061 4.69756ZM7.73274 13.4879L6.94241 14.8589C6.71661 15.254 6.21258 15.3871 5.81741 15.1613C5.42225 14.9355 5.28919 14.4314 5.51499 14.0363L6.1037 13.0201C6.765 12.8145 7.30532 12.9718 7.73274 13.4879ZM14.5432 11H16.6844C17.14 11 17.5069 11.3669 17.5069 11.8226C17.5069 12.2782 17.14 12.6451 16.6844 12.6451H15.4948L16.2973 14.0363C16.5231 14.4314 16.39 14.9314 15.9948 15.1613C15.5997 15.3871 15.0997 15.254 14.8698 14.8589C13.519 12.5161 12.5029 10.7621 11.8295 9.59272C11.14 8.40321 11.6319 7.20966 12.1198 6.80643C12.6602 7.73385 13.4666 9.13305 14.5432 11ZM10.9102 0.145142C5.38596 0.145142 0.910156 4.62095 0.910156 10.1451C0.910156 15.6693 5.38596 20.1451 10.9102 20.1451C16.4343 20.1451 20.9102 15.6693 20.9102 10.1451C20.9102 4.62095 16.4343 0.145142 10.9102 0.145142ZM19.6198 10.1451C19.6198 14.9314 15.7448 18.8548 10.9102 18.8548C6.12387 18.8548 2.20048 14.9798 2.20048 10.1451C2.20048 5.35885 6.07548 1.43546 10.9102 1.43546C15.6964 1.43546 19.6198 5.31046 19.6198 10.1451Z",
        fill: "currentColor"
      }
    )
  })
);
var AppStore_default = SvgAppStore;

// src/Icon/icons/ArrowDown19.tsx
import { jsx as jsx53 } from "react/jsx-runtime";
var SvgArrowDown19 = (props) => /* @__PURE__ */ jsx53(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx53(
      "path",
      {
        d: "M16.576 8.422c-.561 0-1.017.455-1.017 1.017 0 .561.456 1.017.979 1.017h3.428a1.017 1.017 0 0 0 0-2.034h-.678V3.337a1.016 1.016 0 0 0-1.54-.873L16.053 3.48a1.018 1.018 0 0 0 1.046 1.745l.155-.094v3.29h-.678Zm1.695 3.428a3.727 3.727 0 0 0-.806 7.365l-.658.805a1.014 1.014 0 0 0 .786 1.66c.294 0 .587-.127.787-.373 2.989-3.69 3.62-4.097 3.62-5.728 0-2.06-1.67-3.73-3.729-3.73Zm1.242 4.864-.062.075a1.692 1.692 0 0 1-1.18.484c-.935 0-1.695-.76-1.695-1.694a1.696 1.696 0 0 1 3.39 0c0 .44-.178.834-.453 1.135Zm-9.107-1.513-2.305 2.534V3.375a1.016 1.016 0 1 0-2.034 0v14.361l-2.303-2.498a1.012 1.012 0 0 0-1.437-.057 1.018 1.018 0 0 0-.057 1.438l4.03 4.412c.384.416 1.11.416 1.494 0l4.03-4.412a1.018 1.018 0 0 0-.058-1.438c-.338-.386-.982-.357-1.36.02Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDown19_default = SvgArrowDown19;

// src/Icon/icons/ArrowDown91.tsx
import { jsx as jsx54 } from "react/jsx-runtime";
var SvgArrowDown91 = (props) => /* @__PURE__ */ jsx54(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx54(
      "path",
      {
        d: "m10.406 15.351-2.305 2.534V3.525a1.016 1.016 0 1 0-2.034 0v14.361l-2.303-2.498a1.012 1.012 0 0 0-1.437-.057 1.018 1.018 0 0 0-.057 1.438l4.03 4.412c.384.416 1.11.416 1.494 0l4.03-4.412a1.018 1.018 0 0 0-.058-1.438c-.338-.386-.982-.357-1.36.02Zm9.56 4.106h-.678v-5.085a1.016 1.016 0 0 0-1.54-.872l-1.695 1.017a1.018 1.018 0 0 0 1.046 1.745l.155-.094v3.29h-.678a1.017 1.017 0 0 0 0 2.033h3.39a1.017 1.017 0 0 0 0-2.034Zm-2.538-9.585-.659.806a1.014 1.014 0 0 0 .143 1.43c.228.154.452.23.681.23.294 0 .587-.127.787-.373C21.369 8.275 22 7.868 22 6.237a3.729 3.729 0 0 0-7.458 0c-.038 1.784 1.25 3.267 2.886 3.635Zm.843-5.33c.935 0 1.695.76 1.695 1.695 0 .44-.179.834-.456 1.136l-.06.075c-.306.297-.721.484-1.179.484a1.696 1.696 0 0 1 0-3.39Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDown91_default = SvgArrowDown91;

// src/Icon/icons/ArrowDownAZ.tsx
import { jsx as jsx55 } from "react/jsx-runtime";
var SvgArrowDownAZ = (props) => /* @__PURE__ */ jsx55(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx55(
      "path",
      {
        d: "M20.266 19.457H17.64l3.469-4.462c.238-.307.282-.723.111-1.071a1.04 1.04 0 0 0-.953-.569H15.56c-.562 0-.98.455-.98 1.017 0 .561.456 1.017.98 1.017h2.667l-3.468 4.462a1.018 1.018 0 0 0-.111 1.07 1 1 0 0 0 .873.57h4.708c.561 0 .979-.456.979-1.017 0-.562-.344-1.017-.94-1.017Zm1.627-10.284L18.881 3.07c-.345-.69-1.475-.69-1.82 0L14.05 9.173a1.016 1.016 0 1 0 1.819.908l.148-.455h3.828l.227.455a1.013 1.013 0 0 0 1.364.455c.505-.253.708-.863.458-1.363Zm-4.86-1.58.897-1.795.9 1.794h-1.797Zm-6.627 7.758-2.305 2.534V3.525a1.017 1.017 0 1 0-2.034 0v14.36l-2.303-2.497a1.012 1.012 0 0 0-1.437-.057 1.018 1.018 0 0 0-.057 1.438l4.03 4.41c.384.417 1.11.417 1.493 0l4.03-4.41a1.017 1.017 0 0 0-.057-1.438c-.339-.387-.983-.357-1.36.02Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownAZ_default = SvgArrowDownAZ;

// src/Icon/icons/ArrowDownArrowUp.tsx
import { jsx as jsx56 } from "react/jsx-runtime";
var SvgArrowDownArrowUp = (props) => /* @__PURE__ */ jsx56(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx56(
      "path",
      {
        d: "m2.279 16.882 3.873 3.873c.38.38.992.38 1.368 0l3.873-3.873a.968.968 0 0 0-1.368-1.368l-2.219 2.22V3.93a.966.966 0 0 0-.968-.968.966.966 0 0 0-.968.968v13.802L3.65 15.51a.968.968 0 0 0-1.368 1.368l-.003.004ZM16.48 3.245l-3.873 3.873a.968.968 0 0 0 1.368 1.368l2.219-2.219V20.07c0 .537.431.969.968.969a.966.966 0 0 0 .968-.969V6.267l2.22 2.22a.968.968 0 0 0 1.368-1.368l-3.866-3.874a.964.964 0 0 0-1.368 0h-.004Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownArrowUp_default = SvgArrowDownArrowUp;

// src/Icon/icons/ArrowDownBigSmall.tsx
import { jsx as jsx57 } from "react/jsx-runtime";
var SvgArrowDownBigSmall = (props) => /* @__PURE__ */ jsx57(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx57(
      "path",
      {
        d: "M20.73 3.11h-6.35a1.27 1.27 0 0 0-1.27 1.27v6.35c0 .7.57 1.27 1.27 1.27h6.35A1.27 1.27 0 0 0 22 10.73V4.38a1.27 1.27 0 0 0-1.27-1.27Zm-.635 6.985h-5.08v-5.08h5.08v5.08Zm-1.905 4.444h-3.81c-.698 0-1.27.572-1.27 1.27v3.81c0 .698.572 1.27 1.27 1.27h3.81c.699 0 1.27-.572 1.27-1.27v-3.81c0-.698-.571-1.27-1.27-1.27Zm-.635 4.445h-2.54v-2.54h2.54v2.54Zm-7.682-3.846-2.159 2.373V4.064a.952.952 0 1 0-1.905 0v13.448l-2.157-2.34a.947.947 0 0 0-1.346-.053.953.953 0 0 0-.053 1.347l3.774 4.131c.36.39 1.04.39 1.399 0l3.774-4.13a.953.953 0 0 0-.054-1.347c-.317-.363-.92-.335-1.273.018Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownBigSmall_default = SvgArrowDownBigSmall;

// src/Icon/icons/ArrowDownFromDottedLine.tsx
import { jsx as jsx58 } from "react/jsx-runtime";
var SvgArrowDownFromDottedLine = (props) => /* @__PURE__ */ jsx58(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx58(
      "path",
      {
        d: "M12 4.852A1.426 1.426 0 1 0 12 2a1.426 1.426 0 0 0 0 2.852Zm8.555 0a1.426 1.426 0 1 0 0-2.852 1.426 1.426 0 0 0 0 2.852Zm-4.278 0a1.426 1.426 0 1 0 0-2.852 1.426 1.426 0 0 0 0 2.852Zm-8.554 0a1.426 1.426 0 1 0 0-2.852 1.426 1.426 0 0 0 0 2.852Zm-4.278 0a1.426 1.426 0 1 0 0-2.852 1.426 1.426 0 0 0 0 2.852Zm7.775 16.824c.404.432 1.153.432 1.557 0l5.703-6.069a1.07 1.07 0 0 0-1.557-1.467l-3.854 4.1V8.814A1.07 1.07 0 0 0 12 7.74c-.59 0-1.07.483-1.07 1.072v9.428l-3.855-4.102a1.072 1.072 0 0 0-1.51-.045 1.07 1.07 0 0 0-.047 1.514l5.702 6.068Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownFromDottedLine_default = SvgArrowDownFromDottedLine;

// src/Icon/icons/ArrowDownFromLine.tsx
import { jsx as jsx59 } from "react/jsx-runtime";
var SvgArrowDownFromLine = (props) => /* @__PURE__ */ jsx59(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx59(
      "path",
      {
        d: "M4.5 4.144h15A1.072 1.072 0 0 0 19.5 2h-15a1.072 1.072 0 0 0 0 2.144Zm12.433 9.985-3.862 4.106V7.361a1.072 1.072 0 1 0-2.143 0v10.874L7.067 14.13a1.065 1.065 0 0 0-.78-.336 1.071 1.071 0 0 0-.78 1.806l5.674 6.075c.404.433 1.155.433 1.56 0l5.713-6.075a1.071 1.071 0 0 0-.046-1.515c-.39-.407-1.068-.39-1.474.043Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownFromLine_default = SvgArrowDownFromLine;

// src/Icon/icons/ArrowDownLeftAndArrowUpRightToCenter.tsx
import { jsx as jsx60 } from "react/jsx-runtime";
var SvgArrowDownLeftAndArrowUpRightToCenter = (props) => /* @__PURE__ */ jsx60(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx60(
      "path",
      {
        d: "M13.284 11.254c.124.054.254.08.383.08h6a.996.996 0 0 0 .998-.998.999.999 0 0 0-.997-1.003H16.08l5.626-5.626a1 1 0 1 0-1.414-1.414L14.667 7.92V4.332a1 1 0 0 0-2 0v6.001a1 1 0 0 0 .077.383c.102.242.26.438.54.538Zm-2.568 1.492a.957.957 0 0 0-.383-.08h-6a1 1 0 0 0 0 2h3.586l-5.626 5.627a1 1 0 1 0 1.414 1.414l5.626-5.627v3.588a1 1 0 0 0 2 0v-6.001a1 1 0 0 0-.077-.383c-.102-.28-.298-.438-.54-.538Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownLeftAndArrowUpRightToCenter_default = SvgArrowDownLeftAndArrowUpRightToCenter;

// src/Icon/icons/ArrowDownLeft.tsx
import { jsx as jsx61 } from "react/jsx-runtime";
var SvgArrowDownLeft = (props) => /* @__PURE__ */ jsx61(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx61(
      "path",
      {
        d: "M21.512 4.502 7.124 19h11.382a1.5 1.5 0 0 1 0 3.001H3.502c-.828 0-1.5-.669-1.5-1.5V5.496c0-.825.672-1.5 1.5-1.5.829 0 1.5.675 1.5 1.5V16.88L19.444 2.44a1.5 1.5 0 0 1 2.122 0c.586.586.585 1.531-.053 2.062Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownLeft_default = SvgArrowDownLeft;

// src/Icon/icons/ArrowDownLong.tsx
import { jsx as jsx62 } from "react/jsx-runtime";
var SvgArrowDownLong = (props) => /* @__PURE__ */ jsx62(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx62(
      "path",
      {
        d: "M6.025 15.085a.93.93 0 0 1 .663-.274c.24 0 .48.092.663.275l3.712 3.713V2.937c0-.517.421-.937.937-.937.515 0 .937.42.937.937V18.8l3.712-3.711a.937.937 0 1 1 1.326 1.325l-5.312 5.312a.937.937 0 0 1-1.326 0l-5.312-5.312a.94.94 0 0 1 0-1.328Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownLong_default = SvgArrowDownLong;

// src/Icon/icons/ArrowDownRight.tsx
import { jsx as jsx63 } from "react/jsx-runtime";
var SvgArrowDownRight = (props) => /* @__PURE__ */ jsx63(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx63(
      "path",
      {
        d: "M21.973 5.545v14.96c0 .825-.67 1.495-1.496 1.495H5.517a1.494 1.494 0 0 1-1.495-1.496c0-.829.67-1.496 1.496-1.496h11.35L2.465 4.554a1.496 1.496 0 1 1 2.116-2.116l14.4 14.457V5.545a1.5 1.5 0 0 1 1.496-1.496 1.5 1.5 0 0 1 1.496 1.496Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownRight_default = SvgArrowDownRight;

// src/Icon/icons/ArrowDownShortWide.tsx
import { jsx as jsx64 } from "react/jsx-runtime";
var SvgArrowDownShortWide = (props) => /* @__PURE__ */ jsx64(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx64(
      "path",
      {
        d: "M12.721 6.357h1.693c.467 0 .815-.38.815-.847 0-.467-.35-.846-.815-.846H12.72a.848.848 0 0 0-.846.846c0 .468.38.847.846.847Zm0 4.514h3.918a.847.847 0 0 0 0-1.693h-3.918a.849.849 0 0 0-.846.847c0 .465.38.846.846.846Zm8.433 7.336H12.72a.847.847 0 0 0 0 1.693h8.433c.467 0 .846-.38.846-.847a.828.828 0 0 0-.846-.846Zm-8.433-2.822h6.175a.847.847 0 0 0 0-1.693h-6.175a.849.849 0 0 0-.846.847c0 .465.38.846.846.846Zm-3.724-.596L7.078 16.9V4.946a.846.846 0 1 0-1.693 0v11.952l-1.917-2.08a.842.842 0 0 0-1.196-.046.847.847 0 0 0-.047 1.197l3.354 3.67c.32.347.924.347 1.243 0l3.354-3.67a.847.847 0 0 0-.047-1.197c-.282-.322-.818-.298-1.132.016Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownShortWide_default = SvgArrowDownShortWide;

// src/Icon/icons/ArrowDownSmallBig.tsx
import { jsx as jsx65 } from "react/jsx-runtime";
var SvgArrowDownSmallBig = (props) => /* @__PURE__ */ jsx65(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx65(
      "path",
      {
        d: "M14.38 9.46h3.81c.699 0 1.27-.572 1.27-1.27V4.38c0-.698-.571-1.27-1.27-1.27h-3.81c-.698 0-1.27.572-1.27 1.27v3.81c0 .698.572 1.27 1.27 1.27Zm.636-4.445h2.54v2.54h-2.54v-2.54ZM20.73 12h-6.35a1.27 1.27 0 0 0-1.27 1.27v6.35c0 .7.57 1.27 1.27 1.27h6.35a1.27 1.27 0 0 0 1.27-1.27v-6.35c0-.702-.567-1.27-1.27-1.27Zm-.635 6.985h-5.08v-5.08h5.08v5.08ZM9.873 15.138l-2.159 2.373V4.064a.952.952 0 1 0-1.905 0v13.448l-2.157-2.34a.947.947 0 0 0-1.346-.053.953.953 0 0 0-.053 1.347l3.774 4.131c.36.39 1.04.39 1.399 0l3.774-4.13a.953.953 0 0 0-.054-1.347c-.317-.363-.92-.335-1.273.018Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownSmallBig_default = SvgArrowDownSmallBig;

// src/Icon/icons/ArrowDownSquareTriangle.tsx
import { jsx as jsx66 } from "react/jsx-runtime";
var SvgArrowDownSquareTriangle = (props) => /* @__PURE__ */ jsx66(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx66(
      "path",
      {
        d: "M20.034 2.818h-5.247c-.724 0-1.274.588-1.274 1.312v5.246c0 .724.587 1.312 1.274 1.312h5.247c.724 0 1.311-.588 1.311-1.312V4.13a1.31 1.31 0 0 0-1.311-1.312Zm-.656 5.902h-3.935V4.786h3.935V8.72Zm2.463 10.776-3.407-5.62a1.203 1.203 0 0 0-1.024-.563c-.415 0-.8.21-1.02.563l-3.413 5.62c-.45.748.113 1.686 1.025 1.686h6.816c.912-.002 1.474-.94 1.023-1.686Zm-6.386-.283 1.958-3.233 1.957 3.233h-3.915Zm-3.88-2.599a.984.984 0 0 0-1.445-1.335l-2.228 2.413V3.802a.984.984 0 1 0-1.968 0v13.891l-2.228-2.416a.984.984 0 0 0-1.445 1.336l3.898 4.266c.372.403 1.074.403 1.445 0l3.97-4.265Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownSquareTriangle_default = SvgArrowDownSquareTriangle;

// src/Icon/icons/ArrowDownToArc.tsx
import { jsx as jsx67 } from "react/jsx-runtime";
var SvgArrowDownToArc = (props) => /* @__PURE__ */ jsx67(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx67(
      "path",
      {
        d: "M12 20.125c4.488 0 8.125-3.637 8.125-8.16 0-.485.418-.938.938-.938.519 0 .937.454.937.938C22 17.523 17.523 22 12 22S2 17.523 2 11.965c0-.485.42-.938.938-.938.517 0 .937.454.937.938 0 4.523 3.637 8.16 8.125 8.16Zm.688-4.676a.94.94 0 0 1-.688.301c-.262 0-.543-.11-.688-.3L7.25 11.073c-.352-.379-.363-.972.05-1.324.38-.352.973-.363 1.325.05l2.438 2.626V2.937a.937.937 0 1 1 1.874 0v9.489L15.376 9.8c.352-.414.945-.403 1.324-.051a.938.938 0 0 1 .051 1.324l-4.063 4.375Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownToArc_default = SvgArrowDownToArc;

// src/Icon/icons/ArrowDownToBracket.tsx
import { jsx as jsx68 } from "react/jsx-runtime";
var SvgArrowDownToBracket = (props) => /* @__PURE__ */ jsx68(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx68(
      "path",
      {
        d: "M17 22H7a3.75 3.75 0 0 1-3.75-3.75v-2.813a.937.937 0 1 1 1.875 0v2.813A1.88 1.88 0 0 0 7 20.125h10a1.88 1.88 0 0 0 1.875-1.875v-2.813a.938.938 0 0 1 1.875 0v2.813c0 2.07-1.68 3.75-3.75 3.75Zm-4.36-6.504 5.313-5a.936.936 0 1 0-1.284-1.365l-3.731 3.51V2.937a.937.937 0 1 0-1.876 0v9.704L7.329 9.129a.933.933 0 0 0-1.323.043.933.933 0 0 0 .04 1.323l5.313 5a.933.933 0 0 0 1.283.001Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownToBracket_default = SvgArrowDownToBracket;

// src/Icon/icons/ArrowDownToDottedLine.tsx
import { jsx as jsx69 } from "react/jsx-runtime";
var SvgArrowDownToDottedLine = (props) => /* @__PURE__ */ jsx69(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx69(
      "path",
      {
        d: "M12 18.787a1.429 1.429 0 1 0 0 2.857 1.429 1.429 0 0 0 0-2.857Zm-8.571 0a1.429 1.429 0 1 0 0 2.857 1.429 1.429 0 0 0 0-2.857Zm4.285 0a1.429 1.429 0 1 0 0 2.857 1.429 1.429 0 0 0 0-2.857Zm8.572 0a1.429 1.429 0 1 0 0 2.857 1.429 1.429 0 0 0 0-2.857Zm4.285 0a1.429 1.429 0 1 0 0 2.857 1.429 1.429 0 0 0 0-2.857Zm-9.352-2.469c.404.433 1.155.433 1.56 0l5.714-6.08a1.073 1.073 0 0 0-1.56-1.47l-3.862 4.108V3.43c0-.593-.48-1.074-1.071-1.074s-1.071.483-1.071 1.075v9.447l-3.863-4.11a1.07 1.07 0 0 0-1.514-.046 1.073 1.073 0 0 0-.046 1.516l5.713 6.08Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownToDottedLine_default = SvgArrowDownToDottedLine;

// src/Icon/icons/ArrowDownToLine.tsx
import { jsx as jsx70 } from "react/jsx-runtime";
var SvgArrowDownToLine = (props) => /* @__PURE__ */ jsx70(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx70(
      "path",
      {
        d: "M19.5 19.817h-15c-.592 0-1.071.48-1.071 1.072 0 .629.48 1.111 1.071 1.111h15c.591 0 1.071-.48 1.071-1.072 0-.593-.477-1.111-1.071-1.111Zm-2.567-9.973-3.862 4.107V3.076a1.072 1.072 0 1 0-2.142-.004v10.875L7.066 9.844a1.064 1.064 0 0 0-1.514-.047 1.071 1.071 0 0 0-.046 1.514l5.714 6.076c.405.433 1.155.433 1.56 0l5.714-6.076a1.071 1.071 0 0 0-.046-1.515c-.43-.408-1.109-.425-1.515.048Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownToLine_default = SvgArrowDownToLine;

// src/Icon/icons/ArrowDownToSquare.tsx
import { jsx as jsx71 } from "react/jsx-runtime";
var SvgArrowDownToSquare = (props) => /* @__PURE__ */ jsx71(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx71(
      "path",
      {
        d: "M17.04 11.102a.937.937 0 0 0-1.324-1.324L12.94 12.55V2.937A.935.935 0 0 0 12.004 2a.935.935 0 0 0-.938.938v9.613L8.293 9.777a.937.937 0 0 0-1.324 1.324l4.367 4.376a.934.934 0 0 0 1.324 0l4.38-4.375ZM4.812 3.25A2.81 2.81 0 0 0 2 6.063v13.125A2.81 2.81 0 0 0 4.813 22h14.375A2.81 2.81 0 0 0 22 19.187V6.063a2.81 2.81 0 0 0-2.813-2.812h-1.875a.935.935 0 0 0-.937.938c0 .519.418.937.938.937h1.875c.519 0 .937.418.937.938v13.125c0 .519-.418.937-.938.937H4.813a.935.935 0 0 1-.937-.938V6.063c0-.519.418-.937.938-.937h1.875c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937H4.813Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownToSquare_default = SvgArrowDownToSquare;

// src/Icon/icons/ArrowDownTriangleSquare.tsx
import { jsx as jsx72 } from "react/jsx-runtime";
var SvgArrowDownTriangleSquare = (props) => /* @__PURE__ */ jsx72(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx72(
      "path",
      {
        d: "M20.034 13.31h-5.247c-.724 0-1.274.588-1.274 1.313v5.246c0 .724.587 1.311 1.274 1.311h5.247c.724 0 1.311-.587 1.311-1.311v-5.21c0-.762-.586-1.348-1.311-1.348Zm-.656 5.903h-3.935v-3.935h3.935v3.935Zm2.463-10.21-3.407-5.619a1.204 1.204 0 0 0-1.024-.565 1.2 1.2 0 0 0-1.02.565l-3.413 5.62c-.45.747.113 1.685 1.025 1.685h6.816c.912-.001 1.474-.94 1.023-1.686Zm-6.386-.283 1.958-3.233L19.37 8.72h-3.915Zm-3.88 7.894a.984.984 0 0 0-1.445-1.335l-2.228 2.413V3.802a.984.984 0 1 0-1.968 0v13.891l-2.228-2.416a.984.984 0 0 0-1.445 1.336l3.898 4.266c.372.403 1.074.403 1.445 0l3.97-4.265Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownTriangleSquare_default = SvgArrowDownTriangleSquare;

// src/Icon/icons/ArrowDownUpAcrossLine.tsx
import { jsx as jsx73 } from "react/jsx-runtime";
var SvgArrowDownUpAcrossLine = (props) => /* @__PURE__ */ jsx73(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx73(
      "path",
      {
        d: "M3.633 17.285c-.325-.295-.325-.823 0-1.149a.838.838 0 0 1 1.178 0l1.911 1.913v-5.211H2.833a.832.832 0 1 1 0-1.667h12.778V5.96l-1.94 1.88c-.296.354-.824.354-1.15 0-.323-.295-.323-.823 0-1.15l3.333-3.332c.327-.325.854-.325 1.15 0l3.333 3.333c.354.326.354.854 0 1.149-.295.354-.823.354-1.15 0l-1.91-1.88v5.21h3.89c.461 0 .833.371.833.833a.831.831 0 0 1-.833.834H8.389v5.211l1.91-1.913c.326-.323.854-.323 1.149 0 .354.326.354.854 0 1.15l-3.333 3.333c-.296.354-.823.354-1.15 0l-3.332-3.334ZM6.723 5.06c0-.46.37-.865.833-.865.461 0 .833.405.833.865v4.722H6.722V5.06Zm10.555 9.166v4.723a.831.831 0 0 1-.834.833.831.831 0 0 1-.833-.833v-4.723h1.667Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownUpAcrossLine_default = SvgArrowDownUpAcrossLine;

// src/Icon/icons/ArrowDownUpLock.tsx
import { jsx as jsx74 } from "react/jsx-runtime";
var SvgArrowDownUpLock = (props) => /* @__PURE__ */ jsx74(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx74(
      "path",
      {
        d: "m5.469 19.753-3-3c-.292-.265-.292-.74 0-1.034a.754.754 0 0 1 1.061 0l1.72 1.722V12.75h-2.5a.75.75 0 1 1 0-1.5h8.5V6.56L9.503 8.254c-.265.319-.74.319-1.034 0-.29-.266-.29-.74 0-1.034l3-3A.75.75 0 0 1 12 4c.2 0 .39.079.503.22l3 2.999c.319.293.319.768 0 1.034-.265.319-.74.319-1.034 0L12.75 6.561v4.689h2.481c-.15.387-.231.81-.231 1.25v.25H6.75v4.69l1.719-1.721c.293-.29.769-.29 1.034 0 .319.293.319.769 0 1.034l-3 3c-.266.319-.74.319-1.034 0ZM5.25 10V5.75a.75.75 0 1 1 1.5 0V10h-1.5Zm7.5 4v4.25c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75V14h1.5Zm5.75-4a2.5 2.5 0 0 1 2.5 2.5V14c.553 0 1 .447 1 1v4c0 .553-.447 1-1 1h-5c-.553 0-1-.447-1-1v-4c0-.553.447-1 1-1v-1.5a2.5 2.5 0 0 1 2.5-2.5Zm0 1.5c-.553 0-1 .447-1 1V14h2v-1.5c0-.553-.447-1-1-1Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownUpLock_default = SvgArrowDownUpLock;

// src/Icon/icons/ArrowDownWideShort.tsx
import { jsx as jsx75 } from "react/jsx-runtime";
var SvgArrowDownWideShort = (props) => /* @__PURE__ */ jsx75(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx75(
      "path",
      {
        d: "M14.414 18.207H12.72a.847.847 0 0 0 0 1.693h1.693c.467 0 .815-.38.815-.847 0-.467-.35-.846-.815-.846Zm2.225-4.515h-3.918a.849.849 0 0 0-.846.847c0 .465.38.846.846.846h3.918c.468 0 .847-.379.847-.846a.828.828 0 0 0-.847-.847Zm2.257-4.514h-6.175a.849.849 0 0 0-.846.847c0 .465.38.846.846.846h6.175c.468 0 .847-.38.847-.846a.828.828 0 0 0-.847-.847Zm2.258-4.514H12.72a.848.848 0 0 0-.846.846c0 .468.38.847.846.847h8.433c.467 0 .846-.38.846-.847a.828.828 0 0 0-.846-.846ZM8.997 14.789 7.078 16.9V4.946a.846.846 0 1 0-1.693 0v11.952l-1.917-2.08a.842.842 0 0 0-1.196-.046.847.847 0 0 0-.047 1.197l3.354 3.67c.32.347.924.347 1.243 0l3.354-3.67a.847.847 0 0 0-.047-1.197c-.282-.322-.818-.298-1.132.016Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownWideShort_default = SvgArrowDownWideShort;

// src/Icon/icons/ArrowDownZA.tsx
import { jsx as jsx76 } from "react/jsx-runtime";
var SvgArrowDownZA = (props) => /* @__PURE__ */ jsx76(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx76(
      "path",
      {
        d: "M15.52 4.542h2.666L14.756 9a1.018 1.018 0 0 0 .803 1.641h4.707c.561 0 .978-.455.978-1.017 0-.56-.455-1.016-.978-1.016h-2.628l3.468-4.457c.238-.308.282-.723.111-1.072a1.04 1.04 0 0 0-.953-.57h-4.707c-.561 0-.979.455-.979 1.017 0 .561.416 1.016.941 1.016ZM21.89 20.02l-3.012-6.1c-.344-.691-1.475-.691-1.82 0l-3.012 6.1a1.016 1.016 0 1 0 1.82.909l.227-.454h3.827l.227.454a1.016 1.016 0 0 0 1.364.455c.426-.254.63-.864.38-1.364Zm-4.86-1.618.898-1.794.897 1.794h-1.794Zm-6.626-3.05-2.304 2.533V3.526a1.017 1.017 0 1 0-2.034 0v14.359l-2.304-2.498a1.011 1.011 0 0 0-1.436-.057 1.018 1.018 0 0 0-.057 1.438l4.03 4.41c.383.417 1.109.417 1.493 0l4.029-4.41a1.017 1.017 0 0 0-.057-1.438c-.339-.386-.983-.357-1.36.02Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDownZA_default = SvgArrowDownZA;

// src/Icon/icons/ArrowDown.tsx
import { jsx as jsx77 } from "react/jsx-runtime";
var SvgArrowDown = (props) => /* @__PURE__ */ jsx77(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx77(
      "path",
      {
        d: "m20.277 13.812-7.5 7.858c-.206.21-.483.33-.777.33a1.07 1.07 0 0 1-.776-.332l-7.5-7.857c-.408-.467-.392-1.106.036-1.517a1.07 1.07 0 0 1 1.515.037l5.653 5.923V3.072c0-.592.48-1.072 1.031-1.072.552 0 1.112.48 1.112 1.072v15.183l5.652-5.924a1.07 1.07 0 0 1 1.515-.036c.431.41.445 1.049.039 1.517Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowDown_default = SvgArrowDown;

// src/Icon/icons/ArrowLeftFromLine.tsx
import { jsx as jsx78 } from "react/jsx-runtime";
var SvgArrowLeftFromLine = (props) => /* @__PURE__ */ jsx78(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx78(
      "path",
      {
        d: "M19.817 4.5v15c0 .592.48 1.072 1.072 1.072.592 0 1.111-.477 1.111-1.071V4.5c0-.592-.482-1.072-1.112-1.072-.63 0-1.071.48-1.071 1.072ZM9.87 16.934 5.76 13.072h10.876a1.072 1.072 0 1 0 0-2.143H5.763L9.87 7.066a1.06 1.06 0 0 0 .336-.78c0-.264-.097-.528-.292-.734A1.067 1.067 0 0 0 8.4 5.504L2.325 11.22c-.433.405-.433 1.155 0 1.56L8.4 18.494c.431.405 1.11.385 1.515-.046.405-.43.347-1.108-.046-1.514Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowLeftFromLine_default = SvgArrowLeftFromLine;

// src/Icon/icons/ArrowLeftLongToLine.tsx
import { jsx as jsx79 } from "react/jsx-runtime";
var SvgArrowLeftLongToLine = (props) => /* @__PURE__ */ jsx79(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx79(
      "path",
      {
        d: "M2 6.75a.75.75 0 0 1 1.5 0v10.5a.75.75 0 1 1-1.5 0V6.75Zm9.25 9.5a.586.586 0 0 1-.247.503c-.265.319-.74.319-1.034 0l-4.25-4.25c-.29-.265-.29-.74 0-1.034l4.25-4.25c.293-.292.769-.292 1.034 0 .319.293.319.768 0 1.034L8.06 11.25H21.25a.75.75 0 0 1 0 1.5H8.06l2.943 2.969a.673.673 0 0 1 .247.531Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowLeftLongToLine_default = SvgArrowLeftLongToLine;

// src/Icon/icons/ArrowLeftLong.tsx
import { jsx as jsx80 } from "react/jsx-runtime";
var SvgArrowLeftLong = (props) => /* @__PURE__ */ jsx80(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx80(
      "path",
      {
        d: "M8.879 6.023a.842.842 0 0 1 .309.665c0 .242-.09.48-.31.628l-3.677 3.747h15.861a.938.938 0 0 1 0 1.874H5.201l3.712 3.713a.937.937 0 1 1-1.326 1.325l-5.312-5.312a.937.937 0 0 1 0-1.326l5.312-5.312c.366-.366.96-.366 1.292-.002Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowLeftLong_default = SvgArrowLeftLong;

// src/Icon/icons/ArrowLeftToLine.tsx
import { jsx as jsx81 } from "react/jsx-runtime";
var SvgArrowLeftToLine = (props) => /* @__PURE__ */ jsx81(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx81(
      "path",
      {
        d: "M4.144 19.5v-15A1.072 1.072 0 0 0 2 4.5v15c0 .594.48 1.072 1.072 1.072A1.07 1.07 0 0 0 4.144 19.5Zm10.012-2.567-4.107-3.861h10.875c.594 0 1.076-.478 1.076-1.072 0-.594-.48-1.031-1.072-1.031H10.049l4.106-3.863a1.066 1.066 0 0 0 .046-1.514 1.071 1.071 0 0 0-1.514-.046L6.61 11.26c-.433.405-.433 1.155 0 1.56l6.076 5.715c.431.405 1.11.384 1.514-.047.41-.47.388-1.149-.045-1.555Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowLeftToLine_default = SvgArrowLeftToLine;

// src/Icon/icons/ArrowLeft.tsx
import { jsx as jsx82 } from "react/jsx-runtime";
var SvgArrowLeft = (props) => /* @__PURE__ */ jsx82(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx82(
      "path",
      {
        d: "M22 12c0 .593-.481 1.074-1.074 1.074H5.753l5.936 5.663a1.075 1.075 0 0 1-1.482 1.555l-7.873-7.515A1.061 1.061 0 0 1 2 12c0-.295.12-.572.333-.778l7.873-7.516a1.077 1.077 0 0 1 1.519.038c.41.425.394 1.108-.037 1.519l-5.936 5.663h15.214c.591 0 1.034.484 1.034 1.074Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowLeft_default = SvgArrowLeft;

// src/Icon/icons/ArrowPointer.tsx
import { jsx as jsx83 } from "react/jsx-runtime";
var SvgArrowPointer = (props) => /* @__PURE__ */ jsx83(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx83(
      "path",
      {
        d: "M4.872 19.512V3.032a1.033 1.033 0 0 1 1.72-.771l12.206 10.85a.985.985 0 0 1-.655 1.72h-5.675l2.628 5.648a1.069 1.069 0 1 1-1.938.904l-2.641-5.676-3.926 4.49a.977.977 0 0 1-.738.335c-.542 0-.98-.441-.98-1.02Zm10.238-6.82-8.1-7.2V16.47l2.67-3.047c.364-.503.992-.73 1.607-.73h3.822Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowPointer_default = SvgArrowPointer;

// src/Icon/icons/ArrowRightArrowLeft.tsx
import { jsx as jsx84 } from "react/jsx-runtime";
var SvgArrowRightArrowLeft = (props) => /* @__PURE__ */ jsx84(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx84(
      "path",
      {
        d: "M7.122 21.716a.967.967 0 0 0 1.367-1.367L6.27 18.132l13.792-.004a.965.965 0 0 0 .967-.968.965.965 0 0 0-.967-.967H6.27l2.218-2.218a.967.967 0 0 0-1.367-1.367l-3.87 3.867a.964.964 0 0 0 0 1.367l3.87 3.87v.004Zm13.626-14.19a.963.963 0 0 0 0-1.368l-3.87-3.874a.967.967 0 0 0-1.367 1.367l2.218 2.217-13.792.004a.965.965 0 0 0-.967.968c0 .536.43.967.967.967H17.73l-2.218 2.218a.967.967 0 0 0 1.367 1.367l3.87-3.87v.003Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowRightArrowLeft_default = SvgArrowRightArrowLeft;

// src/Icon/icons/ArrowRightFromArc.tsx
import { jsx as jsx85 } from "react/jsx-runtime";
var SvgArrowRightFromArc = (props) => /* @__PURE__ */ jsx85(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx85(
      "path",
      {
        d: "M12 20.125c.52 0 .938.418.938.938 0 .519-.418.937-.938.937-5.523 0-10-4.477-10-10S6.477 2 12 2a.937.937 0 1 1 0 1.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125Zm9.7-8.813c.19.145.3.426.3.688a.94.94 0 0 1-.3.688l-4.376 4.062A.938.938 0 0 1 16 16.7c-.352-.38-.363-.973.05-1.325l2.626-2.473H9.188a.914.914 0 0 1-.938-.937c0-.485.418-.938.938-.938h9.488L16.05 8.625c-.414-.352-.403-.945-.051-1.324.352-.414.945-.403 1.324-.051l4.375 4.063Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowRightFromArc_default = SvgArrowRightFromArc;

// src/Icon/icons/ArrowRightFromBracket.tsx
import { jsx as jsx86 } from "react/jsx-runtime";
var SvgArrowRightFromBracket = (props) => /* @__PURE__ */ jsx86(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx86(
      "path",
      {
        d: "M9.503 19.815c0 .52-.418.938-.938.938H5.75A3.751 3.751 0 0 1 2 17.002V6.998a3.751 3.751 0 0 1 3.751-3.751h2.814a.937.937 0 1 1 0 1.875H5.75a1.881 1.881 0 0 0-1.875 1.876v10.004c0 1.031.844 1.875 1.875 1.875h2.814c.52 0 .938.418.938.938Zm12.25-8.456-4.966-5.315a.937.937 0 1 0-1.365 1.285l3.475 3.733H9.155c-.485 0-.903.422-.903.938s.42.938.903.938h9.707l-3.514 3.734a.937.937 0 0 0 .04 1.325c.219.17.45.255.644.255.25 0 .499-.099.683-.295l4.967-5.315a.874.874 0 0 0 .071-1.283Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowRightFromBracket_default = SvgArrowRightFromBracket;

// src/Icon/icons/ArrowRightFromLine.tsx
import { jsx as jsx87 } from "react/jsx-runtime";
var SvgArrowRightFromLine = (props) => /* @__PURE__ */ jsx87(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx87(
      "path",
      {
        d: "M4.144 19.5v-15A1.072 1.072 0 0 0 2 4.5v15a1.072 1.072 0 0 0 2.144 0Zm9.985-12.433 4.106 3.862H7.361c-.594 0-1.074.482-1.074 1.07 0 .59.48 1.072 1.074 1.072h10.874l-4.106 3.863a1.068 1.068 0 0 0-.044 1.514 1.071 1.071 0 0 0 1.515.046l6.075-5.714c.433-.405.433-1.155 0-1.56L15.6 5.506a1.071 1.071 0 0 0-1.515.046c-.407.43-.39 1.11.043 1.515Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowRightFromLine_default = SvgArrowRightFromLine;

// src/Icon/icons/ArrowRightLongToLine.tsx
import { jsx as jsx88 } from "react/jsx-runtime";
var SvgArrowRightLongToLine = (props) => /* @__PURE__ */ jsx88(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx88(
      "path",
      {
        d: "M22 17.25c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75V6.75a.75.75 0 1 1 1.5 0v10.5Zm-9.031-1.531 2.972-2.969H2.75a.751.751 0 0 1 0-1.5h13.19L12.97 8.253c-.29-.266-.29-.74 0-1.034.293-.292.769-.292 1.034 0l4.25 4.25c.319.293.319.769 0 1.034l-4.25 4.25c-.265.319-.74.319-1.034 0a.64.64 0 0 1-.219-.503c0-.194.072-.384.219-.531Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowRightLongToLine_default = SvgArrowRightLongToLine;

// src/Icon/icons/ArrowRightLong.tsx
import { jsx as jsx89 } from "react/jsx-runtime";
var SvgArrowRightLong = (props) => /* @__PURE__ */ jsx89(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx89(
      "path",
      {
        d: "M15.085 17.944c-.184-.149-.274-.387-.274-.63a.93.93 0 0 1 .275-.662L18.8 12.94H2.937c-.517 0-.937-.422-.937-.973 0-.484.42-.902.937-.902H18.8l-3.711-3.712a.937.937 0 1 1 1.325-1.325l5.312 5.312a.937.937 0 0 1 0 1.325l-5.312 5.313a.915.915 0 0 1-1.328-.035Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowRightLong_default = SvgArrowRightLong;

// src/Icon/icons/ArrowRightToArc.tsx
import { jsx as jsx90 } from "react/jsx-runtime";
var SvgArrowRightToArc = (props) => /* @__PURE__ */ jsx90(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx90(
      "path",
      {
        d: "M20.125 12c0-4.488-3.637-8.125-8.16-8.125-.485 0-.938-.42-.938-.938 0-.517.454-.937.938-.937C17.523 2 22 6.477 22 12s-4.477 10-10.035 10c-.485 0-.938-.418-.938-.938 0-.519.454-.937.938-.937 4.523 0 8.16-3.637 8.16-8.125Zm-4.676-.688c.192.145.301.426.301.688a.94.94 0 0 1-.3.688l-4.376 4.062a.938.938 0 0 1-1.324-.05c-.352-.38-.363-.973.05-1.325l2.626-2.473H2.937A.915.915 0 0 1 2 11.965c0-.485.42-.938.938-.938h9.488L9.8 8.625c-.414-.352-.403-.945-.051-1.324.352-.414.945-.403 1.324-.051l4.375 4.063Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowRightToArc_default = SvgArrowRightToArc;

// src/Icon/icons/ArrowRightToBracket.tsx
import { jsx as jsx91 } from "react/jsx-runtime";
var SvgArrowRightToBracket = (props) => /* @__PURE__ */ jsx91(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx91(
      "path",
      {
        d: "M22 7v10a3.75 3.75 0 0 1-3.75 3.75h-2.813a.937.937 0 1 1 0-1.875h2.813A1.88 1.88 0 0 0 20.125 17V7a1.88 1.88 0 0 0-1.875-1.875h-2.813a.937.937 0 1 1 0-1.875h2.813A3.75 3.75 0 0 1 22 7Zm-6.504 4.36-5-5.313a.935.935 0 0 0-1.324-.043.934.934 0 0 0-.043 1.324l3.512 3.734H2.937A.939.939 0 0 0 2 12c0 .516.42.938.938.938h9.703L9.128 16.67a.936.936 0 0 0 .684 1.58.933.933 0 0 0 .683-.295l5-5.313a.933.933 0 0 0 .001-1.283Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowRightToBracket_default = SvgArrowRightToBracket;

// src/Icon/icons/ArrowRightToCity.tsx
import { jsx as jsx92 } from "react/jsx-runtime";
var SvgArrowRightToCity = (props) => /* @__PURE__ */ jsx92(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx92(
      "path",
      {
        d: "M12.5 19.25c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75V5.75c0-.967.784-1.75 1.75-1.75h3.5c.966 0 1.75.783 1.75 1.75V10h1V7.75c0-.416.334-.75.75-.75s.75.334.75.75v2.269c.847.118 1.5.85 1.5 1.731v7.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-7.5a.25.25 0 0 0-.25-.25H16.5V5.75a.25.25 0 0 0-.25-.25h-3.5a.25.25 0 0 0-.25.25v13.5ZM13.5 7a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5V7ZM15 9.5c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1c0-.275.225-.5.5-.5h1ZM13.5 13c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1Zm5.5-.5c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1c0-.275.225-.5.5-.5h1ZM17.5 16c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1Zm-7.747-4.556A.755.755 0 0 1 10 12c0 .213-.09.412-.247.556l-2.75 2.5c-.306.278-.778.228-1.06-.053a.748.748 0 0 1 .054-1.06l1.312-1.193H2.75a.75.75 0 1 1 0-1.5h4.56l-1.313-1.194a.748.748 0 0 1-.053-1.06.748.748 0 0 1 1.06-.052l2.75 2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowRightToCity_default = SvgArrowRightToCity;

// src/Icon/icons/ArrowRightToLine.tsx
import { jsx as jsx93 } from "react/jsx-runtime";
var SvgArrowRightToLine = (props) => /* @__PURE__ */ jsx93(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx93(
      "path",
      {
        d: "M19.817 4.5v15c0 .592.48 1.072 1.072 1.072.629 0 1.111-.478 1.111-1.072v-15c0-.591-.482-1.071-1.112-1.071-.553 0-1.071.48-1.071 1.071ZM9.844 7.067l4.106 3.863H3.075A1.072 1.072 0 0 0 2 12c0 .59.48 1.072 1.072 1.072h10.875l-4.106 3.863a1.066 1.066 0 0 0-.337.78 1.071 1.071 0 0 0 1.807.78l6.076-5.715c.433-.404.433-1.155 0-1.56L11.31 5.506a1.07 1.07 0 0 0-1.516.048c-.407.428-.424 1.107.049 1.513Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowRightToLine_default = SvgArrowRightToLine;

// src/Icon/icons/ArrowRight.tsx
import { jsx as jsx94 } from "react/jsx-runtime";
var SvgArrowRight = (props) => /* @__PURE__ */ jsx94(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx94(
      "path",
      {
        d: "m13.812 3.725 7.856 7.499a1.072 1.072 0 0 1 0 1.552l-7.856 7.499a1.073 1.073 0 0 1-1.48-1.551l5.924-5.652H3.072a1.072 1.072 0 0 1 0-2.142h15.181L12.33 5.278a1.076 1.076 0 0 1-.036-1.517c.41-.428 1.049-.444 1.518-.036Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowRight_default = SvgArrowRight;

// src/Icon/icons/ArrowRotateLeft.tsx
import { jsx as jsx95 } from "react/jsx-runtime";
var SvgArrowRotateLeft = (props) => /* @__PURE__ */ jsx95(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx95(
      "path",
      {
        d: "M3.034 2.002c.572 0 1.035.463 1.035 1.034v4.401c1.711-2.867 4.84-4.74 8.28-4.74 5.323 0 9.651 4.327 9.651 9.65s-4.328 9.65-9.65 9.65a9.689 9.689 0 0 1-6.186-2.23 1.034 1.034 0 1 1 1.325-1.59 7.61 7.61 0 0 0 4.856 1.756c4.182 0 7.586-3.404 7.586-7.586 0-4.183-3.405-7.586-7.586-7.586-2.868 0-5.466 1.65-6.746 4.138h4.332a1.035 1.035 0 0 1 0 2.069H3.034A1.033 1.033 0 0 1 2 9.932V3.036c0-.57.463-1.034 1.034-1.034Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowRotateLeft_default = SvgArrowRotateLeft;

// src/Icon/icons/ArrowRotateRight.tsx
import { jsx as jsx96 } from "react/jsx-runtime";
var SvgArrowRotateRight = (props) => /* @__PURE__ */ jsx96(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx96(
      "path",
      {
        d: "M22 3.037v6.896c0 .574-.461 1.035-1.035 1.035H14.07a1.035 1.035 0 0 1 0-2.069h4.332c-1.28-2.487-3.88-4.138-6.746-4.138a7.548 7.548 0 0 0-7.586 7.586 7.572 7.572 0 0 0 7.586 7.586 7.591 7.591 0 0 0 4.854-1.756 1.034 1.034 0 1 1 1.325 1.59 9.684 9.684 0 0 1-6.185 2.23C6.328 21.999 2 17.672 2 12.348c0-5.323 4.328-9.65 9.65-9.65 3.443 0 6.57 1.873 8.281 4.702V3.037a1.035 1.035 0 0 1 2.069 0Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowRotateRight_default = SvgArrowRotateRight;

// src/Icon/icons/ArrowTrendDown.tsx
import { jsx as jsx97 } from "react/jsx-runtime";
var SvgArrowTrendDown = (props) => /* @__PURE__ */ jsx97(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx97(
      "path",
      {
        d: "M15.056 15.889h4.1l-6.045-6.045-3.885 3.826c-.295.354-.823.354-1.15 0L2.244 7.837c-.325-.295-.325-.823 0-1.15a.835.835 0 0 1 1.179 0l5.244 5.247 3.854-3.858c.326-.322.854-.322 1.15 0l6.662 6.636v-4.1c0-.463.372-.834.834-.834.461 0 .833.371.833.833v6.111a.831.831 0 0 1-.833.834h-6.111a.831.831 0 0 1-.834-.834c0-.462.372-.833.834-.833Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowTrendDown_default = SvgArrowTrendDown;

// src/Icon/icons/ArrowTrendUp.tsx
import { jsx as jsx98 } from "react/jsx-runtime";
var SvgArrowTrendUp = (props) => /* @__PURE__ */ jsx98(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx98(
      "path",
      {
        d: "M14.222 7.282c0-.462.372-.833.834-.833h6.11c.462 0 .834.371.834.833v6.111a.831.831 0 0 1-.833.833.831.831 0 0 1-.834-.833v-4.1l-6.663 6.604c-.295.354-.823.354-1.15 0L8.668 12.07l-5.244 5.215a.786.786 0 0 1-1.179 0c-.325-.295-.325-.822 0-1.149l5.832-5.833c.327-.323.855-.323 1.15 0l3.885 3.857 6.045-6.045h-4.1a.831.831 0 0 1-.834-.833Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowTrendUp_default = SvgArrowTrendUp;

// src/Icon/icons/ArrowTurnDownLeft.tsx
import { jsx as jsx99 } from "react/jsx-runtime";
var SvgArrowTurnDownLeft = (props) => /* @__PURE__ */ jsx99(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx99(
      "path",
      {
        d: "m7.273 19.663-5-5a.806.806 0 0 1-.273-.63.93.93 0 0 1 .275-.662l5-5A.937.937 0 1 1 8.6 9.697l-3.4 3.4h14.925V4.97c0-.517.422-.937.938-.937.515 0 .937.42.937.937v9.063c0 .517-.42.937-.938.937H5.201l3.4 3.4a.937.937 0 0 1 0 1.326.911.911 0 0 1-1.328-.034Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowTurnDownLeft_default = SvgArrowTurnDownLeft;

// src/Icon/icons/ArrowTurnDownRight.tsx
import { jsx as jsx100 } from "react/jsx-runtime";
var SvgArrowTurnDownRight = (props) => /* @__PURE__ */ jsx100(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx100(
      "path",
      {
        d: "M15.398 19.665c-.363-.332-.363-.926 0-1.293l3.403-3.398H2.938A.939.939 0 0 1 2 14.036V4.974a.938.938 0 0 1 1.875 0v8.125h14.926l-3.403-3.434c-.363-.332-.363-.926 0-1.293.368-.363.961-.363 1.293 0l5 5a.825.825 0 0 1 .309.629c0 .277-.09.516-.309.664l-5 5c-.332.399-.925.399-1.293 0Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowTurnDownRight_default = SvgArrowTurnDownRight;

// src/Icon/icons/ArrowTurnDown.tsx
import { jsx as jsx101 } from "react/jsx-runtime";
var SvgArrowTurnDown = (props) => /* @__PURE__ */ jsx101(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx101(
      "path",
      {
        d: "m18.413 16.691-5 5c-.149.22-.387.309-.665.309a.875.875 0 0 1-.662-.275l-5-5A.937.937 0 1 1 8.41 15.4l3.435 3.4V3.876H6.221a.938.938 0 0 1 0-1.875h6.563c.517 0 .937.42.937.938V18.8l3.4-3.4a.937.937 0 0 1 1.326 0c.366.366.364.958-.034 1.29Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowTurnDown_default = SvgArrowTurnDown;

// src/Icon/icons/ArrowTurnUp.tsx
import { jsx as jsx102 } from "react/jsx-runtime";
var SvgArrowTurnUp = (props) => /* @__PURE__ */ jsx102(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx102(
      "path",
      {
        d: "M18.413 8.566a.937.937 0 0 1-1.326 0l-3.366-3.365v15.861c0 .518-.42.938-.937.938H6.22a.937.937 0 1 1 0-1.875h5.625V5.201l-3.4 3.365a.937.937 0 1 1-1.325-1.325l5-5c.182-.15.42-.241.663-.241a.93.93 0 0 1 .663.275l5 5c.364.366.364.96-.034 1.291Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowTurnUp_default = SvgArrowTurnUp;

// src/Icon/icons/ArrowUp19.tsx
import { jsx as jsx103 } from "react/jsx-runtime";
var SvgArrowUp19 = (props) => /* @__PURE__ */ jsx103(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx103(
      "path",
      {
        d: "M16.576 8.422c-.561 0-1.017.455-1.017 1.016 0 .562.456 1.018.98 1.018h3.427a1.017 1.017 0 0 0 0-2.034h-.678V3.337a1.016 1.016 0 0 0-1.54-.873L16.053 3.48a1.018 1.018 0 0 0 1.046 1.745l.155-.094v3.29h-.678Zm1.695 3.428a3.727 3.727 0 0 0-.806 7.365l-.658.805a1.014 1.014 0 0 0 .786 1.66c.294 0 .587-.127.787-.373 2.989-3.69 3.62-4.097 3.62-5.729 0-2.059-1.67-3.728-3.729-3.728Zm1.242 4.864-.061.075a1.693 1.693 0 0 1-1.18.484 1.696 1.696 0 1 1 1.695-1.695c0 .441-.179.835-.454 1.136ZM7.83 2.67c-.384-.416-1.11-.416-1.493 0L2.27 7.078a1.017 1.017 0 0 0 .057 1.438 1.01 1.01 0 0 0 1.436-.053l2.305-2.5v14.361c0 .562.455 1.018 1.017 1.018.561 0 1.017-.458 1.017-1.056V5.964l2.303 2.498a1.017 1.017 0 1 0 1.495-1.38L7.83 2.67Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUp19_default = SvgArrowUp19;

// src/Icon/icons/ArrowUp91.tsx
import { jsx as jsx104 } from "react/jsx-runtime";
var SvgArrowUp91 = (props) => /* @__PURE__ */ jsx104(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx104(
      "path",
      {
        d: "m17.428 9.872-.659.805a1.014 1.014 0 0 0 .144 1.43c.227.155.451.231.68.231.294 0 .587-.127.787-.373C21.369 8.275 22 7.868 22 6.237a3.729 3.729 0 0 0-7.458 0c-.038 1.784 1.25 3.267 2.886 3.635Zm.843-5.33c.935 0 1.695.76 1.695 1.695 0 .44-.179.834-.455 1.136l-.062.075c-.305.297-.72.484-1.178.484a1.696 1.696 0 0 1 0-3.39ZM7.831 2.82c-.385-.416-1.11-.416-1.494 0L2.27 7.228a1.017 1.017 0 0 0 .057 1.438 1.01 1.01 0 0 0 1.436-.053l2.305-2.5v14.361c0 .562.455 1.018 1.017 1.018.561 0 1.017-.459 1.017-1.056V6.114l2.303 2.498a1.017 1.017 0 1 0 1.495-1.38L7.83 2.82Zm12.135 16.637h-.678v-5.085a1.016 1.016 0 0 0-1.54-.873l-1.695 1.017a1.018 1.018 0 0 0 1.046 1.746l.155-.094v3.289h-.678a1.017 1.017 0 0 0 0 2.034h3.39a1.017 1.017 0 0 0 0-2.034Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUp91_default = SvgArrowUp91;

// src/Icon/icons/ArrowUpAZ.tsx
import { jsx as jsx105 } from "react/jsx-runtime";
var SvgArrowUpAZ = (props) => /* @__PURE__ */ jsx105(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx105(
      "path",
      {
        d: "M21.891 9.165 18.88 3.06c-.344-.691-1.475-.691-1.82 0l-3.012 6.105a1.017 1.017 0 1 0 1.82.91l.227-.455h3.827l.227.454a1.017 1.017 0 0 0 1.364.456c.426-.255.63-.865.38-1.365Zm-4.86-1.58.898-1.795.897 1.795h-1.794Zm3.233 11.833h-2.626l3.468-4.461a1.019 1.019 0 0 0-.802-1.643h-4.707c-.561 0-.979.456-.979 1.018 0 .561.456 1.017.979 1.017h2.667l-3.507 4.497a1.02 1.02 0 0 0-.112 1.072c.17.352.523.572.874.572h4.707c.562 0 .979-.456.979-1.018s-.343-1.054-.94-1.054ZM7.83 2.822c-.384-.416-1.11-.416-1.494 0L2.27 7.229a1.017 1.017 0 0 0 .057 1.438 1.01 1.01 0 0 0 1.436-.053l2.304-2.499v14.358c0 .56.458 1.017 1.017 1.017.56 0 1.017-.458 1.017-1.055V6.115l2.303 2.498a1.013 1.013 0 0 0 1.438.057c.41-.382.436-1.026.055-1.44L7.83 2.821Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpAZ_default = SvgArrowUpAZ;

// src/Icon/icons/ArrowUpArrowDown.tsx
import { jsx as jsx106 } from "react/jsx-runtime";
var SvgArrowUpArrowDown = (props) => /* @__PURE__ */ jsx106(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx106(
      "path",
      {
        d: "M21.716 16.878a.967.967 0 0 0-1.367-1.367l-2.217 2.218V3.937a.965.965 0 0 0-.968-.967.965.965 0 0 0-.967.967V17.73l-2.218-2.217a.967.967 0 0 0-1.367 1.367l3.871 3.87a.964.964 0 0 0 1.367 0l3.87-3.87h-.004ZM7.526 3.252a.964.964 0 0 0-1.368 0l-3.874 3.87A.967.967 0 0 0 3.651 8.49l2.217-2.217v13.791c0 .536.432.968.968.968a.965.965 0 0 0 .967-.968V6.272l2.218 2.217a.967.967 0 0 0 1.367-1.367l-3.863-3.87Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpArrowDown_default = SvgArrowUpArrowDown;

// src/Icon/icons/ArrowUpBigSmall.tsx
import { jsx as jsx107 } from "react/jsx-runtime";
var SvgArrowUpBigSmall = (props) => /* @__PURE__ */ jsx107(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx107(
      "path",
      {
        d: "M18.19 14.54h-3.81c-.698 0-1.269.57-1.269 1.27v3.809c0 .698.571 1.27 1.27 1.27h3.81c.698 0 1.27-.572 1.27-1.27v-3.81c0-.698-.572-1.27-1.27-1.27Zm-.635 4.444h-2.54v-2.54h2.54v2.54ZM20.73 3.11h-6.35a1.27 1.27 0 0 0-1.269 1.27v6.349c0 .701.569 1.27 1.27 1.27h6.35A1.27 1.27 0 0 0 22 10.73V4.38a1.27 1.27 0 0 0-1.27-1.27Zm-.635 6.984h-5.08v-5.08h5.08v5.08ZM7.46 3.403c-.36-.39-1.039-.39-1.399 0L2.253 7.531a.953.953 0 0 0 .053 1.347.946.946 0 0 0 1.345-.05l2.158-2.34v13.448c0 .524.429.953.953.953a.954.954 0 0 0 .952-.953V6.488l2.158 2.34a.949.949 0 0 0 1.346.053.957.957 0 0 0 .052-1.35L7.46 3.403Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpBigSmall_default = SvgArrowUpBigSmall;

// src/Icon/icons/ArrowUpFromArc.tsx
import { jsx as jsx108 } from "react/jsx-runtime";
var SvgArrowUpFromArc = (props) => /* @__PURE__ */ jsx108(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx108(
      "path",
      {
        d: "M20.125 12c0-.52.418-.938.938-.938.519 0 .937.418.937.938 0 5.523-4.477 10-10 10S2 17.523 2 12a.937.937 0 1 1 1.875 0A8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12Zm-8.813-9.7c.145-.191.426-.3.653-.3.297 0 .543.109.723.3l4.062 4.376a.938.938 0 0 1-1.375 1.273l-2.438-2.624v9.488c0 .519-.417.937-.972.937-.485 0-.938-.418-.938-.938V5.325L8.625 7.949A.938.938 0 0 1 7.301 8c-.414-.352-.403-.945-.051-1.324L11.313 2.3Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpFromArc_default = SvgArrowUpFromArc;

// src/Icon/icons/ArrowUpFromBracket.tsx
import { jsx as jsx109 } from "react/jsx-runtime";
var SvgArrowUpFromBracket = (props) => /* @__PURE__ */ jsx109(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx109(
      "path",
      {
        d: "M19.814 14.498c.518 0 .938.42.938.938v2.813A3.75 3.75 0 0 1 17 22H6.999a3.75 3.75 0 0 1-3.75-3.75v-2.814a.936.936 0 1 1 1.875 0v2.813a1.88 1.88 0 0 0 1.875 1.876H17a1.88 1.88 0 0 0 1.875-1.876v-2.813c0-.52.418-.938.938-.938ZM11.36 2.251 6.046 7.217c-.38.39-.397.983-.042 1.358a.937.937 0 0 0 1.325.04l3.733-3.51v9.704c0 .522.422.94.938.94s.938-.42.938-.903V5.104l3.733 3.514a.936.936 0 1 0 1.285-1.366l-5.314-4.966a.901.901 0 0 0-1.283-.035Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpFromBracket_default = SvgArrowUpFromBracket;

// src/Icon/icons/ArrowUpFromDottedLine.tsx
import { jsx as jsx110 } from "react/jsx-runtime";
var SvgArrowUpFromDottedLine = (props) => /* @__PURE__ */ jsx110(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx110(
      "path",
      {
        d: "M12 19.143A1.429 1.429 0 1 0 12 22a1.429 1.429 0 0 0 0-2.857Zm-8.571 0a1.429 1.429 0 1 0 0 2.857 1.429 1.429 0 0 0 0-2.857Zm4.285 0a1.429 1.429 0 1 0 0 2.857 1.429 1.429 0 0 0 0-2.857Zm8.572 0a1.429 1.429 0 1 0 0 2.857 1.429 1.429 0 0 0 0-2.857Zm4.285 0a1.429 1.429 0 1 0 0 2.857 1.429 1.429 0 0 0 0-2.857Zm-7.79-16.818c-.404-.433-1.155-.433-1.56 0l-5.714 6.08a1.07 1.07 0 1 0 1.559 1.469l3.863-4.106v9.446c0 .59.482 1.072 1.071 1.072.59 0 1.071-.481 1.071-1.073V5.766l3.863 4.11c.213.222.494.298.78.298a1.073 1.073 0 0 0 .78-1.808l-5.713-6.041Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpFromDottedLine_default = SvgArrowUpFromDottedLine;

// src/Icon/icons/ArrowUpFromGroundWater.tsx
import { jsx as jsx111 } from "react/jsx-runtime";
var SvgArrowUpFromGroundWater = (props) => /* @__PURE__ */ jsx111(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx111(
      "path",
      {
        d: "M11.135 14.5V5.956L9.781 7.281c-.295.355-.823.355-1.15 0-.322-.295-.322-.822 0-1.148l2.779-2.778c.326-.325.854-.325 1.149 0l2.778 2.778c.354.326.354.853 0 1.148-.295.355-.823.355-1.15 0l-1.354-1.325V14.5c0 .462-.371.834-.864.834a.852.852 0 0 1-.834-.834Zm-6.388 3.545c.346-.312.822-.312 1.138 0 .75.646 1.778 1.177 2.75 1.177 1.032 0 2.063-.53 2.81-1.177.315-.284.791-.312 1.08 0 .777.646 1.805 1.177 2.777 1.177 1.031 0 2.063-.53 2.81-1.177a.772.772 0 0 1 1.107 0c.59.521 1.364.93 2.128 1.101.448.1.733.545.632.997a.835.835 0 0 1-.996.628c-.997-.222-1.816-.708-2.348-1.056-.944.678-2.1 1.174-3.333 1.174-1.17 0-2.326-.496-3.333-1.174-.945.678-2.1 1.174-3.334 1.174-1.17 0-2.326-.496-3.302-1.174-.5.348-1.32.834-2.316 1.056a.833.833 0 1 1-.364-1.625c.77-.174 1.526-.614 2.094-1.1Zm3.888-6.632H4.191c-.276 0-.556.282-.556.556v5.19a2.816 2.816 0 0 1-1.028.47 2.227 2.227 0 0 0-.607.24v-5.9c0-1.194.995-2.222 2.222-2.222h4.445l-.032 1.666ZM22 11.97v5.868a4.02 4.02 0 0 0-.608-.208 3.233 3.233 0 0 1-1.059-.47v-5.19a.579.579 0 0 0-.555-.556h-4.445V9.747h4.445c1.226 0 2.222 1.027 2.222 2.222Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpFromGroundWater_default = SvgArrowUpFromGroundWater;

// src/Icon/icons/ArrowUpFromLine.tsx
import { jsx as jsx112 } from "react/jsx-runtime";
var SvgArrowUpFromLine = (props) => /* @__PURE__ */ jsx112(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx112(
      "path",
      {
        d: "M19.5 19.817h-15c-.59 0-1.07.48-1.07 1.072 0 .629.48 1.111 1.07 1.111h15c.59 0 1.07-.48 1.07-1.072 0-.593-.477-1.11-1.07-1.11ZM7.065 9.872l3.863-4.107v10.874c0 .592.48 1.073 1.071 1.073s1.071-.481 1.071-1.073V5.765l3.863 4.106a1.068 1.068 0 0 0 1.514.044 1.071 1.071 0 0 0 .046-1.515L12.78 2.325c-.405-.433-1.155-.433-1.56 0L5.506 8.4a1.073 1.073 0 0 0 .046 1.516c.43.406 1.108.348 1.514-.044Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpFromLine_default = SvgArrowUpFromLine;

// src/Icon/icons/ArrowUpFromSquare.tsx
import { jsx as jsx113 } from "react/jsx-runtime";
var SvgArrowUpFromSquare = (props) => /* @__PURE__ */ jsx113(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx113(
      "path",
      {
        d: "M12.664 2.275a.934.934 0 0 0-1.324 0L6.96 6.65a.937.937 0 0 0 1.324 1.324l2.774-2.773v9.612c0 .52.418.938.937.938.52 0 .938-.418.938-.938V5.201l2.773 2.773A.937.937 0 0 0 17.03 6.65l-4.367-4.375Zm-7.85.977A2.81 2.81 0 0 0 2 6.064v13.124A2.81 2.81 0 0 0 4.813 22h14.374a2.81 2.81 0 0 0 2.812-2.812V6.064a2.81 2.81 0 0 0-2.812-2.812h-.313a.935.935 0 0 0-.937.937c0 .52.418.938.937.938h.313c.52 0 .937.418.937.937v13.124c0 .52-.418.937-.937.937H4.813a.935.935 0 0 1-.937-.937V6.064c0-.52.418-.937.937-.937h.313c.52 0 .937-.418.937-.938a.935.935 0 0 0-.937-.937h-.313Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpFromSquare_default = SvgArrowUpFromSquare;

// src/Icon/icons/ArrowUpFromWaterPump.tsx
import { jsx as jsx114 } from "react/jsx-runtime";
var SvgArrowUpFromWaterPump = (props) => /* @__PURE__ */ jsx114(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx114(
      "path",
      {
        d: "M10.333 3.111c.92 0 1.667.747 1.667 1.667V12h4.722V5.956l-1.385 1.325c-.295.355-.823.355-1.15 0-.322-.295-.322-.822 0-1.148l2.778-2.778c.327-.325.854-.325 1.15 0l2.777 2.778c.355.326.355.853 0 1.148-.295.355-.823.355-1.149 0L18.39 5.956V12h1.389c1.226 0 2.222.997 2.222 2.222v3.646a2.218 2.218 0 0 0-.608-.24 3.233 3.233 0 0 1-1.059-.468V14.19a.579.579 0 0 0-.555-.555H4.222a.578.578 0 0 0-.555.555v2.969a3.223 3.223 0 0 1-1.06.469 2.227 2.227 0 0 0-.607.24v-3.647C2 12.997 2.995 12 4.222 12V4.778c0-.92.746-1.667 1.667-1.667h4.444ZM8.635 19.222c1.032 0 2.063-.53 2.81-1.177.315-.312.791-.312 1.08 0 .777.646 1.805 1.177 2.777 1.177 1.031 0 2.063-.53 2.81-1.177a.772.772 0 0 1 1.107 0c.59.521 1.364.93 2.128 1.101.448.1.733.545.632.997a.835.835 0 0 1-.996.628c-.997-.222-1.816-.708-2.348-1.056-.944.678-2.1 1.174-3.333 1.174-1.17 0-2.326-.496-3.333-1.174-.945.678-2.1 1.174-3.334 1.174-1.17 0-2.326-.496-3.302-1.174-.5.348-1.32.834-2.316 1.056a.833.833 0 1 1-.364-1.625c.77-.174 1.526-.614 2.094-1.1.346-.313.822-.313 1.138 0 .75.645 1.778 1.176 2.75 1.176Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpFromWaterPump_default = SvgArrowUpFromWaterPump;

// src/Icon/icons/ArrowUpLeftFromCircle.tsx
import { jsx as jsx115 } from "react/jsx-runtime";
var SvgArrowUpLeftFromCircle = (props) => /* @__PURE__ */ jsx115(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx115(
      "path",
      {
        d: "M14.188 15.125a.937.937 0 0 0 .663-1.6L5.2 3.875H9.5A.938.938 0 0 0 9.5 2H2.937A.938.938 0 0 0 2 2.938V9.5a.938.938 0 0 0 1.875 0V5.2l9.648 9.65a.923.923 0 0 0 .665.275ZM13.25 4.5a.938.938 0 0 0 0 1.875 6.884 6.884 0 0 1 6.875 6.875 6.884 6.884 0 0 1-6.875 6.875c-3.79 0-6.875-3.086-6.875-6.875a.938.938 0 0 0-1.875 0c0 4.824 3.926 8.75 8.75 8.75S22 18.074 22 13.25 18.074 4.5 13.25 4.5Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpLeftFromCircle_default = SvgArrowUpLeftFromCircle;

// src/Icon/icons/ArrowUpLeft.tsx
import { jsx as jsx116 } from "react/jsx-runtime";
var SvgArrowUpLeft = (props) => /* @__PURE__ */ jsx116(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx116(
      "path",
      {
        d: "M21.51 21.506c-.237.35-.624.494-1.006.494a1.5 1.5 0 0 1-1.06-.44L5.004 7.12V18.5c0 .831-.671 1.5-1.5 1.5-.828 0-1.5-.669-1.5-1.5v-15c0-.825.672-1.5 1.5-1.5h15a1.5 1.5 0 0 1 0 3H7.126l14.437 14.438c.585.587.585 1.537-.052 2.068Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpLeft_default = SvgArrowUpLeft;

// src/Icon/icons/ArrowUpLong.tsx
import { jsx as jsx117 } from "react/jsx-runtime";
var SvgArrowUpLong = (props) => /* @__PURE__ */ jsx117(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx117(
      "path",
      {
        d: "M17.934 8.901c-.148.219-.386.308-.628.308a.93.93 0 0 1-.662-.274L12.94 5.23v15.835a.936.936 0 0 1-1.872 0V5.23L7.36 8.901a.936.936 0 1 1-1.323-1.323l5.303-5.304a.936.936 0 0 1 1.324 0l5.303 5.304c.364.399.364.992-.034 1.323Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpLong_default = SvgArrowUpLong;

// src/Icon/icons/ArrowUpRightAndArrowDownLeftFromCenter.tsx
import { jsx as jsx118 } from "react/jsx-runtime";
var SvgArrowUpRightAndArrowDownLeftFromCenter = (props) => /* @__PURE__ */ jsx118(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx118(
      "path",
      {
        d: "M21.422 2.072a.959.959 0 0 0-.36-.072h-5.59c-.55 0-.972.42-.972.938 0 .517.42.937.938.937h3.361l-5.273 5.273a.937.937 0 1 0 1.326 1.326l5.273-5.273v3.362c0 .519.422.937.938.937.515 0 .937-.422.937-.973v-5.59a.946.946 0 0 0-.578-.865ZM2.579 21.926a.88.88 0 0 0 .358.074h5.59c.551 0 .973-.418.973-.938a.935.935 0 0 0-.938-.937H5.201l5.273-5.273a.937.937 0 1 0-1.326-1.326L3.875 18.8v-3.363a.939.939 0 0 0-.938-.938.939.939 0 0 0-.937.938v5.624a.937.937 0 0 0 .58.864Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpRightAndArrowDownLeftFromCenter_default = SvgArrowUpRightAndArrowDownLeftFromCenter;

// src/Icon/icons/ArrowUpRightDots.tsx
import { jsx as jsx119 } from "react/jsx-runtime";
var SvgArrowUpRightDots = (props) => /* @__PURE__ */ jsx119(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx119(
      "path",
      {
        d: "M7.278 3.111h5c.462 0 .833.374.833.834v5a.831.831 0 0 1-.833.833.831.831 0 0 1-.834-.833V5.956l-8.021 7.992a.786.786 0 0 1-1.179 0c-.325-.295-.325-.823 0-1.15l8.023-8.02h-2.99a.832.832 0 1 1 0-1.667ZM22 5.89a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0Zm-4.444 4.445a1.667 1.667 0 1 1-3.335-.001 1.667 1.667 0 0 1 3.335 0Zm-3.334 4.444a1.667 1.667 0 1 1 3.335.001 1.667 1.667 0 0 1-3.335-.001Zm3.334 4.444a1.667 1.667 0 1 1-3.335 0 1.667 1.667 0 0 1 3.335 0Zm4.444 0a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0ZM9.778 14.778a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Zm3.333 4.444a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0Zm-7.778 0a1.667 1.667 0 1 1 3.334.001 1.667 1.667 0 0 1-3.334 0ZM22 14.778a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0Zm-3.333-4.444a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpRightDots_default = SvgArrowUpRightDots;

// src/Icon/icons/ArrowUpRightFromSquare.tsx
import { jsx as jsx120 } from "react/jsx-runtime";
var SvgArrowUpRightFromSquare = (props) => /* @__PURE__ */ jsx120(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx120(
      "path",
      {
        d: "M13.877 2.938c0 .519.418.937.938.937h3.988l-8.715 8.71a.937.937 0 0 0 1.324 1.324l8.711-8.71v3.989c0 .519.418.937.938.937s.937-.418.937-.938v-6.25A.935.935 0 0 0 21.06 2h-6.245a.935.935 0 0 0-.938.938Zm-9.063.312a2.81 2.81 0 0 0-2.812 2.813v13.125A2.81 2.81 0 0 0 4.814 22H17.94a2.81 2.81 0 0 0 2.813-2.813v-5a.935.935 0 0 0-.938-.937.935.935 0 0 0-.937.938v5c0 .519-.418.937-.938.937H4.814a.935.935 0 0 1-.937-.938V6.063c0-.519.418-.937.937-.937h5c.52 0 .938-.418.938-.938a.935.935 0 0 0-.938-.937h-5Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpRightFromSquare_default = SvgArrowUpRightFromSquare;

// src/Icon/icons/ArrowUpRight.tsx
import { jsx as jsx121 } from "react/jsx-runtime";
var SvgArrowUpRight = (props) => /* @__PURE__ */ jsx121(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx121(
      "path",
      {
        d: "M22 3.5v15a1.5 1.5 0 0 1-3 0V7.119L4.563 21.556a1.496 1.496 0 0 1-2.123.004 1.5 1.5 0 0 1 0-2.12L16.88 5H5.501C4.67 5 4 4.331 4 3.5S4.67 2 5.5 2H20.5A1.5 1.5 0 0 1 22 3.5Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpRight_default = SvgArrowUpRight;

// src/Icon/icons/ArrowUpShortWide.tsx
import { jsx as jsx122 } from "react/jsx-runtime";
var SvgArrowUpShortWide = (props) => /* @__PURE__ */ jsx122(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx122(
      "path",
      {
        d: "M12.721 6.346h1.693c.467 0 .815-.379.815-.847 0-.467-.38-.847-.815-.847h-1.693a.847.847 0 0 0 0 1.694Zm0 9.036h6.175a.847.847 0 0 0 0-1.694h-6.175a.847.847 0 0 0 0 1.694Zm0-4.518h3.918a.847.847 0 0 0 0-1.694h-3.918a.847.847 0 0 0 0 1.694Zm8.433 7.311H12.72a.847.847 0 0 0-.846.847c0 .468.38.878.846.878h8.433c.467 0 .846-.38.846-.848 0-.467-.35-.877-.846-.877ZM6.853 4.36c-.32-.346-.924-.346-1.243 0L2.225 8.029a.847.847 0 0 0 .047 1.197.841.841 0 0 0 1.195-.044l1.919-2.08v11.951c0 .466.38.847.846.847.466 0 .846-.381.846-.878V7.101L8.996 9.18a.843.843 0 0 0 1.197.048.85.85 0 0 0 .045-1.2L6.853 4.36Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpShortWide_default = SvgArrowUpShortWide;

// src/Icon/icons/ArrowUpSmallBig.tsx
import { jsx as jsx123 } from "react/jsx-runtime";
var SvgArrowUpSmallBig = (props) => /* @__PURE__ */ jsx123(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx123(
      "path",
      {
        d: "M20.73 12h-6.35a1.27 1.27 0 0 0-1.269 1.27v6.349c0 .701.569 1.27 1.27 1.27h6.35A1.27 1.27 0 0 0 22 19.619v-6.35c0-.702-.567-1.27-1.27-1.27Zm-.635 6.984h-5.08v-5.08h5.08v5.08ZM14.381 9.46h3.81c.698 0 1.27-.571 1.27-1.27V4.38c0-.698-.572-1.27-1.27-1.27h-3.81c-.699 0-1.27.572-1.27 1.27v3.81c0 .699.571 1.27 1.27 1.27Zm.635-4.444h2.54v2.54h-2.54v-2.54ZM7.46 3.403c-.36-.39-1.039-.39-1.399 0L2.253 7.531a.953.953 0 0 0 .053 1.347.946.946 0 0 0 1.345-.05l2.158-2.34v13.448c0 .524.429.953.953.953a.954.954 0 0 0 .952-.953V6.488l2.158 2.34a.949.949 0 0 0 1.346.053.957.957 0 0 0 .052-1.35L7.46 3.403Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpSmallBig_default = SvgArrowUpSmallBig;

// src/Icon/icons/ArrowUpSquareTriangle.tsx
import { jsx as jsx124 } from "react/jsx-runtime";
var SvgArrowUpSquareTriangle = (props) => /* @__PURE__ */ jsx124(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx124(
      "path",
      {
        d: "M14.787 10.688h5.247c.724 0 1.311-.588 1.311-1.312V4.13c0-.724-.587-1.312-1.311-1.312h-5.246c-.725 0-1.275.588-1.275 1.312v5.246c-.037.726.55 1.312 1.274 1.312Zm.656-5.902h3.935V8.72h-3.935V4.786Zm6.398 14.71-3.407-5.62a1.203 1.203 0 0 0-1.023-.564c-.416 0-.8.21-1.021.564l-3.412 5.62c-.451.748.112 1.685 1.024 1.685h6.816c.912-.001 1.474-.94 1.023-1.686Zm-6.385-.283 1.957-3.233 1.957 3.233h-3.914ZM7.64 3.12c-.372-.402-1.074-.402-1.445 0L2.26 7.384A.984.984 0 1 0 3.706 8.72l2.229-2.414v13.89c0 .541.442.984.983.984a.986.986 0 0 0 .984-.985V6.306l2.228 2.416a.979.979 0 0 0 1.39.055.984.984 0 0 0 .055-1.39L7.64 3.12Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpSquareTriangle_default = SvgArrowUpSquareTriangle;

// src/Icon/icons/ArrowUpToDottedLine.tsx
import { jsx as jsx125 } from "react/jsx-runtime";
var SvgArrowUpToDottedLine = (props) => /* @__PURE__ */ jsx125(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx125(
      "path",
      {
        d: "M12 5.194a1.429 1.429 0 1 0 0-2.858 1.429 1.429 0 0 0 0 2.858Zm8.571 0a1.429 1.429 0 1 0 0-2.857 1.429 1.429 0 0 0 0 2.857Zm-4.285 0a1.429 1.429 0 1 0 0-2.857 1.429 1.429 0 0 0 0 2.857Zm-8.572 0a1.429 1.429 0 1 0 0-2.857 1.429 1.429 0 0 0 0 2.857Zm-4.285 0a1.429 1.429 0 1 0 0-2.857 1.429 1.429 0 0 0 0 2.857Zm9.352 2.509c-.404-.433-1.155-.433-1.56 0l-5.714 6.08a1.073 1.073 0 0 0 1.56 1.47l3.862-4.108v9.446c0 .59.482 1.072 1.071 1.072.59 0 1.071-.481 1.071-1.073v-9.447l3.863 4.11c.213.222.495.298.78.298a1.073 1.073 0 0 0 .78-1.808l-5.713-6.04Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpToDottedLine_default = SvgArrowUpToDottedLine;

// src/Icon/icons/ArrowUpToLine.tsx
import { jsx as jsx126 } from "react/jsx-runtime";
var SvgArrowUpToLine = (props) => /* @__PURE__ */ jsx126(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx126(
      "path",
      {
        d: "M4.5 4.144h15A1.072 1.072 0 0 0 19.5 2h-15a1.072 1.072 0 0 0 0 2.144Zm2.566 10.008 3.863-4.112v10.884c0 .594.482 1.076 1.071 1.076.59 0 1.071-.48 1.071-1.073V10.04l3.863 4.11c.213.225.495.337.78.337a1.073 1.073 0 0 0 .78-1.808l-5.714-6.08c-.405-.434-1.155-.434-1.56 0l-5.714 6.08a1.075 1.075 0 0 0 .046 1.517c.43.407 1.108.389 1.514-.044Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpToLine_default = SvgArrowUpToLine;

// src/Icon/icons/ArrowUpTriangleSquare.tsx
import { jsx as jsx127 } from "react/jsx-runtime";
var SvgArrowUpTriangleSquare = (props) => /* @__PURE__ */ jsx127(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx127(
      "path",
      {
        d: "M20.034 13.312h-5.246c-.725 0-1.275.587-1.275 1.311v5.246c0 .724.587 1.312 1.274 1.312h5.247c.724 0 1.311-.588 1.311-1.312v-5.21c0-.761-.586-1.348-1.311-1.348Zm-.656 5.902h-3.935v-3.935h3.935v3.934Zm2.463-10.21-3.407-5.62a1.204 1.204 0 0 0-1.023-.564 1.2 1.2 0 0 0-1.021.565l-3.412 5.619c-.451.748.112 1.685 1.024 1.685h6.816c.912 0 1.474-.94 1.023-1.685Zm-6.385-.283 1.957-3.233 1.957 3.233h-3.914Zm-7.816-5.6c-.372-.402-1.074-.402-1.445 0L2.26 7.385a.984.984 0 1 0 1.445 1.336l2.229-2.414v13.89c0 .541.442.984.983.984a.986.986 0 0 0 .984-.985V6.307l2.228 2.416a.979.979 0 0 0 1.39.055.984.984 0 0 0 .055-1.39L7.64 3.12Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpTriangleSquare_default = SvgArrowUpTriangleSquare;

// src/Icon/icons/ArrowUpWideShort.tsx
import { jsx as jsx128 } from "react/jsx-runtime";
var SvgArrowUpWideShort = (props) => /* @__PURE__ */ jsx128(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx128(
      "path",
      {
        d: "M21.154 4.653H12.72a.847.847 0 0 0 0 1.694h8.433c.467 0 .846-.38.846-.847a.828.828 0 0 0-.846-.847Zm-6.74 13.522h-1.693a.847.847 0 0 0-.846.847c0 .468.38.878.846.878h1.693c.467 0 .815-.38.815-.848 0-.467-.35-.877-.815-.877Zm2.225-4.486h-3.918a.847.847 0 0 0 0 1.694h3.918c.468 0 .847-.38.847-.847a.828.828 0 0 0-.847-.847Zm2.258-4.518H12.72a.847.847 0 0 0 0 1.695h6.175c.468 0 .847-.38.847-.848a.828.828 0 0 0-.846-.847ZM6.852 4.36c-.32-.346-.924-.346-1.243 0L2.225 8.029a.847.847 0 0 0 .047 1.197.841.841 0 0 0 1.195-.044l1.919-2.08v11.951c0 .466.38.847.846.847.466 0 .846-.381.846-.878V7.101L8.996 9.18a.843.843 0 0 0 1.197.048.85.85 0 0 0 .045-1.2L6.853 4.36Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpWideShort_default = SvgArrowUpWideShort;

// src/Icon/icons/ArrowUpZA.tsx
import { jsx as jsx129 } from "react/jsx-runtime";
var SvgArrowUpZA = (props) => /* @__PURE__ */ jsx129(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx129(
      "path",
      {
        d: "M15.52 4.542h2.666L14.756 9a1.017 1.017 0 0 0 .803 1.642h4.707c.561 0 .979-.455.979-1.017 0-.561-.456-1.016-.98-1.016h-2.627l3.468-4.457c.238-.308.282-.723.111-1.072a1.04 1.04 0 0 0-.953-.57h-4.707c-.561 0-.978.455-.978 1.017 0 .561.415 1.016.94 1.016ZM21.89 20.02l-3.012-6.063c-.344-.69-1.475-.69-1.82 0l-3.012 6.063a1.016 1.016 0 1 0 1.82.908l.227-.454h3.827l.227.454a1.016 1.016 0 0 0 1.364.456c.426-.254.63-.864.38-1.364Zm-4.86-1.618.898-1.794.897 1.794h-1.794ZM7.83 2.82c-.384-.416-1.11-.416-1.494 0L2.27 7.228a1.017 1.017 0 0 0 .057 1.438 1.01 1.01 0 0 0 1.436-.053l2.304-2.499v14.358c0 .56.458 1.017 1.017 1.017.56 0 1.017-.457 1.017-1.055V6.114l2.303 2.498a1.013 1.013 0 0 0 1.438.057c.41-.381.436-1.025.055-1.44L7.83 2.82Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUpZA_default = SvgArrowUpZA;

// src/Icon/icons/ArrowUp.tsx
import { jsx as jsx130 } from "react/jsx-runtime";
var SvgArrowUp = (props) => /* @__PURE__ */ jsx130(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx130(
      "path",
      {
        d: "m3.707 10.208 7.516-7.873a1.073 1.073 0 0 1 1.555-.002l7.515 7.873a1.075 1.075 0 0 1-1.555 1.482l-5.665-5.936v15.215A1.03 1.03 0 0 1 12.04 22c-.552 0-1.114-.438-1.114-1.033V5.752L5.263 11.69c-.41.43-1.093.443-1.52.035a1.073 1.073 0 0 1-.036-1.516Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowUp_default = SvgArrowUp;

// src/Icon/icons/ArrowsCross.tsx
import { jsx as jsx131 } from "react/jsx-runtime";
var SvgArrowsCross = (props) => /* @__PURE__ */ jsx131(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx131(
      "path",
      {
        d: "M20.929 2H14.54c-.63 0-1.111.48-1.111 1.071 0 .592.48 1.072 1.071 1.072h3.842L2.314 20.17a1.071 1.071 0 1 0 1.515 1.515L19.857 5.656V9.5c0 .594.482 1.071 1.072 1.071.589 0 1.071-.482 1.071-1.111V3.07c0-.587-.482-1.07-1.071-1.07ZM9.473 10.991l1.515-1.515L3.83 2.314a1.071 1.071 0 1 0-1.515 1.515l7.16 7.162ZM20.93 13.43c-.592 0-1.072.48-1.072 1.071v3.842l-5.33-5.33-1.515 1.515 5.332 5.33H14.5a1.072 1.072 0 0 0 0 2.143h6.429c.587 0 1.071-.483 1.071-1.072V14.5c0-.59-.478-1.072-1.071-1.072Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsCross_default = SvgArrowsCross;

// src/Icon/icons/ArrowsDownToLine.tsx
import { jsx as jsx132 } from "react/jsx-runtime";
var SvgArrowsDownToLine = (props) => /* @__PURE__ */ jsx132(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx132(
      "path",
      {
        d: "M21.167 18.111c.461 0 .833.372.833.833a.831.831 0 0 1-.833.834H2.833a.832.832 0 1 1 0-1.667h18.334Zm-3.052-1.94c-.125.187-.337.273-.56.273a.75.75 0 0 1-.59-.274l-3.61-3.611c-.324-.295-.324-.823 0-1.15.326-.322.853-.322 1.149 0l2.218 2.192V5.055a.832.832 0 1 1 1.667 0v8.546l2.187-2.191c.327-.323.855-.323 1.15 0 .354.326.354.854 0 1.149l-3.611 3.611Zm-7.5-3.612L7.003 16.17c-.295.354-.822.354-1.149 0l-3.61-3.611c-.325-.295-.325-.823 0-1.15a.838.838 0 0 1 1.179 0l2.157 2.192.031-8.546a.832.832 0 1 1 1.667 0v8.546l2.187-2.191c.327-.323.854-.323 1.15 0 .354.326.354.854 0 1.149Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsDownToLine_default = SvgArrowsDownToLine;

// src/Icon/icons/ArrowsDownToPeople.tsx
import { jsx as jsx133 } from "react/jsx-runtime";
var SvgArrowsDownToPeople = (props) => /* @__PURE__ */ jsx133(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx133(
      "path",
      {
        d: "M5.421 4.369a.789.789 0 1 1 1.579 0v3.884l.757-.76c.309-.305.809-.305 1.088 0 .336.31.336.81 0 1.09L6.74 10.687c-.28.335-.78.335-1.089 0L3.547 8.582c-.308-.28-.308-.78 0-1.088a.794.794 0 0 1 1.116 0l.758.76V4.368Zm10.793 3.125.786.76V4.368a.789.789 0 1 1 1.579 0v3.884l.757-.76c.309-.305.809-.305 1.088 0 .336.31.336.81 0 1.09l-2.105 2.105c-.28.335-.78.335-1.089 0l-2.105-2.106c-.306-.28-.306-.78 0-1.088.31-.306.81-.306 1.089 0Zm.26 5.822a1.315 1.315 0 1 1 2.63 0 1.315 1.315 0 0 1-2.63 0Zm4.043 6.428-.622-1.155v.78c0 .582-.47 1.052-1.053 1.052h-2.105c-.582 0-1.053-.47-1.053-1.052v-.78l-.621 1.155a.79.79 0 0 1-1.07.319c-.41-.207-.526-.684-.319-1.07l1.194-2.22a.737.737 0 0 1-.141-.187l-.622-1.155v1.306c0 .582-.47 1.053-1.052 1.053h-2.106c-.582 0-1.052-.47-1.052-1.053v-1.306l-.622 1.155c-.066.072-.085.135-.141.187l1.194 2.22a.79.79 0 0 1-1.388.75l-.622-1.154v.78c0 .582-.47 1.052-1.053 1.052H5.158c-.581 0-1.053-.47-1.053-1.052v-.78l-.62 1.155a.79.79 0 0 1-1.39-.75L3.34 16.68a2.897 2.897 0 0 1 2.548-1.523h.645c.536 0 1.05.148 1.493.415l1.106-2.05A2.893 2.893 0 0 1 11.678 12h.644c1.066 0 2.043.586 2.55 1.523l1.102 2.05a2.898 2.898 0 0 1 1.493-.415h.645c1.066 0 2.043.586 2.55 1.523l1.243 2.313a.79.79 0 0 1-1.388.75Zm-2.201-.902v-2.088c-.096-.01-.135-.017-.204-.017h-.645a1.38 1.38 0 0 0-.204.017v2.088h1.053Zm-6.842-5.246v2.615h1.052v-2.615c-.095-.01-.134-.017-.204-.017h-.644c-.07 0-.139.007-.204.017Zm-4.737 5.246v-2.088c-.096-.01-.135-.017-.204-.017h-.645c-.069 0-.138.007-.204.017v2.088h1.053Zm6.579-8.684a1.315 1.315 0 1 1-2.631 0 1.315 1.315 0 0 1 2.63 0Zm-8.421 3.158a1.315 1.315 0 1 1 2.63 0 1.315 1.315 0 0 1-2.63 0Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsDownToPeople_default = SvgArrowsDownToPeople;

// src/Icon/icons/ArrowsFromDottedLine.tsx
import { jsx as jsx134 } from "react/jsx-runtime";
var SvgArrowsFromDottedLine = (props) => /* @__PURE__ */ jsx134(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx134(
      "path",
      {
        d: "M12 10.715a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-7.5 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm4.688-4.063c.24 0 .48-.091.662-.274L11.063 5.2v3.362a.938.938 0 0 0 1.874 0V5.2l1.213 1.212c.182.182.42.24.662.24.735 0 .938-.672.938-.902 0-.24-.092-.48-.275-.663l-2.812-2.813A.964.964 0 0 0 11.965 2a.943.943 0 0 0-.663.273L8.489 5.086c-.15.184-.239.423-.239.663 0 .536.438.903.938.903ZM19.5 10.715a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-3.75 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-6.25 1.25c0-.69-.56-1.25-1.25-1.25S7 11.309 7 11.965s.559 1.25 1.25 1.25 1.25-.524 1.25-1.25Zm5.313 5.312c-.24 0-.48.092-.663.275l-1.213 1.249v-3.362a.938.938 0 0 0-1.874 0v3.362L9.85 17.589c-.182-.187-.424-.312-.662-.312a.938.938 0 0 0-.663 1.6l2.812 2.814c.1.133.331.309.663.309a.951.951 0 0 0 .663-.275l2.812-2.813a.95.95 0 0 0 .275-.697c0-.5-.438-.938-.938-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsFromDottedLine_default = SvgArrowsFromDottedLine;

// src/Icon/icons/ArrowsFromLine.tsx
import { jsx as jsx135 } from "react/jsx-runtime";
var SvgArrowsFromLine = (props) => /* @__PURE__ */ jsx135(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx135(
      "path",
      {
        d: "M14.813 17.277c-.24 0-.48.092-.663.275l-1.213 1.249v-3.362a.938.938 0 0 0-1.874 0v3.362L9.85 17.589c-.182-.187-.424-.312-.662-.312a.938.938 0 0 0-.663 1.6l2.812 2.814c.1.133.331.309.663.309a.951.951 0 0 0 .663-.275l2.812-2.813a.95.95 0 0 0 .275-.697c0-.5-.438-.938-.938-.938ZM9.186 6.652c.24 0 .48-.091.663-.274L11.063 5.2v3.362a.938.938 0 0 0 1.874 0V5.2l1.213 1.212c.182.182.42.24.662.24.735 0 .938-.672.938-.902 0-.24-.092-.48-.275-.663l-2.812-2.813A.964.964 0 0 0 11.965 2c-.11 0-.39.038-.63.273L8.524 5.086a.931.931 0 0 0-.273.663c0 .536.438.903.938.903Zm10.626 4.41H4.188c-.518 0-.938.418-.938.903 0 .484.42.973.938.973h15.625a.938.938 0 0 0 0-1.876Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsFromLine_default = SvgArrowsFromLine;

// src/Icon/icons/ArrowsLeftRightToLine.tsx
import { jsx as jsx136 } from "react/jsx-runtime";
var SvgArrowsLeftRightToLine = (props) => /* @__PURE__ */ jsx136(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx136(
      "path",
      {
        d: "M2.75 6a.75.75 0 0 1 .75.75v10.5a.75.75 0 1 1-1.5 0V6.75A.75.75 0 0 1 2.75 6Zm6.753 2.219c.319.293.319.769 0 1.034L7.56 11.25h8.882l-1.972-1.997c-.29-.265-.29-.74 0-1.034.293-.29.769-.29 1.034 0l3.25 3.25c.319.293.319.769 0 1.034l-3.25 3.25c-.265.319-.74.319-1.034 0-.29-.265-.29-.74 0-1.034l1.972-1.969H7.559l1.944 1.969c.319.293.319.769 0 1.034-.265.319-.74.319-1.034 0l-3.25-3.25c-.292-.265-.292-.74 0-1.034l3.25-3.25c.293-.29.769-.29 1.034 0ZM22 17.25c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75V6.75a.75.75 0 1 1 1.5 0v10.5Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsLeftRightToLine_default = SvgArrowsLeftRightToLine;

// src/Icon/icons/ArrowsLeftRight.tsx
import { jsx as jsx137 } from "react/jsx-runtime";
var SvgArrowsLeftRight = (props) => /* @__PURE__ */ jsx137(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx137(
      "path",
      {
        d: "M22 12c0 .262-.11.512-.302.689l-4.062 3.75a.931.931 0 0 1-.636.249.937.937 0 0 1-.636-1.626l2.3-2.124H5.335l2.301 2.124a.937.937 0 1 1-1.272 1.377l-4.062-3.75a.938.938 0 0 1 0-1.377l4.062-3.75a.937.937 0 1 1 1.271 1.376l-2.3 2.125h13.332l-2.301-2.124a.937.937 0 1 1 1.27-1.376l4.063 3.75c.192.176.301.426.301.687Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsLeftRight_default = SvgArrowsLeftRight;

// src/Icon/icons/ArrowsMaximize.tsx
import { jsx as jsx138 } from "react/jsx-runtime";
var SvgArrowsMaximize = (props) => /* @__PURE__ */ jsx138(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx138(
      "path",
      {
        d: "M19.857 9.5V5.656L13.513 12l6.344 6.344V14.5c0-.59.482-1.071 1.072-1.071.589 0 1.071.482 1.071 1.071v6.429A1.072 1.072 0 0 1 20.929 22H14.5a1.072 1.072 0 0 1 0-2.143h3.842L12 13.513l-6.342 6.344H9.5A1.072 1.072 0 0 1 9.5 22H3.071A1.073 1.073 0 0 1 2 20.929V14.5c0-.59.48-1.071 1.071-1.071.592 0 1.072.482 1.072 1.071v3.842L10.487 12 4.143 5.656V9.5A1.07 1.07 0 1 1 2 9.5V3.071a1.07 1.07 0 0 1 .661-.988A1.07 1.07 0 0 1 3.071 2H9.5a1.07 1.07 0 1 1 0 2.143H5.658L12 10.487l6.344-6.344H14.5c-.59 0-1.071-.48-1.071-1.072C13.429 2.48 13.91 2 14.5 2h6.429A1.073 1.073 0 0 1 22 3.071V9.5c0 .594-.478 1.071-1.071 1.071A1.069 1.069 0 0 1 19.857 9.5Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsMaximize_default = SvgArrowsMaximize;

// src/Icon/icons/ArrowsMinimize.tsx
import { jsx as jsx139 } from "react/jsx-runtime";
var SvgArrowsMinimize = (props) => /* @__PURE__ */ jsx139(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx139(
      "path",
      {
        d: "M9.667 2.667c-.55 0-1 .448-1 1v3.586l-4.96-4.96a1 1 0 1 0-1.414 1.414l4.962 4.96H3.667a1.002 1.002 0 0 0 .002 2.003l5.998-.003a1 1 0 0 0 1-1l.002-5.996a1.002 1.002 0 0 0-1.002-1.004Zm4.284 7.921c.125.054.254.08.383.08l5.996.002a1.002 1.002 0 1 0 .004-2.003h-3.586l4.959-4.959a1 1 0 1 0-1.414-1.414l-4.959 4.96V3.667c0-.552-.446-1-1-1s-1.002.45-1.002 1.002l.002 5.998a1 1 0 0 0 .077.383c.102.242.26.438.54.538Zm2.796 4.746h3.587a1 1 0 1 0-.002-2.003l-5.998.003a1 1 0 0 0-.923.618.978.978 0 0 0-.077.382l-.002 5.996a1.002 1.002 0 1 0 2.002.004v-3.586l4.959 4.959a1 1 0 1 0 1.414-1.414l-4.96-4.959Zm-6.697-1.92a.957.957 0 0 0-.383-.08L3.67 13.33a1.002 1.002 0 0 0-.003 2.004h3.587l-4.959 4.959a1 1 0 1 0 1.415 1.414l4.958-4.96v3.587a1 1 0 1 0 2.003-.002l-.003-5.998a1 1 0 0 0-.077-.383c-.102-.28-.298-.438-.54-.538Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsMinimize_default = SvgArrowsMinimize;

// src/Icon/icons/ArrowsRepeat1.tsx
import { jsx as jsx140 } from "react/jsx-runtime";
var SvgArrowsRepeat1 = (props) => /* @__PURE__ */ jsx140(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx140(
      "path",
      {
        d: "M21.063 11.063a.938.938 0 0 0-.938.937 4.067 4.067 0 0 1-4.063 4.063H5.438a.939.939 0 0 0-.662 1.6l4.062 4.062c.183.185.42.275.628.275.77 0 .973-.672.973-.938 0-.24-.092-.48-.275-.662l-2.464-2.462h8.364A5.944 5.944 0 0 0 22 12a.935.935 0 0 0-.938-.938ZM7.938 7.937h10.625a.939.939 0 0 0 .662-1.6l-4.062-4.062A.936.936 0 1 0 13.837 3.6l2.464 2.462H7.938C4.663 6.063 2 8.727 2 11.965c0 .55.42.973.938.973A.937.937 0 0 0 3.875 12a4.068 4.068 0 0 1 4.063-4.063Zm4.375 6.875c.517 0 .937-.42.937-.937v-3.438c0-.356-.282-.937-.938-.937a.923.923 0 0 0-.418.099l-1.25.625c-.328.163-.554.495-.554.838a.94.94 0 0 0 1.25.884v1.929c.035.52.457.938.973.938Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsRepeat1_default = SvgArrowsRepeat1;

// src/Icon/icons/ArrowsRepeat.tsx
import { jsx as jsx141 } from "react/jsx-runtime";
var SvgArrowsRepeat = (props) => /* @__PURE__ */ jsx141(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx141(
      "path",
      {
        d: "M21.063 11.063a.938.938 0 0 0-.938.937 4.067 4.067 0 0 1-4.063 4.063H7.7l2.462-2.463a.937.937 0 1 0-1.325-1.325l-4.063 4.062a.937.937 0 0 0 0 1.326l4.063 4.062A.929.929 0 0 0 9.5 22a.937.937 0 0 0 .663-1.6l-2.464-2.463h8.364A5.944 5.944 0 0 0 22 12a.935.935 0 0 0-.938-.938ZM7.938 7.938H16.3L13.839 10.4a.937.937 0 0 0 1.324 1.325l4.062-4.062a.937.937 0 0 0 0-1.326l-4.062-4.062A.937.937 0 1 0 13.837 3.6l2.464 2.463H7.938C4.664 6.063 2 8.727 2 11.965c0 .55.42.973.938.973A.936.936 0 0 0 3.875 12a4.068 4.068 0 0 1 4.063-4.062Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsRepeat_default = SvgArrowsRepeat;

// src/Icon/icons/ArrowsRetweet.tsx
import { jsx as jsx142 } from "react/jsx-runtime";
var SvgArrowsRetweet = (props) => /* @__PURE__ */ jsx142(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx142(
      "path",
      {
        d: "M12.252 15.5H6.751V8.56l1.97 1.97c.146.149.337.22.53.22a.75.75 0 0 0 .53-1.28l-3.25-3.25a.75.75 0 0 0-1.06 0L2.22 9.468a.75.75 0 1 0 1.06 1.06l1.97-1.97v7.692c0 .415.338.75.75.75h6.252a.75.75 0 0 0 0-1.5Zm9.505-2.031a.75.75 0 0 0-1.06 0l-1.943 1.972V7.75a.75.75 0 0 0-.75-.75h-6.252a.752.752 0 0 0-.75.75c0 .413.337.75.75.75h5.501v6.942l-1.97-1.97a.735.735 0 0 0-.53-.22.75.75 0 0 0-.53 1.28l3.25 3.25a.75.75 0 0 0 1.06 0l3.252-3.25a.73.73 0 0 0-.028-1.062Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsRetweet_default = SvgArrowsRetweet;

// src/Icon/icons/ArrowsRotate.tsx
import { jsx as jsx143 } from "react/jsx-runtime";
var SvgArrowsRotate = (props) => /* @__PURE__ */ jsx143(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx143(
      "path",
      {
        d: "M20.28 13.337a.997.997 0 0 0-1.24.68c-.902 3.144-3.797 5.315-7.075 5.315-2.772 0-5.283-1.595-6.52-4h4.183a1 1 0 0 0 1-1c0-.551-.409-1-.963-1H3a1 1 0 0 0-1 1v6.666a1 1 0 0 0 2 0v-4.253c1.658 2.77 4.674 4.586 7.965 4.586 4.124 0 7.806-2.762 8.96-6.72.192-.566-.116-1.082-.646-1.274ZM21 2.002c-.55 0-1 .448-1 1v4.253c-1.653-2.772-4.674-4.587-7.998-4.587-4.124 0-7.81 2.763-8.96 6.72a.997.997 0 0 0 .68 1.237.995.995 0 0 0 1.239-.68c.905-3.107 3.8-5.277 7.041-5.277 2.772 0 5.282 1.595 6.52 4h-4.187c-.55 0-1 .45-1 .999 0 .55.45 1 1 1H21a1 1 0 0 0 1-1V3.002c0-.552-.446-1-1-1Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsRotate_default = SvgArrowsRotate;

// src/Icon/icons/ArrowsSpin.tsx
import { jsx as jsx144 } from "react/jsx-runtime";
var SvgArrowsSpin = (props) => /* @__PURE__ */ jsx144(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx144(
      "path",
      {
        d: "M12 4.222c-.524 0-1.038.053-1.575.152V2.117A11.03 11.03 0 0 1 11.999 2c2.593 0 4.954.986 6.732 2.604l1.625-1.624a.74.74 0 0 1 1.264.523v4.88c0 .408-.333.741-.74.741H16c-.658 0-.992-.8-.524-1.264l1.68-1.68A7.736 7.736 0 0 0 12 4.221ZM4.222 12c0 .514.05 1.019.145 1.505H2.112c-.074-.49-.112-.99-.112-1.505 0-2.55.958-4.884 2.533-6.648L2.905 3.72c-.466-.467-.136-1.265.482-1.265H8.31c.407 0 .74.332.74.74v4.877c0 .662-.8.99-1.263.528L6.11 6.925a7.735 7.735 0 0 0-1.887 5.074Zm4.304 4.292-1.602 1.602a7.733 7.733 0 0 0 5.074 1.885c.49 0 .926-.042 1.43-.13v2.25A9.72 9.72 0 0 1 12 22a9.858 9.858 0 0 1-6.649-2.533l-1.704 1.704c-.467.468-1.265.134-1.265-.523v-4.88c0-.407.332-.74.741-.74H8c.62 0 .99.796.528 1.263Zm7.69-.74 1.607 1.606A7.734 7.734 0 0 0 19.777 12c0-.495-.046-.986-.134-1.458h2.255c.07.477.102.963.102 1.458a9.976 9.976 0 0 1-2.602 6.732l1.699 1.7a.74.74 0 0 1-.523 1.263h-4.88a.743.743 0 0 1-.741-.74v-4.88a.74.74 0 0 1 1.264-.524Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsSpin_default = SvgArrowsSpin;

// src/Icon/icons/ArrowsSplitUpAndLeft.tsx
import { jsx as jsx145 } from "react/jsx-runtime";
var SvgArrowsSplitUpAndLeft = (props) => /* @__PURE__ */ jsx145(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx145(
      "path",
      {
        d: "M11.379 7.316c-.332.399-.926.399-1.293 0-.363-.332-.363-.925 0-1.293l3.75-3.748c.367-.367.96-.367 1.293 0l3.75 3.748c.398.368.398.961 0 1.293-.332.399-.926.399-1.293 0l-2.148-2.115v12.111a2.81 2.81 0 0 0 2.812 2.813h2.813c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H18.25a4.686 4.686 0 0 1-4.688-4.688V17a2.81 2.81 0 0 0-2.812-2.813H5.2l2.116 2.149c.399.367.399.96 0 1.293-.332.398-.925.398-1.293 0l-3.748-3.75C2.099 13.739 2 13.5 2 13.25s.099-.488.275-.664l3.748-3.75c.368-.363.961-.363 1.293 0 .399.367.399.96 0 1.293l-2.115 2.184h5.549c1.055 0 2.027.347 2.813.902V5.2l-2.184 2.115Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsSplitUpAndLeft_default = SvgArrowsSplitUpAndLeft;

// src/Icon/icons/ArrowsToCircle.tsx
import { jsx as jsx146 } from "react/jsx-runtime";
var SvgArrowsToCircle = (props) => /* @__PURE__ */ jsx146(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx146(
      "path",
      {
        d: "M2.22 4.22a.75.75 0 0 1 1.06 0l3.722 3.723V6.752a.75.75 0 1 1 1.5 0v3.001c0 .416-.334.75-.75.75h-3a.75.75 0 1 1 0-1.5h1.19L2.22 5.282a.75.75 0 0 1 0-1.061Zm19.54 1.062-3.694 3.72h1.19c.416 0 .751.335.751.751s-.335.75-.75.75h-3.001a.748.748 0 0 1-.75-.75V6.752a.75.75 0 1 1 1.5 0v1.191l3.72-3.722c.294-.293.77-.293 1.035 0a.708.708 0 0 1 0 1.06Zm-7.755 6.722c0 1.104-.898 2-2.001 2-1.104 0-2-.896-2-2s.896-2 2-2 2 .896 2 2Zm1.5 2.251c0-.416.335-.75.75-.75h3.002c.415 0 .75.334.75.75s-.335.75-.75.75h-1.191l3.695 3.72c.319.294.319.77 0 1.035-.266.32-.741.32-1.035 0l-3.72-3.695v1.191c0 .416-.335.75-.75.75a.748.748 0 0 1-.75-.75v-3.001Zm-7.002 3.001c0 .416-.335.75-.75.75a.748.748 0 0 1-.751-.75v-1.19L3.281 19.76a.708.708 0 0 1-1.061 0c-.293-.266-.293-.74 0-1.035l3.722-3.72h-1.19a.75.75 0 1 1 0-1.5h3c.416 0 .75.334.75.75v3.001Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsToCircle_default = SvgArrowsToCircle;

// src/Icon/icons/ArrowsToDot.tsx
import { jsx as jsx147 } from "react/jsx-runtime";
var SvgArrowsToDot = (props) => /* @__PURE__ */ jsx147(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx147(
      "path",
      {
        d: "m12.938 6.3 1.21-1.213c.368-.366.961-.366 1.293 0 .399.366.399.96 0 1.292L12.63 9.19c-.332.399-.926.399-1.293 0L8.523 6.38c-.363-.332-.363-.926 0-1.292.368-.366.961-.366 1.293 0l1.246 1.214V2.937a.937.937 0 1 1 1.876 0v3.364Zm5.94 9.141c-.331.399-.925.399-1.292 0l-2.813-2.812c-.363-.332-.363-.926 0-1.293l2.813-2.813c.367-.363.96-.363 1.293 0 .398.368.398.961 0 1.293l-1.18 1.246h3.363c.52 0 .938.418.938.938s-.418.938-.938.938H17.7l1.18 1.21c.398.368.398.961 0 1.293ZM13.25 12c0 .691-.559 1.25-1.25 1.25s-1.25-.559-1.25-1.25.559-1.25 1.25-1.25 1.25.559 1.25 1.25Zm-4.059-.664c.399.367.399.96 0 1.293L6.38 15.44c-.332.399-.926.399-1.292 0-.366-.332-.366-.925 0-1.293l1.214-1.21H2.937a.937.937 0 1 1 0-1.876h3.364L5.087 9.816c-.366-.332-.366-.925 0-1.293.366-.363.96-.363 1.292 0l2.812 2.813Zm-.668 7.543c-.363-.332-.363-.926 0-1.293l2.813-2.813c.367-.363.96-.363 1.293 0l2.812 2.813c.399.367.399.96 0 1.293-.332.398-.925.398-1.293 0l-1.21-1.18v3.363c0 .52-.418.938-.938.938a.935.935 0 0 1-.938-.938V17.7l-1.246 1.18c-.332.398-.925.398-1.293 0Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsToDot_default = SvgArrowsToDot;

// src/Icon/icons/ArrowsToDottedLine.tsx
import { jsx as jsx148 } from "react/jsx-runtime";
var SvgArrowsToDottedLine = (props) => /* @__PURE__ */ jsx148(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx148(
      "path",
      {
        d: "M4.5 10.75a1.25 1.25 0 1 0-.001 2.499A1.25 1.25 0 0 0 4.5 10.75ZM10.75 12a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0Zm.586-2.809A.844.844 0 0 0 12 9.5a.95.95 0 0 0 .663-.275l2.812-2.812a.938.938 0 0 0-1.326-1.326l-1.212 1.214V2.937a.937.937 0 1 0-1.874 0V6.3L9.816 5.087c-.148-.183-.39-.274-.629-.274a.938.938 0 0 0-.662 1.6l2.81 2.778Zm4.414 1.559a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm3.75 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm-6.871 4.023A.835.835 0 0 0 12 14.5a.945.945 0 0 0-.663.274l-2.812 2.813a.938.938 0 0 0 1.326 1.326l1.212-1.214v3.363a.938.938 0 0 0 1.874 0v-3.361l1.213 1.212c.182.185.42.274.662.274.735 0 .938-.671.938-.937 0-.24-.092-.48-.275-.663l-2.846-2.814ZM9.5 12A1.25 1.25 0 1 0 7 12a1.25 1.25 0 0 0 2.5 0Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsToDottedLine_default = SvgArrowsToDottedLine;

// src/Icon/icons/ArrowsToEye.tsx
import { jsx as jsx149 } from "react/jsx-runtime";
var SvgArrowsToEye = (props) => /* @__PURE__ */ jsx149(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx149(
      "path",
      {
        d: "M5.335 6.299v-1.22c0-.426.343-.8.77-.8.426 0 .769.374.769.8v3.077c0 .427-.343.77-.77.77H3.026c-.425 0-.798-.343-.798-.77 0-.426.373-.77.798-.77h1.22l-2.02-2.02a.77.77 0 1 1 1.088-1.088l2.02 2.02Zm4.617 5.705c0-1.132.92-2.052 2.052-2.052 1.132 0 2.052.92 2.052 2.052 0 1.132-.92 2.052-2.052 2.052a2.054 2.054 0 0 1-2.052-2.052Zm8.032-.388a.87.87 0 0 1 0 .776c-.805 1.613-2.86 4.23-5.98 4.23-3.12 0-5.175-2.617-5.98-4.23a.87.87 0 0 1 0-.776c.805-1.613 2.86-4.23 5.98-4.23 3.12 0 5.175 2.617 5.98 4.23Zm-1.54.388c-.791-1.407-2.372-3.078-4.44-3.078-2.068 0-3.649 1.67-4.44 3.078.791 1.408 2.372 3.078 4.44 3.078 2.068 0 3.649-1.67 4.44-3.078Zm5.31-6.638-1.994 2.02h1.222c.426 0 .77.344.77.77 0 .427-.344.77-.77.77h-3.078a.768.768 0 0 1-.77-.77V5.078c0-.425.343-.798.77-.798.426 0 .77.373.77.798v1.22l2.02-2.02c.3-.3.788-.3 1.06 0 .328.3.328.787 0 1.088ZM3.315 19.703a.726.726 0 0 1-1.089 0c-.3-.273-.3-.76 0-1.062l2.021-2.02h-1.22c-.425 0-.798-.343-.798-.77 0-.426.373-.769.798-.769h3.078c.427 0 .77.343.77.77v3.078c0 .427-.343.77-.77.77a.768.768 0 0 1-.77-.77v-1.222l-2.02 1.995Zm18.44 0c-.272.327-.76.327-1.06 0l-2.02-1.995v1.222c0 .427-.344.77-.77.77a.768.768 0 0 1-.77-.77v-3.078c0-.427.343-.77.77-.77h3.078c.426 0 .77.343.77.77 0 .426-.344.77-.77.77H19.76l1.995 2.02c.327.3.327.788 0 1.06Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsToEye_default = SvgArrowsToEye;

// src/Icon/icons/ArrowsToLine.tsx
import { jsx as jsx150 } from "react/jsx-runtime";
var SvgArrowsToLine = (props) => /* @__PURE__ */ jsx150(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx150(
      "path",
      {
        d: "M11.336 9.191A.844.844 0 0 0 12 9.5a.95.95 0 0 0 .663-.275l2.812-2.812a.938.938 0 0 0-1.326-1.326l-1.212 1.214V2.937a.937.937 0 1 0-1.874 0V6.3L9.816 5.087c-.148-.183-.39-.274-.629-.274a.938.938 0 0 0-.662 1.6l2.81 2.778Zm1.293 5.582A.835.835 0 0 0 12 14.5a.945.945 0 0 0-.663.274l-2.812 2.813a.938.938 0 0 0 1.326 1.326l1.212-1.214v3.363a.938.938 0 0 0 1.874 0v-3.361l1.213 1.212c.182.185.42.274.662.274.735 0 .938-.671.938-.937 0-.24-.092-.48-.275-.663l-2.846-2.814Zm7.184-3.71H4.188c-.518 0-.938.417-.938.902 0 .484.42.973.938.973h15.625a.938.938 0 0 0 0-1.876Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsToLine_default = SvgArrowsToLine;

// src/Icon/icons/ArrowsTurnRight.tsx
import { jsx as jsx151 } from "react/jsx-runtime";
var SvgArrowsTurnRight = (props) => /* @__PURE__ */ jsx151(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx151(
      "path",
      {
        d: "M14.75 2.3a.937.937 0 0 1 1.324-.05l4.375 4.063c.192.144.301.425.301.687a.94.94 0 0 1-.3.688l-4.376 4.062a.938.938 0 0 1-1.324-.05c-.352-.38-.363-.973.05-1.325l2.626-2.438H7.938a2.812 2.812 0 0 0-2.813 2.813v1.563a.937.937 0 1 1-1.875 0V10.75a4.687 4.687 0 0 1 4.688-4.688h9.488L14.8 3.626c-.414-.353-.403-.946-.051-1.325ZM11 12.3c.352-.413.945-.402 1.324-.05l4.375 4.063c.192.144.301.425.301.687a.94.94 0 0 1-.3.688l-4.376 4.062A.938.938 0 0 1 11 21.7c-.352-.38-.363-.973.05-1.325l2.626-2.438H6.687c-.862 0-1.562.7-1.562 1.563v1.563a.937.937 0 1 1-1.875 0V19.5a3.438 3.438 0 0 1 3.438-3.438h6.988l-2.625-2.437c-.414-.352-.403-.945-.051-1.324Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsTurnRight_default = SvgArrowsTurnRight;

// src/Icon/icons/ArrowsTurnToDots.tsx
import { jsx as jsx152 } from "react/jsx-runtime";
var SvgArrowsTurnToDots = (props) => /* @__PURE__ */ jsx152(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx152(
      "path",
      {
        d: "M11.96 2.743c.368-.366.962-.366 1.294 0a.885.885 0 0 1 0 1.326l-1.492 1.525h6.8A3.438 3.438 0 0 1 22 9.03v1.563c0 .52-.418.937-.938.937a.935.935 0 0 1-.937-.937V9.03c0-.863-.7-1.562-1.563-1.562h-6.8l1.492 1.523c.398.367.398.961 0 1.293-.332.399-.926.399-1.293 0L8.836 7.16c-.363-.332-.363-.926 0-1.293l3.125-3.124Zm3.169 13.124c.398.367.398.961 0 1.293l-3.125 3.125c-.332.398-.926.398-1.293 0-.363-.332-.363-.926 0-1.293l1.527-1.523h-6.8c-.863 0-1.563.699-1.563 1.562v1.563a.937.937 0 1 1-1.875 0V19.03a3.438 3.438 0 0 1 3.438-3.437h6.8l-1.527-1.559c-.363-.332-.363-.926 0-1.293.367-.363.96-.363 1.293 0l3.125 3.125Zm6.871.664c0 1.38-1.121 2.5-2.5 2.5a2.502 2.502 0 0 1-2.5-2.5c0-1.379 1.121-2.5 2.5-2.5s2.5 1.121 2.5 2.5Zm-15-10a2.501 2.501 0 1 1-5.002-.002A2.501 2.501 0 0 1 7 6.531Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsTurnToDots_default = SvgArrowsTurnToDots;

// src/Icon/icons/ArrowsUpDownLeftRight.tsx
import { jsx as jsx153 } from "react/jsx-runtime";
var SvgArrowsUpDownLeftRight = (props) => /* @__PURE__ */ jsx153(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx153(
      "path",
      {
        d: "M22 11.965a.925.925 0 0 1-.306.688l-3.438 3.127a.838.838 0 0 1-.631.279.937.937 0 0 1-.631-1.632l1.643-1.496h-5.7v5.703l1.495-1.644a.938.938 0 0 1 1.387 1.263l-3.126 3.44a.933.933 0 0 1-1.387 0l-3.124-3.44a.935.935 0 0 1-.245-.63c0-.523.424-.939.903-.939.255 0 .508.104.693.307l1.53 1.646V12.93h-5.7l1.643 1.495a.937.937 0 0 1-1.262 1.388l-3.438-3.127A.94.94 0 0 1 2 11.965c0-.264.111-.522.306-.7L5.744 8.14c.182-.131.404-.21.631-.21a.937.937 0 0 1 .63 1.632l-1.642 1.494h5.7V5.352L9.57 6.996a.964.964 0 0 1-.73.305c-.514 0-.902-.417-.902-.939 0-.225.08-.451.244-.63l3.125-3.44A.94.94 0 0 1 12 2c.258 0 .516.098.693.293l3.125 3.44a.938.938 0 1 1-1.387 1.263l-1.493-1.644v5.703h5.699l-1.644-1.496a.937.937 0 0 1 .63-1.631.94.94 0 0 1 .633.244l3.437 3.127a.928.928 0 0 1 .307.666Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsUpDownLeftRight_default = SvgArrowsUpDownLeftRight;

// src/Icon/icons/ArrowsUpDown.tsx
import { jsx as jsx154 } from "react/jsx-runtime";
var SvgArrowsUpDown = (props) => /* @__PURE__ */ jsx154(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx154(
      "path",
      {
        d: "M11.982 22a.938.938 0 0 1-.688-.302l-3.75-4.062a.933.933 0 0 1 .053-1.324.937.937 0 0 1 1.324.052l2.125 2.301V5.37l-2.09 2.302A.938.938 0 0 1 7.33 7c0-.227.082-.455.249-.636l3.75-4.062a.939.939 0 0 1 1.377 0l3.75 4.062a.936.936 0 1 1-1.377 1.272l-2.125-2.301v13.332l2.124-2.301a.937.937 0 1 1 1.378 1.272l-3.75 4.063c-.177.225-.427.299-.724.299Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsUpDown_default = SvgArrowsUpDown;

// src/Icon/icons/ArrowsUpToLine.tsx
import { jsx as jsx155 } from "react/jsx-runtime";
var SvgArrowsUpToLine = (props) => /* @__PURE__ */ jsx155(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx155(
      "path",
      {
        d: "M2.833 5.889a.834.834 0 0 1 0-1.667h18.334a.832.832 0 1 1 0 1.667H2.833Zm3.021 1.91a.833.833 0 0 1 .59-.244c.223 0 .434.087.56.244l3.61 3.61c.355.327.355.855 0 1.15-.295.354-.822.354-1.149 0l-2.187-2.16v8.545a.831.831 0 0 1-.834.834.831.831 0 0 1-.833-.834V10.4l-2.188 2.16a.787.787 0 0 1-1.179 0c-.325-.295-.325-.823 0-1.15l3.61-3.61Zm7.5 3.61 3.611-3.61c.327-.323.854-.323 1.15 0l3.61 3.61c.355.327.355.855 0 1.15-.294.354-.822.354-1.149 0l-2.187-2.16v8.545a.831.831 0 0 1-.833.834.831.831 0 0 1-.834-.834V10.4l-2.219 2.16c-.295.354-.822.354-1.149 0-.323-.295-.323-.823 0-1.15Z",
        fill: "currentColor"
      }
    )
  })
);
var ArrowsUpToLine_default = SvgArrowsUpToLine;

// src/Icon/icons/Asterisk.tsx
import { jsx as jsx156 } from "react/jsx-runtime";
var SvgAsterisk = (props) => /* @__PURE__ */ jsx156(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx156(
      "path",
      {
        d: "M20.634 17a1.071 1.071 0 0 1-1.464.392l-6.085-3.535v7.072c0 .591-.48 1.071-1.032 1.071-.551 0-1.111-.478-1.111-1.071v-7.072l-6.125 3.537c-.17.057-.354.142-.536.142a1.07 1.07 0 0 1-.537-2L9.87 12 3.745 8.463c-.513-.293-.688-.95-.433-1.463.335-.509.99-.692 1.504-.393l6.126 3.536V3.07c0-.591.482-1.071 1.071-1.071.59 0 1.072.48 1.072 1.071v7.072l6.125-3.537c.517-.298 1.17-.115 1.424.394.295.512.12 1.168-.392 1.463L14.116 12l6.125 3.537c.553.293.727.95.393 1.463Z",
        fill: "currentColor"
      }
    )
  })
);
var Asterisk_default = SvgAsterisk;

// src/Icon/icons/At.tsx
import { jsx as jsx157 } from "react/jsx-runtime";
var SvgAt = (props) => /* @__PURE__ */ jsx157(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx157(
      "path",
      {
        d: "M12.308 2.005A9.896 9.896 0 0 0 5.055 4.82 9.99 9.99 0 0 0 2 12.05c0 4.942 3.662 9.212 8.52 9.938a1 1 0 0 0 .292-1.976C6.93 19.428 4 16.007 4 12.05c0-2.206.87-4.262 2.447-5.796 1.564-1.517 3.594-2.326 5.8-2.251 4.274.13 7.753 3.91 7.753 8.426v.794a1.843 1.843 0 0 1-1.833 1.848 1.844 1.844 0 0 1-1.834-1.85V8.363c0-.553-.448-.963-1-.963a.987.987 0 0 0-.968.844 4.418 4.418 0 0 0-2.698-.91C9.094 7.333 7 9.426 7 11.962c0 2.535 2.094 4.629 4.667 4.629 1.28 0 2.442-.52 3.286-1.36a3.823 3.823 0 0 0 3.214 1.764c2.113 0 3.833-1.727 3.833-3.848v-.719c0-5.587-4.35-10.3-9.692-10.424Zm-.641 12.662C10.196 14.667 9 13.47 9 12.037c0-1.47 1.196-2.629 2.667-2.629 1.47 0 2.666 1.196 2.666 2.63 0 1.433-1.196 2.629-2.666 2.629Z",
        fill: "currentColor"
      }
    )
  })
);
var At_default = SvgAt;

// src/Icon/icons/AtomSimple.tsx
import { jsx as jsx158 } from "react/jsx-runtime";
var SvgAtomSimple = (props) => /* @__PURE__ */ jsx158(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx158(
      "path",
      {
        d: "M19.753 11.984c2.391 3.717 2.977 7.188 1.21 8.95-2.726 2.679-8.152-.68-8.963-1.165-.808.518-6.243 3.924-8.963 1.164-1.761-1.761-1.182-5.235 1.21-8.95-2.394-3.723-2.973-7.19-1.212-8.956 1.767-1.762 5.24-1.182 8.963 1.209 3.723-2.391 7.197-2.977 8.963-1.21 1.765 1.768 1.182 5.234-1.208 8.958Zm-14.143-1.9a27.625 27.625 0 0 1 4.49-4.486C8.235 4.526 5.55 3.551 4.551 4.543c-.747.747-.474 2.883 1.059 5.541Zm4.494 8.276a26.788 26.788 0 0 1-4.49-4.481c-1.534 2.658-1.807 4.798-1.06 5.538.744.75 2.883.477 5.55-1.057Zm6.982-6.376c-1.449-1.922-3.177-3.696-5.127-5.146a24.363 24.363 0 0 0-5.129 5.146 23.943 23.943 0 0 0 5.129 5.114c2.064-1.498 3.66-3.099 5.127-5.114Zm-3.7-.036a1.426 1.426 0 1 1-2.854 0c0-.792.635-1.428 1.427-1.428.829.037 1.426.674 1.426 1.428Zm4.998 1.93a26.993 26.993 0 0 1-4.49 4.482c2.664 1.533 4.802 1.806 5.551 1.06.745-.743.473-2.884-1.06-5.541Zm-4.49-8.28a27.295 27.295 0 0 1 4.49 4.486c1.533-2.658 1.806-4.794 1.06-5.538-.993-.995-3.673-.026-5.55 1.052Z",
        fill: "currentColor"
      }
    )
  })
);
var AtomSimple_default = SvgAtomSimple;

// src/Icon/icons/Atom.tsx
import { jsx as jsx159 } from "react/jsx-runtime";
var SvgAtom = (props) => /* @__PURE__ */ jsx159(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx159(
      "path",
      {
        d: "M12 10.75c-.691 0-1.285.563-1.285 1.25 0 .688.594 1.25 1.285 1.25.688 0 1.25-.562 1.25-1.25A1.256 1.256 0 0 0 12 10.75ZM20.406 7c-.61-1.084-1.938-1.616-3.637-1.616-.37.004-.737.029-1.103.078C14.777 3.343 13.465 2 12 2c-1.465 0-2.777 1.343-3.668 3.462a9.242 9.242 0 0 0-1.103-.078c-1.698 0-3.026.53-3.636 1.616-.732 1.309-.254 3.15 1.079 5-1.333 1.85-1.811 3.691-1.079 5 .61 1.084 1.938 1.616 3.637 1.616.371-.005.737-.029 1.104-.078C9.223 20.656 10.535 22 12 22c1.465 0 2.778-1.343 3.666-3.462a9.25 9.25 0 0 0 1.104.078c1.699 0 3.027-.532 3.637-1.616.732-1.309.254-3.15-1.079-5 1.332-1.852 1.777-3.691 1.078-5ZM12 3.875c.561 0 1.255.708 1.84 1.953-.625.172-1.238.383-1.84.629-.6-.249-1.216-.46-1.84-.63.586-1.244 1.277-1.952 1.84-1.952ZM7.23 16.742c-1.035 0-1.825-.259-2.06-.679-.278-.498-.02-1.47.728-2.602.454.46.938.902 1.446 1.312.088.645.21 1.29.376 1.92-.161.01-.333.05-.49.05Zm.114-7.515c-.508.41-.992.851-1.447 1.312-.747-1.133-1.006-2.101-.727-2.601.234-.42 1.025-.68 2.06-.68.121 0 .327.04.488.05a15.39 15.39 0 0 0-.374 1.919ZM12 20.125c-.561 0-1.255-.708-1.84-1.918a28.395 28.395 0 0 0 1.84-.664c.6.249 1.216.46 1.84.63-.586 1.245-1.277 1.952-1.84 1.952Zm0-4.375a3.75 3.75 0 0 1 0-7.5A3.75 3.75 0 0 1 15.75 12c0 2.07-1.715 3.75-3.75 3.75Zm6.832.313c-.234.42-1.025.678-2.06.678-.121 0-.327-.039-.488-.048.165-.63.251-1.275.372-1.92.473-.41.991-.85 1.41-1.313.786 1.134 1.008 2.102.766 2.602Zm-.73-5.524a17.09 17.09 0 0 0-1.446-1.312c-.12-.645-.207-1.29-.375-1.918.161-.01.332-.05.489-.05 1.035 0 1.825.26 2.06.68.244.498.022 1.467-.728 2.6Z",
        fill: "currentColor"
      }
    )
  })
);
var Atom_default = SvgAtom;

// src/Icon/icons/AustralSign.tsx
import { jsx as jsx160 } from "react/jsx-runtime";
var SvgAustralSign = (props) => /* @__PURE__ */ jsx160(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx160(
      "path",
      {
        d: "M16.312 10.571h4.616c.594 0 1.072.478 1.072 1.072 0 .593-.478 1.071-1.072 1.071h-3.714l.898 2.143h2.816c.594 0 1.072.478 1.072 1.071 0 .594-.478 1.072-1.072 1.072h-1.915l1.473 3.513c.233.545-.026 1.134-.571 1.402a1.068 1.068 0 0 1-1.402-.572L16.687 17H7.272l-1.784 4.343a1.07 1.07 0 0 1-1.403.572c-.545-.268-.802-.857-.573-1.402L4.988 17H3.072a1.07 1.07 0 1 1 0-2.143h2.816l.898-2.143H3.072a1.07 1.07 0 1 1 0-2.143h4.616l3.325-7.914C11.18 2.259 11.567 2 12 2c.433 0 .821.259.987.657l3.325 7.914Zm-2.325 0L12 5.8l-1.987 4.772h3.974Zm-4.875 2.143-.898 2.143h7.572l-.898-2.143H9.112Z",
        fill: "currentColor"
      }
    )
  })
);
var AustralSign_default = SvgAustralSign;

// src/Icon/icons/AwardSimple.tsx
import { jsx as jsx161 } from "react/jsx-runtime";
var SvgAwardSimple = (props) => /* @__PURE__ */ jsx161(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx161(
      "path",
      {
        d: "M19.5 9.5c0-.84-.402-1.45-.641-1.813a4.364 4.364 0 0 0-.019-.028l.003-.048c.024-.43.065-1.149-.348-1.862-.415-.718-1.063-1.044-1.45-1.239l-.036-.018-.019-.037c-.194-.387-.52-1.035-1.238-1.45-.422-.245-.9-.363-1.466-.363a7.2 7.2 0 0 0-.396.014l-.049.003-.027-.019C13.449 2.401 12.84 2 12 2c-.84 0-1.45.401-1.812.64-.008.007-.02.013-.028.019l-.046-.003a7.842 7.842 0 0 0-.399-.014c-.565 0-1.044.118-1.465.362-.719.416-1.045 1.063-1.239 1.45l-.018.037-.037.018c-.387.194-1.035.52-1.45 1.239-.414.713-.373 1.431-.349 1.86l.003.049c-.006.01-.012.018-.018.03-.24.363-.641.973-.641 1.812 0 .84.4 1.449.64 1.813l.019.027-.003.047c-.024.43-.065 1.152.348 1.863.416.718 1.063 1.044 1.45 1.239l.037.018.018.037c.194.387.52 1.034 1.238 1.45.032.018.069.023.101.04l-1.085 5.21a.625.625 0 0 0 .891.687L12 20.01l3.845 1.923a.625.625 0 0 0 .891-.687l-1.085-5.21c.032-.017.068-.022.1-.04.718-.415 1.044-1.063 1.239-1.45a6.2 6.2 0 0 0 .018-.037l.037-.018c.386-.194 1.034-.52 1.45-1.239.413-.713.372-1.432.348-1.862l-.003-.048.019-.028c.238-.366.64-.975.64-1.815Zm-2.536 1.34c-.123.46.106 1.068-.127 1.472-.238.41-.88.513-1.213.846-.333.332-.437.975-.846 1.212-.153.089-.335.111-.528.111-.192 0-.394-.022-.588-.022-.124 0-.245.01-.357.04-.41.117-.82.625-1.305.625-.483 0-.895-.506-1.34-.626-.113-.03-.234-.073-.36-.073-.192 0-.394.022-.586.022-.192 0-.375-.023-.528-.111-.408-.204-.514-.845-.845-1.177-.333-.332-.976-.437-1.213-.847-.233-.403-.004-1.012-.127-1.473-.12-.445-.626-.855-.626-1.34 0-.483.507-.894.626-1.34.123-.461-.106-1.07.128-1.473.237-.409.88-.514 1.213-.846.332-.332.436-.975.846-1.212.153-.089.335-.111.527-.111s.395.022.588.022c.124 0 .245-.01.357-.04.445-.118.856-.624 1.34-.624.484 0 .895.506 1.34.625.113.03.234.04.359.04.193 0 .395-.023.586-.023.193 0 .376.023.528.111.41.237.514.88.846 1.213.333.332.976.436 1.213.846.233.404.004 1.012.128 1.473.12.445.625.855.625 1.34 0 .484-.508.894-.66 1.34ZM12 7a2.5 2.5 0 1 0 0 4.999 2.5 2.5 0 0 0 0-5Z",
        fill: "currentColor"
      }
    )
  })
);
var AwardSimple_default = SvgAwardSimple;

// src/Icon/icons/Award.tsx
import { jsx as jsx162 } from "react/jsx-runtime";
var SvgAward = (props) => /* @__PURE__ */ jsx162(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx162(
      "path",
      {
        d: "M17.57 14.188c.32-.206.666-.491.924-.903.414-.713.372-1.432.349-1.863l-.003-.048.018-.028c.24-.397.607-1.006.607-1.846 0-.84-.4-1.449-.64-1.813a2.178 2.178 0 0 0-.018-.027l.003-.048c.024-.43.065-1.15-.348-1.863-.416-.718-1.064-1.044-1.45-1.238l-.037-.019-.019-.037c-.194-.386-.52-1.034-1.238-1.45-.422-.244-.901-.362-1.467-.362a7.2 7.2 0 0 0-.396.014l-.048.002a2.197 2.197 0 0 0-.028-.018C13.449 2.401 12.84 2 12 2c-.84 0-1.45.401-1.813.64-.008.007-.02.013-.027.019l-.047-.003a7.84 7.84 0 0 0-.399-.014c-.565 0-1.043.118-1.465.362-.719.416-1.045 1.064-1.239 1.45a4.058 4.058 0 0 0-.018.037l-.037.018c-.387.195-1.035.52-1.45 1.239-.414.713-.373 1.432-.349 1.861l.003.048-.018.03c-.24.364-.641.973-.641 1.813s.4 1.449.64 1.813l.019.027-.003.047c-.024.43-.065 1.148.348 1.863.267.461.626.752.954.958l-1.891 4.715a.937.937 0 0 0 1.054 1.265l1.766-.353.837 1.651a.928.928 0 0 0 .874.513.926.926 0 0 0 .83-.581L11.71 17h.612l1.75 4.418c.14.344.458.566.83.581.012-.034-.008.001.039.001a.926.926 0 0 0 .834-.513l.837-1.652 1.765.353a.93.93 0 0 0 .904-.318.937.937 0 0 0 .15-.948l-1.861-4.735Zm-.698-1.876c-.237.41-.88.514-1.213.847-.333.332-.437.975-.846 1.212-.153.089-.335.11-.528.11-.192 0-.394-.021-.588-.021-.124 0-.245.009-.357.039-.445.118-.855.626-1.34.626-.483 0-.894-.506-1.34-.625-.113-.031-.234-.074-.359-.074-.193 0-.395.022-.586.022-.193 0-.375-.022-.528-.111-.409-.204-.515-.845-.846-1.177-.333-.332-.976-.437-1.213-.848-.233-.402-.004-1.011-.127-1.472-.12-.445-.625-.856-.625-1.34 0-.484.506-.895.625-1.34.123-.462-.106-1.07.128-1.474.237-.409.88-.514 1.213-.846.332-.332.436-.975.846-1.212.153-.089.335-.11.528-.11.192 0 .394.021.587.021.125 0 .246-.009.358-.039.445-.12.855-.625 1.34-.625.484 0 .894.506 1.34.625.113.03.234.04.358.04.194 0 .395-.022.587-.022.193 0 .375.022.528.11.41.237.514.88.846 1.213.333.333.976.437 1.213.846.233.404.004 1.012.128 1.473.12.445.625.856.625 1.34 0 .484-.506.895-.626 1.34-.124.46.106 1.07-.128 1.473ZM12 7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
        fill: "currentColor"
      }
    )
  })
);
var Award_default = SvgAward;

// src/Icon/icons/Axe.tsx
import { jsx as jsx163 } from "react/jsx-runtime";
var SvgAxe = (props) => /* @__PURE__ */ jsx163(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx163(
      "path",
      {
        d: "M2.293 17.584a1 1 0 0 0 0 1.415l.707.707a.997.997 0 0 0 1.415.001l7.225-7.225-2.121-2.12-7.226 7.222ZM18.428 9l-1.654-1.654.932-.932a1 1 0 0 0 0-1.415l-.707-.706a.996.996 0 0 0-1.412 0l-.932.932-.932-.932a.997.997 0 0 0-1.414 0L9.294 7.31a.998.998 0 0 0 0 1.413L14 13.428V17h.972C18.866 17 22 13.866 22 10V9h-3.572ZM15.5 15.478V12.81l-4.794-4.793 2.309-2.308 4.794 4.792h2.67a5.513 5.513 0 0 1-4.979 4.978Z",
        fill: "currentColor"
      }
    )
  })
);
var Axe_default = SvgAxe;

// src/Icon/icons/Azure.tsx
import { jsx as jsx164, jsxs as jsxs2 } from "react/jsx-runtime";
var Azure = (props) => /* @__PURE__ */ jsxs2(
  "svg",
  __spreadProps(__spreadValues({
    width: "38",
    height: "29",
    viewBox: "0 0 38 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsx164(
        "path",
        {
          d: "M9.60301 9.5223L0.1875 25.7833H8.69449L20.5878 0.359985L9.60301 9.5223Z",
          fill: "#0089D6"
        }
      ),
      /* @__PURE__ */ jsx164(
        "path",
        {
          d: "M17.1602 15.2178L21.7854 2.34103L37.1475 28.92H8.69449L26.0801 25.7833L17.1602 15.2178Z",
          fill: "#0089D6"
        }
      )
    ]
  })
);
var Azure_default = Azure;

// src/Icon/icons/B.tsx
import { jsx as jsx165 } from "react/jsx-runtime";
var SvgB = (props) => /* @__PURE__ */ jsx165(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx165(
      "path",
      {
        d: "M16.022 11.505a5.504 5.504 0 0 0 1.692-3.97A5.541 5.541 0 0 0 12.18 2h-6.25c-.592 0-1.072.48-1.072 1.071V20.93c0 .593.48 1.071 1.072 1.071h7.678a5.54 5.54 0 0 0 5.536-5.536c0-2.183-1.281-4.058-3.12-4.96ZM7 4.143h5.179a3.396 3.396 0 0 1 3.392 3.393 3.397 3.397 0 0 1-3.392 3.393H7V4.143Zm6.607 15.714H7v-6.786h6.607A3.397 3.397 0 0 1 17 16.464a3.397 3.397 0 0 1-3.393 3.393Z",
        fill: "currentColor"
      }
    )
  })
);
var B_default = SvgB;

// src/Icon/icons/Backpack.tsx
import { jsx as jsx166 } from "react/jsx-runtime";
var SvgBackpack = (props) => /* @__PURE__ */ jsx166(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx166(
      "path",
      {
        d: "M15.75 5.125h-.313v-.938A2.19 2.19 0 0 0 13.25 2h-2.5a2.19 2.19 0 0 0-2.188 2.188v.937H8.25c-2.764 0-5 2.236-5 5V19.5c0 1.382 1.118 2.5 2.5 2.5h12.5c1.382 0 2.5-1.118 2.5-2.5v-9.375c0-2.766-2.234-5-5-5Zm-5.313-.938c0-.17.141-.312.313-.312h2.5c.17 0 .313.142.313.313v.937h-3.126v-.938Zm5.313 15.938h-7.5v-2.5h7.5v2.5Zm0-4.375h-7.5V14.5c0-.688.562-1.25 1.25-1.25h5c.688 0 1.25.562 1.25 1.25v1.25Zm3.125 3.75a.623.623 0 0 1-.625.625h-.625V14.5a3.128 3.128 0 0 0-3.125-3.125h-5A3.128 3.128 0 0 0 6.375 14.5v5.625H5.75a.623.623 0 0 1-.625-.625v-9.375A3.129 3.129 0 0 1 8.25 7h7.5a3.128 3.128 0 0 1 3.125 3.125V19.5Zm-3.75-11.25H8.84a.608.608 0 0 0-.59.59v.66c0 .347.278.625.625.625h6.25a.622.622 0 0 0 .625-.625v-.625a.622.622 0 0 0-.625-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var Backpack_default = SvgBackpack;

// src/Icon/icons/BackwardFast.tsx
import { jsx as jsx167 } from "react/jsx-runtime";
var SvgBackwardFast = (props) => /* @__PURE__ */ jsx167(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx167(
      "path",
      {
        d: "M20.702 4.258c-.283 0-.57.093-.819.299l-6.915 6.31V5.55c0-.775-.633-1.292-1.299-1.292-.282 0-.57.093-.818.299l-6.916 6.31v-5.64a.968.968 0 0 0-.967-.968c-.535 0-.968.433-.968.932v13.544a.968.968 0 1 0 1.935 0v-5.558l6.916 6.262c.246.21.536.303.818.303.666 0 1.299-.516 1.299-1.327v-5.238l6.915 6.262c.246.21.536.303.819.303.665 0 1.298-.516 1.298-1.327V5.55c0-.775-.633-1.292-1.298-1.292Zm-9.67 12.738L5.54 12.02l5.492-5.008v9.984Zm9.032 0-5.491-4.976 5.491-5.008v9.984Z",
        fill: "currentColor"
      }
    )
  })
);
var BackwardFast_default = SvgBackwardFast;

// src/Icon/icons/BackwardStep.tsx
import { jsx as jsx168 } from "react/jsx-runtime";
var SvgBackwardStep = (props) => /* @__PURE__ */ jsx168(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx168(
      "path",
      {
        d: "M4.917 3.25v17.5a1.25 1.25 0 0 0 2.5 0v-5.51l9.03 6.453a1.672 1.672 0 0 0 1.733.123c.555-.286.903-.858.903-1.483V3.667A1.668 1.668 0 0 0 17.417 2c-.341 0-.681.104-.969.31L7.417 8.76V3.25a1.25 1.25 0 0 0-2.5 0Zm2.5 8.583 9.166-6.547v13.428l-9.166-6.547v-.334Z",
        fill: "currentColor"
      }
    )
  })
);
var BackwardStep_default = SvgBackwardStep;

// src/Icon/icons/Backward.tsx
import { jsx as jsx169 } from "react/jsx-runtime";
var SvgBackward = (props) => /* @__PURE__ */ jsx169(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx169(
      "path",
      {
        d: "M10.742 4.498c-.273 0-.553.09-.792.29l-7.503 6.25a1.258 1.258 0 0 0 0 1.922l7.5 6.215c.24.233.522.323.795.323.645 0 1.259-.5 1.259-1.251V5.75c-.036-.753-.614-1.253-1.259-1.253Zm-.652 12.418-5.868-4.918 5.902-4.918v9.836h-.034ZM21.352 4.652a1.25 1.25 0 0 0-1.271.042l-6.395 4.07a.937.937 0 1 0 1.006 1.582l5.433-3.457V17.11l-5.434-3.458a.937.937 0 1 0-1.006 1.582l6.395 4.07c.204.131.434.197.667.197.206 0 .418-.051.605-.154A1.28 1.28 0 0 0 22 18.213V5.749c0-.456-.25-.877-.648-1.097Z",
        fill: "currentColor"
      }
    )
  })
);
var Backward_default = SvgBackward;

// src/Icon/icons/Bacteria.tsx
import { jsx as jsx170 } from "react/jsx-runtime";
var SvgBacteria = (props) => /* @__PURE__ */ jsx170(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx170(
      "path",
      {
        d: "M7.972 8a.5.5 0 1 0 .5.5c0-.276-.197-.5-.5-.5Zm-2.5 3A.47.47 0 0 0 5 11.47c0 .248.225.528.472.528a.5.5 0 0 0 .5-.5c0-.276-.197-.5-.5-.5Zm9 5a.47.47 0 0 0-.472.471c0 .248.224.5.472.5a.5.5 0 0 0 .5-.5c0-.276-.197-.472-.5-.472Zm6.71-4.772.42-.125a.553.553 0 0 0 .375-.688.556.556 0 0 0-.692-.374l-.425.126a2.577 2.577 0 0 0-1.086-1.046l.112-.429a.557.557 0 0 0-1.078-.278l-.11.42c-.078-.002-.732-.07-1.467.385l-.306-.31c-.118-.121-.483-.306-.787-.012a.552.552 0 0 0-.012.784l.307.314a2.551 2.551 0 0 0-.4.994c-.026.152-.074.296-.118.441l-.284-.134a.553.553 0 1 0-.47 1.002l.29.136a3.708 3.708 0 0 1-1.098 1.064l-.128-.29a.559.559 0 0 0-.734-.284.554.554 0 0 0-.285.731l.126.285c-.118.032-.233.073-.356.094-.402.066-.76.229-1.071.449l-.327-.295a.557.557 0 0 0-.787.04.552.552 0 0 0 .038.782l.329.296c-.25.435-.373.939-.334 1.467l-.426.126a.553.553 0 1 0 .318 1.062l.424-.125a2.59 2.59 0 0 0 1.089 1.047l-.11.424a.556.556 0 0 0 1.077.28l.108-.417c.232.008.6-.002 1.518-.265l.125.348a.556.556 0 0 0 1.048-.372l-.122-.342a8.92 8.92 0 0 0 1.363-.732l.22.295a.56.56 0 0 0 .78.112.553.553 0 0 0 .113-.775l-.219-.291a8.915 8.915 0 0 0 1.088-1.098l.297.216a.557.557 0 0 0 .778-.12.552.552 0 0 0-.121-.775l-.297-.215c.277-.431.519-.887.719-1.365l.346.118a.553.553 0 1 0 .362-1.047l-.349-.12c.082-.296.155-.595.206-.903a2.69 2.69 0 0 0 .022-.611Zm-7.626 6.506a1.133 1.133 0 0 1-1.292-.925c-.05-.297.02-.595.194-.84.175-.244.434-.377.731-.455a5.262 5.262 0 0 0 4.325-4.325 1.12 1.12 0 0 1 1.295-.924c.296.05.555.21.73.455.174.245.243.543.194.84a7.512 7.512 0 0 1-6.177 6.174Zm-3.047-6.66a.554.554 0 0 0 .285-.73l-.125-.285c.118-.032.233-.073.356-.093.402-.067.76-.23 1.071-.45l.327.295a.558.558 0 0 0 .786-.039.552.552 0 0 0-.038-.782l-.329-.296c.25-.435.373-.939.333-1.467l.426-.126a.553.553 0 1 0-.317-1.062l-.424.125a2.59 2.59 0 0 0-1.09-1.047l.112-.424a.556.556 0 0 0-1.076-.279l-.11.416c-.234-.008-.6.002-1.518.265l-.125-.348c-.103-.288-.422-.44-.737-.336a.562.562 0 0 0-.31.708l.122.342a8.897 8.897 0 0 0-1.362.731l-.222-.294a.558.558 0 0 0-.778-.112c-.247.183-.325.53-.116.775l.218.292A8.91 8.91 0 0 0 4.781 7.95l-.296-.216a.557.557 0 0 0-.778.12.55.55 0 0 0 .121.774l.297.215a8.846 8.846 0 0 0-.719 1.366l-.346-.119a.555.555 0 0 0-.707.344.55.55 0 0 0 .345.703l.35.122a8.593 8.593 0 0 0-.207.903c-.034.206-.036.41-.022.61l-.42.124a.55.55 0 0 0-.376.688c.095.319.424.454.692.373l.425-.125c.247.444.621.809 1.086 1.046l-.112.428c-.058.224.06.693.54.693a.556.556 0 0 0 .538-.415l.11-.42c.078.003.732.07 1.467-.385l.305.312c.118.121.482.306.787.012a.552.552 0 0 0 .011-.784l-.307-.315c.195-.293.339-.624.4-.993.026-.152.074-.296.118-.441l.286.133a.545.545 0 0 0 .737-.294c.131-.25.013-.578-.265-.71l-.291-.134A3.751 3.751 0 0 1 9.647 10.5l.128.29a.561.561 0 0 0 .734.285ZM6.484 12.81c-.034.203-.347 1.084-1.293.925a1.122 1.122 0 0 1-.925-1.295 7.514 7.514 0 0 1 6.178-6.175c.93-.156 1.256.713 1.291.926a1.124 1.124 0 0 1-.925 1.294 5.2 5.2 0 0 0-4.326 4.325Z",
        fill: "currentColor"
      }
    )
  })
);
var Bacteria_default = SvgBacteria;

// src/Icon/icons/Bacterium.tsx
import { jsx as jsx171 } from "react/jsx-runtime";
var SvgBacterium = (props) => /* @__PURE__ */ jsx171(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx171(
      "path",
      {
        d: "M21.96 6.02a.928.928 0 0 0-1.153-.621l-.707.21a4.315 4.315 0 0 0-1.815-1.746l.185-.707a.922.922 0 0 0-.664-1.126.926.926 0 0 0-1.131.661l-.183.695c-.287-.01-.58.007-.874.056-.565.094-1.115.23-1.657.384l-.206-.579c-.172-.48-.668-.734-1.185-.56a.922.922 0 0 0-.563 1.18l.203.57c-.796.34-1.553.752-2.268 1.22l-.367-.491c-.344-.409-.89-.492-1.301-.188a.92.92 0 0 0-.188 1.293l.365.485a14.721 14.721 0 0 0-1.814 1.83l-.496-.362a.93.93 0 0 0-1.296.203.92.92 0 0 0 .201 1.29l.494.36a14.531 14.531 0 0 0-1.195 2.271l-.577-.195a.924.924 0 1 0-.604 1.746l.583.2c-.137.492-.258.992-.344 1.505-.058.344-.061.682-.037 1.015l-.701.208a.921.921 0 0 0 .264 1.808.916.916 0 0 0 .264-.039l.708-.209a4.294 4.294 0 0 0 1.81 1.743l-.186.714A.924.924 0 0 0 6.423 22a.928.928 0 0 0 .897-.691l.184-.703c.058.002.117.014.175.014.823 0 1.602-.241 2.271-.655l.507.52a.927.927 0 0 0 1.312.02.92.92 0 0 0 .02-1.307l-.512-.524a4.258 4.258 0 0 0 .667-1.656 6.12 6.12 0 0 1 .185-.74l.484.227a.928.928 0 0 0 1.234-.444.922.922 0 0 0-.445-1.228l-.483-.226a6.177 6.177 0 0 1 1.829-1.772l.214.483a.93.93 0 0 0 1.223.472c.434-.206.682-.75.475-1.217l-.21-.475c.197-.053.388-.12.593-.154a4.292 4.292 0 0 0 1.785-.75l.545.492a.927.927 0 0 0 1.31-.064.92.92 0 0 0-.064-1.304l-.548-.494c.417-.723.62-1.564.556-2.444l.71-.21a.925.925 0 0 0 .624-1.15ZM18.41 9.08a2.483 2.483 0 0 1-1.623 1.012 8.155 8.155 0 0 0-6.697 6.694c-.201 1.176-1.236 2.09-2.46 2.09a2.482 2.482 0 0 1-2.04-1.047 2.483 2.483 0 0 1-.431-1.864c.923-5.539 5.265-9.847 10.808-10.804.137-.023.277-.035.415-.035a2.52 2.52 0 0 1 2.458 2.09c.11.66-.043 1.321-.43 1.864ZM8.25 13.25c-.69 0-1.214.56-1.214 1.214 0 .655.56 1.215 1.215 1.215s1.214-.56 1.214-1.215-.523-1.214-1.214-1.214Zm3.125-4.063c-.517 0-.934.42-.934.903 0 .517.417.937.934.937a.9.9 0 0 0 .903-.902c0-.52-.383-.938-.903-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var Bacterium_default = SvgBacterium;

// src/Icon/icons/BadgeCheck.tsx
import { jsx as jsx172 } from "react/jsx-runtime";
var SvgBadgeCheck = (props) => /* @__PURE__ */ jsx172(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx172(
      "path",
      {
        d: "M11.379 15.129c-.332.398-.926.398-1.293 0L7.898 12.94c-.363-.332-.363-.925 0-1.293.368-.363.961-.363 1.293 0l1.559 1.528 3.71-3.715c.368-.363.962-.363 1.294 0 .398.367.398.96 0 1.293l-4.375 4.375ZM15.44 3.696a4.328 4.328 0 0 1 3.63 1.233 4.295 4.295 0 0 1 1.234 3.63C21.3 9.352 22 10.598 22 12c0 1.402-.7 2.648-1.695 3.441a4.328 4.328 0 0 1-1.235 3.63 4.328 4.328 0 0 1-3.629 1.234C14.648 21.3 13.402 22 12 22c-1.402 0-2.648-.7-3.441-1.695a4.295 4.295 0 0 1-3.63-1.235 4.329 4.329 0 0 1-1.233-3.629A4.334 4.334 0 0 1 2 12c0-1.402.666-2.648 1.696-3.441a4.294 4.294 0 0 1 1.233-3.63 4.296 4.296 0 0 1 3.63-1.233A4.334 4.334 0 0 1 12 2c1.402 0 2.648.666 3.441 1.696ZM9.426 5.87l-.707-.227c-.844-.26-1.832-.054-2.465.61-.665.634-.871 1.622-.611 2.466l.227.707-.684.398a2.46 2.46 0 0 0 0 4.352l.684.363-.227.707c-.26.879-.054 1.832.61 2.5.634.664 1.622.871 2.466.61l.707-.227.398.687A2.459 2.459 0 0 0 12 20.125c.941 0 1.762-.527 2.176-1.309l.363-.687.707.23c.879.258 1.832.051 2.5-.613.664-.668.871-1.621.61-2.5l-.227-.707.687-.363A2.459 2.459 0 0 0 20.125 12c0-.941-.527-1.762-1.309-2.176l-.687-.398.226-.707c.262-.844.055-1.832-.609-2.465-.668-.665-1.621-.871-2.5-.611l-.707.227-.363-.684a2.46 2.46 0 0 0-4.352 0l-.398.684Z",
        fill: "currentColor"
      }
    )
  })
);
var BadgeCheck_default = SvgBadgeCheck;

// src/Icon/icons/BadgeDollar.tsx
import { jsx as jsx173 } from "react/jsx-runtime";
var SvgBadgeDollar = (props) => /* @__PURE__ */ jsx173(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx173(
      "path",
      {
        d: "M12.785 8.18c.317.047.809.144 1.012.199a.78.78 0 0 1 .555.957.736.736 0 0 1-.957.52c-.168-.012-.758-.126-.95-.157-.543-.086-.996-.015-1.293.121-.293.133-.382.293-.406.414a.477.477 0 0 0 .016.27c.02.043.031.105.187.187.278.192.711.325 1.32.508l.032.012c.527.156 1.219.367 1.73.742.281.168.512.477.707.852.164.375.2.793.121 1.226-.136.793-.66 1.336-1.32 1.617a2.994 2.994 0 0 1-.754.207v.313c0 .434-.351.785-.75.785a.785.785 0 0 1-.785-.785v-.348c-.414-.09-.988-.285-1.348-.41a4.04 4.04 0 0 1-.199-.066.78.78 0 0 1 .496-1.48c.086.027.176.058.27.09.414.14.89.304 1.156.347.535.09 1.016.031 1.3-.09.259-.11.364-.262.395-.445.035-.188.008-.286-.015-.34a.54.54 0 0 0-.192-.211c-.27-.195-.695-.336-1.297-.52l-.125-.027c-.476-.152-1.129-.352-1.62-.684a2.048 2.048 0 0 1-.723-.812c-.172-.367-.215-.777-.141-1.238.133-.727.672-1.254 1.3-1.54.231-.101.481-.18.743-.23v-.332c0-.434.352-.785.785-.785.399 0 .75.351.75.785v.348Zm2.656-4.484a4.328 4.328 0 0 1 3.63 1.233 4.295 4.295 0 0 1 1.234 3.63C21.3 9.352 22 10.598 22 12c0 1.402-.7 2.648-1.695 3.441a4.328 4.328 0 0 1-1.235 3.63 4.328 4.328 0 0 1-3.629 1.234C14.648 21.3 13.402 22 12 22c-1.402 0-2.648-.7-3.441-1.695a4.295 4.295 0 0 1-3.63-1.235 4.329 4.329 0 0 1-1.233-3.629A4.334 4.334 0 0 1 2 12c0-1.402.666-2.648 1.696-3.441a4.294 4.294 0 0 1 1.233-3.63 4.296 4.296 0 0 1 3.63-1.233A4.334 4.334 0 0 1 12 2c1.402 0 2.648.666 3.441 1.696ZM9.426 5.87l-.707-.227c-.844-.26-1.832-.054-2.465.61-.665.634-.871 1.622-.611 2.466l.227.707-.684.398a2.46 2.46 0 0 0 0 4.352l.684.363-.227.707c-.26.879-.054 1.832.61 2.5.634.664 1.622.871 2.466.61l.707-.227.398.687A2.459 2.459 0 0 0 12 20.125c.941 0 1.762-.527 2.176-1.309l.363-.687.707.23c.879.258 1.832.051 2.5-.613.664-.668.871-1.621.61-2.5l-.227-.707.687-.363A2.459 2.459 0 0 0 20.125 12c0-.941-.527-1.762-1.309-2.176l-.687-.398.226-.707c.262-.844.055-1.832-.609-2.465-.668-.665-1.621-.871-2.5-.611l-.707.227-.363-.684a2.46 2.46 0 0 0-4.352 0l-.398.684Z",
        fill: "currentColor"
      }
    )
  })
);
var BadgeDollar_default = SvgBadgeDollar;

// src/Icon/icons/BadgePercent.tsx
import { jsx as jsx174 } from "react/jsx-runtime";
var SvgBadgePercent = (props) => /* @__PURE__ */ jsx174(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx174(
      "path",
      {
        d: "M8.25 9.5c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25-.559 1.25-1.25 1.25-1.25-.559-1.25-1.25Zm7.5 5c0 .691-.559 1.25-1.25 1.25s-1.25-.559-1.25-1.25.559-1.25 1.25-1.25 1.25.559 1.25 1.25Zm-5.621.629c-.332.398-.926.398-1.293 0-.363-.332-.363-.926 0-1.293l5-5c.367-.363.96-.363 1.293 0 .398.367.398.96 0 1.293l-5 5ZM15.44 3.696a4.328 4.328 0 0 1 3.63 1.233 4.295 4.295 0 0 1 1.234 3.63C21.3 9.352 22 10.598 22 12c0 1.402-.7 2.648-1.695 3.441a4.328 4.328 0 0 1-1.235 3.63 4.328 4.328 0 0 1-3.629 1.234C14.648 21.3 13.402 22 12 22c-1.402 0-2.648-.7-3.441-1.695a4.295 4.295 0 0 1-3.63-1.235 4.329 4.329 0 0 1-1.233-3.629A4.334 4.334 0 0 1 2 12c0-1.402.666-2.648 1.696-3.441a4.294 4.294 0 0 1 1.233-3.63 4.296 4.296 0 0 1 3.63-1.233A4.334 4.334 0 0 1 12 2c1.402 0 2.648.666 3.441 1.696ZM9.426 5.87l-.707-.227c-.844-.26-1.832-.054-2.465.61-.665.634-.871 1.622-.611 2.466l.227.707-.684.398a2.46 2.46 0 0 0 0 4.352l.684.363-.227.707c-.26.879-.054 1.832.61 2.5.634.664 1.622.871 2.466.61l.707-.227.398.687A2.459 2.459 0 0 0 12 20.125c.941 0 1.762-.527 2.176-1.309l.363-.687.707.23c.879.258 1.832.051 2.5-.613.664-.668.871-1.621.61-2.5l-.227-.707.687-.363A2.459 2.459 0 0 0 20.125 12c0-.941-.527-1.762-1.309-2.176l-.687-.398.226-.707c.262-.844.055-1.832-.609-2.465-.668-.665-1.621-.871-2.5-.611l-.707.227-.363-.684a2.46 2.46 0 0 0-4.352 0l-.398.684Z",
        fill: "currentColor"
      }
    )
  })
);
var BadgePercent_default = SvgBadgePercent;

// src/Icon/icons/Badge.tsx
import { jsx as jsx175 } from "react/jsx-runtime";
var SvgBadge = (props) => /* @__PURE__ */ jsx175(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx175(
      "path",
      {
        d: "M8.559 3.696A4.334 4.334 0 0 1 12 2c1.402 0 2.648.666 3.441 1.696a4.328 4.328 0 0 1 3.63 1.233 4.295 4.295 0 0 1 1.234 3.63C21.3 9.352 22 10.598 22 12c0 1.402-.7 2.648-1.695 3.441a4.328 4.328 0 0 1-1.235 3.63 4.328 4.328 0 0 1-3.629 1.234C14.648 21.3 13.402 22 12 22c-1.402 0-2.648-.7-3.441-1.695a4.295 4.295 0 0 1-3.63-1.235 4.329 4.329 0 0 1-1.233-3.629A4.352 4.352 0 0 1 2 11.965c0-1.367.666-2.613 1.696-3.406a4.294 4.294 0 0 1 1.233-3.63 4.296 4.296 0 0 1 3.63-1.233ZM12 3.875a2.46 2.46 0 0 0-2.176 1.31l-.398.685-.707-.227c-.844-.26-1.832-.054-2.465.61-.665.634-.871 1.622-.611 2.466l.227.707-.684.398a2.46 2.46 0 0 0 0 4.352l.684.363-.227.707c-.26.879-.054 1.832.61 2.5.634.664 1.622.871 2.466.61l.707-.227.398.687A2.459 2.459 0 0 0 12 20.125c.941 0 1.762-.527 2.176-1.309l.363-.687.707.226c.879.262 1.832.055 2.5-.609.664-.668.871-1.621.61-2.5l-.227-.707.687-.363a2.473 2.473 0 0 0 1.309-2.211c0-.906-.527-1.727-1.309-2.14l-.687-.4.226-.706c.262-.844.055-1.832-.609-2.465-.668-.665-1.621-.871-2.5-.611l-.707.227-.363-.684C13.762 4.404 12.94 3.84 12 3.84v.035Z",
        fill: "currentColor"
      }
    )
  })
);
var Badge_default = SvgBadge;

// src/Icon/icons/Ban.tsx
import { jsx as jsx176 } from "react/jsx-runtime";
var SvgBan = (props) => /* @__PURE__ */ jsx176(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx176(
      "path",
      {
        d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM5.63 6.957A8.08 8.08 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125c1.906 0 3.66-.656 5.043-1.754L5.63 6.957ZM20.125 12A8.124 8.124 0 0 0 12 3.875 8.08 8.08 0 0 0 6.957 5.63l11.414 11.413A8.086 8.086 0 0 0 20.125 12Z",
        fill: "currentColor"
      }
    )
  })
);
var Ban_default = SvgBan;

// src/Icon/icons/Bandage.tsx
import { jsx as jsx177 } from "react/jsx-runtime";
var SvgBandage = (props) => /* @__PURE__ */ jsx177(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx177(
      "path",
      {
        d: "M19.5 7A2.5 2.5 0 0 1 22 9.5v5a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 14.5v-5A2.5 2.5 0 0 1 4.5 7h15ZM16 15.5h3.5c.553 0 1-.447 1-1v-5c0-.553-.447-1-1-1H16v7Zm-8-7H4.5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1H8v-7Zm2.5 2.75c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75c0 .416.334.75.75.75Zm3-1.5a.748.748 0 0 0-.75.75c0 .416.334.75.75.75s.75-.334.75-.75a.748.748 0 0 0-.75-.75Zm-3 4.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75c0 .416.334.75.75.75Zm3-1.5a.748.748 0 0 0-.75.75c0 .416.334.75.75.75s.75-.334.75-.75a.748.748 0 0 0-.75-.75Z",
        fill: "currentColor"
      }
    )
  })
);
var Bandage_default = SvgBandage;

// src/Icon/icons/BarcodeRead.tsx
import { jsx as jsx178 } from "react/jsx-runtime";
var SvgBarcodeRead = (props) => /* @__PURE__ */ jsx178(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx178(
      "path",
      {
        d: "M3.944 4.762c-.153 0-.277.156-.277.278v2.778a.813.813 0 0 1-.834.833A.813.813 0 0 1 2 7.818V5.04c0-1.043.87-1.913 1.944-1.913h2.778c.462 0 .834.373.834.802a.813.813 0 0 1-.834.833H3.944ZM7 8.373v7.223a.812.812 0 0 1-.833.833.812.812 0 0 1-.834-.833V8.372c0-.43.372-.833.834-.833.461 0 .833.403.833.833Zm1.111-.277c0-.275.25-.556.556-.556.305 0 .555.281.555.556v7.777c0 .337-.25.556-.555.556a.538.538 0 0 1-.556-.556V8.096Zm9.445 0c0-.275.25-.556.555-.556.306 0 .556.281.556.556v7.777c0 .337-.25.556-.556.556a.538.538 0 0 1-.555-.556V8.096Zm-7.223.277c0-.43.372-.833.834-.833.462 0 .833.403.833.833v7.223a.812.812 0 0 1-.833.833.812.812 0 0 1-.834-.833V8.372Zm6.111 0v7.223a.812.812 0 0 1-.833.833.812.812 0 0 1-.833-.833V8.372c0-.43.371-.833.833-.833.462 0 .833.403.833.833Zm3.89-3.333c0-.122-.126-.278-.278-.278h-2.778a.813.813 0 0 1-.834-.833c0-.43.372-.802.834-.802h2.778c1.072 0 1.944.87 1.944 1.913v2.778a.812.812 0 0 1-.833.833.812.812 0 0 1-.834-.833V5.04ZM6.721 19.207c.462 0 .834.402.834.833a.812.812 0 0 1-.834.833H3.944A1.925 1.925 0 0 1 2 18.93V16.15c0-.43.373-.833.833-.833.46 0 .834.402.834.833v2.778c0 .184.124.278.277.278h2.778Zm13.611-3.056c0-.43.372-.833.834-.833.461 0 .833.402.833.833v2.778a1.926 1.926 0 0 1-1.944 1.944h-2.778a.812.812 0 0 1-.834-.833c0-.43.372-.833.834-.833h2.778c.152 0 .277-.094.277-.278V16.15Z",
        fill: "currentColor"
      }
    )
  })
);
var BarcodeRead_default = SvgBarcodeRead;

// src/Icon/icons/BarcodeScan.tsx
import { jsx as jsx179 } from "react/jsx-runtime";
var SvgBarcodeScan = (props) => /* @__PURE__ */ jsx179(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx179(
      "path",
      {
        d: "M5.5 5.75V10H4V5.75c0-.386.336-.75.75-.75.416 0 .75.364.75.75ZM4 18.25V14h1.5v4.25a.73.73 0 0 1-.75.75.732.732 0 0 1-.75-.75Zm3 .25V14h1v4.5c0 .303-.225.5-.5.5a.484.484 0 0 1-.5-.5Zm2-.25V14h1.5v4.25c0 .444-.334.75-.75.75a.73.73 0 0 1-.75-.75ZM9.75 5c.416 0 .75.364.75.75V10H9V5.75c0-.386.334-.75.75-.75Zm2.75 13.25V14H14v4.25c0 .444-.334.75-.75.75a.731.731 0 0 1-.75-.75ZM13.25 5c.416 0 .75.364.75.75V10h-1.5V5.75c0-.386.334-.75.75-.75Zm3.25 13.5V14h1v4.5c0 .303-.225.5-.5.5a.484.484 0 0 1-.5-.5ZM17 5c.275 0 .5.252.5.5V10h-1V5.5c0-.248.225-.5.5-.5Zm1.5 13.25V14H20v4.25c0 .444-.334.75-.75.75a.731.731 0 0 1-.75-.75ZM19.25 5c.416 0 .75.364.75.75V10h-1.5V5.75c0-.386.334-.75.75-.75ZM7 5.5c0-.248.225-.5.5-.5s.5.252.5.5V10H7V5.5Zm-4.25 5.75h18.5c.416 0 .75.363.75.75 0 .444-.334.75-.75.75H2.75A.732.732 0 0 1 2 12c0-.387.336-.75.75-.75Z",
        fill: "currentColor"
      }
    )
  })
);
var BarcodeScan_default = SvgBarcodeScan;

// src/Icon/icons/Barcode.tsx
import { jsx as jsx180 } from "react/jsx-runtime";
var SvgBarcode = (props) => /* @__PURE__ */ jsx180(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx180(
      "path",
      {
        d: "M3.875 4.188v15.625c0 .554-.42.937-.938.937A.915.915 0 0 1 2 19.812V4.188c0-.482.42-.937.938-.937.517 0 .937.455.937.938ZM7 3.874v16.25a.605.605 0 0 1-.625.625.605.605 0 0 1-.625-.625V3.875c0-.31.281-.625.625-.625S7 3.565 7 3.875Zm3.125.313v15.625a.914.914 0 0 1-.938.937.914.914 0 0 1-.937-.938V4.188c0-.482.418-.937.938-.937.519 0 .937.455.937.938Zm4.375 0v15.625a.914.914 0 0 1-.938.937.914.914 0 0 1-.937-.938V4.188c0-.482.418-.937.938-.937.519 0 .937.455.937.938Zm5.625 0c0-.483.418-.938.938-.938.519 0 .937.455.937.938v15.625a.914.914 0 0 1-.938.937.914.914 0 0 1-.937-.938V4.188Zm-2.5-.313c0-.31.281-.625.625-.625s.625.315.625.625v16.25a.605.605 0 0 1-.625.625.605.605 0 0 1-.625-.625V3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var Barcode_default = SvgBarcode;

// src/Icon/icons/BarsFilter.tsx
import { jsx as jsx181 } from "react/jsx-runtime";
var SvgBarsFilter = (props) => /* @__PURE__ */ jsx181(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx181(
      "path",
      {
        d: "M2 4.857c0-.591.48-1.071 1.071-1.071H20.93c.593 0 1.071.48 1.071 1.071 0 .594-.478 1.072-1.071 1.072H3.07A1.07 1.07 0 0 1 2 4.857ZM4.857 12c0-.594.48-1.071 1.072-1.071H18.07c.594 0 1.072.477 1.072 1.071s-.478 1.071-1.072 1.071H5.93A1.07 1.07 0 0 1 4.857 12Zm8.929 8.214h-3.572a1.069 1.069 0 0 1-1.071-1.071c0-.594.478-1.072 1.071-1.072h3.572c.594 0 1.071.478 1.071 1.072 0 .594-.477 1.071-1.071 1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var BarsFilter_default = SvgBarsFilter;

// src/Icon/icons/BarsProgress.tsx
import { jsx as jsx182 } from "react/jsx-runtime";
var SvgBarsProgress = (props) => /* @__PURE__ */ jsx182(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx182(
      "path",
      {
        d: "M20.125 4.5C21.16 4.5 22 5.34 22 6.375v2.5c0 1.035-.84 1.875-1.875 1.875H3.875A1.875 1.875 0 0 1 2 8.875v-2.5C2 5.339 2.84 4.5 3.875 4.5h16.25Zm0 1.875H14.5v2.5h5.625v-2.5Zm0 6.875c1.035 0 1.875.84 1.875 1.875v2.5c0 1.035-.84 1.875-1.875 1.875H3.875A1.875 1.875 0 0 1 2 17.625v-2.5c0-1.035.84-1.875 1.875-1.875h16.25Zm0 1.875H9.5v2.5h10.625v-2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var BarsProgress_default = SvgBarsProgress;

// src/Icon/icons/BarsSort.tsx
import { jsx as jsx183 } from "react/jsx-runtime";
var SvgBarsSort = (props) => /* @__PURE__ */ jsx183(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx183(
      "path",
      {
        d: "M2 4.857c0-.591.48-1.071 1.071-1.071H20.93c.593 0 1.071.48 1.071 1.071 0 .594-.478 1.072-1.071 1.072H3.07A1.07 1.07 0 0 1 2 4.857ZM2 12c0-.594.48-1.071 1.071-1.071h12.143c.594 0 1.072.477 1.072 1.071s-.478 1.071-1.072 1.071H3.071A1.07 1.07 0 0 1 2 12Zm7.5 8.214H3.071a1.07 1.07 0 1 1 0-2.143H9.5c.594 0 1.071.478 1.071 1.072 0 .594-.477 1.071-1.071 1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var BarsSort_default = SvgBarsSort;

// src/Icon/icons/BarsStaggered.tsx
import { jsx as jsx184 } from "react/jsx-runtime";
var SvgBarsStaggered = (props) => /* @__PURE__ */ jsx184(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx184(
      "path",
      {
        d: "M2 5.75c0-.518.42-.938.938-.938h15.624a.937.937 0 1 1 0 1.875H2.938A.936.936 0 0 1 2 5.75ZM4.5 12c0-.52.42-.938.938-.938h15.625c.519 0 .937.418.937.938s-.418.938-.938.938H5.438A.937.937 0 0 1 4.5 12Zm14.063 7.188H2.938a.937.937 0 1 1 0-1.875h15.624c.52 0 .938.418.938.937 0 .52-.418.938-.938.938Z",
        fill: "currentColor"
      }
    )
  })
);
var BarsStaggered_default = SvgBarsStaggered;

// src/Icon/icons/Bars.tsx
import { jsx as jsx185 } from "react/jsx-runtime";
var SvgBars = (props) => /* @__PURE__ */ jsx185(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx185(
      "path",
      {
        d: "M2 4.857c0-.591.48-1.071 1.071-1.071H20.93c.593 0 1.071.48 1.071 1.071 0 .594-.478 1.072-1.071 1.072H3.07A1.07 1.07 0 0 1 2 4.857ZM2 12c0-.594.48-1.071 1.071-1.071H20.93c.593 0 1.071.477 1.071 1.071s-.478 1.071-1.071 1.071H3.07A1.07 1.07 0 0 1 2 12Zm18.929 8.214H3.07a1.07 1.07 0 1 1 0-2.143H20.93c.593 0 1.071.478 1.071 1.072 0 .594-.478 1.071-1.071 1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var Bars_default = SvgBars;

// src/Icon/icons/Baseball.tsx
import { jsx as jsx186 } from "react/jsx-runtime";
var SvgBaseball = (props) => /* @__PURE__ */ jsx186(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx186(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm1.57 17.969c.01-.409.019-.36.019-.453 0-.355-.276-.934-.935-.934a.943.943 0 0 0-.936.859 8.173 8.173 0 0 0-.028.667 8.12 8.12 0 0 1-7.797-7.797h.165c.528 0 1.438-.045 1.438-.967 0-.797-.766-.938-.938-.938-.087 0-.108.011-.28.011l-.244-.002a8.144 8.144 0 0 1 6.398-6.386c-.01.437-.02.392-.02.49 0 .362.283.937.938.937.482 0 .891-.37.933-.859.02-.235.03-.47.03-.707a8.123 8.123 0 0 1 7.796 7.817h-.297c-.165 0-.332.005-.498.021a.936.936 0 0 0-.846.93c0 .355.271.942.918.942.099 0 .118-.015.33-.015l.25.001a8.14 8.14 0 0 1-6.396 6.383ZM11.617 7.035c0-.256-.203-.937-.935-.937-.353 0-.694.2-.853.543-1.49 3.214-3.703 2.744-3.703 4.024 0 .73.669.937.939.937 1.251 0 4.552-3.211 4.552-4.567Zm5.285 5.38c-1.26 0-4.535 3.23-4.535 4.589 0 .257.205.937.938.937a.935.935 0 0 0 .852-.548c1.474-3.225 3.681-2.76 3.681-4.039.002-.733-.666-.94-.936-.94Z",
        fill: "currentColor"
      }
    )
  })
);
var Baseball_default = SvgBaseball;

// src/Icon/icons/BasketShoppingSimple.tsx
import { jsx as jsx187 } from "react/jsx-runtime";
var SvgBasketShoppingSimple = (props) => /* @__PURE__ */ jsx187(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx187(
      "path",
      {
        d: "M8.667 13.389a.831.831 0 0 1-.834.833A.831.831 0 0 1 7 13.39c0-.462.372-.833.833-.833.462 0 .834.371.834.833Zm6.666 0c0-.462.372-.833.834-.833.461 0 .833.371.833.833a.831.831 0 0 1-.833.833.831.831 0 0 1-.834-.833ZM10.441 3.205a.836.836 0 0 1 .354 1.124L7.962 9.778h8.076l-2.833-5.449a.834.834 0 0 1 1.48-.77l3.232 6.219h3.25c.461 0 .833.371.833.833a.831.831 0 0 1-.833.833h-.695l-1.94 7.76c-.279.99-1.136 1.685-2.157 1.685H7.594c-.99 0-1.879-.694-2.126-1.684l-1.94-7.76h-.695a.832.832 0 1 1 0-1.667h3.25L9.316 3.56a.834.834 0 0 1 1.125-.355Zm8.312 8.24H5.246l1.837 7.357a.55.55 0 0 0 .51.42h8.782c.257 0 .48-.173.542-.42l1.836-7.357Z",
        fill: "currentColor"
      }
    )
  })
);
var BasketShoppingSimple_default = SvgBasketShoppingSimple;

// src/Icon/icons/BasketShopping.tsx
import { jsx as jsx188 } from "react/jsx-runtime";
var SvgBasketShopping = (props) => /* @__PURE__ */ jsx188(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx188(
      "path",
      {
        d: "M9.778 16.722a.831.831 0 0 1-.834.834.831.831 0 0 1-.833-.834v-2.778c0-.461.372-.833.833-.833.462 0 .834.372.834.833v2.778ZM12 13.112c.462 0 .833.37.833.832v2.778a.831.831 0 0 1-.833.834.831.831 0 0 1-.833-.834v-2.778c0-.461.371-.833.833-.833Zm3.889 3.61a.831.831 0 0 1-.833.834.831.831 0 0 1-.834-.834v-2.778c0-.461.372-.833.834-.833.461 0 .833.372.833.833v2.778ZM10.44 3.205a.835.835 0 0 1 .354 1.124L7.962 9.778h8.076l-2.833-5.45a.834.834 0 0 1 1.48-.769l3.232 6.219h3.25c.461 0 .833.371.833.833a.831.831 0 0 1-.833.833h-.695l-1.94 7.76c-.279.99-1.136 1.685-2.157 1.685H7.594c-.99 0-1.879-.694-2.126-1.684l-1.94-7.76h-.695a.832.832 0 1 1 0-1.667h3.25L9.316 3.56a.834.834 0 0 1 1.125-.355ZM7.083 18.802a.55.55 0 0 0 .51.42h8.782c.257 0 .48-.173.542-.42l1.836-7.357H5.246l1.837 7.357Z",
        fill: "currentColor"
      }
    )
  })
);
var BasketShopping_default = SvgBasketShopping;

// src/Icon/icons/BatteryBolt.tsx
import { jsx as jsx189 } from "react/jsx-runtime";
var SvgBatteryBolt = (props) => /* @__PURE__ */ jsx189(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx189(
      "path",
      {
        d: "M14.778 8.111c-.032-.597-.278-1.18-.778-1.555a1.476 1.476 0 0 0-.167-.112h4.278a2.777 2.777 0 0 1 2.778 2.778v.556A1.11 1.11 0 0 1 22 10.888v2.223a1.11 1.11 0 0 1-1.111 1.111v.556a2.777 2.777 0 0 1-2.778 2.778h-7.607a2.07 2.07 0 0 0 .232-.167l1.823-1.5h5.552a1.11 1.11 0 0 0 1.111-1.111V9.222a1.11 1.11 0 0 0-1.11-1.11h-3.334ZM2 14.778V9.222a2.777 2.777 0 0 1 2.778-2.778h7.052c-.08.05-.156.073-.233.167l-1.823 1.5H4.778a1.11 1.11 0 0 0-1.111 1.111v5.556a1.11 1.11 0 0 0 1.11 1.11h2.747c.032.598.278 1.15.81 1.556.051.01.107.077.166.112H4.778A2.777 2.777 0 0 1 2 14.778Zm11.167-7.111a.556.556 0 0 1 .177.663l-1.334 3.114h2.212c.236 0 .445.146.524.368a.578.578 0 0 1-.17.619l-4.722 3.888a.555.555 0 0 1-.865-.65l1.334-3.145H8.11c-.236 0-.444-.114-.524-.336a.563.563 0 0 1 .17-.619l4.722-3.888c.198-.191.483-.167.688-.014Z",
        fill: "currentColor"
      }
    )
  })
);
var BatteryBolt_default = SvgBatteryBolt;

// src/Icon/icons/BatteryEmpty.tsx
import { jsx as jsx190 } from "react/jsx-runtime";
var SvgBatteryEmpty = (props) => /* @__PURE__ */ jsx190(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx190(
      "path",
      {
        d: "M18.111 6.444a2.777 2.777 0 0 1 2.778 2.778v.556A1.11 1.11 0 0 1 22 10.888v2.223a1.11 1.11 0 0 1-1.111 1.111v.556a2.777 2.777 0 0 1-2.778 2.778H4.778A2.777 2.777 0 0 1 2 14.778V9.222a2.777 2.777 0 0 1 2.778-2.778H18.11ZM3.667 14.778a1.11 1.11 0 0 0 1.11 1.11h13.334a1.11 1.11 0 0 0 1.111-1.11V9.222a1.11 1.11 0 0 0-1.11-1.11H4.777a1.11 1.11 0 0 0-1.111 1.11v5.556Z",
        fill: "currentColor"
      }
    )
  })
);
var BatteryEmpty_default = SvgBatteryEmpty;

// src/Icon/icons/BatteryExclamation.tsx
import { jsx as jsx191 } from "react/jsx-runtime";
var SvgBatteryExclamation = (props) => /* @__PURE__ */ jsx191(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx191(
      "path",
      {
        d: "M4.778 6.444h4.444v1.667H4.778a1.11 1.11 0 0 0-1.111 1.111v5.556a1.11 1.11 0 0 0 1.11 1.11h3.945a2.756 2.756 0 0 0 .177 1.667H4.778A2.777 2.777 0 0 1 2 14.779V9.222a2.777 2.777 0 0 1 2.778-2.778Zm9.444 10c0-.19-.02-.375-.055-.555h3.944a1.11 1.11 0 0 0 1.111-1.111V9.222a1.11 1.11 0 0 0-1.11-1.11h-4.445V6.443h4.444a2.777 2.777 0 0 1 2.778 2.778v.556A1.11 1.11 0 0 1 22 10.888v2.223a1.11 1.11 0 0 1-1.111 1.111v.556a2.777 2.777 0 0 1-2.778 2.778H13.99c.149-.34.232-.716.232-1.112Zm-1.666 0a1.11 1.11 0 1 1-2.223 0 1.11 1.11 0 1 1 2.223 0Zm-.278-3.055a.831.831 0 0 1-.834.833.831.831 0 0 1-.833-.833V7.278c0-.462.372-.834.833-.834.462 0 .834.372.834.834v6.11Z",
        fill: "currentColor"
      }
    )
  })
);
var BatteryExclamation_default = SvgBatteryExclamation;

// src/Icon/icons/BatteryFull.tsx
import { jsx as jsx192 } from "react/jsx-runtime";
var SvgBatteryFull = (props) => /* @__PURE__ */ jsx192(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx192(
      "path",
      {
        d: "M17.556 14.222H5.333V9.778h12.223v4.444ZM2 9.222a2.777 2.777 0 0 1 2.778-2.778H18.11a2.777 2.777 0 0 1 2.778 2.778v.556A1.11 1.11 0 0 1 22 10.888v2.223a1.11 1.11 0 0 1-1.111 1.111v.556a2.777 2.777 0 0 1-2.778 2.778H4.778A2.777 2.777 0 0 1 2 14.778V9.222Zm2.778-1.11a1.11 1.11 0 0 0-1.111 1.11v5.556a1.11 1.11 0 0 0 1.11 1.11h13.334a1.11 1.11 0 0 0 1.111-1.11V9.222a1.11 1.11 0 0 0-1.11-1.11H4.777Z",
        fill: "currentColor"
      }
    )
  })
);
var BatteryFull_default = SvgBatteryFull;

// src/Icon/icons/BatteryHalf.tsx
import { jsx as jsx193 } from "react/jsx-runtime";
var SvgBatteryHalf = (props) => /* @__PURE__ */ jsx193(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx193(
      "path",
      {
        d: "M12 14.222H5.333V9.778H12v4.444Zm-10-5a2.777 2.777 0 0 1 2.778-2.778H18.11a2.777 2.777 0 0 1 2.778 2.778v.556A1.11 1.11 0 0 1 22 10.888v2.223a1.11 1.11 0 0 1-1.111 1.111v.556a2.777 2.777 0 0 1-2.778 2.778H4.778A2.777 2.777 0 0 1 2 14.778V9.222Zm2.778-1.11a1.11 1.11 0 0 0-1.111 1.11v5.556a1.11 1.11 0 0 0 1.11 1.11h13.334a1.11 1.11 0 0 0 1.111-1.11V9.222a1.11 1.11 0 0 0-1.11-1.11H4.777Z",
        fill: "currentColor"
      }
    )
  })
);
var BatteryHalf_default = SvgBatteryHalf;

// src/Icon/icons/BatteryLow.tsx
import { jsx as jsx194 } from "react/jsx-runtime";
var SvgBatteryLow = (props) => /* @__PURE__ */ jsx194(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx194(
      "path",
      {
        d: "M7.556 14.222H5.333V9.778h2.223v4.444ZM2 9.222a2.777 2.777 0 0 1 2.778-2.778H18.11a2.777 2.777 0 0 1 2.778 2.778v.556A1.11 1.11 0 0 1 22 10.888v2.223a1.11 1.11 0 0 1-1.111 1.111v.556a2.777 2.777 0 0 1-2.778 2.778H4.778A2.777 2.777 0 0 1 2 14.778V9.222Zm2.778-1.11a1.11 1.11 0 0 0-1.111 1.11v5.556a1.11 1.11 0 0 0 1.11 1.11h13.334a1.11 1.11 0 0 0 1.111-1.11V9.222a1.11 1.11 0 0 0-1.11-1.11H4.777Z",
        fill: "currentColor"
      }
    )
  })
);
var BatteryLow_default = SvgBatteryLow;

// src/Icon/icons/BatteryQuarter.tsx
import { jsx as jsx195 } from "react/jsx-runtime";
var SvgBatteryQuarter = (props) => /* @__PURE__ */ jsx195(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx195(
      "path",
      {
        d: "M8.667 14.222H5.333V9.778h3.334v4.444ZM2 9.222a2.777 2.777 0 0 1 2.778-2.778H18.11a2.777 2.777 0 0 1 2.778 2.778v.556A1.11 1.11 0 0 1 22 10.888v2.223a1.11 1.11 0 0 1-1.111 1.111v.556a2.777 2.777 0 0 1-2.778 2.778H4.778A2.777 2.777 0 0 1 2 14.778V9.222Zm2.778-1.11a1.11 1.11 0 0 0-1.111 1.11v5.556a1.11 1.11 0 0 0 1.11 1.11h13.334a1.11 1.11 0 0 0 1.111-1.11V9.222a1.11 1.11 0 0 0-1.11-1.11H4.777Z",
        fill: "currentColor"
      }
    )
  })
);
var BatteryQuarter_default = SvgBatteryQuarter;

// src/Icon/icons/BatterySlash.tsx
import { jsx as jsx196 } from "react/jsx-runtime";
var SvgBatterySlash = (props) => /* @__PURE__ */ jsx196(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx196(
      "path",
      {
        d: "M6.837 7H17.5A2.5 2.5 0 0 1 20 9.5v.5c.553 0 1 .447 1 1v2c0 .553-.447 1-1 1v.5c0 .828-.403 1.534-1.022 2.015l2.734 2.144a.75.75 0 0 1-.925 1.181l-18.5-14.5a.75.75 0 1 1 .926-1.18L6.837 7ZM8.75 8.5l8.916 6.987c.471-.078.834-.49.834-.987v-5c0-.553-.447-1-1-1H8.75Zm4.037 7 1.907 1.5H5.5A2.5 2.5 0 0 1 3 14.5v-5c0-.513.154-.988.417-1.384l1.188.937A.914.914 0 0 0 4.5 9.5v5a1 1 0 0 0 1 1h7.287Z",
        fill: "currentColor"
      }
    )
  })
);
var BatterySlash_default = SvgBatterySlash;

// src/Icon/icons/BatteryThreeQuarters.tsx
import { jsx as jsx197 } from "react/jsx-runtime";
var SvgBatteryThreeQuarters = (props) => /* @__PURE__ */ jsx197(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx197(
      "path",
      {
        d: "M14.222 14.222H5.333V9.778h8.89v4.444ZM2 9.222a2.777 2.777 0 0 1 2.778-2.778H18.11a2.777 2.777 0 0 1 2.778 2.778v.556A1.11 1.11 0 0 1 22 10.888v2.223a1.11 1.11 0 0 1-1.111 1.111v.556a2.777 2.777 0 0 1-2.778 2.778H4.778A2.777 2.777 0 0 1 2 14.778V9.222Zm2.778-1.11a1.11 1.11 0 0 0-1.111 1.11v5.556a1.11 1.11 0 0 0 1.11 1.11h13.334a1.11 1.11 0 0 0 1.111-1.11V9.222a1.11 1.11 0 0 0-1.11-1.11H4.777Z",
        fill: "currentColor"
      }
    )
  })
);
var BatteryThreeQuarters_default = SvgBatteryThreeQuarters;

// src/Icon/icons/Bee.tsx
import { jsx as jsx198 } from "react/jsx-runtime";
var SvgBee = (props) => /* @__PURE__ */ jsx198(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx198(
      "path",
      {
        d: "M17.556 6.429c-.963 0-1.922.328-2.804.789.008-.05.026-.123.026-.234 0-.708-.272-1.349-.709-1.84l1.101-1.1a.555.555 0 1 0-.785-.786L13.17 4.473c-.357-.135-.75-.267-1.17-.267-.42 0-.813.132-1.17.298L9.615 3.29a.555.555 0 1 0-.786.786l1.102 1.1a2.737 2.737 0 0 0-.709 1.81c0 .08.017.153.024.233-.881-.432-1.84-.79-2.802-.79C3.991 6.429 2 8.2 2 10.319c0 2.177 1.989 3.92 4.413 3.92.268 0 .51-.028.75-.063.48 3.455 4.837 6.73 4.837 6.73s4.358-3.277 4.837-6.73c.24.035.479.063.719.063 2.453 0 4.444-1.741 4.444-3.858 0-2.177-1.99-3.92-4.444-3.951Zm-8.764 7.253h6.416a3.563 3.563 0 0 1-.248 1.111H9.038a3.568 3.568 0 0 1-.246-1.111Zm.402-1.667c.145-.26.312-.507.528-.723a3.202 3.202 0 0 1 2.274-.943c.858 0 1.673.335 2.282.943.218.216.385.463.528.723H9.194Zm-1.944.438a3.31 3.31 0 0 1-.837.118c-1.5 0-2.746-.997-2.746-2.254 0-1.194 1.245-2.19 2.746-2.19 1.013 0 2.125.56 3.093 1.244a4.925 4.925 0 0 0-2.256 3.082ZM12 18.72c-.646-.597-1.41-1.396-2.031-2.26h4.059c-.618.864-1.382 1.663-2.028 2.26Zm5.556-6.15c-.264 0-.535-.046-.807-.116a4.87 4.87 0 0 0-2.284-3.083c.969-.682 2.077-1.245 3.09-1.245 1.531 0 2.778.997 2.778 2.224 0 1.224-1.246 2.22-2.777 2.22Z",
        fill: "currentColor"
      }
    )
  })
);
var Bee_default = SvgBee;

// src/Icon/icons/BellConcierge.tsx
import { jsx as jsx199 } from "react/jsx-runtime";
var SvgBellConcierge = (props) => /* @__PURE__ */ jsx199(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx199(
      "path",
      {
        d: "M21.094 17.634H2.94c-.518 0-.939.419-.939.904 0 .556.42.974.904.974h18.155c.518 0 .939-.42.939-.903a.897.897 0 0 0-.904-.975ZM5.13 15.756c0-3.795 3.091-6.886 6.887-6.886 3.795 0 6.886 3.09 6.886 6.886v.626h1.878v-.626c0-4.417-3.267-8.056-7.512-8.666v-.724h.939a.94.94 0 0 0 .939-.94c0-.518-.419-.938-.975-.938H9.79c-.485 0-.904.42-.904.939 0 .518.421.939.94.939h.938v.724c-4.245.61-7.512 4.249-7.512 8.666v.626H5.13v-.626Z",
        fill: "currentColor"
      }
    )
  })
);
var BellConcierge_default = SvgBellConcierge;

// src/Icon/icons/BellExclamation.tsx
import { jsx as jsx200 } from "react/jsx-runtime";
var SvgBellExclamation = (props) => /* @__PURE__ */ jsx200(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx200(
      "path",
      {
        d: "M13.25 14.5c0 .691-.558 1.25-1.25 1.25-.691 0-1.25-.559-1.25-1.25s.559-1.25 1.25-1.25c.692 0 1.25.559 1.25 1.25Zm-.312-3.438c0 .52-.418.938-.938.938a.935.935 0 0 1-.937-.938V7.938c0-.52.418-.938.937-.938.52 0 .938.418.938.938v3.125Zm.312-7.812v.698a5.94 5.94 0 0 1 5 5.865v1.304c0 1.774.606 3.496 1.711 4.883l.582.727a.935.935 0 0 1-.73 1.523H4.188a.938.938 0 0 1-.732-1.523L4.038 16a7.823 7.823 0 0 0 1.712-4.883V9.812a5.94 5.94 0 0 1 5-5.864V3.25a1.25 1.25 0 1 1 2.5 0Zm-1.562 2.5a4.064 4.064 0 0 0-4.063 4.063v1.304a9.698 9.698 0 0 1-1.55 5.258h11.851a9.701 9.701 0 0 1-1.55-5.258V9.812a4.064 4.064 0 0 0-4.063-4.062h-.625ZM14.5 19.5c0 .629-.261 1.3-.73 1.77-.469.468-1.14.73-1.77.73a2.5 2.5 0 0 1-1.77-.73 2.563 2.563 0 0 1-.73-1.77h5Z",
        fill: "currentColor"
      }
    )
  })
);
var BellExclamation_default = SvgBellExclamation;

// src/Icon/icons/BellOn.tsx
import { jsx as jsx201 } from "react/jsx-runtime";
var SvgBellOn = (props) => /* @__PURE__ */ jsx201(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx201(
      "path",
      {
        d: "M13 5v.559c2.266.36 4 2.322 4 4.691v1.044c0 1.418.484 2.797 1.369 3.906l.465.581A.748.748 0 0 1 18.25 17H5.75a.748.748 0 0 1-.584-1.219l.465-.581A6.271 6.271 0 0 0 7 11.294V10.25a4.752 4.752 0 0 1 4-4.691V5a1 1 0 1 1 2 0Zm-1.25 2a3.252 3.252 0 0 0-3.25 3.25v1.044A7.761 7.761 0 0 1 7.26 15.5h9.48a7.762 7.762 0 0 1-1.24-4.206V10.25A3.252 3.252 0 0 0 12.25 7h-.5ZM14 18c0 .503-.21 1.04-.584 1.416A2.05 2.05 0 0 1 12 20a2 2 0 0 1-1.416-.584A2.05 2.05 0 0 1 10 18h4ZM2 10.25a.75.75 0 0 1 .75-.75h2.5c.416 0 .75.334.75.75s-.334.75-.75.75h-2.5a.75.75 0 0 1-.75-.75Zm19.25-.75c.416 0 .75.334.75.75s-.334.75-.75.75h-2.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h2.5Zm-.578-4.835a.75.75 0 0 1-.338 1.006l-2 1a.75.75 0 1 1-.669-1.342l2-1a.751.751 0 0 1 1.007.336ZM3.665 5.67a.75.75 0 0 1 .67-1.342l2 1a.75.75 0 1 1-.67 1.342l-2-1Z",
        fill: "currentColor"
      }
    )
  })
);
var BellOn_default = SvgBellOn;

// src/Icon/icons/BellPlus.tsx
import { jsx as jsx202 } from "react/jsx-runtime";
var SvgBellPlus = (props) => /* @__PURE__ */ jsx202(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx202(
      "path",
      {
        d: "M12 7.938c.52 0 .938.417.938.937v1.563H14.5c.52 0 .938.417.938.937s-.418.938-.938.938h-1.562v1.562c0 .52-.418.938-.938.938a.935.935 0 0 1-.937-.938v-1.563H9.5a.935.935 0 0 1-.937-.937c0-.52.418-.938.937-.938h1.563V8.876c0-.52.418-.938.937-.938Zm1.25-4.688v.698a5.94 5.94 0 0 1 5 5.865v1.304c0 1.774.606 3.496 1.711 4.883l.582.727a.935.935 0 0 1-.73 1.523H4.188a.938.938 0 0 1-.732-1.523L4.038 16a7.823 7.823 0 0 0 1.712-4.883V9.812a5.94 5.94 0 0 1 5-5.864V3.25a1.25 1.25 0 1 1 2.5 0Zm-1.562 2.5a4.064 4.064 0 0 0-4.063 4.063v1.304a9.698 9.698 0 0 1-1.55 5.258h11.851a9.701 9.701 0 0 1-1.55-5.258V9.812a4.064 4.064 0 0 0-4.063-4.062h-.625ZM14.5 19.5c0 .629-.261 1.3-.73 1.77-.469.468-1.14.73-1.77.73a2.5 2.5 0 0 1-1.77-.73 2.563 2.563 0 0 1-.73-1.77h5Z",
        fill: "currentColor"
      }
    )
  })
);
var BellPlus_default = SvgBellPlus;

// src/Icon/icons/BellSchoolSlash.tsx
import { jsx as jsx203 } from "react/jsx-runtime";
var SvgBellSchoolSlash = (props) => /* @__PURE__ */ jsx203(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx203(
      "path",
      {
        d: "M5.703 6.112A6.47 6.47 0 0 1 10.472 4C14.09 4 17 6.91 17 10.5a6.47 6.47 0 0 1-1.094 3.61l1.61 1.259A1.5 1.5 0 0 1 20 16.5c0 .247-.06.481-.166.66l1.878 1.5a.75.75 0 0 1-.925 1.18l-18.5-14.5a.75.75 0 1 1 .926-1.18l2.49 1.952Zm1.188.93 1.584 1.242a2.974 2.974 0 0 1 1.997-.784c1.684 0 3.028 1.316 3.028 3 0 .522-.131 1.01-.366 1.41l1.588 1.271a5.066 5.066 0 0 0 .778-2.71c0-2.734-2.238-5-5.028-5-1.39 0-2.672.62-3.581 1.57Zm5.028 3.942c.053-.153.053-.315.053-.484A1.476 1.476 0 0 0 9.69 9.238l2.228 1.746Zm3.08 6.26V18c0 .172-.021.34-.09.5h1.688l1.525 1.2c-.331.19-.713.3-1.122.3H7.972c-1.075 0-2-.897-2-2v-2.81c-1.205-1.184-2-2.874-2-4.69 0-.603.11-1.184.263-1.738L5.55 9.797c-.034.228-.078.465-.078.675 0 2.79 2.265 5.028 5 5.028.678 0 1.3-.125 1.844-.35L15 17.244ZM13 18.5c.276 0 .5-.225.5-.5v-1.731a6.528 6.528 0 0 1-3.027.73 6.675 6.675 0 0 1-3-.73v1.73c0 .276.253.5.5.5H13Z",
        fill: "currentColor"
      }
    )
  })
);
var BellSchoolSlash_default = SvgBellSchoolSlash;

// src/Icon/icons/BellSchool.tsx
import { jsx as jsx204 } from "react/jsx-runtime";
var SvgBellSchool = (props) => /* @__PURE__ */ jsx204(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx204(
      "path",
      {
        d: "M6.375 10.125c0-2.105 1.645-3.75 3.75-3.75 2.07 0 3.75 1.645 3.75 3.75 0 2.07-1.68 3.75-3.75 3.75a3.729 3.729 0 0 1-3.75-3.75ZM10.125 12a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Zm5.625 7.5c0 .215-.027.426-.113.625h2.613c.496 0 .906-.387.902-.879a1.913 1.913 0 0 1-.902-1.621 1.875 1.875 0 0 1 3.75 0c0 .695-.379 1.3-.973 1.625 0 1.523-1.246 2.75-2.777 2.75H7c-1.38 0-2.5-1.121-2.5-2.5v-3.512A8.164 8.164 0 0 1 2 10.125 8.125 8.125 0 0 1 10.125 2a8.124 8.124 0 0 1 8.125 8.125c0 2.27-.96 4.383-2.5 5.863V19.5Zm-5.625-3.125a6.248 6.248 0 0 0 6.25-6.25 6.248 6.248 0 0 0-6.25-6.25 6.248 6.248 0 0 0-6.25 6.25 6.248 6.248 0 0 0 6.25 6.25Zm3.75 3.125v-2.164a8.122 8.122 0 0 1-3.75.914 8.122 8.122 0 0 1-3.75-.914V19.5c0 .344.281.625.625.625h6.25a.627.627 0 0 0 .625-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var BellSchool_default = SvgBellSchool;

// src/Icon/icons/BellSlash.tsx
import { jsx as jsx205 } from "react/jsx-runtime";
var SvgBellSlash = (props) => /* @__PURE__ */ jsx205(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx205(
      "path",
      {
        d: "M7.737 7.706A4.752 4.752 0 0 1 11 5.56V5a1 1 0 1 1 2 0v.559c2.265.36 4 2.322 4 4.69v1.045a6.27 6.27 0 0 0 1.369 3.906l.465.581c.138.203.21.475.122.719l2.756 2.16a.75.75 0 0 1-.925 1.18l-18.5-14.5a.75.75 0 1 1 .926-1.18l4.524 3.546Zm1.191.931 7.156 5.585a7.5 7.5 0 0 1-.584-2.928V10.25A3.252 3.252 0 0 0 12.25 7h-.5c-1.21 0-2.263.66-2.822 1.637ZM7 11.294v-.354l1.46 1.15a7.756 7.756 0 0 1-1.2 3.41h5.527l1.907 1.5H5.75a.748.748 0 0 1-.584-1.219l.465-.581A6.27 6.27 0 0 0 7 11.294ZM14 18c0 .503-.21 1.04-.585 1.416A2.05 2.05 0 0 1 12 20a2 2 0 0 1-1.416-.584A2.05 2.05 0 0 1 10 18h4Z",
        fill: "currentColor"
      }
    )
  })
);
var BellSlash_default = SvgBellSlash;

// src/Icon/icons/Bell.tsx
import { jsx as jsx206 } from "react/jsx-runtime";
var SvgBell = (props) => /* @__PURE__ */ jsx206(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx206(
      "path",
      {
        d: "M13.25 3.25v.698a5.94 5.94 0 0 1 5 5.865v1.304c0 1.774.606 3.496 1.711 4.883l.582.727a.935.935 0 0 1-.73 1.523H4.188a.938.938 0 0 1-.732-1.523L4.038 16a7.823 7.823 0 0 0 1.712-4.883V9.812a5.94 5.94 0 0 1 5-5.864V3.25a1.25 1.25 0 1 1 2.5 0Zm-1.562 2.5a4.064 4.064 0 0 0-4.063 4.063v1.304a9.698 9.698 0 0 1-1.55 5.258h11.851a9.701 9.701 0 0 1-1.55-5.258V9.812a4.064 4.064 0 0 0-4.063-4.062h-.625ZM14.5 19.5c0 .629-.261 1.3-.73 1.77-.469.468-1.14.73-1.77.73a2.5 2.5 0 0 1-1.77-.73 2.563 2.563 0 0 1-.73-1.77h5Z",
        fill: "currentColor"
      }
    )
  })
);
var Bell_default = SvgBell;

// src/Icon/icons/Bells.tsx
import { jsx as jsx207 } from "react/jsx-runtime";
var SvgBells = (props) => /* @__PURE__ */ jsx207(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx207(
      "path",
      {
        d: "M9.794 13.273c.366.994.404 2.08.113 3.1l-.038.122-7.211-2.625a.996.996 0 0 1-.651-.823c-.044-.375.129-.744.446-.954l.256-.166c1.081-.738 1.906-1.749 2.35-2.963l.458-1.251c.76-2.145 3.138-3.251 5.313-2.47.15.055.297.118.435.187a5.292 5.292 0 0 0-2.056 6.24l.585 1.603Zm.942-.341-.588-1.603a4.293 4.293 0 0 1 2.565-5.511 4.313 4.313 0 0 1 5.522 2.567l.586 1.602a6.014 6.014 0 0 0 2.302 2.929l.432.288a.98.98 0 0 1 .438.95c-.047.376-.297.664-.65.82l-9.309 3.389a1.005 1.005 0 0 1-1.307-1.217l.143-.498c.35-1.22.304-2.55-.134-3.716Zm1.411-.514a7.49 7.49 0 0 1 .282 4.202l7.487-2.725A7.532 7.532 0 0 1 17.41 10.5L16.825 8.9a2.808 2.808 0 0 0-3.595-1.671 2.827 2.827 0 0 0-1.696 3.588l.613 1.602Zm4.884 6.59a2.004 2.004 0 0 1-1.618-.81l3.633-1.321c.003.04.003.081.003.122 0 1.11-.904 2.009-2.018 2.009ZM4.94 15.76l3.678 1.355a2.011 2.011 0 0 1-1.674.888A2.013 2.013 0 0 1 4.94 15.76Z",
        fill: "currentColor"
      }
    )
  })
);
var Bells_default = SvgBells;

// src/Icon/icons/BinaryCircleCheck.tsx
import { jsx as jsx208 } from "react/jsx-runtime";
var SvgBinaryCircleCheck = (props) => /* @__PURE__ */ jsx208(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx208(
      "path",
      {
        d: "M12.25 9.5h1c.416 0 .75.334.75.75s-.334.75-.75.75h-3.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h1V5.79l-.512.172a.751.751 0 0 1-.476-1.424l1.5-.5a.748.748 0 0 1 .988.712V9.5Zm-7 9h1c.416 0 .75.334.75.75s-.334.75-.75.75h-3.5a.75.75 0 1 1 0-1.5h1v-3.71l-.513.173c-.393.103-.818-.082-.949-.475a.751.751 0 0 1 .475-.95l1.5-.5a.751.751 0 0 1 .987.713v4.749ZM2 6.25A2.25 2.25 0 0 1 4.25 4h1.5A2.25 2.25 0 0 1 8 6.25v2.5A2.249 2.249 0 0 1 5.75 11h-1.5A2.25 2.25 0 0 1 2 8.75v-2.5Zm2.25-.75a.75.75 0 0 0-.75.75v2.5c0 .416.336.75.75.75h1.5c.416 0 .75-.334.75-.75v-2.5a.75.75 0 0 0-.75-.75h-1.5Zm7.5 7.5c.16 0 .366.022.54.066-.212.45-.365.906-.456 1.44a.749.749 0 0 0-.084-.006h-1.5a.748.748 0 0 0-.75.75v2.5c0 .416.334.75.75.75h1.5c.272 0 .51-.144.64-.36.238.46.538.885.888 1.263A2.255 2.255 0 0 1 11.75 20h-1.5A2.249 2.249 0 0 1 8 17.75v-2.5A2.249 2.249 0 0 1 10.25 13h1.5ZM22 15.5a4.501 4.501 0 0 1-9 0c0-2.484 2.016-4.528 4.5-4.528S22 13.016 22 15.5Zm-3.103-1.353L17 16.044l-.897-.897a.496.496 0 0 0-.706 0 .496.496 0 0 0 0 .706l1.25 1.25a.496.496 0 0 0 .706 0l2.25-2.25a.496.496 0 0 0 0-.706.496.496 0 0 0-.706 0Z",
        fill: "currentColor"
      }
    )
  })
);
var BinaryCircleCheck_default = SvgBinaryCircleCheck;

// src/Icon/icons/BinaryLock.tsx
import { jsx as jsx209 } from "react/jsx-runtime";
var SvgBinaryLock = (props) => /* @__PURE__ */ jsx209(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx209(
      "path",
      {
        d: "M11.938 4.142a.748.748 0 0 1 .312.608V9.5h1c.416 0 .75.334.75.75s-.334.75-.75.75h-3.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h1V5.79l-.512.172a.751.751 0 0 1-.476-1.424l1.5-.5a.748.748 0 0 1 .675.104Zm-7 8.999c.196.14.312.368.312.609v4.75h1c.416 0 .75.334.75.75s-.334.75-.75.75h-3.5a.75.75 0 1 1 0-1.5h1v-3.71l-.513.173c-.393.103-.818-.082-.949-.475a.751.751 0 0 1 .475-.95l1.5-.5a.755.755 0 0 1 .675.103ZM5.75 4A2.25 2.25 0 0 1 8 6.25v2.5A2.249 2.249 0 0 1 5.75 11h-1.5A2.25 2.25 0 0 1 2 8.75v-2.5A2.25 2.25 0 0 1 4.25 4h1.5ZM3.5 8.75c0 .416.336.75.75.75h1.5c.416 0 .75-.334.75-.75v-2.5a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75v2.5Zm4.5 6.5A2.249 2.249 0 0 1 10.25 13h1.5A2.249 2.249 0 0 1 14 15.25v2.5A2.249 2.249 0 0 1 11.75 20h-1.5A2.249 2.249 0 0 1 8 17.75v-2.5Zm2.25-.75a.748.748 0 0 0-.75.75v2.5c0 .416.334.75.75.75h1.5c.416 0 .75-.334.75-.75v-2.5a.748.748 0 0 0-.75-.75h-1.5ZM18.5 10a2.5 2.5 0 0 1 2.5 2.5V14c.553 0 1 .447 1 1v4c0 .553-.447 1-1 1h-5c-.553 0-1-.447-1-1v-4c0-.553.447-1 1-1v-1.5a2.5 2.5 0 0 1 2.5-2.5Zm0 1.5c-.553 0-1 .447-1 1V14h2v-1.5c0-.553-.447-1-1-1Z",
        fill: "currentColor"
      }
    )
  })
);
var BinaryLock_default = SvgBinaryLock;

// src/Icon/icons/BinarySlash.tsx
import { jsx as jsx210 } from "react/jsx-runtime";
var SvgBinarySlash = (props) => /* @__PURE__ */ jsx210(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx210(
      "path",
      {
        d: "M6 6.344V6.25A2.25 2.25 0 0 1 8.25 4h1.5A2.25 2.25 0 0 1 12 6.25v2.5c0 .675-.297 1.281-.769 1.694L14.491 13h1.259A2.249 2.249 0 0 1 18 15.25v.472l3.712 2.937a.75.75 0 0 1-.925 1.181l-18.5-14.5a.75.75 0 1 1 .926-1.18L6 6.344ZM7.5 7.52 9.98 9.462a.749.749 0 0 0 .519-.712v-2.5a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75v1.269Zm8.75 1.98h1c.416 0 .75.335.75.75 0 .416-.334.75-.75.75h-3.5a.748.748 0 0 1-.75-.75c0-.415.334-.75.75-.75h1V5.792l-.513.17a.751.751 0 0 1-.475-1.423l1.5-.5a.748.748 0 0 1 .675.104c.197.14.313.367.313.608V9.5Zm-7 9h1c.415 0 .75.335.75.75 0 .417-.335.75-.75.75h-3.5a.748.748 0 0 1-.75-.75c0-.415.334-.75.75-.75h1v-3.708l-.513.171c-.393.104-.818-.08-.95-.475a.75.75 0 0 1 .475-.95l1.5-.5a.753.753 0 0 1 .988.713v4.75ZM12 15.25c0-.118.01-.234.028-.35l1.472 1.16v1.69c0 .417.334.75.75.75h1.5c.216 0 .41-.09.547-.237l1.178.932c-.413.465-1.031.806-1.725.806h-1.5A2.249 2.249 0 0 1 12 17.75v-2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var BinarySlash_default = SvgBinarySlash;

// src/Icon/icons/Binary.tsx
import { jsx as jsx211 } from "react/jsx-runtime";
var SvgBinary = (props) => /* @__PURE__ */ jsx211(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx211(
      "path",
      {
        d: "M17.313 8.875h1.25c.519 0 .937.418.937.938 0 .519-.418.937-.938.937h-4.375a.935.935 0 0 1-.937-.938c0-.519.418-.937.938-.937h1.25V4.238l-.641.214a.937.937 0 1 1-.594-1.779l1.875-.625a.935.935 0 0 1 .844.129c.246.176.39.46.39.76v5.938Zm-8.75 11.25h1.25c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H5.439a.937.937 0 1 1 0-1.875h1.25v-4.637l-.642.215c-.49.129-1.022-.101-1.185-.594a.94.94 0 0 1 .593-1.187l1.875-.625a.939.939 0 0 1 1.234.89v5.938ZM4.5 4.812A2.813 2.813 0 0 1 7.313 2h1.875A2.812 2.812 0 0 1 12 4.813v3.125a2.81 2.81 0 0 1-2.813 2.812H7.313A2.812 2.812 0 0 1 4.5 7.937V4.813Zm2.813-.937a.938.938 0 0 0-.938.938v3.125c0 .519.42.937.938.937h1.875c.519 0 .937-.418.937-.938V4.813a.936.936 0 0 0-.938-.937H7.313Zm9.375 9.375a2.81 2.81 0 0 1 2.812 2.813v3.125A2.81 2.81 0 0 1 16.687 22h-1.875A2.81 2.81 0 0 1 12 19.187v-3.125a2.81 2.81 0 0 1 2.813-2.812h1.874Zm-2.813 5.938c0 .519.418.937.938.937h1.874c.52 0 .938-.418.938-.938v-3.125a.935.935 0 0 0-.938-.937h-1.875a.935.935 0 0 0-.937.938v3.125Z",
        fill: "currentColor"
      }
    )
  })
);
var Binary_default = SvgBinary;

// src/Icon/icons/Binoculars.tsx
import { jsx as jsx212 } from "react/jsx-runtime";
var SvgBinoculars = (props) => /* @__PURE__ */ jsx212(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx212(
      "path",
      {
        d: "M18.25 5.125H14.5v-1.25c0-.344.281-.625.625-.625h2.5c.344 0 .625.281.625.625v1.25ZM9.5 3.875a.627.627 0 0 0-.625-.625h-2.5a.627.627 0 0 0-.625.625v1.25H9.5v-1.25Zm12.5 15a1.86 1.86 0 0 1-1.859 1.875h-5.016a1.875 1.875 0 0 1-1.875-1.875V13.25h-2.5v5.625c0 1.035-.84 1.875-1.875 1.875H3.859A1.86 1.86 0 0 1 2 18.875l.015-1.719c.132-5.066 2.381-5.863 2.48-9.527.019-.688.562-1.254 1.25-1.254h3.72c.726 0 1.285.559 1.285 1.25v.625h2.5v-.625c0-.69.56-1.25 1.25-1.25h3.755c.688 0 1.231.566 1.25 1.254.1 3.664 2.35 4.46 2.48 9.527L22 18.875ZM8.875 8.25H6.34c-.145 1.758-.717 2.992-1.225 4.094-.6 1.289-1.167 2.51-1.23 4.863l-.01 1.684 5-.016V8.25Zm11.25 10.625-.015-1.704c-.058-2.32-.625-3.54-1.226-4.828-.505-1.1-1.08-2.335-1.224-4.093h-2.535v10.625h5Z",
        fill: "currentColor"
      }
    )
  })
);
var Binoculars_default = SvgBinoculars;

// src/Icon/icons/BlanketFire.tsx
import { jsx as jsx213 } from "react/jsx-runtime";
var SvgBlanketFire = (props) => /* @__PURE__ */ jsx213(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx213(
      "path",
      {
        d: "M5 14.25c0 .412.34.75.75.75H11v-.06c0-.468.09-.956.25-1.44h-5.5c-.41 0-.75.338-.75.75Zm7.16-2.666c.22-.36.47-.724.75-1.085H5.75c-.84 0-1.62.28-2.25.75v-4.5c0-.69.56-1.25 1.25-1.25h8.5c.69 0 1.25.56 1.25 1.25V8.73c.13-.122.26-.242.39-.36.31-.28.72-.401 1.11-.364V6.75A2.75 2.75 0 0 0 13.25 4h-8.5C3.23 4 2 5.23 2 6.75v7.5A3.75 3.75 0 0 0 5.75 18h6.069c-.27-.466-.48-.97-.62-1.5H5.75a2.251 2.251 0 0 1-2.25-2.25C3.5 13.007 4.51 12 5.75 12h6.169c.081-.14.162-.278.24-.416Zm9.09.954c-.47-.89-1.12-1.827-1.89-2.536a.471.471 0 0 0-.629-.002c-.3.274-.58.613-.82.922-.54-.65-1.12-1.25-1.74-1.804a.462.462 0 0 0-.612-.002c-1.04.928-1.92 1.982-2.55 2.993-.609 1-1.009 2.007-1.009 2.832C12 17.684 14.2 20 17 20c2.77 0 5-2.316 5-5.06 0-.63-.3-1.527-.75-2.402Zm-2.69 4.965c-.47.34-.97.497-1.557.497-1.384 0-2.503-.906-2.503-2.466 0-.75.47-1.406 1.41-2.562.12.157 1.93 2.47 1.93 2.47l1.13-1.314c.09.125.15.25.22.375.56 1.031.31 2.372-.63 3Z",
        fill: "currentColor"
      }
    )
  })
);
var BlanketFire_default = SvgBlanketFire;

// src/Icon/icons/Blanket.tsx
import { jsx as jsx214 } from "react/jsx-runtime";
var SvgBlanket = (props) => /* @__PURE__ */ jsx214(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx214(
      "path",
      {
        d: "M22 5.929A3.934 3.934 0 0 0 18.071 2H5.93A3.933 3.933 0 0 0 2 5.929V17c0 2.759 2.243 5 5 5h13.929a1.072 1.072 0 0 0 0-2.143H7A2.86 2.86 0 0 1 4.143 17 2.86 2.86 0 0 1 7 14.143h11.964a.894.894 0 0 1 0 1.786H7.357c-.59 0-1.071.482-1.071 1.071 0 .59.48 1.071 1.071 1.071h11.607A3.039 3.039 0 0 0 22 15.036c0-.041-.01-.079-.012-.12.003-.019.012-.037.012-.059V5.93ZM18.964 12H7c-1.063 0-2.046.34-2.857.908v-6.98c0-.984.8-1.785 1.786-1.785H18.07c.985 0 1.786.8 1.786 1.786v6.218a3.117 3.117 0 0 0-.893-.147Z",
        fill: "currentColor"
      }
    )
  })
);
var Blanket_default = SvgBlanket;

// src/Icon/icons/BlockBrickFire.tsx
import { jsx as jsx215 } from "react/jsx-runtime";
var SvgBlockBrickFire = (props) => /* @__PURE__ */ jsx215(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx215(
      "path",
      {
        d: "M6.737 14.105h3.71a4.37 4.37 0 0 0-.026.464c0 .378.033.75.07 1.115H9.367v1.58h1.648a6.396 6.396 0 0 0 1.037 1.578H4.105A2.106 2.106 0 0 1 2 16.737V6.21c0-1.163.942-2.106 2.105-2.106h10.527c1.16 0 2.105.943 2.105 2.106v1.598a24.47 24.47 0 0 0-.194-.18 1.502 1.502 0 0 0-2.027.026c-.427.378-.829.776-1.204 1.187H9.369v1.842h2.5c-.079.119-.15.237-.223.352-.244.395-.497.806-.658 1.227h-4.25v1.842Zm0-6.842H12V5.684H6.737v1.58Zm-1.58 0V5.684H4.106a.526.526 0 0 0-.526.527v1.052h1.579ZM3.58 8.843v1.841h4.21V8.842H3.58Zm1.579 5.262v-1.842h-1.58v1.842h1.58Zm-1.58 1.58v1.052c.001.29.236.526.527.526H7.79v-1.579H3.58Zm11.58-8.422V6.211a.527.527 0 0 0-.526-.527h-1.053v1.58h1.579Zm2.533 3.076c.26-.326.552-.681.872-1a.53.53 0 0 1 .657.03c.813.746 1.5 1.733 1.984 2.67.48.921.796 1.866.796 2.53 0 2.888-2.345 5.326-5.263 5.326-2.95 0-5.263-2.441-5.263-5.326 0-.868.417-1.928 1.066-2.98.657-1.063 1.582-2.175 2.677-3.151.184-.165.438-.162.648.003.651.585 1.26 1.214 1.826 1.898Zm1.349 3.77c-.066-.132-.132-.264-.23-.395l-1.185 1.411-2.07-2.599c-.956 1.188-1.45 1.908-1.45 2.698 0 1.611 1.184 2.566 2.635 2.566.622 0 1.148-.165 1.642-.523.986-.662 1.25-2.043.657-3.158Z",
        fill: "currentColor"
      }
    )
  })
);
var BlockBrickFire_default = SvgBlockBrickFire;

// src/Icon/icons/BlockBrick.tsx
import { jsx as jsx216 } from "react/jsx-runtime";
var SvgBlockBrick = (props) => /* @__PURE__ */ jsx216(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx216(
      "path",
      {
        d: "M2 4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857Zm6.429 1.429h7.142V4.143H8.43v2.143Zm-2.143 0V4.143H4.857a.714.714 0 0 0-.714.714v1.429h2.143ZM4.143 8.429v2.5h6.786v-2.5H4.143Zm2.143 7.142v-2.5H4.143v2.5h2.143Zm-2.143 2.143v1.429c0 .393.32.714.714.714h6.072v-2.143H4.143Zm4.286-2.143h7.142v-2.5H8.43v2.5Zm11.428 0v-2.5h-2.143v2.5h2.143Zm0 2.143h-6.786v2.143h6.072a.716.716 0 0 0 .714-.714v-1.429ZM13.071 8.43v2.5h6.786v-2.5h-6.786Zm6.786-2.143V4.857a.715.715 0 0 0-.714-.714h-1.429v2.143h2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var BlockBrick_default = SvgBlockBrick;

// src/Icon/icons/BlockQuestion.tsx
import { jsx as jsx217 } from "react/jsx-runtime";
var SvgBlockQuestion = (props) => /* @__PURE__ */ jsx217(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx217(
      "path",
      {
        d: "M10.929 8.429a.716.716 0 0 0-.715.714V9.5c0 .594-.477 1.071-1.071 1.071A1.069 1.069 0 0 1 8.07 9.5v-.357a2.86 2.86 0 0 1 2.858-2.857h2.589c1.727 0 3.125 1.397 3.125 3.085 0 1.133-.576 2.151-1.518 2.678l-2.054 1.272v.108c0 .593-.477 1.071-1.071 1.071a1.069 1.069 0 0 1-1.071-1.071v-.715c0-.375.196-.723.522-.92l2.571-1.544c.26-.179.478-.496.478-.88 0-.504-.438-.941-.982-.941h-2.59ZM10.57 17c0-.79.639-1.429 1.429-1.429s1.429.639 1.429 1.429-.639 1.429-1.429 1.429-1.429-.639-1.429-1.429ZM7 5.929a1.07 1.07 0 1 1-1.071-1.071c.593 0 1.071.477 1.071 1.07Zm10 0c0-.594.478-1.072 1.071-1.072.594 0 1.072.478 1.072 1.072 0 .593-.478 1.071-1.072 1.071A1.069 1.069 0 0 1 17 5.929ZM7 18.07A1.07 1.07 0 1 1 5.929 17C6.522 17 7 17.478 7 18.071Zm10 0c0-.593.478-1.071 1.071-1.071.594 0 1.072.478 1.072 1.071 0 .594-.478 1.072-1.072 1.072A1.069 1.069 0 0 1 17 18.07ZM19.143 2A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857A2.857 2.857 0 0 1 4.857 2h14.286Zm0 2.143H4.857a.714.714 0 0 0-.714.714v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714Z",
        fill: "currentColor"
      }
    )
  })
);
var BlockQuestion_default = SvgBlockQuestion;

// src/Icon/icons/BlockQuote.tsx
import { jsx as jsx218 } from "react/jsx-runtime";
var SvgBlockQuote = (props) => /* @__PURE__ */ jsx218(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx218(
      "path",
      {
        d: "M20.929 3.607c.593 0 1.071.48 1.071 1.072 0 .593-.478 1.071-1.071 1.071H3.07a1.07 1.07 0 1 1 0-2.143H20.93Zm0 7.143c.593 0 1.071.478 1.071 1.071 0 .594-.478 1.072-1.071 1.072H8.786a1.069 1.069 0 0 1-1.072-1.072c0-.593.478-1.071 1.072-1.071h12.143ZM7.714 18.964c0-.593.478-1.071 1.072-1.071h12.143c.593 0 1.071.477 1.071 1.071s-.478 1.072-1.071 1.072H8.786a1.069 1.069 0 0 1-1.072-1.072ZM2 11.464a1.07 1.07 0 1 1 2.143 0v7.857a1.07 1.07 0 1 1-2.143 0v-7.857Z",
        fill: "currentColor"
      }
    )
  })
);
var BlockQuote_default = SvgBlockQuote;

// src/Icon/icons/Block.tsx
import { jsx as jsx219 } from "react/jsx-runtime";
var SvgBlock = (props) => /* @__PURE__ */ jsx219(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx219(
      "path",
      {
        d: "M7 5.929a1.07 1.07 0 1 1-1.071-1.071c.593 0 1.071.477 1.071 1.07Zm10 0c0-.594.478-1.072 1.071-1.072.594 0 1.072.478 1.072 1.072 0 .593-.478 1.071-1.072 1.071A1.069 1.069 0 0 1 17 5.929ZM7 18.07A1.07 1.07 0 1 1 5.929 17C6.522 17 7 17.478 7 18.071Zm10 0c0-.593.478-1.071 1.071-1.071.594 0 1.072.478 1.072 1.071 0 .594-.478 1.072-1.072 1.072A1.069 1.069 0 0 1 17 18.07ZM19.143 2A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857A2.857 2.857 0 0 1 4.857 2h14.286Zm0 2.143H4.857a.714.714 0 0 0-.714.714v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714Z",
        fill: "currentColor"
      }
    )
  })
);
var Block_default = SvgBlock;

// src/Icon/icons/Bluetooth.tsx
import { jsx as jsx220 } from "react/jsx-runtime";
var SvgBluetooth = (props) => /* @__PURE__ */ jsx220(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx220(
      "path",
      {
        d: "m13.413 11.983 4.484-3.825a.873.873 0 0 0 .364-.714.941.941 0 0 0-.33-.715l-5.322-4.503a.933.933 0 0 0-1.003-.139c-.334.119-.545.451-.545.818v7.008L7.287 6.731A.938.938 0 1 0 6.07 8.16l4.485 3.825-4.485 3.825a.937.937 0 1 0 1.218 1.428l3.774-3.22v7.043A.937.937 0 0 0 12 22a.935.935 0 0 0 .609-.225l5.322-4.504c.209-.213.33-.475.33-.75a.94.94 0 0 0-.33-.713l-4.518-3.825Zm-.474-7.043 2.936 2.469-2.936 2.504V4.94Zm0 14.086v-5.008l2.936 2.469-2.936 2.54Z",
        fill: "currentColor"
      }
    )
  })
);
var Bluetooth_default = SvgBluetooth;

// src/Icon/icons/Bold.tsx
import { jsx as jsx221 } from "react/jsx-runtime";
var SvgBold = (props) => /* @__PURE__ */ jsx221(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx221(
      "path",
      {
        d: "M17.348 11.362c.093-.082.197-.148.285-.237a5.315 5.315 0 0 0 1.55-3.821C19.156 4.38 16.75 2 13.826 2H4.857a1.072 1.072 0 0 0 0 2.143H5.93v15.714H4.857c-.591 0-1.071.482-1.071 1.072 0 .589.48 1.071 1.071 1.071H14.5a5.72 5.72 0 0 0 5.714-5.714c0-2.107-1.2-3.933-2.866-4.924Zm-3.522-7.22a3.226 3.226 0 0 1 3.214 3.184 3.194 3.194 0 0 1-.93 2.292 3.186 3.186 0 0 1-2.284.953H8.07V4.143h5.755Zm.674 15.715H8.071v-7.143H14.5a3.575 3.575 0 0 1 3.571 3.572c0 1.97-1.602 3.571-3.571 3.571Z",
        fill: "currentColor"
      }
    )
  })
);
var Bold_default = SvgBold;

// src/Icon/icons/BoltAuto.tsx
import { jsx as jsx222 } from "react/jsx-runtime";
var SvgBoltAuto = (props) => /* @__PURE__ */ jsx222(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx222(
      "path",
      {
        d: "M11.16 10.889h2.961c.67 0 1.212.541 1.212 1.211 0 .358-.156.695-.427.927L5.92 20.652a.998.998 0 0 1-1.606-1.035l1.86-6.506H3.17a1.17 1.17 0 0 1-.76-2.063l9.002-7.698a1 1 0 0 1 1.608 1.032l-1.862 6.507Zm-3.882.555a.84.84 0 0 1 .666.33.852.852 0 0 1 .136.733l-1.556 5.447 6.361-5.399h-2.83a.84.84 0 0 1-.666-.33.851.851 0 0 1-.136-.732l1.552-5.431-6.293 5.382h2.766Zm10.832 1.667c.317 0 .605.177.747.461l3.056 6.111a.835.835 0 0 1-1.494.743l-.461-.927h-3.695l-.461.927a.835.835 0 0 1-1.493-.743l3.055-6.11a.833.833 0 0 1 .746-.462Zm-1.013 4.722h2.027l-1.014-2.024-1.013 2.024Z",
        fill: "currentColor"
      }
    )
  })
);
var BoltAuto_default = SvgBoltAuto;

// src/Icon/icons/BoltLightning.tsx
import { jsx as jsx223 } from "react/jsx-runtime";
var SvgBoltLightning = (props) => /* @__PURE__ */ jsx223(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx223(
      "path",
      {
        d: "M19.39 8.75a.932.932 0 0 0-.827-.5h-6.117l1.985-4.965a.937.937 0 0 0-.094-.874.98.98 0 0 0-.774-.411H6.688a.937.937 0 0 0-.93.814l-1.25 9.375a.94.94 0 0 0 .929 1.06h5.715L9.52 20.833a.938.938 0 0 0 .547 1.058c.12.087.246.11.37.11a.939.939 0 0 0 .774-.408l8.126-11.875a.937.937 0 0 0 .054-.967Zm-7.038 7.855.877-4.093a.936.936 0 0 0-.188-.786.931.931 0 0 0-.728-.351H6.508l1-7.5h4.672L10.192 8.84a.954.954 0 0 0 .093.875c.172.258.465.41.778.41h5.722l-4.433 6.48Z",
        fill: "currentColor"
      }
    )
  })
);
var BoltLightning_default = SvgBoltLightning;

// src/Icon/icons/BoltSlash.tsx
import { jsx as jsx224 } from "react/jsx-runtime";
var SvgBoltSlash = (props) => /* @__PURE__ */ jsx224(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx224(
      "path",
      {
        d: "m9.122 8.79 5.35-4.575a.9.9 0 0 1 1.447.929L14.244 11h2.665c.603 0 1.09.487 1.09 1.09 0 .322-.14.626-.383.835l-1.547 1.312 5.643 4.422a.75.75 0 0 1-.925 1.181l-18.5-14.5a.75.75 0 1 1 .926-1.18l5.909 4.63Zm1.203.944 2.222 1.744 1.378-4.822-3.6 3.078Zm3.528 2.766 1.01.79.934-.79h-1.944Zm-1.338 2.784 1.2.947-4.187 3.556a.9.9 0 0 1-1.447-.93l1.65-5.766 1.272.975-.931 3.293 2.444-2.075Zm-5.718-4.506L9.616 13H7.053a1.054 1.054 0 0 1-.684-1.856l.428-.366Z",
        fill: "currentColor"
      }
    )
  })
);
var BoltSlash_default = SvgBoltSlash;

// src/Icon/icons/Bolt.tsx
import { jsx as jsx225 } from "react/jsx-runtime";
var SvgBolt = (props) => /* @__PURE__ */ jsx225(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx225(
      "path",
      {
        d: "M15.816 2c.746 0 1.286.713 1.082 1.43l-2.093 7.32h3.332c.754 0 1.363.61 1.363 1.363 0 .403-.176.782-.48 1.043L8.91 21.734a1.122 1.122 0 0 1-1.807-1.164l2.092-7.32H5.818a1.317 1.317 0 0 1-.857-2.32L15.09 2.27c.203-.174.46-.27.726-.27Zm-1.41 3.32-7.08 6.055h3.112c.292 0 .57.137.75.371.175.238.23.543.152.824L9.59 18.7l7.156-6.075h-3.183a.945.945 0 0 1-.75-.371.957.957 0 0 1-.153-.824l1.746-6.11Z",
        fill: "currentColor"
      }
    )
  })
);
var Bolt_default = SvgBolt;

// src/Icon/icons/BookArrowRight.tsx
import { jsx as jsx226 } from "react/jsx-runtime";
var SvgBookArrowRight = (props) => /* @__PURE__ */ jsx226(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx226(
      "path",
      {
        d: "M15.253 13a.75.75 0 0 0-.75.75V15H4.5c-.356 0-.694.075-1 .21V6.499a1 1 0 0 1 1-1h10.002v1.75c0 .416.334.75.75.75s.75-.334.75-.75v-1.75a1.5 1.5 0 0 0-1.5-1.5H4.5A2.5 2.5 0 0 0 2 6.498V17.5a2.5 2.5 0 0 0 2.5 2.5h10.753a.75.75 0 0 0 0-1.5h-.25V16.41c.581-.208 1-.758 1-1.408v-1.25a.748.748 0 0 0-.75-.75Zm-1.75 5.501H4.5a1.001 1.001 0 0 1 0-2h9.002v2Zm8.254-8.533-2.5-2.5a.75.75 0 1 0-1.061 1.06l1.248 1.222h-8.692a.751.751 0 0 0 0 1.5h8.692l-1.22 1.22a.745.745 0 0 0-.001 1.06.75.75 0 0 0 1.061 0l2.5-2.5a.73.73 0 0 0-.027-1.062Z",
        fill: "currentColor"
      }
    )
  })
);
var BookArrowRight_default = SvgBookArrowRight;

// src/Icon/icons/BookArrowUp.tsx
import { jsx as jsx227 } from "react/jsx-runtime";
var SvgBookArrowUp = (props) => /* @__PURE__ */ jsx227(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx227(
      "path",
      {
        d: "M20.75 15.75V3.875C20.75 2.841 19.91 2 18.875 2h-12.5A3.125 3.125 0 0 0 3.25 5.125v13.75C3.25 20.602 4.65 22 6.375 22h2.813a.938.938 0 0 0 0-1.875H6.374a1.251 1.251 0 0 1 0-2.5h2.813a.938.938 0 0 0 0-1.875H6.374c-.445 0-.867.093-1.25.261V5.125c0-.69.56-1.25 1.25-1.25h12.5V15.75h-2.813a.937.937 0 1 0 0 1.875h1.563v2.5h-1.563a.937.937 0 1 0 0 1.875h3.75a.938.938 0 0 0 0-1.875H19.5V17.51a1.873 1.873 0 0 0 1.25-1.76Zm-4.371-4.059a.937.937 0 0 0 0-1.325L13.254 7.24a.937.937 0 0 0-1.326 0l-3.125 3.125a.937.937 0 1 0 1.326 1.325l1.559-1.492v10.864a.938.938 0 0 0 1.874 0V10.198l1.525 1.525c.183.186.42.276.663.276.242 0 .48-.09.629-.309Z",
        fill: "currentColor"
      }
    )
  })
);
var BookArrowUp_default = SvgBookArrowUp;

// src/Icon/icons/BookAtlas.tsx
import { jsx as jsx228 } from "react/jsx-runtime";
var SvgBookAtlas = (props) => /* @__PURE__ */ jsx228(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx228(
      "path",
      {
        d: "M20.75 15.75V3.875C20.75 2.841 19.91 2 18.875 2h-12.5A3.128 3.128 0 0 0 3.25 5.125v13.75A3.129 3.129 0 0 0 6.375 22h13.438a.938.938 0 0 0 0-1.875H19.5V17.51a1.873 1.873 0 0 0 1.25-1.76Zm-3.125 4.375H6.375a1.251 1.251 0 0 1 0-2.5h11.25v2.5Zm1.25-4.375h-12.5c-.445 0-.867.093-1.25.261V5.125c0-.69.56-1.25 1.25-1.25h12.5V15.75ZM12.312 5.125a4.691 4.691 0 0 0-4.687 4.688 4.691 4.691 0 0 0 4.688 4.687A4.689 4.689 0 0 0 17 9.812a4.686 4.686 0 0 0-4.688-4.687Zm-3.374 5.313h1.352c.054.921.19 1.757.48 2.433a3.441 3.441 0 0 1-1.832-2.434Zm1.355-1.25H8.938a3.421 3.421 0 0 1 1.83-2.432c-.288.674-.424 1.51-.475 2.431Zm2.02 3.976c-.27-.328-.684-1.266-.782-2.726h1.563c-.098 1.46-.512 2.398-.781 2.726Zm-.782-3.976c.098-1.46.513-2.398.781-2.725.27.326.684 1.264.782 2.724H11.53Zm2.324 3.683a9.834 9.834 0 0 0 .48-2.434h1.354a3.446 3.446 0 0 1-1.834 2.434Zm.48-3.684c-.053-.922-.224-1.757-.478-2.431a3.426 3.426 0 0 1 1.83 2.431h-1.351Z",
        fill: "currentColor"
      }
    )
  })
);
var BookAtlas_default = SvgBookAtlas;

// src/Icon/icons/BookBlank.tsx
import { jsx as jsx229 } from "react/jsx-runtime";
var SvgBookBlank = (props) => /* @__PURE__ */ jsx229(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx229(
      "path",
      {
        d: "M20.75 15.75V3.875C20.75 2.841 19.91 2 18.875 2h-12.5A3.128 3.128 0 0 0 3.25 5.125v13.75A3.129 3.129 0 0 0 6.375 22h13.438a.938.938 0 0 0 0-1.875H19.5V17.51a1.873 1.873 0 0 0 1.25-1.76Zm-3.125 4.375H6.375a1.251 1.251 0 0 1 0-2.5h11.25v2.5Zm1.25-4.375h-12.5c-.445 0-.867.093-1.25.261V5.125c0-.69.56-1.25 1.25-1.25h12.5V15.75Z",
        fill: "currentColor"
      }
    )
  })
);
var BookBlank_default = SvgBookBlank;

// src/Icon/icons/BookBookmark.tsx
import { jsx as jsx230 } from "react/jsx-runtime";
var SvgBookBookmark = (props) => /* @__PURE__ */ jsx230(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx230(
      "path",
      {
        d: "M20.75 15.75V3.875C20.75 2.841 19.91 2 18.875 2h-12.5A3.128 3.128 0 0 0 3.25 5.125v13.75A3.129 3.129 0 0 0 6.375 22h13.438a.938.938 0 0 0 0-1.875H19.5V17.51a1.873 1.873 0 0 0 1.25-1.76Zm-3.125 4.375H6.375a1.251 1.251 0 0 1 0-2.5h11.25v2.5Zm1.25-4.375h-12.5c-.445 0-.867.093-1.25.261V5.125c0-.69.56-1.25 1.25-1.25h4.375v6.215c0 .524.606.816.98.488l2.145-1.703 2.11 1.737c.41.325 1.015.036 1.015-.522V3.875h1.875V15.75Z",
        fill: "currentColor"
      }
    )
  })
);
var BookBookmark_default = SvgBookBookmark;

// src/Icon/icons/BookCircleArrowRight.tsx
import { jsx as jsx231 } from "react/jsx-runtime";
var SvgBookCircleArrowRight = (props) => /* @__PURE__ */ jsx231(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx231(
      "path",
      {
        d: "M12.894 18.5H4.5a1 1 0 0 1 0-2h7.594a5.56 5.56 0 0 1-.094-1c0-.169.01-.335.025-.5H4.5c-.356 0-.694.074-1 .209V6.5a1 1 0 0 1 1-1h10v5.394c.457-.299.962-.53 1.5-.681V5.5c0-.827-.672-1.5-1.5-1.5h-10A2.503 2.503 0 0 0 2 6.5v11C2 18.878 3.122 20 4.5 20h9.844a5.519 5.519 0 0 1-1.45-1.5ZM17.5 11a4.501 4.501 0 0 0 0 9 4.5 4.5 0 1 0 0-9Zm2.353 4.853-1.75 1.75a.5.5 0 1 1-.706-.706l.897-.897H15.5c-.276 0-.472-.224-.472-.5s.197-.5.472-.5h2.793l-.896-.897a.5.5 0 1 1 .706-.706l1.75 1.75a.497.497 0 0 1 0 .706Z",
        fill: "currentColor"
      }
    )
  })
);
var BookCircleArrowRight_default = SvgBookCircleArrowRight;

// src/Icon/icons/BookCircleArrowUp.tsx
import { jsx as jsx232 } from "react/jsx-runtime";
var SvgBookCircleArrowUp = (props) => /* @__PURE__ */ jsx232(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx232(
      "path",
      {
        d: "M12.894 18.5H4.5a1 1 0 0 1 0-2h7.594a5.56 5.56 0 0 1-.094-1c0-.169.01-.335.025-.5H4.5c-.356 0-.694.074-1 .209V6.5a1 1 0 0 1 1-1h10v5.394c.457-.299.962-.53 1.5-.681V5.5c0-.827-.672-1.5-1.5-1.5h-10A2.503 2.503 0 0 0 2 6.5v11C2 18.878 3.122 20 4.5 20h9.844a5.519 5.519 0 0 1-1.45-1.5ZM17.5 11c-2.484 0-4.5 2.016-4.5 4.472C13 17.928 15.016 20 17.5 20a4.5 4.5 0 0 0 0-9Zm2.103 4.603a.5.5 0 0 1-.707 0L18 14.706V17.5c0 .276-.224.472-.5.472s-.5-.197-.5-.472v-2.793l-.897.896a.5.5 0 1 1-.706-.706l1.75-1.75a.5.5 0 0 1 .706 0l1.75 1.75a.501.501 0 0 1 0 .706Z",
        fill: "currentColor"
      }
    )
  })
);
var BookCircleArrowUp_default = SvgBookCircleArrowUp;

// src/Icon/icons/BookCopy.tsx
import { jsx as jsx233 } from "react/jsx-runtime";
var SvgBookCopy = (props) => /* @__PURE__ */ jsx233(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx233(
      "path",
      {
        d: "M22 12V4.778c0-.92-.747-1.667-1.667-1.667h-8.889A2.781 2.781 0 0 0 8.667 5.89v8.889a2.782 2.782 0 0 0 2.777 2.778h9.723a.834.834 0 0 0 0-1.667h-.278v-2.323A1.67 1.67 0 0 0 22 12Zm-2.778 3.889h-7.778a1.112 1.112 0 0 1 0-2.222h7.778v2.222ZM20.333 12h-8.889c-.395 0-.77.082-1.11.232V5.89c0-.613.498-1.111 1.11-1.111h8.89V12ZM14.5 19.222h-.278v-.555h-1.666v.555H4.778a1.112 1.112 0 0 1 0-2.222H8.26a3.857 3.857 0 0 1-.65-1.667H4.778c-.395 0-.771.083-1.111.233V9.222c0-.613.498-1.11 1.11-1.11h2.779V6.443H4.778A2.781 2.781 0 0 0 2 9.222v8.89a2.781 2.781 0 0 0 2.778 2.777H14.5a.834.834 0 0 0 0-1.667Z",
        fill: "currentColor"
      }
    )
  })
);
var BookCopy_default = SvgBookCopy;

// src/Icon/icons/BookFont.tsx
import { jsx as jsx234 } from "react/jsx-runtime";
var SvgBookFont = (props) => /* @__PURE__ */ jsx234(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx234(
      "path",
      {
        d: "M20.75 15.75V3.875C20.75 2.841 19.91 2 18.875 2h-12.5A3.128 3.128 0 0 0 3.25 5.125v13.75A3.129 3.129 0 0 0 6.375 22h13.438a.938.938 0 0 0 0-1.875H19.5V17.51a1.873 1.873 0 0 0 1.25-1.76Zm-3.125 4.375H6.375a1.251 1.251 0 0 1 0-2.5h11.25v2.5Zm1.25-4.375h-12.5c-.445 0-.867.093-1.25.261V5.125c0-.69.56-1.25 1.25-1.25h12.5V15.75ZM8.77 13.777a.935.935 0 0 0 1.257-.42L10.703 12h3.841l.679 1.356a.934.934 0 0 0 1.258.42.937.937 0 0 0 .42-1.257l-3.438-6.875c-.317-.637-1.36-.637-1.677 0l-3.438 6.875a.94.94 0 0 0 .422 1.258Zm3.855-5.617.984 1.965h-1.968l.984-1.965Z",
        fill: "currentColor"
      }
    )
  })
);
var BookFont_default = SvgBookFont;

// src/Icon/icons/BookOpenCover.tsx
import { jsx as jsx235 } from "react/jsx-runtime";
var SvgBookOpenCover = (props) => /* @__PURE__ */ jsx235(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx235(
      "path",
      {
        d: "m20.756 5.058-.256.065v11.503l-8.5 1.89-8.5-1.89V5.123l-.257-.065A1 1 0 0 0 2 6.028V17a1 1 0 0 0 .783.976l9 1.972c.143.032.291.032.434 0l9-1.972c.458-.101.783-.48.783-.948v-11a1 1 0 0 0-1.244-.97ZM5.062 15.753l6.75 1.75c.06.019.097.025.188.025.09 0 .127-.008.188-.024l6.75-1.75a.75.75 0 0 0 .562-.726V4.778a.747.747 0 0 0-.887-.737L12 5.265 5.388 4.041a.748.748 0 0 0-.888.737v10.25c0 .34.232.64.562.725Zm7.688-9.101L18 5.679v8.769l-5.25 1.361V6.652ZM6 5.679l5.25.973v9.156L6 14.447V5.679Z",
        fill: "currentColor"
      }
    )
  })
);
var BookOpenCover_default = SvgBookOpenCover;

// src/Icon/icons/BookOpenReader.tsx
import { jsx as jsx236 } from "react/jsx-runtime";
var SvgBookOpenReader = (props) => /* @__PURE__ */ jsx236(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx236(
      "path",
      {
        d: "M19.965 9.5c-.025 0-.054 0-.078.005-1.95.108-5.489.507-7.887 1.854-2.398-1.347-5.938-1.748-7.887-1.855C4.09 9.5 4.061 9.5 4.036 9.5 3.24 9.5 2 10.063 2 11.46v6.919c0 1.082.83 1.941 1.89 1.996 1.343.073 4.707.356 6.914 1.465.212.105.434.16.665.16h1.06c.224 0 .458-.054.668-.161 2.207-1.109 5.57-1.392 6.914-1.465A1.972 1.972 0 0 0 22 18.414v-6.953c0-1.399-1.238-1.961-2.035-1.961Zm-8.902 10.406c-2.368-1.006-5.395-1.313-7.075-1.401-.07-.005-.113-.052-.113-.09l-.02-6.966a.4.4 0 0 1 .152-.074c1.401.078 4.888.395 7.056 1.61v6.921Zm9.062-1.492c0 .04-.044.083-.112.088-1.675.088-4.703.395-7.075 1.406v-6.924c2.164-1.21 5.628-1.527 7.027-1.609.058.004.152.043.16.086v6.953ZM12 9.5A3.751 3.751 0 0 0 12 2a3.751 3.751 0 0 0 0 7.5Zm0-5.625a1.875 1.875 0 1 1 0 3.75 1.875 1.875 0 0 1 0-3.75Z",
        fill: "currentColor"
      }
    )
  })
);
var BookOpenReader_default = SvgBookOpenReader;

// src/Icon/icons/BookOpen.tsx
import { jsx as jsx237 } from "react/jsx-runtime";
var SvgBookOpen = (props) => /* @__PURE__ */ jsx237(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx237(
      "path",
      {
        d: "M20.781 5.082c-1.635-.591-3.17-.874-4.514-.86-2.038.034-3.562.625-4.267.963-.705-.338-2.226-.929-4.264-.961-1.368-.024-2.883.266-4.517.858A1.861 1.861 0 0 0 2 6.833v10.143c0 .576.264 1.11.724 1.46a1.91 1.91 0 0 0 1.673.325c4.1-1.11 7.014.796 7.136.875a.831.831 0 0 0 .436.142.917.917 0 0 0 .466-.142c.122-.08 3.041-1.986 7.135-.877a1.91 1.91 0 0 0 1.675-.324A1.77 1.77 0 0 0 22 16.972V6.833c0-.782-.517-1.485-1.219-1.75Zm-9.614 12.501a11.007 11.007 0 0 0-4.216-.837c-.916 0-1.92.113-2.988.403a.241.241 0 0 1-.227-.038c-.07-.052-.07-.118-.07-.139V6.833a.2.2 0 0 1 .125-.183c1.422-.514 2.765-.776 3.917-.758a8.863 8.863 0 0 1 3.459.743v10.948Zm9.166-.61c0 .02 0 .083-.07.137a.251.251 0 0 1-.225.038c-3.16-.854-5.743-.174-7.205.436V6.636a8.85 8.85 0 0 1 3.458-.746c1.135-.018 2.496.245 3.916.759a.199.199 0 0 1 .126.184v10.14Z",
        fill: "currentColor"
      }
    )
  })
);
var BookOpen_default = SvgBookOpen;

// src/Icon/icons/BookUser.tsx
import { jsx as jsx238 } from "react/jsx-runtime";
var SvgBookUser = (props) => /* @__PURE__ */ jsx238(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx238(
      "path",
      {
        d: "M20.75 15.75V3.875C20.75 2.841 19.91 2 18.875 2h-12.5A3.128 3.128 0 0 0 3.25 5.125v13.75A3.129 3.129 0 0 0 6.375 22h13.438a.938.938 0 0 0 0-1.875H19.5V17.51a1.873 1.873 0 0 0 1.25-1.76Zm-3.125 4.375H6.375a1.251 1.251 0 0 1 0-2.5h11.25v2.5Zm1.25-4.375H17v-.625A3.124 3.124 0 0 0 13.875 12h-2.5a3.124 3.124 0 0 0-3.125 3.125v.625H6.375c-.445 0-.867.093-1.25.261V5.125c0-.69.56-1.25 1.25-1.25h12.5V15.75Zm-6.25-5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
        fill: "currentColor"
      }
    )
  })
);
var BookUser_default = SvgBookUser;

// src/Icon/icons/Book.tsx
import { jsx as jsx239 } from "react/jsx-runtime";
var SvgBook = (props) => /* @__PURE__ */ jsx239(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx239(
      "path",
      {
        d: "M20.75 15.75V3.875C20.75 2.841 19.91 2 18.875 2h-12.5A3.128 3.128 0 0 0 3.25 5.125v13.75A3.129 3.129 0 0 0 6.375 22h13.438a.938.938 0 0 0 0-1.875H19.5V17.51a1.873 1.873 0 0 0 1.25-1.76Zm-3.125 4.375H6.375a1.251 1.251 0 0 1 0-2.5h11.25v2.5Zm1.25-4.375h-12.5c-.445 0-.867.093-1.25.261V5.125c0-.69.56-1.25 1.25-1.25h12.5V15.75Zm-9.688-7.5h6.876c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937H9.188a.94.94 0 0 0-.937.938.94.94 0 0 0 .938.937Zm0 3.125h6.876c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937H9.188a.94.94 0 0 0-.937.938.94.94 0 0 0 .938.937Z",
        fill: "currentColor"
      }
    )
  })
);
var Book_default = SvgBook;

// src/Icon/icons/BookmarkSlash.tsx
import { jsx as jsx240 } from "react/jsx-runtime";
var SvgBookmarkSlash = (props) => /* @__PURE__ */ jsx240(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx240(
      "path",
      {
        d: "m21.718 18.66-3.714-2.938V5.498a1.5 1.5 0 0 0-1.5-1.5H7.5a1.5 1.5 0 0 0-1.5 1.5v.844L3.213 4.157a.75.75 0 1 0-.926 1.18l18.505 14.505c.138.106.3.16.435.16a.748.748 0 0 0 .59-.288.723.723 0 0 0-.1-1.053Zm-5.214-4.085L7.5 7.52V5.685c0-.105.081-.187.16-.187h8.627c.134 0 .216.082.216.187v8.89Zm-4.502.925-4.5 2.626v-6.808L6 10.143V19a1 1 0 0 0 1.504.864l4.497-2.627 4.498 2.624a.997.997 0 0 0 1.388-.405l-2.617-2.05-3.269-1.907Z",
        fill: "currentColor"
      }
    )
  })
);
var BookmarkSlash_default = SvgBookmarkSlash;

// src/Icon/icons/Bookmark.tsx
import { jsx as jsx241 } from "react/jsx-runtime";
var SvgBookmark = (props) => /* @__PURE__ */ jsx241(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx241(
      "path",
      {
        d: "M17.626 2H6.374C5.34 2 4.5 2.84 4.5 3.875v16.873a1.25 1.25 0 0 0 1.88 1.08L12 18.548l5.622 3.28c.832.451 1.879-.115 1.879-1.08V3.875C19.5 2.84 18.66 2 17.626 2Zm0 17.658L12 16.376l-5.626 3.282V4.11c0-.132.103-.235.2-.235h10.782c.168 0 .27.103.27.235v15.548Z",
        fill: "currentColor"
      }
    )
  })
);
var Bookmark_default = SvgBookmark;

// src/Icon/icons/Books.tsx
import { jsx as jsx242 } from "react/jsx-runtime";
var SvgBooks = (props) => /* @__PURE__ */ jsx242(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx242(
      "path",
      {
        d: "M21.937 19.008 17.73 3.388a1.877 1.877 0 0 0-2.295-1.323l-2.415.643c-.23.062-.435.167-.617.298A1.872 1.872 0 0 0 10.75 2h-2.5c-.344 0-.66.1-.938.26A1.855 1.855 0 0 0 6.375 2h-2.5C2.839 2 2 2.84 2 3.875v16.25C2 21.16 2.84 22 3.875 22h2.5c.343 0 .66-.1.937-.26.278.162.594.26.938.26h2.5c1.035 0 1.874-.84 1.874-1.875V8.457l3.274 12.16a1.876 1.876 0 0 0 2.295 1.319l2.415-.644a1.87 1.87 0 0 0 1.329-2.285ZM10.75 3.875V5.75h-2.5V3.875h2.5Zm-2.5 3.75h2.5v8.75h-2.5v-8.75Zm-1.875 8.75h-2.5v-8.75h2.5v8.75Zm0-12.5V5.75h-2.5V3.875h2.5Zm-2.5 16.25V18.25h2.5v1.875h-2.5Zm4.375 0v-1.84l2.5-.035v1.875h-2.5ZM13.5 4.52l2.415-.644.487 1.793-2.418.644-.485-1.793Zm.972 3.597 2.418-.645 2.267 8.41-2.418.645-2.267-8.41ZM17.71 20.13l-.485-1.799 2.419-.645.483 1.795-2.417.649Z",
        fill: "currentColor"
      }
    )
  })
);
var Books_default = SvgBooks;

// src/Icon/icons/BorderAll.tsx
import { jsx as jsx243 } from "react/jsx-runtime";
var SvgBorderAll = (props) => /* @__PURE__ */ jsx243(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx243(
      "path",
      {
        d: "M19.143 2A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857A2.857 2.857 0 0 1 4.857 2h14.286Zm0 2.143H13.07v6.786h6.786V4.857a.715.715 0 0 0-.714-.714Zm.714 8.928h-6.786v6.786h6.072a.716.716 0 0 0 .714-.714V13.07ZM10.93 10.93V4.143H4.857a.714.714 0 0 0-.714.714v6.072h6.786Zm-6.786 8.214c0 .393.32.714.714.714h6.072v-6.786H4.143v6.072Z",
        fill: "currentColor"
      }
    )
  })
);
var BorderAll_default = SvgBorderAll;

// src/Icon/icons/BorderBottomRight.tsx
import { jsx as jsx244 } from "react/jsx-runtime";
var SvgBorderBottomRight = (props) => /* @__PURE__ */ jsx244(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx244(
      "path",
      {
        d: "M22 18.786A3.212 3.212 0 0 1 18.786 22H3.07a1.07 1.07 0 1 1 0-2.143h15.715c.593 0 1.071-.477 1.071-1.071V3.07a1.07 1.07 0 1 1 2.143 0v15.715ZM14.857 3.429a1.428 1.428 0 1 1 2.856-.002 1.428 1.428 0 0 1-2.856.002Zm-8.571 0a1.428 1.428 0 1 1 2.856-.002 1.428 1.428 0 0 1-2.856.002ZM12 2a1.428 1.428 0 1 1 .001 2.856A1.428 1.428 0 0 1 12 2ZM2 3.429a1.429 1.429 0 1 1 2.857 0 1.429 1.429 0 0 1-2.857 0Zm1.429 7.142a1.428 1.428 0 1 1 0 2.856 1.428 1.428 0 0 1 0-2.856ZM2 7.714a1.428 1.428 0 1 1 2.856-.001A1.428 1.428 0 0 1 2 7.714Zm1.429 7.143a1.428 1.428 0 1 1 0 2.856 1.428 1.428 0 0 1 0-2.856Z",
        fill: "currentColor"
      }
    )
  })
);
var BorderBottomRight_default = SvgBorderBottomRight;

// src/Icon/icons/BorderBottom.tsx
import { jsx as jsx245 } from "react/jsx-runtime";
var SvgBorderBottom = (props) => /* @__PURE__ */ jsx245(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx245(
      "path",
      {
        d: "M22 20.929c0 .593-.478 1.071-1.071 1.071H3.07a1.07 1.07 0 1 1 0-2.143H20.93c.593 0 1.071.478 1.071 1.072Zm0-4.643c0 .79-.638 1.428-1.429 1.428-.79 0-1.428-.638-1.428-1.428a1.427 1.427 0 1 1 2.857 0ZM3.429 14.857a1.428 1.428 0 1 1 0 2.856 1.428 1.428 0 0 1 0-2.856Zm10 1.429c0 .79-.639 1.428-1.429 1.428s-1.429-.638-1.429-1.428c0-.79.639-1.429 1.429-1.429s1.429.639 1.429 1.429Zm7.142-10a1.427 1.427 0 1 1 0 2.857c-.79 0-1.428-.639-1.428-1.429s.638-1.428 1.428-1.428ZM4.857 7.714a1.428 1.428 0 1 1-2.856.002 1.428 1.428 0 0 1 2.856-.002ZM12 6.286a1.427 1.427 0 1 1 0 2.857c-.79 0-1.429-.639-1.429-1.429S11.21 6.286 12 6.286ZM22 12c0 .79-.638 1.429-1.429 1.429-.79 0-1.428-.639-1.428-1.429s.638-1.429 1.428-1.429c.79 0 1.429.639 1.429 1.429ZM3.429 10.571a1.428 1.428 0 1 1 0 2.856 1.428 1.428 0 0 1 0-2.856Zm10 1.429c0 .79-.639 1.429-1.429 1.429S10.571 12.79 10.571 12s.639-1.429 1.429-1.429 1.429.639 1.429 1.429ZM20.57 2a1.428 1.428 0 1 1 .002 2.856A1.428 1.428 0 0 1 20.57 2ZM4.857 3.429a1.429 1.429 0 1 1-2.857 0 1.429 1.429 0 0 1 2.857 0ZM12 2a1.428 1.428 0 1 1 .001 2.856A1.428 1.428 0 0 1 12 2Zm5.714 10a1.427 1.427 0 1 1-2.857 0c0-.79.638-1.429 1.429-1.429.79 0 1.428.639 1.428 1.429ZM16.286 2a1.428 1.428 0 1 1 .001 2.856A1.428 1.428 0 0 1 16.286 2ZM9.143 3.429a1.428 1.428 0 1 1-2.856 0 1.428 1.428 0 0 1 2.856 0ZM7.714 10.57c.79 0 1.429.639 1.429 1.429s-.639 1.429-1.429 1.429S6.286 12.79 6.286 12s.638-1.429 1.428-1.429Z",
        fill: "currentColor"
      }
    )
  })
);
var BorderBottom_default = SvgBorderBottom;

// src/Icon/icons/BorderCenterH.tsx
import { jsx as jsx246 } from "react/jsx-runtime";
var SvgBorderCenterH = (props) => /* @__PURE__ */ jsx246(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx246(
      "path",
      {
        d: "M3.429 22a1.428 1.428 0 1 1-.002-2.856A1.428 1.428 0 0 1 3.43 22Zm4.285 0c-.79 0-1.428-.638-1.428-1.429 0-.79.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857Zm0-17.143a1.428 1.428 0 1 1-.001-2.856 1.428 1.428 0 0 1 .001 2.856Zm10 15.714a1.427 1.427 0 1 1-2.857 0c0-.79.638-1.428 1.429-1.428.79 0 1.428.638 1.428 1.428ZM16.286 4.857a1.428 1.428 0 1 1-.002-2.856 1.428 1.428 0 0 1 .002 2.856Zm-2.857 15.714c0 .79-.639 1.429-1.429 1.429s-1.429-.638-1.429-1.429c0-.79.639-1.428 1.429-1.428s1.429.638 1.429 1.428ZM12 4.857a1.428 1.428 0 1 1-.001-2.856A1.428 1.428 0 0 1 12 4.857Zm10 15.714c0 .79-.638 1.429-1.429 1.429-.79 0-1.428-.638-1.428-1.429 0-.79.638-1.428 1.428-1.428.79 0 1.429.638 1.429 1.428ZM22 3.43a1.428 1.428 0 1 1-2.856 0 1.428 1.428 0 0 1 2.856 0ZM3.429 4.857a1.429 1.429 0 1 1 0-2.857 1.429 1.429 0 0 1 0 2.857Zm10 11.429c0 .79-.639 1.428-1.429 1.428s-1.429-.638-1.429-1.428c0-.79.639-1.429 1.429-1.429s1.429.639 1.429 1.429Zm7.142 1.428c-.79 0-1.428-.638-1.428-1.428a1.427 1.427 0 1 1 2.857 0c0 .79-.638 1.428-1.429 1.428ZM4.857 16.286a1.428 1.428 0 1 1-2.856.001 1.428 1.428 0 0 1 2.856-.001Zm15.714-7.143c-.79 0-1.428-.639-1.428-1.429s.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857ZM4.857 7.714a1.428 1.428 0 1 1-2.856.002 1.428 1.428 0 0 1 2.856-.002ZM12 9.143c-.79 0-1.429-.639-1.429-1.429S11.21 6.286 12 6.286s1.429.638 1.429 1.428c0 .79-.639 1.429-1.429 1.429Zm8.929 1.786c.593 0 1.071.477 1.071 1.071s-.478 1.071-1.071 1.071H3.07a1.07 1.07 0 1 1 0-2.142H20.93Z",
        fill: "currentColor"
      }
    )
  })
);
var BorderCenterH_default = SvgBorderCenterH;

// src/Icon/icons/BorderCenterV.tsx
import { jsx as jsx247 } from "react/jsx-runtime";
var SvgBorderCenterV = (props) => /* @__PURE__ */ jsx247(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx247(
      "path",
      {
        d: "M22 20.571c0 .79-.638 1.429-1.429 1.429-.79 0-1.428-.638-1.428-1.429 0-.79.638-1.428 1.428-1.428.79 0 1.429.638 1.429 1.428Zm0-4.285c0 .79-.638 1.428-1.429 1.428-.79 0-1.428-.638-1.428-1.428a1.427 1.427 0 1 1 2.857 0Zm-17.143 0a1.428 1.428 0 1 1-2.856.001 1.428 1.428 0 0 1 2.856-.001Zm15.714-10a1.427 1.427 0 1 1 0 2.857c-.79 0-1.428-.639-1.428-1.429s.638-1.428 1.428-1.428ZM4.857 7.714a1.428 1.428 0 1 1-2.856.002 1.428 1.428 0 0 1 2.856-.002Zm15.714 2.857c.79 0 1.429.639 1.429 1.429s-.638 1.429-1.429 1.429c-.79 0-1.428-.639-1.428-1.429s.638-1.429 1.428-1.429ZM4.857 12a1.428 1.428 0 1 1-2.856.001A1.428 1.428 0 0 1 4.857 12ZM20.571 2a1.428 1.428 0 1 1 .002 2.856A1.428 1.428 0 0 1 20.57 2ZM3.43 2a1.429 1.429 0 1 1 0 2.857 1.429 1.429 0 0 1 0-2.857Zm1.428 18.571a1.428 1.428 0 1 1-2.856.002 1.428 1.428 0 0 1 2.856-.002Zm11.429-10c.79 0 1.428.639 1.428 1.429s-.638 1.429-1.428 1.429c-.79 0-1.429-.639-1.429-1.429s.639-1.429 1.429-1.429Zm1.428-7.142a1.428 1.428 0 1 1-2.856 0 1.428 1.428 0 0 1 2.856 0Zm-1.428 15.714c.79 0 1.428.638 1.428 1.428a1.427 1.427 0 1 1-2.857 0c0-.79.638-1.428 1.429-1.428ZM9.143 3.429a1.428 1.428 0 1 1-2.856 0 1.428 1.428 0 0 1 2.856 0ZM7.714 19.143a1.427 1.427 0 1 1 0 2.857c-.79 0-1.428-.638-1.428-1.429 0-.79.638-1.428 1.428-1.428ZM9.143 12c0 .79-.639 1.429-1.429 1.429S6.286 12.79 6.286 12s.638-1.429 1.428-1.429c.79 0 1.429.639 1.429 1.429Zm1.786-8.929a1.07 1.07 0 1 1 2.142 0V20.93c0 .593-.477 1.071-1.071 1.071a1.069 1.069 0 0 1-1.071-1.071V3.07Z",
        fill: "currentColor"
      }
    )
  })
);
var BorderCenterV_default = SvgBorderCenterV;

// src/Icon/icons/BorderInner.tsx
import { jsx as jsx248 } from "react/jsx-runtime";
var SvgBorderInner = (props) => /* @__PURE__ */ jsx248(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx248(
      "path",
      {
        d: "M19.143 20.571c0-.79.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857c-.79 0-1.428-.638-1.428-1.429Zm0-4.285a1.427 1.427 0 1 1 2.857 0c0 .79-.638 1.428-1.429 1.428-.79 0-1.428-.638-1.428-1.428ZM2 16.286a1.428 1.428 0 1 1 2.856-.002A1.428 1.428 0 0 1 2 16.286Zm20-8.572c0 .79-.638 1.429-1.429 1.429-.79 0-1.428-.639-1.428-1.429s.638-1.428 1.428-1.428c.79 0 1.429.638 1.429 1.428Zm-20 0a1.428 1.428 0 1 1 2.856-.001A1.428 1.428 0 0 1 2 7.714ZM22 3.43a1.428 1.428 0 1 1-2.856 0 1.428 1.428 0 0 1 2.856 0Zm-17.143 0a1.429 1.429 0 1 1-2.857 0 1.429 1.429 0 0 1 2.857 0ZM2 20.57a1.428 1.428 0 1 1 2.856-.001A1.428 1.428 0 0 1 2 20.571ZM17.714 3.43a1.428 1.428 0 1 1-2.856 0 1.428 1.428 0 0 1 2.856 0ZM14.857 20.57c0-.79.639-1.428 1.429-1.428s1.428.638 1.428 1.428a1.427 1.427 0 1 1-2.857 0ZM9.143 3.43a1.428 1.428 0 1 1-2.856 0 1.428 1.428 0 0 1 2.856 0ZM6.286 20.57c0-.79.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857c-.79 0-1.428-.638-1.428-1.429ZM12 22a1.069 1.069 0 0 1-1.071-1.071V13.07H3.07a1.07 1.07 0 1 1 0-2.142h7.858V3.07a1.07 1.07 0 1 1 2.142 0v7.858h7.858c.593 0 1.071.477 1.071 1.071s-.478 1.071-1.071 1.071H13.07v7.858c0 .593-.477 1.071-1.071 1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var BorderInner_default = SvgBorderInner;

// src/Icon/icons/BorderLeft.tsx
import { jsx as jsx249 } from "react/jsx-runtime";
var SvgBorderLeft = (props) => /* @__PURE__ */ jsx249(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx249(
      "path",
      {
        d: "M3.071 22A1.07 1.07 0 0 1 2 20.929V3.07a1.072 1.072 0 0 1 2.143 0V20.93A1.07 1.07 0 0 1 3.07 22Zm4.643 0c-.79 0-1.428-.638-1.428-1.429 0-.79.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857ZM9.143 3.429a1.428 1.428 0 1 1-2.856 0 1.428 1.428 0 0 1 2.856 0Zm-1.429 10c-.79 0-1.428-.639-1.428-1.429s.638-1.429 1.428-1.429c.79 0 1.429.639 1.429 1.429s-.639 1.429-1.429 1.429Zm10 7.142a1.427 1.427 0 1 1-2.857 0c0-.79.638-1.428 1.429-1.428.79 0 1.428.638 1.428 1.428ZM16.286 4.857a1.428 1.428 0 1 1-.002-2.856 1.428 1.428 0 0 1 .002 2.856ZM17.714 12a1.427 1.427 0 1 1-2.857 0c0-.79.638-1.429 1.429-1.429.79 0 1.428.639 1.428 1.429ZM12 22c-.79 0-1.429-.638-1.429-1.429 0-.79.639-1.428 1.429-1.428s1.429.638 1.429 1.428c0 .79-.639 1.429-1.429 1.429Zm1.429-18.571a1.428 1.428 0 1 1-2.856 0 1.428 1.428 0 0 1 2.856 0Zm-1.429 10c-.79 0-1.429-.639-1.429-1.429s.639-1.429 1.429-1.429 1.429.639 1.429 1.429-.639 1.429-1.429 1.429Zm10 7.142c0 .79-.638 1.429-1.429 1.429-.79 0-1.428-.638-1.428-1.429 0-.79.638-1.428 1.428-1.428.79 0 1.429.638 1.429 1.428ZM20.571 4.857a1.428 1.428 0 1 1-.001-2.855 1.428 1.428 0 0 1 .001 2.855ZM22 12c0 .79-.638 1.429-1.429 1.429-.79 0-1.428-.639-1.428-1.429s.638-1.429 1.428-1.429c.79 0 1.429.639 1.429 1.429Zm-10 5.714a1.427 1.427 0 1 1 0-2.857c.79 0 1.429.638 1.429 1.429 0 .79-.639 1.428-1.429 1.428Zm10-1.428c0 .79-.638 1.428-1.429 1.428-.79 0-1.428-.638-1.428-1.428a1.427 1.427 0 1 1 2.857 0Zm-1.429-7.143c-.79 0-1.428-.639-1.428-1.429s.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857ZM13.43 7.714c0 .79-.639 1.429-1.429 1.429s-1.429-.639-1.429-1.429S11.21 6.286 12 6.286s1.429.638 1.429 1.428Z",
        fill: "currentColor"
      }
    )
  })
);
var BorderLeft_default = SvgBorderLeft;

// src/Icon/icons/BorderNone.tsx
import { jsx as jsx250 } from "react/jsx-runtime";
var SvgBorderNone = (props) => /* @__PURE__ */ jsx250(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx250(
      "path",
      {
        d: "M4.857 20.571a1.428 1.428 0 1 1-2.856.002 1.428 1.428 0 0 1 2.856-.002ZM7.714 22c-.79 0-1.428-.638-1.428-1.429 0-.79.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857Zm0-17.143a1.428 1.428 0 1 1-.001-2.856 1.428 1.428 0 0 1 .001 2.856ZM9.143 12c0 .79-.639 1.429-1.429 1.429S6.286 12.79 6.286 12s.638-1.429 1.428-1.429c.79 0 1.429.639 1.429 1.429Zm7.143 10c-.79 0-1.429-.638-1.429-1.429 0-.79.639-1.428 1.429-1.428s1.428.638 1.428 1.428c0 .79-.638 1.429-1.428 1.429Zm1.428-18.571a1.428 1.428 0 1 1-2.856 0 1.428 1.428 0 0 1 2.856 0Zm-1.428 10c-.79 0-1.429-.639-1.429-1.429s.639-1.429 1.429-1.429 1.428.639 1.428 1.429-.638 1.429-1.428 1.429Zm-2.857 7.142c0 .79-.639 1.429-1.429 1.429s-1.429-.638-1.429-1.429c0-.79.639-1.428 1.429-1.428s1.429.638 1.429 1.428ZM12 4.857a1.428 1.428 0 1 1-.001-2.856A1.428 1.428 0 0 1 12 4.857ZM13.429 12c0 .79-.639 1.429-1.429 1.429S10.571 12.79 10.571 12s.639-1.429 1.429-1.429 1.429.639 1.429 1.429Zm7.142 10c-.79 0-1.428-.638-1.428-1.429 0-.79.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857Zm0-17.143a1.428 1.428 0 1 1-.001-2.855 1.428 1.428 0 0 1 .001 2.855ZM4.857 3.43a1.429 1.429 0 1 1-2.857 0 1.429 1.429 0 0 1 2.857 0Zm15.714 10c-.79 0-1.428-.639-1.428-1.429s.638-1.429 1.428-1.429c.79 0 1.429.639 1.429 1.429s-.638 1.429-1.429 1.429ZM4.857 12a1.428 1.428 0 1 1-2.856.001A1.428 1.428 0 0 1 4.857 12ZM12 17.714a1.427 1.427 0 1 1 0-2.857c.79 0 1.429.638 1.429 1.429 0 .79-.639 1.428-1.429 1.428Zm10-1.428c0 .79-.638 1.428-1.429 1.428-.79 0-1.428-.638-1.428-1.428a1.427 1.427 0 1 1 2.857 0ZM3.429 17.714a1.428 1.428 0 1 1-.002-2.856 1.428 1.428 0 0 1 .002 2.856ZM22 7.714c0 .79-.638 1.429-1.429 1.429-.79 0-1.428-.639-1.428-1.429s.638-1.428 1.428-1.428c.79 0 1.429.638 1.429 1.428ZM3.429 9.143a1.428 1.428 0 1 1-.002-2.856 1.428 1.428 0 0 1 .002 2.856Zm10-1.429c0 .79-.639 1.429-1.429 1.429s-1.429-.639-1.429-1.429S11.21 6.286 12 6.286s1.429.638 1.429 1.428Z",
        fill: "currentColor"
      }
    )
  })
);
var BorderNone_default = SvgBorderNone;

// src/Icon/icons/BorderOuter.tsx
import { jsx as jsx251 } from "react/jsx-runtime";
var SvgBorderOuter = (props) => /* @__PURE__ */ jsx251(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx251(
      "path",
      {
        d: "M13.429 7.714c0 .79-.639 1.429-1.429 1.429s-1.429-.639-1.429-1.429S11.21 6.286 12 6.286s1.429.638 1.429 1.428ZM6.286 12a1.427 1.427 0 1 1 2.857 0c0 .79-.639 1.429-1.429 1.429S6.286 12.79 6.286 12Zm7.143 0c0 .79-.639 1.429-1.429 1.429S10.571 12.79 10.571 12s.639-1.429 1.429-1.429 1.429.639 1.429 1.429Zm1.428 0c0-.79.639-1.429 1.429-1.429s1.428.639 1.428 1.429-.638 1.429-1.428 1.429c-.79 0-1.429-.639-1.429-1.429Zm-1.428 4.286c0 .79-.639 1.428-1.429 1.428s-1.429-.638-1.429-1.428c0-.79.639-1.429 1.429-1.429s1.429.639 1.429 1.429ZM2 4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857Zm2.143 0v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714H4.857a.714.714 0 0 0-.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var BorderOuter_default = SvgBorderOuter;

// src/Icon/icons/BorderRight.tsx
import { jsx as jsx252 } from "react/jsx-runtime";
var SvgBorderRight = (props) => /* @__PURE__ */ jsx252(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx252(
      "path",
      {
        d: "M20.929 2C21.522 2 22 2.48 22 3.071V20.93c0 .593-.478 1.071-1.071 1.071a1.069 1.069 0 0 1-1.072-1.071V3.07A1.07 1.07 0 0 1 20.93 2Zm-4.643 0a1.428 1.428 0 1 1 .001 2.856A1.428 1.428 0 0 1 16.286 2Zm-1.429 18.571c0-.79.639-1.428 1.429-1.428s1.428.638 1.428 1.428a1.427 1.427 0 1 1-2.857 0Zm1.429-10c.79 0 1.428.639 1.428 1.429s-.638 1.429-1.428 1.429c-.79 0-1.429-.639-1.429-1.429s.639-1.429 1.429-1.429Zm-10-7.142a1.428 1.428 0 1 1 2.856-.002 1.428 1.428 0 0 1-2.856.002Zm1.428 15.714a1.427 1.427 0 1 1 0 2.857c-.79 0-1.428-.638-1.428-1.429 0-.79.638-1.428 1.428-1.428ZM6.286 12a1.427 1.427 0 1 1 2.857 0c0 .79-.639 1.429-1.429 1.429S6.286 12.79 6.286 12ZM12 2a1.428 1.428 0 1 1 .001 2.856A1.428 1.428 0 0 1 12 2Zm-1.429 18.571c0-.79.639-1.428 1.429-1.428s1.429.638 1.429 1.428c0 .79-.639 1.429-1.429 1.429s-1.429-.638-1.429-1.429Zm1.429-10c.79 0 1.429.639 1.429 1.429S12.79 13.429 12 13.429 10.571 12.79 10.571 12s.639-1.429 1.429-1.429ZM2 3.43a1.429 1.429 0 1 1 2.857 0 1.429 1.429 0 0 1-2.857 0Zm1.429 15.714a1.428 1.428 0 1 1 .001 2.856 1.428 1.428 0 0 1-.001-2.856ZM2 12a1.428 1.428 0 1 1 2.856-.001A1.428 1.428 0 0 1 2 12Zm10-5.714a1.427 1.427 0 1 1 0 2.857c-.79 0-1.429-.639-1.429-1.429S11.21 6.286 12 6.286ZM2 7.714a1.428 1.428 0 1 1 2.856-.001A1.428 1.428 0 0 1 2 7.714Zm1.429 7.143a1.428 1.428 0 1 1 0 2.856 1.428 1.428 0 0 1 0-2.856Zm7.142 1.429c0-.79.639-1.429 1.429-1.429s1.429.639 1.429 1.429-.639 1.428-1.429 1.428-1.429-.638-1.429-1.428Z",
        fill: "currentColor"
      }
    )
  })
);
var BorderRight_default = SvgBorderRight;

// src/Icon/icons/BorderTopLeft.tsx
import { jsx as jsx253 } from "react/jsx-runtime";
var SvgBorderTopLeft = (props) => /* @__PURE__ */ jsx253(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx253(
      "path",
      {
        d: "M2 5.214A3.215 3.215 0 0 1 5.214 2H20.93a1.07 1.07 0 1 1 0 2.143H5.214c-.591 0-1.071.48-1.071 1.071V20.93a1.07 1.07 0 1 1-2.143 0V5.214Zm7.143 15.357c0 .79-.639 1.429-1.429 1.429s-1.428-.638-1.428-1.429c0-.79.638-1.428 1.428-1.428.79 0 1.429.638 1.429 1.428Zm8.571 0a1.427 1.427 0 1 1-2.857 0c0-.79.638-1.428 1.429-1.428.79 0 1.428.638 1.428 1.428ZM12 22c-.79 0-1.429-.638-1.429-1.429 0-.79.639-1.428 1.429-1.428s1.429.638 1.429 1.428c0 .79-.639 1.429-1.429 1.429Zm10-1.429c0 .79-.638 1.429-1.429 1.429-.79 0-1.428-.638-1.428-1.429 0-.79.638-1.428 1.428-1.428.79 0 1.429.638 1.429 1.428Zm-1.429-7.142c-.79 0-1.428-.639-1.428-1.429s.638-1.429 1.428-1.429c.79 0 1.429.639 1.429 1.429s-.638 1.429-1.429 1.429ZM22 16.286c0 .79-.638 1.428-1.429 1.428-.79 0-1.428-.638-1.428-1.428a1.427 1.427 0 1 1 2.857 0Zm-1.429-7.143c-.79 0-1.428-.639-1.428-1.429s.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857Z",
        fill: "currentColor"
      }
    )
  })
);
var BorderTopLeft_default = SvgBorderTopLeft;

// src/Icon/icons/BorderTop.tsx
import { jsx as jsx254 } from "react/jsx-runtime";
var SvgBorderTop = (props) => /* @__PURE__ */ jsx254(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx254(
      "path",
      {
        d: "M2 3.071C2 2.48 2.48 2 3.071 2H20.93a1.07 1.07 0 1 1 0 2.143H3.07C2.48 4.143 2 3.663 2 3.07Zm0 4.643a1.428 1.428 0 1 1 2.856-.001A1.428 1.428 0 0 1 2 7.714Zm18.571 1.429c-.79 0-1.428-.639-1.428-1.429s.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857Zm-10-1.429c0-.79.639-1.428 1.429-1.428s1.429.638 1.429 1.428c0 .79-.639 1.429-1.429 1.429s-1.429-.639-1.429-1.429Zm-7.142 10a1.428 1.428 0 1 1-.002-2.856 1.428 1.428 0 0 1 .002 2.856Zm15.714-1.428a1.427 1.427 0 1 1 2.857 0c0 .79-.638 1.428-1.429 1.428-.79 0-1.428-.638-1.428-1.428ZM12 17.714a1.427 1.427 0 1 1 0-2.857c.79 0 1.429.638 1.429 1.429 0 .79-.639 1.428-1.429 1.428ZM2 12a1.428 1.428 0 1 1 2.856-.001A1.428 1.428 0 0 1 2 12Zm18.571 1.429c-.79 0-1.428-.639-1.428-1.429s.638-1.429 1.428-1.429c.79 0 1.429.639 1.429 1.429s-.638 1.429-1.429 1.429Zm-10-1.429c0-.79.639-1.429 1.429-1.429s1.429.639 1.429 1.429-.639 1.429-1.429 1.429-1.429-.639-1.429-1.429ZM3.43 22a1.428 1.428 0 1 1-.002-2.856A1.428 1.428 0 0 1 3.43 22Zm15.714-1.429c0-.79.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857c-.79 0-1.428-.638-1.428-1.429ZM12 22c-.79 0-1.429-.638-1.429-1.429 0-.79.639-1.428 1.429-1.428s1.429.638 1.429 1.428c0 .79-.639 1.429-1.429 1.429ZM6.286 12a1.427 1.427 0 1 1 2.857 0c0 .79-.639 1.429-1.429 1.429S6.286 12.79 6.286 12Zm1.428 10c-.79 0-1.428-.638-1.428-1.429 0-.79.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857Zm7.143-1.429c0-.79.639-1.428 1.429-1.428s1.428.638 1.428 1.428a1.427 1.427 0 1 1-2.857 0Zm1.429-7.142c-.79 0-1.429-.639-1.429-1.429s.639-1.429 1.429-1.429 1.428.639 1.428 1.429-.638 1.429-1.428 1.429Z",
        fill: "currentColor"
      }
    )
  })
);
var BorderTop_default = SvgBorderTop;

// src/Icon/icons/BoxArchive.tsx
import { jsx as jsx255 } from "react/jsx-runtime";
var SvgBoxArchive = (props) => /* @__PURE__ */ jsx255(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx255(
      "path",
      {
        d: "M20.125 3.25H3.875C2.839 3.25 2 4.09 2 5.125v2.5c0 .688.563 1.25 1.215 1.25l.035 9.375a2.5 2.5 0 0 0 2.5 2.5h12.5a2.5 2.5 0 0 0 2.5-2.5V8.875c.688 0 1.25-.563 1.25-1.215V5.125c0-1.036-.84-1.875-1.875-1.875ZM18.25 18.875H5.75a.625.625 0 0 1-.625-.625V8.875h13.75v9.375a.627.627 0 0 1-.625.625ZM20.125 7H3.875V5.125h16.25V7ZM9.152 12.625h5.625c.555 0 .973-.418.973-.938a.935.935 0 0 0-.938-.937h-5.66a.92.92 0 0 0-.902.902c0 .555.418.973.902.973Z",
        fill: "currentColor"
      }
    )
  })
);
var BoxArchive_default = SvgBoxArchive;

// src/Icon/icons/BoxBallot.tsx
import { jsx as jsx256 } from "react/jsx-runtime";
var SvgBoxBallot = (props) => /* @__PURE__ */ jsx256(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx256(
      "path",
      {
        d: "M20.056 8.667h-1.39v1.666h1.39c.152 0 .277.125.277.278v3.611H3.667v-3.61c0-.154.124-.279.277-.279h1.39V8.667h-1.39A1.946 1.946 0 0 0 2 10.61v8.333c0 1.073.873 1.945 1.944 1.945h16.112A1.947 1.947 0 0 0 22 18.944v-8.333a1.946 1.946 0 0 0-1.944-1.944Zm.277 10.277a.278.278 0 0 1-.277.278H3.944a.278.278 0 0 1-.277-.278V15.89h16.666v3.055ZM7.556 12h8.888c.614 0 1.112-.498 1.112-1.111V4.222c0-.613-.498-1.11-1.112-1.11H7.556a1.11 1.11 0 0 0-1.112 1.11v6.667A1.11 1.11 0 0 0 7.556 12Zm.555-7.222h7.778v5.555H8.11V4.778Z",
        fill: "currentColor"
      }
    )
  })
);
var BoxBallot_default = SvgBoxBallot;

// src/Icon/icons/BoxCheck.tsx
import { jsx as jsx257 } from "react/jsx-runtime";
var SvgBoxCheck = (props) => /* @__PURE__ */ jsx257(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx257(
      "path",
      {
        d: "M11.29 18.076c-.38.455-1.058.455-1.477 0l-2.5-2.5c-.416-.38-.416-1.058 0-1.478.42-.415 1.098-.415 1.477 0l1.781 1.746 4.242-4.246c.42-.415 1.098-.415 1.477 0 .456.42.456 1.098 0 1.478l-5 5ZM21.755 7.875c.16.366.245.759.245 1.16v10.108A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V9.036c0-.402.084-.795.246-1.161l1.857-4.178A2.857 2.857 0 0 1 6.714 2h10.572a2.86 2.86 0 0 1 2.611 1.697l1.858 4.178Zm-8.684-.16h6.268l-1.401-3.148a.71.71 0 0 0-.652-.424H13.07v3.571ZM4.143 19.142c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V9.857H4.143v9.286Zm6.786-15H6.714a.714.714 0 0 0-.653.424L4.662 7.714h6.267V4.143Z",
        fill: "currentColor"
      }
    )
  })
);
var BoxCheck_default = SvgBoxCheck;

// src/Icon/icons/BoxCircleCheck.tsx
import { jsx as jsx258 } from "react/jsx-runtime";
var SvgBoxCircleCheck = (props) => /* @__PURE__ */ jsx258(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx258(
      "path",
      {
        d: "M3.667 17c0 .305.248.555.555.555h7.052c.268.608.601 1.17 1.01 1.667H4.223A2.223 2.223 0 0 1 2 17V9.139c0-.313.065-.618.192-.903l1.444-3.25a2.222 2.222 0 0 1 2.03-1.32h8.223c.878 0 1.674.518 2.031 1.32l1.445 3.25c.125.285.19.59.19.903v.108a6.065 6.065 0 0 0-3.104.531H3.667V17ZM13.889 5.333H10.61v2.778h4.875l-1.09-2.448a.553.553 0 0 0-.507-.33ZM4.07 8.111h4.873V5.333H5.667c-.22 0-.42.13-.508.33L4.07 8.111ZM22 15.333c0 2.76-2.24 5-5 5s-5-2.24-5-5 2.24-5 5-5 5 2.24 5 5Zm-3.448-1.503-2.108 2.107-.996-.996a.551.551 0 0 0-.785 0 .551.551 0 0 0 0 .785l1.39 1.389c.214.218.569.218.784 0l2.5-2.5a.551.551 0 0 0 0-.785.551.551 0 0 0-.785 0Z",
        fill: "currentColor"
      }
    )
  })
);
var BoxCircleCheck_default = SvgBoxCircleCheck;

// src/Icon/icons/BoxDollar.tsx
import { jsx as jsx259 } from "react/jsx-runtime";
var SvgBoxDollar = (props) => /* @__PURE__ */ jsx259(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx259(
      "path",
      {
        d: "M21.755 7.875c.16.366.245.759.245 1.16v10.108A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V9.036c0-.402.084-.795.246-1.161l1.857-4.178A2.857 2.857 0 0 1 6.714 2h10.572a2.86 2.86 0 0 1 2.611 1.697l1.858 4.178Zm-8.684-.16h6.268l-1.401-3.148a.71.71 0 0 0-.652-.424H13.07v3.571Zm-.174 2.856v.282c.295.053.741.143.938.196a.888.888 0 0 1 .634 1.09.888.888 0 0 1-1.09.633c-.174-.044-.776-.16-.973-.232-.544-.044-1.027.027-1.277.156-.28.125-.348.273-.366.362-.026.152 0 .205.01.223.008.023.044.076.16.156.272.188.7.322 1.295.514l.076.009c.54.165 1.263.38 1.803.777.3.214.58.508.755.91.178.407.214.853.133 1.317-.147.849-.71 1.429-1.415 1.728-.214.053-.446.16-.683.205v.246c0 .29-.178.549-.352.714h6.598a.716.716 0 0 0 .714-.714V9.817h-7.312c.174.205.352.464.352.714v.04Zm-1.442-.714H4.143v9.286c0 .393.32.714.714.714h6.598a.9.9 0 0 1-.352-.714v-.286a11.936 11.936 0 0 1-1.33-.406c-.077-.027-.144-.05-.197-.107-.469-.116-.723-.62-.567-1.09a.893.893 0 0 1 1.13-.567c.089.032.187.063.285.099.424.143.902.303 1.17.348.571.09 1.013.031 1.286-.085.245-.103.33-.236.357-.393.03-.178.004-.259-.014-.294-.013-.04-.053-.103-.165-.183-.263-.192-.683-.33-1.308-.523l-.098-.027c-.522-.156-1.206-.361-1.723-.714a2.21 2.21 0 0 1-.773-.87 2.127 2.127 0 0 1-.152-1.295c.143-.817.724-1.38 1.389-1.683.183-.098.46-.174.71-.228v-.308c0-.25.138-.509.352-.714v.04Zm-.526-5.714H6.714a.714.714 0 0 0-.653.424L4.662 7.714h6.267V4.143Z",
        fill: "currentColor"
      }
    )
  })
);
var BoxDollar_default = SvgBoxDollar;

// src/Icon/icons/BoxOpenFull.tsx
import { jsx as jsx260 } from "react/jsx-runtime";
var SvgBoxOpenFull = (props) => /* @__PURE__ */ jsx260(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx260(
      "path",
      {
        d: "M17.255 3.77a1.565 1.565 0 0 1 .915 2.019l-.898 2.398-5.301.66-.206-.03c.15-.29.205-.617.205-.966 0-1.154-.908-2.09-2.09-2.09-1.124 0-2.09.936-2.09 2.09 0 .167.049.297.085.48l-2.14-.268c-.003-.068-.036-.14-.036-.212 0-2.309 1.901-4.18 4.181-4.18 2.303 0 4.151 1.814 4.18 4.075l1.177-3.058a1.567 1.567 0 0 1 2.018-.918ZM4.005 8.942l7.965.97-2.694 4.54a1.026 1.026 0 0 1-1.183.497L2.76 13.423c-.63-.18-.94-.888-.648-1.473l1.362-2.724c.099-.196.312-.31.532-.284Zm16.357 8.136c0 .719-.49 1.346-1.19 1.522l-6.666 1.666c-.333.085-.68.085-1.012 0L4.827 18.6c-.7-.176-1.218-.803-1.218-1.522v-2.316l1.568.448v1.868l6.01 1.503v-4.75c0-.404.379-.783.784-.783.463 0 .813.379.813.784v4.749l6.01-1.503V15.21l1.568-.448v2.316Zm.878-3.655-5.334 1.526a1.026 1.026 0 0 1-1.182-.497l-2.754-4.54 8.026-.97a.53.53 0 0 1 .532.284l1.362 2.724c.29.585-.02 1.294-.65 1.473Z",
        fill: "currentColor"
      }
    )
  })
);
var BoxOpenFull_default = SvgBoxOpenFull;

// src/Icon/icons/BoxOpen.tsx
import { jsx as jsx261 } from "react/jsx-runtime";
var SvgBoxOpen = (props) => /* @__PURE__ */ jsx261(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx261(
      "path",
      {
        d: "m2.11 7.748 1.363-2.723a.523.523 0 0 1 .532-.285L12 5.71l-2.724 4.54a1.026 1.026 0 0 1-1.183.497L2.758 9.222c-.629-.18-.94-.889-.647-1.474ZM12 5.71l7.996-.97a.526.526 0 0 1 .532.285l1.362 2.723c.29.585-.02 1.294-.65 1.474l-5.334 1.525a1.026 1.026 0 0 1-1.182-.496L12 5.71Zm8.362 4.85v5.452c0 .719-.49 1.346-1.19 1.522L12.507 19.2c-.333.085-.68.085-1.012 0l-6.667-1.666a1.571 1.571 0 0 1-1.189-1.522v-5.451l1.568.447v5.004l6.01 1.503V9.659c0-.434.35-.784.784-.784.434 0 .784.35.784.784v7.856l6.01-1.503v-5.004l1.568-.447Zm-8.398-2.73h.072-.072Z",
        fill: "currentColor"
      }
    )
  })
);
var BoxOpen_default = SvgBoxOpen;

// src/Icon/icons/BoxTaped.tsx
import { jsx as jsx262 } from "react/jsx-runtime";
var SvgBoxTaped = (props) => /* @__PURE__ */ jsx262(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx262(
      "path",
      {
        d: "M21.755 7.875c.16.366.245.759.245 1.16v10.108A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V9.036c0-.402.084-.795.246-1.161l1.857-4.178A2.857 2.857 0 0 1 6.714 2h10.572a2.86 2.86 0 0 1 2.611 1.697l1.858 4.178Zm-6.898-.16h4.482l-1.401-3.148a.71.71 0 0 0-.652-.424h-3.62l1.191 3.571Zm-4.522-3.572h-3.62a.714.714 0 0 0-.654.424L4.662 7.714h4.44l1.233-3.571ZM9.143 9.857h-5v9.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V9.857h-5V12c0 .79-.638 1.429-1.428 1.429H10.57c-.79 0-1.428-.639-1.428-1.429V9.857Z",
        fill: "currentColor"
      }
    )
  })
);
var BoxTaped_default = SvgBoxTaped;

// src/Icon/icons/BoxTissue.tsx
import { jsx as jsx263 } from "react/jsx-runtime";
var SvgBoxTissue = (props) => /* @__PURE__ */ jsx263(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx263(
      "path",
      {
        d: "M7.207 14.5h9.582c.408 0 .77-.264.893-.652l2.396-7.5a.936.936 0 0 0-.89-1.223h-4.094c-.73 0-1.376-.455-1.605-1.134C13.179 3.083 12.344 2 10.105 2H4.812a.938.938 0 0 0-.914 1.144l2.396 10.625a.938.938 0 0 0 .913.731Zm2.898-10.625c1.363 0 1.532.502 1.605.716A3.56 3.56 0 0 0 15.094 7h2.812l-1.797 5.625H7.957l-1.973-8.75h4.121Zm9.875 6.89-.593 1.86h.425c.173 0 .313.14.313.313v3.437H3.875v-3.438c0-.172.14-.312.313-.312h.567l-.423-1.875h-.144A2.19 2.19 0 0 0 2 12.938v6.874A2.19 2.19 0 0 0 4.188 22h15.625A2.19 2.19 0 0 0 22 19.812v-6.875c0-1.148-.89-2.082-2.02-2.171Zm.145 9.047c0 .173-.14.313-.313.313H4.188a.313.313 0 0 1-.312-.313V18.25h16.25v1.563Z",
        fill: "currentColor"
      }
    )
  })
);
var BoxTissue_default = SvgBoxTissue;

// src/Icon/icons/Box.tsx
import { jsx as jsx264 } from "react/jsx-runtime";
var SvgBox = (props) => /* @__PURE__ */ jsx264(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx264(
      "path",
      {
        d: "M17.286 2a2.86 2.86 0 0 1 2.611 1.697l1.858 4.178c.16.366.245.759.245 1.16v10.108A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V9.036c0-.402.084-.795.246-1.161l1.857-4.178A2.857 2.857 0 0 1 6.714 2h10.572Zm0 2.143H13.07v3.571h6.268l-1.401-3.147a.71.71 0 0 0-.652-.424Zm2.571 5.714H4.143v9.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V9.857ZM4.663 7.714h6.266V4.143H6.714a.714.714 0 0 0-.653.424L4.662 7.714Z",
        fill: "currentColor"
      }
    )
  })
);
var Box_default = SvgBox;

// src/Icon/icons/BoxesPacking.tsx
import { jsx as jsx265 } from "react/jsx-runtime";
var SvgBoxesPacking = (props) => /* @__PURE__ */ jsx265(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx265(
      "path",
      {
        d: "M20.5 5.5h-9V8H10V5.5A1.5 1.5 0 0 1 11.5 4h9A1.5 1.5 0 0 1 22 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-6.584c.053-.184.084-.325.084-.5v-1h6.5v-13Zm-.997 8.219c.319.293.319.769 0 1.034-.265.319-.74.319-1.034 0l-.719-.694v2.191c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-2.19l-.747.693c-.265.319-.74.319-1.034 0-.29-.265-.29-.74 0-1.034l2-2c.293-.29.768-.29 1.034 0l2 2ZM9.25 14.5c.416 0 .75.334.75.75s-.334.75-.75.75h-2.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h2.5ZM2 10a1 1 0 0 1 1-1h10c.553 0 1 .447 1 1v2.5c0 .553-.447 1-1 1V19c0 .553-.447 1-1 1H4a1 1 0 0 1-1-1v-5.5a1 1 0 0 1-1-1V10Zm1.5.5V12h9v-1.5h-9Zm1 8h7v-5h-7v5Z",
        fill: "currentColor"
      }
    )
  })
);
var BoxesPacking_default = SvgBoxesPacking;

// src/Icon/icons/BoxesStacked.tsx
import { jsx as jsx266 } from "react/jsx-runtime";
var SvgBoxesStacked = (props) => /* @__PURE__ */ jsx266(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx266(
      "path",
      {
        d: "M15.333 4.778c.306 0 .556.25.556.555v4.445h1.667V5.333a2.224 2.224 0 0 0-2.223-2.222H8.667a2.224 2.224 0 0 0-2.223 2.222v4.445h1.667V5.333c0-.305.25-.555.556-.555h1.944V7c0 .306.25.556.556.556h1.666c.306 0 .556-.25.556-.556V4.778h1.944Zm-1.958 16.11h6.403A2.224 2.224 0 0 0 22 18.668V13.11a2.224 2.224 0 0 0-2.222-2.222h-6.403c.41.458.698 1.031.802 1.667h.879v2.222c0 .305.25.555.555.555h1.667c.305 0 .555-.25.555-.555v-2.222h1.945c.305 0 .555.25.555.555v5.556c0 .305-.25.555-.555.555h-5.6a3.333 3.333 0 0 1-.803 1.667Zm-2.486-8.332c.305 0 .555.25.555.555v5.556c0 .305-.25.555-.555.555H4.222a.557.557 0 0 1-.555-.555V13.11c0-.305.25-.555.555-.555h1.945v2.222c0 .305.25.555.555.555H8.39c.305 0 .555-.25.555-.555v-2.222h1.945Zm-6.667-1.667A2.224 2.224 0 0 0 2 13.11v5.556c0 1.225.997 2.222 2.222 2.222h6.667a2.224 2.224 0 0 0 2.222-2.222V13.11a2.224 2.224 0 0 0-2.222-2.222H4.222Z",
        fill: "currentColor"
      }
    )
  })
);
var BoxesStacked_default = SvgBoxesStacked;

// src/Icon/icons/BracketCurlyRight.tsx
import { jsx as jsx267 } from "react/jsx-runtime";
var SvgBracketCurlyRight = (props) => /* @__PURE__ */ jsx267(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx267(
      "path",
      {
        d: "M7 3.031c0 .632.48 1.112 1.031 1.112h3.612c.196 0 .357.16.357.357v3.46c0 1.046.417 2.05 1.159 2.788L14.415 12l-1.258 1.252A3.935 3.935 0 0 0 12 16.04v3.46c0 .196-.16.357-.357.357H8.03c-.551 0-1.031.478-1.031 1.031C7 21.442 7.48 22 8.031 22h3.612a2.5 2.5 0 0 0 2.5-2.5v-3.46c0-.471.187-.924.52-1.257l2.024-2.024c.201-.201.313-.473.313-.759 0-.285-.112-.558-.313-.759l-2.023-2.024a1.776 1.776 0 0 1-.521-1.257V4.5a2.5 2.5 0 0 0-2.5-2.5H8.03C7.48 2 7 2.48 7 3.031Z",
        fill: "currentColor"
      }
    )
  })
);
var BracketCurlyRight_default = SvgBracketCurlyRight;

// src/Icon/icons/BracketCurly.tsx
import { jsx as jsx268 } from "react/jsx-runtime";
var SvgBracketCurly = (props) => /* @__PURE__ */ jsx268(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx268(
      "path",
      {
        d: "M15.929 2h-3.572a2.5 2.5 0 0 0-2.5 2.5v3.46c0 .471-.187.924-.52 1.257l-2.024 2.024C7.112 11.442 7 11.714 7 12c0 .285.112.558.313.759l2.023 2.024c.334.333.521.784.521 1.257v3.46a2.5 2.5 0 0 0 2.5 2.5h3.572c.593 0 1.071-.478 1.071-1.071 0-.594-.478-1.072-1.071-1.072h-3.572A.358.358 0 0 1 12 19.5v-3.46c0-1.046-.417-2.05-1.159-2.788L9.585 12l1.258-1.252A3.933 3.933 0 0 0 12 7.96V4.5c0-.196.16-.357.357-.357h3.572a1.07 1.07 0 1 0 0-2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var BracketCurly_default = SvgBracketCurly;

// src/Icon/icons/BracketRoundRight.tsx
import { jsx as jsx269 } from "react/jsx-runtime";
var SvgBracketRoundRight = (props) => /* @__PURE__ */ jsx269(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx269(
      "path",
      {
        d: "M8.949 20.01c.183-.11 4.478-2.764 4.478-8.01 0-5.227-4.27-7.884-4.478-8.009a1.073 1.073 0 0 1 1.1-1.84c.224.133 5.523 3.363 5.523 9.85s-5.3 9.714-5.523 9.848a1.073 1.073 0 0 1-1.466-.371c-.304-.544-.139-1.165.366-1.468Z",
        fill: "currentColor"
      }
    )
  })
);
var BracketRoundRight_default = SvgBracketRoundRight;

// src/Icon/icons/BracketRound.tsx
import { jsx as jsx270 } from "react/jsx-runtime";
var SvgBracketRound = (props) => /* @__PURE__ */ jsx270(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx270(
      "path",
      {
        d: "M15.418 21.478a1.074 1.074 0 0 1-1.467.371c-.224-.134-5.523-3.362-5.523-9.85 0-6.486 5.3-9.715 5.523-9.848a1.073 1.073 0 0 1 1.097 1.842c-.206.125-4.478 2.779-4.478 8.01 0 5.245 4.297 7.898 4.478 8.01.508.3.669.92.37 1.465Z",
        fill: "currentColor"
      }
    )
  })
);
var BracketRound_default = SvgBracketRound;

// src/Icon/icons/BracketSquareRight.tsx
import { jsx as jsx271 } from "react/jsx-runtime";
var SvgBracketSquareRight = (props) => /* @__PURE__ */ jsx271(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx271(
      "path",
      {
        d: "M8.786 3.031c0 .632.48 1.112 1.031 1.112h3.254v15.714H9.817c-.551 0-1.031.478-1.031 1.031 0 .554.48 1.112 1.071 1.112h3.929c.785 0 1.428-.643 1.428-1.429V3.43c0-.786-.643-1.429-1.428-1.429H9.857c-.591 0-1.071.48-1.071 1.031Z",
        fill: "currentColor"
      }
    )
  })
);
var BracketSquareRight_default = SvgBracketSquareRight;

// src/Icon/icons/BracketSquare.tsx
import { jsx as jsx272 } from "react/jsx-runtime";
var SvgBracketSquare = (props) => /* @__PURE__ */ jsx272(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx272(
      "path",
      {
        d: "M14.143 2h-3.929c-.785 0-1.428.643-1.428 1.429V20.57c0 .786.643 1.429 1.428 1.429h3.929c.591 0 1.071-.48 1.071-1.031 0-.552-.477-1.112-1.071-1.112h-3.214V4.143h3.214a1.07 1.07 0 1 0 0-2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var BracketSquare_default = SvgBracketSquare;

// src/Icon/icons/BracketsCurly.tsx
import { jsx as jsx273 } from "react/jsx-runtime";
var SvgBracketsCurly = (props) => /* @__PURE__ */ jsx273(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx273(
      "path",
      {
        d: "M8.944 4.222H6.167c-1.074 0-1.945.87-1.945 1.945v2.69c0 .367-.146.72-.405.979L2.243 11.41a.834.834 0 0 0 0 1.18l1.574 1.574c.26.26.405.61.405.978v2.691c0 1.073.87 1.945 1.945 1.945h2.777a.831.831 0 0 0 .834-.833.831.831 0 0 0-.834-.834H6.167a.279.279 0 0 1-.278-.278v-2.69a3.06 3.06 0 0 0-.901-2.169L4.01 12l.978-.974c.578-.575.9-1.356.9-2.168V6.167c0-.153.126-.278.279-.278h2.777a.832.832 0 1 0 0-1.667Zm12.813 7.188-1.574-1.574c-.26-.26-.405-.61-.405-.978V6.167a1.945 1.945 0 0 0-1.945-1.945h-2.777c-.462 0-.834.373-.834.802 0 .43.372.865.802.865h2.81c.152 0 .277.125.277.278v2.69c0 .812.322 1.59.896 2.164l.948.979-.979.979a3.168 3.168 0 0 0-.865 2.163v2.691a.279.279 0 0 1-.278.278h-2.777c-.462 0-.834.372-.834.802 0 .43.372.865.802.865h2.81c1.073 0 1.944-.87 1.944-1.945v-2.69c0-.367.146-.72.405-.979l1.574-1.574A.833.833 0 0 0 22 12a.833.833 0 0 0-.243-.59Z",
        fill: "currentColor"
      }
    )
  })
);
var BracketsCurly_default = SvgBracketsCurly;

// src/Icon/icons/BracketsRound.tsx
import { jsx as jsx274 } from "react/jsx-runtime";
var SvgBracketsRound = (props) => /* @__PURE__ */ jsx274(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx274(
      "path",
      {
        d: "M7.793 4.994a.939.939 0 0 0-.96-1.612C6.637 3.5 2 6.325 2 12.001c0 5.675 4.637 8.5 4.832 8.617a.933.933 0 0 0 1.283-.325.94.94 0 0 0-.321-1.285c-.157-.097-3.919-2.418-3.919-7.042 0-4.54 3.738-6.862 3.918-6.972Zm9.375-1.612a.937.937 0 0 0-.962 1.61c.161.097 3.919 2.419 3.919 6.974 0 4.554-3.76 6.91-3.918 7.007a.938.938 0 0 0 .96 1.612C17.363 20.5 22 17.676 22 12c0-5.676-4.637-8.502-4.832-8.619Z",
        fill: "currentColor"
      }
    )
  })
);
var BracketsRound_default = SvgBracketsRound;

// src/Icon/icons/BracketsSquare.tsx
import { jsx as jsx275 } from "react/jsx-runtime";
var SvgBracketsSquare = (props) => /* @__PURE__ */ jsx275(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx275(
      "path",
      {
        d: "M7.357 2H3.43C2.643 2 2 2.643 2 3.429V20.57C2 21.357 2.643 22 3.429 22h3.928c.594 0 1.072-.478 1.072-1.071 0-.594-.478-1.072-1.072-1.072H4.143V4.143h3.214a1.07 1.07 0 1 0 0-2.143Zm13.214 0h-3.928c-.594 0-1.072.48-1.072 1.031 0 .552.478 1.112 1.032 1.112h3.254v15.714h-3.214c-.594 0-1.072.478-1.072 1.031 0 .554.478 1.112 1.032 1.112h3.968c.786 0 1.429-.643 1.429-1.429V3.43C22 2.643 21.357 2 20.571 2Z",
        fill: "currentColor"
      }
    )
  })
);
var BracketsSquare_default = SvgBracketsSquare;

// src/Icon/icons/BrainArrowCurvedRight.tsx
import { jsx as jsx276 } from "react/jsx-runtime";
var SvgBrainArrowCurvedRight = (props) => /* @__PURE__ */ jsx276(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx276(
      "path",
      {
        d: "m21.837 14.618-3-2.974c-.316-.313-.815-.082-.815.379V13.5h-2.496c-.175 0-.351-.004-.503.023-1.472.219-2.675 1.39-2.917 2.859a3.52 3.52 0 0 0 1.508 3.53c.304.204.675-.101.554-.453-.281-.828-.172-2.956 1.886-2.956h2v1.472c0 .465.527.695.815.383l2.999-2.976a.569.569 0 0 0-.031-.764Zm-10.804 1.6c.039-.25.105-.492.19-.726V6.563A1.105 1.105 0 0 1 12.318 5.5c.484 0 .91.328 1.002.8l.149.59.714-.038c.516.004.996.484.996 1.066 0 .137-.012.168-.172.851l.566.239c.425.175 1.331.945.753 2.062l-.309.624.61.352c.109.063.195.14.277.215l.004-.242c0-.687.449-1.262 1.066-1.453.09-.054.108-.104.108-.16 0-1.031-.523-1.94-1.367-2.52a2.57 2.57 0 0 0-2.108-2.49 2.567 2.567 0 0 0-2.29-1.395c-.709 0-1.355.289-1.846.753a2.46 2.46 0 0 0-1.793-.753c-.984 0-1.862.554-2.29 1.402A2.57 2.57 0 0 0 4.277 7.9a2.968 2.968 0 0 0-1.273 3.23 2.988 2.988 0 0 0 .363 4.747 2.802 2.802 0 0 0 2.678 2.758 2.792 2.792 0 0 0 2.397 1.362c.785 0 1.539-.351 2.05-.898.418.45.985.75 1.621.851a4.667 4.667 0 0 1-1.08-3.733Zm-1.294.993c0 .713-.578 1.288-1.293 1.288-1.027 0-1.235-.922-1.426-1.488l-.632.105c-.722.125-1.515-.476-1.515-1.265 0-.086.148-.856.148-.856l-.57-.234c-1.15-.474-1.287-2.067-.17-2.705l.609-.347-.309-.63c-.55-1.116.356-1.89.784-2.066l.59-.237c-.156-.688-.171-.715-.171-.852 0-.586.476-1.062.995-1.066l.715.04.152-.59a1.062 1.062 0 0 1 2.093.262V17.21Z",
        fill: "currentColor"
      }
    )
  })
);
var BrainArrowCurvedRight_default = SvgBrainArrowCurvedRight;

// src/Icon/icons/BrainCircuit.tsx
import { jsx as jsx277 } from "react/jsx-runtime";
var SvgBrainCircuit = (props) => /* @__PURE__ */ jsx277(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx277(
      "path",
      {
        d: "M3.25 16.688v-.063A4.383 4.383 0 0 1 2 13.527c0-1.05.395-2.043 1.048-2.804a3.874 3.874 0 0 1-.11-.946c0-1.238.635-2.363 1.606-3.043A3.747 3.747 0 0 1 6.34 4.086 3.435 3.435 0 0 1 9.5 2c.984 0 1.84.414 2.5 1.078a3.435 3.435 0 0 1 5.66 1.008 3.752 3.752 0 0 1 1.797 2.648c.969.68 1.605 1.805 1.605 3.043 0 .348-.039.653-.109.946A4.327 4.327 0 0 1 22 13.527c0 1.23-.477 2.309-1.285 3.098v.031c.035.012.035.02.035.032a3.748 3.748 0 0 1-3.09 3.69A3.585 3.585 0 0 1 14.656 22c-1.054 0-2-.453-2.656-1.207A3.548 3.548 0 0 1 9.344 22a3.585 3.585 0 0 1-3.004-1.621 3.75 3.75 0 0 1-3.09-3.692Zm7.813-3.473H9.5c-.344 0-.625.316-.625.625v.476a1.562 1.562 0 1 1-1.25 0v-.476c0-1 .84-1.875 1.875-1.875h1.563v-3.75h-.754c-.243.586-.793.937-1.434.937A1.54 1.54 0 0 1 7.312 7.59c0-.828.7-1.563 1.563-1.563.64 0 1.191.422 1.434.938h.754V5.402c0-.827-.7-1.562-1.563-1.562s-1.563.735-1.563 1.562v.061a1.878 1.878 0 0 0-1.562 1.814c0 .258.004.473.11.672a1.855 1.855 0 0 0-.831.297 1.884 1.884 0 0 0-.841 1.531c0 .602.252 1.114.651 1.457A2.498 2.498 0 0 0 4.1 12.527c-.144.317-.26.664-.26 1.036 0 .933.549 1.75 1.307 2.18l.184.093a1.888 1.888 0 0 0-.205.852 1.877 1.877 0 0 0 2.5 1.769 1.72 1.72 0 0 0 1.719 1.668c.863 0 1.633-.688 1.71-1.563h.008v-5.347ZM14.5 3.84c-.863 0-1.563.735-1.563 1.562v1.563H14.5c1.035 0 1.875.875 1.875 1.875v.476c.55.243.938.793.938 1.399 0 .898-.7 1.562-1.563 1.562a1.54 1.54 0 0 1-1.563-1.562c0-.606.387-1.156.938-1.399V8.84c0-.309-.281-.625-.625-.625h-1.563v6.25h2.004c.243-.516.793-.938 1.434-.938.863 0 1.563.735 1.563 1.598a1.562 1.562 0 0 1-2.997.625h-2.004v2.813h.008a1.717 1.717 0 0 0 1.711 1.562c.559 0 1.051-.266 1.332-.676.246-.277.375-.62.352-.992.195.066.441.105.66.105a1.877 1.877 0 0 0 1.734-2.59c-.02-.046-.039-.093-.062-.136.062-.031.121-.063.18-.094a2.5 2.5 0 0 0-.317-4.508 1.898 1.898 0 0 0 .64-1.636 1.883 1.883 0 0 0-.827-1.352 2.036 2.036 0 0 0-.832-.297 1.97 1.97 0 0 0 .093-.883 1.877 1.877 0 0 0-1.582-1.603l.035-.026c0-.862-.699-1.562-1.562-1.562V3.84ZM8.875 8.215A.605.605 0 0 0 9.5 7.59c0-.309-.281-.625-.625-.625s-.625.316-.625.625c0 .379.281.625.625.625Zm-.625 8.16a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625.627.627 0 0 0-.625.625c0 .344.281.625.625.625Zm8.125-5.66c0-.309-.281-.625-.625-.625s-.625.316-.625.625c0 .379.281.625.625.625a.605.605 0 0 0 .625-.625Zm0 5.035a.627.627 0 0 0 .625-.625c0-.344-.281-.66-.625-.66s-.625.316-.625.66c0 .344.281.625.625.625Z",
        fill: "currentColor"
      }
    )
  })
);
var BrainCircuit_default = SvgBrainCircuit;

// src/Icon/icons/Brain.tsx
import { jsx as jsx278 } from "react/jsx-runtime";
var SvgBrain = (props) => /* @__PURE__ */ jsx278(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx278(
      "path",
      {
        d: "M2 13.527c0-1.05.395-2.043 1.048-2.804a3.874 3.874 0 0 1-.11-.946c0-1.238.635-2.363 1.606-3.043A3.747 3.747 0 0 1 6.34 4.086 3.435 3.435 0 0 1 9.5 2c.984 0 1.84.414 2.5 1.078a3.435 3.435 0 0 1 5.66 1.008 3.752 3.752 0 0 1 1.797 2.648c.969.68 1.605 1.805 1.605 3.043 0 .348-.039.653-.109.946A4.327 4.327 0 0 1 22 13.527c0 1.23-.477 2.309-1.285 3.098 0 .02.035.043.035.063a3.748 3.748 0 0 1-3.09 3.69A3.585 3.585 0 0 1 14.656 22c-1.054 0-2-.453-2.656-1.207A3.548 3.548 0 0 1 9.344 22a3.585 3.585 0 0 1-3.004-1.621 3.75 3.75 0 0 1-3.09-3.754A4.383 4.383 0 0 1 2 13.527Zm9.055 5.036h.008V5.402c0-.828-.7-1.563-1.563-1.563s-1.563.735-1.563 1.562v.061a1.878 1.878 0 0 0-1.562 1.814c0 .258.004.473.11.672a1.855 1.855 0 0 0-.831.297 1.884 1.884 0 0 0-.841 1.531c0 .602.252 1.114.651 1.457A2.498 2.498 0 0 0 4.1 12.527c-.144.317-.26.664-.26 1.036 0 .933.549 1.75 1.307 2.18l.184.093a1.888 1.888 0 0 0-.205.852 1.877 1.877 0 0 0 2.5 1.769 1.72 1.72 0 0 0 1.719 1.668c.863 0 1.633-.688 1.71-1.563Zm4.972-13.1.035-.06c0-.828-.699-1.563-1.562-1.563-.863 0-1.563.735-1.563 1.562v13.16h.008a1.717 1.717 0 0 0 1.711 1.563c.559 0 1.051-.266 1.332-.676.246-.277.375-.62.352-.992.195.066.441.105.66.105a1.877 1.877 0 0 0 1.734-2.59c-.02-.046-.039-.093-.062-.136.062-.031.121-.063.18-.094a2.5 2.5 0 0 0-.317-4.508 1.898 1.898 0 0 0 .64-1.636 1.883 1.883 0 0 0-.827-1.352 2.036 2.036 0 0 0-.832-.297 1.97 1.97 0 0 0 .093-.883 1.877 1.877 0 0 0-1.582-1.603Z",
        fill: "currentColor"
      }
    )
  })
);
var Brain_default = SvgBrain;

// src/Icon/icons/BriefcaseBlank.tsx
import { jsx as jsx279 } from "react/jsx-runtime";
var SvgBriefcaseBlank = (props) => /* @__PURE__ */ jsx279(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx279(
      "path",
      {
        d: "M19.5 6.375H17v-1.25a2.5 2.5 0 0 0-2.5-2.5h-5c-1.379 0-2.5 1.12-2.5 2.5v1.25H4.5c-1.38 0-2.5 1.121-2.5 2.5v10a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5ZM8.875 5.125c0-.345.28-.625.625-.625h5c.345 0 .625.28.625.625v1.25h-6.25v-1.25Zm11.25 13.75a.627.627 0 0 1-.625.625h-15a.627.627 0 0 1-.625-.625v-10c0-.344.281-.625.625-.625h15c.344 0 .625.281.625.625v10Z",
        fill: "currentColor"
      }
    )
  })
);
var BriefcaseBlank_default = SvgBriefcaseBlank;

// src/Icon/icons/Briefcase.tsx
import { jsx as jsx280 } from "react/jsx-runtime";
var SvgBriefcase = (props) => /* @__PURE__ */ jsx280(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx280(
      "path",
      {
        d: "M19.5 6.375H17v-1.25a2.5 2.5 0 0 0-2.5-2.5h-5c-1.379 0-2.5 1.12-2.5 2.5v1.25H4.5c-1.38 0-2.5 1.121-2.5 2.5v10a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5ZM9.5 4.5h5c.345 0 .625.28.625.625v1.25h-6.25v-1.25c0-.345.281-.625.625-.625Zm-5 3.75h15c.344 0 .625.281.625.625v3.75H3.875v-3.75c0-.344.281-.625.625-.625Zm15 11.25h-15a.627.627 0 0 1-.625-.625V14.5H9.5v.625c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25V14.5h5.625v4.375a.627.627 0 0 1-.625.625Z",
        fill: "currentColor"
      }
    )
  })
);
var Briefcase_default = SvgBriefcase;

// src/Icon/icons/BrightnessLow.tsx
import { jsx as jsx281 } from "react/jsx-runtime";
var SvgBrightnessLow = (props) => /* @__PURE__ */ jsx281(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx281(
      "path",
      {
        d: "M13.539 3.538a1.538 1.538 0 1 1-3.076.002 1.538 1.538 0 0 1 3.076-.002ZM7.385 12c0-2.591 2.024-4.615 4.615-4.615A4.59 4.59 0 0 1 16.615 12 4.617 4.617 0 0 1 12 16.615 4.59 4.59 0 0 1 7.385 12ZM12 14.308a2.308 2.308 0 1 0-.001-4.617A2.308 2.308 0 0 0 12 14.308Zm-1.539 6.154c0-.851.688-1.539 1.539-1.539s1.539.688 1.539 1.539c0 .85-.688 1.538-1.539 1.538a1.537 1.537 0 0 1-1.539-1.538Zm10-6.923c-.85 0-1.538-.688-1.538-1.539s.688-1.539 1.539-1.539c.85 0 1.538.688 1.538 1.539s-.688 1.539-1.538 1.539ZM3.539 10.46a1.538 1.538 0 1 1 .002 3.076 1.538 1.538 0 0 1-.002-3.076Zm3.847-4.615a1.538 1.538 0 1 1-3.078.001 1.538 1.538 0 0 1 3.078 0Zm10.769 13.846c-.851 0-1.539-.687-1.539-1.538s.688-1.539 1.539-1.539c.85 0 1.538.688 1.538 1.539 0 .85-.687 1.538-1.538 1.538Zm1.538-13.846c0 .851-.687 1.539-1.538 1.539s-1.539-.688-1.539-1.539c0-.85.688-1.538 1.539-1.538.85 0 1.538.687 1.538 1.538ZM5.846 16.616c.851 0 1.539.687 1.539 1.538a1.538 1.538 0 1 1-1.538-1.538Z",
        fill: "currentColor"
      }
    )
  })
);
var BrightnessLow_default = SvgBrightnessLow;

// src/Icon/icons/Brightness.tsx
import { jsx as jsx282 } from "react/jsx-runtime";
var SvgBrightness = (props) => /* @__PURE__ */ jsx282(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx282(
      "path",
      {
        d: "M11.063 2.938a.937.937 0 1 1 1.874 0v2.5c0 .519-.417.937-.937.937a.935.935 0 0 1-.938-.938v-2.5ZM8.25 12c0-2.105 1.645-3.75 3.75-3.75 2.07 0 3.75 1.645 3.75 3.75 0 2.07-1.68 3.75-3.75 3.75A3.729 3.729 0 0 1 8.25 12ZM12 13.875a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75ZM2 12c0-.52.42-.938.938-.938h2.5c.519 0 .937.418.937.938s-.418.938-.938.938h-2.5A.937.937 0 0 1 2 12Zm19.063-.938c.519 0 .937.418.937.938s-.418.938-.938.938h-2.5a.935.935 0 0 1-.937-.938c0-.52.418-.938.938-.938h2.5ZM12 22a.935.935 0 0 1-.938-.938v-2.5c0-.519.418-.937.938-.937s.938.418.938.938v2.5c0 .519-.418.937-.938.937ZM4.929 4.929a.937.937 0 0 1 1.325 0l1.77 1.766a.945.945 0 0 1 0 1.328.945.945 0 0 1-1.329 0L4.93 6.253a.937.937 0 0 1 0-1.324ZM19.07 17.746a.934.934 0 0 1 0 1.324.934.934 0 0 1-1.324 0l-1.77-1.765a.945.945 0 0 1 0-1.328.945.945 0 0 1 1.329 0l1.765 1.77ZM4.93 19.07a.936.936 0 0 1 0-1.324l1.766-1.77a.945.945 0 0 1 1.328 0 .945.945 0 0 1 0 1.329l-1.77 1.765a.935.935 0 0 1-1.324 0ZM17.746 4.93a.936.936 0 1 1 1.324 1.325l-1.765 1.77a.938.938 0 1 1-1.328-1.329l1.77-1.766Z",
        fill: "currentColor"
      }
    )
  })
);
var Brightness_default = SvgBrightness;

// src/Icon/icons/BringForward.tsx
import { jsx as jsx283 } from "react/jsx-runtime";
var SvgBringForward = (props) => /* @__PURE__ */ jsx283(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx283(
      "path",
      {
        d: "M10.75 20.125h8.75a.627.627 0 0 0 .625-.625v-8.75a.627.627 0 0 0-.625-.625H17V8.25h2.5c1.379 0 2.5 1.121 2.5 2.5v8.75c0 1.379-1.121 2.5-2.5 2.5h-8.75a2.502 2.502 0 0 1-2.5-2.5V17h1.875v2.5c0 .344.281.625.625.625ZM4.5 15.75c-1.38 0-2.5-1.121-2.5-2.5V4.5A2.5 2.5 0 0 1 4.5 2h8.75c1.379 0 2.5 1.12 2.5 2.5v8.75c0 1.379-1.121 2.5-2.5 2.5H4.5Z",
        fill: "currentColor"
      }
    )
  })
);
var BringForward_default = SvgBringForward;

// src/Icon/icons/BringFront.tsx
import { jsx as jsx284 } from "react/jsx-runtime";
var SvgBringFront = (props) => /* @__PURE__ */ jsx284(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx284(
      "path",
      {
        d: "M3.5 6v4a.5.5 0 0 0 .5.5h2V12H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2H8.5a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5ZM16 20c-1.103 0-2-.897-2-2h1.5c0 .275.225.5.5.5h4c.275 0 .5-.225.5-.5v-4c0-.275-.225-.5-.5-.5h-2V12h2c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2h-4ZM15 7c1.103 0 2 .897 2 2v6c0 1.103-.897 2-2 2H9c-1.103 0-2-.897-2-2V9c0-1.103.897-2 2-2h6Z",
        fill: "currentColor"
      }
    )
  })
);
var BringFront_default = SvgBringFront;

// src/Icon/icons/Broom.tsx
import { jsx as jsx285 } from "react/jsx-runtime";
var SvgBroom = (props) => /* @__PURE__ */ jsx285(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx285(
      "path",
      {
        d: "M21.84 4.288a.749.749 0 0 0-1.052-.13l-7.285 5.694-1.23-1.546a.378.378 0 0 0-.592.002l-1.8 2.286c-.972.024-3.25.205-4.75 1.399C3.195 13.53 2 19.977 2 19.977c.473.024 6.634.235 8.506-1.222 1.488-1.16 2.187-3.36 2.43-4.3l2.631-1.234c.191-.105.285-.387.137-.574l-1.268-1.593 7.275-5.684c.326-.284.386-.756.13-1.082ZM9.57 17.555c-.516.41-2.32.89-5.71.942.149-.598.317-1.192.493-1.762l1.417-1.097c.128-.121.036-.37-.156-.332l-.816.172c.418-1.101.867-1.94 1.273-2.293.843-.672 2.226-.94 3.425-1.047l1.87 2.316c-.293.976-.874 2.37-1.796 3.101Zm3.86-5.015-1.11.515-1.244-1.56.758-.96c.074-.066.219-.098.293 0l1.368 1.714a.193.193 0 0 1-.066.29Z",
        fill: "currentColor"
      }
    )
  })
);
var Broom_default = SvgBroom;

// src/Icon/icons/Browser.tsx
import { jsx as jsx286 } from "react/jsx-runtime";
var SvgBrowser = (props) => /* @__PURE__ */ jsx286(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx286(
      "path",
      {
        d: "M2.302 4.558c.22-.405.55-.743.948-.974A2.482 2.482 0 0 1 4.5 3.25h15c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75a2.486 2.486 0 0 1 .302-1.192ZM3.875 18.25c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625v-10H3.875v10Z",
        fill: "currentColor"
      }
    )
  })
);
var Browser_default = SvgBrowser;

// src/Icon/icons/Browsers.tsx
import { jsx as jsx287 } from "react/jsx-runtime";
var SvgBrowsers = (props) => /* @__PURE__ */ jsx287(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx287(
      "path",
      {
        d: "M19.778 3.111c1.226 0 2.222.995 2.222 2.222v10a2.224 2.224 0 0 1-2.222 2.223H7.556a2.224 2.224 0 0 1-2.223-2.223v-10c0-1.227.997-2.222 2.223-2.222h12.222ZM7.556 15.89h12.222c.305 0 .555-.25.555-.556V7.556H7v7.777c0 .306.25.556.556.556Zm-3.89.278a3.056 3.056 0 0 0 3.056 3.055h11.111c.462 0 .834.372.834.834a.831.831 0 0 1-.834.833H6.723A4.722 4.722 0 0 1 2 16.167v-8.89a.832.832 0 1 1 1.667 0v8.89Z",
        fill: "currentColor"
      }
    )
  })
);
var Browsers_default = SvgBrowsers;

// src/Icon/icons/Brush.tsx
import { jsx as jsx288 } from "react/jsx-runtime";
var SvgBrush = (props) => /* @__PURE__ */ jsx288(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx288(
      "path",
      {
        d: "M4.5 4.5A2.5 2.5 0 0 1 7 2h10c1.379 0 2.5 1.12 2.5 2.5v10c0 1.379-1.121 2.5-2.5 2.5h-2.5v2.5c0 1.379-1.121 2.5-2.5 2.5a2.502 2.502 0 0 1-2.5-2.5V17H7c-1.38 0-2.5-1.121-2.5-2.5v-10Zm13.125 8.75V4.5A.626.626 0 0 0 17 3.875h-3.75v2.5a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625v-2.5H9.5v3.75a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625v-3.75H7a.625.625 0 0 0-.625.625v8.75h11.25ZM12 20.125a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625.627.627 0 0 0-.625.625c0 .344.281.625.625.625Z",
        fill: "currentColor"
      }
    )
  })
);
var Brush_default = SvgBrush;

// src/Icon/icons/Bucket.tsx
import { jsx as jsx289 } from "react/jsx-runtime";
var SvgBucket = (props) => /* @__PURE__ */ jsx289(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx289(
      "path",
      {
        d: "M7 8.25H5.125v-.313C5.125 4.659 7.785 2 11.063 2h1.874a5.939 5.939 0 0 1 5.938 5.938v.312H17v-.313a4.063 4.063 0 0 0-4.063-4.062h-1.874A4.063 4.063 0 0 0 7 7.938v.312Zm-3.75 2.188c0-.52.42-.938.938-.938h15.625c.519 0 .937.418.937.938 0 .519-.418.937-.938.937h-.234l-1.121 8.95c-.117.937-.918 1.675-1.863 1.675H7.406c-.946 0-1.744-.738-1.861-1.676l-1.123-8.949h-.234a.937.937 0 0 1-.938-.938Zm4.156 9.687h9.188l1.093-8.75H6.312l1.095 8.75Z",
        fill: "currentColor"
      }
    )
  })
);
var Bucket_default = SvgBucket;

// src/Icon/icons/BugSlash.tsx
import { jsx as jsx290 } from "react/jsx-runtime";
var SvgBugSlash = (props) => /* @__PURE__ */ jsx290(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx290(
      "path",
      {
        d: "M9.472 9.087C9.74 9.003 9.99 9 10.25 9h3.5c.625 0 1.21.178 1.706.484L17.72 7.22c.293-.292.768-.292 1.034 0 .319.293.319.768 0 1.034l-2.238 2.29A3.17 3.17 0 0 1 17 12.25h2.25c.416 0 .75.334.75.75 0 .415-.334.75-.75.75H17V14c0 .31-.028.61-.081.903l4.793 3.756a.75.75 0 0 1-.925 1.181l-18.5-14.5a.75.75 0 1 1 .926-1.18l6.259 4.927Zm1.831 1.413 4.197 3.29v-1.54c0-.966-.784-1.75-1.75-1.75h-2.447ZM15 7v.111a.887.887 0 0 1-.888.889H9.887A.887.887 0 0 1 9 7.11V7c0-1.657 1.316-3 3-3a3 3 0 0 1 3 3Zm-8 5.25c0-.403.075-.79.21-1.147l1.293.994c-.003.069-.003.112-.003.153V14a3.502 3.502 0 0 0 2.75 3.419v-3.132l1.5 1.182v1.95a3.497 3.497 0 0 0 1.519-.753l1.193.94A4.982 4.982 0 0 1 12 19a4.986 4.986 0 0 1-3.506-1.434l-2.24 2.187c-.267.319-.742.319-1.035 0-.292-.266-.292-.74 0-1.034l2.368-2.366A4.983 4.983 0 0 1 7 14v-.25H4.75a.75.75 0 1 1 0-1.5H7Z",
        fill: "currentColor"
      }
    )
  })
);
var BugSlash_default = SvgBugSlash;

// src/Icon/icons/Bug.tsx
import { jsx as jsx291 } from "react/jsx-runtime";
var SvgBug = (props) => /* @__PURE__ */ jsx291(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx291(
      "path",
      {
        d: "M15.75 5.755v.139c0 .615-.496 1.11-1.11 1.11H9.36c-.614 0-1.11-.495-1.11-1.11v-.14A3.728 3.728 0 0 1 12 2.005a3.75 3.75 0 0 1 3.75 3.75Zm-12.225.273a.94.94 0 0 1 1.325 0L7.68 8.86a3.962 3.962 0 0 1 2.133-.605h4.374c.782 0 1.512.223 2.133.605l2.828-2.832c.368-.365.961-.365 1.293 0 .399.368.399.961 0 1.293l-2.796 2.864c.382.62.605 1.316.605 2.132h2.813c.519 0 .937.418.937.938s-.418.937-.938.937H18.25v.313a6.228 6.228 0 0 1-.734 2.941l2.925 2.957c.399.367.399.961 0 1.293-.332.399-.925.399-1.293 0l-2.765-2.734A6.232 6.232 0 0 1 12 20.755a6.232 6.232 0 0 1-4.383-1.793L4.85 21.696a.885.885 0 0 1-1.325 0c-.366-.332-.366-.926 0-1.293l2.96-2.957a6.228 6.228 0 0 1-.735-2.941v-.313H2.937a.937.937 0 1 1 0-1.875H5.75c0-.816.223-1.511.605-2.132L3.525 7.32c-.366-.332-.366-.925 0-1.293Zm4.1 8.477a4.378 4.378 0 0 0 3.438 4.273v-5.836c0-.52.417-.937.937-.937s.938.418.938.937v5.836a4.378 4.378 0 0 0 3.437-4.273v-2.188c0-1.207-.98-2.187-2.188-2.187H9.814c-1.208 0-2.188.98-2.188 2.187v2.188Z",
        fill: "currentColor"
      }
    )
  })
);
var Bug_default = SvgBug;

// src/Icon/icons/Bugs.tsx
import { jsx as jsx292 } from "react/jsx-runtime";
var SvgBugs = (props) => /* @__PURE__ */ jsx292(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx292(
      "path",
      {
        d: "M8.552 7.85h.59l.148-.692a.838.838 0 1 1 1.643.33l-.28 1.398c-.077.391-.423.643-.821.643h-1.12v.846l1.322.329c.332.084.58.356.63.695l.28 1.958a.845.845 0 0 1-.714.951.845.845 0 0 1-.95-.713l-.2-1.398-.643-.161c-.378.692-1.116 1.129-1.962 1.129-.846 0-1.582-.437-1.962-1.13l-.643.162-.2 1.398a.842.842 0 0 1-.95.713.842.842 0 0 1-.711-.95l.28-1.959a.84.84 0 0 1 .626-.695l1.323-.329v-.846h-1.12c-.4 0-.744-.252-.822-.643l-.28-1.399a.839.839 0 1 1 1.646-.329l.145.693H4.4c.164-.374.444-.72.799-.969L4.033 4.313a.839.839 0 1 1 1.53-.693l.912 2.013.916-2.013A.836.836 0 0 1 8.5 3.202c.391.192.608.69.42 1.111L7.75 6.883c.353.248.637.594.8.968ZM7.035 10.96V8.72a.561.561 0 0 0-.56-.56.561.561 0 0 0-.56.56v2.238c0 .308.253.56.56.56.308 0 .56-.252.56-.56Zm12.499 3.45.514.298.486-.556c.307-.35.835-.381 1.153-.077.378.308.413.836.109 1.154l-.944 1.101a.838.838 0 0 1-1.05.175l-.968-.56-.405.703.979.948a.842.842 0 0 1 .196.916l-.738 1.835a.836.836 0 0 1-1.091.465.836.836 0 0 1-.465-1.09l.524-1.312-.475-.461c-.706.409-1.549.447-2.28.024a2.23 2.23 0 0 1-1.118-1.986l-.64-.181-.87 1.111a.84.84 0 0 1-1.322-1.038l1.223-1.556a.917.917 0 0 1 .888-.318l1.312.406.405-.703-.968-.56a.84.84 0 0 1-.375-.996l.458-1.353a.839.839 0 0 1 1.063-.524c.44.15.644.626.525 1.063l-.266.699.546.297c.346-.27.762-.43 1.192-.497l.272-2.776a.84.84 0 1 1 1.672.161l-.217 2.203 1.8-1.287a.843.843 0 0 1 1.172.193.84.84 0 0 1-.196 1.17l-2.325 1.644c.213.392.283.832.224 1.266Zm-1.937-.796a.56.56 0 0 0-.766.206l-1.119 1.937a.561.561 0 0 0 .207.765.557.557 0 0 0 .762-.206l1.118-1.937a.562.562 0 0 0-.202-.765Z",
        fill: "currentColor"
      }
    )
  })
);
var Bugs_default = SvgBugs;

// src/Icon/icons/BuildingCircleArrowRight.tsx
import { jsx as jsx293 } from "react/jsx-runtime";
var SvgBuildingCircleArrowRight = (props) => /* @__PURE__ */ jsx293(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx293(
      "path",
      {
        d: "M3.5 6v12a.5.5 0 0 0 .5.5h2.5v-2a1.5 1.5 0 0 1 3 0v2H12c.275 0 .5-.225.5-.5v-.206c.256.56.603 1.065 1.022 1.503-.394.431-.913.703-1.522.703H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v5.256a5.51 5.51 0 0 0-1.5 1.95V6a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5Zm1.25 1.25a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 .5.5v1.5c0 .275-.225.5-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5Zm6-.5a.5.5 0 0 1 .5.5v1.5c0 .275-.225.5-.5.5h-1.5a.501.501 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h1.5Zm-6 4.5a.5.5 0 0 1 .5-.5h1.5c.275 0 .5.225.5.5v1.5c0 .275-.225.5-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5Zm6-.5c.275 0 .5.225.5.5v1.5c0 .275-.225.5-.5.5h-1.5a.501.501 0 0 1-.5-.5v-1.5c0-.275.225-.5.5-.5h1.5ZM22 15.5a4.501 4.501 0 0 1-9 0 4.501 4.501 0 0 1 9 0Zm-4.603-1.397.897.897H15.5c-.275 0-.5.225-.5.5s.225.5.5.5h2.794l-.897.897a.496.496 0 0 0 0 .706.496.496 0 0 0 .706 0l1.75-1.75a.496.496 0 0 0 0-.706l-1.75-1.75a.496.496 0 0 0-.706 0 .496.496 0 0 0 0 .706Z",
        fill: "currentColor"
      }
    )
  })
);
var BuildingCircleArrowRight_default = SvgBuildingCircleArrowRight;

// src/Icon/icons/BuildingCircleCheck.tsx
import { jsx as jsx294 } from "react/jsx-runtime";
var SvgBuildingCircleCheck = (props) => /* @__PURE__ */ jsx294(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx294(
      "path",
      {
        d: "M3.5 6v12a.5.5 0 0 0 .5.5h2.5v-2a1.5 1.5 0 0 1 3 0v2H12c.275 0 .5-.225.5-.5v-.206c.256.56.603 1.065 1.022 1.503-.394.431-.913.703-1.522.703H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v5.256a5.51 5.51 0 0 0-1.5 1.95V6a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5Zm1.25 1.25a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 .5.5v1.5c0 .275-.225.5-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5Zm6-.5a.5.5 0 0 1 .5.5v1.5c0 .275-.225.5-.5.5h-1.5a.501.501 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h1.5Zm-6 4.5a.5.5 0 0 1 .5-.5h1.5c.275 0 .5.225.5.5v1.5c0 .275-.225.5-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5Zm6-.5c.275 0 .5.225.5.5v1.5c0 .275-.225.5-.5.5h-1.5a.501.501 0 0 1-.5-.5v-1.5c0-.275.225-.5.5-.5h1.5ZM22 15.5a4.501 4.501 0 0 1-9 0 4.501 4.501 0 0 1 9 0Zm-3.103-1.353L17 16.044l-.897-.897a.496.496 0 0 0-.706 0 .496.496 0 0 0 0 .706l1.25 1.25a.496.496 0 0 0 .706 0l2.25-2.25a.496.496 0 0 0 0-.706.496.496 0 0 0-.706 0Z",
        fill: "currentColor"
      }
    )
  })
);
var BuildingCircleCheck_default = SvgBuildingCircleCheck;

// src/Icon/icons/BuildingCircleExclamation.tsx
import { jsx as jsx295 } from "react/jsx-runtime";
var SvgBuildingCircleExclamation = (props) => /* @__PURE__ */ jsx295(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx295(
      "path",
      {
        d: "M3.5 6v12a.5.5 0 0 0 .5.5h2.5v-2a1.5 1.5 0 0 1 3 0v2H12c.275 0 .5-.225.5-.5v-.206c.256.56.603 1.065 1.022 1.503-.394.431-.913.703-1.522.703H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v5.256a5.51 5.51 0 0 0-1.5 1.95V6a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5Zm1.25 1.25a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 .5.5v1.5c0 .275-.225.5-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5Zm6-.5a.5.5 0 0 1 .5.5v1.5c0 .275-.225.5-.5.5h-1.5a.501.501 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h1.5Zm-6 4.5a.5.5 0 0 1 .5-.5h1.5c.275 0 .5.225.5.5v1.5c0 .275-.225.5-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5Zm6-.5c.275 0 .5.225.5.5v1.5c0 .275-.225.5-.5.5h-1.5a.501.501 0 0 1-.5-.5v-1.5c0-.275.225-.5.5-.5h1.5ZM13 15.5a4.501 4.501 0 0 1 9 0 4.501 4.501 0 0 1-9 0Zm4.5 3c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75c0 .416.334.75.75.75Zm-.528-5.5v2.5c0 .275.253.5.5.5.303 0 .5-.225.5-.5V13c0-.275-.197-.5-.5-.5a.52.52 0 0 0-.5.5Z",
        fill: "currentColor"
      }
    )
  })
);
var BuildingCircleExclamation_default = SvgBuildingCircleExclamation;

// src/Icon/icons/BuildingCircleXmark.tsx
import { jsx as jsx296 } from "react/jsx-runtime";
var SvgBuildingCircleXmark = (props) => /* @__PURE__ */ jsx296(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx296(
      "path",
      {
        d: "M3.5 6v12a.5.5 0 0 0 .5.5h2.5v-2a1.5 1.5 0 0 1 3 0v2H12c.275 0 .5-.225.5-.5v-.206c.256.56.603 1.065 1.022 1.503-.394.431-.913.703-1.522.703H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v5.256a5.51 5.51 0 0 0-1.5 1.95V6a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5Zm1.25 1.25a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 .5.5v1.5c0 .275-.225.5-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5Zm6-.5a.5.5 0 0 1 .5.5v1.5c0 .275-.225.5-.5.5h-1.5a.501.501 0 0 1-.5-.5v-1.5a.5.5 0 0 1 .5-.5h1.5Zm-6 4.5a.5.5 0 0 1 .5-.5h1.5c.275 0 .5.225.5.5v1.5c0 .275-.225.5-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5Zm6-.5c.275 0 .5.225.5.5v1.5c0 .275-.225.5-.5.5h-1.5a.501.501 0 0 1-.5-.5v-1.5c0-.275.225-.5.5-.5h1.5ZM13 15.5a4.501 4.501 0 0 1 9 0 4.501 4.501 0 0 1-9 0Zm6.353-1.147a.496.496 0 0 0 0-.706.496.496 0 0 0-.706 0L17.5 14.794l-1.147-1.147a.496.496 0 0 0-.706 0 .496.496 0 0 0 0 .706l1.147 1.147-1.147 1.147a.496.496 0 0 0 0 .706.496.496 0 0 0 .706 0l1.147-1.147 1.147 1.147a.496.496 0 0 0 .706 0 .496.496 0 0 0 0-.706L18.206 15.5l1.147-1.147Z",
        fill: "currentColor"
      }
    )
  })
);
var BuildingCircleXmark_default = SvgBuildingCircleXmark;

// src/Icon/icons/BuildingColumns.tsx
import { jsx as jsx297 } from "react/jsx-runtime";
var SvgBuildingColumns = (props) => /* @__PURE__ */ jsx297(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx297(
      "path",
      {
        d: "M21.313 7.004c.425.234.687.68.687 1.164 0 .738-.594 1.332-1.332 1.332H3.33a1.33 1.33 0 0 1-.642-2.496l8.859-4.887a.938.938 0 0 1 .906 0l8.86 4.887ZM10.75 7c0-.691.559-1.25 1.25-1.25a1.249 1.249 0 0 1 1.082 1.875h5.473L12 4.008 5.445 7.625h5.473A1.256 1.256 0 0 1 10.75 7ZM4.5 10.75h1.875V17h2.5v-6.25h1.875V17h2.5v-6.25h1.875V17h2.5v-6.25H19.5V17h.313c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H4.5A.937.937 0 1 1 4.5 17v-6.25Zm16.563 9.375c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H3.25a.937.937 0 1 1 0-1.875h17.813Z",
        fill: "currentColor"
      }
    )
  })
);
var BuildingColumns_default = SvgBuildingColumns;

// src/Icon/icons/Building.tsx
import { jsx as jsx298 } from "react/jsx-runtime";
var SvgBuilding = (props) => /* @__PURE__ */ jsx298(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx298(
      "path",
      {
        d: "M7.938 6.063c0-.346.28-.625.625-.625h1.874c.344 0 .626.28.626.625v1.875a.627.627 0 0 1-.626.625H8.563a.626.626 0 0 1-.626-.626V6.063Zm7.5-.625c.343 0 .624.28.624.625v1.875a.627.627 0 0 1-.625.625h-1.874a.627.627 0 0 1-.626-.626V6.063c0-.345.282-.625.626-.625h1.874Zm-7.5 5.625c0-.344.28-.626.625-.626h1.874c.344 0 .626.282.626.626v1.874a.627.627 0 0 1-.626.626H8.563a.626.626 0 0 1-.626-.626v-1.874Zm7.5-.626c.343 0 .624.282.624.626v1.874a.627.627 0 0 1-.625.626h-1.874a.627.627 0 0 1-.626-.626v-1.874c0-.344.282-.626.626-.626h1.874ZM4.5 4.5A2.5 2.5 0 0 1 7 2h10c1.379 0 2.5 1.12 2.5 2.5v15c0 1.379-1.121 2.5-2.5 2.5H7c-1.38 0-2.5-1.121-2.5-2.5v-15Zm1.875 0v15c0 .344.28.625.625.625h3.125v-2.5a1.875 1.875 0 0 1 3.75 0v2.5H17a.627.627 0 0 0 .625-.625v-15A.626.626 0 0 0 17 3.875H7a.625.625 0 0 0-.625.625Z",
        fill: "currentColor"
      }
    )
  })
);
var Building_default = SvgBuilding;

// src/Icon/icons/Buildings.tsx
import { jsx as jsx299 } from "react/jsx-runtime";
var SvgBuildings = (props) => /* @__PURE__ */ jsx299(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx299(
      "path",
      {
        d: "M15.125 13.875c0-.344.281-.625.625-.625H17c.344 0 .625.281.625.625v1.25a.627.627 0 0 1-.625.625h-1.25a.627.627 0 0 1-.625-.625v-1.25Zm0-7.5c0-.344.281-.625.625-.625H17c.344 0 .625.281.625.625v1.25A.627.627 0 0 1 17 8.25h-1.25a.627.627 0 0 1-.625-.625v-1.25ZM15.75 12a.627.627 0 0 1-.625-.625v-1.25c0-.344.281-.625.625-.625H17c.344 0 .625.281.625.625v1.25A.627.627 0 0 1 17 12h-1.25ZM19.5 2C20.879 2 22 3.12 22 4.5v15c0 1.379-1.121 2.5-2.5 2.5h-6.25a2.502 2.502 0 0 1-2.5-2.5v-15c0-1.38 1.121-2.5 2.5-2.5h6.25Zm0 1.875h-6.25a.626.626 0 0 0-.625.625v15c0 .344.281.625.625.625h6.25a.627.627 0 0 0 .625-.625v-15a.626.626 0 0 0-.625-.625Zm-10 5H4.812a.936.936 0 0 0-.937.938v9.374c0 .52.42.938.938.938H9.55A3.75 3.75 0 0 0 10.453 22h-5.64A2.812 2.812 0 0 1 2 19.187V9.813A2.812 2.812 0 0 1 4.813 7H9.5v1.875ZM7.625 14.5c.344 0 .625.281.625.625v1.25a.627.627 0 0 1-.625.625h-1.25a.627.627 0 0 1-.625-.625v-1.25c0-.344.281-.625.625-.625h1.25Zm0-3.75c.344 0 .625.281.625.625v1.25a.627.627 0 0 1-.625.625h-1.25a.627.627 0 0 1-.625-.625v-1.25c0-.344.281-.625.625-.625h1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var Buildings_default = SvgBuildings;

// src/Icon/icons/Bullhorn.tsx
import { jsx as jsx300 } from "react/jsx-runtime";
var SvgBullhorn = (props) => /* @__PURE__ */ jsx300(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx300(
      "path",
      {
        d: "M9.84 6.936c2.734 0 5.36-1.085 7.293-3.02l1.484-1.484c.785-.787 2.133-.23 2.133.884v5.636c.727.344 1.25 1.27 1.25 2.36 0 1.09-.523 2.015-1.25 2.359v5.637c0 1.113-1.348 1.672-2.133.882l-1.484-1.484c-1.867-1.867-4.375-2.976-7.008-3.016v4.059c0 1.207-.98 2.188-2.188 2.188h-1.25A2.188 2.188 0 0 1 4.5 19.748v-4.062c-1.38 0-2.5-1.122-2.5-2.5v-3.75c0-1.38 1.12-2.5 2.5-2.5h5.34Zm9.035-2.111-.418.417a12.192 12.192 0 0 1-8.332 3.566v5.007c3.129.04 6.113 1.348 8.332 3.567l.418.418V4.825Zm-12.5 14.924c0 .172.14.313.313.313h1.25c.171 0 .312-.141.312-.313v-4.062H6.375v4.062Zm-2.5-10.313v3.75c0 .344.28.59.625.59h3.75V8.811H4.5a.626.626 0 0 0-.625.625Z",
        fill: "currentColor"
      }
    )
  })
);
var Bullhorn_default = SvgBullhorn;

// src/Icon/icons/BullseyeArrow.tsx
import { jsx as jsx301 } from "react/jsx-runtime";
var SvgBullseyeArrow = (props) => /* @__PURE__ */ jsx301(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx301(
      "path",
      {
        d: "m16.313 10.34 1.789.297c.097.441.148.894.148 1.363A6.248 6.248 0 0 1 12 18.25 6.248 6.248 0 0 1 5.75 12a6.248 6.248 0 0 1 7.613-6.101l.297 1.788-.191.192c-.457-.164-.953-.29-1.469-.29-2.418 0-4.375 1.993-4.375 4.376 0 2.453 1.957 4.41 4.375 4.41s4.375-1.957 4.375-4.41c0-.48-.09-.977-.254-1.434l.192-.191ZM21.44 8.7c.329 1 .559 2.144.559 3.3 0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2c1.156 0 2.266.196 3.3.557l-1.515 1.515A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12a6.47 6.47 0 0 0-.23-1.785l1.546-1.516Zm-8.812 3.929c-.332.398-.926.398-1.293 0-.363-.332-.363-.926 0-1.293l3.601-3.598-.332-1.979a1.25 1.25 0 0 1 .348-1.089l2-2c.285-.317.856-.207 1.024.21l.898 2.21 2.246.898a.68.68 0 0 1 .207 1.059l-2 2c-.285.285-.691.379-1.086.348l-1.98-.332-3.633 3.566Z",
        fill: "currentColor"
      }
    )
  })
);
var BullseyeArrow_default = SvgBullseyeArrow;

// src/Icon/icons/BullseyePointer.tsx
import { jsx as jsx302 } from "react/jsx-runtime";
var SvgBullseyePointer = (props) => /* @__PURE__ */ jsx302(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx302(
      "path",
      {
        d: "M12 20.125A8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875a8.124 8.124 0 0 0-8.1 8.762l-1.831.539A10.092 10.092 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10c-.398 0-.79-.023-1.176-.07l.54-1.828c.21.015.421.023.636.023Zm.465-3.773A4.378 4.378 0 0 0 16.375 12 4.373 4.373 0 0 0 12 7.625a4.378 4.378 0 0 0-4.352 3.91l-1.897.559L5.75 12A6.248 6.248 0 0 1 12 5.75 6.248 6.248 0 0 1 18.25 12 6.248 6.248 0 0 1 12 18.25c-.031 0-.063-.035-.094-.035l.559-1.863ZM3.524 14.05l8.003-2.352a.614.614 0 0 1 .774.774L9.949 20.44c-.16.579-.906.645-1.16.137L7.672 18.34c-.027-.086-.063-.102-.102-.145l-3.436 3.438a1.25 1.25 0 0 1-1.768-1.766l3.437-3.437a.693.693 0 0 0-.144-.102l-2.238-1.117a.626.626 0 0 1 .103-1.16Z",
        fill: "currentColor"
      }
    )
  })
);
var BullseyePointer_default = SvgBullseyePointer;

// src/Icon/icons/Bullseye.tsx
import { jsx as jsx303 } from "react/jsx-runtime";
var SvgBullseye = (props) => /* @__PURE__ */ jsx303(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx303(
      "path",
      {
        d: "M9.5 12c0-1.379 1.121-2.5 2.5-2.5s2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5A2.502 2.502 0 0 1 9.5 12Zm2.5.625a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625.627.627 0 0 0-.625.625c0 .344.281.625.625.625ZM5.75 12A6.248 6.248 0 0 1 12 5.75 6.248 6.248 0 0 1 18.25 12 6.248 6.248 0 0 1 12 18.25 6.248 6.248 0 0 1 5.75 12ZM12 16.375A4.373 4.373 0 0 0 16.375 12 4.373 4.373 0 0 0 12 7.625 4.373 4.373 0 0 0 7.625 12 4.373 4.373 0 0 0 12 16.375ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var Bullseye_default = SvgBullseye;

// src/Icon/icons/Burst.tsx
import { jsx as jsx304 } from "react/jsx-runtime";
var SvgBurst = (props) => /* @__PURE__ */ jsx304(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx304(
      "path",
      {
        d: "m9.848 6.54 1.261-3.892a.936.936 0 0 1 1.782 0l1.347 4.16 2.754-1.001c.344-.125.727-.04.95.216.292.258.374.641.253.985l-1.004 2.754 4.16 1.347a.936.936 0 0 1 0 1.782l-4.027 1.304 2.067 3.93c.191.363.125.809-.2 1.066-.257.325-.703.391-1.066.2l-3.93-2.067-1.304 4.028a.936.936 0 0 1-1.782 0l-1.304-4.028-3.931 2.067a.897.897 0 0 1-1.1-.2c-.29-.257-.357-.703-.166-1.066l2.068-3.93-4.028-1.304a.936.936 0 0 1 0-1.782L6.54 9.848l-4.375-6.38a.937.937 0 0 1 1.304-1.304l6.38 4.375Zm-1.532 3.913a1.887 1.887 0 0 1-1.199 1.18L5.98 12l1.274.414c.523.168.95.563 1.156 1.074.211.512.18 1.09-.074 1.582l-.664 1.258 1.258-.664c.457-.254 1.07-.285 1.582-.074.476.207.906.633 1.074 1.156L12 18.02l.414-1.274c.168-.523.563-.95 1.074-1.156.512-.211 1.09-.18 1.582.074l1.258.664-.664-1.258a1.884 1.884 0 0 1-.074-1.582 1.865 1.865 0 0 1 1.156-1.074L18.02 12l-1.407-.457a1.869 1.869 0 0 1-1.105-.961 1.855 1.855 0 0 1-.078-1.465l.312-.86-.86.313c-.48.176-1.042.114-1.464-.074a1.887 1.887 0 0 1-.961-1.11L12 5.98l-.367 1.137a1.887 1.887 0 0 1-1.18 1.2 1.877 1.877 0 0 1-1.664-.231L6.555 6.555l1.53 2.234c.337.484.419 1.102.231 1.664Z",
        fill: "currentColor"
      }
    )
  })
);
var Burst_default = SvgBurst;

// src/Icon/icons/BusinessTime.tsx
import { jsx as jsx305 } from "react/jsx-runtime";
var SvgBusinessTime = (props) => /* @__PURE__ */ jsx305(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx305(
      "path",
      {
        d: "M17.5 11a4.501 4.501 0 0 0 0 9 4.5 4.5 0 1 0 0-9Zm1.5 5h-1.5a.5.5 0 0 1-.5-.5v-2c0-.275.225-.5.5-.5s.5.225.5.5V15h1a.5.5 0 1 1 0 1ZM4 17.5a.501.501 0 0 1-.5-.5v-3.5H8v.5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.5h.38a5.492 5.492 0 0 1 .877-1.5H3.5V9c0-.275.225-.5.5-.5h12c.275 0 .5.225.5.5v1.095c.325-.06.66-.095 1-.095.169 0 .335.01.5.025V9a2 2 0 0 0-2-2h-2V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v1H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h9.256a5.489 5.489 0 0 1-.876-1.5H4ZM7.5 6a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v1h-5V6Z",
        fill: "currentColor"
      }
    )
  })
);
var BusinessTime_default = SvgBusinessTime;

// src/Icon/icons/C.tsx
import { jsx as jsx306 } from "react/jsx-runtime";
var SvgC = (props) => /* @__PURE__ */ jsx306(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx306(
      "path",
      {
        d: "M13.282 22c-6.165 0-9.852-5.183-9.852-9.96C3.43 7.241 7.126 2 13.282 2c4.24 0 7.286 2.788 7.286 3.686 0 .408-.317 1.072-1.071 1.072-1.08 0-2.143-2.615-6.215-2.615C8.461 4.143 5.57 8.21 5.57 12c0 3.725 2.887 7.857 7.714 7.857 4.067 0 5.138-2.615 6.214-2.615.408 0 1.072.316 1.072 1.072-.002.882-3.024 3.686-7.288 3.686Z",
        fill: "currentColor"
      }
    )
  })
);
var C_default = SvgC;

// src/Icon/icons/CabinetFiling.tsx
import { jsx as jsx307 } from "react/jsx-runtime";
var SvgCabinetFiling = (props) => /* @__PURE__ */ jsx307(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx307(
      "path",
      {
        d: "M18.25 2H5.75a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5h12.5a2.5 2.5 0 0 0 2.5-2.5v-15c0-1.38-1.121-2.5-2.5-2.5Zm0 18.125H5.75a.625.625 0 0 1-.625-.625v-6.563h13.75V19.5a.627.627 0 0 1-.625.625Zm.625-9.063H5.125V4.5c0-.345.28-.625.625-.625h12.5c.345 0 .625.28.625.625v6.563ZM8.25 8.563h.625a.623.623 0 0 0 .625-.624v-.313h5v.313c0 .346.278.625.625.625h.625a.623.623 0 0 0 .625-.626V7c0-.688-.562-1.25-1.25-1.25h-6.25c-.688 0-1.25.562-1.25 1.25v.938c0 .347.277.625.625.625Zm0 9.376h.625a.623.623 0 0 0 .625-.625V17h5v.313c0 .346.278.625.625.625h.625a.623.623 0 0 0 .625-.625v-.938c0-.688-.562-1.25-1.25-1.25h-6.25c-.688 0-1.25.562-1.25 1.25v.938c0 .347.277.625.625.625Z",
        fill: "currentColor"
      }
    )
  })
);
var CabinetFiling_default = SvgCabinetFiling;

// src/Icon/icons/CalculatorSimple.tsx
import { jsx as jsx308 } from "react/jsx-runtime";
var SvgCalculatorSimple = (props) => /* @__PURE__ */ jsx308(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx308(
      "path",
      {
        d: "M8.566 15.398a.937.937 0 0 0-1.325 0l-.866.903-.9-.9a.937.937 0 1 0-1.325 1.326l.9.898-.9.9a.937.937 0 1 0 1.325 1.325l.9-.9.9.899c.182.186.42.276.662.276a.937.937 0 0 0 .663-1.6l-.9-.9.899-.9a.912.912 0 0 0-.033-1.327ZM4.5 7.27h3.75a.938.938 0 0 0 0-1.875H4.5a.938.938 0 0 0 0 1.875Zm10.938.046h1.25v1.25c0 .518.42.935.937.935a.935.935 0 0 0 .938-.935v-1.25h1.25a.94.94 0 0 0 .937-.94.935.935 0 0 0-.938-.935h-1.25v-1.25a.94.94 0 0 0-.937-.94.94.94 0 0 0-.938.94v1.25h-1.25a.935.935 0 0 0-.937.935c0 .517.422.94.938.94Zm5.624 3.747h-8.125V2.937a.937.937 0 1 0-1.874 0v8.126H2.937A.939.939 0 0 0 2 12c0 .516.42.938.938.938h8.124v8.124a.938.938 0 0 0 1.876 0v-8.125h8.124c.52 0 .938-.417.938-.937a.935.935 0 0 0-.938-.938ZM19.5 18.25h-3.752a.937.937 0 0 0 .002 1.875h3.75a.938.938 0 0 0 0-1.875Zm0-3.125h-3.75a.938.938 0 0 0-.938.938c0 .517.418.937.903.937h3.752c.553 0 .97-.418.97-.938a.935.935 0 0 0-.937-.937Z",
        fill: "currentColor"
      }
    )
  })
);
var CalculatorSimple_default = SvgCalculatorSimple;

// src/Icon/icons/Calculator.tsx
import { jsx as jsx309 } from "react/jsx-runtime";
var SvgCalculator = (props) => /* @__PURE__ */ jsx309(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx309(
      "path",
      {
        d: "M12 15.438a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.874ZM12 12a.937.937 0 1 0 0-1.875A.937.937 0 0 0 12 12Zm3.438 3.438a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.874Zm0-3.438a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875Zm0 6.875a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875Zm-6.876 0h3.126a.937.937 0 1 0 0-1.875H8.562a.937.937 0 1 0 0 1.875ZM17 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10a2.5 2.5 0 0 0 2.5-2.5v-15C19.5 3.12 18.379 2 17 2Zm.625 17.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.625-.625V8.875h11.25V19.5Zm0-12.5H6.375V4.5c0-.345.28-.625.625-.625h10c.345 0 .625.28.625.625V7Zm-9.063 5c.52 0 .938-.418.938-.938a.935.935 0 0 0-.938-.937.935.935 0 0 0-.937.938c0 .519.42.937.938.937Zm0 3.438c.52 0 .938-.418.938-.938a.935.935 0 0 0-.938-.938.935.935 0 0 0-.937.938c0 .52.42.938.938.938Z",
        fill: "currentColor"
      }
    )
  })
);
var Calculator_default = SvgCalculator;

// src/Icon/icons/CalendarArrowDown.tsx
import { jsx as jsx310 } from "react/jsx-runtime";
var SvgCalendarArrowDown = (props) => /* @__PURE__ */ jsx310(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx310(
      "path",
      {
        d: "m12.938 15.676 1.523-1.528c.367-.363.96-.363 1.293 0 .398.368.398.961 0 1.293l-3.125 3.125c-.332.399-.926.399-1.293 0L8.21 15.441c-.363-.332-.363-.925 0-1.293.367-.363.96-.363 1.293 0l1.559 1.528v-3.989c0-.519.417-.937.937-.937s.938.418.938.938v3.988ZM8.25 2c.52 0 .938.42.938.938V4.5h5.624V2.937a.937.937 0 1 1 1.876 0V4.5h1.562c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937c0-.517.417-.937.937-.937Zm10.625 7.5H5.125v10c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarArrowDown_default = SvgCalendarArrowDown;

// src/Icon/icons/CalendarArrowUp.tsx
import { jsx as jsx311 } from "react/jsx-runtime";
var SvgCalendarArrowUp = (props) => /* @__PURE__ */ jsx311(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx311(
      "path",
      {
        d: "m11.063 13.95-1.56 1.491c-.331.399-.925.399-1.292 0-.363-.332-.363-.925 0-1.293l3.125-3.125c.367-.363.96-.363 1.293 0l3.125 3.125c.398.368.398.961 0 1.293-.332.399-.926.399-1.293 0l-1.524-1.492v3.989c0 .519-.417.937-.937.937a.935.935 0 0 1-.938-.938V13.95ZM8.25 2c.52 0 .938.42.938.938V4.5h5.624V2.937a.937.937 0 1 1 1.876 0V4.5h1.562c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937c0-.517.417-.937.937-.937Zm10.625 7.5H5.125v10c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarArrowUp_default = SvgCalendarArrowUp;

// src/Icon/icons/CalendarCheck.tsx
import { jsx as jsx312 } from "react/jsx-runtime";
var SvgCalendarCheck = (props) => /* @__PURE__ */ jsx312(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx312(
      "path",
      {
        d: "M11.691 17.941c-.332.399-.925.399-1.293 0l-2.5-2.5c-.363-.332-.363-.925 0-1.293.368-.363.961-.363 1.293 0l1.871 1.84 3.711-3.715c.368-.363.961-.363 1.293 0 .399.368.399.961 0 1.293l-4.375 4.375ZM8.25 2c.52 0 .938.42.938.938V4.5h5.624V2.937a.937.937 0 1 1 1.876 0V4.5h1.562c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937c0-.517.417-.937.937-.937Zm10.625 7.5H5.125v10c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarCheck_default = SvgCalendarCheck;

// src/Icon/icons/CalendarCircleExclamation.tsx
import { jsx as jsx313 } from "react/jsx-runtime";
var SvgCalendarCircleExclamation = (props) => /* @__PURE__ */ jsx313(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx313(
      "path",
      {
        d: "M7.247 5.333h5.03V3.944a.832.832 0 1 1 1.667 0v1.39h1.39c1.225 0 2.222.994 2.222 2.222v2.222H3.636v8.889c0 .305.28.555.555.555h7.688a6.12 6.12 0 0 0 1.607 1.667H4.222A2.223 2.223 0 0 1 2 18.667V7.556c0-1.228.995-2.223 2.222-2.223h1.39V3.944a.832.832 0 1 1 1.666 0l-.031 1.39ZM22 15.89c0 2.76-2.24 5-5 5s-5.031-2.24-5.031-5 2.27-5 5.031-5c2.76 0 5 2.24 5 5Zm-5 1.667a.831.831 0 0 0-.833.833c0 .462.371.833.833.833a.831.831 0 0 0 .833-.833.831.831 0 0 0-.833-.833Zm.524-4.445a.538.538 0 0 0-.555-.555.579.579 0 0 0-.556.555v2.778c0 .305.281.555.556.555.337 0 .555-.25.555-.555V13.11Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarCircleExclamation_default = SvgCalendarCircleExclamation;

// src/Icon/icons/CalendarCircleMinus.tsx
import { jsx as jsx314 } from "react/jsx-runtime";
var SvgCalendarCircleMinus = (props) => /* @__PURE__ */ jsx314(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx314(
      "path",
      {
        d: "M7.247 5.333h5.03V3.944a.832.832 0 1 1 1.667 0v1.39h1.39c1.225 0 2.222.994 2.222 2.222v2.222H3.636v8.889c0 .305.28.555.555.555h7.688a6.12 6.12 0 0 0 1.607 1.667H4.222A2.223 2.223 0 0 1 2 18.667V7.556c0-1.228.995-2.223 2.222-2.223h1.39V3.944a.832.832 0 1 1 1.666 0l-.031 1.39Zm4.722 10.556c0-2.76 2.27-5 5.031-5 2.76 0 5 2.24 5 5s-2.24 5-5 5-5.031-2.24-5.031-5Zm7.253.524a.538.538 0 0 0 .556-.555.579.579 0 0 0-.556-.556h-4.444a.579.579 0 0 0-.556.556c0 .336.25.555.556.555h4.444Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarCircleMinus_default = SvgCalendarCircleMinus;

// src/Icon/icons/CalendarCirclePlus.tsx
import { jsx as jsx315 } from "react/jsx-runtime";
var SvgCalendarCirclePlus = (props) => /* @__PURE__ */ jsx315(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx315(
      "path",
      {
        d: "M7.247 5.333h5.03V3.944a.832.832 0 1 1 1.667 0v1.39h1.39c1.225 0 2.222.994 2.222 2.222v2.222H3.636v8.889c0 .305.28.555.555.555h7.688a6.12 6.12 0 0 0 1.607 1.667H4.222A2.223 2.223 0 0 1 2 18.667V7.556c0-1.228.995-2.223 2.222-2.223h1.39V3.944a.832.832 0 1 1 1.666 0l-.031 1.39ZM22 15.89c0 2.76-2.24 5-5 5s-5.031-2.24-5.031-5 2.27-5 5.031-5c2.76 0 5 2.24 5 5Zm-5.556-2.254v1.667h-1.666a.579.579 0 0 0-.556.556c0 .336.25.555.556.555h1.666v1.667c0 .337.25.555.556.555a.538.538 0 0 0 .556-.555v-1.667h1.666a.538.538 0 0 0 .556-.555.579.579 0 0 0-.556-.556h-1.666v-1.667A.579.579 0 0 0 17 13.08a.579.579 0 0 0-.556.555Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarCirclePlus_default = SvgCalendarCirclePlus;

// src/Icon/icons/CalendarCircleUser.tsx
import { jsx as jsx316 } from "react/jsx-runtime";
var SvgCalendarCircleUser = (props) => /* @__PURE__ */ jsx316(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx316(
      "path",
      {
        d: "M7.247 5.333h5.03V3.944a.832.832 0 1 1 1.667 0v1.39h1.39c1.225 0 2.222.994 2.222 2.222v2.222H3.636v8.889c0 .305.28.555.555.555h7.688a6.12 6.12 0 0 0 1.607 1.667H4.222A2.223 2.223 0 0 1 2 18.667V7.556c0-1.228.995-2.223 2.222-2.223h1.39V3.944a.832.832 0 1 1 1.666 0l-.031 1.39Zm4.722 10.556c0-2.76 2.27-5 5.031-5 2.76 0 5 2.24 5 5s-2.24 5-5 5-5.031-2.24-5.031-5ZM17 19.778a3.878 3.878 0 0 0 2.698-1.087 1.649 1.649 0 0 0-1.566-1.135h-2.264c-.73 0-1.35.475-1.566 1.135A3.878 3.878 0 0 0 17 19.778Zm0-3.334a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarCircleUser_default = SvgCalendarCircleUser;

// src/Icon/icons/CalendarClock.tsx
import { jsx as jsx317 } from "react/jsx-runtime";
var SvgCalendarClock = (props) => /* @__PURE__ */ jsx317(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx317(
      "path",
      {
        d: "M6.413 3.111c.493 0 .834.373.834.833v1.39h5.03v-1.39a.832.832 0 1 1 1.667 0v1.39h1.39c1.225 0 2.222.994 2.222 2.222v2.222H3.636v8.889c0 .305.28.555.555.555h7.688a6.12 6.12 0 0 0 1.607 1.667H4.222A2.223 2.223 0 0 1 2 18.667V7.556c0-1.228.995-2.223 2.222-2.223h1.39V3.944c0-.46.37-.833.832-.833h-.03ZM22 15.89c0 2.76-2.24 5-5 5s-5.031-2.24-5.031-5 2.27-5 5.031-5c2.76 0 5 2.24 5 5Zm-5.587-2.222v2.222c0 .305.281.555.556.555h1.698c.305 0 .555-.25.555-.555a.557.557 0 0 0-.555-.556h-1.143v-1.666a.538.538 0 0 0-.555-.556.579.579 0 0 0-.556.556Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarClock_default = SvgCalendarClock;

// src/Icon/icons/CalendarDay.tsx
import { jsx as jsx318 } from "react/jsx-runtime";
var SvgCalendarDay = (props) => /* @__PURE__ */ jsx318(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx318(
      "path",
      {
        d: "M11.375 12c.344 0 .625.281.625.625v3.75a.627.627 0 0 1-.625.625h-3.75A.627.627 0 0 1 7 16.375v-3.75c0-.344.281-.625.625-.625h3.75ZM8.25 2c.52 0 .938.42.938.938V4.5h5.624V2.937a.937.937 0 1 1 1.876 0V4.5h1.562c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937c0-.517.417-.937.937-.937Zm10.625 7.5H5.125v10c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarDay_default = SvgCalendarDay;

// src/Icon/icons/CalendarDays.tsx
import { jsx as jsx319 } from "react/jsx-runtime";
var SvgCalendarDays = (props) => /* @__PURE__ */ jsx319(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx319(
      "path",
      {
        d: "M9.188 4.5h5.624V2.937a.937.937 0 1 1 1.876 0V4.5h1.562c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937a.936.936 0 1 1 1.875 0V4.5Zm-4.063 7.188H8.25V9.5H5.125v2.188Zm0 1.874v2.5H8.25v-2.5H5.125Zm5 0v2.5h3.75v-2.5h-3.75Zm5.625 0v2.5h3.125v-2.5H15.75ZM18.875 9.5H15.75v2.188h3.125V9.5Zm0 8.438H15.75v2.187h2.5a.627.627 0 0 0 .625-.625v-1.563Zm-5 0h-3.75v2.187h3.75v-2.188Zm-5.625 0H5.125V19.5c0 .344.28.625.625.625h2.5v-2.188ZM13.875 9.5h-3.75v2.188h3.75V9.5Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarDays_default = SvgCalendarDays;

// src/Icon/icons/CalendarExclamation.tsx
import { jsx as jsx320 } from "react/jsx-runtime";
var SvgCalendarExclamation = (props) => /* @__PURE__ */ jsx320(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx320(
      "path",
      {
        d: "M13.25 17.625c0 .691-.559 1.25-1.25 1.25s-1.25-.559-1.25-1.25.559-1.25 1.25-1.25 1.25.559 1.25 1.25Zm-.313-3.438c0 .52-.417.938-.937.938a.935.935 0 0 1-.938-.938v-2.5c0-.519.418-.937.938-.937s.938.418.938.938v2.5ZM9.188 4.5h5.626V2.937a.937.937 0 1 1 1.874 0V4.5h1.563c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937a.936.936 0 1 1 1.875 0V4.5Zm-4.062 15c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10H5.125v10Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarExclamation_default = SvgCalendarExclamation;

// src/Icon/icons/CalendarImage.tsx
import { jsx as jsx321 } from "react/jsx-runtime";
var SvgCalendarImage = (props) => /* @__PURE__ */ jsx321(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx321(
      "path",
      {
        d: "m9.992 14.848.445.59 2.278-3.29a.624.624 0 0 1 1.039.02l3.262 5.121a.626.626 0 0 1-.528.961H7.645a.626.626 0 0 1-.496-1.008L9 14.84a.62.62 0 0 1 .992.008ZM7 12c0-.691.559-1.25 1.25-1.25S9.5 11.309 9.5 12s-.559 1.25-1.25 1.25S7 12.691 7 12Zm2.188-7.5h5.624V2.937a.937.937 0 1 1 1.876 0V4.5h1.562c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937a.936.936 0 1 1 1.875 0V4.5Zm-4.063 15c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10H5.125v10Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarImage_default = SvgCalendarImage;

// src/Icon/icons/CalendarLinesPen.tsx
import { jsx as jsx322 } from "react/jsx-runtime";
var SvgCalendarLinesPen = (props) => /* @__PURE__ */ jsx322(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx322(
      "path",
      {
        d: "M6.445 3.11c.462 0 .834.373.834.833v1.389h5.001v-1.39a.833.833 0 1 1 1.667 0v1.39h1.39c1.225 0 2.222.995 2.222 2.223v2.222H3.667v8.891c0 .306.249.556.556.556h6.894l-.178.701c-.08.327-.059.66.05.966H4.222A2.224 2.224 0 0 1 2 18.668V7.555c0-1.228.995-2.223 2.223-2.223h1.389v-1.39c0-.46.372-.833.833-.833ZM12.28 12c.462 0 .834.372.834.834a.831.831 0 0 1-.834.833H6.168a.832.832 0 0 1-.834-.833c0-.462.372-.834.834-.834h6.112Zm-6.946 4.168c0-.462.372-.834.834-.834h3.89c.461 0 .833.372.833.834a.831.831 0 0 1-.834.833h-3.89a.832.832 0 0 1-.833-.833Zm16.257-4.373c.545.542.545 1.42 0 1.966l-1.021 1.02-2.462-2.465 1.02-1.021a1.392 1.392 0 0 1 1.966 0l.497.5Zm-8.759 5.765 4.487-4.456 2.466 2.463-4.487 4.487a1.118 1.118 0 0 1-.517.292l-2.088.524a.567.567 0 0 1-.528-.146.59.59 0 0 1-.145-.559l.52-2.06c.05-.194.15-.371.292-.545Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarLinesPen_default = SvgCalendarLinesPen;

// src/Icon/icons/CalendarLines.tsx
import { jsx as jsx323 } from "react/jsx-runtime";
var SvgCalendarLines = (props) => /* @__PURE__ */ jsx323(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx323(
      "path",
      {
        d: "M7 12.938c0-.52.418-.938.938-.938h8.125c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H7.938A.935.935 0 0 1 7 12.937Zm5.313 2.812c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H7.939A.935.935 0 0 1 7 16.687c0-.519.418-.937.938-.937h4.375ZM9.187 4.5h5.626V2.937a.937.937 0 1 1 1.874 0V4.5h1.563c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937a.936.936 0 1 1 1.875 0V4.5Zm-4.062 15c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10H5.125v10Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarLines_default = SvgCalendarLines;

// src/Icon/icons/CalendarMinus.tsx
import { jsx as jsx324 } from "react/jsx-runtime";
var SvgCalendarMinus = (props) => /* @__PURE__ */ jsx324(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx324(
      "path",
      {
        d: "M9.188 15.75a.935.935 0 0 1-.938-.938c0-.519.418-.937.938-.937h5.624c.52 0 .938.418.938.938 0 .519-.418.937-.938.937H9.189ZM8.25 2c.52 0 .938.42.938.938V4.5h5.624V2.937a.937.937 0 1 1 1.876 0V4.5h1.562c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937c0-.517.417-.937.937-.937Zm10.625 7.5H5.125v10c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarMinus_default = SvgCalendarMinus;

// src/Icon/icons/CalendarPen.tsx
import { jsx as jsx325 } from "react/jsx-runtime";
var SvgCalendarPen = (props) => /* @__PURE__ */ jsx325(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx325(
      "path",
      {
        d: "m15.313 13.578-.583.582-2.082-2.117.582-.55a1.474 1.474 0 1 1 2.082 2.085ZM8.957 15.77l2.773-2.81 2.118 2.083-2.809 2.813c-.16.124-.363.273-.582.328l-1.43.355a.619.619 0 0 1-.593-.164.616.616 0 0 1-.164-.594l.355-1.43c.055-.218.137-.421.332-.581ZM8.25 2c.52 0 .938.42.938.938V4.5h5.624V2.937a.937.937 0 1 1 1.876 0V4.5h1.562c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937c0-.517.417-.937.937-.937Zm10.625 7.5H5.125v10c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarPen_default = SvgCalendarPen;

// src/Icon/icons/CalendarPlus.tsx
import { jsx as jsx326 } from "react/jsx-runtime";
var SvgCalendarPlus = (props) => /* @__PURE__ */ jsx326(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx326(
      "path",
      {
        d: "M12 11.063c.52 0 .938.417.938.937v1.875h1.874c.52 0 .938.418.938.938 0 .519-.418.937-.938.937h-1.874v1.875c0 .52-.418.938-.938.938a.935.935 0 0 1-.938-.938V15.75H9.188a.935.935 0 0 1-.938-.938c0-.519.418-.937.938-.937h1.874V12c0-.52.418-.938.938-.938ZM9.187 4.5h5.626V2.937a.937.937 0 1 1 1.874 0V4.5h1.563c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937a.936.936 0 1 1 1.875 0V4.5Zm-4.062 15c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10H5.125v10Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarPlus_default = SvgCalendarPlus;

// src/Icon/icons/CalendarRange.tsx
import { jsx as jsx327 } from "react/jsx-runtime";
var SvgCalendarRange = (props) => /* @__PURE__ */ jsx327(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx327(
      "path",
      {
        d: "M7 13.25c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25-.559 1.25-1.25 1.25S7 13.941 7 13.25Zm8.75 2.5c.691 0 1.25.559 1.25 1.25s-.559 1.25-1.25 1.25-1.25-.559-1.25-1.25.559-1.25 1.25-1.25Zm-5-2.5c0-.52.418-.938.938-.938h4.374c.52 0 .938.418.938.938s-.418.938-.938.938h-4.375a.935.935 0 0 1-.937-.938Zm1.563 2.813c.519 0 .937.418.937.937 0 .52-.418.938-.938.938H7.939A.935.935 0 0 1 7 17c0-.52.418-.938.938-.938h4.375ZM9.187 4.5h5.626V2.937a.937.937 0 1 1 1.874 0V4.5h1.563c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937a.936.936 0 1 1 1.875 0V4.5Zm-4.062 15c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10H5.125v10Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarRange_default = SvgCalendarRange;

// src/Icon/icons/CalendarStar.tsx
import { jsx as jsx328 } from "react/jsx-runtime";
var SvgCalendarStar = (props) => /* @__PURE__ */ jsx328(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx328(
      "path",
      {
        d: "m13.285 13.355 2.063.301a.404.404 0 0 1 .222.692L14.082 15.8l.352 2.05a.408.408 0 0 1-.59.43L12 17.313l-1.844.968a.408.408 0 0 1-.59-.43l.352-2.05-1.488-1.453a.404.404 0 0 1 .222-.692l2.063-.3.922-1.868c.148-.3.578-.3.726 0l.922 1.867ZM8.25 2c.52 0 .938.42.938.938V4.5h5.624V2.937a.937.937 0 1 1 1.876 0V4.5h1.562c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937c0-.517.417-.937.937-.937Zm10.625 7.5H5.125v10c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarStar_default = SvgCalendarStar;

// src/Icon/icons/CalendarWeek.tsx
import { jsx as jsx329 } from "react/jsx-runtime";
var SvgCalendarWeek = (props) => /* @__PURE__ */ jsx329(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx329(
      "path",
      {
        d: "M16.375 12c.344 0 .625.281.625.625v2.5a.627.627 0 0 1-.625.625h-8.75A.627.627 0 0 1 7 15.125v-2.5c0-.344.281-.625.625-.625h8.75ZM8.25 2c.52 0 .938.42.938.938V4.5h5.624V2.937a.937.937 0 1 1 1.876 0V4.5h1.562c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937c0-.517.417-.937.937-.937Zm10.625 7.5H5.125v10c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarWeek_default = SvgCalendarWeek;

// src/Icon/icons/CalendarXmark.tsx
import { jsx as jsx330 } from "react/jsx-runtime";
var SvgCalendarXmark = (props) => /* @__PURE__ */ jsx330(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx330(
      "path",
      {
        d: "m13.324 14.813 1.805 1.835c.398.368.398.961 0 1.293-.332.399-.926.399-1.293 0L12 16.137l-1.871 1.804c-.332.399-.926.399-1.293 0-.363-.332-.363-.925 0-1.293l1.84-1.835-1.84-1.872c-.363-.332-.363-.925 0-1.293.367-.363.96-.363 1.293 0L12 13.488l1.836-1.84c.367-.363.96-.363 1.293 0 .398.368.398.961 0 1.293l-1.805 1.871ZM8.25 2c.52 0 .938.42.938.938V4.5h5.624V2.937a.937.937 0 1 1 1.876 0V4.5h1.562c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937c0-.517.417-.937.937-.937Zm10.625 7.5H5.125v10c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10Z",
        fill: "currentColor"
      }
    )
  })
);
var CalendarXmark_default = SvgCalendarXmark;

// src/Icon/icons/Calendar.tsx
import { jsx as jsx331 } from "react/jsx-runtime";
var SvgCalendar = (props) => /* @__PURE__ */ jsx331(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx331(
      "path",
      {
        d: "M9.188 4.5h5.624V2.937a.937.937 0 1 1 1.876 0V4.5h1.562c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V7a2.5 2.5 0 0 1 2.5-2.5h1.563V2.937a.936.936 0 1 1 1.875 0V4.5Zm-4.063 15c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-10H5.125v10Z",
        fill: "currentColor"
      }
    )
  })
);
var Calendar_default = SvgCalendar;

// src/Icon/icons/Calendars.tsx
import { jsx as jsx332 } from "react/jsx-runtime";
var SvgCalendars = (props) => /* @__PURE__ */ jsx332(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx332(
      "path",
      {
        d: "M10.75 2c.52 0 .938.42.938.938V4.5h4.374V2.937a.937.937 0 1 1 1.875 0V4.5H19.5C20.879 4.5 22 5.62 22 7v8.75c0 1.379-1.121 2.5-2.5 2.5H8.25a2.502 2.502 0 0 1-2.5-2.5V7c0-1.38 1.121-2.5 2.5-2.5h1.563V2.937c0-.517.417-.937.937-.937ZM7.625 15.75c0 .344.281.625.625.625H19.5a.627.627 0 0 0 .625-.625V9.5h-12.5v6.25Zm-3.75 1.563a2.812 2.812 0 0 0 2.813 2.812h10.625c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H6.688A4.687 4.687 0 0 1 2 17.312V9.188a.936.936 0 1 1 1.875 0v8.126Z",
        fill: "currentColor"
      }
    )
  })
);
var Calendars_default = SvgCalendars;

// src/Icon/icons/Camcorder.tsx
import { jsx as jsx333 } from "react/jsx-runtime";
var SvgCamcorder = (props) => /* @__PURE__ */ jsx333(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx333(
      "path",
      {
        d: "M12.833 11.444H5.611a.835.835 0 0 0-.833.834c0 .458.373.833.833.833h7.222a.834.834 0 0 0 0-1.667Zm8.528-2.003a1.383 1.383 0 0 0-1.33-.093l-3.587 1.645v-.104a2.222 2.222 0 0 0-2.222-2.222l-8.889-.032V7.278a1.39 1.39 0 0 1 1.39-1.39h5.555a.832.832 0 1 0 0-1.666H6.722a3.059 3.059 0 0 0-3.055 3.056v1.467C2.71 8.993 2 9.855 2 10.858v6.635c0 1.228.995 2.191 2.222 2.191l10 .094a2.222 2.222 0 0 0 2.222-2.222v-.105l3.587 1.644a1.388 1.388 0 0 0 1.33-.093c.4-.255.639-.693.639-1.2v-7.19c0-.477-.24-.91-.639-1.171Zm-6.583 8.115c0 .306-.25.555-.556.555h-10a.556.556 0 0 1-.555-.555v-6.667c0-.306.249-.556.555-.556h10c.306 0 .556.25.556.556v6.667Zm5.555-.157-3.889-1.782v-2.79l3.89-1.783V17.4Z",
        fill: "currentColor"
      }
    )
  })
);
var Camcorder_default = SvgCamcorder;

// src/Icon/icons/CameraCctv.tsx
import { jsx as jsx334 } from "react/jsx-runtime";
var SvgCameraCctv = (props) => /* @__PURE__ */ jsx334(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx334(
      "path",
      {
        d: "M19.964 8.966 6.832 3.192a1.106 1.106 0 0 0-1.374.482l-3.31 5.793a1.1 1.1 0 0 0-.079.933c.113.309.356.552.664.663l5.704 2.36-1.46 3.853h-3.31v-1.11a.832.832 0 1 0-1.667 0v3.887a.832.832 0 1 0 1.666 0v-1.11h3.888a.87.87 0 0 0 .781-.538l1.639-4.347 2.627 1.087a1.098 1.098 0 0 0 .968-.1l6.567-4.11a1.108 1.108 0 0 0-.172-1.969Zm-7.033 4.513L3.907 9.747l2.75-4.811 11.705 5.148-5.43 3.395Zm9.026-.538a.66.66 0 0 0-.281-.326l-1.228-.538-4.805 3.003 4.149 1.823c.295.13.64-.005.77-.3l1.415-3.215a.782.782 0 0 0-.02-.447Z",
        fill: "currentColor"
      }
    )
  })
);
var CameraCctv_default = SvgCameraCctv;

// src/Icon/icons/CameraSlash.tsx
import { jsx as jsx335 } from "react/jsx-runtime";
var SvgCameraSlash = (props) => /* @__PURE__ */ jsx335(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx335(
      "path",
      {
        d: "M6.837 7h1.497l.325-.974A1.496 1.496 0 0 1 10.081 5h3.838c.646 0 1.218.413 1.421 1.026l.325.974H18c1.103 0 2 .897 2 2v8c0 .103-.006.203-.022.3l1.734 1.36a.75.75 0 0 1-.925 1.18l-18.5-14.5a.75.75 0 1 1 .926-1.18L6.837 7ZM8.75 8.5l1.722 1.35A3.498 3.498 0 0 1 15.5 13c0 .25-.025.494-.075.731l3.075 2.41V9c0-.275-.225-.5-.5-.5h-3.416l-.665-2H10.08l-.665 2H8.75Zm5.206 4.081A2.004 2.004 0 0 0 12 11h-.06l2.016 1.581ZM12 16.5A3.498 3.498 0 0 1 8.5 13a6.1 6.1 0 0 1 .066-.806l1.459 1.13a2.003 2.003 0 0 0 2.122 1.67l1.434 1.103A3.183 3.183 0 0 1 12 16.5Zm-6 1h9.328l1.903 1.5H6c-1.104 0-2-.897-2-2V9c0-.134.013-.266.039-.394L5.5 9.756V17c0 .275.225.5.5.5Z",
        fill: "currentColor"
      }
    )
  })
);
var CameraSlash_default = SvgCameraSlash;

// src/Icon/icons/CameraViewfinder.tsx
import { jsx as jsx336 } from "react/jsx-runtime";
var SvgCameraViewfinder = (props) => /* @__PURE__ */ jsx336(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx336(
      "path",
      {
        d: "M2 2.938C2 2.42 2.42 2 2.938 2h4.374a.936.936 0 1 1 0 1.875H3.876v3.438a.936.936 0 1 1-1.875 0V2.938ZM9.813 12c0-1.207.98-2.188 2.187-2.188a2.189 2.189 0 0 1 0 4.375A2.189 2.189 0 0 1 9.812 12Zm3.96-6.25c.625 0 1.192.371 1.438.945L15.34 7h.41c1.379 0 2.5 1.121 2.5 2.5v5c0 1.379-1.121 2.5-2.5 2.5h-7.5a2.502 2.502 0 0 1-2.5-2.5v-5c0-1.379 1.121-2.5 2.5-2.5h.41l.13-.305a1.56 1.56 0 0 1 1.437-.945h3.546ZM9.895 8.875H8.25a.627.627 0 0 0-.625.625v5c0 .344.281.625.625.625h7.5a.627.627 0 0 0 .625-.625v-5a.627.627 0 0 0-.625-.625h-1.645l-.535-1.25h-3.14l-.535 1.25ZM21.063 2c.519 0 .937.42.937.938v4.374c0 .52-.418.938-.938.938a.935.935 0 0 1-.937-.938V3.876h-3.438a.937.937 0 1 1 0-1.875h4.375ZM2 16.688a.937.937 0 1 1 1.875 0v3.437h3.438c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H2.938A.937.937 0 0 1 2 21.062v-4.375ZM16.688 22a.935.935 0 0 1-.938-.938c0-.519.418-.937.938-.937h3.437v-3.438c0-.519.418-.937.938-.937.519 0 .937.418.937.938v4.375c0 .519-.418.937-.938.937h-4.375Z",
        fill: "currentColor"
      }
    )
  })
);
var CameraViewfinder_default = SvgCameraViewfinder;

// src/Icon/icons/CameraWebSlash.tsx
import { jsx as jsx337 } from "react/jsx-runtime";
var SvgCameraWebSlash = (props) => /* @__PURE__ */ jsx337(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx337(
      "path",
      {
        d: "m21.718 18.659-4.555-3.57a6.757 6.757 0 0 0 1.591-4.342c0-3.73-3.023-6.724-6.752-6.724-2.241 0-4.213 1.104-5.439 2.785L3.216 4.183a.725.725 0 0 0-1.056.1.75.75 0 0 0 .127 1.053l18.477 14.476a.748.748 0 0 0 .463.188.75.75 0 0 0 .59-.288.724.724 0 0 0-.1-1.053Zm-8.1-6.377-3.516-2.729c.397-.631 1.097-1.085 1.897-1.085 1.241 0 2.254 1.038 2.254 2.279 0 .606-.244 1.16-.635 1.535Zm1.182.953c.59-.66.953-1.528.953-2.488a3.751 3.751 0 0 0-3.75-3.751 3.725 3.725 0 0 0-3.078 1.636l-1.174-.92c.947-1.336 2.492-2.216 4.251-2.216a5.257 5.257 0 0 1 5.252 5.251 5.185 5.185 0 0 1-1.282 3.407l-1.172-.919ZM8.295 18.5l1.176-1.495a6.725 6.725 0 0 0 5.211-.06l-1.422-1.115c-.405.1-.822.17-1.258.17-2.894-.029-5.251-2.357-5.251-5.252l.002-.018L5.35 9.63c-.06.363-.1.735-.1 1.116a6.742 6.742 0 0 0 2.883 5.53l-1.973 2.51a.752.752 0 0 0-.085.79c.125.26.387.422.675.422h11.831l-1.914-1.5H8.295Z",
        fill: "currentColor"
      }
    )
  })
);
var CameraWebSlash_default = SvgCameraWebSlash;

// src/Icon/icons/CameraWeb.tsx
import { jsx as jsx338 } from "react/jsx-runtime";
var SvgCameraWeb = (props) => /* @__PURE__ */ jsx338(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx338(
      "path",
      {
        d: "M12 5.721a4.696 4.696 0 1 0 0 9.391 4.696 4.696 0 0 0 0-9.39Zm0 7.514a2.817 2.817 0 0 1-.004-5.635 2.824 2.824 0 0 1 2.822 2.817A2.82 2.82 0 0 1 12 13.235Zm4.845 4.105a8.443 8.443 0 0 0 3.607-6.923C20.452 5.75 16.668 2 12 2s-8.452 3.784-8.452 8.417a8.44 8.44 0 0 0 3.61 6.923l-2.47 3.141A.938.938 0 0 0 5.426 22h13.147a.94.94 0 0 0 .738-1.52l-2.468-3.14Zm-9.486 2.782 1.472-1.872a8.409 8.409 0 0 0 6.338 0l1.472 1.872H7.359ZM12 16.992a6.582 6.582 0 0 1-6.574-6.575A6.583 6.583 0 0 1 12 3.843a6.581 6.581 0 0 1 6.574 6.574A6.583 6.583 0 0 1 12 16.991Z",
        fill: "currentColor"
      }
    )
  })
);
var CameraWeb_default = SvgCameraWeb;

// src/Icon/icons/CaretLeft.tsx
import { jsx as jsx339 } from "react/jsx-runtime";
var SvgCaretLeft = (props) => /* @__PURE__ */ jsx339(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx339(
      "path",
      {
        d: "M18.499 19V5.001c0-2.664-3.235-4.007-5.125-2.117l-7 6.993a3.022 3.022 0 0 0 0 4.25l7 6.993c1.888 1.88 5.125.549 5.125-2.12Zm-10-6.999 6.999-7v14l-7-7Z",
        fill: "currentColor"
      }
    )
  })
);
var CaretLeft_default = SvgCaretLeft;

// src/Icon/icons/CaretRight.tsx
import { jsx as jsx340 } from "react/jsx-runtime";
var SvgCaretRight = (props) => /* @__PURE__ */ jsx340(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx340(
      "path",
      {
        d: "M5.49 4.969v14.024c0 2.67 3.24 4.015 5.134 2.121l7.012-7.006a3.027 3.027 0 0 0 0-4.257l-7.012-7.006C8.73 1.016 5.489 2.352 5.489 4.97Zm10.017 7.012-7.012 7.012V4.97l7.012 7.012Z",
        fill: "currentColor"
      }
    )
  })
);
var CaretRight_default = SvgCaretRight;

// src/Icon/icons/CaretUp.tsx
import { jsx as jsx341 } from "react/jsx-runtime";
var SvgCaretUp = (props) => /* @__PURE__ */ jsx341(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx341(
      "path",
      {
        d: "M4.999 18.5h14c2.664 0 4.007-3.236 2.117-5.126l-6.994-7a3.022 3.022 0 0 0-4.25 0l-6.993 7c-1.88 1.888-.544 5.125 2.12 5.125Zm6.945-10.057 7 7H4.999l6.945-7Z",
        fill: "currentColor"
      }
    )
  })
);
var CaretUp_default = SvgCaretUp;

// src/Icon/icons/Cellular.tsx
import { jsx as jsx342 } from "react/jsx-runtime";
var SvgCellular = (props) => /* @__PURE__ */ jsx342(
  "svg",
  __spreadProps(__spreadValues({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx342(
      "path",
      {
        d: "M3 18.481h1.332c.365 0 .612-.229.612-.587v-3.416c0-.357-.247-.586-.612-.586H3.001c-.365 0-.612.229-.612.586v3.416c0 .358.247.587.612.587ZM8.566 18.48h1.321c.375 0 .613-.228.613-.586v-5.867c0-.348-.238-.587-.613-.587h-1.32c-.375 0-.623.24-.623.587v5.867c0 .358.248.587.622.587ZM14.113 18.48h1.32c.376 0 .623-.228.623-.586V9.191c0-.348-.248-.586-.622-.586h-1.321c-.375 0-.613.238-.613.586v8.703c0 .358.238.587.613.587ZM19.668 18.481h1.323c.374 0 .62-.23.62-.587V6.106c0-.358-.246-.587-.62-.587h-1.323c-.365 0-.612.23-.612.587v11.788c0 .358.247.587.612.587Z",
        fill: "currentColor"
      }
    )
  })
);
var Cellular_default = SvgCellular;

// src/Icon/icons/Certificate.tsx
import { jsx as jsx343 } from "react/jsx-runtime";
var SvgCertificate = (props) => /* @__PURE__ */ jsx343(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx343(
      "path",
      {
        d: "m12.002 4.089 1.723-1.805c.27-.244.586-.34.95-.252a.932.932 0 0 1 .664.675l.621 2.442 2.422-.685c.329-.092.68 0 .919.24.207.24.332.59.238.917l-.684 2.423 2.442.621a.938.938 0 0 1 .676.665c.086.328-.043.644-.254.914l-1.805 1.758 1.805 1.723c.211.27.34.586.254.95a.938.938 0 0 1-.676.664l-2.442.621.684 2.422c.094.329-.031.68-.238.919-.239.207-.59.332-.919.238l-2.422-.684-.621 2.442a.938.938 0 0 1-.664.676c-.364.086-.68-.043-.95-.254l-1.723-1.805-1.758 1.805c-.27.211-.586.34-.914.254a.938.938 0 0 1-.665-.676l-.62-2.442-2.424.684c-.326.094-.677-.031-.918-.238a.937.937 0 0 1-.239-.919l.685-2.422-2.442-.621a.932.932 0 0 1-.675-.664c-.088-.364.008-.68.252-.95l1.805-1.723-1.805-1.758c-.244-.27-.34-.586-.252-.914a.932.932 0 0 1 .675-.665l2.442-.62-.685-2.424a.939.939 0 0 1 1.157-1.157l2.423.685.621-2.442a.932.932 0 0 1 .665-.675c.328-.088.644.008.914.252l1.758 1.805Zm-3.02 2.685c-.438.25-.961.317-1.446.18l-.812-.23.23.812c.137.485.07 1.008-.18 1.446-.253.406-.707.758-1.164.883l-.817.207.604.586c.362.352.569.836.569 1.344 0 .473-.207.992-.57 1.344l-.603.586.817.207c.457.125.91.446 1.164.883.25.438.317.961.18 1.446l-.23.813.812-.23a1.889 1.889 0 0 1 1.446.179c.406.254.758.672.883 1.164l.207.817.586-.602a1.87 1.87 0 0 1 1.344-.57c.473 0 .992.207 1.344.57l.586.602.207-.817c.125-.492.446-.91.883-1.164.438-.25.961-.317 1.446-.18l.813.23-.23-.812a1.889 1.889 0 0 1 .179-1.446 1.882 1.882 0 0 1 1.164-.883l.817-.207-.602-.586a1.933 1.933 0 0 1-.57-1.344c0-.508.207-.992.57-1.344l.602-.586-.817-.207c-.488-.125-.91-.477-1.164-.883a1.889 1.889 0 0 1-.18-1.446l.23-.812-.812.23a1.889 1.889 0 0 1-1.446-.18 1.895 1.895 0 0 1-.883-1.164l-.207-.817-.586.604a1.934 1.934 0 0 1-1.344.569c-.508 0-.992-.207-1.344-.57l-.586-.603-.207.817c-.125.489-.477.91-.883 1.164Z",
        fill: "currentColor"
      }
    )
  })
);
var Certificate_default = SvgCertificate;

// src/Icon/icons/Certificates.tsx
import { jsx as jsx344 } from "react/jsx-runtime";
var SvgCertificates = (props) => /* @__PURE__ */ jsx344(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx344(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.74 20C2.915 20 2 19.105 2 17.314V6.694C2 4.904 2.916 4 4.74 4h15.092c1.832 0 2.74.904 2.74 2.694v10.62c0 1.79-.908 2.686-2.74 2.686H4.74Zm.017-1.4h15.058c.863 0 1.352-.46 1.352-1.364V6.772c0-.903-.489-1.373-1.352-1.373H4.757c-.873 0-1.352.47-1.352 1.373v10.464c0 .904.48 1.365 1.352 1.365Zm9.43-1.818c-.658 0-.968-.313-.968-.967v-.738a.21.21 0 0 0-.063-.157l-.522-.522c-.463-.463-.466-.902 0-1.365l.522-.525a.197.197 0 0 0 .063-.153v-.738c0-.662.31-.968.968-.968h.738a.197.197 0 0 0 .153-.063l.526-.522c.462-.466.901-.466 1.364 0l.522.522a.21.21 0 0 0 .157.063h.738c.654 0 .967.313.967.968v.738c0 .062.018.107.063.153l.522.525c.463.463.467.902 0 1.365l-.522.522a.21.21 0 0 0-.063.157v.738c0 .654-.313.967-.967.967h-.738a.198.198 0 0 0-.157.063l-.522.522c-.463.463-.902.463-1.364 0l-.526-.522a.186.186 0 0 0-.153-.063h-.738Zm1.712-1.336c.14 0 .261-.07.345-.199l1.625-2.506a.519.519 0 0 0 .095-.258c0-.195-.174-.33-.362-.33-.122 0-.227.066-.31.198l-1.403 2.238-.644-.804c-.09-.115-.181-.156-.296-.156a.347.347 0 0 0-.348.348c0 .094.031.177.1.264l.84 1.013c.104.129.216.192.358.192ZM4.857 7.429a.571.571 0 0 0 0 1.142h14.857a.571.571 0 0 0 0-1.142H4.857Zm0 2.285a.571.571 0 0 0 0 1.143h5.714a.571.571 0 1 0 0-1.143H4.857Zm-.571 2.857c0-.315.256-.571.571-.571h3.429a.571.571 0 1 1 0 1.143H4.857a.571.571 0 0 1-.571-.572Zm.571 1.715a.571.571 0 1 0 0 1.143h5.714a.572.572 0 0 0 0-1.143H4.857Z",
        fill: "currentColor"
      }
    )
  })
);
var Certificates_default = SvgCertificates;

// src/Icon/icons/ChairOffice.tsx
import { jsx as jsx345 } from "react/jsx-runtime";
var SvgChairOffice = (props) => /* @__PURE__ */ jsx345(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx345(
      "path",
      {
        d: "M18.973 13.496A2.181 2.181 0 0 0 17 12.016L16.965 4.5c0-1.382-1.118-2.5-2.5-2.5h-5C8.117 2 6.999 3.118 6.999 4.5v7.516a2.17 2.17 0 0 0-1.969 1.48l-.42 1.25a2.2 2.2 0 0 0 .303 1.972c.41.566 1.07.907 1.773.907h4.374v2.5H9.188a.935.935 0 0 0-.937.938c0 .519.418.937.938.937h5.624a.938.938 0 0 0 0-1.875h-1.876v-2.5h4.375c.668 0 1.367-.342 1.777-.908.41-.571.523-1.304.298-1.973l-.413-1.248ZM8.84 4.5c0-.347.278-.625.625-.625h5c.347 0 .625.278.625.625V12H8.84V4.5Zm8.437 11.25H6.686a.313.313 0 0 1-.298-.41l.42-1.25a.302.302 0 0 1 .293-.215h9.797a.32.32 0 0 1 .297.215l.416 1.25c.065.207-.091.41-.334.41ZM5.75 11.062V7.938A.939.939 0 0 0 4.812 7a.939.939 0 0 0-.937.938v3.125a.937.937 0 1 0 1.875 0ZM19.188 7a.94.94 0 0 0-.938.938v3.125a.938.938 0 0 0 1.875 0V7.937A.938.938 0 0 0 19.187 7Z",
        fill: "currentColor"
      }
    )
  })
);
var ChairOffice_default = SvgChairOffice;

// src/Icon/icons/Chair.tsx
import { jsx as jsx346 } from "react/jsx-runtime";
var SvgChair = (props) => /* @__PURE__ */ jsx346(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx346(
      "path",
      {
        d: "m20.641 14.742-.415-1.25a2.18 2.18 0 0 0-1.973-1.48L18.22 7a5 5 0 0 0-5-5h-2.5C7.993 2 5.754 4.239 5.754 7l-.001 5.016a2.18 2.18 0 0 0-1.973 1.479l-.415 1.25a2.2 2.2 0 0 0 .302 1.973c.215.302.508.532.836.688v3.657c0 .519.42.937.938.937.517 0 .937-.42.937-.902v-3.473h11.25v3.438c-.034.519.42.937.904.937.484 0 .937-.42.937-.902V17.44c.327-.156.62-.386.84-.688.41-.604.555-1.338.332-2.01ZM14.781 4.31A3.05 3.05 0 0 1 16.345 7v5h-1.563V4.31Zm-3.75-.435h1.876V12h-1.875V3.875Zm-1.874.435V12H7.594V7c0-1.152.668-2.148 1.563-2.69ZM5.142 15.34l.42-1.25a.302.302 0 0 1 .293-.215h12.297a.32.32 0 0 1 .298.215l.415 1.25a.315.315 0 0 1-.302.41H5.438a.312.312 0 0 1-.296-.41Z",
        fill: "currentColor"
      }
    )
  })
);
var Chair_default = SvgChair;

// src/Icon/icons/ChalkboardUser.tsx
import { jsx as jsx347 } from "react/jsx-runtime";
var SvgChalkboardUser = (props) => /* @__PURE__ */ jsx347(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx347(
      "path",
      {
        d: "M8 15H6a4 4 0 0 0-4 4 1 1 0 0 0 1 1h8a1 1 0 0 0 1-1 4 4 0 0 0-4-4Zm-4.45 3.5c.233-1.14 1.243-2 2.45-2h2c1.207 0 2.217.86 2.45 2h-6.9ZM7 14a3 3 0 1 0 0-6c-1.684 0-3 1.316-3 3 0 1.656 1.316 3 3 3Zm0-4.5A1.501 1.501 0 1 1 5.5 11 1.5 1.5 0 0 1 7 9.5ZM20.25 4H8.75C7.784 4 7 4.785 7 5.75v.75a.75.75 0 0 0 1.5 0v-.75a.25.25 0 0 1 .25-.25h11.5a.25.25 0 0 1 .25.25v9.5a.25.25 0 0 1-.25.25H18.5v-1a1 1 0 0 0-1-1H15a1 1 0 0 0-1 1v1h-1a.75.75 0 0 0 0 1.5h7.25c.965 0 1.75-.785 1.75-1.75v-9.5C22 4.785 21.216 4 20.25 4Z",
        fill: "currentColor"
      }
    )
  })
);
var ChalkboardUser_default = SvgChalkboardUser;

// src/Icon/icons/Chalkboard.tsx
import { jsx as jsx348 } from "react/jsx-runtime";
var SvgChalkboard = (props) => /* @__PURE__ */ jsx348(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx348(
      "path",
      {
        d: "M21.167 18.111h-4.723v-1.666c0-.614-.497-1.112-1.11-1.112h-4.445c-.614 0-1.111.498-1.111 1.112v1.666H2.833a.832.832 0 1 0 0 1.667h18.334a.834.834 0 0 0 0-1.667Zm-6.39 0h-3.333V17h3.334v1.111Zm-10-11.944c0-.153.126-.278.279-.278h13.888c.153 0 .278.125.278.278V17h1.667V6.167a1.946 1.946 0 0 0-1.945-1.945H5.056A1.947 1.947 0 0 0 3.11 6.167V17h1.667V6.167Z",
        fill: "currentColor"
      }
    )
  })
);
var Chalkboard_default = SvgChalkboard;

// src/Icon/icons/ChartArea.tsx
import { jsx as jsx349 } from "react/jsx-runtime";
var SvgChartArea = (props) => /* @__PURE__ */ jsx349(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx349(
      "path",
      {
        d: "M3.875 17.938c0 .519.42.937.938.937h16.25c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H4.813A2.812 2.812 0 0 1 2 17.937V4.188a.938.938 0 0 1 1.875 0v13.75Zm12.172-9.985a1.253 1.253 0 0 1 1.832.07l2.418 2.825c.293.34.453.773.453 1.222v3.68c0 .691-.559 1.25-1.25 1.25H7c-.691 0-1.25-.559-1.25-1.25v-4.223c0-.496.2-.976.55-1.328l3.567-3.566a1.247 1.247 0 0 1 1.766 0L14.5 9.5l1.547-1.547Zm-5.297.45-3.125 3.124v3.598h11.25V12.07l-1.98-2.312-1.07 1.066c-.352.352-.829.551-1.325.551s-.973-.2-1.324-.55L10.75 8.401Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartArea_default = SvgChartArea;

// src/Icon/icons/ChartBar.tsx
import { jsx as jsx350 } from "react/jsx-runtime";
var SvgChartBar = (props) => /* @__PURE__ */ jsx350(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx350(
      "path",
      {
        d: "M2.938 3.25c.517 0 .937.42.937.938v13.75c0 .519.42.937.938.937h16.25c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H4.813A2.812 2.812 0 0 1 2 17.937V4.188c0-.517.42-.937.938-.937ZM7 7.313c0-.52.418-.938.938-.938h8.125c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H7.938A.935.935 0 0 1 7 7.312Zm6.563 2.812c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H7.939A.935.935 0 0 1 7 11.062c0-.519.418-.937.938-.937h5.625Zm5 3.75c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H7.938A.935.935 0 0 1 7 14.812c0-.519.418-.937.938-.937h10.625Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartBar_default = SvgChartBar;

// src/Icon/icons/ChartBullet.tsx
import { jsx as jsx351 } from "react/jsx-runtime";
var SvgChartBullet = (props) => /* @__PURE__ */ jsx351(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx351(
      "path",
      {
        d: "M12.313 3.25c.519 0 .937.42.937.938V4.5h6.875C21.16 4.5 22 5.34 22 6.375v2.5c0 1.035-.84 1.875-1.875 1.875H13.25v.313c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938v-.312h-7.5A1.875 1.875 0 0 1 2 8.875v-2.5C2 5.339 2.84 4.5 3.875 4.5h7.5v-.313c0-.517.418-.937.938-.937ZM8.25 8.875h3.125v-2.5H8.25v2.5Zm5-2.5v2.5h6.875v-2.5H13.25Zm-6.875 0h-2.5v2.5h2.5v-2.5ZM16.063 12c.519 0 .937.418.937.938v.312h3.125c1.035 0 1.875.84 1.875 1.875v2.5c0 1.035-.84 1.875-1.875 1.875H17v.313c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938V19.5H3.875A1.875 1.875 0 0 1 2 17.625v-2.5c0-1.035.84-1.875 1.875-1.875h11.25v-.313c0-.519.418-.937.938-.937Zm-5.313 5.625h4.375v-2.5H10.75v2.5Zm6.25-2.5v2.5h3.125v-2.5H17Zm-8.125 0h-5v2.5h5v-2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartBullet_default = SvgChartBullet;

// src/Icon/icons/ChartCandlestick.tsx
import { jsx as jsx352 } from "react/jsx-runtime";
var SvgChartCandlestick = (props) => /* @__PURE__ */ jsx352(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx352(
      "path",
      {
        d: "M3.875 17.938c0 .519.42.937.938.937h16.25c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H4.813A2.812 2.812 0 0 1 2 17.937V4.188a.938.938 0 0 1 1.875 0v13.75ZM14.5 5.75c.691 0 1.25.559 1.25 1.25v3.75c0 .691-.559 1.25-1.25 1.25v1.875a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625V12c-.691 0-1.25-.559-1.25-1.25V7c0-.691.559-1.25 1.25-1.25V3.875a.626.626 0 0 1 1.25 0V5.75Zm2.5 5c0-.691.559-1.25 1.25-1.25V7.625c0-.344.281-.625.625-.625s.625.281.625.625V9.5c.691 0 1.25.559 1.25 1.25v2.5c0 .691-.559 1.25-1.25 1.25v1.875a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625V14.5c-.691 0-1.25-.559-1.25-1.25v-2.5ZM8.25 5.125a.626.626 0 0 1 1.25 0V7c.691 0 1.25.559 1.25 1.25v5c0 .691-.559 1.25-1.25 1.25v1.875a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625V14.5c-.691 0-1.25-.559-1.25-1.25v-5C7 7.559 7.559 7 8.25 7V5.125Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartCandlestick_default = SvgChartCandlestick;

// src/Icon/icons/ChartColumn.tsx
import { jsx as jsx353 } from "react/jsx-runtime";
var SvgChartColumn = (props) => /* @__PURE__ */ jsx353(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx353(
      "path",
      {
        d: "M2.938 3.25c.517 0 .937.42.937.938v13.75c0 .519.42.937.938.937h16.25c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H4.813A2.812 2.812 0 0 1 2 17.937V4.188c0-.517.42-.937.938-.937Zm5.624 7.5c.52 0 .938.418.938.938v3.124c0 .52-.418.938-.938.938a.935.935 0 0 1-.937-.938v-3.124c0-.52.418-.938.938-.938Zm4.688 4.063c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938V7.939c0-.52.418-.938.938-.938.519 0 .937.418.937.938v6.875ZM16.063 9.5c.519 0 .937.418.937.938v4.374c0 .52-.418.938-.938.938a.935.935 0 0 1-.937-.938v-4.374c0-.52.418-.938.938-.938Zm4.687 5.313c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938V5.438a.937.937 0 1 1 1.875 0v9.375Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartColumn_default = SvgChartColumn;

// src/Icon/icons/ChartGantt.tsx
import { jsx as jsx354 } from "react/jsx-runtime";
var SvgChartGantt = (props) => /* @__PURE__ */ jsx354(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx354(
      "path",
      {
        d: "M2.938 3.25c.517 0 .937.42.937.938v13.75c0 .519.42.937.938.937h16.25c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H4.813A2.812 2.812 0 0 1 2 17.937V4.188c0-.517.42-.937.938-.937ZM7 7.313c0-.52.418-.938.938-.938h4.375c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H7.939A.935.935 0 0 1 7 7.312Zm9.063 2.812c.519 0 .937.418.937.938 0 .519-.418.937-.938.937h-5.625a.935.935 0 0 1-.937-.938c0-.519.418-.937.938-.937h5.624Zm3.75 3.75c.519 0 .937.418.937.938 0 .519-.418.937-.938.937h-3.125a.935.935 0 0 1-.937-.938c0-.519.418-.937.938-.937h3.125Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartGantt_default = SvgChartGantt;

// src/Icon/icons/ChartLineDown.tsx
import { jsx as jsx355 } from "react/jsx-runtime";
var SvgChartLineDown = (props) => /* @__PURE__ */ jsx355(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx355(
      "path",
      {
        d: "M3.875 17.938c0 .519.42.937.938.937h16.25c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H4.813A2.812 2.812 0 0 1 2 17.937V4.188a.938.938 0 0 1 1.875 0v13.75ZM14.5 13.563c0-.52.418-.938.938-.938h2.113l-3.676-3.676-3.121 3.055c-.332.398-.926.398-1.293 0L6.336 8.879c-.363-.332-.363-.926 0-1.293.367-.363.96-.363 1.293 0l2.46 2.465 3.122-3.09c.367-.363.96-.363 1.293 0l4.371 4.34V9.187c0-.519.418-.937.938-.937.519 0 .937.418.937.938v4.374c0 .52-.418.938-.938.938h-4.375a.935.935 0 0 1-.937-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartLineDown_default = SvgChartLineDown;

// src/Icon/icons/ChartLineUp.tsx
import { jsx as jsx356 } from "react/jsx-runtime";
var SvgChartLineUp = (props) => /* @__PURE__ */ jsx356(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx356(
      "path",
      {
        d: "M3.875 17.938c0 .519.42.937.938.937h16.25c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H4.813A2.812 2.812 0 0 1 2 17.937V4.188a.938.938 0 0 1 1.875 0v13.75ZM15.438 7h4.374c.52 0 .938.418.938.938v4.375c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938V10.2l-4.371 4.305c-.332.398-.926.398-1.293 0l-3.121-3.055-2.461 2.43c-.332.398-.926.398-1.293 0-.363-.332-.363-.926 0-1.293L9.46 9.46c.367-.363.96-.363 1.293 0l3.121 3.09 3.676-3.676h-2.113a.935.935 0 0 1-.938-.938c0-.519.418-.937.938-.937Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartLineUp_default = SvgChartLineUp;

// src/Icon/icons/ChartLine.tsx
import { jsx as jsx357 } from "react/jsx-runtime";
var SvgChartLine = (props) => /* @__PURE__ */ jsx357(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx357(
      "path",
      {
        d: "M3.875 17.938c0 .519.42.937.938.937h16.25c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H4.813A2.812 2.812 0 0 1 2 17.937V4.188a.938.938 0 0 1 1.875 0v13.75Zm11.254-4.06c-.332.4-.926.4-1.293 0l-3.121-3.054-3.086 3.055c-.332.398-.926.398-1.293 0-.363-.332-.363-.926 0-1.293l3.75-3.75a.919.919 0 0 1 .629-.274c.285 0 .523.098.664.274l3.121 3.09 4.648-4.653c.368-.363.961-.363 1.293 0 .399.368.399.961 0 1.293L15.13 13.88Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartLine_default = SvgChartLine;

// src/Icon/icons/ChartMixed.tsx
import { jsx as jsx358 } from "react/jsx-runtime";
var SvgChartMixed = (props) => /* @__PURE__ */ jsx358(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx358(
      "path",
      {
        d: "M15.109 10.541c-.352.27-.875.3-1.227-.004l-4.46-3.902-5.965 3.941a.903.903 0 0 1-1.3-.226.939.939 0 0 1 .26-1.301L8.98 4.675a.937.937 0 0 1 1.137.075l4.39 3.838 5.945-5.094a.936.936 0 0 1 1.32.101.934.934 0 0 1-.101 1.322l-6.562 5.624Zm-3.734 2.066v6.25c0 1.07-.84 1.875-1.875 1.875a1.853 1.853 0 0 1-1.875-1.875v-6.25c0-1 .84-1.874 1.875-1.874 1.035 0 1.875.874 1.875 1.874Zm-1.563 6.25v-6.25c0-.136-.14-.312-.312-.312s-.313.176-.313.312v6.25c0 .207.14.313.313.313.172 0 .312-.106.312-.313Zm-3.437-2.5v2.5c0 1.07-.84 1.875-1.875 1.875a1.853 1.853 0 0 1-1.875-1.875v-2.5c0-1 .84-1.875 1.875-1.875 1.035 0 1.875.875 1.875 1.875Zm-1.563 2.5v-2.5c0-.136-.14-.312-.312-.312-.173 0-.313.175-.313.312v2.5c0 .207.14.313.313.313s.312-.106.312-.313Zm7.813-3.75c0-1 .84-1.875 1.874-1.875 1.036 0 1.875.875 1.875 1.875v3.75c0 1.07-.84 1.875-1.874 1.875a1.853 1.853 0 0 1-1.875-1.875v-3.75Zm1.874-.312c-.171 0-.312.176-.312.312v3.75c0 .207.14.313.313.313.171 0 .312-.106.312-.313v-3.75c0-.136-.14-.312-.313-.312Zm6.875-2.188v6.25c0 1.07-.84 1.875-1.875 1.875a1.853 1.853 0 0 1-1.875-1.875v-6.25c0-1 .84-1.874 1.875-1.874 1.035 0 1.875.874 1.875 1.874Zm-1.562 6.25v-6.25c0-.136-.14-.312-.313-.312-.172 0-.312.176-.312.312v6.25c0 .207.14.313.312.313s.313-.106.313-.313Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartMixed_default = SvgChartMixed;

// src/Icon/icons/ChartNetwork.tsx
import { jsx as jsx359 } from "react/jsx-runtime";
var SvgChartNetwork = (props) => /* @__PURE__ */ jsx359(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx359(
      "path",
      {
        d: "M11 6c0 .527-.203 1.006-.537 1.362l.84 1.8A4.445 4.445 0 0 1 12.5 9c1.19 0 2.325.484 3.134 1.272L18.06 8.49A2 2 0 1 1 22 8a2.002 2.002 0 0 1-3.052 1.699l-2.425 1.781A4.47 4.47 0 0 1 17 13.5c0 .578-.11 1.131-.31 1.64l2.107 1.263A2.002 2.002 0 0 1 22 18c0 1.103-.897 2-2 2a2.002 2.002 0 0 1-1.975-2.31l-2.106-1.265C15.066 17.391 13.869 18 12.5 18c-2.231 0-4.081-1.622-4.466-3.75h-2.18A2 2 0 1 1 4 11.5c.838 0 1.558.516 1.852 1.25h2.181a4.646 4.646 0 0 1 1.91-2.953l-.84-1.8C9.068 7.972 9.033 8 9 8a2 2 0 1 1 2-2Zm1.5 10.5a3 3 0 0 0 3-3c0-1.684-1.344-3-3-3-1.684 0-3 1.316-3 3 0 1.656 1.316 3 3 3Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartNetwork_default = SvgChartNetwork;

// src/Icon/icons/ChartPieSimple.tsx
import { jsx as jsx360 } from "react/jsx-runtime";
var SvgChartPieSimple = (props) => /* @__PURE__ */ jsx360(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx360(
      "path",
      {
        d: "M21.352 11.375h-8.727V2.648c0-.353.238-.648.625-.648A8.75 8.75 0 0 1 22 10.75a.637.637 0 0 1-.648.625ZM10.75 13.25h8.645c.722 0 1.3.613 1.152 1.32A9.374 9.374 0 0 1 11.375 22 9.375 9.375 0 0 1 2 12.625c0-4.512 3.185-8.277 7.43-9.173.707-.149 1.32.43 1.32 1.153v8.645ZM8.875 5.551a7.504 7.504 0 0 0-5 7.074 7.48 7.48 0 0 0 7.5 7.5 7.504 7.504 0 0 0 7.074-5H8.875V5.551Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartPieSimple_default = SvgChartPieSimple;

// src/Icon/icons/ChartPie.tsx
import { jsx as jsx361 } from "react/jsx-runtime";
var SvgChartPie = (props) => /* @__PURE__ */ jsx361(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx361(
      "path",
      {
        d: "M12.038 11.41V3.163c0-.333.225-.612.59-.612a8.267 8.267 0 0 1 8.267 8.267c0 .332-.28.59-.612.59h-8.245Zm6.979-1.772C18.5 7 16.448 4.916 13.81 4.431v5.207h5.207Zm-8.75-5.255v8.798l5.776 5.776a.56.56 0 0 1-.056.856 8.818 8.818 0 0 1-5.13 1.635A8.857 8.857 0 0 1 2 12.59c0-4.477 3.325-8.18 7.606-8.775a.57.57 0 0 1 .66.567Zm-1.772 9.532V5.907a7.09 7.09 0 0 0-4.724 6.684 7.066 7.066 0 0 0 7.086 7.085 7.153 7.153 0 0 0 2.82-.583l-5.182-5.178Zm12.932-.734c.34 0 .613.288.568.627a8.847 8.847 0 0 1-2.727 5.252c-.221.177-.568.192-.782-.022l-5.857-5.857h8.798Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartPie_default = SvgChartPie;

// src/Icon/icons/ChartPyramid.tsx
import { jsx as jsx362 } from "react/jsx-runtime";
var SvgChartPyramid = (props) => /* @__PURE__ */ jsx362(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx362(
      "path",
      {
        d: "M10.3 4.126c.762-1.3 2.637-1.3 3.399 0l8.03 13.767c.765 1.31-.18 2.956-1.7 2.956H3.97c-1.518 0-2.463-1.646-1.698-2.956L10.3 4.126Zm1.7.99L9.703 9.02h4.594L12 5.116Zm5.356 9.182-1.913-3.313H8.556l-1.912 3.313h10.712ZM5.497 16.263l-1.529 2.621H20.03l-1.527-2.62H5.497Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartPyramid_default = SvgChartPyramid;

// src/Icon/icons/ChartRadar.tsx
import { jsx as jsx363 } from "react/jsx-runtime";
var SvgChartRadar = (props) => /* @__PURE__ */ jsx363(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx363(
      "path",
      {
        d: "M14.965 13.012a1.592 1.592 0 0 1-.415 3.132c-.633 0-1.183-.371-1.438-.905l-3.872-.777a1.593 1.593 0 1 1-1.064-2.78l2.295-3.06a1.593 1.593 0 1 1 2.893.382l1.6 4.008Zm-5.116-.379 3.16.634-1.263-3.155-1.897 2.521ZM6.148 4.188c.434-.688 1.171-1.112 1.964-1.112h7.777c.793 0 1.494.424 1.929 1.112l3.88 6.693a2.228 2.228 0 0 1 0 2.24l-3.88 6.693c-.435.69-1.136 1.112-1.929 1.112H8.112c-.793 0-1.53-.423-1.964-1.112L2.3 13.12a2.232 2.232 0 0 1 0-2.24l3.847-6.693Zm1.964.8c-.112 0-.22.061-.275.16l-3.882 6.658c-.057.135-.057.255 0 .354l3.882 6.694c.056.1.163.16.275.16h7.777c.112 0 .22-.06.275-.16l3.88-6.694c.06-.1.06-.219 0-.354l-3.88-6.658a.318.318 0 0 0-.275-.16H8.112Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartRadar_default = SvgChartRadar;

// src/Icon/icons/ChartScatter3D.tsx
import { jsx as jsx364 } from "react/jsx-runtime";
var SvgChartScatter3D = (props) => /* @__PURE__ */ jsx364(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx364(
      "path",
      {
        d: "M2 4.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm10.938 8.312 7.476 6.282a.936.936 0 1 1-1.203 1.437l-7.246-6.058L4.79 20.53a.937.937 0 0 1-1.207-1.437l7.443-6.282V4.187c0-.517.454-.937.938-.937.555 0 .973.42.973.937v8.625ZM15.75 4.5a1.25 1.25 0 1 1 2.499-.001 1.25 1.25 0 0 1-2.499 0Zm2.5 7.5c0 .691-.559 1.25-1.25 1.25s-1.25-.559-1.25-1.25.559-1.25 1.25-1.25 1.25.559 1.25 1.25Zm1.25-3.75c0-.691.559-1.25 1.25-1.25S22 7.559 22 8.25s-.559 1.25-1.25 1.25-1.25-.559-1.25-1.25Zm-11.25 0C8.25 8.94 7.691 9.5 7 9.5S5.75 8.94 5.75 8.25 6.309 7 7 7s1.25.559 1.25 1.25ZM4.5 12A1.25 1.25 0 1 1 2.001 12 1.25 1.25 0 0 1 4.5 12Zm6.25 7.5c0-.692.559-1.25 1.25-1.25s1.25.558 1.25 1.25c0 .691-.559 1.25-1.25 1.25s-1.25-.559-1.25-1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartScatter3D_default = SvgChartScatter3D;

// src/Icon/icons/ChartScatterBubble.tsx
import { jsx as jsx365 } from "react/jsx-runtime";
var SvgChartScatterBubble = (props) => /* @__PURE__ */ jsx365(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx365(
      "path",
      {
        d: "M2.938 3.25c.517 0 .937.42.937.938v13.75c0 .519.42.937.938.937h16.25c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H4.813A2.812 2.812 0 0 1 2 17.937V4.188c0-.517.42-.937.938-.937ZM7 13.875a1.875 1.875 0 1 1 3.75 0 1.875 1.875 0 0 1-3.75 0Zm11.25-.625c0 1.379-1.121 2.5-2.5 2.5a2.502 2.502 0 0 1-2.5-2.5c0-1.379 1.121-2.5 2.5-2.5s2.5 1.121 2.5 2.5Zm-2.5-.938a.935.935 0 0 0-.938.938c0 .52.418.938.938.938s.938-.418.938-.938a.935.935 0 0 0-.938-.938ZM9.5 8.876a1.875 1.875 0 1 1 3.75 0 1.875 1.875 0 0 1-3.75 0ZM19.5 7c0 1.379-1.121 2.5-2.5 2.5A2.501 2.501 0 1 1 19.5 7ZM17 6.062a.935.935 0 0 0-.938.938c0 .52.418.938.938.938s.938-.418.938-.938A.935.935 0 0 0 17 6.062Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartScatterBubble_default = SvgChartScatterBubble;

// src/Icon/icons/ChartScatter.tsx
import { jsx as jsx366 } from "react/jsx-runtime";
var SvgChartScatter = (props) => /* @__PURE__ */ jsx366(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx366(
      "path",
      {
        d: "M3.875 17.938c0 .519.42.937.938.937h16.25c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H4.813A2.812 2.812 0 0 1 2 17.937V4.188a.938.938 0 0 1 1.875 0v13.75ZM8.25 8.25C8.25 7.559 8.809 7 9.5 7s1.25.559 1.25 1.25S10.191 9.5 9.5 9.5s-1.25-.559-1.25-1.25ZM14.5 12c0 .691-.559 1.25-1.25 1.25S12 12.691 12 12s.559-1.25 1.25-1.25 1.25.559 1.25 1.25Zm1.25 2.5c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25-.559 1.25-1.25 1.25-1.25-.559-1.25-1.25ZM19.5 7c0 .691-.559 1.25-1.25 1.25S17 7.691 17 7s.559-1.25 1.25-1.25S19.5 6.309 19.5 7ZM7 14.5c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25-.559 1.25-1.25 1.25S7 15.191 7 14.5Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartScatter_default = SvgChartScatter;

// src/Icon/icons/ChartSimpleHorizontal.tsx
import { jsx as jsx367 } from "react/jsx-runtime";
var SvgChartSimpleHorizontal = (props) => /* @__PURE__ */ jsx367(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx367(
      "path",
      {
        d: "M22 12.714c0 1.183-.96 2.143-2.143 2.143H4.143A2.143 2.143 0 0 1 2 12.714v-1.428c0-1.183.96-2.143 2.143-2.143h15.714c1.183 0 2.143.96 2.143 2.143v1.428ZM4.143 11.286v1.428h15.714v-1.428H4.143Zm9.286 8.571c0 1.183-.96 2.143-2.143 2.143H4.143A2.143 2.143 0 0 1 2 19.857V18.43c0-1.183.96-2.143 2.143-2.143h7.143c1.183 0 2.143.96 2.143 2.143v1.428ZM4.143 18.43v1.428h7.143V18.43H4.143Zm0-10.715A2.143 2.143 0 0 1 2 5.571V4.143C2 2.959 2.96 2 4.143 2H17c1.183 0 2.143.96 2.143 2.143V5.57c0 1.183-.96 2.143-2.143 2.143H4.143ZM17 5.571V4.143H4.143V5.57H17Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartSimpleHorizontal_default = SvgChartSimpleHorizontal;

// src/Icon/icons/ChartSimple.tsx
import { jsx as jsx368 } from "react/jsx-runtime";
var SvgChartSimple = (props) => /* @__PURE__ */ jsx368(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx368(
      "path",
      {
        d: "M12.714 2c1.183 0 2.143.96 2.143 2.143v15.714c0 1.183-.96 2.143-2.143 2.143h-1.428a2.143 2.143 0 0 1-2.143-2.143V4.143c0-1.184.96-2.143 2.143-2.143h1.428Zm0 2.143h-1.428v15.714h1.428V4.143ZM5.571 10.57c1.183 0 2.143.96 2.143 2.143v7.143c0 1.183-.96 2.143-2.143 2.143H4.143A2.143 2.143 0 0 1 2 19.857v-7.143c0-1.183.96-2.143 2.143-2.143H5.57Zm0 2.143H4.143v7.143H5.57v-7.143ZM16.286 7c0-1.183.96-2.143 2.143-2.143h1.428C21.04 4.857 22 5.817 22 7v12.857C22 21.04 21.04 22 19.857 22H18.43a2.143 2.143 0 0 1-2.143-2.143V7Zm2.143 12.857h1.428V7H18.43v12.857Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartSimple_default = SvgChartSimple;

// src/Icon/icons/ChartTreeMap.tsx
import { jsx as jsx369 } from "react/jsx-runtime";
var SvgChartTreeMap = (props) => /* @__PURE__ */ jsx369(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx369(
      "path",
      {
        d: "M8.875 3.25c1.035 0 1.875.84 1.875 1.875V9.5c0 1.035-.84 1.875-1.875 1.875h-5A1.875 1.875 0 0 1 2 9.5V5.125c0-1.036.84-1.875 1.875-1.875h5Zm0 1.875h-5V9.5h5V5.125Zm0 7.5c1.035 0 1.875.84 1.875 1.875v4.375c0 1.035-.84 1.875-1.875 1.875h-5A1.875 1.875 0 0 1 2 18.875V14.5c0-1.035.84-1.875 1.875-1.875h5Zm0 1.875h-5v4.375h5V14.5ZM12 5.125c0-1.036.84-1.875 1.875-1.875h6.25C21.16 3.25 22 4.09 22 5.125v1.25c0 1.035-.84 1.875-1.875 1.875h-6.25A1.875 1.875 0 0 1 12 6.375v-1.25Zm1.875 1.25h6.25v-1.25h-6.25v1.25Zm6.25 3.125c1.035 0 1.875.84 1.875 1.875v1.25c0 1.035-.84 1.875-1.875 1.875h-6.25A1.875 1.875 0 0 1 12 12.625v-1.25c0-1.035.84-1.875 1.875-1.875h6.25Zm0 1.875h-6.25v1.25h6.25v-1.25ZM12 17.625c0-1.035.84-1.875 1.875-1.875h6.25c1.035 0 1.875.84 1.875 1.875v1.25c0 1.035-.84 1.875-1.875 1.875h-6.25A1.875 1.875 0 0 1 12 18.875v-1.25Zm1.875 1.25h6.25v-1.25h-6.25v1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartTreeMap_default = SvgChartTreeMap;

// src/Icon/icons/ChartUser.tsx
import { jsx as jsx370 } from "react/jsx-runtime";
var SvgChartUser = (props) => /* @__PURE__ */ jsx370(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx370(
      "path",
      {
        d: "M7 14a3 3 0 1 0 0-6c-1.684 0-3 1.316-3 3 0 1.656 1.316 3 3 3Zm0-4.5A1.501 1.501 0 1 1 5.5 11 1.5 1.5 0 0 1 7 9.5ZM8 15H6a4 4 0 0 0-4 4 1 1 0 0 0 1 1h8a1 1 0 0 0 1-1 4 4 0 0 0-4-4Zm-4.45 3.5c.233-1.14 1.243-2 2.45-2h2c1.207 0 2.217.86 2.45 2h-6.9ZM20.25 4H8.75C7.784 4 7 4.785 7 5.75v.75a.75.75 0 0 0 1.5 0v-.75a.25.25 0 0 1 .25-.25h11.5a.25.25 0 0 1 .25.25v9.5a.25.25 0 0 1-.25.25H13a.75.75 0 0 0 0 1.5h7.25c.965 0 1.75-.785 1.75-1.75v-9.5C22 4.785 21.216 4 20.25 4Zm-7.997 5.219a.751.751 0 0 0-1.061 1.061l2.25 2.25c.174.148.364.22.558.22a.745.745 0 0 0 .53-.22l2.97-2.97v.69a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75h-2.5a.751.751 0 0 0 0 1.5h.69L14 10.938l-1.747-1.72Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartUser_default = SvgChartUser;

// src/Icon/icons/ChartWaterfall.tsx
import { jsx as jsx371 } from "react/jsx-runtime";
var SvgChartWaterfall = (props) => /* @__PURE__ */ jsx371(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx371(
      "path",
      {
        d: "M2.938 3.25c.517 0 .937.42.937.938v13.75c0 .519.42.937.938.937h16.25c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H4.813A2.812 2.812 0 0 1 2 17.937V4.188c0-.517.42-.937.938-.937Zm5.624 7.5c.52 0 .938.418.938.938v3.124c0 .52-.418.938-.938.938a.935.935 0 0 1-.937-.938v-3.124c0-.52.418-.938.938-.938Zm4.688.313c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938V7.938c0-.52.418-.938.938-.938.519 0 .937.418.937.938v3.125ZM16.063 4.5c.519 0 .937.42.937.938v3.125c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938V5.438c0-.518.418-.938.938-.938Zm4.687 10.313c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938V5.438a.937.937 0 1 1 1.875 0v9.375Z",
        fill: "currentColor"
      }
    )
  })
);
var ChartWaterfall_default = SvgChartWaterfall;

// src/Icon/icons/CheckDouble.tsx
import { jsx as jsx372 } from "react/jsx-runtime";
var SvgCheckDouble = (props) => /* @__PURE__ */ jsx372(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx372(
      "path",
      {
        d: "M9.866 11.295c-.38.456-1.059.456-1.479 0L4.815 7.722c-.418-.38-.418-1.059 0-1.479a1.078 1.078 0 0 1 1.516 0l2.816 2.819 6.387-6.39c.42-.42 1.1-.42 1.479 0a1.011 1.011 0 0 1 0 1.515l-7.147 7.108Zm0 10.006c-.38.456-1.059.456-1.479 0l-6.073-6.075c-.419-.38-.419-1.059 0-1.478a1.078 1.078 0 0 1 1.516 0l5.317 5.32L20.18 8.03c.42-.415 1.099-.415 1.478 0 .456.42.456 1.099 0 1.479L9.866 21.3Z",
        fill: "currentColor"
      }
    )
  })
);
var CheckDouble_default = SvgCheckDouble;

// src/Icon/icons/CheckToSlot.tsx
import { jsx as jsx373 } from "react/jsx-runtime";
var SvgCheckToSlot = (props) => /* @__PURE__ */ jsx373(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx373(
      "path",
      {
        d: "m13.844 7.875-2.518 3.205-1.284-1.1a.831.831 0 1 0-1.084 1.263l1.945 1.667c.153.1.34.17.51.17.027 0 .056 0 .083-.004a.829.829 0 0 0 .574-.315l3.056-3.889a.833.833 0 0 0-.141-1.17c-.332-.282-.856-.188-1.141.173Zm-8.51 9.403h13.333a.834.834 0 0 0 0-1.667V6.444a2.222 2.222 0 0 0-2.223-2.222H7.556a2.223 2.223 0 0 0-2.223 2.222v9.167a.833.833 0 1 0 0 1.667ZM7 6.444c0-.306.249-.555.556-.555h8.888c.307 0 .556.249.556.555v9.167H7V6.444Zm13.215 6.667a.834.834 0 0 0 0 1.667c.066 0 .118.052.118.118v2.937a.278.278 0 0 1-.277.278H3.944a.278.278 0 0 1-.277-.278v-2.936c0-.067.053-.12.118-.12a.834.834 0 0 0 0-1.666c-.984 0-1.785.802-1.785 1.785v2.937c0 1.073.873 1.945 1.944 1.945h16.112A1.947 1.947 0 0 0 22 17.833v-2.936c0-.984-.802-1.786-1.785-1.786Z",
        fill: "currentColor"
      }
    )
  })
);
var CheckToSlot_default = SvgCheckToSlot;

// src/Icon/icons/Check.tsx
import { jsx as jsx374 } from "react/jsx-runtime";
var SvgCheck = (props) => /* @__PURE__ */ jsx374(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx374(
      "path",
      {
        d: "M21.658 5.35c.456.42.456 1.099 0 1.479L9.866 18.62c-.38.456-1.059.456-1.479 0l-6.073-6.075c-.419-.38-.419-1.058 0-1.478a1.078 1.078 0 0 1 1.516 0l5.317 5.32L20.18 5.35c.42-.417 1.099-.417 1.478 0Z",
        fill: "currentColor"
      }
    )
  })
);
var Check_default = SvgCheck;

// src/Icon/icons/CheckCircle.tsx
import { jsx as jsx375 } from "react/jsx-runtime";
var CheckCircle = (props) => /* @__PURE__ */ jsx375(
  "svg",
  __spreadProps(__spreadValues({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx375(
      "path",
      {
        d: "M13.3125 7.54395C13.3125 10.7549 10.6875 13.3564 7.5 13.3564C4.28906 13.3564 1.6875 10.7549 1.6875 7.54395C1.6875 4.35645 4.28906 1.73145 7.5 1.73145C10.6875 1.73145 13.3125 4.35645 13.3125 7.54395ZM6.82031 10.6377L11.1328 6.3252C11.2734 6.18457 11.2734 5.92676 11.1328 5.78613L10.5938 5.27051C10.4531 5.10645 10.2188 5.10645 10.0781 5.27051L6.5625 8.78613L4.89844 7.14551C4.75781 6.98145 4.52344 6.98145 4.38281 7.14551L3.84375 7.66113C3.70312 7.80176 3.70312 8.05957 3.84375 8.2002L6.28125 10.6377C6.42188 10.7783 6.67969 10.7783 6.82031 10.6377Z",
        fill: "currentColor"
      }
    )
  })
);
var CheckCircle_default = CheckCircle;

// src/Icon/icons/ChevronLeft.tsx
import { jsx as jsx376 } from "react/jsx-runtime";
var SvgChevronLeft = (props) => /* @__PURE__ */ jsx376(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx376(
      "path",
      {
        d: "m15.467 21.656-8.495-8.865c-.25-.297-.352-.575-.352-.812 0-.237.103-.555.31-.77l8.494-8.865a1.11 1.11 0 0 1 1.573-.034c.447.424.461 1.13.033 1.573L9.275 11.98l7.794 8.137c.428.44.413 1.15-.033 1.573a1.105 1.105 0 0 1-1.57-.033Z",
        fill: "currentColor"
      }
    )
  })
);
var ChevronLeft_default = SvgChevronLeft;

// src/Icon/icons/ChevronRight.tsx
import { jsx as jsx377 } from "react/jsx-runtime";
var SvgChevronRight = (props) => /* @__PURE__ */ jsx377(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx377(
      "path",
      {
        d: "m8.55 2.344 8.511 8.885c.208.215.311.494.311.771 0 .278-.103.556-.31.771l-8.513 8.885a1.112 1.112 0 0 1-1.576.033 1.11 1.11 0 0 1-.033-1.576l7.81-8.155-7.809-8.07a1.11 1.11 0 0 1 .033-1.577 1.11 1.11 0 0 1 1.575.033Z",
        fill: "currentColor"
      }
    )
  })
);
var ChevronRight_default = SvgChevronRight;

// src/Icon/icons/ChevronsUpDown.tsx
import { jsx as jsx378 } from "react/jsx-runtime";
var SvgChevronsUpDown = (props) => /* @__PURE__ */ jsx378(
  "svg",
  __spreadProps(__spreadValues({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx378(
      "path",
      {
        d: "M4.667 10 8 13.333 11.333 10M4.667 6 8 2.667 11.333 6",
        stroke: "#3F3F46",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  })
);
var ChevronsUpDown_default = SvgChevronsUpDown;

// src/Icon/icons/ChevronUp.tsx
import { jsx as jsx379 } from "react/jsx-runtime";
var SvgChevronUp = (props) => /* @__PURE__ */ jsx379(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx379(
      "path",
      {
        d: "m2.344 15.489 8.866-8.495c.254-.25.533-.394.81-.394.28 0 .556.103.77.31l8.866 8.494c.445.425.46 1.13.034 1.573a1.108 1.108 0 0 1-1.574.034l-8.095-7.716-8.137 7.794c-.441.428-1.15.413-1.574-.033a1.103 1.103 0 0 1 .034-1.568Z",
        fill: "currentColor"
      }
    )
  })
);
var ChevronUp_default = SvgChevronUp;

// src/Icon/icons/ChevronsDown.tsx
import { jsx as jsx380 } from "react/jsx-runtime";
var SvgChevronsDown = (props) => /* @__PURE__ */ jsx380(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx380(
      "path",
      {
        d: "M11.202 12.448a1.155 1.155 0 0 0 1.596 0l8.846-8.462c.46-.44.477-1.17.036-1.631a1.158 1.158 0 0 0-1.631-.034L12 10.02l-8.048-7.7c-.505-.439-1.192-.425-1.632.036a1.155 1.155 0 0 0 .036 1.631l8.846 8.46Zm9.645-1.216c-.287 0-.575.107-.798.32L12 19.252l-8.048-7.698c-.505-.442-1.192-.428-1.632.034a1.153 1.153 0 0 0 .036 1.63l8.846 8.461a1.155 1.155 0 0 0 1.596 0l8.846-8.462c.46-.44.477-1.17.036-1.631a1.164 1.164 0 0 0-.833-.354Z",
        fill: "currentColor"
      }
    )
  })
);
var ChevronsDown_default = SvgChevronsDown;

// src/Icon/icons/ChevronsLeft.tsx
import { jsx as jsx381 } from "react/jsx-runtime";
var SvgChevronsLeft = (props) => /* @__PURE__ */ jsx381(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx381(
      "path",
      {
        d: "m4.75 12 7.697-8.048a1.155 1.155 0 0 0-.036-1.632 1.151 1.151 0 0 0-1.628.036L2.32 11.202a1.155 1.155 0 0 0 0 1.595l8.462 8.847c.44.46 1.17.476 1.631.036.234-.228.354-.531.354-.834 0-.287-.107-.574-.32-.797l-7.698-8.05Zm16.927 8.048L13.98 12l7.697-8.048a1.155 1.155 0 0 0-1.668-1.596l-8.462 8.846a1.155 1.155 0 0 0 0 1.596l8.462 8.846a1.155 1.155 0 0 0 1.668-1.596Z",
        fill: "currentColor"
      }
    )
  })
);
var ChevronsLeft_default = SvgChevronsLeft;

// src/Icon/icons/ChevronsRight.tsx
import { jsx as jsx382 } from "react/jsx-runtime";
var SvgChevronsRight = (props) => /* @__PURE__ */ jsx382(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx382(
      "path",
      {
        d: "M12.447 11.202 3.986 2.356A1.152 1.152 0 1 0 2.32 3.95l7.7 8.05-7.698 8.048a1.155 1.155 0 0 0 1.668 1.595l8.462-8.846a1.157 1.157 0 0 0-.005-1.596Zm9.231 0-8.461-8.846A1.153 1.153 0 1 0 11.55 3.95l7.7 8.05-7.698 8.048a1.155 1.155 0 0 0 1.668 1.595l8.462-8.846a1.156 1.156 0 0 0-.005-1.596Z",
        fill: "currentColor"
      }
    )
  })
);
var ChevronsRight_default = SvgChevronsRight;

// src/Icon/icons/ChevronsUp.tsx
import { jsx as jsx383 } from "react/jsx-runtime";
var SvgChevronsUp = (props) => /* @__PURE__ */ jsx383(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx383(
      "path",
      {
        d: "M3.953 12.446 12 4.75l8.047 7.696a1.15 1.15 0 0 0 1.632-.034 1.155 1.155 0 0 0-.036-1.631L12.798 2.32a1.154 1.154 0 0 0-1.596 0l-8.845 8.46c-.46.44-.476 1.171-.036 1.633.44.46 1.127.475 1.632.033Zm8.845-.894a1.154 1.154 0 0 0-1.595 0l-8.846 8.46a1.155 1.155 0 0 0 1.596 1.668L12 13.98l8.047 7.696a1.15 1.15 0 0 0 1.632-.034 1.155 1.155 0 0 0-.036-1.632l-8.845-8.458Z",
        fill: "currentColor"
      }
    )
  })
);
var ChevronsUp_default = SvgChevronsUp;

// src/Icon/icons/ChromeExtensions.tsx
import { jsx as jsx384 } from "react/jsx-runtime";
var SvgChromeExtensions = (props) => /* @__PURE__ */ jsx384(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx384(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 11a8.14 8.14 0 0 1 1.07-4.028l3.433 5.975A4.001 4.001 0 0 0 9 15c.447 0 .847-.072 1.275-.206l-2.384 4.131A8.004 8.004 0 0 1 1 11Zm11.41 2.05c.384-.6.59-1.328.59-2.05a4.001 4.001 0 0 0-1.353-3h4.772a7.978 7.978 0 0 1 .519 4.002 4.8 4.8 0 0 0-4.697 6.303c-.991.44-2.088.688-3.241.695l3.41-5.95ZM15.93 7H9a3.98 3.98 0 0 0-3.922 3.21L2.693 6.076A7.983 7.983 0 0 1 9 3a7.999 7.999 0 0 1 6.931 4ZM6.25 11a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM14 18.359v1.54c0 .717.369 1.093 1.082 1.093h4.474c.72 0 1.096-.369 1.096-1.078v-1.526c0-.073.058-.105.13-.047.2.152.434.275.746.275.614 0 1.092-.485 1.092-1.107 0-.619-.478-1.104-1.092-1.104-.311 0-.547.123-.746.275-.072.058-.13.026-.13-.047v-1.555c0-.709-.376-1.078-1.096-1.078h-4.474c-.713 0-1.082.376-1.082 1.092v1.552c0 .235.184.39.402.39.119 0 .246-.05.358-.158l.007-.008c.169-.157.379-.354.792-.354.546 0 .977.434.977.988 0 .553-.43.987-.977.987-.41 0-.62-.197-.787-.354l-.012-.011a.529.529 0 0 0-.358-.156c-.217 0-.402.156-.402.39Z",
        fill: "currentColor"
      }
    )
  })
);
var ChromeExtensions_default = SvgChromeExtensions;

// src/Icon/icons/Circle0.tsx
import { jsx as jsx385 } from "react/jsx-runtime";
var SvgCircle0 = (props) => /* @__PURE__ */ jsx385(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx385(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125ZM12 7a3.756 3.756 0 0 0-3.75 3.75v2.5A3.754 3.754 0 0 0 12 17a3.754 3.754 0 0 0 3.75-3.75v-2.5A3.756 3.756 0 0 0 12 7Zm1.875 6.25a1.876 1.876 0 0 1-3.75 0v-2.5c0-1.034.841-1.875 1.875-1.875s1.875.841 1.875 1.875v2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var Circle0_default = SvgCircle0;

// src/Icon/icons/Circle1.tsx
import { jsx as jsx386 } from "react/jsx-runtime";
var SvgCircle1 = (props) => /* @__PURE__ */ jsx386(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx386(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm2.5-5h-1.563V7.937a.939.939 0 0 0-1.457-.78L9.45 8.511c-.43.286-.547.868-.261 1.266a.94.94 0 0 0 1.3.26l.575-.35v5.438H9.5A.938.938 0 0 0 9.5 17h5a.938.938 0 0 0 0-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var Circle1_default = SvgCircle1;

// src/Icon/icons/Circle2.tsx
import { jsx as jsx387 } from "react/jsx-runtime";
var SvgCircle2 = (props) => /* @__PURE__ */ jsx387(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx387(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm2.813-5h-3.196l2.463-2.234a3.402 3.402 0 0 0 1.03-2.444 3.4 3.4 0 0 0-1.03-2.443 3.538 3.538 0 0 0-4.933 0l-.428.422a.934.934 0 0 0-.012 1.324.935.935 0 0 0 1.326.012l.428-.422a1.656 1.656 0 0 1 2.305 0 1.542 1.542 0 0 1 .027 2.186l-4.234 3.84a.937.937 0 0 0-.245 1.032.935.935 0 0 0 .873.602h5.626a.938.938 0 0 0 0-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var Circle2_default = SvgCircle2;

// src/Icon/icons/Circle3.tsx
import { jsx as jsx388 } from "react/jsx-runtime";
var SvgCircle3 = (props) => /* @__PURE__ */ jsx388(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx388(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm.828-9.668 1.995-1.828A.937.937 0 0 0 14.187 7h-5a.94.94 0 0 0-.937.938.94.94 0 0 0 .938.937h2.59l-1.973 1.809a.938.938 0 0 0 .633 1.629h2.03c.776 0 1.407.63 1.407 1.406a1.41 1.41 0 0 1-1.406 1.406h-1.742a.682.682 0 0 1-.649-.468.948.948 0 0 0-1.187-.595.938.938 0 0 0-.594 1.187A2.557 2.557 0 0 0 10.727 17h1.742a3.286 3.286 0 0 0 3.281-3.281 3.287 3.287 0 0 0-2.922-3.262Z",
        fill: "currentColor"
      }
    )
  })
);
var Circle3_default = SvgCircle3;

// src/Icon/icons/Circle4.tsx
import { jsx as jsx389 } from "react/jsx-runtime";
var SvgCircle4 = (props) => /* @__PURE__ */ jsx389(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx389(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm2.813-7.5H14.5v-1.98a.938.938 0 0 0-1.875 0v1.98h-2.559l1.859-4.316a.937.937 0 0 0-.49-1.232c-.478-.206-1.029.013-1.267.49L7.746 13.19a.938.938 0 0 0 .078.887.98.98 0 0 0 .781.422h4.02v1.563a.938.938 0 0 0 1.875 0V14.5h.313c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937Z",
        fill: "currentColor"
      }
    )
  })
);
var Circle4_default = SvgCircle4;

// src/Icon/icons/Circle5.tsx
import { jsx as jsx390 } from "react/jsx-runtime";
var SvgCircle5 = (props) => /* @__PURE__ */ jsx390(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx390(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm1.023-9.281-2.414-.281.32-1.688h3.258a.938.938 0 0 0 0-1.875h-4.035c-.449 0-.836.32-.918.762l-.653 3.437c-.05.258.009.52.161.73a.94.94 0 0 0 .647.378l3.414.401a1.21 1.21 0 0 1 1.072 1.202c0 .672-.543 1.215-1.246 1.215h-1.902a.682.682 0 0 1-.649-.468c-.164-.489-.73-.75-1.187-.595a.938.938 0 0 0-.594 1.187A2.557 2.557 0 0 0 10.727 17h1.937c1.7 0 3.086-1.387 3.086-3.09 0-1.566-1.207-2.883-2.727-3.066Z",
        fill: "currentColor"
      }
    )
  })
);
var Circle5_default = SvgCircle5;

// src/Icon/icons/Circle6.tsx
import { jsx as jsx391 } from "react/jsx-runtime";
var SvgCircle6 = (props) => /* @__PURE__ */ jsx391(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx391(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm1.016-10.469 1.162-1.013c.39-.34.431-.933.09-1.323a.94.94 0 0 0-1.322-.09L9.824 9.954c-.5.434-1.574 1.684-1.574 3.297A3.754 3.754 0 0 0 12 17a3.754 3.754 0 0 0 3.75-3.75c0-1.715-1.16-3.145-2.734-3.594ZM12 15.125a1.877 1.877 0 0 1-1.798-2.41A1.888 1.888 0 0 1 12 11.374a1.876 1.876 0 0 1 0 3.75Z",
        fill: "currentColor"
      }
    )
  })
);
var Circle6_default = SvgCircle6;

// src/Icon/icons/Circle7.tsx
import { jsx as jsx392 } from "react/jsx-runtime";
var SvgCircle7 = (props) => /* @__PURE__ */ jsx392(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx392(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125ZM14.813 7H9.186a.94.94 0 0 0-.937.938.94.94 0 0 0 .938.937h4.054l-3.63 6.742a.937.937 0 0 0 .38 1.27.892.892 0 0 0 .41.113.937.937 0 0 0 .827-.493l4.375-8.125a.937.937 0 0 0-.02-.925C15.448 7.172 15.14 7 14.812 7Z",
        fill: "currentColor"
      }
    )
  })
);
var Circle7_default = SvgCircle7;

// src/Icon/icons/Circle8.tsx
import { jsx as jsx393 } from "react/jsx-runtime";
var SvgCircle8 = (props) => /* @__PURE__ */ jsx393(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx393(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm3.125-10.313A2.816 2.816 0 0 0 12.312 7h-.624a2.816 2.816 0 0 0-2.813 2.813c0 .615.205 1.181.543 1.645a3.103 3.103 0 0 0-1.168 2.417A3.13 3.13 0 0 0 11.375 17h1.25a3.128 3.128 0 0 0 3.125-3.125c0-.979-.461-1.843-1.168-2.417a2.79 2.79 0 0 0 .543-1.646Zm-3.438-.937h.626a.94.94 0 0 1 .937.938.94.94 0 0 1-.938.937h-.624a.94.94 0 0 1-.938-.938.94.94 0 0 1 .938-.937Zm.938 6.25h-1.25a1.25 1.25 0 0 1 0-2.5h1.25a1.25 1.25 0 0 1 0 2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var Circle8_default = SvgCircle8;

// src/Icon/icons/Circle9.tsx
import { jsx as jsx394 } from "react/jsx-runtime";
var SvgCircle9 = (props) => /* @__PURE__ */ jsx394(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx394(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125ZM12 7a3.756 3.756 0 0 0-3.75 3.75c0 1.713 1.161 3.146 2.734 3.592L9.82 15.355a.939.939 0 0 0 1.233 1.414l3.123-2.722c.499-.434 1.573-1.684 1.573-3.297A3.756 3.756 0 0 0 12 7Zm1.797 4.285A1.885 1.885 0 0 1 12 12.625a1.875 1.875 0 1 1 1.797-1.34Z",
        fill: "currentColor"
      }
    )
  })
);
var Circle9_default = SvgCircle9;

// src/Icon/icons/CircleA.tsx
import { jsx as jsx395 } from "react/jsx-runtime";
var SvgCircleA = (props) => /* @__PURE__ */ jsx395(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx395(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm.852-13.25c-.307-.667-1.397-.667-1.703 0l-3.75 8.129a.944.944 0 0 0 .458 1.25.936.936 0 0 0 1.245-.46l.47-1.023h4.855l.47 1.023a.937.937 0 0 0 1.245.46.944.944 0 0 0 .458-1.25l-3.748-8.129Zm-2.45 6.047L12 9.52l1.563 3.403h-3.16v-.001Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleA_default = SvgCircleA;

// src/Icon/icons/CircleAmpersand.tsx
import { jsx as jsx396 } from "react/jsx-runtime";
var SvgCircleAmpersand = (props) => /* @__PURE__ */ jsx396(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx396(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm2.95-5.809 1.099-1.613a.937.937 0 1 0-1.55-1.056l-.85 1.247-1.162-1.27.769-.621A2.254 2.254 0 0 0 11.84 7h-.902a2.257 2.257 0 0 0-2.254 2.254c0 .639.236 1.251.668 1.724l.404.443-1.162.938a2.605 2.605 0 0 0-.969 2.032A2.592 2.592 0 0 0 10.235 17h1.268c.914 0 1.772-.407 2.35-1.101l.727.796a.935.935 0 0 0 1.326.06.938.938 0 0 0 .06-1.325l-1.017-1.114Zm-4.012-5.441h.903a.378.378 0 0 1 .236.67l-.858.693-.48-.527a.686.686 0 0 1-.18-.457.38.38 0 0 1 .379-.379Zm1.542 5.734a1.177 1.177 0 0 1-.976.516h-1.27a.739.739 0 0 1-.734-.734c0-.224.099-.432.273-.572l1.254-1.014 1.538 1.683-.085.121Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleAmpersand_default = SvgCircleAmpersand;

// src/Icon/icons/CircleArrowDownLeft.tsx
import { jsx as jsx397 } from "react/jsx-runtime";
var SvgCircleArrowDownLeft = (props) => /* @__PURE__ */ jsx397(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx397(
      "path",
      {
        d: "M14.773 7.898 9.5 13.176V9.37a.938.938 0 0 0-1.875 0v6.066c0 .518.42.938.938.938h6.066a.938.938 0 0 0 0-1.875h-3.805l5.274-5.273a.937.937 0 0 0-1.325-1.329ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleArrowDownLeft_default = SvgCircleArrowDownLeft;

// src/Icon/icons/CircleArrowDownRight.tsx
import { jsx as jsx398 } from "react/jsx-runtime";
var SvgCircleArrowDownRight = (props) => /* @__PURE__ */ jsx398(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx398(
      "path",
      {
        d: "M15.438 8.434a.938.938 0 0 0-.938.937v3.802L9.191 7.898a.937.937 0 1 0-1.325 1.326l5.31 5.276H9.37a.938.938 0 0 0 0 1.875h6.066c.518 0 .938-.42.938-.938V9.372a.938.938 0 0 0-.938-.937ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleArrowDownRight_default = SvgCircleArrowDownRight;

// src/Icon/icons/CircleArrowDown.tsx
import { jsx as jsx399 } from "react/jsx-runtime";
var SvgCircleArrowDown = (props) => /* @__PURE__ */ jsx399(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx399(
      "path",
      {
        d: "M15.375 11.676 12.937 14.3V7.625a.938.938 0 0 0-1.874 0v6.676l-2.438-2.625a.934.934 0 0 0-1.324-.051c-.414.352-.403.945-.051 1.324l4.063 4.375c.144.192.425.301.687.301a.939.939 0 0 0 .687-.3l4.063-4.374a.94.94 0 0 0-.05-1.326.936.936 0 0 0-1.325.05ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleArrowDown_default = SvgCircleArrowDown;

// src/Icon/icons/CircleArrowLeft.tsx
import { jsx as jsx400 } from "react/jsx-runtime";
var SvgCircleArrowLeft = (props) => /* @__PURE__ */ jsx400(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx400(
      "path",
      {
        d: "M16.375 11.063H9.699l2.626-2.438a.939.939 0 0 0-1.277-1.375l-4.375 4.063c-.189.144-.298.425-.298.687 0 .262.109.509.3.687l4.374 4.063a.939.939 0 0 0 1.277-1.375l-2.627-2.438h6.676a.938.938 0 0 0 0-1.874ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleArrowLeft_default = SvgCircleArrowLeft;

// src/Icon/icons/CircleArrowRight.tsx
import { jsx as jsx401 } from "react/jsx-runtime";
var SvgCircleArrowRight = (props) => /* @__PURE__ */ jsx401(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx401(
      "path",
      {
        d: "M12.95 7.25a.94.94 0 0 0-1.277 1.375l2.628 2.438H7.625a.94.94 0 0 0-.938.937.94.94 0 0 0 .938.938h6.676l-2.626 2.437a.939.939 0 0 0 1.277 1.375l4.375-4.063a.939.939 0 0 0-.001-1.375L12.949 7.25ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleArrowRight_default = SvgCircleArrowRight;

// src/Icon/icons/CircleArrowUpLeft.tsx
import { jsx as jsx402 } from "react/jsx-runtime";
var SvgCircleArrowUpLeft = (props) => /* @__PURE__ */ jsx402(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx402(
      "path",
      {
        d: "M10.824 9.5h3.803a.938.938 0 0 0 0-1.875H8.562a.94.94 0 0 0-.937.938v6.066a.938.938 0 0 0 1.875 0v-3.805l5.273 5.274a.938.938 0 1 0 1.327-1.323L10.824 9.5ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleArrowUpLeft_default = SvgCircleArrowUpLeft;

// src/Icon/icons/CircleArrowUpRight.tsx
import { jsx as jsx403 } from "react/jsx-runtime";
var SvgCircleArrowUpRight = (props) => /* @__PURE__ */ jsx403(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx403(
      "path",
      {
        d: "M15.438 7.625H9.37a.938.938 0 0 0 0 1.875h3.803l-5.273 5.273A.937.937 0 0 0 9.225 16.1l5.275-5.276v3.803a.938.938 0 0 0 1.875 0V8.562a.938.938 0 0 0-.938-.937ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleArrowUpRight_default = SvgCircleArrowUpRight;

// src/Icon/icons/CircleArrowUp.tsx
import { jsx as jsx404 } from "react/jsx-runtime";
var SvgCircleArrowUp = (props) => /* @__PURE__ */ jsx404(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx404(
      "path",
      {
        d: "M12.688 6.676A.94.94 0 0 0 12 6.375c-.262 0-.543.11-.688.3L7.25 11.052a.94.94 0 0 0 1.375 1.277l2.438-2.629v6.676a.938.938 0 0 0 1.874 0V9.699l2.438 2.626a.939.939 0 0 0 1.375-1.277l-4.063-4.372ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleArrowUp_default = SvgCircleArrowUp;

// src/Icon/icons/CircleB.tsx
import { jsx as jsx405 } from "react/jsx-runtime";
var SvgCircleB = (props) => /* @__PURE__ */ jsx405(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx405(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm3.2-8.445a2.95 2.95 0 0 0 .55-1.711A2.972 2.972 0 0 0 12.781 7H9.187a.94.94 0 0 0-.937.938v8.125c0 .519.422.937.938.937h4.218a2.972 2.972 0 0 0 2.969-2.969c0-.96-.465-1.808-1.176-2.351Zm-5.075-2.805h2.656a1.095 1.095 0 0 1 0 2.188h-2.656V8.874Zm3.281 6.25h-3.281v-2.188h3.281c.602 0 1.094.493 1.094 1.094 0 .602-.492 1.094-1.094 1.094Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleB_default = SvgCircleB;

// src/Icon/icons/CircleBolt.tsx
import { jsx as jsx406 } from "react/jsx-runtime";
var SvgCircleBolt = (props) => /* @__PURE__ */ jsx406(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx406(
      "path",
      {
        d: "M14.25 7.125c.23.172.313.48.2.746l-1.5 3.504h2.488c.265 0 .5.164.59.414.085.215.011.527-.192.695l-5.313 4.375a.625.625 0 0 1-.973-.73l1.5-3.54H8.563c-.265 0-.5-.128-.59-.378a.633.633 0 0 1 .192-.695l5.313-4.375c.222-.215.543-.188.773-.016ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleBolt_default = SvgCircleBolt;

// src/Icon/icons/CircleBookOpen.tsx
import { jsx as jsx407 } from "react/jsx-runtime";
var SvgCircleBookOpen = (props) => /* @__PURE__ */ jsx407(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx407(
      "path",
      {
        d: "M16.656 8.75c-.829-.338-1.626-.505-2.31-.5-.78.012-1.334.191-1.721.316v7.149c.461-.272 1.988-1.005 3.96-.146.196.118.415-.018.415-.214V9.25a.543.543 0 0 0-.344-.5Zm-9.312 0C7.133 8.8 7 9.035 7 9.246v6.106c0 .197.22.333.412.25 1.975-.856 3.502-.125 3.963.148V8.566c-.387-.125-.977-.304-1.723-.316-.687-.012-1.515.16-2.308.5ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleBookOpen_default = SvgCircleBookOpen;

// src/Icon/icons/CircleBookmark.tsx
import { jsx as jsx408 } from "react/jsx-runtime";
var SvgCircleBookmark = (props) => /* @__PURE__ */ jsx408(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx408(
      "path",
      {
        d: "M14.082 7.625H9.918a1.04 1.04 0 0 0-1.043 1.043v6.457c0 .524.606.816.98.488L12 13.875l2.11 1.737c.41.325 1.015.036 1.015-.522V8.668a1.04 1.04 0 0 0-1.043-1.043ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleBookmark_default = SvgCircleBookmark;

// src/Icon/icons/CircleC.tsx
import { jsx as jsx409 } from "react/jsx-runtime";
var SvgCircleC = (props) => /* @__PURE__ */ jsx409(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx409(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm2.113-10.336a.937.937 0 0 0 1.332-1.32c-1.877-1.894-5.152-1.894-7.027 0a5.034 5.034 0 0 0 0 7.066C9.39 16.48 10.637 17 11.965 17a4.916 4.916 0 0 0 3.514-1.467.937.937 0 0 0-1.332-1.321 3.053 3.053 0 0 1-2.182.913 3.05 3.05 0 0 1-2.181-.913 3.152 3.152 0 0 1 0-4.426c1.165-1.173 3.196-1.177 4.33.003Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleC_default = SvgCircleC;

// src/Icon/icons/CircleCalendar.tsx
import { jsx as jsx410 } from "react/jsx-runtime";
var SvgCircleCalendar = (props) => /* @__PURE__ */ jsx410(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx410(
      "path",
      {
        d: "M10.125 6.375c.344 0 .625.281.625.625v.625h2.5V7c0-.344.281-.625.625-.625s.625.281.625.625v.625h.625C16.16 7.625 17 8.465 17 9.5v5c0 1.035-.84 1.875-1.875 1.875h-6.25A1.875 1.875 0 0 1 7 14.5v-5c0-1.035.84-1.875 1.875-1.875H9.5V7c0-.344.281-.625.625-.625Zm5 8.125v-3.75h-6.25v3.75h6.25ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleCalendar_default = SvgCircleCalendar;

// src/Icon/icons/CircleCamera.tsx
import { jsx as jsx411 } from "react/jsx-runtime";
var SvgCircleCamera = (props) => /* @__PURE__ */ jsx411(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx411(
      "path",
      {
        d: "M15.75 8.25h-1.406l-.242-.642A.934.934 0 0 0 13.227 7h-2.454a.938.938 0 0 0-.878.608l-.239.642H8.25C7.559 8.25 7 8.809 7 9.5v5c0 .69.56 1.25 1.25 1.25h7.5c.69 0 1.25-.56 1.25-1.25v-5c0-.691-.559-1.25-1.25-1.25ZM12 13.875a1.875 1.875 0 1 1 0-3.75 1.875 1.875 0 0 1 0 3.75ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleCamera_default = SvgCircleCamera;

// src/Icon/icons/CircleCaretDown.tsx
import { jsx as jsx412 } from "react/jsx-runtime";
var SvgCircleCaretDown = (props) => /* @__PURE__ */ jsx412(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx412(
      "path",
      {
        d: "M15.75 10.125h-7.5a.938.938 0 0 0-.688 1.574l3.75 4.063a.934.934 0 0 0 1.376-.001l3.75-4.063a.939.939 0 0 0-.688-1.573ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleCaretDown_default = SvgCircleCaretDown;

// src/Icon/icons/CircleCaretLeft.tsx
import { jsx as jsx413 } from "react/jsx-runtime";
var SvgCircleCaretLeft = (props) => /* @__PURE__ */ jsx413(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx413(
      "path",
      {
        d: "M13.313 7.39a.939.939 0 0 0-1.013.172l-4.062 3.75a.939.939 0 0 0 .001 1.376l4.063 3.75a.939.939 0 0 0 1.573-.688v-7.5a.942.942 0 0 0-.563-.86ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleCaretLeft_default = SvgCircleCaretLeft;

// src/Icon/icons/CircleCaretRight.tsx
import { jsx as jsx414 } from "react/jsx-runtime";
var SvgCircleCaretRight = (props) => /* @__PURE__ */ jsx414(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx414(
      "path",
      {
        d: "M11.7 7.563a.937.937 0 0 0-1.575.687v7.5a.939.939 0 0 0 1.574.689l4.062-3.75a.937.937 0 0 0 0-1.377l-4.062-3.75ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleCaretRight_default = SvgCircleCaretRight;

// src/Icon/icons/CircleCaretUp.tsx
import { jsx as jsx415 } from "react/jsx-runtime";
var SvgCircleCaretUp = (props) => /* @__PURE__ */ jsx415(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx415(
      "path",
      {
        d: "M12.688 8.238a.934.934 0 0 0-1.376 0l-3.75 4.063a.939.939 0 0 0 .688 1.574h7.5c.372 0 .71-.22.824-.562a.939.939 0 0 0-.17-1.012l-3.716-4.063ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleCaretUp_default = SvgCircleCaretUp;

// src/Icon/icons/CircleCheck.tsx
import { jsx as jsx416 } from "react/jsx-runtime";
var SvgCircleCheck = (props) => /* @__PURE__ */ jsx416(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx416(
      "path",
      {
        d: "M11.523 15.273a1.096 1.096 0 0 1-1.546 0l-2.5-2.5a1.096 1.096 0 0 1 0-1.546 1.096 1.096 0 0 1 1.546 0l1.727 1.726 4.227-4.226a1.096 1.096 0 0 1 1.546 0 1.096 1.096 0 0 1 0 1.546l-5 5ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleCheck_default = SvgCircleCheck;

// src/Icon/icons/CircleChevronDown.tsx
import { jsx as jsx417 } from "react/jsx-runtime";
var SvgCircleChevronDown = (props) => /* @__PURE__ */ jsx417(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx417(
      "path",
      {
        d: "M15.71 10.086 12 13.8l-3.746-3.715a.937.937 0 1 0-1.326 1.326l4.375 4.375c.216.186.455.275.697.275.242 0 .48-.091.663-.274l4.375-4.375a.937.937 0 1 0-1.327-1.327ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleChevronDown_default = SvgCircleChevronDown;

// src/Icon/icons/CircleChevronLeft.tsx
import { jsx as jsx418 } from "react/jsx-runtime";
var SvgCircleChevronLeft = (props) => /* @__PURE__ */ jsx418(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx418(
      "path",
      {
        d: "M13.879 6.96a.937.937 0 0 0-1.326 0l-4.375 4.376c-.15.184-.24.422-.24.664 0 .242.091.48.274.663l4.375 4.375a.937.937 0 1 0 1.326-1.326L10.199 12l3.712-3.712a.912.912 0 0 0-.032-1.327ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleChevronLeft_default = SvgCircleChevronLeft;

// src/Icon/icons/CircleChevronRight.tsx
import { jsx as jsx419 } from "react/jsx-runtime";
var SvgCircleChevronRight = (props) => /* @__PURE__ */ jsx419(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx419(
      "path",
      {
        d: "M11.379 6.96a.937.937 0 1 0-1.326 1.327L13.801 12l-3.712 3.712a.937.937 0 1 0 1.325 1.326l4.376-4.375a.927.927 0 0 0 .273-.663.931.931 0 0 0-.275-.663l-4.41-4.376ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleChevronRight_default = SvgCircleChevronRight;

// src/Icon/icons/CircleChevronUp.tsx
import { jsx as jsx420 } from "react/jsx-runtime";
var SvgCircleChevronUp = (props) => /* @__PURE__ */ jsx420(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx420(
      "path",
      {
        d: "M12.629 8.21c-.149-.183-.387-.273-.629-.273a.93.93 0 0 0-.664.274L6.96 12.586a.937.937 0 1 0 1.326 1.326L12 10.199l3.712 3.712a.937.937 0 1 0 1.326-1.325l-4.41-4.375ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleChevronUp_default = SvgCircleChevronUp;

// src/Icon/icons/CircleD.tsx
import { jsx as jsx421 } from "react/jsx-runtime";
var SvgCircleD = (props) => /* @__PURE__ */ jsx421(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx421(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125ZM11.937 7h-2.75a.94.94 0 0 0-.937.938v8.125c0 .519.422.937.938.937h2.75C14.73 17 17 14.758 17 12s-2.27-5-5.063-5Zm0 8.125h-1.812v-6.25h1.813c1.757 0 3.187 1.402 3.187 3.125s-1.43 3.125-3.188 3.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleD_default = SvgCircleD;

// src/Icon/icons/CircleDashed.tsx
import { jsx as jsx422 } from "react/jsx-runtime";
var SvgCircleDashed = (props) => /* @__PURE__ */ jsx422(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx422(
      "path",
      {
        d: "M2.923 11.045c-.568 0-1.017-.489-.906-1.046a10.133 10.133 0 0 1 1.51-3.642c.314-.473.978-.5 1.38-.1.347.347.373.895.11 1.309a8.215 8.215 0 0 0-1.091 2.632c-.106.477-.513.847-1.003.847Zm4.643-6.028c-.414.263-.962.237-1.308-.11-.402-.402-.374-1.066.1-1.38a10.133 10.133 0 0 1 3.641-1.51c.557-.111 1.046.338 1.046.906 0 .49-.37.897-.847 1.003a8.215 8.215 0 0 0-2.632 1.09Zm5.388 16.06c0-.493.37-.898.847-1.006a8.234 8.234 0 0 0 2.632-1.09 1.004 1.004 0 0 1 1.308.112c.402.402.374 1.066-.1 1.38A10.185 10.185 0 0 1 14 21.983c-.557.108-1.046-.337-1.046-.906Zm7.117-7.276c.108-.477.513-.847 1.006-.847.569 0 1.014.489.907 1.046a10.185 10.185 0 0 1-1.511 3.642c-.314.473-.978.5-1.38.1a1.004 1.004 0 0 1-.111-1.309 8.234 8.234 0 0 0 1.09-2.632ZM7.566 18.98a8.234 8.234 0 0 0 2.632 1.09c.477.108.847.513.847 1.006 0 .569-.489 1.014-1.046.907a10.185 10.185 0 0 1-3.642-1.511c-.473-.314-.5-.978-.1-1.38.347-.35.895-.41 1.309-.111ZM2.017 14c-.111-.557.338-1.046.906-1.046.49 0 .897.37 1.003.847.21.95.585 1.837 1.09 2.632.264.414.238.962-.109 1.308-.402.402-1.066.374-1.38-.1A10.133 10.133 0 0 1 2.016 14Zm14.416-8.983a8.216 8.216 0 0 0-2.632-1.091c-.477-.106-.847-.513-.847-1.003 0-.568.489-1.017 1.046-.906 1.324.264 2.556.785 3.642 1.51.473.314.5.978.1 1.38-.347.347-.895.373-1.309.11Zm2.549 2.549a1.004 1.004 0 0 1 .111-1.308c.402-.402 1.066-.374 1.38.1a10.185 10.185 0 0 1 1.51 3.641c.108.557-.337 1.046-.906 1.046-.493 0-.898-.37-1.006-.847a8.234 8.234 0 0 0-1.09-2.632Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleDashed_default = SvgCircleDashed;

// src/Icon/icons/CircleDivide.tsx
import { jsx as jsx423 } from "react/jsx-runtime";
var SvgCircleDivide = (props) => /* @__PURE__ */ jsx423(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx423(
      "path",
      {
        d: "M10.75 8.25c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25S12.691 9.5 12 9.5s-1.25-.559-1.25-1.25Zm4.688 2.813c.519 0 .937.417.937.937s-.418.938-.938.938H8.564A.935.935 0 0 1 7.625 12c0-.52.418-.938.938-.938h6.874ZM13.25 15.75c0 .691-.559 1.25-1.25 1.25s-1.25-.559-1.25-1.25.559-1.25 1.25-1.25 1.25.559 1.25 1.25ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleDivide_default = SvgCircleDivide;

// src/Icon/icons/CircleDollarToSlot.tsx
import { jsx as jsx424 } from "react/jsx-runtime";
var SvgCircleDollarToSlot = (props) => /* @__PURE__ */ jsx424(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx424(
      "path",
      {
        d: "M12.785 6.621c.258.047.649.125.82.172.418.11.668.539.555.953a.777.777 0 0 1-.953.555c-.152-.04-.68-.14-.852-.203-.476-.04-.898.023-1.117.136-.246.11-.304.239-.32.317-.023.133 0 .18.008.195.008.02.039.066.14.137.239.164.614.281 1.133.449l.067.008c.472.144 1.105.332 1.578.68.261.187.508.445.66.796.156.356.187.746.117 1.153-.129.742-.621 1.25-1.238 1.511-.188.047-.39.141-.598.18v.18c0 .469-.351.82-.82.82-.399 0-.75-.351-.75-.82v-.215c-.371-.086-.89-.25-1.164-.355-.067-.024-.125-.043-.172-.094-.41-.102-.633-.543-.496-.953a.781.781 0 0 1 .988-.496c.078.027.164.054.25.085.371.126.79.266 1.024.305.5.078.886.027 1.125-.074.214-.09.289-.207.312-.344.027-.156.004-.226-.012-.258-.011-.035-.047-.09-.144-.16-.23-.168-.598-.289-1.145-.457l-.086-.023c-.457-.137-1.054-.317-1.508-.625a1.933 1.933 0 0 1-.675-.762 1.861 1.861 0 0 1-.133-1.133c.125-.715.633-1.207 1.215-1.472.16-.086.402-.153.62-.2v-.27c0-.398.352-.75.786-.75.434 0 .785.352.785.75v.282Zm-8.91 3.504A8.124 8.124 0 0 1 12 2a8.124 8.124 0 0 1 8.125 8.125A8.124 8.124 0 0 1 12 18.25a8.124 8.124 0 0 1-8.125-8.125ZM12 16.375a6.248 6.248 0 0 0 6.25-6.25A6.248 6.248 0 0 0 12 3.875a6.248 6.248 0 0 0-6.25 6.25 6.248 6.248 0 0 0 6.25 6.25Zm-5.66 1.25H4.5a.626.626 0 0 0-.625.625v1.25c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625v-1.25a.627.627 0 0 0-.625-.625h-1.875A9.373 9.373 0 0 0 19.5 15.75a2.5 2.5 0 0 1 2.5 2.5v1.25c0 1.379-1.121 2.5-2.5 2.5h-15C3.12 22 2 20.879 2 19.5v-1.25a2.5 2.5 0 0 1 2.5-2.5c.532.71 1.164 1.34 1.84 1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleDollarToSlot_default = SvgCircleDollarToSlot;

// src/Icon/icons/CircleDollar.tsx
import { jsx as jsx425 } from "react/jsx-runtime";
var SvgCircleDollar = (props) => /* @__PURE__ */ jsx425(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx425(
      "path",
      {
        d: "M12.813 7.773c.378.047.757.153 1.132.258.07.02.145.043.215.028.45.16.715.625.59 1.074a.843.843 0 0 1-1.04.586c-.058-.016-.12-.031-.179-.051-.273-.074-.547-.152-.824-.207-.516-.098-1.113-.05-1.598.156-.43.188-.785.64-.296.953.386.246.851.371 1.296.457a.89.89 0 0 0 .274.11c.61.175 1.387.394 1.969.793a2.211 2.211 0 0 1 .949 2.273c-.164.875-.77 1.45-1.504 1.742a3.673 3.673 0 0 1-.985.242v.594a.845.845 0 0 1-.843.844.845.845 0 0 1-.844-.844v-.68c-.566-.124-1.121-.308-1.672-.488a.842.842 0 0 1-.535-1.066.843.843 0 0 1 1.066-.535c.098.031.196.066.293.097.442.149.895.305 1.348.375.664.098 1.16.04 1.543-.136.469-.157.688-.711.23-1.024-.394-.304-.882-.402-1.347-.527-.125-.027-.18-.05-.266-.074-.59-.168-1.324-.375-1.879-.73-.761-.49-1.152-1.302-.988-2.204.156-.851.82-1.418 1.523-1.719.215-.129.446-.168.684-.222v-.63c0-.464.379-.878.844-.878.465 0 .844.414.844.879v.554ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleDollar_default = SvgCircleDollar;

// src/Icon/icons/CircleDot.tsx
import { jsx as jsx426 } from "react/jsx-runtime";
var SvgCircleDot = (props) => /* @__PURE__ */ jsx426(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx426(
      "path",
      {
        d: "M8.25 12c0-2.105 1.645-3.75 3.75-3.75 2.07 0 3.75 1.645 3.75 3.75 0 2.07-1.68 3.75-3.75 3.75A3.729 3.729 0 0 1 8.25 12ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleDot_default = SvgCircleDot;

// src/Icon/icons/CircleDownLeft.tsx
import { jsx as jsx427 } from "react/jsx-runtime";
var SvgCircleDownLeft = (props) => /* @__PURE__ */ jsx427(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx427(
      "path",
      {
        d: "M15.316 8.242a.938.938 0 0 0-1.325 0l-2.526 2.524-1.649-1.618c-.144-.18-.386-.273-.629-.273a.935.935 0 0 0-.938.938v5c.001.519.423.937.938.937h5a.938.938 0 0 0 .663-1.6l-1.616-1.617 2.523-2.522a.938.938 0 0 0 0-1.326l-.44-.443ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleDownLeft_default = SvgCircleDownLeft;

// src/Icon/icons/CircleDownRight.tsx
import { jsx as jsx428 } from "react/jsx-runtime";
var SvgCircleDownRight = (props) => /* @__PURE__ */ jsx428(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx428(
      "path",
      {
        d: "M15.172 8.945a.937.937 0 0 0-1.022.204l-1.616 1.617-2.522-2.524a.945.945 0 0 0-1.328 0l-.442.442a.938.938 0 0 0 0 1.325l2.522 2.523-1.616 1.616a.938.938 0 0 0 .665 1.602h5c.517 0 .937-.42.937-.938v-5a.936.936 0 0 0-.578-.867ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleDownRight_default = SvgCircleDownRight;

// src/Icon/icons/CircleDown.tsx
import { jsx as jsx429 } from "react/jsx-runtime";
var SvgCircleDown = (props) => /* @__PURE__ */ jsx429(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx429(
      "path",
      {
        d: "M15.438 11.375H13.25l-.035-3.438A.938.938 0 0 0 12.277 7h-.625c-.484 0-.937.422-.937.938l.035 3.437H8.562a.938.938 0 0 0-.688 1.574l3.468 3.75a.941.941 0 0 0 1.383-.005l3.408-3.75a.938.938 0 0 0-.695-1.569ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleDown_default = SvgCircleDown;

// src/Icon/icons/CircleE.tsx
import { jsx as jsx430 } from "react/jsx-runtime";
var SvgCircleE = (props) => /* @__PURE__ */ jsx430(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx430(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm2.813-11.25c.519 0 .937-.418.937-.938A.935.935 0 0 0 14.812 7H9.189a.94.94 0 0 0-.938.938v8.125c0 .519.422.937.938.937h5.624a.938.938 0 0 0 0-1.875h-4.687v-2.188h3.438a.936.936 0 1 0 0-1.875h-3.438V8.876h4.688Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleE_default = SvgCircleE;

// src/Icon/icons/CircleEllipsisVertical.tsx
import { jsx as jsx431 } from "react/jsx-runtime";
var SvgCircleEllipsisVertical = (props) => /* @__PURE__ */ jsx431(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx431(
      "path",
      {
        d: "M10.75 12c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25-.559 1.25-1.25 1.25-1.25-.559-1.25-1.25Zm2.5-3.75c0 .691-.559 1.25-1.25 1.25s-1.25-.559-1.25-1.25S11.309 7 12 7s1.25.559 1.25 1.25Zm-2.5 7.5c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25S12.691 17 12 17s-1.25-.559-1.25-1.25ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleEllipsisVertical_default = SvgCircleEllipsisVertical;

// src/Icon/icons/CircleEllipsis.tsx
import { jsx as jsx432 } from "react/jsx-runtime";
var SvgCircleEllipsis = (props) => /* @__PURE__ */ jsx432(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx432(
      "path",
      {
        d: "M12 10.75c.691 0 1.25.559 1.25 1.25s-.559 1.25-1.25 1.25-1.25-.559-1.25-1.25.559-1.25 1.25-1.25Zm3.75 2.5c-.691 0-1.25-.559-1.25-1.25s.559-1.25 1.25-1.25S17 11.309 17 12s-.559 1.25-1.25 1.25Zm-7.5-2.5c.691 0 1.25.559 1.25 1.25s-.559 1.25-1.25 1.25S7 12.691 7 12s.559-1.25 1.25-1.25ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm8.125-10A8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleEllipsis_default = SvgCircleEllipsis;

// src/Icon/icons/CircleEnvelope.tsx
import { jsx as jsx433 } from "react/jsx-runtime";
var SvgCircleEnvelope = (props) => /* @__PURE__ */ jsx433(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx433(
      "path",
      {
        d: "M12 13.25c-.113 0-.191-.016-.23-.043L7 11.297V14.5c0 .69.56 1.25 1.25 1.25h7.5c.69 0 1.25-.56 1.25-1.25v-3.203l-4.77 1.907a.607.607 0 0 1-.23.046Zm3.75-5h-7.5C7.559 8.25 7 8.809 7 9.5v.452l5 2 5-2V9.5c0-.691-.559-1.25-1.25-1.25ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleEnvelope_default = SvgCircleEnvelope;

// src/Icon/icons/CircleExclamationCheck.tsx
import { jsx as jsx434 } from "react/jsx-runtime";
var SvgCircleExclamationCheck = (props) => /* @__PURE__ */ jsx434(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx434(
      "path",
      {
        d: "M10.05 18.541c1.865 0 3.545-.78 4.737-2.031.289-.302.739-.312 1.069-.026.302.29.311.74.025 1.07a8.034 8.034 0 0 1-5.83 2.497A8.05 8.05 0 0 1 2 12a8.05 8.05 0 0 1 15.381-3.33.754.754 0 0 1-1.374.623 6.552 6.552 0 0 0-5.985-3.834c-3.585 0-6.54 2.928-6.54 6.541 0 3.613 2.955 6.541 6.54 6.541h.029Zm.755-6.318a.736.736 0 0 1-.754.755.736.736 0 0 1-.755-.755V8.701c0-.39.336-.755.755-.755.418 0 .754.365.754.755v3.522Zm-1.76 2.796c0-.557.449-1.035 1.006-1.035.556 0 1.006.478 1.006 1.035a1.005 1.005 0 1 1-2.013 0Zm12.698-5.654a.883.883 0 0 1 0 1.245l-4.025 4.025a.883.883 0 0 1-1.246 0l-2.012-2.012a.883.883 0 0 1 0-1.246.883.883 0 0 1 1.245 0l1.39 1.39 3.403-3.402a.883.883 0 0 1 1.245 0Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleExclamationCheck_default = SvgCircleExclamationCheck;

// src/Icon/icons/CircleExclamation.tsx
import { jsx as jsx435 } from "react/jsx-runtime";
var SvgCircleExclamation = (props) => /* @__PURE__ */ jsx435(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx435(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm0-6.25c.518 0 .938-.42.938-.938v-5a.938.938 0 0 0-1.876 0v5c0 .52.422.938.938.938Zm0 1.293a1.228 1.228 0 1 0 0 2.457 1.228 1.228 0 0 0 0-2.457Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleExclamation_default = SvgCircleExclamation;

// src/Icon/icons/CircleF.tsx
import { jsx as jsx436 } from "react/jsx-runtime";
var SvgCircleF = (props) => /* @__PURE__ */ jsx436(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx436(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125ZM14.813 7H9.186a.94.94 0 0 0-.937.938v8.125a.938.938 0 0 0 1.875 0V13.25h3.438c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937h-3.437v-2.5h4.688c.519 0 .937-.418.937-.938A.935.935 0 0 0 14.812 7Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleF_default = SvgCircleF;

// src/Icon/icons/CircleG.tsx
import { jsx as jsx437 } from "react/jsx-runtime";
var SvgCircleG = (props) => /* @__PURE__ */ jsx437(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx437(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm4.063-8.75h-3.125a.94.94 0 0 0-.938.938.94.94 0 0 0 .938.937h1.971a3.67 3.67 0 0 1-.7.96c-1.179 1.18-3.24 1.18-4.418 0a3.132 3.132 0 0 1 0-4.422c1.182-1.179 3.15-1.233 4.396-.116a.937.937 0 1 0 1.25-1.396c-1.973-1.77-5.1-1.683-6.972.19a5.005 5.005 0 0 0 0 7.07A4.966 4.966 0 0 0 12 17c1.336 0 2.591-.52 3.535-1.464.763-.764 1.278-1.697 1.449-2.628a.796.796 0 0 0 .016-.17v-.425a.938.938 0 0 0-.938-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleG_default = SvgCircleG;

// src/Icon/icons/CircleH.tsx
import { jsx as jsx438 } from "react/jsx-runtime";
var SvgCircleH = (props) => /* @__PURE__ */ jsx438(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx438(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125ZM15.438 7a.94.94 0 0 0-.938.938v3.125h-5V7.937a.938.938 0 0 0-1.875 0v8.125a.938.938 0 0 0 1.875 0v-3.125h5v3.126a.938.938 0 0 0 1.875 0V7.938A.938.938 0 0 0 15.437 7Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleH_default = SvgCircleH;

// src/Icon/icons/CircleHalfStroke.tsx
import { jsx as jsx439 } from "react/jsx-runtime";
var SvgCircleHalfStroke = (props) => /* @__PURE__ */ jsx439(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx439(
      "path",
      {
        d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875v16.25A8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleHalfStroke_default = SvgCircleHalfStroke;

// src/Icon/icons/CircleHalf.tsx
import { jsx as jsx440 } from "react/jsx-runtime";
var SvgCircleHalf = (props) => /* @__PURE__ */ jsx440(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx440(
      "path",
      {
        d: "M15.78 2.009c.688-.086 1.255.486 1.255 1.145v17.657c0 .697-.567 1.267-1.255 1.18-4.97-.617-8.815-4.854-8.815-10.026 0-5.101 3.845-9.338 8.815-9.956Zm-.633 2.028c-3.607.852-6.294 4.097-6.294 7.928a8.194 8.194 0 0 0 6.294 7.997V4.037Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleHalf_default = SvgCircleHalf;

// src/Icon/icons/CircleI.tsx
import { jsx as jsx441 } from "react/jsx-runtime";
var SvgCircleI = (props) => /* @__PURE__ */ jsx441(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx441(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm2.813-11.25c.519 0 .937-.418.937-.938A.935.935 0 0 0 14.812 7H9.189a.94.94 0 0 0-.938.938.94.94 0 0 0 .938.937h1.874v6.25H9.188a.94.94 0 0 0-.938.938.94.94 0 0 0 .938.937h5.624a.938.938 0 0 0 0-1.875h-1.874v-6.25h1.874Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleI_default = SvgCircleI;

// src/Icon/icons/CircleInfo.tsx
import { jsx as jsx442 } from "react/jsx-runtime";
var SvgCircleInfo = (props) => /* @__PURE__ */ jsx442(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx442(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm1.563-5h-.626v-3.438A.938.938 0 0 0 12 10.75h-1.25a.94.94 0 0 0-.938.938.94.94 0 0 0 .938.937h.313v2.5h-.626a.94.94 0 0 0-.937.938.94.94 0 0 0 .938.937h3.124a.938.938 0 0 0 0-1.875ZM12 9.5A1.25 1.25 0 1 0 12 7a1.25 1.25 0 0 0 0 2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleInfo_default = SvgCircleInfo;

// src/Icon/icons/CircleJ.tsx
import { jsx as jsx443 } from "react/jsx-runtime";
var SvgCircleJ = (props) => /* @__PURE__ */ jsx443(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx443(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125ZM14.188 7a.94.94 0 0 0-.938.938v5.417c0 .977-.84 1.77-1.875 1.77-1.035 0-1.875-.793-1.875-1.77v-.418a.938.938 0 0 0-1.875 0v.417c0 2.01 1.684 3.646 3.75 3.646s3.75-1.635 3.75-3.646V7.938A.938.938 0 0 0 14.187 7Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleJ_default = SvgCircleJ;

// src/Icon/icons/CircleK.tsx
import { jsx as jsx444 } from "react/jsx-runtime";
var SvgCircleK = (props) => /* @__PURE__ */ jsx444(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx444(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm3.48-12.844a.938.938 0 0 0-1.325-.01l-4.03 3.967v-3.3a.938.938 0 0 0-1.875 0v8.125a.938.938 0 0 0 1.875 0V13.87l1.207-1.188 2.71 3.914a.934.934 0 0 0 1.303.236.937.937 0 0 0 .238-1.304l-2.813-4.062c-.028-.042-.07-.065-.104-.1l2.804-2.762a.934.934 0 0 0 .01-1.324Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleK_default = SvgCircleK;

// src/Icon/icons/CircleL.tsx
import { jsx as jsx445 } from "react/jsx-runtime";
var SvgCircleL = (props) => /* @__PURE__ */ jsx445(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx445(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm2.813-5h-4.688V7.937a.938.938 0 0 0-1.875 0v8.125c0 .52.422.938.938.938h5.624a.938.938 0 0 0 0-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleL_default = SvgCircleL;

// src/Icon/icons/CircleLeft.tsx
import { jsx as jsx446 } from "react/jsx-runtime";
var SvgCircleLeft = (props) => /* @__PURE__ */ jsx446(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx446(
      "path",
      {
        d: "M16.063 10.75h-3.438V8.562a.938.938 0 0 0-1.574-.688L7.3 11.343a.941.941 0 0 0 .005 1.383l3.75 3.408a.938.938 0 0 0 1.57-.694v-2.187l3.437-.002c.519 0 .937-.418.937-.938v-.624a.938.938 0 0 0-.938-.938ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleLeft_default = SvgCircleLeft;

// src/Icon/icons/CircleLocationArrow.tsx
import { jsx as jsx447 } from "react/jsx-runtime";
var SvgCircleLocationArrow = (props) => /* @__PURE__ */ jsx447(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx447(
      "path",
      {
        d: "m15.992 9.137-3.281 7.656c-.137.316-.445.52-.824.52a.865.865 0 0 1-.824-.86v-3.515H7.511c-.371 0-.727-.29-.809-.688a.865.865 0 0 1 .504-.96l7.656-3.282a.861.861 0 0 1 .95.183c.214.246.32.618.18.946ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleLocationArrow_default = SvgCircleLocationArrow;

// src/Icon/icons/CircleM.tsx
import { jsx as jsx448 } from "react/jsx-runtime";
var SvgCircleM = (props) => /* @__PURE__ */ jsx448(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx448(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm4.352-13.078a.932.932 0 0 0-1.049.343L12 11.96 8.7 7.356a.972.972 0 0 0-1.052-.308.936.936 0 0 0-.648.89v8.125a.938.938 0 0 0 1.875 0v-5.226l2.365 3.274c.353.489 1.167.489 1.52 0l2.365-3.274v5.226a.938.938 0 0 0 1.875 0V7.938a.936.936 0 0 0-.648-.89Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleM_default = SvgCircleM;

// src/Icon/icons/CircleMicrophoneLines.tsx
import { jsx as jsx449 } from "react/jsx-runtime";
var SvgCircleMicrophoneLines = (props) => /* @__PURE__ */ jsx449(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx449(
      "path",
      {
        d: "M16.063 11.063a.938.938 0 0 0-.938.937A3.129 3.129 0 0 1 12 15.125 3.129 3.129 0 0 1 8.875 12 .938.938 0 0 0 7 12c0 2.436 1.753 4.465 4.063 4.906v.407a.938.938 0 0 0 1.874 0v-.408A5.002 5.002 0 0 0 17 12a.938.938 0 0 0-.938-.938ZM12 13.874c1.036 0 1.875-.84 1.875-1.875v-1.25h-.938a.312.312 0 1 1 0-.625h.938v-1.25h-.938a.312.312 0 1 1 0-.625h.938v-.625a1.875 1.875 0 0 0-3.75 0V12c0 1.035.84 1.875 1.875 1.875ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleMicrophoneLines_default = SvgCircleMicrophoneLines;

// src/Icon/icons/CircleMicrophone.tsx
import { jsx as jsx450 } from "react/jsx-runtime";
var SvgCircleMicrophone = (props) => /* @__PURE__ */ jsx450(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx450(
      "path",
      {
        d: "M12 13.875c1.036 0 1.875-.84 1.875-1.875V7.625a1.875 1.875 0 0 0-3.75 0V12c0 1.035.84 1.875 1.875 1.875Zm4.063-2.813a.938.938 0 0 0-.938.938A3.129 3.129 0 0 1 12 15.125 3.129 3.129 0 0 1 8.875 12 .938.938 0 0 0 7 12c0 2.436 1.753 4.465 4.063 4.906v.407a.938.938 0 0 0 1.874 0v-.408A5.002 5.002 0 0 0 17 12a.938.938 0 0 0-.938-.938ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleMicrophone_default = SvgCircleMicrophone;

// src/Icon/icons/CircleMinus.tsx
import { jsx as jsx451 } from "react/jsx-runtime";
var SvgCircleMinus = (props) => /* @__PURE__ */ jsx451(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx451(
      "path",
      {
        d: "M15.438 11.063c.519 0 .937.417.937.937s-.418.938-.938.938H8.564A.935.935 0 0 1 7.625 12c0-.52.418-.938.938-.938h6.874ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleMinus_default = SvgCircleMinus;

// src/Icon/icons/CircleN.tsx
import { jsx as jsx452 } from "react/jsx-runtime";
var SvgCircleN = (props) => /* @__PURE__ */ jsx452(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx452(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125ZM14.813 7a.938.938 0 0 0-.938.938v5.125l-3.918-5.66a.94.94 0 0 0-1.05-.362.94.94 0 0 0-.657.896v8.125a.938.938 0 0 0 1.875 0v-5.125l3.918 5.657a.925.925 0 0 0 1.049.363.935.935 0 0 0 .658-.895V7.938A.938.938 0 0 0 14.812 7Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleN_default = SvgCircleN;

// src/Icon/icons/CircleNodes.tsx
import { jsx as jsx453 } from "react/jsx-runtime";
var SvgCircleNodes = (props) => /* @__PURE__ */ jsx453(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx453(
      "path",
      {
        d: "M17.207 16.11A3.125 3.125 0 0 1 15.75 22c-1.727 0-3.16-1.398-3.16-3.125 0-.45.129-.875.297-1.258l-5.512-4.824A3.125 3.125 0 1 1 5.75 7c.941 0 1.848.445 2.418 1.148l6.965-2.786a3.125 3.125 0 1 1 6.242-.237 3.129 3.129 0 0 1-2.77 3.102l-1.398 7.882ZM18.25 3.874a1.25 1.25 0 1 0-.001 2.499 1.25 1.25 0 0 0 .001-2.499ZM8.867 9.887c.004.078-.027.125-.027.238 0 .45-.059.875-.227 1.258l5.512 4.824a3.05 3.05 0 0 1 1.234-.434l1.434-7.882a3.081 3.081 0 0 1-.961-.79L8.867 9.888Zm6.883 7.738c-.691 0-1.25.559-1.25 1.25s.559 1.25 1.25 1.25 1.25-.559 1.25-1.25-.559-1.25-1.25-1.25Zm-10.035-6.25c.725 0 1.25-.559 1.25-1.25s-.525-1.25-1.25-1.25c-.655 0-1.25.559-1.25 1.25s.595 1.25 1.25 1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleNodes_default = SvgCircleNodes;

// src/Icon/icons/CircleNotch.tsx
import { jsx as jsx454 } from "react/jsx-runtime";
var SvgCircleNotch = (props) => /* @__PURE__ */ jsx454(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx454(
      "path",
      {
        d: "M10.402 2.872a.938.938 0 0 1-.644 1.16c-3.399.972-5.883 4.104-5.883 7.776A8.101 8.101 0 0 0 12 19.933a8.101 8.101 0 0 0 8.125-8.125c0-3.672-2.484-6.804-5.883-7.777a.938.938 0 1 1 .516-1.803C18.938 3.426 22 7.277 22 11.808c0 5.559-4.477 10-10 10s-10-4.441-10-10c0-4.531 3.061-8.382 7.242-9.58a.94.94 0 0 1 1.16.644Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleNotch_default = SvgCircleNotch;

// src/Icon/icons/CircleO.tsx
import { jsx as jsx455 } from "react/jsx-runtime";
var SvgCircleO = (props) => /* @__PURE__ */ jsx455(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx455(
      "path",
      {
        d: "M12 7c-2.758 0-5 2.242-5 5s2.243 5 5 5 5-2.243 5-5-2.242-5-5-5Zm0 8.125A3.129 3.129 0 0 1 8.875 12 3.129 3.129 0 0 1 12 8.875 3.129 3.129 0 0 1 15.125 12 3.129 3.129 0 0 1 12 15.125ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleO_default = SvgCircleO;

// src/Icon/icons/CircleP.tsx
import { jsx as jsx456 } from "react/jsx-runtime";
var SvgCircleP = (props) => /* @__PURE__ */ jsx456(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx456(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125ZM12.938 7h-3.75a.94.94 0 0 0-.938.938v8.125a.938.938 0 0 0 1.875 0v-2.188h2.813a3.441 3.441 0 0 0 3.437-3.438A3.442 3.442 0 0 0 12.937 7Zm0 5h-2.813V8.875h2.813a1.562 1.562 0 1 1 0 3.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleP_default = SvgCircleP;

// src/Icon/icons/CirclePause.tsx
import { jsx as jsx457 } from "react/jsx-runtime";
var SvgCirclePause = (props) => /* @__PURE__ */ jsx457(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx457(
      "path",
      {
        d: "M9.813 8.25a.94.94 0 0 0-.938.938v5.624a.938.938 0 0 0 1.875 0V9.189a.938.938 0 0 0-.938-.938Zm4.374 0a.94.94 0 0 0-.937.938v5.624a.938.938 0 0 0 1.875 0V9.189a.938.938 0 0 0-.938-.938ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CirclePause_default = SvgCirclePause;

// src/Icon/icons/CirclePhoneFlip.tsx
import { jsx as jsx458 } from "react/jsx-runtime";
var SvgCirclePhoneFlip = (props) => /* @__PURE__ */ jsx458(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx458(
      "path",
      {
        d: "m16.527 7.469-1.968-.454a.615.615 0 0 0-.7.354l-.91 2.12a.611.611 0 0 0 .176.711l1.05.861a6.83 6.83 0 0 1-3.115 3.116l-.86-1.048a.603.603 0 0 0-.712-.176l-2.117.906a.613.613 0 0 0-.354.699l.454 1.968a.607.607 0 0 0 .596.473C12.992 17 17 12.991 17 8.062a.61.61 0 0 0-.473-.593ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CirclePhoneFlip_default = SvgCirclePhoneFlip;

// src/Icon/icons/CirclePhoneHangup.tsx
import { jsx as jsx459 } from "react/jsx-runtime";
var SvgCirclePhoneHangup = (props) => /* @__PURE__ */ jsx459(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx459(
      "path",
      {
        d: "M18.316 11.246c-3.48-3.484-9.152-3.484-12.634 0a.607.607 0 0 0-.086.755l1.07 1.713c.155.248.47.354.745.244l2.141-.856a.607.607 0 0 0 .38-.627l-.135-1.35a6.831 6.831 0 0 1 4.406 0l-.134 1.352a.611.611 0 0 0 .38.627l2.14.857c.277.107.59.005.745-.245l1.07-1.713a.612.612 0 0 0-.088-.757ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CirclePhoneHangup_default = SvgCirclePhoneHangup;

// src/Icon/icons/CirclePhone.tsx
import { jsx as jsx460 } from "react/jsx-runtime";
var SvgCirclePhone = (props) => /* @__PURE__ */ jsx460(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx460(
      "path",
      {
        d: "m16.629 13.86-2.119-.909a.608.608 0 0 0-.712.175l-.86 1.052a6.831 6.831 0 0 1-3.117-3.116l1.054-.894a.611.611 0 0 0 .175-.712l-.91-2.085a.612.612 0 0 0-.699-.355l-1.968.453c-.313.066-.508.308-.508.593 0 4.926 4.008 8.938 8.933 8.938a.608.608 0 0 0 .596-.473l.454-1.968a.555.555 0 0 0-.32-.7ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CirclePhone_default = SvgCirclePhone;

// src/Icon/icons/CirclePlay.tsx
import { jsx as jsx461 } from "react/jsx-runtime";
var SvgCirclePlay = (props) => /* @__PURE__ */ jsx461(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx461(
      "path",
      {
        d: "M9.355 7.746c.293-.168.657-.195.946.016l5.625 3.437c.277.172.449.473.449.801a.943.943 0 0 1-.45.8l-5.624 3.438a.931.931 0 0 1-.946.016.932.932 0 0 1-.48-.817v-6.91a.92.92 0 0 1 .48-.78ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CirclePlay_default = SvgCirclePlay;

// src/Icon/icons/CirclePlus.tsx
import { jsx as jsx462 } from "react/jsx-runtime";
var SvgCirclePlus = (props) => /* @__PURE__ */ jsx462(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx462(
      "path",
      {
        d: "M11.063 15.438v-2.5h-2.5A.935.935 0 0 1 7.625 12c0-.52.418-.938.938-.938h2.5v-2.5c0-.519.417-.937.937-.937s.938.418.938.938v2.5h2.5c.519 0 .937.417.937.937s-.418.938-.938.938h-2.5v2.5c0 .519-.417.937-.937.937a.935.935 0 0 1-.938-.938ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CirclePlus_default = SvgCirclePlus;

// src/Icon/icons/CircleQ.tsx
import { jsx as jsx463 } from "react/jsx-runtime";
var SvgCircleQ = (props) => /* @__PURE__ */ jsx463(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx463(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125ZM12 7c-2.758 0-5 2.242-5 5s2.243 5 5 5c1.04 0 2.007-.32 2.808-.866l.592.591c.182.185.42.275.662.275a.937.937 0 0 0 .663-1.6l-.591-.592c.546-.8.866-1.769.866-2.808 0-2.758-2.242-5-5-5Zm2.762 6.434-1.16-1.16a.937.937 0 1 0-1.326 1.326l1.16 1.16a3.098 3.098 0 0 1-1.436.365A3.128 3.128 0 0 1 8.875 12 3.129 3.129 0 0 1 12 8.875 3.129 3.129 0 0 1 15.125 12c0 .52-.14 1.004-.363 1.434Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleQ_default = SvgCircleQ;

// src/Icon/icons/CircleQuarter.tsx
import { jsx as jsx464 } from "react/jsx-runtime";
var SvgCircleQuarter = (props) => /* @__PURE__ */ jsx464(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx464(
      "path",
      {
        d: "M19.553 2.017c1.381-.172 2.447.976 2.447 2.3v15.157C22 20.942 20.942 22 19.474 22H4.317c-1.324 0-2.472-1.066-2.3-2.447 1.138-9.15 8.386-16.398 17.536-17.536ZM6.09 18.211h12.12V6.09C12.259 7.512 7.512 12.258 6.09 18.21Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleQuarter_default = SvgCircleQuarter;

// src/Icon/icons/CircleQuarters.tsx
import { jsx as jsx465 } from "react/jsx-runtime";
var SvgCircleQuarters = (props) => /* @__PURE__ */ jsx465(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx465(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm5.746 15.746L12 12l-5.746 5.746A8.11 8.11 0 0 1 3.875 12c0-2.242.91-4.273 2.38-5.746L12 12l5.746-5.746A8.114 8.114 0 0 1 20.125 12c0 2.242-.91 4.273-2.379 5.746Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleQuarters_default = SvgCircleQuarters;

// src/Icon/icons/CircleQuestion.tsx
import { jsx as jsx466 } from "react/jsx-runtime";
var SvgCircleQuestion = (props) => /* @__PURE__ */ jsx466(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx466(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm0-5c-.703 0-1.25.547-1.25 1.25s.512 1.25 1.25 1.25c.668 0 1.25-.547 1.25-1.25s-.582-1.25-1.25-1.25ZM13.293 7h-1.996a2.718 2.718 0 0 0-2.735 2.734c0 .508.43.938.938.938a.95.95 0 0 0 .938-.938c0-.468.355-.859.824-.859h1.996c.504 0 .93.39.93.86 0 .312-.157.55-.43.706l-2.227 1.364a.964.964 0 0 0-.469.82v.625c0 .508.43.938.938.938a.95.95 0 0 0 .938-.938v-.078l1.761-1.094c.82-.508 1.328-1.406 1.328-2.344C16.062 8.211 14.852 7 13.293 7Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleQuestion_default = SvgCircleQuestion;

// src/Icon/icons/CircleR.tsx
import { jsx as jsx467 } from "react/jsx-runtime";
var SvgCircleR = (props) => /* @__PURE__ */ jsx467(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx467(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm4.375-10A3.13 3.13 0 0 0 13.25 7H9.187a.94.94 0 0 0-.937.938v8.125a.938.938 0 0 0 1.875 0V13.25h1.796l2.446 3.364a.932.932 0 0 0 1.308.206.937.937 0 0 0 .207-1.309l-1.75-2.404a3.118 3.118 0 0 0 2.243-2.982Zm-3.125 1.25h-3.125v-2.5h3.125a1.251 1.251 0 0 1 0 2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleR_default = SvgCircleR;

// src/Icon/icons/CircleRadiation.tsx
import { jsx as jsx468 } from "react/jsx-runtime";
var SvgCircleRadiation = (props) => /* @__PURE__ */ jsx468(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx468(
      "path",
      {
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.412 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.587 8-8 8Zm-1.233-9.975-1.734-2.78a.68.68 0 0 0-1.004-.153 6.32 6.32 0 0 0-2.316 4.133.68.68 0 0 0 .662.775h3.292c0-.833.441-1.558 1.1-1.975ZM12 13.333a1.334 1.334 0 1 0 0-2.667 1.334 1.334 0 0 0 0 2.667Zm1.233.638c-.396.225-.779.362-1.233.362a2.31 2.31 0 0 1-1.232-.36l-1.74 2.783c-.217.348-.067.795.303.97.81.387 1.715.607 2.669.607.957 0 1.86-.222 2.672-.608.37-.175.52-.623.302-.97l-1.74-2.784Zm2.742-6.88a.676.676 0 0 0-1.002.158l-1.738 2.778A2.333 2.333 0 0 1 14.333 12h3.29c.41 0 .713-.366.663-.773a6.327 6.327 0 0 0-2.311-4.135Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleRadiation_default = SvgCircleRadiation;

// src/Icon/icons/CircleRight.tsx
import { jsx as jsx469 } from "react/jsx-runtime";
var SvgCircleRight = (props) => /* @__PURE__ */ jsx469(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx469(
      "path",
      {
        d: "M12.945 7.867c-.277-.25-.707-.312-1.011-.16-.305.152-.594.484-.594.82v2.188l-3.402.035a.94.94 0 0 0-.938.938v.624c0 .52.422.938.938.938l3.437-.035v2.187a.938.938 0 0 0 1.574.689l3.75-3.467c.192-.144.301-.394.301-.655-.012-.304-.112-.518-.306-.694l-3.749-3.408ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleRight_default = SvgCircleRight;

// src/Icon/icons/CircleS.tsx
import { jsx as jsx470 } from "react/jsx-runtime";
var SvgCircleS = (props) => /* @__PURE__ */ jsx470(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx470(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm.25-9.027c-1.95-.54-2.215-.801-2.105-1.418a.781.781 0 0 1 .364-.532c.336-.217 1.205-.503 3.267.023a.937.937 0 1 0 .464-1.817c-2.096-.535-3.69-.461-4.746.217a2.667 2.667 0 0 0-1.193 1.78c-.44 2.476 1.9 3.126 3.45 3.555 1.95.542 2.214.802 2.104 1.419-.051.285-.17.46-.395.588-.707.394-2.285.228-3.93-.418a.937.937 0 1 0-.686 1.746c.715.28 2.144.76 3.54.76.704 0 1.398-.12 1.99-.452.718-.401 1.176-1.057 1.326-1.896.405-2.473-1.9-3.126-3.45-3.555Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleS_default = SvgCircleS;

// src/Icon/icons/CircleSmall.tsx
import { jsx as jsx471 } from "react/jsx-runtime";
var SvgCircleSmall = (props) => /* @__PURE__ */ jsx471(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx471(
      "path",
      {
        d: "M22 12c0 5.525-4.475 10-10 10-5.523 0-10-4.475-10-10S6.477 2 12 2c5.525 0 10 4.475 10 10ZM12 5c-3.866 0-7 3.131-7 7s3.134 7 7 7c3.869 0 7-3.131 7-7s-3.131-7-7-7Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleSmall_default = SvgCircleSmall;

// src/Icon/icons/CircleSortDown.tsx
import { jsx as jsx472 } from "react/jsx-runtime";
var SvgCircleSortDown = (props) => /* @__PURE__ */ jsx472(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx472(
      "path",
      {
        d: "M12.512 6.586A.738.738 0 0 0 12 6.375a.729.729 0 0 0-.508.21l-3.578 3.563a.72.72 0 0 0 .512 1.227h7.148c.645 0 .962-.777.513-1.226l-3.575-3.563Zm-2.805 3.539L12 7.841l2.293 2.284H9.707Zm5.867 2.5H8.426a.72.72 0 0 0-.512 1.227l3.578 3.562c.137.133.317.211.508.211a.743.743 0 0 0 .512-.21l3.575-3.564c.448-.449.132-1.226-.513-1.226ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleSortDown_default = SvgCircleSortDown;

// src/Icon/icons/CircleSortUp.tsx
import { jsx as jsx473 } from "react/jsx-runtime";
var SvgCircleSortUp = (props) => /* @__PURE__ */ jsx473(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx473(
      "path",
      {
        d: "M12.512 6.586A.738.738 0 0 0 12 6.375a.729.729 0 0 0-.508.21l-3.578 3.563a.72.72 0 0 0 .512 1.227h7.148c.645 0 .962-.777.513-1.226l-3.575-3.563Zm3.062 6.039H8.426a.72.72 0 0 0-.512 1.227l3.578 3.562c.137.133.317.211.508.211a.743.743 0 0 0 .512-.21l3.575-3.564c.448-.449.132-1.226-.513-1.226Zm-3.57 3.535-2.297-2.285h4.582l-2.285 2.285ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleSortUp_default = SvgCircleSortUp;

// src/Icon/icons/CircleSort.tsx
import { jsx as jsx474 } from "react/jsx-runtime";
var SvgCircleSort = (props) => /* @__PURE__ */ jsx474(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx474(
      "path",
      {
        d: "M15.574 12.625H8.426a.72.72 0 0 0-.512 1.227l3.578 3.562c.137.133.317.211.508.211a.743.743 0 0 0 .512-.21l3.575-3.564c.448-.449.132-1.226-.513-1.226Zm-3.062-6.04a.738.738 0 0 0-.512-.21.729.729 0 0 0-.508.21l-3.578 3.563a.72.72 0 0 0 .512 1.227h7.148c.645 0 .962-.777.513-1.226l-3.575-3.563ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleSort_default = SvgCircleSort;

// src/Icon/icons/CircleStar.tsx
import { jsx as jsx475 } from "react/jsx-runtime";
var SvgCircleStar = (props) => /* @__PURE__ */ jsx475(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx475(
      "path",
      {
        d: "M12 6.727c.238 0 .457.136.559.347l1.222 2.473 2.73.398a.622.622 0 0 1 .344 1.066l-1.972 1.891.465 2.754a.622.622 0 0 1-.906.656L12 15.033l-2.441 1.28a.622.622 0 0 1-.907-.656l.465-2.754-1.972-1.89a.622.622 0 0 1 .343-1.067l2.73-.398 1.223-2.473A.621.621 0 0 1 12 6.727ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleStar_default = SvgCircleStar;

// src/Icon/icons/CircleStop.tsx
import { jsx as jsx476 } from "react/jsx-runtime";
var SvgCircleStop = (props) => /* @__PURE__ */ jsx476(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx476(
      "path",
      {
        d: "M14.813 8.25H9.186a.94.94 0 0 0-.937.938v5.624a.94.94 0 0 0 .938.938h5.624a.94.94 0 0 0 .938-.938V9.189a.94.94 0 0 0-.938-.938ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleStop_default = SvgCircleStop;

// src/Icon/icons/CircleT.tsx
import { jsx as jsx477 } from "react/jsx-runtime";
var SvgCircleT = (props) => /* @__PURE__ */ jsx477(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx477(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm4.063-12.5H7.938A.94.94 0 0 0 7 8.563a.94.94 0 0 0 .938.937h3.125v6.563a.938.938 0 0 0 1.874 0V9.5h3.126c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleT_default = SvgCircleT;

// src/Icon/icons/CircleThreeQuarters.tsx
import { jsx as jsx478 } from "react/jsx-runtime";
var SvgCircleThreeQuarters = (props) => /* @__PURE__ */ jsx478(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx478(
      "path",
      {
        d: "M10.784 2.009c.686-.086 1.25.484 1.25 1.141v8.78h8.78c.695 0 1.263.6 1.177 1.286-.616 4.95-4.837 8.784-9.956 8.784C6.492 22 2 17.508 2 11.93c0-5.083 3.832-9.305 8.784-9.921Zm-.63 11.803V4.03c-3.595.85-6.272 4.083-6.272 7.9 0 4.54 3.65 8.189 8.153 8.189 3.853 0 7.087-2.678 7.933-6.307h-9.815Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleThreeQuarters_default = SvgCircleThreeQuarters;

// src/Icon/icons/CircleTrash.tsx
import { jsx as jsx479 } from "react/jsx-runtime";
var SvgCircleTrash = (props) => /* @__PURE__ */ jsx479(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx479(
      "path",
      {
        d: "m9.867 7 .442-.441a.612.612 0 0 1 .406-.184h2.535c.164 0 .324.066.441.184l.442.441h1.617c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625H8.215c-.309 0-.625-.281-.625-.625S7.906 7 8.215 7h1.652Zm5.883 2.5-.531 6.355A1.247 1.247 0 0 1 13.977 17h-3.954c-.648 0-1.191-.5-1.242-1.145L8.25 9.5h7.5ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleTrash_default = SvgCircleTrash;

// src/Icon/icons/CircleU.tsx
import { jsx as jsx480 } from "react/jsx-runtime";
var SvgCircleU = (props) => /* @__PURE__ */ jsx480(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx480(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm3.438-12.5a.94.94 0 0 0-.938.938v4.8c0 1.317-1.121 2.387-2.5 2.387s-2.5-1.07-2.5-2.386V8.562a.938.938 0 0 0-1.875 0v4.801c0 2.352 1.965 4.262 4.375 4.262s4.375-1.912 4.375-4.262v-4.8a.938.938 0 0 0-.938-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleU_default = SvgCircleU;

// src/Icon/icons/CircleUpLeft.tsx
import { jsx as jsx481 } from "react/jsx-runtime";
var SvgCircleUpLeft = (props) => /* @__PURE__ */ jsx481(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx481(
      "path",
      {
        d: "m13.234 11.465 1.616-1.617a.936.936 0 0 0-.663-1.598h-5a.94.94 0 0 0-.937.938v5a.938.938 0 0 0 1.6.662l1.616-1.616 2.523 2.522a.937.937 0 0 0 1.325 0l.442-.442a.938.938 0 0 0 0-1.325l-2.522-2.524ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleUpLeft_default = SvgCircleUpLeft;

// src/Icon/icons/CircleUpRight.tsx
import { jsx as jsx482 } from "react/jsx-runtime";
var SvgCircleUpRight = (props) => /* @__PURE__ */ jsx482(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx482(
      "path",
      {
        d: "M14.813 8.25h-5a.936.936 0 0 0-.868.578c-.144.352-.062.754.203.988l1.617 1.617-2.523 2.555a.938.938 0 0 0 0 1.326l.442.442a.938.938 0 0 0 1.326 0l2.522-2.522 1.616 1.616a.937.937 0 0 0 1.602-.662v-5a.938.938 0 0 0-.938-.938ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleUpRight_default = SvgCircleUpRight;

// src/Icon/icons/CircleUp.tsx
import { jsx as jsx483 } from "react/jsx-runtime";
var SvgCircleUp = (props) => /* @__PURE__ */ jsx483(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx483(
      "path",
      {
        d: "M12.66 7.3a.95.95 0 0 0-.691-.3c-.301.012-.551.113-.692.305l-3.408 3.75a.932.932 0 0 0-.162 1.011c.148.34.484.559.82.559h2.188l.035 3.438c0 .517.42.937.938.937h.624c.518 0 .903-.42.903-.938v-3.437h2.187a.938.938 0 0 0 .688-1.574l-3.43-3.75ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleUp_default = SvgCircleUp;

// src/Icon/icons/CircleUser.tsx
import { jsx as jsx484 } from "react/jsx-runtime";
var SvgCircleUser = (props) => /* @__PURE__ */ jsx484(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx484(
      "path",
      {
        d: "M12 6.375a3.438 3.438 0 1 0 0 6.875 3.438 3.438 0 0 0 0-6.875Zm0 5a1.562 1.562 0 1 1 0-3.126 1.562 1.562 0 0 1 0 3.126ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125a8.068 8.068 0 0 1-4.863-1.632 3.891 3.891 0 0 1 3.465-2.118h2.8c1.475 0 2.786.82 3.464 2.118A8.086 8.086 0 0 1 12 20.125Zm6.258-2.95c-1.055-1.648-2.852-2.675-4.86-2.675h-2.796c-2.007 0-3.803 1.025-4.86 2.675A8.082 8.082 0 0 1 3.875 12c0-4.48 3.645-8.125 8.125-8.125S20.125 7.52 20.125 12c0 1.965-.703 3.77-1.867 5.176Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleUser_default = SvgCircleUser;

// src/Icon/icons/CircleV.tsx
import { jsx as jsx485 } from "react/jsx-runtime";
var SvgCircleV = (props) => /* @__PURE__ */ jsx485(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx485(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm4.48-12.402a.939.939 0 0 0-1.257.419L12 14.59 8.777 8.145a.938.938 0 0 0-1.68.835l4.063 8.125a.937.937 0 0 0 1.679.002L16.9 8.982a.939.939 0 0 0-.42-1.26Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleV_default = SvgCircleV;

// src/Icon/icons/CircleVideo.tsx
import { jsx as jsx486 } from "react/jsx-runtime";
var SvgCircleVideo = (props) => /* @__PURE__ */ jsx486(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx486(
      "path",
      {
        d: "M13.094 8.875H8.406c-.465 0-.781.316-.781.781v4.688c0 .431.35.781.781.781h4.688c.431 0 .781-.35.781-.781V9.656a.762.762 0 0 0-.781-.781Zm3.742.715-1.711 1.18v2.459l1.712 1.18c.331.228.788-.003.788-.401V9.992a.5.5 0 0 0-.79-.402ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleVideo_default = SvgCircleVideo;

// src/Icon/icons/CircleW.tsx
import { jsx as jsx487 } from "react/jsx-runtime";
var SvgCircleW = (props) => /* @__PURE__ */ jsx487(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx487(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm4.965-12.457a.94.94 0 0 0-1.172.62l-1.547 5.017-1.342-4.985a.937.937 0 0 0-1.81 0l-1.34 4.985-1.547-5.02a.937.937 0 1 0-1.792.552l2.5 8.125c.124.401.495.628.913.663a.937.937 0 0 0 .889-.694L12 12.168l1.282 4.762a.937.937 0 0 0 .89.695h.015c.411 0 .776-.268.897-.662l2.5-8.125c.15-.494-.127-1.053-.62-1.17Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleW_default = SvgCircleW;

// src/Icon/icons/CircleWaveformLines.tsx
import { jsx as jsx488 } from "react/jsx-runtime";
var SvgCircleWaveformLines = (props) => /* @__PURE__ */ jsx488(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx488(
      "path",
      {
        d: "M11.063 7a.94.94 0 0 0-.938.938v8.125a.94.94 0 0 0 .938.937.94.94 0 0 0 .937-.938V7.938A.94.94 0 0 0 11.062 7ZM7.937 9.5a.94.94 0 0 0-.937.938v3.124a.94.94 0 0 0 .938.938.94.94 0 0 0 .937-.938v-3.124a.94.94 0 0 0-.938-.938Zm9.375.938a.94.94 0 0 0-.937.937v1.25a.94.94 0 0 0 .938.938.94.94 0 0 0 .937-.938v-1.25a.94.94 0 0 0-.938-.938Zm-3.125-1.563a.94.94 0 0 0-.937.938v4.374a.94.94 0 0 0 .938.938.94.94 0 0 0 .937-.938V9.814a.94.94 0 0 0-.938-.938ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleWaveformLines_default = SvgCircleWaveformLines;

// src/Icon/icons/CircleX.tsx
import { jsx as jsx489 } from "react/jsx-runtime";
var SvgCircleX = (props) => /* @__PURE__ */ jsx489(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx489(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm4.043-12.902a.937.937 0 0 0-1.321.11L12 10.547 9.277 7.332a.935.935 0 0 0-1.32-.11.935.935 0 0 0-.11 1.321L10.774 12l-2.925 3.457a.938.938 0 0 0 .11 1.322.913.913 0 0 0 .57.221c.265 0 .53-.113.716-.332L12 13.453l2.722 3.216a.94.94 0 0 0 1.32.11.938.938 0 0 0 .11-1.322L13.228 12l2.925-3.457a.935.935 0 0 0-.109-1.32Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleX_default = SvgCircleX;

// src/Icon/icons/CircleXmark.tsx
import { jsx as jsx490 } from "react/jsx-runtime";
var SvgCircleXmark = (props) => /* @__PURE__ */ jsx490(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx490(
      "path",
      {
        d: "M8.836 8.836c.367-.363.96-.363 1.293 0l1.836 1.84 1.87-1.84c.368-.363.962-.363 1.294 0 .398.367.398.96 0 1.293l-1.805 1.836 1.805 1.87c.398.368.398.962 0 1.294-.332.398-.926.398-1.293 0l-1.871-1.805-1.836 1.805c-.332.398-.926.398-1.293 0-.363-.332-.363-.926 0-1.293l1.84-1.871-1.84-1.836c-.363-.332-.363-.926 0-1.293ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleXmark_default = SvgCircleXmark;

// src/Icon/icons/CircleY.tsx
import { jsx as jsx491 } from "react/jsx-runtime";
var SvgCircleY = (props) => /* @__PURE__ */ jsx491(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx491(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm3.352-12.172L12 11.863l-3.352-3.91a.935.935 0 0 0-1.32-.101.935.935 0 0 0-.101 1.32l3.835 4.476v3.04a.938.938 0 0 0 1.876 0v-3.04l3.836-4.476a.937.937 0 1 0-1.422-1.219Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleY_default = SvgCircleY;

// src/Icon/icons/CircleZ.tsx
import { jsx as jsx492 } from "react/jsx-runtime";
var SvgCircleZ = (props) => /* @__PURE__ */ jsx492(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx492(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm2.813-5h-3.836l4.605-6.652a.935.935 0 0 0 .06-.97C15.48 7.16 15.16 7 14.812 7H9.189a.94.94 0 0 0-.938.938.94.94 0 0 0 .938.937h3.835l-4.605 6.652A.94.94 0 0 0 9.188 17h5.624a.938.938 0 0 0 0-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var CircleZ_default = SvgCircleZ;

// src/Icon/icons/Circle.tsx
import { jsx as jsx493 } from "react/jsx-runtime";
var SvgCircle = (props) => /* @__PURE__ */ jsx493(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx493(
      "path",
      {
        d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var Circle_default = SvgCircle;

// src/Icon/icons/ClipboardCheck.tsx
import { jsx as jsx494 } from "react/jsx-runtime";
var SvgClipboardCheck = (props) => /* @__PURE__ */ jsx494(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx494(
      "path",
      {
        d: "M17 4.5H15.063a3.126 3.126 0 0 0-6.126 0H7A2.502 2.502 0 0 0 4.5 7v12.5C4.5 20.879 5.621 22 7 22h10c1.379 0 2.5-1.121 2.5-2.5V7c0-1.379-1.121-2.5-2.5-2.5ZM7.625 6.375v.938c0 .519.418.937.938.937h6.875c.519 0 .937-.418.937-.938v-.937H17c.344 0 .625.281.625.625v12.5a.627.627 0 0 1-.625.625H7a.627.627 0 0 1-.625-.625V7c0-.344.281-.625.625-.625h.625Zm3.438-1.25a.938.938 0 1 1 1.875 0 .938.938 0 0 1-1.876 0Zm4.726 7.328a.937.937 0 0 0-1.324-1.324l-3.504 3.504-1.422-1.422a.937.937 0 0 0-1.324 1.324l2.082 2.082a.937.937 0 0 0 .664.274c.25 0 .488-.098.664-.274l4.164-4.164Z",
        fill: "currentColor"
      }
    )
  })
);
var ClipboardCheck_default = SvgClipboardCheck;

// src/Icon/icons/ClipboardListCheck.tsx
import { jsx as jsx495 } from "react/jsx-runtime";
var SvgClipboardListCheck = (props) => /* @__PURE__ */ jsx495(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx495(
      "path",
      {
        d: "M17 4.5H15.063a3.126 3.126 0 0 0-6.126 0H7A2.502 2.502 0 0 0 4.5 7v12.5C4.5 20.879 5.621 22 7 22h10c1.379 0 2.5-1.121 2.5-2.5V7c0-1.379-1.121-2.5-2.5-2.5ZM7.625 6.375v.938c0 .519.418.937.938.937h6.875c.519 0 .937-.418.937-.938v-.937H17c.344 0 .625.281.625.625v12.5a.627.627 0 0 1-.625.625H7a.627.627 0 0 1-.625-.625V7c0-.344.281-.625.625-.625h.625Zm3.438-1.25a.938.938 0 1 1 1.875 0 .938.938 0 0 1-1.876 0Zm.128 6.066a.627.627 0 0 0 0-.882.627.627 0 0 0-.882 0l-1.434 1.433-.496-.496a.627.627 0 0 0-.883 0 .627.627 0 0 0 0 .883l.938.937c.242.243.64.243.882 0l1.875-1.875ZM12 12.625c0 .344.281.625.625.625h2.5a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625h-2.5a.627.627 0 0 0-.625.625Zm-1.25 3.75c0 .344.281.625.625.625h3.75a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625h-3.75a.627.627 0 0 0-.625.625Zm-1.875.938a.938.938 0 1 0 0-1.876.938.938 0 0 0 0 1.876Z",
        fill: "currentColor"
      }
    )
  })
);
var ClipboardListCheck_default = SvgClipboardListCheck;

// src/Icon/icons/ClipboardList.tsx
import { jsx as jsx496 } from "react/jsx-runtime";
var SvgClipboardList = (props) => /* @__PURE__ */ jsx496(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx496(
      "path",
      {
        d: "M17 4.5H15.063a3.126 3.126 0 0 0-6.126 0H7A2.502 2.502 0 0 0 4.5 7v12.5C4.5 20.879 5.621 22 7 22h10c1.379 0 2.5-1.121 2.5-2.5V7c0-1.379-1.121-2.5-2.5-2.5ZM7.625 6.375v.938c0 .519.418.937.938.937h6.875c.519 0 .937-.418.937-.938v-.937H17c.344 0 .625.281.625.625v12.5a.627.627 0 0 1-.625.625H7a.627.627 0 0 1-.625-.625V7c0-.344.281-.625.625-.625h.625Zm3.438-1.25a.938.938 0 1 1 1.875 0 .938.938 0 0 1-1.876 0Zm-1.25 7.5a.938.938 0 1 0-1.877 0 .938.938 0 0 0 1.877 0ZM11.374 12a.627.627 0 0 0-.625.625c0 .344.281.625.625.625h3.75a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625h-3.75Zm0 3.75a.627.627 0 0 0-.625.625c0 .344.281.625.625.625h3.75a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625h-3.75Zm-2.5 1.563a.938.938 0 1 0 0-1.876.938.938 0 0 0 0 1.876Z",
        fill: "currentColor"
      }
    )
  })
);
var ClipboardList_default = SvgClipboardList;

// src/Icon/icons/ClipboardQuestion.tsx
import { jsx as jsx497 } from "react/jsx-runtime";
var SvgClipboardQuestion = (props) => /* @__PURE__ */ jsx497(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx497(
      "path",
      {
        d: "M17 4.5H15.063a3.126 3.126 0 0 0-6.126 0H7A2.502 2.502 0 0 0 4.5 7v12.5C4.5 20.879 5.621 22 7 22h10c1.379 0 2.5-1.121 2.5-2.5V7c0-1.379-1.121-2.5-2.5-2.5ZM7.625 6.375v.938c0 .519.418.937.938.937h6.875c.519 0 .937-.418.937-.938v-.937H17c.344 0 .625.281.625.625v12.5a.627.627 0 0 1-.625.625H7a.627.627 0 0 1-.625-.625V7c0-.344.281-.625.625-.625h.625Zm3.438-1.25a.938.938 0 1 1 1.875 0 .938.938 0 0 1-1.876 0Zm-2.43 5.832-.016.047a.936.936 0 1 0 1.766.625l.015-.047a.311.311 0 0 1 .293-.207h2.278a.59.59 0 0 1 .293 1.102l-1.73.992a.935.935 0 0 0-.473.812v.531a.937.937 0 0 0 1.875.016l1.261-.723A2.465 2.465 0 0 0 12.97 9.5h-2.274a2.19 2.19 0 0 0-2.062 1.457Zm4.617 7.293a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0Z",
        fill: "currentColor"
      }
    )
  })
);
var ClipboardQuestion_default = SvgClipboardQuestion;

// src/Icon/icons/ClipboardUser.tsx
import { jsx as jsx498 } from "react/jsx-runtime";
var SvgClipboardUser = (props) => /* @__PURE__ */ jsx498(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx498(
      "path",
      {
        d: "M17 4.5H15.063a3.126 3.126 0 0 0-6.126 0H7A2.502 2.502 0 0 0 4.5 7v12.5C4.5 20.879 5.621 22 7 22h10c1.379 0 2.5-1.121 2.5-2.5V7c0-1.379-1.121-2.5-2.5-2.5ZM7.625 6.375v.938c0 .519.418.937.938.937h6.875c.519 0 .937-.418.937-.938v-.937H17c.344 0 .625.281.625.625v12.5a.627.627 0 0 1-.625.625h-.625A3.124 3.124 0 0 0 13.25 17h-2.5a3.124 3.124 0 0 0-3.125 3.125H7a.627.627 0 0 1-.625-.625V7c0-.344.281-.625.625-.625h.625Zm3.438-1.25a.938.938 0 1 1 1.875 0 .938.938 0 0 1-1.876 0ZM14.5 13.25a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z",
        fill: "currentColor"
      }
    )
  })
);
var ClipboardUser_default = SvgClipboardUser;

// src/Icon/icons/Clipboard.tsx
import { jsx as jsx499 } from "react/jsx-runtime";
var SvgClipboard = (props) => /* @__PURE__ */ jsx499(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx499(
      "path",
      {
        d: "M15.438 4.5H17c1.379 0 2.5 1.121 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5H7a2.502 2.502 0 0 1-2.5-2.5V7c0-1.379 1.121-2.5 2.5-2.5H8.937a3.126 3.126 0 0 1 6.126 0h.374ZM7 6.375A.627.627 0 0 0 6.375 7v12.5c0 .344.281.625.625.625h10a.627.627 0 0 0 .625-.625V7A.627.627 0 0 0 17 6.375h-.625v.938c0 .519-.418.937-.938.937H8.563a.935.935 0 0 1-.937-.938v-.937H7Zm5-.313a.937.937 0 1 0 0-1.874.937.937 0 0 0 0 1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var Clipboard_default = SvgClipboard;

// src/Icon/icons/ClockEightThirty.tsx
import { jsx as jsx500 } from "react/jsx-runtime";
var SvgClockEightThirty = (props) => /* @__PURE__ */ jsx500(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx500(
      "path",
      {
        d: "M11.063 13.75 8.77 15.246a.905.905 0 0 1-1.301-.226.942.942 0 0 1 .261-1.301l3.75-2.5a.942.942 0 0 1 .961-.047.94.94 0 0 1 .496.828v5.313c0 .519-.417.937-.937.937a.935.935 0 0 1-.938-.938V13.75ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10 8.125A8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockEightThirty_default = SvgClockEightThirty;

// src/Icon/icons/ClockEight.tsx
import { jsx as jsx501 } from "react/jsx-runtime";
var SvgClockEight = (props) => /* @__PURE__ */ jsx501(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx501(
      "path",
      {
        d: "M12.938 12a.917.917 0 0 1-.418.746l-3.75 2.5a.905.905 0 0 1-1.301-.226.942.942 0 0 1 .261-1.301l3.332-2.219V6.687c0-.519.418-.937.938-.937s.938.418.938.938V12ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockEight_default = SvgClockEight;

// src/Icon/icons/ClockElevenThirty.tsx
import { jsx as jsx502 } from "react/jsx-runtime";
var SvgClockElevenThirty = (props) => /* @__PURE__ */ jsx502(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx502(
      "path",
      {
        d: "M11.063 12.285 8.719 8.77a.942.942 0 0 1 .261-1.301c.43-.285 1.012-.168 1.266.261l2.5 3.75a.76.76 0 0 1 .191.52v5.313c0 .519-.417.937-.972.937-.485 0-.938-.418-.938-.938l.036-5.027ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10 8.125A8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockElevenThirty_default = SvgClockElevenThirty;

// src/Icon/icons/ClockEleven.tsx
import { jsx as jsx503 } from "react/jsx-runtime";
var SvgClockEleven = (props) => /* @__PURE__ */ jsx503(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx503(
      "path",
      {
        d: "M11.063 6.688c0-.52.417-.938.937-.938s.938.418.938.938V12c0 .414-.27.777-.7.863-.363.153-.789 0-1.02-.343l-2.5-3.75a.942.942 0 0 1 .262-1.301c.43-.285 1.012-.168 1.266.261l.781 1.172.036-2.214ZM12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM3.875 12A8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockEleven_default = SvgClockEleven;

// src/Icon/icons/ClockFiveThirty.tsx
import { jsx as jsx504 } from "react/jsx-runtime";
var SvgClockFiveThirty = (props) => /* @__PURE__ */ jsx504(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx504(
      "path",
      {
        d: "M12.938 17.313c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938V12c0-.414.27-.777.665-.898a.836.836 0 0 1 1.02.378l2.5 3.75c.32.43.202 1.012-.227 1.266a.905.905 0 0 1-1.301-.226l-.781-1.172v2.214ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm8.125-10A8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockFiveThirty_default = SvgClockFiveThirty;

// src/Icon/icons/ClockFive.tsx
import { jsx as jsx505 } from "react/jsx-runtime";
var SvgClockFive = (props) => /* @__PURE__ */ jsx505(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx505(
      "path",
      {
        d: "m12.938 11.715 2.308 3.515c.32.43.203 1.012-.226 1.266a.905.905 0 0 1-1.301-.226l-2.5-3.75a.943.943 0 0 1-.156-.52V6.687c0-.519.417-.937.937-.937s.938.418.938.938v5.027ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockFive_default = SvgClockFive;

// src/Icon/icons/ClockFourThirty.tsx
import { jsx as jsx506 } from "react/jsx-runtime";
var SvgClockFourThirty = (props) => /* @__PURE__ */ jsx506(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx506(
      "path",
      {
        d: "M12.938 17.313c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938V12a.94.94 0 0 1 .497-.828.942.942 0 0 1 .96.047l3.75 2.5c.43.289.547.87.227 1.3-.254.43-.836.547-1.265.227l-2.293-1.496v3.563ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm8.125-10A8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockFourThirty_default = SvgClockFourThirty;

// src/Icon/icons/ClockNineThirty.tsx
import { jsx as jsx507 } from "react/jsx-runtime";
var SvgClockNineThirty = (props) => /* @__PURE__ */ jsx507(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx507(
      "path",
      {
        d: "M12.938 17.313c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938v-4.375H7.938A.935.935 0 0 1 7 12c0-.52.418-.938.938-.938H12c.52 0 .938.418.938.938v5.313ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm8.125-10A8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockNineThirty_default = SvgClockNineThirty;

// src/Icon/icons/ClockNine.tsx
import { jsx as jsx508 } from "react/jsx-runtime";
var SvgClockNine = (props) => /* @__PURE__ */ jsx508(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx508(
      "path",
      {
        d: "M12.938 12c0 .52-.418.938-.938.938H7.937A.935.935 0 0 1 7 12c0-.52.418-.938.938-.938h3.125V6.689c0-.52.417-.938.937-.938s.938.418.938.938V12ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockNine_default = SvgClockNine;

// src/Icon/icons/ClockOneThirty.tsx
import { jsx as jsx509 } from "react/jsx-runtime";
var SvgClockOneThirty = (props) => /* @__PURE__ */ jsx509(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx509(
      "path",
      {
        d: "M12.938 17.313c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938V12c0-.184.055-.367.157-.52l2.5-3.75a.942.942 0 0 1 1.3-.261c.43.289.547.87.227 1.3l-2.309 3.516v5.027ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm8.125-10A8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockOneThirty_default = SvgClockOneThirty;

// src/Icon/icons/ClockOne.tsx
import { jsx as jsx510 } from "react/jsx-runtime";
var SvgClockOne = (props) => /* @__PURE__ */ jsx510(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx510(
      "path",
      {
        d: "m12.938 8.902.78-1.172a.942.942 0 0 1 1.302-.261c.43.289.546.87.226 1.3l-2.5 3.75a.821.821 0 0 1-1.02.344.898.898 0 0 1-.699-.863V6.687c0-.519.454-.937.938-.937.555 0 .973.418.973.938v2.214ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockOne_default = SvgClockOne;

// src/Icon/icons/ClockRotateLeft.tsx
import { jsx as jsx511 } from "react/jsx-runtime";
var SvgClockRotateLeft = (props) => /* @__PURE__ */ jsx511(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx511(
      "path",
      {
        d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10c-2.04 0-3.938-.61-5.52-1.66a.98.98 0 0 1-.296-1.297c.32-.434.902-.55 1.336-.266A8.062 8.062 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875a8.121 8.121 0 0 0-6.848 3.75h2.16c.52 0 .938.418.938.938 0 .519-.418.937-.938.937H2.938A.936.936 0 0 1 2 8.562V4.189a.938.938 0 0 1 1.875 0v1.98A9.99 9.99 0 0 1 12 2Zm0 5c.52 0 .938.418.938.938v3.675l2.503 2.535c.399.368.399.961 0 1.293-.332.399-.925.399-1.293 0l-2.812-2.812c-.176-.14-.274-.379-.274-.629V7.937c0-.519.418-.937.938-.937Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockRotateLeft_default = SvgClockRotateLeft;

// src/Icon/icons/ClockSevenThirty.tsx
import { jsx as jsx512 } from "react/jsx-runtime";
var SvgClockSevenThirty = (props) => /* @__PURE__ */ jsx512(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx512(
      "path",
      {
        d: "m11.063 15.098-.817 1.171c-.254.43-.836.547-1.266.227-.43-.254-.546-.836-.261-1.265l2.5-3.75c.23-.344.656-.532 1.02-.38.429.122.698.485.698.899v5.313c0 .519-.417.937-.937.937a.935.935 0 0 1-.938-.938v-2.214ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10 8.125A8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockSevenThirty_default = SvgClockSevenThirty;

// src/Icon/icons/ClockSeven.tsx
import { jsx as jsx513 } from "react/jsx-runtime";
var SvgClockSeven = (props) => /* @__PURE__ */ jsx513(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx513(
      "path",
      {
        d: "M11.063 6.688c0-.52.417-.938.937-.938s.938.418.938.938V12a.76.76 0 0 1-.192.52l-2.5 3.75c-.254.43-.836.546-1.266.226-.43-.254-.546-.836-.261-1.265l2.344-3.516V6.688ZM12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM3.875 12A8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockSeven_default = SvgClockSeven;

// src/Icon/icons/ClockSixThirty.tsx
import { jsx as jsx514 } from "react/jsx-runtime";
var SvgClockSixThirty = (props) => /* @__PURE__ */ jsx514(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx514(
      "path",
      {
        d: "M12.938 17.313c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938V12c0-.52.418-.938.938-.938s.938.418.938.938v5.313ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm8.125-10A8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockSixThirty_default = SvgClockSixThirty;

// src/Icon/icons/ClockSix.tsx
import { jsx as jsx515 } from "react/jsx-runtime";
var SvgClockSix = (props) => /* @__PURE__ */ jsx515(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx515(
      "path",
      {
        d: "M12.938 16.063c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938V6.688c0-.519.418-.937.938-.937s.938.418.938.938v9.375ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockSix_default = SvgClockSix;

// src/Icon/icons/ClockTenThirty.tsx
import { jsx as jsx516 } from "react/jsx-runtime";
var SvgClockTenThirty = (props) => /* @__PURE__ */ jsx516(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx516(
      "path",
      {
        d: "M12.938 17.313c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938V12.5L7.73 10.246c-.43-.254-.546-.836-.261-1.266a.942.942 0 0 1 1.3-.261l3.75 2.5c.227.176.418.433.418.781v5.313ZM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm8.125-10A8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockTenThirty_default = SvgClockTenThirty;

// src/Icon/icons/ClockTen.tsx
import { jsx as jsx517 } from "react/jsx-runtime";
var SvgClockTen = (props) => /* @__PURE__ */ jsx517(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx517(
      "path",
      {
        d: "M11.063 6.688c0-.52.417-.938.937-.938s.938.418.938.938V12c0 .348-.192.629-.497.828a.874.874 0 0 1-.96-.082l-3.75-2.5c-.43-.254-.547-.836-.262-1.266a.942.942 0 0 1 1.3-.261l2.258 1.531.036-3.563ZM12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM3.875 12A8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockTen_default = SvgClockTen;

// src/Icon/icons/ClockThreeThirty.tsx
import { jsx as jsx518 } from "react/jsx-runtime";
var SvgClockThreeThirty = (props) => /* @__PURE__ */ jsx518(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx518(
      "path",
      {
        d: "M11.063 12c0-.52.417-.938.937-.938h4.063c.519 0 .937.418.937.938s-.418.938-.938.938h-3.125v4.374c0 .52-.417.938-.937.938a.935.935 0 0 1-.938-.938V12ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10 8.125A8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockThreeThirty_default = SvgClockThreeThirty;

// src/Icon/icons/ClockThree.tsx
import { jsx as jsx519 } from "react/jsx-runtime";
var SvgClockThree = (props) => /* @__PURE__ */ jsx519(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx519(
      "path",
      {
        d: "M11.063 6.688c0-.52.417-.938.937-.938s.938.418.938.938v4.375h3.124c.52 0 .938.417.938.937s-.418.938-.938.938H12a.935.935 0 0 1-.938-.938V6.687ZM12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM3.875 12A8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockThree_default = SvgClockThree;

// src/Icon/icons/ClockTwelveThirty.tsx
import { jsx as jsx520 } from "react/jsx-runtime";
var SvgClockTwelveThirty = (props) => /* @__PURE__ */ jsx520(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx520(
      "path",
      {
        d: "M12.938 17.313c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938V7.938c0-.519.418-.937.938-.937s.938.418.938.938v9.375ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockTwelveThirty_default = SvgClockTwelveThirty;

// src/Icon/icons/ClockTwelve.tsx
import { jsx as jsx521 } from "react/jsx-runtime";
var SvgClockTwelve = (props) => /* @__PURE__ */ jsx521(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx521(
      "path",
      {
        d: "M12.938 12c0 .52-.418.938-.938.938a.935.935 0 0 1-.938-.938V6.687c0-.519.418-.937.938-.937s.938.418.938.938V12ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockTwelve_default = SvgClockTwelve;

// src/Icon/icons/ClockTwoThirty.tsx
import { jsx as jsx522 } from "react/jsx-runtime";
var SvgClockTwoThirty = (props) => /* @__PURE__ */ jsx522(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx522(
      "path",
      {
        d: "M11.063 12c0-.348.156-.605.417-.781l3.75-2.5c.43-.285 1.012-.168 1.266.261.32.43.203 1.012-.226 1.266L12.938 12.5v4.813c0 .519-.418.937-.973.937-.485 0-.938-.418-.938-.938L11.063 12ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10 8.125A8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockTwoThirty_default = SvgClockTwoThirty;

// src/Icon/icons/ClockTwo.tsx
import { jsx as jsx523 } from "react/jsx-runtime";
var SvgClockTwo = (props) => /* @__PURE__ */ jsx523(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx523(
      "path",
      {
        d: "m12.938 10.25 2.292-1.531c.43-.285 1.012-.168 1.266.261.32.43.203 1.012-.226 1.266l-3.75 2.5a.874.874 0 0 1-.961.082c-.305-.2-.532-.48-.532-.863V6.652c0-.484.454-.937.938-.937.555 0 .973.453.973.937v3.598ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var ClockTwo_default = SvgClockTwo;

// src/Icon/icons/Clock.tsx
import { jsx as jsx524 } from "react/jsx-runtime";
var SvgClock = (props) => /* @__PURE__ */ jsx524(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx524(
      "path",
      {
        d: "M11.063 6.688c0-.52.417-.938.937-.938s.938.418.938.938V11.5l3.332 2.219c.43.289.546.87.226 1.3-.254.43-.836.547-1.265.227l-3.75-2.5c-.262-.14-.418-.434-.418-.781V6.688ZM12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM3.875 12A8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875 8.124 8.124 0 0 0 3.875 12Z",
        fill: "currentColor"
      }
    )
  })
);
var Clock_default = SvgClock;

// src/Icon/icons/Clone.tsx
import { jsx as jsx525 } from "react/jsx-runtime";
var SvgClone = (props) => /* @__PURE__ */ jsx525(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx525(
      "path",
      {
        d: "M4.5 20.125h8.75a.627.627 0 0 0 .625-.625V17h1.875v2.5c0 1.379-1.121 2.5-2.5 2.5H4.5C3.12 22 2 20.879 2 19.5v-8.75c0-1.379 1.12-2.5 2.5-2.5H7v1.875H4.5a.626.626 0 0 0-.625.625v8.75c0 .344.28.625.625.625ZM8.25 4.5c0-1.38 1.121-2.5 2.5-2.5h8.75C20.879 2 22 3.12 22 4.5v8.75c0 1.379-1.121 2.5-2.5 2.5h-8.75a2.502 2.502 0 0 1-2.5-2.5V4.5Zm2.5 9.375h8.75a.627.627 0 0 0 .625-.625V4.5a.626.626 0 0 0-.625-.625h-8.75a.626.626 0 0 0-.625.625v8.75c0 .344.281.625.625.625Z",
        fill: "currentColor"
      }
    )
  })
);
var Clone_default = SvgClone;

// src/Icon/icons/CloudArrowDown.tsx
import { jsx as jsx526 } from "react/jsx-runtime";
var SvgCloudArrowDown = (props) => /* @__PURE__ */ jsx526(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx526(
      "path",
      {
        d: "M8.969 13.753c-.29-.265-.29-.74 0-1.034.293-.29.769-.29 1.034 0l1.247 1.222V9.75c0-.416.334-.75.75-.75s.75.334.75.75v4.19l1.219-1.221c.293-.29.769-.29 1.034 0 .319.293.319.769 0 1.034l-2.5 2.5c-.265.319-.74.319-1.034 0l-2.5-2.5ZM6.5 19A4.5 4.5 0 0 1 2 14.5c0-1.96 1.252-3.653 3-4.244v-.006a5.25 5.25 0 0 1 9.228-3.428 3.749 3.749 0 0 1 5.225 4.03A4.253 4.253 0 0 1 18 18.995V19H6.5Zm3.75-12.5a3.749 3.749 0 0 0-3.75 3.75v1.066l-1.028.356A3.014 3.014 0 0 0 3.5 14.5a3 3 0 0 0 3 3h11.331l.082-.006A2.747 2.747 0 0 0 20.5 14.75a2.75 2.75 0 0 0-1.65-2.522l-1.066-.466.188-1.146a2.249 2.249 0 0 0-3.134-2.422l-1.02.453-.727-.844A3.752 3.752 0 0 0 10.22 6.5h.029Z",
        fill: "currentColor"
      }
    )
  })
);
var CloudArrowDown_default = SvgCloudArrowDown;

// src/Icon/icons/CloudArrowUp.tsx
import { jsx as jsx527 } from "react/jsx-runtime";
var SvgCloudArrowUp = (props) => /* @__PURE__ */ jsx527(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx527(
      "path",
      {
        d: "M11.469 9.469c.293-.29.769-.29 1.034 0l2.5 2.5c.319.293.319.769 0 1.034-.265.319-.74.319-1.034 0L12.75 11.81V16c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-4.19l-1.247 1.193c-.265.319-.74.319-1.034 0-.29-.265-.29-.74 0-1.034l2.5-2.5ZM6.5 19A4.5 4.5 0 0 1 2 14.5c0-1.96 1.252-3.653 3-4.244v-.006a5.25 5.25 0 0 1 9.228-3.428 3.749 3.749 0 0 1 5.225 4.03A4.253 4.253 0 0 1 18 18.995V19H6.5Zm3.75-12.5a3.749 3.749 0 0 0-3.75 3.75v1.066l-1.028.356A3.014 3.014 0 0 0 3.5 14.5a3 3 0 0 0 3 3h11.331l.082-.006A2.747 2.747 0 0 0 20.5 14.75a2.75 2.75 0 0 0-1.65-2.522l-1.066-.466.188-1.146a2.249 2.249 0 0 0-3.134-2.422l-1.02.453-.727-.844A3.752 3.752 0 0 0 10.22 6.5h.029Z",
        fill: "currentColor"
      }
    )
  })
);
var CloudArrowUp_default = SvgCloudArrowUp;

// src/Icon/icons/CloudCheck.tsx
import { jsx as jsx528 } from "react/jsx-runtime";
var SvgCloudCheck = (props) => /* @__PURE__ */ jsx528(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx528(
      "path",
      {
        d: "M11.619 15.619a.877.877 0 0 1-1.238 0l-2-2a.877.877 0 0 1 0-1.238.877.877 0 0 1 1.238 0L11 13.762l3.381-3.38a.877.877 0 0 1 1.238 0c.34.34.34.896 0 1.237l-4 4ZM6.5 19A4.5 4.5 0 0 1 2 14.5c0-1.96 1.252-3.653 3-4.244v-.006a5.25 5.25 0 0 1 9.228-3.428 3.749 3.749 0 0 1 5.225 4.03A4.253 4.253 0 0 1 18 18.995V19H6.5Zm3.75-12.5a3.749 3.749 0 0 0-3.75 3.75v1.066l-1.028.356A3.014 3.014 0 0 0 3.5 14.5a3 3 0 0 0 3 3h11.331l.082-.006A2.747 2.747 0 0 0 20.5 14.75a2.75 2.75 0 0 0-1.65-2.522l-1.066-.466.188-1.146a2.249 2.249 0 0 0-3.134-2.422l-1.02.453-.727-.844A3.752 3.752 0 0 0 10.22 6.5h.029Z",
        fill: "currentColor"
      }
    )
  })
);
var CloudCheck_default = SvgCloudCheck;

// src/Icon/icons/CloudExclamation.tsx
import { jsx as jsx529 } from "react/jsx-runtime";
var SvgCloudExclamation = (props) => /* @__PURE__ */ jsx529(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx529(
      "path",
      {
        d: "M12 9c.416 0 .75.334.75.75v3.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-3.5c0-.416.334-.75.75-.75Zm1 7a.999.999 0 1 1-2 0 .999.999 0 1 1 2 0Zm-6.5 3A4.5 4.5 0 0 1 2 14.5c0-1.96 1.252-3.653 3-4.244v-.006a5.25 5.25 0 0 1 9.228-3.428 3.749 3.749 0 0 1 5.225 4.03A4.253 4.253 0 0 1 18 18.995V19H6.5Zm3.75-12.5a3.749 3.749 0 0 0-3.75 3.75v1.066l-1.028.356A3.014 3.014 0 0 0 3.5 14.5a3 3 0 0 0 3 3h11.331l.082-.006A2.747 2.747 0 0 0 20.5 14.75a2.75 2.75 0 0 0-1.65-2.522l-1.066-.466.188-1.146a2.249 2.249 0 0 0-3.134-2.422l-1.02.453-.727-.844A3.752 3.752 0 0 0 10.22 6.5h.029Z",
        fill: "currentColor"
      }
    )
  })
);
var CloudExclamation_default = SvgCloudExclamation;

// src/Icon/icons/CloudLock.tsx
import { jsx as jsx530 } from "react/jsx-runtime";
var SvgCloudLock = (props) => /* @__PURE__ */ jsx530(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx530(
      "path",
      {
        d: "M17.617 18.516H6.86c-2.671 0-4.68-1.93-4.68-4.227 0-1.906 1.102-3.484 2.868-3.766.039-2.187 2.133-3.648 4.055-3.085.937-1.368 2.445-2.5 4.562-2.5 3.195 0 5.703 2.515 5.688 6 1.523.64 2.468 2.062 2.468 3.703 0 2.148-1.843 3.875-4.203 3.875Zm0-1.258c1.664 0 2.945-1.164 2.945-2.617 0-1.414-.914-2.454-2.335-2.766-.094-.023-.133-.078-.125-.18.03-.367.054-.789.03-1.148-.132-2.32-1.905-4.352-4.468-4.352-2.023 0-3.187 1.11-3.945 2.461-.047.086-.102.11-.196.078-1.601-.523-3.335.188-3.335 2.594 0 .102-.04.156-.149.156-1.656 0-2.601 1.243-2.601 2.805 0 1.594 1.453 2.969 3.421 2.969h10.758ZM9.47 15.125v-2.79c0-.483.203-.733.617-.757v-.828c0-1.29.773-2.156 1.922-2.156 1.14 0 1.914.867 1.914 2.156v.828c.414.024.617.274.617.758v2.789c0 .531-.234.773-.719.773h-3.633c-.484 0-.718-.242-.718-.773Zm1.351-3.555h2.367v-.898c0-.82-.476-1.367-1.18-1.367-.71 0-1.187.547-1.187 1.367v.898Z",
        fill: "currentColor"
      }
    )
  })
);
var CloudLock_default = SvgCloudLock;

// src/Icon/icons/CloudMinus.tsx
import { jsx as jsx531 } from "react/jsx-runtime";
var SvgCloudMinus = (props) => /* @__PURE__ */ jsx531(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx531(
      "path",
      {
        d: "M14.75 12.25c.416 0 .75.334.75.75s-.334.75-.75.75h-5.5A.748.748 0 0 1 8.5 13c0-.416.334-.75.75-.75h5.5ZM6.5 19A4.5 4.5 0 0 1 2 14.5c0-1.96 1.252-3.653 3-4.244v-.006a5.25 5.25 0 0 1 9.228-3.428 3.749 3.749 0 0 1 5.225 4.03A4.253 4.253 0 0 1 18 18.995V19H6.5Zm3.75-12.5a3.749 3.749 0 0 0-3.75 3.75v1.066l-1.028.356A3.014 3.014 0 0 0 3.5 14.5a3 3 0 0 0 3 3h11.331l.082-.006A2.747 2.747 0 0 0 20.5 14.75a2.75 2.75 0 0 0-1.65-2.522l-1.066-.466.188-1.146a2.249 2.249 0 0 0-3.134-2.422l-1.02.453-.727-.844A3.752 3.752 0 0 0 10.22 6.5h.029Z",
        fill: "currentColor"
      }
    )
  })
);
var CloudMinus_default = SvgCloudMinus;

// src/Icon/icons/CloudPlus.tsx
import { jsx as jsx532 } from "react/jsx-runtime";
var SvgCloudPlus = (props) => /* @__PURE__ */ jsx532(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx532(
      "path",
      {
        d: "M11.25 15.75v-2h-2A.748.748 0 0 1 8.5 13c0-.416.334-.75.75-.75h2v-2c0-.416.334-.75.75-.75s.75.334.75.75v2h2c.416 0 .75.334.75.75s-.334.75-.75.75h-2v2c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75ZM6.5 19A4.5 4.5 0 0 1 2 14.5c0-1.96 1.252-3.653 3-4.244v-.006a5.25 5.25 0 0 1 9.228-3.428 3.749 3.749 0 0 1 5.225 4.03A4.253 4.253 0 0 1 18 18.995V19H6.5Zm3.75-12.5a3.749 3.749 0 0 0-3.75 3.75v1.066l-1.028.356A3.014 3.014 0 0 0 3.5 14.5a3 3 0 0 0 3 3h11.331l.082-.006A2.747 2.747 0 0 0 20.5 14.75a2.75 2.75 0 0 0-1.65-2.522l-1.066-.466.188-1.146a2.249 2.249 0 0 0-3.134-2.422l-1.02.453-.727-.844A3.752 3.752 0 0 0 10.22 6.5h.029Z",
        fill: "currentColor"
      }
    )
  })
);
var CloudPlus_default = SvgCloudPlus;

// src/Icon/icons/CloudSlash.tsx
import { jsx as jsx533 } from "react/jsx-runtime";
var SvgCloudSlash = (props) => /* @__PURE__ */ jsx533(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx533(
      "path",
      {
        d: "M3.213 4.16a.75.75 0 0 0-.925 1.18l18.5 14.5a.75.75 0 0 0 .924-1.18l-1.043-.82a4.253 4.253 0 0 0-1.216-6.987 3.749 3.749 0 0 0-5.225-4.031A5.244 5.244 0 0 0 10.25 5c-1.516 0-2.878.64-3.837 1.669l-3.2-2.51ZM7.6 7.596A3.736 3.736 0 0 1 10.25 6.5a3.74 3.74 0 0 1 2.84 1.303c.432.5 1.141.66 1.748.39a2.249 2.249 0 0 1 3.134 2.422c-.11.676.253 1.341.878 1.616a2.75 2.75 0 0 1 .616 4.669L7.6 7.597ZM17.231 19l-1.903-1.5H6.5a3 3 0 0 1-1-5.828c.513-.181.881-.622.975-1.144l-1.41-1.112c-.043.272-.065.55-.065.834v.006A4.501 4.501 0 0 0 6.5 19h10.731Z",
        fill: "currentColor"
      }
    )
  })
);
var CloudSlash_default = SvgCloudSlash;

// src/Icon/icons/CloudXmark.tsx
import { jsx as jsx534 } from "react/jsx-runtime";
var SvgCloudXmark = (props) => /* @__PURE__ */ jsx534(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx534(
      "path",
      {
        d: "M9.469 10.469c.293-.29.769-.29 1.034 0l1.469 1.472 1.497-1.472c.293-.29.769-.29 1.034 0 .319.293.319.769 0 1.034l-1.444 1.469 1.444 1.497c.319.293.319.769 0 1.034-.265.319-.74.319-1.034 0l-1.497-1.444-1.469 1.444c-.265.319-.74.319-1.034 0-.29-.265-.29-.74 0-1.034l1.472-1.497-1.472-1.469c-.29-.265-.29-.74 0-1.034ZM6.5 19A4.5 4.5 0 0 1 2 14.5c0-1.96 1.252-3.653 3-4.244v-.006a5.25 5.25 0 0 1 9.228-3.428 3.749 3.749 0 0 1 5.225 4.03A4.253 4.253 0 0 1 18 18.995V19H6.5Zm3.75-12.5a3.749 3.749 0 0 0-3.75 3.75v1.066l-1.028.356A3.014 3.014 0 0 0 3.5 14.5a3 3 0 0 0 3 3h11.331l.082-.006A2.747 2.747 0 0 0 20.5 14.75a2.75 2.75 0 0 0-1.65-2.522l-1.066-.466.188-1.146a2.249 2.249 0 0 0-3.134-2.422l-1.02.453-.727-.844A3.752 3.752 0 0 0 10.22 6.5h.029Z",
        fill: "currentColor"
      }
    )
  })
);
var CloudXmark_default = SvgCloudXmark;

// src/Icon/icons/Cloud.tsx
import { jsx as jsx535 } from "react/jsx-runtime";
var SvgCloud = (props) => /* @__PURE__ */ jsx535(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx535(
      "path",
      {
        d: "M18 18.994V19H6.5A4.5 4.5 0 0 1 2 14.5c0-1.96 1.252-3.653 3-4.244v-.006a5.25 5.25 0 0 1 9.228-3.428 3.749 3.749 0 0 1 5.225 4.03A4.253 4.253 0 0 1 18 18.995ZM13.819 8.647l-.728-.844A3.737 3.737 0 0 0 10.25 6.5c-2.072 0-3.75 1.678-3.75 3.722v1.094l-1.028.353A3.021 3.021 0 0 0 3.5 14.5a3 3 0 0 0 3 3h11.331l.082-.006A2.747 2.747 0 0 0 20.5 14.75a2.75 2.75 0 0 0-1.65-2.522l-1.066-.466.188-1.146a2.249 2.249 0 0 0-3.134-2.422l-1.02.453Z",
        fill: "currentColor"
      }
    )
  })
);
var Cloud_default = SvgCloud;

// src/Icon/icons/CodeBranch.tsx
import { jsx as jsx536 } from "react/jsx-runtime";
var SvgCodeBranch = (props) => /* @__PURE__ */ jsx536(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx536(
      "path",
      {
        d: "M9.5 5.125a3.123 3.123 0 0 1-2.188 2.98v3.86a4.794 4.794 0 0 1 2.813-.902h3.75a2.81 2.81 0 0 0 2.813-2.813v-.145A3.123 3.123 0 0 1 17.625 2a3.125 3.125 0 0 1 .938 6.105v.145a4.686 4.686 0 0 1-4.688 4.688h-3.75a2.81 2.81 0 0 0-2.813 2.812v.145A3.124 3.124 0 0 1 6.375 22a3.125 3.125 0 0 1-.938-6.105v-7.79A3.125 3.125 0 1 1 9.5 5.125Zm-3.125 1.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm11.25-2.5a1.25 1.25 0 1 0-.001 2.499 1.25 1.25 0 0 0 .001-2.499Zm-11.25 16.25a1.25 1.25 0 1 0 .001-2.499 1.25 1.25 0 0 0-.001 2.499Z",
        fill: "currentColor"
      }
    )
  })
);
var CodeBranch_default = SvgCodeBranch;

// src/Icon/icons/CodeSimple.tsx
import { jsx as jsx537 } from "react/jsx-runtime";
var SvgCodeSimple = (props) => /* @__PURE__ */ jsx537(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx537(
      "path",
      {
        d: "m4.04 12 5.48 5.229c.334.32.345.816.029 1.18a.837.837 0 0 1-1.18.028l-6.111-5.833a.838.838 0 0 1 0-1.208l6.11-5.832a.836.836 0 0 1 1.18.027.836.836 0 0 1-.027 1.18L4.04 12Zm10.44-5.23a.836.836 0 0 1-.029-1.179c.32-.333.816-.345 1.18-.027l6.112 5.832c.163.16.257.374.257.604 0 .229-.094.444-.257.604l-6.111 5.833c-.365.316-.861.306-1.18-.028-.317-.364-.306-.86.027-1.18l5.48-5.23-5.48-5.229Z",
        fill: "currentColor"
      }
    )
  })
);
var CodeSimple_default = SvgCodeSimple;

// src/Icon/icons/Code.tsx
import { jsx as jsx538 } from "react/jsx-runtime";
var SvgCode = (props) => /* @__PURE__ */ jsx538(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx538(
      "path",
      {
        d: "m14.966 4.973-4.5 14.5c-.15.396-.544.615-.938.493-.397-.15-.619-.544-.494-.937l4.5-14.5a.75.75 0 1 1 1.432.444Zm2.796 2.73 4 3.75c.154.141.238.341.238.52a.806.806 0 0 1-.238.574l-4 3.75a.747.747 0 0 1-1.059-.034.747.747 0 0 1 .035-1.06l3.415-3.23-3.415-3.176a.747.747 0 0 1-.035-1.059.747.747 0 0 1 1.06-.034Zm-10.5 1.094-3.415 3.175 3.416 3.232a.747.747 0 0 1 .034 1.059.747.747 0 0 1-1.06.034l-4-3.75c-.151-.168-.237-.34-.237-.575 0-.178.086-.378.237-.518l4-3.75a.747.747 0 0 1 1.06.034.747.747 0 0 1-.034 1.06Z",
        fill: "currentColor"
      }
    )
  })
);
var Code_default = SvgCode;

// src/Icon/icons/Columns3.tsx
import { jsx as jsx539 } from "react/jsx-runtime";
var SvgColumns3 = (props) => /* @__PURE__ */ jsx539(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx539(
      "path",
      {
        d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10c0 1.103-.897 2-2 2H4a2 2 0 0 1-2-2V7Zm14 10.5h4c.275 0 .5-.225.5-.5V7a.5.5 0 0 0-.5-.5h-4v11Zm-1.5-11h-5v11h5v-11ZM8 17.5v-11H4a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4Z",
        fill: "currentColor"
      }
    )
  })
);
var Columns3_default = SvgColumns3;

// src/Icon/icons/Command.tsx
import { jsx as jsx540 } from "react/jsx-runtime";
var SvgCommand = (props) => /* @__PURE__ */ jsx540(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx540(
      "path",
      {
        d: "M17.714 13.429h-2.143V10.57h2.143a4.286 4.286 0 1 0-4.285-4.285v2.143H10.57V6.286a4.286 4.286 0 1 0-4.285 4.285h2.143v2.858H6.286a4.286 4.286 0 1 0 4.285 4.285v-2.143h2.858v2.143a4.286 4.286 0 1 0 4.285-4.285Zm-2.143-7.143c0-1.182.962-2.143 2.143-2.143 1.182 0 2.143.961 2.143 2.143 0 1.181-.96 2.143-2.143 2.143h-2.143V6.286ZM8.43 17.714a2.145 2.145 0 0 1-2.143 2.143 2.144 2.144 0 0 1-2.143-2.143c0-1.183.961-2.143 2.143-2.143h2.143v2.143Zm0-9.285H6.286a2.144 2.144 0 0 1-2.143-2.143c0-1.183.961-2.143 2.143-2.143 1.181 0 2.143.96 2.143 2.143v2.143Zm5 5H10.57V10.57h2.858v2.858Zm4.285 6.428a2.145 2.145 0 0 1-2.143-2.143v-2.143h2.143c1.182 0 2.143.962 2.143 2.143 0 1.182-.96 2.143-2.143 2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var Command_default = SvgCommand;

// src/Icon/icons/CommentsQuestion.tsx
import { jsx as jsx541 } from "react/jsx-runtime";
var SvgCommentsQuestion = (props) => /* @__PURE__ */ jsx541(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx541(
      "path",
      {
        d: "M7.972 6.75h.96c.815 0 1.48.666 1.48 1.481a1.45 1.45 0 0 1-.846 1.325l-.594.297V10c0 .275-.197.5-.5.5a.52.52 0 0 1-.5-.5v-.456c0-.19.134-.363.303-.447l.872-.434a.48.48 0 0 0-.216-.913h-.96a.383.383 0 0 0-.383.381c0 .278-.222.5-.5.5a.482.482 0 0 1-.5-.5c0-.762.621-1.381 1.384-1.381Zm-.125 4.75a.61.61 0 0 1 .625-.625c.372 0 .625.253.625.625a.61.61 0 0 1-.625.625.627.627 0 0 1-.625-.625ZM8.5 15c-.584 0-1.15-.072-1.69-.194C5.852 15.4 4.472 16 2.78 16a.777.777 0 0 1-.717-.472.785.785 0 0 1 .148-.844 8.722 8.722 0 0 0 1.218-1.75C2.537 11.994 2 10.8 2 9.5 2 6.463 4.91 4 8.5 4S15 6.463 15 9.5 12.09 15 8.5 15Zm5-5.5c0-2.206-2.244-4-5-4s-5 1.794-5 4c0 1.1.553 1.912 1.018 2.403l.735.778-.493.947c-.112.188-.237.431-.368.638a5.779 5.779 0 0 0 1.63-.763l.522-.297.6.11c.456.13.912.184 1.328.184 2.784 0 5.028-1.794 5.028-4Zm2.5.019V9.5c0-.516-.069-1.016-.2-1.494 3.45.131 6.2 2.54 6.2 5.494 0 1.3-.538 2.494-1.428 3.434.51.985 1.2 1.738 1.219 1.75.209.225.268.557.118.844-.093.288-.378.472-.69.472-1.69 0-3.072-.6-4.028-1.194A7.677 7.677 0 0 1 15.5 19c-2.563 0-4.778-1.256-5.838-3.078a8.099 8.099 0 0 0 1.554-.363c.875 1.163 2.468 1.941 4.284 1.941.444 0 .9-.053 1.356-.184l.6-.11.522.297a5.752 5.752 0 0 0 1.631.763c-.13-.207-.256-.45-.368-.638l-.494-.947.734-.778c.466-.487 1.019-1.303 1.019-2.403 0-2.072-1.978-3.778-4.528-3.981H16Z",
        fill: "currentColor"
      }
    )
  })
);
var CommentsQuestion_default = SvgCommentsQuestion;

// src/Icon/icons/Comments.tsx
import { jsx as jsx542 } from "react/jsx-runtime";
var SvgComments = (props) => /* @__PURE__ */ jsx542(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx542(
      "path",
      {
        d: "M8.5 4C12.09 4 15 6.463 15 9.5S12.09 15 8.5 15c-.584 0-1.15-.072-1.69-.194C5.852 15.4 4.472 16 2.78 16a.777.777 0 0 1-.717-.472.785.785 0 0 1 .148-.844 8.722 8.722 0 0 0 1.218-1.75C2.537 11.994 2 10.8 2 9.5 2 6.463 4.91 4 8.5 4Zm-1.356 9.316c.456.13.912.184 1.356.184 2.756 0 5-1.794 5-4s-2.244-4-5-4-5 1.794-5 4c0 1.1.553 1.912 1.018 2.403l.735.778-.493.947c-.112.188-.237.431-.368.638a5.779 5.779 0 0 0 1.63-.763l.522-.297.6.11Zm8.656-5.31c3.45.131 6.2 2.54 6.2 5.494 0 1.3-.538 2.494-1.428 3.434.51.985 1.2 1.738 1.219 1.75.209.225.268.557.118.844-.093.288-.378.472-.69.472-1.69 0-3.072-.6-4.028-1.194A7.677 7.677 0 0 1 15.5 19c-2.563 0-4.778-1.256-5.838-3.078a8.099 8.099 0 0 0 1.554-.363c.875 1.163 2.468 1.941 4.284 1.941.444 0 .9-.053 1.356-.184l.6-.11.522.297a5.752 5.752 0 0 0 1.631.763c-.13-.207-.256-.45-.368-.638l-.494-.947.734-.778c.466-.487 1.019-1.303 1.019-2.403 0-2.072-1.978-3.778-4.528-3.981L16 9.5c0-.516-.069-1.016-.2-1.494Z",
        fill: "currentColor"
      }
    )
  })
);
var Comments_default = SvgComments;

// src/Icon/icons/CompressWide.tsx
import { jsx as jsx543 } from "react/jsx-runtime";
var SvgCompressWide = (props) => /* @__PURE__ */ jsx543(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx543(
      "path",
      {
        d: "M16.688 10.75h4.375a.937.937 0 0 0 0-1.875h-3.438V5.437a.936.936 0 1 0-1.875 0v4.375c0 .52.418.938.938.938Zm-9.375 2.5H2.938a.937.937 0 1 0 0 1.875h3.437v3.438c0 .519.418.937.938.937.519 0 .937-.418.937-.938v-4.375a.935.935 0 0 0-.938-.937Zm13.75 0h-4.375a.935.935 0 0 0-.938.938v4.374a.938.938 0 0 0 1.875 0v-3.437h3.438a.938.938 0 0 0 0-1.875ZM7.313 4.5c-.52 0-.938.42-.938.938v3.437H2.937a.936.936 0 1 0 0 1.875h4.376c.519 0 .937-.418.937-.938V5.439a.936.936 0 0 0-.938-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var CompressWide_default = SvgCompressWide;

// src/Icon/icons/Compress.tsx
import { jsx as jsx544 } from "react/jsx-runtime";
var SvgCompress = (props) => /* @__PURE__ */ jsx544(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx544(
      "path",
      {
        d: "M8.071 14.857h-5a1.07 1.07 0 1 0 0 2.143H7v3.929C7 21.522 7.478 22 8.071 22c.594 0 1.072-.478 1.072-1.071v-5c0-.594-.478-1.072-1.072-1.072Zm7.858-5.714h5a1.071 1.071 0 0 0 0-2.143H17V3.071A1.07 1.07 0 0 0 15.929 2a1.07 1.07 0 0 0-1.072 1.071v5c0 .594.478 1.072 1.072 1.072ZM8.07 2A1.07 1.07 0 0 0 7 3.071V7H3.071a1.07 1.07 0 1 0 0 2.143h5c.594 0 1.072-.478 1.072-1.072v-5A1.07 1.07 0 0 0 8.07 2ZM20.93 14.857h-5c-.594 0-1.072.478-1.072 1.072v5a1.072 1.072 0 0 0 2.143 0V17h3.929a1.072 1.072 0 0 0 0-2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var Compress_default = SvgCompress;

// src/Icon/icons/ComputerSpeaker.tsx
import { jsx as jsx545 } from "react/jsx-runtime";
var SvgComputerSpeaker = (props) => /* @__PURE__ */ jsx545(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx545(
      "path",
      {
        d: "M20 5h-6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm.5 12a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v10ZM2 7v7a2 2 0 0 0 2 2h7v-1.5H4a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h7.05a3.167 3.167 0 0 1 .703-1.5H4a2 2 0 0 0-2 2Zm3.75 10.5a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h6.003a2.976 2.976 0 0 1-.73-1.5H5.75Zm11.222-6a2.5 2.5 0 0 0 0 5c1.38 0 2.472-1.12 2.472-2.5.028-1.381-1.063-2.5-2.472-2.5Zm0 3.5c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.422 1-1 1ZM17 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
        fill: "currentColor"
      }
    )
  })
);
var ComputerSpeaker_default = SvgComputerSpeaker;

// src/Icon/icons/Computer.tsx
import { jsx as jsx546 } from "react/jsx-runtime";
var SvgComputer = (props) => /* @__PURE__ */ jsx546(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx546(
      "path",
      {
        d: "M2 14V7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7c0 1.103-.897 2-2 2h-2.71l.5 1.5h1.46c.416 0 .75.334.75.75s-.334.75-.75.75h-8.5a.75.75 0 1 1 0-1.5h1.46l.5-1.5H4a2 2 0 0 1-2-2Zm12-7.5H4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10c.275 0 .5-.225.5-.5V7a.5.5 0 0 0-.5-.5Zm-3.79 11-.5-1.5H8.29l-.5 1.5h2.42ZM17 6.5A1.5 1.5 0 0 1 18.5 5h2A1.5 1.5 0 0 1 22 6.5v11a1.5 1.5 0 0 1-1.5 1.5h-2a1.5 1.5 0 0 1-1.5-1.5v-11Zm1.5 1h2v-1h-2v1Zm0 1.5v1h2V9h-2Zm1 4.5c.553 0 1 .447 1 1v-3h-2v3c0-.553.447-1 1-1Zm-1 4h2v-3a.999.999 0 1 1-2 0v3Z",
        fill: "currentColor"
      }
    )
  })
);
var Computer_default = SvgComputer;

// src/Icon/icons/ContainerStorage.tsx
import { jsx as jsx547 } from "react/jsx-runtime";
var SvgContainerStorage = (props) => /* @__PURE__ */ jsx547(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx547(
      "path",
      {
        d: "M21.25 17.5H21v-11h.25a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0 0 1.5H3v11h-.25a.751.751 0 0 0 0 1.5h18.5a.75.75 0 0 0 0-1.5Zm-1.75 0h-15v-11h15v11ZM8 16.5a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 0-1.5 0v7.5c0 .416.338.75.75.75Zm4 0a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 0-1.5 0v7.5c0 .416.338.75.75.75Zm4 0a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 0-1.5 0v7.5c0 .416.338.75.75.75Z",
        fill: "currentColor"
      }
    )
  })
);
var ContainerStorage_default = SvgContainerStorage;

// src/Icon/icons/ConveyorBeltBoxes.tsx
import { jsx as jsx548 } from "react/jsx-runtime";
var SvgConveyorBeltBoxes = (props) => /* @__PURE__ */ jsx548(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx548(
      "path",
      {
        d: "M6 15.5c-.555 0-1 .445-1 1 0 .555.445 1 1 1 .555 0 1-.445 1-1 0-.555-.444-1-1-1ZM7 12h4.5c.476 0 .907-.173 1.25-.45.316.278.775.45 1.25.45h3a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3c-.174 0-.34.03-.5.07V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v4c0 1.103.897 2 2 2Zm6.5-4a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V8Zm-7-2a.5.5 0 0 1 .5-.5h4.5c.275 0 .5.224.5.5v4a.5.5 0 0 1-.5.5H7a.501.501 0 0 1-.5-.5V6ZM18 15.5c-.555 0-1 .445-1 1 0 .555.445 1 1 1 .555 0 1-.445 1-1 0-.555-.444-1-1-1Zm-6 0c-.555 0-1 .445-1 1 0 .555.445 1 1 1 .555 0 1-.445 1-1 0-.555-.444-1-1-1Zm6.5-2.5h-13A3.499 3.499 0 0 0 2 16.5C2 18.434 3.567 20 5.5 20h13a3.5 3.5 0 1 0 0-7Zm0 5.5h-13c-1.103 0-2-.897-2-2s.897-2 2-2h13c1.103 0 2 .897 2 2s-.897 2-2 2Z",
        fill: "currentColor"
      }
    )
  })
);
var ConveyorBeltBoxes_default = SvgConveyorBeltBoxes;

// src/Icon/icons/ConveyorBeltEmpty.tsx
import { jsx as jsx549 } from "react/jsx-runtime";
var SvgConveyorBeltEmpty = (props) => /* @__PURE__ */ jsx549(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx549(
      "path",
      {
        d: "M6 11c-.555 0-1 .445-1 1 0 .555.445 1 1 1 .555 0 1-.445 1-1 0-.555-.444-1-1-1Zm12 0c-.555 0-1 .445-1 1 0 .555.445 1 1 1 .555 0 1-.445 1-1 0-.555-.444-1-1-1Zm-6 0c-.555 0-1 .445-1 1 0 .555.445 1 1 1 .555 0 1-.445 1-1 0-.555-.444-1-1-1Zm6.5-2.5h-13A3.499 3.499 0 0 0 2 12c0 1.934 1.567 3.5 3.5 3.5h13a3.5 3.5 0 1 0 0-7Zm0 5.5h-13c-1.103 0-2-.897-2-2s.897-2 2-2h13c1.103 0 2 .897 2 2s-.897 2-2 2Z",
        fill: "currentColor"
      }
    )
  })
);
var ConveyorBeltEmpty_default = SvgConveyorBeltEmpty;

// src/Icon/icons/ConveyorBelt.tsx
import { jsx as jsx550 } from "react/jsx-runtime";
var SvgConveyorBelt = (props) => /* @__PURE__ */ jsx550(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx550(
      "path",
      {
        d: "M6 15.5c-.555 0-1 .445-1 1 0 .555.445 1 1 1 .555 0 1-.445 1-1 0-.555-.444-1-1-1ZM18.5 13h-13A3.499 3.499 0 0 0 2 16.5C2 18.434 3.567 20 5.5 20h13a3.5 3.5 0 1 0 0-7Zm-.028 5.5h-13c-1.075 0-1.972-.897-1.972-2s.897-2 2-2h13c1.103 0 2 .897 2 2s-.897 2-2.028 2Zm-.472-3c-.555 0-1 .445-1 1 0 .555.445 1 1 1 .555 0 1-.445 1-1 0-.555-.444-1-1-1Zm-6.028 0c-.528 0-.972.447-.972 1 0 .553.445 1 1 1 .555 0 1-.445 1-1 0-.555-.447-1-1.028-1ZM8 12h8a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v4c0 1.103.897 2 2 2Zm-.5-6a.5.5 0 0 1 .5-.5h2V8l2-1 2 1V5.5h2a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H8a.501.501 0 0 1-.5-.5V6Z",
        fill: "currentColor"
      }
    )
  })
);
var ConveyorBelt_default = SvgConveyorBelt;

// src/Icon/icons/Cookie.tsx
import { jsx as jsx551 } from "react/jsx-runtime";
var SvgCookie = (props) => /* @__PURE__ */ jsx551(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx551(
      "path",
      {
        d: "M15.749 14.5c-.688 0-1.25.561-1.25 1.25 0 .688.562 1.25 1.25 1.25s1.25-.562 1.25-1.25c0-.689-.563-1.25-1.25-1.25Zm-1.25-6.25c.688 0 1.25-.561 1.25-1.25 0-.688-.562-1.25-1.25-1.25s-1.25.562-1.25 1.25c0 .689.563 1.25 1.25 1.25Zm-5 1.25c0-.688-.561-1.25-1.25-1.25C7.562 8.25 7 8.812 7 9.5s.562 1.25 1.25 1.25c.689 0 1.25-.562 1.25-1.25Zm0 5c-.688 0-1.25.561-1.25 1.25 0 .688.562 1.25 1.25 1.25.689 0 1.25-.562 1.25-1.25 0-.689-.562-1.25-1.25-1.25Zm3.75-3.75c-.688 0-1.25.562-1.25 1.25s.562 1.25 1.25 1.25 1.25-.562 1.25-1.25-.562-1.25-1.25-1.25Zm8.687 1.203-.474-2.978a5.17 5.17 0 0 0-1.45-2.847L17.874 3.99a5.153 5.153 0 0 0-2.842-1.45l-2.993-.474a5.136 5.136 0 0 0-3.145.496L6.195 3.94a5.171 5.171 0 0 0-2.262 2.257l-1.367 2.69a5.168 5.168 0 0 0-.502 3.16l.473 2.98a5.169 5.169 0 0 0 1.45 2.846l2.139 2.138a5.153 5.153 0 0 0 2.841 1.45l2.993.474a5.143 5.143 0 0 0 3.143-.496l2.7-1.377a5.175 5.175 0 0 0 2.262-2.256l1.367-2.69c.5-.975.676-2.08.504-3.162Zm-2.172 2.312-1.372 2.69a3.264 3.264 0 0 1-1.435 1.436l-2.7 1.377a3.278 3.278 0 0 1-2.005.317l-2.993-.473a3.29 3.29 0 0 1-1.806-.925L5.31 16.55a3.28 3.28 0 0 1-.923-1.816l-.473-2.976c-.107-.693 0-1.392.322-2.022l1.372-2.69c.317-.624.81-1.12 1.435-1.437l2.7-1.377a3.28 3.28 0 0 1 2.003-.317l2.993.473c.69.113 1.315.43 1.81.923l2.14 2.139a3.28 3.28 0 0 1 .922 1.816l.473 2.978c.11.693 0 1.393-.32 2.021Z",
        fill: "currentColor"
      }
    )
  })
);
var Cookie_default = SvgCookie;

// src/Icon/icons/Copy.tsx
import { jsx as jsx552 } from "react/jsx-runtime";
var SvgCopy = (props) => /* @__PURE__ */ jsx552(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx552(
      "path",
      {
        d: "M21.633 4.76 19.24 2.366A1.247 1.247 0 0 0 18.356 2h-6.391a2.5 2.5 0 0 0-2.5 2.5v10C9.5 15.883 10.622 17 12 17h7.5c1.375 0 2.5-1.125 2.5-2.5V5.643c0-.331-.133-.65-.367-.884Zm-1.508 9.74c0 .345-.28.625-.625.625h-7.535a.625.625 0 0 1-.625-.625V4.505c0-.345.28-.625.625-.625h5L17 5.75c0 .69.56 1.25 1.25 1.25h1.84v7.5h.035Zm-7.5 5c0 .345-.28.625-.625.625H4.465a.625.625 0 0 1-.625-.625l.035-9.996c0-.345.28-.625.625-.625h3.75V7H4.5A2.5 2.5 0 0 0 2 9.5v10C2 20.879 3.12 22 4.5 22H12c1.375 0 2.5-1.125 2.5-2.5v-1.25h-1.84l-.035 1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var Copy_default = SvgCopy;

// src/Icon/icons/Copyright.tsx
import { jsx as jsx553 } from "react/jsx-runtime";
var SvgCopyright = (props) => /* @__PURE__ */ jsx553(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx553(
      "path",
      {
        d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Zm-.035-11.25a3.05 3.05 0 0 1 2.18.913.94.94 0 0 0 1.328.006.94.94 0 0 0 .006-1.327A4.914 4.914 0 0 0 11.965 7s.001 0 0 0a4.916 4.916 0 0 0-3.514 1.467 5.033 5.033 0 0 0 0 7.067A4.915 4.915 0 0 0 11.965 17c.001 0 0 0 0 0a4.914 4.914 0 0 0 3.514-1.467.94.94 0 0 0-.006-1.327.941.941 0 0 0-1.327.006 3.052 3.052 0 0 1-2.181.913s.001 0 0 0c-.824 0-1.6-.324-2.183-.913a3.154 3.154 0 0 1 0-4.426 3.06 3.06 0 0 1 2.183-.912Z",
        fill: "currentColor"
      }
    )
  })
);
var Copyright_default = SvgCopyright;

// src/Icon/icons/CreditCardBlank.tsx
import { jsx as jsx554 } from "react/jsx-runtime";
var SvgCreditCardBlank = (props) => /* @__PURE__ */ jsx554(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx554(
      "path",
      {
        d: "M5.333 15.611c0-.462.372-.833.834-.833h1.666c.462 0 .834.371.834.833a.831.831 0 0 1-.834.833H6.167a.831.831 0 0 1-.834-.833Zm4.445 0c0-.462.371-.833.833-.833H14.5c.462 0 .833.371.833.833a.831.831 0 0 1-.833.833h-3.889a.831.831 0 0 1-.833-.833ZM2 6.444c0-1.227.995-2.222 2.222-2.222h15.556c1.226 0 2.222.995 2.222 2.222v11.111a2.224 2.224 0 0 1-2.222 2.223H4.222A2.223 2.223 0 0 1 2 17.555V6.445Zm1.667 0v11.111c0 .306.248.556.555.556h15.556c.305 0 .555-.25.555-.556V6.445a.556.556 0 0 0-.555-.556H4.222a.555.555 0 0 0-.555.555Z",
        fill: "currentColor"
      }
    )
  })
);
var CreditCardBlank_default = SvgCreditCardBlank;

// src/Icon/icons/CreditCardFront.tsx
import { jsx as jsx555 } from "react/jsx-runtime";
var SvgCreditCardFront = (props) => /* @__PURE__ */ jsx555(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx555(
      "path",
      {
        d: "M5.333 15.611c0-.462.372-.833.834-.833h1.666c.462 0 .834.371.834.833a.831.831 0 0 1-.834.833H6.167a.831.831 0 0 1-.834-.833Zm4.445 0c0-.462.371-.833.833-.833H14.5c.462 0 .833.371.833.833a.831.831 0 0 1-.833.833h-3.889a.831.831 0 0 1-.833-.833Zm-4.445-2.778c0-.462.372-.833.834-.833h11.666c.462 0 .834.371.834.833a.831.831 0 0 1-.834.834H6.167a.831.831 0 0 1-.834-.834Zm12.5-5.277c.462 0 .834.371.834.833v1.667a.831.831 0 0 1-.834.833h-2.777a.831.831 0 0 1-.834-.833V8.389c0-.462.372-.833.834-.833h2.777ZM2 6.444c0-1.227.995-2.222 2.222-2.222h15.556c1.226 0 2.222.995 2.222 2.222v11.111a2.224 2.224 0 0 1-2.222 2.223H4.222A2.223 2.223 0 0 1 2 17.555V6.445Zm1.667 0v11.111c0 .306.248.556.555.556h15.556c.305 0 .555-.25.555-.556V6.445a.556.556 0 0 0-.555-.556H4.222a.555.555 0 0 0-.555.555Z",
        fill: "currentColor"
      }
    )
  })
);
var CreditCardFront_default = SvgCreditCardFront;

// src/Icon/icons/CreditCard.tsx
import { jsx as jsx556 } from "react/jsx-runtime";
var SvgCreditCard = (props) => /* @__PURE__ */ jsx556(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx556(
      "path",
      {
        d: "M7.833 14.778c.462 0 .834.371.834.833a.831.831 0 0 1-.834.833H6.167a.831.831 0 0 1-.834-.833c0-.462.372-.833.834-.833h1.666Zm6.667 0c.462 0 .833.371.833.833a.831.831 0 0 1-.833.833h-3.889a.831.831 0 0 1-.833-.833c0-.462.371-.833.833-.833H14.5Zm5.278-10.556c1.226 0 2.222.995 2.222 2.222v11.111a2.224 2.224 0 0 1-2.222 2.223H4.222A2.223 2.223 0 0 1 2 17.555V6.445c0-1.228.995-2.223 2.222-2.223h15.556Zm0 1.667H4.222a.555.555 0 0 0-.555.555v1.112h16.666V6.444a.556.556 0 0 0-.555-.555Zm.555 5H3.667v6.666c0 .306.248.556.555.556h15.556c.305 0 .555-.25.555-.556V10.89Z",
        fill: "currentColor"
      }
    )
  })
);
var CreditCard_default = SvgCreditCard;

// src/Icon/icons/CropSimple.tsx
import { jsx as jsx557 } from "react/jsx-runtime";
var SvgCropSimple = (props) => /* @__PURE__ */ jsx557(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx557(
      "path",
      {
        d: "M7 16.688c0 .171.14.312.313.312h8.437v1.875H7.312a2.189 2.189 0 0 1-2.187-2.188V7H2.937a.936.936 0 1 1 0-1.875h2.188V2.937a.938.938 0 0 1 1.875 0v13.75Zm10-9.375A.313.313 0 0 0 16.687 7H8.25V5.125h8.438c1.207 0 2.187.98 2.187 2.188V17h2.188c.519 0 .937.418.937.938 0 .519-.418.937-.938.937h-2.187v2.188c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938V7.313Z",
        fill: "currentColor"
      }
    )
  })
);
var CropSimple_default = SvgCropSimple;

// src/Icon/icons/Crop.tsx
import { jsx as jsx558 } from "react/jsx-runtime";
var SvgCrop = (props) => /* @__PURE__ */ jsx558(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx558(
      "path",
      {
        d: "M5.125 2.938a.938.938 0 0 1 1.875 0v12.738L15.676 7H8.25V5.125h9.3l2.848-2.85c.368-.367.961-.367 1.293 0a.885.885 0 0 1 0 1.325l-2.816 2.85V17h2.188c.519 0 .937.418.937.938 0 .519-.418.937-.938.937h-2.187v2.188c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938V8.325L8.324 17h7.426v1.875H7.312a2.189 2.189 0 0 1-2.187-2.188V7H2.937a.936.936 0 1 1 0-1.875h2.188V2.937Z",
        fill: "currentColor"
      }
    )
  })
);
var Crop_default = SvgCrop;

// src/Icon/icons/CrosshairsSimple.tsx
import { jsx as jsx559 } from "react/jsx-runtime";
var SvgCrosshairsSimple = (props) => /* @__PURE__ */ jsx559(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx559(
      "path",
      {
        d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm.938 1.929v2.759c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938V3.93a8.128 8.128 0 0 0-7.133 7.133h2.759c.519 0 .937.418.937.938s-.418.938-.938.938H3.93a8.127 8.127 0 0 0 7.133 7.132v-2.758c0-.519.418-.937.938-.937s.938.418.938.938v2.757a8.126 8.126 0 0 0 7.132-7.133h-2.758a.935.935 0 0 1-.937-.937c0-.52.418-.938.938-.938h2.757a8.127 8.127 0 0 0-7.133-7.133Z",
        fill: "currentColor"
      }
    )
  })
);
var CrosshairsSimple_default = SvgCrosshairsSimple;

// src/Icon/icons/Crosshairs.tsx
import { jsx as jsx560 } from "react/jsx-runtime";
var SvgCrosshairs = (props) => /* @__PURE__ */ jsx560(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx560(
      "path",
      {
        d: "M10.75 12c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25-.559 1.25-1.25 1.25-1.25-.559-1.25-1.25ZM12 2c.52 0 .938.42.938.938v.676a8.444 8.444 0 0 1 7.449 7.448h.675c.52 0 .938.418.938.938s-.418.938-.938.938h-.675a8.446 8.446 0 0 1-7.45 7.449v.675c0 .52-.417.938-.937.938a.935.935 0 0 1-.938-.938v-.675a8.444 8.444 0 0 1-7.448-7.45h-.676a.937.937 0 1 1 0-1.874h.676a8.442 8.442 0 0 1 7.448-7.449v-.676c0-.518.418-.938.938-.938Zm-.938 16.496v-1.183c0-.52.418-.938.938-.938s.938.418.938.938v1.183a6.563 6.563 0 0 0 5.558-5.558h-1.183a.935.935 0 0 1-.938-.938c0-.52.418-.938.938-.938h1.183a6.563 6.563 0 0 0-5.558-5.558v1.184c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938V5.505a6.563 6.563 0 0 0-5.558 5.559h1.184c.519 0 .937.417.937.937s-.418.938-.938.938H5.505a6.563 6.563 0 0 0 5.559 5.558Z",
        fill: "currentColor"
      }
    )
  })
);
var Crosshairs_default = SvgCrosshairs;

// src/Icon/icons/Cube.tsx
import { jsx as jsx561 } from "react/jsx-runtime";
var SvgCube = (props) => /* @__PURE__ */ jsx561(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx561(
      "path",
      {
        d: "M11.223 2.242c.5-.19 1.054-.19 1.554 0l7.813 2.964A2.188 2.188 0 0 1 22 7.25v9.524c0 .91-.563 1.723-1.41 2.047l-7.813 2.96c-.5.157-1.054.157-1.554 0l-7.811-2.96A2.19 2.19 0 0 1 2 16.775V7.25c0-.91.562-1.723 1.412-2.045l7.81-2.964Zm.886 1.753c-.07-.027-.183-.027-.218 0L4.485 6.802 12 9.755l7.516-2.953-7.407-2.807ZM4.077 17.068l6.986 2.648v-8.312L3.875 8.58v8.195c0 .129.08.246.202.293Zm8.86 2.648 6.985-2.648a.317.317 0 0 0 .203-.293V8.58l-7.188 2.824v8.312Z",
        fill: "currentColor"
      }
    )
  })
);
var Cube_default = SvgCube;

// src/Icon/icons/CubesStacked.tsx
import { jsx as jsx562 } from "react/jsx-runtime";
var SvgCubesStacked = (props) => /* @__PURE__ */ jsx562(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx562(
      "path",
      {
        d: "M14.857 2c.79 0 1.429.64 1.429 1.429v2.857c0 .79-.639 1.428-1.429 1.428H12c-.79 0-1.429-.638-1.429-1.428V3.429C10.571 2.639 11.21 2 12 2h2.857Zm-2.143 2.143V5.57h1.429V4.143h-1.429Zm-7.546 7.62c-.395-.683-.16-1.558.523-1.99l2.474-1.43c.683-.356 1.518-.12 1.951.563l1.429 2.473c.393.684.16 1.518-.523 1.951L8.55 14.76c-.683.393-1.558.16-1.991-.522l-1.39-2.474Zm4.162.067-.714-1.236-1.237.714.715 1.237 1.236-.715Zm4.099-1.259c0-.79.638-1.428 1.428-1.428h2.857c.79 0 1.429.638 1.429 1.428v2.858c0 .79-.639 1.428-1.429 1.428h-2.857c-.79 0-1.428-.638-1.428-1.428V10.57ZM17 12.714v-1.428h-1.429v1.428H17Zm-.714 5c0-.79.638-1.428 1.428-1.428h2.857c.79 0 1.429.638 1.429 1.428v2.857c0 .79-.638 1.429-1.429 1.429h-2.857c-.79 0-1.428-.638-1.428-1.429v-2.857Zm3.571 2.143V18.43H18.43v1.428h1.428Zm-6.428-3.571c.79 0 1.428.638 1.428 1.428v2.857c0 .79-.638 1.429-1.428 1.429H10.57c-.79 0-1.428-.638-1.428-1.429v-2.857c0-.79.638-1.428 1.428-1.428h2.858Zm-2.143 2.143v1.428h1.428V18.43h-1.428ZM2 17.714c0-.79.64-1.428 1.429-1.428h2.857c.79 0 1.428.638 1.428 1.428v2.857c0 .79-.638 1.429-1.428 1.429H3.429A1.428 1.428 0 0 1 2 20.571v-2.857Zm3.571 2.143V18.43H4.143v1.428H5.57Z",
        fill: "currentColor"
      }
    )
  })
);
var CubesStacked_default = SvgCubesStacked;

// src/Icon/icons/Cubes.tsx
import { jsx as jsx563 } from "react/jsx-runtime";
var SvgCubes = (props) => /* @__PURE__ */ jsx563(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx563(
      "path",
      {
        d: "M17.556 6.34v3.976l3.19 1.211A1.944 1.944 0 0 1 22 13.345v4.138c0 .771-.455 1.47-1.163 1.778l-3.344 1.472a1.821 1.821 0 0 1-1.528-.014L12 19.108l-3.965 1.61c-.49.233-1.042.23-1.528.014L3.162 19.26A1.94 1.94 0 0 1 2 17.482v-4.138c0-.806.5-1.532 1.255-1.816l3.19-1.212V6.34c0-.822.517-1.556 1.291-1.832l3.611-1.288a1.94 1.94 0 0 1 1.306 0l3.61 1.288a1.945 1.945 0 0 1 1.293 1.832Zm-5.462-1.55c-.09-.022-.125-.022-.188 0l-2.82 1.006L12 6.913l2.913-1.117-2.82-1.007Zm-.927 6.606V8.378L8.11 7.205v3.1l3.056 1.09Zm1.666 0 3.056-1.09V7.204l-3.056 1.173v3.018Zm-4.722 4.003v3.514l3.056-1.264v-3.42l-3.056 1.17Zm-4.278 2.337 2.611 1.15v-3.487l-2.777-1.066v3.15c0 .11.065.208.166.253Zm12.056-2.337-3.056-1.17v3.42l3.056 1.264v-3.514Zm1.667 3.486 2.61-1.15a.277.277 0 0 0 .167-.253v-3.149L17.556 15.4v3.486Zm-10.174-7.07a.278.278 0 0 0-.191 0l-2.732 1.039 2.819 1.08 2.913-1.118-2.81-1Zm6.427 1 2.913 1.119 2.82-1.08-2.733-1.038a.37.37 0 0 0-.222 0l-2.778 1Z",
        fill: "currentColor"
      }
    )
  })
);
var Cubes_default = SvgCubes;

// src/Icon/icons/D.tsx
import { jsx as jsx564 } from "react/jsx-runtime";
var SvgD = (props) => /* @__PURE__ */ jsx564(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx564(
      "path",
      {
        d: "M10.335 22H4.5a1.07 1.07 0 0 1-1.071-1.071V3.07C3.429 2.48 3.909 2 4.5 2h5.835C15.978 2 20.57 6.487 20.57 12s-4.593 10-10.236 10ZM5.57 19.857h4.764c4.464 0 8.094-3.527 8.094-7.857s-3.632-7.857-8.094-7.857H5.57v15.714Z",
        fill: "currentColor"
      }
    )
  })
);
var D_default = SvgD;

// src/Icon/icons/Dash.tsx
import { jsx as jsx565 } from "react/jsx-runtime";
var SvgDash = (props) => /* @__PURE__ */ jsx565(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx565(
      "path",
      {
        d: "M22 12c0 .518-.42.938-.938.938H2.938a.937.937 0 1 1 0-1.876h18.125c.52 0 .938.422.938.938Z",
        fill: "currentColor"
      }
    )
  })
);
var Dash_default = SvgDash;

// src/Icon/icons/Database.tsx
import { jsx as jsx566 } from "react/jsx-runtime";
var SvgDatabase = (props) => /* @__PURE__ */ jsx566(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx566(
      "path",
      {
        d: "M12 22c-4.832 0-8.75-1.398-8.75-3.125V5.125C3.25 3.399 7.168 2 12 2s8.75 1.4 8.75 3.125v13.75C20.75 20.602 16.832 22 12 22Zm6.875-16.64-.023-.019c-.207-.176-.622-.42-1.297-.66-1.332-.476-3.297-.806-5.555-.806-2.258 0-4.223.33-5.557.806-.674.24-1.087.484-1.296.66l-.022.02v3.463c.519.25 1.236.555 2.14.778 1.325.293 2.958.523 4.735.523 1.777 0 3.41-.23 4.734-.523a10.844 10.844 0 0 0 2.141-.778V5.361Zm0 5.53c-.52.208-1.09.383-1.691.532C15.69 11.789 13.906 12 12 12c-1.906 0-3.691-.21-5.183-.578-.601-.149-1.172-.324-1.692-.531v2.933c.519.25 1.236.555 2.14.778 1.325.293 2.958.523 4.735.523 1.777 0 3.41-.23 4.734-.523a10.847 10.847 0 0 0 2.141-.778v-2.933ZM5.147 18.66c.209.14.622.418 1.296.66 1.334.473 3.3.805 5.522.805 2.293 0 4.258-.332 5.59-.805a5.478 5.478 0 0 0 1.297-.66l.023-.055v-2.714c-.52.207-1.09.382-1.691.53-1.493.368-3.278.579-5.22.579-1.87 0-3.655-.21-5.147-.578-.601-.149-1.172-.324-1.727-.531v2.714l.057.055Zm13.806-.101-.004.007c.004-.039.008-.007.008-.007h-.004Zm-13.902.007c-.004-.039-.006-.007-.006-.007l.006.007Zm0-13.132c-.005.005-.006.008-.006.008l.006-.008Zm13.906.008-.008-.008.008.008Z",
        fill: "currentColor"
      }
    )
  })
);
var Database_default = SvgDatabase;

// src/Icon/icons/DeleteLeft.tsx
import { jsx as jsx567 } from "react/jsx-runtime";
var SvgDeleteLeft = (props) => /* @__PURE__ */ jsx567(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx567(
      "path",
      {
        d: "M17.003 10.337 15.4 12l1.604 1.632c.355.326.355.854 0 1.15-.295.353-.822.353-1.149 0l-1.632-1.605-1.663 1.604c-.295.354-.823.354-1.15 0-.322-.295-.322-.823 0-1.15L13.046 12l-1.635-1.663c-.323-.295-.323-.823 0-1.15.326-.322.854-.322 1.149 0l1.663 1.636 1.632-1.636c.327-.322.854-.322 1.15 0 .354.327.354.855 0 1.15Zm2.775-5.004c1.226 0 2.222.995 2.222 2.223v8.888a2.224 2.224 0 0 1-2.222 2.223H9.128c-.59 0-1.156-.233-1.572-.65l-5.23-5.232a1.108 1.108 0 0 1 0-1.57l5.23-5.23a2.223 2.223 0 0 1 1.572-.652h10.65Zm.555 2.223A.557.557 0 0 0 19.778 7H9.128a.56.56 0 0 0-.395.163L3.897 12l4.836 4.837a.56.56 0 0 0 .395.163h10.65c.305 0 .555-.25.555-.556V7.556Z",
        fill: "currentColor"
      }
    )
  })
);
var DeleteLeft_default = SvgDeleteLeft;

// src/Icon/icons/DeleteRight.tsx
import { jsx as jsx568 } from "react/jsx-runtime";
var SvgDeleteRight = (props) => /* @__PURE__ */ jsx568(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx568(
      "path",
      {
        d: "M6.965 9.188c.327-.323.854-.323 1.15 0l1.632 1.635 1.663-1.636c.326-.322.854-.322 1.149 0 .354.327.354.855 0 1.15l-1.604 1.632 1.604 1.663c.354.326.354.854 0 1.15-.295.353-.823.353-1.15 0l-1.662-1.605-1.632 1.604c-.296.354-.823.354-1.15 0-.323-.295-.323-.823 0-1.15l1.636-1.662-1.636-1.632c-.323-.295-.323-.823 0-1.15Zm7.906-3.855c.59 0 1.125.234 1.573.651l5.23 5.231a1.11 1.11 0 0 1 0 1.57l-5.23 5.232c-.447.417-.982.65-1.572.65H4.221A2.223 2.223 0 0 1 2 16.444V7.556c0-1.228.995-2.223 2.222-2.223h10.65ZM3.667 16.444c0 .306.248.556.555.556h10.65a.62.62 0 0 0 .395-.163L20.104 12l-4.837-4.837A.62.62 0 0 0 14.871 7H4.223a.556.556 0 0 0-.555.556v8.888Z",
        fill: "currentColor"
      }
    )
  })
);
var DeleteRight_default = SvgDeleteRight;

// src/Icon/icons/DesktopAndScreensaver.tsx
import { jsx as jsx569 } from "react/jsx-runtime";
var SvgDesktopAndScreensaver = (props) => /* @__PURE__ */ jsx569(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx569(
      "path",
      {
        d: "M13.237 7.212c-.108 0-.171-.06-.189-.156-.279-1.447-.26-1.465-1.826-1.768-.108-.017-.171-.078-.171-.182s.063-.165.17-.182c1.566-.303 1.512-.338 1.827-1.768.018-.095.08-.156.189-.156.108 0 .162.06.18.156.324 1.43.27 1.465 1.835 1.768.099.017.17.078.17.182s-.071.165-.17.182c-1.565.286-1.556.32-1.835 1.768-.018.095-.072.156-.18.156ZM10.862 21C6.23 21 3 17.75 3 13.53c0-3.233 1.907-6.015 4.669-7.098.413-.156.72-.095.89.095.162.174.171.477 0 .815-.279.546-.486 1.594-.486 2.643 0 3.796 2.582 6.223 6.612 6.223 1.035 0 1.853-.156 2.537-.416.315-.113.594-.087.746.069.171.165.225.46.064.823C16.826 19.405 14.154 21 10.862 21Zm6.675-7.921c-.162 0-.28-.113-.306-.269-.315-2.314-.396-2.314-2.888-2.773-.153-.026-.27-.13-.27-.286a.29.29 0 0 1 .27-.295c2.492-.338 2.582-.416 2.888-2.764.027-.165.144-.277.306-.277.17 0 .288.112.306.286.296 2.313.431 2.305 2.887 2.755.153.026.27.13.27.295 0 .165-.117.26-.306.286-2.438.381-2.555.442-2.851 2.756-.018.173-.135.286-.306.286Zm-6.657 6.595c2.258 0 4.264-.919 5.388-2.418-.386.122-1.124.226-1.925.226-4.533 0-7.592-2.86-7.592-7.133 0-.832.126-1.69.351-2.262-1.673 1.23-2.726 3.163-2.726 5.339 0 3.553 2.672 6.248 6.504 6.248Z",
        fill: "currentColor"
      }
    )
  })
);
var DesktopAndScreensaver_default = SvgDesktopAndScreensaver;

// src/Icon/icons/DesktopArrowDown.tsx
import { jsx as jsx570 } from "react/jsx-runtime";
var SvgDesktopArrowDown = (props) => /* @__PURE__ */ jsx570(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx570(
      "path",
      {
        d: "M8.632 6.688a.833.833 0 0 0 0 1.178l2.778 2.778a.833.833 0 0 0 1.178 0l2.778-2.778a.833.833 0 1 0-1.178-1.178l-1.355 1.357v-4.1a.832.832 0 1 0-1.666 0v4.1L9.78 6.688a.716.716 0 0 0-.559-.244.833.833 0 0 0-.59.244ZM19.778 3.11h-5.556v1.667h5.556c.306 0 .555.249.555.555V12H3.667V5.333c0-.306.249-.555.555-.555h5.556V3.11H4.222A2.222 2.222 0 0 0 2 5.333v10c0 1.228.995 2.223 2.222 2.223h5.15l-.334 1.666h-1.76a.836.836 0 0 0-.834.834c0 .458.375.833.834.833h9.444a.834.834 0 0 0 0-1.667h-1.761l-.332-1.666h5.149A2.222 2.222 0 0 0 22 15.333v-10a2.223 2.223 0 0 0-2.222-2.222ZM10.74 19.222l.333-1.666h1.856l.333 1.666H10.74Zm9.593-3.889c0 .307-.249.556-.555.556H4.222a.556.556 0 0 1-.555-.556v-1.666h16.666v1.666Z",
        fill: "currentColor"
      }
    )
  })
);
var DesktopArrowDown_default = SvgDesktopArrowDown;

// src/Icon/icons/Desktop.tsx
import { jsx as jsx571 } from "react/jsx-runtime";
var SvgDesktop = (props) => /* @__PURE__ */ jsx571(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx571(
      "path",
      {
        d: "M19.778 3.111H4.222A2.222 2.222 0 0 0 2 5.333v10c0 1.228.995 2.223 2.222 2.223h5.15l-.334 1.666h-1.76a.836.836 0 0 0-.834.834c0 .458.375.833.834.833h9.444a.834.834 0 0 0 0-1.667h-1.761l-.332-1.666h5.149A2.222 2.222 0 0 0 22 15.333v-10a2.223 2.223 0 0 0-2.222-2.222ZM13.26 19.222h-2.52l.333-1.666h1.856l.331 1.666Zm7.073-3.889c0 .307-.249.556-.555.556H4.222a.556.556 0 0 1-.555-.556v-1.666h16.666v1.666Zm0-3.333H3.667V5.333c0-.306.249-.555.555-.555h15.556c.306 0 .555.249.555.555V12Z",
        fill: "currentColor"
      }
    )
  })
);
var Desktop_default = SvgDesktop;

// src/Icon/icons/Devices.tsx
import { jsx as jsx572 } from "react/jsx-runtime";
var SvgDevices = (props) => /* @__PURE__ */ jsx572(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx572(
      "path",
      {
        d: "M.974 18.889A.975.975 0 0 1 0 17.916c0-.538.44-.973.974-.973H2.86V6.81c0-1.195.707-1.81 1.844-1.81H20.33c.956 0 1.517.47 1.577 1.374H5.076c-.552 0-.828.274-.828.82v9.749H15.71c0 .196.008.384.008.58.018.53.156.982.397 1.366H.974ZM18.39 19c-1.069 0-1.68-.58-1.68-1.596V8.9c0-1.016.611-1.605 1.68-1.605h3.93c1.06 0 1.68.59 1.68 1.605v8.503C24 18.419 23.388 19 22.32 19h-3.93Zm.017-1.118h3.887c.379 0 .577-.205.577-.59v-8.28c0-.392-.198-.597-.577-.597h-3.887c-.379 0-.569.205-.569.597v8.28c0 .385.19.59.57.59Zm1.258-8.221a.39.39 0 0 1-.396-.401c0-.214.164-.384.396-.384h1.353c.224 0 .397.17.397.384a.395.395 0 0 1-.397.401h-1.353Zm-.49 7.785c-.182 0-.285-.11-.285-.298 0-.163.112-.29.284-.29h2.344c.172 0 .302.127.302.29 0 .179-.13.298-.302.298h-2.344Z",
        fill: "currentColor"
      }
    )
  })
);
var Devices_default = SvgDevices;

// src/Icon/icons/DeviceMac.tsx
import { jsx as jsx573 } from "react/jsx-runtime";
var SvgDeviceMac = (props) => /* @__PURE__ */ jsx573(
  "svg",
  __spreadProps(__spreadValues({
    width: "12",
    height: "10",
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx573(
      "path",
      {
        d: "M1.41028 8.24983H10.7444C11.5008 8.24983 11.9552 7.79549 11.9552 7.03902V1.20596C11.9552 0.450371 11.5008 0 10.7444 0H1.41028C0.65779 0 0.203449 0.450371 0.203449 1.20596V7.03902C0.203449 7.79549 0.65779 8.24983 1.41028 8.24983ZM1.33494 6.00833C1.19405 6.00833 1.13198 5.95594 1.13198 5.80536V1.26319C1.13198 1.05316 1.26145 0.92766 1.46664 0.92766H10.692C10.8972 0.92766 11.0266 1.05316 11.0266 1.26319V5.80536C11.0266 5.95594 10.9597 6.00833 10.8197 6.00833H1.33494ZM4.50054 9.35683H7.65808V8.15116H4.50054V9.35683ZM4.47671 10H7.6819C7.92283 10 8.11804 9.80043 8.11804 9.56076C8.11804 9.3211 7.92283 9.1224 7.6819 9.1224H4.47671C4.23579 9.1224 4.03661 9.3211 4.03661 9.56076C4.03661 9.80043 4.23579 10 4.47671 10Z",
        fill: "currentColor"
      }
    )
  })
);
var DeviceMac_default = SvgDeviceMac;

// src/Icon/icons/DeviceIphone.tsx
import { jsx as jsx574 } from "react/jsx-runtime";
var SvgDeviceIphone = (props) => /* @__PURE__ */ jsx574(
  "svg",
  __spreadProps(__spreadValues({
    width: "7",
    height: "10",
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx574(
      "path",
      {
        d: "M1.3152 10H4.908C5.68452 10 6.20345 9.49488 6.20345 8.73884V1.26115C6.20345 0.504297 5.68452 0 4.908 0H1.3152C0.527157 0 0 0.504297 0 1.26033V8.73966C0 9.49488 0.527157 10 1.3152 10ZM1.46882 9.07875C1.10323 9.07875 0.895751 8.88206 0.895751 8.53357V1.46644C0.895751 1.11795 1.10323 0.921264 1.46882 0.921264H4.73922C5.10023 0.921264 5.30771 1.1196 5.30771 1.46726V8.53275C5.30771 8.88041 5.10023 9.07875 4.73922 9.07875H1.46882ZM2.11869 8.72277H4.09227C4.22559 8.72277 4.31987 8.63014 4.31987 8.49142C4.31987 8.35188 4.22559 8.26218 4.09227 8.26218H2.11869C1.98537 8.26218 1.88652 8.35188 1.88652 8.49142C1.88652 8.63014 1.98537 8.72277 2.11869 8.72277ZM2.52899 1.99212H3.67822C3.87464 1.99212 4.02707 1.83969 4.02707 1.63953C4.02707 1.44312 3.87382 1.28986 3.67822 1.28986H2.52899C2.32965 1.28986 2.17639 1.44312 2.17639 1.63953C2.17639 1.83969 2.32883 1.99212 2.52899 1.99212Z",
        fill: "currentColor"
      }
    )
  })
);
var DeviceIphone_default = SvgDeviceIphone;

// src/Icon/icons/DeviceIpad.tsx
import { jsx as jsx575 } from "react/jsx-runtime";
var SvgDeviceIpad = (props) => /* @__PURE__ */ jsx575(
  "svg",
  __spreadProps(__spreadValues({
    width: "14",
    height: "10",
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx575(
      "path",
      {
        d: "M2.71455 10H11.981C13.1418 10 13.7385 9.40232 13.7385 8.25819V1.73988C13.7385 0.595746 13.1418 0 11.981 0H2.71263C1.55627 0 0.95517 0.591353 0.95517 1.73988V8.25819C0.95517 9.40672 1.55724 10 2.71455 10ZM2.77541 8.95037C2.27631 8.95037 2.00576 8.69246 2.00576 8.17193V1.8271C2.00576 1.30657 2.27535 1.04962 2.77348 1.04962H11.9202C12.4139 1.04962 12.6888 1.30657 12.6888 1.8271V8.17193C12.6888 8.69246 12.4139 8.95037 11.9202 8.95037H2.77541ZM5.27402 8.52338H9.42497C9.57734 8.52338 9.68685 8.42116 9.68685 8.26151C9.68685 8.10186 9.57734 7.99428 9.42497 7.99428H5.27402C5.12166 7.99428 5.00872 8.10186 5.00872 8.26151C5.00872 8.42116 5.12166 8.52338 5.27402 8.52338Z",
        fill: "currentColor"
      }
    )
  })
);
var DeviceIpad_default = SvgDeviceIpad;

// src/Icon/icons/DeviceAppleTv.tsx
import { jsx as jsx576 } from "react/jsx-runtime";
var SvgDeviceAppleTv = (props) => /* @__PURE__ */ jsx576(
  "svg",
  __spreadProps(__spreadValues({
    width: "11",
    height: "10",
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx576(
      "path",
      {
        d: "M3.5781 3.93105C3.96919 3.97311 4.27615 3.54136 4.2495 3.19641C3.85752 3.21222 3.56637 3.56035 3.5781 3.93105ZM4.91543 5.60836C4.73008 5.52384 4.60757 5.40222 4.54065 5.22771C4.46786 5.03649 4.47781 4.84478 4.54065 4.68021C4.57545 4.57033 4.64824 4.4338 4.83678 4.32214C4.69617 4.11372 4.47284 4.00702 4.21241 4.00702C3.91718 4.00702 3.74496 4.16165 3.59709 4.16165C3.4714 4.16165 3.3308 4.01199 3.09165 4.01199C2.8362 4.01199 2.62509 4.11779 2.48946 4.2941C2.32668 4.49665 2.25797 4.74484 2.25797 5.0003C2.25797 5.42211 2.44242 5.91582 2.71955 6.22686C2.86921 6.38735 2.98088 6.47008 3.11154 6.47008C3.31091 6.47008 3.41671 6.3254 3.65496 6.3254C3.76077 6.3254 3.84757 6.36925 3.91042 6.38735C4.00807 6.41947 4.07588 6.46421 4.18666 6.46421C4.30827 6.46421 4.40412 6.41539 4.46876 6.35752C4.67986 6.15357 4.84672 5.85387 4.91543 5.60836ZM6.24103 3.43466H5.73827V4.00702H5.39014V4.39493H5.73827V5.80097C5.73827 6.28881 5.93267 6.46421 6.42727 6.46421C6.53576 6.46421 6.65558 6.45019 6.69764 6.44522V6.03425C6.67457 6.04827 6.58866 6.04827 6.53576 6.04827C6.3346 6.04827 6.24103 5.96554 6.24103 5.74309V4.39493H6.70938V4.00702H6.24103V3.43466ZM8.35277 6.44522L9.23438 4.00702H8.68778L8.09374 5.96554L7.4653 4.00702H6.93271L7.82834 6.44522H8.35277ZM3.46544 10H8.04094C8.94572 10 9.6563 9.90076 10.167 9.39005C10.6786 8.87934 10.772 8.17553 10.772 7.26896V2.72697C10.772 1.8195 10.6786 1.11887 10.167 0.609053C9.6554 0.0983426 8.94572 0 8.04094 0H3.45728C2.56474 0 1.85416 0.0983426 1.34255 0.609053C0.831843 1.12066 0.738472 1.82358 0.738472 2.71881V7.26896C0.738472 8.17553 0.831843 8.88024 1.34255 9.39005C1.85505 9.90076 2.56474 10 3.46544 10ZM3.3303 9.02502C2.81462 9.02502 2.33225 8.95362 2.05312 8.6754C1.77897 8.40035 1.71255 7.92475 1.71255 7.40817V2.60406C1.71255 2.07436 1.77897 1.59875 2.05312 1.31962C2.33225 1.04547 2.8187 0.974079 3.34253 0.974079H8.18015C8.69583 0.974079 9.17731 1.04547 9.45325 1.3237C9.73147 1.59875 9.7979 2.07436 9.7979 2.59183V7.40817C9.7979 7.92475 9.73147 8.40035 9.45325 8.6754C9.17731 8.95362 8.69583 9.02502 8.18015 9.02502H3.3303Z",
        fill: "currentColor"
      }
    )
  })
);
var DeviceAppleTv_default = SvgDeviceAppleTv;

// src/Icon/icons/DeviceVision.tsx
import { jsx as jsx577 } from "react/jsx-runtime";
var SvgDeviceVision = (props) => /* @__PURE__ */ jsx577(
  "svg",
  __spreadProps(__spreadValues({
    width: "11",
    height: "6",
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx577(
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5.77373 0.16629C4.42862 0.16629 3.18446 0.234664 2.27523 0.625284C1.81713 0.822088 1.43863 1.10277 1.17566 1.5016C0.912745 1.90036 0.77198 2.40712 0.77198 3.04473C0.77198 4.60448 1.76339 5.83369 3.12046 5.83369C3.81119 5.83369 4.33437 5.53998 4.75716 5.25929C4.83169 5.20981 4.9018 5.16167 4.96882 5.11565C5.09599 5.02834 5.212 4.94868 5.32589 4.88204C5.49801 4.78134 5.64161 4.7256 5.77373 4.7256C5.90484 4.7256 6.04772 4.78123 6.21944 4.88197C6.3326 4.94836 6.44788 5.02764 6.57426 5.11455C6.64162 5.16087 6.71219 5.2094 6.78721 5.25926C7.2096 5.53998 7.73277 5.83369 8.42352 5.83369C9.78059 5.83369 10.772 4.60448 10.772 3.04473C10.772 2.40629 10.6312 1.89911 10.3684 1.50018C10.1055 1.10117 9.72705 0.820578 9.26915 0.623983C8.36034 0.233794 7.11703 0.16629 5.77373 0.16629ZM1.56994 3.04473C1.56994 2.5629 1.6718 2.20108 1.85472 1.9261C2.03741 1.65148 2.30854 1.45205 2.66767 1.30824C3.39418 1.0173 4.45159 0.964245 5.77373 0.964245C7.09421 0.964245 8.15072 1.01645 8.87679 1.30696C9.23567 1.45056 9.50667 1.64986 9.68929 1.92461C9.87217 2.19974 9.97405 2.562 9.97405 3.04473C9.97405 3.67949 9.81445 4.1782 9.54515 4.51552C9.27814 4.84996 8.89578 5.03576 8.42352 5.03576C7.86314 5.03576 7.47625 4.78055 7.08947 4.5044L7.02604 4.45895C6.66573 4.20042 6.28556 3.92763 5.77373 3.92763C5.25988 3.92763 4.87871 4.20079 4.51755 4.4596L4.455 4.50436C4.06773 4.78055 3.68085 5.03576 3.12046 5.03576C2.64819 5.03576 2.26583 4.84996 1.99883 4.51552C1.72953 4.1782 1.56994 3.67949 1.56994 3.04473Z",
        fill: "currentColor"
      }
    )
  })
);
var DeviceVision_default = SvgDeviceVision;

// src/Icon/icons/DiagramCells.tsx
import { jsx as jsx578 } from "react/jsx-runtime";
var SvgDiagramCells = (props) => /* @__PURE__ */ jsx578(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx578(
      "path",
      {
        d: "M4.5 10.75c-1.38 0-2.5-1.121-2.5-2.5v-2.5a2.5 2.5 0 0 1 2.5-2.5h15c1.379 0 2.5 1.12 2.5 2.5v2.5c0 1.379-1.121 2.5-2.5 2.5h-15Zm17.5 7.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5v-2.5c0-1.379 1.12-2.5 2.5-2.5h15c1.379 0 2.5 1.121 2.5 2.5v2.5Zm-2.5-3.125h-15a.626.626 0 0 0-.625.625v2.5c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625v-2.5a.627.627 0 0 0-.625-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var DiagramCells_default = SvgDiagramCells;

// src/Icon/icons/DiagramLeanCanvas.tsx
import { jsx as jsx579 } from "react/jsx-runtime";
var SvgDiagramLeanCanvas = (props) => /* @__PURE__ */ jsx579(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx579(
      "path",
      {
        d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10c0 1.103-.897 2-2 2H4a2 2 0 0 1-2-2V7Zm16 6.25h2.5V7a.5.5 0 0 0-.5-.5h-2v6.75ZM16.5 6.5h-2v2.75h2V6.5Zm-3.5 0h-2v6.75h2V6.5Zm-3.5 0h-2v2.75h2V6.5ZM6 6.5H4a.5.5 0 0 0-.5.5v6.25H6V6.5Zm-2.5 8.25V17a.5.5 0 0 0 .5.5h7.25v-2.75H3.5Zm9.25 2.75H20c.275 0 .5-.225.5-.5v-2.25h-7.75v2.75ZM9.5 10.75h-2v2.5h2v-2.5Zm5 0v2.5h2v-2.5h-2Z",
        fill: "currentColor"
      }
    )
  })
);
var DiagramLeanCanvas_default = SvgDiagramLeanCanvas;

// src/Icon/icons/DiagramNested.tsx
import { jsx as jsx580 } from "react/jsx-runtime";
var SvgDiagramNested = (props) => /* @__PURE__ */ jsx580(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx580(
      "path",
      {
        d: "M8.429 2c1.183 0 2.142.96 2.142 2.143v4.286c0 1.183-.96 2.142-2.142 2.142H7.357v4.286c0 .987.8 1.786 1.786 1.786h4.286V15.57c0-1.183.96-2.142 2.142-2.142h4.286c1.183 0 2.143.96 2.143 2.142v4.286C22 21.04 21.04 22 19.857 22h-4.286a2.143 2.143 0 0 1-2.142-2.143v-1.071H9.143a3.929 3.929 0 0 1-3.929-3.929v-4.286H4.143A2.143 2.143 0 0 1 2 8.43V4.143C2 2.959 2.96 2 4.143 2h4.286Zm0 2.143H4.143v4.286h4.286V4.143ZM19.857 15.57h-4.286v4.286h4.286v-4.286Z",
        fill: "currentColor"
      }
    )
  })
);
var DiagramNested_default = SvgDiagramNested;

// src/Icon/icons/DiagramNext.tsx
import { jsx as jsx581 } from "react/jsx-runtime";
var SvgDiagramNext = (props) => /* @__PURE__ */ jsx581(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx581(
      "path",
      {
        d: "M12.938 10.75v3.363l.898-.902c.367-.363.96-.363 1.293 0 .398.367.398.96 0 1.293l-2.5 2.5c-.332.398-.926.398-1.293 0l-2.5-2.5c-.363-.332-.363-.926 0-1.293.367-.363.96-.363 1.293 0l.934.902V10.75H4.5c-1.38 0-2.5-1.121-2.5-2.5v-2.5a2.5 2.5 0 0 1 2.5-2.5h15c1.379 0 2.5 1.12 2.5 2.5v2.5c0 1.379-1.121 2.5-2.5 2.5h-6.563ZM4.5 13.25h2.578c-.16.625-.074 1.3.258 1.875H4.5a.626.626 0 0 0-.625.625v2.5c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625v-2.5a.627.627 0 0 0-.625-.625h-2.836c.332-.574.418-1.25.223-1.875H19.5c1.379 0 2.5 1.121 2.5 2.5v2.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5v-2.5c0-1.379 1.12-2.5 2.5-2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var DiagramNext_default = SvgDiagramNext;

// src/Icon/icons/DiagramPredecessor.tsx
import { jsx as jsx582 } from "react/jsx-runtime";
var SvgDiagramPredecessor = (props) => /* @__PURE__ */ jsx582(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx582(
      "path",
      {
        d: "M4.5 20.75c-1.38 0-2.5-1.121-2.5-2.5v-2.5c0-1.379 1.12-2.5 2.5-2.5h15c1.379 0 2.5 1.121 2.5 2.5v2.5c0 1.379-1.121 2.5-2.5 2.5h-15Zm15.625-2.5v-2.5a.627.627 0 0 0-.625-.625h-15a.626.626 0 0 0-.625.625v2.5c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625Zm-6.875-10c0 1.379-1.121 2.5-2.5 2.5H4.5c-1.38 0-2.5-1.121-2.5-2.5v-2.5a2.5 2.5 0 0 1 2.5-2.5h11.875a2.812 2.812 0 0 1 2.813 2.813V7.55l.898-.903c.367-.363.96-.363 1.293 0 .398.368.398.961 0 1.293l-2.5 2.5c-.332.399-.926.399-1.293 0l-2.5-2.5c-.363-.332-.363-.925 0-1.293.367-.363.96-.363 1.293 0l.933.903V6.062a.937.937 0 0 0-.937-.937h-3.238c.086.2.113.41.113.625v2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var DiagramPredecessor_default = SvgDiagramPredecessor;

// src/Icon/icons/DiagramPrevious.tsx
import { jsx as jsx583 } from "react/jsx-runtime";
var SvgDiagramPrevious = (props) => /* @__PURE__ */ jsx583(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx583(
      "path",
      {
        d: "M22 18.25c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5v-2.5c0-1.379 1.12-2.5 2.5-2.5h6.563V9.887l-.934.867c-.332.398-.926.398-1.293 0-.363-.332-.363-.926 0-1.293l2.5-2.5c.367-.363.96-.363 1.293 0l2.5 2.5c.398.367.398.96 0 1.293-.332.398-.926.398-1.293 0l-.899-.867v3.363H19.5c1.379 0 2.5 1.121 2.5 2.5v2.5Zm-1.875 0v-2.5a.627.627 0 0 0-.625-.625h-15a.626.626 0 0 0-.625.625v2.5c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625ZM2 8.25v-2.5a2.5 2.5 0 0 1 2.5-2.5h15c1.379 0 2.5 1.12 2.5 2.5v2.5c0 1.379-1.121 2.5-2.5 2.5h-2.613a2.407 2.407 0 0 0-.617-2.395l-2.5-2.498a2.504 2.504 0 0 0-3.54 0l-2.5 2.498a2.507 2.507 0 0 0-.652 2.395H4.5c-1.38 0-2.5-1.121-2.5-2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var DiagramPrevious_default = SvgDiagramPrevious;

// src/Icon/icons/DiagramProject.tsx
import { jsx as jsx584 } from "react/jsx-runtime";
var SvgDiagramProject = (props) => /* @__PURE__ */ jsx584(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx584(
      "path",
      {
        d: "M6.722 4.222c1.073 0 1.945.87 1.945 1.945v.555h6.666v-.555c0-1.074.872-1.945 1.945-1.945h2.778c1.072 0 1.944.87 1.944 1.945v2.777a1.946 1.946 0 0 1-1.944 1.945h-2.778a1.946 1.946 0 0 1-1.945-1.945V8.39H8.667v.555c0 .26-.052.507-.143.737l2.636 3.513c.177-.055.368-.083.562-.083H14.5c1.073 0 1.944.872 1.944 1.945v2.777a1.946 1.946 0 0 1-1.944 1.945h-2.778a1.946 1.946 0 0 1-1.944-1.945v-2.777c0-.26.052-.507.142-.737l-2.635-3.513a1.887 1.887 0 0 1-.563.083H3.944A1.945 1.945 0 0 1 2 8.944V6.167c0-1.074.87-1.945 1.944-1.945h2.778Zm0 1.667H3.944a.278.278 0 0 0-.277.278v2.777c0 .153.124.278.277.278h2.778A.279.279 0 0 0 7 8.944V6.167a.278.278 0 0 0-.278-.278Zm7.778 8.889h-2.778a.279.279 0 0 0-.278.278v2.777c0 .153.125.278.278.278H14.5a.279.279 0 0 0 .278-.278v-2.777a.279.279 0 0 0-.278-.278ZM17 6.167v2.777c0 .153.125.278.278.278h2.778a.279.279 0 0 0 .277-.278V6.167a.278.278 0 0 0-.277-.278h-2.778a.278.278 0 0 0-.278.278Z",
        fill: "currentColor"
      }
    )
  })
);
var DiagramProject_default = SvgDiagramProject;

// src/Icon/icons/DiagramSankey.tsx
import { jsx as jsx585 } from "react/jsx-runtime";
var SvgDiagramSankey = (props) => /* @__PURE__ */ jsx585(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx585(
      "path",
      {
        d: "M13.455 5.889a.282.282 0 0 0-.236.133l-2.406 3.936c-.351.577-.98.93-1.657.93H2.833a.832.832 0 1 1 0-1.666h6.323a.288.288 0 0 0 .236-.132L11.8 5.153c.35-.578.979-.93 1.656-.93h7.712a.832.832 0 1 1 0 1.666h-7.712Zm-4.306 8.333 2.143 3.719c.048.118.142.17.243.17h9.632c.461 0 .833.372.833.833a.831.831 0 0 1-.833.834h-9.632a1.953 1.953 0 0 1-1.691-.98l-2.615-4.576H2.833a.832.832 0 1 1 0-1.666h18.334c.461 0 .833.371.833.833a.831.831 0 0 1-.833.833H9.149Z",
        fill: "currentColor"
      }
    )
  })
);
var DiagramSankey_default = SvgDiagramSankey;

// src/Icon/icons/DiagramSubtask.tsx
import { jsx as jsx586 } from "react/jsx-runtime";
var SvgDiagramSubtask = (props) => /* @__PURE__ */ jsx586(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx586(
      "path",
      {
        d: "M2 5.75a2.5 2.5 0 0 1 2.5-2.5h15c1.379 0 2.5 1.12 2.5 2.5v2.5c0 1.379-1.121 2.5-2.5 2.5H7.937v3.75c0 .863.7 1.563 1.563 1.563h1.25v-.313c0-1.379 1.121-2.5 2.5-2.5h6.25c1.379 0 2.5 1.121 2.5 2.5v2.5c0 1.379-1.121 2.5-2.5 2.5h-6.25a2.502 2.502 0 0 1-2.5-2.5v-.313H9.5A3.438 3.438 0 0 1 6.062 14.5v-3.75H4.5c-1.38 0-2.5-1.121-2.5-2.5v-2.5Zm17.5 9.375h-6.25a.627.627 0 0 0-.625.625v2.5c0 .344.281.625.625.625h6.25a.627.627 0 0 0 .625-.625v-2.5a.627.627 0 0 0-.625-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var DiagramSubtask_default = SvgDiagramSubtask;

// src/Icon/icons/DiagramSuccessor.tsx
import { jsx as jsx587 } from "react/jsx-runtime";
var SvgDiagramSuccessor = (props) => /* @__PURE__ */ jsx587(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx587(
      "path",
      {
        d: "M22 18.25c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5v-2.5c0-1.379 1.12-2.5 2.5-2.5h15c1.379 0 2.5 1.121 2.5 2.5v2.5Zm-8.75-10c0 1.379-1.121 2.5-2.5 2.5H4.5c-1.38 0-2.5-1.121-2.5-2.5v-2.5a2.5 2.5 0 0 1 2.5-2.5h11.875a2.812 2.812 0 0 1 2.813 2.813V7.55l.898-.903c.367-.363.96-.363 1.293 0 .398.368.398.961 0 1.293l-2.5 2.5c-.332.399-.926.399-1.293 0l-2.5-2.5c-.363-.332-.363-.925 0-1.293.367-.363.96-.363 1.293 0l.933.903V6.062a.937.937 0 0 0-.937-.937h-3.238c.086.2.113.41.113.625v2.5Zm-1.875 0v-2.5a.626.626 0 0 0-.625-.625H4.5a.625.625 0 0 0-.625.625v2.5c0 .344.28.625.625.625h6.25a.627.627 0 0 0 .625-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var DiagramSuccessor_default = SvgDiagramSuccessor;

// src/Icon/icons/DiagramVenn.tsx
import { jsx as jsx588 } from "react/jsx-runtime";
var SvgDiagramVenn = (props) => /* @__PURE__ */ jsx588(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx588(
      "path",
      {
        d: "M12 18.325a7 7 0 1 1 0-12.651 7 7 0 1 1 0 12.651ZM8 12c0-2.125.947-4.025 2.438-5.31a5.5 5.5 0 1 0 0 10.62A7.034 7.034 0 0 1 8 12Zm6.125 2c.184-.472.306-.975.353-1.5H9.522c.047.525.169 1.028.325 1.5h4.278Zm-3.734 1c.418.644.965 1.19 1.609 1.61A5.486 5.486 0 0 0 13.61 15h-3.22Zm-.544-5a6.668 6.668 0 0 0-.325 1.5h4.956a5.448 5.448 0 0 0-.353-1.5H9.847Zm3.762-1A5.486 5.486 0 0 0 12 7.39 5.486 5.486 0 0 0 10.39 9h3.22Z",
        fill: "currentColor"
      }
    )
  })
);
var DiagramVenn_default = SvgDiagramVenn;

// src/Icon/icons/DialHigh.tsx
import { jsx as jsx589 } from "react/jsx-runtime";
var SvgDialHigh = (props) => /* @__PURE__ */ jsx589(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx589(
      "path",
      {
        d: "M10.889 4.222a1.11 1.11 0 1 1 2.221 0 1.11 1.11 0 0 1-2.221 0ZM12 18.667a5.554 5.554 0 0 1-5.556-5.556A5.554 5.554 0 0 1 12 7.556a5.554 5.554 0 0 1 5.556 5.555A5.554 5.554 0 0 1 12 18.667Zm-.833-5.556c0-.462.371-.833.833-.833h3.799A3.891 3.891 0 0 0 12 9.222a3.887 3.887 0 0 0-3.889 3.89C8.111 15.26 9.851 17 12 17a3.891 3.891 0 0 0 3.799-3.056H12a.831.831 0 0 1-.833-.833Zm10.833 0a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm-20 0a1.11 1.11 0 1 1 2.221-.001A1.11 1.11 0 0 1 2 13.111Zm4.444-6.667a1.11 1.11 0 1 1-2.222 0 1.111 1.111 0 0 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.22 0 1.11 1.11 0 0 1-2.22 0ZM6.444 19.778a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.222 0 1.11 1.11 0 1 1-2.222 0Z",
        fill: "currentColor"
      }
    )
  })
);
var DialHigh_default = SvgDialHigh;

// src/Icon/icons/DialLow.tsx
import { jsx as jsx590 } from "react/jsx-runtime";
var SvgDialLow = (props) => /* @__PURE__ */ jsx590(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx590(
      "path",
      {
        d: "M10.889 4.222a1.11 1.11 0 1 1 2.221 0 1.11 1.11 0 0 1-2.221 0ZM12 7.556a5.554 5.554 0 0 1 5.556 5.555A5.554 5.554 0 0 1 12 18.667a5.554 5.554 0 0 1-5.556-5.556A5.554 5.554 0 0 1 12 7.556Zm3.889 5.555c0-2.15-1.74-3.889-3.889-3.889a3.891 3.891 0 0 0-3.799 3.056H12c.462 0 .833.371.833.833a.831.831 0 0 1-.833.833H8.201A3.891 3.891 0 0 0 12 17c2.15 0 3.889-1.74 3.889-3.889Zm6.111 0a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm-20 0a1.11 1.11 0 1 1 2.221-.001A1.11 1.11 0 0 1 2 13.111Zm4.444-6.667a1.11 1.11 0 1 1-2.222 0 1.111 1.111 0 0 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.22 0 1.11 1.11 0 0 1-2.22 0ZM6.444 19.778a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.222 0 1.11 1.11 0 1 1-2.222 0Z",
        fill: "currentColor"
      }
    )
  })
);
var DialLow_default = SvgDialLow;

// src/Icon/icons/DialMax.tsx
import { jsx as jsx591 } from "react/jsx-runtime";
var SvgDialMax = (props) => /* @__PURE__ */ jsx591(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx591(
      "path",
      {
        d: "M10.889 4.222a1.11 1.11 0 1 1 2.221 0 1.11 1.11 0 0 1-2.221 0ZM8.073 17.038a5.551 5.551 0 0 1 0-7.854 5.551 5.551 0 0 1 7.854 0 5.552 5.552 0 0 1 0 7.854 5.552 5.552 0 0 1-7.854 0Zm3.337-4.517c.326-.323.854-.323 1.149 0l2.715 2.687a3.887 3.887 0 0 0-.524-4.847 3.892 3.892 0 0 0-5.5 0 3.892 3.892 0 0 0 0 5.5 3.886 3.886 0 0 0 4.847.524L11.41 13.67c-.323-.295-.323-.823 0-1.15Zm10.59.59a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm-20 0a1.11 1.11 0 1 1 2.221-.001A1.11 1.11 0 0 1 2 13.111Zm4.444-6.667a1.11 1.11 0 1 1-2.222 0 1.111 1.111 0 0 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.22 0 1.11 1.11 0 0 1-2.22 0ZM6.444 19.778a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.222 0 1.11 1.11 0 1 1-2.222 0Z",
        fill: "currentColor"
      }
    )
  })
);
var DialMax_default = SvgDialMax;

// src/Icon/icons/DialMedLow.tsx
import { jsx as jsx592 } from "react/jsx-runtime";
var SvgDialMedLow = (props) => /* @__PURE__ */ jsx592(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx592(
      "path",
      {
        d: "M10.889 4.222a1.11 1.11 0 1 1 2.221 0 1.11 1.11 0 0 1-2.221 0Zm5.038 4.962a5.552 5.552 0 0 1 0 7.854 5.552 5.552 0 0 1-7.854 0 5.551 5.551 0 0 1 0-7.854 5.551 5.551 0 0 1 7.854 0Zm-1.177 6.677a3.892 3.892 0 0 0 0-5.5 3.887 3.887 0 0 0-4.847-.524l2.656 2.684c.354.326.354.854 0 1.15-.295.353-.823.353-1.15 0l-2.683-2.657a3.887 3.887 0 0 0 .524 4.847 3.892 3.892 0 0 0 5.5 0Zm7.25-2.75a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm-20 0a1.11 1.11 0 1 1 2.221-.001A1.11 1.11 0 0 1 2 13.111Zm4.444-6.667a1.11 1.11 0 1 1-2.222 0 1.111 1.111 0 0 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.22 0 1.11 1.11 0 0 1-2.22 0ZM6.444 19.778a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.222 0 1.11 1.11 0 1 1-2.222 0Z",
        fill: "currentColor"
      }
    )
  })
);
var DialMedLow_default = SvgDialMedLow;

// src/Icon/icons/DialMed.tsx
import { jsx as jsx593 } from "react/jsx-runtime";
var SvgDialMed = (props) => /* @__PURE__ */ jsx593(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx593(
      "path",
      {
        d: "M10.889 4.222a1.11 1.11 0 1 1 2.221 0 1.11 1.11 0 0 1-2.221 0Zm6.667 8.89A5.554 5.554 0 0 1 12 18.666a5.554 5.554 0 0 1-5.556-5.556A5.554 5.554 0 0 1 12 7.556a5.554 5.554 0 0 1 5.556 5.555ZM12 17c2.15 0 3.889-1.74 3.889-3.889a3.891 3.891 0 0 0-3.056-3.799v3.8a.831.831 0 0 1-.833.832.831.831 0 0 1-.833-.833V9.312C9.42 9.694 8.11 11.25 8.11 13.08 8.111 15.26 9.851 17 12 17Zm10-3.889a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm-20 0a1.11 1.11 0 1 1 2.221-.001A1.11 1.11 0 0 1 2 13.111Zm4.444-6.667a1.11 1.11 0 1 1-2.222 0 1.111 1.111 0 0 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.22 0 1.11 1.11 0 0 1-2.22 0ZM6.444 19.778a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.222 0 1.11 1.11 0 1 1-2.222 0Z",
        fill: "currentColor"
      }
    )
  })
);
var DialMed_default = SvgDialMed;

// src/Icon/icons/DialMin.tsx
import { jsx as jsx594 } from "react/jsx-runtime";
var SvgDialMin = (props) => /* @__PURE__ */ jsx594(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx594(
      "path",
      {
        d: "M10.889 4.222a1.11 1.11 0 1 1 2.221 0 1.11 1.11 0 0 1-2.221 0ZM8.073 9.184a5.551 5.551 0 0 1 7.854 0 5.552 5.552 0 0 1 0 7.854 5.552 5.552 0 0 1-7.854 0 5.551 5.551 0 0 1 0-7.854Zm4.486 3.337c.354.326.354.854 0 1.15l-2.656 2.714a3.887 3.887 0 0 0 4.847-.524 3.892 3.892 0 0 0 0-5.5 3.892 3.892 0 0 0-5.5 0 3.887 3.887 0 0 0-.524 4.847l2.684-2.687c.326-.323.854-.323 1.149 0Zm9.441.59a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm-20 0a1.11 1.11 0 1 1 2.221-.001A1.11 1.11 0 0 1 2 13.111Zm4.444-6.667a1.11 1.11 0 1 1-2.222 0 1.111 1.111 0 0 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.22 0 1.11 1.11 0 0 1-2.22 0ZM6.444 19.778a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.222 0 1.11 1.11 0 1 1-2.222 0Z",
        fill: "currentColor"
      }
    )
  })
);
var DialMin_default = SvgDialMin;

// src/Icon/icons/DialOff.tsx
import { jsx as jsx595 } from "react/jsx-runtime";
var SvgDialOff = (props) => /* @__PURE__ */ jsx595(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx595(
      "path",
      {
        d: "M10.889 4.222a1.11 1.11 0 1 1 2.221 0 1.11 1.11 0 0 1-2.221 0Zm-4.445 8.89A5.554 5.554 0 0 1 12 7.555a5.554 5.554 0 0 1 5.556 5.555A5.554 5.554 0 0 1 12 18.667a5.554 5.554 0 0 1-5.556-5.556ZM12 12.277c.462 0 .833.371.833.833v3.799a3.891 3.891 0 0 0 3.056-3.799c0-2.15-1.74-3.889-3.889-3.889a3.887 3.887 0 0 0-3.889 3.89 3.891 3.891 0 0 0 3.056 3.798V13.11c0-.462.371-.833.833-.833Zm10 .833a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm-20 0a1.11 1.11 0 1 1 2.221-.001A1.11 1.11 0 0 1 2 13.111Zm4.444-6.667a1.11 1.11 0 1 1-2.222 0 1.111 1.111 0 0 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.22 0 1.11 1.11 0 0 1-2.22 0ZM6.444 19.778a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.222 0 1.11 1.11 0 1 1-2.222 0Z",
        fill: "currentColor"
      }
    )
  })
);
var DialOff_default = SvgDialOff;

// src/Icon/icons/Dial.tsx
import { jsx as jsx596 } from "react/jsx-runtime";
var SvgDial = (props) => /* @__PURE__ */ jsx596(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx596(
      "path",
      {
        d: "M10.889 4.222a1.11 1.11 0 1 1 2.221 0 1.11 1.11 0 0 1-2.221 0Zm5.038 12.816a5.552 5.552 0 0 1-7.854 0 5.551 5.551 0 0 1 0-7.854 5.551 5.551 0 0 1 7.854 0 5.552 5.552 0 0 1 0 7.854ZM9.25 15.861a3.892 3.892 0 0 0 5.5 0 3.887 3.887 0 0 0 .524-4.847L12.56 13.67c-.295.354-.823.354-1.15 0-.322-.295-.322-.823 0-1.15l2.688-2.683a3.887 3.887 0 0 0-4.847.524 3.892 3.892 0 0 0 0 5.5ZM22 13.111a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm-20 0a1.11 1.11 0 1 1 2.221-.001A1.11 1.11 0 0 1 2 13.111Zm4.444-6.667a1.11 1.11 0 1 1-2.222 0 1.111 1.111 0 0 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.22 0 1.11 1.11 0 0 1-2.22 0ZM6.444 19.778a1.11 1.11 0 1 1-2.222 0 1.11 1.11 0 1 1 2.222 0Zm11.112 0a1.11 1.11 0 1 1 2.222 0 1.11 1.11 0 1 1-2.222 0Z",
        fill: "currentColor"
      }
    )
  })
);
var Dial_default = SvgDial;

// src/Icon/icons/DiamondExclamation.tsx
import { jsx as jsx597 } from "react/jsx-runtime";
var SvgDiamondExclamation = (props) => /* @__PURE__ */ jsx597(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx597(
      "path",
      {
        d: "M12 14.465A1.25 1.25 0 1 0 12 16.966a1.25 1.25 0 0 0-.001-2.5Zm-.938-6.562v4.375a.938.938 0 0 0 1.875 0V7.903A.938.938 0 0 0 12 6.966c-.518 0-.938.453-.938.937Zm10.378 2.793-8.132-8.167c-.742-.704-1.955-.704-2.658 0l-8.092 8.167a1.814 1.814 0 0 0 0 2.617l8.132 8.129a1.817 1.817 0 0 0 2.62 0l8.132-8.129a1.812 1.812 0 0 0-.002-2.617ZM12 20.1l-8.1-8.097 8.054-8.128h.012a.123.123 0 0 1 .05.011l8.082 8.117L12 20.1Z",
        fill: "currentColor"
      }
    )
  })
);
var DiamondExclamation_default = SvgDiamondExclamation;

// src/Icon/icons/DiamondHalfStroke.tsx
import { jsx as jsx598 } from "react/jsx-runtime";
var SvgDiamondHalfStroke = (props) => /* @__PURE__ */ jsx598(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx598(
      "path",
      {
        d: "M12 20.125V3.875c.102 0 .203.04.273.113l7.739 7.739a.384.384 0 0 1 .113.273c0 .102-.04.203-.113.273l-7.739 7.739a.384.384 0 0 1-.273.113Zm-1.602-17.46-7.734 7.733a2.262 2.262 0 0 0 0 3.204l7.734 7.734a2.262 2.262 0 0 0 3.204 0l7.734-7.734a2.262 2.262 0 0 0 0-3.204l-7.734-7.734a2.262 2.262 0 0 0-3.204 0Z",
        fill: "currentColor"
      }
    )
  })
);
var DiamondHalfStroke_default = SvgDiamondHalfStroke;

// src/Icon/icons/DiamondHalf.tsx
import { jsx as jsx599 } from "react/jsx-runtime";
var SvgDiamondHalf = (props) => /* @__PURE__ */ jsx599(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx599(
      "path",
      {
        d: "M15.895 2.457A1.562 1.562 0 0 1 17 2V22c-.398 0-.8-.152-1.105-.457l-8.438-8.438a1.566 1.566 0 0 1 0-2.21l8.438-8.438Zm-.77 15.664V5.88L9.004 12l6.121 6.121Z",
        fill: "currentColor"
      }
    )
  })
);
var DiamondHalf_default = SvgDiamondHalf;

// src/Icon/icons/DiamondTurnRight.tsx
import { jsx as jsx600 } from "react/jsx-runtime";
var SvgDiamondTurnRight = (props) => /* @__PURE__ */ jsx600(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx600(
      "path",
      {
        d: "m21.418 10.694-8.129-8.129a1.867 1.867 0 0 0-2.646 0l-8.095 8.129A1.85 1.85 0 0 0 2 11.983c0 .479.183.958.548 1.323l8.129 8.129c.366.4.843.548 1.323.548.479 0 .958-.183 1.323-.548l8.129-8.129c.365-.365.548-.844.548-1.323-.035-.445-.184-.922-.582-1.29Zm-9.414 9.45-8.13-8.122 8.09-8.129 8.129 8.121-8.09 8.13Zm1.797-9.688H9.812a.94.94 0 0 0-.937.937v2.813a.938.938 0 0 0 1.875 0V12.33h3.05l-.9.9a.937.937 0 1 0 1.325 1.325l2.5-2.5a.937.937 0 0 0 0-1.326l-2.5-2.5A.937.937 0 1 0 12.9 9.556l.9.9Z",
        fill: "currentColor"
      }
    )
  })
);
var DiamondTurnRight_default = SvgDiamondTurnRight;

// src/Icon/icons/Diamond.tsx
import { jsx as jsx601 } from "react/jsx-runtime";
var SvgDiamond = (props) => /* @__PURE__ */ jsx601(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx601(
      "path",
      {
        d: "M10.895 2.458c.609-.61 1.601-.61 2.21 0l8.438 8.437c.61.609.61 1.601 0 2.21l-8.438 8.438c-.609.61-1.601.61-2.21 0l-8.437-8.438a1.564 1.564 0 0 1 0-2.21l8.437-8.437ZM12 4.004 4.004 12 12 19.996 19.996 12 12 4.004Z",
        fill: "currentColor"
      }
    )
  })
);
var Diamond_default = SvgDiamond;

// src/Icon/icons/Diploma.tsx
import { jsx as jsx602 } from "react/jsx-runtime";
var SvgDiploma = (props) => /* @__PURE__ */ jsx602(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx602(
      "path",
      {
        d: "M18.853 8.5h-2.066c.135-.306.213-.644.213-1C17 6.13 15.884 5 14.516 5c-1.025 0-1.72.472-2.516 1.467C11.203 5.472 10.51 5 9.484 5 8.116 5 7 6.13 7 7.5c0 .356.078.693.214 1H5c-1.657 0-3 1.515-3 4C2 14.985 3.343 17 5 17l5-1.072V18.5c0 .093.03.173.07.244.012.02.025.036.04.054.038.05.084.092.138.124.016.01.028.02.045.029a.48.48 0 0 0 .21.05c.008 0 .015-.003.022-.004.011 0 .02-.003.032-.005a.487.487 0 0 0 .244-.092L12 17.972l1.2.9c.076.057.16.082.245.092.01 0 .02.004.03.005.01.028.016.031.022.031.073 0 .143-.02.209-.05.017-.008.03-.02.045-.03a.487.487 0 0 0 .139-.123c.014-.018.026-.034.038-.054a.588.588 0 0 0 .072-.271V15.91L18.853 17C20.591 17 22 14.984 22 12.5s-1.41-4-3.147-4Zm-4.337-1.985a.985.985 0 1 1-.001 1.97h-2.121c1.268-1.89 1.631-1.97 2.122-1.97Zm-5.032 0c.49 0 .853.08 2.121 1.97h-2.12a.986.986 0 0 1 0-1.97Zm.2 7.948-4.793 1.026C4.29 15.366 3.5 14.23 3.5 12.5c0-1.472.617-2.5 1.5-2.5h4.519l-.01-.016H10v4.41l-.316.069Zm9.285 1.028L14 14.403V9.984h.49L14.48 10h4.369c.987 0 1.65 1.003 1.65 2.5 0 1.631-.784 2.869-1.531 2.99Z",
        fill: "currentColor"
      }
    )
  })
);
var Diploma_default = SvgDiploma;

// src/Icon/icons/DisplayArrowDown.tsx
import { jsx as jsx603 } from "react/jsx-runtime";
var SvgDisplayArrowDown = (props) => /* @__PURE__ */ jsx603(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx603(
      "path",
      {
        d: "M8.632 8.91a.833.833 0 0 0 0 1.178l2.778 2.778a.833.833 0 0 0 1.178 0l2.778-2.778a.833.833 0 1 0-1.178-1.178l-1.355 1.357V3.944a.832.832 0 1 0-1.666 0v6.323L9.78 8.91a.711.711 0 0 0-.559-.243.827.827 0 0 0-.59.243ZM19.778 3.11h-5.556v1.667h5.556c.306 0 .555.249.555.555v10c0 .307-.249.556-.555.556H4.222a.556.556 0 0 1-.555-.556v-10c0-.306.249-.555.555-.555h5.556V3.11H4.222A2.222 2.222 0 0 0 2 5.333v10c0 1.228.995 2.223 2.222 2.223h5.15l-.334 1.666h-1.76a.836.836 0 0 0-.834.834c0 .458.375.833.834.833h9.444a.834.834 0 0 0 0-1.667h-1.761l-.332-1.666h5.149A2.222 2.222 0 0 0 22 15.333v-10a2.223 2.223 0 0 0-2.222-2.222ZM10.74 19.222l.333-1.666h1.856l.333 1.666H10.74Z",
        fill: "currentColor"
      }
    )
  })
);
var DisplayArrowDown_default = SvgDisplayArrowDown;

// src/Icon/icons/DisplayCode.tsx
import { jsx as jsx604 } from "react/jsx-runtime";
var SvgDisplayCode = (props) => /* @__PURE__ */ jsx604(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx604(
      "path",
      {
        d: "M19.778 3.111H4.222A2.222 2.222 0 0 0 2 5.333v10c0 1.228.995 2.223 2.222 2.223h5.15l-.334 1.666h-1.76a.836.836 0 0 0-.834.834c0 .458.375.833.834.833h9.444a.834.834 0 0 0 0-1.667h-1.761l-.332-1.666h5.149A2.222 2.222 0 0 0 22 15.333v-10a2.223 2.223 0 0 0-2.222-2.222ZM10.74 19.222l.333-1.666h1.856l.333 1.666H10.74Zm9.593-3.889c0 .307-.249.556-.555.556H4.222a.556.556 0 0 1-.555-.556v-10c0-.306.249-.555.555-.555h15.556c.306 0 .555.249.555.555v10ZM14.573 7.9a.694.694 0 1 0-.982.983l1.176 1.175-1.176 1.175a.695.695 0 1 0 .983.982l1.667-1.667a.696.696 0 0 0 0-.983L14.573 7.9Zm-4.167 0a.694.694 0 0 0-.982 0L7.758 9.566a.695.695 0 0 0 0 .983l1.666 1.667a.7.7 0 0 0 .982 0 .696.696 0 0 0 0-.984l-1.173-1.176 1.173-1.174a.753.753 0 0 0 0-.983Z",
        fill: "currentColor"
      }
    )
  })
);
var DisplayCode_default = SvgDisplayCode;

// src/Icon/icons/DisplaySlash.tsx
import { jsx as jsx605 } from "react/jsx-runtime";
var SvgDisplaySlash = (props) => /* @__PURE__ */ jsx605(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx605(
      "path",
      {
        d: "m21.718 18.661-2.21-1.732c.86-.225 1.497-1 1.497-1.928V5.998a2 2 0 0 0-2-2H5c-.515 0-.98.198-1.332.517l-.456-.357a.75.75 0 1 0-.926 1.18l18.505 14.505c.138.106.3.16.435.16a.749.749 0 0 0 .59-.288.724.724 0 0 0-.1-1.054Zm-2.214-3.66a.5.5 0 0 1-.5.5h-1.319L4.94 5.51c.021-.003.04-.013.062-.013h14.003a.5.5 0 0 1 .5.5v9.003Zm-3.279 3.5H14.64l-.271-1.5h.385l-1.915-1.5H5a.5.5 0 0 1-.5-.5V8.965L3 7.789V15a2 2 0 0 0 2 2h4.636l-.3 1.5H7.723a.75.75 0 0 0 0 1.501h8.474a.75.75 0 0 0 .75-.75c0-.414-.28-.75-.722-.75Zm-5.357 0 .3-1.5h1.67l.301 1.5h-2.271Z",
        fill: "currentColor"
      }
    )
  })
);
var DisplaySlash_default = SvgDisplaySlash;

// src/Icon/icons/Display.tsx
import { jsx as jsx606 } from "react/jsx-runtime";
var SvgDisplay = (props) => /* @__PURE__ */ jsx606(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx606(
      "path",
      {
        d: "M19.778 3.111H4.222A2.222 2.222 0 0 0 2 5.333v10c0 1.228.995 2.223 2.222 2.223h5.15l-.334 1.666h-1.76a.836.836 0 0 0-.834.834c0 .458.375.833.834.833h9.444a.834.834 0 0 0 0-1.667h-1.761l-.332-1.666h5.149A2.222 2.222 0 0 0 22 15.333v-10a2.223 2.223 0 0 0-2.222-2.222ZM13.26 19.222h-2.52l.333-1.666h1.856l.331 1.666Zm7.073-3.889c0 .307-.249.556-.555.556H4.222a.556.556 0 0 1-.555-.556v-10c0-.306.249-.555.555-.555h15.556c.306 0 .555.249.555.555v10Z",
        fill: "currentColor"
      }
    )
  })
);
var Display_default = SvgDisplay;

// src/Icon/icons/DistributeSpacingHorizontal.tsx
import { jsx as jsx607 } from "react/jsx-runtime";
var SvgDistributeSpacingHorizontal = (props) => /* @__PURE__ */ jsx607(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx607(
      "path",
      {
        d: "M19.813 2c.519 0 .937.42.937.938v18.125c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938V2.938c0-.517.418-.937.938-.937ZM15.75 16.375c0 1.035-.84 1.875-1.875 1.875h-3.75a1.875 1.875 0 0 1-1.875-1.875v-8.75c0-1.035.84-1.875 1.875-1.875h3.75c1.035 0 1.875.84 1.875 1.875v8.75Zm-1.875 0v-8.75h-3.75v8.75h3.75Zm-8.75 4.688a.937.937 0 1 1-1.875 0V2.938a.938.938 0 0 1 1.875 0v18.125Z",
        fill: "currentColor"
      }
    )
  })
);
var DistributeSpacingHorizontal_default = SvgDistributeSpacingHorizontal;

// src/Icon/icons/DistributeSpacingVertical.tsx
import { jsx as jsx608 } from "react/jsx-runtime";
var SvgDistributeSpacingVertical = (props) => /* @__PURE__ */ jsx608(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx608(
      "path",
      {
        d: "M2 4.188c0-.518.42-.938.938-.938h18.125a.937.937 0 1 1 0 1.875H2.938A.938.938 0 0 1 2 4.187ZM16.375 8.25c1.035 0 1.875.84 1.875 1.875v3.75c0 1.035-.84 1.875-1.875 1.875h-8.75a1.875 1.875 0 0 1-1.875-1.875v-3.75c0-1.035.84-1.875 1.875-1.875h8.75Zm0 1.875h-8.75v3.75h8.75v-3.75Zm4.688 8.75c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H2.938a.937.937 0 1 1 0-1.875h18.125Z",
        fill: "currentColor"
      }
    )
  })
);
var DistributeSpacingVertical_default = SvgDistributeSpacingVertical;

// src/Icon/icons/Divide.tsx
import { jsx as jsx609 } from "react/jsx-runtime";
var SvgDivide = (props) => /* @__PURE__ */ jsx609(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx609(
      "path",
      {
        d: "M20.929 10.929H3.07C2.48 10.929 2 11.41 2 12c0 .59.48 1.071 1.071 1.071H20.93c.593 0 1.071-.477 1.071-1.071s-.478-1.071-1.071-1.071ZM12 7a2.143 2.143 0 1 0 0-4.286A2.143 2.143 0 0 0 12 7Zm0 10a2.143 2.143 0 1 0 0 4.286A2.143 2.143 0 0 0 12 17Z",
        fill: "currentColor"
      }
    )
  })
);
var Divide_default = SvgDivide;

// src/Icon/icons/DoNotEnter.tsx
import { jsx as jsx610 } from "react/jsx-runtime";
var SvgDoNotEnter = (props) => /* @__PURE__ */ jsx610(
  "svg",
  __spreadProps(__spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), {
    children: /* @__PURE__ */ jsx610(
      "path",
      {
        d: "M11.334 6.75065C11.7949 6.75065 12.1673 7.12305 12.1673 7.58398V8.41732C12.1673 8.87826 11.7949 9.25065 11.334 9.25065H4.66732C4.20638 9.25065 3.83398 8.87826 3.83398 8.41732V7.58398C3.83398 7.12305 4.20638 6.75065 4.66732 6.75065H11.334ZM14.6673 8.00065C14.6673 11.6829 11.6829 14.6673 8.00065 14.6673C4.31836 14.6673 1.33398 11.6829 1.33398 8.00065C1.33398 4.31836 4.31836 1.33398 8.00065 1.33398C11.6829 1.33398 14.6673 4.31836 14.6673 8.00065ZM8.00065 2.58398C5.00846 2.58398 2.58398 5.00846 2.58398 8.00065C2.58398 10.9928 5.00846 13.4173 8.00065 13.4173C10.9928 13.4173 13.4173 10.9928 13.4173 8.00065C13.4173 5.00846 10.9928 2.58398 8.00065 2.58398Z",
        fill: "currentColor"
      }
    )
  })
);
var DoNotEnter_default = SvgDoNotEnter;

// src/Icon/icons/DoorClosed.tsx
import { jsx as jsx611 } from "react/jsx-runtime";
var SvgDoorClosed = (props) => /* @__PURE__ */ jsx611(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx611(
      "path",
      {
        d: "M14.778 10.889c-.612 0-1.111.5-1.111 1.111 0 .612.499 1.111 1.11 1.111.613 0 1.112-.5 1.112-1.111 0-.612-.5-1.111-1.111-1.111Zm6.389 8.333h-2.5V5.333c0-1.222-1-2.222-2.223-2.222H7.556c-1.223 0-2.223 1-2.223 2.222v13.89h-2.5a.832.832 0 1 0 0 1.666h18.334a.834.834 0 0 0 0-1.667Zm-4.167 0H7V5.333c0-.307.249-.555.556-.555h8.888c.307 0 .556.248.556.555v13.89Z",
        fill: "currentColor"
      }
    )
  })
);
var DoorClosed_default = SvgDoorClosed;

// src/Icon/icons/DoorOpen.tsx
import { jsx as jsx612 } from "react/jsx-runtime";
var SvgDoorOpen = (props) => /* @__PURE__ */ jsx612(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx612(
      "path",
      {
        d: "M9.778 13.111c.46 0 .833-.499.833-1.08 0-.58-.371-1.142-.833-1.142-.462 0-.834.5-.834 1.111s.375 1.111.834 1.111Zm2.222-10c-.087 0-.177.013-.267.035L5.066 4.874c-.528.13-.844.59-.844 1.115v13.233H2.833a.832.832 0 1 0 0 1.667H12c.614 0 1.111-.498 1.111-1.111V4.26c0-.65-.51-1.15-1.111-1.15Zm-.556 16.111H5.89V6.38l5.555-1.437v14.28Zm9.723 0h-1.39V7.556a2.222 2.222 0 0 0-2.221-2.223h-3.334V7h3.334c.306 0 .555.249.555.556v12.222c0 .613.498 1.11 1.111 1.11h1.945a.834.834 0 0 0 0-1.666Z",
        fill: "currentColor"
      }
    )
  })
);
var DoorOpen_default = SvgDoorOpen;

// src/Icon/icons/Dove.tsx
import { jsx as jsx613 } from "react/jsx-runtime";
var SvgDove = (props) => /* @__PURE__ */ jsx613(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx613(
      "path",
      {
        d: "M16.392 8.263a.63.63 0 0 0 .625.625c.342 0 .626-.29.626-.632a.627.627 0 0 0-.626-.625.628.628 0 0 0-.625.632Zm.59-3.763a3.751 3.751 0 0 0-3.667 2.987c-1.132-1.431-1.914-3.116-2.197-4.942-.05-.518-.699-.745-1.05-.33a10.587 10.587 0 0 0-2.153 4.11c-.062.223-.094.454-.133.684a10.476 10.476 0 0 1-2.369-3.375c-.215-.488-.912-.51-1.141-.026a10.597 10.597 0 0 0-1.008 4.374c-.049 3.755 2.141 6.375 3.748 7.79l-4.458 1.503c-.474.127-.688.713-.42 1.143.772 1.265 2.69 3.4 6.825 3.58.527.024.69-.18.988-.367l2.984-2.114h1.587c3.452 0 6.215-2.804 6.215-6.262V8.247l1.25-3.749-5 .002ZM9.728 6.806c.102-.38.23-.747.376-1.104.62 1.504 1.558 2.853 2.705 4.005a10.692 10.692 0 0 1-3.281-1.334 6.777 6.777 0 0 1 .2-1.567Zm9.164 1.14v5.318c0 2.412-1.963 4.36-4.375 4.36h-2.183l-3.491 2.49c-2.047-.132-3.36-.835-4.18-1.573l6.016-2.031c-2.183-1.817-5.59-4.31-5.54-8.5.005-.352.03-.665.073-1.007 3.624 4.731 9.302 5 9.927 5v-3.74c0-1.04.84-1.88 1.875-1.88h2.398l-.52 1.564Z",
        fill: "currentColor"
      }
    )
  })
);
var Dove_default = SvgDove;

// src/Icon/icons/DownFromDottedLine.tsx
import { jsx as jsx614 } from "react/jsx-runtime";
var SvgDownFromDottedLine = (props) => /* @__PURE__ */ jsx614(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx614(
      "path",
      {
        d: "m10.397 21.281-5.713-6.428a2.146 2.146 0 0 1-.353-2.304c.346-.768 1.111-1.303 1.915-1.303h2.142v-2.5c0-1.34 1.161-2.5 2.5-2.5h2.183c1.38 0 2.5 1.16 2.5 2.5v2.5h2.143c.844 0 1.607.535 1.956 1.303a2.154 2.154 0 0 1-.353 2.304l-5.714 6.428A2.175 2.175 0 0 1 11.96 22a2.133 2.133 0 0 1-1.563-.719Zm7.317-7.852H13.43V8.786a.358.358 0 0 0-.358-.357h-2.183c-.156 0-.357.16-.357.357v4.643H6.246l5.714 6.428 5.754-6.428Zm4.286-10a1.428 1.428 0 1 1-2.856 0 1.428 1.428 0 0 1 2.856 0Zm-7.143 0a1.428 1.428 0 1 1 2.856-.002 1.428 1.428 0 0 1-2.856.002Zm-1.428 0a1.428 1.428 0 1 1-2.856 0 1.428 1.428 0 0 1 2.856 0Zm-7.143 0a1.428 1.428 0 1 1 2.856-.002 1.428 1.428 0 0 1-2.856.002Zm-1.429 0a1.429 1.429 0 1 1-2.857 0 1.429 1.429 0 0 1 2.857 0Z",
        fill: "currentColor"
      }
    )
  })
);
var DownFromDottedLine_default = SvgDownFromDottedLine;

// src/Icon/icons/DownFromLine.tsx
import { jsx as jsx615 } from "react/jsx-runtime";
var SvgDownFromLine = (props) => /* @__PURE__ */ jsx615(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx615(
      "path",
      {
        d: "M17.487 11.286H15.57V8.429a2.14 2.14 0 0 0-2.142-2.141H10.57a2.14 2.14 0 0 0-2.142 2.14v2.858H6.496c-1.859 0-2.836 2.204-1.588 3.581l6.08 6.715c.28.28.646.418 1.012.418s.731-.14 1.01-.419l6.067-6.714c1.244-1.38.267-3.581-1.59-3.581ZM12 19.563l-5.418-6.134h3.99v-5h2.857v5h3.99L12 19.562ZM19.5 2h-15a1.072 1.072 0 0 0 0 2.143h15A1.07 1.07 0 1 0 19.5 2Z",
        fill: "currentColor"
      }
    )
  })
);
var DownFromLine_default = SvgDownFromLine;

// src/Icon/icons/DownLeftAndUpRightToCenter.tsx
import { jsx as jsx616 } from "react/jsx-runtime";
var SvgDownLeftAndUpRightToCenter = (props) => /* @__PURE__ */ jsx616(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx616(
      "path",
      {
        d: "M21.676 2.293a1 1 0 0 0-1.414 0l-3.39 3.39-1.96-1.959a1.333 1.333 0 0 0-2.276.943v5.63c0 .551.447.962 1 .962h5.667a1.332 1.332 0 0 0 .942-2.276l-1.96-1.96 3.391-3.39c.425-.317.425-.95 0-1.34ZM10.301 12.667H4.634c-.539 0-1.026.325-1.232.823a1.416 1.416 0 0 0 .327 1.452l1.96 1.96-3.391 3.39a1 1 0 1 0 1.414 1.415l3.391-3.391 1.96 1.96a1.333 1.333 0 0 0 2.276-.943v-5.666c-.038-.554-.446-1-1.038-1Z",
        fill: "currentColor"
      }
    )
  })
);
var DownLeftAndUpRightToCenter_default = SvgDownLeftAndUpRightToCenter;

// src/Icon/icons/DownLeft.tsx
import { jsx as jsx617 } from "react/jsx-runtime";
var SvgDownLeft = (props) => /* @__PURE__ */ jsx617(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx617(
      "path",
      {
        d: "m16.943 4.626 2.455 2.453-8.495 8.494 3.801 3.801H4.603V9.321L8.4 13.12l8.542-8.494c0-.049 0 0 0 0Zm0-2.603c-.665 0-1.332.254-1.84.763L8.453 9.44 5.01 6.003c-.331-.336-.774-.558-1.226-.558-.224 0-.45.043-.664.134C2.472 5.895 2 6.53 2 7.23v13.013c0 .96.826 1.735 1.735 1.735h13.013a1.734 1.734 0 0 0 1.227-2.962l-3.39-3.442 6.653-6.658a2.602 2.602 0 0 0 0-3.68L18.784 2.78a2.606 2.606 0 0 0-1.84-.758Z",
        fill: "currentColor"
      }
    )
  })
);
var DownLeft_default = SvgDownLeft;

// src/Icon/icons/DownLong.tsx
import { jsx as jsx618 } from "react/jsx-runtime";
var SvgDownLong = (props) => /* @__PURE__ */ jsx618(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx618(
      "path",
      {
        d: "M7.134 16.308a.926.926 0 0 1 .824-.564h3.125V2.937c0-.517.42-.937.902-.937.482 0 .938.42.938.937v12.808h3.09a.937.937 0 0 1 .686 1.577L12.637 21.7a.938.938 0 0 1-1.374 0L7.2 17.322c-.147-.272-.215-.67-.066-1.014Z",
        fill: "currentColor"
      }
    )
  })
);
var DownLong_default = SvgDownLong;

// src/Icon/icons/DownRight.tsx
import { jsx as jsx619 } from "react/jsx-runtime";
var SvgDownRight = (props) => /* @__PURE__ */ jsx619(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx619(
      "path",
      {
        d: "m7.067 4.609 8.516 8.516 3.808-3.807V19.39H9.315l3.807-3.807-8.516-8.516 2.46-2.46c.001-.048 0 0 0 0Zm0-2.609a2.6 2.6 0 0 0-1.844.764L2.764 5.223a2.609 2.609 0 0 0 0 3.689l6.67 6.67-3.447 3.447A1.74 1.74 0 0 0 7.217 22h13.044c.96 0 1.69-.778 1.69-1.69L22 7.217c0-.703-.424-1.338-1.073-1.606a1.713 1.713 0 0 0-.667-.135c-.452 0-.895.178-1.229.512l-3.447 3.447-6.671-6.67A2.606 2.606 0 0 0 7.068 2Z",
        fill: "currentColor"
      }
    )
  })
);
var DownRight_default = SvgDownRight;

// src/Icon/icons/DownToBracket.tsx
import { jsx as jsx620 } from "react/jsx-runtime";
var SvgDownToBracket = (props) => /* @__PURE__ */ jsx620(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx620(
      "path",
      {
        d: "M17 22H7a3.75 3.75 0 0 1-3.75-3.75v-2.813a.937.937 0 1 1 1.875 0v2.813A1.88 1.88 0 0 0 7 20.125h10a1.88 1.88 0 0 0 1.875-1.875v-2.813c0-.519.418-.937.938-.937.519 0 .937.418.937.938v2.812c0 2.07-1.68 3.75-3.75 3.75Zm-5.7-5.629-5.22-5.953a1.307 1.307 0 0 1-.214-1.41c.207-.461.663-.758 1.161-.758h2.16V3.562c0-.861.7-1.562 1.563-1.562h2.5c.863 0 1.563.7 1.563 1.563V8.25h2.16c.5 0 .953.297 1.16.758a1.32 1.32 0 0 1-.211 1.41l-5.223 5.953a.92.92 0 0 1-.699.317.92.92 0 0 1-.7-.317Zm.7-2.035 3.672-4.211h-2.735v-6.25h-1.874v6.25h-2.77L12 14.335Z",
        fill: "currentColor"
      }
    )
  })
);
var DownToBracket_default = SvgDownToBracket;

// src/Icon/icons/DownToDottedLine.tsx
import { jsx as jsx621 } from "react/jsx-runtime";
var SvgDownToDottedLine = (props) => /* @__PURE__ */ jsx621(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx621(
      "path",
      {
        d: "m10.397 16.995-5.713-6.428a2.146 2.146 0 0 1-.353-2.304A2.145 2.145 0 0 1 6.286 7h2.143V4.5a2.5 2.5 0 0 1 2.5-2.5h2.142a2.5 2.5 0 0 1 2.5 2.5V7h2.143c.844 0 1.607.496 1.956 1.263a2.154 2.154 0 0 1-.353 2.304l-5.714 6.428a2.152 2.152 0 0 1-1.603.72 2.152 2.152 0 0 1-1.603-.72Zm7.317-7.852H13.43V4.5a.358.358 0 0 0-.358-.357H10.93a.358.358 0 0 0-.358.357v4.643H6.286L12 15.57l5.714-6.428ZM2 20.57a1.428 1.428 0 1 1 2.856-.001A1.428 1.428 0 0 1 2 20.571Zm7.143 0c0 .79-.639 1.429-1.429 1.429s-1.428-.638-1.428-1.429c0-.79.638-1.428 1.428-1.428.79 0 1.429.638 1.429 1.428Zm1.428 0c0-.79.639-1.428 1.429-1.428s1.429.638 1.429 1.428c0 .79-.639 1.429-1.429 1.429s-1.429-.638-1.429-1.429Zm7.143 0a1.427 1.427 0 1 1-2.857 0c0-.79.638-1.428 1.429-1.428.79 0 1.428.638 1.428 1.428Zm1.429 0c0-.79.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857c-.79 0-1.428-.638-1.428-1.429Z",
        fill: "currentColor"
      }
    )
  })
);
var DownToDottedLine_default = SvgDownToDottedLine;

// src/Icon/icons/DownToLine.tsx
import { jsx as jsx622 } from "react/jsx-runtime";
var SvgDownToLine = (props) => /* @__PURE__ */ jsx622(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx622(
      "path",
      {
        d: "M11.009 17.295a1.422 1.422 0 0 0 2.019.001l6.067-6.714C20.339 9.2 19.362 7 17.505 7h-1.916V4.143c0-1.184-.96-2.143-2.143-2.143h-2.857c-1.184 0-2.143.96-2.143 2.143V7H6.513c-1.859 0-2.836 2.204-1.588 3.582l6.084 6.713Zm-.42-8.152v-5h2.857v5h3.99l-5.42 6.134L6.6 9.143h3.99ZM19.5 19.857h-15c-.592 0-1.071.482-1.071 1.072 0 .589.48 1.071 1.071 1.071h15a1.072 1.072 0 0 0 0-2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var DownToLine_default = SvgDownToLine;

// src/Icon/icons/Down.tsx
import { jsx as jsx623 } from "react/jsx-runtime";
var SvgDown = (props) => /* @__PURE__ */ jsx623(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx623(
      "path",
      {
        d: "M20.464 12.17a1.434 1.434 0 0 0-1.321-.884H15.57V4.143c0-1.184-.96-2.143-2.143-2.143h-2.857c-1.183 0-2.143.96-2.143 2.143v7.143H4.857a1.428 1.428 0 0 0-1.01 2.437l7.143 7.857c.278.282.644.42 1.01.42s.731-.14 1.01-.419l7.143-7.857c.41-.407.53-1.023.311-1.554ZM12 19.563 6.58 13.428h3.99V4.143h2.857v9.286h3.99L12 19.562Z",
        fill: "currentColor"
      }
    )
  })
);
var Down_default = SvgDown;

// src/Icon/icons/Download.tsx
import { jsx as jsx624 } from "react/jsx-runtime";
var SvgDownload = (props) => /* @__PURE__ */ jsx624(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx624(
      "path",
      {
        d: "M19.5 13.875h-2.09l-1.875 1.875H19.5c.345 0 .625.28.625.625V19.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625v-3.125c0-.344.28-.625.625-.625h3.965L6.59 13.875H4.5a2.5 2.5 0 0 0-2.5 2.5V19.5A2.5 2.5 0 0 0 4.5 22h15a2.5 2.5 0 0 0 2.5-2.5v-3.125c0-1.379-1.121-2.5-2.5-2.5Zm-.625 4.063a.937.937 0 1 0-1.875 0 .937.937 0 0 0 1.875 0Zm-7.54-1.56a.842.842 0 0 0 .665.31c.242 0 .48-.092.663-.275l5.312-5.313a.937.937 0 1 0-1.325-1.325l-3.712 3.713V2.938a.937.937 0 1 0-1.876 0v10.55L7.316 9.773A.937.937 0 1 0 5.991 11.1l5.345 5.28Z",
        fill: "currentColor"
      }
    )
  })
);
var Download_default = SvgDownload;

// src/Icon/icons/DrawCircle.tsx
import { jsx as jsx625 } from "react/jsx-runtime";
var SvgDrawCircle = (props) => /* @__PURE__ */ jsx625(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx625(
      "path",
      {
        d: "M20.082 9.566C21.184 9.832 22 10.82 22 11.965a2.515 2.515 0 0 1-1.918 2.469 8.456 8.456 0 0 1-5.648 5.648A2.515 2.515 0 0 1 11.964 22c-1.144 0-2.132-.816-2.398-1.918a8.456 8.456 0 0 1-5.648-5.648A2.506 2.506 0 0 1 2 12c0-1.18.818-2.168 1.918-2.434a8.455 8.455 0 0 1 5.648-5.648A2.506 2.506 0 0 1 12 2c1.18 0 2.168.818 2.434 1.918a8.456 8.456 0 0 1 5.648 5.648ZM11.965 5.09c.379 0 .66-.245.66-.625 0-.31-.281-.625-.66-.625-.309 0-.625.315-.625.625 0 .38.316.625.625.625Zm2.176.704c-.438.722-1.235 1.17-2.176 1.17-.871 0-1.668-.448-2.106-1.17A6.577 6.577 0 0 0 5.794 9.86C6.516 10.297 7 11.094 7 11.965a2.52 2.52 0 0 1-1.206 2.176 6.581 6.581 0 0 0 4.065 4.066 2.502 2.502 0 0 1 4.282 0 6.585 6.585 0 0 0 4.066-4.066A2.523 2.523 0 0 1 17 11.965c0-.871.484-1.668 1.207-2.106a6.581 6.581 0 0 0-4.066-4.065Zm-2.176 14.331c.379 0 .66-.281.66-.625s-.281-.625-.66-.625c-.309 0-.625.281-.625.625s.316.625.625.625Zm-7.5-8.785c-.31 0-.625.316-.625.625 0 .379.315.625.625.625.38 0 .625-.246.625-.625a.625.625 0 0 0-.625-.625ZM19.5 12.59a.605.605 0 0 0 .625-.625c0-.309-.281-.625-.625-.625s-.625.316-.625.625c0 .379.281.625.625.625Z",
        fill: "currentColor"
      }
    )
  })
);
var DrawCircle_default = SvgDrawCircle;

// src/Icon/icons/DrawPolygon.tsx
import { jsx as jsx626 } from "react/jsx-runtime";
var SvgDrawPolygon = (props) => /* @__PURE__ */ jsx626(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx626(
      "path",
      {
        d: "M18.7 16.321a2.86 2.86 0 0 1 3.3 2.822A2.86 2.86 0 0 1 19.143 22c-1.201 0-2.228-.737-2.648-1.786h-8.99A2.848 2.848 0 0 1 4.856 22 2.858 2.858 0 0 1 2 19.143c0-1.201.739-2.228 1.786-2.648v-8.99a2.857 2.857 0 1 1 3.719-3.719h8.99A2.85 2.85 0 0 1 19.143 2a2.858 2.858 0 0 1 0 5.714c-.152 0-.3-.013-.442-.035l-1.563 2.602c.362.478.576 1.072.576 1.719s-.214 1.241-.576 1.719l1.563 2.602ZM4.858 4.143a.714.714 0 1 0 0 1.428.714.714 0 0 0 0-1.428ZM5.93 16.495c.714.286 1.29.822 1.575 1.576h8.992c.093-.232.214-.45.366-.647l-1.563-2.603A2.86 2.86 0 0 1 12 12a2.86 2.86 0 0 1 3.3-2.821l1.563-2.603a2.721 2.721 0 0 1-.366-.647H7.503A2.845 2.845 0 0 1 5.93 7.504v8.992ZM19.143 4.143a.715.715 0 0 0 0 1.428.715.715 0 0 0 0-1.429ZM4.857 19.857a.715.715 0 0 0 0-1.428.715.715 0 0 0 0 1.428Zm14.286-1.428a.716.716 0 0 0-.714.714c0 .393.321.714.714.714a.716.716 0 0 0 .714-.714.716.716 0 0 0-.714-.714Zm-4.286-5.715a.716.716 0 0 0 .714-.714.716.716 0 0 0-.714-.714.716.716 0 0 0-.714.714c0 .393.321.714.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var DrawPolygon_default = SvgDrawPolygon;

// src/Icon/icons/DrawSquare.tsx
import { jsx as jsx627 } from "react/jsx-runtime";
var SvgDrawSquare = (props) => /* @__PURE__ */ jsx627(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx627(
      "path",
      {
        d: "M7.504 20.214A2.848 2.848 0 0 1 4.857 22 2.858 2.858 0 0 1 2 19.143c0-1.201.739-2.228 1.786-2.648v-8.99a2.857 2.857 0 1 1 3.719-3.719h8.99A2.85 2.85 0 0 1 19.143 2 2.858 2.858 0 0 1 22 4.857c0 1.201-.737 2.228-1.786 2.647v8.992A2.846 2.846 0 0 1 22 19.142 2.86 2.86 0 0 1 19.143 22c-1.201 0-2.228-.737-2.648-1.786h-8.99ZM4.857 5.571a.715.715 0 1 0-.002-1.43.715.715 0 0 0 .002 1.43ZM5.93 16.496c.714.285 1.29.821 1.575 1.575h8.992a2.623 2.623 0 0 1 1.575-1.576v-8.99c-.754-.286-1.29-.862-1.576-1.576h-8.99a2.845 2.845 0 0 1-1.576 1.575v8.992Zm-1.072 1.933a.715.715 0 0 0 0 1.428.715.715 0 0 0 0-1.428Zm14.286 0a.716.716 0 0 0-.714.714c0 .393.321.714.714.714a.716.716 0 0 0 .714-.714.716.716 0 0 0-.714-.714Zm0-14.286a.715.715 0 0 0 0 1.428.715.715 0 0 0 0-1.429Z",
        fill: "currentColor"
      }
    )
  })
);
var DrawSquare_default = SvgDrawSquare;

// src/Icon/icons/E.tsx
import { jsx as jsx628 } from "react/jsx-runtime";
var SvgE = (props) => /* @__PURE__ */ jsx628(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx628(
      "path",
      {
        d: "M19.143 20.929c0 .591-.48 1.071-1.072 1.071H5.93a1.07 1.07 0 0 1-1.072-1.071V3.07C4.857 2.48 5.337 2 5.93 2H18.07a1.07 1.07 0 1 1 0 2.143H7v6.786h8.214a1.072 1.072 0 0 1 0 2.142H7v6.786h11.071c.594 0 1.072.482 1.072 1.072Z",
        fill: "currentColor"
      }
    )
  })
);
var E_default = SvgE;

// src/Icon/icons/Eject.tsx
import { jsx as jsx629 } from "react/jsx-runtime";
var SvgEject = (props) => /* @__PURE__ */ jsx629(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx629(
      "path",
      {
        d: "M4.143 16.245h15.674c1.858 0 2.835-2.215 1.58-3.588L13.58 4.08A2.254 2.254 0 0 0 12 3.429c-.578 0-1.155.23-1.579.69l-7.857 8.577c-1.255 1.366-.279 3.55 1.58 3.55Zm7.853-10.674 7.821 8.572H4.145l7.85-8.572Zm8.933 12.857H3.07a1.07 1.07 0 1 0 0 2.143H20.93a1.071 1.071 0 0 0 0-2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var Eject_default = SvgEject;

// src/Icon/icons/EllipsisStrokeVertical.tsx
import { jsx as jsx630 } from "react/jsx-runtime";
var SvgEllipsisStrokeVertical = (props) => /* @__PURE__ */ jsx630(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx630(
      "path",
      {
        d: "M12 22a2.858 2.858 0 0 1 0-5.714 2.86 2.86 0 0 1 2.857 2.857A2.86 2.86 0 0 1 12 22Zm1.072-2.857c0-.594-.478-1.072-1.072-1.072a1.07 1.07 0 1 0 0 2.143c.594 0 1.072-.477 1.072-1.071ZM12 14.857a2.858 2.858 0 0 1 0-5.714A2.86 2.86 0 0 1 14.857 12 2.86 2.86 0 0 1 12 14.857ZM13.072 12c0-.594-.478-1.071-1.072-1.071a1.07 1.07 0 1 0 0 2.142c.594 0 1.072-.477 1.072-1.071ZM12 2a2.858 2.858 0 0 1 2.857 2.857A2.858 2.858 0 1 1 12 2Zm-1.071 2.857c0 .594.48 1.072 1.071 1.072.594 0 1.072-.478 1.072-1.072a1.07 1.07 0 1 0-2.143 0Z",
        fill: "currentColor"
      }
    )
  })
);
var EllipsisStrokeVertical_default = SvgEllipsisStrokeVertical;

// src/Icon/icons/EllipsisStroke.tsx
import { jsx as jsx631 } from "react/jsx-runtime";
var SvgEllipsisStroke = (props) => /* @__PURE__ */ jsx631(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx631(
      "path",
      {
        d: "M22 12a2.86 2.86 0 0 1-2.857 2.857A2.86 2.86 0 0 1 16.286 12a2.86 2.86 0 0 1 2.857-2.857A2.86 2.86 0 0 1 22 12Zm-2.857-1.071c-.594 0-1.072.477-1.072 1.071s.478 1.071 1.072 1.071c.594 0 1.071-.477 1.071-1.071s-.477-1.071-1.071-1.071ZM14.857 12A2.86 2.86 0 0 1 12 14.857 2.86 2.86 0 0 1 9.143 12 2.86 2.86 0 0 1 12 9.143 2.86 2.86 0 0 1 14.857 12ZM12 10.929c-.594 0-1.071.477-1.071 1.071s.477 1.071 1.071 1.071 1.071-.477 1.071-1.071-.477-1.071-1.071-1.071ZM2 12a2.858 2.858 0 0 1 5.714 0A2.858 2.858 0 0 1 2 12Zm2.857 1.071c.594 0 1.072-.477 1.072-1.071s-.478-1.071-1.072-1.071a1.07 1.07 0 1 0 0 2.142Z",
        fill: "currentColor"
      }
    )
  })
);
var EllipsisStroke_default = SvgEllipsisStroke;

// src/Icon/icons/EllipsisVertical.tsx
import { jsx as jsx632 } from "react/jsx-runtime";
var SvgEllipsisVertical = (props) => /* @__PURE__ */ jsx632(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx632(
      "path",
      {
        d: "M12 17.385A2.308 2.308 0 1 1 12 22a2.308 2.308 0 0 1 0-4.616Zm0-7.693a2.308 2.308 0 1 1 0 4.616 2.308 2.308 0 0 1 0-4.616Zm0-3.077A2.308 2.308 0 1 1 12 2a2.308 2.308 0 0 1 0 4.616Z",
        fill: "currentColor"
      }
    )
  })
);
var EllipsisVertical_default = SvgEllipsisVertical;

// src/Icon/icons/Ellipsis.tsx
import { jsx as jsx633 } from "react/jsx-runtime";
var SvgEllipsis = (props) => /* @__PURE__ */ jsx633(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx633(
      "path",
      {
        d: "M17.385 12a2.308 2.308 0 1 1 4.616.001A2.308 2.308 0 0 1 17.385 12Zm-7.693 0a2.308 2.308 0 1 1 4.617.001A2.308 2.308 0 0 1 9.692 12Zm-3.077 0A2.308 2.308 0 1 1 2 12a2.308 2.308 0 0 1 4.616 0Z",
        fill: "currentColor"
      }
    )
  })
);
var Ellipsis_default = SvgEllipsis;

// src/Icon/icons/EnvelopeCircleCheck.tsx
import { jsx as jsx634 } from "react/jsx-runtime";
var SvgEnvelopeCircleCheck = (props) => /* @__PURE__ */ jsx634(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx634(
      "path",
      {
        d: "M4 7h12c.275 0 .5.225.5.5v.69l-.706.579A5.51 5.51 0 0 1 18 8.522V7.5c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h9.256a5.476 5.476 0 0 1-.881-1.5H4a.501.501 0 0 1-.5-.5v-5.369l4.438 3.644a3.248 3.248 0 0 0 4.065.047 5.428 5.428 0 0 1 .7-2.513l-1.59 1.307a1.748 1.748 0 0 1-2.222 0L3.5 8.19V7.5c0-.275.225-.5.5-.5Zm18 7a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0Zm-2.397-1.353a.502.502 0 0 1 0 .706l-2.25 2.25a.502.502 0 0 1-.706 0l-1.25-1.25a.502.502 0 0 1 0-.706.502.502 0 0 1 .706 0l.897.897 1.897-1.897a.502.502 0 0 1 .706 0Z",
        fill: "currentColor"
      }
    )
  })
);
var EnvelopeCircleCheck_default = SvgEnvelopeCircleCheck;

// src/Icon/icons/EnvelopeDot.tsx
import { jsx as jsx635 } from "react/jsx-runtime";
var SvgEnvelopeDot = (props) => /* @__PURE__ */ jsx635(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx635(
      "path",
      {
        d: "M19.222 9.778a2.778 2.778 0 1 0 0-5.556 2.778 2.778 0 0 0 0 5.556Zm.556 7.778V10.85c-.18.024-.368.038-.556.038-.781 0-1.51-.23-2.118-.629l-4.982 4.09c-.72.591-1.75.591-2.47 0L3.668 9.435v-.767c0-.306.25-.556.555-.556h11.271a3.906 3.906 0 0 1-.122-1.667H4.223A2.224 2.224 0 0 0 2 8.667v8.889c0 1.225.997 2.222 2.222 2.222h13.334a2.224 2.224 0 0 0 2.222-2.222ZM3.667 11.59l4.93 4.049a3.611 3.611 0 0 0 4.584 0l4.93-4.049v5.966c0 .305-.25.555-.555.555H4.222a.557.557 0 0 1-.555-.555V11.59Z",
        fill: "currentColor"
      }
    )
  })
);
var EnvelopeDot_default = SvgEnvelopeDot;

// src/Icon/icons/EnvelopeOpenDollar.tsx
import { jsx as jsx636 } from "react/jsx-runtime";
var SvgEnvelopeOpenDollar = (props) => /* @__PURE__ */ jsx636(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx636(
      "path",
      {
        d: "M6.687 3.877a.313.313 0 0 0-.313.312v6.608l-1.671-1.37a2.452 2.452 0 0 0-.203-.15V4.19c0-1.207.98-2.187 2.187-2.187H17.31c1.206 0 2.187.98 2.187 2.187v5.085c-.07.047-.137.098-.203.148l-1.672 1.375V4.19a.313.313 0 0 0-.313-.312H6.688Zm-2.812 8.912v7.022c0 .172.14.312.312.312H19.81c.172 0 .313-.14.313-.312v-7.022l-5.546 4.554a4.062 4.062 0 0 1-5.156 0l-5.545-4.554ZM2 11.293a1.168 1.168 0 0 1 1.91-.902l6.702 5.507a2.185 2.185 0 0 0 2.776 0l6.702-5.507a1.167 1.167 0 0 1 1.91.902v8.518c0 1.207-.98 2.187-2.187 2.187H4.187A2.188 2.188 0 0 1 2 19.811v-8.518ZM12.78 5.44v.543c.292.047.57.113.823.183a.782.782 0 1 1-.402 1.512c-.43-.114-.844-.196-1.219-.203-.308-.004-.624.07-.84.195-.187.11-.241.219-.241.363 0 .07.004.137.207.262.246.148.605.261 1.105.41l.027.008c.438.132 1 .3 1.45.585.503.317.948.832.96 1.625.012.816-.41 1.41-.969 1.758a2.8 2.8 0 0 1-.906.351v.531c0 .43-.351.781-.78.781a.783.783 0 0 1-.782-.78v-.571a8.852 8.852 0 0 1-1.101-.328c-.082-.027-.16-.055-.239-.082a.779.779 0 0 1-.492-.988.78.78 0 0 1 .989-.492c.097.031.19.066.28.093.532.18.938.317 1.371.332.336.012.645-.062.836-.183.16-.098.235-.215.23-.41 0-.114-.03-.195-.23-.32-.246-.157-.601-.27-1.093-.418l-.067-.02c-.425-.129-.96-.289-1.39-.547-.496-.3-.96-.8-.965-1.59-.004-.823.461-1.393 1.008-1.714.27-.16.566-.265.867-.332V5.44c0-.43.351-.781.781-.781.43 0 .781.351.781.78Z",
        fill: "currentColor"
      }
    )
  })
);
var EnvelopeOpenDollar_default = SvgEnvelopeOpenDollar;

// src/Icon/icons/EnvelopeOpenText.tsx
import { jsx as jsx637 } from "react/jsx-runtime";
var SvgEnvelopeOpenText = (props) => /* @__PURE__ */ jsx637(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx637(
      "path",
      {
        d: "M17.31 3.877H6.687a.313.313 0 0 0-.313.312v6.608l-1.671-1.37a2.452 2.452 0 0 0-.203-.15V4.19c0-1.207.98-2.187 2.187-2.187H17.31c1.206 0 2.187.98 2.187 2.187v5.085c-.07.047-.137.098-.203.148l-1.672 1.375V4.19a.313.313 0 0 0-.313-.312ZM8.248 6.689c0-.52.418-.938.937-.938h5.624c.52 0 .937.418.937.938 0 .519-.418.937-.937.937H9.186a.935.935 0 0 1-.937-.937Zm0 3.124c0-.52.418-.937.937-.937h5.624c.52 0 .937.418.937.937 0 .52-.418.937-.937.937H9.186a.935.935 0 0 1-.937-.937Zm-4.374 2.976v7.022c0 .172.14.312.312.312H19.81c.172 0 .313-.14.313-.312v-7.022l-5.546 4.554a4.062 4.062 0 0 1-5.156 0l-5.545-4.554ZM2 11.293a1.168 1.168 0 0 1 1.91-.902l6.702 5.507a2.185 2.185 0 0 0 2.776 0l6.702-5.507a1.167 1.167 0 0 1 1.91.902v8.518c0 1.207-.98 2.187-2.187 2.187H4.187A2.188 2.188 0 0 1 2 19.811v-8.518Z",
        fill: "currentColor"
      }
    )
  })
);
var EnvelopeOpenText_default = SvgEnvelopeOpenText;

// src/Icon/icons/EnvelopeOpen.tsx
import { jsx as jsx638 } from "react/jsx-runtime";
var SvgEnvelopeOpen = (props) => /* @__PURE__ */ jsx638(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx638(
      "path",
      {
        d: "M21.281 8.367c-.972-.766-1.777-1.381-6.418-4.75C14.215 3.141 12.926 2 12.016 2h-.032c-.91 0-2.199 1.141-2.851 1.616-4.638 3.368-5.444 3.986-6.415 4.751A1.865 1.865 0 0 0 2 9.844V19.5C2 20.879 3.12 22 4.5 22h15a2.5 2.5 0 0 0 2.5-2.5V9.844c0-.578-.262-1.125-.719-1.477ZM20.125 19.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625v-6.691l5.316 4.43A4.416 4.416 0 0 0 12 18.25c1.023 0 2.021-.36 2.811-1.016l5.314-4.425V19.5Zm0-9.133-6.516 5.395c-.905.753-2.318.753-3.221 0l-6.513-5.395.004-.526c.908-.716 1.65-1.288 6.363-4.711.12-.088.261-.197.416-.316.303-.236.979-.76 1.342-.915.364.155 1.04.679 1.344.915.155.12.295.228.42.32 4.705 3.417 5.45 3.991 6.361 4.71v.523Z",
        fill: "currentColor"
      }
    )
  })
);
var EnvelopeOpen_default = SvgEnvelopeOpen;

// src/Icon/icons/Envelope.tsx
import { jsx as jsx639 } from "react/jsx-runtime";
var SvgEnvelope = (props) => /* @__PURE__ */ jsx639(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx639(
      "path",
      {
        d: "M4.5 6.375A.627.627 0 0 0 3.875 7v.863l6.738 5.532a2.185 2.185 0 0 0 2.778 0l6.734-5.532V7a.627.627 0 0 0-.625-.625h-15Zm-.625 3.914V17c0 .344.281.625.625.625h15a.627.627 0 0 0 .625-.625v-6.71l-5.547 4.554a4.063 4.063 0 0 1-5.156 0l-5.547-4.555ZM2 7c0-1.379 1.121-2.5 2.5-2.5h15C20.879 4.5 22 5.621 22 7v10c0 1.379-1.121 2.5-2.5 2.5h-15A2.502 2.502 0 0 1 2 17V7Z",
        fill: "currentColor"
      }
    )
  })
);
var Envelope_default = SvgEnvelope;

// src/Icon/icons/EnvelopesBulk.tsx
import { jsx as jsx640 } from "react/jsx-runtime";
var SvgEnvelopesBulk = (props) => /* @__PURE__ */ jsx640(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx640(
      "path",
      {
        d: "M20.5 8h-10A1.5 1.5 0 0 0 9 9.5v.5h1.5v-.5h10v6H15V17h5.5a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 20.5 8Zm-15-2.5h10V7H17V5.5A1.5 1.5 0 0 0 15.5 4h-10A1.5 1.5 0 0 0 4 5.5V10h1.5V5.5Zm7 5.5h-9A1.5 1.5 0 0 0 2 12.5v6A1.5 1.5 0 0 0 3.5 20h9a1.5 1.5 0 0 0 1.5-1.5v-6a1.5 1.5 0 0 0-1.5-1.5Zm0 7.5h-9v-3.75c.453.344 2.5 1.816 2.5 1.816.453.35 1.206.934 2 .934s1.547-.586 2-.934c0 0 2.047-1.473 2.5-1.816v3.75Zm0-5.581c-.074.058-3.494 2.562-3.66 2.676-.265.18-.596.405-.84.405-.293 0-.71-.328-.984-.547-.107-.084-3.442-2.578-3.516-2.631V12.5h9v.419Zm5-2.419v2h2v-2h-2Z",
        fill: "currentColor"
      }
    )
  })
);
var EnvelopesBulk_default = SvgEnvelopesBulk;

// src/Icon/icons/Envelopes.tsx
import { jsx as jsx641 } from "react/jsx-runtime";
var SvgEnvelopes = (props) => /* @__PURE__ */ jsx641(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx641(
      "path",
      {
        d: "M19.778 5.889H7.556A.557.557 0 0 0 7 6.444v.271l6.16 4.563a.853.853 0 0 0 1.014 0l6.16-4.563v-.27a.557.557 0 0 0-.556-.556Zm.555 2.9-5.17 3.83a2.519 2.519 0 0 1-2.993 0L7 8.788v5.433c0 .306.25.556.556.556h12.222c.305 0 .555-.25.555-.556V8.788ZM7.556 4.221h12.222c1.226 0 2.222.997 2.222 2.222v7.778a2.224 2.224 0 0 1-2.222 2.222H7.556a2.224 2.224 0 0 1-2.223-2.222V6.444c0-1.225.997-2.222 2.223-2.222ZM2.833 6.444c.462 0 .834.372.834.834v7.778a3.056 3.056 0 0 0 3.055 3.055h11.111c.462 0 .834.372.834.833a.831.831 0 0 1-.834.834H6.723A4.723 4.723 0 0 1 2 15.056V7.278c0-.462.372-.834.833-.834Z",
        fill: "currentColor"
      }
    )
  })
);
var Envelopes_default = SvgEnvelopes;

// src/Icon/icons/Equals.tsx
import { jsx as jsx642 } from "react/jsx-runtime";
var SvgEquals = (props) => /* @__PURE__ */ jsx642(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx642(
      "path",
      {
        d: "M20.846 15.461H3.154a1.155 1.155 0 0 0 0 2.308h17.692a1.154 1.154 0 1 0 0-2.307ZM3.154 8.538h17.692a1.154 1.154 0 1 0 0-2.307H3.154a1.155 1.155 0 0 0 0 2.307Z",
        fill: "currentColor"
      }
    )
  })
);
var Equals_default = SvgEquals;

// src/Icon/icons/Eraser.tsx
import { jsx as jsx643 } from "react/jsx-runtime";
var SvgEraser = (props) => /* @__PURE__ */ jsx643(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx643(
      "path",
      {
        d: "M12.12 20.69c-.023 0-.051.035-.075.035h-4.31c-.761 0-1.49-.303-2.028-.84L2.84 17.016a2.867 2.867 0 0 1 0-4.055l8.847-8.846a2.867 2.867 0 0 1 4.055 0l4.987 5.022a2.806 2.806 0 0 1 0 4.055l-5.585 5.621h5.9c.53 0 .956.426.956.956s-.426.956-.956.956l-8.923-.036Zm-7.928-5.06 2.834 2.868c.215.216.458.315.709.315h4.31c.251 0 .494-.1.673-.315l2.59-2.553-6.374-6.374-4.742 4.74c-.373.375-.373.98 0 1.32ZM2.84 12.961l1.352 1.35-1.352-1.35Z",
        fill: "currentColor"
      }
    )
  })
);
var Eraser_default = SvgEraser;

// src/Icon/icons/Ethernet.tsx
import { jsx as jsx644 } from "react/jsx-runtime";
var SvgEthernet = (props) => /* @__PURE__ */ jsx644(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx644(
      "path",
      {
        d: "M20.75 9.5H19.5V8.25c0-.688-.563-1.25-1.25-1.25H17V5.75c0-.688-.563-1.25-1.25-1.25h-7.5C7.562 4.5 7 5.063 7 5.75V7H5.75c-.688 0-1.25.563-1.25 1.25V9.5H3.25c-.688 0-1.25.563-1.25 1.25v7.5c0 .688.563 1.25 1.25 1.25h17.5c.688 0 1.25-.563 1.25-1.25v-7.5c0-.688-.563-1.25-1.25-1.25Zm-.625 8.125h-1.563v-2.188a.938.938 0 0 0-1.875 0v2.188h-1.875v-2.188a.938.938 0 0 0-1.874 0v2.188h-1.876v-2.188a.938.938 0 0 0-1.874 0v2.188H7.312v-2.188a.938.938 0 0 0-1.875 0v2.188H3.875v-6.25H5.75c.345 0 .625-.28.625-.625V8.875H8.25c.345 0 .625-.28.625-.625V6.375h6.25V8.25c0 .345.28.625.625.625h1.875v1.875c0 .345.28.625.625.625h1.875v6.25Z",
        fill: "currentColor"
      }
    )
  })
);
var Ethernet_default = SvgEthernet;

// src/Icon/icons/EuroSign.tsx
import { jsx as jsx645 } from "react/jsx-runtime";
var SvgEuroSign = (props) => /* @__PURE__ */ jsx645(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx645(
      "path",
      {
        d: "M5.929 11.286a1.07 1.07 0 1 1 0-2.143h1.485C8.643 5.012 12.47 2 17 2h1.071a1.07 1.07 0 1 1 0 2.143H17c-3.33 0-6.179 2.071-7.362 5h7.005c.594 0 1.071.478 1.071 1.071 0 .594-.477 1.072-1.071 1.072H9.174a7.579 7.579 0 0 0-.031.714c0 .241.009.478.031.714h7.469c.594 0 1.071.478 1.071 1.072 0 .594-.477 1.071-1.071 1.071H9.638c1.183 2.929 4.032 5 7.362 5h1.071c.594 0 1.072.478 1.072 1.072 0 .593-.478 1.071-1.072 1.071H17c-4.531 0-8.357-3.013-9.586-7.143H5.93a1.07 1.07 0 1 1 0-2.143h1.096a10.226 10.226 0 0 1 0-1.428H5.929Z",
        fill: "currentColor"
      }
    )
  })
);
var EuroSign_default = SvgEuroSign;

// src/Icon/icons/Exclamation.tsx
import { jsx as jsx646 } from "react/jsx-runtime";
var SvgExclamation = (props) => /* @__PURE__ */ jsx646(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx646(
      "path",
      {
        d: "M12 17c.592 0 1.071-.48 1.071-1.072V3.071a1.07 1.07 0 1 0-2.142 0v12.857A1.07 1.07 0 0 0 12 17Zm0 2.142A1.429 1.429 0 1 0 12 22a1.429 1.429 0 0 0 0-2.858Z",
        fill: "currentColor"
      }
    )
  })
);
var Exclamation_default = SvgExclamation;

// src/Icon/icons/ExpandWide.tsx
import { jsx as jsx647 } from "react/jsx-runtime";
var SvgExpandWide = (props) => /* @__PURE__ */ jsx647(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx647(
      "path",
      {
        d: "M7.313 17.625H3.874v-3.438a.937.937 0 1 0-1.875 0v4.376c0 .519.42.937.938.937h4.374c.52 0 .938-.418.938-.938a.935.935 0 0 0-.938-.937Zm0-13.125H2.938A.938.938 0 0 0 2 5.438v4.375a.937.937 0 1 0 1.875 0V6.374h3.438c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937Zm13.75 0h-4.375a.937.937 0 1 0 0 1.875h3.437v3.438c0 .519.418.937.938.937.519 0 .937-.418.937-.938V5.439a.937.937 0 0 0-.938-.938Zm0 8.75a.937.937 0 0 0-.938.938v3.437h-3.438a.937.937 0 1 0 0 1.875h4.375c.518 0 .938-.42.938-.938v-4.375a.935.935 0 0 0-.938-.937Z",
        fill: "currentColor"
      }
    )
  })
);
var ExpandWide_default = SvgExpandWide;

// src/Icon/icons/Expand.tsx
import { jsx as jsx648 } from "react/jsx-runtime";
var SvgExpand = (props) => /* @__PURE__ */ jsx648(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx648(
      "path",
      {
        d: "M8.071 2h-5C2.48 2 2 2.48 2 3.071v5a1.07 1.07 0 1 0 2.143 0V4.143H8.07a1.07 1.07 0 1 0 0-2.143ZM20.93 2h-5a1.07 1.07 0 1 0 0 2.143h3.928V8.07c0 .594.478 1.072 1.072 1.072.593 0 1.071-.478 1.071-1.072v-5A1.07 1.07 0 0 0 20.929 2ZM8.07 19.857H4.143V15.93a1.07 1.07 0 1 0-2.143 0v5C2 21.522 2.48 22 3.071 22h5c.594 0 1.072-.478 1.072-1.071 0-.594-.478-1.072-1.072-1.072Zm12.858-5c-.592 0-1.072.48-1.072 1.072v3.928H15.93a1.072 1.072 0 0 0 0 2.143h5C21.52 22 22 21.52 22 20.929v-5c0-.594-.478-1.072-1.071-1.072Z",
        fill: "currentColor"
      }
    )
  })
);
var Expand_default = SvgExpand;

// src/Icon/icons/EyeSlash.tsx
import { jsx as jsx649 } from "react/jsx-runtime";
var SvgEyeSlash = (props) => /* @__PURE__ */ jsx649(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx649(
      "path",
      {
        d: "M6.71 6.899C8.093 5.821 9.868 5 12 5c2.525 0 4.547 1.151 6.019 2.519 1.462 1.356 2.44 2.953 2.903 4.097a.994.994 0 0 1 0 .768c-.419 1.01-1.26 2.431-2.497 3.7l3.287 2.575a.75.75 0 0 1-.925 1.181l-18.5-14.5a.75.75 0 1 1 .926-1.18l3.496 2.739Zm1.221.96L9.37 8.984a4 4 0 0 1 6.187 4.85l1.681 1.319c1.047-1.066 1.822-2.306 2.22-3.153a11.273 11.273 0 0 0-2.46-3.384C15.712 7.425 14.037 6.472 12 6.472c-1.578 0-2.966.582-4.069 1.387Zm6.41 5.022c.103-.275.159-.572.159-.91 0-1.352-1.119-2.5-2.5-2.5-.022 0-.04.029-.09.029.068.16.09.328.09.472 0 .347-.075.647-.206.912l2.546 1.997Zm.293 4.072 1.31 1.031A8.214 8.214 0 0 1 12 19c-2.525 0-4.547-1.15-6.019-2.519-1.462-1.384-2.44-2.981-2.904-4.097a1 1 0 0 1 0-.768c.298-.716.807-1.641 1.52-2.57l1.178.929c-.584.728-.97 1.45-1.23 1.997.424.965 1.255 2.293 2.458 3.412C8.287 16.574 9.963 17.5 12 17.5c.96 0 1.837-.206 2.634-.547ZM8 11.972c0-.063.003-.15.01-.238l1.752 1.382a2.39 2.39 0 0 0 1.675 1.293l1.757 1.41c-.379.09-.779.18-1.222.18-2.181 0-4-1.79-4-4.027H8Z",
        fill: "currentColor"
      }
    )
  })
);
var EyeSlash_default = SvgEyeSlash;

// src/Icon/icons/Eye.tsx
import { jsx as jsx650 } from "react/jsx-runtime";
var SvgEye = (props) => /* @__PURE__ */ jsx650(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx650(
      "path",
      {
        d: "M7.556 12a4.444 4.444 0 1 1 8.888 0 4.444 4.444 0 0 1-8.888 0ZM12 14.778a2.777 2.777 0 1 0 0-5.556h-.1c.076.177.1.365.1.556A2.224 2.224 0 0 1 9.778 12c-.19 0-.378-.024-.555-.1v.069A2.784 2.784 0 0 0 12 14.778ZM5.313 7.02C6.948 5.5 9.195 4.22 12 4.22c2.806 0 5.053 1.28 6.688 2.8 1.625 1.507 2.712 3.281 3.226 4.552.115.274.115.58 0 .854-.514 1.24-1.6 3.014-3.226 4.552-1.635 1.521-3.882 2.8-6.688 2.8-2.805 0-5.052-1.279-6.687-2.8-1.625-1.538-2.71-3.312-3.228-4.552a1.11 1.11 0 0 1 0-.854c.517-1.271 1.603-3.045 3.228-4.552ZM12 5.889c-2.264 0-4.125 1.027-5.552 2.35C5.111 9.483 4.188 10.927 3.717 12c.471 1.042 1.394 2.518 2.731 3.76 1.427 1.324 3.288 2.351 5.552 2.351s4.126-1.027 5.553-2.35c1.337-1.243 2.229-2.72 2.732-3.761a12.528 12.528 0 0 0-2.732-3.76C16.126 6.915 14.264 5.888 12 5.888Z",
        fill: "currentColor"
      }
    )
  })
);
var Eye_default = SvgEye;

// src/Icon/icons/F.tsx
import { jsx as jsx651 } from "react/jsx-runtime";
var SvgF = (props) => /* @__PURE__ */ jsx651(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx651(
      "path",
      {
        d: "M19.143 3.071c0 .592-.48 1.072-1.072 1.072H7v6.786h8.214a1.072 1.072 0 0 1 0 2.142H7v7.858a1.07 1.07 0 1 1-2.143 0V3.07C4.857 2.48 5.337 2 5.93 2H18.07c.594 0 1.072.48 1.072 1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var F_default = SvgF;

// src/Icon/icons/FaAngleDownSmall.tsx
import { jsx as jsx652 } from "react/jsx-runtime";
var SvgFaAngleDownSmall = (props) => /* @__PURE__ */ jsx652(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx652(
      "path",
      {
        d: "m17.575 10.905-4.637 4.132c-.261.295-.602.42-.937.42-.336 0-.675-.124-.938-.373l-4.637-4.178a1.37 1.37 0 0 1-.053-1.932A1.361 1.361 0 0 1 8.3 8.922l3.7 3.29L15.7 8.918a1.363 1.363 0 0 1 1.929.053 1.377 1.377 0 0 1-.054 1.935Z",
        fill: "currentColor"
      }
    )
  })
);
var FaAngleDownSmall_default = SvgFaAngleDownSmall;

// src/Icon/icons/FaAngleLeftSmall.tsx
import { jsx as jsx653 } from "react/jsx-runtime";
var SvgFaAngleLeftSmall = (props) => /* @__PURE__ */ jsx653(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx653(
      "path",
      {
        d: "m13.074 17.575-4.13-4.637a1.36 1.36 0 0 1-.374-.937c0-.338.125-.675.373-.938l4.131-4.637a1.365 1.365 0 0 1 1.982 1.875l-3.296 3.7 3.296 3.7a1.363 1.363 0 0 1-.054 1.928 1.368 1.368 0 0 1-1.928-.054Z",
        fill: "currentColor"
      }
    )
  })
);
var FaAngleLeftSmall_default = SvgFaAngleLeftSmall;

// src/Icon/icons/FaAngleRightSmall.tsx
import { jsx as jsx654 } from "react/jsx-runtime";
var SvgFaAngleRightSmall = (props) => /* @__PURE__ */ jsx654(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx654(
      "path",
      {
        d: "m10.925 6.426 4.132 4.637a1.362 1.362 0 0 1 0 1.875l-4.132 4.638a1.366 1.366 0 0 1-1.98-1.878l3.295-3.7L8.944 8.3a1.36 1.36 0 0 1 .054-1.926 1.365 1.365 0 0 1 1.928.053Z",
        fill: "currentColor"
      }
    )
  })
);
var FaAngleRightSmall_default = SvgFaAngleRightSmall;

// src/Icon/icons/FaAngleUpSmall.tsx
import { jsx as jsx655 } from "react/jsx-runtime";
var SvgFaAngleUpSmall = (props) => /* @__PURE__ */ jsx655(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx655(
      "path",
      {
        d: "m6.426 13.122 4.637-4.13c.26-.296.602-.421.937-.421.335 0 .675.124.938.372l4.636 4.131a1.365 1.365 0 0 1-1.875 1.981l-3.7-3.295-3.698 3.295a1.362 1.362 0 0 1-1.928-.053c-.517-.494-.494-1.357.053-1.88Z",
        fill: "currentColor"
      }
    )
  })
);
var FaAngleUpSmall_default = SvgFaAngleUpSmall;

// src/Icon/icons/FaArrowLeftToLineControl.tsx
import { jsx as jsx656 } from "react/jsx-runtime";
var SvgFaArrowLeftToLineControl = (props) => /* @__PURE__ */ jsx656(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx656(
      "path",
      {
        d: "M12.013 16.893 7.906 13.03h10.875c.594 0 1.076-.477 1.076-1.071s-.48-1.031-1.072-1.031H7.906l4.106-3.863a1.066 1.066 0 0 0 .046-1.514 1.071 1.071 0 0 0-1.514-.046L4.468 11.22c-.433.405-.433 1.155 0 1.56l6.076 5.714c.431.406 1.11.385 1.514-.046.41-.47.388-1.149-.045-1.555Z",
        fill: "currentColor"
      }
    )
  })
);
var FaArrowLeftToLineControl_default = SvgFaArrowLeftToLineControl;

// src/Icon/icons/FaArrowRightToLineControl.tsx
import { jsx as jsx657 } from "react/jsx-runtime";
var SvgFaArrowRightToLineControl = (props) => /* @__PURE__ */ jsx657(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx657(
      "path",
      {
        d: "m11.988 7.067 4.106 3.863H5.22A1.072 1.072 0 0 0 4.144 12c0 .59.48 1.072 1.073 1.072h10.875l-4.107 3.863a1.066 1.066 0 0 0-.336.78 1.071 1.071 0 0 0 1.806.78l6.076-5.715c.433-.404.433-1.155 0-1.56l-6.076-5.714a1.07 1.07 0 0 0-1.516.048c-.406.428-.424 1.107.049 1.513Z",
        fill: "currentColor"
      }
    )
  })
);
var FaArrowRightToLineControl_default = SvgFaArrowRightToLineControl;

// src/Icon/icons/FaCaretDownSolidSmall.tsx
import { jsx as jsx658 } from "react/jsx-runtime";
var SvgFaCaretDownSolidSmall = (props) => /* @__PURE__ */ jsx658(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx658(
      "path",
      {
        d: "M11.152 15.248c.469.469 1.23.469 1.699 0l4.797-4.797a1.2 1.2 0 0 0-.85-2.05l-9.596.003a1.204 1.204 0 0 0-.851 2.05l4.798 4.798.003-.004Z",
        fill: "currentColor"
      }
    )
  })
);
var FaCaretDownSolidSmall_default = SvgFaCaretDownSolidSmall;

// src/Icon/icons/FaCaretLeftSolidSmall.tsx
import { jsx as jsx659 } from "react/jsx-runtime";
var SvgFaCaretLeftSolidSmall = (props) => /* @__PURE__ */ jsx659(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx659(
      "path",
      {
        d: "M8.752 12.848a1.201 1.201 0 0 1 0-1.699l4.797-4.797a1.194 1.194 0 0 1 1.309-.26 1.2 1.2 0 0 1 .742 1.11v9.596a1.204 1.204 0 0 1-2.05.851l-4.798-4.798v-.003Z",
        fill: "currentColor"
      }
    )
  })
);
var FaCaretLeftSolidSmall_default = SvgFaCaretLeftSolidSmall;

// src/Icon/icons/FaCaretRightSolidSmall.tsx
import { jsx as jsx660 } from "react/jsx-runtime";
var SvgFaCaretRightSolidSmall = (props) => /* @__PURE__ */ jsx660(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx660(
      "path",
      {
        d: "M15.248 12.848a1.201 1.201 0 0 0 0-1.699l-4.797-4.797a1.194 1.194 0 0 0-1.309-.26 1.2 1.2 0 0 0-.742 1.11v9.596a1.204 1.204 0 0 0 2.05.851l4.799-4.798v-.003Z",
        fill: "currentColor"
      }
    )
  })
);
var FaCaretRightSolidSmall_default = SvgFaCaretRightSolidSmall;

// src/Icon/icons/FaCaretUpSolidSmall.tsx
import { jsx as jsx661 } from "react/jsx-runtime";
var SvgFaCaretUpSolidSmall = (props) => /* @__PURE__ */ jsx661(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx661(
      "path",
      {
        d: "M12.848 8.752a1.201 1.201 0 0 0-1.699 0l-4.797 4.797a1.194 1.194 0 0 0-.26 1.309 1.2 1.2 0 0 0 1.11.742h9.596a1.204 1.204 0 0 0 .851-2.05l-4.798-4.798h-.003Z",
        fill: "currentColor"
      }
    )
  })
);
var FaCaretUpSolidSmall_default = SvgFaCaretUpSolidSmall;

// src/Icon/icons/FaCheck14Px.tsx
import { jsx as jsx662 } from "react/jsx-runtime";
var SvgFaCheck14Px = (props) => /* @__PURE__ */ jsx662(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx662(
      "path",
      {
        d: "M11.158 3.85c.456.42.456 1.099 0 1.479L6.366 10.12c-.38.456-1.059.456-1.479 0L2.814 8.046c-.419-.38-.419-1.058 0-1.478a1.078 1.078 0 0 1 1.516 0l1.317 1.32L9.68 3.85c.42-.417 1.099-.417 1.478 0Z",
        fill: "currentColor"
      }
    )
  })
);
var FaCheck14Px_default = SvgFaCheck14Px;

// src/Icon/icons/FaDash14Px.tsx
import { jsx as jsx663 } from "react/jsx-runtime";
var SvgFaDash14Px = (props) => /* @__PURE__ */ jsx663(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx663(
      "path",
      {
        d: "M12 7c0 .518-.42.938-.938.938H2.938a.936.936 0 1 1 0-1.875h8.124c.52 0 .938.421.938.937Z",
        fill: "currentColor"
      }
    )
  })
);
var FaDash14Px_default = SvgFaDash14Px;

// src/Icon/icons/FaPlusMinusSmall.tsx
import { jsx as jsx664 } from "react/jsx-runtime";
var SvgFaPlusMinusSmall = (props) => /* @__PURE__ */ jsx664(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx664(
      "path",
      {
        d: "M11.875 4.75c-.655 0-1.187.531-1.187 1.187v4.75h-4.75a1.188 1.188 0 0 0 0 2.375h4.75v4.75a1.188 1.188 0 0 0 2.375 0v-4.75h4.75a1.187 1.187 0 1 0 0-2.375h-4.75v-4.75c0-.656-.532-1.187-1.188-1.187Z",
        fill: "currentColor"
      }
    )
  })
);
var FaPlusMinusSmall_default = SvgFaPlusMinusSmall;

// src/Icon/icons/FaThumbtack.tsx
import { jsx as jsx665, jsxs as jsxs3 } from "react/jsx-runtime";
var SvgFaThumbtack = (props) => /* @__PURE__ */ jsxs3(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsx665("g", { clipPath: "url(#fa-thumbtack_svg__a)", children: /* @__PURE__ */ jsx665(
        "path",
        {
          d: "m13.99 15.314-3.757 3.757a1.246 1.246 0 0 1-1.037.357 1.254 1.254 0 0 1-.92-.6l-.515-.86a6.553 6.553 0 0 1-.82-4.616L3.35 9.161l-.85.85a.938.938 0 0 1-1.326-1.326l7.513-7.513a.936.936 0 0 1 1.326 0c.243.244.324.59.246.898a.946.946 0 0 1-.246.428l-.851.85 4.193 3.591a6.559 6.559 0 0 1 4.615.82l.86.517a1.248 1.248 0 0 1 .242 1.956l-3.756 3.756 3.757 3.757c.367.367.367.958-.025 1.35-.343.343-.959.368-1.326 0l-3.732-3.78ZM8.953 12.82l-.169.887a4.658 4.658 0 0 0 .582 3.296l.106.176 3.19-3.19-2.43-2.431a.935.935 0 0 1 0-1.326.935.935 0 0 1 1.325 0l2.431 2.43 3.19-3.19-.176-.105c-1.017-.613-2.216-.773-3.296-.583l-.911.194-4.964-4.3-3.154 3.154 4.276 4.988Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ jsx665("defs", { children: /* @__PURE__ */ jsx665("clipPath", { id: "fa-thumbtack_svg__a", children: /* @__PURE__ */ jsx665("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }) })
    ]
  })
);
var FaThumbtack_default = SvgFaThumbtack;

// src/Icon/icons/FaXmarkLargeClose.tsx
import { jsx as jsx666 } from "react/jsx-runtime";
var SvgFaXmarkLargeClose = (props) => /* @__PURE__ */ jsx666(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx666(
      "path",
      {
        d: "m12.006 10.491 5.174-5.177c.42-.419 1.099-.419 1.478 0a1.012 1.012 0 0 1 0 1.516l-5.138 5.175 5.138 5.175c.456.42.456 1.099 0 1.478-.38.456-1.058.456-1.478 0l-5.174-5.138-5.176 5.138a1.012 1.012 0 0 1-1.516 0c-.419-.38-.419-1.058 0-1.478l5.177-5.175L5.314 6.83A1.072 1.072 0 1 1 6.83 5.314l5.176 5.177Z",
        fill: "currentColor"
      }
    )
  })
);
var FaXmarkLargeClose_default = SvgFaXmarkLargeClose;

// src/Icon/icons/FaXmarkSmall.tsx
import { jsx as jsx667 } from "react/jsx-runtime";
var SvgFaXmarkSmall = (props) => /* @__PURE__ */ jsx667(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx667(
      "path",
      {
        d: "M17.483 15.446a1.496 1.496 0 0 1-2.116 2.116L12 14.142 8.583 17.56a1.496 1.496 0 0 1-2.116-2.116l3.42-3.416-3.422-3.474a1.496 1.496 0 0 1 2.116-2.116L12 9.915l3.418-3.418a1.496 1.496 0 0 1 2.116 2.115l-3.42 3.416 3.368 3.418Z",
        fill: "currentColor"
      }
    )
  })
);
var FaXmarkSmall_default = SvgFaXmarkSmall;

// src/Icon/icons/FileArrowDown.tsx
import { jsx as jsx668 } from "react/jsx-runtime";
var SvgFileArrowDown = (props) => /* @__PURE__ */ jsx668(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx668(
      "path",
      {
        d: "M12.938 15.363v-3.988a.938.938 0 0 0-1.876 0v3.988l-1.558-1.527c-.149-.184-.387-.274-.629-.274s-.48.09-.663.274a.937.937 0 0 0 0 1.326l3.125 3.125a.937.937 0 0 0 1.326 0l3.125-3.125a.937.937 0 1 0-1.326-1.326l-1.524 1.527Zm5.832-9.715-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Z",
        fill: "currentColor"
      }
    )
  })
);
var FileArrowDown_default = SvgFileArrowDown;

// src/Icon/icons/FileArrowUp.tsx
import { jsx as jsx669 } from "react/jsx-runtime";
var SvgFileArrowUp = (props) => /* @__PURE__ */ jsx669(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx669(
      "path",
      {
        d: "M11.336 10.71 8.21 13.837a.937.937 0 1 0 1.326 1.326l1.525-1.525v3.988a.938.938 0 0 0 1.876 0v-3.988l1.524 1.524c.183.187.42.277.663.277a.937.937 0 0 0 .663-1.6l-3.125-3.126a.943.943 0 0 0-1.327-.001Zm7.434-5.062-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Z",
        fill: "currentColor"
      }
    )
  })
);
var FileArrowUp_default = SvgFileArrowUp;

// src/Icon/icons/FileBinary.tsx
import { jsx as jsx670 } from "react/jsx-runtime";
var SvgFileBinary = (props) => /* @__PURE__ */ jsx670(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx670(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Zm-4.688-7.188c0 .52.422.938.938.938v3.125a.938.938 0 0 0 0 1.875h1.875a.938.938 0 0 0 0-1.875v-4.063a.938.938 0 0 0-.938-.937h-.937a.94.94 0 0 0-.938.938Zm-2.812-.937H9.5a2.19 2.19 0 0 0-2.188 2.188v2.5A2.19 2.19 0 0 0 9.5 18.25h.625a2.19 2.19 0 0 0 2.188-2.188v-2.5c0-1.207-.981-2.187-2.188-2.187Zm.313 4.688c0 .172-.14.312-.313.312H9.5a.313.313 0 0 1-.313-.313v-2.5c0-.171.141-.312.313-.312h.625c.172 0 .313.14.313.313v2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var FileBinary_default = SvgFileBinary;

// src/Icon/icons/FileCertificate.tsx
import { jsx as jsx671 } from "react/jsx-runtime";
var SvgFileCertificate = (props) => /* @__PURE__ */ jsx671(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx671(
      "path",
      {
        d: "M11.68 15.215c.293-.293.405-.723.298-1.123-.21-.806-.215-.694 0-1.5a1.17 1.17 0 0 0-.298-1.128c-.582-.593-.559-.495-.739-1.3-.101-.398-.445-.71-.804-.82-.797-.219-.7-.16-1.281-.75-.286-.293-.743-.41-1.102-.305-.796.215-.683.215-1.474 0a1.137 1.137 0 0 0-1.105.305c-.585.59-.488.531-1.279.75-.395.11-.7.422-.807.82-.21.81-.156.708-.737 1.299a1.18 1.18 0 0 0-.296 1.128c.21.806.21.693 0 1.5-.108.4.008.83.296 1.122.58.59.527.493.737 1.3.108.405.412.717.808.824.56.151.449.117.62.195V22l2.5-1.25L9.515 22v-4.469c.166-.078.058-.044.62-.195.39-.107.668-.42.805-.825.18-.808.157-.706.739-1.296Zm-4.664.535a2.498 2.498 0 0 1-2.5-2.5c0-1.382 1.118-2.5 2.5-2.5 1.38 0 2.5 1.118 2.5 2.5s-1.117 2.5-2.5 2.5Zm14.27-10.102L18.37 2.732A2.512 2.512 0 0 0 16.602 2H9.48a2.5 2.5 0 0 0-2.5 2.5v2.693s.86-.418 1.875-.03l.035-2.658c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5c0 .345-.28.625-.626.625h-8.714L10.73 22h8.75c1.375 0 2.5-1.125 2.5-2.5V7.414a2.33 2.33 0 0 0-.695-1.766Z",
        fill: "currentColor"
      }
    )
  })
);
var FileCertificate_default = SvgFileCertificate;

// src/Icon/icons/FileChartColumn.tsx
import { jsx as jsx672 } from "react/jsx-runtime";
var SvgFileChartColumn = (props) => /* @__PURE__ */ jsx672(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx672(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035ZM12 12a.94.94 0 0 0-.938.938v5a.938.938 0 0 0 1.876 0v-5A.938.938 0 0 0 12 12Zm2.5 5.938a.938.938 0 0 0 1.875 0v-3.75a.938.938 0 0 0-1.875 0v3.75ZM8.562 14.5a.938.938 0 0 0-.937.938v2.5a.938.938 0 0 0 1.875 0v-2.5a.938.938 0 0 0-.938-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var FileChartColumn_default = SvgFileChartColumn;

// src/Icon/icons/FileChartPie.tsx
import { jsx as jsx673 } from "react/jsx-runtime";
var SvgFileChartPie = (props) => /* @__PURE__ */ jsx673(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx673(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Zm-6.25-8.125a3.75 3.75 0 1 0 3.75 3.75h-3.75v-3.75Zm1.25 2.5h3.75a3.75 3.75 0 0 0-3.75-3.75v3.75Z",
        fill: "currentColor"
      }
    )
  })
);
var FileChartPie_default = SvgFileChartPie;

// src/Icon/icons/FileCheck.tsx
import { jsx as jsx674 } from "react/jsx-runtime";
var SvgFileCheck = (props) => /* @__PURE__ */ jsx674(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx674(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Zm-6.613-4.816-1.196-1.16a.937.937 0 1 0-1.325 1.325l1.875 1.875c.208.178.45.276.697.276l.035-.001a.937.937 0 0 0 .676-.326l3.75-4.375a.937.937 0 0 0-1.423-1.22l-3.09 3.606Z",
        fill: "currentColor"
      }
    )
  })
);
var FileCheck_default = SvgFileCheck;

// src/Icon/icons/FileCircleCheck.tsx
import { jsx as jsx675 } from "react/jsx-runtime";
var SvgFileCircleCheck = (props) => /* @__PURE__ */ jsx675(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx675(
      "path",
      {
        d: "M4.191 19.222h7.688a6.198 6.198 0 0 0 1.569 1.643 2.648 2.648 0 0 1-.337.024H4.222A2.223 2.223 0 0 1 2 18.667V5.333c0-1.227.995-2.222 2.222-2.222H9.97c.59 0 1.152.234 1.57.651l3.145 3.144c.417.417.65.98.65 1.57v1.53a6.05 6.05 0 0 0-1.667.761v-2.1h-2.778a1.11 1.11 0 0 1-1.111-1.111V4.778H4.222a.555.555 0 0 0-.555.555v13.334c0 .305.248.555.555.555h-.031ZM22 15.89c0 2.76-2.24 5-5 5s-5.031-2.24-5.031-5 2.27-5 5.031-5c2.76 0 5 2.24 5 5Zm-3.448-1.504-2.108 2.108-.996-.996a.551.551 0 0 0-.785 0 .551.551 0 0 0 0 .784l1.39 1.39c.214.218.569.218.784 0l2.5-2.5a.551.551 0 0 0 0-.786.551.551 0 0 0-.785 0Z",
        fill: "currentColor"
      }
    )
  })
);
var FileCircleCheck_default = SvgFileCircleCheck;

// src/Icon/icons/FileCircleExclamation.tsx
import { jsx as jsx676 } from "react/jsx-runtime";
var SvgFileCircleExclamation = (props) => /* @__PURE__ */ jsx676(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx676(
      "path",
      {
        d: "M4.191 19.222h7.688a6.198 6.198 0 0 0 1.569 1.643 2.648 2.648 0 0 1-.337.024H4.222A2.223 2.223 0 0 1 2 18.667V5.333c0-1.227.995-2.222 2.222-2.222H9.97c.59 0 1.152.234 1.57.651l3.145 3.144c.417.417.65.98.65 1.57v1.53a6.05 6.05 0 0 0-1.667.761v-2.1h-2.778a1.11 1.11 0 0 1-1.111-1.111V4.778H4.222a.555.555 0 0 0-.555.555v13.334c0 .305.248.555.555.555h-.031Zm7.778-3.333c0-2.76 2.27-5 5.031-5 2.76 0 5 2.24 5 5s-2.24 5-5 5-5.031-2.24-5.031-5ZM17 19.222a.831.831 0 0 0 .833-.833.831.831 0 0 0-.833-.833.831.831 0 0 0-.833.833c0 .462.371.833.833.833Zm-.587-6.11v2.777c0 .305.281.555.556.555.337 0 .555-.25.555-.555V13.11a.538.538 0 0 0-.555-.555.579.579 0 0 0-.556.555Z",
        fill: "currentColor"
      }
    )
  })
);
var FileCircleExclamation_default = SvgFileCircleExclamation;

// src/Icon/icons/FileCircleInfo.tsx
import { jsx as jsx677 } from "react/jsx-runtime";
var SvgFileCircleInfo = (props) => /* @__PURE__ */ jsx677(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx677(
      "path",
      {
        d: "M4.191 19.222h7.688a6.198 6.198 0 0 0 1.569 1.643 2.648 2.648 0 0 1-.337.024H4.222A2.223 2.223 0 0 1 2 18.667V5.333c0-1.227.995-2.222 2.222-2.222H9.97c.59 0 1.152.234 1.57.651l3.145 3.144c.417.417.65.98.65 1.57v1.53a6.05 6.05 0 0 0-1.667.761v-2.1h-2.778a1.11 1.11 0 0 1-1.111-1.111V4.778H4.222a.555.555 0 0 0-.555.555v13.334c0 .305.248.555.555.555h-.031Zm7.778-3.333c0-2.76 2.27-5 5.031-5 2.76 0 5 2.24 5 5s-2.24 5-5 5-5.031-2.24-5.031-5ZM17 14.222a.831.831 0 0 0 .833-.833.831.831 0 0 0-.833-.833.831.831 0 0 0-.833.833c0 .462.371.833.833.833Zm-.556 2.222v1.667a.557.557 0 0 0-.555.556c0 .305.25.555.555.555h1.112c.305 0 .555-.25.555-.555a.557.557 0 0 0-.555-.556V15.89a.557.557 0 0 0-.556-.556h-.556a.557.557 0 0 0-.555.556c0 .305.25.555.555.555Z",
        fill: "currentColor"
      }
    )
  })
);
var FileCircleInfo_default = SvgFileCircleInfo;

// src/Icon/icons/FileCircleMinus.tsx
import { jsx as jsx678 } from "react/jsx-runtime";
var SvgFileCircleMinus = (props) => /* @__PURE__ */ jsx678(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx678(
      "path",
      {
        d: "M4.191 19.222h7.688a6.198 6.198 0 0 0 1.569 1.643 2.648 2.648 0 0 1-.337.024H4.222A2.223 2.223 0 0 1 2 18.667V5.333c0-1.227.995-2.222 2.222-2.222H9.97c.59 0 1.152.234 1.57.651l3.145 3.144c.417.417.65.98.65 1.57v1.53a6.05 6.05 0 0 0-1.667.761v-2.1h-2.778a1.11 1.11 0 0 1-1.111-1.111V4.778H4.222a.555.555 0 0 0-.555.555v13.334c0 .305.248.555.555.555h-.031ZM22 15.89c0 2.76-2.24 5-5 5s-5.031-2.24-5.031-5 2.27-5 5.031-5c2.76 0 5 2.24 5 5Zm-2.778-.587h-4.444a.579.579 0 0 0-.556.556c0 .336.25.555.556.555h4.444a.538.538 0 0 0 .556-.555.579.579 0 0 0-.556-.556Z",
        fill: "currentColor"
      }
    )
  })
);
var FileCircleMinus_default = SvgFileCircleMinus;

// src/Icon/icons/FileCirclePlus.tsx
import { jsx as jsx679 } from "react/jsx-runtime";
var SvgFileCirclePlus = (props) => /* @__PURE__ */ jsx679(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx679(
      "path",
      {
        d: "M4.191 19.222h7.688a6.198 6.198 0 0 0 1.569 1.643 2.648 2.648 0 0 1-.337.024H4.222A2.223 2.223 0 0 1 2 18.667V5.333c0-1.227.995-2.222 2.222-2.222H9.97c.59 0 1.152.234 1.57.651l3.145 3.144c.417.417.65.98.65 1.57v1.53a6.05 6.05 0 0 0-1.667.761v-2.1h-2.778a1.11 1.11 0 0 1-1.111-1.111V4.778H4.222a.555.555 0 0 0-.555.555v13.334c0 .305.248.555.555.555h-.031Zm7.778-3.333c0-2.76 2.27-5 5.031-5 2.76 0 5 2.24 5 5s-2.24 5-5 5-5.031-2.24-5.031-5Zm5.587-2.254A.579.579 0 0 0 17 13.08a.579.579 0 0 0-.556.555v1.667h-1.666a.579.579 0 0 0-.556.556c0 .336.25.555.556.555h1.666v1.667c0 .337.25.555.556.555a.538.538 0 0 0 .556-.555v-1.667h1.666a.538.538 0 0 0 .556-.555.579.579 0 0 0-.556-.556h-1.666v-1.667Z",
        fill: "currentColor"
      }
    )
  })
);
var FileCirclePlus_default = SvgFileCirclePlus;

// src/Icon/icons/FileCircleQuestion.tsx
import { jsx as jsx680 } from "react/jsx-runtime";
var SvgFileCircleQuestion = (props) => /* @__PURE__ */ jsx680(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx680(
      "path",
      {
        d: "M4.191 19.222h7.688a6.198 6.198 0 0 0 1.569 1.643 2.648 2.648 0 0 1-.337.024H4.222A2.223 2.223 0 0 1 2 18.667V5.333c0-1.227.995-2.222 2.222-2.222H9.97c.59 0 1.152.234 1.57.651l3.145 3.144c.417.417.65.98.65 1.57v1.53a6.05 6.05 0 0 0-1.667.761v-2.1h-2.778a1.11 1.11 0 0 1-1.111-1.111V4.778H4.222a.555.555 0 0 0-.555.555v13.334c0 .305.248.555.555.555h-.031Zm7.778-3.333c0-2.76 2.27-5 5.031-5 2.76 0 5 2.24 5 5s-2.24 5-5 5-5.031-2.24-5.031-5ZM17 19.222a.831.831 0 0 0 .833-.833.831.831 0 0 0-.833-.833.831.831 0 0 0-.833.833c0 .462.371.833.833.833ZM14.778 14.5c0 .306.25.556.555.556.306 0 .556-.25.556-.556v-.222c0-.184.15-.334.333-.334h1.406c.268 0 .483.216.483.483 0 .18-.1.344-.257.43l-1.11.584a.554.554 0 0 0-.3.49v.513c0 .306.25.556.556.556.306 0 .556-.25.556-.556v-.177l.816-.427c.52-.277.85-.85.85-1.413 0-.878-.715-1.594-1.594-1.594h-1.406c-.798 0-1.444.646-1.444 1.445v.222Z",
        fill: "currentColor"
      }
    )
  })
);
var FileCircleQuestion_default = SvgFileCircleQuestion;

// src/Icon/icons/FileCircleXmark.tsx
import { jsx as jsx681 } from "react/jsx-runtime";
var SvgFileCircleXmark = (props) => /* @__PURE__ */ jsx681(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx681(
      "path",
      {
        d: "M4.191 19.222h7.688a6.198 6.198 0 0 0 1.569 1.643 2.648 2.648 0 0 1-.337.024H4.222A2.223 2.223 0 0 1 2 18.667V5.333c0-1.227.995-2.222 2.222-2.222H9.97c.59 0 1.152.234 1.57.651l3.145 3.144c.417.417.65.98.65 1.57v1.53a6.05 6.05 0 0 0-1.667.761v-2.1h-2.778a1.11 1.11 0 0 1-1.111-1.111V4.778H4.222a.555.555 0 0 0-.555.555v13.334c0 .305.248.555.555.555h-.031Zm7.778-3.333c0-2.76 2.27-5 5.031-5 2.76 0 5 2.24 5 5s-2.24 5-5 5-5.031-2.24-5.031-5Zm7.09-1.274a.551.551 0 0 0 0-.785.551.551 0 0 0-.785 0L17 15.104l-1.274-1.274a.551.551 0 0 0-.785 0 .551.551 0 0 0 0 .785l1.274 1.274-1.274 1.274a.551.551 0 0 0 0 .785c.215.219.57.219.785 0L17 16.674l1.274 1.274c.216.219.57.219.785 0a.551.551 0 0 0 0-.785l-1.274-1.274 1.274-1.274Z",
        fill: "currentColor"
      }
    )
  })
);
var FileCircleXmark_default = SvgFileCircleXmark;

// src/Icon/icons/FileCode.tsx
import { jsx as jsx682 } from "react/jsx-runtime";
var SvgFileCode = (props) => /* @__PURE__ */ jsx682(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx682(
      "path",
      {
        d: "M10.832 12.07a.781.781 0 0 0-1.105 0l-1.875 1.875a.782.782 0 0 0 0 1.106l1.875 1.875a.78.78 0 1 0 1.106-1.104L9.513 14.5l1.322-1.322a.853.853 0 0 0-.002-1.108Zm7.938-6.422-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Zm-4.457-7.43a.782.782 0 0 0 0 1.106l1.32 1.324-1.322 1.322a.782.782 0 0 0 1.105 1.106l1.875-1.875a.782.782 0 0 0 0-1.106l-1.875-1.875a.778.778 0 0 0-1.103-.002Z",
        fill: "currentColor"
      }
    )
  })
);
var FileCode_default = SvgFileCode;

// src/Icon/icons/FileContract.tsx
import { jsx as jsx683 } from "react/jsx-runtime";
var SvgFileContract = (props) => /* @__PURE__ */ jsx683(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx683(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035ZM8.25 7h3.125A.627.627 0 0 0 12 6.375a.627.627 0 0 0-.625-.625H8.25a.626.626 0 0 0 0 1.25Zm0 2.5h3.125A.627.627 0 0 0 12 8.875a.627.627 0 0 0-.625-.625H8.25a.626.626 0 0 0 0 1.25Zm3.93 6.695-.543-1.626a.933.933 0 0 0-1.776.001l-.713 2.133a.434.434 0 0 1-.414.297H8.25a.623.623 0 0 0-.625.625c0 .347.279.625.625.625h.484c.727 0 1.372-.464 1.601-1.152l.415-1.246.66 1.968c.078.244.293.41.547.43H12c.2 0 .454-.132.557-.347l.302-.6a.434.434 0 0 1 .391-.24.43.43 0 0 1 .395.253c.289.579.87.934 1.511.934h.594a.623.623 0 0 0 .625-.625.622.622 0 0 0-.625-.625h-.596a.45.45 0 0 1-.395-.254c-.462-.933-1.806-1.187-2.58-.55Z",
        fill: "currentColor"
      }
    )
  })
);
var FileContract_default = SvgFileContract;

// src/Icon/icons/FileCsv.tsx
import { jsx as jsx684 } from "react/jsx-runtime";
var SvgFileCsv = (props) => /* @__PURE__ */ jsx684(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx684(
      "path",
      {
        d: "M17.625 19.5v-1.25H19.5v1.25c0 1.379-1.121 2.5-2.5 2.5H7c-1.38 0-2.5-1.121-2.5-2.5v-1.25h1.875v1.25c0 .344.28.625.625.625h10a.627.627 0 0 0 .625-.625ZM14.5 8.25c-.691 0-1.25-.559-1.25-1.25V3.875H7a.625.625 0 0 0-.625.625v5H4.5v-5A2.5 2.5 0 0 1 7 2h6.465c.664 0 1.297.263 1.765.732l3.54 3.538c.468.468.73 1.101.73 1.765V9.5h-1.875V8.25H14.5Zm-6.25 2.5c.863 0 1.563.7 1.563 1.563v.312a.627.627 0 0 1-.626.625.627.627 0 0 1-.624-.625v-.313A.313.313 0 0 0 8.25 12h-.625a.313.313 0 0 0-.313.313v3.124c0 .172.14.313.313.313h.625c.172 0 .313-.14.313-.313v-.312c0-.344.28-.625.624-.625s.626.281.626.625v.313c0 .863-.7 1.562-1.563 1.562h-.625c-.863 0-1.563-.7-1.563-1.563v-3.124c0-.864.7-1.563 1.563-1.563h.625Zm2.188 1.813c0-1 .812-1.813 1.812-1.813h.688c.343 0 .624.281.624.625a.627.627 0 0 1-.624.625h-.688a.56.56 0 0 0-.563.563c0 .199.11.386.282.488l.992.566c.566.32.914.887.914 1.57 0 1-.813 1.813-1.813 1.813h-1a.627.627 0 0 1-.624-.625c0-.344.28-.625.624-.625h1a.56.56 0 0 0 .563-.563c0-.199-.11-.386-.281-.488l-.992-.566a1.804 1.804 0 0 1-.915-1.57Zm5 .046c0 .899.214 1.782.624 2.575.41-.793.625-1.676.625-2.575v-1.234c0-.344.282-.625.625-.625.344 0 .625.281.625.625v1.234a6.868 6.868 0 0 1-1.156 3.813l-.199.3a.627.627 0 0 1-1.039 0l-.2-.3a6.868 6.868 0 0 1-1.155-3.813v-1.234c0-.344.28-.625.624-.625s.626.281.626.625v1.234Z",
        fill: "currentColor"
      }
    )
  })
);
var FileCsv_default = SvgFileCsv;

// src/Icon/icons/FileDashedLine.tsx
import { jsx as jsx685 } from "react/jsx-runtime";
var SvgFileDashedLine = (props) => /* @__PURE__ */ jsx685(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx685(
      "path",
      {
        d: "M17 18.667v-2.778h1.667v2.778a2.224 2.224 0 0 1-2.223 2.222H7.556a2.224 2.224 0 0 1-2.223-2.222v-2.778H7v2.778c0 .305.25.555.556.555h8.888c.306 0 .556-.25.556-.555Zm-2.778-10a1.11 1.11 0 0 1-1.11-1.111V4.778H7.555A.556.556 0 0 0 7 5.333V12H5.333V5.333c0-1.227.997-2.222 2.223-2.222h5.746c.59 0 1.153.234 1.57.651l3.145 3.144c.417.417.65.98.65 1.57V12H17V8.667h-2.778Zm-7.5 4.444c.462 0 .834.372.834.833a.831.831 0 0 1-.834.834H2.833a.832.832 0 1 1 0-1.667h3.89Zm6.667 0c.462 0 .833.372.833.833a.831.831 0 0 1-.833.834H10.61a.831.831 0 0 1-.833-.834c0-.461.371-.833.833-.833h2.778Zm7.778 0c.461 0 .833.372.833.833a.831.831 0 0 1-.833.834h-3.89a.831.831 0 0 1-.833-.834c0-.461.372-.833.834-.833h3.889Z",
        fill: "currentColor"
      }
    )
  })
);
var FileDashedLine_default = SvgFileDashedLine;

// src/Icon/icons/FileExcel.tsx
import { jsx as jsx686 } from "react/jsx-runtime";
var SvgFileExcel = (props) => /* @__PURE__ */ jsx686(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx686(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Zm-4.176-8.387L12 12.973l-1.45-1.86a.93.93 0 0 0-1.312-.164.935.935 0 0 0-.164 1.317l1.739 2.234-1.74 2.236a.938.938 0 0 0 .704 1.514c.28 0 .557-.125.741-.361L12 16.027l1.448 1.862a.94.94 0 0 0 1.314.163.938.938 0 0 0 .164-1.316L13.187 14.5l1.74-2.236a.938.938 0 0 0-.164-1.316.933.933 0 0 0-1.314.165Z",
        fill: "currentColor"
      }
    )
  })
);
var FileExcel_default = SvgFileExcel;

// src/Icon/icons/FileExclamation.tsx
import { jsx as jsx687 } from "react/jsx-runtime";
var SvgFileExclamation = (props) => /* @__PURE__ */ jsx687(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx687(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035ZM12 15.125c.518 0 .938-.42.938-.938v-3.75a.938.938 0 0 0-1.876 0v3.75c0 .52.422.938.938.938Zm-.035 1.25c-.656 0-1.215.559-1.215 1.25a1.25 1.25 0 1 0 2.5 0c0-.69-.559-1.25-1.285-1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var FileExclamation_default = SvgFileExclamation;

// src/Icon/icons/FileExport.tsx
import { jsx as jsx688 } from "react/jsx-runtime";
var SvgFileExport = (props) => /* @__PURE__ */ jsx688(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx688(
      "path",
      {
        d: "m21.73 13.632-2.778-2.778a.833.833 0 1 0-1.179 1.179l1.387 1.356H9.502a.836.836 0 0 0-.834.834c0 .458.374.833.834.833h9.658l-1.355 1.356a.816.816 0 0 0-.246.59.833.833 0 0 0 1.423.59l2.779-2.78a.812.812 0 0 0-.03-1.18Zm-7.227 2.813a.833.833 0 0 0-.834.834v1.39a.556.556 0 0 1-.555.555h-8.89a.556.556 0 0 1-.556-.556V5.336c0-.307.248-.555.555-.555H9.78v2.773c0 .614.497 1.112 1.111 1.112h2.747v2.5c0 .46.373.834.803.834.429 0 .895-.372.895-.834V7.923c0-.59-.234-1.156-.65-1.572l-2.593-2.593a2.23 2.23 0 0 0-1.57-.649H4.19C2.995 3.109 2 4.104 2 5.332v13.336c0 1.228.995 2.223 2.223 2.223h8.89c1.223 0 2.223-1 2.223-2.223V17.28a.831.831 0 0 0-.833-.834Z",
        fill: "currentColor"
      }
    )
  })
);
var FileExport_default = SvgFileExport;

// src/Icon/icons/FileImage.tsx
import { jsx as jsx689 } from "react/jsx-runtime";
var SvgFileImage = (props) => /* @__PURE__ */ jsx689(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx689(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Zm-4.715-6.094a.547.547 0 0 0-.455.244l-1.549 2.327-.456-.685a.544.544 0 0 0-.909-.002l-1.823 2.735a.547.547 0 0 0-.027.561.53.53 0 0 0 .446.289h7.656a.547.547 0 0 0 .455-.85L13.33 13.65c-.065-.154-.237-.244-.42-.244ZM9.5 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var FileImage_default = SvgFileImage;

// src/Icon/icons/FileImport.tsx
import { jsx as jsx690 } from "react/jsx-runtime";
var SvgFileImport = (props) => /* @__PURE__ */ jsx690(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx690(
      "path",
      {
        d: "M12.273 16.96a.93.93 0 0 0-.273.665.937.937 0 0 0 1.6.663l3.125-3.125a.937.937 0 0 0 0-1.326L13.6 10.712a.937.937 0 1 0-1.325 1.326l1.526 1.524H2.937A.939.939 0 0 0 2 14.5c0 .516.42.938.938.938H13.8l-1.528 1.523ZM21.27 5.649l-2.916-2.916A2.512 2.512 0 0 0 16.586 2H9.5C8.121 2 6.965 3.12 7 4.5v6.563c0 .518.42.937.938.937.517 0 .937-.42.902-.938l.035-6.557c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5c0 .345-.28.625-.625.625H9.5a.625.625 0 0 1-.625-.625v-1.563A.935.935 0 0 0 7.937 17c-.519 0-.937.42-.902.938L7 19.5A2.5 2.5 0 0 0 9.5 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766Z",
        fill: "currentColor"
      }
    )
  })
);
var FileImport_default = SvgFileImport;

// src/Icon/icons/FileInvoice.tsx
import { jsx as jsx691 } from "react/jsx-runtime";
var SvgFileInvoice = (props) => /* @__PURE__ */ jsx691(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx691(
      "path",
      {
        d: "M7.625 12v2.5c0 .69.56 1.25 1.25 1.25h6.25c.69 0 1.25-.56 1.25-1.25V12c0-.69-.56-1.25-1.25-1.25h-6.25c-.69 0-1.25.559-1.25 1.25ZM18.77 5.648l-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035ZM8.25 7h3.125A.627.627 0 0 0 12 6.375a.627.627 0 0 0-.625-.625H8.25a.626.626 0 0 0 0 1.25Zm0 2.5h3.125A.627.627 0 0 0 12 8.875a.627.627 0 0 0-.625-.625H8.25a.626.626 0 0 0 0 1.25Zm7.5 7.5h-3.125a.625.625 0 1 0 0 1.25h3.125a.625.625 0 1 0 0-1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var FileInvoice_default = SvgFileInvoice;

// src/Icon/icons/FileLines.tsx
import { jsx as jsx692 } from "react/jsx-runtime";
var SvgFileLines = (props) => /* @__PURE__ */ jsx692(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx692(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035ZM8.25 12.937c0 .52.422.938.938.938h5.624c.52 0 .938-.418.938-.938a.935.935 0 0 0-.938-.937H9.189a.94.94 0 0 0-.938.938Zm6.563 2.813H9.186a.94.94 0 0 0-.937.938c0 .515.42.937.938.937h5.624a.938.938 0 0 0 0-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var FileLines_default = SvgFileLines;

// src/Icon/icons/FileLock.tsx
import { jsx as jsx693 } from "react/jsx-runtime";
var SvgFileLock = (props) => /* @__PURE__ */ jsx693(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx693(
      "path",
      {
        d: "m20.858 14.222.03-1.666a2.781 2.781 0 0 0-2.777-2.778 2.782 2.782 0 0 0-2.778 2.778v1.666c-.614 0-1.11.498-1.11 1.112v4.413c0 .645.496 1.142 1.11 1.142h5.525c.645 0 1.142-.497 1.142-1.142v-4.414c0-.614-.497-1.11-1.142-1.11Zm-1.636 0H17v-1.666a1.112 1.112 0 0 1 2.222 0v1.666Zm-4.708-4.444a.82.82 0 0 0 .82-.82V7.924c0-.59-.235-1.155-.651-1.572L12.09 3.761a2.229 2.229 0 0 0-1.57-.65H4.222A2.222 2.222 0 0 0 2 5.333v13.334c0 1.227.995 2.222 2.222 2.222h8.07a.82.82 0 0 0 .82-.82v-.026a.824.824 0 0 0-.82-.82h-8.07a.556.556 0 0 1-.555-.556V5.337c0-.306.248-.555.555-.555h5.556v2.742c0 .614.497 1.111 1.11 1.111h2.779v.29c0 .485.368.853.82.853h.027Z",
        fill: "currentColor"
      }
    )
  })
);
var FileLock_default = SvgFileLock;

// src/Icon/icons/FileMagnifyingGlass.tsx
import { jsx as jsx694 } from "react/jsx-runtime";
var SvgFileMagnifyingGlass = (props) => /* @__PURE__ */ jsx694(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx694(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Zm-6.25-9.375a3.75 3.75 0 1 0 0 7.5c.694 0 1.336-.202 1.894-.53l1.818 1.818c.183.185.42.274.663.274a.937.937 0 0 0 .663-1.6l-1.819-1.818a3.729 3.729 0 0 0-3.22-5.644Zm0 5.625a1.875 1.875 0 1 1 0-3.75 1.875 1.875 0 0 1 0 3.75Z",
        fill: "currentColor"
      }
    )
  })
);
var FileMagnifyingGlass_default = SvgFileMagnifyingGlass;

// src/Icon/icons/FileMinus.tsx
import { jsx as jsx695 } from "react/jsx-runtime";
var SvgFileMinus = (props) => /* @__PURE__ */ jsx695(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx695(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.125V19.5Zm-8.75-6.563c-.518 0-.938.42-.938.903 0 .518.42.902.938.902h6.25c.518 0 .938-.42.938-.902 0-.483-.42-.902-.938-.902h-6.25Z",
        fill: "currentColor"
      }
    )
  })
);
var FileMinus_default = SvgFileMinus;

// src/Icon/icons/FileMusic.tsx
import { jsx as jsx696 } from "react/jsx-runtime";
var SvgFileMusic = (props) => /* @__PURE__ */ jsx696(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx696(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Zm-7.5-7.527v4.48a2.792 2.792 0 0 0-.625-.078c-1.035 0-1.875.562-1.875 1.25s.84 1.25 1.875 1.25c1.035 0 1.875-.562 1.875-1.25v-3.941l3.75-1.465v2.984a2.793 2.793 0 0 0-.625-.078c-1.035 0-1.875.562-1.875 1.25s.84 1.25 1.875 1.25c1.035 0 1.875-.562 1.875-1.25v-6.25a.618.618 0 0 0-.809-.594l-5 1.846a.62.62 0 0 0-.441.596Z",
        fill: "currentColor"
      }
    )
  })
);
var FileMusic_default = SvgFileMusic;

// src/Icon/icons/FilePdf.tsx
import { jsx as jsx697 } from "react/jsx-runtime";
var SvgFilePdf = (props) => /* @__PURE__ */ jsx697(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx697(
      "path",
      {
        d: "M17 20.125a.627.627 0 0 0 .625-.625v-1.25H19.5v1.25c0 1.379-1.121 2.5-2.5 2.5H7c-1.38 0-2.5-1.121-2.5-2.5v-1.25h1.875v1.25c0 .344.28.625.625.625h10ZM14.5 8.25c-.691 0-1.25-.559-1.25-1.25V3.875H7a.625.625 0 0 0-.625.625v5H4.5v-5A2.5 2.5 0 0 1 7 2h6.465c.664 0 1.297.263 1.765.732l3.54 3.538c.468.468.73 1.101.73 1.765V9.5h-1.875V8.25H14.5Zm-6.563 2.5a2.189 2.189 0 0 1 0 4.375h-.312v1.25a.626.626 0 0 1-1.25 0v-5c0-.344.28-.625.625-.625h.938Zm.938 2.188A.935.935 0 0 0 7.937 12h-.312v1.875h.313c.519 0 .937-.418.937-.938Zm1.875-1.563c0-.344.281-.625.625-.625h.938c1.035 0 1.874.84 1.874 1.875v2.5c0 1.035-.84 1.875-1.874 1.875h-.938a.627.627 0 0 1-.625-.625v-5ZM12 15.75h.313a.627.627 0 0 0 .624-.625v-2.5a.627.627 0 0 0-.624-.625H12v3.75Zm5.625-5c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625h-1.25v1.25h1.25c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625h-1.25v1.875a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625v-5c0-.344.281-.625.625-.625h1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var FilePdf_default = SvgFilePdf;

// src/Icon/icons/FilePen.tsx
import { jsx as jsx698 } from "react/jsx-runtime";
var SvgFilePen = (props) => /* @__PURE__ */ jsx698(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx698(
      "path",
      {
        d: "M4.223 19.224h6.894l-.178.701c-.08.327-.059.66.05.966H4.222A2.224 2.224 0 0 1 2 18.668V5.332c0-1.228.995-2.223 2.223-2.223H9.97c.59 0 1.153.234 1.57.651l3.147 3.145c.417.417.65.98.65 1.57v5.04l-1.668 1.666V8.666h-2.778a1.11 1.11 0 0 1-1.112-1.111V4.776H4.223a.556.556 0 0 0-.556.556v13.336c0 .306.249.556.556.556Zm17.368-7.429c.545.542.545 1.42 0 1.966l-1.021 1.02-2.462-2.465 1.02-1.021a1.392 1.392 0 0 1 1.966 0l.497.5Zm-8.759 5.765 4.487-4.456 2.466 2.463-4.487 4.487a1.118 1.118 0 0 1-.517.292l-2.088.524a.567.567 0 0 1-.528-.146.59.59 0 0 1-.145-.559l.52-2.06c.05-.194.15-.371.292-.545Z",
        fill: "currentColor"
      }
    )
  })
);
var FilePen_default = SvgFilePen;

// src/Icon/icons/FilePlusMinus.tsx
import { jsx as jsx699 } from "react/jsx-runtime";
var SvgFilePlusMinus = (props) => /* @__PURE__ */ jsx699(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx699(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Zm-4.688-8.438V9.5a.938.938 0 0 0-1.874 0v1.563H9.5a.94.94 0 0 0-.938.937.94.94 0 0 0 .938.938h1.563V14.5a.938.938 0 0 0 1.874 0v-1.563H14.5a.938.938 0 0 0 0-1.874h-1.563Zm1.563 5.626h-5a.938.938 0 0 0 0 1.875h5a.938.938 0 0 0 0-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var FilePlusMinus_default = SvgFilePlusMinus;

// src/Icon/icons/FilePlus.tsx
import { jsx as jsx700 } from "react/jsx-runtime";
var SvgFilePlus = (props) => /* @__PURE__ */ jsx700(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx700(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.125V19.5Zm-4.688-8.785c0-.485-.417-.902-.937-.902s-.938.417-.938.902v2.223H8.876c-.518 0-.938.419-.938.902 0 .518.42.902.938.902h2.188v2.188c0 .59.417 1.008.937 1.008.518 0 .938-.42.938-.903v-2.258h2.187c.518 0 .938-.42.938-.902 0-.483-.42-.902-.938-.902h-2.188v-2.258Z",
        fill: "currentColor"
      }
    )
  })
);
var FilePlus_default = SvgFilePlus;

// src/Icon/icons/FilePowerpoint.tsx
import { jsx as jsx701 } from "react/jsx-runtime";
var SvgFilePowerpoint = (props) => /* @__PURE__ */ jsx701(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx701(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Zm-5.313-8.75H9.5a.627.627 0 0 0-.625.625v6.563a.938.938 0 0 0 1.875 0v-1.25h1.719a2.972 2.972 0 0 0 2.956-3.242c-.14-1.555-1.55-2.696-3.113-2.696Zm.157 4.063H10.75v-2.188h1.719a1.095 1.095 0 0 1 0 2.188Z",
        fill: "currentColor"
      }
    )
  })
);
var FilePowerpoint_default = SvgFilePowerpoint;

// src/Icon/icons/FileShield.tsx
import { jsx as jsx702 } from "react/jsx-runtime";
var SvgFileShield = (props) => /* @__PURE__ */ jsx702(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx702(
      "path",
      {
        d: "M4.191 19.222h8.597c.382.5.837.976 1.372 1.403-.313.17-.67.264-1.049.264H4.222A2.223 2.223 0 0 1 2 18.667V5.333c0-1.227.995-2.222 2.222-2.222H9.97c.59 0 1.152.234 1.57.651l3.145 3.144c.417.417.65.98.65 1.57v1.823l-1.667.666V8.667h-2.778a1.11 1.11 0 0 1-1.111-1.111V4.778H4.222a.555.555 0 0 0-.555.555v13.334c0 .305.248.555.555.555h-.031Zm12.5-8.274c.198-.08.42-.08.618 0l4.167 1.667a.838.838 0 0 1 .524.774c0 2.198-.9 5.861-4.68 7.437a.848.848 0 0 1-.64 0C12.9 19.25 12 15.586 12 13.39c0-.34.177-.646.524-.774l4.167-1.667Zm.309 1.67v6.524c2.368-1.145 3.174-3.437 3.313-5.229L17 12.618Z",
        fill: "currentColor"
      }
    )
  })
);
var FileShield_default = SvgFileShield;

// src/Icon/icons/FileSignature.tsx
import { jsx as jsx703 } from "react/jsx-runtime";
var SvgFileSignature = (props) => /* @__PURE__ */ jsx703(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx703(
      "path",
      {
        d: "M3.667 18.667V5.337c0-.306.248-.555.555-.555h5.556v2.774c0 .613.497 1.11 1.11 1.11h2.748v3.27l1.697-1.655V7.924c0-.59-.234-1.155-.65-1.572L12.09 3.76a2.231 2.231 0 0 0-1.57-.649H4.22A2.22 2.22 0 0 0 2 5.333v13.334a2.22 2.22 0 0 0 2.22 2.222h8.891c1.03 0 1.894-.713 2.143-1.667H4.223a.556.556 0 0 1-.556-.555Zm8.496-3.67a.56.56 0 0 0-.163.395v1.049l-.528.004a.4.4 0 0 1-.351-.226c-.413-.83-1.606-1.055-2.292-.49l-.482-1.446a.833.833 0 0 0-1.581.002l-.634 1.896a.386.386 0 0 1-.368.264h-.43a.554.554 0 0 0-.556.555c0 .308.247.556.555.556h.43a1.5 1.5 0 0 0 1.424-1.025l.369-1.107.586 1.75a.55.55 0 0 0 .487.382h.038a.548.548 0 0 0 .494-.309l.27-.534a.386.386 0 0 1 .347-.213c.073 0 .252.022.351.226.257.514.774.83 1.343.83h2.694c.148 0 .29-.06.394-.165l5.448-5.486-2.357-2.357-5.488 5.449Zm9.577-6.073-1.108-1.108a.88.88 0 0 0-1.25 0l-.946.946 2.357 2.357.946-.946a.879.879 0 0 0 0-1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var FileSignature_default = SvgFileSignature;

// src/Icon/icons/FileSlash.tsx
import { jsx as jsx704 } from "react/jsx-runtime";
var SvgFileSlash = (props) => /* @__PURE__ */ jsx704(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx704(
      "path",
      {
        d: "M22 19.232a.749.749 0 0 0-.288-.591l-3.717-2.914V8.3c0-.531-.211-1.041-.587-1.417L15.073 4.55a1.982 1.982 0 0 0-1.388-.56H8.008a2.004 2.004 0 0 0-2.002 2.003v.344L3.215 4.15a.75.75 0 0 0-.463-.16.746.746 0 0 0-.752.723c0 .222.099.443.288.59l18.497 14.493c.167.163.33.216.464.216.46 0 .751-.357.751-.779Zm-5.48-4.653L7.536 7.516V5.997c0-.276.224-.5.472-.5h5.007v2.5c0 .552.449.972.973.972l2.532-.001v5.61Zm-.5 3.902H8.008c-.276 0-.472-.224-.472-.5l-.028-6.65-1.502-1.177v7.826c0 1.106.896 2.003 1.974 2.003h8.04c.638 0 1.203-.308 1.57-.777l-1.18-.925c-.093.147-.228.2-.39.2Z",
        fill: "currentColor"
      }
    )
  })
);
var FileSlash_default = SvgFileSlash;

// src/Icon/icons/FileSpreadsheet.tsx
import { jsx as jsx705 } from "react/jsx-runtime";
var SvgFileSpreadsheet = (props) => /* @__PURE__ */ jsx705(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx705(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Zm-10-7.5v5c0 .69.56 1.25 1.25 1.25h6.25c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25h-6.25c-.69 0-1.25.559-1.25 1.25Zm3.75 5h-2.5v-1.875h2.5V17Zm1.25-5h2.5v1.875h-2.5V12Zm0 3.125h2.5V17h-2.5v-1.875Zm-1.25-1.25h-2.5V12h2.5v1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var FileSpreadsheet_default = SvgFileSpreadsheet;

// src/Icon/icons/FileUser.tsx
import { jsx as jsx706 } from "react/jsx-runtime";
var SvgFileUser = (props) => /* @__PURE__ */ jsx706(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx706(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625h-.063A3.745 3.745 0 0 0 13.25 17h-2.5a3.743 3.743 0 0 0-3.687 3.125H7a.625.625 0 0 1-.625-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035ZM12 10.75a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
        fill: "currentColor"
      }
    )
  })
);
var FileUser_default = SvgFileUser;

// src/Icon/icons/FileVideo.tsx
import { jsx as jsx707 } from "react/jsx-runtime";
var SvgFileVideo = (props) => /* @__PURE__ */ jsx707(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx707(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Zm-3.75-6.25c0-.69-.56-1.25-1.25-1.25h-3.75c-.69 0-1.25.56-1.25 1.25V17c0 .69.56 1.25 1.25 1.25h3.75c.69 0 1.25-.56 1.25-1.25v-.645l1.713 1.18c.33.227.787-.004.787-.402v-4.016c0-.397-.455-.631-.787-.403l-1.713 1.18v-.644Z",
        fill: "currentColor"
      }
    )
  })
);
var FileVideo_default = SvgFileVideo;

// src/Icon/icons/FileWaveform.tsx
import { jsx as jsx708 } from "react/jsx-runtime";
var SvgFileWaveform = (props) => /* @__PURE__ */ jsx708(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx708(
      "path",
      {
        d: "M9.969 16.895a.935.935 0 0 0 .777.418c.02 0 .041 0 .06-.002a.938.938 0 0 0 .781-.517l1.716-3.433.381.666a.94.94 0 0 0 .816.473h1.563c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937h-1.018l-.98-1.715a.918.918 0 0 0-.841-.473.937.937 0 0 0-.813.52l-1.777 3.554-1.012-1.468c-.14-.262-.434-.418-.746-.418H4.187a.939.939 0 0 0-.937.938c0 .515.42.937.938.937h4.187l1.594 2.395Zm10.05-11.247-2.915-2.916A2.512 2.512 0 0 0 15.336 2H8.25c-1.38 0-2.535 1.12-2.5 2.5v5.938a.938.938 0 0 0 1.875 0V4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5c0 .345-.28.625-.625.625H8.25a.625.625 0 0 1-.625-.625v-2.813c0-.518-.42-.937-.902-.937-.483 0-.938.42-.938.938L5.75 19.5a2.5 2.5 0 0 0 2.5 2.5h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766Z",
        fill: "currentColor"
      }
    )
  })
);
var FileWaveform_default = SvgFileWaveform;

// src/Icon/icons/FileWord.tsx
import { jsx as jsx709 } from "react/jsx-runtime";
var SvgFileWord = (props) => /* @__PURE__ */ jsx709(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx709(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Zm-4.742-7.813a.931.931 0 0 0-.883-.624.935.935 0 0 0-.884.624l-.964 2.739-1.011-3.034a.945.945 0 0 0-1.187-.595.94.94 0 0 0-.593 1.187l1.875 5.625c.127.38.479.637.881.641.397 0 .76-.25.892-.625L12 14.816l.992 2.809a.935.935 0 0 0 .883.625.948.948 0 0 0 .89-.641l1.875-5.625a.939.939 0 0 0-1.78-.593l-1.01 3.033-.967-2.736Z",
        fill: "currentColor"
      }
    )
  })
);
var FileWord_default = SvgFileWord;

// src/Icon/icons/FileXmark.tsx
import { jsx as jsx710 } from "react/jsx-runtime";
var SvgFileXmark = (props) => /* @__PURE__ */ jsx710(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx710(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h6.25V7c0 .69.56 1.25 1.25 1.25h3.125V19.5Zm-3.79-8.164L12 13.176l-1.871-1.84a.937.937 0 1 0-1.326 1.326l1.873 1.838-1.837 1.837a.937.937 0 1 0 1.325 1.326L12 15.824l1.837 1.837a.937.937 0 1 0 1.326-1.326L13.324 14.5l1.837-1.837a.937.937 0 0 0-1.325-1.327Z",
        fill: "currentColor"
      }
    )
  })
);
var FileXmark_default = SvgFileXmark;

// src/Icon/icons/FileZipper.tsx
import { jsx as jsx711 } from "react/jsx-runtime";
var SvgFileZipper = (props) => /* @__PURE__ */ jsx711(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx711(
      "path",
      {
        d: "m18.77 5.648-2.916-2.916A2.512 2.512 0 0 0 14.086 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM17.625 19.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.624-.625L6.375 4.505c0-.345.28-.625.625-.625h1.875v.62h2.5v-.62h1.875V7c0 .69.56 1.25 1.25 1.25h3.09V19.5h.035Zm-6.25-13.75h-2.5V7h2.5V5.75Zm0 2.5h-2.5V9.5h2.5V8.25Zm0 2.5h-2.5L7.681 15.3c-.31 1.524.87 2.95 2.456 2.95 1.572 0 2.752-1.418 2.448-2.935l-1.21-4.565Zm-.625 5.625H9.5a.625.625 0 1 1 0-1.25h1.25a.625.625 0 1 1 0 1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var FileZipper_default = SvgFileZipper;

// src/Icon/icons/File.tsx
import { jsx as jsx712 } from "react/jsx-runtime";
var SvgFile = (props) => /* @__PURE__ */ jsx712(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx712(
      "path",
      {
        d: "M4.5 4.5A2.5 2.5 0 0 1 7 2h6.465c.664 0 1.297.263 1.765.732l3.54 3.538c.468.468.73 1.101.73 1.765V19.5c0 1.379-1.121 2.5-2.5 2.5H7c-1.38 0-2.5-1.121-2.5-2.5v-15Zm13.125 15V8.25H14.5c-.691 0-1.25-.559-1.25-1.25V3.875H7a.625.625 0 0 0-.625.625v15c0 .344.28.625.625.625h10a.627.627 0 0 0 .625-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var File_default = SvgFile;

// src/Icon/icons/Files.tsx
import { jsx as jsx713 } from "react/jsx-runtime";
var SvgFiles = (props) => /* @__PURE__ */ jsx713(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx713(
      "path",
      {
        d: "m20.02 5.648-2.916-2.916A2.512 2.512 0 0 0 15.336 2H9.5C8.121 2 7 3.12 7 4.5v11.25a2.5 2.5 0 0 0 2.5 2.5h8.75c1.375 0 2.5-1.125 2.5-2.5V7.414c0-.66-.262-1.297-.73-1.766ZM18.875 15.75c0 .345-.28.625-.625.625H9.5a.625.625 0 0 1-.625-.625V4.505c0-.345.28-.625.625-.625h5V7c0 .69.56 1.25 1.25 1.25h3.125v7.5ZM16.062 22H7.938a4.692 4.692 0 0 1-4.687-4.688V6.688a.939.939 0 0 1 1.875 0v10.625a2.816 2.816 0 0 0 2.813 2.813h8.125a.938.938 0 0 1 0 1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var Files_default = SvgFiles;

// src/Icon/icons/FilterCircleDollar.tsx
import { jsx as jsx714 } from "react/jsx-runtime";
var SvgFilterCircleDollar = (props) => /* @__PURE__ */ jsx714(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx714(
      "path",
      {
        d: "M18.396 3.111a1.381 1.381 0 0 1 1.076 2.247l-2.934 3.645c-.288.358-.812.417-1.201.129-.33-.288-.417-.816-.097-1.174l2.559-3.18H4.012l5.582 6.979c.118.15.184.333.184.52v2.362l.778.583a.832.832 0 1 1-1 1.333l-1.112-.833a.834.834 0 0 1-.333-.666v-2.487L2.295 5.3a1.347 1.347 0 0 1 1.053-2.189h15.048ZM22 15.89c0 2.76-2.24 5-5 5s-5-2.24-5-5 2.24-5 5-5 5 2.24 5 5Zm-5.66-1.281c.177-.063.438-.112.653-.108.254.004.594.063.913.142.299.073.6-.138.674-.406a.556.556 0 0 0-.403-.674 6.165 6.165 0 0 0-.621-.124v-.327a.557.557 0 0 0-.556-.555.557.557 0 0 0-.556.555v.33a2.798 2.798 0 0 0-.656.219c-.382.219-.77.639-.729 1.291.035.556.406.882.75 1.066.31.164.688.271.993.327l.063.048c.354.101.59.18.802.289.16.093.135.149.135.197.035.084.014.129-.035.157.007.003-.03.076-.139.118-.131.087-.378.132-.61.094-.362.02-.643-.08-1.039-.205l-.201-.063a.556.556 0 1 0-.333 1.059c.059.018.114.007.176.056.244.08.525.17.823.229v.396a.555.555 0 1 0 1.112 0v-.375c.215-.038.434-.108.635-.216.417-.229.77-.649.722-1.284.014-.56-.326-.91-.68-1.118-.327-.195-.74-.31-1.063-.403h-.003c-.365-.104-.636-.18-.83-.285-.167-.09-.167-.139-.167-.153v-.034c-.007-.039.01-.07.024-.094.021-.031.063-.073.146-.15Z",
        fill: "currentColor"
      }
    )
  })
);
var FilterCircleDollar_default = SvgFilterCircleDollar;

// src/Icon/icons/FilterCircleXmark.tsx
import { jsx as jsx715 } from "react/jsx-runtime";
var SvgFilterCircleXmark = (props) => /* @__PURE__ */ jsx715(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx715(
      "path",
      {
        d: "M18.396 3.111a1.381 1.381 0 0 1 1.076 2.247l-2.934 3.645c-.288.358-.812.417-1.201.129-.33-.288-.417-.816-.097-1.174l2.559-3.18H4.012l5.582 6.979c.118.15.184.333.184.52v2.362l.778.583a.832.832 0 1 1-1 1.333l-1.112-.833a.834.834 0 0 1-.333-.666v-2.487L2.295 5.3a1.347 1.347 0 0 1 1.053-2.189h15.048ZM12 15.89c0-2.76 2.24-5 5-5s5 2.24 5 5-2.24 5-5 5-5-2.24-5-5Zm7.059-1.274a.551.551 0 0 0 0-.785.551.551 0 0 0-.785 0L17 15.104l-1.274-1.274a.551.551 0 0 0-.785 0 .551.551 0 0 0 0 .785l1.274 1.274-1.274 1.274a.551.551 0 0 0 0 .785c.215.219.57.219.785 0L17 16.674l1.274 1.274c.216.219.57.219.785 0a.551.551 0 0 0 0-.785l-1.274-1.274 1.274-1.274Z",
        fill: "currentColor"
      }
    )
  })
);
var FilterCircleXmark_default = SvgFilterCircleXmark;

// src/Icon/icons/FilterList.tsx
import { jsx as jsx716 } from "react/jsx-runtime";
var SvgFilterList = (props) => /* @__PURE__ */ jsx716(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx716(
      "path",
      {
        d: "M14.14 4.5c.887 0 1.61.721 1.61 1.61 0 .406-.152.8-.465 1.097l-3.633 3.91v7.11c0 .703-.535 1.273-1.238 1.273-.285 0-.496-.074-.703-.21l-2.98-1.946a1.617 1.617 0 0 1-.668-1.305v-4.922L2.43 7.207A1.61 1.61 0 0 1 3.61 4.5h10.53Zm-6.238 6.25v5.121l1.875 1.238V10.75c0-.238.125-.465.286-.637l3.468-3.738H4.217l3.47 3.738c.16.172.215.399.215.637Zm13.16 6.563c.52 0 .938.418.938.937 0 .52-.418.938-.938.938h-5.625a.935.935 0 0 1-.937-.938c0-.52.418-.938.938-.938h5.624ZM14.5 12c0-.52.418-.938.938-.938h5.624c.52 0 .938.418.938.938s-.418.938-.938.938h-5.625A.935.935 0 0 1 14.5 12Zm6.563-7.188a.937.937 0 1 1 0 1.875h-3.125a.937.937 0 1 1 0-1.875h3.125Z",
        fill: "currentColor"
      }
    )
  })
);
var FilterList_default = SvgFilterList;

// src/Icon/icons/FilterSlash.tsx
import { jsx as jsx717 } from "react/jsx-runtime";
var SvgFilterSlash = (props) => /* @__PURE__ */ jsx717(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx717(
      "path",
      {
        d: "M4.567 5.221c.206-.14.455-.221.724-.221h13.406a1.304 1.304 0 0 1 1.01 2.125l-4.954 6.081 6.96 5.453a.75.75 0 0 1-.926 1.181l-18.5-14.5a.75.75 0 1 1 .926-1.18L4.567 5.22ZM6.2 6.5l7.372 5.753 4.71-5.753H6.2ZM13 16.975v-1.31l1.5 1.185v1.14A1.01 1.01 0 0 1 13.49 19a.899.899 0 0 1-.628-.247l-2.89-2.266a1.254 1.254 0 0 1-.472-.978v-2.6L11 14.09v1.297l2 1.588Z",
        fill: "currentColor"
      }
    )
  })
);
var FilterSlash_default = SvgFilterSlash;

// src/Icon/icons/Filter.tsx
import { jsx as jsx718 } from "react/jsx-runtime";
var SvgFilter = (props) => /* @__PURE__ */ jsx718(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx718(
      "path",
      {
        d: "M2 4.879c0-.9.73-1.629 1.629-1.629H20.37c.899 0 1.629.73 1.629 1.629 0 .375-.129.738-.367 1.027l-6.508 7.989v5.593c0 .696-.566 1.262-1.262 1.262-.285 0-.562-.098-.785-.309L9.465 17.61a1.567 1.567 0 0 1-.59-1.222v-2.492L2.366 5.906A1.621 1.621 0 0 1 2 4.88Zm2.147.246 6.392 7.844c.137.168.211.379.211.594v2.671l2.5 1.985v-4.657c0-.214.074-.425.21-.593l6.392-7.844H4.147Z",
        fill: "currentColor"
      }
    )
  })
);
var Filter_default = SvgFilter;

// src/Icon/icons/Filters.tsx
import { jsx as jsx719 } from "react/jsx-runtime";
var SvgFilters = (props) => /* @__PURE__ */ jsx719(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx719(
      "path",
      {
        d: "M20.694 5.006a1.307 1.307 0 0 1 1.028 2.114L17.5 12.516v4.475c0 .834-.962 1.303-1.619.787l-2.903-2.281a1.248 1.248 0 0 1-.478-.984v-1.997L8.278 7.12a1.307 1.307 0 0 1 1.028-2.114h11.388ZM14 12.256v2.135l2 1.572v-3.707c0-.168.056-.33.16-.462l4.137-5.288H9.703l4.138 5.288c.103.131.159.294.159.462ZM7.49 7.738l.576.768H3.702l4.139 5.288c.103.131.159.294.159.462v1.135l2 1.572v-2.707c0-.168.056-.33.16-.462l1.037-1.325.303.39v5.132c0 .834-.963 1.303-1.619.787l-2.903-2.281a1.248 1.248 0 0 1-.478-.984v-.997L2.278 9.119a1.307 1.307 0 0 1 1.03-2.112h3.798c.082.262.213.509.385.73Z",
        fill: "currentColor"
      }
    )
  })
);
var Filters_default = SvgFilters;

// src/Icon/icons/Fingerprint.tsx
import { jsx as jsx720 } from "react/jsx-runtime";
var SvgFingerprint = (props) => /* @__PURE__ */ jsx720(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx720(
      "path",
      {
        d: "M12.02 11.61c-.516 0-.9.42-.9.901a28.427 28.427 0 0 1-1.082 8.248c-.139.417.052 1.224.867 1.224.41 0 .785-.268.902-.682.526-1.867 1.174-4.89 1.15-8.755a.937.937 0 0 0-.937-.935Zm-.035-3.185c-2.421-.008-4.055 1.832-4.02 3.942a25.581 25.581 0 0 1-.521 5.557c-.108.472.219.999.726 1.106.472.102.999-.22 1.106-.726.404-1.954.59-3.962.56-5.931-.015-1.051.742-2.084 2.122-2.077 1.223.02 2.232.99 2.247 2.165a30.965 30.965 0 0 1-.414 5.595c-.083.472.263.99.775 1.078.775.126 1.043-.59 1.072-.775.322-1.915.473-3.943.439-5.893-.036-2.216-1.869-4.01-4.092-4.041Zm-4.312-.773a.94.94 0 0 0-1.322.133 6.812 6.812 0 0 0-1.51 4.367 22.584 22.584 0 0 1-.35 4.372c-.093.472.243.994.75 1.087.785.136 1.058-.58 1.057-.756.278-1.554.41-3.143.38-4.734a5.228 5.228 0 0 1 1.092-3.15.902.902 0 0 0-.097-1.319Zm4.23-2.431a6.794 6.794 0 0 0-1.75.195c-.502.081-.814.588-.697 1.125.122.502.589.81 1.096.693a6.4 6.4 0 0 1 1.363-.143c2.94.044 5.366 2.398 5.417 5.249a35.737 35.737 0 0 1-.22 4.43c-.058.511.312.94.824 1.033a.954.954 0 0 0 1.033-.824c.18-1.55.259-3.11.234-4.667-.066-3.848-3.322-7.033-7.3-7.091Zm9.867 4.736c-.113-.472-.605-.829-1.117-.717-.472.112-.824.614-.712 1.116.186.839.19 1.463.186 2.403-.005.517.409.94.926.946.511 0 .94-.414.945-.93.005-.86.013-1.718-.229-2.818Zm-1.6-3.537a10.376 10.376 0 0 0-8.317-4.402c-2.72-.035-5.233.968-7.105 2.845a9.294 9.294 0 0 0-2.743 6.77L2 12.47c.02.52.424.949.94.964.01.004.02.004.03.004.472 0 .921-.404.9-.911l.006-.921c.005-2.048.78-3.974 2.229-5.42C7.62 4.674 9.668 3.86 11.865 3.89c2.705.004 5.252 1.39 6.808 3.603a.932.932 0 0 0 1.302.229c.39-.3.527-.877.196-1.302Z",
        fill: "currentColor"
      }
    )
  })
);
var Fingerprint_default = SvgFingerprint;

// src/Icon/icons/FlagSwallowtail.tsx
import { jsx as jsx721 } from "react/jsx-runtime";
var SvgFlagSwallowtail = (props) => /* @__PURE__ */ jsx721(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx721(
      "path",
      {
        d: "M5.125 2.938A.935.935 0 0 0 4.187 2a.935.935 0 0 0-.937.938v18.125c0 .519.418.937.938.937.519 0 .937-.418.937-.938V15.75h14.688a.935.935 0 0 0 .75-1.5L17 9.5l3.563-4.75a.935.935 0 0 0-.75-1.5H5.124v-.313Zm0 2.187h12.813L15.5 8.375c-.5.668-.5 1.582 0 2.25l2.438 3.25H5.124v-8.75Z",
        fill: "currentColor"
      }
    )
  })
);
var FlagSwallowtail_default = SvgFlagSwallowtail;

// src/Icon/icons/Flag.tsx
import { jsx as jsx722 } from "react/jsx-runtime";
var SvgFlag = (props) => /* @__PURE__ */ jsx722(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx722(
      "path",
      {
        d: "M5.125 2.938A.935.935 0 0 0 4.187 2a.935.935 0 0 0-.937.938v18.125c0 .519.418.937.938.937.519 0 .937-.418.937-.938v-3.906l3.137-.785a6.947 6.947 0 0 1 4.785.524 6.918 6.918 0 0 0 5.535.289l1.355-.508c.489-.184.813-.649.813-1.172V4.582A1.21 1.21 0 0 0 19 3.5l-.375.188a6.412 6.412 0 0 1-5.746 0 6.426 6.426 0 0 0-4.434-.489l-3.32.832V2.938Zm0 3.027 3.773-.945a4.574 4.574 0 0 1 3.141.343 8.305 8.305 0 0 0 6.836.266v9.445l-.953.356a5.068 5.068 0 0 1-4.04-.211 8.82 8.82 0 0 0-6.077-.668l-2.68.672V5.965Z",
        fill: "currentColor"
      }
    )
  })
);
var Flag_default = SvgFlag;

// src/Icon/icons/Flashlight.tsx
import { jsx as jsx723 } from "react/jsx-runtime";
var SvgFlashlight = (props) => /* @__PURE__ */ jsx723(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx723(
      "path",
      {
        d: "M20.999 6.993h-1.002c-1.96 0-3.87.579-5.504 1.666l-.504.337H3.502c-.83 0-1.502.673-1.502 1.502v3.004c0 .83.673 1.502 1.502 1.502H13.99l.504.337a10.053 10.053 0 0 0 5.504 1.666H21c.551 0 1.001-.45 1.001-1.001V7.994a.987.987 0 0 0-1.001-1.001Zm-1.975 8.437a8.309 8.309 0 0 1-3.668-1.342l-.885-.586H3.502v-3.004h10.969l.884-.587a8.35 8.35 0 0 1 3.669-1.34v6.859Zm-8.137-4.181h-.75a.751.751 0 0 0 0 1.502h.75a.751.751 0 0 0 0-1.502Z",
        fill: "currentColor"
      }
    )
  })
);
var Flashlight_default = SvgFlashlight;

// src/Icon/icons/FlaskRoundPotion.tsx
import { jsx as jsx724 } from "react/jsx-runtime";
var SvgFlaskRoundPotion = (props) => /* @__PURE__ */ jsx724(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx724(
      "path",
      {
        d: "M15.747 8.602V3.875h.312a.937.937 0 1 0 0-1.875H7.934a.937.937 0 1 0 0 1.875h.312v4.691c-2.557 1.36-4.34 4.055-4.34 7.184 0 2.1.797 4.016 2.11 5.46.464.513 1.138.79 1.8.79h8.325c.703 0 1.387-.293 1.856-.816a8.111 8.111 0 0 0 2.089-5.254c.137-3.117-1.68-5.918-4.34-7.328Zm-2.016 6.253c-2.356-1.178-5.035-1.261-7.895.154a6.228 6.228 0 0 1 3.318-4.777l1.005-.526V3.875h3.75v5.848l.987.53c2.065 1.11 3.375 3.257 3.38 5.496-1.03-.034-2.6.044-4.545-.894Z",
        fill: "currentColor"
      }
    )
  })
);
var FlaskRoundPotion_default = SvgFlaskRoundPotion;

// src/Icon/icons/FlaskVial.tsx
import { jsx as jsx725 } from "react/jsx-runtime";
var SvgFlaskVial = (props) => /* @__PURE__ */ jsx725(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx725(
      "path",
      {
        d: "M7 17.828A3 3 0 0 1 3 15V5.5h-.25a.75.75 0 0 1 0-1.5h6.5a.75.75 0 1 1 0 1.5H9v8.184L7.469 16.17A3.18 3.18 0 0 0 7 17.829ZM4.5 9h3V5.5h-3V9Zm0 1.5V15a1.5 1.5 0 0 0 3 0v-4.5h-3ZM18.25 4a.75.75 0 1 1 0 1.5H18v5.287l3.66 5.991c.23.335.34.716.34 1.11A2.114 2.114 0 0 1 19.887 20h-9.774c-1.166 0-2.141-.947-2.141-2.113 0-.393.137-.774.34-1.109l3.66-5.99V5.5h-.25a.768.768 0 0 1-.75-.75c0-.414.362-.75.75-.75h6.528ZM16.5 5.5h-3V11a.738.738 0 0 1-.113.394L11.784 14h6.432l-1.604-2.606A.738.738 0 0 1 16.5 11V5.5Zm-7 12.387c0 .338.275.613.613.613h9.774a.613.613 0 0 0 .613-.613c0-.115-.06-.224-.09-.321L19.136 15.5h-8.274L9.59 17.566a.61.61 0 0 0-.091.322Z",
        fill: "currentColor"
      }
    )
  })
);
var FlaskVial_default = SvgFlaskVial;

// src/Icon/icons/Flask.tsx
import { jsx as jsx726 } from "react/jsx-runtime";
var SvgFlask = (props) => /* @__PURE__ */ jsx726(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx726(
      "path",
      {
        d: "m20.328 17.762-4.613-7.364V3.875h.312c.518 0 .902-.42.902-.938 0-.517-.351-.937-.902-.937h-8.09a.939.939 0 0 0 0 1.875h.313v6.523l-4.578 7.364C2.528 19.602 3.846 22 6.019 22H17.98c2.172 0 3.493-2.402 2.348-4.238ZM7.906 14.5l2.218-3.566V3.875h3.75v7.059l2.22 3.566H7.906Z",
        fill: "currentColor"
      }
    )
  })
);
var Flask_default = SvgFlask;

// src/Icon/icons/FloppyDiskCircleArrowRight.tsx
import { jsx as jsx727 } from "react/jsx-runtime";
var SvgFloppyDiskCircleArrowRight = (props) => /* @__PURE__ */ jsx727(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx727(
      "path",
      {
        d: "M9.79 11.444a2.232 2.232 0 0 0-2.226 2.225 2.232 2.232 0 0 0 2.226 2.226c.411 0 .793-.12 1.125-.318-.002-.079-.012-.159-.012-.239 0-1.052.266-2.042.734-2.907a2.229 2.229 0 0 0-1.847-.987Zm-5.564 6.12a.556.556 0 0 1-.557-.556V5.879c0-.307.25-.556.557-.556h.556V8.94c0 .46.374.834.835.834h6.677a.833.833 0 0 0 .835-.834V5.458l2.72 2.721c.04.037.062.093.062.145v.998a6.19 6.19 0 0 1 1.112-.104c.188 0 .373.011.557.028V8.24c0-.441-.177-.868-.488-1.18l-2.918-2.917a1.666 1.666 0 0 0-1.181-.49H4.226C2.996 3.654 2 4.65 2 5.879v11.129c0 1.23.996 2.226 2.226 2.226H12.3a6.11 6.11 0 0 1-.976-1.67h-7.1ZM6.45 5.323h5.008v2.782H6.451V5.323Zm10.572 5.008a5.007 5.007 0 1 0 0 10.015c2.767 0 4.977-2.241 4.977-5.008 0-2.766-2.212-5.007-4.977-5.007Zm2.62 5.4-1.948 1.948a.577.577 0 0 1-.425.164.505.505 0 0 1-.393-.164.556.556 0 0 1 0-.786l1.03-.998h-3.108c-.308 0-.526-.25-.526-.556 0-.308.25-.557.526-.557h3.108l-.998-.998a.556.556 0 1 1 .787-.786l1.947 1.947a.553.553 0 0 1 0 .787Z",
        fill: "currentColor"
      }
    )
  })
);
var FloppyDiskCircleArrowRight_default = SvgFloppyDiskCircleArrowRight;

// src/Icon/icons/FloppyDiskCircleXmark.tsx
import { jsx as jsx728 } from "react/jsx-runtime";
var SvgFloppyDiskCircleXmark = (props) => /* @__PURE__ */ jsx728(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx728(
      "path",
      {
        d: "M17 10.333a5.004 5.004 0 0 0-5 5 5 5 0 1 0 5-5Zm1.962 6.177a.556.556 0 0 1-.785.785l-1.178-1.177-1.177 1.178a.556.556 0 0 1-.785-.786l1.177-1.177-1.177-1.177a.556.556 0 0 1 .785-.786l1.177 1.178 1.178-1.178a.555.555 0 1 1 .785.786l-1.178 1.177 1.178 1.177Zm-9.184-5.066c-1.222 0-2.222 1-2.222 2.223 0 1.222 1 2.222 2.222 2.222.41 0 .792-.12 1.123-.317-.002-.079-.012-.159-.012-.239 0-1.05.266-2.039.732-2.902a2.225 2.225 0 0 0-1.843-.986Zm-5.556 6.112A.556.556 0 0 1 3.667 17V5.889c0-.307.248-.556.555-.556h.556v3.611c0 .46.373.834.833.834h6.667a.831.831 0 0 0 .833-.834V5.468l2.717 2.717a.2.2 0 0 1 .06.145v.996A6.18 6.18 0 0 1 17 9.222c.188 0 .372.012.556.028V8.247c0-.44-.177-.866-.488-1.178l-2.913-2.913a1.663 1.663 0 0 0-1.18-.49H4.223A2.222 2.222 0 0 0 2 5.89V17c0 1.227.995 2.222 2.222 2.222h8.063a6.1 6.1 0 0 1-.974-1.666H4.222ZM6.444 5.333h5v2.778h-5V5.333Z",
        fill: "currentColor"
      }
    )
  })
);
var FloppyDiskCircleXmark_default = SvgFloppyDiskCircleXmark;

// src/Icon/icons/FloppyDiskPen.tsx
import { jsx as jsx729 } from "react/jsx-runtime";
var SvgFloppyDiskPen = (props) => /* @__PURE__ */ jsx729(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx729(
      "path",
      {
        d: "M3.667 17V5.89c0-.308.248-.556.555-.556h.556v3.61c0 .46.373.834.833.834h6.667a.831.831 0 0 0 .833-.833V5.468l2.717 2.717a.2.2 0 0 1 .06.145v4.042l1.668-1.667V8.247c0-.44-.177-.866-.488-1.177l-2.913-2.913a1.663 1.663 0 0 0-1.18-.49H4.223A2.222 2.222 0 0 0 2 5.889V17c0 1.228.995 2.223 2.222 2.223h6.799l.333-1.667H4.222A.556.556 0 0 1 3.667 17ZM6.444 5.334h5V8.11h-5V5.334Zm6.23 11.826a.625.625 0 0 0-.171.32l-.496 2.48a.313.313 0 0 0 .367.367l2.48-.496a.624.624 0 0 0 .32-.171l4.35-4.351-2.5-2.5-4.35 4.351Zm-2.896-5.715c-1.222 0-2.222 1-2.222 2.222s1 2.222 2.222 2.222S12 14.89 12 13.667s-1-2.222-2.222-2.222Zm11.857-.01-.732-.734a1.25 1.25 0 0 0-1.768 0l-1.324 1.324 2.5 2.5 1.324-1.323a1.253 1.253 0 0 0 0-1.768Z",
        fill: "currentColor"
      }
    )
  })
);
var FloppyDiskPen_default = SvgFloppyDiskPen;

// src/Icon/icons/FloppyDisk.tsx
import { jsx as jsx730 } from "react/jsx-runtime";
var SvgFloppyDisk = (props) => /* @__PURE__ */ jsx730(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx730(
      "path",
      {
        d: "M12 12a2.866 2.866 0 0 0-2.857 2.857A2.866 2.866 0 0 0 12 17.714a2.866 2.866 0 0 0 2.857-2.857A2.866 2.866 0 0 0 12 12Zm9.335-5.665-3.746-3.746C17.228 2.226 16.68 2 16.112 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V7.888c0-.567-.228-1.116-.665-1.553ZM7.715 4.143h6.428v3.571H7.714V4.143Zm12.142 15c0 .394-.32.714-.714.714H4.857a.714.714 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h.714v4.643c0 .591.48 1.071 1.072 1.071h8.571c.594 0 1.072-.478 1.072-1.071v-4.47l3.493 3.493c.051.048.078.12.078.187v11.147Z",
        fill: "currentColor"
      }
    )
  })
);
var FloppyDisk_default = SvgFloppyDisk;

// src/Icon/icons/FloppyDisks.tsx
import { jsx as jsx731 } from "react/jsx-runtime";
var SvgFloppyDisks = (props) => /* @__PURE__ */ jsx731(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx731(
      "path",
      {
        d: "m21.45 5.826-3.277-3.277A1.863 1.863 0 0 0 16.848 2H8.25c-1.379 0-2.5 1.12-2.5 2.5v11.25a2.5 2.5 0 0 0 2.5 2.5H19.5a2.5 2.5 0 0 0 2.5-2.5V7.152c0-.5-.2-.976-.55-1.326Zm-10.7-1.951h4.375V5.75H10.75V3.875Zm9.375 11.875c0 .345-.28.625-.625.625H8.25a.625.625 0 0 1-.625-.625V4.5c0-.345.28-.625.625-.625h.625v2.813c0 .517.42.937.938.937h6.25c.519 0 .937-.418.937-.938v-2.66l3.056 3.055a.23.23 0 0 1 .069.168v8.5Zm-6.25-6.25a2.507 2.507 0 0 0-2.5 2.5c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5-1.125-2.5-2.5-2.5ZM17.313 22H6.688A4.692 4.692 0 0 1 2 17.312V6.688a.939.939 0 0 1 1.875 0v10.625a2.816 2.816 0 0 0 2.813 2.813h10.625a.938.938 0 0 1 0 1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var FloppyDisks_default = SvgFloppyDisks;

// src/Icon/icons/FolderArrowDown.tsx
import { jsx as jsx732 } from "react/jsx-runtime";
var SvgFolderArrowDown = (props) => /* @__PURE__ */ jsx732(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx732(
      "path",
      {
        d: "M19.5 5.75h-6.723l-1.921-1.768A2.492 2.492 0 0 0 9.09 3.25H4.5A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5Zm.625 12.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625V5.75c0-.345.28-.625.625-.625h4.59a.62.62 0 0 1 .442.183L12 7.625h7.5c.345 0 .625.28.625.625v10Zm-5.664-5.664-1.524 1.527v-3.988a.938.938 0 0 0-1.874 0v3.988l-1.56-1.527a.937.937 0 1 0-1.325 1.326l3.125 3.125c.216.186.459.276.697.276.238 0 .48-.092.663-.275l3.125-3.125a.937.937 0 1 0-1.327-1.327Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderArrowDown_default = SvgFolderArrowDown;

// src/Icon/icons/FolderArrowUp.tsx
import { jsx as jsx733 } from "react/jsx-runtime";
var SvgFolderArrowUp = (props) => /* @__PURE__ */ jsx733(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx733(
      "path",
      {
        d: "M12.629 9.46a.937.937 0 0 0-1.326 0l-3.125 3.126a.937.937 0 1 0 1.326 1.326l1.559-1.525v3.988a.938.938 0 0 0 1.874 0v-3.988l1.525 1.524c.183.187.42.277.663.277a.937.937 0 0 0 .663-1.6l-3.16-3.127ZM19.5 5.75h-6.723l-1.921-1.768A2.492 2.492 0 0 0 9.09 3.25H4.5A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5Zm.625 12.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625V5.75c0-.345.28-.625.625-.625h4.59a.62.62 0 0 1 .442.183L12 7.625h7.5c.345 0 .625.28.625.625v10Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderArrowUp_default = SvgFolderArrowUp;

// src/Icon/icons/FolderBookmark.tsx
import { jsx as jsx734 } from "react/jsx-runtime";
var SvgFolderBookmark = (props) => /* @__PURE__ */ jsx734(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx734(
      "path",
      {
        d: "M19.5 5.75h-6.723l-1.921-1.768A2.492 2.492 0 0 0 9.09 3.25H4.5A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5Zm.625 12.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625V5.75c0-.345.28-.625.625-.625h4.59a.62.62 0 0 1 .442.183L12 7.625v6.215c0 .524.606.815.98.487l2.145-1.651 2.11 1.687c.41.325 1.015.035 1.015-.523V7.625h1.25c.345 0 .625.28.625.625v10Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderBookmark_default = SvgFolderBookmark;

// src/Icon/icons/FolderClosed.tsx
import { jsx as jsx735 } from "react/jsx-runtime";
var SvgFolderClosed = (props) => /* @__PURE__ */ jsx735(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx735(
      "path",
      {
        d: "M19.5 5.75h-6.723l-1.921-1.768A2.492 2.492 0 0 0 9.09 3.25H4.5A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5Zm-15-.625h4.59a.62.62 0 0 1 .442.183L12 7.625h7.5c.345 0 .625.28.625.625V9.5H3.875V5.75c0-.345.28-.625.625-.625Zm15 13.75h-15a.626.626 0 0 1-.625-.625v-6.875h16.25v6.875a.627.627 0 0 1-.625.625Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderClosed_default = SvgFolderClosed;

// src/Icon/icons/FolderGearRight.tsx
import { jsx as jsx736 } from "react/jsx-runtime";
var SvgFolderGearRight = (props) => /* @__PURE__ */ jsx736(
  "svg",
  __spreadProps(__spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx736(
      "path",
      {
        d: "M18.419 12.85a.507.507 0 0 1-.505-.427l-.188-.846a2.553 2.553 0 0 1-.358-.146l-.71.445c-.212.137-.464.137-.643-.06l-.473-.513c-.171-.188-.188-.445-.057-.676l.415-.752-.138-.342-.807-.205a.527.527 0 0 1-.408-.53V8.07c0-.248.163-.445.408-.514l.799-.205a9.35 9.35 0 0 1 .138-.35l-.448-.761c-.13-.223-.082-.488.09-.676l.48-.505c.18-.188.44-.222.636-.094l.701.47c.123-.068.237-.102.375-.162l.188-.838A.523.523 0 0 1 18.419 4h.701c.253 0 .448.18.505.436l.196.855c.114.043.228.077.359.146l.717-.47c.204-.137.448-.095.628.093l.497.505c.171.171.196.453.065.676l-.44.76c.04.095.09.206.147.351l.79.205c.245.069.416.257.416.514v.726c0 .266-.155.47-.416.53l-.799.206c-.048.12-.073.222-.146.342l.416.744a.55.55 0 0 1-.05.684l-.48.513c-.196.197-.424.197-.644.06l-.701-.445c-.114.06-.245.112-.359.146l-.196.846c-.057.265-.252.428-.505.428h-.701ZM3.559 20C1.856 20 1 19.12 1 17.349V6.925c0-1.72.823-2.574 2.25-2.574h2.323c.807 0 1.222.154 1.76.632l.498.428c.407.368.741.505 1.296.505h4.931a5.51 5.51 0 0 0-.44 1.376H8.784c-.807 0-1.239-.162-1.768-.624l-.498-.436c-.415-.368-.741-.513-1.28-.513h-1.72c-.782 0-1.206.436-1.206 1.283V9.13h11.24c.042.445.148.88.294 1.291H2.312v6.859c0 .889.449 1.342 1.264 1.342h13.351c.807 0 1.272-.453 1.272-1.334v-3.395c.424.069.986.06 1.312 0v3.455c0 1.762-.856 2.651-2.315 2.651H3.56ZM18.778 9.858c.733 0 1.353-.633 1.353-1.428 0-.778-.62-1.446-1.353-1.428-.766.008-1.361.65-1.361 1.428 0 .795.595 1.428 1.36 1.428Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderGearRight_default = SvgFolderGearRight;

// src/Icon/icons/FolderGear.tsx
import { jsx as jsx737 } from "react/jsx-runtime";
var SvgFolderGear = (props) => /* @__PURE__ */ jsx737(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx737(
      "path",
      {
        d: "M19.5 5.75h-6.723l-1.921-1.768A2.492 2.492 0 0 0 9.09 3.25H4.5A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5Zm.625 12.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625V5.75c0-.345.28-.625.625-.625h4.59a.62.62 0 0 1 .442.183L12 7.625h7.5c.345 0 .625.28.625.625v10Zm-4.902-4.402c.035-.196.058-.395.058-.598 0-.203-.024-.403-.06-.597l.795-.458a.272.272 0 0 0 .126-.315 2.964 2.964 0 0 0-.388-.818c-.188-.265-.335-.497-.532-.712a.272.272 0 0 0-.337-.05l-.801.464a2.815 2.815 0 0 0-.99-.596v-.922a.272.272 0 0 0-.21-.267A3.96 3.96 0 0 0 12 8.875c-.305 0-.598.04-.883.105a.272.272 0 0 0-.21.266v.923a3.246 3.246 0 0 0-1.024.597l-.805-.465a.273.273 0 0 0-.336.05 4.061 4.061 0 0 0-.531.711 4.08 4.08 0 0 0-.352.817c-.039.121.016.254.125.316l.793.458a3.355 3.355 0 0 0-.058.597c0 .203.024.403.06.597l-.795.458a.272.272 0 0 0-.126.315c.091.278.2.552.353.818.152.263.334.497.532.712a.272.272 0 0 0 .337.05l.801-.464c.303.256.646.46 1.025.596v.924c0 .126.087.24.21.267.286.028.58.102.884.102.305 0 .598-.04.883-.104a.272.272 0 0 0 .21-.267v-.924c.38-.135.725-.337 1.026-.594l.801.463c.11.064.251.045.337-.049.197-.215.38-.449.532-.712a4.06 4.06 0 0 0 .351-.818.272.272 0 0 0-.126-.315l-.791-.457Zm-3.223.77a1.367 1.367 0 1 1 0-2.735 1.367 1.367 0 0 1 0 2.734Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderGear_default = SvgFolderGear;

// src/Icon/icons/FolderGrid.tsx
import { jsx as jsx738 } from "react/jsx-runtime";
var SvgFolderGrid = (props) => /* @__PURE__ */ jsx738(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx738(
      "path",
      {
        d: "M19.5 5.75h-6.723l-1.921-1.768A2.492 2.492 0 0 0 9.09 3.25H4.5A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5Zm.625 12.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625V5.75c0-.345.28-.625.625-.625h4.59a.62.62 0 0 1 .442.183L12 7.625h7.5c.345 0 .625.28.625.625v10ZM8.25 11.375h-2.5a.626.626 0 0 0-.625.625v2.5c0 .345.28.625.625.625h2.5c.345 0 .625-.28.625-.625V12a.627.627 0 0 0-.625-.625Zm5 0h-2.5a.627.627 0 0 0-.625.625v2.5c0 .345.28.625.625.625h2.5c.345 0 .625-.28.625-.625V12a.627.627 0 0 0-.625-.625Zm5 0h-2.5a.625.625 0 0 0-.625.625v2.5c0 .345.28.625.625.625h2.5c.346 0 .625-.28.625-.625V12a.627.627 0 0 0-.625-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderGrid_default = SvgFolderGrid;

// src/Icon/icons/FolderHeart.tsx
import { jsx as jsx739 } from "react/jsx-runtime";
var SvgFolderHeart = (props) => /* @__PURE__ */ jsx739(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx739(
      "path",
      {
        d: "M19.5 5.75h-6.723l-1.921-1.768A2.492 2.492 0 0 0 9.09 3.25H4.5A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5Zm.625 12.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625V5.75c0-.345.28-.625.625-.625h4.59a.62.62 0 0 1 .442.183L12 7.625h7.5c.345 0 .625.28.625.625v10Zm-7.8-8.012-.329.344-.332-.344c-.836-.867-2.2-1.008-3.117-.226a2.408 2.408 0 0 0-.168 3.484l3.24 3.342c.21.215.548.215.758 0l3.241-3.342a2.403 2.403 0 0 0-.172-3.484c-.91-.782-2.278-.64-3.122.226Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderHeart_default = SvgFolderHeart;

// src/Icon/icons/FolderImage.tsx
import { jsx as jsx740 } from "react/jsx-runtime";
var SvgFolderImage = (props) => /* @__PURE__ */ jsx740(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx740(
      "path",
      {
        d: "M19.5 5.75h-6.723l-1.921-1.768A2.492 2.492 0 0 0 9.09 3.25H4.5A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5Zm.625 12.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625V5.75c0-.345.28-.625.625-.625h4.59a.62.62 0 0 1 .442.183L12 7.625h7.5c.345 0 .625.28.625.625v10Zm-13.16-6.875a1.25 1.25 0 1 0-1.25-1.25c0 .69.594 1.25 1.25 1.25Zm7.012-.973a.622.622 0 0 0-.52-.277.622.622 0 0 0-.52.278l-2.45 3.676-.874-1.196a.636.636 0 0 0-.539-.258c-.2 0-.387.095-.505.257l-2.734 3.75a.625.625 0 0 0-.052.651c.143.21.322.342.592.342h11.25a.625.625 0 0 0 .52-.972l-4.168-6.25Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderImage_default = SvgFolderImage;

// src/Icon/icons/FolderMagnifyingGlass.tsx
import { jsx as jsx741 } from "react/jsx-runtime";
var SvgFolderMagnifyingGlass = (props) => /* @__PURE__ */ jsx741(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx741(
      "path",
      {
        d: "M19.5 5.75h-6.723l-1.921-1.768A2.492 2.492 0 0 0 9.09 3.25H4.5A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5Zm.625 12.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625V5.75c0-.345.28-.625.625-.625h4.59a.62.62 0 0 1 .442.183L12 7.625h7.5c.345 0 .625.28.625.625v10Zm-5.531-3.73c.328-.56.531-1.2.531-1.895a3.75 3.75 0 1 0-3.75 3.75c.694 0 1.336-.202 1.894-.53l1.818 1.818c.183.185.42.274.663.274a.937.937 0 0 0 .663-1.6l-1.82-1.817Zm-3.219-.02a1.875 1.875 0 1 1 0-3.75 1.875 1.875 0 0 1 0 3.75Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderMagnifyingGlass_default = SvgFolderMagnifyingGlass;

// src/Icon/icons/FolderMinus.tsx
import { jsx as jsx742 } from "react/jsx-runtime";
var SvgFolderMinus = (props) => /* @__PURE__ */ jsx742(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx742(
      "path",
      {
        d: "M19.5 5.75h-6.723l-1.921-1.768A2.492 2.492 0 0 0 9.09 3.25H4.5A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5Zm.625 12.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625V5.75c0-.345.28-.625.625-.625h4.59a.62.62 0 0 1 .442.183L12 7.625h7.5c.345 0 .625.28.625.625v10Zm-5-5.938H8.84c-.485 0-.902.418-.902.938a.9.9 0 0 0 .902.902h6.25c.555 0 .973-.382.973-.902a.935.935 0 0 0-.938-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderMinus_default = SvgFolderMinus;

// src/Icon/icons/FolderOpen.tsx
import { jsx as jsx743 } from "react/jsx-runtime";
var SvgFolderOpen = (props) => /* @__PURE__ */ jsx743(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx743(
      "path",
      {
        d: "m21.882 12.496-3.333 6.667a1.12 1.12 0 0 1-1.025.615H4.222A2.222 2.222 0 0 1 2 17.556V6.444c0-1.227.995-2.222 2.222-2.222h4.08c.59 0 1.155.234 1.572.651l1.706 1.571h4.865c1.227 0 2.222.996 2.222 2.223v1.11H17v-1.11a.556.556 0 0 0-.555-.556h-5.556l-2.195-2.06a.547.547 0 0 0-.392-.162h-4.08a.556.556 0 0 0-.555.555v10l2.47-4.94a1.11 1.11 0 0 1 .995-.615h13.757c.823 0 1.361.868.993 1.607Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderOpen_default = SvgFolderOpen;

// src/Icon/icons/FolderPlus.tsx
import { jsx as jsx744 } from "react/jsx-runtime";
var SvgFolderPlus = (props) => /* @__PURE__ */ jsx744(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx744(
      "path",
      {
        d: "M19.5 5.75h-6.723l-1.921-1.768A2.492 2.492 0 0 0 9.09 3.25H4.5A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5Zm.625 12.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625V5.75c0-.345.28-.625.625-.625h4.59a.62.62 0 0 1 .442.183L12 7.625h7.5c.345 0 .625.28.625.625v10Zm-5-5.938h-2.188V10.09c-.035-.485-.417-.902-.937-.902s-.938.417-.938.902v2.223H8.84c-.485 0-.902.417-.902.937a.9.9 0 0 0 .902.902h2.187v2.188c.036.555.454.973.973.973a.9.9 0 0 0 .902-.903v-2.258h2.188c.555 0 .973-.382.973-.902a.935.935 0 0 0-.938-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderPlus_default = SvgFolderPlus;

// src/Icon/icons/FolderTree.tsx
import { jsx as jsx745 } from "react/jsx-runtime";
var SvgFolderTree = (props) => /* @__PURE__ */ jsx745(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx745(
      "path",
      {
        d: "M20.889 14.222h-3.333l-1.534-.945a1.174 1.174 0 0 0-.584-.166H13.11c-.613 0-1.111.498-1.111 1.111v5.556c0 .613.498 1.11 1.111 1.11h7.778c.613 0 1.111-.497 1.111-1.11v-4.445a1.11 1.11 0 0 0-1.111-1.11Zm-.556 5h-6.666v-4.444h1.614l1.4.863c.263.161.566.248.875.248h2.777v3.333ZM10.056 8.667a.831.831 0 0 0 .833-.834.831.831 0 0 0-.833-.833h-6.39V3.944a.833.833 0 1 0-1.666 0v12.778c0 1.073.87 1.945 1.944 1.945h6.112a.833.833 0 0 0 0-1.667H3.944a.279.279 0 0 1-.277-.278V8.667h6.389Zm10.833-4.445h-3.333l-1.534-.945a1.192 1.192 0 0 0-.584-.166H13.11c-.613 0-1.111.498-1.111 1.111v5.556c0 .613.498 1.11 1.111 1.11h7.778c.613 0 1.111-.497 1.111-1.11V5.333a1.11 1.11 0 0 0-1.111-1.11Zm-.556 5h-6.666V4.778h1.614l1.4.863c.263.162.566.248.875.248h2.777v3.333Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderTree_default = SvgFolderTree;

// src/Icon/icons/FolderUser.tsx
import { jsx as jsx746 } from "react/jsx-runtime";
var SvgFolderUser = (props) => /* @__PURE__ */ jsx746(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx746(
      "path",
      {
        d: "M19.5 5.75h-6.723l-1.921-1.768A2.492 2.492 0 0 0 9.09 3.25H4.5A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5Zm.625 12.5c0 .345-.28.625-.625.625h-2.563a3.744 3.744 0 0 0-3.687-3.125h-2.5a3.743 3.743 0 0 0-3.687 3.125H4.5a.626.626 0 0 1-.625-.625V5.75c0-.345.28-.625.625-.625h4.59a.62.62 0 0 1 .442.183L12 7.625h7.5c.345 0 .625.28.625.625v10ZM12 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderUser_default = SvgFolderUser;

// src/Icon/icons/FolderXmark.tsx
import { jsx as jsx747 } from "react/jsx-runtime";
var SvgFolderXmark = (props) => /* @__PURE__ */ jsx747(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx747(
      "path",
      {
        d: "M19.5 5.75h-6.723l-1.921-1.768A2.492 2.492 0 0 0 9.09 3.25H4.5A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10c0-1.379-1.121-2.5-2.5-2.5Zm.625 12.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625V5.75c0-.345.28-.625.625-.625h4.59a.62.62 0 0 1 .442.183L12 7.625h7.5c.345 0 .625.28.625.625v10Zm-4.996-8.164a.937.937 0 0 0-1.326 0L12 11.926l-1.871-1.84a.937.937 0 1 0-1.326 1.326l1.873 1.838-1.837 1.837a.937.937 0 1 0 1.325 1.326L12 14.574l1.837 1.837a.937.937 0 1 0 1.326-1.326l-1.839-1.835 1.837-1.837a.912.912 0 0 0-.032-1.327Z",
        fill: "currentColor"
      }
    )
  })
);
var FolderXmark_default = SvgFolderXmark;

// src/Icon/icons/Folder.tsx
import { jsx as jsx748 } from "react/jsx-runtime";
var SvgFolder = (props) => /* @__PURE__ */ jsx748(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx748(
      "path",
      {
        d: "M19.5 5.75h-6.723l-1.886-1.768a2.492 2.492 0 0 0-1.766-.732H4.5A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-10a2.48 2.48 0 0 0-2.5-2.5Zm.625 12.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625V5.75c0-.345.28-.625.625-.625h4.59a.62.62 0 0 1 .442.183L12 7.625h7.5c.345 0 .625.28.625.625v10Z",
        fill: "currentColor"
      }
    )
  })
);
var Folder_default = SvgFolder;

// src/Icon/icons/Folders.tsx
import { jsx as jsx749 } from "react/jsx-runtime";
var SvgFolders = (props) => /* @__PURE__ */ jsx749(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx749(
      "path",
      {
        d: "M19.778 6.444h-4.865l-1.706-1.57a2.223 2.223 0 0 0-1.572-.652h-4.08a2.223 2.223 0 0 0-2.222 2.222v7.778c0 1.227.995 2.223 2.223 2.223h12.222A2.222 2.222 0 0 0 22 14.222V8.667a2.224 2.224 0 0 0-2.222-2.223Zm.555 7.778c0 .307-.249.556-.555.556H7.556A.556.556 0 0 1 7 14.222V6.444c0-.306.25-.555.556-.555h4.08c.148 0 .287.058.392.163l2.194 2.06h5.556c.306 0 .555.248.555.555v5.555Zm-2.5 5.556H6.167A4.17 4.17 0 0 1 2 15.61V7.278c0-.459.373-.834.833-.834.46 0 .834.375.834.834v8.333c0 1.379 1.121 2.5 2.5 2.5h11.666a.834.834 0 0 1 0 1.667Z",
        fill: "currentColor"
      }
    )
  })
);
var Folders_default = SvgFolders;

// src/Icon/icons/FontCase.tsx
import { jsx as jsx750 } from "react/jsx-runtime";
var SvgFontCase = (props) => /* @__PURE__ */ jsx750(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx750(
      "path",
      {
        d: "M8.201 5.46c-.222-.582-1.18-.582-1.402 0l-4.75 12.499a.75.75 0 0 0 1.402.533L4.6 15.476h5.806l1.146 3.016a.747.747 0 0 0 .966.434.75.75 0 0 0 .435-.967l-4.75-12.5Zm-3.03 8.516L7.5 7.839l2.331 6.137H5.17Zm16.08-5a.75.75 0 0 0-.75.75v.153a3.959 3.959 0 0 0-2.5-.903c-2.206 0-4 1.794-4 4v1.998c0 2.206 1.794 4.003 3.971 4.003.95 0 1.813-.348 2.472-.904v.152c0 .414.336.75.75.75s.806-.334.806-.75V9.726a.75.75 0 0 0-.75-.75Zm-.75 6c0 1.379-1.122 2.5-2.5 2.5a2.502 2.502 0 0 1-2.5-2.5v-2c0-1.38 1.121-2.5 2.5-2.5 1.378 0 2.5 1.121 2.5 2.5v2Z",
        fill: "currentColor"
      }
    )
  })
);
var FontCase_default = SvgFontCase;

// src/Icon/icons/Font.tsx
import { jsx as jsx751 } from "react/jsx-runtime";
var SvgFont = (props) => /* @__PURE__ */ jsx751(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx751(
      "path",
      {
        d: "M20.929 19.857h-1.404L13 2.69A1.08 1.08 0 0 0 12 2c-.003 0 .004 0 0 0-.437 0-.833.266-.996.674L4.132 19.857h-1.06c-.592 0-1.072.482-1.072 1.071C2 21.518 2.48 22 3.071 22h5c.594 0 1.072-.478 1.072-1.072 0-.593-.478-1.071-1.072-1.071H6.44l1.572-3.929h7.727l1.493 3.929H15.93a1.072 1.072 0 0 0 0 2.143h5a1.072 1.072 0 0 0 0-2.143ZM8.87 13.786l3.106-7.764 2.947 7.764H8.871Z",
        fill: "currentColor"
      }
    )
  })
);
var Font_default = SvgFont;

// src/Icon/icons/ForwardFast.tsx
import { jsx as jsx752 } from "react/jsx-runtime";
var SvgForwardFast = (props) => /* @__PURE__ */ jsx752(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx752(
      "path",
      {
        d: "M2 5.55v12.899c0 .777.633 1.293 1.299 1.293.282 0 .57-.093.818-.299l6.915-6.266v5.27c0 .779.633 1.295 1.299 1.295.282 0 .57-.093.818-.299l6.915-6.266v5.593a.968.968 0 1 0 1.936 0V5.227a.929.929 0 0 0-.931-.931.968.968 0 0 0-.968.967V10.9l-6.915-6.31a1.296 1.296 0 0 0-.855-.332c-.666 0-1.299.517-1.299 1.292v5.318L4.117 4.557a1.27 1.27 0 0 0-.818-.299C2.633 4.258 2 4.775 2 5.55Zm10.968 1.462 5.492 5.012-5.492 4.972V7.012Zm-9.033 0 5.492 5.012-5.492 4.972V7.012Z",
        fill: "currentColor"
      }
    )
  })
);
var ForwardFast_default = SvgForwardFast;

// src/Icon/icons/ForwardStep.tsx
import { jsx as jsx753 } from "react/jsx-runtime";
var SvgForwardStep = (props) => /* @__PURE__ */ jsx753(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx753(
      "path",
      {
        d: "M17.833 2c-.69 0-1.25.56-1.25 1.25v5.51L7.552 2.31A1.656 1.656 0 0 0 6.583 2a1.668 1.668 0 0 0-1.667 1.667v16.62c0 .625.349 1.197.904 1.483.24.168.503.23.763.23.342 0 .68-.104.969-.31l9.031-6.45v5.51a1.25 1.25 0 0 0 2.5 0V3.25c0-.69-.557-1.25-1.25-1.25Zm-1.25 10.167-9.166 6.546V5.287l9.166 6.547v.334Z",
        fill: "currentColor"
      }
    )
  })
);
var ForwardStep_default = SvgForwardStep;

// src/Icon/icons/Forward.tsx
import { jsx as jsx754 } from "react/jsx-runtime";
var SvgForward = (props) => /* @__PURE__ */ jsx754(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx754(
      "path",
      {
        d: "M12.001 5.75v12.498c0 .753.614 1.253 1.258 1.253.274 0 .553-.09.793-.29l7.501-6.215a1.259 1.259 0 0 0 0-1.924l-7.5-6.215a1.019 1.019 0 0 0-.794-.358c-.644 0-1.258.5-1.258 1.251Zm1.876 1.331L19.78 12l-5.903 4.919V7.08ZM2 5.751v12.497a1.25 1.25 0 0 0 1.922 1.055l6.395-4.071a.937.937 0 0 0 .288-1.295.942.942 0 0 0-1.295-.284L3.875 17.11V6.89l5.435 3.458a.937.937 0 1 0 1.006-1.582L3.92 4.696A1.25 1.25 0 0 0 2 5.75Z",
        fill: "currentColor"
      }
    )
  })
);
var Forward_default = SvgForward;

// src/Icon/icons/Frame.tsx
import { jsx as jsx755 } from "react/jsx-runtime";
var SvgFrame = (props) => /* @__PURE__ */ jsx755(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx755(
      "path",
      {
        d: "M20.929 7h-1.786v10h1.786c.593 0 1.071.478 1.071 1.071 0 .594-.478 1.072-1.071 1.072h-1.786v1.786c0 .593-.478 1.071-1.072 1.071A1.069 1.069 0 0 1 17 20.929v-1.786H7v1.786a1.07 1.07 0 1 1-2.143 0v-1.786H3.071a1.07 1.07 0 1 1 0-2.143h1.786V7H3.071a1.07 1.07 0 1 1 0-2.143h1.786V3.071a1.072 1.072 0 0 1 2.143 0v1.786h10V3.071a1.07 1.07 0 1 1 2.143 0v1.786h1.786c.593 0 1.071.478 1.071 1.072C22 6.522 21.522 7 20.929 7ZM7 17h10V7H7v10Z",
        fill: "currentColor"
      }
    )
  })
);
var Frame_default = SvgFrame;

// src/Icon/icons/G.tsx
import { jsx as jsx756 } from "react/jsx-runtime";
var SvgG = (props) => /* @__PURE__ */ jsx756(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx756(
      "path",
      {
        d: "M11.975 22c-5.902 0-9.915-4.763-9.915-9.969C2.06 6.478 6.542 2 12.02 2c4.288 0 7.384 2.785 7.384 3.696 0 .842-.769 1.073-1.072 1.073-1.094 0-2.162-2.626-6.313-2.626-4.3 0-7.817 3.488-7.817 7.884 0 1.668 1.29 7.84 7.813 7.84 2.383 0 7.21-1.562 7.834-6.76h-6.723a1.066 1.066 0 0 1-1.066-1.071c0-.594.48-1.073 1.031-1.073h7.817c.591 0 1.031.48 1.031 1.073.08 6.352-5.138 9.924-9.964 9.964Z",
        fill: "currentColor"
      }
    )
  })
);
var G_default = SvgG;

// src/Icon/icons/GalleryThumbnails.tsx
import { jsx as jsx757 } from "react/jsx-runtime";
var SvgGalleryThumbnails = (props) => /* @__PURE__ */ jsx757(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx757(
      "path",
      {
        d: "M19.778 3.111c1.226 0 2.222.995 2.222 2.222v7.778a2.224 2.224 0 0 1-2.222 2.222H4.222A2.223 2.223 0 0 1 2 13.111V5.333c0-1.227.995-2.222 2.222-2.222h15.556Zm0 1.667H4.222a.555.555 0 0 0-.555.555v7.778c0 .306.248.556.555.556h15.556c.305 0 .555-.25.555-.556V5.333a.556.556 0 0 0-.555-.555ZM2 18.667a1.11 1.11 0 0 1 1.111-1.111h1.111a1.11 1.11 0 0 1 1.111 1.11v1.112a1.11 1.11 0 0 1-1.11 1.11H3.11A1.11 1.11 0 0 1 2 19.779v-1.111Zm7.778-1.111a1.11 1.11 0 0 1 1.11 1.11v1.112a1.11 1.11 0 0 1-1.11 1.11H8.667a1.11 1.11 0 0 1-1.111-1.11v-1.111a1.11 1.11 0 0 1 1.11-1.111h1.112Zm3.333 1.11a1.11 1.11 0 0 1 1.111-1.11h1.111a1.11 1.11 0 0 1 1.111 1.11v1.112a1.11 1.11 0 0 1-1.11 1.11h-1.112a1.11 1.11 0 0 1-1.11-1.11v-1.111Zm7.778-1.11A1.11 1.11 0 0 1 22 18.666v1.112a1.11 1.11 0 0 1-1.111 1.11h-1.111a1.11 1.11 0 0 1-1.111-1.11v-1.111a1.11 1.11 0 0 1 1.11-1.111h1.112Z",
        fill: "currentColor"
      }
    )
  })
);
var GalleryThumbnails_default = SvgGalleryThumbnails;

// src/Icon/icons/Gavel.tsx
import { jsx as jsx758 } from "react/jsx-runtime";
var SvgGavel = (props) => /* @__PURE__ */ jsx758(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx758(
      "path",
      {
        d: "M22 10.438c0-.355-.274-.933-.927-.933a.947.947 0 0 0-.629.24l-6.191-6.192c.16-.18.24-.404.24-.628.003-.65-.572-.925-.931-.925a.953.953 0 0 0-.67.275l-4.993 5a.938.938 0 0 0 .663 1.6c.222 0 .44-.087.617-.244l2.434 2.431-2.778 2.774-.218-.219a1.248 1.248 0 0 0-1.77 0l-4.48 4.48a1.245 1.245 0 0 0 0 1.768l1.767 1.767a1.245 1.245 0 0 0 1.766.001l4.481-4.48a1.246 1.246 0 0 0 0-1.767l-.22-.22 2.776-2.78 2.432 2.433a.946.946 0 0 0-.24.628c0 .62.574.928.933.928.24 0 .48-.092.663-.275l5-4.992a.947.947 0 0 0 .274-.67Zm-5.313 3.05-6.176-6.175 2.426-2.425 6.176 6.175-2.426 2.425Z",
        fill: "currentColor"
      }
    )
  })
);
var Gavel_default = SvgGavel;

// src/Icon/icons/Gear.tsx
import { jsx as jsx759 } from "react/jsx-runtime";
var SvgGear = (props) => /* @__PURE__ */ jsx759(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx759(
      "path",
      {
        d: "M8.25 12c0-2.105 1.645-3.75 3.75-3.75 2.07 0 3.75 1.645 3.75 3.75 0 2.07-1.68 3.75-3.75 3.75A3.729 3.729 0 0 1 8.25 12ZM12 10.125a1.875 1.875 0 1 0 .001 3.75 1.875 1.875 0 0 0 0-3.75ZM13.45 2c.867 0 1.62.593 1.824 1.435l.304 1.269c.333.162.649.346.95.55l1.254-.37a1.878 1.878 0 0 1 2.156.86l1.449 2.51c.43.75.293 1.7-.332 2.297l-.95.867a8.44 8.44 0 0 1 0 1.129l.95.902c.625.598.762 1.547.332 2.297l-1.45 2.508a1.882 1.882 0 0 1-2.155.863l-1.254-.37a8.12 8.12 0 0 1-.95.55l-.304 1.27A1.877 1.877 0 0 1 13.45 22H10.55a1.877 1.877 0 0 1-1.824-1.434l-.305-1.27a8.133 8.133 0 0 1-.949-.55l-1.29.371c-.795.242-1.685-.113-2.118-.863l-1.45-2.508c-.433-.75-.296-1.7.332-2.297l.947-.902a8.459 8.459 0 0 1 0-1.129l-.947-.867a1.876 1.876 0 0 1-.331-2.297l1.449-2.51c.433-.75 1.323-1.105 2.119-.86l1.289.37c.3-.204.617-.388.95-.55l.304-1.269A1.876 1.876 0 0 1 10.55 2h2.899Zm-3.422 4.047-.438.183a6.163 6.163 0 0 0-1.375.797l-.379.29-2.147-.633-1.45 2.507 1.621 1.543-.06.47a6.4 6.4 0 0 0 0 1.593l.06.469-1.62 1.543 1.449 2.507 2.147-.632.38.289c.417.32.878.59 1.374.797l.438.183.523 2.172h2.899l.523-2.172.438-.183a6.164 6.164 0 0 0 1.375-.797l.378-.29 2.149.633 1.449-2.507-1.621-1.543.059-.47c.035-.26.05-.526.05-.796s-.015-.535-.05-.797l-.06-.469 1.622-1.543-1.45-2.507-2.148.632-.379-.289a6.165 6.165 0 0 0-1.374-.797l-.438-.183-.524-2.172h-2.898l-.523 2.172Z",
        fill: "currentColor"
      }
    )
  })
);
var Gear_default = SvgGear;

// src/Icon/icons/Gears.tsx
import { jsx as jsx760 } from "react/jsx-runtime";
var SvgGears = (props) => /* @__PURE__ */ jsx760(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx760(
      "path",
      {
        d: "M5.77 9.341c0-.7.594-1.266 1.265-1.266.728 0 1.266.567 1.266 1.266 0 .7-.538 1.266-1.266 1.266-.67 0-1.266-.566-1.266-1.266Zm2.79-4.83.21.88c.3.13.585.295.844.489l.858-.256a.481.481 0 0 1 .493.13c.513.563.905 1.24 1.14 1.986a.477.477 0 0 1-.133.49l-.665.605c.05.174.032.351.032.532 0 .136.019.325.003.484l.63.601c.133.127.19.316.133.49a5.315 5.315 0 0 1-1.14 1.988.48.48 0 0 1-.493.13l-.81-.244a4.47 4.47 0 0 1-.906.531l-.196.823c-.07.18-.177.323-.357.364-.367.08-.747.124-1.168.124-.364 0-.744-.045-1.14-.124a.49.49 0 0 1-.328-.364l-.197-.822a4.4 4.4 0 0 1-.904-.532l-.81.243a.478.478 0 0 1-.493-.13 5.31 5.31 0 0 1-1.142-1.986.482.482 0 0 1 .134-.491l.632-.601a4.393 4.393 0 0 1 .005-1.016l-.637-.605a.482.482 0 0 1-.134-.49 5.317 5.317 0 0 1 1.142-1.987.479.479 0 0 1 .494-.13l.855.257c.261-.194.544-.358.846-.489l.209-.88a.488.488 0 0 1 .329-.362 5.686 5.686 0 0 1 1.139-.124c.42 0 .8.043 1.168.124.18.04.288.183.357.362ZM3.997 9.367c0 .117.035.23.048.344l.069.624-.713.68c.108.24.24.469.391.68l.928-.275.514.39c.197.148.409.275.636.373l.586.253.221.937a3.76 3.76 0 0 0 .773 0l.221-.937.585-.253c.228-.098.44-.225.637-.373l.512-.39.93.276c.152-.212.282-.44.39-.68l-.712-.681.07-.624c.012-.113-.01-.227-.01-.344 0-.13.022-.257.006-.38l-.076-.63.722-.69a3.904 3.904 0 0 0-.39-.68l-.965.288-.51-.379c-.211-.136-.382-.252-.623-.344l-.553-.253-.234-.99a4.266 4.266 0 0 0-.773 0l-.234.99-.582.253a2.99 2.99 0 0 0-.595.344l-.51.379-.964-.288c-.151.212-.283.44-.391.68l.724.69-.077.63c-.015.123-.051.25-.051.38Zm12.687 4.278a1.265 1.265 0 1 1 0 2.53 1.265 1.265 0 0 1 0-2.53Zm3.718-2.142-.256.857c.193.26.357.545.487.845l.88.209a.49.49 0 0 1 .364.33c.079.395.123.774.123 1.167 0 .392-.044.772-.123 1.139-.042.18-.184.288-.364.358l-.88.208c-.13.301-.294.586-.487.845l.256.858a.477.477 0 0 1-.13.494 5.365 5.365 0 0 1-1.987 1.142.484.484 0 0 1-.49-.136l-.634-.665c-.145.051-.322.06-.503.06-.164 0-.326-.009-.484-.025l-.601.63a.485.485 0 0 1-.49.136 5.365 5.365 0 0 1-1.988-1.142.477.477 0 0 1-.13-.494l.244-.81a4.466 4.466 0 0 1-.532-.905l-.822-.196c-.18-.07-.323-.178-.364-.358a5.2 5.2 0 0 1-.152-1.14c0-.392.072-.771.152-1.167a.49.49 0 0 1 .364-.329l.822-.196c.143-.323.32-.627.532-.905l-.244-.81a.48.48 0 0 1 .13-.494 5.317 5.317 0 0 1 1.987-1.14.477.477 0 0 1 .49.134l.602.633a4.058 4.058 0 0 1 .987.003l.633-.636a.476.476 0 0 1 .49-.133 5.317 5.317 0 0 1 1.988 1.139.48.48 0 0 1 .13.494Zm-3.744.37a3.12 3.12 0 0 0-.345.019l-.623.07-.68-.713c-.24.108-.469.238-.68.39l.274.902-.417.54c-.12.197-.247.409-.345.637l-.253.585-.937.222a3.881 3.881 0 0 0 0 .772l.937.221.253.586c.098.228.224.44.345.636l.418.513-.276.93c.212.152.44.282.68.392l.68-.715.624.07a3.096 3.096 0 0 0 .725-.003l.63-.076.69.724c.24-.11.468-.24.68-.392l-.288-.965.38-.51c.136-.212.25-.383.345-.623l.25-.554.99-.234a3.883 3.883 0 0 0 0-.772l-.99-.235-.25-.582a3.271 3.271 0 0 0-.345-.595l-.38-.51.288-.964a3.904 3.904 0 0 0-.68-.39l-.69.722-.63-.076a3.698 3.698 0 0 0-.38-.022Z",
        fill: "currentColor"
      }
    )
  })
);
var Gears_default = SvgGears;

// src/Icon/icons/Gem.tsx
import { jsx as jsx761 } from "react/jsx-runtime";
var SvgGem = (props) => /* @__PURE__ */ jsx761(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx761(
      "path",
      {
        d: "M8.583 4.97 12 8.605l3.418-3.633H8.583Zm8.414 1.06-2.828 3.003h5.039L16.997 6.03Zm1.953 4.878H5.05L12 18.576l6.949-7.668ZM4.794 9.033h5.039L7.005 6.03 4.794 9.033ZM21.759 10.6l-9.063 10a.944.944 0 0 1-.695.308.943.943 0 0 1-.696-.308l-9.062-10a.937.937 0 0 1-.059-1.188L6.56 3.475a.942.942 0 0 1 .754-.383h9.375a.93.93 0 0 1 .754.383l4.375 5.937a.942.942 0 0 1-.058 1.188Z",
        fill: "currentColor"
      }
    )
  })
);
var Gem_default = SvgGem;

// src/Icon/icons/GlassesRound.tsx
import { jsx as jsx762 } from "react/jsx-runtime";
var SvgGlassesRound = (props) => /* @__PURE__ */ jsx762(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx762(
      "path",
      {
        d: "m21.462 10.97-1.1-4.419c-.268-.933-1.174-2.313-2.966-2.313-.543 0-.803.104-1.498.334a.552.552 0 0 0-.347.703l.174.525a.557.557 0 0 0 .525.382c.126 0 .17-.026.634-.182.907-.3 1.675.213 1.862.955l1.028 4.123a4.67 4.67 0 0 0-2.495-.729 4.71 4.71 0 0 0-4.292 2.778h-1.973c-.743-1.636-2.379-2.81-4.292-2.81-.92 0-1.77.274-2.496.73l1.03-4.125c.186-.742.954-1.259 1.861-.955.466.19.477.215.633.215.23 0 .447-.147.525-.382l.174-.525a.551.551 0 0 0-.347-.703c-.692-.23-.953-.334-1.498-.334-1.792 0-2.73 1.38-2.964 2.313l-1.102 4.42C2.074 12.827 2 13.546 2 15.04a4.722 4.722 0 0 0 4.722 4.722c2.513 0 4.518-1.97 4.695-4.413h1.163a4.687 4.687 0 0 0 4.698 4.413A4.722 4.722 0 0 0 22 15.04c0-1.493-.073-2.212-.538-4.07Zm-14.74 7.157a3.06 3.06 0 0 1-3.055-3.056 3.06 3.06 0 0 1 3.055-3.055c1.684 0 3.025 1.371 3.025 3.055 0 1.684-1.34 3.056-3.025 3.056Zm10.556 0a3.06 3.06 0 0 1-3.056-3.056 3.06 3.06 0 0 1 3.056-3.055 3.06 3.06 0 0 1 3.055 3.055 3.06 3.06 0 0 1-3.055 3.056Z",
        fill: "currentColor"
      }
    )
  })
);
var GlassesRound_default = SvgGlassesRound;

// src/Icon/icons/Glasses.tsx
import { jsx as jsx763 } from "react/jsx-runtime";
var SvgGlasses = (props) => /* @__PURE__ */ jsx763(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx763(
      "path",
      {
        d: "M21.936 12.848 20.36 6.534a3.057 3.057 0 0 0-3.933-2.157l-.529.178a.552.552 0 0 0-.347.703l.174.526c.095.29.412.447.703.351l.455-.151c.378-.126.799-.126 1.155.06.356.187.608.504.708.894l1.332 5.345a9.51 9.51 0 0 0-2.817-.434c-1.389 0-2.973.321-4.622 1.263h-1.277c-1.646-.941-3.233-1.264-4.622-1.264-1.09 0-2.049.195-2.817.434l1.333-5.345c.1-.39.351-.707.712-.894.352-.185.772-.185 1.15-.06l.456.153c.291.095.608-.061.703-.352l.174-.526a.552.552 0 0 0-.353-.702l-.53-.178A3.06 3.06 0 0 0 3.64 6.535l-1.575 6.313a2.217 2.217 0 0 0-.065.538v2.44c0 2.15 1.793 3.953 4.004 3.953h1.29c2.092 0 3.833-1.597 3.99-3.66l.1-1.342h1.24l.1 1.342c.156 2.031 1.896 3.66 3.986 3.66H18c2.209 0 4-1.771 4-3.955v-2.438a2.05 2.05 0 0 0-.064-.538ZM9.62 15.963c-.09 1.219-1.118 2.118-2.334 2.118H6c-1.289 0-2.335-1.024-2.335-2.288V14.14a8.19 8.19 0 0 1 3.078-.626 7.44 7.44 0 0 1 3.012.643l-.136 1.806Zm10.716-.14c0 1.264-1.046 2.288-2.335 2.288h-1.29c-1.21 0-2.235-.928-2.326-2.118l-.139-1.836a7.462 7.462 0 0 1 3.017-.643c1.298 0 2.387.343 3.073.626v1.684Z",
        fill: "currentColor"
      }
    )
  })
);
var Glasses_default = SvgGlasses;

// src/Icon/icons/Globe.tsx
import { jsx as jsx764 } from "react/jsx-runtime";
var SvgGlobe = (props) => /* @__PURE__ */ jsx764(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx764(
      "path",
      {
        d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 18.125c.29 0 1.02-.281 1.86-1.89.343-.692.605-1.532.859-2.485H9.28c.219.953.516 1.793.86 2.484.804 1.61 1.57 1.891 1.859 1.891Zm-3.027-6.25h6.054a18.069 18.069 0 0 0 0-3.75H8.973a18.069 18.069 0 0 0 0 3.75Zm5.746-5.625c-.254-.953-.516-1.793-.86-2.482-.84-1.611-1.57-1.893-1.859-1.893-.29 0-1.055.282-1.86 1.893-.343.689-.64 1.529-.859 2.482h5.438Zm2.195 1.875C16.97 10.73 17 11.359 17 12c0 .64-.031 1.27-.086 1.875h2.992A8.02 8.02 0 0 0 20.125 12a8.02 8.02 0 0 0-.219-1.875h-2.992Zm-1.55-5.523c.55 1.002.988 2.246 1.273 3.648h2.574a8.16 8.16 0 0 0-3.848-3.648Zm-6.727 0A8.159 8.159 0 0 0 4.79 8.25h2.573c.285-1.402.723-2.646 1.274-3.648ZM3.875 12c0 .645.075 1.273.218 1.875h2.993A20.888 20.888 0 0 1 7 12c0-.64.031-1.27.086-1.875H4.093A8.15 8.15 0 0 0 3.875 12Zm15.336 3.75h-2.574c-.285 1.402-.723 2.645-1.274 3.648a8.165 8.165 0 0 0 3.848-3.648Zm-11.848 0H4.79a8.165 8.165 0 0 0 3.847 3.648c-.551-1.003-.989-2.246-1.274-3.648Z",
        fill: "currentColor"
      }
    )
  })
);
var Globe_default = SvgGlobe;

// src/Icon/icons/GreaterThanEqual.tsx
import { jsx as jsx765 } from "react/jsx-runtime";
var SvgGreaterThanEqual = (props) => /* @__PURE__ */ jsx765(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx765(
      "path",
      {
        d: "M3.515 16.353a1.069 1.069 0 0 0 1.408.56l15-6.428a1.072 1.072 0 0 0 0-1.97l-15-6.428a1.072 1.072 0 0 0-.846 1.97L16.781 9.5l-12.7 5.442a1.076 1.076 0 0 0-.566 1.41Zm17.414 3.504H3.07C2.48 19.857 2 20.34 2 20.93c0 .589.48 1.07 1.071 1.07H20.93a1.072 1.072 0 0 0 0-2.142Z",
        fill: "currentColor"
      }
    )
  })
);
var GreaterThanEqual_default = SvgGreaterThanEqual;

// src/Icon/icons/GreaterThan.tsx
import { jsx as jsx766 } from "react/jsx-runtime";
var SvgGreaterThan = (props) => /* @__PURE__ */ jsx766(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx766(
      "path",
      {
        d: "M22 12c0 .481-.277.92-.713 1.127l-17.5 8.333a1.248 1.248 0 0 1-1.665-.59 1.248 1.248 0 0 1 .59-1.666L17.845 12 2.714 4.796a1.247 1.247 0 0 1-.59-1.665 1.246 1.246 0 0 1 1.664-.59l17.5 8.333c.436.203.712.646.712 1.125Z",
        fill: "currentColor"
      }
    )
  })
);
var GreaterThan_default = SvgGreaterThan;

// src/Icon/icons/Grid2Plus.tsx
import { jsx as jsx767 } from "react/jsx-runtime";
var SvgGrid2Plus = (props) => /* @__PURE__ */ jsx767(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx767(
      "path",
      {
        d: "M8.207 2a2.07 2.07 0 0 1 2.069 2.069v4.138a2.07 2.07 0 0 1-2.07 2.069H4.07A2.07 2.07 0 0 1 2 8.206V4.07C2 2.926 2.926 2 4.069 2h4.138Zm0 2.069H4.069v4.138h4.138V4.069Zm0 8.965a2.07 2.07 0 0 1 2.069 2.07v4.137a2.07 2.07 0 0 1-2.07 2.07H4.07A2.07 2.07 0 0 1 2 19.24v-4.138a2.07 2.07 0 0 1 2.069-2.069h4.138Zm0 2.07H4.069v4.137h4.138v-4.138Zm4.827-11.035A2.07 2.07 0 0 1 15.104 2h4.137a2.07 2.07 0 0 1 2.07 2.069v4.138a2.07 2.07 0 0 1-2.07 2.069h-4.138a2.07 2.07 0 0 1-2.069-2.07V4.07Zm2.07 4.138h4.137V4.069h-4.138v4.138Zm2.068 4.138c.574 0 1.035.461 1.035 1.034v2.759h2.758c.574 0 1.035.461 1.035 1.034 0 .574-.461 1.035-1.035 1.035h-2.758v2.758c0 .574-.461 1.035-1.035 1.035a1.032 1.032 0 0 1-1.034-1.035v-2.758h-2.759a1.032 1.032 0 0 1-1.034-1.035c0-.573.461-1.034 1.034-1.034h2.759v-2.759c0-.573.461-1.034 1.034-1.034Z",
        fill: "currentColor"
      }
    )
  })
);
var Grid2Plus_default = SvgGrid2Plus;

// src/Icon/icons/Grid2.tsx
import { jsx as jsx768 } from "react/jsx-runtime";
var SvgGrid2 = (props) => /* @__PURE__ */ jsx768(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx768(
      "path",
      {
        d: "M2 4.143C2 2.959 2.96 2 4.143 2h4.286c1.183 0 2.142.96 2.142 2.143v4.286c0 1.183-.96 2.142-2.142 2.142H4.143A2.143 2.143 0 0 1 2 8.43V4.143Zm2.143 4.286h4.286V4.143H4.143v4.286ZM2 15.57c0-1.183.96-2.142 2.143-2.142h4.286c1.183 0 2.142.96 2.142 2.142v4.286c0 1.183-.96 2.143-2.142 2.143H4.143A2.143 2.143 0 0 1 2 19.857v-4.286Zm2.143 4.286h4.286v-4.286H4.143v4.286ZM19.857 2C21.04 2 22 2.96 22 4.143v4.286c0 1.183-.96 2.142-2.143 2.142h-4.286A2.143 2.143 0 0 1 13.43 8.43V4.143c0-1.184.96-2.143 2.142-2.143h4.286Zm0 2.143h-4.286v4.286h4.286V4.143ZM13.43 15.57c0-1.183.96-2.142 2.142-2.142h4.286c1.183 0 2.143.96 2.143 2.142v4.286C22 21.04 21.04 22 19.857 22h-4.286a2.143 2.143 0 0 1-2.142-2.143v-4.286Zm2.142 4.286h4.286v-4.286h-4.286v4.286Z",
        fill: "currentColor"
      }
    )
  })
);
var Grid2_default = SvgGrid2;

// src/Icon/icons/Grid4.tsx
import { jsx as jsx769 } from "react/jsx-runtime";
var SvgGrid4 = (props) => /* @__PURE__ */ jsx769(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx769(
      "path",
      {
        d: "M6 5.286c0 .281-.163.527-.4.602A.446.446 0 0 1 5.286 6H2.714a.446.446 0 0 1-.313-.112C2.163 5.813 2 5.567 2 5.286V2.714C2 2.32 2.32 2 2.714 2h2.572C5.68 2 6 2.32 6 2.714v2.572ZM4.571 4.57V3.43H3.43V4.57H4.57Zm.715 2.764c.112 0 .219.022.314.071.237.116.4.362.4.643v2.572a.71.71 0 0 1-.4.638.679.679 0 0 1-.314.076H2.714a.678.678 0 0 1-.313-.076A.71.71 0 0 1 2 10.62V8.05a.716.716 0 0 1 .714-.715h2.572ZM4.57 9.906V8.763H3.43v1.143H4.57Zm.715 2.76c.112 0 .219.026.314.075a.71.71 0 0 1 .4.639v2.57a.717.717 0 0 1-.714.715H2.714A.717.717 0 0 1 2 15.951v-2.572a.71.71 0 0 1 .4-.638.678.678 0 0 1 .314-.076h2.572Zm-.715 2.57v-1.142H3.43v1.143H4.57ZM2.714 18h2.572c.112 0 .219-.013.314.071.237.116.4.362.4.643v2.572c0 .393-.32.714-.714.714H2.714A.715.715 0 0 1 2 21.286v-2.572c0-.281.163-.526.4-.643.095-.084.202-.071.314-.071Zm1.857 2.571V19.43H3.43v1.142H4.57Zm6.764-15.285c0 .281-.165.527-.402.602-.134.085-.2.112-.313.112H8.05a.454.454 0 0 1-.318-.112c-.236-.075-.397-.321-.397-.602V2.714c0-.394.317-.714.714-.714h2.572c.392 0 .714.32.714.714v2.572ZM9.906 4.57V3.43H8.763V4.57h1.143Zm.714 2.764c.112 0 .18.022.313.071a.719.719 0 0 1 .402.643v2.572a.712.712 0 0 1-.402.638c-.134.049-.2.076-.313.076H8.05a.692.692 0 0 1-.318-.076.708.708 0 0 1-.397-.639V8.05c0-.282.16-.528.397-.644.098-.049.201-.071.317-.071h2.572Zm-.714 2.571V8.763H8.763v1.143h1.143Zm.714 2.76c.112 0 .18.026.313.075a.712.712 0 0 1 .402.639v2.57a.719.719 0 0 1-.402.644c-.134.044-.2.071-.313.071H8.05a.75.75 0 0 1-.318-.071.715.715 0 0 1-.397-.643v-2.572c0-.28.16-.522.397-.638.098-.049.201-.076.317-.076h2.572Zm-.714 2.57v-1.142H8.763v1.143h1.143ZM8.05 18h2.572c.111 0 .178-.013.312.071a.719.719 0 0 1 .402.643v2.572a.716.716 0 0 1-.715.714H8.05a.714.714 0 0 1-.715-.714v-2.572c0-.281.16-.526.397-.643.098-.084.201-.071.317-.071Zm1.857 2.571V19.43H8.763v1.142h1.143ZM15.951 6h-2.572a.443.443 0 0 1-.312-.112c-.237-.075-.402-.321-.402-.602V2.714c0-.394.322-.714.715-.714h2.57c.398 0 .715.32.715.714v2.572c0 .281-.16.527-.397.602A.454.454 0 0 1 15.95 6Zm-1.857-2.571V4.57h1.143V3.43h-1.143Zm2.571 4.62v2.572c0 .28-.16.522-.397.638a.692.692 0 0 1-.317.076h-2.572a.673.673 0 0 1-.312-.076.712.712 0 0 1-.402-.639V8.05a.719.719 0 0 1 .715-.715h2.57c.117 0 .22.022.318.071a.715.715 0 0 1 .397.643Zm-2.571.714v1.143h1.143V8.763h-1.143Zm2.571 4.617v2.57c0 .282-.16.528-.397.644a.75.75 0 0 1-.317.071h-2.572a.719.719 0 0 1-.714-.714v-2.572c0-.28.165-.522.402-.638.094-.049.2-.076.313-.076h2.57c.117 0 .22.027.318.076a.708.708 0 0 1 .397.639Zm-2.571.714v1.143h1.143v-1.143h-1.143Zm2.174 3.977a.715.715 0 0 1 .397.643v2.572a.714.714 0 0 1-.714.714h-2.572a.716.716 0 0 1-.714-.714v-2.572c0-.281.165-.526.402-.643.094-.084.2-.071.313-.071h2.57c.117 0 .22-.013.318.071Zm-2.174 1.358v1.142h1.143V19.43h-1.143ZM22 5.286c0 .281-.165.527-.402.602a.443.443 0 0 1-.312.112h-2.572a.443.443 0 0 1-.312-.112c-.237-.075-.402-.321-.402-.602V2.714c0-.394.321-.714.714-.714h2.572c.393 0 .714.32.714.714v2.572Zm-1.429-.715V3.43H19.43V4.57h1.142Zm.715 2.764a.719.719 0 0 1 .714.714v2.572a.712.712 0 0 1-.402.638.673.673 0 0 1-.312.076h-2.572a.673.673 0 0 1-.312-.076.712.712 0 0 1-.402-.639V8.05a.719.719 0 0 1 .714-.715h2.572Zm-.715 2.571V8.763H19.43v1.143h1.142Zm.715 2.76c.111 0 .218.026.312.075a.712.712 0 0 1 .402.639v2.57a.719.719 0 0 1-.714.715h-2.572a.719.719 0 0 1-.714-.714v-2.572c0-.28.165-.522.402-.638.093-.049.2-.076.312-.076h2.572Zm-.715 2.57v-1.142H19.43v1.143h1.142ZM18.714 18h2.572c.111 0 .218-.013.312.071a.719.719 0 0 1 .402.643v2.572a.716.716 0 0 1-.714.714h-2.572a.716.716 0 0 1-.714-.714v-2.572c0-.281.165-.526.402-.643.093-.084.2-.071.312-.071Zm1.857 2.571V19.43H19.43v1.142h1.142Z",
        fill: "currentColor"
      }
    )
  })
);
var Grid4_default = SvgGrid4;

// src/Icon/icons/Grid5.tsx
import { jsx as jsx770 } from "react/jsx-runtime";
var SvgGrid5 = (props) => /* @__PURE__ */ jsx770(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx770(
      "path",
      {
        d: "M2 2.714C2 2.32 2.32 2 2.714 2h1.429c.394 0 .714.32.714.714v1.429c0 .394-.32.714-.714.714H2.714A.714.714 0 0 1 2 4.143V2.714ZM2 7c0-.393.32-.714.714-.714h1.429c.394 0 .714.321.714.714v1.429c0 .392-.32.714-.714.714H2.714A.715.715 0 0 1 2 8.429V7Zm2.143 3.571c.394 0 .714.322.714.715v1.428c0 .393-.32.715-.714.715H2.714A.715.715 0 0 1 2 12.714v-1.428c0-.393.32-.715.714-.715h1.429Zm-2.143 5c0-.392.32-.714.714-.714h1.429c.394 0 .714.322.714.714V17c0 .393-.32.714-.714.714H2.714A.715.715 0 0 1 2 17v-1.429Zm2.143 3.572c.394 0 .714.321.714.714v1.429c0 .393-.32.714-.714.714H2.714A.715.715 0 0 1 2 21.286v-1.429c0-.393.32-.714.714-.714h1.429ZM6.286 2.714C6.286 2.32 6.607 2 7 2h1.429c.392 0 .714.32.714.714v1.429a.715.715 0 0 1-.714.714H7a.715.715 0 0 1-.714-.714V2.714Zm2.143 3.572c.392 0 .714.321.714.714v1.429a.716.716 0 0 1-.714.714H7a.716.716 0 0 1-.714-.714V7c0-.393.321-.714.714-.714h1.429Zm-2.143 5c0-.393.321-.715.714-.715h1.429c.392 0 .714.322.714.715v1.428a.716.716 0 0 1-.714.715H7a.716.716 0 0 1-.714-.715v-1.428Zm2.143 3.571c.392 0 .714.322.714.714V17a.716.716 0 0 1-.714.714H7A.716.716 0 0 1 6.286 17v-1.429c0-.392.321-.714.714-.714h1.429Zm-2.143 5c0-.393.321-.714.714-.714h1.429c.392 0 .714.321.714.714v1.429a.716.716 0 0 1-.714.714H7a.716.716 0 0 1-.714-.714v-1.429ZM12.714 2c.393 0 .715.32.715.714v1.429a.715.715 0 0 1-.715.714h-1.428a.715.715 0 0 1-.715-.714V2.714c0-.394.322-.714.715-.714h1.428Zm-2.143 5c0-.393.322-.714.715-.714h1.428c.393 0 .715.321.715.714v1.429a.716.716 0 0 1-.715.714h-1.428a.716.716 0 0 1-.715-.714V7Zm2.143 3.571c.393 0 .715.322.715.715v1.428a.716.716 0 0 1-.715.715h-1.428a.716.716 0 0 1-.715-.715v-1.428c0-.393.322-.715.715-.715h1.428Zm-2.143 5c0-.392.322-.714.715-.714h1.428c.393 0 .715.322.715.714V17a.716.716 0 0 1-.715.714h-1.428A.716.716 0 0 1 10.57 17v-1.429Zm2.143 3.572c.393 0 .715.321.715.714v1.429a.716.716 0 0 1-.715.714h-1.428a.716.716 0 0 1-.715-.714v-1.429c0-.393.322-.714.715-.714h1.428Zm2.143-16.429c0-.394.322-.714.714-.714H17c.393 0 .714.32.714.714v1.429a.715.715 0 0 1-.714.714h-1.429a.715.715 0 0 1-.714-.714V2.714ZM17 6.286c.393 0 .714.321.714.714v1.429a.716.716 0 0 1-.714.714h-1.429a.716.716 0 0 1-.714-.714V7c0-.393.322-.714.714-.714H17Zm-2.143 5c0-.393.322-.715.714-.715H17c.393 0 .714.322.714.715v1.428a.716.716 0 0 1-.714.715h-1.429a.716.716 0 0 1-.714-.715v-1.428ZM17 14.857c.393 0 .714.322.714.714V17a.716.716 0 0 1-.714.714h-1.429a.716.716 0 0 1-.714-.714v-1.429c0-.392.322-.714.714-.714H17Zm-2.143 5c0-.393.322-.714.714-.714H17c.393 0 .714.321.714.714v1.429A.716.716 0 0 1 17 22h-1.429a.716.716 0 0 1-.714-.714v-1.429ZM21.286 2c.393 0 .714.32.714.714v1.429a.715.715 0 0 1-.714.714h-1.429a.715.715 0 0 1-.714-.714V2.714c0-.394.321-.714.714-.714h1.429Zm-2.143 5c0-.393.321-.714.714-.714h1.429c.393 0 .714.321.714.714v1.429a.716.716 0 0 1-.714.714h-1.429a.716.716 0 0 1-.714-.714V7Zm2.143 3.571c.393 0 .714.322.714.715v1.428a.716.716 0 0 1-.714.715h-1.429a.716.716 0 0 1-.714-.715v-1.428c0-.393.321-.715.714-.715h1.429Zm-2.143 5c0-.392.321-.714.714-.714h1.429c.393 0 .714.322.714.714V17a.716.716 0 0 1-.714.714h-1.429a.716.716 0 0 1-.714-.714v-1.429Zm2.143 3.572c.393 0 .714.321.714.714v1.429a.716.716 0 0 1-.714.714h-1.429a.716.716 0 0 1-.714-.714v-1.429c0-.393.321-.714.714-.714h1.429Z",
        fill: "currentColor"
      }
    )
  })
);
var Grid5_default = SvgGrid5;

// src/Icon/icons/GridDividers.tsx
import { jsx as jsx771 } from "react/jsx-runtime";
var SvgGridDividers = (props) => /* @__PURE__ */ jsx771(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx771(
      "path",
      {
        d: "M2 2.938C2 2.42 2.42 2 2.938 2h18.125a.937.937 0 1 1 0 1.875H2.938A.938.938 0 0 1 2 2.937ZM3.25 7c0-.691.56-1.25 1.25-1.25H7c.691 0 1.25.559 1.25 1.25v2.5c0 .691-.559 1.25-1.25 1.25H4.5A1.25 1.25 0 0 1 3.25 9.5V7Zm3.125 1.875v-1.25h-1.25v1.25h1.25ZM3.25 18.25c0-.691.56-1.25 1.25-1.25H7c.691 0 1.25.559 1.25 1.25v2.5C8.25 21.441 7.691 22 7 22H4.5a1.25 1.25 0 0 1-1.25-1.25v-2.5Zm3.125 1.875v-1.25h-1.25v1.25h1.25ZM13.25 5.75c.691 0 1.25.559 1.25 1.25v2.5c0 .691-.559 1.25-1.25 1.25h-2.5c-.691 0-1.25-.559-1.25-1.25V7c0-.691.559-1.25 1.25-1.25h2.5Zm-1.875 1.875v1.25h1.25v-1.25h-1.25ZM9.5 18.25c0-.691.559-1.25 1.25-1.25h2.5c.691 0 1.25.559 1.25 1.25v2.5c0 .691-.559 1.25-1.25 1.25h-2.5c-.691 0-1.25-.559-1.25-1.25v-2.5Zm3.125 1.875v-1.25h-1.25v1.25h1.25ZM19.5 5.75c.691 0 1.25.559 1.25 1.25v2.5c0 .691-.559 1.25-1.25 1.25H17c-.691 0-1.25-.559-1.25-1.25V7c0-.691.559-1.25 1.25-1.25h2.5Zm-1.875 1.875v1.25h1.25v-1.25h-1.25ZM15.75 18.25c0-.691.559-1.25 1.25-1.25h2.5c.691 0 1.25.559 1.25 1.25v2.5c0 .691-.559 1.25-1.25 1.25H17c-.691 0-1.25-.559-1.25-1.25v-2.5Zm3.125 1.875v-1.25h-1.25v1.25h1.25Zm2.188-6.875c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H2.938a.937.937 0 1 1 0-1.875h18.125Z",
        fill: "currentColor"
      }
    )
  })
);
var GridDividers_default = SvgGridDividers;

// src/Icon/icons/GridHorizontal.tsx
import { jsx as jsx772 } from "react/jsx-runtime";
var SvgGridHorizontal = (props) => /* @__PURE__ */ jsx772(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx772(
      "path",
      {
        d: "M2 7.357c0-.986.8-1.786 1.786-1.786h2.143c.986 0 1.785.8 1.785 1.786V9.5c0 .987-.799 1.786-1.785 1.786H3.786C2.8 11.286 2 10.486 2 9.5V7.357ZM3.786 9.5h2.143V7.357H3.786V9.5ZM2 14.5c0-.987.8-1.786 1.786-1.786h2.143c.986 0 1.785.8 1.785 1.786v2.143c0 .986-.799 1.786-1.785 1.786H3.786c-.986 0-1.786-.8-1.786-1.786V14.5Zm1.786 2.143h2.143V14.5H3.786v2.143ZM13.07 5.57c.987 0 1.786.8 1.786 1.786V9.5c0 .987-.799 1.786-1.786 1.786H10.93c-.987 0-1.786-.8-1.786-1.786V7.357c0-.986.799-1.786 1.786-1.786h2.142Zm0 1.786H10.93V9.5h2.142V7.357ZM9.143 14.5c0-.987.799-1.786 1.786-1.786h2.142c.987 0 1.786.8 1.786 1.786v2.143c0 .986-.799 1.786-1.786 1.786H10.93c-.987 0-1.786-.8-1.786-1.786V14.5Zm1.786 2.143h2.142V14.5H10.93v2.143ZM20.214 5.57c.987 0 1.786.8 1.786 1.786V9.5c0 .987-.8 1.786-1.786 1.786h-2.143c-.986 0-1.785-.8-1.785-1.786V7.357c0-.986.799-1.786 1.785-1.786h2.143Zm0 1.786h-2.143V9.5h2.143V7.357ZM16.286 14.5c0-.987.799-1.786 1.785-1.786h2.143c.987 0 1.786.8 1.786 1.786v2.143c0 .986-.8 1.786-1.786 1.786h-2.143c-.986 0-1.785-.8-1.785-1.786V14.5Zm1.785 2.143h2.143V14.5h-2.143v2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var GridHorizontal_default = SvgGridHorizontal;

// src/Icon/icons/Grid.tsx
import { jsx as jsx773 } from "react/jsx-runtime";
var SvgGrid = (props) => /* @__PURE__ */ jsx773(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx773(
      "path",
      {
        d: "M5.929 2c.986 0 1.785.8 1.785 1.786v2.143c0 .986-.799 1.785-1.785 1.785H3.786C2.8 7.714 2 6.915 2 5.93V3.786C2 2.8 2.8 2 3.786 2h2.143Zm0 1.786H3.786v2.143h2.143V3.786Zm0 5.357c.986 0 1.785.799 1.785 1.786v2.142c0 .987-.799 1.786-1.785 1.786H3.786C2.8 14.857 2 14.058 2 13.071V10.93c0-.987.8-1.786 1.786-1.786h2.143Zm0 1.786H3.786v2.142h2.143V10.93ZM2 18.07c0-.986.8-1.785 1.786-1.785h2.143c.986 0 1.785.799 1.785 1.785v2.143c0 .987-.799 1.786-1.785 1.786H3.786C2.8 22 2 21.2 2 20.214v-2.143Zm1.786 2.143h2.143v-2.143H3.786v2.143ZM13.07 2c.987 0 1.786.8 1.786 1.786v2.143c0 .986-.799 1.785-1.786 1.785H10.93c-.987 0-1.786-.799-1.786-1.785V3.786C9.143 2.8 9.942 2 10.929 2h2.142Zm0 1.786H10.93v2.143h2.142V3.786Zm-3.928 7.143c0-.987.799-1.786 1.786-1.786h2.142c.987 0 1.786.799 1.786 1.786v2.142c0 .987-.799 1.786-1.786 1.786H10.93c-.987 0-1.786-.799-1.786-1.786V10.93Zm1.786 2.142h2.142V10.93H10.93v2.142Zm2.142 3.215c.987 0 1.786.799 1.786 1.785v2.143c0 .987-.799 1.786-1.786 1.786H10.93c-.987 0-1.786-.8-1.786-1.786v-2.143c0-.986.799-1.785 1.786-1.785h2.142Zm0 1.785H10.93v2.143h2.142v-2.143Zm3.215-14.285C16.286 2.8 17.085 2 18.07 2h2.143C21.201 2 22 2.8 22 3.786v2.143c0 .986-.8 1.785-1.786 1.785h-2.143c-.986 0-1.785-.799-1.785-1.785V3.786Zm1.785 2.143h2.143V3.786h-2.143v2.143Zm2.143 3.214c.987 0 1.786.799 1.786 1.786v2.142c0 .987-.8 1.786-1.786 1.786h-2.143c-.986 0-1.785-.799-1.785-1.786V10.93c0-.987.799-1.786 1.785-1.786h2.143Zm0 1.786h-2.143v2.142h2.143V10.93Zm-3.928 7.142c0-.986.799-1.785 1.785-1.785h2.143c.987 0 1.786.799 1.786 1.785v2.143c0 .987-.8 1.786-1.786 1.786h-2.143c-.986 0-1.785-.8-1.785-1.786v-2.143Zm1.785 2.143h2.143v-2.143h-2.143v2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var Grid_default = SvgGrid;

// src/Icon/icons/GripDotsVertical.tsx
import { jsx as jsx774 } from "react/jsx-runtime";
var SvgGripDotsVertical = (props) => /* @__PURE__ */ jsx774(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx774(
      "path",
      {
        d: "M7 3.667a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0ZM7 12a1.666 1.666 0 1 1 3.332-.002A1.666 1.666 0 0 1 7 12Zm3.333 8.333a1.666 1.666 0 1 1-3.331.002 1.666 1.666 0 0 1 3.331-.002Zm3.334-16.666a1.666 1.666 0 1 1 3.333 0c0 .922-.745 1.666-1.667 1.666a1.665 1.665 0 0 1-1.666-1.666ZM17 12c0 .922-.745 1.667-1.667 1.667A1.665 1.665 0 0 1 13.667 12c0-.922.745-1.667 1.666-1.667.922 0 1.667.745 1.667 1.667Zm-3.333 8.333c0-.921.745-1.666 1.666-1.666.922 0 1.667.744 1.667 1.666 0 .922-.745 1.667-1.667 1.667a1.665 1.665 0 0 1-1.666-1.667Z",
        fill: "currentColor"
      }
    )
  })
);
var GripDotsVertical_default = SvgGripDotsVertical;

// src/Icon/icons/GripDots.tsx
import { jsx as jsx775 } from "react/jsx-runtime";
var SvgGripDots = (props) => /* @__PURE__ */ jsx775(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx775(
      "path",
      {
        d: "M20.333 7C21.255 7 22 7.745 22 8.667s-.745 1.666-1.667 1.666a1.665 1.665 0 0 1-1.666-1.666c0-.922.744-1.667 1.666-1.667ZM12 7c.922 0 1.667.745 1.667 1.667s-.745 1.666-1.667 1.666a1.665 1.665 0 0 1-1.667-1.666C10.333 7.745 11.078 7 12 7Zm-8.333 3.333a1.666 1.666 0 1 1 0-3.333 1.666 1.666 0 1 1 0 3.333Zm16.666 3.334c.922 0 1.667.745 1.667 1.666 0 .922-.745 1.667-1.667 1.667a1.665 1.665 0 0 1-1.666-1.667c0-.921.744-1.666 1.666-1.666ZM12 17a1.665 1.665 0 0 1-1.667-1.667c0-.921.745-1.666 1.667-1.666s1.667.745 1.667 1.666c0 .922-.745 1.667-1.667 1.667Zm-8.333-3.333a1.666 1.666 0 1 1 .001 3.331 1.666 1.666 0 0 1-.001-3.331Z",
        fill: "currentColor"
      }
    )
  })
);
var GripDots_default = SvgGripDots;

// src/Icon/icons/GripLinesVertical.tsx
import { jsx as jsx776 } from "react/jsx-runtime";
var SvgGripLinesVertical = (props) => /* @__PURE__ */ jsx776(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx776(
      "path",
      {
        d: "M10.214 3.071V20.93a1.07 1.07 0 1 1-2.143 0V3.07a1.072 1.072 0 0 1 2.143 0Zm5.715 0V20.93c0 .593-.478 1.071-1.072 1.071a1.069 1.069 0 0 1-1.071-1.071V3.07a1.07 1.07 0 1 1 2.143 0Z",
        fill: "currentColor"
      }
    )
  })
);
var GripLinesVertical_default = SvgGripLinesVertical;

// src/Icon/icons/GripLines.tsx
import { jsx as jsx777 } from "react/jsx-runtime";
var SvgGripLines = (props) => /* @__PURE__ */ jsx777(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx777(
      "path",
      {
        d: "M20.929 10.214H3.07a1.07 1.07 0 1 1 0-2.143H20.93c.593 0 1.071.478 1.071 1.072 0 .594-.478 1.071-1.071 1.071Zm0 5.715H3.07a1.07 1.07 0 1 1 0-2.143H20.93c.593 0 1.071.477 1.071 1.071s-.478 1.072-1.071 1.072Z",
        fill: "currentColor"
      }
    )
  })
);
var GripLines_default = SvgGripLines;

// src/Icon/icons/GripVertical.tsx
import { jsx as jsx778 } from "react/jsx-runtime";
var SvgGripVertical = (props) => /* @__PURE__ */ jsx778(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx778(
      "path",
      {
        d: "M6.643 22c-.986 0-1.786-.8-1.786-1.786v-2.143c0-.986.8-1.785 1.786-1.785h2.143c.986 0 1.786.799 1.786 1.785v2.143c0 .987-.8 1.786-1.786 1.786H6.643Zm2.143-1.786v-2.143H6.643v2.143h2.143ZM15.214 22c-.986 0-1.785-.8-1.785-1.786v-2.143c0-.986.799-1.785 1.785-1.785h2.143c.987 0 1.786.799 1.786 1.785v2.143c0 .987-.8 1.786-1.786 1.786h-2.143Zm2.143-1.786v-2.143h-2.143v2.143h2.143Zm-12.5-9.285c0-.987.8-1.786 1.786-1.786h2.143c.986 0 1.786.799 1.786 1.786v2.142c0 .987-.8 1.786-1.786 1.786H6.643c-.986 0-1.786-.799-1.786-1.786V10.93Zm1.786 0v2.142h2.143V10.93H6.643Zm8.571 3.928c-.986 0-1.785-.799-1.785-1.786V10.93c0-.987.799-1.786 1.785-1.786h2.143c.987 0 1.786.799 1.786 1.786v2.142c0 .987-.8 1.786-1.786 1.786h-2.143Zm2.143-1.786V10.93h-2.143v2.142h2.143Zm-12.5-9.285C4.857 2.8 5.657 2 6.643 2h2.143c.986 0 1.786.8 1.786 1.786v2.143c0 .986-.8 1.785-1.786 1.785H6.643c-.986 0-1.786-.799-1.786-1.785V3.786Zm1.786 0v2.143h2.143V3.786H6.643Zm8.571 3.928c-.986 0-1.785-.799-1.785-1.785V3.786c0-.986.799-1.786 1.785-1.786h2.143c.987 0 1.786.8 1.786 1.786v2.143c0 .986-.8 1.785-1.786 1.785h-2.143Zm2.143-1.785V3.786h-2.143v2.143h2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var GripVertical_default = SvgGripVertical;

// src/Icon/icons/Grip.tsx
import { jsx as jsx779 } from "react/jsx-runtime";
var SvgGrip = (props) => /* @__PURE__ */ jsx779(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx779(
      "path",
      {
        d: "M22 17.357c0 .987-.8 1.786-1.786 1.786h-2.143c-.986 0-1.785-.8-1.785-1.786v-2.143c0-.986.799-1.785 1.785-1.785h2.143c.987 0 1.786.799 1.786 1.785v2.143Zm-1.786-2.143h-2.143v2.143h2.143v-2.143ZM22 8.786c0 .986-.8 1.785-1.786 1.785h-2.143c-.986 0-1.785-.799-1.785-1.785V6.643c0-.987.799-1.786 1.785-1.786h2.143c.987 0 1.786.8 1.786 1.786v2.143Zm-1.786-2.143h-2.143v2.143h2.143V6.643Zm-9.285 12.5c-.987 0-1.786-.8-1.786-1.786v-2.143c0-.986.799-1.785 1.786-1.785h2.142c.987 0 1.786.799 1.786 1.785v2.143c0 .987-.799 1.786-1.786 1.786H10.93Zm0-1.786h2.142v-2.143H10.93v2.143Zm3.928-8.571c0 .986-.799 1.785-1.786 1.785H10.93c-.987 0-1.786-.799-1.786-1.785V6.643c0-.987.799-1.786 1.786-1.786h2.142c.987 0 1.786.8 1.786 1.786v2.143Zm-1.786-2.143H10.93v2.143h2.142V6.643Zm-9.285 12.5c-.986 0-1.786-.8-1.786-1.786v-2.143c0-.986.8-1.785 1.786-1.785h2.143c.986 0 1.785.799 1.785 1.785v2.143c0 .987-.799 1.786-1.785 1.786H3.786Zm0-1.786h2.143v-2.143H3.786v2.143Zm3.928-8.571c0 .986-.799 1.785-1.785 1.785H3.786C2.8 10.571 2 9.772 2 8.786V6.643c0-.987.8-1.786 1.786-1.786h2.143c.986 0 1.785.8 1.785 1.786v2.143ZM5.93 6.643H3.786v2.143h2.143V6.643Z",
        fill: "currentColor"
      }
    )
  })
);
var Grip_default = SvgGrip;

// src/Icon/icons/GroupArrowsRotate.tsx
import { jsx as jsx780 } from "react/jsx-runtime";
var SvgGroupArrowsRotate = (props) => /* @__PURE__ */ jsx780(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx780(
      "path",
      {
        d: "M7.907 4.687a2.68 2.68 0 0 1-3.22 3.22 8.346 8.346 0 0 0-.718 1.697 1.004 1.004 0 1 1-1.927-.57c.24-.812.577-1.579.997-2.291a2.681 2.681 0 0 1 3.704-3.704c.712-.42 1.479-.756 2.291-.997a1.004 1.004 0 1 1 .57 1.927 8.346 8.346 0 0 0-1.696.718Zm9.35-1.648a2.68 2.68 0 0 1 3.703 3.704c.42.712.721 1.479.997 2.291a1.005 1.005 0 1 1-1.927.57 8.315 8.315 0 0 0-.716-1.696 2.683 2.683 0 0 1-3.221-3.22c-.57-.3-1.102-.541-1.697-.719a1.006 1.006 0 1 1 .574-1.927c.809.24 1.575.577 2.287.997ZM4.687 16.093a2.68 2.68 0 0 1 3.22 3.221c.533.298 1.102.54 1.697.716a1.005 1.005 0 1 1-.57 1.927c-.812-.276-1.579-.578-2.291-.997a2.68 2.68 0 0 1-3.704-3.703 10.304 10.304 0 0 1-.997-2.287 1.006 1.006 0 1 1 1.927-.574c.178.595.42 1.127.718 1.697Zm16.273 1.164a2.678 2.678 0 0 1-3.703 3.703c-.712.42-1.478.721-2.287.997a1.004 1.004 0 1 1-.574-1.927c.595-.175 1.127-.418 1.697-.716a2.684 2.684 0 0 1 3.221-3.221c.298-.57.54-1.102.716-1.697a1.004 1.004 0 1 1 1.927.574c-.276.809-.578 1.575-.997 2.287ZM9.354 12.034c0 1.039.59 1.943 1.462 2.387.494.256.69.86.44 1.354a1.008 1.008 0 0 1-1.354.44 4.692 4.692 0 0 1-1.348-7.327l-.47-.465c-.31-.277-.08-.746.31-.746h2.535c.239 0 .435.197.435.436v2.534c0 .352-.469.582-.745.306l-.641-.641a2.668 2.668 0 0 0-.624 1.722Zm3.46-3.808a1.009 1.009 0 0 1 1.353-.44 4.692 4.692 0 0 1 1.349 7.327l.465.469c.276.272.046.741-.306.741H13.14a.435.435 0 0 1-.436-.435v-2.535c0-.385.47-.582.746-.343l.64.678c.39-.465.625-1.064.625-1.721 0-1.04-.591-1.944-1.462-2.388a1.009 1.009 0 0 1-.44-1.353Z",
        fill: "currentColor"
      }
    )
  })
);
var GroupArrowsRotate_default = SvgGroupArrowsRotate;

// src/Icon/icons/H.tsx
import { jsx as jsx781 } from "react/jsx-runtime";
var SvgH = (props) => /* @__PURE__ */ jsx781(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx781(
      "path",
      {
        d: "M20.571 3.071V20.93a1.072 1.072 0 0 1-2.142 0V12H5.57v8.929a1.07 1.07 0 1 1-2.142 0V3.07a1.072 1.072 0 0 1 2.142 0v6.786H18.43V3.071C18.429 2.48 18.91 2 19.5 2c.59 0 1.071.48 1.071 1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var H_default = SvgH;

// src/Icon/icons/H1.tsx
import { jsx as jsx782 } from "react/jsx-runtime";
var SvgH1 = (props) => /* @__PURE__ */ jsx782(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx782(
      "path",
      {
        d: "M12.278 5.333a.835.835 0 0 0-.834.834v4.722H3.667V6.167a.834.834 0 0 0-1.667 0v11.666a.832.832 0 1 0 1.667 0v-5.277h7.777v5.277a.834.834 0 0 0 1.667 0V6.167a.832.832 0 0 0-.833-.834ZM21.167 17H19.5V6.167a.833.833 0 0 0-1.295-.693l-2.5 1.635a.833.833 0 0 0 .924 1.387l1.204-.77V17h-1.666a.834.834 0 0 0 0 1.667h4.968c.49 0 .865-.372.865-.834a.834.834 0 0 0-.833-.833Z",
        fill: "currentColor"
      }
    )
  })
);
var H1_default = SvgH1;

// src/Icon/icons/H2.tsx
import { jsx as jsx783 } from "react/jsx-runtime";
var SvgH2 = (props) => /* @__PURE__ */ jsx783(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx783(
      "path",
      {
        d: "M11.25 5.997a.751.751 0 0 0-.75.75v4.25h-7v-4.25a.75.75 0 0 0-1.5 0v10.5a.75.75 0 1 0 1.5 0v-4.75h7v4.75a.75.75 0 0 0 1.5 0v-10.5a.75.75 0 0 0-.75-.75Zm10 10.506h-5.069l3.928-3.587a3.95 3.95 0 0 0 .427-5.49 3.872 3.872 0 0 0-2.706-1.411 3.88 3.88 0 0 0-2.885.967l-.802.708a.75.75 0 0 0 .993 1.125l.802-.709a2.406 2.406 0 0 1 1.774-.596c.655.052 1.247.36 1.667.87a2.485 2.485 0 0 1-.273 3.42l-5.362 4.9a.75.75 0 0 0 .506 1.303h7a.75.75 0 0 0 0-1.5Z",
        fill: "currentColor"
      }
    )
  })
);
var H2_default = SvgH2;

// src/Icon/icons/H3.tsx
import { jsx as jsx784 } from "react/jsx-runtime";
var SvgH3 = (props) => /* @__PURE__ */ jsx784(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx784(
      "path",
      {
        d: "M11.25 6.003a.751.751 0 0 0-.75.75v4.25h-7v-4.25a.75.75 0 0 0-1.5 0v10.5a.75.75 0 1 0 1.5 0v-4.75h7v4.75a.75.75 0 0 0 1.5 0v-10.5a.75.75 0 0 0-.75-.75Zm7.456 4.982H17.64l3.61-3.716a.75.75 0 0 0-.539-1.272l-6.211.005c-.414 0-.75.33-.75.745 0 .414.336.75.75.75h4.41l-3.61 3.715a.75.75 0 0 0 .538 1.273h2.841c.99 0 1.794.9 1.794 2.006 0 1.106-.805 2.006-1.794 2.006h-2.41c-.485 0-.919-.351-1.08-.874a.75.75 0 1 0-1.434.441c.356 1.156 1.366 1.932 2.514 1.932h2.41c1.843.001 3.321-1.57 3.321-3.505 0-1.934-1.478-3.506-3.294-3.506Z",
        fill: "currentColor"
      }
    )
  })
);
var H3_default = SvgH3;

// src/Icon/icons/H4.tsx
import { jsx as jsx785 } from "react/jsx-runtime";
var SvgH4 = (props) => /* @__PURE__ */ jsx785(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx785(
      "path",
      {
        d: "M21.25 6.004a.75.75 0 0 0-.75.75v5.243h-5.228l.963-5.103a.75.75 0 1 0-1.473-.277L13.63 12.61a.75.75 0 0 0 .159.617c.144.17.357.27.579.27H20.5v3.756a.75.75 0 0 0 1.5 0v-10.5a.75.75 0 0 0-.75-.75Zm-10-.007a.751.751 0 0 0-.75.75v4.25h-7v-4.25a.75.75 0 0 0-1.5 0v10.5a.75.75 0 1 0 1.5 0v-4.75h7v4.75a.75.75 0 0 0 1.5 0v-10.5a.75.75 0 0 0-.75-.75Z",
        fill: "currentColor"
      }
    )
  })
);
var H4_default = SvgH4;

// src/Icon/icons/H5.tsx
import { jsx as jsx786 } from "react/jsx-runtime";
var SvgH5 = (props) => /* @__PURE__ */ jsx786(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx786(
      "path",
      {
        d: "M3.5 11h7V6.75a.75.75 0 1 1 1.5 0v10.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75V12.5h-7v4.75a.75.75 0 1 1-1.5 0V6.75a.75.75 0 0 1 1.5 0V11Zm16.75-5a.75.75 0 1 1 0 1.5h-3.884l-.7 3.5H18.5c1.934 0 3.5 1.566 3.5 3.5S20.434 18 18.5 18h-1.988c-1.078 0-2.03-.716-2.371-1.71l-.104-.302a.75.75 0 0 1 .475-.95c.366-.132.82.08.95.474l.1.304c.138.409.52.684.95.684H18.5c1.103 0 2-.897 2-2s-.897-2-2-2h-3.75c-.225 0-.466-.1-.581-.275a.755.755 0 0 1-.153-.622l1-5A.749.749 0 0 1 15.75 6h4.5Z",
        fill: "currentColor"
      }
    )
  })
);
var H5_default = SvgH5;

// src/Icon/icons/H6.tsx
import { jsx as jsx787 } from "react/jsx-runtime";
var SvgH6 = (props) => /* @__PURE__ */ jsx787(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx787(
      "path",
      {
        d: "M3.5 11h7V6.75a.75.75 0 1 1 1.5 0v10.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75V12.5h-7v4.75a.75.75 0 1 1-1.5 0V6.75a.75.75 0 0 1 1.5 0V11Zm14.69-4.836c.35.26.404.731.144 1.027l-1.459 1.853A4.501 4.501 0 1 1 17.5 18a4.501 4.501 0 0 1-4.494-4.75H13c0-1.14.387-2.25 1.1-3.14l3.066-3.828c.256-.324.728-.376 1.025-.118ZM17.5 16.5a3 3 0 0 0 3-3c0-1.684-1.344-3-3-3-1.684 0-3 1.316-3 3 0 1.656 1.316 3 3 3Z",
        fill: "currentColor"
      }
    )
  })
);
var H6_default = SvgH6;

// src/Icon/icons/Hammer.tsx
import { jsx as jsx788 } from "react/jsx-runtime";
var SvgHammer = (props) => /* @__PURE__ */ jsx788(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx788(
      "path",
      {
        d: "M2.733 16.621a2.498 2.498 0 0 0-.001 3.534c.488.49 1.128.733 1.737.733.61 0 1.28-.244 1.768-.732l7.02-8.038-2.48-2.524-8.044 7.027ZM21.835 9.88l-.789-.794a.562.562 0 0 0-.789 0l-.392.397-1.007-1.007a2.22 2.22 0 0 0-.571-2.15l-1.58-1.578a5.624 5.624 0 0 0-3.947-1.635c-1.43 0-2.856.545-3.947 1.635l2.367 2.367v.654c0 .28.057.554.157.812l2.952 2.969c.266.104.546.157.825.157.196 0 .392-.026.584-.074l1.007 1.007-.392.397a.558.558 0 0 0 0 .789l.785.789a.563.563 0 0 0 .794 0l3.947-3.948a.558.558 0 0 0-.003-.787Zm-3.551 1.972L16.2 9.764l-.93.249c-.33.087-.527-.127-.54-.136L13.018 8.16a.543.543 0 0 1-.162-.393V6.421l-1.408-1.408a3.88 3.88 0 0 1 1.312-.227c1.042 0 2.023.406 2.76 1.142L17.1 7.507c.205.205.157.462.14.54l-.25.93 2.085 2.083-.79.79Z",
        fill: "currentColor"
      }
    )
  })
);
var Hammer_default = SvgHammer;

// src/Icon/icons/Hashtag.tsx
import { jsx as jsx789 } from "react/jsx-runtime";
var SvgHashtag = (props) => /* @__PURE__ */ jsx789(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx789(
      "path",
      {
        d: "m20.928 6.643-3.303-.001.608-3.382a1.072 1.072 0 0 0-.865-1.245 1.08 1.08 0 0 0-1.245.865l-.677 3.762h-4.964l.609-3.382a1.072 1.072 0 0 0-.865-1.245 1.076 1.076 0 0 0-1.244.866l-.677 3.761H4.5a1.07 1.07 0 1 0 0 2.143h3.418l-1.157 6.428h-3.69a1.072 1.072 0 0 0 0 2.144h3.305l-.609 3.382a1.072 1.072 0 0 0 2.108.38l.676-3.762h4.965l-.609 3.382a1.072 1.072 0 0 0 2.11.38l.677-3.762H19.5c.591 0 1.071-.48 1.071-1.031 0-.591-.48-1.072-1.071-1.072h-3.418l1.157-6.428 3.69-.04c.59 0 1.07-.48 1.07-1.031 0-.63-.477-1.112-1.07-1.112Zm-7.022 8.531H8.942l1.157-6.428h4.964l-1.157 6.428Z",
        fill: "currentColor"
      }
    )
  })
);
var Hashtag_default = SvgHashtag;

// src/Icon/icons/Heading.tsx
import { jsx as jsx790 } from "react/jsx-runtime";
var SvgHeading = (props) => /* @__PURE__ */ jsx790(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx790(
      "path",
      {
        d: "M22 20.929C22 21.52 21.52 22 20.929 22h-5a1.072 1.072 0 0 1 0-2.143h1.428v-6.786H6.643v6.786H8.07a1.072 1.072 0 0 1 0 2.143h-5a1.07 1.07 0 1 1 0-2.143H4.5V4.143H3.071a1.072 1.072 0 0 1 0-2.143h5a1.07 1.07 0 1 1 0 2.143H6.643v6.786h10.714V4.143H15.93c-.59 0-1.072-.48-1.072-1.072C14.857 2.48 15.34 2 15.93 2h5a1.07 1.07 0 1 1 0 2.143H19.5v15.714h1.429c.593 0 1.071.482 1.071 1.072Z",
        fill: "currentColor"
      }
    )
  })
);
var Heading_default = SvgHeading;

// src/Icon/icons/HeadphonesSimple.tsx
import { jsx as jsx791 } from "react/jsx-runtime";
var SvgHeadphonesSimple = (props) => /* @__PURE__ */ jsx791(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx791(
      "path",
      {
        d: "M8.25 12.62h-.625c-1.38 0-2.5 1.122-2.5 2.506v3.12a2.503 2.503 0 0 0 2.5 2.504h.625c.69 0 1.25-.56 1.25-1.252V13.87c0-.691-.559-1.25-1.25-1.25Zm-.625 6.255a.628.628 0 0 1-.625-.63v-3.12c0-.348.28-.63.625-.63v4.38ZM12 3.25c-5.59 0-9.822 4.652-10 10v4.375c0 .345.28.625.625.625h.625a.626.626 0 0 0 .625-.628V13.25c0-4.48 3.646-8.117 8.125-8.117 4.48 0 8.125 3.636 8.125 8.117v4.37c-.035.349.281.63.625.63l.625.001c.346 0 .625-.28.625-.625v-4.411c-.18-5.313-4.41-9.965-10-9.965Zm4.375 9.37h-.625c-.69 0-1.25.561-1.25 1.253v5.625c0 .692.56 1.252 1.25 1.252h.625c1.38 0 2.5-1.121 2.5-2.505v-3.12a2.503 2.503 0 0 0-2.5-2.504ZM17 18.247a.628.628 0 0 1-.625.629v-4.38c.345 0 .625.283.625.63v3.12Z",
        fill: "currentColor"
      }
    )
  })
);
var HeadphonesSimple_default = SvgHeadphonesSimple;

// src/Icon/icons/Headphones.tsx
import { jsx as jsx792 } from "react/jsx-runtime";
var SvgHeadphones = (props) => /* @__PURE__ */ jsx792(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx792(
      "path",
      {
        d: "M12 3.25c-5.59 0-9.822 4.652-10 10v4.371c0 .033.014.063.019.095a3.209 3.209 0 0 0 3.198 3.034A1.78 1.78 0 0 0 7 18.969v-5.18C7 12.801 6.2 12 5.213 12c-.452 0-.881.094-1.272.262C4.431 8.246 7.855 5.13 12 5.13s7.57 3.117 8.059 7.133a3.19 3.19 0 0 0-1.27-.263c-.988 0-1.789.8-1.789 1.79v5.179a1.78 1.78 0 0 0 1.781 1.781 3.208 3.208 0 0 0 3.199-3.033c.005-.031.018-.062.018-.095L22 13.246c-.18-5.348-4.41-9.996-10-9.996ZM5.125 13.879v4.992a1.344 1.344 0 0 1-1.25-1.339v-2.32c0-.708.553-1.29 1.25-1.333Zm13.75 4.992V13.88a1.34 1.34 0 0 1 1.25 1.335v2.32c0 .708-.555 1.29-1.25 1.337Z",
        fill: "currentColor"
      }
    )
  })
);
var Headphones_default = SvgHeadphones;

// src/Icon/icons/Headset.tsx
import { jsx as jsx793 } from "react/jsx-runtime";
var SvgHeadset = (props) => /* @__PURE__ */ jsx793(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx793(
      "path",
      {
        d: "M12 2C6.41 2 2.179 6.652 2 12v2.078C2 15.691 3.28 17 4.857 17h.714C6.36 17 7 16.348 7 15.54v-5.204c0-.809-.64-1.461-1.429-1.461h-.714c-.128 0-.248.028-.371.045C5.703 5.965 8.613 3.883 12 3.882a8.161 8.161 0 0 1 7.516 5.004c-.125.016-.246-.011-.371-.011h-.715c-.79 0-1.43.652-1.43 1.46v5.204c0 .809.64 1.461 1.43 1.461h.714c.347 0 .675-.073.982-.188v.813c0 .862-.7 1.563-1.562 1.563h-4.325a1.867 1.867 0 0 0-1.614-.938h-1.25c-1.035 0-1.875.84-1.875 1.875 0 1.035.84 1.875 1.84 1.875h1.285c.692 0 1.29-.38 1.615-.938h4.322A3.441 3.441 0 0 0 22 17.625V12c-.18-5.348-4.41-10-10-10Zm-7.143 8.75h.268v4.375h-.268c-.541 0-.982-.504-.982-1.047V12c0-.094.01-.185.014-.279.038-.541.451-.971.968-.971Zm14.288 4.375h-.27V10.75h.268c.517 0 .93.431.968.971.002.095.014.185.014.279v2.08c0 .541-.441 1.045-.98 1.045Z",
        fill: "currentColor"
      }
    )
  })
);
var Headset_default = SvgHeadset;

// src/Icon/icons/Heart.tsx
import { jsx as jsx794 } from "react/jsx-runtime";
var SvgHeart = (props) => /* @__PURE__ */ jsx794(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx794(
      "path",
      {
        d: "m11.531 5.083.434.469.469-.468a5.683 5.683 0 0 1 4.902-1.56A5.582 5.582 0 0 1 22 9.032v.227a5.844 5.844 0 0 1-1.86 4.277l-7.058 6.59a1.585 1.585 0 0 1-2.164 0l-7.059-6.59A5.85 5.85 0 0 1 2 9.26v-.227c0-2.73 1.973-5.06 4.664-5.508a5.615 5.615 0 0 1 4.867 1.559c-.035 0 0 0 0 0Zm.434 3.121-1.758-1.828a3.79 3.79 0 0 0-3.234-1.002 3.71 3.71 0 0 0-3.098 3.658v.227c0 1.101.457 2.156 1.263 2.906L12 18.571l6.863-6.406a3.975 3.975 0 0 0 1.262-2.906v-.227a3.711 3.711 0 0 0-3.098-3.658 3.79 3.79 0 0 0-3.234 1.002l-1.828 1.828Z",
        fill: "currentColor"
      }
    )
  })
);
var Heart_default = SvgHeart;

// src/Icon/icons/HexagonCheck.tsx
import { jsx as jsx795 } from "react/jsx-runtime";
var SvgHexagonCheck = (props) => /* @__PURE__ */ jsx795(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx795(
      "path",
      {
        d: "M11.514 15.345a1.12 1.12 0 0 1-1.58 0L7.377 12.79a1.12 1.12 0 0 1 0-1.58 1.12 1.12 0 0 1 1.581 0l1.764 1.764 4.32-4.32a1.12 1.12 0 0 1 1.58 0 1.12 1.12 0 0 1 0 1.582l-5.11 5.11Zm-9.095-4.838 3.694-6.069a2.858 2.858 0 0 1 2.419-1.38h6.902c1.002 0 1.936.523 2.455 1.38l3.692 6.07a2.869 2.869 0 0 1 0 2.985l-3.692 6.067a2.87 2.87 0 0 1-2.455 1.381H8.532c-.966 0-1.9-.522-2.419-1.38l-3.694-6.068a2.869 2.869 0 0 1 0-2.986Zm1.637.994a.96.96 0 0 0 0 .998l3.694 6.067a.945.945 0 0 0 .782.46h6.902a.958.958 0 0 0 .818-.46l3.692-6.067a.955.955 0 0 0 0-.998l-3.692-6.067a.954.954 0 0 0-.818-.46H8.532c-.3 0-.61.175-.782.46l-3.694 6.067Zm13.833-7.063-1.637.996 1.637-.996Zm-15.47 9.055 1.637-.994-1.637.994Z",
        fill: "currentColor"
      }
    )
  })
);
var HexagonCheck_default = SvgHexagonCheck;

// src/Icon/icons/HexagonDivide.tsx
import { jsx as jsx796 } from "react/jsx-runtime";
var SvgHexagonDivide = (props) => /* @__PURE__ */ jsx796(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx796(
      "path",
      {
        d: "M10.688 8.168c0-.707.606-1.277 1.277-1.277.742 0 1.313.57 1.313 1.277s-.57 1.277-1.313 1.277c-.67 0-1.277-.57-1.277-1.277Zm4.825 2.874c.531 0 .958.427.958.958 0 .53-.427.958-.957.958H8.451c-.495 0-.958-.427-.958-.958 0-.53.463-.958.958-.958h7.062Zm-2.235 4.79c0 .707-.57 1.277-1.313 1.277-.67 0-1.277-.57-1.277-1.277s.606-1.277 1.277-1.277c.742 0 1.313.57 1.313 1.277ZM2.42 10.507l3.694-6.069a2.858 2.858 0 0 1 2.419-1.38h6.902c1.002 0 1.936.523 2.455 1.38l3.692 6.07a2.869 2.869 0 0 1 0 2.985l-3.692 6.067a2.87 2.87 0 0 1-2.455 1.381H8.532c-.966 0-1.9-.522-2.419-1.38l-3.694-6.068a2.869 2.869 0 0 1 0-2.986Zm1.637.994a.96.96 0 0 0 0 .998l3.694 6.067a.945.945 0 0 0 .782.46h6.902a.958.958 0 0 0 .818-.46l3.692-6.067a.955.955 0 0 0 0-.998l-3.692-6.067a.954.954 0 0 0-.818-.46H8.532c-.3 0-.61.175-.782.46l-3.694 6.067Zm13.833-7.063-1.637.996 1.637-.996Zm-15.47 9.055 1.637-.994-1.637.994Z",
        fill: "currentColor"
      }
    )
  })
);
var HexagonDivide_default = SvgHexagonDivide;

// src/Icon/icons/HexagonExclamation.tsx
import { jsx as jsx797 } from "react/jsx-runtime";
var SvgHexagonExclamation = (props) => /* @__PURE__ */ jsx797(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx797(
      "path",
      {
        d: "M11.965 6.89c.567 0 .994.428.994.959v4.47c0 .531-.427.958-.994.958-.495 0-.958-.427-.958-.958V7.85c0-.531.463-.958.958-.958Zm1.313 8.942c0 .707-.57 1.277-1.313 1.277-.67 0-1.277-.57-1.277-1.277s.606-1.277 1.277-1.277c.742 0 1.313.57 1.313 1.277ZM2.42 10.507l3.694-6.069a2.858 2.858 0 0 1 2.419-1.38h6.902c1.002 0 1.936.523 2.455 1.38l3.692 6.07a2.869 2.869 0 0 1 0 2.985l-3.692 6.067a2.87 2.87 0 0 1-2.455 1.381H8.532c-.966 0-1.9-.522-2.419-1.38l-3.694-6.068a2.869 2.869 0 0 1 0-2.986Zm1.637.994a.96.96 0 0 0 0 .998l3.694 6.067a.945.945 0 0 0 .782.46h6.902a.958.958 0 0 0 .818-.46l3.692-6.067a.955.955 0 0 0 0-.998l-3.692-6.067a.954.954 0 0 0-.818-.46H8.532c-.3 0-.61.175-.782.46l-3.694 6.067Zm13.833-7.063-1.637.996 1.637-.996Zm-15.47 9.055 1.637-.994-1.637.994Z",
        fill: "currentColor"
      }
    )
  })
);
var HexagonExclamation_default = SvgHexagonExclamation;

// src/Icon/icons/HexagonImage.tsx
import { jsx as jsx798 } from "react/jsx-runtime";
var SvgHexagonImage = (props) => /* @__PURE__ */ jsx798(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx798(
      "path",
      {
        d: "M11.035 8.102c0 .925-.72 1.61-1.61 1.61-.889 0-1.609-.685-1.609-1.61 0-.853.72-1.609 1.61-1.609.889 0 1.609.756 1.609 1.61ZM5.942 4.4a2.849 2.849 0 0 1 2.506-1.448h7.104c1.034 0 1.992.552 2.507 1.448l3.552 6.116c.519.933.519 2.036 0 2.896L18.059 19.6a2.89 2.89 0 0 1-2.507 1.448H8.448A2.846 2.846 0 0 1 5.942 19.6l-3.554-6.188c-.517-.86-.517-1.963 0-2.896L5.942 4.4ZM5.78 15.464l2.289-2.506a.97.97 0 0 1 .7-.314.957.957 0 0 1 .708.298l1.565 1.633 2.88-3.468a.96.96 0 0 1 1.485 0l3.141 3.782 1.392-2.442c.17-.261.17-.632 0-.965L16.39 5.366a.966.966 0 0 0-.837-.483H8.448a.966.966 0 0 0-.837.483l-3.55 6.116c-.173.333-.173.704 0 .965l1.72 3.017Z",
        fill: "currentColor"
      }
    )
  })
);
var HexagonImage_default = SvgHexagonImage;

// src/Icon/icons/HexagonMinus.tsx
import { jsx as jsx799 } from "react/jsx-runtime";
var SvgHexagonMinus = (props) => /* @__PURE__ */ jsx799(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx799(
      "path",
      {
        d: "M15.514 11.042c.53 0 .957.427.957.958 0 .53-.427.958-.957.958H8.451c-.495 0-.958-.427-.958-.958 0-.53.463-.958.958-.958h7.062Zm-13.095-.535 3.694-6.069a2.858 2.858 0 0 1 2.419-1.38h6.902c1.002 0 1.936.523 2.455 1.38l3.692 6.07a2.869 2.869 0 0 1 0 2.985l-3.692 6.067a2.87 2.87 0 0 1-2.455 1.381H8.532c-.966 0-1.9-.522-2.419-1.38l-3.694-6.068a2.869 2.869 0 0 1 0-2.986Zm1.637.994a.96.96 0 0 0 0 .998l3.694 6.067a.945.945 0 0 0 .782.46h6.902a.958.958 0 0 0 .818-.46l3.692-6.067a.955.955 0 0 0 0-.998l-3.692-6.067a.954.954 0 0 0-.818-.46H8.532c-.3 0-.61.175-.782.46l-3.694 6.067Zm13.833-7.063-1.637.996 1.637-.996Zm-15.47 9.055 1.637-.994-1.637.994Z",
        fill: "currentColor"
      }
    )
  })
);
var HexagonMinus_default = SvgHexagonMinus;

// src/Icon/icons/HexagonPlus.tsx
import { jsx as jsx800 } from "react/jsx-runtime";
var SvgHexagonPlus = (props) => /* @__PURE__ */ jsx800(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx800(
      "path",
      {
        d: "M11.007 15.513v-2.555H8.452c-.495 0-.958-.427-.958-.958 0-.53.463-.958.958-.958h2.555V8.487c0-.53.463-.958.958-.958.567 0 .994.427.994.958v2.555h2.555c.53 0 .957.427.957.958 0 .53-.427.958-.957.958h-2.555v2.555c0 .53-.427.958-.994.958-.495 0-.958-.427-.958-.958Zm-8.588-5.006 3.694-6.069a2.858 2.858 0 0 1 2.419-1.38h6.902c1.002 0 1.936.523 2.455 1.38l3.692 6.07a2.869 2.869 0 0 1 0 2.985l-3.692 6.067a2.87 2.87 0 0 1-2.455 1.381H8.532c-.966 0-1.9-.522-2.419-1.38l-3.694-6.068a2.869 2.869 0 0 1 0-2.986Zm1.637.994a.96.96 0 0 0 0 .998l3.694 6.067a.945.945 0 0 0 .782.46h6.902a.958.958 0 0 0 .818-.46l3.692-6.067a.955.955 0 0 0 0-.998l-3.692-6.067a.954.954 0 0 0-.818-.46H8.532c-.3 0-.61.175-.782.46l-3.694 6.067Zm13.833-7.063-1.637.996 1.637-.996Zm-15.47 9.055 1.637-.994-1.637.994Z",
        fill: "currentColor"
      }
    )
  })
);
var HexagonPlus_default = SvgHexagonPlus;

// src/Icon/icons/HexagonXmark.tsx
import { jsx as jsx801 } from "react/jsx-runtime";
var SvgHexagonXmark = (props) => /* @__PURE__ */ jsx801(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx801(
      "path",
      {
        d: "M8.767 8.767c.376-.372.982-.372 1.322 0l1.876 1.88 1.912-1.88c.375-.372.982-.372 1.321 0 .407.375.407.982 0 1.321l-1.844 1.876 1.844 1.912c.407.375.407.982 0 1.321-.34.408-.946.408-1.321 0l-1.912-1.844-1.876 1.844c-.34.408-.946.408-1.322 0-.37-.339-.37-.946 0-1.32l1.88-1.913-1.88-1.876c-.37-.34-.37-.946 0-1.321Zm-6.348 1.74 3.694-6.069a2.858 2.858 0 0 1 2.419-1.38h6.902c1.002 0 1.936.523 2.455 1.38l3.692 6.07a2.869 2.869 0 0 1 0 2.985l-3.692 6.067a2.87 2.87 0 0 1-2.455 1.381H8.532c-.966 0-1.9-.522-2.419-1.38l-3.694-6.068a2.869 2.869 0 0 1 0-2.986Zm1.637.994a.96.96 0 0 0 0 .998l3.694 6.067a.945.945 0 0 0 .782.46h6.902a.958.958 0 0 0 .818-.46l3.692-6.067a.955.955 0 0 0 0-.998l-3.692-6.067a.954.954 0 0 0-.818-.46H8.532c-.3 0-.61.175-.782.46l-3.694 6.067Zm13.833-7.063-1.637.996 1.637-.996Zm-15.47 9.055 1.637-.994-1.637.994Z",
        fill: "currentColor"
      }
    )
  })
);
var HexagonXmark_default = SvgHexagonXmark;

// src/Icon/icons/Hexagon.tsx
import { jsx as jsx802 } from "react/jsx-runtime";
var SvgHexagon = (props) => /* @__PURE__ */ jsx802(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx802(
      "path",
      {
        d: "m2.42 10.507 3.693-6.069a2.858 2.858 0 0 1 2.419-1.38h6.902c1.002 0 1.936.523 2.455 1.38l3.692 6.07a2.869 2.869 0 0 1 0 2.985l-3.692 6.067a2.87 2.87 0 0 1-2.455 1.381H8.532c-.966 0-1.9-.522-2.419-1.38l-3.694-6.068a2.869 2.869 0 0 1 0-2.986Zm1.636.994a.96.96 0 0 0 0 .998l3.694 6.067a.945.945 0 0 0 .782.46h6.902a.958.958 0 0 0 .818-.46l3.692-6.067a.955.955 0 0 0 0-.998l-3.692-6.067a.954.954 0 0 0-.818-.46H8.532c-.3 0-.61.175-.782.46l-3.694 6.067Zm13.833-7.063-1.637.996 1.637-.996Zm-15.47 9.055 1.637-.994-1.637.994Z",
        fill: "currentColor"
      }
    )
  })
);
var Hexagon_default = SvgHexagon;

// src/Icon/icons/HighlighterLine.tsx
import { jsx as jsx803 } from "react/jsx-runtime";
var SvgHighlighterLine = (props) => /* @__PURE__ */ jsx803(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx803(
      "path",
      {
        d: "M12.535 17.556h-1.667l-1.517 1.517c-.403.371-.903.49-1.375.35l-1.14 1.14a1.11 1.11 0 0 1-.784.326h-2.94A1.11 1.11 0 0 1 2 19.778v-.163c0-.296.117-.577.325-.785l2.528-2.528a1.391 1.391 0 0 1 .352-1.375L6.69 13.41v-1.667c0-.535.288-1.038.726-1.354l9.646-6.924a1.882 1.882 0 0 1 2.434.199l1.118 1.117c.354.353.52.834.52 1.334 0 .395-.093.75-.323 1.1L13.89 16.83a1.62 1.62 0 0 1-1.354.726ZM6.58 15.91l1.788 1.788 1.81-1.81h2.357l.559-.78-3.924-3.924-.812.56V14.1L6.58 15.91Zm7.5-2.205 5.378-7.462c.028-.037.01-.082.01-.128 0-.058.008-.115-.034-.156l-1.146-1.117c-.01-.04-.066-.064-.125-.064a.225.225 0 0 0-.128.041l-7.493 5.379 3.538 3.507Zm-9.79 5.517h1.533l.854-.857-.764-.764-1.623 1.621Zm16.877 0c.461 0 .833.372.833.834a.831.831 0 0 1-.833.833H10.61a.831.831 0 0 1-.833-.833c0-.462.371-.834.833-.834h10.556Z",
        fill: "currentColor"
      }
    )
  })
);
var HighlighterLine_default = SvgHighlighterLine;

// src/Icon/icons/Highlighter.tsx
import { jsx as jsx804 } from "react/jsx-runtime";
var SvgHighlighter = (props) => /* @__PURE__ */ jsx804(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx804(
      "path",
      {
        d: "M9.683 19.392c-.421.389-.944.512-1.437.367l-1.19 1.19a1.16 1.16 0 0 1-.82.341H3.16A1.16 1.16 0 0 1 2 20.13v-.171c0-.309.122-.603.34-.82l2.642-2.642a1.453 1.453 0 0 1 .368-1.438l1.553-1.586v-1.742c0-.558.301-1.085.758-1.415L17.743 3.08a1.967 1.967 0 0 1 2.544.207l1.169 1.167c.37.37.544.872.544 1.395 0 .413-.098.784-.337 1.15l-7.237 10.05c-.33.489-.856.758-1.415.758h-1.742l-1.586 1.585Zm-1.038-5.196-1.858 1.89 1.869 1.87 1.89-1.891h2.465l.584-.817-4.1-4.1-.85.583v2.465Zm11.613-8.347c0-.06.007-.12-.036-.163L19.024 4.52c-.01-.043-.069-.068-.13-.068a.235.235 0 0 0-.135.044l-7.831 5.622 3.698 3.665 5.621-7.799c.03-.039.011-.086.011-.134ZM6.888 18.652l-.798-.798-1.697 1.695h1.603l.892-.897Z",
        fill: "currentColor"
      }
    )
  })
);
var Highlighter_default = SvgHighlighter;

// src/Icon/icons/HorizontalRule.tsx
import { jsx as jsx805 } from "react/jsx-runtime";
var SvgHorizontalRule = (props) => /* @__PURE__ */ jsx805(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx805(
      "path",
      {
        d: "M21.25 12.75H2.75a.75.75 0 1 1 0-1.5h18.5a.75.75 0 1 1 0 1.5Z",
        fill: "currentColor"
      }
    )
  })
);
var HorizontalRule_default = SvgHorizontalRule;

// src/Icon/icons/HouseBlank.tsx
import { jsx as jsx806 } from "react/jsx-runtime";
var SvgHouseBlank = (props) => /* @__PURE__ */ jsx806(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx806(
      "path",
      {
        d: "M11.462 3.309a.83.83 0 0 1 1.076 0l9.167 7.778a.832.832 0 1 1-1.076 1.27l-.851-.722v6.476A2.777 2.777 0 0 1 17 20.89H7a2.777 2.777 0 0 1-2.778-2.778v-6.476l-.85.723a.833.833 0 0 1-1.078-1.271l9.168-7.778Zm-5.573 6.913v7.89A1.11 1.11 0 0 0 7 19.221h10a1.11 1.11 0 0 0 1.111-1.11v-7.89l-6.11-5.185-6.112 5.185Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseBlank_default = SvgHouseBlank;

// src/Icon/icons/HouseBuilding.tsx
import { jsx as jsx807 } from "react/jsx-runtime";
var SvgHouseBuilding = (props) => /* @__PURE__ */ jsx807(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx807(
      "path",
      {
        d: "M12.5 6v3.269L11 7.894V6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v12c0 1.103-.897 2-2 2h-5.5a2.5 2.5 0 0 0 .5-1.5h5c.275 0 .5-.225.5-.5V6a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5Zm2.412 6a2.527 2.527 0 0 0-.721-1.184L14 10.644V10.5c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-.588ZM15 15v-2h.5c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5H15Zm2-4.5c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1Zm1.5 2.5c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1c0-.275.225-.5.5-.5h1Zm-3-6c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1c0-.275.225-.5.5-.5h1Zm1.5.5c0-.275.225-.5.5-.5h1c.275 0 .5.225.5.5v1c0 .275-.225.5-.5.5h-1a.501.501 0 0 1-.5-.5v-1ZM6.5 13.25c0-.416.334-.75.75-.75h1.5c.416 0 .75.334.75.75v1.5c0 .416-.334.75-.75.75h-1.5a.748.748 0 0 1-.75-.75v-1.5Zm.15-5.513c.762-.7 1.938-.7 2.7 0l4 3.641c.416.406.65.94.65 1.503V18c0 1.103-.897 2-2 2H4a2 2 0 0 1-2-2v-5.119c0-.562.235-1.097.648-1.503l4.002-3.64ZM3.5 12.881V18a.5.5 0 0 0 .5.5h8c.275 0 .5-.225.5-.5v-5.119a.5.5 0 0 0-.162-.369l-4-3.668a.5.5 0 0 0-.675 0l-4 3.668a.498.498 0 0 0-.163.37Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseBuilding_default = SvgHouseBuilding;

// src/Icon/icons/HouseChimneyBlank.tsx
import { jsx as jsx808 } from "react/jsx-runtime";
var SvgHouseChimneyBlank = (props) => /* @__PURE__ */ jsx808(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx808(
      "path",
      {
        d: "M18.111 8.038V5.056c0-.46.372-.865.834-.865.461 0 .833.404.833.865V9.45l1.927 1.636a.832.832 0 1 1-1.076 1.27l-.851-.722v6.476A2.777 2.777 0 0 1 17 20.89H7a2.777 2.777 0 0 1-2.778-2.778v-6.476l-.85.723a.833.833 0 0 1-1.078-1.271l9.168-7.778a.83.83 0 0 1 1.076 0l5.573 4.73ZM7 19.222h10a1.11 1.11 0 0 0 1.111-1.11v-7.89l-6.11-5.185-6.112 5.185v7.89A1.11 1.11 0 0 0 7 19.221Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseChimneyBlank_default = SvgHouseChimneyBlank;

// src/Icon/icons/HouseChimneyCrack.tsx
import { jsx as jsx809 } from "react/jsx-runtime";
var SvgHouseChimneyCrack = (props) => /* @__PURE__ */ jsx809(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx809(
      "path",
      {
        d: "M11.462 3.309a.83.83 0 0 1 1.076 0l5.573 4.73V5.055c0-.46.372-.865.834-.865.461 0 .833.404.833.865V9.45l1.927 1.636a.832.832 0 1 1-1.076 1.27l-.851-.722v6.476A2.777 2.777 0 0 1 17 20.89H7a2.777 2.777 0 0 1-2.778-2.778v-6.476l-.85.723a.833.833 0 0 1-1.078-1.271l9.168-7.778Zm-5.573 6.913v7.89A1.11 1.11 0 0 0 7 19.221h2.983l-1.052-1.67c-.15-.24-.098-.583.125-.73L12 14.487l-2.017-2.642c-.393-.514.257-1.17.774-.813l4 3.025c.292.218.267.652.01.878L12 17.132l1.316 2.09H17a1.11 1.11 0 0 0 1.111-1.11v-7.89l-6.11-5.185-6.112 5.185Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseChimneyCrack_default = SvgHouseChimneyCrack;

// src/Icon/icons/HouseChimneyUser.tsx
import { jsx as jsx810 } from "react/jsx-runtime";
var SvgHouseChimneyUser = (props) => /* @__PURE__ */ jsx810(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx810(
      "path",
      {
        d: "M9.778 10.889c0-1.226.996-2.222 2.222-2.222s2.222.996 2.222 2.222A2.224 2.224 0 0 1 12 13.11a2.224 2.224 0 0 1-2.222-2.222ZM8.11 17a2.777 2.777 0 0 1 2.778-2.778h2.222A2.777 2.777 0 0 1 15.89 17c0 .306-.25.556-.556.556H8.667A.557.557 0 0 1 8.11 17Zm10-8.962V5.056c0-.46.372-.865.834-.865.461 0 .833.404.833.865V9.45l1.927 1.636a.832.832 0 1 1-1.076 1.27l-.851-.722v6.476A2.777 2.777 0 0 1 17 20.89H7a2.777 2.777 0 0 1-2.778-2.778v-6.476l-.85.723a.833.833 0 0 1-1.078-1.271l9.168-7.778a.83.83 0 0 1 1.076 0l5.573 4.73ZM7 19.222h10a1.11 1.11 0 0 0 1.111-1.11v-7.89l-6.11-5.185-6.112 5.185v7.89A1.11 1.11 0 0 0 7 19.221Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseChimneyUser_default = SvgHouseChimneyUser;

// src/Icon/icons/HouseChimneyWindow.tsx
import { jsx as jsx811 } from "react/jsx-runtime";
var SvgHouseChimneyWindow = (props) => /* @__PURE__ */ jsx811(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx811(
      "path",
      {
        d: "M9.222 10.611c0-.767.622-1.389 1.39-1.389h2.777c.767 0 1.389.622 1.389 1.39v2.777c0 .767-.622 1.389-1.389 1.389h-2.778a1.389 1.389 0 0 1-1.389-1.39v-2.777Zm3.89 2.5V10.89h-2.223v2.222h2.222Zm-1.65-9.802a.83.83 0 0 1 1.076 0l5.573 4.73V5.055c0-.46.372-.865.834-.865.461 0 .833.404.833.865V9.45l1.927 1.636a.832.832 0 1 1-1.076 1.27l-.851-.722v6.476A2.777 2.777 0 0 1 17 20.89H7a2.777 2.777 0 0 1-2.778-2.778v-6.476l-.85.723a.833.833 0 0 1-1.078-1.271l9.168-7.778Zm-5.573 6.913v7.89A1.11 1.11 0 0 0 7 19.221h10a1.11 1.11 0 0 0 1.111-1.11v-7.89l-6.11-5.185-6.112 5.185Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseChimneyWindow_default = SvgHouseChimneyWindow;

// src/Icon/icons/HouseChimney.tsx
import { jsx as jsx812 } from "react/jsx-runtime";
var SvgHouseChimney = (props) => /* @__PURE__ */ jsx812(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx812(
      "path",
      {
        d: "M11.462 3.309a.83.83 0 0 1 1.076 0l5.573 4.73V5.055c0-.46.372-.865.834-.865.461 0 .833.404.833.865V9.45l1.927 1.636a.832.832 0 1 1-1.076 1.27l-.851-.722v6.476A2.777 2.777 0 0 1 17 20.89H7a2.777 2.777 0 0 1-2.778-2.778v-6.476l-.85.723a.833.833 0 0 1-1.078-1.271l9.168-7.778Zm-5.573 6.913v7.89A1.11 1.11 0 0 0 7 19.221h1.667v-5.278c0-.767.621-1.389 1.389-1.389h3.889c.767 0 1.388.622 1.388 1.39v5.277H17a1.11 1.11 0 0 0 1.111-1.11v-7.89l-6.11-5.185-6.112 5.185Zm4.444 4v5h3.334v-5h-3.334Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseChimney_default = SvgHouseChimney;

// src/Icon/icons/HouseCircleCheck.tsx
import { jsx as jsx813 } from "react/jsx-runtime";
var SvgHouseCircleCheck = (props) => /* @__PURE__ */ jsx813(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx813(
      "path",
      {
        d: "M10.516 4.178a.748.748 0 0 1 .968 0l6.957 5.903a5.476 5.476 0 0 0-2.232.072L11 5.733 5.5 10.4v7.1c0 .553.447 1 1 1H8v-4.75c0-.69.56-1.25 1.25-1.25h3.5c.047 0 .09.003.134.006-.296.457-.525.96-.678 1.494H9.5v4.5h3.39a5.51 5.51 0 0 0 1.447 1.5H6.5A2.5 2.5 0 0 1 4 17.5v-5.828l-.765.65a.75.75 0 0 1-.97-1.144l8.25-7ZM22 15.5a4.501 4.501 0 0 1-9 0 4.501 4.501 0 0 1 9 0Zm-3.103-1.353L17 16.044l-.897-.897a.496.496 0 0 0-.706 0 .496.496 0 0 0 0 .706l1.25 1.25a.496.496 0 0 0 .706 0l2.25-2.25a.496.496 0 0 0 0-.706.496.496 0 0 0-.706 0Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseCircleCheck_default = SvgHouseCircleCheck;

// src/Icon/icons/HouseCircleExclamation.tsx
import { jsx as jsx814 } from "react/jsx-runtime";
var SvgHouseCircleExclamation = (props) => /* @__PURE__ */ jsx814(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx814(
      "path",
      {
        d: "M10.516 4.178a.748.748 0 0 1 .968 0l6.957 5.903a5.476 5.476 0 0 0-2.232.072L11 5.733 5.5 10.4v7.1c0 .553.447 1 1 1H8v-4.75c0-.69.56-1.25 1.25-1.25h3.5c.047 0 .09.003.134.006-.296.457-.525.96-.678 1.494H9.5v4.5h3.39a5.51 5.51 0 0 0 1.447 1.5H6.5A2.5 2.5 0 0 1 4 17.5v-5.828l-.765.65a.75.75 0 0 1-.97-1.144l8.25-7ZM13 15.5a4.501 4.501 0 0 1 9 0 4.501 4.501 0 0 1-9 0Zm4.5 3c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75c0 .416.334.75.75.75Zm-.528-5.5v2.5c0 .275.253.5.5.5.303 0 .5-.225.5-.5V13c0-.275-.197-.5-.5-.5a.52.52 0 0 0-.5.5Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseCircleExclamation_default = SvgHouseCircleExclamation;

// src/Icon/icons/HouseCircleXmark.tsx
import { jsx as jsx815 } from "react/jsx-runtime";
var SvgHouseCircleXmark = (props) => /* @__PURE__ */ jsx815(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx815(
      "path",
      {
        d: "M10.516 4.178a.748.748 0 0 1 .968 0l6.957 5.903a5.476 5.476 0 0 0-2.232.072L11 5.733 5.5 10.4v7.1c0 .553.447 1 1 1H8v-4.75c0-.69.56-1.25 1.25-1.25h3.5c.047 0 .09.003.134.006-.296.457-.525.96-.678 1.494H9.5v4.5h3.39a5.51 5.51 0 0 0 1.447 1.5H6.5A2.5 2.5 0 0 1 4 17.5v-5.828l-.765.65a.75.75 0 0 1-.97-1.144l8.25-7ZM13 15.5a4.501 4.501 0 0 1 9 0 4.501 4.501 0 0 1-9 0Zm5.206 0 1.147-1.147a.496.496 0 0 0 0-.706.496.496 0 0 0-.706 0L17.5 14.794l-1.147-1.147a.496.496 0 0 0-.706 0 .496.496 0 0 0 0 .706l1.147 1.147-1.147 1.147a.496.496 0 0 0 0 .706.496.496 0 0 0 .706 0l1.147-1.147 1.147 1.147a.496.496 0 0 0 .706 0 .496.496 0 0 0 0-.706L18.206 15.5Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseCircleXmark_default = SvgHouseCircleXmark;

// src/Icon/icons/HouseCrack.tsx
import { jsx as jsx816 } from "react/jsx-runtime";
var SvgHouseCrack = (props) => /* @__PURE__ */ jsx816(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx816(
      "path",
      {
        d: "M21.705 11.087a.832.832 0 1 1-1.076 1.27l-.851-.722v6.476A2.777 2.777 0 0 1 17 20.89H7a2.777 2.777 0 0 1-2.778-2.778v-6.476l-.85.723a.833.833 0 0 1-1.078-1.271l9.168-7.778a.83.83 0 0 1 1.076 0l9.167 7.778ZM7 19.222h2.983l-1.052-1.67c-.15-.24-.098-.583.125-.73L12 14.487l-2.017-2.642c-.393-.514.257-1.17.774-.813l4 3.025c.292.218.267.652.01.878L12 17.132l1.316 2.09H17a1.11 1.11 0 0 0 1.111-1.11v-7.89l-6.11-5.185-6.112 5.185v7.89A1.11 1.11 0 0 0 7 19.221Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseCrack_default = SvgHouseCrack;

// src/Icon/icons/HouseDay.tsx
import { jsx as jsx817 } from "react/jsx-runtime";
var SvgHouseDay = (props) => /* @__PURE__ */ jsx817(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx817(
      "path",
      {
        d: "m8.306 5.86 1.738-.522a.505.505 0 0 1 .5.126c.128.13.178.321.125.497L10.147 7.7l.987.534-1.706 1.391A2.504 2.504 0 0 0 7 6.526a2.5 2.5 0 0 0 0 4.999h.097l-1.203.978-.194-.356-1.74.522a.503.503 0 0 1-.622-.625l.522-1.738-1.6-.862A.516.516 0 0 1 2 8.972c0-.156.099-.322.26-.41l1.6-.862-.522-1.739a.5.5 0 0 1 .623-.623L5.7 5.86l.862-1.6a.503.503 0 0 1 .881 0l.863 1.6ZM8.5 8.972c0 .856-.672 1.5-1.5 1.5s-1.5-.644-1.5-1.5c0-.8.672-1.5 1.5-1.5s1.5.7 1.5 1.5Zm4.5 4.75c0-.388.334-.75.75-.75h1.5c.416 0 .75.362.75.75v1.528c0 .416-.334.75-.75.75h-1.5a.748.748 0 0 1-.75-.75v-1.528Zm8.725-1.053c.184.15.278.36.275.581a.78.78 0 0 1-.169.475c-.262.319-.734.34-1.056.106L20 13.2v5.05c0 .966-.784 1.75-1.75 1.75h-7.5C9.784 20 9 19.216 9 18.25V13.2l-.775.631c-.322.235-.794.213-1.056-.106-.113-.137-.166-.362-.169-.525-.003-.222.09-.381.275-.531l6.75-5.5a.753.753 0 0 1 .95 0l6.75 5.5Zm-3.225-.69-4-3.288-4 3.287v6.272c0 .137.113.25.25.25h7.5a.25.25 0 0 0 .25-.25v-6.272Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseDay_default = SvgHouseDay;

// src/Icon/icons/HouseLaptop.tsx
import { jsx as jsx818 } from "react/jsx-runtime";
var SvgHouseLaptop = (props) => /* @__PURE__ */ jsx818(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx818(
      "path",
      {
        d: "M9.025 4.169a.754.754 0 0 1 .95 0l6.75 5.5c.319.262.34.734.106 1.056-.262.319-.734.34-1.056.106L15 10.2v1.3h-1.5V8.978l-4-3.26-4 3.26v6.272c0 .137.112.25.25.25h4.75V17H5.75A1.75 1.75 0 0 1 4 15.25V10.2l-.776.631c-.321.235-.794.213-1.055-.106a.751.751 0 0 1 .107-1.056l6.749-5.5ZM11 10.75v1.428c-.216.213-.331.466-.416.744a.742.742 0 0 1-.334.078h-1.5a.748.748 0 0 1-.75-.75v-1.5c0-.416.334-.75.75-.75h1.5c.416 0 .75.334.75.75Zm1.5 1.75h7c.553 0 1 .447 1 1v5h1.125c.206 0 .375.169.375.375 0 .622-.503 1.125-1.125 1.125h-9.75A1.124 1.124 0 0 1 10 18.875c0-.206.169-.375.375-.375H11.5v-5c0-.553.447-1 1-1ZM13 14v4.5h6V14h-6Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseLaptop_default = SvgHouseLaptop;

// src/Icon/icons/HouseLock.tsx
import { jsx as jsx819 } from "react/jsx-runtime";
var SvgHouseLock = (props) => /* @__PURE__ */ jsx819(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx819(
      "path",
      {
        d: "M17.381 9.181a3.52 3.52 0 0 0-1.34.828L11 5.733 5.5 10.4v7.1c0 .553.447 1 1 1H8v-4.75c0-.69.56-1.25 1.25-1.25h3.5c.69 0 1.25.56 1.25 1.25V19c0 .366.097.706.269 1H6.5A2.5 2.5 0 0 1 4 17.5v-5.828l-.765.65a.75.75 0 0 1-.97-1.144l8.25-7a.748.748 0 0 1 .97 0l5.896 5.003ZM12.5 18.5v-4.528h-3V18.5h3Zm6-8.528c1.381 0 2.5 1.147 2.5 2.5v1.5c.553 0 1 .475 1 1.028v4c0 .553-.447 1-1 1h-5c-.553 0-1-.447-1-1v-4c0-.553.447-1.028 1-1.028v-1.5c0-1.353 1.119-2.5 2.5-2.5Zm0 1.5c-.553 0-1 .475-1 1v1.5h2v-1.5c0-.525-.447-1-1-1Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseLock_default = SvgHouseLock;

// src/Icon/icons/HouseUser.tsx
import { jsx as jsx820 } from "react/jsx-runtime";
var SvgHouseUser = (props) => /* @__PURE__ */ jsx820(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx820(
      "path",
      {
        d: "M14.222 10.889A2.224 2.224 0 0 1 12 13.11a2.224 2.224 0 0 1-2.222-2.222c0-1.226.996-2.222 2.222-2.222s2.222.996 2.222 2.222Zm-1.11 3.333A2.777 2.777 0 0 1 15.888 17c0 .306-.25.556-.556.556H8.667A.557.557 0 0 1 8.11 17a2.777 2.777 0 0 1 2.778-2.778h2.222ZM11.461 3.31a.83.83 0 0 1 1.076 0l9.167 7.778a.832.832 0 1 1-1.076 1.27l-.851-.722v6.476A2.777 2.777 0 0 1 17 20.89H7a2.777 2.777 0 0 1-2.778-2.778v-6.476l-.85.723a.833.833 0 0 1-1.078-1.271l9.168-7.778Zm-5.573 6.913v7.89A1.11 1.11 0 0 0 7 19.221h10a1.11 1.11 0 0 0 1.111-1.11v-7.89l-6.11-5.185-6.112 5.185Z",
        fill: "currentColor"
      }
    )
  })
);
var HouseUser_default = SvgHouseUser;

// src/Icon/icons/House.tsx
import { jsx as jsx821 } from "react/jsx-runtime";
var SvgHouse = (props) => /* @__PURE__ */ jsx821(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx821(
      "path",
      {
        d: "M21.705 11.087a.832.832 0 1 1-1.076 1.27l-.851-.722v6.476A2.777 2.777 0 0 1 17 20.89H7a2.777 2.777 0 0 1-2.778-2.778v-6.476l-.85.723a.833.833 0 0 1-1.078-1.271l9.168-7.778a.83.83 0 0 1 1.076 0l9.167 7.778ZM7 19.222h1.667v-5.278c0-.767.621-1.388 1.389-1.388h3.889c.767 0 1.388.621 1.388 1.389v5.277H17a1.11 1.11 0 0 0 1.111-1.11v-7.89l-6.11-5.185-6.112 5.185v7.89A1.11 1.11 0 0 0 7 19.221Zm3.333 0h3.334v-5h-3.334v5Z",
        fill: "currentColor"
      }
    )
  })
);
var House_default = SvgHouse;

// src/Icon/icons/Hyphen.tsx
import { jsx as jsx822 } from "react/jsx-runtime";
var SvgHyphen = (props) => /* @__PURE__ */ jsx822(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx822(
      "path",
      {
        d: "M22 12c0 .831-.669 1.5-1.5 1.5h-17c-.828 0-1.5-.669-1.5-1.5 0-.825.672-1.5 1.5-1.5h17A1.5 1.5 0 0 1 22 12Z",
        fill: "currentColor"
      }
    )
  })
);
var Hyphen_default = SvgHyphen;

// src/Icon/icons/ICursor.tsx
import { jsx as jsx823 } from "react/jsx-runtime";
var SvgICursor = (props) => /* @__PURE__ */ jsx823(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx823(
      "path",
      {
        d: "M17 21.063c0 .517-.42.937-.938.937A4.987 4.987 0 0 1 12 19.894 4.985 4.985 0 0 1 7.937 22a.937.937 0 1 1 0-1.875A3.128 3.128 0 0 0 11.063 17v-4.063h-1.25a.937.937 0 1 1 0-1.874h1.25V7a3.128 3.128 0 0 0-3.124-3.125.938.938 0 0 1 0-1.875c1.676 0 3.156.836 4.062 2.106A4.987 4.987 0 0 1 16.063 2a.937.937 0 1 1 0 1.875A3.128 3.128 0 0 0 12.938 7v4.063h1.25a.938.938 0 0 1 0 1.874h-1.25V17a3.128 3.128 0 0 0 3.124 3.125c.52 0 .938.422.938.938Z",
        fill: "currentColor"
      }
    )
  })
);
var ICursor_default = SvgICursor;

// src/Icon/icons/I.tsx
import { jsx as jsx824 } from "react/jsx-runtime";
var SvgI = (props) => /* @__PURE__ */ jsx824(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx824(
      "path",
      {
        d: "M19.143 20.929c0 .591-.48 1.071-1.072 1.071H5.93a1.07 1.07 0 1 1 0-2.143h5V4.143h-5a1.072 1.072 0 0 1 0-2.143H18.07a1.07 1.07 0 1 1 0 2.143h-5v15.714h5c.594 0 1.072.482 1.072 1.072Z",
        fill: "currentColor"
      }
    )
  })
);
var I_default = SvgI;

// src/Icon/icons/Icons.tsx
import { jsx as jsx825 } from "react/jsx-runtime";
var SvgIcons = (props) => /* @__PURE__ */ jsx825(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx825(
      "path",
      {
        d: "M3.125 2.69c1.148-.964 2.768-.86 3.84-.047 1.14-.817 2.746-.91 3.914.038l.012.011a3.1 3.1 0 0 1 .203 4.566l-3.07 3.078c-.551.535-1.477.575-2.051-.015L2.906 7.262l-.001-.004C1.632 5.95 1.7 3.873 3.125 2.69Zm1.2 1.44a1.216 1.216 0 0 0-.094 1.804l2.777 2.77 2.758-2.77c.504-.5.476-1.33-.075-1.802-.476-.38-1.226-.337-1.714.132l-.953 1.02-.996-1.012c-.497-.486-1.263-.512-1.698-.146l-.005.005ZM22 8.84c0 1.07-1.121 1.875-2.5 1.875-1.38 0-2.5-.804-2.5-1.875 0-1 1.12-1.875 2.5-1.875.215 0 .426.055.625.094V4.081l-4.375.875v5.134c0 1.07-1.121 1.875-2.5 1.875s-2.5-.804-2.5-1.875c0-1 1.121-1.875 2.5-1.875.215 0 .426.055.625.094V4.153c0-.412.316-.797.754-.884l6.25-1.25a.935.935 0 0 1 .777.194.918.918 0 0 1 .344.69V8.84ZM9.5 17.313a1.875 1.875 0 1 1-3.75-.001 1.875 1.875 0 0 1 3.75 0Zm3.75-1.563v3.75c0 1.379-1.121 2.5-2.5 2.5H4.5C3.12 22 2 20.879 2 19.5v-3.75c0-1.379 1.12-2.5 2.465-2.5l.315-.558c.212-.426.644-.727 1.118-.727h3.454c.472 0 .906.3 1.117.727l.281.558c1.379 0 2.5 1.121 2.5 2.5Zm-7.591-.625H4.465c-.31 0-.59.281-.59.625v3.75c0 .344.28.625.625.625h6.25a.627.627 0 0 0 .625-.625v-3.75a.627.627 0 0 0-.625-.625H9.59l-.625-1.285h-2.68l-.626 1.285Zm14.833-3.004a.62.62 0 0 1 .207.75l-1.5 3.504h2.176c.261 0 .492.16.55.406a.556.556 0 0 1-.14.688l-5 4.375c-.219.16-.543.207-.777.035a.625.625 0 0 1-.207-.75l1.5-3.504h-2.176a.624.624 0 0 1-.586-.406.69.69 0 0 1 .176-.723l5-4.375a.669.669 0 0 1 .777 0Z",
        fill: "currentColor"
      }
    )
  })
);
var Icons_default = SvgIcons;

// src/Icon/icons/IdBadge.tsx
import { jsx as jsx826 } from "react/jsx-runtime";
var SvgIdBadge = (props) => /* @__PURE__ */ jsx826(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx826(
      "path",
      {
        d: "M17 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10a2.5 2.5 0 0 0 2.5-2.5v-15C19.5 3.12 18.379 2 17 2Zm.625 17.5c0 .345-.28.625-.625.625H7a.625.625 0 0 1-.625-.625v-15c0-.345.28-.625.625-.625h2.5V4.5c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25v-.625H17c.345 0 .625.28.625.625v15ZM12 13.25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm1.25 1.25h-2.5a3.125 3.125 0 0 0-3.125 3.125c0 .344.28.625.625.625h7.5c.345 0 .625-.28.625-.625A3.124 3.124 0 0 0 13.25 14.5Z",
        fill: "currentColor"
      }
    )
  })
);
var IdBadge_default = SvgIdBadge;

// src/Icon/icons/IdCardClip.tsx
import { jsx as jsx827 } from "react/jsx-runtime";
var SvgIdCardClip = (props) => /* @__PURE__ */ jsx827(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx827(
      "path",
      {
        d: "M10.889 7.556h2.222c.614 0 1.111-.498 1.111-1.112V4.222c0-.613-.497-1.11-1.11-1.11h-2.223a1.11 1.11 0 0 0-1.111 1.11v2.222a1.11 1.11 0 0 0 1.11 1.112ZM12 13.666a2.222 2.222 0 1 0 0-4.443 2.222 2.222 0 0 0 0 4.444Zm7.778-8.333h-4.445V7h4.445c.306 0 .555.25.555.556v11.11c0 .307-.249.556-.555.556H4.222a.556.556 0 0 1-.555-.555V7.556c0-.307.249-.556.555-.556h4.445V5.333H4.222A2.222 2.222 0 0 0 2 7.556v11.11c0 1.228.995 2.223 2.222 2.223h15.556A2.222 2.222 0 0 0 22 18.667V7.556a2.223 2.223 0 0 0-2.222-2.223ZM8.667 18.111h6.666a.556.556 0 0 0 .556-.555 2.778 2.778 0 0 0-2.778-2.778H10.89a2.778 2.778 0 0 0-2.778 2.778c0 .305.25.555.556.555Z",
        fill: "currentColor"
      }
    )
  })
);
var IdCardClip_default = SvgIdCardClip;

// src/Icon/icons/IdCard.tsx
import { jsx as jsx828 } from "react/jsx-runtime";
var SvgIdCard = (props) => /* @__PURE__ */ jsx828(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx828(
      "path",
      {
        d: "M14.778 15.056h3.333a.834.834 0 0 0 0-1.667h-3.333a.834.834 0 0 0 0 1.667Zm-5.556-.834a2.222 2.222 0 1 0 0-4.444 2.222 2.222 0 0 0 0 4.444Zm10.556-10H4.222A2.222 2.222 0 0 0 2 6.444v11.112c0 1.227.995 2.222 2.222 2.222h15.556A2.222 2.222 0 0 0 22 17.556V6.444a2.223 2.223 0 0 0-2.222-2.222Zm.555 13.334c0 .306-.249.555-.555.555H13.11a2.778 2.778 0 0 0-2.778-2.778H8.111a2.777 2.777 0 0 0-2.778 2.778h-1.11a.556.556 0 0 1-.556-.555v-8.89h16.666v8.89Zm-5.555-5.278h3.333a.834.834 0 0 0 0-1.667h-3.333a.834.834 0 0 0 0 1.667Z",
        fill: "currentColor"
      }
    )
  })
);
var IdCard_default = SvgIdCard;

// src/Icon/icons/ImageLandscape.tsx
import { jsx as jsx829 } from "react/jsx-runtime";
var SvgImageLandscape = (props) => /* @__PURE__ */ jsx829(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx829(
      "path",
      {
        d: "M19.778 5.333H4.222A2.222 2.222 0 0 0 2 7.556v8.888c0 1.228.995 2.223 2.222 2.223h15.556A2.222 2.222 0 0 0 22 16.444V7.556a2.223 2.223 0 0 0-2.222-2.223Zm.555 11.111c0 .307-.249.556-.555.556h-.93l-4.594-6.892a.74.74 0 0 0-1.234 0l-2.906 4.357-1.034-1.42a.74.74 0 0 0-1.198 0L4.999 17h-.777a.556.556 0 0 1-.555-.556V7.556c0-.307.249-.556.555-.556h15.556c.306 0 .555.25.555.556v8.888ZM8.08 8.667a1.111 1.111 0 1 0 1.111 1.11c0-.613-.465-1.11-1.111-1.11Z",
        fill: "currentColor"
      }
    )
  })
);
var ImageLandscape_default = SvgImageLandscape;

// src/Icon/icons/ImagePolaroidUser.tsx
import { jsx as jsx830 } from "react/jsx-runtime";
var SvgImagePolaroidUser = (props) => /* @__PURE__ */ jsx830(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx830(
      "path",
      {
        d: "M19.017 2H4.982a2.807 2.807 0 0 0-2.807 2.807v14.386A2.807 2.807 0 0 0 4.982 22h14.035a2.807 2.807 0 0 0 2.808-2.807V4.807A2.808 2.808 0 0 0 19.017 2Zm.702 17.193a.703.703 0 0 1-.702.702H4.982a.703.703 0 0 1-.701-.702v-2.105h15.438v2.105Zm0-4.21h-2.981a3.498 3.498 0 0 0-3.335-2.457h-2.806a3.5 3.5 0 0 0-3.335 2.457H4.281V4.806c0-.387.315-.702.701-.702h14.035c.387 0 .702.315.702.702v10.175ZM12 5.508a2.807 2.807 0 1 0 0 5.613 2.807 2.807 0 0 0 0-5.613Z",
        fill: "currentColor"
      }
    )
  })
);
var ImagePolaroidUser_default = SvgImagePolaroidUser;

// src/Icon/icons/ImagePolaroid.tsx
import { jsx as jsx831 } from "react/jsx-runtime";
var SvgImagePolaroid = (props) => /* @__PURE__ */ jsx831(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx831(
      "path",
      {
        d: "M7 5.571A1.429 1.429 0 1 0 7 8.43 1.429 1.429 0 0 0 7 5.57Zm15-.714A2.857 2.857 0 0 0 19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857Zm-2.143 14.286c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V17h15.714v2.143Zm0-4.286h-1.284l-4.311-6.469a.72.72 0 0 0-1.191.002l-2.8 4.2-.999-1.367a.714.714 0 0 0-1.153-.001l-2.65 3.635H4.143v-10c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v10Z",
        fill: "currentColor"
      }
    )
  })
);
var ImagePolaroid_default = SvgImagePolaroid;

// src/Icon/icons/ImagePortrait.tsx
import { jsx as jsx832 } from "react/jsx-runtime";
var SvgImagePortrait = (props) => /* @__PURE__ */ jsx832(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx832(
      "path",
      {
        d: "M12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm5-10H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10a2.5 2.5 0 0 0 2.5-2.5v-15C19.5 3.12 18.379 2 17 2Zm.625 17.5c0 .345-.28.625-.625.625H7a.626.626 0 0 1-.625-.625v-15c0-.345.28-.625.625-.625h10c.345 0 .625.28.625.625v15Zm-4.375-6.25h-2.5a3.125 3.125 0 0 0-3.125 3.125c0 .344.28.625.625.625h7.5c.345 0 .625-.28.625-.625a3.124 3.124 0 0 0-3.125-3.125Z",
        fill: "currentColor"
      }
    )
  })
);
var ImagePortrait_default = SvgImagePortrait;

// src/Icon/icons/ImageSlash.tsx
import { jsx as jsx833 } from "react/jsx-runtime";
var SvgImageSlash = (props) => /* @__PURE__ */ jsx833(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx833(
      "path",
      {
        d: "m21.718 18.661-1.75-1.37c.015-.096.008-.19.008-.29V7a2 2 0 0 0-2-2H5.973a1.95 1.95 0 0 0-1.167.407L3.213 4.158a.75.75 0 0 0-.926 1.18l18.505 14.505c.138.106.3.159.435.159a.75.75 0 0 0 .59-.287.724.724 0 0 0-.1-1.054Zm-3.242-2.52-1.129-.884-3.147-4.276c-.078-.144-.256-.231-.447-.231a.59.59 0 0 0-.476.23l-.496.676-2.595-2.032c.007-.122.066-.243.066-.375a1.5 1.5 0 0 0-1.5-1.5c-.26 0-.502.072-.715.19L6.2 6.498h11.803a.5.5 0 0 1 .5.5v9.143h-.028Zm-8.53-.63-1.16-1.442a.592.592 0 0 0-.461-.213.593.593 0 0 0-.462.213l-2.36 2.933c0-.001 0 0 0 0l-.03-7.237-1.5-1.176L4 17.001a2 2 0 0 0 2 2h11.288l-6.286-4.926-1.056 1.435Z",
        fill: "currentColor"
      }
    )
  })
);
var ImageSlash_default = SvgImageSlash;

// src/Icon/icons/ImageUser.tsx
import { jsx as jsx834 } from "react/jsx-runtime";
var SvgImageUser = (props) => /* @__PURE__ */ jsx834(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx834(
      "path",
      {
        d: "M19.5 3.25h-15A2.5 2.5 0 0 0 2 5.75v12.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5V5.75c0-1.38-1.121-2.5-2.5-2.5Zm.625 15c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625V5.75c0-.345.28-.625.625-.625h15c.345 0 .625.28.625.625v12.5ZM12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm1.25 1.25h-2.5a3.125 3.125 0 0 0-3.125 3.125c0 .345.28.625.625.625h7.5c.345 0 .625-.28.625-.625a3.124 3.124 0 0 0-3.125-3.125Z",
        fill: "currentColor"
      }
    )
  })
);
var ImageUser_default = SvgImageUser;

// src/Icon/icons/Image.tsx
import { jsx as jsx835 } from "react/jsx-runtime";
var SvgImage = (props) => /* @__PURE__ */ jsx835(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx835(
      "path",
      {
        d: "M7.948 6.678a1.878 1.878 0 1 0 0 3.757 1.878 1.878 0 0 0 0-3.757Zm11.548-3.443H4.47C3.12 3.235 2 4.355 2 5.739v12.522c0 1.383 1.121 2.504 2.47 2.504h15.026A2.504 2.504 0 0 0 22 18.261V5.739a2.483 2.483 0 0 0-2.504-2.504Zm.626 14.764-5.353-7.275c-.098-.18-.321-.29-.56-.29a.738.738 0 0 0-.595.29l-4.171 5.638-1.452-1.804a.741.741 0 0 0-.578-.266.742.742 0 0 0-.578.266L3.88 18.23s0 .001 0 0L3.878 5.74c0-.345.281-.626.626-.626h15.027c.345 0 .626.28.626.626v12.26h-.035Z",
        fill: "currentColor"
      }
    )
  })
);
var Image_default = SvgImage;

// src/Icon/icons/ImagesUser.tsx
import { jsx as jsx836 } from "react/jsx-runtime";
var SvgImagesUser = (props) => /* @__PURE__ */ jsx836(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx836(
      "path",
      {
        d: "M19.778 4.222H7.556a2.223 2.223 0 0 0-2.223 2.222v7.778c0 1.228.995 2.222 2.223 2.222h12.222A2.222 2.222 0 0 0 22 14.222V6.444a2.223 2.223 0 0 0-2.222-2.222Zm.555 10c0 .306-.249.556-.555.556H17.5a2.778 2.778 0 0 0-2.722-2.222h-2.222a2.778 2.778 0 0 0-2.722 2.222H7.556A.556.556 0 0 1 7 14.222V6.444c0-.306.25-.555.556-.555h12.222c.306 0 .555.25.555.555v7.778ZM13.667 7a2.222 2.222 0 1 0 0 4.444 2.222 2.222 0 0 0 0-4.444Zm4.166 12.778H6.167A4.17 4.17 0 0 1 2 15.61V7.278c0-.459.373-.834.833-.834.46 0 .834.375.834.834v8.333c0 1.379 1.121 2.5 2.5 2.5h11.666a.834.834 0 0 1 0 1.667Z",
        fill: "currentColor"
      }
    )
  })
);
var ImagesUser_default = SvgImagesUser;

// src/Icon/icons/Images.tsx
import { jsx as jsx837 } from "react/jsx-runtime";
var SvgImages = (props) => /* @__PURE__ */ jsx837(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx837(
      "path",
      {
        d: "M19.778 4.222H7.556a2.222 2.222 0 0 0-2.223 2.222v7.778c0 1.228.995 2.222 2.223 2.222h12.222A2.222 2.222 0 0 0 22 14.222V6.444a2.223 2.223 0 0 0-2.222-2.222Zm.555 10c0 .306-.249.556-.555.556h-.556L15.427 9.19a.564.564 0 0 0-.465-.247.555.555 0 0 0-.462.248L12.32 12.46l-.776-1.064a.556.556 0 0 0-.897 0l-2.537 3.382h-.555A.556.556 0 0 1 7 14.222V6.444c0-.306.25-.555.556-.555h12.222c.306 0 .555.25.555.555v7.778ZM9.778 7a1.111 1.111 0 1 0 0 2.222 1.111 1.111 0 0 0 0-2.222Zm8.055 12.778H6.167A4.17 4.17 0 0 1 2 15.61V7.278c0-.459.373-.834.833-.834.46 0 .834.375.834.834v8.333c0 1.379 1.121 2.5 2.5 2.5h11.666a.834.834 0 0 1 0 1.667Z",
        fill: "currentColor"
      }
    )
  })
);
var Images_default = SvgImages;

// src/Icon/icons/InboxFull.tsx
import { jsx as jsx838 } from "react/jsx-runtime";
var SvgInboxFull = (props) => /* @__PURE__ */ jsx838(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx838(
      "path",
      {
        d: "m21.855 13.91-2.392-9.715a1.25 1.25 0 0 0-1.213-.945H5.75a1.25 1.25 0 0 0-1.212.947l-2.393 9.715A4.96 4.96 0 0 0 2 15.105v3.145a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-3.143c0-.404-.047-.806-.145-1.197ZM6.242 5.125h11.52l2 8.125h-3.387c-.355 0-.68.2-.839.519l-.99 1.981H9.454l-.988-1.98a.937.937 0 0 0-.84-.52H4.239l2.003-8.125ZM20.125 18.25c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625v-3.125h3.17l.992 1.981c.158.32.483.519.838.519h6.25c.355 0 .68-.2.839-.519l.99-1.981h3.171v3.125ZM9.187 8.875h5.626c.519 0 .937-.418.937-.938A.935.935 0 0 0 14.812 7H9.189a.94.94 0 0 0-.938.938.94.94 0 0 0 .938.937ZM16.064 12c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937H7.938a.94.94 0 0 0-.937.938.94.94 0 0 0 .938.937h8.125Z",
        fill: "currentColor"
      }
    )
  })
);
var InboxFull_default = SvgInboxFull;

// src/Icon/icons/InboxIn.tsx
import { jsx as jsx839 } from "react/jsx-runtime";
var SvgInboxIn = (props) => /* @__PURE__ */ jsx839(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx839(
      "path",
      {
        d: "M20.125 14.5h-3.75c-.355 0-.68.2-.839.519L14.546 17H9.454l-.991-1.981a.93.93 0 0 0-.837-.519H3.25c-.69 0-1.25.56-1.25 1.25v3.75A2.5 2.5 0 0 0 4.5 22h15a2.5 2.5 0 0 0 2.5-2.5v-3.125c0-1.035-.84-1.875-1.875-1.875Zm0 5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625v-3.125h3.17l.992 1.981c.158.32.483.519.838.519h6.25c.355 0 .68-.2.839-.519l.99-1.981h3.171V19.5Zm-8.813-5.3c.145.19.426.3.688.3a.939.939 0 0 0 .687-.3l4.063-4.374A.94.94 0 0 0 16.7 8.5a.941.941 0 0 0-1.325.049l-2.438 2.627V2.937a.938.938 0 0 0-1.874 0v8.239L8.624 8.55c-.355-.414-.945-.403-1.324-.051-.414.352-.403.945-.051 1.324l4.063 4.375Z",
        fill: "currentColor"
      }
    )
  })
);
var InboxIn_default = SvgInboxIn;

// src/Icon/icons/InboxOut.tsx
import { jsx as jsx840 } from "react/jsx-runtime";
var SvgInboxOut = (props) => /* @__PURE__ */ jsx840(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx840(
      "path",
      {
        d: "M20.125 14.493h-3.75c-.355 0-.68.2-.839.52l-.99 1.98H9.454l-.991-1.98a.93.93 0 0 0-.837-.52H3.25c-.69 0-1.25.56-1.25 1.25v3.75a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-3.125c0-1.035-.84-1.875-1.875-1.875Zm0 5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625v-3.125h3.17l.992 1.982c.158.32.483.518.838.518h6.25c.355 0 .68-.2.839-.518l.99-1.982h3.171v3.125Zm-11.5-11.55 2.438-2.624v8.237a.938.938 0 0 0 1.874 0V5.319l2.438 2.625a.937.937 0 1 0 1.374-1.277l-4.062-4.375c-.356-.38-1.018-.38-1.374 0L7.25 6.667a.937.937 0 1 0 1.375 1.275Z",
        fill: "currentColor"
      }
    )
  })
);
var InboxOut_default = SvgInboxOut;

// src/Icon/icons/Inbox.tsx
import { jsx as jsx841 } from "react/jsx-runtime";
var SvgInbox = (props) => /* @__PURE__ */ jsx841(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx841(
      "path",
      {
        d: "m21.855 13.928-2.392-9.715a1.244 1.244 0 0 0-1.213-.98H5.75a1.25 1.25 0 0 0-1.212.947l-2.393 9.748c-.096.39-.145.793-.145 1.195v3.145a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-3.144c0-.403-.047-.806-.145-1.196ZM6.242 5.143h11.52l2 8.125h-3.387c-.355 0-.68.2-.839.518l-.99 1.982H9.454l-.988-1.98a.937.937 0 0 0-.84-.52H4.239l2.003-8.125Zm13.883 13.125c0 .344-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625v-3.125h3.17l.992 1.98c.158.32.483.52.838.52h6.25c.355 0 .68-.2.839-.52l.99-1.98h3.171v3.125Z",
        fill: "currentColor"
      }
    )
  })
);
var Inbox_default = SvgInbox;

// src/Icon/icons/Inboxes.tsx
import { jsx as jsx842 } from "react/jsx-runtime";
var SvgInboxes = (props) => /* @__PURE__ */ jsx842(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx842(
      "path",
      {
        d: "m21.566 5.229-2.128-2.554A1.876 1.876 0 0 0 17.996 2H6.004c-.557 0-1.085.247-1.441.675L2.435 5.229c-.281.337-.435.76-.435 1.2v4.321a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5V6.43c0-.442-.152-.864-.434-1.201ZM6.004 3.875h11.992l1.527 1.875h-3.148c-.355 0-.68.2-.839.519l-.99 1.981H9.454l-.988-1.98a.937.937 0 0 0-.84-.52H4.441l1.563-1.875Zm14.121 6.875c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625V7.625h3.17l.992 1.981c.158.32.483.519.838.519h6.25c.355 0 .68-.2.839-.519l.99-1.981h3.171v3.125Zm0 3.715-3.75.035c-.355 0-.68.2-.839.519L14.546 17H9.454l-.991-1.981a.93.93 0 0 0-.837-.519H3.25c-.69 0-1.25.56-1.25 1.25v3.75A2.5 2.5 0 0 0 4.5 22h15a2.5 2.5 0 0 0 2.5-2.5v-3.125c0-1.035-.84-1.91-1.875-1.91Zm0 5.035c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625v-3.125h3.17l.992 1.981c.158.32.483.484.838.484h6.25c.355 0 .68-.2.839-.519l.99-1.946h3.171V19.5Z",
        fill: "currentColor"
      }
    )
  })
);
var Inboxes_default = SvgInboxes;

// src/Icon/icons/Indent.tsx
import { jsx as jsx843 } from "react/jsx-runtime";
var SvgIndent = (props) => /* @__PURE__ */ jsx843(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx843(
      "path",
      {
        d: "M2 3.429c0-.592.48-1.072 1.071-1.072H20.93a1.07 1.07 0 1 1 0 2.143H3.07C2.48 4.5 2 4.02 2 3.429Zm8.571 5.714c0-.594.478-1.072 1.072-1.072h9.286c.593 0 1.071.478 1.071 1.072 0 .594-.478 1.071-1.071 1.071h-9.286a1.069 1.069 0 0 1-1.072-1.071Zm10.358 4.643c.593 0 1.071.477 1.071 1.071s-.478 1.072-1.071 1.072h-9.286a1.069 1.069 0 0 1-1.072-1.072c0-.594.478-1.071 1.072-1.071h9.286ZM2 20.57c0-.593.48-1.071 1.071-1.071H20.93c.593 0 1.071.478 1.071 1.071 0 .594-.478 1.072-1.071 1.072H3.07A1.07 1.07 0 0 1 2 20.57Zm1.168-4.535A.714.714 0 0 1 2 15.486V8.514c0-.602.702-.973 1.168-.549l4.234 3.482c.348.286.348.782 0 1.108l-4.234 3.482Z",
        fill: "currentColor"
      }
    )
  })
);
var Indent_default = SvgIndent;

// src/Icon/icons/Infinity.tsx
import { jsx as jsx844 } from "react/jsx-runtime";
var SvgInfinity = (props) => /* @__PURE__ */ jsx844(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx844(
      "path",
      {
        d: "M17.137 7C14.72 7 12.912 9.128 12 10.516 11.088 9.128 9.281 7 6.862 7 4.18 7 2 9.244 2 12s2.18 5 4.862 5c2.422 0 4.226-2.128 5.138-3.516.912 1.388 2.719 3.516 5.137 3.516C19.822 17 22 14.756 22 12s-2.178-5-4.863-5ZM6.864 15.5C5.008 15.5 3.5 13.931 3.5 12s1.508-3.5 3.362-3.5c2.118 0 3.766 2.57 4.285 3.5-.522.931-2.166 3.5-4.285 3.5Zm10.274 0c-2.117 0-3.765-2.57-4.284-3.5.522-.931 2.166-3.5 4.284-3.5 1.857 0 3.363 1.569 3.363 3.5s-1.506 3.5-3.363 3.5Z",
        fill: "currentColor"
      }
    )
  })
);
var Infinity_default = SvgInfinity;

// src/Icon/icons/Info.tsx
import { jsx as jsx845 } from "react/jsx-runtime";
var SvgInfo = (props) => /* @__PURE__ */ jsx845(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx845(
      "path",
      {
        d: "M15 20h-2V9a1 1 0 0 0-1-1h-1.667c-.552 0-1 .45-1 1s.448 1 1 1H11v10H9c-.552 0-1 .45-1 1s.448 1 1 1h6a1 1 0 0 0 0-2ZM12 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
        fill: "currentColor"
      }
    )
  })
);
var Info_default = SvgInfo;

// src/Icon/icons/InputNumeric.tsx
import { jsx as jsx846 } from "react/jsx-runtime";
var SvgInputNumeric = (props) => /* @__PURE__ */ jsx846(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx846(
      "path",
      {
        d: "M5.25 9.75c0-.416.334-.75.75-.75h1c.416 0 .75.334.75.75v3.75h.5c.416 0 .75.334.75.75s-.334.75-.75.75h-2.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h.5v-3H6a.748.748 0 0 1-.75-.75Zm5.61 1.434a.747.747 0 1 1-1.22-.868l.348-.488a1.977 1.977 0 0 1 3.1-.153c.665.734.65 1.903-.035 2.647l-1.09 1.178H13c.416 0 .75.334.75.75s-.334.75-.75.75h-2.75a.748.748 0 0 1-.55-1.26l2.25-2.437a.482.482 0 0 0 .01-.64.482.482 0 0 0-.754.037l-.347.484ZM20 6a2 2 0 0 1 2 2v8c0 1.103-.897 2-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16Zm0 1.5H4a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h16c.275 0 .5-.225.5-.5V8c0-.275-.225-.5-.5-.5Z",
        fill: "currentColor"
      }
    )
  })
);
var InputNumeric_default = SvgInputNumeric;

// src/Icon/icons/InputPipe.tsx
import { jsx as jsx847 } from "react/jsx-runtime";
var SvgInputPipe = (props) => /* @__PURE__ */ jsx847(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx847(
      "path",
      {
        d: "M6.5 14.25c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-4.5c0-.416.334-.75.75-.75s.75.334.75.75v4.5ZM2 8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8c0 1.103-.897 2-2 2H4a2 2 0 0 1-2-2V8Zm1.5 0v8a.5.5 0 0 0 .5.5h16c.275 0 .5-.225.5-.5V8c0-.275-.225-.5-.5-.5H4a.5.5 0 0 0-.5.5Z",
        fill: "currentColor"
      }
    )
  })
);
var InputPipe_default = SvgInputPipe;

// src/Icon/icons/InputText.tsx
import { jsx as jsx848 } from "react/jsx-runtime";
var SvgInputText = (props) => /* @__PURE__ */ jsx848(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx848(
      "path",
      {
        d: "M7.75 9c.297 0 .566.175.684.447l2 4.5a.745.745 0 0 1-.38.987.745.745 0 0 1-.988-.38l-.138-.304H6.572l-.138.303a.745.745 0 0 1-.987.381.747.747 0 0 1-.382-.987l2-4.5A.746.746 0 0 1 7.75 9Zm-.513 3.75h1.025l-.512-1.153-.513 1.153Zm4.263-3c0-.416.334-.75.75-.75h1.625a1.876 1.876 0 0 1 1.694 2.678A1.876 1.876 0 0 1 14.375 15H12.25a.748.748 0 0 1-.75-.75v-4.5Zm1.5.75v.75h.875a.376.376 0 0 0 .375-.375.376.376 0 0 0-.375-.375H13Zm0 3h1.375a.376.376 0 0 0 .375-.375.376.376 0 0 0-.375-.375H13v.75ZM2 8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8c0 1.103-.897 2-2 2H4a2 2 0 0 1-2-2V8Zm1.5 0v8a.5.5 0 0 0 .5.5h16c.275 0 .5-.225.5-.5V8c0-.275-.225-.5-.5-.5H4a.5.5 0 0 0-.5.5Z",
        fill: "currentColor"
      }
    )
  })
);
var InputText_default = SvgInputText;

// src/Icon/icons/InstallOnce16Px.tsx
import { jsx as jsx849, jsxs as jsxs4 } from "react/jsx-runtime";
var SvgInstallOnce16Px = (props) => /* @__PURE__ */ jsxs4(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsx849(
        "path",
        {
          d: "M13.625 4.188v3a.555.555 0 0 1-.563.562h-3c-.328 0-.562-.234-.562-.54 0-.163.047-.304.164-.397l1.219-1.243C10.109 4.844 9.102 4.375 8 4.375A4.116 4.116 0 0 0 3.875 8.5 4.101 4.101 0 0 0 8 12.625c1.898 0 2.508-1.078 2.977-1.078.234 0 .562.187.562.562 0 .586-1.758 1.641-3.562 1.641-2.907 0-5.25-2.344-5.25-5.227a5.241 5.241 0 0 1 5.25-5.25c1.406 0 2.718.586 3.68 1.524l.96-.961a.565.565 0 0 1 .399-.164c.351-.024.609.21.609.515Z",
          fill: "#1A1D25"
        }
      ),
      /* @__PURE__ */ jsx849(
        "path",
        {
          d: "M7.787 11V7.346H6.765V6.73h.14c.322 0 .581-.077.756-.231.161-.147.245-.371.245-.7h.826V11h-.945Z",
          fill: "#1A1D25"
        }
      )
    ]
  })
);
var InstallOnce16Px_default = SvgInstallOnce16Px;

// src/Icon/icons/InstalledProfiles.tsx
import { jsx as jsx850 } from "react/jsx-runtime";
var SvgInstalledProfiles = (props) => /* @__PURE__ */ jsx850(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx850(
      "path",
      {
        d: "M6.667 19.633c-1.577 0-2.308-.73-2.308-2.307v-1.901a.583.583 0 0 0-.176-.45L2.836 13.62c-1.11-1.11-1.119-2.13 0-3.249l1.347-1.355a.565.565 0 0 0 .176-.44V6.664c0-1.585.731-2.307 2.308-2.307h1.902a.572.572 0 0 0 .45-.176l1.356-1.347c1.11-1.109 2.14-1.118 3.25 0l1.356 1.347a.572.572 0 0 0 .45.176h1.902c1.585 0 2.308.74 2.308 2.307v1.91c0 .176.053.308.185.44l1.338 1.356c1.11 1.118 1.119 2.14 0 3.249l-1.338 1.356a.592.592 0 0 0-.185.449v1.901c0 1.585-.731 2.307-2.308 2.307h-1.902a.58.58 0 0 0-.45.185l-1.356 1.347c-1.11 1.109-2.14 1.118-3.25 0l-1.356-1.347a.58.58 0 0 0-.45-.185H6.667Zm0-1.4h2.37a.85.85 0 0 1 .669.282l1.655 1.664c.564.554.723.554 1.278 0l1.664-1.664a.832.832 0 0 1 .66-.282h2.37c.784 0 .907-.123.907-.907v-2.368c0-.264.088-.466.282-.66l1.665-1.655c.555-.564.555-.722 0-1.286l-1.665-1.655a.879.879 0 0 1-.282-.669V6.665c0-.784-.123-.907-.907-.907h-2.37c-.263 0-.475-.07-.66-.273L12.64 3.821c-.555-.554-.714-.554-1.278 0L9.706 5.485c-.194.203-.397.273-.67.273H6.667c-.793 0-.907.115-.907.907v2.368a.87.87 0 0 1-.273.67l-1.665 1.654c-.555.564-.555.722 0 1.286l1.665 1.655a.865.865 0 0 1 .273.66v2.368c0 .784.123.907.907.907Zm4.377-2.06c-.29 0-.528-.114-.748-.405l-2.15-2.641a.95.95 0 0 1-.202-.546c0-.396.3-.704.687-.704.238 0 .432.079.643.36l1.735 2.246 3.655-5.864c.168-.264.388-.396.617-.396.361 0 .713.255.713.643 0 .202-.114.396-.211.563l-4.025 6.339c-.176.264-.423.405-.714.405Z",
        fill: "currentColor"
      }
    )
  })
);
var InstalledProfiles_default = SvgInstalledProfiles;

// src/Icon/icons/Intersection.tsx
import { jsx as jsx851 } from "react/jsx-runtime";
var SvgIntersection = (props) => /* @__PURE__ */ jsx851(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx851(
      "path",
      {
        d: "M20.571 10.571V20.93a1.072 1.072 0 0 1-2.142 0V10.57A6.435 6.435 0 0 0 12 4.143a6.436 6.436 0 0 0-6.429 6.428V20.93a1.07 1.07 0 1 1-2.142 0V10.57C3.429 5.844 7.274 2 12 2c4.726 0 8.571 3.844 8.571 8.571Z",
        fill: "currentColor"
      }
    )
  })
);
var Intersection_default = SvgIntersection;

// src/Icon/icons/Italic.tsx
import { jsx as jsx852 } from "react/jsx-runtime";
var SvgItalic = (props) => /* @__PURE__ */ jsx852(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx852(
      "path",
      {
        d: "M20.571 3.071c0 .592-.48 1.072-1.071 1.072h-3.035L9.907 19.857h3.879a1.072 1.072 0 0 1 0 2.143H4.5a1.07 1.07 0 1 1 0-2.143h3.152L14.21 4.143h-3.996c-.589 0-1.071-.48-1.071-1.072C9.143 2.48 9.625 2 10.214 2H19.5c.594 0 1.071.48 1.071 1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var Italic_default = SvgItalic;

// src/Icon/icons/K.tsx
import { jsx as jsx853 } from "react/jsx-runtime";
var SvgK = (props) => /* @__PURE__ */ jsx853(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx853(
      "path",
      {
        d: "M18.946 20.313a1.072 1.072 0 1 1-1.75 1.233l-6.647-9.452L7 15.692v5.237a1.07 1.07 0 1 1-2.142 0V3.07a1.072 1.072 0 0 1 2.143 0v9.585L17.312 2.317A1.072 1.072 0 0 1 18.83 3.83l-6.754 6.773c.011.014.028.022.04.037l6.83 9.672Z",
        fill: "currentColor"
      }
    )
  })
);
var K_default = SvgK;

// src/Icon/icons/KandjiAI.tsx
import { jsx as jsx854, jsxs as jsxs5 } from "react/jsx-runtime";
var SvgKandjiAI = (_a) => {
  var _b = _a, { color = "#fff" } = _b, props = __objRest(_b, ["color"]);
  return /* @__PURE__ */ jsxs5(
    "svg",
    __spreadProps(__spreadValues({
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx854(
          "path",
          {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M12.1667 1.16667L11.5781 1.3875C11.5219 1.40521 11.5 1.45 11.5 1.5C11.5 1.55 11.5219 1.59479 11.5781 1.6125L12.1667 1.83333L12.3875 2.42188C12.4052 2.46875 12.45 2.5 12.5 2.5C12.55 2.5 12.5948 2.46875 12.6125 2.42188L12.8333 1.83333L13.4219 1.6125C13.4688 1.59479 13.5 1.55 13.5 1.5C13.5 1.45 13.4688 1.40521 13.4219 1.3875L12.8333 1.16667L12.6125 0.578125C12.5948 0.521875 12.55 0.5 12.5 0.5C12.45 0.5 12.4052 0.521875 12.3875 0.578125L12.1667 1.16667ZM8.69458 4.07871L8.30319 4.37097L8.06309 3.83325L7.82299 4.37097L7.43159 4.07871V4.8463H8.69458V4.07871ZM13.9586 4.46701C13.906 4.2727 13.7837 4.10447 13.615 3.99428C13.4463 3.8841 13.2429 3.83964 13.0435 3.86937C13.011 3.87424 12.9789 3.88109 12.9473 3.88989C11.4952 4.28641 9.79803 6.4578 9.27672 7.16546L9.27261 7.1712C9.24547 7.20732 9.22245 7.23852 9.20272 7.26643C9.16612 7.03388 9.05888 6.81816 8.8955 6.64843C8.73212 6.47871 8.52047 6.36316 8.28919 6.31742L8.83517 6.12532C8.95088 6.08799 9.04924 6.01028 9.11223 5.90643C9.17522 5.80259 9.19862 5.67955 9.17814 5.55988C9.15767 5.44021 9.09468 5.33191 9.00074 5.25483C8.90679 5.17775 8.78816 5.13705 8.6666 5.14019H7.46117C7.33961 5.13705 7.22099 5.17775 7.12704 5.25483C7.0331 5.33191 6.97011 5.44021 6.94964 5.55988C6.92916 5.67955 6.95256 5.80259 7.01555 5.90643C7.07854 6.01028 7.1769 6.08799 7.29261 6.12532L7.83859 6.31742C7.61528 6.36177 7.41016 6.47123 7.24916 6.63197C7.08816 6.79271 6.97853 6.99751 6.93411 7.22046L6.89546 7.16792L6.89135 7.16299C6.37004 6.45534 4.67126 4.28394 3.2208 3.88743C3.18918 3.87863 3.15705 3.87178 3.12459 3.8669C2.92493 3.83675 2.72114 3.88099 2.55206 3.99121C2.38298 4.10143 2.26043 4.26992 2.20778 4.46455C2.14959 4.71227 2.15297 4.97043 2.21764 5.21654C2.39278 5.98166 3.01852 6.87074 3.95343 7.3633H3.94685L4.37113 7.57593C4.28537 7.59538 4.20081 7.61977 4.11788 7.64899C4.02343 7.68195 3.9323 7.72373 3.84571 7.77377C3.7294 7.84269 3.64511 7.95473 3.61122 8.08545C3.57733 8.21618 3.5966 8.35498 3.66482 8.47158C3.82516 8.74331 4.22395 8.96414 4.70168 9.03228C5.48118 9.14803 6.46871 8.87384 6.967 7.80087C7.02001 7.96186 7.10801 8.10915 7.22472 8.2322C7.34143 8.35525 7.48395 8.45101 7.64207 8.51262C7.14872 8.50441 6.59287 8.55367 6.40869 8.97728C6.34874 9.12894 6.32075 9.2913 6.32646 9.45425H9.79556C9.79556 9.14968 9.73389 8.83607 9.44035 8.67763C9.1468 8.51919 8.78254 8.52165 8.44131 8.52822C8.61671 8.46747 8.7748 8.36527 8.90208 8.23033C9.02937 8.09538 9.12207 7.9317 9.17229 7.75325C9.66154 8.86809 10.6688 9.15378 11.4606 9.03556C11.9384 8.96414 12.3372 8.74659 12.4975 8.47486C12.5657 8.35826 12.585 8.21946 12.5511 8.08874C12.5172 7.95801 12.4329 7.84597 12.3166 7.77706C12.23 7.72701 12.1389 7.68523 12.0444 7.65227C11.9615 7.62306 11.8769 7.59866 11.7912 7.57921L12.2212 7.36823H12.2146C13.1495 6.87566 13.7769 5.98494 13.9512 5.22228C14.0157 4.97493 14.0182 4.71557 13.9586 4.46701ZM6.3577 9.94765C6.38523 10.2091 6.44035 10.467 6.52216 10.7169H9.59C9.67657 10.4434 9.73605 10.1621 9.7676 9.87705H6.3503L6.3577 9.94765ZM7.56472 12.0749L7.53436 12.0567C7.17396 11.8337 6.88273 11.515 6.69319 11.1364H9.41732C9.15585 11.6774 8.73567 12.1149 8.08691 12.2676C7.93846 12.3003 7.69979 12.1564 7.56472 12.0749ZM4.11719 13.3313L5 13L5.33125 12.1172C5.35781 12.0328 5.425 12 5.5 12C5.575 12 5.64219 12.0328 5.66875 12.1172L6 13L6.88281 13.3313C6.95313 13.3578 7 13.425 7 13.5C7 13.575 6.95313 13.6422 6.88281 13.6687L6 14L5.66875 14.8828C5.64219 14.9531 5.575 15 5.5 15C5.425 15 5.35781 14.9531 5.33125 14.8828L5 14L4.11719 13.6687C4.03281 13.6422 4 13.575 4 13.5C4 13.425 4.03281 13.3578 4.11719 13.3313ZM2.84728 9.09751C2.87457 9.0381 2.9344 9 3.00052 9C3.0656 9 3.12543 9.0381 3.15272 9.09751L3.70585 10.2941L4.90239 10.8473C4.96221 10.8746 5 10.9344 5 11.0005C5 11.0656 4.96221 11.1254 4.90239 11.1527L3.70585 11.7059L3.15272 12.9024C3.12543 12.9622 3.0656 13 3.00052 13C2.9344 13 2.87457 12.9622 2.84728 12.9024L2.29415 11.7059L1.09753 11.1527C1.03807 11.1254 1 11.0656 1 11.0005C1 10.9344 1.03807 10.8746 1.09753 10.8473L2.29415 10.2941L2.84728 9.09751ZM2.75177 10.5062C2.70139 10.6143 2.61427 10.7014 2.50617 10.7518L1.96898 11.0005L2.50617 11.2482C2.61427 11.2892 2.70139 11.3857 2.75177 11.4938L3.00052 12.0312L3.24823 11.4938C3.28916 11.3857 3.38573 11.2892 3.49383 11.2482L4.03123 11.0005L3.49383 10.7518C3.38573 10.7014 3.28916 10.6143 3.24823 10.5062L3.00052 9.96877L2.75177 10.5062ZM10.5004 1.5C10.4508 1.5 10.4059 1.52858 10.3855 1.57313L9.97061 2.47061L9.07315 2.88546C9.02855 2.90593 9 2.9508 9 3.00039C9 3.0492 9.02855 3.09407 9.07315 3.11454L9.97061 3.52939L10.3855 4.42679C10.4059 4.47166 10.4508 4.5 10.5004 4.5C10.5492 4.5 10.5941 4.47166 10.6145 4.42679L11.0294 3.52939L11.9268 3.11454C11.9717 3.09407 12 3.0492 12 3.00039C12 2.9508 11.9717 2.90593 11.9268 2.88546L11.0294 2.47061L10.6145 1.57313C10.5941 1.52858 10.5492 1.5 10.5004 1.5ZM10.1296 2.81383C10.2107 2.77604 10.276 2.71071 10.3138 2.62962L10.5004 2.22658L10.6862 2.62962C10.7169 2.71071 10.7893 2.77604 10.8704 2.81383L11.2734 3.00039L10.8704 3.18617C10.7893 3.21687 10.7169 3.28929 10.6862 3.37038L10.5004 3.77342L10.3138 3.37038C10.276 3.28929 10.2107 3.21687 10.1296 3.18617L9.72674 3.00039L10.1296 2.81383Z",
            fill: color === "gradient" ? "url(#kandji-ai-icon-linear-gradient)" : color
          }
        ),
        /* @__PURE__ */ jsx854("defs", { children: /* @__PURE__ */ jsxs5(
          "linearGradient",
          {
            id: "kandji-ai-icon-linear-gradient",
            x1: "1",
            y1: "1",
            x2: "9.5",
            y2: "12.5",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx854("stop", { "stop-color": "#0053D2" }),
              /* @__PURE__ */ jsx854("stop", { offset: "1", "stop-color": "#9B41DF" })
            ]
          }
        ) })
      ]
    })
  );
};
var KandjiAI_default = SvgKandjiAI;

// src/Icon/icons/KandjiBlueprint.tsx
import { jsx as jsx855, jsxs as jsxs6 } from "react/jsx-runtime";
var SvgKandjiBlueprint = (props) => /* @__PURE__ */ jsxs6(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsx855(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 4.5A2.5 2.5 0 0 1 4.5 2h15A2.5 2.5 0 0 1 22 4.5v11.982c0 .332-.132.65-.366.884l-4.268 4.268a1.25 1.25 0 0 1-.884.366H4.5A2.5 2.5 0 0 1 2 19.5v-15Zm2.5-.625h15c.345 0 .625.28.625.625v11.563H18.25c-1.208 0-2.188.979-2.188 2.187v1.875H4.5a.625.625 0 0 1-.625-.625v-15c0-.345.28-.625.625-.625Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx855(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.188 9.656a.937.937 0 1 0 1.875 0 .937.937 0 0 0-1.875 0Zm.937-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM7.938 8.719v5h1.875v-5H7.938Zm-.313-1.563c-.69 0-1.25.56-1.25 1.25v5.625c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25V8.406c0-.69-.56-1.25-1.25-1.25h-2.5Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
var KandjiBlueprint_default = SvgKandjiBlueprint;

// src/Icon/icons/KandjiBlueprintLight.tsx
import { jsx as jsx856, jsxs as jsxs7 } from "react/jsx-runtime";
var SvgKandjiBlueprintLight = (props) => /* @__PURE__ */ jsxs7(
  "svg",
  __spreadProps(__spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsx856(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M6.33914 8.65295C6.33914 7.82453 7.01071 7.15295 7.83914 7.15295H9.86637C10.6948 7.15295 11.3664 7.82453 11.3664 8.65295V13.7848C11.3664 14.6132 10.6948 15.2848 9.86637 15.2848H7.83914C7.01071 15.2848 6.33914 14.6132 6.33914 13.7848V8.65295ZM7.83914 8.65295H9.86637V13.7848H7.83914V8.65295Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx856(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M15.1328 12.1487C16.508 12.1487 17.6228 11.0339 17.6228 9.65868C17.6228 8.2835 16.508 7.1687 15.1328 7.1687C13.7576 7.1687 12.6428 8.2835 12.6428 9.65868C12.6428 11.0339 13.7576 12.1487 15.1328 12.1487ZM15.1328 10.6487C15.6796 10.6487 16.1228 10.2054 16.1228 9.65868C16.1228 9.11193 15.6796 8.6687 15.1328 8.6687C14.5861 8.6687 14.1428 9.11193 14.1428 9.65868C14.1428 10.2054 14.5861 10.6487 15.1328 10.6487Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx856(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M2 5C2 3.34315 3.34315 2 5 2H19.0109C20.6738 2 22.0194 3.3525 22.0109 5.01531L21.9547 16.0282C21.9507 16.8104 21.6414 17.56 21.0928 18.1174L18.1268 21.1307C17.5629 21.7036 16.7927 22.0263 15.9888 22.0263H5C3.34315 22.0263 2 20.6831 2 19.0263V5ZM5 3.5H19.0109C19.8423 3.5 20.5151 4.17625 20.5109 5.00766L20.4547 16.0206C20.4538 16.1852 20.4259 16.347 20.3734 16.4999H18C17.1716 16.4999 16.5 17.1715 16.5 17.9999V20.4365C16.3377 20.4953 16.1648 20.5263 15.9888 20.5263H5C4.17157 20.5263 3.5 19.8547 3.5 19.0263V5C3.5 4.17157 4.17157 3.5 5 3.5Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
var KandjiBlueprintLight_default = SvgKandjiBlueprintLight;

// src/Icon/icons/KandjiLogo.tsx
import { jsx as jsx857, jsxs as jsxs8 } from "react/jsx-runtime";
var SvgKandjiLogo = (props) => /* @__PURE__ */ jsxs8(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsx857(
        "path",
        {
          d: "M21.928 5.94a1.387 1.387 0 0 0-1.71-.975c-2.453.67-5.322 4.34-6.202 5.535l-.007.01a7.219 7.219 0 0 0-.119.161 1.94 1.94 0 0 0-1.543-1.604l.922-.324a.855.855 0 0 0 .28-1.471.855.855 0 0 0-.564-.194h-2.037a.856.856 0 0 0-.865.71.852.852 0 0 0 .58.955l.922.324a1.946 1.946 0 0 0-1.528 1.526l-.066-.088-.006-.009C9.104 9.3 6.233 5.631 3.782 4.961a1.391 1.391 0 0 0-1.712.975c-.099.419-.093.855.016 1.271.296 1.293 1.354 2.795 2.934 3.628h-.011l.717.36a3.853 3.853 0 0 0-.428.123c-.16.055-.314.126-.46.21a.865.865 0 0 0-.306 1.18c.271.459.945.832 1.752.947 1.317.196 2.986-.268 3.828-2.08a1.94 1.94 0 0 0 1.141 1.202c-.834-.014-1.773.07-2.084.785-.101.257-.149.53-.14.806h5.863c0-.514-.104-1.044-.6-1.312s-1.111-.264-1.688-.253a1.947 1.947 0 0 0 1.235-1.31c.827 1.885 2.53 2.367 3.867 2.168.808-.121 1.481-.489 1.752-.948a.863.863 0 0 0-.305-1.179 2.69 2.69 0 0 0-.46-.21 3.85 3.85 0 0 0-.428-.124l.726-.357h-.01c1.58-.832 2.64-2.338 2.934-3.626.109-.418.113-.857.013-1.277ZM9.083 15.202c.046.442.14.878.278 1.3h5.184c.146-.462.247-.937.3-1.42H9.07l.013.12ZM11.071 18.766c.214.128.663.416.934.357 1.096-.258 1.806-.998 2.248-1.912H9.65c.32.64.812 1.178 1.421 1.555Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx857(
        "path",
        {
          d: "m13.032 5.284-.662.494-.405-.909-.406.909-.661-.494v1.297h2.134V5.284Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
var KandjiLogo_default = SvgKandjiLogo;

// src/Icon/icons/KernelExtensions.tsx
import { jsx as jsx858 } from "react/jsx-runtime";
var SvgKernelExtensions = (props) => /* @__PURE__ */ jsx858(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx858(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m11.93 12.047-7.367-4.18c.125-.117.265-.21.437-.304l5.508-3.141C10.984 4.148 11.46 4 11.93 4c.46 0 .937.148 1.414.422l5.515 3.14c.172.094.313.188.43.305l-7.36 4.18ZM11.39 21a.519.519 0 0 1-.148-.07l-6.125-3.485C4.398 17.031 4 16.61 4 15.477V9.39c0-.235.016-.422.063-.594l7.328 4.187V21Zm1.07 0v-8.016l7.33-4.187c.046.172.062.36.062.594v6.086c0 1.132-.391 1.554-1.118 1.968l-6.117 3.485a.69.69 0 0 1-.156.07ZM12 5c-.552 0-1 .201-1 .45v.9c0 .249.448.45 1 .45s1-.201 1-.45v-.9c0-.249-.448-.45-1-.45Zm2 2.45c0-.249.448-.45 1-.45s1 .201 1 .45v.9c0 .249-.448.45-1 .45s-1-.201-1-.45v-.9ZM9 7c-.552 0-1 .201-1 .45v.9c0 .249.448.45 1 .45s1-.201 1-.45v-.9C10 7.201 9.552 7 9 7Zm2 2.45c0-.249.448-.45 1-.45s1 .201 1 .45v.9c0 .248-.448.45-1 .45s-1-.202-1-.45v-.9Z",
        fill: "currentColor"
      }
    )
  })
);
var KernelExtensions_default = SvgKernelExtensions;

// src/Icon/icons/KeySkeletonLeftRight.tsx
import { jsx as jsx859 } from "react/jsx-runtime";
var SvgKeySkeletonLeftRight = (props) => /* @__PURE__ */ jsx859(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx859(
      "path",
      {
        d: "M22 7.994A3.987 3.987 0 0 1 17.994 12c-1.927 0-3.555-1.402-3.908-3.283h-2.6v1.53a.732.732 0 0 1-.752.752.768.768 0 0 1-.75-.752v-1.53H8.48v1.53c0 .417-.31.752-.751.752-.388-.029-.751-.335-.751-.78V7.966c0-.388.363-.75.75-.75h6.357c.353-1.826 1.98-3.227 3.908-3.227A3.988 3.988 0 0 1 22 7.994Zm-4.006-2.503c-1.355 0-2.503 1.12-2.503 2.503 0 1.384 1.148 2.504 2.503 2.504a2.485 2.485 0 0 0 2.504-2.504 2.485 2.485 0 0 0-2.504-2.503ZM2 16.006a4.005 4.005 0 0 1 7.942-.751h2.573v-1.503a.75.75 0 0 1 .75-.75.75.75 0 0 1 .752.75v1.503h1.502v-1.53c0-.389.335-.752.751-.724a.75.75 0 0 1 .751.752v2.253c-.028.416-.335.75-.75.75H9.941A4.006 4.006 0 0 1 2 16.006Zm4.006 2.503a2.503 2.503 0 1 0 0-5.006 2.503 2.503 0 0 0 0 5.006Z",
        fill: "currentColor"
      }
    )
  })
);
var KeySkeletonLeftRight_default = SvgKeySkeletonLeftRight;

// src/Icon/icons/KeySkeleton.tsx
import { jsx as jsx860 } from "react/jsx-runtime";
var SvgKeySkeleton = (props) => /* @__PURE__ */ jsx860(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx860(
      "path",
      {
        d: "M11.867 12.216 8.01 16.069l1.805 1.837c.399.368.399.962 0 1.294-.332.398-.926.398-1.293 0l-1.837-1.806-1.175 1.177 1.804 1.836c.399.368.399.962 0 1.294-.332.399-.926.399-1.292 0L3.52 19.2c-.366-.332-.366-.926 0-1.294l7.018-7.019a5.628 5.628 0 1 1 1.329 1.329Zm3.26-.836a3.753 3.753 0 0 0 0-7.504 3.73 3.73 0 0 0-3.752 3.752 3.73 3.73 0 0 0 3.752 3.752Z",
        fill: "currentColor"
      }
    )
  })
);
var KeySkeleton_default = SvgKeySkeleton;

// src/Icon/icons/Key.tsx
import { jsx as jsx861 } from "react/jsx-runtime";
var SvgKey = (props) => /* @__PURE__ */ jsx861(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx861(
      "path",
      {
        d: "M15.125 7.625c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25-.559 1.25-1.25 1.25-1.25-.559-1.25-1.25Zm0 8.125c-.371 0-.734-.027-1.09-.086l-1.094 1.027c-.14.211-.379.309-.629.309H10.75v1.563c0 .519-.418.937-.938.937H8.25v1.563c0 .519-.418.937-.938.937H2.938A.937.937 0 0 1 2 21.062v-4.375c0-.25.099-.488.275-.664l6.06-6.058a6.875 6.875 0 1 1 6.79 5.785Zm0-1.875a5 5 0 1 0-4.938-4.207l.149.945-6.496 6.461v3.051h2.5v-2.5h2.5v-2.5h3.086l1.46-1.46.946.148c.258.042.523.062.793.062Z",
        fill: "currentColor"
      }
    )
  })
);
var Key_default = SvgKey;

// src/Icon/icons/KeyboardBrightnessLow.tsx
import { jsx as jsx862 } from "react/jsx-runtime";
var SvgKeyboardBrightnessLow = (props) => /* @__PURE__ */ jsx862(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx862(
      "path",
      {
        d: "M10.75 7.625c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25-.559 1.25-1.25 1.25-1.25-.559-1.25-1.25Zm-6.25 2.5a1.25 1.25 0 1 1 2.499-.001 1.25 1.25 0 0 1-2.499.001Zm15 0c0 .691-.559 1.25-1.25 1.25S17 10.816 17 10.125s.559-1.25 1.25-1.25 1.25.559 1.25 1.25Zm0 6.25c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25-.559 1.25-1.25 1.25-1.25-.559-1.25-1.25Zm-15 0a1.25 1.25 0 1 1-2.499.001 1.25 1.25 0 0 1 2.499-.001Zm11.25-1.25c.691 0 1.25.559 1.25 1.25s-.559 1.25-1.25 1.25h-7.5c-.691 0-1.25-.559-1.25-1.25s.559-1.25 1.25-1.25h7.5Z",
        fill: "currentColor"
      }
    )
  })
);
var KeyboardBrightnessLow_default = SvgKeyboardBrightnessLow;

// src/Icon/icons/KeyboardBrightness.tsx
import { jsx as jsx863 } from "react/jsx-runtime";
var SvgKeyboardBrightness = (props) => /* @__PURE__ */ jsx863(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx863(
      "path",
      {
        d: "M8.503 12.219c.319.293.319.769 0 1.034-.265.319-.74.319-1.034 0l-2.5-2.5c-.292-.265-.292-.74 0-1.034.293-.29.768-.29 1.034 0l2.5 2.5ZM11.25 7.25a.75.75 0 1 1 1.5 0v3.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-3.5Zm6.719 2.469c.293-.29.768-.29 1.034 0 .319.293.319.769 0 1.034l-2.5 2.5c-.265.319-.74.319-1.034 0-.29-.265-.29-.74 0-1.034l2.5-2.5ZM2 16.75a.75.75 0 0 1 .75-.75h2.5c.416 0 .75.334.75.75s-.334.75-.75.75h-2.5a.75.75 0 0 1-.75-.75ZM15.25 16c.416 0 .75.334.75.75s-.334.75-.75.75h-6.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h6.5Zm6 0c.416 0 .75.334.75.75s-.334.75-.75.75h-2.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var KeyboardBrightness_default = SvgKeyboardBrightness;

// src/Icon/icons/KeyboardDown.tsx
import { jsx as jsx864 } from "react/jsx-runtime";
var SvgKeyboardDown = (props) => /* @__PURE__ */ jsx864(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx864(
      "path",
      {
        d: "M11.583 7.833h.834a.415.415 0 0 0 .416-.416v-.834a.415.415 0 0 0-.416-.416h-.834a.415.415 0 0 0-.416.416v.834c0 .232.184.416.416.416Zm2.778 0h.833a.415.415 0 0 0 .417-.416v-.834a.415.415 0 0 0-.417-.416h-.833a.415.415 0 0 0-.417.416v.834c0 .232.184.416.417.416Zm-5.555 0h.833a.415.415 0 0 0 .417-.416v-.834a.415.415 0 0 0-.417-.416h-.833a.415.415 0 0 0-.417.416v.834c0 .232.184.416.417.416Zm9.166-1.666h-.833a.415.415 0 0 0-.417.416v.834c0 .23.186.416.417.416h.833a.415.415 0 0 0 .417-.416v-.834a.414.414 0 0 0-.417-.416Zm1.806-3.056H4.222A2.222 2.222 0 0 0 2 5.333v6.111c0 1.228.995 2.223 2.222 2.223h15.556A2.222 2.222 0 0 0 22 11.444v-6.11a2.223 2.223 0 0 0-2.222-2.223Zm.555 8.333c0 .306-.25.556-.555.556H4.222a.557.557 0 0 1-.555-.556v-6.11c0-.307.249-.556.555-.556h15.556c.306 0 .555.249.555.555v6.111ZM6.861 6.167h-.833a.415.415 0 0 0-.417.416v.834c0 .23.186.416.417.416h.833a.415.415 0 0 0 .417-.416v-.834a.414.414 0 0 0-.417-.416Zm9.028 3.055H8.11a.553.553 0 0 0-.555.556v.555c0 .31.246.556.555.556h7.778a.553.553 0 0 0 .555-.556v-.555a.553.553 0 0 0-.555-.556ZM15 15.601l-3 3.229-3-3.231a.832.832 0 1 0-1.222 1.132l3.61 3.892c.13.169.38.266.612.266a.834.834 0 0 0 .61-.267l3.612-3.892a.832.832 0 0 0-.044-1.176c-.338-.31-.866-.321-1.178.047Z",
        fill: "currentColor"
      }
    )
  })
);
var KeyboardDown_default = SvgKeyboardDown;

// src/Icon/icons/KeyboardLeft.tsx
import { jsx as jsx865 } from "react/jsx-runtime";
var SvgKeyboardLeft = (props) => /* @__PURE__ */ jsx865(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx865(
      "path",
      {
        d: "M15.644 12.751h.751a.375.375 0 0 0 .376-.375v-.752a.375.375 0 0 0-.376-.375h-.75a.374.374 0 0 0-.376.375v.752c0 .21.165.375.375.375Zm-4.757-1.502h-.75a.374.374 0 0 0-.376.375v.752c0 .208.167.375.375.375h.752a.374.374 0 0 0 .375-.375v-.752a.373.373 0 0 0-.376-.375Zm2.254-1.002h.75a.374.374 0 0 0 .376-.375v-.751a.374.374 0 0 0-.375-.376h-.751a.374.374 0 0 0-.376.376v.751c0 .21.166.376.376.376Zm2.503 0h.751a.374.374 0 0 0 .376-.375v-.751a.374.374 0 0 0-.376-.376h-.75a.374.374 0 0 0-.376.376v.751c0 .21.165.376.375.376ZM5.758 8.965a.75.75 0 0 0-1.062 0l-2.503 2.504a.849.849 0 0 0-.193.504.75.75 0 0 0 .22.531l2.504 2.504a.673.673 0 0 0 .53.248.75.75 0 0 0 .531-1.282L3.814 12l1.973-1.973a.731.731 0 0 0-.028-1.063Zm7.383 3.787h.75a.374.374 0 0 0 .376-.375v-.752a.374.374 0 0 0-.375-.375h-.751a.375.375 0 0 0-.376.375v.752c0 .21.166.375.376.375Zm5.758-4.006h-.751a.374.374 0 0 0-.376.376v.751c0 .208.167.376.376.376h.75a.374.374 0 0 0 .376-.376v-.751a.373.373 0 0 0-.375-.376Zm1.098-2.753H8.982a2.003 2.003 0 0 0-2.003 2.002v8.012c0 1.106.896 2.002 2.003 2.002h11.015A2.003 2.003 0 0 0 22 16.006V7.994c0-1.106-.87-2.002-2.003-2.002Zm.53 10.014c0 .276-.226.5-.502.5H9.01a.501.501 0 0 1-.5-.5V7.994c0-.276.224-.5.5-.5h11.015c.276 0 .501.224.501.5v8.012Zm-9.64-7.26h-.75a.374.374 0 0 0-.376.375v.751c0 .208.167.376.375.376h.752a.374.374 0 0 0 .375-.376v-.751a.373.373 0 0 0-.376-.376Zm6.134 5.257h-5.007a.5.5 0 0 0-.5.5v.501a.5.5 0 0 0 .5.5h5.007a.5.5 0 0 0 .5-.5v-.5c0-.279-.221-.501-.5-.501Zm1.878-2.754h-.751a.374.374 0 0 0-.376.375v.752c0 .208.167.375.376.375h.75a.374.374 0 0 0 .376-.375v-.752a.373.373 0 0 0-.375-.375Z",
        fill: "currentColor"
      }
    )
  })
);
var KeyboardLeft_default = SvgKeyboardLeft;

// src/Icon/icons/Keyboard.tsx
import { jsx as jsx866 } from "react/jsx-runtime";
var SvgKeyboard = (props) => /* @__PURE__ */ jsx866(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx866(
      "path",
      {
        d: "M19.778 5.333H4.222A2.222 2.222 0 0 0 2 7.556v8.888c0 1.228.995 2.223 2.222 2.223h15.556A2.222 2.222 0 0 0 22 16.444V7.556a2.223 2.223 0 0 0-2.222-2.223Zm.555 11.111c0 .307-.249.556-.555.556H4.222a.556.556 0 0 1-.555-.556V7.556c0-.307.249-.556.555-.556h15.556c.306 0 .555.25.555.556v8.888ZM6.861 8.39h-.833a.415.415 0 0 0-.417.417v.833c0 .231.186.417.417.417h.833a.415.415 0 0 0 .417-.417v-.833a.413.413 0 0 0-.417-.417Zm1.945 1.667h.833a.415.415 0 0 0 .417-.417v-.833a.415.415 0 0 0-.417-.417h-.833a.415.415 0 0 0-.417.417v.833c0 .233.184.417.417.417Zm2.777 0h.834a.415.415 0 0 0 .416-.417v-.833a.415.415 0 0 0-.416-.417h-.834a.415.415 0 0 0-.416.417v.833c0 .233.184.417.416.417Zm2.778 0h.833a.415.415 0 0 0 .417-.417v-.833a.415.415 0 0 0-.417-.417h-.833a.415.415 0 0 0-.417.417v.833c0 .233.184.417.417.417Zm3.611-1.667h-.833a.415.415 0 0 0-.417.417v.833c0 .231.186.417.417.417h.833a.415.415 0 0 0 .417-.417v-.833a.413.413 0 0 0-.417-.417Zm-11.11 2.778h-.834a.415.415 0 0 0-.417.416v.834c0 .23.186.416.417.416h.833a.415.415 0 0 0 .417-.416v-.834a.413.413 0 0 0-.417-.416Zm1.944 1.666h.833a.415.415 0 0 0 .417-.416v-.834a.415.415 0 0 0-.417-.416h-.833a.415.415 0 0 0-.417.416v.834c0 .232.184.416.417.416Zm2.777 0h.834a.415.415 0 0 0 .416-.416v-.834a.415.415 0 0 0-.416-.416h-.834a.415.415 0 0 0-.416.416v.834c0 .232.184.416.416.416Zm2.778 0h.833a.415.415 0 0 0 .417-.416v-.834a.415.415 0 0 0-.417-.416h-.833a.415.415 0 0 0-.417.416v.834c0 .232.184.416.417.416Zm3.611-1.666h-.833a.415.415 0 0 0-.417.416v.834c0 .23.186.416.417.416h.833a.415.415 0 0 0 .417-.416v-.834a.413.413 0 0 0-.417-.416Zm-2.083 3.055H8.11a.553.553 0 0 0-.555.556v.555c0 .309.247.556.555.556h7.778a.554.554 0 0 0 .555-.556v-.555a.553.553 0 0 0-.555-.556Z",
        fill: "currentColor"
      }
    )
  })
);
var Keyboard_default = SvgKeyboard;

// src/Icon/icons/Keynote.tsx
import { jsx as jsx867 } from "react/jsx-runtime";
var SvgKeynote = (props) => /* @__PURE__ */ jsx867(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx867(
      "path",
      {
        d: "m21.82 12.074-2.5-3.437a.936.936 0 0 0-.758-.387H7.626v-.938c0-1.36.972-2.498 2.258-2.756.285.34.699.569 1.18.569h3.124a1.562 1.562 0 1 0 0-3.125h-3.124c-.532 0-.981.283-1.262.69C7.52 3.003 5.75 4.945 5.75 7.312v.937h-.313a.94.94 0 0 0-.758.387l-2.5 3.437a.934.934 0 0 0-.179.551v2.152c0 .551.42.973.938.973h8.124v4.375H7.938a.94.94 0 0 0-.938.938.94.94 0 0 0 .938.937h8.125a.938.938 0 0 0 0-1.875h-3.125V15.75h8.124c.518 0 .938-.42.938-.938v-2.187c0-.2-.063-.39-.18-.55Zm-1.695 1.801H3.875v-.945l2.04-2.805h12.17l2.04 2.805v.945Z",
        fill: "currentColor"
      }
    )
  })
);
var Keynote_default = SvgKeynote;

// src/Icon/icons/L.tsx
import { jsx as jsx868 } from "react/jsx-runtime";
var SvgL = (props) => /* @__PURE__ */ jsx868(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx868(
      "path",
      {
        d: "M17.357 22H6.643a1.07 1.07 0 0 1-1.072-1.071V3.07a1.072 1.072 0 0 1 2.143 0v16.786h9.643a1.072 1.072 0 0 1 0 2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var L_default = SvgL;

// src/Icon/icons/LaptopArrowDown.tsx
import { jsx as jsx869 } from "react/jsx-runtime";
var SvgLaptopArrowDown = (props) => /* @__PURE__ */ jsx869(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx869(
      "path",
      {
        d: "M18.5 6.75V14H20V6.75C20 5.785 19.216 5 18.25 5H14v1.5h4.25a.25.25 0 0 1 .25.25Zm-9.531 3.469a.75.75 0 0 0 0 1.06l2.5 2.5a.75.75 0 0 0 1.06 0l2.5-2.5a.75.75 0 1 0-1.06-1.06L12.75 11.44V5.75c0-.414-.336-.75-.722-.75-.386 0-.778.336-.778.75v5.69l-1.247-1.221A.64.64 0 0 0 9.5 10a.745.745 0 0 0-.531.219ZM21.25 15H2.75a.751.751 0 0 0-.75.75v.5A2.753 2.753 0 0 0 4.75 19h14.5A2.753 2.753 0 0 0 22 16.25v-.5a.75.75 0 0 0-.75-.75Zm-2 2.5H4.75c-.603 0-1.109-.43-1.225-1h16.95c-.116.569-.622 1-1.225 1ZM5.5 6.75a.25.25 0 0 1 .25-.25h4.047V5H5.75C4.785 5 4 5.785 4 6.75V14h1.5V6.75Z",
        fill: "currentColor"
      }
    )
  })
);
var LaptopArrowDown_default = SvgLaptopArrowDown;

// src/Icon/icons/LaptopCode.tsx
import { jsx as jsx870 } from "react/jsx-runtime";
var SvgLaptopCode = (props) => /* @__PURE__ */ jsx870(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx870(
      "path",
      {
        d: "M21.25 15H2.75a.751.751 0 0 0-.75.75v.5A2.753 2.753 0 0 0 4.75 19h14.5A2.753 2.753 0 0 0 22 16.25v-.5a.75.75 0 0 0-.75-.75Zm-2 2.5H4.75c-.603 0-1.109-.43-1.225-1h16.95c-.116.569-.622 1-1.225 1ZM5.5 6.75a.25.25 0 0 1 .25-.25h12.5a.25.25 0 0 1 .25.25V14H20V6.75C20 5.785 19.216 5 18.25 5H5.75C4.785 5 4 5.785 4 6.75V14h1.5V6.75Zm7.934 5.444a.624.624 0 0 0 .883-.001l1.5-1.5a.626.626 0 0 0 0-.885l-1.5-1.5a.625.625 0 1 0-.884.884l1.058 1.058-1.058 1.057a.624.624 0 0 0 .001.887Zm-2.868-3.885a.625.625 0 0 0-.884 0l-1.5 1.5a.626.626 0 0 0 0 .885l1.5 1.5a.63.63 0 0 0 .884 0 .626.626 0 0 0 0-.885L9.509 10.25l1.057-1.056a.678.678 0 0 0 0-.885Z",
        fill: "currentColor"
      }
    )
  })
);
var LaptopCode_default = SvgLaptopCode;

// src/Icon/icons/LaptopFile.tsx
import { jsx as jsx871 } from "react/jsx-runtime";
var SvgLaptopFile = (props) => /* @__PURE__ */ jsx871(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx871(
      "path",
      {
        d: "M3.5 15.5H9V17H3.5A1.5 1.5 0 0 1 2 15.5v-10A1.5 1.5 0 0 1 3.5 4h4.878c.397 0 .781.158 1.063.44l2.118 2.12c.282.282.441.665.441 1.062V10.5h-1.5V8H9c-.553 0-1-.447-1-1V5.5H3.5v10Zm8.25-3.5h7.5c.69 0 1.25.56 1.25 1.25v5.25h.75c.416 0 .75.334.75.75s-.334.75-.75.75H9.75a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h.75v-5.25c0-.69.56-1.25 1.25-1.25Zm.25 1.5v5h7v-5h-7Z",
        fill: "currentColor"
      }
    )
  })
);
var LaptopFile_default = SvgLaptopFile;

// src/Icon/icons/LaptopMobile.tsx
import { jsx as jsx872 } from "react/jsx-runtime";
var SvgLaptopMobile = (props) => /* @__PURE__ */ jsx872(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx872(
      "path",
      {
        d: "M5.5 6a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1H18V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8H2.5a.5.5 0 0 0-.5.5A1.5 1.5 0 0 0 3.5 16H13v-2H5.5V6ZM20 8h-4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-8c0-1.103-.897-2-2-2Zm.5 10a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v8Z",
        fill: "currentColor"
      }
    )
  })
);
var LaptopMobile_default = SvgLaptopMobile;

// src/Icon/icons/LaptopSlash.tsx
import { jsx as jsx873 } from "react/jsx-runtime";
var SvgLaptopSlash = (props) => /* @__PURE__ */ jsx873(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx873(
      "path",
      {
        d: "M4 8.575V14h1.5V9.75L4 8.575Zm.75 8.925c-.603 0-1.109-.43-1.225-1h10.588L12.197 15H2.75a.751.751 0 0 0-.75.75v.5A2.753 2.753 0 0 0 4.75 19H17.3l-1.914-1.5H4.75ZM22 15.75a.75.75 0 0 0-.75-.75h-4.206L6.2 6.5h12.05a.25.25 0 0 1 .25.25V14H20V6.75C20 5.785 19.216 5 18.25 5H5.75c-.384 0-.738.131-1.027.316L3.213 4.16a.75.75 0 1 0-.926 1.18L20.76 19.812a.748.748 0 0 0 .463.188.749.749 0 0 0 .463-1.34l-.565-.443c.549-.498.88-1.189.88-1.967v-.5Zm-2.056 1.522-.988-.772h1.518c-.065.325-.265.566-.53.772Z",
        fill: "currentColor"
      }
    )
  })
);
var LaptopSlash_default = SvgLaptopSlash;

// src/Icon/icons/Laptop.tsx
import { jsx as jsx874 } from "react/jsx-runtime";
var SvgLaptop = (props) => /* @__PURE__ */ jsx874(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx874(
      "path",
      {
        d: "M21.25 15H2.75a.751.751 0 0 0-.75.75v.5A2.753 2.753 0 0 0 4.75 19h14.5A2.753 2.753 0 0 0 22 16.25v-.5a.75.75 0 0 0-.75-.75Zm-2 2.5H4.75c-.603 0-1.109-.43-1.225-1h16.95c-.116.569-.622 1-1.225 1ZM5.5 6.75a.25.25 0 0 1 .25-.25h12.5a.25.25 0 0 1 .25.25V14H20V6.75C20 5.785 19.216 5 18.25 5H5.75C4.785 5 4 5.785 4 6.75V14h1.5V6.75Z",
        fill: "currentColor"
      }
    )
  })
);
var Laptop_default = SvgLaptop;

// src/Icon/icons/Launchpad.tsx
import { jsx as jsx875 } from "react/jsx-runtime";
var SvgLaunchpad = (props) => /* @__PURE__ */ jsx875(
  "svg",
  __spreadProps(__spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx875(
      "path",
      {
        d: "M4.075 11.104c-1.38 0-2.075-.695-2.075-2.13V4.118C2 2.684 2.695 2 4.075 2h4.954c1.38 0 2.075.684 2.075 2.118v4.856c0 1.434-.695 2.13-2.075 2.13H4.075Zm10.907 0c-1.39 0-2.086-.695-2.086-2.13V4.118c0-1.434.695-2.118 2.086-2.118h4.943C21.305 2 22 2.684 22 4.118v4.856c0 1.434-.695 2.13-2.075 2.13h-4.943ZM4.097 9.572h4.9c.38 0 .575-.196.575-.598V4.118c0-.39-.196-.586-.576-.586h-4.9c-.38 0-.564.195-.564.586v4.856c0 .402.184.598.565.598Zm10.907 0h4.9c.38 0 .564-.196.564-.598V4.118c0-.39-.184-.586-.565-.586h-4.9c-.39 0-.575.195-.575.586v4.856c0 .402.185.598.576.598ZM4.075 22C2.695 22 2 21.316 2 19.882v-4.867c0-1.424.695-2.119 2.075-2.119h4.954c1.38 0 2.075.695 2.075 2.119v4.867c0 1.434-.695 2.118-2.075 2.118H4.075Zm10.907 0c-1.39 0-2.086-.684-2.086-2.118v-4.867c0-1.424.695-2.119 2.086-2.119h4.943c1.38 0 2.075.695 2.075 2.119v4.867C22 21.316 21.305 22 19.925 22h-4.943ZM4.097 20.468h4.9c.38 0 .575-.195.575-.586v-4.857c0-.401-.196-.597-.576-.597h-4.9c-.38 0-.564.196-.564.597v4.857c0 .39.184.586.565.586Zm10.907 0h4.9c.38 0 .564-.195.564-.586v-4.857c0-.401-.184-.597-.565-.597h-4.9c-.39 0-.575.196-.575.597v4.857c0 .39.185.586.576.586Z",
        fill: "currentColor"
      }
    )
  })
);
var Launchpad_default = SvgLaunchpad;

// src/Icon/icons/LayerGroup.tsx
import { jsx as jsx876 } from "react/jsx-runtime";
var SvgLayerGroup = (props) => /* @__PURE__ */ jsx876(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx876(
      "path",
      {
        d: "M11.031 2.199C11.336 2.068 11.668 2 12 2c.332 0 .629.068.969.199l8.176 3.504a1.41 1.41 0 0 1 0 2.594L12.969 11.8c-.34.133-.637.199-.969.199a2.43 2.43 0 0 1-.969-.2L2.855 8.298a1.41 1.41 0 0 1 0-2.594l8.176-3.504ZM12 3.875c-.113 0-.191.016-.23.047L4.588 7l7.182 3.078c.039.031.117.047.23.047a.593.593 0 0 0 .23-.047L19.41 7l-7.18-3.078a.594.594 0 0 0-.23-.047Zm-.23 11.203c.039.031.117.047.23.047a.593.593 0 0 0 .23-.047l7.426-3.183a.94.94 0 0 1 1.2-1.36l.355.18c.484.242.789.734.789 1.273 0 .575-.34 1.09-.863 1.313l-8.168 3.5c-.34.133-.637.199-.969.199a2.43 2.43 0 0 1-.969-.2l-8.14-3.488a1.467 1.467 0 0 1-.275-2.546l.402-.29a.937.937 0 0 1 1.307.22.9.9 0 0 1-.095 1.167l7.54 3.215Zm-7.445.617a.9.9 0 0 1-.095 1.168l7.54 3.215c.039.031.117.047.23.047a.593.593 0 0 0 .23-.047l7.426-3.183a.94.94 0 0 1 1.2-1.36l.355.18c.484.242.789.734.789 1.273 0 .575-.34 1.09-.863 1.313l-8.168 3.5c-.34.133-.637.199-.969.199a2.43 2.43 0 0 1-.969-.2l-8.14-3.488a1.467 1.467 0 0 1-.275-2.546l.402-.29a.937.937 0 0 1 1.307.22Z",
        fill: "currentColor"
      }
    )
  })
);
var LayerGroup_default = SvgLayerGroup;

// src/Icon/icons/LayerMinus.tsx
import { jsx as jsx877 } from "react/jsx-runtime";
var SvgLayerMinus = (props) => /* @__PURE__ */ jsx877(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx877(
      "path",
      {
        d: "M21.063 3.172a.782.782 0 0 1 0 1.562h-4.375a.76.76 0 0 1-.782-.78.76.76 0 0 1 .781-.782h4.375ZM11.03 6.027c.305-.132.637-.199.969-.199.332 0 .629.067.969.2l8.176 3.503c.52.223.855.73.855 1.297s-.336 1.074-.855 1.297l-8.176 3.504c-.34.133-.637.2-.969.2a2.43 2.43 0 0 1-.969-.2l-8.176-3.504a1.41 1.41 0 0 1 0-2.594l8.176-3.504ZM12 7.703c-.113 0-.191.016-.23.047l-7.182 3.078 7.182 3.078c.039.031.117.047.23.047a.593.593 0 0 0 .23-.047l7.18-3.078-7.18-3.078a.594.594 0 0 0-.23-.047Zm-.23 11.203c.039.032.117.047.23.047a.593.593 0 0 0 .23-.047l7.426-3.183a.94.94 0 0 1 1.2-1.36l.355.18c.484.242.789.734.789 1.273 0 .575-.34 1.09-.863 1.313l-8.168 3.5c-.34.133-.637.2-.969.2a2.43 2.43 0 0 1-.969-.2l-8.14-3.488a1.467 1.467 0 0 1-.275-2.547l.402-.29a.937.937 0 0 1 1.307.22.9.9 0 0 1-.095 1.167l7.54 3.215Z",
        fill: "currentColor"
      }
    )
  })
);
var LayerMinus_default = SvgLayerMinus;

// src/Icon/icons/LayerPlus.tsx
import { jsx as jsx878 } from "react/jsx-runtime";
var SvgLayerPlus = (props) => /* @__PURE__ */ jsx878(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx878(
      "path",
      {
        d: "M19.656 4.266h1.407a.782.782 0 0 1 0 1.562h-1.407v1.406c0 .43-.351.782-.781.782a.762.762 0 0 1-.781-.782V5.828h-1.407a.76.76 0 0 1-.78-.781.76.76 0 0 1 .78-.781h1.407V2.859a.76.76 0 0 1 .781-.78c.43 0 .781.349.781.78v1.407ZM12.97 7.12l8.176 3.504c.52.223.855.73.855 1.297 0 .566-.336 1.074-.855 1.297l-8.176 3.504c-.34.133-.637.199-.969.199a2.43 2.43 0 0 1-.969-.2L2.855 13.22a1.41 1.41 0 0 1 0-2.594l8.176-3.504c.305-.133.637-.2.969-.2.332 0 .629.067.969.2Zm-8.38 4.8L11.768 15c.04.031.118.047.231.047a.594.594 0 0 0 .23-.047l7.18-3.078-7.18-3.078a.594.594 0 0 0-.23-.047c-.113 0-.191.015-.23.047l-7.182 3.078Zm-.264 3.696a.9.9 0 0 1-.095 1.168L11.77 20c.039.031.117.047.23.047a.594.594 0 0 0 .23-.047l7.426-3.184a.94.94 0 0 1 1.2-1.36l.355.18c.484.243.789.735.789 1.274 0 .574-.34 1.09-.863 1.313l-8.168 3.5c-.34.133-.637.199-.969.199a2.43 2.43 0 0 1-.969-.2l-8.14-3.488a1.467 1.467 0 0 1-.275-2.547l.402-.289a.937.937 0 0 1 1.307.22Z",
        fill: "currentColor"
      }
    )
  })
);
var LayerPlus_default = SvgLayerPlus;

// src/Icon/icons/LeftFromLine.tsx
import { jsx as jsx879 } from "react/jsx-runtime";
var SvgLeftFromLine = (props) => /* @__PURE__ */ jsx879(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx879(
      "path",
      {
        d: "M12.714 17.487V15.57h2.857a2.14 2.14 0 0 0 2.141-2.142V10.57a2.143 2.143 0 0 0-2.14-2.142h-2.858V6.496c0-1.859-2.204-2.836-3.581-1.589l-6.714 6.084A1.417 1.417 0 0 0 2 12c0 .366.14.731.419 1.01l6.714 6.067c1.38 1.244 3.581.267 3.581-1.59ZM4.44 12l6.132-5.42v3.991h5v2.858h-5v3.99L4.44 12ZM22 19.5v-15a1.07 1.07 0 1 0-2.143 0v15a1.072 1.072 0 0 0 2.143 0Z",
        fill: "currentColor"
      }
    )
  })
);
var LeftFromLine_default = SvgLeftFromLine;

// src/Icon/icons/LeftLongToLine.tsx
import { jsx as jsx880 } from "react/jsx-runtime";
var SvgLeftLongToLine = (props) => /* @__PURE__ */ jsx880(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx880(
      "path",
      {
        d: "M2 6.75a.75.75 0 0 1 1.5 0v10.5a.75.75 0 1 1-1.5 0V6.75Zm8.503 8.5a.748.748 0 0 1-1.26.55l-3.502-3.25a.747.747 0 0 1 0-1.1L9.244 8.2a.815.815 0 0 1 .81-.166c.271.147.45.42.45.716v2.5H21.25a.75.75 0 0 1 0 1.5H10.503v2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var LeftLongToLine_default = SvgLeftLongToLine;

// src/Icon/icons/LeftLong.tsx
import { jsx as jsx881 } from "react/jsx-runtime";
var SvgLeftLong = (props) => /* @__PURE__ */ jsx881(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx881(
      "path",
      {
        d: "M7.702 7.125c.34.149.564.49.564.826v3.13h12.83c.519 0 .904.42.904.904 0 .483-.42.94-.904.94H8.266v3.094a.939.939 0 0 1-1.58.689L2.3 12.638a.94.94 0 0 1 0-1.377l4.387-4.069c.272-.149.671-.215 1.015-.067Z",
        fill: "currentColor"
      }
    )
  })
);
var LeftLong_default = SvgLeftLong;

// src/Icon/icons/LeftRight.tsx
import { jsx as jsx882 } from "react/jsx-runtime";
var SvgLeftRight = (props) => /* @__PURE__ */ jsx882(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx882(
      "path",
      {
        d: "m21.716 11.311-4.382-4.069a.96.96 0 0 0-.672-.25.939.939 0 0 0-.94.939v3.13H8.212v-3.13a.939.939 0 0 0-.564-.86.703.703 0 0 0-.34-.079.937.937 0 0 0-.638.25l-4.382 4.07c-.383.355-.383 1.02 0 1.376l4.382 4.07a.936.936 0 0 0 1.013.172.939.939 0 0 0 .564-.861v-3.13h7.512v3.13a.939.939 0 0 0 .904.939.938.938 0 0 0 .639-.25l4.382-4.07a.94.94 0 0 0 .034-1.377Z",
        fill: "currentColor"
      }
    )
  })
);
var LeftRight_default = SvgLeftRight;

// src/Icon/icons/LeftToLine.tsx
import { jsx as jsx883 } from "react/jsx-runtime";
var SvgLeftToLine = (props) => /* @__PURE__ */ jsx883(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx883(
      "path",
      {
        d: "M6.705 11.009c-.28.277-.42.643-.42 1.009 0 .366.14.732.42 1.009l6.715 6.067c1.38 1.245 3.58.268 3.58-1.59V15.59h2.857c1.184 0 2.143-.96 2.143-2.143v-2.857c0-1.184-.96-2.143-2.143-2.143H17V6.513c0-1.858-2.204-2.835-3.582-1.588l-6.713 6.084Zm8.152-.42h5v2.857h-5v3.99l-6.134-5.418 6.134-5.42v3.991ZM4.143 19.5v-15A1.072 1.072 0 0 0 2 4.5v15a1.07 1.07 0 1 0 2.143 0Z",
        fill: "currentColor"
      }
    )
  })
);
var LeftToLine_default = SvgLeftToLine;

// src/Icon/icons/Left.tsx
import { jsx as jsx884 } from "react/jsx-runtime";
var SvgLeft = (props) => /* @__PURE__ */ jsx884(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx884(
      "path",
      {
        d: "M11.835 20.464c.531-.223.88-.745.88-1.321V15.57h7.142c1.184 0 2.143-.96 2.143-2.143v-2.857c0-1.183-.96-2.143-2.143-2.143h-7.143V4.857a1.428 1.428 0 0 0-2.437-1.01L2.42 10.99a1.422 1.422 0 0 0-.001 2.02l7.857 7.143c.407.41 1.023.53 1.559.311ZM4.439 12l6.132-5.42v3.991h9.286v2.857h-9.286v3.99L4.44 12Z",
        fill: "currentColor"
      }
    )
  })
);
var Left_default = SvgLeft;

// src/Icon/icons/LessThanEqual.tsx
import { jsx as jsx885 } from "react/jsx-runtime";
var SvgLessThanEqual = (props) => /* @__PURE__ */ jsx885(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx885(
      "path",
      {
        d: "m4.077 10.486 15 6.428a1.08 1.08 0 0 0 1.408-.564 1.073 1.073 0 0 0-.562-1.407L7.219 9.499l12.7-5.442a1.073 1.073 0 0 0-.845-1.97l-15 6.429a1.075 1.075 0 0 0 .003 1.97Zm16.852 9.37H3.07c-.591 0-1.071.482-1.071 1.072 0 .589.48 1.071 1.071 1.071H20.93a1.072 1.072 0 0 0 0-2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var LessThanEqual_default = SvgLessThanEqual;

// src/Icon/icons/LessThan.tsx
import { jsx as jsx886 } from "react/jsx-runtime";
var SvgLessThan = (props) => /* @__PURE__ */ jsx886(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx886(
      "path",
      {
        d: "M21.286 4.814 6.192 12.001l15.095 7.186c.622.295.886 1.039.59 1.66-.211.408-.663.714-1.173.714-.178 0-.362-.039-.534-.122L2.711 13.126a1.244 1.244 0 0 1 0-2.25l17.46-8.314c.663-.3 1.412-.033 1.708.589.296.622.03 1.32-.593 1.663Z",
        fill: "currentColor"
      }
    )
  })
);
var LessThan_default = SvgLessThan;

// src/Icon/icons/LibraryGridLight.tsx
import { jsx as jsx887 } from "react/jsx-runtime";
var SvgLibraryGridLight = (props) => /* @__PURE__ */ jsx887(
  "svg",
  __spreadProps(__spreadValues({
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx887("g", { id: "Library-grid-light", children: /* @__PURE__ */ jsx887(
      "path",
      {
        id: "grid",
        d: "M4.57496 11.1037C3.19527 11.1037 2.5 10.4085 2.5 8.97447V4.11841C2.5 2.68441 3.19527 2 4.57496 2H9.52879C10.9085 2 11.6037 2.68441 11.6037 4.11841V8.97447C11.6037 10.4085 10.9085 11.1037 9.52879 11.1037H4.57496ZM15.4821 11.1037C14.0915 11.1037 13.3963 10.4085 13.3963 8.97447V4.11841C13.3963 2.68441 14.0915 2 15.4821 2H20.425C21.8047 2 22.5 2.68441 22.5 4.11841V8.97447C22.5 10.4085 21.8047 11.1037 20.425 11.1037H15.4821ZM4.59669 9.57197H9.4962C9.87643 9.57197 10.072 9.37643 10.072 8.97447V4.11841C10.072 3.72732 9.87643 3.53178 9.4962 3.53178H4.59669C4.21646 3.53178 4.03178 3.72732 4.03178 4.11841V8.97447C4.03178 9.37643 4.21646 9.57197 4.59669 9.57197ZM15.5038 9.57197H20.4033C20.7835 9.57197 20.9682 9.37643 20.9682 8.97447V4.11841C20.9682 3.72732 20.7835 3.53178 20.4033 3.53178H15.5038C15.1127 3.53178 14.928 3.72732 14.928 4.11841V8.97447C14.928 9.37643 15.1127 9.57197 15.5038 9.57197ZM4.57496 22C3.19527 22 2.5 21.3156 2.5 19.8816V15.0147C2.5 13.5915 3.19527 12.8963 4.57496 12.8963H9.52879C10.9085 12.8963 11.6037 13.5915 11.6037 15.0147V19.8816C11.6037 21.3156 10.9085 22 9.52879 22H4.57496ZM15.4821 22C14.0915 22 13.3963 21.3156 13.3963 19.8816V15.0147C13.3963 13.5915 14.0915 12.8963 15.4821 12.8963H20.425C21.8047 12.8963 22.5 13.5915 22.5 15.0147V19.8816C22.5 21.3156 21.8047 22 20.425 22H15.4821ZM4.59669 20.4682H9.4962C9.87643 20.4682 10.072 20.2727 10.072 19.8816V15.0255C10.072 14.6236 9.87643 14.428 9.4962 14.428H4.59669C4.21646 14.428 4.03178 14.6236 4.03178 15.0255V19.8816C4.03178 20.2727 4.21646 20.4682 4.59669 20.4682ZM15.5038 20.4682H20.4033C20.7835 20.4682 20.9682 20.2727 20.9682 19.8816V15.0255C20.9682 14.6236 20.7835 14.428 20.4033 14.428H15.5038C15.1127 14.428 14.928 14.6236 14.928 15.0255V19.8816C14.928 20.2727 15.1127 20.4682 15.5038 20.4682Z",
        fill: "currentColor"
      }
    ) })
  })
);
var LibraryGridLight_default = SvgLibraryGridLight;

// src/Icon/icons/LightbulbOn.tsx
import { jsx as jsx888 } from "react/jsx-runtime";
var SvgLightbulbOn = (props) => /* @__PURE__ */ jsx888(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx888(
      "path",
      {
        d: "m5.347 12.977-1.734 1a.757.757 0 0 0-.387.653c0 .27.145.52.38.656a.751.751 0 0 0 .757-.012l1.734-1a.752.752 0 0 0 .262-1.015.746.746 0 0 0-1.012-.282Zm.75-7.251-1.735-1a.751.751 0 0 0-.757-.012.761.761 0 0 0-.38.656.758.758 0 0 0 .388.653l1.734 1a.75.75 0 0 0 .76.011.76.76 0 0 0 .377-.656.755.755 0 0 0-.387-.652ZM5.5 9.999a.75.75 0 0 0-.75-.75h-2a.75.75 0 0 0 0 1.5h2c.416 0 .75-.334.75-.75Zm12.781-2.875a.761.761 0 0 0 .375-.101l1.73-1a.748.748 0 0 0 .263-1.016.747.747 0 0 0-1.012-.281l-1.73 1a.75.75 0 0 0 .374 1.398ZM21.25 9.25h-2a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5Zm-.863 4.728-1.734-1a.751.751 0 0 0-.758-.011.76.76 0 0 0-.378.656.756.756 0 0 0 .386.652l1.735 1c.355.2.809.075 1.012-.28a.752.752 0 0 0-.262-1.017ZM12 4a5.487 5.487 0 0 0-5.5 5.472 5.47 5.47 0 0 0 1.36 3.619c.517.588 1.324 1.82 1.632 2.858l.004.024h5.01l.002-.024c.309-1.038 1.116-2.27 1.633-2.858.847-.94 1.359-2.203 1.359-3.619 0-3.01-2.463-5.472-5.5-5.472Zm3.012 8.128c-.489.558-1.095 1.447-1.532 2.372h-2.957c-.438-.925-1.043-1.814-1.532-2.371A4.044 4.044 0 0 1 8 9.47c0-1.931 1.503-3.964 3.972-3.972C14.206 5.5 16 7.293 16 9.471c0 .969-.35 1.928-.988 2.656ZM9.503 18.2c0 .197.06.389.168.553l.534.803c.164.246.537.446.832.446h1.93c.294 0 .667-.2.831-.446l.534-.803c.093-.14.168-.387.168-.553V17H9.503v1.2ZM11.5 6.5A2.503 2.503 0 0 0 9 9a.5.5 0 1 0 1 0c0-.827.673-1.5 1.5-1.5a.5.5 0 1 0 0-1Z",
        fill: "currentColor"
      }
    )
  })
);
var LightbulbOn_default = SvgLightbulbOn;

// src/Icon/icons/LightbulbSlash.tsx
import { jsx as jsx889 } from "react/jsx-runtime";
var SvgLightbulbSlash = (props) => /* @__PURE__ */ jsx889(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx889(
      "path",
      {
        d: "m21.718 18.661-6.133-4.807c.197-.29.393-.55.557-.738a5.468 5.468 0 0 0 1.36-3.62 5.47 5.47 0 0 0-5.473-5.473c-2.336-.018-4.124 1.29-4.98 3.141L3.212 4.158a.75.75 0 0 0-.926 1.18l18.477 14.476a.749.749 0 0 0 .463.188.749.749 0 0 0 .59-.287.724.724 0 0 0-.1-1.054Zm-7.315-5.733L8.258 8.111c.497-1.427 1.844-2.607 3.716-2.613 2.235 0 4.03 1.795 4.03 3.973 0 .968-.352 1.903-.99 2.63-.192.246-.401.496-.61.827Zm-2.841 1.573h-1.039a11.2 11.2 0 0 0-.865-1.493l-3.029-2.374c.198.937.597 1.79 1.234 2.484.517.589 1.324 1.82 1.633 2.859l.003.024h3.979l-1.916-1.5Zm-2.057 3.697c0 .197.059.389.167.553l.536.803c.164.246.537.446.833.446h1.927c.295 0 .668-.2.832-.446l.534-.803c.091-.138.167-.386.167-.553L14.505 17H9.474l.031 1.2Z",
        fill: "currentColor"
      }
    )
  })
);
var LightbulbSlash_default = SvgLightbulbSlash;

// src/Icon/icons/Lightbulb.tsx
import { jsx as jsx890 } from "react/jsx-runtime";
var SvgLightbulb = (props) => /* @__PURE__ */ jsx890(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx890(
      "path",
      {
        d: "M8.879 19.747c0 .247.07.486.206.692l.67 1.003c.205.308.67.558 1.04.558h2.41c.368 0 .834-.25 1.04-.558l.666-1.003c.115-.173.21-.483.21-.692l.004-1.53h-6.25l.004 1.53ZM12 2a6.86 6.86 0 0 0-6.875 6.84c0 1.734.642 3.315 1.701 4.524.646.736 1.654 2.275 2.04 3.573l.005.03h6.258l.005-.03c.386-1.298 1.395-2.837 2.04-3.573 1.06-1.176 1.702-2.754 1.702-4.524C18.876 5.078 15.797 2 12 2Zm3.766 10.16c-.612.698-1.369 1.81-1.916 2.966h-3.696c-.547-1.156-1.305-2.268-1.916-2.965A5.064 5.064 0 0 1 7 8.841c0-2.415 1.879-4.956 4.965-4.966C14.758 3.875 17 6.118 17 8.84a5.07 5.07 0 0 1-1.234 3.32Zm-4.391-7.035A3.13 3.13 0 0 0 8.25 8.25a.625.625 0 1 0 1.25 0c0-1.034.84-1.875 1.875-1.875a.624.624 0 1 0 0-1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var Lightbulb_default = SvgLightbulb;

// src/Icon/icons/LineColumns.tsx
import { jsx as jsx891 } from "react/jsx-runtime";
var SvgLineColumns = (props) => /* @__PURE__ */ jsx891(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx891(
      "path",
      {
        d: "M9.813 3.563a.937.937 0 1 1 0 1.874H2.936a.938.938 0 0 1 0-1.875h6.876Zm0 5c.519 0 .937.417.937.937s-.418.938-.938.938H2.939a.937.937 0 1 1 0-1.876h6.874ZM2 14.5c0-.52.42-.938.938-.938h6.874c.52 0 .938.418.938.938s-.418.938-.938.938H2.939A.937.937 0 0 1 2 14.5Zm7.813 4.063c.519 0 .937.418.937.937 0 .52-.418.938-.938.938H2.939a.937.937 0 1 1 0-1.875h6.874ZM13.25 9.5c0-.52.418-.938.938-.938h6.874c.52 0 .938.418.938.938s-.418.938-.938.938h-6.875a.935.935 0 0 1-.937-.938Zm7.813-5.938a.937.937 0 1 1 0 1.876h-6.875a.937.937 0 1 1 0-1.875h6.874ZM13.25 14.5c0-.52.418-.938.938-.938h6.874c.52 0 .938.418.938.938s-.418.938-.938.938h-6.875a.935.935 0 0 1-.937-.938Zm7.813 4.063c.519 0 .937.418.937.937 0 .52-.418.938-.938.938h-6.875a.935.935 0 0 1-.937-.938c0-.52.418-.938.938-.938h6.874Z",
        fill: "currentColor"
      }
    )
  })
);
var LineColumns_default = SvgLineColumns;

// src/Icon/icons/LineHeight.tsx
import { jsx as jsx892 } from "react/jsx-runtime";
var SvgLineHeight = (props) => /* @__PURE__ */ jsx892(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx892(
      "path",
      {
        d: "M8.451 7.274c.31.344.282.84-.059 1.177a.834.834 0 0 1-1.177-.059L6.167 7.226v9.548l1.048-1.166a.834.834 0 0 1 1.236 1.118l-2.5 2.777a.833.833 0 0 1-1.237 0l-2.5-2.777a.833.833 0 0 1 1.239-1.118L4.5 16.774V7.226L3.453 8.392a.834.834 0 0 1-1.177.06c-.342-.337-.37-.834-.062-1.178l2.5-2.776a.834.834 0 0 1 1.237 0l2.5 2.776Zm12.716-1.663a.832.832 0 1 1 0 1.667H10.61a.832.832 0 1 1 0-1.667h10.556Zm0 5.556c.461 0 .833.371.833.833a.831.831 0 0 1-.833.833H10.61A.831.831 0 0 1 9.778 12c0-.462.371-.833.833-.833h10.556Zm-11.39 6.389c0-.462.372-.834.834-.834h10.556c.461 0 .833.372.833.834a.831.831 0 0 1-.833.833H10.61a.831.831 0 0 1-.833-.833Z",
        fill: "currentColor"
      }
    )
  })
);
var LineHeight_default = SvgLineHeight;

// src/Icon/icons/LinesLeaning.tsx
import { jsx as jsx893 } from "react/jsx-runtime";
var SvgLinesLeaning = (props) => /* @__PURE__ */ jsx893(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx893(
      "path",
      {
        d: "M19.5 2c.593 0 1.071.48 1.071 1.072v17.855c0 .594-.478 1.072-1.071 1.072a1.069 1.069 0 0 1-1.072-1.072V3.072A1.07 1.07 0 0 1 19.5 2Zm-4.076.021c.58.116.955.68.84 1.26l-3.572 17.856a1.069 1.069 0 1 1-2.098-.42l3.571-17.855a1.07 1.07 0 0 1 1.26-.841Zm-4.133.043c.557.2.848.814.647 1.37L5.508 21.29a1.071 1.071 0 1 1-2.015-.723L9.92 2.709c.201-.557.817-.846 1.37-.645Z",
        fill: "currentColor"
      }
    )
  })
);
var LinesLeaning_default = SvgLinesLeaning;

// src/Icon/icons/LinkHorizontalSlash.tsx
import { jsx as jsx894 } from "react/jsx-runtime";
var SvgLinkHorizontalSlash = (props) => /* @__PURE__ */ jsx894(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx894(
      "path",
      {
        d: "M5.66 6.077c.271-.05.55-.077.837-.077h5.006a4.496 4.496 0 0 1 3.46 7.369l3.7 2.9a3.028 3.028 0 0 0 1.837-2.766 2.994 2.994 0 0 0-2.797-2.988l-.253-.018a.747.747 0 0 1-.697-.797.747.747 0 0 1 .797-.697l.253.016a4.496 4.496 0 0 1 2.147 8.26l1.762 1.38a.75.75 0 0 1-.925 1.181l-18.5-14.5a.75.75 0 1 1 .926-1.18l2.446 1.917ZM7.474 7.5l6.278 4.944a2.866 2.866 0 0 0 .747-1.947A2.995 2.995 0 0 0 11.503 7.5H7.475ZM12.497 18a4.496 4.496 0 0 1-4.219-6.053L9.55 12.95a2.995 2.995 0 0 0 2.947 3.55h1.56l1.905 1.5h-3.465ZM2.942 7.74l1.178.932a2.995 2.995 0 0 0 2.177 4.812l.253.019a.747.747 0 0 1 .697.797.747.747 0 0 1-.797.697l-.253-.016a4.494 4.494 0 0 1-3.255-7.24Z",
        fill: "currentColor"
      }
    )
  })
);
var LinkHorizontalSlash_default = SvgLinkHorizontalSlash;

// src/Icon/icons/LinkHorizontal.tsx
import { jsx as jsx895 } from "react/jsx-runtime";
var SvgLinkHorizontal = (props) => /* @__PURE__ */ jsx895(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx895(
      "path",
      {
        d: "M11.503 6a4.496 4.496 0 0 1 .3 8.981l-.253.016a.747.747 0 0 1-.797-.697.747.747 0 0 1 .697-.797l.253-.019a2.995 2.995 0 0 0-.2-5.984H6.497a2.996 2.996 0 0 0-.2 5.984l.253.02a.747.747 0 0 1 .697.796.747.747 0 0 1-.797.697l-.253-.016A4.496 4.496 0 0 1 6.497 6h5.006Zm.994 12A4.496 4.496 0 0 1 8 13.503a4.499 4.499 0 0 1 4.194-4.487l.225-.013a.747.747 0 0 1 .797.697.747.747 0 0 1-.697.797l-.222.015a2.997 2.997 0 0 0 .2 5.988h5.006a2.995 2.995 0 0 0 .2-5.984l-.253-.02a.747.747 0 0 1-.697-.796.747.747 0 0 1 .797-.697l.253.016a4.496 4.496 0 0 1-.3 8.981h-5.006Z",
        fill: "currentColor"
      }
    )
  })
);
var LinkHorizontal_default = SvgLinkHorizontal;

// src/Icon/icons/LinkSimpleSlash.tsx
import { jsx as jsx896 } from "react/jsx-runtime";
var SvgLinkSimpleSlash = (props) => /* @__PURE__ */ jsx896(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx896(
      "path",
      {
        d: "M3.213 4.16a.75.75 0 0 0-.925 1.18l18.5 14.5a.75.75 0 0 0 .924-1.18l-3.075-2.41A4.996 4.996 0 0 0 21 12c0-2.762-2.238-5-5-5h-2.25a.748.748 0 0 0-.75.75c0 .416.334.75.75.75H16c1.934 0 3.5 1.566 3.5 3.5 0 1.456-.89 2.706-2.16 3.234l-3.168-2.484h1.078c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-2.99L8.75 8.5h1.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75H8c-.353 0-.697.038-1.028.106L3.212 4.16Zm2.175 5.509L4.21 8.74A4.998 4.998 0 0 0 8 17h2.25c.416-.001.75-.335.75-.751a.748.748 0 0 0-.75-.75H8A3.498 3.498 0 0 1 4.5 12c0-.894.335-1.713.888-2.331Z",
        fill: "currentColor"
      }
    )
  })
);
var LinkSimpleSlash_default = SvgLinkSimpleSlash;

// src/Icon/icons/LinkSimple.tsx
import { jsx as jsx897 } from "react/jsx-runtime";
var SvgLinkSimple = (props) => /* @__PURE__ */ jsx897(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx897(
      "path",
      {
        d: "M2 12a5.554 5.554 0 0 1 5.556-5.556h2.5c.461 0 .833.372.833.834a.831.831 0 0 1-.833.833h-2.5A3.887 3.887 0 0 0 3.666 12c0 2.15 1.74 3.889 3.89 3.889h2.5c.461 0 .833.371.833.833a.831.831 0 0 1-.833.834h-2.5A5.554 5.554 0 0 1 2 12Zm20 0a5.554 5.554 0 0 1-5.556 5.556h-2.5a.831.831 0 0 1-.833-.834c0-.462.372-.833.833-.833h2.5c2.15 0 3.89-1.74 3.89-3.889 0-2.15-1.74-3.889-3.89-3.889h-2.5a.831.831 0 0 1-.833-.833c0-.462.372-.834.833-.834h2.5A5.554 5.554 0 0 1 22 12Zm-13.611-.833h7.222c.462 0 .833.371.833.833a.831.831 0 0 1-.833.833H8.39A.831.831 0 0 1 7.556 12c0-.462.371-.833.833-.833Z",
        fill: "currentColor"
      }
    )
  })
);
var LinkSimple_default = SvgLinkSimple;

// src/Icon/icons/LinkSlash.tsx
import { jsx as jsx898 } from "react/jsx-runtime";
var SvgLinkSlash = (props) => /* @__PURE__ */ jsx898(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx898(
      "path",
      {
        d: "M7.803 7.756a4.494 4.494 0 0 1 5.962.353c1.354 1.353 1.644 3.372.913 5.038l1.425 1.115 2.972-2.972a2.995 2.995 0 0 0-4.09-4.373l-.194.167a.749.749 0 0 1-.988-1.128l.194-.168a4.493 4.493 0 0 1 6.137.205 4.494 4.494 0 0 1 0 6.357l-2.843 2.844 4.421 3.465a.75.75 0 0 1-.925 1.181l-18.5-14.5a.75.75 0 1 1 .926-1.18l4.59 3.596Zm1.231.966 4.413 3.46a2.996 2.996 0 0 0-.744-3.013c-.994-.997-2.544-1.144-3.669-.447Zm1.2 7.168a4.473 4.473 0 0 1-1.31-3.434l1.695 1.335c.143.378.372.734.675 1.04.459.485 1.096.769 1.725.85l1.697 1.338a4.505 4.505 0 0 1-4.482-1.128Zm-4.59-6.018 1.187.934-1.905 1.903a2.997 2.997 0 0 0 0 4.238c1.115 1.087 2.905 1.175 4.09.137l.193-.168a.75.75 0 0 1 .987 1.128l-.193.168a4.492 4.492 0 0 1-6.138-.206c-1.755-1.753-1.755-4.628 0-6.356l1.779-1.778Z",
        fill: "currentColor"
      }
    )
  })
);
var LinkSlash_default = SvgLinkSlash;

// src/Icon/icons/Link.tsx
import { jsx as jsx899 } from "react/jsx-runtime";
var SvgLink = (props) => /* @__PURE__ */ jsx899(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx899(
      "path",
      {
        d: "M7.14 7.884a4.756 4.756 0 0 1 6.943 6.494l-.175.201a.795.795 0 0 1-1.197-1.045l.178-.201a3.17 3.17 0 0 0-.145-4.328c-1.237-1.267-3.244-1.267-4.51 0L4.515 12.75a3.17 3.17 0 0 0 0 4.483c1.18 1.15 3.074 1.243 4.327.146l.205-.179a.791.791 0 0 1 1.118.076c.29.328.255.83-.073 1.118l-.205.178a4.755 4.755 0 0 1-6.494-.218c-1.857-1.855-1.857-4.897 0-6.725L7.14 7.884Zm9.72 8.233a4.757 4.757 0 0 1-6.728 0 4.73 4.73 0 0 1-.218-6.494l.155-.178a.795.795 0 0 1 1.197 1.044l-.155.179a3.17 3.17 0 0 0 4.628 4.328l3.746-3.746a3.17 3.17 0 0 0-4.328-4.627l-.204.176a.792.792 0 0 1-1.045-1.194l.205-.177a4.755 4.755 0 0 1 6.494 6.943l-3.747 3.746Z",
        fill: "currentColor"
      }
    )
  })
);
var Link_default = SvgLink;

// src/Icon/icons/ListCheck.tsx
import { jsx as jsx900 } from "react/jsx-runtime";
var SvgListCheck = (props) => /* @__PURE__ */ jsx900(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx900(
      "path",
      {
        d: "M5.197 8.566a.804.804 0 0 1-.672.274c-.257.043-.506-.059-.688-.274L2.275 7.004c-.367-.332-.367-.926 0-1.292a.938.938 0 0 1 1.325 0l.864.862 2.153-2.389a.938.938 0 1 1 1.39 1.255l-2.81 3.126Zm0 6.25a.803.803 0 0 1-.672.274c-.257.043-.506-.059-.688-.274l-1.562-1.562c-.367-.332-.367-.926 0-1.293a.943.943 0 0 1 1.325 0l.864.863 2.153-2.39a.938.938 0 0 1 1.39 1.258l-2.81 3.124Zm5.24-7.503a.936.936 0 1 1 0-1.875h10.626a.937.937 0 1 1 0 1.875H10.438ZM9.5 12.625c0-.52.418-.937.938-.937h10.624c.52 0 .938.417.938.937s-.418.938-.938.938H10.438a.935.935 0 0 1-.937-.938Zm-1.25 6.25c0-.52.418-.937.938-.937h11.874c.52 0 .938.418.938.937 0 .52-.418.938-.938.938H9.188a.935.935 0 0 1-.937-.938Zm-3.75 1.25a1.25 1.25 0 1 1-.001-2.499 1.25 1.25 0 0 1 .001 2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var ListCheck_default = SvgListCheck;

// src/Icon/icons/ListDropdown.tsx
import { jsx as jsx901 } from "react/jsx-runtime";
var SvgListDropdown = (props) => /* @__PURE__ */ jsx901(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx901(
      "path",
      {
        d: "M17 11.063c.52 0 .938.417.938.937s-.418.938-.938.938H7A.935.935 0 0 1 6.062 12c0-.52.418-.938.938-.938h10Zm0 3.75c.52 0 .938.417.938.937s-.418.938-.938.938H7a.935.935 0 0 1-.938-.938c0-.52.418-.938.938-.938h10ZM2 5.75a2.5 2.5 0 0 1 2.5-2.5h15c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75ZM3.875 9.5v8.75c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625V9.5H3.875Zm15.184-3.75H16.19a.313.313 0 0 0-.218.535l1.43 1.43c.124.125.32.125.445 0l1.43-1.43c.199-.2.058-.535-.22-.535Z",
        fill: "currentColor"
      }
    )
  })
);
var ListDropdown_default = SvgListDropdown;

// src/Icon/icons/ListOl.tsx
import { jsx as jsx902 } from "react/jsx-runtime";
var SvgListOl = (props) => /* @__PURE__ */ jsx902(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx902(
      "path",
      {
        d: "M2.6 4.064c0-.526.461-.952.952-.952h1.27a.93.93 0 0 1 .952.952v4.76h.635a.93.93 0 0 1 .952.953.928.928 0 0 1-.952.952H3.234c-.49 0-.952-.424-.952-.952 0-.524.462-.952.952-.952h.635V5.017h-.317c-.49 0-.953-.427-.953-.953ZM5.122 15.38a.61.61 0 0 0-.954.048l-.442.615a.952.952 0 0 1-1.55-1.103l.442-.62a2.511 2.511 0 0 1 3.937-.194c.845.933.825 2.417-.044 3.361l-1.385 1.496h1.317a.95.95 0 0 1 .953.953.95.95 0 0 1-.953.952H2.952a.952.952 0 0 1-.7-1.6l2.86-3.094c.21-.23.213-.58.011-.814ZM21.048 4.698a.951.951 0 1 1 0 1.904H10.254a.951.951 0 1 1 0-1.905h10.794Zm0 6.349a.95.95 0 0 1 .952.952.95.95 0 0 1-.952.953H10.254a.95.95 0 0 1-.952-.953.95.95 0 0 1 .952-.952h10.794Zm0 6.349a.95.95 0 0 1 .952.952.95.95 0 0 1-.952.953H10.254a.95.95 0 0 1-.952-.953.95.95 0 0 1 .952-.952h10.794Z",
        fill: "currentColor"
      }
    )
  })
);
var ListOl_default = SvgListOl;

// src/Icon/icons/ListRadio.tsx
import { jsx as jsx903 } from "react/jsx-runtime";
var SvgListRadio = (props) => /* @__PURE__ */ jsx903(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx903(
      "path",
      {
        d: "M4.5 3.25a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm16.563 1.563a.937.937 0 1 1 0 1.875H9.188a.936.936 0 1 1 0-1.875h11.874Zm0 6.25c.519 0 .937.417.937.937s-.418.938-.938.938H9.188A.935.935 0 0 1 8.25 12c0-.52.418-.938.938-.938h11.874Zm0 6.25c.519 0 .937.418.937.937 0 .52-.418.938-.938.938H9.188a.935.935 0 0 1-.937-.938c0-.52.418-.938.938-.938h11.874ZM4.5 9.5a2.501 2.501 0 0 1 0 5 2.501 2.501 0 0 1 0-5ZM3.562 12a.937.937 0 1 0 1.876 0 .937.937 0 1 0-1.875 0Zm.938 8.75a2.501 2.501 0 0 1 0-5 2.501 2.501 0 0 1 0 5Zm.938-2.5a.937.937 0 1 0-1.875 0 .937.937 0 1 0 1.874 0Z",
        fill: "currentColor"
      }
    )
  })
);
var ListRadio_default = SvgListRadio;

// src/Icon/icons/ListSearch.tsx
import { jsx as jsx904 } from "react/jsx-runtime";
var SvgListSearch = (props) => /* @__PURE__ */ jsx904(
  "svg",
  __spreadProps(__spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx904(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.604 18.678h11.733a4.767 4.767 0 0 1-1.668-1.284H3.621c-.83 0-1.286-.422-1.286-1.252V6.543c0-.829.456-1.26 1.286-1.26h14.313c.82 0 1.285.431 1.285 1.26v3.745a4.81 4.81 0 0 1 1.335.794v-4.61C20.554 4.829 19.692 4 17.95 4H3.604C1.87 4 1 4.83 1 6.472v9.742c0 1.643.87 2.464 2.604 2.464Zm8.641-3.046a.503.503 0 0 0 .466-.269 4.42 4.42 0 0 1-.067-.532.512.512 0 0 0-.399-.18H5.229a.498.498 0 0 0-.514.503c0 .271.216.478.514.478h7.016Zm-7.754-2.415h8.345c.591-1.892 2.416-3.27 4.575-3.27.218 0 .432.015.642.042-.166-.338-.506-.536-.982-.536H4.491c-.688 0-1.094.415-1.094 1.069v1.626c0 .654.406 1.069 1.094 1.069Zm.738-5.199h7.016c.299 0 .514-.215.514-.494 0-.271-.216-.486-.514-.486H5.229c-.298 0-.514.215-.514.486 0 .279.216.494.514.494Zm.009 3.811c-.299 0-.523-.215-.523-.494 0-.271.224-.486.523-.486h4.08c.298 0 .514.215.514.486 0 .279-.216.494-.514.494h-4.08Zm12.258 6.445c-2.095 0-3.8-1.639-3.8-3.653 0-2.014 1.705-3.653 3.8-3.653 2.095 0 3.8 1.639 3.8 3.653 0 .833-.291 1.598-.781 2.211l2.328 2.252c.1.097.157.23.157.376 0 .307-.224.54-.548.54a.573.573 0 0 1-.404-.156l-2.343-2.256a3.87 3.87 0 0 1-2.21.686Zm0-6.523c-1.648 0-2.986 1.286-2.986 2.87s1.338 2.87 2.986 2.87c1.647 0 2.985-1.286 2.985-2.87s-1.338-2.87-2.985-2.87Z",
        fill: "currentColor"
      }
    )
  })
);
var ListSearch_default = SvgListSearch;

// src/Icon/icons/ListTimeline.tsx
import { jsx as jsx905 } from "react/jsx-runtime";
var SvgListTimeline = (props) => /* @__PURE__ */ jsx905(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx905(
      "path",
      {
        d: "m6.804 4.862 1.804-1.805c.25-.25.592-.39.946-.39H18c.738 0 1.333.597 1.333 1.333v2.667C19.333 7.404 18.738 8 18 8H9.554a1.34 1.34 0 0 1-.946-.392L6.804 5.804a.67.67 0 0 1 0-.942Zm10.53 1.1V4.63H9.828l-.667.667.667.667h7.504Zm-14-2c.736 0 1.333.635 1.333 1.334a1.31 1.31 0 0 1-1.334 1.333A1.31 1.31 0 0 1 2 5.296c0-.699.597-1.334 1.333-1.334Zm0 6.667c.736 0 1.333.633 1.333 1.334a1.31 1.31 0 0 1-1.334 1.333A1.31 1.31 0 0 1 2 11.963c0-.7.597-1.334 1.333-1.334Zm0 9.371a1.333 1.333 0 1 1-.002-2.665A1.333 1.333 0 0 1 3.333 20Zm3.47-1.804 1.804-1.804c.25-.25.592-.392.946-.392H18c.738 0 1.333.596 1.333 1.333V20c0 .738-.595 1.333-1.333 1.333H9.554a1.34 1.34 0 0 1-.946-.391l-1.804-1.805a.669.669 0 0 1 0-.941Zm10.53 1.137V18H9.828l-.667.667.667.666h7.504Zm-8.726-5.058-1.804-1.804a.669.669 0 0 1 0-.942l1.804-1.804c.25-.25.592-.392.946-.392h11.113c.737 0 1.333.596 1.333 1.334v2.666c0 .738-.596 1.334-1.333 1.334H9.554a1.34 1.34 0 0 1-.946-.392Zm.554-2.313.667.667H20v-1.333H9.83l-.668.667Z",
        fill: "currentColor"
      }
    )
  })
);
var ListTimeline_default = SvgListTimeline;

// src/Icon/icons/ListTree.tsx
import { jsx as jsx906 } from "react/jsx-runtime";
var SvgListTree = (props) => /* @__PURE__ */ jsx906(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx906(
      "path",
      {
        d: "M4.813 3.875c.517 0 .937.42.937.938v1.875c0 .519-.42.937-.938.937v3.438H7c0-.52.418-.938.938-.938h1.875c.519 0 .937.418.937.938v1.874c0 .52-.418.938-.938.938H7.938A.935.935 0 0 1 7 12.937H4.812V17c0 .172.14.313.313.313H7c0-.52.418-.938.938-.938h1.875c.519 0 .937.418.937.938v1.875c0 .519-.418.937-.938.937H7.938A.935.935 0 0 1 7 19.187H5.125A2.188 2.188 0 0 1 2.937 17V7.625A.936.936 0 0 1 2 6.687V4.813c0-.517.42-.937.938-.937h1.874ZM8.25 5.75c0-.518.418-.938.938-.938h11.874a.937.937 0 1 1 0 1.875H9.188a.935.935 0 0 1-.937-.937Zm5 6.25c0-.52.418-.938.938-.938h6.874c.52 0 .938.418.938.938s-.418.938-.938.938h-6.875A.935.935 0 0 1 13.25 12Zm0 6.25c0-.52.418-.938.938-.938h6.874c.52 0 .938.418.938.938s-.418.938-.938.938h-6.875a.935.935 0 0 1-.937-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var ListTree_default = SvgListTree;

// src/Icon/icons/ListUl.tsx
import { jsx as jsx907 } from "react/jsx-runtime";
var SvgListUl = (props) => /* @__PURE__ */ jsx907(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx907(
      "path",
      {
        d: "M3.333 4a1.334 1.334 0 1 1 0 2.667 1.334 1.334 0 0 1 0-2.667ZM21 4.333a.999.999 0 1 1 0 2H8.333a.999.999 0 1 1 0-2H21ZM21 11c.554 0 1 .446 1 1s-.446 1-1 1H8.333c-.554 0-1-.446-1-1s.446-1 1-1H21Zm0 6.667c.554 0 1 .445 1 1 0 .554-.446 1-1 1H8.333c-.554 0-1-.446-1-1 0-.555.446-1 1-1H21ZM3.333 13.333a1.333 1.333 0 1 1-.001-2.665 1.333 1.333 0 0 1 .001 2.665Zm0 4A1.333 1.333 0 1 1 3.334 20a1.333 1.333 0 0 1 0-2.666Z",
        fill: "currentColor"
      }
    )
  })
);
var ListUl_default = SvgListUl;

// src/Icon/icons/List.tsx
import { jsx as jsx908 } from "react/jsx-runtime";
var SvgList = (props) => /* @__PURE__ */ jsx908(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx908(
      "path",
      {
        d: "M4.903 3.613c.537 0 .968.433.968.968v1.935a.965.965 0 0 1-.968.968H2.968A.967.967 0 0 1 2 6.516V4.581c0-.535.433-.968.968-.968h1.935Zm16.13.968a.967.967 0 1 1 0 1.935H8.773a.967.967 0 1 1 0-1.935h12.258Zm0 6.451c.535 0 .967.432.967.968a.965.965 0 0 1-.968.968H8.774A.965.965 0 0 1 7.806 12c0-.536.432-.968.968-.968h12.258Zm0 6.452c.535 0 .967.431.967.968a.965.965 0 0 1-.968.967H8.774a.965.965 0 0 1-.968-.967c0-.537.432-.968.968-.968h12.258ZM2 11.032c0-.536.433-.967.968-.967h1.935c.537 0 .968.431.968.967v1.936a.965.965 0 0 1-.968.967H2.968A.967.967 0 0 1 2 12.968v-1.936Zm2.903 5.484c.537 0 .968.432.968.968v1.935a.965.965 0 0 1-.968.968H2.968A.967.967 0 0 1 2 19.42v-1.935c0-.536.433-.968.968-.968h1.935Z",
        fill: "currentColor"
      }
    )
  })
);
var List_default = SvgList;

// src/Icon/icons/Loader.tsx
import { jsx as jsx909 } from "react/jsx-runtime";
var SvgLoader = (props) => /* @__PURE__ */ jsx909(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx909(
      "path",
      {
        d: "M12.938 6.063c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938V2.938a.937.937 0 1 1 1.876 0v3.126Zm0 15c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938v-3.125c0-.519.418-.937.938-.937s.938.418.938.938v3.125ZM2 12c0-.52.42-.938.938-.938h3.124c.52 0 .938.418.938.938s-.418.938-.938.938H2.938A.937.937 0 0 1 2 12Zm19.063-.938c.519 0 .937.418.937.938s-.418.938-.938.938h-3.125A.935.935 0 0 1 17 12c0-.52.418-.938.938-.938h3.125ZM19.07 4.93a.935.935 0 0 1 0 1.325l-2.207 2.21a.938.938 0 0 1-1.328-1.323l2.211-2.212a.936.936 0 0 1 1.324 0ZM6.254 19.07c-.367.367-.957.367-1.36 0a1.006 1.006 0 0 1 0-1.324l2.243-2.21a.938.938 0 0 1 1.328 1.323L6.254 19.07ZM4.894 4.93c.403-.366.993-.366 1.36 0l2.21 2.212a.938.938 0 0 1-1.328 1.324L4.896 6.254a1.007 1.007 0 0 1 0-1.325ZM19.07 17.746a.934.934 0 0 1 0 1.324.934.934 0 0 1-1.324 0l-2.21-2.21a.938.938 0 0 1 1.328-1.324l2.206 2.21Z",
        fill: "currentColor"
      }
    )
  })
);
var Loader_default = SvgLoader;

// src/Icon/icons/LocalUsers.tsx
import { jsx as jsx910 } from "react/jsx-runtime";
var SvgLocalUsers = (props) => /* @__PURE__ */ jsx910(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx910(
      "path",
      {
        d: "M15.77 11.981c-1.86 0-3.368-1.649-3.375-3.656-.008-1.985 1.515-3.586 3.375-3.586 1.867 0 3.375 1.57 3.375 3.57 0 2.016-1.516 3.672-3.375 3.672Zm-9 .063c-1.61 0-2.93-1.438-2.93-3.204-.008-1.726 1.32-3.148 2.93-3.148 1.625 0 2.93 1.398 2.93 3.133 0 1.773-1.321 3.219-2.93 3.219Zm9-1.243c1.148 0 2.117-1.11 2.117-2.492 0-1.36-.953-2.39-2.117-2.39-1.165 0-2.125 1.046-2.118 2.406 0 1.383.977 2.476 2.118 2.476Zm-9 .078c.96 0 1.773-.914 1.773-2.054 0-1.102-.79-1.969-1.773-1.969-.97 0-1.766.883-1.766 1.984 0 1.125.805 2.04 1.766 2.04Zm-4.352 8.329c-1.055 0-1.586-.43-1.586-1.297 0-2.602 2.656-4.977 5.93-4.977 1.289 0 2.5.344 3.508 1.008-.352.242-.641.515-.883.828-.758-.445-1.649-.68-2.625-.68-2.555 0-4.766 1.813-4.766 3.75 0 .149.07.211.234.211h5.72c-.055.477.226.946.6 1.157H2.419Zm8.438 0c-1.297 0-1.915-.391-1.915-1.25 0-2.047 2.586-5.008 6.82-5.008 4.243 0 6.829 2.96 6.829 5.008 0 .859-.617 1.25-1.922 1.25h-9.813Zm-.376-1.18h10.563c.203 0 .289-.055.289-.219 0-1.281-1.984-3.68-5.57-3.68-3.578 0-5.563 2.399-5.563 3.68 0 .164.078.219.281.219Z",
        fill: "currentColor"
      }
    )
  })
);
var LocalUsers_default = SvgLocalUsers;

// src/Icon/icons/LocationArrow.tsx
import { jsx as jsx911 } from "react/jsx-runtime";
var SvgLocationArrow = (props) => /* @__PURE__ */ jsx911(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx911(
      "path",
      {
        d: "M3.495 12c-.691 0-1.324-.519-1.466-1.24a1.54 1.54 0 0 1 .927-1.721L19.88 2.114a1.539 1.539 0 0 1 2.005 2.007l-6.923 16.923a1.54 1.54 0 0 1-1.721.928c-.721-.145-1.284-.774-1.284-1.51V12H3.495Zm10.813-2.307v6.855l4.745-11.6-11.6 4.745h6.855Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationArrow_default = SvgLocationArrow;

// src/Icon/icons/LocationCheck.tsx
import { jsx as jsx912 } from "react/jsx-runtime";
var SvgLocationCheck = (props) => /* @__PURE__ */ jsx912(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx912(
      "path",
      {
        d: "M11.377 12.656c-.333.4-.928.4-1.296 0l-2.192-2.193c-.367-.333-.367-.928 0-1.296.367-.364.962-.364 1.295 0l1.563 1.531 3.72-3.724c.368-.364.964-.364 1.297 0 .4.368.4.963 0 1.296l-4.387 4.386ZM19.52 9.52c0 3.423-4.583 9.517-6.592 12.032-.482.599-1.374.599-1.856 0C9.028 19.036 4.48 12.942 4.48 9.519a7.52 7.52 0 1 1 15.039 0ZM12 3.88a5.641 5.641 0 0 0-5.64 5.64c0 .486.176 1.238.6 2.24.41.972.993 2.045 1.664 3.13 1.112 1.81 2.405 3.525 3.376 4.801.971-1.276 2.264-2.992 3.376-4.801.67-1.085 1.253-2.158 1.664-3.13.423-1.002.6-1.754.6-2.24A5.641 5.641 0 0 0 12 3.88Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationCheck_default = SvgLocationCheck;

// src/Icon/icons/LocationCrosshairsSlash.tsx
import { jsx as jsx913 } from "react/jsx-runtime";
var SvgLocationCrosshairsSlash = (props) => /* @__PURE__ */ jsx913(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx913(
      "path",
      {
        d: "M7.778 7.737a5.976 5.976 0 0 1 3.472-1.69V4.75a.75.75 0 1 1 1.5 0v1.297a6.005 6.005 0 0 1 5.203 5.203h1.297c.416 0 .75.334.75.75 0 .415-.334.75-.75.75h-1.297a5.968 5.968 0 0 1-.803 2.331l4.562 3.578a.75.75 0 0 1-.925 1.181l-18.5-14.5a.75.75 0 1 1 .926-1.18l4.565 3.577Zm1.194.935 1.203.947A2.99 2.99 0 0 1 12 8.999c1.656 0 3 1.317 3 3 0 .429-.09.835-.278 1.204l1.234.944a4.501 4.501 0 0 0-6.984-5.475Zm4.512 3.54a1.5 1.5 0 0 0-2.044-1.603l2.044 1.603Zm-.734 5.741v1.297c0 .416-.335.75-.75.75a.748.748 0 0 1-.75-.75v-1.297a6 6 0 0 1-5.203-5.203H4.75a.75.75 0 1 1 0-1.5h1.297a5.33 5.33 0 0 1 .187-.916l1.31 1.035a4.501 4.501 0 0 0 6.112 4.816l1.31 1.03a5.972 5.972 0 0 1-2.216.738Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationCrosshairsSlash_default = SvgLocationCrosshairsSlash;

// src/Icon/icons/LocationCrosshairs.tsx
import { jsx as jsx914 } from "react/jsx-runtime";
var SvgLocationCrosshairs = (props) => /* @__PURE__ */ jsx914(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx914(
      "path",
      {
        d: "M15.75 12c0 2.07-1.68 3.75-3.75 3.75A3.729 3.729 0 0 1 8.25 12c0-2.105 1.645-3.75 3.75-3.75 2.07 0 3.75 1.645 3.75 3.75ZM12 10.125a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75ZM12 2c.52 0 .938.42.938.938v1.62a7.506 7.506 0 0 1 6.503 6.505h1.622c.519 0 .937.417.937.937s-.418.938-.938.938h-1.62a7.504 7.504 0 0 1-6.505 6.503v1.622c0 .519-.417.937-.937.937a.935.935 0 0 1-.938-.938v-1.62a7.506 7.506 0 0 1-6.504-6.505h-1.62a.937.937 0 1 1 0-1.874h1.62a7.507 7.507 0 0 1 6.505-6.505v-1.62c0-.518.417-.938.937-.938ZM6.375 12A5.626 5.626 0 0 0 12 17.625 5.626 5.626 0 0 0 17.625 12 5.626 5.626 0 0 0 12 6.375 5.626 5.626 0 0 0 6.375 12Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationCrosshairs_default = SvgLocationCrosshairs;

// src/Icon/icons/LocationDotSlash.tsx
import { jsx as jsx915 } from "react/jsx-runtime";
var SvgLocationDotSlash = (props) => /* @__PURE__ */ jsx915(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx915(
      "path",
      {
        d: "M6.812 6.982A6 6 0 0 1 18 10c0 1.21-.718 2.837-1.655 4.453l5.368 4.206a.75.75 0 0 1-.925 1.181l-18.5-14.5a.75.75 0 1 1 .926-1.18l3.6 2.822Zm1.197.937L9.634 9.19A2.5 2.5 0 0 1 14.5 10c0 .883-.46 1.658-1.15 2.105l1.8 1.41c.344-.6.64-1.185.872-1.729.337-.8.478-1.4.478-1.787a4.501 4.501 0 0 0-8.49-2.081Zm3.9 3.078c.05-.025.069.003.09.003a.999.999 0 1 0 0-2 .999.999 0 0 0-.952 1.3l.862.697Zm-2.603 3.287c.888 1.444 1.919 2.813 2.694 3.832.444-.57.975-1.276 1.515-2.044l1.179.931A54.482 54.482 0 0 1 12.74 19.6a.944.944 0 0 1-1.48 0c-1.576-1.969-5.126-6.688-5.257-9.447l1.928 1.519c.016.037.031.05.047.115.328.775.794 1.632 1.328 2.497Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationDotSlash_default = SvgLocationDotSlash;

// src/Icon/icons/LocationDot.tsx
import { jsx as jsx916 } from "react/jsx-runtime";
var SvgLocationDot = (props) => /* @__PURE__ */ jsx916(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx916(
      "path",
      {
        d: "M15.133 9.52a3.132 3.132 0 1 1-6.266 0 3.132 3.132 0 1 1 6.266 0ZM12 8.265c-.693 0-1.253.56-1.253 1.253 0 .694.56 1.254 1.253 1.254.693 0 1.253-.56 1.253-1.254 0-.693-.56-1.253-1.253-1.253Zm7.52 1.253c0 3.423-4.583 9.517-6.592 12.032-.482.599-1.374.599-1.856 0C9.028 19.036 4.48 12.942 4.48 9.519a7.52 7.52 0 1 1 15.039 0ZM12 3.88a5.641 5.641 0 0 0-5.64 5.64c0 .486.176 1.238.6 2.24.41.972.993 2.045 1.664 3.13 1.112 1.81 2.405 3.525 3.376 4.801.971-1.276 2.264-2.992 3.376-4.801.67-1.085 1.253-2.158 1.664-3.13.423-1.002.6-1.754.6-2.24A5.641 5.641 0 0 0 12 3.88Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationDot_default = SvgLocationDot;

// src/Icon/icons/LocationExclamation.tsx
import { jsx as jsx917 } from "react/jsx-runtime";
var SvgLocationExclamation = (props) => /* @__PURE__ */ jsx917(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx917(
      "path",
      {
        d: "M12 5.76c.52 0 .94.419.94.94v4.386c0 .52-.42.94-.94.94a.938.938 0 0 1-.94-.94V6.7c0-.521.42-.94.94-.94Zm1.253 8.772a1.252 1.252 0 1 1-2.506 0c0-.693.56-1.253 1.253-1.253.693 0 1.253.56 1.253 1.253ZM19.52 9.52c0 3.423-4.583 9.517-6.592 12.032-.482.599-1.374.599-1.856 0C9.028 19.036 4.48 12.942 4.48 9.519a7.52 7.52 0 1 1 15.039 0ZM12 3.88a5.641 5.641 0 0 0-5.64 5.64c0 .486.176 1.238.6 2.24.41.972.993 2.045 1.664 3.13 1.112 1.81 2.405 3.525 3.376 4.801.971-1.276 2.264-2.992 3.376-4.801.67-1.085 1.253-2.158 1.664-3.13.423-1.002.6-1.754.6-2.24A5.641 5.641 0 0 0 12 3.88Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationExclamation_default = SvgLocationExclamation;

// src/Icon/icons/LocationMinus.tsx
import { jsx as jsx918 } from "react/jsx-runtime";
var SvgLocationMinus = (props) => /* @__PURE__ */ jsx918(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx918(
      "path",
      {
        d: "M14.82 8.58c.52 0 .94.419.94.94 0 .52-.42.94-.94.94H9.18c-.52 0-.94-.42-.94-.94 0-.521.42-.94.94-.94h5.64Zm4.7.94c0 3.422-4.583 9.516-6.592 12.03-.482.6-1.374.6-1.856 0C9.028 19.037 4.48 12.943 4.48 9.52a7.52 7.52 0 1 1 15.039 0ZM12 3.88a5.641 5.641 0 0 0-5.64 5.64c0 .485.176 1.237.6 2.24.41.97.993 2.044 1.664 3.129 1.112 1.81 2.405 3.525 3.376 4.801.971-1.276 2.264-2.992 3.376-4.801.67-1.085 1.253-2.158 1.664-3.13.423-1.002.6-1.754.6-2.24A5.641 5.641 0 0 0 12 3.88Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationMinus_default = SvgLocationMinus;

// src/Icon/icons/LocationPen.tsx
import { jsx as jsx919 } from "react/jsx-runtime";
var SvgLocationPen = (props) => /* @__PURE__ */ jsx919(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx919(
      "path",
      {
        d: "m15.321 8.282-.583.583-2.088-2.122.584-.552a1.478 1.478 0 0 1 2.087 2.09ZM8.95 10.479l2.78-2.816 2.123 2.088-2.815 2.82c-.161.125-.365.274-.584.328l-1.433.357a.62.62 0 0 1-.596-.165.623.623 0 0 1-.165-.595l.357-1.434c.055-.219.137-.422.333-.583Zm10.57-.96c0 3.423-4.582 9.517-6.59 12.032-.482.599-1.375.599-1.857 0C9.028 19.036 4.48 12.942 4.48 9.519a7.52 7.52 0 1 1 15.039 0ZM12 3.88a5.641 5.641 0 0 0-5.64 5.64c0 .486.176 1.238.6 2.24.41.972.993 2.045 1.664 3.13 1.112 1.81 2.405 3.525 3.376 4.801.971-1.276 2.264-2.992 3.376-4.801.67-1.085 1.253-2.158 1.664-3.13.423-1.002.6-1.754.6-2.24A5.641 5.641 0 0 0 12 3.88Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationPen_default = SvgLocationPen;

// src/Icon/icons/LocationPinLock.tsx
import { jsx as jsx920 } from "react/jsx-runtime";
var SvgLocationPinLock = (props) => /* @__PURE__ */ jsx920(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx920(
      "path",
      {
        d: "M9.5 19.645c.723-.961 1.625-2.133 2.5-3.438v3.246a76.687 76.687 0 0 1-1.574 2.047 1.18 1.18 0 0 1-1.852 0C6.535 18.992 2 12.914 2 9.5A7.5 7.5 0 0 1 9.5 2c3.738 0 6.8 2.733 7.406 6.309a4.37 4.37 0 0 0-1.8.738c-.231-2.895-2.653-5.172-5.641-5.172-3.07 0-5.625 2.52-5.625 5.625 0 .484.21 1.234.633 2.234.409.97.99 2.04 1.66 3.121 1.11 1.805 2.398 3.516 3.332 4.79H9.5ZM12.625 9.5a3.124 3.124 0 1 1-6.25 0 3.124 3.124 0 1 1 6.25 0ZM9.5 8.25c-.691 0-1.25.559-1.25 1.25s.559 1.25 1.25 1.25 1.25-.559 1.25-1.25-.559-1.25-1.25-1.25Zm8.125 1.25a3.124 3.124 0 0 1 3.125 3.125V14.5c.691 0 1.25.559 1.25 1.25v5c0 .691-.559 1.25-1.25 1.25H14.5c-.691 0-1.25-.559-1.25-1.25v-5c0-.691.559-1.25 1.25-1.25v-1.875A3.124 3.124 0 0 1 17.625 9.5Zm0 1.875c-.691 0-1.25.559-1.25 1.25V14.5h2.5v-1.875c0-.691-.559-1.25-1.25-1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationPinLock_default = SvgLocationPinLock;

// src/Icon/icons/LocationPinSlash.tsx
import { jsx as jsx921 } from "react/jsx-runtime";
var SvgLocationPinSlash = (props) => /* @__PURE__ */ jsx921(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx921(
      "path",
      {
        d: "M6.812 6.982A6 6 0 0 1 18 10c0 1.21-.718 2.837-1.655 4.453l5.368 4.206a.75.75 0 0 1-.925 1.181l-18.5-14.5a.75.75 0 1 1 .926-1.18l3.6 2.822Zm1.197.937 7.14 5.596c.345-.6.642-1.184.873-1.728.337-.8.478-1.4.478-1.787a4.501 4.501 0 0 0-8.49-2.081Zm-.03 3.868c.327.775.793 1.632 1.327 2.497.888 1.444 1.919 2.813 2.694 3.832.444-.57.975-1.276 1.515-2.044l1.179.931A54.482 54.482 0 0 1 12.74 19.6a.944.944 0 0 1-1.48 0c-1.576-1.969-5.126-6.688-5.257-9.447l1.928 1.519c.016.037.031.05.047.115Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationPinSlash_default = SvgLocationPinSlash;

// src/Icon/icons/LocationPin.tsx
import { jsx as jsx922 } from "react/jsx-runtime";
var SvgLocationPin = (props) => /* @__PURE__ */ jsx922(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx922(
      "path",
      {
        d: "M11.072 21.55C9.028 19.037 4.48 12.943 4.48 9.52a7.52 7.52 0 1 1 15.039 0c0 3.422-4.583 9.516-6.592 12.03-.482.6-1.374.6-1.856 0Zm5.968-9.79c.423-1.003.6-1.755.6-2.24A5.641 5.641 0 0 0 12 3.88a5.641 5.641 0 0 0-5.64 5.64c0 .485.176 1.237.6 2.24.41.97.993 2.044 1.664 3.129 1.112 1.81 2.405 3.525 3.376 4.801.971-1.276 2.264-2.992 3.376-4.801.67-1.085 1.253-2.158 1.664-3.13Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationPin_default = SvgLocationPin;

// src/Icon/icons/LocationPlus.tsx
import { jsx as jsx923 } from "react/jsx-runtime";
var SvgLocationPlus = (props) => /* @__PURE__ */ jsx923(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx923(
      "path",
      {
        d: "M12 5.76c.52 0 .94.419.94.94v1.88h1.88c.52 0 .94.419.94.94 0 .52-.42.94-.94.94h-1.88v1.88c0 .52-.42.94-.94.94s-.94-.42-.94-.94v-1.88H9.18c-.52 0-.94-.42-.94-.94 0-.521.42-.94.94-.94h1.88V6.7c0-.521.42-.94.94-.94Zm7.52 3.76c0 3.422-4.583 9.516-6.592 12.03-.482.6-1.374.6-1.856 0C9.028 19.037 4.48 12.943 4.48 9.52a7.52 7.52 0 1 1 15.039 0ZM12 3.88a5.641 5.641 0 0 0-5.64 5.64c0 .485.176 1.237.6 2.24.41.97.993 2.044 1.664 3.129 1.112 1.81 2.405 3.525 3.376 4.801.971-1.276 2.264-2.992 3.376-4.801.67-1.085 1.253-2.158 1.664-3.13.423-1.002.6-1.754.6-2.24A5.641 5.641 0 0 0 12 3.88Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationPlus_default = SvgLocationPlus;

// src/Icon/icons/LocationQuestion.tsx
import { jsx as jsx924 } from "react/jsx-runtime";
var SvgLocationQuestion = (props) => /* @__PURE__ */ jsx924(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx924(
      "path",
      {
        d: "M8.624 7.22a2.195 2.195 0 0 1 2.068-1.46h2.283a2.474 2.474 0 0 1 1.23 4.617l-1.3.725c.027.513-.392.889-.905.889a.916.916 0 0 1-.94-.94v-.494c0-.337.18-.646.474-.814l1.735-.995a.594.594 0 0 0 .298-.517c0-.325-.267-.627-.592-.627h-2.283c-.133 0-.25.118-.294.243l-.02.051c-.172.49-.708.744-1.233.572a.953.953 0 0 1-.537-1.202l.016-.047Zm4.63 7.312c0 .694-.56 1.254-1.254 1.254-.693 0-1.253-.56-1.253-1.254 0-.693.56-1.253 1.253-1.253.693 0 1.253.56 1.253 1.253ZM19.52 9.52c0 3.423-4.583 9.517-6.592 12.032-.482.599-1.374.599-1.856 0C9.028 19.036 4.48 12.942 4.48 9.519a7.52 7.52 0 1 1 15.039 0ZM12 3.88a5.641 5.641 0 0 0-5.64 5.64c0 .486.176 1.238.6 2.24.41.972.993 2.045 1.664 3.13 1.112 1.81 2.405 3.525 3.376 4.801.971-1.276 2.264-2.992 3.376-4.801.67-1.085 1.253-2.158 1.664-3.13.423-1.002.6-1.754.6-2.24A5.641 5.641 0 0 0 12 3.88Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationQuestion_default = SvgLocationQuestion;

// src/Icon/icons/LocationSmile.tsx
import { jsx as jsx925 } from "react/jsx-runtime";
var SvgLocationSmile = (props) => /* @__PURE__ */ jsx925(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx925(
      "path",
      {
        d: "M8.867 7.953c0-.521.419-.94.94-.94.52 0 .94.419.94.94 0 .52-.42.94-.94.94-.521 0-.94-.42-.94-.94Zm6.266 0c0 .52-.419.94-.94.94-.52 0-.94-.42-.94-.94 0-.521.42-.94.94-.94.521 0 .94.419.94.94ZM12 11.869c1.007 0 1.68-.642 1.856-.904a.778.778 0 0 1 1.085-.216c.36.24.458.725.216 1.085-.38.572-1.492 1.602-3.157 1.602-1.664 0-2.777-1.03-3.157-1.602a.778.778 0 0 1 .216-1.085.778.778 0 0 1 1.085.216c.176.262.85.904 1.856.904Zm7.52-2.35c0 3.423-4.583 9.517-6.592 12.032-.482.599-1.374.599-1.856 0C9.028 19.036 4.48 12.942 4.48 9.519a7.52 7.52 0 1 1 15.039 0ZM12 3.88a5.641 5.641 0 0 0-5.64 5.64c0 .486.176 1.238.6 2.24.41.972.993 2.045 1.664 3.13 1.112 1.81 2.405 3.525 3.376 4.801.971-1.276 2.264-2.992 3.376-4.801.67-1.085 1.253-2.158 1.664-3.13.423-1.002.6-1.754.6-2.24A5.641 5.641 0 0 0 12 3.88Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationSmile_default = SvgLocationSmile;

// src/Icon/icons/LocationXmark.tsx
import { jsx as jsx926 } from "react/jsx-runtime";
var SvgLocationXmark = (props) => /* @__PURE__ */ jsx926(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx926(
      "path",
      {
        d: "M9.028 6.547a.94.94 0 0 1 1.331 0L12 8.192l1.641-1.645a.94.94 0 1 1 1.332 1.331l-1.645 1.606 1.645 1.676a.94.94 0 1 1-1.332 1.332l-1.64-1.645-1.642 1.645a.94.94 0 1 1-1.331-1.332l1.644-1.676-1.644-1.606a.94.94 0 0 1 0-1.331ZM19.52 9.519c0 3.423-4.583 9.517-6.592 12.032-.482.599-1.374.599-1.856 0C9.028 19.036 4.48 12.942 4.48 9.519a7.52 7.52 0 1 1 15.039 0ZM12 3.88a5.641 5.641 0 0 0-5.64 5.64c0 .486.176 1.238.6 2.24.41.972.993 2.045 1.664 3.13 1.112 1.81 2.405 3.525 3.376 4.801.971-1.276 2.264-2.992 3.376-4.801.67-1.085 1.253-2.158 1.664-3.13.423-1.002.6-1.754.6-2.24A5.641 5.641 0 0 0 12 3.88Z",
        fill: "currentColor"
      }
    )
  })
);
var LocationXmark_default = SvgLocationXmark;

// src/Icon/icons/LockA.tsx
import { jsx as jsx927 } from "react/jsx-runtime";
var SvgLockA = (props) => /* @__PURE__ */ jsx927(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx927(
      "path",
      {
        d: "m8.035 17.832 3.121-6.242a.97.97 0 0 1 .18-.254c.086-.082.184-.149.293-.23.121-.02.246-.079.371-.079s.25.059.371.079c.11.082.207.148.258.23.11.074.168.16.215.254l3.12 6.242a.94.94 0 0 1-1.68.836l-.518-1.043h-3.532l-.52 1.043a.94.94 0 0 1-1.257.422.94.94 0 0 1-.422-1.258Zm3.137-2.082h1.656L12 14.098l-.828 1.652ZM12 2a5 5 0 0 1 5 5v1.25h1.25c1.379 0 2.5 1.121 2.5 2.5v8.75c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5v-8.75c0-1.379 1.12-2.5 2.5-2.5H7V7a5 5 0 0 1 5-5Zm0 1.875A3.125 3.125 0 0 0 8.875 7v1.25h6.25V7A3.125 3.125 0 0 0 12 3.875ZM5.125 10.75v8.75c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-8.75a.627.627 0 0 0-.625-.625H5.75a.626.626 0 0 0-.625.625Z",
        fill: "currentColor"
      }
    )
  })
);
var LockA_default = SvgLockA;

// src/Icon/icons/LockHashtag.tsx
import { jsx as jsx928 } from "react/jsx-runtime";
var SvgLockHashtag = (props) => /* @__PURE__ */ jsx928(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx928(
      "path",
      {
        d: "M10.438 10.75c.519 0 .937.418.937.938v.937h1.25v-.938c0-.519.418-.937.938-.937.519 0 .937.418.937.938v.937h.938c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H14.5v1.25h.938c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H14.5v.938c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938v-.937h-1.25v.938c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938v-.937h-.938a.935.935 0 0 1-.937-.938c0-.519.418-.937.938-.937H9.5V14.5h-.938a.935.935 0 0 1-.937-.938c0-.519.418-.937.938-.937H9.5v-.938c0-.519.418-.937.938-.937Zm.937 5h1.25V14.5h-1.25v1.25ZM7 8.25V7a5 5 0 1 1 10 0v1.25h1.25c1.379 0 2.5 1.121 2.5 2.5v8.75c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5v-8.75c0-1.379 1.12-2.5 2.5-2.5H7Zm1.875 0h6.25V7a3.125 3.125 0 1 0-6.25 0v1.25ZM5.75 10.125a.626.626 0 0 0-.625.625v8.75c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625v-8.75a.627.627 0 0 0-.625-.625H5.75Z",
        fill: "currentColor"
      }
    )
  })
);
var LockHashtag_default = SvgLockHashtag;

// src/Icon/icons/LockKeyholeOpen.tsx
import { jsx as jsx929 } from "react/jsx-runtime";
var SvgLockKeyholeOpen = (props) => /* @__PURE__ */ jsx929(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx929(
      "path",
      {
        d: "M8.857 16.286A.855.855 0 0 1 8 15.429c0-.475.382-.858.857-.858h2.286c.475 0 .857.383.857.858a.855.855 0 0 1-.857.857H8.857ZM17.43 4.57A2.857 2.857 0 0 0 14.57 7.43v2.285h1.143A2.288 2.288 0 0 1 18 12v6.857a2.288 2.288 0 0 1-2.286 2.286H4.286A2.287 2.287 0 0 1 2 18.857V12a2.287 2.287 0 0 1 2.286-2.286h8.571V7.43a4.571 4.571 0 1 1 9.143 0V10a.855.855 0 0 1-.857.857.855.855 0 0 1-.857-.857V7.429a2.857 2.857 0 0 0-2.857-2.858Zm-1.715 6.858H4.286a.572.572 0 0 0-.572.571v6.857c0 .314.256.572.572.572h11.428a.573.573 0 0 0 .572-.572V12a.573.573 0 0 0-.572-.571Z",
        fill: "currentColor"
      }
    )
  })
);
var LockKeyholeOpen_default = SvgLockKeyholeOpen;

// src/Icon/icons/LockKeyhole.tsx
import { jsx as jsx930 } from "react/jsx-runtime";
var SvgLockKeyhole = (props) => /* @__PURE__ */ jsx930(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx930(
      "path",
      {
        d: "M12.938 17c0 .52-.418.938-.938.938a.935.935 0 0 1-.938-.938v-2.5c0-.52.418-.938.938-.938s.938.418.938.938V17ZM12 2a5 5 0 0 1 5 5v2.5h1.25c1.379 0 2.5 1.121 2.5 2.5v7.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V12c0-1.379 1.12-2.5 2.5-2.5H7V7a5 5 0 0 1 5-5Zm0 1.875A3.125 3.125 0 0 0 8.875 7v2.5h6.25V7A3.125 3.125 0 0 0 12 3.875Zm-6.25 7.5a.626.626 0 0 0-.625.625v7.5c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625V12a.627.627 0 0 0-.625-.625H5.75Z",
        fill: "currentColor"
      }
    )
  })
);
var LockKeyhole_default = SvgLockKeyhole;

// src/Icon/icons/LockOpen.tsx
import { jsx as jsx931 } from "react/jsx-runtime";
var SvgLockOpen = (props) => /* @__PURE__ */ jsx931(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx931(
      "path",
      {
        d: "M14.571 9.714h1.143A2.288 2.288 0 0 1 18 12v6.857a2.288 2.288 0 0 1-2.286 2.286H4.286A2.287 2.287 0 0 1 2 18.857V12a2.287 2.287 0 0 1 2.286-2.286h8.571V7.43a4.571 4.571 0 1 1 9.143 0V10a.855.855 0 0 1-.857.857.855.855 0 0 1-.857-.857V7.429a2.857 2.857 0 1 0-5.715 0v2.285ZM3.714 12v6.857c0 .314.256.572.572.572h11.428a.573.573 0 0 0 .572-.572V12a.573.573 0 0 0-.572-.571H4.286a.572.572 0 0 0-.572.571Z",
        fill: "currentColor"
      }
    )
  })
);
var LockOpen_default = SvgLockOpen;

// src/Icon/icons/Lock.tsx
import { jsx as jsx932 } from "react/jsx-runtime";
var SvgLock = (props) => /* @__PURE__ */ jsx932(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx932(
      "path",
      {
        d: "M7 9.5V7a5 5 0 1 1 10 0v2.5h1.25c1.379 0 2.5 1.121 2.5 2.5v7.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V12c0-1.379 1.12-2.5 2.5-2.5H7Zm1.875 0h6.25V7a3.125 3.125 0 1 0-6.25 0v2.5Zm-3.75 10c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625V12a.627.627 0 0 0-.625-.625H5.75a.626.626 0 0 0-.625.625v7.5Z",
        fill: "currentColor"
      }
    )
  })
);
var Lock_default = SvgLock;

// src/Icon/icons/M.tsx
import { jsx as jsx933 } from "react/jsx-runtime";
var SvgM = (props) => /* @__PURE__ */ jsx933(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx933(
      "path",
      {
        d: "M20.928 22c-.591 0-1.071-.48-1.071-1.071V6.649l-6.96 10.579c-.396.603-1.395.603-1.791 0L4.143 6.648v14.28a1.07 1.07 0 1 1-2.142 0V3.074a1.07 1.07 0 0 1 1.966-.589L12 14.692l8.03-12.209a1.073 1.073 0 0 1 1.969.59v17.856c0 .593-.477 1.071-1.071 1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var M_default = SvgM;

// src/Icon/icons/MagnifyingGlassArrowRight.tsx
import { jsx as jsx934 } from "react/jsx-runtime";
var SvgMagnifyingGlassArrowRight = (props) => /* @__PURE__ */ jsx934(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx934(
      "path",
      {
        d: "M13.885 9.465c.398.367.398.961 0 1.293l-2.502 2.501c-.332.399-.926.399-1.293 0-.364-.332-.364-.926 0-1.293l.903-.9h-3.99a.936.936 0 0 1-.939-.937c0-.52.419-.938.938-.938h3.99l-.902-.934c-.364-.332-.364-.926 0-1.294.367-.363.961-.363 1.293 0l2.502 2.502ZM2 10.129C2 5.639 5.64 2 10.129 2c4.49 0 8.129 3.64 8.129 8.129a8.09 8.09 0 0 1-1.755 5.045l5.198 5.233c.399.368.399.962 0 1.294-.332.399-.926.399-1.294 0l-5.233-5.198a8.09 8.09 0 0 1-5.045 1.755A8.128 8.128 0 0 1 2 10.129Zm8.129 6.253a6.251 6.251 0 0 0 6.253-6.253 6.251 6.251 0 0 0-6.253-6.253 6.251 6.251 0 0 0-6.253 6.253 6.251 6.251 0 0 0 6.253 6.253Z",
        fill: "currentColor"
      }
    )
  })
);
var MagnifyingGlassArrowRight_default = SvgMagnifyingGlassArrowRight;

// src/Icon/icons/MagnifyingGlassChart.tsx
import { jsx as jsx935 } from "react/jsx-runtime";
var SvgMagnifyingGlassChart = (props) => /* @__PURE__ */ jsx935(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx935(
      "path",
      {
        d: "M6.064 10.442c0-.52.419-.938.938-.938.52 0 .938.418.938.938v2.5c0 .52-.418.939-.938.939a.936.936 0 0 1-.938-.938v-2.501ZM9.191 6.69c0-.52.418-.938.938-.938s.938.418.938.938v6.253c0 .52-.418.938-.938.938a.936.936 0 0 1-.938-.938V6.69Zm3.127 2.501c0-.52.418-.938.938-.938s.938.418.938.938v3.752c0 .52-.419.938-.939.938a.936.936 0 0 1-.938-.938V9.19ZM2 10.129C2 5.639 5.64 2 10.129 2c4.49 0 8.129 3.64 8.129 8.129a8.09 8.09 0 0 1-1.755 5.045l5.198 5.233c.399.368.399.962 0 1.294-.332.399-.926.399-1.294 0l-5.233-5.198a8.09 8.09 0 0 1-5.045 1.755A8.128 8.128 0 0 1 2 10.129Zm8.129 6.253a6.251 6.251 0 0 0 6.253-6.253 6.251 6.251 0 0 0-6.253-6.253 6.251 6.251 0 0 0-6.253 6.253 6.251 6.251 0 0 0 6.253 6.253Z",
        fill: "currentColor"
      }
    )
  })
);
var MagnifyingGlassChart_default = SvgMagnifyingGlassChart;

// src/Icon/icons/MagnifyingGlassDollar.tsx
import { jsx as jsx936 } from "react/jsx-runtime";
var SvgMagnifyingGlassDollar = (props) => /* @__PURE__ */ jsx936(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx936(
      "path",
      {
        d: "m21.694 20.398-5.234-5.234a7.913 7.913 0 0 0 1.793-5.039A8.124 8.124 0 0 0 10.128 2a8.125 8.125 0 0 0 0 16.25c1.905 0 3.654-.66 5.039-1.76l5.234 5.235a.938.938 0 0 0 1.327 0 .913.913 0 0 0-.034-1.327Zm-11.566-4.023a6.257 6.257 0 0 1-6.25-6.25 6.257 6.257 0 0 1 6.25-6.25 6.257 6.257 0 0 1 6.25 6.25 6.258 6.258 0 0 1-6.25 6.25Zm.214-7.004-.234-.067c-1.074-.347-1.043-.476-1.004-.738.067-.382.741-.484 1.37-.383.195.03.444.098.763.209a.782.782 0 0 0 .512-1.477c-.328-.08-.594-.185-.84-.2v-.34c0-.43-.35-.781-.781-.781a.76.76 0 0 0-.782.781v.314c-.958.186-1.631.766-1.783 1.645-.306 1.764 1.385 2.225 2.104 2.47l.245.072c1.257.36 1.29.498 1.242.774-.07.381-.741.479-1.374.381-.3-.043-.68-.18-1.012-.3l-.199-.07a.78.78 0 0 0-.996.476.785.785 0 0 0 .477 1l.189.067c.342.12.725.25 1.107.327v.344a.782.782 0 0 0 1.563 0v-.309c.959-.184 1.632-.768 1.784-1.648.306-1.785-1.358-2.262-2.35-2.547Z",
        fill: "currentColor"
      }
    )
  })
);
var MagnifyingGlassDollar_default = SvgMagnifyingGlassDollar;

// src/Icon/icons/MagnifyingGlassList.tsx
import { jsx as jsx937 } from "react/jsx-runtime";
var SvgMagnifyingGlassList = (props) => /* @__PURE__ */ jsx937(
  "svg",
  __spreadProps(__spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx937(
      "path",
      {
        d: "M2 10.09C2 5.628 5.664 2 10.168 2c4.503 0 8.168 3.629 8.168 8.09a7.945 7.945 0 0 1-1.679 4.895l5.005 4.988c.215.213.338.507.338.83 0 .68-.481 1.197-1.177 1.197-.328 0-.635-.111-.87-.345l-5.036-4.997a8.15 8.15 0 0 1-4.75 1.52C5.665 18.178 2 14.55 2 10.09Zm1.75 0c0 3.507 2.876 6.355 6.418 6.355 3.541 0 6.418-2.848 6.418-6.356 0-3.507-2.877-6.356-6.418-6.356-3.542 0-6.418 2.849-6.418 6.356Zm3.194-.65a.702.702 0 0 1-.717-.71c0-.394.307-.709.717-.709h6.489a.7.7 0 0 1 .706.71.7.7 0 0 1-.706.71h-6.49Zm0 2.707a.694.694 0 0 1-.717-.7.71.71 0 0 1 .717-.72h4.708c.4 0 .727.325.727.72 0 .396-.328.7-.727.7H6.944Z",
        fill: "currentColor"
      }
    )
  })
);
var MagnifyingGlassList_default = SvgMagnifyingGlassList;

// src/Icon/icons/MagnifyingGlassLocation.tsx
import { jsx as jsx938 } from "react/jsx-runtime";
var SvgMagnifyingGlassLocation = (props) => /* @__PURE__ */ jsx938(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx938(
      "path",
      {
        d: "M10.092 5.75c-1.824 0-3.328 1.504-3.328 3.367 0 1.498 2.2 4.238 3.042 5.235.08.09.193.148.287.148a.493.493 0 0 0 .324-.148c.843-.997 3.042-3.737 3.042-5.234.032-1.864-1.476-3.368-3.367-3.368Zm.036 4.375a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm11.566 10.273-5.234-5.234a7.913 7.913 0 0 0 1.793-5.039A8.124 8.124 0 0 0 10.128 2a8.125 8.125 0 0 0 0 16.25c1.905 0 3.654-.66 5.039-1.76l5.234 5.235a.938.938 0 0 0 1.327 0 .913.913 0 0 0-.034-1.327Zm-11.566-4.023a6.257 6.257 0 0 1-6.25-6.25 6.257 6.257 0 0 1 6.25-6.25 6.257 6.257 0 0 1 6.25 6.25 6.258 6.258 0 0 1-6.25 6.25Z",
        fill: "currentColor"
      }
    )
  })
);
var MagnifyingGlassLocation_default = SvgMagnifyingGlassLocation;

// src/Icon/icons/MagnifyingGlassMinus.tsx
import { jsx as jsx939 } from "react/jsx-runtime";
var SvgMagnifyingGlassMinus = (props) => /* @__PURE__ */ jsx939(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx939(
      "path",
      {
        d: "m21.694 20.398-5.234-5.234a7.913 7.913 0 0 0 1.793-5.039A8.124 8.124 0 0 0 10.128 2a8.125 8.125 0 0 0 0 16.25c1.905 0 3.654-.66 5.039-1.76l5.234 5.235a.938.938 0 0 0 1.327 0 .913.913 0 0 0-.034-1.327Zm-11.566-4.023a6.257 6.257 0 0 1-6.25-6.25 6.257 6.257 0 0 1 6.25-6.25 6.257 6.257 0 0 1 6.25 6.25 6.258 6.258 0 0 1-6.25 6.25Zm3.125-7.188H6.968c-.485 0-.903.418-.903.938s.42.938.903.938h6.25c.554 0 .972-.418.972-.938a.935.935 0 0 0-.937-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var MagnifyingGlassMinus_default = SvgMagnifyingGlassMinus;

// src/Icon/icons/MagnifyingGlassPlus.tsx
import { jsx as jsx940 } from "react/jsx-runtime";
var SvgMagnifyingGlassPlus = (props) => /* @__PURE__ */ jsx940(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx940(
      "path",
      {
        d: "m21.694 20.398-5.234-5.234a7.913 7.913 0 0 0 1.793-5.039A8.124 8.124 0 0 0 10.128 2a8.125 8.125 0 0 0 0 16.25c1.905 0 3.654-.66 5.039-1.76l5.234 5.235a.938.938 0 0 0 1.327 0 .913.913 0 0 0-.034-1.327Zm-11.566-4.023a6.257 6.257 0 0 1-6.25-6.25 6.257 6.257 0 0 1 6.25-6.25 6.257 6.257 0 0 1 6.25 6.25 6.258 6.258 0 0 1-6.25 6.25Zm3.125-7.188H11.03V7c0-.518-.42-.938-.902-.938-.483 0-.938.418-.938.938v2.188H6.968c-.485 0-.903.417-.903.937s.42.938.903.938H9.19v2.187c0 .518.42.938.902.938.518 0 .903-.42.903-.938v-2.188h2.187c.59 0 1.008-.417 1.008-.937a.935.935 0 0 0-.937-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var MagnifyingGlassPlus_default = SvgMagnifyingGlassPlus;

// src/Icon/icons/MagnifyingGlass.tsx
import { jsx as jsx941 } from "react/jsx-runtime";
var SvgMagnifyingGlass = (props) => /* @__PURE__ */ jsx941(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx941(
      "path",
      {
        d: "m21.694 20.398-5.234-5.234c1.133-1.387 1.758-3.133 1.758-5.039A8.125 8.125 0 0 0 10.092 2c-4.487 0-8.09 3.638-8.09 8.125s3.638 8.125 8.09 8.125c1.906 0 3.655-.66 5.04-1.76l5.234 5.235c.219.185.46.275.7.275.238 0 .479-.092.662-.275a.913.913 0 0 0-.034-1.327ZM3.878 10.125a6.257 6.257 0 0 1 6.25-6.25 6.257 6.257 0 0 1 6.25 6.25 6.257 6.257 0 0 1-6.25 6.25 6.258 6.258 0 0 1-6.25-6.25Z",
        fill: "currentColor"
      }
    )
  })
);
var MagnifyingGlass_default = SvgMagnifyingGlass;

// src/Icon/icons/MailboxFlagUp.tsx
import { jsx as jsx942 } from "react/jsx-runtime";
var SvgMailboxFlagUp = (props) => /* @__PURE__ */ jsx942(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx942(
      "path",
      {
        d: "M15.056 11.444a.831.831 0 0 1-.834-.833V5.612c0-.463.372-.834.834-.834h2.222c.462 0 .833.371.833.833v1.111a.831.831 0 0 1-.833.834h-1.39v3.055a.831.831 0 0 1-.832.833ZM7 7.556a3.334 3.334 0 0 0-3.333 3.333V17c0 .305.25.555.555.555h6.111V10.89A3.334 3.334 0 0 0 7 7.556Zm3.726 0A4.983 4.983 0 0 1 12 10.889v6.666h7.778c.305 0 .555-.25.555-.555v-6.111c0-1.212-.649-2.274-1.618-2.858a1.93 1.93 0 0 0 .507-1.309V6.41A5.002 5.002 0 0 1 22 10.889V17a2.224 2.224 0 0 1-2.222 2.222H4.223A2.224 2.224 0 0 1 2 17v-6.111c0-2.76 2.24-5 5-5h6.111V7.556h-2.385ZM5.61 10.333H8.39c.462 0 .833.372.833.834A.831.831 0 0 1 8.39 12H5.61a.831.831 0 0 1-.833-.833c0-.462.371-.834.833-.834Z",
        fill: "currentColor"
      }
    )
  })
);
var MailboxFlagUp_default = SvgMailboxFlagUp;

// src/Icon/icons/Mailbox.tsx
import { jsx as jsx943 } from "react/jsx-runtime";
var SvgMailbox = (props) => /* @__PURE__ */ jsx943(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx943(
      "path",
      {
        d: "M3.667 10.333a3.334 3.334 0 0 1 6.666 0V17h-6.11a.557.557 0 0 1-.556-.555v-6.112Zm6.666 8.334h9.445A2.224 2.224 0 0 0 22 16.444v-6.11c0-2.761-2.24-5-5-5H7c-2.76 0-5 2.239-5 5v6.11c0 1.226.997 2.223 2.222 2.223h6.111ZM12 10.333A4.983 4.983 0 0 0 10.726 7H17a3.334 3.334 0 0 1 3.333 3.333v6.112c0 .305-.25.555-.555.555H12v-6.667Zm-6.389-.555a.831.831 0 0 0-.833.833c0 .462.371.833.833.833H8.39a.831.831 0 0 0 .833-.833.831.831 0 0 0-.833-.833H5.61Zm8.889 0a.831.831 0 0 0-.833.833c0 .462.371.833.833.833h1.944v.834c0 .462.372.833.834.833h.555a.831.831 0 0 0 .834-.833V10.61a.831.831 0 0 0-.834-.833H14.5Z",
        fill: "currentColor"
      }
    )
  })
);
var Mailbox_default = SvgMailbox;

// src/Icon/icons/Malware.tsx
import { jsx as jsx944 } from "react/jsx-runtime";
var SvgMalware = (props) => /* @__PURE__ */ jsx944(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx944(
      "path",
      {
        d: "M10.3053 5.71084V6.23688C10.3053 7.07412 9.62039 7.62881 8.90641 7.62881C8.56518 7.62881 8.21718 7.50221 7.93419 7.21926L7.56223 6.88706C7.42768 6.74817 7.24973 6.68306 7.07178 6.68306C6.67512 6.68306 6.37733 7.00741 6.37733 7.33845C6.37733 7.51614 6.44513 7.69379 6.58081 7.82933L6.95303 8.2016C7.23671 8.52334 7.36258 8.87057 7.36258 9.21345C7.36258 9.92742 6.80832 10.6123 5.97108 10.6123H5.44417C5.06032 10.6123 4.74973 10.9229 4.74973 11.3068C4.74973 11.6906 5.06032 12.0012 5.44417 12.0012H5.97021C6.80745 12.0012 7.36171 12.6861 7.36171 13.4001C7.36171 13.7413 7.23506 14.0893 6.95216 14.3723L6.58133 14.743C6.44569 14.8786 6.37785 15.0562 6.37785 15.2338C6.37785 15.6039 6.67581 15.8892 7.0723 15.8892C7.24999 15.8892 7.42768 15.8214 7.56318 15.6858L7.93541 15.3135C8.21835 15.0306 8.56605 14.904 8.90719 14.904C9.62117 14.904 10.3061 15.4582 10.3061 16.2955V16.8215C10.3061 17.2054 10.6167 17.516 11.0005 17.516C11.3844 17.516 11.695 17.2054 11.695 16.8215V16.2955C11.695 15.4582 12.3798 14.904 13.0938 14.904C13.4351 14.904 13.7831 15.0306 14.066 15.3135L14.4383 15.6858C14.5739 15.8214 14.7516 15.8892 14.9292 15.8892C15.3258 15.8892 15.6236 15.5649 15.6236 15.2338C15.6236 15.0562 15.5558 14.8785 15.4201 14.743L15.0479 14.3707C14.765 14.0878 14.6384 13.7401 14.6384 13.3985C14.6384 12.6845 15.1926 11.9996 16.0299 11.9996H16.5559C16.9397 11.9996 17.2503 11.6891 17.2503 11.3052C17.2503 10.9213 16.9397 10.6108 16.5559 10.6108H16.0299C15.1926 10.6108 14.6384 9.92586 14.6384 9.21188C14.6384 8.87065 14.765 8.52265 15.0479 8.23966L15.4201 7.8674C15.5558 7.73176 15.6236 7.55412 15.6236 7.37651C15.6236 7.00642 15.3256 6.72113 14.9292 6.72113C14.7515 6.72113 14.5738 6.78892 14.4383 6.9246L14.064 7.25598C13.781 7.53892 13.4333 7.66553 13.0917 7.66553C12.3778 7.66553 11.6929 7.11128 11.6929 6.2736V5.71084C11.6929 5.32699 11.3823 5.0164 10.9984 5.0164C10.6146 5.0164 10.3053 5.36796 10.3053 5.71084ZM9.61084 10.572C9.22733 10.572 8.95546 10.261 8.95546 9.87751C8.95546 9.49392 9.2664 9.18307 9.6499 9.18307C10.0334 9.18307 10.3053 9.49396 10.3053 9.87751C10.3053 10.2985 9.99279 10.572 9.61084 10.572ZM12.3886 11.9608C12.7721 11.9608 13.0831 12.2717 13.0831 12.6162C13.0831 12.9997 12.7721 13.2716 12.3886 13.2716C12.0051 13.2716 11.6942 12.9608 11.6942 12.6162C11.6942 12.3124 12.0067 11.9608 12.3886 11.9608ZM20.136 4.52074L11.8027 1.04808C11.59 0.960018 11.2341 0.888794 11.0041 0.888794C10.774 0.888794 10.4138 0.960018 10.2011 1.04817L1.86778 4.52083C1.09131 4.8417 0.583496 5.60112 0.583496 6.44357C0.583062 17.6075 8.79487 23.111 10.9954 23.111C13.2532 23.111 21.4164 17.5468 21.4164 6.44435C21.4164 5.60234 20.9086 4.84149 20.136 4.52074ZM11.0041 2.973C11.0041 2.973 11.0084 2.97343 11.0041 2.973V2.973ZM10.9607 21.0277C6.98497 19.3567 2.669 14.0789 2.669 6.44869C2.669 6.44652 2.669 6.45086 2.669 6.44869L10.9503 2.99209C10.9646 2.98777 10.9822 2.97907 11.0053 2.97474L19.3343 6.44523C19.3331 15.2334 13.8817 19.8254 10.9607 21.0277Z",
        fill: "currentColor"
      }
    )
  })
);
var Malware_default = SvgMalware;

// src/Icon/icons/MapLocationDot.tsx
import { jsx as jsx945 } from "react/jsx-runtime";
var SvgMapLocationDot = (props) => /* @__PURE__ */ jsx945(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx945(
      "path",
      {
        d: "M16.167 7.246c0 .33-.063.667-.205 1.024-.167.608-.51 1.351-.92 2.056l-.004-.024a7.106 7.106 0 0 1-.333.587c-.153.243-.313.454-.469.722l-.014.02a27.167 27.167 0 0 1-1.708 2.282.62.62 0 0 1-1.028 0 27.171 27.171 0 0 1-1.708-2.281c-.64-.948-1.26-1.997-1.622-2.935-.028-.072-.055-.145-.11-.218-.122-.438-.213-.844-.213-1.202a4.166 4.166 0 1 1 8.333 0v-.03ZM12 8.357c.767 0 1.389-.59 1.389-1.389 0-.735-.622-1.389-1.389-1.389s-1.389.654-1.389 1.39c0 .798.622 1.388 1.389 1.388Zm2.222 5.191c.469-.632 1-1.385 1.483-2.166.062-.101.121-.202.184-.303v7.785l4.444-1.614V8.468L16.56 9.84c.076-.163.15-.323.219-.486.205-.486.382-1.01.458-1.535l3.646-1.325a.84.84 0 0 1 .764.1.825.825 0 0 1 .354.652v10.587c0 .35-.219.663-.549.785l-6.11 2.222a.845.845 0 0 1-.57 0l-5.827-2.122-5.826 2.122a.84.84 0 0 1-.763-.1.838.838 0 0 1-.355-.685V9.468c0-.32.22-.632.549-.753l4.173-1.518v.05c0 .555.129 1.096.31 1.614l-3.365 1.222v8.781L8.11 17.25v-6.17c.063.1.122.2.184.302a31.508 31.508 0 0 0 1.483 2.166v3.702l4.444 1.614v-5.316Z",
        fill: "currentColor"
      }
    )
  })
);
var MapLocationDot_default = SvgMapLocationDot;

// src/Icon/icons/MapLocation.tsx
import { jsx as jsx946 } from "react/jsx-runtime";
var SvgMapLocation = (props) => /* @__PURE__ */ jsx946(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx946(
      "path",
      {
        d: "m15.042 10.326-.004-.024a7.106 7.106 0 0 1-.333.587c-.153.243-.313.454-.469.722-.003-.025-.01.014-.014.02a27.167 27.167 0 0 1-1.708 2.282.62.62 0 0 1-1.028 0 27.171 27.171 0 0 1-1.708-2.281c-.64-.948-1.26-1.997-1.622-2.935-.028-.072-.055-.145-.11-.218-.122-.438-.213-.844-.213-1.202a4.166 4.166 0 1 1 8.333 0 2.7 2.7 0 0 1-.204.993c-.167.608-.51 1.351-.92 2.056Zm.847.753v7.785l4.444-1.614V8.468L16.56 9.84c.076-.163.15-.323.219-.483.205-.49.382-1.014.458-1.538l3.646-1.325a.84.84 0 0 1 .764.1.825.825 0 0 1 .354.652v10.587c0 .35-.219.663-.549.785l-6.11 2.222a.845.845 0 0 1-.57 0l-5.827-2.122-5.826 2.122a.84.84 0 0 1-.763-.1.838.838 0 0 1-.355-.685V9.5c0-.351.22-.664.549-.785l4.173-1.518v.05c0 .555.129 1.096.31 1.614l-3.365 1.222v8.781L8.11 17.25v-6.17c.063.1.122.2.184.302a31.508 31.508 0 0 0 1.483 2.166v3.702l4.444 1.614v-5.316c.469-.632 1-1.385 1.483-2.166.062-.101.121-.202.184-.303Z",
        fill: "currentColor"
      }
    )
  })
);
var MapLocation_default = SvgMapLocation;

// src/Icon/icons/MapPin.tsx
import { jsx as jsx947 } from "react/jsx-runtime";
var SvgMapPin = (props) => /* @__PURE__ */ jsx947(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx947(
      "path",
      {
        d: "M12.938 21.063c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938v-7.89a5.625 5.625 0 1 1 1.875 0v7.89ZM12 3.875a3.728 3.728 0 0 0-3.75 3.75c0 2.07 1.645 3.75 3.75 3.75a3.751 3.751 0 0 0 0-7.5Z",
        fill: "currentColor"
      }
    )
  })
);
var MapPin_default = SvgMapPin;

// src/Icon/icons/Map.tsx
import { jsx as jsx948 } from "react/jsx-runtime";
var SvgMap = (props) => /* @__PURE__ */ jsx948(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx948(
      "path",
      {
        d: "M21.639 4.37a.834.834 0 0 1 .361.686v11.666a.863.863 0 0 1-.538.778l-5.833 2.222a.835.835 0 0 1-.56.014l-6.385-2.128-5.554 2.114a.842.842 0 0 1-.77-.09.837.837 0 0 1-.36-.687V7.278c0-.347.214-.656.537-.779l5.835-2.222a.83.83 0 0 1 .559-.012l6.385 2.128 5.556-2.116a.83.83 0 0 1 .767.093ZM3.667 17.736l4.166-1.587V6.265L3.667 7.851v9.885ZM14.5 7.88l-5-1.667v9.91l5 1.666v-9.91Zm1.667 9.857 4.166-1.587V6.265l-4.166 1.586v9.885Z",
        fill: "currentColor"
      }
    )
  })
);
var Map_default = SvgMap;

// src/Icon/icons/Marker.tsx
import { jsx as jsx949 } from "react/jsx-runtime";
var SvgMarker = (props) => /* @__PURE__ */ jsx949(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx949(
      "path",
      {
        d: "M11.155 2.773a2.837 2.837 0 0 1 3.564.362l.516.516.591-.592c1.414-1.412 3.706-1.412 5.084 0 1.45 1.414 1.45 3.705 0 5.084l-9.869 9.94a13.542 13.542 0 0 1-6.923 3.702l-.985.197a.884.884 0 0 1-.853-.292c-.224-.189-.32-.508-.259-.82l.197-.984a13.545 13.545 0 0 1 3.705-6.923L13.9 4.988l-.551-.515c-.335-.369-.934-.37-1.304 0L8.623 7.827a.703.703 0 0 1-.544.308.884.884 0 0 1-.76-.308c-.366-.334-.366-.933 0-1.303l3.391-3.388c.138-.138.288-.26.445-.363Zm-.256 7.886 2.446 2.446 6.262-6.266a1.722 1.722 0 0 0 0-2.443c-.674-.675-1.769-.675-2.477 0L10.9 10.66Zm-1.335 1.335L7.26 14.302a11.475 11.475 0 0 0-3.097 5.541 11.651 11.651 0 0 0 5.539-3.1l2.308-2.303-2.446-2.446Z",
        fill: "currentColor"
      }
    )
  })
);
var Marker_default = SvgMarker;

// src/Icon/icons/Maximize.tsx
import { jsx as jsx950 } from "react/jsx-runtime";
var SvgMaximize = (props) => /* @__PURE__ */ jsx950(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx950(
      "path",
      {
        d: "M21.118 13.575a1.427 1.427 0 0 0-1.557.31l-2.1 2.1-3.946-3.946 3.947-3.948 2.1 2.1A1.428 1.428 0 0 0 22 9.181V3.11c0-.591-.48-1.031-1.031-1.031h-6.032a1.428 1.428 0 0 0-1.01 2.439l2.1 2.1L12 10.524 8.054 6.578l2.1-2.1a1.428 1.428 0 0 0-1.01-2.439H3.072c-.592 0-1.032.48-1.032 1.032v6.032a1.428 1.428 0 0 0 2.439 1.01l2.1-2.1 3.909 4.026-3.948 3.947-2.1-2.099A1.428 1.428 0 0 0 2 14.897v6.032c0 .592.48 1.032 1.031 1.032h6.032a1.428 1.428 0 0 0 1.01-2.44l-2.1-2.099 3.948-3.947 3.947 3.947-2.1 2.1a1.428 1.428 0 0 0 1.01 2.439h6.032c.591 0 1.031-.48 1.031-1.032v-6.073c.121-.536-.187-1.058-.723-1.281Z",
        fill: "currentColor"
      }
    )
  })
);
var Maximize_default = SvgMaximize;

// src/Icon/icons/Medal.tsx
import { jsx as jsx951 } from "react/jsx-runtime";
var SvgMedal = (props) => /* @__PURE__ */ jsx951(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx951(
      "path",
      {
        d: "m15.363 13.312-2.047-.296-.918-1.856a.447.447 0 0 0-.8 0l-.918 1.855-2.046.298a.45.45 0 0 0-.247.769l1.48 1.445-.347 2.039a.446.446 0 0 0 .65.469l1.83-.962 1.83.962a.447.447 0 0 0 .65-.474l-.347-2.036 1.48-1.445a.449.449 0 0 0-.25-.768ZM12 7.626c-3.968 0-7.151 3.217-7.151 7.186 0 3.97 3.183 7.187 7.15 7.187 3.97 0 7.152-3.218 7.152-7.187 0-3.969-3.183-7.186-7.151-7.186Zm0 12.498c-2.929 0-5.277-2.383-5.277-5.312C6.723 11.883 9.071 9.5 12 9.5c2.93 0 5.277 2.383 5.277 5.312 0 2.929-2.383 5.312-5.277 5.312ZM7.31 7.8 4.69 3.876h2.704l1.723 3.016a8.35 8.35 0 0 1 1.9-.454L8.75 2.474A.933.933 0 0 0 7.938 2H2.939a.946.946 0 0 0-.829.5.928.928 0 0 0 .049.958L5.87 9.028A8.34 8.34 0 0 1 7.309 7.8Zm14.58-5.3a.962.962 0 0 0-.864-.5h-4.964a.938.938 0 0 0-.814.473l-2.265 3.964c.66.076 1.295.234 1.9.454l1.722-3.016h2.703l-2.617 3.925a8.474 8.474 0 0 1 1.437 1.225l3.712-5.57a.918.918 0 0 0 .05-.955Z",
        fill: "currentColor"
      }
    )
  })
);
var Medal_default = SvgMedal;

// src/Icon/icons/Megaphone.tsx
import { jsx as jsx952 } from "react/jsx-runtime";
var SvgMegaphone = (props) => /* @__PURE__ */ jsx952(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx952(
      "path",
      {
        d: "M22 5.024v13.92a.831.831 0 0 1-.833.834.831.831 0 0 1-.834-.833v-.198l-6.17-1.681c-.32 1.545-1.646 2.712-3.274 2.712a3.314 3.314 0 0 1-3.333-3.333c0-.396.038-.775.194-1.129l-4.083-1.115v.299A.832.832 0 1 1 2 14.5v-5a.832.832 0 1 1 1.667 0v.299l16.666-4.547v-.196a.832.832 0 1 1 1.667 0v-.032Zm-1.667 11.997V6.979L3.667 11.524v.952l16.666 4.545Zm-9.444 1.09c.861 0 1.566-.653 1.656-1.486l-3.173-.868a1.667 1.667 0 0 0 1.517 2.354Z",
        fill: "currentColor"
      }
    )
  })
);
var Megaphone_default = SvgMegaphone;

// src/Icon/icons/MemoCircleCheck.tsx
import { jsx as jsx953 } from "react/jsx-runtime";
var SvgMemoCircleCheck = (props) => /* @__PURE__ */ jsx953(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx953(
      "path",
      {
        d: "M13.111 4.778h-8.92a.577.577 0 0 0-.556.555v13.334c0 .305.28.555.556.555h7.688a6.198 6.198 0 0 0 1.569 1.643 2.648 2.648 0 0 1-.337.024H4.222A2.223 2.223 0 0 1 2 18.667V5.333c0-1.227.995-2.222 2.222-2.222h8.89c1.225 0 2.221.995 2.221 2.222v4.674a6.05 6.05 0 0 0-1.666.76V5.302a.578.578 0 0 0-.556-.555v.03Zm-7.809 3.61c0-.46.403-.832.833-.832h5c.494 0 .834.371.834.833 0 .462-.34.833-.834.833h-5a.852.852 0 0 1-.833-.833Zm5.833 2.5c.494 0 .834.372.834.834 0 .462-.34.834-.834.834h-5a.852.852 0 0 1-.833-.834c0-.462.403-.833.833-.833h5Zm-3.333 3.334c.493 0 .833.372.833.834 0 .461-.34.833-.833.833H6.135a.852.852 0 0 1-.833-.833c0-.462.403-.834.833-.834h1.667ZM22 15.89c0 2.76-2.24 5-5 5s-5.031-2.24-5.031-5 2.27-5 5.031-5c2.76 0 5 2.24 5 5Zm-3.448-1.504-2.108 2.108-.996-.996a.551.551 0 0 0-.785 0 .551.551 0 0 0 0 .784l1.39 1.39c.214.218.569.218.784 0l2.5-2.5a.551.551 0 0 0 0-.786.551.551 0 0 0-.785 0Z",
        fill: "currentColor"
      }
    )
  })
);
var MemoCircleCheck_default = SvgMemoCircleCheck;

// src/Icon/icons/MemoCircleInfo.tsx
import { jsx as jsx954 } from "react/jsx-runtime";
var SvgMemoCircleInfo = (props) => /* @__PURE__ */ jsx954(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx954(
      "path",
      {
        d: "M13.111 4.778h-8.92a.577.577 0 0 0-.556.555v13.334c0 .305.28.555.556.555h7.688a6.198 6.198 0 0 0 1.569 1.643 2.648 2.648 0 0 1-.337.024H4.222A2.223 2.223 0 0 1 2 18.667V5.333c0-1.227.995-2.222 2.222-2.222h8.89c1.225 0 2.221.995 2.221 2.222v4.674a6.05 6.05 0 0 0-1.666.76V5.302a.578.578 0 0 0-.556-.555v.03Zm-7.809 3.61c0-.46.403-.832.833-.832h5c.494 0 .834.371.834.833 0 .462-.34.833-.834.833h-5a.852.852 0 0 1-.833-.833Zm5.833 2.5c.494 0 .834.372.834.834 0 .462-.34.834-.834.834h-5a.852.852 0 0 1-.833-.834c0-.462.403-.833.833-.833h5Zm-3.333 3.334c.493 0 .833.372.833.834 0 .461-.34.833-.833.833H6.135a.852.852 0 0 1-.833-.833c0-.462.403-.834.833-.834h1.667Zm4.167 1.667c0-2.76 2.27-5 5.031-5 2.76 0 5 2.24 5 5s-2.24 5-5 5-5.031-2.24-5.031-5ZM17 14.222a.831.831 0 0 0 .833-.833.831.831 0 0 0-.833-.833.831.831 0 0 0-.833.833c0 .462.371.833.833.833Zm-.556 2.222v1.667a.557.557 0 0 0-.555.556c0 .305.25.555.555.555h1.112c.305 0 .555-.25.555-.555a.557.557 0 0 0-.555-.556V15.89a.557.557 0 0 0-.556-.556h-.556a.557.557 0 0 0-.555.556c0 .305.25.555.555.555Z",
        fill: "currentColor"
      }
    )
  })
);
var MemoCircleInfo_default = SvgMemoCircleInfo;

// src/Icon/icons/MemoPad.tsx
import { jsx as jsx955 } from "react/jsx-runtime";
var SvgMemoPad = (props) => /* @__PURE__ */ jsx955(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx955(
      "path",
      {
        d: "M7.938 14.5h8.125c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937H7.938a.94.94 0 0 0-.937.938.94.94 0 0 0 .938.937Zm0 3.75h4.375a.938.938 0 0 0 0-1.875H7.936a.94.94 0 0 0-.937.938.94.94 0 0 0 .938.937Zm0-7.5h8.125c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937H7.938A.94.94 0 0 0 7 9.813a.94.94 0 0 0 .938.937ZM18.25 2H5.75a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5h12.5a2.5 2.5 0 0 0 2.5-2.5v-15c0-1.38-1.121-2.5-2.5-2.5Zm.625 17.5c0 .345-.28.625-.625.625H5.75a.626.626 0 0 1-.625-.625V7h13.75v12.5Z",
        fill: "currentColor"
      }
    )
  })
);
var MemoPad_default = SvgMemoPad;

// src/Icon/icons/Memo.tsx
import { jsx as jsx956 } from "react/jsx-runtime";
var SvgMemo = (props) => /* @__PURE__ */ jsx956(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx956(
      "path",
      {
        d: "M14.813 10.75H9.186a.94.94 0 0 0-.937.938.94.94 0 0 0 .938.937h5.624c.52 0 .938-.418.938-.938a.935.935 0 0 0-.938-.937Zm-3.75 3.75H9.187a.94.94 0 0 0-.937.938c0 .515.42.937.938.937h1.874a.938.938 0 0 0 0-1.875Zm3.75-7.5H9.186a.94.94 0 0 0-.937.938.94.94 0 0 0 .938.937h5.624c.52 0 .938-.418.938-.938A.935.935 0 0 0 14.812 7ZM17 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10a2.5 2.5 0 0 0 2.5-2.5v-15C19.5 3.12 18.379 2 17 2Zm.625 17.5c0 .345-.28.625-.625.625H7a.626.626 0 0 1-.625-.625v-15c0-.345.28-.625.625-.625h10c.345 0 .625.28.625.625v15Z",
        fill: "currentColor"
      }
    )
  })
);
var Memo_default = SvgMemo;

// src/Icon/icons/Memory.tsx
import { jsx as jsx957 } from "react/jsx-runtime";
var SvgMemory = (props) => /* @__PURE__ */ jsx957(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx957(
      "path",
      {
        d: "M22 8.767V7c0-.92-.747-1.667-1.667-1.667H3.667C2.747 5.333 2 6.08 2 7v1.769a1.659 1.659 0 0 1 0 3.13v5.656c0 .614.498 1.112 1.111 1.112H20.89c.613 0 1.111-.498 1.111-1.112V11.9a1.662 1.662 0 0 1-1.111-1.566c0-.725.465-1.336 1.111-1.566ZM20.333 17H18.39a.834.834 0 0 0-1.667 0h-1.11a.834.834 0 0 0-1.668 0h-1.11a.833.833 0 0 0-1.667 0h-1.111a.834.834 0 0 0-1.667 0H7.278a.834.834 0 0 0-1.667 0H3.667v-1.667h16.666V17Zm0-9.142a3.329 3.329 0 0 0-1.11 2.476c0 .963.419 1.857 1.11 2.477v.856H3.667v-.858a3.325 3.325 0 0 0 1.11-2.476 3.33 3.33 0 0 0-1.11-2.476V7h16.666v.858ZM7.556 12.556c.46 0 .833-.374.833-.834V8.944a.834.834 0 0 0-1.667 0v2.778c0 .462.375.834.834.834Zm4.444 0c.46 0 .833-.374.833-.834V8.944a.833.833 0 0 0-1.666 0v2.778c0 .462.375.834.833.834Zm4.444 0c.46 0 .834-.374.834-.834V8.944a.834.834 0 0 0-1.667 0v2.778c0 .462.375.834.833.834Z",
        fill: "currentColor"
      }
    )
  })
);
var Memory_default = SvgMemory;

// src/Icon/icons/MessageArrowDown.tsx
import { jsx as jsx958 } from "react/jsx-runtime";
var SvgMessageArrowDown = (props) => /* @__PURE__ */ jsx958(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx958(
      "path",
      {
        d: "m14.52 9.53-1.524 1.527V7.07a.938.938 0 0 0-1.875 0v3.988L9.598 9.53a.93.93 0 0 0-.664-.273.937.937 0 0 0-.664 1.6l3.125 3.124a.937.937 0 0 0 1.325 0l3.125-3.125A.937.937 0 1 0 14.52 9.53Zm4.98-7.46h-15C3.123 2.07 2 3.191 2 4.533v11.215c0 1.377 1.123 2.465 2.5 2.465h3.75v3.246c0 .384.43.607.747.379l4.878-3.555H19.5c1.377 0 2.5-1.123 2.5-2.465V4.534c0-1.342-1.121-2.465-2.5-2.465Zm.625 13.75a.63.63 0 0 1-.625.624h-6.25l-3.125 2.344v-2.344H4.5a.63.63 0 0 1-.625-.625V4.57a.63.63 0 0 1 .625-.625h15a.63.63 0 0 1 .625.625v11.25Z",
        fill: "currentColor"
      }
    )
  })
);
var MessageArrowDown_default = SvgMessageArrowDown;

// src/Icon/icons/MessageArrowUpRight.tsx
import { jsx as jsx959 } from "react/jsx-runtime";
var SvgMessageArrowUpRight = (props) => /* @__PURE__ */ jsx959(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx959(
      "path",
      {
        d: "M15.438 6.391h-5a.94.94 0 0 0-.938.938.94.94 0 0 0 .938.937h2.736l-3.75 3.75a.937.937 0 1 0 1.326 1.326l3.75-3.75v2.737a.938.938 0 0 0 1.875 0v-5a.938.938 0 0 0-.938-.938ZM19.5 2.016h-15C3.123 2.016 2 3.14 2 4.481v11.215c0 1.377 1.123 2.465 2.5 2.465h3.75v3.352c0 .384.43.607.747.378l4.878-3.66H19.5c1.377 0 2.5-1.123 2.5-2.465V4.482c0-1.341-1.121-2.465-2.5-2.465Zm.625 13.75a.63.63 0 0 1-.625.626h-6.25l-3.125 2.343v-2.343H4.5a.63.63 0 0 1-.625-.625V4.517A.63.63 0 0 1 4.5 3.89h15a.63.63 0 0 1 .625.625v11.25Z",
        fill: "currentColor"
      }
    )
  })
);
var MessageArrowUpRight_default = SvgMessageArrowUpRight;

// src/Icon/icons/MessageArrowUp.tsx
import { jsx as jsx960 } from "react/jsx-runtime";
var SvgMessageArrowUp = (props) => /* @__PURE__ */ jsx960(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx960(
      "path",
      {
        d: "M12.723 6.405a.937.937 0 0 0-1.326 0L8.272 9.53a.937.937 0 1 0 1.326 1.326L11.12 9.33v3.988a.938.938 0 0 0 1.875 0V9.331l1.525 1.524c.182.187.42.277.663.277a.937.937 0 0 0 .663-1.6l-3.124-3.127ZM19.5 2.07h-15C3.123 2.07 2 3.192 2 4.534v11.215c0 1.377 1.123 2.465 2.5 2.465h3.75v3.246c0 .384.43.607.747.379l4.878-3.555H19.5c1.377 0 2.5-1.123 2.5-2.465V4.534c0-1.342-1.121-2.465-2.5-2.465Zm.625 13.75a.63.63 0 0 1-.625.625h-6.25l-3.125 2.344v-2.344H4.5a.63.63 0 0 1-.625-.625V4.57a.63.63 0 0 1 .625-.625h15a.63.63 0 0 1 .625.625v11.25Z",
        fill: "currentColor"
      }
    )
  })
);
var MessageArrowUp_default = SvgMessageArrowUp;

// src/Icon/icons/MessageCaptions.tsx
import { jsx as jsx961 } from "react/jsx-runtime";
var SvgMessageCaptions = (props) => /* @__PURE__ */ jsx961(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx961(
      "path",
      {
        d: "M7.312 12.694h-.59a.938.938 0 0 0-.937.938c0 .515.418.937.902.937h.59c.518 0 .902-.42.902-.937 0-.518-.316-.938-.867-.938Zm6.25 0h-3.125c-.517 0-.902.42-.902.938 0 .517.418.937.902.937h3.125c.517 0 .902-.42.902-.937 0-.518-.351-.938-.902-.938Zm-6.875-1.25h3.75c.517 0 .937-.42.937-.902 0-.483-.386-.973-.937-.973h-3.75c-.484 0-.902.422-.902.938 0 .515.418.937.902.937Zm10.625 1.25h-.59c-.518 0-.902.42-.902.938 0 .517.383.937.867.937h.59c.517 0 .902-.42.902-.937 0-.518-.316-.938-.867-.938Zm0-3.125h-3.75c-.517 0-.902.42-.902.938 0 .517.418.937.902.937h3.75c.517 0 .902-.42.902-.937 0-.518-.351-.938-.902-.938Zm2.187-7.5h-15C3.124 2.07 2 3.194 2 4.535V15.75c0 1.377 1.123 2.464 2.5 2.464h3.75v3.246c0 .385.43.608.747.38l4.878-3.66H19.5c1.377 0 2.5-1.124 2.5-2.465V4.534a2.477 2.477 0 0 0-2.5-2.464Zm.66 13.75a.63.63 0 0 1-.624.625h-6.25l-3.125 2.344v-2.344H4.535a.63.63 0 0 1-.625-.625V4.569a.63.63 0 0 1 .625-.624h15a.63.63 0 0 1 .624.624v11.25Z",
        fill: "currentColor"
      }
    )
  })
);
var MessageCaptions_default = SvgMessageCaptions;

// src/Icon/icons/MessageCheck.tsx
import { jsx as jsx962 } from "react/jsx-runtime";
var SvgMessageCheck = (props) => /* @__PURE__ */ jsx962(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx962(
      "path",
      {
        d: "m14.195 7.397-3.09 3.606-1.16-1.16a.937.937 0 1 0-1.326 1.325l1.875 1.875a.939.939 0 0 0 .663.275l.036-.001a.925.925 0 0 0 .674-.326l3.75-4.375a.937.937 0 1 0-1.422-1.218Zm5.304-5.327h-15C3.124 2.07 2 3.193 2 4.534V15.75c0 1.377 1.123 2.464 2.5 2.464h3.75v3.246c0 .385.43.608.747.38l4.878-3.66H19.5c1.377 0 2.5-1.124 2.5-2.465V4.534a2.477 2.477 0 0 0-2.5-2.464Zm.66 13.749a.63.63 0 0 1-.624.625h-6.25l-3.125 2.344v-2.344H4.535a.63.63 0 0 1-.625-.625V4.569a.63.63 0 0 1 .625-.624h15a.63.63 0 0 1 .624.624v11.25Z",
        fill: "currentColor"
      }
    )
  })
);
var MessageCheck_default = SvgMessageCheck;

// src/Icon/icons/MessageCode.tsx
import { jsx as jsx963 } from "react/jsx-runtime";
var SvgMessageCode = (props) => /* @__PURE__ */ jsx963(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx963(
      "path",
      {
        d: "M19.5 2.016h-15C3.123 2.016 2 3.14 2 4.481v11.215c0 1.377 1.123 2.465 2.5 2.465h3.75v3.352c0 .384.43.607.747.378l4.878-3.66H19.5c1.377 0 2.5-1.123 2.5-2.465V4.482c0-1.341-1.121-2.465-2.5-2.465Zm.625 13.75a.63.63 0 0 1-.625.626h-6.25l-3.125 2.343v-2.343H4.5a.63.63 0 0 1-.625-.625V4.517A.63.63 0 0 1 4.5 3.89h15a.63.63 0 0 1 .625.625v11.25Zm-9.684-8.789a.937.937 0 0 0-1.325 0l-2.5 2.5a.937.937 0 0 0 0 1.326l2.5 2.5c.216.186.458.276.697.276a.937.937 0 0 0 .662-1.6l-1.838-1.837 1.837-1.838a.912.912 0 0 0-.033-1.327Zm4.375 0a.937.937 0 1 0-1.325 1.326l1.872 1.838-1.837 1.838a.937.937 0 0 0 1.324 1.325l2.5-2.5a.937.937 0 0 0 0-1.325l-2.534-2.502Z",
        fill: "currentColor"
      }
    )
  })
);
var MessageCode_default = SvgMessageCode;

// src/Icon/icons/MessageDots.tsx
import { jsx as jsx964 } from "react/jsx-runtime";
var SvgMessageDots = (props) => /* @__PURE__ */ jsx964(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx964(
      "path",
      {
        d: "M7.719 8.944c-.694 0-1.215.557-1.215 1.25 0 .694.556 1.25 1.215 1.25.658 0 1.214-.556 1.214-1.25 0-.693-.52-1.25-1.214-1.25Zm4.374 0c-.693 0-1.25.557-1.25 1.25 0 .694.557 1.25 1.25 1.25.694 0 1.215-.556 1.215-1.25 0-.693-.52-1.25-1.215-1.25Zm4.375 0c-.693 0-1.215.557-1.215 1.25 0 .694.557 1.25 1.215 1.25s1.215-.556 1.215-1.25c0-.693-.52-1.25-1.215-1.25ZM19.5 2.07h-15C3.124 2.07 2 3.193 2 4.534V15.75c0 1.377 1.123 2.464 2.5 2.464h3.75v3.246c0 .385.43.608.747.38l4.878-3.66H19.5c1.377 0 2.5-1.124 2.5-2.465V4.534a2.477 2.477 0 0 0-2.5-2.464Zm.66 13.749a.63.63 0 0 1-.624.625h-6.25l-3.125 2.344v-2.344H4.535a.63.63 0 0 1-.625-.625V4.569a.63.63 0 0 1 .625-.624h15a.63.63 0 0 1 .624.624v11.25Z",
        fill: "currentColor"
      }
    )
  })
);
var MessageDots_default = SvgMessageDots;

// src/Icon/icons/MessageExclamation.tsx
import { jsx as jsx965 } from "react/jsx-runtime";
var SvgMessageExclamation = (props) => /* @__PURE__ */ jsx965(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx965(
      "path",
      {
        d: "M12.093 12.694a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm0-1.25c.518 0 .938-.42.938-.937V6.132a.938.938 0 0 0-1.875 0v4.375c0 .52.422.937.937.937ZM19.5 2.07h-15C3.124 2.07 2 3.193 2 4.534V15.75c0 1.377 1.123 2.464 2.5 2.464h3.75v3.246c0 .385.43.608.747.38l4.878-3.66H19.5c1.377 0 2.5-1.124 2.5-2.465V4.534a2.477 2.477 0 0 0-2.5-2.464Zm.66 13.749a.63.63 0 0 1-.624.625h-6.25l-3.125 2.344v-2.344H4.535a.63.63 0 0 1-.625-.625V4.569a.63.63 0 0 1 .625-.624h15a.63.63 0 0 1 .624.624v11.25Z",
        fill: "currentColor"
      }
    )
  })
);
var MessageExclamation_default = SvgMessageExclamation;

// src/Icon/icons/MessageLines.tsx
import { jsx as jsx966 } from "react/jsx-runtime";
var SvgMessageLines = (props) => /* @__PURE__ */ jsx966(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx966(
      "path",
      {
        d: "M16.097 7.694H7.972a.94.94 0 0 0-.937.938.94.94 0 0 0 .937.937h8.125c.52 0 .938-.418.938-.937a.935.935 0 0 0-.938-.938Zm-3.75 3.75H7.972a.94.94 0 0 0-.937.938.94.94 0 0 0 .937.937h4.375c.52 0 .938-.418.938-.937a.935.935 0 0 0-.938-.938ZM19.5 2.07h-15C3.124 2.07 2 3.193 2 4.534V15.75c0 1.377 1.123 2.464 2.5 2.464h3.75v3.246c0 .385.43.608.747.38l4.878-3.66H19.5c1.377 0 2.5-1.124 2.5-2.465V4.534a2.477 2.477 0 0 0-2.5-2.464Zm.66 13.749a.63.63 0 0 1-.624.625h-6.25l-3.125 2.344v-2.344H4.535a.63.63 0 0 1-.625-.625V4.569a.63.63 0 0 1 .625-.624h15a.63.63 0 0 1 .624.624v11.25Z",
        fill: "currentColor"
      }
    )
  })
);
var MessageLines_default = SvgMessageLines;

// src/Icon/icons/MessagePlus.tsx
import { jsx as jsx967 } from "react/jsx-runtime";
var SvgMessagePlus = (props) => /* @__PURE__ */ jsx967(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx967(
      "path",
      {
        d: "M19.5 2.07h-15C3.123 2.07 2 3.191 2 4.533v11.215c0 1.377 1.123 2.465 2.5 2.465h3.75v3.246c0 .384.43.607.747.379l4.878-3.555H19.5c1.377 0 2.5-1.123 2.5-2.465V4.534c0-1.342-1.121-2.465-2.5-2.465Zm.625 13.75a.63.63 0 0 1-.625.624h-6.25l-3.125 2.344v-2.344H4.5a.63.63 0 0 1-.625-.625V4.57a.63.63 0 0 1 .625-.625h15a.63.63 0 0 1 .625.625v11.25Zm-5-6.563h-2.188V7.034c-.035-.484-.417-.902-.937-.902s-.938.418-.938.902v2.223H8.84c-.485 0-.902.418-.902.937a.9.9 0 0 0 .902.902h2.187v2.223c.036.52.454.938.973.938a.9.9 0 0 0 .902-.903v-2.257h2.188c.555 0 .973-.383.973-.903a.935.935 0 0 0-.938-.937Z",
        fill: "currentColor"
      }
    )
  })
);
var MessagePlus_default = SvgMessagePlus;

// src/Icon/icons/MessageQuestion.tsx
import { jsx as jsx968 } from "react/jsx-runtime";
var SvgMessageQuestion = (props) => /* @__PURE__ */ jsx968(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx968(
      "path",
      {
        d: "M19.5 2.035h-15C3.123 2.035 2 3.158 2 4.5v11.214c0 1.446 1.123 2.536 2.5 2.536h3.75v3.246c0 .384.43.605.747.377l4.878-3.623H19.5c1.377 0 2.5-1.123 2.5-2.465V4.5c0-1.342-1.121-2.465-2.5-2.465Zm.625 13.75a.63.63 0 0 1-.625.625h-6.25l-3.125 2.344V16.41H4.5a.63.63 0 0 1-.625-.625V4.535A.63.63 0 0 1 4.5 3.91h15a.63.63 0 0 1 .625.625v11.25Zm-8.395-3.281c-.535 0-.98.445-.98 1.015 0 .57.445 1.016.98 1.016.606 0 1.051-.446 1.051-1.016 0-.57-.445-1.015-1.05-1.015Zm1.118-6.72h-1.696c-1.27 0-2.277 1-2.277 2.259 0 .42.358.774.781.774a.787.787 0 0 0 .781-.774.72.72 0 0 1 .716-.71h1.693a.72.72 0 0 1 .716.71c0 .258-.13.484-.358.613l-1.856 1.098a.794.794 0 0 0-.391.677v.517c0 .42.358.774.781.774a.789.789 0 0 0 .782-.774v-.066l1.497-.903a2.287 2.287 0 0 0 1.108-1.936 2.253 2.253 0 0 0-2.277-2.258Z",
        fill: "currentColor"
      }
    )
  })
);
var MessageQuestion_default = SvgMessageQuestion;

// src/Icon/icons/MessageQuote.tsx
import { jsx as jsx969 } from "react/jsx-runtime";
var SvgMessageQuote = (props) => /* @__PURE__ */ jsx969(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx969(
      "path",
      {
        d: "M10.125 18.25c0-1.035-.84-1.875-1.875-1.875H4.5a.627.627 0 0 1-.625-.625V4.5c0-.343.281-.625.625-.625h15c.344 0 .625.282.625.625v11.25a.627.627 0 0 1-.625.625h-5.418c-.406 0-.8.133-1.125.375l-2.832 2.125v-.625Zm-.008 2.977.008-.008 3.957-2.969H19.5c1.379 0 2.5-1.12 2.5-2.5V4.5C22 3.122 20.879 2 19.5 2h-15A2.502 2.502 0 0 0 2 4.5v11.25c0 1.38 1.121 2.5 2.5 2.5h3.75v3.125c0 .239.133.454.344.559.21.105.465.082.656-.059l.668-.5.2-.148ZM8.25 6.375c-.691 0-1.25.559-1.25 1.25V9.5c0 .692.559 1.25 1.25 1.25H9.5v.286a.942.942 0 0 1-.785.925l-.309.051a.935.935 0 0 0-.77 1.078.935.935 0 0 0 1.079.77l.308-.051a2.814 2.814 0 0 0 2.352-2.773V7.625c0-.691-.559-1.25-1.25-1.25H8.25ZM17 9.5V7.625c0-.691-.559-1.25-1.25-1.25h-1.875c-.691 0-1.25.559-1.25 1.25V9.5c0 .692.559 1.25 1.25 1.25h1.25v.286a.942.942 0 0 1-.785.925l-.309.051a.935.935 0 0 0-.77 1.078.935.935 0 0 0 1.079.77l.308-.051A2.814 2.814 0 0 0 17 11.036V9.5Z",
        fill: "currentColor"
      }
    )
  })
);
var MessageQuote_default = SvgMessageQuote;

// src/Icon/icons/MessageSlash.tsx
import { jsx as jsx970 } from "react/jsx-runtime";
var SvgMessageSlash = (props) => /* @__PURE__ */ jsx970(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx970(
      "path",
      {
        d: "m21.718 18.661-2.577-2.02A2 2 0 0 0 20.004 15V5.97a1.974 1.974 0 0 0-1.972-1.972H5.972c-.734 0-1.373.403-1.72.996l-1.039-.836a.75.75 0 1 0-.926 1.18l18.477 14.477a.75.75 0 0 0 .463.187.75.75 0 0 0 .59-.287.724.724 0 0 0-.1-1.054Zm-3.214-3.66c0 .273-.226.5-.5.5h-.319L5.51 5.957c-.006-.253.231-.459.49-.459h12.004c.274 0 .5.227.5.5v9.003Zm-8.002 2.375v-1.875H6.001a.504.504 0 0 1-.5-.5V9.749L4 8.574v6.427c0 1.102.898 1.972 1.972 1.972h2.972V19.6c0 .307.345.486.598.303l3.904-2.929h1.25l-1.834-1.436-2.36 1.84Z",
        fill: "currentColor"
      }
    )
  })
);
var MessageSlash_default = SvgMessageSlash;

// src/Icon/icons/MessageXmark.tsx
import { jsx as jsx971 } from "react/jsx-runtime";
var SvgMessageXmark = (props) => /* @__PURE__ */ jsx971(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx971(
      "path",
      {
        d: "M19.5 2.07h-15C3.123 2.07 2 3.191 2 4.533v11.215c0 1.377 1.123 2.465 2.5 2.465h3.75v3.246c0 .384.43.607.747.379l4.878-3.555H19.5c1.377 0 2.5-1.123 2.5-2.465V4.534c0-1.342-1.121-2.465-2.5-2.465Zm.625 13.75a.63.63 0 0 1-.625.624h-6.25l-3.125 2.344v-2.344H4.5a.63.63 0 0 1-.625-.625V4.57a.63.63 0 0 1 .625-.625h15a.63.63 0 0 1 .625.625v11.25Zm-4.996-8.79a.937.937 0 0 0-1.326 0L12 8.87l-1.871-1.84a.937.937 0 1 0-1.326 1.326l1.873 1.838-1.84 1.836a.937.937 0 1 0 1.326 1.326L12 11.518l1.837 1.837a.937.937 0 1 0 1.326-1.325l-1.839-1.836 1.837-1.837a.912.912 0 0 0-.032-1.327Z",
        fill: "currentColor"
      }
    )
  })
);
var MessageXmark_default = SvgMessageXmark;

// src/Icon/icons/Message.tsx
import { jsx as jsx972 } from "react/jsx-runtime";
var SvgMessage = (props) => /* @__PURE__ */ jsx972(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx972(
      "path",
      {
        d: "M19.5 2.052h-15C3.123 2.052 2 3.175 2 4.517v11.215c0 1.376 1.123 2.464 2.5 2.464h3.75v3.28c0 .385.43.608.747.38l4.878-3.66H19.5c1.377 0 2.5-1.123 2.5-2.465V4.518a2.477 2.477 0 0 0-2.5-2.465Zm.66 13.75a.63.63 0 0 1-.625.625h-6.25L10.16 18.77v-2.343H4.535a.63.63 0 0 1-.625-.625V4.552a.63.63 0 0 1 .625-.625h15a.63.63 0 0 1 .624.625v11.25Z",
        fill: "currentColor"
      }
    )
  })
);
var Message_default = SvgMessage;

// src/Icon/icons/Messages.tsx
import { jsx as jsx973 } from "react/jsx-runtime";
var SvgMessages = (props) => /* @__PURE__ */ jsx973(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx973(
      "path",
      {
        d: "M15 5.972V12a2 2 0 0 1-2 1.997L9 14l-3.403 1.925a.374.374 0 0 1-.597-.3V14H4c-1.102 0-2-.897-2-2V5.972C2 4.898 2.898 4 4 4h9c1.103 0 2 .898 2 1.972ZM6.5 13.69 8.606 12.5H13c.272 0 .5-.225.5-.5V6c0-.273-.228-.5-.5-.5H4c-.273 0-.5.227-.5.5v6c0 .275.227.5.5.5h2.5v1.19ZM10 16v-1h1.5v1c0 .272.225.5.5.5h3.394l2.106 1.19V16.5H20c.272 0 .5-.228.5-.5v-6c0-.272-.228-.5-.5-.5h-4V8h4c1.103 0 2 .897 2 1.972V16c0 1.103-.897 2-2 2h-1v1.625a.374.374 0 0 1-.597.3L15 18l-3-.003c-1.1 0-2-.894-2-1.997Z",
        fill: "currentColor"
      }
    )
  })
);
var Messages_default = SvgMessages;

// src/Icon/icons/MicrochipAi.tsx
import { jsx as jsx974 } from "react/jsx-runtime";
var SvgMicrochipAi = (props) => /* @__PURE__ */ jsx974(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx974(
      "path",
      {
        d: "M10.84 9.152c-.25-.568-1.183-.568-1.432 0l-2.188 5a.781.781 0 0 0 1.432.627l.207-.473c.008.034.012.038.016.038h2.5l.015-.003.207.472c.094.292.415.468.716.468a.782.782 0 0 0 .715-1.094L10.84 9.152Zm-1.297 3.63.582-1.333.582 1.332H9.543Zm5.582-4.063a.781.781 0 0 0-.781.781v5a.781.781 0 1 0 1.562 0v-5a.762.762 0 0 0-.781-.781Zm5.938 4.219c.519 0 .937-.418.937-.938s-.42-.938-.938-.938H19.5V9.188h1.563c.519 0 .937-.418.937-.938s-.42-.938-.938-.938H19.5V7A2.5 2.5 0 0 0 17 4.5h-.313V2.937a.937.937 0 1 0-1.875 0V4.5h-1.874V2.937a.937.937 0 1 0-1.876 0V4.5H9.188V2.937a.936.936 0 1 0-1.876 0V4.5H7A2.5 2.5 0 0 0 4.5 7v.313H2.937A.939.939 0 0 0 2 8.25c0 .516.42.938.938.938H4.5v1.874H2.937A.939.939 0 0 0 2 12c0 .516.42.938.938.938H4.5v1.874H2.937A.939.939 0 0 0 2 15.75c0 .516.42.938.938.938H4.5V17A2.5 2.5 0 0 0 7 19.5h.313v1.563a.938.938 0 0 0 1.875 0V19.5h1.874v1.563a.938.938 0 0 0 1.876 0V19.5h1.874v1.563a.938.938 0 0 0 1.876 0V19.5H17a2.5 2.5 0 0 0 2.5-2.5v-.313h1.563a.938.938 0 0 0 0-1.875H19.5v-1.874h1.563ZM17.625 17c0 .345-.28.625-.625.625H7A.626.626 0 0 1 6.375 17V7c0-.345.28-.625.625-.625h10c.345 0 .625.28.625.625v10Z",
        fill: "currentColor"
      }
    )
  })
);
var MicrochipAi_default = SvgMicrochipAi;

// src/Icon/icons/Microchip.tsx
import { jsx as jsx975 } from "react/jsx-runtime";
var SvgMicrochip = (props) => /* @__PURE__ */ jsx975(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx975(
      "path",
      {
        d: "M14.5 8.25h-5c-.691 0-1.25.559-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-5c0-.691-.559-1.25-1.25-1.25Zm-.625 5.625h-3.75v-3.75h3.75v3.75Zm7.188-.938a.936.936 0 1 0 0-1.875H19.5V9.188h1.563c.519 0 .937-.418.937-.938s-.42-.938-.938-.938H19.5V7A2.5 2.5 0 0 0 17 4.5h-.313V2.937a.937.937 0 1 0-1.875 0V4.5h-1.874V2.937a.937.937 0 1 0-1.876 0V4.5H9.188V2.937a.936.936 0 1 0-1.876 0V4.5H7A2.5 2.5 0 0 0 4.5 7v.313H2.937A.939.939 0 0 0 2 8.25c0 .516.42.938.938.938H4.5v1.874H2.937A.939.939 0 0 0 2 12c0 .516.42.938.938.938H4.5v1.874H2.937A.939.939 0 0 0 2 15.75c0 .516.42.938.938.938H4.5V17A2.5 2.5 0 0 0 7 19.5h.313v1.563a.938.938 0 0 0 1.875 0V19.5h1.874v1.563a.938.938 0 0 0 1.876 0V19.5h1.874v1.563a.938.938 0 0 0 1.876 0V19.5H17a2.5 2.5 0 0 0 2.5-2.5v-.313h1.563a.938.938 0 0 0 0-1.875H19.5v-1.874h1.563ZM17.625 17c0 .345-.28.625-.625.625H7A.626.626 0 0 1 6.375 17V7c0-.345.28-.625.625-.625h10c.345 0 .625.28.625.625v10Z",
        fill: "currentColor"
      }
    )
  })
);
var Microchip_default = SvgMicrochip;

// src/Icon/icons/MicrophoneLinesSlash.tsx
import { jsx as jsx976 } from "react/jsx-runtime";
var SvgMicrophoneLinesSlash = (props) => /* @__PURE__ */ jsx976(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx976(
      "path",
      {
        d: "m21.718 18.661-4.98-3.904c.482-.81.767-1.747.767-2.757v-1.25c0-.415-.336-.75-.722-.75a.769.769 0 0 0-.75.75v1.222c0 .66-.176 1.272-.462 1.82l-.804-.63c.162-.366.265-.763.265-1.19V6.97c-.057-1.629-1.401-2.973-3.058-2.973-1.656 0-3 1.344-3 3v1.698L3.212 4.158a.75.75 0 1 0-.926 1.18l18.477 14.476a.748.748 0 0 0 .463.188.749.749 0 0 0 .59-.287.724.724 0 0 0-.1-1.054ZM12.474 8h1.029v1h-1c-.277 0-.472.224-.472.5a.47.47 0 0 0 .472.472l1 .029v2c0 .07-.021.132-.03.199L10.502 9.87V7a1.5 1.5 0 0 1 3 0h-1a.47.47 0 0 0-.471.472c0 .248.196.528.443.528Zm1.779 10.503h-1.5v-1.056a5.459 5.459 0 0 0 1.815-.59l-1.344-1.052a3.99 3.99 0 0 1-1.62.178C9.527 15.779 8 13.91 8 11.822v-.113l-1.463-1.147a.565.565 0 0 0-.037.188l-.028 1.003c0 2.802 1.972 5.302 4.723 5.68V18.5l-1.444.002a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h4.501a.75.75 0 0 0 0-1.5Z",
        fill: "currentColor"
      }
    )
  })
);
var MicrophoneLinesSlash_default = SvgMicrophoneLinesSlash;

// src/Icon/icons/MicrophoneLines.tsx
import { jsx as jsx977 } from "react/jsx-runtime";
var SvgMicrophoneLines = (props) => /* @__PURE__ */ jsx977(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx977(
      "path",
      {
        d: "M12 15.75c2.07 0 3.75-1.68 3.75-3.75V5.75a3.751 3.751 0 0 0-7.5 0V12c0 2.07 1.68 3.75 3.75 3.75Zm-1.875-10a1.875 1.875 0 0 1 3.75 0h-1.25a.625.625 0 1 0 0 1.25h1.25v1.25h-1.25a.627.627 0 0 0-.625.625c0 .344.281.625.625.625h1.25v1.25h-1.25a.627.627 0 0 0-.625.625c0 .344.281.625.625.625h1.25a1.875 1.875 0 0 1-3.75 0V5.75Zm7.813 3.75c-.52 0-.938.418-.938.902V12c0 2.92-2.52 5.27-5.5 4.977-2.594-.254-4.5-2.59-4.5-5.2V10.44c0-.522-.42-.94-.938-.94-.517 0-.937.418-.937.902v1.256c0 3.501 2.5 6.625 5.938 7.098v1.369H9.187a.935.935 0 0 0-.937.938c0 .519.418.937.938.937h5.624a.938.938 0 0 0 0-1.875h-1.874v-1.32c3.351-.457 5.937-3.332 5.937-6.805v-1.598c0-.484-.418-.902-.938-.902Z",
        fill: "currentColor"
      }
    )
  })
);
var MicrophoneLines_default = SvgMicrophoneLines;

// src/Icon/icons/MicrophoneSlash.tsx
import { jsx as jsx978 } from "react/jsx-runtime";
var SvgMicrophoneSlash = (props) => /* @__PURE__ */ jsx978(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx978(
      "path",
      {
        d: "m21.718 18.661-4.98-3.904c.482-.81.767-1.747.767-2.757v-1.25c0-.415-.336-.75-.722-.75a.769.769 0 0 0-.75.75v1.222c0 .66-.176 1.272-.462 1.82l-.804-.63c.162-.366.265-.763.265-1.19l-.057-4.973c0-1.657-1.316-3.001-2.973-3.001-1.656 0-3.028 1.344-3.028 3v1.696L3.213 4.158a.75.75 0 1 0-.926 1.18l18.477 14.476a.748.748 0 0 0 .463.188.749.749 0 0 0 .59-.287.724.724 0 0 0-.1-1.054ZM13.503 12c0 .07-.021.132-.03.199L10.502 9.87V7a1.5 1.5 0 0 1 3 0V12Zm.75 6.502h-1.5v-1.056a5.457 5.457 0 0 0 1.815-.59l-1.344-1.052a3.988 3.988 0 0 1-1.62.178C9.527 15.779 8 13.91 8 11.822v-.113l-1.463-1.147a.565.565 0 0 0-.037.188l-.028 1.003c0 2.802 1.972 5.302 4.723 5.68V18.5l-1.444.002a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h4.501a.75.75 0 0 0 0-1.5Z",
        fill: "currentColor"
      }
    )
  })
);
var MicrophoneSlash_default = SvgMicrophoneSlash;

// src/Icon/icons/MicrophoneStand.tsx
import { jsx as jsx979 } from "react/jsx-runtime";
var SvgMicrophoneStand = (props) => /* @__PURE__ */ jsx979(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx979(
      "path",
      {
        d: "M20.614 3.392a4.755 4.755 0 0 0-6.723 0L12.773 4.51a4.732 4.732 0 0 0-1.387 3.325l-8.91 10.059c-.654.707-.62 1.865.043 2.563l.994.996a1.877 1.877 0 0 0 2.566.078l4.957-4.402v3.933c0 .518.42.938.902.938.518 0 .938-.42.938-.938v-5.59l3.227-2.816a4.73 4.73 0 0 0 3.325-1.387l1.118-1.118c1.923-1.897 1.923-4.904.068-6.76ZM4.87 20.09l-.99-.991L12.203 9.7l2.065 2.066L4.87 20.09Zm11.26-9.34a2.895 2.895 0 0 1-.289-.03l-2.558-2.558a2.849 2.849 0 0 1 .722-2.212l4.047 4.047a2.835 2.835 0 0 1-1.923.753Zm3.25-2.074-4.051-4.05c1.097-1.034 2.875-.995 3.953.094a2.866 2.866 0 0 1 .097 3.956Z",
        fill: "currentColor"
      }
    )
  })
);
var MicrophoneStand_default = SvgMicrophoneStand;

// src/Icon/icons/Microphone.tsx
import { jsx as jsx980 } from "react/jsx-runtime";
var SvgMicrophone = (props) => /* @__PURE__ */ jsx980(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx980(
      "path",
      {
        d: "M17.938 9.5c-.52 0-.938.418-.938.902V12c0 2.92-2.52 5.27-5.5 4.977-2.594-.254-4.5-2.59-4.5-5.204v-1.37c0-.485-.42-.903-.938-.903-.517 0-.937.418-.937.902v1.256c0 3.501 2.5 6.625 5.938 7.098v1.369h-1.91a.92.92 0 0 0-.903.902c0 .485.418.973.902.973h5.625c.555 0 .973-.418.973-.938a.935.935 0 0 0-.938-.937h-1.874v-1.32c3.351-.457 5.937-3.332 5.937-6.805v-1.598c0-.484-.418-.902-.938-.902ZM12 15.75c2.07 0 3.75-1.68 3.75-3.75V5.75C15.75 3.715 14.07 2 12 2 9.93 2 8.25 3.68 8.25 5.75V12c0 2.07 1.68 3.75 3.75 3.75Zm-1.875-10a1.875 1.875 0 0 1 3.75 0V12a1.875 1.875 0 0 1-3.75 0V5.75Z",
        fill: "currentColor"
      }
    )
  })
);
var Microphone_default = SvgMicrophone;

// src/Icon/icons/Minimize.tsx
import { jsx as jsx981 } from "react/jsx-runtime";
var SvgMinimize = (props) => /* @__PURE__ */ jsx981(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx981(
      "path",
      {
        d: "M14.188 10.75h5.277a1.25 1.25 0 0 0 .884-2.133L18.51 6.779l3.18-3.178a.937.937 0 1 0-1.326-1.326l-3.18 3.179-1.836-1.837a1.25 1.25 0 0 0-2.134.883v5.278c.035.554.453.972.973.972Zm-4.375 2.465H4.5a1.25 1.25 0 0 0-.884 2.133l1.838 1.838-3.18 3.178a.937.937 0 0 0 0 1.326.84.84 0 0 0 .664.31c.24 0 .48-.092.663-.275l3.178-3.179 1.838 1.838a1.25 1.25 0 0 0 2.133-.884v-5.348a.958.958 0 0 0-.937-.937Zm.168-9.87c-.157-.064-.32-.13-.48-.13a1.25 1.25 0 0 0-.885.366L6.777 5.454l-3.176-3.18a.937.937 0 1 0-1.326 1.327l3.179 3.178-1.837 1.838a1.246 1.246 0 0 0-.272 1.362c.194.466.65.771 1.155.771h5.277a.9.9 0 0 0 .903-.902V4.5c.07-.505-.235-.962-.7-1.155Zm8.566 13.878 1.837-1.837a1.249 1.249 0 0 0-.884-2.134h-5.277a.9.9 0 0 0-.902.902v5.278a1.25 1.25 0 0 0 2.133.883l1.837-1.837 3.179 3.18c.112.252.35.342.593.342a.937.937 0 0 0 .663-1.6l-3.18-3.177Z",
        fill: "currentColor"
      }
    )
  })
);
var Minimize_default = SvgMinimize;

// src/Icon/icons/Minus.tsx
import { jsx as jsx982 } from "react/jsx-runtime";
var SvgMinus = (props) => /* @__PURE__ */ jsx982(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx982(
      "path",
      {
        d: "M22 12c0 .64-.514 1.154-1.154 1.154H3.154a1.154 1.154 0 1 1 0-2.308h17.692c.64 0 1.154.52 1.154 1.154Z",
        fill: "currentColor"
      }
    )
  })
);
var Minus_default = SvgMinus;

// src/Icon/icons/MinusHexagon.tsx
import { jsx as jsx983 } from "react/jsx-runtime";
var SvgMinusHexagon = (props) => /* @__PURE__ */ jsx983(
  "svg",
  __spreadProps(__spreadValues({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx983(
      "path",
      {
        d: "M13.377 6.98145C13.5879 7.33301 13.5879 7.77832 13.377 8.12988L10.752 12.6299C10.541 12.958 10.1895 13.1689 9.79102 13.1689H4.54102C4.11914 13.1689 3.76758 12.958 3.55664 12.6299L0.931641 8.12988C0.720703 7.77832 0.720703 7.33301 0.931641 6.98145L3.55664 2.48145C3.76758 2.15332 4.11914 1.91895 4.54102 1.91895H9.79102C10.1895 1.91895 10.541 2.15332 10.752 2.48145L13.377 6.98145ZM10.2598 8.48145C10.4004 8.48145 10.541 8.36426 10.541 8.2002V6.8877C10.541 6.74707 10.4004 6.60645 10.2598 6.60645H4.07227C3.9082 6.60645 3.79102 6.74707 3.79102 6.8877V8.2002C3.79102 8.36426 3.9082 8.48145 4.07227 8.48145H10.2598Z",
        fill: "currentColor"
      }
    )
  })
);
var MinusHexagon_default = SvgMinusHexagon;

// src/Icon/icons/MobileButton.tsx
import { jsx as jsx984 } from "react/jsx-runtime";
var SvgMobileButton = (props) => /* @__PURE__ */ jsx984(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx984(
      "path",
      {
        d: "M16.375 2h-8.75a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5h8.75a2.5 2.5 0 0 0 2.5-2.5v-15c0-1.38-1.121-2.5-2.5-2.5ZM17 19.5c0 .345-.28.625-.625.625h-8.75A.626.626 0 0 1 7 19.5v-15c0-.345.28-.625.625-.625h8.75c.344 0 .625.28.625.625v15Zm-5-2.188a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var MobileButton_default = SvgMobileButton;

// src/Icon/icons/MobileNotch.tsx
import { jsx as jsx985 } from "react/jsx-runtime";
var SvgMobileNotch = (props) => /* @__PURE__ */ jsx985(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx985(
      "path",
      {
        d: "M13.875 17.625h-3.75a.626.626 0 0 0 0 1.25h3.75a.625.625 0 1 0 0-1.25ZM16.375 2h-8.75a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5h8.75a2.5 2.5 0 0 0 2.5-2.5v-15c0-1.38-1.121-2.5-2.5-2.5ZM17 19.5c0 .345-.28.625-.625.625h-8.75A.626.626 0 0 1 7 19.5v-15c0-.345.28-.625.625-.625H9.5v1.25c0 .345.281.625.625.625h3.75c.344 0 .625-.28.625-.625v-1.25h1.875c.344 0 .625.28.625.625v15Z",
        fill: "currentColor"
      }
    )
  })
);
var MobileNotch_default = SvgMobileNotch;

// src/Icon/icons/MobileScreenButton.tsx
import { jsx as jsx986 } from "react/jsx-runtime";
var SvgMobileScreenButton = (props) => /* @__PURE__ */ jsx986(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx986(
      "path",
      {
        d: "M16.375 2h-8.75a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5h8.75a2.5 2.5 0 0 0 2.5-2.5v-15c0-1.38-1.121-2.5-2.5-2.5ZM17 19.5c0 .345-.28.625-.625.625h-8.75A.626.626 0 0 1 7 19.5v-3.125h10V19.5Zm0-5H7v-10c0-.345.28-.625.625-.625h8.75c.344 0 .625.28.625.625v10Zm-5 4.688a.937.937 0 1 0 0-1.875.937.937 0 0 0 0 1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var MobileScreenButton_default = SvgMobileScreenButton;

// src/Icon/icons/MobileScreen.tsx
import { jsx as jsx987 } from "react/jsx-runtime";
var SvgMobileScreen = (props) => /* @__PURE__ */ jsx987(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx987(
      "path",
      {
        d: "M16.375 2h-8.75a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5h8.75a2.5 2.5 0 0 0 2.5-2.5v-15c0-1.38-1.121-2.5-2.5-2.5ZM17 19.5c0 .345-.28.625-.625.625h-8.75A.626.626 0 0 1 7 19.5v-3.125h10V19.5Zm0-5H7v-10c0-.345.28-.625.625-.625h8.75c.344 0 .625.28.625.625v10Zm-6.25 4.375h2.5a.625.625 0 1 0 0-1.25h-2.5a.625.625 0 1 0 0 1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var MobileScreen_default = SvgMobileScreen;

// src/Icon/icons/Mobile.tsx
import { jsx as jsx988 } from "react/jsx-runtime";
var SvgMobile = (props) => /* @__PURE__ */ jsx988(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx988(
      "path",
      {
        d: "M16.375 2h-8.75a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5h8.75a2.5 2.5 0 0 0 2.5-2.5v-15c0-1.38-1.121-2.5-2.5-2.5ZM17 19.5c0 .345-.28.625-.625.625h-8.75A.626.626 0 0 1 7 19.5v-15c0-.345.28-.625.625-.625h8.75c.344 0 .625.28.625.625v15Zm-3.75-1.875h-2.5a.625.625 0 1 0 0 1.25h2.5a.625.625 0 1 0 0-1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var Mobile_default = SvgMobile;

// src/Icon/icons/MonitorWaveform.tsx
import { jsx as jsx989 } from "react/jsx-runtime";
var SvgMonitorWaveform = (props) => /* @__PURE__ */ jsx989(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx989(
      "path",
      {
        d: "M19.778 4.222H4.222A2.222 2.222 0 0 0 2 6.444v11.112c0 1.227.995 2.222 2.222 2.222h15.556A2.222 2.222 0 0 0 22 17.556V6.444a2.223 2.223 0 0 0-2.222-2.222Zm.555 13.334c0 .306-.249.555-.555.555H4.222a.556.556 0 0 1-.555-.555V13.11h3.972l1.423 2.373a.836.836 0 0 0 .716.405l.031-.001a.83.83 0 0 0 .714-.46l2.099-4.198.885 1.476a.835.835 0 0 0 .715.405h2.5a.831.831 0 0 0 .834-.833.831.831 0 0 0-.834-.834h-2.028L13.27 9.072c-.157-.26-.478-.428-.746-.404a.83.83 0 0 0-.714.46l-2.098 4.198-.886-1.475a.83.83 0 0 0-.715-.407H3.667v-5c0-.306.249-.555.555-.555h15.556c.306 0 .555.25.555.555v11.112Z",
        fill: "currentColor"
      }
    )
  })
);
var MonitorWaveform_default = SvgMonitorWaveform;

// src/Icon/icons/N.tsx
import { jsx as jsx990 } from "react/jsx-runtime";
var SvgN = (props) => /* @__PURE__ */ jsx990(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx990(
      "path",
      {
        d: "M19.5 22c-.31 0-.613-.135-.82-.382L5.571 6.014v14.915a1.07 1.07 0 1 1-2.143 0V3.072a1.072 1.072 0 0 1 1.891-.69l13.108 15.605V3.072C18.428 2.48 18.91 2 19.5 2c.59 0 1.071.48 1.071 1.072v17.857A1.072 1.072 0 0 1 19.5 22Z",
        fill: "currentColor"
      }
    )
  })
);
var N_default = SvgN;

// src/Icon/icons/NetworkInterfaces.tsx
import { jsx as jsx991 } from "react/jsx-runtime";
var SvgNetworkInterfaces = (props) => /* @__PURE__ */ jsx991(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx991(
      "path",
      {
        d: "M12 21c-4.915 0-9-4.085-9-9 0-4.924 4.076-9 8.991-9C16.915 3 21 7.076 21 12c0 4.915-4.076 9-9 9ZM9.538 10.297c.503.168 1.024.3 1.553.388a14.682 14.682 0 0 1 2.02-6.406c-.123-.017-.246-.035-.37-.044a13.672 13.672 0 0 0-3.626 5.189c.238.22.388.529.423.873ZM5.471 7.765a10.147 10.147 0 0 0 1.905 1.517c.23-.15.495-.238.742-.238a14.954 14.954 0 0 1 3.088-4.809c-2.382.247-4.474 1.606-5.735 3.53Zm8.179.106a10.728 10.728 0 0 1 .415-3.106 13.495 13.495 0 0 0-1.915 6.053c.256.017.52.026.785.026.23 0 .45-.009.67-.026a1.33 1.33 0 0 1 .336-.583 10.576 10.576 0 0 1-.291-2.364Zm1.068-.01c.008.671.088 1.324.22 1.96.441.008.83.22 1.068.547a10.114 10.114 0 0 0 3.08-1.589 7.949 7.949 0 0 0-3.936-3.9 9.685 9.685 0 0 0-.432 2.983ZM4.2 12c0 .177.009.344.018.52.89.75 1.861 1.377 2.876 1.871 0-.962.097-1.915.282-2.832a1.388 1.388 0 0 1-.59-1.138c0-.08 0-.16.017-.23a10.614 10.614 0 0 1-1.88-1.438A7.604 7.604 0 0 0 4.2 12Zm15.6 0c0-.75-.115-1.482-.318-2.18a11.185 11.185 0 0 1-3.22 1.589c-.062.317-.22.6-.46.803a9.708 9.708 0 0 0 2.083 2.7 12.843 12.843 0 0 0 1.588-.715A7.565 7.565 0 0 0 19.8 12Zm-8.753-.185v-.053a10.728 10.728 0 0 1-1.835-.45 1.386 1.386 0 0 1-.794.467c-.203.998-.283 2.03-.256 3.08a14.03 14.03 0 0 0 2.911.768c.089-.168.212-.318.362-.433a14.925 14.925 0 0 1-.388-3.38Zm1.888.097c-.273 0-.547-.01-.82-.027 0 1.024.123 2.039.344 3.018a1.38 1.38 0 0 1 1.12.865 13.37 13.37 0 0 0 3.168-.486 10.494 10.494 0 0 1-1.976-2.753 1.375 1.375 0 0 1-1.015-.652 8.291 8.291 0 0 1-.82.035Zm-8.444 2.18a7.905 7.905 0 0 0 3.062 4.287 12.544 12.544 0 0 1-.424-2.797c-.926-.397-1.808-.9-2.638-1.49ZM12 19.8c.45 0 .882-.044 1.315-.115a14.155 14.155 0 0 1-1.077-2.047 1.369 1.369 0 0 1-1.253-.953 14.842 14.842 0 0 1-2.761-.67c.088 1.076.326 2.126.697 3.132A7.529 7.529 0 0 0 12 19.8Zm1.244-2.532c.318.74.706 1.464 1.156 2.144a7.937 7.937 0 0 0 3.882-2.833c-.203-.15-.414-.3-.608-.458-1.342.44-2.736.67-4.13.714-.07.16-.176.31-.3.433Z",
        fill: "currentColor"
      }
    )
  })
);
var NetworkInterfaces_default = SvgNetworkInterfaces;

// src/Icon/icons/NotEqual.tsx
import { jsx as jsx992 } from "react/jsx-runtime";
var SvgNotEqual = (props) => /* @__PURE__ */ jsx992(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx992(
      "path",
      {
        d: "M22 15.846c0 .64-.515 1.154-1.154 1.154h-10.73l-2.92 4.477c-.22.34-.59.523-1.008.523-.217 0-.434-.06-.63-.188a1.181 1.181 0 0 1-.293-1.596L7.361 17H3.154a1.154 1.154 0 1 1 0-2.307h5.712l3.511-5.385H3.154a1.154 1.154 0 1 1 0-2.308h10.73l2.92-4.477a1.154 1.154 0 1 1 1.932 1.262L16.64 7h4.207a1.155 1.155 0 0 1 0 2.308h-5.711l-3.512 5.385h9.223c.64 0 1.154.519 1.154 1.153Z",
        fill: "currentColor"
      }
    )
  })
);
var NotEqual_default = SvgNotEqual;

// src/Icon/icons/NoteSticky.tsx
import { jsx as jsx993 } from "react/jsx-runtime";
var SvgNoteSticky = (props) => /* @__PURE__ */ jsx993(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx993(
      "path",
      {
        d: "M4.857 4.143a.716.716 0 0 0-.714.714v14.286c0 .393.321.714.714.714h10v-3.571c0-.79.639-1.429 1.429-1.429h3.571v-10a.716.716 0 0 0-.714-.714H4.857Zm10 17.857h-10A2.86 2.86 0 0 1 2 19.143V4.857A2.86 2.86 0 0 1 4.857 2h14.286A2.86 2.86 0 0 1 22 4.857v10.246c0 .759-.3 1.486-.835 2.022l-4.04 4.04a2.858 2.858 0 0 1-2.022.835h-.246Z",
        fill: "currentColor"
      }
    )
  })
);
var NoteSticky_default = SvgNoteSticky;

// src/Icon/icons/Note.tsx
import { jsx as jsx994 } from "react/jsx-runtime";
var SvgNote = (props) => /* @__PURE__ */ jsx994(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx994(
      "path",
      {
        d: "M19.143 4.143c.393 0 .714.321.714.714v10h-3.571c-.79 0-1.429.639-1.429 1.429v3.571h-10a.716.716 0 0 1-.714-.714V4.857c0-.393.321-.714.714-.714h14.286ZM4.857 22h10.246c.759 0 1.486-.3 2.022-.835l4.04-4.04A2.858 2.858 0 0 0 22 15.103V4.857A2.86 2.86 0 0 0 19.143 2H4.857A2.86 2.86 0 0 0 2 4.857v14.286A2.86 2.86 0 0 0 4.857 22Zm2.857-5.357a1.072 1.072 0 1 0-2.143 0 1.072 1.072 0 0 0 2.143 0ZM6.643 6.286a1.071 1.071 0 1 0 0 2.143 1.071 1.071 0 0 0 0-2.143ZM7.714 12a1.071 1.071 0 1 0-2.142 0 1.071 1.071 0 0 0 2.142 0Z",
        fill: "currentColor"
      }
    )
  })
);
var Note_default = SvgNote;

// src/Icon/icons/Notebook.tsx
import { jsx as jsx995 } from "react/jsx-runtime";
var SvgNotebook = (props) => /* @__PURE__ */ jsx995(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx995(
      "path",
      {
        d: "M18.875 2H7.625a2.5 2.5 0 0 0-2.5 2.5v1.25H3.562a.939.939 0 0 0-.937.938c0 .515.42.937.938.937h1.562v3.438H3.562a.939.939 0 0 0-.937.937c0 .516.42.938.938.938h1.562v3.437H3.562a.939.939 0 0 0-.937.938c0 .515.42.937.938.937h1.562v1.25a2.5 2.5 0 0 0 2.5 2.5h11.25a2.5 2.5 0 0 0 2.5-2.5v-15c0-1.38-1.121-2.5-2.5-2.5ZM7 19.5v-1.25h.938c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937H7v-3.438h.938c.519 0 .937-.417.937-.937a.935.935 0 0 0-.938-.938H7V7.626h.938c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937H7V4.5c0-.345.28-.625.625-.625h2.5v16.25h-2.5A.627.627 0 0 1 7 19.5Zm12.5 0c0 .345-.28.625-.625.625H12V3.875h6.875c.345 0 .625.28.625.625v15Z",
        fill: "currentColor"
      }
    )
  })
);
var Notebook_default = SvgNotebook;

// src/Icon/icons/Nvd.tsx
import { jsx as jsx996, jsxs as jsxs9 } from "react/jsx-runtime";
var SvgNvd = (props) => /* @__PURE__ */ jsxs9(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsx996("rect", { width: "24", height: "24", fill: "url(#pattern0_893_30033)" }),
      /* @__PURE__ */ jsxs9("defs", { children: [
        /* @__PURE__ */ jsx996(
          "pattern",
          {
            id: "pattern0_893_30033",
            patternContentUnits: "objectBoundingBox",
            width: "1",
            height: "1",
            children: /* @__PURE__ */ jsx996(
              "use",
              {
                xlinkHref: "#image0_893_30033",
                transform: "matrix(0.00166667 0 0 0.00158228 -0.182337 0)"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx996(
          "image",
          {
            id: "image0_893_30033",
            width: "800",
            height: "632",
            xlinkHref: "data:image/png;base64,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"
          }
        )
      ] })
    ]
  })
);
var Nvd_default = SvgNvd;

// src/Icon/icons/O.tsx
import { jsx as jsx997 } from "react/jsx-runtime";
var SvgO = (props) => /* @__PURE__ */ jsx997(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx997(
      "path",
      {
        d: "M12 22C6.487 22 2 17.513 2 12S6.487 2 12 2s10 4.487 10 10-4.487 10-10 10Zm0-17.857A7.818 7.818 0 0 0 4.143 12 7.842 7.842 0 0 0 12 19.857c4.332 0 7.857-3.524 7.857-7.857S16.33 4.143 12 4.143Z",
        fill: "currentColor"
      }
    )
  })
);
var O_default = SvgO;

// src/Icon/icons/ObjectExclude.tsx
import { jsx as jsx998 } from "react/jsx-runtime";
var SvgObjectExclude = (props) => /* @__PURE__ */ jsx998(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx998(
      "path",
      {
        d: "M3.875 4.5v8.75c0 .344.28.625.625.625H7v1.875H4.5c-1.38 0-2.5-1.121-2.5-2.5V4.5A2.5 2.5 0 0 1 4.5 2h8.75c1.379 0 2.5 1.12 2.5 2.5V7h-1.875V4.5a.626.626 0 0 0-.625-.625H4.5a.625.625 0 0 0-.625.625Zm6.25 12.5v2.5c0 .344.281.625.625.625h8.75a.627.627 0 0 0 .625-.625v-8.75a.627.627 0 0 0-.625-.625H17V8.25h2.5c1.379 0 2.5 1.121 2.5 2.5v8.75c0 1.379-1.121 2.5-2.5 2.5h-8.75a2.502 2.502 0 0 1-2.5-2.5V17h1.875ZM12 15.75v-1.875h1.25a.627.627 0 0 0 .625-.625h1.875c0 1.379-1.121 2.5-2.5 2.5H12ZM15.75 12h-1.875v-1.875h-.625V8.25h2.5V12Zm-7.5 3.75V12h1.875v1.875h.625v1.875h-2.5Zm2.5-7.5H12v1.875h-1.25a.627.627 0 0 0-.625.625H8.25c0-1.379 1.121-2.5 2.5-2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var ObjectExclude_default = SvgObjectExclude;

// src/Icon/icons/ObjectGroup.tsx
import { jsx as jsx999 } from "react/jsx-runtime";
var SvgObjectGroup = (props) => /* @__PURE__ */ jsx999(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx999(
      "path",
      {
        d: "M5.75 8.25C5.75 7.559 6.309 7 7 7h5c.691 0 1.25.559 1.25 1.25V12c0 .691-.559 1.25-1.25 1.25H7c-.691 0-1.25-.559-1.25-1.25V8.25ZM12 14.5c1.379 0 2.5-1.121 2.5-2.5v-1.25H17c.691 0 1.25.559 1.25 1.25v3.75c0 .691-.559 1.25-1.25 1.25h-5c-.691 0-1.25-.559-1.25-1.25V14.5H12ZM2.625 6.523C2.241 6.145 2 5.68 2 5.125c0-1.036.84-1.875 1.875-1.875.555 0 1.02.241 1.398.625h13.454A1.875 1.875 0 0 1 22 5.125c0 .555-.242 1.02-.625 1.398v10.954a1.877 1.877 0 1 1-2.648 2.648H5.273c-.378.383-.843.625-1.398.625a1.875 1.875 0 0 1-1.25-3.273V6.523Zm1.875.372v10.21c.531.192.953.614 1.145 1.145h12.71a1.907 1.907 0 0 1 1.145-1.145V6.895a1.907 1.907 0 0 1-1.145-1.145H5.645A1.907 1.907 0 0 1 4.5 6.895Z",
        fill: "currentColor"
      }
    )
  })
);
var ObjectGroup_default = SvgObjectGroup;

// src/Icon/icons/ObjectIntersect.tsx
import { jsx as jsx1000 } from "react/jsx-runtime";
var SvgObjectIntersect = (props) => /* @__PURE__ */ jsx1000(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1000(
      "path",
      {
        d: "M5.75 3.875H4.5a.625.625 0 0 0-.625.625v1.25H2V4.5A2.5 2.5 0 0 1 4.5 2h1.25v1.875ZM7 2h3.75v1.875H7V2ZM2 7h1.875v3.75H2V7Zm13.75 1.25v5c0 1.379-1.121 2.5-2.5 2.5h-5v-5c0-1.379 1.121-2.5 2.5-2.5h5Zm-5 1.875a.627.627 0 0 0-.625.625v3.125h3.125a.627.627 0 0 0 .625-.625v-3.125H10.75Zm-.625 8.125v1.25c0 .344.281.625.625.625H12V22h-1.25a2.502 2.502 0 0 1-2.5-2.5v-1.25h1.875ZM15.75 4.5v1.25h-1.875V4.5a.626.626 0 0 0-.625-.625H12V2h1.25c1.379 0 2.5 1.12 2.5 2.5Zm2.5 3.75h1.25c1.379 0 2.5 1.121 2.5 2.5V12h-1.875v-1.25a.627.627 0 0 0-.625-.625h-1.25V8.25Zm-12.5 5.625v1.875H4.5c-1.38 0-2.5-1.121-2.5-2.5V12h1.875v1.25c0 .344.28.625.625.625h1.25ZM17 20.125V22h-3.75v-1.875H17ZM19.5 22h-1.25v-1.875h1.25a.627.627 0 0 0 .625-.625v-1.25H22v1.25c0 1.379-1.121 2.5-2.5 2.5Zm2.5-5h-1.875v-3.75H22V17Z",
        fill: "currentColor"
      }
    )
  })
);
var ObjectIntersect_default = SvgObjectIntersect;

// src/Icon/icons/ObjectSubtract.tsx
import { jsx as jsx1001 } from "react/jsx-runtime";
var SvgObjectSubtract = (props) => /* @__PURE__ */ jsx1001(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1001(
      "path",
      {
        d: "M3.875 4.5v1.25H2V4.5A2.5 2.5 0 0 1 4.5 2h1.25v1.875H4.5a.625.625 0 0 0-.625.625Zm6.875-.625H7V2h3.75v1.875ZM3.875 10.75H2V7h1.875v3.75Zm0 1.25v1.25c0 .344.28.625.625.625h1.25v1.875H4.5c-1.38 0-2.5-1.121-2.5-2.5V12h1.875ZM7 15.75v-1.875h3.75v1.875H7ZM10.125 17v2.5c0 .344.281.625.625.625h8.75a.627.627 0 0 0 .625-.625v-8.75a.627.627 0 0 0-.625-.625H17V8.25h2.5c1.379 0 2.5 1.121 2.5 2.5v8.75c0 1.379-1.121 2.5-2.5 2.5h-8.75a2.502 2.502 0 0 1-2.5-2.5V17h1.875Zm5.625-6.25h-1.875V7h1.875v3.75Zm0-6.25v1.25h-1.875V4.5a.626.626 0 0 0-.625-.625H12V2h1.25c1.379 0 2.5 1.12 2.5 2.5ZM12 13.875h1.25a.627.627 0 0 0 .625-.625V12h1.875v1.25c0 1.379-1.121 2.5-2.5 2.5H12v-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var ObjectSubtract_default = SvgObjectSubtract;

// src/Icon/icons/ObjectUngroup.tsx
import { jsx as jsx1002 } from "react/jsx-runtime";
var SvgObjectUngroup = (props) => /* @__PURE__ */ jsx1002(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1002(
      "path",
      {
        d: "M4 4c.84 0 1.56.517 1.853 1.25h6.294a2 2 0 1 1 2.603 2.603v3.294A1.992 1.992 0 0 1 16 13c0 1.103-.897 2-2 2-.84 0-1.56-.516-1.853-1.25H5.853a2 2 0 1 1-2.603-2.603V7.853A2 2 0 0 1 4 4Zm0 2.5a.5.5 0 1 0-.5-.5v.007A.5.5 0 0 0 4 6.5Zm10-1a.5.5 0 1 0 0 1 .501.501 0 1 0 0-1Zm-1.853 1.25H5.853c-.2.5-.603.903-1.103 1.103v3.294c.5.2.903.575 1.103 1.103h6.294c.2-.528.575-.903 1.103-1.103V7.853a1.91 1.91 0 0 1-1.103-1.103ZM14.5 13a.5.5 0 1 0-.998.001A.5.5 0 0 0 14.5 13ZM4 12.5a.5.5 0 1 0 0 1l.007-.028c.027 0 .053.025.079.022A.501.501 0 0 0 4 12.5Zm12.728-.75a2.996 2.996 0 0 0-.728-.988v-.512h2.147A1.992 1.992 0 0 1 20 9c1.103 0 2 .897 2 2 0 .84-.516 1.56-1.25 1.853v3.294A1.992 1.992 0 0 1 22 18c0 1.103-.897 2-2 2-.84 0-1.56-.516-1.853-1.25h-6.294A1.992 1.992 0 0 1 10 20c-1.103 0-2-.897-2-2 0-.84.516-1.56 1.25-1.853V15h1.5v1.147c.5.2.903.575 1.103 1.103h6.294c.2-.528.575-.903 1.103-1.103v-3.294a1.91 1.91 0 0 1-1.103-1.103h-1.419ZM20.5 11a.501.501 0 0 0-.587-.494.5.5 0 1 0 .587.494Zm-11 7a.501.501 0 0 0 .588.494A.5.5 0 1 0 9.5 18Zm10.413.494a.501.501 0 0 0 .581-.578v-.003a.5.5 0 1 0-.581.58Z",
        fill: "currentColor"
      }
    )
  })
);
var ObjectUngroup_default = SvgObjectUngroup;

// src/Icon/icons/ObjectUnion.tsx
import { jsx as jsx1003 } from "react/jsx-runtime";
var SvgObjectUnion = (props) => /* @__PURE__ */ jsx1003(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1003(
      "path",
      {
        d: "M4.5 15.75c-1.38 0-2.5-1.121-2.5-2.5V4.5A2.5 2.5 0 0 1 4.5 2h8.75c1.379 0 2.5 1.12 2.5 2.5v3.75h3.75c1.379 0 2.5 1.121 2.5 2.5v8.75c0 1.379-1.121 2.5-2.5 2.5h-8.75a2.502 2.502 0 0 1-2.5-2.5v-3.75H4.5Zm5.625-1.875V19.5c0 .344.281.625.625.625h8.75a.627.627 0 0 0 .625-.625v-8.75a.627.627 0 0 0-.625-.625h-5.625V4.5a.626.626 0 0 0-.625-.625H4.5a.625.625 0 0 0-.625.625v8.75c0 .344.28.625.625.625h5.625Z",
        fill: "currentColor"
      }
    )
  })
);
var ObjectUnion_default = SvgObjectUnion;

// src/Icon/icons/ObjectsAlignBottom.tsx
import { jsx as jsx1004 } from "react/jsx-runtime";
var SvgObjectsAlignBottom = (props) => /* @__PURE__ */ jsx1004(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1004(
      "path",
      {
        d: "M2.938 22a.937.937 0 1 1 0-1.875h18.125c.519 0 .937.418.937.938 0 .519-.418.937-.938.937H2.938Zm3.437-5A1.875 1.875 0 0 1 4.5 15.125V3.875C4.5 2.839 5.34 2 6.375 2h2.5c1.035 0 1.875.84 1.875 1.875v11.25C10.75 16.16 9.91 17 8.875 17h-2.5Zm2.5-13.125h-2.5v11.25h2.5V3.875ZM15.125 17a1.875 1.875 0 0 1-1.875-1.875v-6.25C13.25 7.84 14.09 7 15.125 7h2.5c1.035 0 1.875.84 1.875 1.875v6.25c0 1.035-.84 1.875-1.875 1.875h-2.5Zm2.5-8.125h-2.5v6.25h2.5v-6.25Z",
        fill: "currentColor"
      }
    )
  })
);
var ObjectsAlignBottom_default = SvgObjectsAlignBottom;

// src/Icon/icons/ObjectsAlignCenterHorizontal.tsx
import { jsx as jsx1005 } from "react/jsx-runtime";
var SvgObjectsAlignCenterHorizontal = (props) => /* @__PURE__ */ jsx1005(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1005(
      "path",
      {
        d: "M20.75 8.875c0 1.035-.84 1.875-1.875 1.875h-5.938v2.5h3.438c1.035 0 1.875.84 1.875 1.875v2.5c0 1.035-.84 1.875-1.875 1.875h-3.438v1.563c0 .519-.417.937-.937.937a.935.935 0 0 1-.938-.938V19.5H7.626a1.875 1.875 0 0 1-1.875-1.875v-2.5c0-1.035.84-1.875 1.875-1.875h3.438v-2.5H5.125A1.875 1.875 0 0 1 3.25 8.875v-2.5c0-1.036.84-1.875 1.875-1.875h5.938V2.937a.937.937 0 1 1 1.874 0V4.5h5.938c1.035 0 1.875.84 1.875 1.875v2.5Zm-1.875 0v-2.5H5.125v2.5h13.75Zm-2.5 8.75v-2.5h-8.75v2.5h8.75Z",
        fill: "currentColor"
      }
    )
  })
);
var ObjectsAlignCenterHorizontal_default = SvgObjectsAlignCenterHorizontal;

// src/Icon/icons/ObjectsAlignCenterVertical.tsx
import { jsx as jsx1006 } from "react/jsx-runtime";
var SvgObjectsAlignCenterVertical = (props) => /* @__PURE__ */ jsx1006(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1006(
      "path",
      {
        d: "M4.5 5.125c0-1.036.84-1.875 1.875-1.875h2.5c1.035 0 1.875.84 1.875 1.875v5.938h2.5V7.624c0-1.035.84-1.875 1.875-1.875h2.5c1.035 0 1.875.84 1.875 1.875v3.438h1.563c.519 0 .937.417.937.937s-.418.938-.938.938H19.5v3.437c0 1.035-.84 1.875-1.875 1.875h-2.5a1.875 1.875 0 0 1-1.875-1.875v-3.438h-2.5v5.938c0 1.035-.84 1.875-1.875 1.875h-2.5A1.875 1.875 0 0 1 4.5 18.875v-5.938H2.937a.937.937 0 1 1 0-1.874H4.5V5.125Zm1.875 13.75h2.5V5.125h-2.5v13.75Zm8.75-2.5h2.5v-8.75h-2.5v8.75Z",
        fill: "currentColor"
      }
    )
  })
);
var ObjectsAlignCenterVertical_default = SvgObjectsAlignCenterVertical;

// src/Icon/icons/ObjectsAlignLeft.tsx
import { jsx as jsx1007 } from "react/jsx-runtime";
var SvgObjectsAlignLeft = (props) => /* @__PURE__ */ jsx1007(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1007(
      "path",
      {
        d: "M2 2.938a.938.938 0 0 1 1.875 0v18.125a.937.937 0 1 1-1.875 0V2.938Zm5 3.437C7 5.339 7.84 4.5 8.875 4.5h11.25C21.16 4.5 22 5.34 22 6.375v2.5c0 1.035-.84 1.875-1.875 1.875H8.875A1.875 1.875 0 0 1 7 8.875v-2.5Zm13.125 2.5v-2.5H8.875v2.5h11.25ZM7 15.125c0-1.035.84-1.875 1.875-1.875h6.25c1.035 0 1.875.84 1.875 1.875v2.5c0 1.035-.84 1.875-1.875 1.875h-6.25A1.875 1.875 0 0 1 7 17.625v-2.5Zm8.125 2.5v-2.5h-6.25v2.5h6.25Z",
        fill: "currentColor"
      }
    )
  })
);
var ObjectsAlignLeft_default = SvgObjectsAlignLeft;

// src/Icon/icons/ObjectsAlignRight.tsx
import { jsx as jsx1008 } from "react/jsx-runtime";
var SvgObjectsAlignRight = (props) => /* @__PURE__ */ jsx1008(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1008(
      "path",
      {
        d: "M22 21.063c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938V2.938a.937.937 0 1 1 1.875 0v18.125ZM17 8.874c0 1.035-.84 1.875-1.875 1.875H3.875A1.875 1.875 0 0 1 2 8.875v-2.5C2 5.339 2.84 4.5 3.875 4.5h11.25C16.16 4.5 17 5.34 17 6.375v2.5Zm-1.875 0v-2.5H3.875v2.5h11.25ZM17 17.625c0 1.035-.84 1.875-1.875 1.875h-6.25A1.875 1.875 0 0 1 7 17.625v-2.5c0-1.035.84-1.875 1.875-1.875h6.25c1.035 0 1.875.84 1.875 1.875v2.5Zm-1.875 0v-2.5h-6.25v2.5h6.25Z",
        fill: "currentColor"
      }
    )
  })
);
var ObjectsAlignRight_default = SvgObjectsAlignRight;

// src/Icon/icons/ObjectsAlignTop.tsx
import { jsx as jsx1009 } from "react/jsx-runtime";
var SvgObjectsAlignTop = (props) => /* @__PURE__ */ jsx1009(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1009(
      "path",
      {
        d: "M21.063 2a.937.937 0 1 1 0 1.875H2.938a.938.938 0 0 1 0-1.875h18.125ZM8.874 7c1.035 0 1.875.84 1.875 1.875v11.25C10.75 21.16 9.91 22 8.875 22h-2.5A1.875 1.875 0 0 1 4.5 20.125V8.875C4.5 7.84 5.34 7 6.375 7h2.5Zm0 1.875h-2.5v11.25h2.5V8.875ZM17.625 7c1.035 0 1.875.84 1.875 1.875v6.25c0 1.035-.84 1.875-1.875 1.875h-2.5a1.875 1.875 0 0 1-1.875-1.875v-6.25C13.25 7.84 14.09 7 15.125 7h2.5Zm0 1.875h-2.5v6.25h2.5v-6.25Z",
        fill: "currentColor"
      }
    )
  })
);
var ObjectsAlignTop_default = SvgObjectsAlignTop;

// src/Icon/icons/ObjectsColumn.tsx
import { jsx as jsx1010 } from "react/jsx-runtime";
var SvgObjectsColumn = (props) => /* @__PURE__ */ jsx1010(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1010(
      "path",
      {
        d: "M2 4.143C2 2.959 2.96 2 4.143 2h4.286c1.183 0 2.142.96 2.142 2.143v7.143c0 1.183-.96 2.143-2.142 2.143H4.143A2.143 2.143 0 0 1 2 11.286V4.143Zm2.143 7.143h4.286V4.143H4.143v7.143Zm9.286 1.428c0-1.183.96-2.143 2.142-2.143h4.286c1.183 0 2.143.96 2.143 2.143v7.143C22 21.04 21.04 22 19.857 22h-4.286a2.143 2.143 0 0 1-2.142-2.143v-7.143Zm2.142 7.143h4.286v-7.143h-4.286v7.143Zm-7.142-5c1.183 0 2.142.96 2.142 2.143v2.857c0 1.183-.96 2.143-2.142 2.143H4.143A2.143 2.143 0 0 1 2 19.857V17c0-1.183.96-2.143 2.143-2.143h4.286Zm0 2.143H4.143v2.857h4.286V17Zm5-12.857c0-1.184.96-2.143 2.142-2.143h4.286C21.04 2 22 2.96 22 4.143V7c0 1.183-.96 2.143-2.143 2.143h-4.286A2.143 2.143 0 0 1 13.43 7V4.143ZM15.57 7h4.286V4.143h-4.286V7Z",
        fill: "currentColor"
      }
    )
  })
);
var ObjectsColumn_default = SvgObjectsColumn;

// src/Icon/icons/OctagonCheck.tsx
import { jsx as jsx1011 } from "react/jsx-runtime";
var SvgOctagonCheck = (props) => /* @__PURE__ */ jsx1011(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1011(
      "path",
      {
        d: "M9.48 3.876a.945.945 0 0 0-.664.274L4.15 8.816a.945.945 0 0 0-.274.664v5.041c0 .246.099.453.274.664L2.824 16.51A2.812 2.812 0 0 1 2 14.52v-5.04c0-.747.296-1.462.824-1.99L7.49 2.824A2.812 2.812 0 0 1 9.481 2h5.04c.746 0 1.461.296 1.989.824l4.665 4.667c.528.528.825 1.243.825 1.99v5.04c0 .746-.297 1.461-.825 1.989l-4.665 4.665A2.813 2.813 0 0 1 14.52 22h-5.04a2.813 2.813 0 0 1-1.99-.825L2.824 16.51l1.326-1.325 4.666 4.666a.944.944 0 0 0 .664.273h5.041c.246 0 .453-.097.664-.273l4.666-4.666c.176-.21.273-.418.273-.664v-5.04a.944.944 0 0 0-.273-.665L15.185 4.15c-.21-.175-.418-.274-.664-.274h-5.04Zm1.9 11.255c-.333.398-.927.398-1.294 0l-2.5-2.501c-.364-.332-.364-.926 0-1.294.366-.363.96-.363 1.293 0l1.871 1.84 4.338-4.34c.367-.364.96-.364 1.293 0 .398.367.398.96 0 1.293l-5.002 5.002Z",
        fill: "currentColor"
      }
    )
  })
);
var OctagonCheck_default = SvgOctagonCheck;

// src/Icon/icons/OctagonDivide.tsx
import { jsx as jsx1012 } from "react/jsx-runtime";
var SvgOctagonDivide = (props) => /* @__PURE__ */ jsx1012(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1012(
      "path",
      {
        d: "M10.75 8.214c0-.656.559-1.25 1.25-1.25.692 0 1.251.594 1.251 1.25 0 .727-.559 1.25-1.25 1.25-.692 0-1.25-.523-1.25-1.25Zm4.69 2.814c.519 0 .937.453.937.938a.914.914 0 0 1-.938.937H8.562a.914.914 0 0 1-.938-.937c0-.485.418-.938.938-.938h6.877Zm-2.189 4.689c0 .726-.559 1.25-1.25 1.25-.692 0-1.25-.523-1.25-1.25 0-.657.558-1.25 1.25-1.25.691 0 1.25.593 1.25 1.25ZM2 9.48c0-.746.296-1.461.824-1.989l4.667-4.667A2.812 2.812 0 0 1 9.481 2h5.04c.746 0 1.461.296 1.989.824l4.665 4.667c.528.528.825 1.243.825 1.99v5.04c0 .746-.297 1.461-.825 1.989l-4.665 4.665a2.813 2.813 0 0 1-1.99.825H9.48a2.813 2.813 0 0 1-1.989-.825L2.824 16.51A2.812 2.812 0 0 1 2 14.521v-5.04Zm2.15-.664a.945.945 0 0 0-.274.664v5.041c0 .246.099.485.274.66l4.666 4.67a.944.944 0 0 0 .664.273h5.04c.247 0 .454-.097.665-.273l4.666-4.67a.934.934 0 0 0 .273-.66v-5.04a.944.944 0 0 0-.273-.665L15.185 4.15c-.21-.176-.418-.275-.664-.275H9.48a.945.945 0 0 0-.665.275L4.15 8.816ZM2.824 16.51l1.326-1.329-1.326 1.329Z",
        fill: "currentColor"
      }
    )
  })
);
var OctagonDivide_default = SvgOctagonDivide;

// src/Icon/icons/OctagonExclamation.tsx
import { jsx as jsx1013 } from "react/jsx-runtime";
var SvgOctagonExclamation = (props) => /* @__PURE__ */ jsx1013(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1013(
      "path",
      {
        d: "M12 6.964c.52 0 .938.453.938.938v4.376a.914.914 0 0 1-.937.938.914.914 0 0 1-.938-.938V7.902c0-.485.418-.938.938-.938Zm1.251 8.753c0 .726-.559 1.25-1.25 1.25-.692 0-1.25-.523-1.25-1.25 0-.657.558-1.25 1.25-1.25.691 0 1.25.593 1.25 1.25ZM2 9.48c0-.746.296-1.461.824-1.989l4.667-4.667A2.812 2.812 0 0 1 9.481 2h5.04c.746 0 1.461.296 1.989.824l4.665 4.667c.528.528.825 1.243.825 1.99v5.04c0 .746-.297 1.461-.825 1.989l-4.665 4.665a2.813 2.813 0 0 1-1.99.825H9.48a2.813 2.813 0 0 1-1.989-.825L2.824 16.51A2.812 2.812 0 0 1 2 14.521v-5.04Zm2.15-.664a.945.945 0 0 0-.274.664v5.041c0 .246.099.485.274.66l4.666 4.67a.944.944 0 0 0 .664.273h5.04c.247 0 .454-.097.665-.273l4.666-4.67a.934.934 0 0 0 .273-.66v-5.04a.944.944 0 0 0-.273-.665L15.185 4.15c-.21-.176-.418-.275-.664-.275H9.48a.945.945 0 0 0-.665.275L4.15 8.816ZM2.824 16.51l1.326-1.329-1.326 1.329Z",
        fill: "currentColor"
      }
    )
  })
);
var OctagonExclamation_default = SvgOctagonExclamation;

// src/Icon/icons/OctagonExclamationFilled.tsx
import { jsx as jsx1014 } from "react/jsx-runtime";
var SvgOctagonExclamationFilled = (props) => /* @__PURE__ */ jsx1014(
  "svg",
  __spreadProps(__spreadValues({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1014(
      "path",
      {
        d: "M13.752 11.8799C14.1738 12.6299 13.6348 13.5439 12.7676 13.5439H1.54102C0.673828 13.5439 0.134766 12.6064 0.556641 11.8799L6.18164 2.10645C6.60352 1.35645 7.70508 1.37988 8.12695 2.10645L13.752 11.8799ZM7.16602 9.84082C6.55664 9.84082 6.08789 10.333 6.08789 10.9189C6.08789 11.5283 6.55664 11.9971 7.16602 11.9971C7.75195 11.9971 8.24414 11.5283 8.24414 10.9189C8.24414 10.333 7.75195 9.84082 7.16602 9.84082ZM6.13477 5.97363L6.29883 9.16113C6.32227 9.3252 6.43945 9.41895 6.58008 9.41895H7.72852C7.86914 9.41895 7.98633 9.3252 8.00977 9.16113L8.17383 5.97363C8.19727 5.80957 8.05664 5.66895 7.89258 5.66895H6.41602C6.25195 5.66895 6.11133 5.80957 6.13477 5.97363Z",
        fill: "currentColor"
      }
    )
  })
);
var OctagonExclamationFilled_default = SvgOctagonExclamationFilled;

// src/Icon/icons/OctagonMinus.tsx
import { jsx as jsx1015 } from "react/jsx-runtime";
var SvgOctagonMinus = (props) => /* @__PURE__ */ jsx1015(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1015(
      "path",
      {
        d: "M15.44 11.028c.519 0 .937.453.937.938a.914.914 0 0 1-.938.937H8.562a.914.914 0 0 1-.938-.937c0-.485.418-.938.938-.938h6.877ZM2 9.48c0-.746.296-1.461.824-1.989l4.667-4.667A2.812 2.812 0 0 1 9.481 2h5.04c.746 0 1.461.296 1.989.824l4.665 4.667c.528.528.825 1.243.825 1.99v5.04c0 .746-.297 1.461-.825 1.989l-4.665 4.665a2.813 2.813 0 0 1-1.99.825H9.48a2.813 2.813 0 0 1-1.989-.825L2.824 16.51A2.812 2.812 0 0 1 2 14.521v-5.04Zm2.15-.664a.945.945 0 0 0-.274.664v5.041c0 .246.099.485.274.66l4.666 4.67a.944.944 0 0 0 .664.273h5.04c.247 0 .454-.097.665-.273l4.666-4.67a.934.934 0 0 0 .273-.66v-5.04a.944.944 0 0 0-.273-.665L15.185 4.15c-.21-.176-.418-.275-.664-.275H9.48a.945.945 0 0 0-.665.275L4.15 8.816ZM2.824 16.51l1.326-1.329-1.326 1.329Z",
        fill: "currentColor"
      }
    )
  })
);
var OctagonMinus_default = SvgOctagonMinus;

// src/Icon/icons/OctagonPlus.tsx
import { jsx as jsx1016 } from "react/jsx-runtime";
var SvgOctagonPlus = (props) => /* @__PURE__ */ jsx1016(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1016(
      "path",
      {
        d: "M11.063 15.404v-2.5H8.562a.914.914 0 0 1-.938-.938c0-.485.418-.938.938-.938h2.5V8.527c0-.485.419-.938.939-.938s.937.453.937.938v2.5h2.501c.52 0 .938.454.938.939a.914.914 0 0 1-.938.937h-2.5v2.501a.914.914 0 0 1-.938.938.914.914 0 0 1-.938-.938ZM2 9.48c0-.746.296-1.461.824-1.989l4.667-4.667A2.812 2.812 0 0 1 9.481 2h5.04c.746 0 1.461.296 1.989.824l4.665 4.667c.528.528.825 1.243.825 1.99v5.04c0 .746-.297 1.461-.825 1.989l-4.665 4.665a2.813 2.813 0 0 1-1.99.825H9.48a2.813 2.813 0 0 1-1.989-.825L2.824 16.51A2.812 2.812 0 0 1 2 14.521v-5.04Zm2.15-.664a.945.945 0 0 0-.274.664v5.041c0 .246.099.485.274.66l4.666 4.67a.944.944 0 0 0 .664.273h5.04c.247 0 .454-.097.665-.273l4.666-4.67a.934.934 0 0 0 .273-.66v-5.04a.944.944 0 0 0-.273-.665L15.185 4.15c-.21-.176-.418-.275-.664-.275H9.48a.945.945 0 0 0-.665.275L4.15 8.816ZM2.824 16.51l1.326-1.329-1.326 1.329Z",
        fill: "currentColor"
      }
    )
  })
);
var OctagonPlus_default = SvgOctagonPlus;

// src/Icon/icons/OctagonXmark.tsx
import { jsx as jsx1017 } from "react/jsx-runtime";
var SvgOctagonXmark = (props) => /* @__PURE__ */ jsx1017(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1017(
      "path",
      {
        d: "M8.836 8.836c.367-.364.96-.364 1.293 0l1.837 1.84 1.871-1.84c.367-.364.962-.364 1.294 0 .398.367.398.96 0 1.293l-1.806 1.837 1.806 1.871c.398.368.398.962 0 1.294-.332.398-.927.398-1.294 0l-1.871-1.806-1.837 1.806c-.332.398-.926.398-1.293 0-.364-.332-.364-.926 0-1.294l1.84-1.871-1.84-1.837c-.364-.332-.364-.926 0-1.293ZM2 9.48c0-.746.297-1.461.824-1.989l4.667-4.667A2.812 2.812 0 0 1 9.481 2h5.04c.746 0 1.461.296 1.989.824l4.665 4.667c.528.528.825 1.243.825 1.99v5.04c0 .746-.297 1.461-.825 1.989l-4.665 4.665A2.813 2.813 0 0 1 14.52 22h-5.04a2.813 2.813 0 0 1-1.99-.825L2.824 16.51A2.812 2.812 0 0 1 2 14.521v-5.04Zm2.15-.664a.945.945 0 0 0-.274.664v5.041c0 .246.099.485.275.66l4.665 4.67a.944.944 0 0 0 .664.273h5.041c.246 0 .453-.097.664-.273l4.666-4.67a.935.935 0 0 0 .273-.66v-5.04a.944.944 0 0 0-.273-.665L15.185 4.15c-.21-.176-.418-.275-.664-.275h-5.04a.945.945 0 0 0-.665.275L4.151 8.816ZM2.825 16.51l1.327-1.329-1.327 1.329Z",
        fill: "currentColor"
      }
    )
  })
);
var OctagonXmark_default = SvgOctagonXmark;

// src/Icon/icons/Octagon.tsx
import { jsx as jsx1018 } from "react/jsx-runtime";
var SvgOctagon = (props) => /* @__PURE__ */ jsx1018(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1018(
      "path",
      {
        d: "M2 9.48c0-.746.296-1.461.824-1.989l4.667-4.667A2.812 2.812 0 0 1 9.481 2h5.04c.746 0 1.461.296 1.989.824l4.665 4.667c.528.528.825 1.243.825 1.99v5.04c0 .746-.297 1.461-.825 1.989l-4.665 4.665A2.813 2.813 0 0 1 14.52 22h-5.04a2.813 2.813 0 0 1-1.99-.825L2.824 16.51A2.812 2.812 0 0 1 2 14.52v-5.04Zm2.15-.664a.945.945 0 0 0-.274.664v5.041c0 .246.099.453.274.664l4.666 4.666a.944.944 0 0 0 .664.273h5.041c.246 0 .453-.097.664-.273l4.666-4.666c.176-.21.273-.418.273-.664v-5.04a.944.944 0 0 0-.273-.665L15.185 4.15c-.21-.175-.418-.274-.664-.274h-5.04a.945.945 0 0 0-.665.274L4.15 8.816ZM2.824 16.51l1.326-1.325-1.326 1.325Z",
        fill: "currentColor"
      }
    )
  })
);
var Octagon_default = SvgOctagon;

// src/Icon/icons/Option.tsx
import { jsx as jsx1019 } from "react/jsx-runtime";
var SvgOption = (props) => /* @__PURE__ */ jsx1019(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1019(
      "path",
      {
        d: "M15.75 7.5h5.5a.749.749 0 1 0 0-1.5h-5.5a.749.749 0 1 0 0 1.5Zm5.5 9h-4.047c-.379 0-.733-.169-.971-.463L8.934 7.018A2.74 2.74 0 0 0 6.797 6H2.75a.75.75 0 0 0 0 1.5h4.047c.379 0 .733.169.971.463l7.3 9.019A2.732 2.732 0 0 0 17.203 18h4.047a.75.75 0 0 0 0-1.5Z",
        fill: "currentColor"
      }
    )
  })
);
var Option_default = SvgOption;

// src/Icon/icons/Outdent.tsx
import { jsx as jsx1020 } from "react/jsx-runtime";
var SvgOutdent = (props) => /* @__PURE__ */ jsx1020(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1020(
      "path",
      {
        d: "M2 3.429c0-.592.48-1.072 1.071-1.072H20.93a1.07 1.07 0 1 1 0 2.143H3.07C2.48 4.5 2 4.02 2 3.429Zm8.571 5.714c0-.594.478-1.072 1.072-1.072h9.286c.593 0 1.071.478 1.071 1.072 0 .594-.478 1.071-1.071 1.071h-9.286a1.069 1.069 0 0 1-1.072-1.071Zm10.358 4.643c.593 0 1.071.477 1.071 1.071s-.478 1.072-1.071 1.072h-9.286a1.069 1.069 0 0 1-1.072-1.072c0-.594.478-1.071 1.072-1.071h9.286ZM2 20.57c0-.593.48-1.071 1.071-1.071H20.93c.593 0 1.071.478 1.071 1.071 0 .594-.478 1.072-1.071 1.072H3.07A1.07 1.07 0 0 1 2 20.57Zm.272-8.017c-.306-.326-.306-.822 0-1.108l4.273-3.482c.468-.424 1.13-.053 1.13.55v6.973c0 .602-.662.933-1.13.549l-4.273-3.482Z",
        fill: "currentColor"
      }
    )
  })
);
var Outdent_default = SvgOutdent;

// src/Icon/icons/P.tsx
import { jsx as jsx1021 } from "react/jsx-runtime";
var SvgP = (props) => /* @__PURE__ */ jsx1021(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1021(
      "path",
      {
        d: "M5.929 22a1.07 1.07 0 0 1-1.072-1.071V3.07C4.857 2.48 5.337 2 5.93 2h6.428a6.794 6.794 0 0 1 6.786 6.786 6.794 6.794 0 0 1-6.786 6.785H7v5.358A1.07 1.07 0 0 1 5.929 22ZM7 13.429h5.357A4.648 4.648 0 0 0 17 8.786a4.65 4.65 0 0 0-4.643-4.643H7v9.286Z",
        fill: "currentColor"
      }
    )
  })
);
var P_default = SvgP;

// src/Icon/icons/PageCaretDown.tsx
import { jsx as jsx1022 } from "react/jsx-runtime";
var SvgPageCaretDown = (props) => /* @__PURE__ */ jsx1022(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1022(
      "path",
      {
        d: "M12 15.75a.624.624 0 0 1-.46-.203L8.581 12.32c-.552-.601-.125-1.57.691-1.57h5.454a.937.937 0 0 1 .691 1.57l-2.957 3.227a.624.624 0 0 1-.461.203ZM17 22H7c-1.38 0-2.5-1.121-2.5-2.5v-15A2.5 2.5 0 0 1 7 2h7.09c.664 0 1.297.263 1.765.732l2.915 2.911c.468.47.73 1.103.73 1.767V19.5c0 1.379-1.121 2.5-2.5 2.5ZM6.375 19.5c0 .344.28.625.625.625h10a.627.627 0 0 0 .625-.625V7.41a.627.627 0 0 0-.184-.441l-2.91-2.91a.627.627 0 0 0-.441-.184H7a.625.625 0 0 0-.625.625v15Z",
        fill: "currentColor"
      }
    )
  })
);
var PageCaretDown_default = SvgPageCaretDown;

// src/Icon/icons/PageCaretUp.tsx
import { jsx as jsx1023 } from "react/jsx-runtime";
var SvgPageCaretUp = (props) => /* @__PURE__ */ jsx1023(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1023(
      "path",
      {
        d: "M12 9.5c.176 0 .344.074.46.203l2.958 3.227a.937.937 0 0 1-.691 1.57H9.273c-.816 0-1.243-.969-.691-1.57l2.957-3.227A.624.624 0 0 1 12 9.5ZM17 22H7c-1.38 0-2.5-1.121-2.5-2.5v-15A2.5 2.5 0 0 1 7 2h7.09c.664 0 1.297.263 1.765.732l2.915 2.911c.468.47.73 1.103.73 1.767V19.5c0 1.379-1.121 2.5-2.5 2.5ZM6.375 19.5c0 .344.28.625.625.625h10a.627.627 0 0 0 .625-.625V7.41a.627.627 0 0 0-.184-.441l-2.91-2.91a.627.627 0 0 0-.441-.184H7a.625.625 0 0 0-.625.625v15Z",
        fill: "currentColor"
      }
    )
  })
);
var PageCaretUp_default = SvgPageCaretUp;

// src/Icon/icons/Page.tsx
import { jsx as jsx1024 } from "react/jsx-runtime";
var SvgPage = (props) => /* @__PURE__ */ jsx1024(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1024(
      "path",
      {
        d: "M17 22H7c-1.38 0-2.5-1.121-2.5-2.5v-15A2.5 2.5 0 0 1 7 2h7.09c.664 0 1.297.263 1.765.732l2.915 2.911c.468.47.73 1.103.73 1.767V19.5c0 1.379-1.121 2.5-2.5 2.5ZM7 20.125h10a.627.627 0 0 0 .625-.625V7.41a.627.627 0 0 0-.184-.441l-2.91-2.91a.627.627 0 0 0-.441-.184H7a.625.625 0 0 0-.625.625v15c0 .344.28.625.625.625Z",
        fill: "currentColor"
      }
    )
  })
);
var Page_default = SvgPage;

// src/Icon/icons/PaperPlaneTop.tsx
import { jsx as jsx1025 } from "react/jsx-runtime";
var SvgPaperPlaneTop = (props) => /* @__PURE__ */ jsx1025(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1025(
      "path",
      {
        d: "m21.242 10.869-17.5-7.5c-.158-.068-.326-.137-.491-.137-.337 0-.668.137-.91.393-.36.416-.443.982-.21 1.451l3.619 6.941-3.618 6.942a1.25 1.25 0 0 0 1.61 1.707l17.5-7.5c.46-.197.758-.65.758-1.15-.035-.499-.297-.952-.758-1.147ZM4.614 5.782l12.362 5.298H7.375L4.614 5.782Zm2.76 7.173h9.598L4.613 18.25l2.762-5.296Z",
        fill: "currentColor"
      }
    )
  })
);
var PaperPlaneTop_default = SvgPaperPlaneTop;

// src/Icon/icons/PaperPlane.tsx
import { jsx as jsx1026 } from "react/jsx-runtime";
var SvgPaperPlane = (props) => /* @__PURE__ */ jsx1026(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1026(
      "path",
      {
        d: "M2.623 12.164c-.883.504-.8 1.848.14 2.238l5.481 2.286v4.035a1.275 1.275 0 0 0 2.258.816l2.422-2.902 4.84 2.015c.738.309 1.593-.175 1.714-.965l2.5-16.25a1.246 1.246 0 0 0-.527-1.218 1.254 1.254 0 0 0-1.328-.055l-17.5 10Zm2.035.996 13.34-7.62-8.578 9.585.047.04-4.809-2.005Zm13.09 5.457-6.508-2.715 8.363-9.347-1.855 12.062Z",
        fill: "currentColor"
      }
    )
  })
);
var PaperPlane_default = SvgPaperPlane;

// src/Icon/icons/PaperclipVertical.tsx
import { jsx as jsx1027 } from "react/jsx-runtime";
var SvgPaperclipVertical = (props) => /* @__PURE__ */ jsx1027(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1027(
      "path",
      {
        d: "M6.375 6.219a4.219 4.219 0 1 1 8.438 0v9.218A2.81 2.81 0 0 1 12 18.25a2.81 2.81 0 0 1-2.813-2.813v-7.5c0-.519.418-.937.938-.937s.938.418.938.938v7.5c0 .519.417.937.937.937s.938-.418.938-.938V6.22a2.345 2.345 0 0 0-4.688 0v10.156c0 2.07 1.645 3.75 3.75 3.75 2.07 0 3.75-1.68 3.75-3.75V7.937c0-.519.418-.937.938-.937.519 0 .937.418.937.938v8.437A5.626 5.626 0 0 1 12 22a5.626 5.626 0 0 1-5.625-5.625V6.219Z",
        fill: "currentColor"
      }
    )
  })
);
var PaperclipVertical_default = SvgPaperclipVertical;

// src/Icon/icons/Paperclip.tsx
import { jsx as jsx1028 } from "react/jsx-runtime";
var SvgPaperclip = (props) => /* @__PURE__ */ jsx1028(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1028(
      "path",
      {
        d: "M18.012 4.71c-1.04-1.08-2.734-1.08-3.81 0l-7.675 7.674c-1.753 1.787-1.753 4.63 0 6.38a4.483 4.483 0 0 0 6.346 0l6.103-6.103c.378-.373.988-.373 1.33 0 .409.378.409.988 0 1.33l-6.104 6.103c-2.47 2.541-6.533 2.541-9.038 0-2.505-2.47-2.505-6.533 0-9.039l7.709-7.708c1.795-1.796 4.706-1.796 6.468 0 1.831 1.795 1.831 4.709 0 6.467l-7.344 7.413a3.01 3.01 0 0 1-4.477-.245 3.013 3.013 0 0 1 .221-4.008l6.095-6.095c.378-.373.988-.373 1.33 0 .409.378.409.988 0 1.33l-6.06 6.127a1.082 1.082 0 0 0-.08 1.441 1.078 1.078 0 0 0 1.606.089l7.38-7.38a2.667 2.667 0 0 0 0-3.776Z",
        fill: "currentColor"
      }
    )
  })
);
var Paperclip_default = SvgPaperclip;

// src/Icon/icons/ParagraphLeft.tsx
import { jsx as jsx1029 } from "react/jsx-runtime";
var SvgParagraphLeft = (props) => /* @__PURE__ */ jsx1029(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1029(
      "path",
      {
        d: "M10.09 10.75h1.25l.035 2.813c0 .519.418.937.938.937.519 0 .937-.418.937-.938V3.876h1.25v9.688c0 .519.418.937.938.937.519 0 .937-.42.937-.938V3.876h.938a.937.937 0 1 0 0-1.875H10.09C7.624 2 5.75 3.875 5.75 6.375s1.875 4.375 4.34 4.375Zm0-6.875h1.25v5h-1.25c-1.47 0-2.5-1.03-2.5-2.5s1.066-2.5 2.5-2.5Zm8.473 13.438H7.88l1.31-1.179a.938.938 0 0 0-1.256-1.394L4.81 17.553a.937.937 0 0 0 0 1.394l3.125 2.812c.18.128.404.241.628.241a.937.937 0 0 0 .627-1.635l-1.31-1.177h10.683a.938.938 0 0 0 0-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var ParagraphLeft_default = SvgParagraphLeft;

// src/Icon/icons/Paragraph.tsx
import { jsx as jsx1030 } from "react/jsx-runtime";
var SvgParagraph = (props) => /* @__PURE__ */ jsx1030(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1030(
      "path",
      {
        d: "M20.214 2H10.027C6.154 2 2.853 5.013 2.719 8.884a7.143 7.143 0 0 0 7.138 7.402H12v4.643a1.072 1.072 0 0 0 2.143 0V4.143h2.143v16.786a1.072 1.072 0 0 0 2.143 0V4.143h1.785a1.07 1.07 0 1 0 0-2.143ZM12 14.143H9.857c-2.763 0-5-2.237-5-5 0-2.764 2.237-5 5-5H12v10Z",
        fill: "currentColor"
      }
    )
  })
);
var Paragraph_default = SvgParagraph;

// src/Icon/icons/PartyHorn.tsx
import { jsx as jsx1031 } from "react/jsx-runtime";
var SvgPartyHorn = (props) => /* @__PURE__ */ jsx1031(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx1031(
      "path",
      {
        d: "M9.17 8.25c.212 0 .424-.07.6-.217a6.134 6.134 0 0 0 2.212-4.723v-.373c0-.517-.42-.937-.902-.937-.483 0-.903.42-.903.938v.372A4.26 4.26 0 0 1 8.64 6.592c-.47.334-.52.924-.188 1.322.184.223.45.336.719.336ZM4.482 4.465c.69 0 1.215-.56 1.215-1.215 0-.69-.56-1.215-1.215-1.215-.69 0-1.215.56-1.215 1.215-.035.69.525 1.215 1.215 1.215ZM21.01 12h-.373a6.12 6.12 0 0 0-4.686 2.21.937.937 0 0 0 .12 1.322.9.9 0 0 0 .564.218.936.936 0 0 0 .72-.337c.85-.98 2.045-1.538 3.319-1.538h.372c.518 0 .902-.42.902-.938A.918.918 0 0 0 21.01 12Zm-.313 6.25c-.69 0-1.215.56-1.215 1.215 0 .69.56 1.215 1.215 1.215s1.215-.56 1.215-1.215c.035-.656-.488-1.215-1.215-1.215Zm0-11.25c-.69 0-1.215.56-1.215 1.215 0 .69.56 1.215 1.215 1.215s1.215-.56 1.215-1.215C21.947 7.559 21.424 7 20.697 7Zm-3.492 1.875c.816-.956.757-1.882.713-2.559-.038-.584-.042-.858.267-1.22.308-.36.578-.397 1.159-.45.674-.06 1.598-.144 2.415-1.1a.938.938 0 0 0-1.425-1.218c-.308.36-.578.398-1.159.45-.674.062-1.598.145-2.416 1.1-.815.957-.756 1.883-.712 2.56.037.584.041.858-.268 1.219-.306.359-.576.397-1.156.45-.673.059-1.598.14-2.414 1.096a.94.94 0 0 0 .101 1.324.927.927 0 0 0 .575.223.934.934 0 0 0 .713-.328c.306-.36.576-.397 1.154-.45.71-.058 1.633-.14 2.453-1.097Zm-9.34.992a1.24 1.24 0 0 0-1.149-.34c-.415.09-.756.385-.906.783l-3.715 10c-.172.459-.06.976.287 1.323.205.238.524.367.85.367.148 0 .297-.026.44-.08l9.965-3.75a1.25 1.25 0 0 0 .444-2.054L7.865 9.867ZM4.3 19.684l1.272-3.393 2.12 2.12L4.3 19.684Zm5.319-1.997-3.324-3.324.931-2.484 4.879 4.88-2.486.928Z",
        fill: "currentColor"
      }
    )
  })
);
var PartyHorn_default = SvgPartyHorn;

// src/Icon/icons/Passport.tsx
import { jsx as jsx1032 } from "react/jsx-runtime";
var SvgPassport = (props) => /* @__PURE__ */ jsx1032(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1032(
      "path",
      {
        d: "M18.25 2H5.75a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5h12.5c1.375 0 2.5-1.125 2.5-2.5v-15c0-1.375-1.125-2.5-2.5-2.5Zm.625 17.5c0 .345-.28.625-.625.625H5.75a.625.625 0 0 1-.625-.625v-15c0-.345.28-.625.625-.625h12.5c.345 0 .625.28.625.625v15Zm-2.5-2.5h-8.75a.632.632 0 0 0-.625.625c0 .34.285.625.625.625h8.75a.63.63 0 0 0 .625-.625.628.628 0 0 0-.625-.625ZM12 14.812a4.689 4.689 0 0 0 0-9.374 4.689 4.689 0 0 0-4.688 4.687A4.691 4.691 0 0 0 12 14.813ZM15.375 9.5h-1.353c-.053-.923-.224-1.758-.478-2.432A3.425 3.425 0 0 1 15.375 9.5Zm-1.352 1.25h1.353a3.434 3.434 0 0 1-1.831 2.432c.217-.674.424-1.51.478-2.432ZM12 6.777c.27.325.684 1.262.781 2.723H11.22c.097-1.46.511-2.398.781-2.723Zm.781 3.973c-.097 1.46-.511 2.398-.781 2.727-.27-.329-.684-1.266-.781-2.727h1.562Zm-2.324-3.68c-.289.672-.426 1.508-.477 2.43H8.625a3.417 3.417 0 0 1 1.832-2.43Zm-.477 3.68c.051.922.188 1.758.477 2.434a3.441 3.441 0 0 1-1.832-2.434H9.98Z",
        fill: "currentColor"
      }
    )
  })
);
var Passport_default = SvgPassport;

// src/Icon/icons/Paste.tsx
import { jsx as jsx1033 } from "react/jsx-runtime";
var SvgPaste = (props) => /* @__PURE__ */ jsx1033(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1033(
      "path",
      {
        d: "M5.125 5.75v.625c0 .691.559 1.25 1.25 1.25H8.75A3.748 3.748 0 0 1 12 5.75h2.422A2.503 2.503 0 0 0 12 3.875h-1.586a2.186 2.186 0 0 0-4.328 0H4.5a2.502 2.502 0 0 0-2.5 2.5V17c0 1.379 1.121 2.5 2.5 2.5h3.75v-1.875H4.5A.627.627 0 0 1 3.875 17V6.375c0-.344.281-.625.625-.625h.625Zm2.5-1.563a.625.625 0 1 1 1.25 0 .625.625 0 0 1-1.25 0ZM12 20.126a.627.627 0 0 1-.625-.625v-10c0-.344.281-.625.625-.625h5v1.875c0 .691.559 1.25 1.25 1.25h1.875v7.5a.627.627 0 0 1-.625.625H12ZM19.5 22c1.379 0 2.5-1.121 2.5-2.5v-8.598c0-.496-.2-.972-.55-1.324l-2.028-2.027A1.875 1.875 0 0 0 18.098 7H12a2.502 2.502 0 0 0-2.5 2.5v10c0 1.379 1.121 2.5 2.5 2.5h7.5Z",
        fill: "currentColor"
      }
    )
  })
);
var Paste_default = SvgPaste;

// src/Icon/icons/Pause.tsx
import { jsx as jsx1034 } from "react/jsx-runtime";
var SvgPause = (props) => /* @__PURE__ */ jsx1034(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1034(
      "path",
      {
        d: "M6.583 2c-.69 0-1.25.56-1.25 1.25v17.5a1.25 1.25 0 0 0 2.5 0V3.25c0-.69-.56-1.25-1.25-1.25Zm10.834 0c-.69 0-1.25.56-1.25 1.25v17.5a1.25 1.25 0 0 0 2.5 0V3.25c0-.69-.558-1.25-1.25-1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var Pause_default = SvgPause;

// src/Icon/icons/PenCircle.tsx
import { jsx as jsx1035 } from "react/jsx-runtime";
var SvgPenCircle = (props) => /* @__PURE__ */ jsx1035(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1035(
      "path",
      {
        d: "M16.535 8.02c.613.609.613 1.597 0 2.21l-.836.836-2.77-2.773.837-.836c.609-.61 1.597-.61 2.21 0l.56.563Zm-8.601 5.234 4.109-4.074 2.773 2.77-4.109 4.109c-.16.16-.363.273-.582.328l-2.348.59a.638.638 0 0 1-.593-.165.663.663 0 0 1-.164-.628l.585-2.317c.055-.219.168-.418.329-.613ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10ZM12 3.875A8.124 8.124 0 0 0 3.875 12 8.124 8.124 0 0 0 12 20.125 8.124 8.124 0 0 0 20.125 12 8.124 8.124 0 0 0 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var PenCircle_default = SvgPenCircle;

// src/Icon/icons/PenField.tsx
import { jsx as jsx1036 } from "react/jsx-runtime";
var SvgPenField = (props) => /* @__PURE__ */ jsx1036(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx1036(
      "path",
      {
        d: "M17.722 4.69c.909-.894 2.352-.899 3.239-.01l.374.374a2.26 2.26 0 0 1 .003 3.2l-5.55 5.552a2.277 2.277 0 0 1-1.137.616l-2.688.535a.66.66 0 0 1-.689-.176.757.757 0 0 1-.204-.689l.566-2.694c.088-.425.27-.843.604-1.126l5.482-5.582Zm2.173 1.056a.756.756 0 0 0-1.072.004l-.654.664 1.437 1.438.663-.692c.295-.267.295-.745 0-1.04l-.374-.374Zm-6.781 5.963-.33 1.563 1.559-.327a.768.768 0 0 0 .377-.205l3.82-3.823-1.43-1.43-3.795 3.845a.738.738 0 0 0-.201.377ZM10.3 7.911c.418 0 .754.337.754.755a.753.753 0 0 1-.754.754H4.264a.754.754 0 0 0-.755.755v7.545c0 .418.338.755.755.755h13.581a.753.753 0 0 0 .755-.755v-4.024c0-.418.336-.755.754-.755s.755.337.755.755v4.024a2.262 2.262 0 0 1-2.264 2.264H4.264A2.263 2.263 0 0 1 2 17.72v-7.545A2.263 2.263 0 0 1 4.264 7.91H10.3Zm-5.282 6.037a1.005 1.005 0 1 1 2.012 0 1.005 1.005 0 1 1-2.012 0Zm5.03 0a1.005 1.005 0 1 1-2.012 0 1.005 1.005 0 1 1 2.012 0Z",
        fill: "currentColor"
      }
    )
  })
);
var PenField_default = SvgPenField;

// src/Icon/icons/Pen.tsx
import { jsx as jsx1037 } from "react/jsx-runtime";
var SvgPen = (props) => /* @__PURE__ */ jsx1037(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1037(
      "path",
      {
        d: "M4.29 14.629 16.183 2.734a2.507 2.507 0 0 1 3.543 0l1.54 1.542a2.505 2.505 0 0 1 0 3.54L9.372 19.71c-.05.05-.102.066-.156.148-.376.332-.821.544-1.306.72L3.203 21.96a.882.882 0 0 1-.928-.27c-.243-.207-.334-.563-.237-.895l1.384-4.705a3.449 3.449 0 0 1 .868-1.462Zm.933 1.99-.899 3.058 3.057-.9c.215-.074.477-.21.665-.394l8.93-8.935-2.459-2.46-8.9 8.966a.869.869 0 0 0-.066.075c-.151.168-.264.371-.328.59Z",
        fill: "currentColor"
      }
    )
  })
);
var Pen_default = SvgPen;

// src/Icon/icons/PencilSlash.tsx
import { jsx as jsx1038 } from "react/jsx-runtime";
var SvgPencilSlash = (props) => /* @__PURE__ */ jsx1038(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1038(
      "path",
      {
        d: "M3.213 4.16a.75.75 0 0 0-.925 1.18l18.5 14.5a.75.75 0 0 0 .924-1.18l-6.903-5.41 4.588-4.584a2 2 0 0 0 0-2.828l-1.231-1.235a2 2 0 0 0-2.829 0L10.26 9.681 3.213 4.16Zm8.234 6.453L14.03 8.03 15.97 9.97l-2.347 2.347-2.175-1.704Zm.028 3.85-1.303 1.303-1.55-.388-.388-1.55 1.075-1.075-1.187-.934-2.288 2.287a2.814 2.814 0 0 0-.221.25l-.025.016.006.01a2.774 2.774 0 0 0-.453.893l-.722 2.444-.388 1.318a.74.74 0 0 0 .191.741.757.757 0 0 0 .74.19l1.32-.387 2.44-.719c.325-.093.628-.25.894-.453l.009.007.016-.026a2.216 2.216 0 0 0 .25-.222l2.768-2.768-1.187-.934.003-.003Zm-4.444.753.241.968a.753.753 0 0 0 .547.547l.969.24-.232.35a1.281 1.281 0 0 1-.253.107l-.731.216-1.713.503.504-1.713.215-.73c.025-.088.063-.176.106-.254l.347-.231v-.003Z",
        fill: "currentColor"
      }
    )
  })
);
var PencilSlash_default = SvgPencilSlash;

// src/Icon/icons/Pencil.tsx
import { jsx as jsx1039 } from "react/jsx-runtime";
var SvgPencil = (props) => /* @__PURE__ */ jsx1039(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1039(
      "path",
      {
        d: "m3.424 16.09-.9 3.054-.484 1.65a.939.939 0 0 0 1.16 1.17l1.655-.49 3.054-.899a3.395 3.395 0 0 0 1.118-.567l.012.008.02-.031a2.779 2.779 0 0 0 .313-.278l11.894-11.89a2.503 2.503 0 0 0 0-3.54l-1.54-1.544a2.502 2.502 0 0 0-3.54 0L4.293 14.628a3.514 3.514 0 0 0-.278.313l-.031.02.008.011a3.472 3.472 0 0 0-.567 1.118Zm13.553-6.643-7.258 7.257-1.94-.485-.484-1.939 7.257-7.257 2.425 2.424ZM5.793 16.012l.301 1.212a.942.942 0 0 0 .685.685l1.212.3-.29.439a1.603 1.603 0 0 1-.316.133l-.915.27-2.147.625.63-2.143.27-.915c.03-.11.078-.219.132-.316l.438-.29Zm8.536-5.482a.628.628 0 0 0 0-.884.628.628 0 0 0-.883 0L9.692 13.4a.628.628 0 0 0 0 .884.628.628 0 0 0 .883 0l3.754-3.754Z",
        fill: "currentColor"
      }
    )
  })
);
var Pencil_default = SvgPencil;

// src/Icon/icons/PeopleGroup.tsx
import { jsx as jsx1040 } from "react/jsx-runtime";
var SvgPeopleGroup = (props) => /* @__PURE__ */ jsx1040(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1040(
      "path",
      {
        d: "M4.5 6.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm2 2.5c.722 0 1.444.234 2.012.634a4.463 4.463 0 0 0-.943 1.175A1.98 1.98 0 0 0 6.5 10.5h-1v6h1V16c0-.416.334-.75.75-.75s.75.334.75.75v1c0 .553-.447 1-1 1H5a1 1 0 0 1-1-1v-1.338A3.5 3.5 0 0 1 5.5 9h1ZM4 11.178c-.311.35-.5.816-.5 1.322 0 .506.189.972.5 1.322v-2.644Zm13.5-.678c-.394 0-.76.113-1.069.31a4.462 4.462 0 0 0-.944-1.176A3.485 3.485 0 0 1 17.5 9h1a3.502 3.502 0 0 1 1.5 6.662V17c0 .553-.447 1-1 1h-2c-.553 0-1-.447-1-1v-1c0-.416.334-.75.75-.75s.75.334.75.75v.5h1v-6h-1Zm2.5.678v2.644c.284-.35.5-.816.5-1.322 0-.506-.216-.972-.5-1.322ZM19.5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-9.25.25a1.75 1.75 0 1 1 3.501.001 1.75 1.75 0 0 1-3.501-.001ZM12.5 9.5a3.502 3.502 0 0 1 1.5 6.663V18c0 .553-.447 1-1 1h-2c-.553 0-1-.447-1-1v-1.837A3.502 3.502 0 0 1 11.5 9.5h1Zm-1 8h1V11h-1v6.5ZM10 14.322v-2.644c-.313.35-.5.816-.5 1.322 0 .506.188.972.5 1.322ZM14.5 13c0-.506-.216-.972-.5-1.322v2.644c.284-.35.5-.816.5-1.322Z",
        fill: "currentColor"
      }
    )
  })
);
var PeopleGroup_default = SvgPeopleGroup;

// src/Icon/icons/People.tsx
import { jsx as jsx1041 } from "react/jsx-runtime";
var SvgPeople = (props) => /* @__PURE__ */ jsx1041(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1041(
      "path",
      {
        d: "M6.414 6.444c.92 0 1.635-.746 1.635-1.666 0-.92-.684-1.667-1.604-1.667s-1.698.747-1.698 1.667.778 1.666 1.667 1.666Zm11.11 0c.921 0 1.668-.746 1.668-1.666 0-.92-.716-1.667-1.667-1.667-.92 0-1.635.747-1.635 1.667s.746 1.666 1.635 1.666Zm-8.218 2.66a2.487 2.487 0 0 0-2.312-1.548H5.896a2.49 2.49 0 0 0-2.314 1.548l-1.519 3.691a.833.833 0 1 0 1.541.634l.618-1.502v8.129c0 .46.374.833.834.833.46 0 .802-.373.802-.833v-4.723h1.111v4.723a.834.834 0 0 0 1.666 0v-8.129l.619 1.503c.163.32.476.514.77.514a.832.832 0 0 0 .77-1.15l-1.488-3.69Zm-3.448 4.563V9.222h1.08v4.445h-1.08Zm16.08-.872-1.519-3.69a2.49 2.49 0 0 0-2.314-1.55h-1.1a2.492 2.492 0 0 0-2.313 1.548l-1.519 3.691a.832.832 0 0 0 .758 1.15.84.84 0 0 0 .698-.387l-.993 2.888h1.635v3.61c0 .46.374.834.834.834.46 0 .802-.373.802-.833v-3.611h1.08v3.61a.834.834 0 0 0 1.666 0v-3.61h1.667l-.952-2.857c.282.221.532.357.768.357.106 0 .214-.02.317-.063a.824.824 0 0 0 .485-1.087Zm-5.958 1.983 1.576-4.73 1.577 4.73H15.98Z",
        fill: "currentColor"
      }
    )
  })
);
var People_default = SvgPeople;

// src/Icon/icons/Person.tsx
import { jsx as jsx1042 } from "react/jsx-runtime";
var SvgPerson = (props) => /* @__PURE__ */ jsx1042(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1042(
      "path",
      {
        d: "M13.875 3.875a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm-2.5 11.875v5.313c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938V10.735l-1.684 2.977a.937.937 0 1 1-1.632-.922L8.47 8.746A3.438 3.438 0 0 1 11.465 7h1.07c1.242 0 2.383.668 2.992 1.746l2.29 4.043a.936.936 0 1 1-1.633.922L14.5 10.734v10.329c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938V15.75h-1.25Zm0-1.875h1.25V8.879c-.027-.004-.059-.004-.09-.004h-1.07c-.031 0-.063 0-.09.004v4.996Z",
        fill: "currentColor"
      }
    )
  })
);
var Person_default = SvgPerson;

// src/Icon/icons/Phone.tsx
import { jsx as jsx1043 } from "react/jsx-runtime";
var SvgPhone = (props) => /* @__PURE__ */ jsx1043(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1043(
      "path",
      {
        d: "m20.771 14.512-3.836-1.645a2.04 2.04 0 0 0-2.39.584l-1.072 1.31a11.655 11.655 0 0 1-4.219-4.184l1.31-1.074c.7-.571.942-1.55.587-2.385L9.498 3.232a2.051 2.051 0 0 0-2.339-1.18l-3.564.823A2.032 2.032 0 0 0 2.01 4.867C2.01 14.317 9.693 22 19.142 22c.96 0 1.779-.652 1.957-1.583l.823-3.568a1.982 1.982 0 0 0-1.15-2.337Zm-.64 1.914-.824 3.57c-.018.044-.082.129-.165.129-8.414 0-15.258-6.844-15.258-15.258 0-.082.05-.146.13-.164l3.569-.824a.174.174 0 0 1 .195.098l1.646 3.841a.17.17 0 0 1-.049.198L7.471 9.543a.938.938 0 0 0-.248 1.139 13.363 13.363 0 0 0 6.074 6.074c.355.192.863.089 1.139-.248l1.563-1.909a.161.161 0 0 1 .192-.044L20.03 16.2c.074.067.117.149.102.227Z",
        fill: "currentColor"
      }
    )
  })
);
var Phone_default = SvgPhone;

// src/Icon/icons/Pipe.tsx
import { jsx as jsx1044 } from "react/jsx-runtime";
var SvgPipe = (props) => /* @__PURE__ */ jsx1044(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1044(
      "path",
      {
        d: "M12 22a.938.938 0 0 1-.938-.938V2.938a.938.938 0 0 1 1.876 0v18.125c0 .52-.42.938-.938.938Z",
        fill: "currentColor"
      }
    )
  })
);
var Pipe_default = SvgPipe;

// src/Icon/icons/PlaneUp.tsx
import { jsx as jsx1045 } from "react/jsx-runtime";
var SvgPlaneUp = (props) => /* @__PURE__ */ jsx1045(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1045(
      "path",
      {
        d: "M12 2c1.879 0 3.125 2.886 3.125 4.367v1.64l6.25 3.9c.39.233.625.624.625 1.093v2.535c0 .39-.156.781-.469 1.016-.312.23-.777.308-1.133.191l-5.273-1.676v.977l2.031 1.52c.313.234.469.585.469.976v2.222c0 .352-.156.743-.469.977a1.223 1.223 0 0 1-1.094.195L12 20.761l-4.062 1.211c-.352.075-.743 0-1.055-.234-.313-.234-.508-.625-.508-.977V18.54c0-.39.195-.742.508-.977l1.992-1.52v-.976l-5.273 1.676c-.352.117-.782.039-1.094-.191A1.296 1.296 0 0 1 2 15.535V13c0-.43.274-.899.625-1.055l6.25-3.898v-1.64C8.875 4.886 10.125 2 12 2Zm0 1.911c-.39.078-1.25 1.482-1.25 2.495v2.652l-6.875 4.293v1.325l6.875-2.145v4.445l-2.5 1.875v1.051l3.75-1.09 3.75 1.09v-1.05l-2.5-1.876v-4.445l6.875 2.145V13.35L13.25 9.058V6.406c0-1.052-.82-2.456-1.25-2.495Z",
        fill: "currentColor"
      }
    )
  })
);
var PlaneUp_default = SvgPlaneUp;

// src/Icon/icons/Plane.tsx
import { jsx as jsx1046 } from "react/jsx-runtime";
var SvgPlane = (props) => /* @__PURE__ */ jsx1046(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1046(
      "path",
      {
        d: "M22 12c0 1.701-2.566 2.778-3.882 2.778h-2.847l-3.465 5.555a1.108 1.108 0 0 1-.973.556H8.58c-.347 0-.695-.139-.903-.417a1.176 1.176 0 0 1-.17-1.007l1.49-4.687H7.295l-1.35 1.805c-.209.278-.521.417-.868.417H3.101c-.312 0-.659-.139-.867-.417a1.078 1.078 0 0 1-.173-.972L3.1 12 2.026 8.389c-.07-.313 0-.66.208-.938.208-.277.555-.451.867-.451h1.976c.347 0 .66.174.867.451l1.351 1.771h1.702l-1.49-4.687a1.104 1.104 0 0 1 .17-.973c.208-.277.556-.45.903-.45h2.253c.382 0 .799.242.938.555l3.465 5.555h2.847C19.434 9.222 22 10.333 22 12Zm-1.698 0c-.07-.347-1.32-1.111-2.219-1.111h-3.746L10.52 4.778H9.344l1.906 6.11H6.465L4.8 8.668h-.936L4.834 12l-.97 3.333H4.8l1.665-2.222h4.785l-1.906 6.111h1.177l3.816-6.11h3.746c.934 0 2.184-.73 2.22-1.112Z",
        fill: "currentColor"
      }
    )
  })
);
var Plane_default = SvgPlane;

// src/Icon/icons/PlayPause.tsx
import { jsx as jsx1047 } from "react/jsx-runtime";
var SvgPlayPause = (props) => /* @__PURE__ */ jsx1047(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1047(
      "path",
      {
        d: "M21.063 4.5a.938.938 0 0 0-.938.938v13.125a.938.938 0 0 0 1.875 0V5.438a.937.937 0 0 0-.938-.938Zm-5.625 0c-.52 0-.938.42-.938.938v13.125a.938.938 0 0 0 1.875 0V5.438a.937.937 0 0 0-.938-.938Zm-12.18 15c.274 0 .553-.09.793-.29l7.5-6.214a1.259 1.259 0 0 0 0-1.924l-7.5-6.283c-.24-.199-.519-.289-.792-.289C2.614 4.5 2 5 2 5.751v12.496C2 19 2.614 19.5 3.259 19.5Zm.617-12.418L9.777 12l-5.902 4.918V7.082Z",
        fill: "currentColor"
      }
    )
  })
);
var PlayPause_default = SvgPlayPause;

// src/Icon/icons/Play.tsx
import { jsx as jsx1048 } from "react/jsx-runtime";
var SvgPlay = (props) => /* @__PURE__ */ jsx1048(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1048(
      "path",
      {
        d: "M4.522 2.274a2.144 2.144 0 0 1 2.166.04l12.858 7.857a2.15 2.15 0 0 1 1.027 1.83c0 .746-.389 1.438-1.027 1.791L6.688 21.651a2.06 2.06 0 0 1-2.166.08 2.144 2.144 0 0 1-1.095-1.87V4.142c0-.775.419-1.49 1.095-1.87ZM5.57 19.86l12.86-7.858L5.57 4.143V19.86Z",
        fill: "currentColor"
      }
    )
  })
);
var Play_default = SvgPlay;

// src/Icon/icons/Plug.tsx
import { jsx as jsx1049 } from "react/jsx-runtime";
var SvgPlug = (props) => /* @__PURE__ */ jsx1049(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1049(
      "path",
      {
        d: "M8.25 2c.52 0 .938.42.938.938v3.437H7.312V2.937c0-.517.42-.937.938-.937Zm7.5 0c.52 0 .938.42.938.938v3.437h-1.875V2.937c0-.517.417-.937.937-.937Zm2.813 5.625c.519 0 .937.418.937.938 0 .519-.418.937-.938.937h-.312V12c0 3.133-2.34 5.727-5.313 6.18V22h-1.874v-3.82A6.252 6.252 0 0 1 5.75 12V9.5h-.313a.936.936 0 1 1 0-1.875h13.125ZM12 16.375A4.373 4.373 0 0 0 16.375 12V9.5h-8.75V12A4.373 4.373 0 0 0 12 16.375Z",
        fill: "currentColor"
      }
    )
  })
);
var Plug_default = SvgPlug;

// src/Icon/icons/PlusLarge.tsx
import { jsx as jsx1050 } from "react/jsx-runtime";
var SvgPlusLarge = (props) => /* @__PURE__ */ jsx1050(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1050(
      "path",
      {
        d: "M21.063 11.027c.519 0 .937.454.937.938a.914.914 0 0 1-.938.937h-8.125v8.16c0 .52-.417.938-.972.938a.958.958 0 0 1-.938-.938v-8.16H2.902c-.482 0-.902-.382-.902-.937 0-.485.42-.938.902-.938h8.125v-8.09c0-.517.454-.937.938-.937.555 0 .973.42.973.938v8.09h8.124Z",
        fill: "currentColor"
      }
    )
  })
);
var PlusLarge_default = SvgPlusLarge;

// src/Icon/icons/PlusMinus.tsx
import { jsx as jsx1051 } from "react/jsx-runtime";
var SvgPlusMinus = (props) => /* @__PURE__ */ jsx1051(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1051(
      "path",
      {
        d: "M6.062 9.812h5v5a.938.938 0 0 0 1.876 0v-5h5a.937.937 0 1 0 0-1.875h-5v-5a.937.937 0 0 0-1.876 0v5h-5a.938.938 0 0 0 0 1.875ZM18.25 20.125H5.75a.938.938 0 0 0 0 1.875h12.5a.938.938 0 0 0 0-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var PlusMinus_default = SvgPlusMinus;

// src/Icon/icons/Plus.tsx
import { jsx as jsx1052 } from "react/jsx-runtime";
var SvgPlus = (props) => /* @__PURE__ */ jsx1052(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1052(
      "path",
      {
        d: "M22 12c0 .639-.514 1.153-1.154 1.153h-7.692v7.693a1.155 1.155 0 0 1-2.308 0v-7.693H3.154a1.154 1.154 0 1 1 0-2.307h7.692V3.153a1.154 1.154 0 0 1 2.308 0v7.693h7.692c.64 0 1.154.519 1.154 1.153Z",
        fill: "currentColor"
      }
    )
  })
);
var Plus_default = SvgPlus;

// src/Icon/icons/Podium.tsx
import { jsx as jsx1053 } from "react/jsx-runtime";
var SvgPodium = (props) => /* @__PURE__ */ jsx1053(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1053(
      "path",
      {
        d: "M15.893 20.125h-7.75L6.804 10.75H4.91l1.493 10.445A.94.94 0 0 0 7.33 22h9.375a.939.939 0 0 0 .929-.804l1.458-10.446h-1.895l-1.304 9.375ZM19.83 7.59l-11.562.035v-.313c0-1.36.971-2.498 2.257-2.756.285.34.7.569 1.18.569h3.125a1.563 1.563 0 0 0 0-3.125h-3.125c-.531 0-.98.283-1.262.69-2.28.314-4.05 2.256-4.05 4.623v.312L4.17 7.59c-.482 0-.902.453-.902.937 0 .485.42.938.902.938h15.625c.517 0 .937-.42.937-.938 0-.517-.382-.937-.902-.937Z",
        fill: "currentColor"
      }
    )
  })
);
var Podium_default = SvgPodium;

// src/Icon/icons/PowerOff.tsx
import { jsx as jsx1054 } from "react/jsx-runtime";
var SvgPowerOff = (props) => /* @__PURE__ */ jsx1054(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1054(
      "path",
      {
        d: "M13.275 12.518c0 .53-.426.956-.956.956a.954.954 0 0 1-.956-.956V2.956a.955.955 0 1 1 1.912 0v9.562Zm-8.924-.08c0 4.223 3.39 7.65 7.649 7.65a7.651 7.651 0 0 0 4.534-13.813.953.953 0 0 1-.203-1.336.953.953 0 0 1 1.334-.203 9.544 9.544 0 0 1 3.897 7.702C21.562 17.721 17.279 22 12 22c-5.279 0-9.562-4.279-9.562-9.562a9.546 9.546 0 0 1 3.897-7.702.954.954 0 0 1 1.334.203.953.953 0 0 1-.203 1.336c-1.89 1.394-3.151 3.637-3.151 6.163h.036Z",
        fill: "currentColor"
      }
    )
  })
);
var PowerOff_default = SvgPowerOff;

// src/Icon/icons/PresentationScreen.tsx
import { jsx as jsx1055 } from "react/jsx-runtime";
var SvgPresentationScreen = (props) => /* @__PURE__ */ jsx1055(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1055(
      "path",
      {
        d: "M19.222 13.667H4.778V5.889H3.11v8.333c0 .611.5 1.111 1.111 1.111h6.945v1.633l-2.5 2.5a.832.832 0 0 0 1.176 1.177L12 18.489l2.156 2.156a.832.832 0 0 0 1.18-.003.835.835 0 0 0-.004-1.177l-2.499-2.5v-1.632h6.945c.61 0 1.11-.5 1.11-1.11V5.888h-1.666v7.778ZM21.167 3.11H2.832A.832.832 0 0 0 2 3.943c0 .459.372.835.832.835h18.337a.835.835 0 0 0-.002-1.667Z",
        fill: "currentColor"
      }
    )
  })
);
var PresentationScreen_default = SvgPresentationScreen;

// src/Icon/icons/Print.tsx
import { jsx as jsx1056 } from "react/jsx-runtime";
var SvgPrint = (props) => /* @__PURE__ */ jsx1056(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1056(
      "path",
      {
        d: "M6.34 3.875h9.926l1.359 1.326V8.25H19.5V5.2c0-.496-.198-.973-.55-1.325l-1.325-1.326A1.873 1.873 0 0 0 16.301 2H6.34c-1 0-1.84.84-1.84 1.874V8.25h1.875L6.34 3.875ZM19.188 9.5H4.813A2.816 2.816 0 0 0 2 12.313v4.374c0 .518.42.938.938.938h2.187v3.125c0 .69.56 1.25 1.25 1.25h11.25c.69 0 1.25-.56 1.25-1.25v-3.125h2.188c.517 0 .937-.42.937-.938v-4.375A2.816 2.816 0 0 0 19.187 9.5ZM17 20.125H7v-3.75h10v3.75Zm3.125-4.375h-1.25c0-.69-.56-1.25-1.25-1.25H6.375c-.69 0-1.25.56-1.25 1.25h-1.25v-3.438c0-.516.42-.937.938-.937h14.375c.516 0 .937.42.937.938v3.437Z",
        fill: "currentColor"
      }
    )
  })
);
var Print_default = SvgPrint;

// src/Icon/icons/Q.tsx
import { jsx as jsx1057 } from "react/jsx-runtime";
var SvgQ = (props) => /* @__PURE__ */ jsx1057(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1057(
      "path",
      {
        d: "M18.83 17.675a9.287 9.287 0 0 0 2.503-6.342C21.333 6.187 17.146 2 12.038 2c-5.109 0-9.371 4.188-9.371 9.333 0 5.146 4.187 9.334 9.296 9.334a9.264 9.264 0 0 0 5.32-1.677l2.247 2.655c.237.234.52.355.803.355.668 0 1-.57 1-1a.994.994 0 0 0-.237-.646l-2.267-2.679Zm-6.83.992c-4.044 0-7.333-3.29-7.333-7.334A7.319 7.319 0 0 1 12 4c4.08 0 7.333 3.29 7.333 7.333a7.299 7.299 0 0 1-1.805 4.804l-3.764-4.45a.997.997 0 0 0-.764-.354c-.672 0-.963.579-.963 1.001 0 .228.078.458.237.645l3.788 4.48c-1.195.762-2.575 1.208-4.062 1.208Z",
        fill: "currentColor"
      }
    )
  })
);
var Q_default = SvgQ;

// src/Icon/icons/Qrcode.tsx
import { jsx as jsx1058 } from "react/jsx-runtime";
var SvgQrcode = (props) => /* @__PURE__ */ jsx1058(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1058(
      "path",
      {
        d: "M6.643 5.214c.393 0 .714.362.714.715v.714a.692.692 0 0 1-.714.714h-.714a.69.69 0 0 1-.715-.714v-.714c0-.353.32-.715.715-.715h.714ZM2 4.143C2 3 2.96 2 4.143 2h4.286c1.183 0 2.142 1 2.142 2.143v4.286c0 1.223-.96 2.142-2.142 2.142H4.143A2.118 2.118 0 0 1 2 8.43V4.143Zm2.143 4.286h4.286V4.143H4.143v4.286Zm1.071 8.928c0-.352.32-.714.715-.714h.714c.393 0 .714.361.714.714v.714a.692.692 0 0 1-.714.715h-.714a.69.69 0 0 1-.715-.715v-.714ZM2 15.571c0-1.142.96-2.142 2.143-2.142h4.286c1.183 0 2.142 1 2.142 2.142v4.286c0 1.223-.96 2.143-2.142 2.143H4.143A2.118 2.118 0 0 1 2 19.857v-4.286Zm2.143 4.286h4.286v-4.286H4.143v4.286ZM18.07 5.214c.393 0 .715.362.715.715v.714a.692.692 0 0 1-.715.714h-.714a.692.692 0 0 1-.714-.714v-.714c0-.353.321-.715.714-.715h.714ZM19.857 2C21.04 2 22 3 22 4.143v4.286c0 1.223-.96 2.142-2.143 2.142h-4.286A2.118 2.118 0 0 1 13.43 8.43V4.143C13.429 3 14.389 2 15.57 2h4.286Zm0 2.143h-4.286v4.286h4.286V4.143ZM19.143 22h-1.429v-1.429h1.429V22Zm1.428-1.429H22V22h-1.429v-1.429ZM22 19.143h-4.286v-1.429h-1.428V22h-2.857v-8.571h4.285v1.428h2.857V13.43H22v5.714Z",
        fill: "currentColor"
      }
    )
  })
);
var Qrcode_default = SvgQrcode;

// src/Icon/icons/Question.tsx
import { jsx as jsx1059 } from "react/jsx-runtime";
var SvgQuestion = (props) => /* @__PURE__ */ jsx1059(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1059(
      "path",
      {
        d: "M11.286 19.142a1.429 1.429 0 1 0 0 2.858 1.429 1.429 0 0 0 0-2.858Zm3-17.142H9.5a4.648 4.648 0 0 0-4.643 4.643v.714a1.07 1.07 0 1 0 2.143 0v-.714c0-1.379 1.122-2.5 2.5-2.5h4.786A2.719 2.719 0 0 1 17 6.857a2.705 2.705 0 0 1-1.451 2.402l-3.236 1.705c-1.335.679-2.099 2.013-2.099 3.473v.777a1.072 1.072 0 0 0 2.143 0v-.777c0-.664.366-1.27.955-1.58l3.235-1.703a4.844 4.844 0 0 0 2.596-4.297A4.862 4.862 0 0 0 14.286 2Z",
        fill: "currentColor"
      }
    )
  })
);
var Question_default = SvgQuestion;

// src/Icon/icons/QuoteLeft.tsx
import { jsx as jsx1060 } from "react/jsx-runtime";
var SvgQuoteLeft = (props) => /* @__PURE__ */ jsx1060(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1060(
      "path",
      {
        d: "M6.286 19.143a4.286 4.286 0 0 0 0-8.572c-.785 0-1.51.228-2.143.594v-.95A3.218 3.218 0 0 1 7.357 7h.714c.594 0 1.072-.478 1.072-1.071 0-.594-.478-1.072-1.072-1.072h-.714A5.363 5.363 0 0 0 2 10.214v4.643a4.286 4.286 0 0 0 4.286 4.286Zm0-6.429c1.181 0 2.143.961 2.143 2.143S7.469 17 6.286 17a2.143 2.143 0 0 1 0-4.286Zm11.428 6.429a4.286 4.286 0 1 0 0-8.572c-.784 0-1.51.227-2.143.595v-.952A3.218 3.218 0 0 1 18.786 7h.714c.594 0 1.071-.478 1.071-1.071 0-.594-.477-1.072-1.071-1.072h-.714a5.361 5.361 0 0 0-5.357 5.357v4.643a4.261 4.261 0 0 0 4.285 4.286Zm0-6.429c1.182 0 2.143.961 2.143 2.143A2.145 2.145 0 0 1 17.714 17a2.145 2.145 0 0 1-2.143-2.143c0-1.182.96-2.143 2.143-2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var QuoteLeft_default = SvgQuoteLeft;

// src/Icon/icons/QuoteRight.tsx
import { jsx as jsx1061 } from "react/jsx-runtime";
var SvgQuoteRight = (props) => /* @__PURE__ */ jsx1061(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1061(
      "path",
      {
        d: "M17.714 4.857a4.286 4.286 0 1 0 0 8.572c.785 0 1.51-.227 2.143-.595v.952A3.218 3.218 0 0 1 16.643 17h-.714a1.072 1.072 0 0 0 0 2.143h.714A5.361 5.361 0 0 0 22 13.786V9.143a4.261 4.261 0 0 0-4.286-4.286Zm0 6.429a2.145 2.145 0 0 1-2.143-2.143c0-1.182.962-2.143 2.143-2.143 1.182 0 2.143.961 2.143 2.143s-.96 2.143-2.143 2.143ZM6.286 4.857A4.26 4.26 0 0 0 2 9.143a4.26 4.26 0 0 0 6.429 3.691v.952A3.218 3.218 0 0 1 5.214 17H4.5c-.592 0-1.071.482-1.071 1.071 0 .59.48 1.072 1.071 1.072h.714a5.361 5.361 0 0 0 5.357-5.357V9.143a4.261 4.261 0 0 0-4.285-4.286Zm0 6.429a2.144 2.144 0 0 1-2.143-2.143C4.143 7.96 5.104 7 6.286 7a2.143 2.143 0 0 1 0 4.286Z",
        fill: "currentColor"
      }
    )
  })
);
var QuoteRight_default = SvgQuoteRight;

// src/Icon/icons/Quotes.tsx
import { jsx as jsx1062 } from "react/jsx-runtime";
var SvgQuotes = (props) => /* @__PURE__ */ jsx1062(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1062(
      "path",
      {
        d: "M13.389 12.556a2.498 2.498 0 0 0-2.5 2.5c0 1.382 1.118 2.5 2.5 2.5.289 0 .562-.06.82-.15a1.941 1.941 0 0 1-1.931 1.816.834.834 0 0 0 0 1.667 3.615 3.615 0 0 0 3.61-3.611v-2.222c0-1.382-1.117-2.5-2.5-2.5Zm0 3.333a.834.834 0 0 1 0-1.667c.46 0 .833.375.833.834a.836.836 0 0 1-.833.833Zm6.111-3.333a2.5 2.5 0 1 0 0 5c.289 0 .562-.06.82-.15a1.941 1.941 0 0 1-1.931 1.816.834.834 0 0 0 0 1.667A3.615 3.615 0 0 0 22 17.278v-2.222c0-1.382-1.118-2.5-2.5-2.5Zm0 3.333a.834.834 0 0 1 0-1.667.834.834 0 0 1 0 1.667Zm-6.389-6.945c0-1.382-1.118-2.5-2.5-2.5-.288 0-.562.06-.82.15a1.94 1.94 0 0 1 1.931-1.816.834.834 0 0 0 0-1.667 3.616 3.616 0 0 0-3.61 3.611v2.222a2.5 2.5 0 0 0 5 0Zm-2.5.834a.836.836 0 0 1-.833-.834c0-.458.375-.833.833-.833.458 0 .833.375.833.833a.836.836 0 0 1-.833.834ZM4.5 6.444c-.289 0-.562.06-.82.15A1.94 1.94 0 0 1 5.61 4.778a.832.832 0 1 0 0-1.667A3.615 3.615 0 0 0 2 6.722v2.222a2.5 2.5 0 1 0 5 0c0-1.382-1.118-2.5-2.5-2.5Zm0 3.334a.834.834 0 1 1 .833-.833.835.835 0 0 1-.833.833Z",
        fill: "currentColor"
      }
    )
  })
);
var Quotes_default = SvgQuotes;

// src/Icon/icons/R.tsx
import { jsx as jsx1063 } from "react/jsx-runtime";
var SvgR = (props) => /* @__PURE__ */ jsx1063(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1063(
      "path",
      {
        d: "M13.906 13.38c2.924-.248 5.237-2.675 5.237-5.661C19.103 4.569 16.576 2 13.424 2H5.93c-.592 0-1.072.48-1.072 1.071V20.93a1.07 1.07 0 1 0 2.143 0v-7.5h4.293l5.91 8.129a1.07 1.07 0 0 0 1.498.237 1.071 1.071 0 0 0 .236-1.497l-5.03-6.918ZM7 4.143h6.429A3.576 3.576 0 0 1 17 7.714a3.576 3.576 0 0 1-3.571 3.572H7V4.143Z",
        fill: "currentColor"
      }
    )
  })
);
var R_default = SvgR;

// src/Icon/icons/Radar.tsx
import { jsx as jsx1064 } from "react/jsx-runtime";
var SvgRadar = (props) => /* @__PURE__ */ jsx1064(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1064(
      "path",
      {
        d: "M14.36 8.316c-.715-.437-1.493-.691-2.36-.691A4.373 4.373 0 0 0 7.625 12 4.373 4.373 0 0 0 12 16.375 4.373 4.373 0 0 0 16.375 12h1.875a6.249 6.249 0 0 1-5.09 6.14 1.558 1.558 0 0 0-1.16-.515c-.46 0-.875.2-1.16.516a6.25 6.25 0 0 1-4.982-4.98c.318-.286.517-.7.517-1.161 0-.46-.2-.875-.517-1.16a6.252 6.252 0 0 1 9.849-3.871l1.336-1.339A8.08 8.08 0 0 0 12 3.875a8.13 8.13 0 0 0-8.018 6.8 1.562 1.562 0 0 0 0 2.65 8.136 8.136 0 0 0 6.694 6.695 1.566 1.566 0 0 0 2.648 0A8.132 8.132 0 0 0 20.125 12H22c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2c2.426 0 4.645.862 6.379 2.297l1.707-1.71c.367-.366.96-.366 1.293 0a.885.885 0 0 1 0 1.326l-7.078 7.11A2.502 2.502 0 0 1 12 14.5 2.502 2.502 0 0 1 9.499 12c0-1.379 1.121-2.5 2.5-2.5.348 0 .676.07.941.2l1.418-1.384Z",
        fill: "currentColor"
      }
    )
  })
);
var Radar_default = SvgRadar;

// src/Icon/icons/RectangleBarcode.tsx
import { jsx as jsx1065 } from "react/jsx-runtime";
var SvgRectangleBarcode = (props) => /* @__PURE__ */ jsx1065(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1065(
      "path",
      {
        d: "M7 8.389v7.222a.812.812 0 0 1-.833.833.812.812 0 0 1-.834-.833V8.39c0-.43.372-.833.834-.833.461 0 .833.402.833.833Zm2.222-.278v7.778c0 .337-.25.555-.555.555a.538.538 0 0 1-.556-.555V8.11c0-.274.25-.555.556-.555.305 0 .555.28.555.555Zm1.111.278c0-.43.372-.833.834-.833.462 0 .833.402.833.833v7.222a.812.812 0 0 1-.833.833.812.812 0 0 1-.834-.833V8.39Zm5.556 0v7.222a.812.812 0 0 1-.833.833.812.812 0 0 1-.834-.833V8.39c0-.43.372-.833.834-.833.461 0 .833.402.833.833Zm1.667-.278c0-.274.25-.555.555-.555.306 0 .556.28.556.555v7.778c0 .337-.25.555-.556.555a.538.538 0 0 1-.555-.555V8.11ZM2 6.444c0-1.196.995-2.222 2.222-2.222h15.556C21.004 4.222 22 5.248 22 6.444v11.112a2.204 2.204 0 0 1-2.222 2.222H4.222A2.203 2.203 0 0 1 2 17.556V6.444Zm1.667 0v11.112c0 .336.248.555.555.555h15.556a.538.538 0 0 0 .555-.555V6.444a.578.578 0 0 0-.555-.555H4.222a.577.577 0 0 0-.555.555Z",
        fill: "currentColor"
      }
    )
  })
);
var RectangleBarcode_default = SvgRectangleBarcode;

// src/Icon/icons/RectangleCode.tsx
import { jsx as jsx1066 } from "react/jsx-runtime";
var SvgRectangleCode = (props) => /* @__PURE__ */ jsx1066(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1066(
      "path",
      {
        d: "m14.504 8.836 2.5 2.5c.398.367.398.96 0 1.293l-2.5 2.5c-.332.398-.926.398-1.293 0-.363-.332-.363-.926 0-1.293L15.05 12l-1.84-1.871c-.363-.332-.363-.926 0-1.293.367-.363.96-.363 1.293 0ZM8.949 12l1.805 1.836c.398.367.398.96 0 1.293-.332.398-.926.398-1.293 0l-2.5-2.5c-.363-.332-.363-.926 0-1.293l2.5-2.5c.367-.363.96-.363 1.293 0 .398.367.398.96 0 1.293L8.949 12ZM19.5 3.25c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75a2.5 2.5 0 0 1 2.5-2.5h15Zm0 1.875h-15a.625.625 0 0 0-.625.625v12.5c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625V5.75a.626.626 0 0 0-.625-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var RectangleCode_default = SvgRectangleCode;

// src/Icon/icons/RectangleTerminal.tsx
import { jsx as jsx1067 } from "react/jsx-runtime";
var SvgRectangleTerminal = (props) => /* @__PURE__ */ jsx1067(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1067(
      "path",
      {
        d: "m7.32 7.871 3.75 3.438a.938.938 0 0 1 0 1.382L7.32 16.13c-.383.348-.972.289-1.324-.059a.937.937 0 0 1 .059-1.324L9.05 12 6.055 9.254A.937.937 0 1 1 7.32 7.87Zm9.992 7.254c.52 0 .938.418.938.938 0 .519-.418.937-.938.937h-5.625a.935.935 0 0 1-.937-.938c0-.519.418-.937.938-.937h5.624ZM19.5 3.25c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75a2.5 2.5 0 0 1 2.5-2.5h15Zm0 1.875h-15a.625.625 0 0 0-.625.625v12.5c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625V5.75a.626.626 0 0 0-.625-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var RectangleTerminal_default = SvgRectangleTerminal;

// src/Icon/icons/RectangleVertical.tsx
import { jsx as jsx1068 } from "react/jsx-runtime";
var SvgRectangleVertical = (props) => /* @__PURE__ */ jsx1068(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1068(
      "path",
      {
        d: "M19.5 19.5c0 1.379-1.121 2.5-2.5 2.5H7c-1.38 0-2.5-1.121-2.5-2.5v-15A2.5 2.5 0 0 1 7 2h10c1.379 0 2.5 1.12 2.5 2.5v15Zm-1.875 0v-15A.626.626 0 0 0 17 3.875H7a.625.625 0 0 0-.625.625v15c0 .344.28.625.625.625h10a.627.627 0 0 0 .625-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var RectangleVertical_default = SvgRectangleVertical;

// src/Icon/icons/Rectangle.tsx
import { jsx as jsx1069 } from "react/jsx-runtime";
var SvgRectangle = (props) => /* @__PURE__ */ jsx1069(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1069(
      "path",
      {
        d: "M19.5 4.5C20.879 4.5 22 5.62 22 7v10c0 1.379-1.121 2.5-2.5 2.5h-15C3.12 19.5 2 18.379 2 17V7a2.5 2.5 0 0 1 2.5-2.5h15Zm0 1.875h-15A.626.626 0 0 0 3.875 7v10c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625V7a.627.627 0 0 0-.625-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var Rectangle_default = SvgRectangle;

// src/Icon/icons/Repeat1.tsx
import { jsx as jsx1070 } from "react/jsx-runtime";
var SvgRepeat1 = (props) => /* @__PURE__ */ jsx1070(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1070(
      "path",
      {
        d: "M8.875 7h5.59v2.188a.938.938 0 0 0 1.6.663l3.126-3.125a.937.937 0 0 0 0-1.326l-3.126-3.125a.938.938 0 0 0-1.6.663v2.188h-5.59A6.861 6.861 0 0 0 2 12a.938.938 0 0 0 1.875 0c0-2.758 2.242-5 5-5Zm3.438 7.813c.517 0 .937-.42.937-.937v-3.438a.938.938 0 0 0-1.356-.839l-1.25.625a.938.938 0 0 0 .731 1.722v1.93c0 .52.422.937.938.937Zm8.75-3.75a.938.938 0 0 0-.938.938c0 2.757-2.243 5-5 5H9.5v-2.188a.938.938 0 0 0-1.602-.664l-3.125 3.125a.937.937 0 0 0 0 1.326l3.125 3.125a.938.938 0 0 0 1.602-.662v-2.187h5.625A6.883 6.883 0 0 0 22 12a.938.938 0 0 0-.938-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var Repeat1_default = SvgRepeat1;

// src/Icon/icons/Repeat.tsx
import { jsx as jsx1071 } from "react/jsx-runtime";
var SvgRepeat = (props) => /* @__PURE__ */ jsx1071(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1071(
      "path",
      {
        d: "M8.875 7h5.59v2.188a.938.938 0 0 0 1.6.663l3.126-3.125a.937.937 0 0 0 0-1.326l-3.126-3.125a.938.938 0 0 0-1.6.663v2.188h-5.59A6.861 6.861 0 0 0 2 12a.938.938 0 0 0 1.875 0c0-2.758 2.242-5 5-5Zm12.188 4.063a.938.938 0 0 0-.938.938c0 2.757-2.243 5-5 5H9.5v-2.188a.938.938 0 0 0-1.602-.664l-3.125 3.125a.937.937 0 0 0 0 1.326l3.125 3.125a.938.938 0 0 0 1.602-.662v-2.187h5.625A6.883 6.883 0 0 0 22 12a.938.938 0 0 0-.938-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var Repeat_default = SvgRepeat;

// src/Icon/icons/ReplyAll.tsx
import { jsx as jsx1072 } from "react/jsx-runtime";
var SvgReplyAll = (props) => /* @__PURE__ */ jsx1072(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1072(
      "path",
      {
        d: "M8.807 5.446a.862.862 0 0 0-1.184-1.25L2.536 9.03a1.724 1.724 0 0 0 0 2.498l5.087 4.832a.862.862 0 0 0 1.184-1.249L3.72 10.278l5.087-4.832Zm5.152 5.98h-.862a.86.86 0 0 0-.861.863V14.159l-4.312-3.88 4.312-3.881v1.87a.86.86 0 0 0 .861.861h2.585a4.595 4.595 0 0 1 4.595 4.595 5.77 5.77 0 0 1-.187 1.49 5.172 5.172 0 0 0-4.982-3.787h-1.15Zm0 3.447V13.15h1.149a3.447 3.447 0 0 1 3.446 3.446c0 .621-.151 1.095-.341 1.443a2.207 2.207 0 0 1-.456.592c-.018.019-.036.033-.05.051-.173.176-.298.406-.298.65 0 .391.316.707.707.707.1 0 .2-.022.29-.068.094-.05.227-.126.388-.234a7.093 7.093 0 0 0 .74-.556c1.08-.926 2.466-2.657 2.466-5.457a6.318 6.318 0 0 0-6.318-6.318h-1.723V5.11c0-.453-.266-.865-.682-1.048a1.153 1.153 0 0 0-1.235.193l-5.744 5.17c-.24.219-.38.527-.38.854 0 .327.14.636.38.854l5.744 5.17c.337.305.822.38 1.235.194.413-.187.682-.596.682-1.048v-.575Z",
        fill: "currentColor"
      }
    )
  })
);
var ReplyAll_default = SvgReplyAll;

// src/Icon/icons/Reply.tsx
import { jsx as jsx1073 } from "react/jsx-runtime";
var SvgReply = (props) => /* @__PURE__ */ jsx1073(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1073(
      "path",
      {
        d: "M10.75 11.375h3.75a5.628 5.628 0 0 1 5.422 4.121 6.281 6.281 0 0 0 .203-1.62 5 5 0 0 0-5-5H9.812a.935.935 0 0 1-.937-.938V5.903l-4.691 4.222 4.691 4.223v-2.035c0-.52.418-.938.938-.938h.937Zm0 1.875v2.5c0 .493-.29.942-.742 1.141-.453.2-.977.117-1.344-.21l-6.25-5.626a1.258 1.258 0 0 1-.414-.93c0-.355.152-.691.414-.93l6.25-5.624a1.24 1.24 0 0 1 1.344-.211c.449.203.742.648.742 1.14V7h4.375A6.875 6.875 0 0 1 22 13.875c0 3.047-1.508 4.93-2.684 5.942-.16.136-.316.258-.457.363a7.412 7.412 0 0 1-.347.242c-.176.117-.325.2-.422.254a.64.64 0 0 1-.317.074.771.771 0 0 1-.77-.77c0-.265.142-.515.325-.706l.055-.055c.094-.09.199-.2.3-.336.067-.09.133-.195.196-.308.207-.38.371-.895.371-1.57 0-2.071-1.68-3.75-3.75-3.75h-3.75v-.005Z",
        fill: "currentColor"
      }
    )
  })
);
var Reply_default = SvgReply;

// src/Icon/icons/Retweet.tsx
import { jsx as jsx1074 } from "react/jsx-runtime";
var SvgRetweet = (props) => /* @__PURE__ */ jsx1074(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1074(
      "path",
      {
        d: "M12.81 15.784H6.325V9.838h1.892a.81.81 0 0 0 .573-1.385L6.087 5.75a.812.812 0 0 0-1.147.001L2.238 8.454a.81.81 0 0 0 .573 1.384h1.892v6.757c0 .449.363.81.81.81h7.298a.811.811 0 0 0 0-1.621Zm9.129-1.122c-.125-.304-.422-.53-.75-.53h-1.892V7.405a.811.811 0 0 0-.81-.81h-7.298a.813.813 0 0 0-.81.81c0 .446.364.811.81.811h6.486v5.916h-1.891a.81.81 0 0 0-.574 1.384l2.703 2.704a.73.73 0 0 0 .573.266.81.81 0 0 0 .574-.237l2.702-2.703a.813.813 0 0 0 .177-.884Z",
        fill: "currentColor"
      }
    )
  })
);
var Retweet_default = SvgRetweet;

// src/Icon/icons/Ribbon.tsx
import { jsx as jsx1075 } from "react/jsx-runtime";
var SvgRibbon = (props) => /* @__PURE__ */ jsx1075(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1075(
      "path",
      {
        d: "m20.348 17.804-4.226-4.594 1.465-1.572c1.357-1.465 1.488-3.57.42-5.367l-1.202-1.963c-.62-.955-1.457-1.654-2.437-1.971-1.371-.45-3.325-.45-4.691 0-.991.317-1.856 1.015-2.436 1.972L5.9 6.43a4.333 4.333 0 0 0 .523 5.203L7.89 13.21l-4.234 4.6a1.52 1.52 0 0 0 .293 2.31l2.475 1.617c.902.61 1.777 0 2.007-.244l3.574-3.848 3.569 3.843c.224.25 1.078.855 2.006.25l2.476-1.617a1.533 1.533 0 0 0 .293-2.317ZM16.071 6.699l.337.552c.659 1.074.58 2.265-.2 3.105l-1.362 1.47-1.572-1.709 1.777-1.933c.454-.45.743-.977 1.02-1.485Zm-5.859-2.58c1.035-.332 2.544-.332 3.579 0 .356.117.683.332.971.62-.107.503-.386 1.48-1.02 2.139L11.967 8.73l-1.7-1.886c-.649-.635-.922-1.612-1.025-2.115.284-.283.616-.493.971-.61Zm-2.98 15.907-1.919-1.255 3.847-4.183 1.528 1.68-3.456 3.758Zm9.542 0L7.79 10.36a2.47 2.47 0 0 1-.293-2.95l.395-.698c.199.499.551 1.006.99 1.436l9.77 10.628-1.878 1.252Z",
        fill: "currentColor"
      }
    )
  })
);
var Ribbon_default = SvgRibbon;

// src/Icon/icons/RightFromBracket.tsx
import { jsx as jsx1076 } from "react/jsx-runtime";
var SvgRightFromBracket = (props) => /* @__PURE__ */ jsx1076(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1076(
      "path",
      {
        d: "M8.563 18.875H5.75A1.88 1.88 0 0 1 3.875 17V7A1.88 1.88 0 0 1 5.75 5.125h2.813a.936.936 0 1 0 0-1.875H5.75A3.75 3.75 0 0 0 2 7v10a3.75 3.75 0 0 0 3.75 3.75h2.813c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937Zm13.12-7.555L15.73 6.078a1.315 1.315 0 0 0-1.41-.214 1.28 1.28 0 0 0-.758 1.163v2.16H8.875c-.862 0-1.563.702-1.563 1.563v2.5c0 .862.701 1.563 1.563 1.563h4.688v2.16c0 .498.297.954.758 1.161a1.315 1.315 0 0 0 1.41-.213l5.953-5.2A.93.93 0 0 0 22 12.02a.92.92 0 0 0-.316-.7Zm-6.245 4.352v-2.77h-6.25v-1.875h6.25V8.293l4.21 3.693-4.21 3.686Z",
        fill: "currentColor"
      }
    )
  })
);
var RightFromBracket_default = SvgRightFromBracket;

// src/Icon/icons/RightFromLine.tsx
import { jsx as jsx1077 } from "react/jsx-runtime";
var SvgRightFromLine = (props) => /* @__PURE__ */ jsx1077(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1077(
      "path",
      {
        d: "M4.143 19.5v-15A1.072 1.072 0 0 0 2 4.5v15a1.07 1.07 0 1 0 2.143 0Zm7.143-12.987V8.43H8.429c-1.183 0-2.141.96-2.141 2.142v2.858a2.14 2.14 0 0 0 2.14 2.142h2.858v1.933c0 1.858 2.204 2.836 3.581 1.588l6.715-6.08c.28-.28.418-.646.418-1.012s-.14-.731-.419-1.01l-6.714-6.067c-1.38-1.245-3.581-.267-3.581 1.59ZM19.563 12l-6.134 5.42v-3.991h-5V10.57h5v-3.99L19.562 12Z",
        fill: "currentColor"
      }
    )
  })
);
var RightFromLine_default = SvgRightFromLine;

// src/Icon/icons/RightLeft.tsx
import { jsx as jsx1078 } from "react/jsx-runtime";
var SvgRightLeft = (props) => /* @__PURE__ */ jsx1078(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1078(
      "path",
      {
        d: "M2.938 7.938h12.816l-.005 3.125a.938.938 0 0 0 1.575.687L21.7 7.687a.938.938 0 0 0 0-1.374L17.325 2.25a.939.939 0 0 0-1.575.687l.005 3.126H2.938c-.518 0-.938.418-.938.902 0 .484.42.973.938.973Zm18.125 8.125H8.245l.004-3.16a.938.938 0 0 0-.563-.86c-.341-.149-.738-.047-1.011.207L2.3 16.313a.939.939 0 0 0 0 1.374l4.375 4.063a.938.938 0 0 0 1.574-.687l-.005-3.125h12.818a.938.938 0 0 0 0-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var RightLeft_default = SvgRightLeft;

// src/Icon/icons/RightLongToLine.tsx
import { jsx as jsx1079 } from "react/jsx-runtime";
var SvgRightLongToLine = (props) => /* @__PURE__ */ jsx1079(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1079(
      "path",
      {
        d: "M22 17.25c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75V6.75a.75.75 0 1 1 1.5 0v10.5Zm-8.503-4.5H2.75a.75.75 0 1 1 0-1.5h10.747v-2.5c0-.297.178-.569.45-.716a.815.815 0 0 1 .81.166l3.502 3.25a.747.747 0 0 1 0 1.1l-3.503 3.25a.748.748 0 0 1-1.26-.55v-2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var RightLongToLine_default = SvgRightLongToLine;

// src/Icon/icons/RightLong.tsx
import { jsx as jsx1080 } from "react/jsx-runtime";
var SvgRightLong = (props) => /* @__PURE__ */ jsx1080(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1080(
      "path",
      {
        d: "M16.308 16.853a.926.926 0 0 1-.563-.824v-3.125H2.937c-.517 0-.937-.42-.937-.902 0-.482.42-.937.937-.937h12.808v-3.09a.937.937 0 0 1 1.577-.687L21.7 11.35c.4.371.4 1.004 0 1.375l-4.378 4.062a.996.996 0 0 1-1.014.066Z",
        fill: "currentColor"
      }
    )
  })
);
var RightLong_default = SvgRightLong;

// src/Icon/icons/RightToBracket.tsx
import { jsx as jsx1081 } from "react/jsx-runtime";
var SvgRightToBracket = (props) => /* @__PURE__ */ jsx1081(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1081(
      "path",
      {
        d: "M22 7v10a3.75 3.75 0 0 1-3.75 3.75h-2.813a.937.937 0 1 1 0-1.875h2.813A1.88 1.88 0 0 0 20.125 17V7a1.88 1.88 0 0 0-1.875-1.875h-2.813a.937.937 0 1 1 0-1.875h2.813A3.75 3.75 0 0 1 22 7Zm-5.629 5.7-5.953 5.222a1.312 1.312 0 0 1-1.408.212 1.276 1.276 0 0 1-.76-1.161v-2.16H3.562c-.861 0-1.562-.7-1.562-1.563v-2.5c0-.862.7-1.563 1.563-1.563H8.25v-2.16c0-.498.298-.953.758-1.16a1.316 1.316 0 0 1 1.41.211l5.953 5.219a.934.934 0 0 1 0 1.402Zm-2.035-.7-4.211-3.707v2.77h-6.25v1.874h6.25v2.736L14.335 12Z",
        fill: "currentColor"
      }
    )
  })
);
var RightToBracket_default = SvgRightToBracket;

// src/Icon/icons/RightToLine.tsx
import { jsx as jsx1082 } from "react/jsx-runtime";
var SvgRightToLine = (props) => /* @__PURE__ */ jsx1082(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1082(
      "path",
      {
        d: "M22 19.5v-15a1.07 1.07 0 1 0-2.143 0v15a1.072 1.072 0 0 0 2.143 0Zm-4.705-6.505a1.426 1.426 0 0 0 0-2.022L10.58 4.906C9.2 3.66 7 4.639 7 6.496V8.41H4.143C2.959 8.411 2 9.371 2 10.554v2.857c0 1.184.96 2.143 2.143 2.143H7v1.933c0 1.858 2.204 2.835 3.582 1.588l6.713-6.08Zm-8.152.416h-5v-2.857h5V6.567l6.134 5.42-6.134 5.375V13.41Z",
        fill: "currentColor"
      }
    )
  })
);
var RightToLine_default = SvgRightToLine;

// src/Icon/icons/Right.tsx
import { jsx as jsx1083 } from "react/jsx-runtime";
var SvgRight = (props) => /* @__PURE__ */ jsx1083(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1083(
      "path",
      {
        d: "M12.17 3.538a1.427 1.427 0 0 0-.884 1.32v3.57H4.143C2.959 8.429 2 9.389 2 10.572v2.858c0 1.183.96 2.143 2.143 2.143h7.143v3.57a1.429 1.429 0 0 0 2.439 1.01l7.857-7.142c.28-.278.418-.644.418-1.01s-.14-.731-.419-1.01l-7.857-7.143a1.424 1.424 0 0 0-1.554-.31ZM19.563 12l-6.134 5.42v-3.991H4.143v-2.857h9.286V6.58L19.562 12Z",
        fill: "currentColor"
      }
    )
  })
);
var Right_default = SvgRight;

// src/Icon/icons/RotateLeft.tsx
import { jsx as jsx1084 } from "react/jsx-runtime";
var SvgRotateLeft = (props) => /* @__PURE__ */ jsx1084(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1084(
      "path",
      {
        d: "M2.638 3.132a1.04 1.04 0 0 1 1.128.225l1.771 1.771c1.77-1.74 4.186-2.798 6.772-2.798C17.672 2.369 22 6.696 22 12.02c0 5.323-4.328 9.65-9.65 9.65a9.689 9.689 0 0 1-6.186-2.231 1.034 1.034 0 1 1 1.325-1.59 7.61 7.61 0 0 0 4.856 1.756c4.182 0 7.586-3.404 7.586-7.586s-3.405-7.586-7.586-7.586c-2.03 0-3.92.831-5.31 2.194l2.247 2.247c.296.296.384.74.225 1.127a1.029 1.029 0 0 1-.955.639H3.034A1.033 1.033 0 0 1 2 9.605V4.088c0-.419.252-.796.638-.956Z",
        fill: "currentColor"
      }
    )
  })
);
var RotateLeft_default = SvgRotateLeft;

// src/Icon/icons/RotateRightOne.tsx
import { jsx as jsx1085, jsxs as jsxs10 } from "react/jsx-runtime";
var SvgRotateRightOne = (props) => /* @__PURE__ */ jsxs10(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsx1085(
        "path",
        {
          d: "M22 4.065v5.507a1.03 1.03 0 0 1-1.032 1.032H15.46a1.032 1.032 0 0 1-.73-1.762l2.244-2.243c-1.39-1.36-3.274-2.19-5.3-2.19a7.534 7.534 0 0 0-7.572 7.572 7.557 7.557 0 0 0 7.572 7.572c3.494 0 4.607-1.994 5.468-1.994.438 0 1.033.345 1.033 1.033 0 1.08-3.23 3.023-6.543 3.023C6.319 21.615 2 17.296 2 11.983s4.32-9.598 9.633-9.598c2.582 0 4.99 1.057 6.758 2.794L20.16 3.41c.198-.198.462-.302.73-.302.654-.076 1.11.39 1.11.956Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx1085(
        "path",
        {
          d: "M10.816 10.35H9.111V8.982c.712 0 1.243-.096 1.595-.288.36-.2.592-.528.696-.984h1.489v8.58h-2.076v-5.94Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
var RotateRightOne_default = SvgRotateRightOne;

// src/Icon/icons/RotateRight.tsx
import { jsx as jsx1086 } from "react/jsx-runtime";
var SvgRotateRight = (props) => /* @__PURE__ */ jsx1086(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1086(
      "path",
      {
        d: "M22 4.065v5.507a1.03 1.03 0 0 1-1.032 1.032H15.46a1.032 1.032 0 0 1-.73-1.762l2.244-2.243c-1.39-1.36-3.274-2.19-5.3-2.19a7.534 7.534 0 0 0-7.572 7.572 7.557 7.557 0 0 0 7.572 7.572c3.494 0 4.607-1.994 5.468-1.994.438 0 1.033.345 1.033 1.033 0 1.08-3.23 3.023-6.543 3.023C6.319 21.615 2 17.296 2 11.983s4.32-9.598 9.633-9.598c2.582 0 4.99 1.057 6.758 2.794L20.16 3.41c.198-.198.462-.302.73-.302.654-.076 1.11.39 1.11.956Z",
        fill: "currentColor"
      }
    )
  })
);
var RotateRight_default = SvgRotateRight;

// src/Icon/icons/Rotate.tsx
import { jsx as jsx1087 } from "react/jsx-runtime";
var SvgRotate = (props) => /* @__PURE__ */ jsx1087(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1087(
      "path",
      {
        d: "M21.383 2.743a1.004 1.004 0 0 0-1.09.218L18.19 5.065c-1.676-1.489-3.85-2.397-6.188-2.397-4.124 0-7.81 2.762-8.96 6.72a.997.997 0 0 0 .679 1.237.996.996 0 0 0 1.24-.68C5.864 6.839 8.76 4.669 12 4.669c1.797 0 3.473.684 4.779 1.808L14.295 8.96a1 1 0 0 0 .707 1.707h5.996c.552-.038 1.002-.446 1.002-1v-6a.998.998 0 0 0-.617-.924ZM20.28 13.337a.997.997 0 0 0-1.239.68c-.902 3.145-3.797 5.315-7.076 5.315-1.797 0-3.474-.684-4.779-1.808L9.67 15.04a.99.99 0 0 0 .217-1.083c-.118-.374-.48-.624-.922-.624h-5.96c-.552 0-1.004.448-1.004 1v5.999a1 1 0 0 0 1.707.707l2.104-2.105c1.674 1.49 3.853 2.398 6.153 2.398 4.124 0 7.807-2.762 8.961-6.72.192-.566-.117-1.083-.646-1.275Z",
        fill: "currentColor"
      }
    )
  })
);
var Rotate_default = SvgRotate;

// src/Icon/icons/RulerHorizontal.tsx
import { jsx as jsx1088 } from "react/jsx-runtime";
var SvgRulerHorizontal = (props) => /* @__PURE__ */ jsx1088(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1088(
      "path",
      {
        d: "M4 16a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h16c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2H4Zm0-1.5h16c.275 0 .5-.225.5-.5v-4c0-.275-.225-.5-.5-.5h-1.5V11c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5V9.5h-2V11c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5V9.5h-2V11c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5V9.5h-2V11c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5V9.5h-2V11c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5V9.5H4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5Z",
        fill: "currentColor"
      }
    )
  })
);
var RulerHorizontal_default = SvgRulerHorizontal;

// src/Icon/icons/RulerTriangle.tsx
import { jsx as jsx1089 } from "react/jsx-runtime";
var SvgRulerTriangle = (props) => /* @__PURE__ */ jsx1089(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1089(
      "path",
      {
        d: "M12 17H7v-5l5 5Zm10 3.645v.105c0 .691-.559 1.25-1.25 1.25H4.5C3.12 22 2 20.879 2 19.5V3.25C2 2.56 2.56 2 3.25 2h.107c.332 0 .65.132.884.366l17.392 17.392c.234.234.367.555.367.887Zm-17.5-.52h14.848l-2.606-2.605-.55.546a.62.62 0 0 1-.883 0 .62.62 0 0 1 0-.882l.546-.551-2.238-2.238-.55.546a.62.62 0 0 1-.883 0 .62.62 0 0 1 0-.882l.546-.551-2.238-2.238-.55.546a.62.62 0 0 1-.883 0 .62.62 0 0 1 0-.882l.546-.551-2.238-2.238-.55.546a.62.62 0 0 1-.883 0 .623.623 0 0 1 0-.882l.546-.551-2.64-2.606V19.5c0 .344.315.625.625.625H4.5Z",
        fill: "currentColor"
      }
    )
  })
);
var RulerTriangle_default = SvgRulerTriangle;

// src/Icon/icons/RulerVertical.tsx
import { jsx as jsx1090 } from "react/jsx-runtime";
var SvgRulerVertical = (props) => /* @__PURE__ */ jsx1090(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1090(
      "path",
      {
        d: "M14.5 2C15.879 2 17 3.12 17 4.5v15c0 1.379-1.121 2.5-2.5 2.5h-5C8.12 22 7 20.879 7 19.5v-15A2.5 2.5 0 0 1 9.5 2h5Zm0 1.875h-5a.625.625 0 0 0-.625.625v15c0 .344.28.625.625.625h5a.627.627 0 0 0 .625-.625v-1.25H13.25a.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625h1.875v-2.5H13.25a.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625h1.875v-2.5H13.25a.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625h1.875V7H13.25a.627.627 0 0 1-.625-.625c0-.344.281-.625.625-.625h1.875V4.5a.626.626 0 0 0-.625-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var RulerVertical_default = SvgRulerVertical;

// src/Icon/icons/Ruler.tsx
import { jsx as jsx1091 } from "react/jsx-runtime";
var SvgRuler = (props) => /* @__PURE__ */ jsx1091(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1091(
      "path",
      {
        d: "M2.764 18.409a2.612 2.612 0 0 1 0-3.69L14.718 2.763a2.612 2.612 0 0 1 3.69 0l2.828 2.83a2.609 2.609 0 0 1 0 3.69L9.284 21.236a2.61 2.61 0 0 1-3.69 0l-2.83-2.827Zm1.383-1.385 2.83 2.831a.647.647 0 0 0 .922 0L19.855 7.9a.647.647 0 0 0 0-.921l-2.831-2.831a.65.65 0 0 0-.92 0l-1.606 1.605 1.222 1.226a.647.647 0 0 1 0 .92.647.647 0 0 1-.92 0l-1.227-1.222-1.682 1.683 1.222 1.226a.647.647 0 0 1 0 .92.647.647 0 0 1-.92 0l-1.227-1.221-1.682 1.682 1.222 1.226a.647.647 0 0 1 0 .921.647.647 0 0 1-.92 0l-1.227-1.222-1.683 1.682L7.9 14.8a.647.647 0 0 1 0 .921.647.647 0 0 1-.921 0l-1.226-1.222-1.605 1.605a.65.65 0 0 0 0 .92Z",
        fill: "currentColor"
      }
    )
  })
);
var Ruler_default = SvgRuler;

// src/Icon/icons/SafariExtensions.tsx
import { jsx as jsx1092, jsxs as jsxs11 } from "react/jsx-runtime";
var SvgSafariExtensions = (props) => /* @__PURE__ */ jsxs11(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsxs11(
        "mask",
        {
          id: "safari-extensions_svg__a",
          maskUnits: "userSpaceOnUse",
          x: 2.031,
          y: 2.391,
          width: 21,
          height: 20,
          fill: "currentColor",
          children: [
            /* @__PURE__ */ jsx1092("path", { fill: "#fff", d: "M2.031 2.391h21v20h-21z" }),
            /* @__PURE__ */ jsx1092(
              "path",
              {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11 19.328c-4.352 0-7.969-3.617-7.969-7.969 0-4.359 3.61-7.968 7.961-7.968 4.36 0 7.977 3.609 7.977 7.968 0 .322-.02.64-.058.952a5.972 5.972 0 0 0-1.303-.28c.021-.221.033-.445.033-.672 0-3.687-2.961-6.64-6.649-6.64a6.602 6.602 0 0 0-6.625 6.64A6.609 6.609 0 0 0 11 18c0 .456.05.9.147 1.327a7.21 7.21 0 0 1-.147.001Zm-3.273-4.031c-.516.25-.922-.156-.672-.672l2.195-4.484c.133-.266.297-.43.54-.54l4.468-2.18c.547-.273.93.141.68.673l-2.18 4.476a1.18 1.18 0 0 1-.547.54l-4.484 2.187ZM11 12.32c.531 0 .96-.43.96-.953a.96.96 0 0 0-.96-.96.954.954 0 0 0-.953.96c0 .524.422.953.953.953Zm2 6.039v1.54c0 .717.369 1.093 1.082 1.093h4.474c.72 0 1.096-.369 1.096-1.078v-1.526c0-.073.058-.105.13-.047.2.152.434.275.746.275.614 0 1.092-.485 1.092-1.107 0-.619-.478-1.104-1.092-1.104-.311 0-.547.123-.746.275-.072.058-.13.026-.13-.047v-1.555c0-.709-.376-1.078-1.096-1.078h-4.474c-.713 0-1.082.376-1.082 1.092v1.552c0 .235.184.39.402.39.119 0 .246-.05.358-.158l.007-.008c.169-.157.379-.354.792-.354.546 0 .977.434.977.988 0 .553-.43.987-.977.987-.41 0-.62-.197-.787-.354l-.012-.011a.529.529 0 0 0-.358-.156c-.217 0-.402.156-.402.39Z"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx1092(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11 19.328c-4.352 0-7.969-3.617-7.969-7.969 0-4.359 3.61-7.968 7.961-7.968 4.36 0 7.977 3.609 7.977 7.968 0 .322-.02.64-.058.952a5.972 5.972 0 0 0-1.303-.28c.021-.221.033-.445.033-.672 0-3.687-2.961-6.64-6.649-6.64a6.602 6.602 0 0 0-6.625 6.64A6.609 6.609 0 0 0 11 18c0 .456.05.9.147 1.327a7.21 7.21 0 0 1-.147.001Zm-3.273-4.031c-.516.25-.922-.156-.672-.672l2.195-4.484c.133-.266.297-.43.54-.54l4.468-2.18c.547-.273.93.141.68.673l-2.18 4.476a1.18 1.18 0 0 1-.547.54l-4.484 2.187ZM11 12.32c.531 0 .96-.43.96-.953a.96.96 0 0 0-.96-.96.954.954 0 0 0-.953.96c0 .524.422.953.953.953Zm2 6.039v1.54c0 .717.369 1.093 1.082 1.093h4.474c.72 0 1.096-.369 1.096-1.078v-1.526c0-.073.058-.105.13-.047.2.152.434.275.746.275.614 0 1.092-.485 1.092-1.107 0-.619-.478-1.104-1.092-1.104-.311 0-.547.123-.746.275-.072.058-.13.026-.13-.047v-1.555c0-.709-.376-1.078-1.096-1.078h-4.474c-.713 0-1.082.376-1.082 1.092v1.552c0 .235.184.39.402.39.119 0 .246-.05.358-.158l.007-.008c.169-.157.379-.354.792-.354.546 0 .977.434.977.988 0 .553-.43.987-.977.987-.41 0-.62-.197-.787-.354l-.012-.011a.529.529 0 0 0-.358-.156c-.217 0-.402.156-.402.39Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx1092(
        "path",
        {
          d: "m18.91 12.31-.317.949 1.161.39.15-1.217-.993-.121Zm-1.302-.28-.995-.098-.099.993.994.1.1-.995ZM11 18h1v-1h-1v1Zm.147 1.327.019 1 1.227-.023-.27-1.197-.976.22Zm-4.092-4.702-.898-.44-.002.004.9.436Zm.672.672.436.9.002-.001-.438-.9ZM9.25 10.14l-.894-.448-.004.008.898.44Zm.54-.54.41.912.014-.006.013-.007-.438-.898Zm4.468-2.18.438.9.009-.005-.447-.894Zm.68.673.899.438.005-.012-.905-.426Zm-2.18 4.476.888.459.006-.01.005-.01-.9-.439Zm-.547.54.438.898.01-.004-.448-.895Zm7.571 5.23-.624.782.008.007.01.006.606-.794Zm0-1.66-.607-.794-.009.007-.008.006.624.781Zm-6.022.196-.684-.73-.006.005-.006.006.696.719Zm.007-.008.684.73-.684-.73Zm.005 1.267-.684.73.684-.73Zm-.012-.011.683-.73-.683.73ZM2.03 11.359c0 4.904 4.065 8.97 8.969 8.97v-2c-3.8 0-6.969-3.17-6.969-6.97h-2Zm8.961-8.968c-4.904 0-8.96 4.057-8.96 8.968h2c0-3.807 3.162-6.968 6.96-6.968v-2Zm8.977 8.968c0-4.913-4.066-8.968-8.977-8.968v2c3.808 0 6.977 3.163 6.977 6.968h2Zm-.066 1.073c.044-.352.066-.71.066-1.073h-2c0 .281-.017.558-.05.83l1.984.243Zm-2.395.593a4.97 4.97 0 0 1 1.085.234l.636-1.896a6.97 6.97 0 0 0-1.521-.328l-.2 1.99Zm-.867-1.666c0 .194-.01.385-.028.573l1.99.197c.025-.253.038-.51.038-.77h-2Zm-5.649-5.64a5.622 5.622 0 0 1 5.649 5.64h2c0-4.24-3.41-7.64-7.649-7.64v2Zm-5.625 5.64a5.602 5.602 0 0 1 5.625-5.64v-2a7.602 7.602 0 0 0-7.625 7.64h2ZM11 17a5.609 5.609 0 0 1-5.633-5.64h-2A7.609 7.609 0 0 0 11 19v-2Zm1.123 2.107A5.023 5.023 0 0 1 12 18h-2c0 .53.06 1.048.172 1.547l1.95-.44ZM11 20.328l.166-.001-.037-2-.129.001v2Zm-4.845-6.14c-.263.543-.266 1.26.241 1.767.507.507 1.225.504 1.767.242l-.873-1.8c.027-.013.283-.094.52.144.238.237.157.494.145.52l-1.8-.872Zm2.197-4.487-2.195 4.484 1.796.88 2.195-4.485-1.796-.88Zm1.025-1.01c-.476.214-.799.557-1.021 1.002l1.788.895c.03-.059.045-.072.042-.068l-.002.001-.002.001.005-.002a.23.23 0 0 1 .014-.007L9.377 8.69Zm4.442-2.168-4.468 2.18.876 1.797 4.47-2.18-.878-1.797Zm2.023 1.997c.243-.516.282-1.239-.23-1.763-.532-.543-1.275-.493-1.801-.23l.894 1.79c.02-.011-.258.11-.523-.162a.57.57 0 0 1-.165-.344.383.383 0 0 1 .005-.107c.005-.024.01-.036.01-.036l1.81.852Zm-2.185 4.488 2.18-4.476-1.799-.876-2.18 4.477 1.799.875Zm-.999.996c.44-.22.767-.546.988-.975l-1.777-.917a.23.23 0 0 1-.041.06.239.239 0 0 1-.064.043l.894 1.789Zm-4.493 2.192 4.484-2.188-.876-1.797-4.485 2.187.877 1.798Zm2.796-4.829a.06.06 0 0 1 .005-.022.036.036 0 0 1 .02-.021.038.038 0 0 1 .014-.004v2c1.078 0 1.96-.872 1.96-1.953h-2Zm.039.04a.04.04 0 0 1-.04-.04h2A1.96 1.96 0 0 0 11 9.407v2Zm.047-.04v.003a.042.042 0 0 1-.011.02.052.052 0 0 1-.018.012.05.05 0 0 1-.018.004v-2a1.954 1.954 0 0 0-1.953 1.961h2ZM11 11.32a.05.05 0 0 1 .033.015c.008.008.014.02.014.032h-2c0 1.07.864 1.953 1.953 1.953v-2Zm3 8.58v-1.541h-2v1.54h2Zm.082.092a.482.482 0 0 1-.144-.015c-.004-.002.019.006.047.035.028.028.034.05.032.042A.523.523 0 0 1 14 19.9h-2c0 .52.135 1.085.562 1.517.43.435.995.575 1.52.575v-2Zm4.474 0h-4.474v2h4.474v-2Zm.096-.078a.468.468 0 0 1-.015.14c0 .004.008-.02.036-.048.028-.028.05-.034.04-.03a.537.537 0 0 1-.157.016v2c.52 0 1.086-.134 1.52-.56.435-.428.576-.994.576-1.518h-2Zm0-1.526v1.526h2v-1.526h-2Zm1.755-.828c-.176-.14-.601-.38-1.107-.165-.524.221-.648.72-.648.993h2c0 .2-.094.646-.572.848a.912.912 0 0 1-.922-.114l1.25-1.562Zm.12.056a.09.09 0 0 1-.038-.007.462.462 0 0 1-.1-.063l-1.213 1.59c.3.23.745.48 1.352.48v-2Zm.093-.107c0 .05-.017.073-.028.084a.067.067 0 0 1-.022.015.107.107 0 0 1-.042.008v2c1.18 0 2.092-.946 2.092-2.107h-2Zm-.092-.104c.02 0 .034.004.043.008a.068.068 0 0 1 .022.015c.011.011.027.034.027.08h2c0-1.16-.914-2.102-2.092-2.102v2Zm-.139.07a.462.462 0 0 1 .1-.062.089.089 0 0 1 .039-.008v-2c-.607 0-1.052.25-1.352.48l1.213 1.59Zm-1.737-.842c0 .273.124.772.648.994.506.213.931-.025 1.107-.166l-1.25-1.561a.912.912 0 0 1 .923-.115.929.929 0 0 1 .572.848h-2Zm0-1.555v1.555h2v-1.555h-2ZM18.556 15a.53.53 0 0 1 .158.017c.009.003-.013-.003-.04-.03-.03-.029-.038-.052-.037-.05a.468.468 0 0 1 .015.141h2c0-.524-.141-1.09-.577-1.518-.433-.426-.998-.56-1.519-.56v2Zm-4.474 0h4.474v-2h-4.474v2Zm-.082.092c0-.095.013-.142.017-.154.002-.008-.004.014-.032.042-.028.029-.051.037-.047.035a.482.482 0 0 1 .144-.015v-2c-.525 0-1.09.14-1.52.575-.427.432-.562.998-.562 1.517h2Zm0 1.552v-1.552h-2v1.552h2Zm-.598-.61c.129 0 .277.048.4.162a.62.62 0 0 1 .198.448h-2c0 .853.7 1.39 1.402 1.39v-2Zm-.338.123a.49.49 0 0 1 .338-.122v2c.412 0 .78-.176 1.053-.44l-1.39-1.438Zm.02-.018-.008.007 1.367 1.46.008-.008-1.367-1.46Zm1.475-.625c-.82 0-1.275.437-1.475.625l1.367 1.46c.045-.043.066-.062.085-.078.016-.013.02-.015.018-.013a.087.087 0 0 1-.018.007c-.006.002 0-.001.023-.001v-2Zm1.977 1.988a1.973 1.973 0 0 0-1.977-1.988v2c.003 0 0 0-.005-.002a.037.037 0 0 1-.013-.008.028.028 0 0 1-.005-.009c-.002-.003 0-.001 0 .006h2Zm-1.977 1.987a1.973 1.973 0 0 0 1.977-1.988h-2c0 .008-.002.01 0 .007l.005-.009a.037.037 0 0 1 .013-.008c.005-.002.008-.002.005-.002v2Zm-1.471-.624c.198.185.654.624 1.471.624v-2c-.021 0-.026-.002-.02 0a.085.085 0 0 1 .02.007 1.706 1.706 0 0 1-.102-.09l-1.37 1.459Zm-.012-.011.012.01 1.368-1.459-.013-.011-1.367 1.46Zm.325.114a.479.479 0 0 1-.325-.114l1.367-1.46a1.527 1.527 0 0 0-1.041-.426v2Zm.599-.61a.62.62 0 0 1-.199.449.588.588 0 0 1-.4.161v-2c-.701 0-1.401.538-1.401 1.39h2Z",
          fill: "#fff",
          mask: "url(#safari-extensions_svg__a)"
        }
      )
    ]
  })
);
var SafariExtensions_default = SvgSafariExtensions;

// src/Icon/icons/Scissors.tsx
import { jsx as jsx1093 } from "react/jsx-runtime";
var SvgScissors = (props) => /* @__PURE__ */ jsx1093(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1093(
      "path",
      {
        d: "m20.46 19.281-6.257-5.242 1.46-1.223 6 5.028a.936.936 0 1 1-1.202 1.437ZM6.376 2.001a4.374 4.374 0 0 1 4.375 4.374c0 .7-.164 1.36-.453 1.945l2.933 2.457 7.23-6.058a.937.937 0 1 1 1.204 1.437L10.297 15.68c.289.586.453 1.246.453 1.945A4.373 4.373 0 0 1 6.375 22 4.374 4.374 0 0 1 2 17.625a4.374 4.374 0 0 1 7.121-3.406L11.769 12 9.121 9.781A4.374 4.374 0 0 1 2 6.375 4.375 4.375 0 0 1 6.375 2Zm-2.5 4.374a2.501 2.501 0 0 0 5 0 2.501 2.501 0 0 0-5 0Zm2.5 8.75a2.501 2.501 0 0 0 0 5c1.379 0 2.5-1.121 2.5-2.5s-1.121-2.5-2.5-2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var Scissors_default = SvgScissors;

// src/Icon/icons/ScreenUsers.tsx
import { jsx as jsx1094 } from "react/jsx-runtime";
var SvgScreenUsers = (props) => /* @__PURE__ */ jsx1094(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1094(
      "path",
      {
        d: "M3.75 11a.75.75 0 0 0 .75-.75v-4.5a.25.25 0 0 1 .25-.25h14.5a.25.25 0 0 1 .25.25v4.5c0 .416.334.75.75.75s.75-.334.75-.75v-4.5A1.75 1.75 0 0 0 19.25 4H4.75A1.75 1.75 0 0 0 3 5.75v4.5c0 .416.336.75.75.75ZM19 12a2.003 2.003 0 0 0-1.994 2A1.96 1.96 0 0 0 19 15.972 1.96 1.96 0 0 0 20.994 14 2.003 2.003 0 0 0 19 12Zm.006 2.472A.461.461 0 0 1 18.51 14a.5.5 0 0 1 .492-.5.5.5 0 0 1 .49.5c0 .275-.222.497-.485.472ZM12.744 17h-1.485C10.012 17 9 18.047 9 19.334c0 .366.29.666.65.666h4.697a.66.66 0 0 0 .653-.666C15 18.047 13.988 17 12.744 17Zm7 0h-1.485C17.012 17 16 18.047 16 19.334c0 .366.29.666.65.666h4.697a.66.66 0 0 0 .653-.666C22 18.047 20.988 17 19.744 17Zm-9.738-3A2 2 0 0 0 12 16a2.002 2.002 0 0 0 1.994-2A2.003 2.003 0 0 0 12 12a2.003 2.003 0 0 0-1.994 2Zm2.485 0a.498.498 0 0 1-.486.5.5.5 0 0 1-.004-1 .5.5 0 0 1 .49.5Zm-6.747 3H4.259C3.013 17 2 18.047 2 19.334a.66.66 0 0 0 .65.666h4.698A.66.66 0 0 0 8 19.334C8 18.047 6.987 17 5.744 17Zm-2.737-3A2 2 0 0 0 5 16a2.002 2.002 0 0 0 1.994-2A2.003 2.003 0 0 0 5 12a2.002 2.002 0 0 0-1.993 2Zm2.484 0a.498.498 0 0 1-.486.5.5.5 0 0 1-.005-.998.5.5 0 0 1 .49.498Z",
        fill: "currentColor"
      }
    )
  })
);
var ScreenUsers_default = SvgScreenUsers;

// src/Icon/icons/ScrewdriverWrench.tsx
import { jsx as jsx1095 } from "react/jsx-runtime";
var SvgScrewdriverWrench = (props) => /* @__PURE__ */ jsx1095(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1095(
      "path",
      {
        d: "M10.716 5.774v1.904l1.196 1.162c-.27-1.362.136-2.748 1.112-3.725a4.128 4.128 0 0 1 2.93-1.216h.043l-2.273 2.23.591 3.54 3.54.59 2.235-2.236a4.113 4.113 0 0 1-1.22 2.968 3.997 3.997 0 0 1-1.24.845c.068.063.151.113.22.181l1.196 1.2c.41-.249.8-.546 1.152-.898 1.484-1.45 2.095-3.681 1.587-5.722a1.36 1.36 0 0 0-.953-.986c-.478-.132-.986.005-1.293.351l-2.294 2.29-1.264-.21-.21-1.27 2.29-2.284c.346-.317.478-.824.346-1.293a1.35 1.35 0 0 0-.986-.957 5.991 5.991 0 0 0-5.723 1.583c-.4.4-.722.85-.99 1.293l.043.029-.035.631ZM6.142 19.75c-.498.498-1.377.498-1.88 0a1.247 1.247 0 0 1-.39-.902c0-.357.137-.688.39-.902l5.251-5.317-1.324-1.324-5.25 5.242c-.605.605-.902 1.41-.937 2.23-.034.82.332 1.66.938 2.265a3.163 3.163 0 0 0 4.495 0l3.941-3.941a4.159 4.159 0 0 1-.61-2.036L6.142 19.75Zm15.433-2.277-4.574-4.57a2.896 2.896 0 0 0-3.335-.543l-4.2-4.168V5.77L4.502 2.02l-2.5 2.465 3.75 4.965h2.423l4.168 4.164a2.904 2.904 0 0 0 .543 3.335l4.57 4.574a1.451 1.451 0 0 0 2.06 0l2.06-2.06c.566-.502.566-1.424 0-1.99Z",
        fill: "currentColor"
      }
    )
  })
);
var ScrewdriverWrench_default = SvgScrewdriverWrench;

// src/Icon/icons/Screwdriver.tsx
import { jsx as jsx1096 } from "react/jsx-runtime";
var SvgScrewdriver = (props) => /* @__PURE__ */ jsx1096(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1096(
      "path",
      {
        d: "m21.822 4.332-2.149-2.149a.625.625 0 0 0-.816-.058L13.954 5.8a1.25 1.25 0 0 0-.5 1v2.422l-3.164 3.164c-1.75-.929-3.226.02-3.761.555l-4.055 4.051a1.61 1.61 0 0 0 0 2.27l2.27 2.27c.313.312.723.468 1.134.468a1.6 1.6 0 0 0 1.137-.469l4.053-4.05c1.02-1.02 1.191-2.555.552-3.765l3.128-3.164h2.387a1.25 1.25 0 0 0 1-.5l3.675-4.903a.557.557 0 0 0 .012-.817ZM9.705 16.156l-3.863 3.858-1.884-1.885 3.891-3.863a1.334 1.334 0 0 1 1.89 0 1.31 1.31 0 0 1-.034 1.89Zm7.187-7.48H15.33V7.113l3.784-2.837.618.615-2.84 3.785Z",
        fill: "currentColor"
      }
    )
  })
);
var Screwdriver_default = SvgScrewdriver;

// src/Icon/icons/Scribble.tsx
import { jsx as jsx1097 } from "react/jsx-runtime";
var SvgScribble = (props) => /* @__PURE__ */ jsx1097(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1097(
      "path",
      {
        d: "M9.16 2.838A3.117 3.117 0 0 1 11.312 2h.04a3.148 3.148 0 0 1 2.226 5.371l-8.08 8.082a1.271 1.271 0 0 0 .9 2.172c.336 0 .66-.133.899-.371l9.332-9.332a3.146 3.146 0 1 1 4.45 4.45l-4.071 4.073a2.155 2.155 0 0 0 1.523 3.68h.172c.219 0 .438-.035.649-.105l1.414-.473c.457-.164 1.023.101 1.187.594.129.457-.101 1.023-.594 1.187l-1.414.469a3.85 3.85 0 0 1-1.242.203h-.172a4.031 4.031 0 0 1-2.851-6.883l4.074-4.07a1.274 1.274 0 0 0-1.8-1.8L8.62 18.577a3.146 3.146 0 1 1-4.45-4.45l8.083-8.081a1.272 1.272 0 0 0-.902-2.172h-.04a1.25 1.25 0 0 0-.886.345L3.57 10.504c-.382.348-.975.289-1.325-.059a.937.937 0 0 1 .058-1.324L9.16 2.838Z",
        fill: "currentColor"
      }
    )
  })
);
var Scribble_default = SvgScribble;

// src/Icon/icons/ScrollOld.tsx
import { jsx as jsx1098 } from "react/jsx-runtime";
var SvgScrollOld = (props) => /* @__PURE__ */ jsx1098(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1098(
      "path",
      {
        d: "M20.333 13.667h-1.666V7a2.781 2.781 0 0 0-2.778-2.778H4.778A2.781 2.781 0 0 0 2 7v1.667c0 .92.746 1.666 1.667 1.666h1.11V8.667h-1.11V7c0-.612.499-1.111 1.11-1.111.613 0 1.112.5 1.112 1.111v10a2.781 2.781 0 0 0 2.778 2.778h9.257A4.083 4.083 0 0 0 22 15.7v-.368c0-.92-.747-1.666-1.667-1.666Zm-10.555 1.11V17c0 .612-.5 1.111-1.111 1.111-.612 0-1.111-.5-1.111-1.111v-5h1.666c.306 0 .556-.25.556-.556a.557.557 0 0 0-.556-.555H7.556V7c0-.395-.086-.77-.236-1.111h8.569C16.5 5.889 17 6.389 17 7v.556h-1.111a.557.557 0 0 0-.556.555c0 .306.25.556.556.556H17v2.222h-1.111a.557.557 0 0 0-.556.555c0 .306.25.556.556.556H17v1.667h-6.111a1.11 1.11 0 0 0-1.111 1.11Zm10.555.924c0 1.33-1.08 2.41-2.41 2.41h-6.715c.15-.34.236-.715.236-1.111v-1.667h3.334v1.111a.555.555 0 1 0 1.11 0v-1.11h4.445v.367Z",
        fill: "currentColor"
      }
    )
  })
);
var ScrollOld_default = SvgScrollOld;

// src/Icon/icons/Scroll.tsx
import { jsx as jsx1099 } from "react/jsx-runtime";
var SvgScroll = (props) => /* @__PURE__ */ jsx1099(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1099(
      "path",
      {
        d: "M20.333 13.667h-1.666V7a2.781 2.781 0 0 0-2.778-2.778H4.778A2.781 2.781 0 0 0 2 7v1.667c0 .92.746 1.666 1.667 1.666h1.11V8.667h-1.11V7c0-.612.499-1.111 1.11-1.111.613 0 1.112.5 1.112 1.111v10a2.782 2.782 0 0 0 2.778 2.778h9.257A4.083 4.083 0 0 0 22 15.7v-.368c0-.92-.747-1.666-1.667-1.666Zm-10.555 1.11V17c0 .612-.5 1.111-1.111 1.111-.612 0-1.111-.5-1.111-1.111V7c0-.395-.086-.77-.236-1.111h8.569C16.5 5.889 17 6.389 17 7v6.667h-6.111a1.11 1.11 0 0 0-1.111 1.11Zm10.555.924c0 1.33-1.08 2.41-2.41 2.41h-6.715c.15-.34.236-.715.236-1.111v-1.667h8.89v.368Z",
        fill: "currentColor"
      }
    )
  })
);
var Scroll_default = SvgScroll;

// src/Icon/icons/SdCard.tsx
import { jsx as jsx1100 } from "react/jsx-runtime";
var SvgSdCard = (props) => /* @__PURE__ */ jsx1100(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1100(
      "path",
      {
        d: "M17 2h-6.98c-.332 0-.653.132-.887.366L4.866 6.633a1.256 1.256 0 0 0-.366.887V19.5C4.5 20.875 5.625 22 7 22h10c1.375 0 2.5-1.125 2.5-2.5v-15C19.5 3.125 18.375 2 17 2Zm.625 17.5a.63.63 0 0 1-.625.625H7a.63.63 0 0 1-.625-.625V7.777l3.902-3.902H17a.63.63 0 0 1 .625.625v15ZM15.75 5.125a.625.625 0 0 0-.625.625v2.5a.625.625 0 1 0 1.25 0v-2.5a.626.626 0 0 0-.625-.625Zm-2.5 0a.625.625 0 0 0-.625.625v2.5a.625.625 0 1 0 1.25 0v-2.5a.626.626 0 0 0-.625-.625Zm-2.5 0a.626.626 0 0 0-.625.625v2.5a.625.625 0 1 0 1.25 0v-2.5a.626.626 0 0 0-.625-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var SdCard_default = SvgSdCard;

// src/Icon/icons/SdCards.tsx
import { jsx as jsx1101 } from "react/jsx-runtime";
var SvgSdCards = (props) => /* @__PURE__ */ jsx1101(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1101(
      "path",
      {
        d: "M14.5 5.125a.625.625 0 0 0-.625.625v2.5a.625.625 0 1 0 1.25 0v-2.5a.626.626 0 0 0-.625-.625Zm2.5 0a.625.625 0 0 0-.625.625v2.5a.625.625 0 1 0 1.25 0v-2.5A.626.626 0 0 0 17 5.125ZM18.25 2h-6.355c-.332 0-.653.132-.887.366l-3.64 3.642A1.252 1.252 0 0 0 7 6.895v8.855c0 1.375 1.125 2.5 2.5 2.5h8.75c1.375 0 2.5-1.125 2.5-2.5V4.5c0-1.375-1.125-2.5-2.5-2.5Zm.625 13.75a.633.633 0 0 1-.625.625H9.5a.633.633 0 0 1-.625-.625V7.152l3.277-3.277h6.098c.339 0 .625.286.625.625v11.25ZM16.062 22H7.938a4.692 4.692 0 0 1-4.687-4.688V6.688a.939.939 0 0 1 1.875 0v10.625a2.816 2.816 0 0 0 2.813 2.813h8.125a.938.938 0 0 1 0 1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var SdCards_default = SvgSdCards;

// src/Icon/icons/SealQuestion.tsx
import { jsx as jsx1102 } from "react/jsx-runtime";
var SvgSealQuestion = (props) => /* @__PURE__ */ jsx1102(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1102(
      "path",
      {
        d: "M8.575 8.414a2.227 2.227 0 0 1 2.098-1.482h2.317a2.51 2.51 0 0 1 1.248 4.685l-1.32.735c.028.52-.397.938-.918.938a.951.951 0 0 1-.953-.954V11.8c0-.342.182-.656.48-.827l1.76-1.01a.602.602 0 0 0-.297-1.124h-2.317a.313.313 0 0 0-.298.21l-.02.053c-.175.496-.719.755-1.251.58a.967.967 0 0 1-.545-1.22l.016-.048Zm4.697 7.419A1.27 1.27 0 0 1 12 17.105a1.27 1.27 0 0 1-1.271-1.272A1.27 1.27 0 0 1 12 14.56a1.27 1.27 0 0 1 1.272 1.272Zm1.907-11.444h2.543c1.053 0 1.908.854 1.908 1.907V8.84l1.812 1.812a1.911 1.911 0 0 1 0 2.698l-1.812 1.812v2.58a1.908 1.908 0 0 1-1.908 1.907h-2.579l-1.796 1.792a1.9 1.9 0 0 1-2.694 0l-1.796-1.792H6.278a1.908 1.908 0 0 1-1.907-1.908v-2.579L2.559 13.35a1.908 1.908 0 0 1 0-2.698L4.371 8.84V6.296c0-1.053.854-1.907 1.907-1.907h2.508l1.867-1.83a1.904 1.904 0 0 1 2.694 0l1.832 1.83Zm-8.9 1.907V8.84c0 .505-.203.99-.56 1.347l-1.81 1.812 1.81 1.812c.357.358.56.843.56 1.351v2.58h2.578c.509 0 .994.202 1.351.56L12 20.093l1.793-1.793a1.91 1.91 0 0 1 1.35-.56h2.58v-2.579c0-.508.202-.993.56-1.35l1.808-1.813-1.808-1.812a1.908 1.908 0 0 1-.56-1.347V6.296h-2.544c-.504 0-.99-.202-1.347-.558l-1.867-1.83-1.796 1.83a1.934 1.934 0 0 1-1.383.558H6.278Z",
        fill: "currentColor"
      }
    )
  })
);
var SealQuestion_default = SvgSealQuestion;

// src/Icon/icons/Seal.tsx
import { jsx as jsx1103 } from "react/jsx-runtime";
var SvgSeal = (props) => /* @__PURE__ */ jsx1103(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1103(
      "path",
      {
        d: "M10.653 2.559a1.904 1.904 0 0 1 2.695 0L15.16 4.37h2.563c1.053 0 1.908.854 1.908 1.908V8.84l1.812 1.812a1.907 1.907 0 0 1 0 2.695L19.63 15.16v2.563a1.908 1.908 0 0 1-1.907 1.908H15.16l-1.812 1.812a1.907 1.907 0 0 1-2.695 0L8.841 19.63H6.278a1.908 1.908 0 0 1-1.908-1.907V15.16L2.56 13.348a1.904 1.904 0 0 1 0-2.695L4.37 8.841V6.278c0-1.054.854-1.908 1.908-1.908H8.84l1.812-1.811Zm-.465 3.16a1.913 1.913 0 0 1-1.347.559H6.278V8.84c0 .505-.203.99-.559 1.347L3.907 12l1.812 1.813c.356.357.559.842.559 1.347v2.563H8.84c.505 0 .99.203 1.347.56L12 20.091l1.813-1.808c.357-.357.842-.56 1.347-.56h2.563V15.16c0-.505.203-.99.56-1.347L20.091 12l-1.808-1.812a1.908 1.908 0 0 1-.56-1.347V6.278H15.16c-.505 0-.99-.203-1.347-.559L12 3.908l-1.812 1.811Z",
        fill: "currentColor"
      }
    )
  })
);
var Seal_default = SvgSeal;

// src/Icon/icons/SendBack.tsx
import { jsx as jsx1104 } from "react/jsx-runtime";
var SvgSendBack = (props) => /* @__PURE__ */ jsx1104(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1104(
      "path",
      {
        d: "M8 4a2 2 0 0 1 2 2v4c0 1.103-.897 2-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h4Zm0 1.5H4a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h4c.275 0 .5-.225.5-.5V6a.5.5 0 0 0-.5-.5ZM20 12c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2h-4c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h4Zm0 1.5h-4c-.275 0-.5.225-.5.5v4c0 .275.225.5.5.5h4c.275 0 .5-.225.5-.5v-4c0-.275-.225-.5-.5-.5ZM8 13a3 3 0 0 0 3-3V7h4c1.103 0 2 .897 2 2v2h-1c-1.684 0-3 1.316-3 3v3H9c-1.103 0-2-.897-2-2v-2h1Z",
        fill: "currentColor"
      }
    )
  })
);
var SendBack_default = SvgSendBack;

// src/Icon/icons/SendBackward.tsx
import { jsx as jsx1105 } from "react/jsx-runtime";
var SvgSendBackward = (props) => /* @__PURE__ */ jsx1105(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1105(
      "path",
      {
        d: "M13.25 2c1.379 0 2.5 1.12 2.5 2.5V7h-5C8.645 7 7 8.645 7 10.75v5H4.5c-1.38 0-2.5-1.121-2.5-2.5V4.5A2.5 2.5 0 0 1 4.5 2h8.75Zm-5 8.75c0-1.379 1.121-2.5 2.5-2.5h8.75c1.379 0 2.5 1.121 2.5 2.5v8.75c0 1.379-1.121 2.5-2.5 2.5h-8.75a2.502 2.502 0 0 1-2.5-2.5v-8.75Zm1.875 0v8.75c0 .344.281.625.625.625h8.75a.627.627 0 0 0 .625-.625v-8.75a.627.627 0 0 0-.625-.625h-8.75a.627.627 0 0 0-.625.625Z",
        fill: "currentColor"
      }
    )
  })
);
var SendBackward_default = SvgSendBackward;

// src/Icon/icons/Server.tsx
import { jsx as jsx1106 } from "react/jsx-runtime";
var SvgServer = (props) => /* @__PURE__ */ jsx1106(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1106(
      "path",
      {
        d: "M19.5 3.25h-15A2.5 2.5 0 0 0 2 5.75v2.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-2.5c0-1.38-1.121-2.5-2.5-2.5Zm.625 5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625v-2.5c0-.345.28-.625.625-.625h15c.345 0 .625.28.625.625v2.5Zm-.625 5h-15a2.5 2.5 0 0 0-2.5 2.5v2.5a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-2.5c0-1.379-1.121-2.5-2.5-2.5Zm.625 5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625v-2.5c0-.345.28-.625.625-.625h15c.345 0 .625.28.625.625v2.5ZM15.75 6.062a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.875Zm2.5 0a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.875Zm-2.5 10a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.875Zm2.5 0a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var Server_default = SvgServer;

// src/Icon/icons/SettingsGear.tsx
import { jsx as jsx1107 } from "react/jsx-runtime";
var SvgSettingsGear = (props) => /* @__PURE__ */ jsx1107(
  "svg",
  __spreadProps(__spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1107(
      "path",
      {
        d: "M12 20.77c-.24 0-.462-.018-.693-.036l-.515.982a.498.498 0 0 1-.533.28.504.504 0 0 1-.408-.45l-.16-1.09c-.444-.127-.87-.298-1.297-.478l-.799.73c-.169.162-.382.189-.604.071-.195-.117-.275-.324-.23-.567l.221-1.072a8.25 8.25 0 0 1-1.065-.892l-.986.414c-.222.1-.427.045-.595-.153a.492.492 0 0 1-.045-.604l.578-.937a8.4 8.4 0 0 1-.684-1.216l-1.084.054a.492.492 0 0 1-.506-.333c-.062-.234 0-.45.178-.586l.852-.684a6.956 6.956 0 0 1-.23-1.388l-1.04-.333A.475.475 0 0 1 2 11.996c0-.244.124-.415.355-.496l1.04-.333a7.09 7.09 0 0 1 .23-1.379l-.852-.684a.513.513 0 0 1-.178-.577.492.492 0 0 1 .506-.333l1.084.036c.204-.433.426-.83.684-1.217l-.578-.936a.468.468 0 0 1 .045-.586c.168-.198.373-.243.595-.153l.986.405a9.06 9.06 0 0 1 1.065-.892L6.76 3.788c-.053-.252.036-.46.231-.567.222-.118.435-.1.604.072l.8.72a9.756 9.756 0 0 1 1.296-.477l.16-1.081a.504.504 0 0 1 .408-.45c.24-.028.435.071.533.27l.515.982a8.9 8.9 0 0 1 1.386 0l.506-.982c.098-.199.293-.298.533-.27a.523.523 0 0 1 .417.45l.151 1.08c.444.136.88.29 1.297.478l.8-.72c.168-.171.381-.199.603-.072.195.108.284.315.23.567l-.221 1.063a8.39 8.39 0 0 1 1.066.892l.985-.405a.497.497 0 0 1 .604.153.48.48 0 0 1 .036.586l-.577.936c.266.388.48.784.683 1.217l1.093-.036a.481.481 0 0 1 .497.333.513.513 0 0 1-.178.577l-.852.684c.115.45.204.901.249 1.388l1.02.324c.232.081.365.252.365.495a.482.482 0 0 1-.364.487l-1.021.333a8.52 8.52 0 0 1-.25 1.388l.854.684c.186.145.248.36.177.586a.481.481 0 0 1-.497.333l-1.093-.054c-.204.433-.417.847-.683 1.216l.577.938c.124.207.115.432-.036.603-.168.198-.382.252-.604.153l-.985-.414c-.329.333-.693.63-1.066.892l.222 1.072c.044.243-.036.45-.231.567-.222.117-.435.09-.604-.072l-.8-.73c-.417.18-.852.352-1.296.478l-.15 1.09a.514.514 0 0 1-.41.45c-.248.028-.434-.071-.541-.279l-.506-.982c-.24.018-.462.036-.693.036Zm-.018-11.117a2.33 2.33 0 0 1 2.247 1.757h4.956C18.9 7.572 15.872 4.59 12 4.59c-1.155 0-2.238.27-3.197.748l2.54 4.405c.204-.063.417-.09.64-.09ZM4.79 12.004c0 2.478 1.145 4.658 2.948 6l2.602-4.315a2.365 2.365 0 0 1-.684-1.675c0-.658.258-1.253.684-1.676L7.8 5.94c-1.838 1.343-3.01 3.55-3.01 6.064Zm7.193 1.1c.604 0 1.066-.478 1.066-1.09 0-.613-.462-1.09-1.066-1.09-.613 0-1.074.477-1.074 1.09 0 .612.461 1.09 1.074 1.09ZM12 19.41c3.881 0 6.918-3 7.194-6.838h-4.956c-.249 1.036-1.163 1.802-2.256 1.802-.222 0-.435-.036-.63-.09l-2.62 4.342A7.094 7.094 0 0 0 12 19.41Z",
        fill: "currentColor"
      }
    )
  })
);
var SettingsGear_default = SvgSettingsGear;

// src/Icon/icons/SfAppleTv.tsx
import { jsx as jsx1108 } from "react/jsx-runtime";
var SvgSfAppleTv = (props) => /* @__PURE__ */ jsx1108(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1108(
      "path",
      {
        d: "M7.66 9.87c.78.083 1.392-.778 1.339-1.465-.782.031-1.362.725-1.339 1.464Zm2.666 3.343c-.37-.169-.614-.411-.747-.76a1.517 1.517 0 0 1 0-1.09c.07-.22.214-.492.59-.714-.28-.416-.725-.628-1.244-.628-.589 0-.932.308-1.227.308-.25 0-.53-.298-1.007-.298-.51 0-.93.21-1.2.562-.325.404-.462.898-.462 1.408 0 .84.368 1.825.92 2.444.298.32.52.485.781.485.398 0 .609-.288 1.083-.288.211 0 .384.087.51.123.194.064.33.154.55.154a.837.837 0 0 0 .563-.213 3.57 3.57 0 0 0 .89-1.493Zm2.642-4.333h-1.002v1.14h-.694v.774h.694v2.803c0 .972.388 1.322 1.374 1.322.216 0 .455-.028.539-.038v-.82c-.046.028-.218.028-.323.028-.401 0-.588-.164-.588-.608v-2.687h.934v-.773h-.934V8.88Zm4.21 6 1.757-4.86h-1.09l-1.184 3.905-1.252-3.904h-1.062l1.785 4.86h1.046Zm-9.742 7.087h9.12c1.804 0 3.22-.198 4.238-1.216C21.814 19.733 22 18.33 22 16.523V7.469c0-1.809-.186-3.205-1.206-4.222-1.02-1.018-2.434-1.214-4.238-1.214H7.42c-1.779 0-3.195.196-4.215 1.214C2.186 4.267 2 5.668 2 7.453v9.07c0 1.807.186 3.212 1.204 4.228 1.022 1.018 2.436 1.216 4.232 1.216Zm-.27-1.944c-1.028 0-1.99-.142-2.545-.697-.547-.548-.68-1.496-.68-2.526V7.224c0-1.056.133-2.004.68-2.56.556-.547 1.526-.689 2.57-.689h9.643c1.028 0 1.987.142 2.537.697.555.548.687 1.496.687 2.528v9.6c0 1.03-.132 1.978-.687 2.526-.55.555-1.51.697-2.537.697H7.166Z",
        fill: "currentColor"
      }
    )
  })
);
var SfAppleTv_default = SvgSfAppleTv;

// src/Icon/icons/SfAppleVisionPro.tsx
import { jsx as jsx1109, jsxs as jsxs12 } from "react/jsx-runtime";
var SvgSfAppleVisionPro = (props) => /* @__PURE__ */ jsxs12(
  "svg",
  __spreadProps(__spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx1109(
        "path",
        {
          d: "M22.7165 11.9579C22.7165 15.3283 20.587 17.8945 17.7604 17.8945C14.8495 17.8945 13.3252 15.4279 11.8621 15.4279C10.3914 15.4279 8.86697 17.8945 5.95611 17.8945C3.12951 17.8945 0.999988 15.3283 0.999988 11.9579C0.999988 6.44254 5.86419 5.82206 11.8621 5.82206C17.8524 5.82206 22.7165 6.43488 22.7165 11.9579ZM2.23328 11.9579C2.23328 14.8687 3.69636 16.6612 5.95611 16.6612C8.63717 16.6612 9.64832 14.1946 11.8621 14.1946C14.0683 14.1946 15.0793 16.6612 17.7604 16.6612C20.0201 16.6612 21.4833 14.8687 21.4833 11.9579C21.4833 7.5073 17.7221 7.05535 11.8621 7.05535C5.99441 7.05535 2.23328 7.51496 2.23328 11.9579Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx1109(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M22.9165 11.9579C22.9165 15.4031 20.7301 18.0945 17.7604 18.0945C16.2445 18.0945 15.0946 17.4505 14.1576 16.8278C13.993 16.7183 13.8371 16.6111 13.6875 16.5083C13.4046 16.3138 13.1444 16.1348 12.8904 15.9858C12.5051 15.7597 12.1734 15.6279 11.8621 15.6279C11.5487 15.6279 11.2155 15.7599 10.8292 15.9859C10.5736 16.1355 10.3117 16.3153 10.0271 16.5107C9.87829 16.6128 9.72332 16.7192 9.55978 16.8278C8.62192 17.4505 7.47204 18.0945 5.95611 18.0945C2.98646 18.0945 0.799988 15.4031 0.799988 11.9579C0.799988 10.5492 1.11087 9.43571 1.68676 8.56227C2.26274 7.68871 3.09288 7.07187 4.10288 6.63795C6.11149 5.77503 8.86672 5.62206 11.8621 5.62206C14.8536 5.62206 17.6069 5.7731 19.6146 6.63506C20.6241 7.06851 21.454 7.68513 22.0299 8.55909C22.6057 9.4329 22.9165 10.5474 22.9165 11.9579ZM3.40359 15.2763C4.01211 16.0386 4.88417 16.4612 5.95611 16.4612C7.22802 16.4612 8.10548 15.8804 8.96821 15.2651C9.01336 15.2329 9.05855 15.2005 9.10381 15.1681C9.91126 14.5897 10.742 13.9946 11.8621 13.9946C12.9777 13.9946 13.8062 14.5888 14.6118 15.1666C14.6577 15.1995 14.7036 15.2324 14.7494 15.2651C15.6111 15.8804 16.4885 16.4612 17.7604 16.4612C18.8323 16.4612 19.7044 16.0386 20.3129 15.2763C20.9252 14.5094 21.2833 13.382 21.2833 11.9579C21.2833 10.8733 21.0543 10.0521 20.6375 9.42497C20.221 8.79848 19.6046 8.34692 18.7959 8.02333C17.1648 7.37071 14.799 7.25535 11.8621 7.25535C8.92154 7.25535 6.55372 7.37261 4.92166 8.02618C4.11239 8.35026 3.49571 8.80209 3.07916 9.42827C2.66221 10.055 2.43328 10.8753 2.43328 11.9579C2.43328 13.382 2.7913 14.5094 3.40359 15.2763ZM17.7604 17.8945C20.587 17.8945 22.7165 15.3283 22.7165 11.9579C22.7165 6.43488 17.8524 5.82206 11.8621 5.82206C5.86419 5.82206 0.999988 6.44254 0.999988 11.9579C0.999988 15.3283 3.12951 17.8945 5.95611 17.8945C7.65756 17.8945 8.88531 17.0517 9.90553 16.3515C10.6307 15.8537 11.2511 15.4279 11.8621 15.4279C12.4691 15.4279 13.0866 15.8524 13.8092 16.3492C14.8285 17.0499 16.0571 17.8945 17.7604 17.8945ZM5.95611 16.6612C3.69636 16.6612 2.23328 14.8687 2.23328 11.9579C2.23328 7.51496 5.99441 7.05535 11.8621 7.05535C17.7221 7.05535 21.4833 7.5073 21.4833 11.9579C21.4833 14.8687 20.0201 16.6612 17.7604 16.6612C16.3546 16.6612 15.4079 15.983 14.5074 15.3379C13.6904 14.7526 12.9115 14.1946 11.8621 14.1946C10.8082 14.1946 10.0268 14.7537 9.20806 15.3395C8.30705 15.9842 7.36077 16.6612 5.95611 16.6612Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
var SfAppleVisionPro_default = SvgSfAppleVisionPro;

// src/Icon/icons/SfDesktopComputer.tsx
import { jsx as jsx1110 } from "react/jsx-runtime";
var SvgSfDesktopComputer = (props) => /* @__PURE__ */ jsx1110(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1110(
      "path",
      {
        d: "M4.054 17.53h15.885c1.288 0 2.061-.772 2.061-2.06V5.543c0-1.286-.773-2.052-2.06-2.052H4.053C2.774 3.49 2 4.257 2 5.543v9.927c0 1.288.773 2.06 2.054 2.06Zm-.128-3.814c-.24 0-.346-.09-.346-.345V5.64c0-.358.22-.572.57-.572h15.7c.35 0 .57.214.57.571v7.73c0 .257-.114.346-.352.346H3.926Zm5.387 5.699h5.374v-2.052H9.313v2.052Zm-.04 1.094h5.454a.747.747 0 0 0 0-1.494H9.273a.753.753 0 0 0-.75.747c0 .408.34.747.75.747Z",
        fill: "currentColor"
      }
    )
  })
);
var SfDesktopComputer_default = SvgSfDesktopComputer;

// src/Icon/icons/SfIpadLandscape.tsx
import { jsx as jsx1111 } from "react/jsx-runtime";
var SvgSfIpadLandscape = (props) => /* @__PURE__ */ jsx1111(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1111(
      "path",
      {
        d: "M4.753 19.823H19.25c1.816 0 2.75-.935 2.75-2.725V6.899c0-1.79-.934-2.722-2.75-2.722H4.75C2.94 4.177 2 5.102 2 6.9v10.199c0 1.797.942 2.725 2.753 2.725Zm.095-1.643c-.781 0-1.204-.403-1.204-1.217V7.036c0-.815.421-1.217 1.2-1.217h14.311c.773 0 1.203.402 1.203 1.217v9.927c0 .814-.43 1.217-1.203 1.217H4.848Zm3.909-.668h6.494c.239 0 .41-.16.41-.41 0-.249-.171-.417-.41-.417H8.757a.4.4 0 0 0-.415.418c0 .25.177.41.415.41Z",
        fill: "currentColor"
      }
    )
  })
);
var SfIpadLandscape_default = SvgSfIpadLandscape;

// src/Icon/icons/SfIpadPortrait.tsx
import { jsx as jsx1112 } from "react/jsx-runtime";
var SvgSfIpadPortrait = (props) => /* @__PURE__ */ jsx1112(
  "svg",
  __spreadProps(__spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx1112(
      "path",
      {
        d: "M4 20.4238C4 21.9668 5.08398 23.002 6.70508 23.002H17.6133C19.2344 23.002 20.3184 21.9668 20.3184 20.4238V3.58789C20.3184 2.04492 19.2344 1 17.6133 1H6.70508C5.08398 1 4 2.04492 4 3.58789V20.4238ZM5.57227 20.1602V3.85156C5.57227 3.05078 6.06055 2.57227 6.90039 2.57227H17.418C18.248 2.57227 18.7461 3.05078 18.7461 3.85156V20.1602C18.7461 20.9609 18.248 21.4297 17.418 21.4297H6.90039C6.06055 21.4297 5.57227 20.9609 5.57227 20.1602ZM9.39062 20.6875H14.9277C15.2012 20.6875 15.3867 20.502 15.3867 20.2285C15.3867 19.9551 15.2012 19.7793 14.9277 19.7793H9.39062C9.12695 19.7793 8.94141 19.9551 8.94141 20.2285C8.94141 20.502 9.12695 20.6875 9.39062 20.6875Z",
        fill: "#35414E"
      }
    )
  })
);
var SfIpadPortrait_default = SvgSfIpadPortrait;

// src/Icon/icons/SfIphone.tsx
import { jsx as jsx1113 } from "react/jsx-runtime";
var SvgSfIphone = (props) => /* @__PURE__ */ jsx1113(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1113(
      "path",
      {
        d: "M8.431 21.988h7.177c1.551 0 2.588-1.01 2.588-2.52V4.532c0-1.512-1.037-2.52-2.588-2.52H8.431c-1.574 0-2.627 1.008-2.627 2.518v14.94c0 1.509 1.053 2.518 2.627 2.518Zm.307-1.84c-.73 0-1.144-.393-1.144-1.09V4.942c0-.696.414-1.09 1.144-1.09h6.533c.721 0 1.136.397 1.136 1.091v14.114c0 .694-.415 1.09-1.136 1.09H8.738Zm1.298-.712h3.943c.266 0 .454-.185.454-.462 0-.279-.188-.458-.454-.458h-3.943c-.266 0-.463.18-.463.458 0 .277.197.462.463.462Zm.82-13.444h2.296a.69.69 0 0 0 .696-.705.69.69 0 0 0-.696-.698h-2.296a.692.692 0 0 0-.704.698c0 .4.304.705.704.705Z",
        fill: "currentColor"
      }
    )
  })
);
var SfIphone_default = SvgSfIphone;

// src/Icon/icons/SfKey.tsx
import { jsx as jsx1114 } from "react/jsx-runtime";
var SvgSfKey = (props) => /* @__PURE__ */ jsx1114(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1114(
      "path",
      {
        d: "M11.453 21.828c.328.274.774.313 1.086.008l2.414-2.414a.766.766 0 0 0-.008-1.086l-1.21-1.203 1.765-1.758c.305-.297.29-.773-.008-1.086l-1.633-1.64c2.149-1.032 3.36-2.782 3.36-4.86A5.211 5.211 0 0 0 12 2.58a5.193 5.193 0 0 0-5.227 5.21c0 2.094 1.204 3.953 3.102 4.79v7.374c0 .258.078.555.305.758l1.273 1.117ZM12 20.594l-.867-.86v-8.062a3.949 3.949 0 0 1-3.11-3.883A3.958 3.958 0 0 1 12 3.836a3.95 3.95 0 0 1 3.96 3.953c0 1.867-1.28 3.469-3.241 3.938v1.578l1.531 1.539-1.656 1.633v1.296l1.11 1.094L12 20.594Zm0-12.735c.781 0 1.414-.632 1.414-1.421 0-.782-.633-1.415-1.414-1.415-.797 0-1.422.625-1.422 1.415 0 .789.633 1.421 1.422 1.421Z",
        fill: "currentColor"
      }
    )
  })
);
var SfKey_default = SvgSfKey;

// src/Icon/icons/SfLaptopComputer.tsx
import { jsx as jsx1115 } from "react/jsx-runtime";
var SvgSfLaptopComputer = (props) => /* @__PURE__ */ jsx1115(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1115(
      "path",
      {
        d: "M2 16.813c0 .477.39.866.86.866h18.278c.471 0 .862-.39.862-.866a.867.867 0 0 0-.862-.865H19.7v-8.01c0-1.056-.578-1.617-1.627-1.617H5.928c-1.01 0-1.629.561-1.629 1.616v8.011H2.861c-.47 0-.861.388-.861.865Zm3.63-.865V8.286c0-.428.212-.634.634-.634h11.472c.421 0 .633.206.633.634v7.662H5.63Z",
        fill: "currentColor"
      }
    )
  })
);
var SfLaptopComputer_default = SvgSfLaptopComputer;

// src/Icon/icons/SfLaptopComputerAndIphone.tsx
import { jsx as jsx1116, jsxs as jsxs13 } from "react/jsx-runtime";
var SvgSfLaptopComputerAndIphone = (props) => /* @__PURE__ */ jsxs13(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsx1116(
        "rect",
        {
          x: "0.0253906",
          y: "0.693359",
          width: "14",
          height: "14",
          rx: "2",
          fill: "#A1ADC4"
        }
      ),
      /* @__PURE__ */ jsx1116("g", { "clip-path": "url(#clip0_996_3193)", children: /* @__PURE__ */ jsx1116(
        "path",
        {
          d: "M1.88475 9.97713H8.19355C8.08822 9.79928 8.03316 9.59603 8.02838 9.36737C8.02838 9.32418 8.02718 9.28099 8.02479 9.2378C8.02479 9.19461 8.02479 9.15142 8.02479 9.10823H1.88475C1.77224 9.10823 1.67649 9.15142 1.5975 9.2378C1.5185 9.32164 1.479 9.42327 1.479 9.54268C1.479 9.66209 1.5185 9.76371 1.5975 9.84756C1.67649 9.93394 1.77224 9.97713 1.88475 9.97713ZM2.6711 9.39405H3.2492V4.75609C3.2492 4.63414 3.27793 4.54268 3.33538 4.4817C3.39283 4.42073 3.479 4.39024 3.59391 4.39024H10.6065C10.5921 4.18699 10.5287 4.03455 10.4162 3.93292C10.3037 3.82876 10.1481 3.77667 9.94938 3.77667H3.43951C3.20252 3.77667 3.01461 3.84527 2.87577 3.98247C2.73933 4.11712 2.6711 4.31783 2.6711 4.5846V9.39405ZM9.14148 10.0267H10.7788C11.0014 10.0267 11.1738 9.96443 11.2959 9.83993C11.418 9.71544 11.479 9.54014 11.479 9.31402V5.51829C11.479 5.29217 11.4168 5.11687 11.2923 4.99237C11.1702 4.86534 10.9991 4.80182 10.7788 4.80182H9.14148C8.91886 4.80182 8.74651 4.86534 8.62443 4.99237C8.50234 5.11687 8.4413 5.29217 8.4413 5.51829V9.31402C8.4413 9.54014 8.50234 9.71544 8.62443 9.83993C8.74651 9.96443 8.91886 10.0267 9.14148 10.0267ZM9.14866 9.52743C9.06967 9.52743 9.00982 9.50584 8.96913 9.46265C8.93083 9.41692 8.91168 9.35086 8.91168 9.26448V5.56783C8.91168 5.48145 8.93083 5.41539 8.96913 5.36966C9.00982 5.32393 9.06967 5.30106 9.14866 5.30106H9.29229C9.30665 5.30106 9.31383 5.30868 9.31383 5.32393V5.35823C9.31383 5.42428 9.33298 5.47764 9.37128 5.51829C9.40958 5.55894 9.45985 5.57926 9.52209 5.57926H10.3982C10.4605 5.57926 10.5107 5.55894 10.549 5.51829C10.5873 5.47764 10.6065 5.42428 10.6065 5.35823V5.32393C10.6065 5.30868 10.6137 5.30106 10.628 5.30106H10.7681C10.847 5.30106 10.9069 5.32393 10.9476 5.36966C10.9883 5.41539 11.0086 5.48145 11.0086 5.56783V9.26448C11.0086 9.35086 10.9883 9.41692 10.9476 9.46265C10.9069 9.50584 10.847 9.52743 10.7681 9.52743H9.14866ZM9.46823 9.33307H10.4449C10.5287 9.33307 10.5706 9.28861 10.5706 9.19969C10.5706 9.16158 10.5586 9.13109 10.5347 9.10823C10.5107 9.08282 10.4808 9.07012 10.4449 9.07012H9.46823C9.43233 9.07012 9.4036 9.08282 9.38206 9.10823C9.36051 9.13109 9.34974 9.16158 9.34974 9.19969C9.34974 9.28861 9.38924 9.33307 9.46823 9.33307Z",
          fill: "white"
        }
      ) }),
      /* @__PURE__ */ jsx1116("circle", { cx: "8.83521", cy: "9.04956", r: "3.3562", fill: "#A1ADC4" }),
      /* @__PURE__ */ jsx1116("g", { "clip-path": "url(#clip1_996_3193)", children: /* @__PURE__ */ jsx1116(
        "path",
        {
          d: "M12.7103 12.4929L10.9655 10.7481C11.3431 10.2858 11.5514 9.7038 11.5514 9.06838C11.5514 7.57229 10.3388 6.36005 8.8431 6.36005C7.3474 6.36005 6.14648 7.57268 6.14648 9.06838C6.14648 10.5641 7.35899 11.7767 8.8431 11.7767C9.47839 11.7767 10.0612 11.5565 10.5228 11.1903L12.2676 12.935C12.3405 12.9968 12.4212 13.0267 12.5007 13.0267C12.5801 13.0267 12.6606 12.9962 12.7216 12.9352C12.8431 12.8132 12.8431 12.6153 12.7103 12.4929ZM6.77149 9.06838C6.77149 7.91968 7.70612 6.98505 8.85482 6.98505C10.0035 6.98505 10.9382 7.91968 10.9382 9.06838C10.9382 10.2171 10.0035 11.1517 8.85482 11.1517C7.70612 11.1517 6.77149 10.2168 6.77149 9.06838Z",
          fill: "white"
        }
      ) }),
      /* @__PURE__ */ jsxs13("defs", { children: [
        /* @__PURE__ */ jsx1116("clipPath", { id: "clip0_996_3193", children: /* @__PURE__ */ jsx1116(
          "rect",
          {
            width: "10",
            height: "10",
            fill: "white",
            transform: "translate(1.479 1.69336)"
          }
        ) }),
        /* @__PURE__ */ jsx1116("clipPath", { id: "clip1_996_3193", children: /* @__PURE__ */ jsx1116("rect", { x: "5.479", y: "5.69336", width: "8", height: "8", rx: "4", fill: "white" }) })
      ] })
    ]
  })
);
var SfLaptopComputerAndIphone_default = SvgSfLaptopComputerAndIphone;

// src/Icon/icons/SfStartupSettings.tsx
import { jsx as jsx1117 } from "react/jsx-runtime";
var SvgSfStartupSettings = (props) => /* @__PURE__ */ jsx1117(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1117(
      "path",
      {
        d: "M12 20.328c4.36 0 7.969-3.617 7.969-7.969 0-4.359-3.617-7.968-7.977-7.968-4.351 0-7.96 3.609-7.96 7.968 0 4.352 3.616 7.97 7.968 7.97ZM12 19a6.609 6.609 0 0 1-6.633-6.64 6.602 6.602 0 0 1 6.625-6.641 6.627 6.627 0 0 1 6.649 6.64A6.61 6.61 0 0 1 12 19Zm-5.055-5.156c-.36.46.11.875.555.64l2.586-1.398 3.398 1.82a.878.878 0 0 0 .422.133c.18 0 .344-.094.508-.289l2.64-3.414c.329-.43-.085-.875-.554-.625l-2.602 1.398-3.39-1.828c-.156-.078-.297-.133-.43-.133-.18 0-.344.094-.5.297l-2.633 3.399Z",
        fill: "currentColor"
      }
    )
  })
);
var SfStartupSettings_default = SvgSfStartupSettings;

// src/Icon/icons/SfTv.tsx
import { jsx as jsx1118 } from "react/jsx-runtime";
var SvgSfTv = (props) => /* @__PURE__ */ jsx1118(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1118(
      "path",
      {
        d: "M4.168 17.592h15.664c1.412 0 2.168-.75 2.168-2.168V6.36c0-1.412-.756-2.162-2.168-2.162H4.168C2.756 4.199 2 4.949 2 6.36v9.064c0 1.419.756 2.168 2.168 2.168Zm.089-1.504c-.502 0-.753-.245-.753-.747V6.45c0-.508.251-.747.753-.747h15.485c.502 0 .753.24.753.747v8.892c0 .502-.251.747-.753.747H4.257Zm3.72 4.255h8.045a.718.718 0 0 0 .715-.712.72.72 0 0 0-.715-.714H7.976a.72.72 0 0 0-.713.714c0 .389.324.712.713.712Z",
        fill: "currentColor"
      }
    )
  })
);
var SfTv_default = SvgSfTv;

// src/Icon/icons/ShareAll.tsx
import { jsx as jsx1119 } from "react/jsx-runtime";
var SvgShareAll = (props) => /* @__PURE__ */ jsx1119(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1119(
      "path",
      {
        d: "M15.193 5.446a.862.862 0 0 1 1.184-1.25l5.087 4.833c.715.678.715 1.82 0 2.498l-5.087 4.832a.862.862 0 0 1-1.184-1.249l5.087-4.832-5.087-4.832Zm-5.152 5.98h.862a.86.86 0 0 1 .861.863V14.159l4.312-3.88-4.312-3.881v1.87a.86.86 0 0 1-.861.861H8.318a4.595 4.595 0 0 0-4.595 4.595c0 .55.068 1.045.187 1.49a5.172 5.172 0 0 1 4.983-3.787h1.148Zm0 3.447V13.15H8.893a3.447 3.447 0 0 0-3.446 3.446c0 .621.15 1.095.34 1.443a2.206 2.206 0 0 0 .456.592c.018.019.036.033.05.051.173.176.298.406.298.65a.706.706 0 0 1-.707.707.63.63 0 0 1-.29-.068 6.757 6.757 0 0 1-.707-.456 7.08 7.08 0 0 1-.42-.334C3.385 18.255 2 16.524 2 13.724a6.318 6.318 0 0 1 6.318-6.318h1.723V5.11c0-.453.266-.865.682-1.048a1.153 1.153 0 0 1 1.235.193l5.744 5.17c.24.219.38.527.38.854 0 .327-.136.636-.38.854l-5.744 5.17a1.14 1.14 0 0 1-1.235.194 1.154 1.154 0 0 1-.682-1.048v-.575Z",
        fill: "currentColor"
      }
    )
  })
);
var ShareAll_default = SvgShareAll;

// src/Icon/icons/ShareFromSquare.tsx
import { jsx as jsx1120 } from "react/jsx-runtime";
var SvgShareFromSquare = (props) => /* @__PURE__ */ jsx1120(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1120(
      "path",
      {
        d: "M16.286 11.979v-1.693a.573.573 0 0 0-.572-.572H12.34a4.053 4.053 0 0 0-3.869 2.843 3.367 3.367 0 0 1-.185-1.128c0-2.211 1.789-4 4-4h3.428a.573.573 0 0 0 .572-.572V5.164l3.785 3.407-3.785 3.408ZM14 11.429h.571v1.714c0 .632.511 1.143 1.143 1.143h.132c.283 0 .554-.104.765-.293l4.964-4.468c.271-.243.425-.59.425-.954s-.154-.71-.425-.953l-4.936-4.443a1.238 1.238 0 0 0-2.068.921v1.618h-2.285A5.713 5.713 0 0 0 6.57 11.43c0 2.157 1.236 3.539 2.283 4.317a6.951 6.951 0 0 0 1.314.775c.078.036.164.05.253.05h.09c.35 0 .635-.285.635-.635 0-.279-.189-.525-.414-.697l-.04-.028c-.06-.04-.12-.09-.178-.147-.028-.028-.06-.057-.089-.093l-.086-.103a1.89 1.89 0 0 1-.178-.304 1.982 1.982 0 0 1-.154-.8 2.34 2.34 0 0 1 2.34-2.339H14v.004ZM4.571 4A2.57 2.57 0 0 0 2 6.571v12a2.57 2.57 0 0 0 2.571 2.572h12a2.57 2.57 0 0 0 2.572-2.572v-2.285a.855.855 0 0 0-.857-.857.855.855 0 0 0-.857.857v2.285a.855.855 0 0 1-.858.858h-12a.855.855 0 0 1-.857-.858v-12c0-.475.382-.857.857-.857h2.286a.855.855 0 0 0 .857-.857A.855.855 0 0 0 6.857 4H4.571Z",
        fill: "currentColor"
      }
    )
  })
);
var ShareFromSquare_default = SvgShareFromSquare;

// src/Icon/icons/ShareNodes.tsx
import { jsx as jsx1121 } from "react/jsx-runtime";
var SvgShareNodes = (props) => /* @__PURE__ */ jsx1121(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1121(
      "path",
      {
        d: "M22 6.286a4.287 4.287 0 0 1-7.518 2.812l-4.004 2.005c.062.29.053.589.053.857 0 .348.01.647-.053.937l4.004 1.965c.786-.862 1.942-1.474 3.232-1.474 2.366 0 4.286 1.92 4.286 4.326A4.287 4.287 0 0 1 17.714 22a4.261 4.261 0 0 1-4.285-4.286c0-.308.03-.607.093-.897l-4.004-2.005a4.276 4.276 0 0 1-3.232 1.474C3.919 16.286 2 14.366 2 11.96a4.286 4.286 0 0 1 4.286-4.286c1.29 0 2.446.612 3.232 1.473l4.004-1.964a4.25 4.25 0 0 1-.093-.897A4.26 4.26 0 0 1 17.714 2 4.286 4.286 0 0 1 22 6.286ZM6.246 14.143c1.223 0 2.142-.96 2.142-2.143 0-1.183-.92-2.143-2.142-2.143-1.144 0-2.143.96-2.143 2.143 0 1.183 1 2.143 2.143 2.143Zm11.468-10a2.143 2.143 0 1 0 .001 4.287 2.143 2.143 0 0 0 0-4.287Zm0 15.714a2.143 2.143 0 1 0 0-4.287 2.143 2.143 0 0 0 0 4.287Z",
        fill: "currentColor"
      }
    )
  })
);
var ShareNodes_default = SvgShareNodes;

// src/Icon/icons/Share.tsx
import { jsx as jsx1122 } from "react/jsx-runtime";
var SvgShare = (props) => /* @__PURE__ */ jsx1122(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1122(
      "path",
      {
        d: "M13.25 11.375H9.5a5.628 5.628 0 0 0-5.422 4.121 6.281 6.281 0 0 1-.203-1.62 5 5 0 0 1 5-5h5.313c.519 0 .937-.419.937-.938V5.903l4.691 4.222-4.691 4.223v-2.035a.935.935 0 0 0-.938-.938h-.937Zm0 1.875v2.5c0 .493.29.942.742 1.141.453.2.977.117 1.344-.21l6.25-5.626c.262-.238.414-.574.414-.93 0-.355-.148-.691-.414-.93l-6.25-5.624a1.24 1.24 0 0 0-1.344-.211c-.449.203-.742.648-.742 1.14V7H8.875A6.875 6.875 0 0 0 2 13.875c0 3.047 1.508 4.93 2.684 5.942.16.136.316.258.457.363.125.094.242.172.347.242.176.117.324.2.422.254a.64.64 0 0 0 .317.074c.425 0 .77-.347.77-.77 0-.265-.142-.515-.325-.706l-.055-.055c-.094-.09-.199-.2-.3-.336a2.8 2.8 0 0 1-.196-.308c-.207-.38-.371-.895-.371-1.57 0-2.071 1.68-3.75 3.75-3.75h3.75v-.005Z",
        fill: "currentColor"
      }
    )
  })
);
var Share_default = SvgShare;

// src/Icon/icons/Sharing.tsx
import { jsx as jsx1123 } from "react/jsx-runtime";
var SvgSharing = (props) => /* @__PURE__ */ jsx1123(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1123(
      "path",
      {
        d: "M3.89 13.756c-1.175-1.175-1.19-2.334-.024-3.5l6.397-6.39c1.167-1.167 2.326-1.15 3.5.024l6.35 6.35c1.175 1.174 1.183 2.34.024 3.5l-6.39 6.397c-1.166 1.159-2.325 1.15-3.5-.024L3.89 13.756Zm.92-.881 6.318 6.325c.556.556 1.167.572 1.755-.016l6.301-6.302c.588-.587.572-1.19.008-1.754l-6.317-6.317c-.572-.572-1.167-.58-1.755.008L4.82 11.12c-.588.588-.572 1.183-.008 1.755Zm7.612-4.302a1.026 1.026 0 0 1-1.024-1.024c0-.58.453-1.032 1.024-1.032a1.03 1.03 0 0 1 1.032 1.032c0 .555-.468 1.024-1.032 1.024Zm1.453 8.27a.516.516 0 0 1-.492-.325l-1.008-2.056c-.048-.087-.064-.127-.151-.23l-.913-1.151c-.262-.325-.524-.707-.476-1.238l.071-.969c.016-.174-.127-.238-.246-.135l-.397.342-.087 1.143c-.032.341-.23.5-.5.484-.286-.024-.468-.23-.444-.548l.095-1.063c.024-.302.095-.492.341-.73l.73-.707c.476-.468.929-.714 1.421-.714.754 0 1.143.555 1.095 1.238l-.087 1.27c-.032.476-.111.793-.278 1.278l-.047.135.555.801c.08.111.183.246.278.445l.936 1.913c.064.127.096.23.096.349 0 .301-.246.468-.492.468Zm.261-5.111c-.27 0-.412-.04-.57-.207l-.326-.325.087-1.238.738.825h1.199c.333 0 .523.19.523.468 0 .294-.19.477-.523.477h-1.127Zm-4.58 5.111c-.261 0-.451-.175-.451-.46 0-.19.103-.318.206-.445l1.341-1.587.238-1.12.794 1-.08.342c-.039.175-.055.183-.214.373l-1.452 1.73a.488.488 0 0 1-.381.167Z",
        fill: "currentColor"
      }
    )
  })
);
var Sharing_default = SvgSharing;

// src/Icon/icons/ShieldArrows.tsx
import { jsx as jsx1124 } from "react/jsx-runtime";
var SvgShieldArrows = (props) => /* @__PURE__ */ jsx1124(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1124(
      "path",
      {
        d: "M12 20.46c-.125 0-.32-.046-.523-.155-4.438-2.5-5.97-3.547-5.97-6.399V7.93c0-.82.36-1.086 1.016-1.36.922-.375 3.907-1.508 4.829-1.773.203-.055.43-.117.648-.117.219 0 .445.047.656.117.922.32 3.899 1.39 4.82 1.773.665.282 1.016.54 1.016 1.36v5.976c0 2.852-1.523 3.906-5.969 6.399-.195.11-.398.156-.523.156Zm0-1.413c.125 0 .258-.047.484-.188 3.61-2.195 4.766-2.828 4.766-5.242V8.172c0-.266-.047-.375-.258-.453-1.21-.414-3.5-1.242-4.68-1.711a.916.916 0 0 0-.312-.07.762.762 0 0 0-.313.07c-1.18.469-3.484 1.242-4.671 1.71-.22.087-.266.188-.266.454v5.445c0 2.414 1.156 3.055 4.766 5.242.234.141.359.188.484.188Zm.727-10.14c0-.337.328-.438.578-.266l1.93 1.304c.234.164.242.461.023.61l-1.945 1.312c-.258.172-.586.063-.586-.281v-.828H8.898a.514.514 0 0 1-.515-.508.52.52 0 0 1 .515-.516h3.829v-.828Zm-4.18 5.64c-.219-.156-.219-.453.015-.617l1.938-1.305c.242-.164.578-.063.578.266v.836h3.828c.281 0 .508.234.508.515a.507.507 0 0 1-.508.508h-3.828v.828c0 .336-.336.445-.586.281l-1.945-1.312Z",
        fill: "currentColor"
      }
    )
  })
);
var ShieldArrows_default = SvgShieldArrows;

// src/Icon/icons/ShieldCheck.tsx
import { jsx as jsx1125 } from "react/jsx-runtime";
var SvgShieldCheck = (props) => /* @__PURE__ */ jsx1125(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1125(
      "path",
      {
        d: "m20.223 5.27-7.5-3.125a1.839 1.839 0 0 0-.72-.145c-.246 0-.491.047-.722.144l-7.5 3.126c-.698.288-1.156.972-1.156 1.695C2.625 17.055 10.023 22 11.996 22c1.926 0 9.38-4.871 9.38-15.035 0-.723-.458-1.407-1.153-1.695ZM12 20.125C8.191 18.539 4.5 13.613 4.5 7L12 3.875 19.5 7c0 6.789-3.844 11.602-7.5 13.125Zm-2.184-8.477a.839.839 0 0 0-.629-.308.938.938 0 0 0-.937.937c0 .274.09.516.273.664l1.875 1.875c.176.211.418.274.665.274.1 0 .447-.02.711-.327l3.75-4.376a.935.935 0 0 0 .226-.61c0-.289-.226-.937-.937-.937a.937.937 0 0 0-.712.327l-3.09 3.642-1.195-1.16Z",
        fill: "currentColor"
      }
    )
  })
);
var ShieldCheck_default = SvgShieldCheck;

// src/Icon/icons/ShieldExclamation.tsx
import { jsx as jsx1126 } from "react/jsx-runtime";
var SvgShieldExclamation = (props) => /* @__PURE__ */ jsx1126(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1126(
      "path",
      {
        d: "m20.223 5.27-7.5-3.126a2.26 2.26 0 0 0-.72-.144c-.206 0-.53.065-.722.144l-7.5 3.125a1.86 1.86 0 0 0-1.156 1.696c0 10.082 7.39 15.035 9.34 15.035 2.031 0 9.41-5.008 9.41-15.035 0-.723-.457-1.407-1.152-1.696Zm-8.22-1.394s.005 0 0 0Zm-.038 16.249c-3.578-1.504-7.463-6.254-7.463-13.121 0-.002 0 .002 0 0l7.454-3.111c.012-.004.029-.012.05-.016L19.5 6.965c0 7.945-4.906 12.078-7.535 13.16Zm-.902-12.188v4.375a.938.938 0 0 0 1.874 0V7.939a.938.938 0 0 0-1.874 0ZM12 14.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var ShieldExclamation_default = SvgShieldExclamation;

// src/Icon/icons/ShieldHalved.tsx
import { jsx as jsx1127 } from "react/jsx-runtime";
var SvgShieldHalved = (props) => /* @__PURE__ */ jsx1127(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1127(
      "path",
      {
        d: "M21.428 7.465c-.02 3.932-1.619 11.061-8.391 14.302-.652.31-1.418.31-2.074 0-6.769-3.24-8.372-10.37-8.39-14.302-.006-.994.64-1.846 1.504-2.212l7.4-3.138a1.248 1.248 0 0 1 1.05 0l7.396 3.138c.864.366 1.513 1.218 1.505 2.212ZM11.058 4.34 4.812 6.954c-.233.133-.356.338-.355.534.017 3.441 1.383 9.27 6.6 12.201V4.34Zm1.885 15.353c5.216-2.934 6.583-8.764 6.6-12.205.003-.196-.123-.4-.39-.534l-6.21-2.614v15.353Z",
        fill: "currentColor"
      }
    )
  })
);
var ShieldHalved_default = SvgShieldHalved;

// src/Icon/icons/ShieldKeyhole.tsx
import { jsx as jsx1128 } from "react/jsx-runtime";
var SvgShieldKeyhole = (props) => /* @__PURE__ */ jsx1128(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1128(
      "path",
      {
        d: "m20.223 5.27-7.5-3.126a2.26 2.26 0 0 0-.72-.144c-.206 0-.53.065-.722.144l-7.5 3.125a1.86 1.86 0 0 0-1.156 1.696c0 10.082 7.39 15.035 9.34 15.035 2.031 0 9.41-5.008 9.41-15.035 0-.723-.457-1.407-1.152-1.696Zm-8.22-1.394s.005 0 0 0Zm-.038 16.249c-3.578-1.504-7.463-6.254-7.463-13.121 0-.002 0 .002 0 0l7.454-3.111c.012-.004.029-.012.05-.016L19.5 6.965c0 7.945-4.906 12.078-7.535 13.16Zm-2.152-10c0 .871.512 1.617 1.25 1.97v2.717a.938.938 0 0 0 1.874 0v-2.718A2.182 2.182 0 0 0 12 7.937c-1.208 0-2.188.981-2.188 2.188Z",
        fill: "currentColor"
      }
    )
  })
);
var ShieldKeyhole_default = SvgShieldKeyhole;

// src/Icon/icons/ShieldLock.tsx
import { jsx as jsx1129 } from "react/jsx-runtime";
var SvgShieldLock = (props) => /* @__PURE__ */ jsx1129(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1129(
      "path",
      {
        d: "M12 21.446c-.154 0-.395-.057-.645-.192C5.887 18.174 4 16.884 4 13.369V6.005c0-1.011.443-1.338 1.252-1.675 1.135-.462 4.813-1.858 5.949-2.186.25-.067.53-.144.799-.144.27 0 .549.058.809.144 1.136.395 4.804 1.714 5.94 2.186.818.346 1.251.664 1.251 1.675v7.364c0 3.514-1.877 4.814-7.355 7.885a1.44 1.44 0 0 1-.645.192Zm0-1.742c.154 0 .318-.058.597-.231 4.447-2.705 5.872-3.485 5.872-6.46v-6.71c0-.327-.057-.462-.317-.558-1.493-.51-4.313-1.53-5.767-2.108A1.129 1.129 0 0 0 12 3.55a.94.94 0 0 0-.385.087c-1.454.577-4.294 1.53-5.757 2.108-.27.106-.327.23-.327.558v6.71c0 2.975 1.424 3.764 5.872 6.46.289.173.443.231.597.231Zm-3.475-4.65v-3.831c0-.674.279-1.011.847-1.05V9.037c0-1.771 1.059-2.955 2.628-2.955 1.57 0 2.628 1.184 2.628 2.955v1.136c.568.039.847.376.847 1.05v3.831c0 .722-.317 1.06-.982 1.06H9.507c-.665 0-.982-.338-.982-1.06Zm1.848-4.89h3.254V8.93c0-1.136-.655-1.877-1.627-1.877s-1.627.741-1.627 1.877v1.233Z",
        fill: "currentColor"
      }
    )
  })
);
var ShieldLock_default = SvgShieldLock;

// src/Icon/icons/ShieldMagnifyingGlassVirus.tsx
import { jsx as jsx1130, jsxs as jsxs14 } from "react/jsx-runtime";
var SvgShieldMagnifyingGlassVirus = (props) => /* @__PURE__ */ jsxs14(
  "svg",
  __spreadProps(__spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none"
  }, props), {
    children: [
      /* @__PURE__ */ jsx1130(
        "path",
        {
          d: "M17.7515 2.99592L28.3106 7.44113C29.5443 7.96035 30.4696 9.16684 30.4584 10.5748C30.4413 13.9506 29.5965 18.9901 26.7817 23.4589L24.7607 21.6134C27.0224 17.8193 27.7536 13.5837 27.7667 10.6082C27.7723 10.3299 27.5929 10.0405 27.2116 9.85134L17.0001 5.58242L6.74044 9.85134C6.40729 10.0405 6.23237 10.3299 6.23349 10.6082C6.25874 15.7002 8.38677 24.4817 16.6861 28.4273C16.8824 28.5219 17.1179 28.5219 17.3197 28.4273C19.1924 27.5371 20.7507 26.4006 22.0414 25.1158L24.0284 26.9301C22.5262 28.4414 20.6976 29.7841 18.4805 30.837C17.5496 31.2766 16.4562 31.2766 15.5196 30.837C5.85719 26.2459 3.56929 16.1454 3.54179 10.5748C3.53453 9.16684 4.45704 7.96035 5.68953 7.44113L16.2543 2.99592C16.4842 2.8899 16.7421 2.83335 17.0001 2.83337C17.2637 2.83335 17.516 2.8899 17.7515 2.99592Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx1130(
        "path",
        {
          d: "M16.013 14.7137L15.1325 15.8192L13.605 14.6025L14.1634 11.9006L15.5475 12.1866L15.1649 14.0381L16.013 14.7137Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx1130(
        "path",
        {
          d: "M17.0436 17.5234C17.6386 17.5234 18.21 17.0415 18.21 16.4466C18.21 15.8516 17.6386 14.954 17.0436 14.954C16.4486 14.954 15.878 15.8516 15.878 16.4466C15.878 17.0415 16.4486 17.5234 17.0436 17.5234Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx1130(
        "path",
        {
          d: "M15.1324 16.8802L16.0131 17.9857L15.3115 18.5445L16.3423 20.2452L15.1336 20.9777L13.4585 18.2138L15.1324 16.8802Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx1130(
        "path",
        {
          d: "M20.6268 18.2138L18.9528 16.8802L18.0721 17.9857L18.7737 18.5445L17.743 20.2452L18.9517 20.9777L20.6268 18.2138Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx1130(
        "path",
        {
          d: "M18.9527 15.8192L20.4802 14.6025L19.9218 11.9006L18.5378 12.1866L18.9204 14.0381L18.0722 14.7137L18.9527 15.8192Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx1130(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.20846 16.2258C9.20846 11.881 12.7306 8.35893 17.0753 8.35893C21.42 8.35893 24.9422 11.881 24.9422 16.2258C24.9422 18.3497 24.1004 20.2771 22.7323 21.6925L28.2384 26.8809C28.5231 27.1492 28.5364 27.5975 28.2682 27.8822C27.9999 28.1669 27.5515 28.1802 27.2669 27.912L21.6544 22.6233C20.3645 23.5481 18.7835 24.0926 17.0753 24.0926C12.7306 24.0926 9.20846 20.5705 9.20846 16.2258ZM17.0753 9.77559C13.5129 9.77559 10.6251 12.6634 10.6251 16.2258C10.6251 19.7881 13.5129 22.6759 17.0753 22.6759C20.6376 22.6759 23.5255 19.7881 23.5255 16.2258C23.5255 12.6634 20.6376 9.77559 17.0753 9.77559Z",
          fill: "currentColor"
        }
      )
    ]
  })
);
var ShieldMagnifyingGlassVirus_default = SvgShieldMagnifyingGlassVirus;

// src/Icon/icons/ShieldMinus.tsx
import { jsx as jsx1131 } from "react/jsx-runtime";
var SvgShieldMinus = (props) => /* @__PURE__ */ jsx1131(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1131(
      "path",
      {
        d: "m20.223 5.27-7.5-3.126a2.26 2.26 0 0 0-.72-.144c-.206 0-.53.065-.722.144l-7.5 3.125a1.86 1.86 0 0 0-1.156 1.696c0 10.082 7.39 15.035 9.34 15.035 2.031 0 9.41-5.008 9.41-15.035 0-.723-.457-1.407-1.152-1.696Zm-8.22-1.394s.005 0 0 0Zm-.038 16.249c-3.578-1.504-7.463-6.254-7.463-13.121 0-.002 0 .002 0 0l7.454-3.111c.012-.004.029-.012.05-.016L19.5 6.965c0 7.945-4.906 12.078-7.535 13.16Zm-3.09-9.063a.9.9 0 0 0-.902.903.9.9 0 0 0 .902.902h6.25a.9.9 0 0 0 .902-.902.899.899 0 0 0-.902-.902h-6.25Z",
        fill: "currentColor"
      }
    )
  })
);
var ShieldMinus_default = SvgShieldMinus;

// src/Icon/icons/ShieldPlus.tsx
import { jsx as jsx1132 } from "react/jsx-runtime";
var SvgShieldPlus = (props) => /* @__PURE__ */ jsx1132(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1132(
      "path",
      {
        d: "m20.223 5.27-7.5-3.126a2.26 2.26 0 0 0-.72-.144c-.206 0-.53.065-.722.144l-7.5 3.125a1.86 1.86 0 0 0-1.156 1.696c0 10.082 7.39 15.035 9.34 15.035 2.031 0 9.41-5.008 9.41-15.035 0-.723-.457-1.407-1.152-1.696Zm-8.22-1.394s.005 0 0 0Zm-.038 16.249c-3.578-1.504-7.463-6.254-7.463-13.121 0-.002 0 .002 0 0l7.454-3.111c.012-.004.029-.012.05-.016L19.5 6.965c0 7.945-4.906 12.078-7.535 13.16ZM11.063 8.84v2.223H8.874a.9.9 0 0 0-.902.902.9.9 0 0 0 .902.902h2.188v2.258a.9.9 0 0 0 .902.902.9.9 0 0 0 .902-.902v-2.223h2.188a.9.9 0 0 0 .902-.902c0-.483-.313-.938-.832-.938h-2.188V8.84a.9.9 0 0 0-.902-.902c-.483 0-.973.417-.973.902Z",
        fill: "currentColor"
      }
    )
  })
);
var ShieldPlus_default = SvgShieldPlus;

// src/Icon/icons/ShieldQuartered.tsx
import { jsx as jsx1133 } from "react/jsx-runtime";
var SvgShieldQuartered = (props) => /* @__PURE__ */ jsx1133(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1133(
      "path",
      {
        d: "m12.526 2.115 7.397 3.138c.864.366 1.513 1.218 1.505 2.212-.02 3.932-1.619 11.061-8.391 14.302-.652.31-1.418.31-2.074 0-6.769-3.24-8.372-10.37-8.39-14.302-.006-.994.64-1.846 1.504-2.212l7.4-3.138a1.248 1.248 0 0 1 1.05 0ZM4.458 7.488c.003.707.063 1.509.2 2.369h6.4V4.34L4.81 6.954c-.231.133-.354.338-.353.534Zm.616 4.254c.825 2.903 2.59 6.038 5.983 7.947v-7.947H5.074Zm7.869 0v7.951c3.394-1.909 5.161-5.08 5.982-7.95h-5.982Zm6.399-1.885c.137-.86.196-1.662.2-2.369.004-.196-.122-.4-.389-.534l-6.21-2.614v5.517h6.399Z",
        fill: "currentColor"
      }
    )
  })
);
var ShieldQuartered_default = SvgShieldQuartered;

// src/Icon/icons/ShieldSlash.tsx
import { jsx as jsx1134 } from "react/jsx-runtime";
var SvgShieldSlash = (props) => /* @__PURE__ */ jsx1134(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1134(
      "path",
      {
        d: "M22 19.232a.749.749 0 0 0-.288-.591l-4.202-3.295c1.182-1.86 2.015-4.3 2.015-7.38 0-.606-.368-1.155-.923-1.386l-6.009-2.503a2.209 2.209 0 0 0-.576-.088c-.194 0-.394.037-.579.116L6.034 6.357l-2.82-2.208A.75.75 0 0 0 2 4.739c0 .224.099.444.288.592l18.497 14.492a.749.749 0 0 0 .464.188c.46 0 .751-.357.751-.779Zm-5.658-4.794-8.956-7.02 4.628-1.927 6.009 2.503c0 2.529-.673 4.704-1.681 6.444Zm-4.328 4.071c-2.586-1.077-5.098-4.08-5.805-8.196L4.54 9.005c.477 7.442 6.006 11.006 7.47 11.006 1.159 0 3.212-1.812 3.672-2.27l-1.18-.925c-.789.764-1.671 1.343-2.488 1.693Z",
        fill: "currentColor"
      }
    )
  })
);
var ShieldSlash_default = SvgShieldSlash;

// src/Icon/icons/ShieldVirus.tsx
import { jsx as jsx1135 } from "react/jsx-runtime";
var SvgShieldVirus = (props) => /* @__PURE__ */ jsx1135(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx1135(
      "path",
      {
        d: "M11.375 6.34v.473c0 .754-.617 1.253-1.26 1.253-.306 0-.62-.114-.874-.369l-.335-.299a.608.608 0 0 0-.441-.183c-.357 0-.625.292-.625.59 0 .16.06.32.183.441l.335.336c.255.29.368.602.368.91 0 .643-.498 1.26-1.252 1.26H7a.625.625 0 1 0 0 1.25h.473c.754 0 1.253.616 1.253 1.258 0 .307-.114.62-.369.875l-.334.334a.623.623 0 0 0-.183.442c0 .333.268.59.625.59.16 0 .32-.062.442-.184l.335-.335c.255-.254.567-.368.874-.368.643 0 1.26.498 1.26 1.252v.474a.625.625 0 1 0 1.25 0v-.474c0-.753.616-1.252 1.258-1.252.308 0 .62.114.875.368l.335.335a.623.623 0 0 0 .442.183c.357 0 .625-.291.625-.59 0-.16-.06-.32-.183-.441l-.335-.335a1.223 1.223 0 0 1-.368-.875c0-.643.498-1.26 1.252-1.26H17a.625.625 0 1 0 0-1.25h-.473c-.754 0-1.252-.616-1.252-1.258 0-.307.114-.62.368-.875l.335-.335a.623.623 0 0 0 .183-.442c0-.333-.268-.59-.625-.59-.16 0-.32.061-.441.183l-.337.298a1.224 1.224 0 0 1-.875.37c-.643 0-1.26-.5-1.26-1.254V6.34A.625.625 0 0 0 12 5.715c-.346 0-.624.316-.624.625Zm-.625 4.375c-.345 0-.59-.28-.59-.625s.28-.625.625-.625.59.28.59.625a.605.605 0 0 1-.625.625Zm2.5 1.25c.345 0 .625.28.625.59 0 .345-.28.59-.625.59s-.625-.28-.625-.59c0-.274.281-.59.625-.59Zm6.972-6.696-7.5-3.126A2.231 2.231 0 0 0 12.004 2c-.207 0-.532.064-.723.143l-7.5 3.126a1.873 1.873 0 0 0-1.156 1.73c0 10.048 7.39 15.001 9.37 15.001 2.033 0 9.38-5.008 9.38-15 0-.758-.457-1.443-1.153-1.731Zm-8.218-1.393s.004 0 0 0Zm-.04 16.249c-3.577-1.504-7.462-6.254-7.462-13.121 0-.002 0 .002 0 0l7.453-3.111c.013-.004.029-.012.05-.016L19.5 7.001c-.001 7.91-4.908 12.042-7.536 13.124Z",
        fill: "currentColor"
      }
    )
  })
);
var ShieldVirus_default = SvgShieldVirus;

// src/Icon/icons/ShieldXmark.tsx
import { jsx as jsx1136 } from "react/jsx-runtime";
var SvgShieldXmark = (props) => /* @__PURE__ */ jsx1136(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1136(
      "path",
      {
        d: "m20.223 5.27-7.5-3.126a2.26 2.26 0 0 0-.72-.144c-.206 0-.53.065-.722.144l-7.5 3.125a1.86 1.86 0 0 0-1.156 1.696c0 10.082 7.39 15.035 9.34 15.035 2.031 0 9.41-5.008 9.41-15.035 0-.723-.457-1.407-1.152-1.696Zm-8.22-1.394s.005 0 0 0Zm-.038 16.249c-3.578-1.504-7.463-6.254-7.463-13.121 0-.002 0 .002 0 0l7.454-3.111c.012-.004.029-.012.05-.016L19.5 6.965c0 7.945-4.906 12.078-7.535 13.16Zm-1.836-11.29c-.149-.183-.39-.273-.629-.273a.938.938 0 0 0-.663 1.6L10.676 12l-1.84 1.836a.938.938 0 0 0 1.327 1.327L12 13.324l1.837 1.837a.938.938 0 1 0 1.326-1.324L13.324 12l1.837-1.837a.938.938 0 1 0-1.324-1.326L12 10.676l-1.871-1.84Z",
        fill: "currentColor"
      }
    )
  })
);
var ShieldXmark_default = SvgShieldXmark;

// src/Icon/icons/Shield.tsx
import { jsx as jsx1137 } from "react/jsx-runtime";
var SvgShield = (props) => /* @__PURE__ */ jsx1137(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1137(
      "path",
      {
        d: "m12.526 2.115 7.397 3.138c.864.366 1.513 1.218 1.505 2.212-.02 3.932-1.619 11.061-8.391 14.302-.652.31-1.418.31-2.074 0-6.769-3.24-8.372-10.37-8.39-14.302-.006-.994.64-1.846 1.504-2.212l7.4-3.138a1.248 1.248 0 0 1 1.05 0ZM12 3.94 4.813 6.954c-.233.133-.356.338-.355.534.017 3.594 1.508 9.793 7.322 12.578a.517.517 0 0 0 .444 0c5.814-2.785 7.302-8.984 7.318-12.578.004-.196-.122-.4-.389-.534L12 3.94Z",
        fill: "currentColor"
      }
    )
  })
);
var Shield_default = SvgShield;

// src/Icon/icons/SidebarFlip.tsx
import { jsx as jsx1138 } from "react/jsx-runtime";
var SvgSidebarFlip = (props) => /* @__PURE__ */ jsx1138(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1138(
      "path",
      {
        d: "M22 18.25c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75a2.5 2.5 0 0 1 2.5-2.5h15c1.379 0 2.5 1.12 2.5 2.5v12.5ZM13.25 5.125H4.5a.625.625 0 0 0-.625.625v12.5c0 .344.28.625.625.625h8.75V5.125Zm6.25 1.563a.935.935 0 0 0-.938-.938h-1.875a.935.935 0 0 0-.937.938c0 .519.418.937.938.937h1.875c.519 0 .937-.418.937-.938ZM16.687 9.5a.935.935 0 0 0-.937.938c0 .519.418.937.938.937h1.875c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937h-1.875Zm2.813 4.688a.935.935 0 0 0-.938-.938h-1.875a.935.935 0 0 0-.937.938c0 .519.418.937.938.937h1.875c.519 0 .937-.418.937-.938Z",
        fill: "currentColor"
      }
    )
  })
);
var SidebarFlip_default = SvgSidebarFlip;

// src/Icon/icons/Sidebar.tsx
import { jsx as jsx1139 } from "react/jsx-runtime";
var SvgSidebar = (props) => /* @__PURE__ */ jsx1139(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1139(
      "path",
      {
        d: "M2 5.75a2.5 2.5 0 0 1 2.5-2.5h15c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75Zm8.75 13.125h8.75a.627.627 0 0 0 .625-.625V5.75a.626.626 0 0 0-.625-.625h-8.75v13.75ZM5.437 7.625h1.875c.52 0 .938-.418.938-.938a.935.935 0 0 0-.938-.937H5.438a.936.936 0 1 0 0 1.875Zm0 1.875a.936.936 0 1 0 0 1.875h1.875c.52 0 .938-.418.938-.938a.935.935 0 0 0-.938-.937H5.438Zm0 5.625h1.875c.52 0 .938-.418.938-.938a.935.935 0 0 0-.938-.937H5.438a.937.937 0 1 0 0 1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var Sidebar_default = SvgSidebar;

// src/Icon/icons/SignalBarsFair.tsx
import { jsx as jsx1140 } from "react/jsx-runtime";
var SvgSignalBarsFair = (props) => /* @__PURE__ */ jsx1140(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1140(
      "path",
      {
        d: "M8.857 12H4.286A2.286 2.286 0 0 0 2 14.286v4.571a2.286 2.286 0 0 0 2.286 2.286h4.571a2.286 2.286 0 0 0 2.286-2.286v-4.571A2.283 2.283 0 0 0 8.857 12Zm-1.143 5.714H5.43V15.43h2.285v2.285Zm12-14.857h-4.571a2.286 2.286 0 0 0-2.286 2.286v13.714a2.286 2.286 0 0 0 2.286 2.286h4.571A2.286 2.286 0 0 0 22 18.857V5.143a2.283 2.283 0 0 0-2.286-2.286Zm-1.143 14.857h-2.285V6.286h2.285v11.428Z",
        fill: "currentColor"
      }
    )
  })
);
var SignalBarsFair_default = SvgSignalBarsFair;

// src/Icon/icons/SignalBarsGood.tsx
import { jsx as jsx1141 } from "react/jsx-runtime";
var SvgSignalBarsGood = (props) => /* @__PURE__ */ jsx1141(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1141(
      "path",
      {
        d: "M20.518 3.111h-2.962c-.819 0-1.482.664-1.482 1.482v14.814c0 .819.663 1.482 1.482 1.482h2.962c.819 0 1.482-.663 1.482-1.482V4.593a1.48 1.48 0 0 0-1.482-1.482Zm-.74 15.556h-1.482V5.333h1.482v13.334ZM6.444 14.963H3.481c-.818 0-1.481.663-1.481 1.481v2.963c0 .819.663 1.482 1.481 1.482h2.963c.819 0 1.482-.663 1.482-1.482v-2.963a1.48 1.48 0 0 0-1.482-1.481Zm-.74 3.704H4.222v-1.482h1.482v1.482Zm7.778-9.63h-2.963c-.819 0-1.482.663-1.482 1.481v8.89c0 .817.663 1.48 1.481 1.48h2.963c.819 0 1.482-.663 1.482-1.48v-8.89a1.48 1.48 0 0 0-1.481-1.481Zm-.741 9.63h-1.482v-7.408h1.482v7.408Z",
        fill: "currentColor"
      }
    )
  })
);
var SignalBarsGood_default = SvgSignalBarsGood;

// src/Icon/icons/SignalBarsSlash.tsx
import { jsx as jsx1142 } from "react/jsx-runtime";
var SvgSignalBarsSlash = (props) => /* @__PURE__ */ jsx1142(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1142(
      "path",
      {
        d: "M15.003 18.502h-1v-2.088l-1.5-1.176v3.764a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.628l-1.5-1.176v1.304ZM7.751 13v6.002a1 1 0 0 0 1 1h2.001a1 1 0 0 0 1-1V14.65l-3.304-2.617c-.4.157-.697.522-.697.966Zm1.5.5h1.001v5.002h-1V13.5Zm-3.25 2.501H4a1 1 0 0 0-1.001 1v2a1 1 0 0 0 1 1.001h2a1 1 0 0 0 1.001-1v-2a1 1 0 0 0-1-1Zm-.5 2.5h-1v-1h1v1Zm16.217.16-.463-.362v-13.3a1 1 0 0 0-1-1.001h-2a1 1 0 0 0-1.001 1v10.165l-.75-.588V9a1 1 0 0 0-1-1h-2.001a1 1 0 0 0-1 1v2.44l-9.29-7.281a.75.75 0 1 0-.926 1.18l18.477 14.476a.748.748 0 0 0 .463.188.748.748 0 0 0 .59-.287.723.723 0 0 0-.1-1.054Zm-6.715-5.264-1-.781V9.499h1v3.898Zm4.752 3.726-1-.784V5.5h1v11.624Z",
        fill: "currentColor"
      }
    )
  })
);
var SignalBarsSlash_default = SvgSignalBarsSlash;

// src/Icon/icons/SignalBarsWeak.tsx
import { jsx as jsx1143 } from "react/jsx-runtime";
var SvgSignalBarsWeak = (props) => /* @__PURE__ */ jsx1143(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1143(
      "path",
      {
        d: "M17 2H7a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7c0-2.766-2.234-5-5-5Zm-2.5 12.5h-5v-5h5v5Z",
        fill: "currentColor"
      }
    )
  })
);
var SignalBarsWeak_default = SvgSignalBarsWeak;

// src/Icon/icons/SignalBars.tsx
import { jsx as jsx1144 } from "react/jsx-runtime";
var SvgSignalBars = (props) => /* @__PURE__ */ jsx1144(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1144(
      "path",
      {
        d: "M5.288 16.384H3.096c-.605 0-1.096.49-1.096 1.096v2.191c0 .605.49 1.096 1.096 1.096h2.192c.605 0 1.096-.49 1.096-1.096V17.48c0-.607-.49-1.096-1.096-1.096Zm-.548 2.74H3.644v-1.097H4.74v1.096ZM10.493 12H8.301c-.605 0-1.096.49-1.096 1.096v6.575c0 .605.491 1.096 1.096 1.096h2.192c.605 0 1.096-.49 1.096-1.096v-6.575c0-.606-.49-1.096-1.096-1.096Zm-.548 7.123H8.85v-5.48h1.096v5.48Zm10.96-15.89h-2.193c-.605 0-1.096.49-1.096 1.096V19.67c0 .605.491 1.096 1.096 1.096h2.192c.605 0 1.096-.49 1.096-1.096V4.33c0-.605-.49-1.096-1.096-1.096Zm-.549 15.89H19.26V4.877h1.096v14.246ZM15.7 7.616h-2.192c-.605 0-1.096.491-1.096 1.096v10.96c0 .604.49 1.095 1.096 1.095h2.192c.605 0 1.095-.49 1.095-1.096V8.712c0-.606-.49-1.096-1.095-1.096Zm-.548 11.507h-1.096V9.26h1.096v9.863Z",
        fill: "currentColor"
      }
    )
  })
);
var SignalBars_default = SvgSignalBars;

// src/Icon/icons/SignalFair.tsx
import { jsx as jsx1145 } from "react/jsx-runtime";
var SvgSignalFair = (props) => /* @__PURE__ */ jsx1145(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1145(
      "path",
      {
        d: "M6.286 10.571a2.146 2.146 0 0 0-2.143 2.143v7.143c0 1.183.96 2.143 2.062 2.143 1.103 0 2.224-.955 2.224-2.143v-7.143c0-1.178-.96-2.143-2.143-2.143ZM17.714 2a2.15 2.15 0 0 0-2.143 2.143v15.714a2.143 2.143 0 0 0 4.286 0V4.143A2.143 2.143 0 0 0 17.714 2Z",
        fill: "currentColor"
      }
    )
  })
);
var SignalFair_default = SvgSignalFair;

// src/Icon/icons/SignalGood.tsx
import { jsx as jsx1146 } from "react/jsx-runtime";
var SvgSignalGood = (props) => /* @__PURE__ */ jsx1146(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1146(
      "path",
      {
        d: "M4 14c-.828 0-1.5.675-1.5 1.5v5c0 .828.672 1.5 1.444 1.5.772 0 1.556-.669 1.556-1.5v-5c0-.825-.672-1.5-1.5-1.5Zm8-6c-.825 0-1.5.675-1.5 1.5v11a1.5 1.5 0 0 0 3 0v-11A1.5 1.5 0 0 0 12 8Zm8-6c-.825 0-1.5.675-1.5 1.5v17a1.5 1.5 0 0 0 3 0v-17A1.5 1.5 0 0 0 20 2Z",
        fill: "currentColor"
      }
    )
  })
);
var SignalGood_default = SvgSignalGood;

// src/Icon/icons/SignalSlash.tsx
import { jsx as jsx1147 } from "react/jsx-runtime";
var SvgSignalSlash = (props) => /* @__PURE__ */ jsx1147(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1147(
      "path",
      {
        d: "M8.001 12.972a.75.75 0 0 0-.75.75v5.502c0 .414.336.722.75.722.415 0 .75-.278.75-.694v-5.501c0-.413-.334-.779-.75-.779Zm-4 3.001a.75.75 0 0 0-.75.75v2.5c0 .415.335.723.75.723.413 0 .75-.278.75-.694v-2.5c0-.413-.337-.779-.75-.779Zm7.251 3.279a.75.75 0 0 0 1.5 0v-3.817l-1.5-1.176v4.993Zm4.001 0a.75.75 0 0 0 1.5 0v-.682l-1.5-1.176v1.858Zm6.465-.59-.963-.782V4.748a.75.75 0 0 0-1.5 0V16.73l-2.501-1.96V7.749a.75.75 0 0 0-1.5 0v5.845l-2.501-1.96v-.884a.75.75 0 0 0-.75-.75c-.326 0-.623.209-.7.472l-8.09-6.314a.75.75 0 1 0-.926 1.18l18.477 14.476a.749.749 0 0 0 1.053-.127c.285-.297.226-.77-.1-1.026Z",
        fill: "currentColor"
      }
    )
  })
);
var SignalSlash_default = SvgSignalSlash;

// src/Icon/icons/SignalStreamSlash.tsx
import { jsx as jsx1148 } from "react/jsx-runtime";
var SvgSignalStreamSlash = (props) => /* @__PURE__ */ jsx1148(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1148(
      "path",
      {
        d: "m21.718 18.661-2.235-1.752c2.223-3.188 2.005-7.76-.67-10.668a.75.75 0 0 0-1.106 1.016c2.187 2.376 2.366 6.092.58 8.715l-1.592-1.248c1.171-1.796 1.056-4.341-.374-5.97a.75.75 0 0 0-1.129.99c.97 1.103 1.075 2.817.326 4.058l-2.268-1.777c0-.008.004-.016.004-.024 0-.69-.56-1.25-1.252-1.25-.107 0-.202.035-.302.06L3.213 4.158a.75.75 0 0 0-.926 1.18l18.505 14.505c.138.106.3.159.435.159a.75.75 0 0 0 .59-.287.724.724 0 0 0-.1-1.054ZM4.995 9.368l-1.223-.96c-1.373 3.042-.904 6.824 1.42 9.35a.747.747 0 0 0 1.06.046.75.75 0 0 0 .045-1.06c-1.832-1.993-2.26-4.931-1.302-7.376Zm3.019 2.366-1.325-1.037c-.379 1.562-.087 3.32.995 4.55a.749.749 0 1 0 1.128-.992c-.604-.689-.864-1.617-.798-2.52Z",
        fill: "currentColor"
      }
    )
  })
);
var SignalStreamSlash_default = SvgSignalStreamSlash;

// src/Icon/icons/SignalStream.tsx
import { jsx as jsx1149 } from "react/jsx-runtime";
var SvgSignalStream = (props) => /* @__PURE__ */ jsx1149(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1149(
      "path",
      {
        d: "M19.565 5.603a.834.834 0 0 0-1.228 1.128c2.675 2.906 2.675 7.632 0 10.538a.833.833 0 1 0 1.228 1.129c3.247-3.527 3.247-9.27 0-12.795Zm-3.944 2.685a.833.833 0 0 0-.076 1.176c1.214 1.381 1.214 3.629 0 5.01a.833.833 0 0 0 .076 1.177c.158.107.354.207.55.207a.83.83 0 0 0 .627-.283c1.747-1.988 1.747-5.222 0-7.212a.896.896 0 0 0-1.177-.075ZM5.614 5.554a.834.834 0 0 0-1.179.049c-3.247 3.527-3.247 9.267 0 12.795a.83.83 0 0 0 1.178.048.833.833 0 0 0 .05-1.177c-2.675-2.906-2.675-7.632 0-10.538a.834.834 0 0 0-.05-1.177Zm2.764 2.734a.865.865 0 0 0-1.177.108c-1.748 1.988-1.748 5.222 0 7.212a.831.831 0 0 0 1.177.076.833.833 0 0 0 .076-1.176c-1.214-1.382-1.214-3.629 0-5.01.306-.349.271-.876-.076-1.21Zm3.621 2.323c-.767 0-1.39.622-1.39 1.358 0 .736.623 1.42 1.39 1.42.768 0 1.39-.622 1.39-1.358 0-.736-.622-1.42-1.39-1.42Z",
        fill: "currentColor"
      }
    )
  })
);
var SignalStream_default = SvgSignalStream;

// src/Icon/icons/SignalStrong.tsx
import { jsx as jsx1150 } from "react/jsx-runtime";
var SvgSignalStrong = (props) => /* @__PURE__ */ jsx1150(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1150(
      "path",
      {
        d: "M3.111 15.704c-.613 0-1.111.5-1.111 1.11v3.704c0 .614.498 1.112 1.07 1.112.571 0 1.152-.496 1.152-1.111v-3.704c0-.611-.497-1.111-1.11-1.111Zm5.926-4.445c-.611 0-1.111.5-1.111 1.111v8.149a1.111 1.111 0 0 0 2.222 0V12.37c0-.61-.495-1.11-1.111-1.11ZM20.889 2.37c-.613 0-1.111.498-1.111 1.111V20.52a1.111 1.111 0 0 0 2.222 0V3.48c0-.61-.495-1.11-1.111-1.11Zm-5.926 4.445c-.611 0-1.111.5-1.111 1.11v12.593a1.111 1.111 0 0 0 2.222 0V7.926c0-.611-.495-1.111-1.111-1.111Z",
        fill: "currentColor"
      }
    )
  })
);
var SignalStrong_default = SvgSignalStrong;

// src/Icon/icons/SignalWeak.tsx
import { jsx as jsx1151 } from "react/jsx-runtime";
var SvgSignalWeak = (props) => /* @__PURE__ */ jsx1151(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1151(
      "path",
      {
        d: "M15.75 5.75v12.5a3.751 3.751 0 0 1-7.5 0V5.75C8.25 3.68 9.93 2 12 2c2.07 0 3.75 1.688 3.75 3.75Z",
        fill: "currentColor"
      }
    )
  })
);
var SignalWeak_default = SvgSignalWeak;

// src/Icon/icons/Signal.tsx
import { jsx as jsx1152 } from "react/jsx-runtime";
var SvgSignal = (props) => /* @__PURE__ */ jsx1152(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1152(
      "path",
      {
        d: "M7.429 13.143A.86.86 0 0 0 6.57 14v6.286a.857.857 0 0 0 1.715 0V14a.857.857 0 0 0-.857-.857ZM2.857 16.57A.859.859 0 0 0 2 17.43v2.857c0 .473.384.857.825.857.441 0 .89-.382.89-.857v-2.857a.859.859 0 0 0-.858-.858ZM12 9.714a.86.86 0 0 0-.857.857v9.715a.857.857 0 0 0 1.714 0V10.57A.857.857 0 0 0 12 9.714Zm4.571-3.428a.857.857 0 0 0-.857.857v13.143a.857.857 0 0 0 1.715 0V7.143a.857.857 0 0 0-.858-.857Zm4.572-3.429a.857.857 0 0 0-.857.857v16.572a.857.857 0 0 0 1.714 0V3.714a.856.856 0 0 0-.857-.857Z",
        fill: "currentColor"
      }
    )
  })
);
var Signal_default = SvgSignal;

// src/Icon/icons/Signature.tsx
import { jsx as jsx1153 } from "react/jsx-runtime";
var SvgSignature = (props) => /* @__PURE__ */ jsx1153(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1153(
      "path",
      {
        d: "M7.5 9.25c0 .416-.334.75-.75.75A.748.748 0 0 1 6 9.25V8c0-1.657 1.316-3 3-3a3 3 0 0 1 3 3v.247c0 .694-.044 1.387-.128 2.075l4.156-1.288a.745.745 0 0 1 .763.197c.197.178.262.503.165.772l-.89 2.497h3.184c.416 0 .75.334.75.75s-.334.75-.75.75H15a.752.752 0 0 1-.706-1.003l.747-2.088-3.463 1.072-.031.147c-.419 1.756-1.063 3.44-1.99 4.985l-.523.825C8.666 18.596 7.956 19 7.16 19 5.98 19 5 18.022 5 16.812v-2.337a2.76 2.76 0 0 1 1.91-2.628l3.371-1.063c.147-.818.219-1.678.219-2.537v-.275c0-.8-.672-1.5-1.5-1.5s-1.5.7-1.5 1.5V9.25Zm-1 5.225v2.338c0 .38.306.687.66.687a.76.76 0 0 0 .615-.334l.497-.825a15.238 15.238 0 0 0 1.637-3.844l-2.528.756c-.525.19-.881.675-.881 1.222ZM4 16.813c0 .062.002.125.005.187H2.75a.75.75 0 1 1 0-1.5H4v1.313Zm6.775.187c.266-.488.51-.99.728-1.5h9.747c.416 0 .75.334.75.75s-.334.75-.75.75H10.775Z",
        fill: "currentColor"
      }
    )
  })
);
var Signature_default = SvgSignature;

// src/Icon/icons/SignsPost.tsx
import { jsx as jsx1154 } from "react/jsx-runtime";
var SvgSignsPost = (props) => /* @__PURE__ */ jsx1154(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1154(
      "path",
      {
        d: "M11.062 2.938a.937.937 0 1 1 1.875 0v.312H19.2c.191 0 .371.086.488.234l2 2.5c.184.227.184.555 0 .746l-2 2.5a.564.564 0 0 1-.488.27h-6.262v1.25H19.5c.691 0 1.25.559 1.25 1.25v3.75c0 .691-.559 1.25-1.25 1.25h-6.563v4.063c0 .519-.418.937-.937.937a.935.935 0 0 1-.938-.938V17H4.8a.566.566 0 0 1-.488-.27l-2-2.5c-.183-.19-.183-.52 0-.746l2-2.5a.623.623 0 0 1 .488-.234h6.262V9.5H4.5a1.25 1.25 0 0 1-1.25-1.25V4.5c0-.69.56-1.25 1.25-1.25h6.562v-.313ZM5.125 5.124v2.5h13.472l1-1.25-1-1.25H5.125Zm13.75 7.5H5.4l-1 1.25 1 1.25h13.474v-2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var SignsPost_default = SvgSignsPost;

// src/Icon/icons/SimCard.tsx
import { jsx as jsx1155 } from "react/jsx-runtime";
var SvgSimCard = (props) => /* @__PURE__ */ jsx1155(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1155(
      "path",
      {
        d: "M10.125 11.375H9.23c-.87 0-1.605.734-1.605 1.64V14.5h2.5v-3.125Zm-2.5 5.86c0 .906.735 1.64 1.605 1.64h3.395V15.75h-5v1.484Zm3.75-2.735h5v-1.484c0-.907-.734-1.641-1.676-1.641h-3.324V14.5Zm7.758-7.867-4.27-4.27A1.249 1.249 0 0 0 13.98 2H7a2.507 2.507 0 0 0-2.5 2.5v15C4.5 20.875 5.625 22 7 22h10c1.375 0 2.5-1.125 2.5-2.5V7.52c0-.332-.133-.653-.367-.887ZM17.625 19.5a.63.63 0 0 1-.625.625H7a.63.63 0 0 1-.625-.625v-15A.63.63 0 0 1 7 3.875h6.723l3.902 3.902V19.5Zm-3.75-.625h.824c.942 0 1.676-.734 1.676-1.64V15.75h-2.5v3.125Z",
        fill: "currentColor"
      }
    )
  })
);
var SimCard_default = SvgSimCard;

// src/Icon/icons/SimCards.tsx
import { jsx as jsx1156 } from "react/jsx-runtime";
var SvgSimCards = (props) => /* @__PURE__ */ jsx1156(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1156(
      "path",
      {
        d: "M13.875 8.875h-2.559c-.656 0-1.191.535-1.191 1.191v1.309h3.75v-2.5Zm-3.75 5.059c0 .656.535 1.191 1.191 1.191h1.309v-2.5h-2.5v1.309Zm3.75 1.191h2.558c.657 0 1.192-.535 1.192-1.191v-1.309h-3.75v2.5Zm6.508-9.117L16.74 2.365A1.25 1.25 0 0 0 15.856 2H9.5A2.507 2.507 0 0 0 7 4.5v11.25c0 1.375 1.125 2.5 2.5 2.5h8.75c1.375 0 2.5-1.125 2.5-2.5V6.895c0-.332-.133-.653-.367-.887Zm-1.508 9.742a.633.633 0 0 1-.625.625H9.5a.633.633 0 0 1-.625-.625V4.5c0-.339.286-.625.625-.625h6.098l3.277 3.277v8.598Zm-3.75-4.375h2.5v-1.309c0-.656-.535-1.191-1.191-1.191h-1.309v2.5ZM16.063 22H7.938a4.692 4.692 0 0 1-4.688-4.688V6.688a.939.939 0 0 1 1.875 0v10.625a2.816 2.816 0 0 0 2.813 2.813h8.125a.938.938 0 0 1 0 1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var SimCards_default = SvgSimCards;

// src/Icon/icons/Sitemap.tsx
import { jsx as jsx1157 } from "react/jsx-runtime";
var SvgSitemap = (props) => /* @__PURE__ */ jsx1157(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1157(
      "path",
      {
        d: "M13.111 4.222c.92 0 1.667.746 1.667 1.667V8.11c0 .92-.747 1.667-1.667 1.667h-.278v1.389h5.278c1.073 0 1.945.871 1.945 1.944v1.111h.277c.92 0 1.667.747 1.667 1.667v2.222c0 .92-.747 1.667-1.667 1.667h-2.222c-.92 0-1.667-.747-1.667-1.667v-2.22c0-.92.747-1.667 1.667-1.667h.278v-1.11a.279.279 0 0 0-.278-.279h-5.278v1.39h.278c.92 0 1.667.746 1.667 1.666v2.222c0 .92-.747 1.667-1.667 1.667H10.89c-.92 0-1.667-.747-1.667-1.667V15.89c0-.92.747-1.667 1.667-1.667h.278v-1.389H5.889a.279.279 0 0 0-.278.278v1.111h.278c.92 0 1.667.747 1.667 1.667v2.222c0 .92-.747 1.667-1.667 1.667H3.667A1.67 1.67 0 0 1 2 18.11v-2.22c0-.92.746-1.667 1.667-1.667h.277v-1.11c0-1.074.87-1.945 1.945-1.945h5.278v-1.39h-.278c-.92 0-1.667-.746-1.667-1.666V5.89c0-.92.747-1.667 1.667-1.667h2.222Zm0 1.667H10.89V8.11h2.222V5.89ZM3.667 18.11h2.222v-2.22H3.667v2.222Zm7.222 0h2.222v-2.22H10.89v2.222Zm7.222 0h2.222v-2.22h-2.222v2.222Z",
        fill: "currentColor"
      }
    )
  })
);
var Sitemap_default = SvgSitemap;

// src/Icon/icons/SlashBack.tsx
import { jsx as jsx1158 } from "react/jsx-runtime";
var SvgSlashBack = (props) => /* @__PURE__ */ jsx1158(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1158(
      "path",
      {
        d: "M17.312 22a.937.937 0 0 1-.81-.463L5.877 3.412a.94.94 0 0 1 1.62-.948l10.625 18.124a.938.938 0 0 1-.81 1.412Z",
        fill: "currentColor"
      }
    )
  })
);
var SlashBack_default = SvgSlashBack;

// src/Icon/icons/SlashForward.tsx
import { jsx as jsx1159 } from "react/jsx-runtime";
var SvgSlashForward = (props) => /* @__PURE__ */ jsx1159(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1159(
      "path",
      {
        d: "M6.686 22a.937.937 0 0 1-.808-1.41L16.503 2.464a.938.938 0 0 1 1.619.948L7.497 21.539a.936.936 0 0 1-.81.462Z",
        fill: "currentColor"
      }
    )
  })
);
var SlashForward_default = SvgSlashForward;

// src/Icon/icons/Slash.tsx
import { jsx as jsx1160 } from "react/jsx-runtime";
var SvgSlash = (props) => /* @__PURE__ */ jsx1160(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1160(
      "path",
      {
        d: "M2.16 4.287a.75.75 0 0 1 1.053-.127l18.5 14.5a.75.75 0 0 1-.926 1.18l-18.5-14.5a.75.75 0 0 1-.127-1.053Z",
        fill: "currentColor"
      }
    )
  })
);
var Slash_default = SvgSlash;

// src/Icon/icons/Slider.tsx
import { jsx as jsx1161 } from "react/jsx-runtime";
var SvgSlider = (props) => /* @__PURE__ */ jsx1161(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1161(
      "path",
      {
        d: "M15.75 5.75c1.379 0 2.5 1.121 2.5 2.5v2.813h2.813c.519 0 .937.417.937.937s-.418.938-.938.938H18.25v2.812c0 1.379-1.121 2.5-2.5 2.5H14.5a2.502 2.502 0 0 1-2.5-2.5v-7.5c0-1.379 1.121-2.5 2.5-2.5h1.25Zm0 1.875H14.5a.627.627 0 0 0-.625.625v7.5c0 .344.281.625.625.625h1.25a.627.627 0 0 0 .625-.625v-7.5a.627.627 0 0 0-.625-.625ZM2.937 11.063h7.813v1.874H2.937a.937.937 0 1 1 0-1.874Z",
        fill: "currentColor"
      }
    )
  })
);
var Slider_default = SvgSlider;

// src/Icon/icons/SlidersSimple.tsx
import { jsx as jsx1162 } from "react/jsx-runtime";
var SvgSlidersSimple = (props) => /* @__PURE__ */ jsx1162(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1162(
      "path",
      {
        d: "M21.063 15.438c.519 0 .937.417.937.937s-.418.938-.938.938H8.105A3.123 3.123 0 0 1 2 16.375a3.125 3.125 0 0 1 6.105-.938h12.957Zm-17.188.937a1.25 1.25 0 1 0 2.499.001 1.25 1.25 0 0 0-2.499-.001Zm12.02-9.688a3.126 3.126 0 1 1 0 1.875H2.938a.936.936 0 1 1 0-1.874h12.957Zm2.98 2.188c.691 0 1.25-.559 1.25-1.25s-.559-1.25-1.25-1.25-1.25.559-1.25 1.25.559 1.25 1.25 1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var SlidersSimple_default = SvgSlidersSimple;

// src/Icon/icons/SlidersUp.tsx
import { jsx as jsx1163 } from "react/jsx-runtime";
var SvgSlidersUp = (props) => /* @__PURE__ */ jsx1163(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1163(
      "path",
      {
        d: "M5.75 2c.52 0 .938.42.938.938v2.33a3.125 3.125 0 0 1 0 5.962v9.832c0 .52-.418.938-.938.938a.937.937 0 0 1-.938-.938V11.23a3.125 3.125 0 0 1 0-5.962v-2.33c0-.518.42-.938.938-.938Zm0 7.5C6.441 9.5 7 8.941 7 8.25S6.441 7 5.75 7a1.25 1.25 0 1 0 0 2.5Zm9.375 6.25a3.124 3.124 0 0 1-2.188 2.98v2.332c0 .52-.417.938-.937.938a.935.935 0 0 1-.938-.938V18.73a3.124 3.124 0 0 1 0-5.96V2.938a.937.937 0 1 1 1.876 0v9.832a3.124 3.124 0 0 1 2.187 2.98ZM12 17c.691 0 1.25-.559 1.25-1.25S12.691 14.5 12 14.5s-1.25.559-1.25 1.25S11.309 17 12 17Zm7.188 4.063c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938V12.48a3.124 3.124 0 0 1 0-5.96V2.938a.937.937 0 1 1 1.875 0V6.52a3.123 3.123 0 0 1 0 5.96v8.582ZM18.25 8.25c-.691 0-1.25.559-1.25 1.25s.559 1.25 1.25 1.25 1.25-.559 1.25-1.25-.559-1.25-1.25-1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var SlidersUp_default = SvgSlidersUp;

// src/Icon/icons/Sliders.tsx
import { jsx as jsx1164 } from "react/jsx-runtime";
var SvgSliders = (props) => /* @__PURE__ */ jsx1164(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1164(
      "path",
      {
        d: "M2 18.25c0-.52.42-.938.938-.938h2.33a3.125 3.125 0 0 1 5.962 0h9.832c.52 0 .938.418.938.938s-.418.938-.938.938H11.23a3.124 3.124 0 0 1-5.962 0h-2.33A.937.937 0 0 1 2 18.25Zm7.5 0c0-.691-.559-1.25-1.25-1.25S7 17.559 7 18.25s.559 1.25 1.25 1.25 1.25-.559 1.25-1.25Zm6.25-9.375c1.398 0 2.582.918 2.98 2.188h2.332c.52 0 .938.417.938.937s-.418.938-.938.938H18.73a3.124 3.124 0 0 1-5.96 0H2.938a.937.937 0 1 1 0-1.876h9.832a3.124 3.124 0 0 1 2.98-2.187ZM17 12c0-.691-.559-1.25-1.25-1.25s-1.25.559-1.25 1.25.559 1.25 1.25 1.25S17 12.691 17 12Zm4.063-7.188a.937.937 0 1 1 0 1.875H12.48a3.124 3.124 0 0 1-5.961 0H2.938a.936.936 0 1 1 0-1.875H6.52a3.125 3.125 0 0 1 5.96 0h8.582ZM8.25 5.75C8.25 6.441 8.809 7 9.5 7s1.25-.559 1.25-1.25a1.25 1.25 0 1 0-2.5 0Z",
        fill: "currentColor"
      }
    )
  })
);
var Sliders_default = SvgSliders;

// src/Icon/icons/SortDown.tsx
import { jsx as jsx1165 } from "react/jsx-runtime";
var SvgSortDown = (props) => /* @__PURE__ */ jsx1165(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1165(
      "path",
      {
        d: "M18.966 5.493H5.009c-2.668 0-4.02 3.24-2.12 5.125l7.002 7.009a3.002 3.002 0 0 0 4.248 0l7.01-7.01c1.822-1.883.545-5.124-2.183-5.124Zm-7.01 10.012L4.949 8.496h14.018l-7.01 7.01Z",
        fill: "currentColor"
      }
    )
  })
);
var SortDown_default = SvgSortDown;

// src/Icon/icons/SortUp.tsx
import { jsx as jsx1166 } from "react/jsx-runtime";
var SvgSortUp = (props) => /* @__PURE__ */ jsx1166(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1166(
      "path",
      {
        d: "M5.002 18.499h13.993c2.664 0 4.016-3.236 2.117-5.119l-6.993-7a2.998 2.998 0 0 0-4.242 0l-7 7C1.002 15.261 2.33 18.5 5.002 18.5ZM12 8.498l7 7H5.002l6.998-7Z",
        fill: "currentColor"
      }
    )
  })
);
var SortUp_default = SvgSortUp;

// src/Icon/icons/Sort.tsx
import { jsx as jsx1167 } from "react/jsx-runtime";
var SvgSort = (props) => /* @__PURE__ */ jsx1167(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1167(
      "path",
      {
        d: "M16.63 13.334H7.34c-1.776 0-2.677 2.157-1.412 3.413l4.663 4.667a1.999 1.999 0 0 0 2.828 0l4.63-4.667c1.248-1.254.398-3.413-1.419-3.413ZM12 20.001l-4.629-4.667h9.297L12 20.001ZM7.335 10.63h9.326c1.776 0 2.677-2.157 1.412-3.413l-4.659-4.631a1.999 1.999 0 0 0-2.828 0l-4.63 4.667c-1.287 1.256-.402 3.377 1.38 3.377Zm4.667-6.631 4.63 4.667H7.333l4.667-4.667Z",
        fill: "currentColor"
      }
    )
  })
);
var Sort_default = SvgSort;

// src/Icon/icons/Sparkles.tsx
import { jsx as jsx1168 } from "react/jsx-runtime";
var SvgSparkles = (props) => /* @__PURE__ */ jsx1168(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1168(
      "path",
      {
        d: "M14.793 5.328 17 4.5l.828-2.207a.451.451 0 0 1 .844 0L19.5 4.5l2.207.828a.452.452 0 0 1 0 .844L19.5 7l-.828 2.207a.452.452 0 0 1-.422.293.452.452 0 0 1-.422-.293L17 7l-2.207-.828c-.211-.067-.293-.234-.293-.422 0-.188.082-.356.293-.422Zm-5.918-.465a.626.626 0 0 1 1.137 0l2.058 4.453 4.453 2.059a.624.624 0 0 1 .364.57c0 .242-.14.465-.364.567L12.07 14.57l-2.058 4.453a.622.622 0 0 1-.567.364.624.624 0 0 1-.57-.364L6.816 14.57l-4.453-2.058a.624.624 0 0 1 0-1.137l4.453-2.059 2.059-4.453Zm-.355 5.242a1.89 1.89 0 0 1-.915.915l-1.999.925 2 .922c.402.152.726.512.914.914l.925 2 .922-2c.152-.402.512-.761.914-.914l2-.922-2-.925c-.402-.188-.761-.512-.914-.915l-.922-2-.925 2Zm9.308 4.688c.067-.211.235-.293.422-.293.188 0 .355.082.422.293L19.5 17l2.207.828a.452.452 0 0 1 .293.422.452.452 0 0 1-.293.422L19.5 19.5l-.828 2.207a.452.452 0 0 1-.422.293.452.452 0 0 1-.422-.293L17 19.5l-2.207-.828c-.211-.067-.293-.235-.293-.422 0-.188.082-.355.293-.422L17 17l.828-2.207Z",
        fill: "currentColor"
      }
    )
  })
);
var Sparkles_default = SvgSparkles;

// src/Icon/icons/Speaker.tsx
import { jsx as jsx1169 } from "react/jsx-runtime";
var SvgSpeaker = (props) => /* @__PURE__ */ jsx1169(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1169(
      "path",
      {
        d: "M17 2H7a2.5 2.5 0 0 0-2.5 2.5v15A2.5 2.5 0 0 0 7 22h10a2.5 2.5 0 0 0 2.5-2.5v-15C19.5 3.12 18.379 2 17 2Zm.625 17.5c0 .345-.28.625-.625.625H7a.626.626 0 0 1-.625-.625v-15c0-.345.28-.625.625-.625h10c.345 0 .625.28.625.625v15ZM12 8.25a1.563 1.563 0 1 0 0-3.125 1.563 1.563 0 0 0 0 3.125Zm0 2.5a4.062 4.062 0 1 0 0 8.125 4.062 4.062 0 0 0 0-8.125ZM12 17a2.19 2.19 0 0 1-2.188-2.188c0-1.207.981-2.187 2.188-2.187a2.19 2.19 0 0 1 2.188 2.188C14.188 16.02 13.207 17 12 17Z",
        fill: "currentColor"
      }
    )
  })
);
var Speaker_default = SvgSpeaker;

// src/Icon/icons/Speakers.tsx
import { jsx as jsx1170 } from "react/jsx-runtime";
var SvgSpeakers = (props) => /* @__PURE__ */ jsx1170(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1170(
      "path",
      {
        d: "M16.25 9a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5ZM20 4h-7.5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2H20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm.5 14a.5.5 0 0 1-.5.5h-7.5a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5H20a.5.5 0 0 1 .5.5v12Zm-4.25-7a3.25 3.25 0 1 0 .001 6.499A3.25 3.25 0 0 0 16.25 11Zm0 5c-.965 0-1.75-.785-1.75-1.75s.785-1.75 1.75-1.75 1.75.784 1.75 1.75S17.216 16 16.25 16Zm-8.5-9.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm0 6c.49 0 .931.203 1.25.528V11.26A3.205 3.205 0 0 0 7.75 11a3.25 3.25 0 0 0 0 6.5c.445 0 .865-.097 1.25-.26V15.47c-.319.326-.76.529-1.25.529a1.751 1.751 0 0 1 0-3.5ZM10.253 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6.253a2.976 2.976 0 0 1-.73-1.5H4a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5h5.55a3.167 3.167 0 0 1 .703-1.5Z",
        fill: "currentColor"
      }
    )
  })
);
var Speakers_default = SvgSpeakers;

// src/Icon/icons/SpellCheck.tsx
import { jsx as jsx1171 } from "react/jsx-runtime";
var SvgSpellCheck = (props) => /* @__PURE__ */ jsx1171(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1171(
      "path",
      {
        d: "M21.774 12.813a.834.834 0 0 0-1.18-.024l-6.356 6.103-3.034-3.036a.834.834 0 1 0-1.18 1.18l3.582 3.612a.83.83 0 0 0 1.167.012l6.915-6.67a.786.786 0 0 0 .086-1.177ZM11.725 12h3.196a2.643 2.643 0 0 0 2.64-2.64c0-.854-.415-1.607-1.047-2.09.307-.432.49-.954.49-1.522a2.643 2.643 0 0 0-2.64-2.64h-2.639a.835.835 0 0 0-.833.833v7.225c0 .462.375.834.833.834Zm.834-7.225h1.806c.535 0 .973.436.973.973a.975.975 0 0 1-.973.972h-1.806V4.775Zm0 3.612h2.362a.974.974 0 0 1 0 1.946h-2.362V8.387Zm-2.845 2.456L6.658 3.618c-.26-.616-1.274-.616-1.535 0l-3.056 7.225c-.181.42.018.91.442 1.09A.828.828 0 0 0 3.6 11.49l.372-.879h3.835l.372.88a.823.823 0 0 0 1.09.444.83.83 0 0 0 .444-1.09Zm-5.035-1.9 1.21-2.862 1.213 2.862H4.679Z",
        fill: "currentColor"
      }
    )
  })
);
var SpellCheck_default = SvgSpellCheck;

// src/Icon/icons/SpinnerThird.tsx
import { jsx as jsx1172 } from "react/jsx-runtime";
var SvgSpinnerThird = (props) => /* @__PURE__ */ jsx1172(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1172(
      "path",
      {
        d: "M4.93 3.212C4.93 2.542 5.47 2 6.141 2c7.14 0 12.929 5.788 12.929 12.929 0 2.353-.632 4.566-1.733 6.465a1.211 1.211 0 1 1-2.096-1.212 10.498 10.498 0 0 0 1.404-5.298c0-5.758-4.702-10.505-10.504-10.505-.672 0-1.213-.498-1.213-1.212v.045Z",
        fill: "currentColor"
      }
    )
  })
);
var SpinnerThird_default = SvgSpinnerThird;

// src/Icon/icons/Spinner.tsx
import { jsx as jsx1173 } from "react/jsx-runtime";
var SvgSpinner = (props) => /* @__PURE__ */ jsx1173(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1173(
      "path",
      {
        d: "M13.25 3.25a1.25 1.25 0 1 1-2.499.001 1.25 1.25 0 0 1 2.499-.001Zm0 17.5c0 .691-.559 1.25-1.25 1.25s-1.25-.559-1.25-1.25.559-1.25 1.25-1.25 1.25.559 1.25 1.25Zm7.5-10c.691 0 1.25.559 1.25 1.25s-.559 1.25-1.25 1.25-1.25-.559-1.25-1.25.559-1.25 1.25-1.25Zm-17.5 2.5a1.25 1.25 0 1 1-.001-2.499 1.25 1.25 0 0 1 .001 2.499Zm1.679 4.055a1.248 1.248 0 1 1 1.766 1.763 1.248 1.248 0 0 1-1.766-1.763Zm12.376 1.765a1.247 1.247 0 0 1 0-1.765 1.247 1.247 0 0 1 1.765 0 1.247 1.247 0 0 1 0 1.765 1.247 1.247 0 0 1-1.765 0ZM6.695 4.93A1.248 1.248 0 1 1 4.93 6.695 1.248 1.248 0 1 1 6.695 4.93Z",
        fill: "currentColor"
      }
    )
  })
);
var Spinner_default = SvgSpinner;

// src/Icon/icons/Split.tsx
import { jsx as jsx1174 } from "react/jsx-runtime";
var SvgSplit = (props) => /* @__PURE__ */ jsx1174(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1174(
      "path",
      {
        d: "M21.69 16.336a.937.937 0 0 1 0 1.325l-3.125 3.125c-.148.186-.387.276-.629.276a.937.937 0 0 1-.663-1.6l1.526-1.525h-4.3a.937.937 0 0 1-.663-.274l-4.723-4.726H2.937a.936.936 0 1 1 0-1.874h6.176l4.69-4.691a.955.955 0 0 1 .696-.309h4.3l-1.524-1.524A.937.937 0 1 1 18.6 3.213l3.124 3.125a.937.937 0 0 1 0 1.325l-3.124 3.125a.929.929 0 0 1-.665.275.937.937 0 0 1-.663-1.6L18.8 7.937h-3.91L10.828 12l4.063 4.062h3.91l-1.525-1.524a.937.937 0 1 1 1.326-1.326l3.089 3.124Z",
        fill: "currentColor"
      }
    )
  })
);
var Split_default = SvgSplit;

// src/Icon/icons/Square0.tsx
import { jsx as jsx1175 } from "react/jsx-runtime";
var SvgSquare0 = (props) => /* @__PURE__ */ jsx1175(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1175(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM12 6.286a4.293 4.293 0 0 0-4.286 4.285v2.858A4.29 4.29 0 0 0 12 17.714a4.29 4.29 0 0 0 4.286-4.285V10.57A4.293 4.293 0 0 0 12 6.286Zm2.143 7.143A2.145 2.145 0 0 1 12 15.57a2.144 2.144 0 0 1-2.143-2.142V10.57c0-1.181.961-2.142 2.143-2.142s2.143.96 2.143 2.142v2.858Z",
        fill: "currentColor"
      }
    )
  })
);
var Square0_default = SvgSquare0;

// src/Icon/icons/Square1.tsx
import { jsx as jsx1176 } from "react/jsx-runtime";
var SvgSquare1 = (props) => /* @__PURE__ */ jsx1176(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1176(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Zm-5-3.572h-1.786V7.357a1.073 1.073 0 0 0-1.665-.891L9.084 8.013c-.49.326-.624.991-.298 1.447.327.49.992.623 1.485.297l.658-.4v6.214H9.143a1.072 1.072 0 0 0 0 2.143h5.714a1.072 1.072 0 0 0 0-2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var Square1_default = SvgSquare1;

// src/Icon/icons/Square2.tsx
import { jsx as jsx1177 } from "react/jsx-runtime";
var SvgSquare2 = (props) => /* @__PURE__ */ jsx1177(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1177(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Zm-4.643-3.572h-3.652l2.816-2.553a3.888 3.888 0 0 0 1.177-2.793 3.887 3.887 0 0 0-1.177-2.792c-1.554-1.527-4.083-1.527-5.639 0l-.489.482a1.067 1.067 0 0 0-.013 1.514 1.069 1.069 0 0 0 1.515.014l.49-.483a1.893 1.893 0 0 1 2.634 0 1.762 1.762 0 0 1 .03 2.498l-4.839 4.39a1.07 1.07 0 0 0-.28 1.178c.16.416.557.688.999.688h6.428a1.072 1.072 0 0 0 0-2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var Square2_default = SvgSquare2;

// src/Icon/icons/Square3.tsx
import { jsx as jsx1178 } from "react/jsx-runtime";
var SvgSquare3 = (props) => /* @__PURE__ */ jsx1178(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1178(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Zm-6.91-8.906 2.279-2.09a1.071 1.071 0 0 0-.726-1.861H8.786c-.59 0-1.072.482-1.072 1.071 0 .59.482 1.072 1.072 1.072h2.96L9.49 10.495a1.072 1.072 0 0 0 .723 1.862h2.322a1.61 1.61 0 0 1 1.607 1.607 1.61 1.61 0 0 1-1.607 1.607h-1.991a.78.78 0 0 1-.741-.534 1.084 1.084 0 0 0-1.358-.68 1.072 1.072 0 0 0-.678 1.356 2.923 2.923 0 0 0 2.777 2.001h1.99a3.755 3.755 0 0 0 3.75-3.75 3.756 3.756 0 0 0-3.339-3.727Z",
        fill: "currentColor"
      }
    )
  })
);
var Square3_default = SvgSquare3;

// src/Icon/icons/Square4.tsx
import { jsx as jsx1179 } from "react/jsx-runtime";
var SvgSquare4 = (props) => /* @__PURE__ */ jsx1179(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1179(
      "path",
      {
        d: "M15.214 12.714h-.357v-2.263a1.072 1.072 0 0 0-2.143 0v2.263H9.79l2.124-4.933a1.07 1.07 0 0 0-.56-1.407c-.546-.236-1.175.014-1.448.559l-2.768 6.429c-.142.332-.108.711.09 1.013.198.3.571.482.933.482h4.553v1.786a1.072 1.072 0 0 0 2.143 0v-1.786h.357c.594 0 1.072-.477 1.072-1.071s-.478-1.072-1.072-1.072ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var Square4_default = SvgSquare4;

// src/Icon/icons/Square5.tsx
import { jsx as jsx1180 } from "react/jsx-runtime";
var SvgSquare5 = (props) => /* @__PURE__ */ jsx1180(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1180(
      "path",
      {
        d: "m13.17 10.679-2.76-.322.367-1.928H14.5a1.072 1.072 0 0 0 0-2.143H9.888c-.513 0-.955.366-1.049.87l-.747 3.929c-.056.294.01.594.185.835.176.24.443.396.74.43l3.9.46a1.383 1.383 0 0 1 1.226 1.373c0 .768-.62 1.388-1.424 1.388h-2.174a.78.78 0 0 1-.741-.534c-.188-.56-.835-.858-1.358-.68a1.072 1.072 0 0 0-.678 1.356 2.923 2.923 0 0 0 2.777 2.001h2.213a3.535 3.535 0 0 0 3.528-3.531c0-1.79-1.38-3.295-3.116-3.504ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var Square5_default = SvgSquare5;

// src/Icon/icons/Square6.tsx
import { jsx as jsx1181 } from "react/jsx-runtime";
var SvgSquare6 = (props) => /* @__PURE__ */ jsx1181(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1181(
      "path",
      {
        d: "M4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.857 2.857 0 0 0 19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.858 2.858 0 0 0 4.857 22ZM4.143 4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857ZM12 17.714a4.29 4.29 0 0 0 4.286-4.285c0-1.959-1.328-3.596-3.124-4.106l1.328-1.158a1.073 1.073 0 0 0-1.409-1.616L9.513 9.661c-.571.495-1.799 1.924-1.799 3.768A4.293 4.293 0 0 0 12 17.714Zm-2.094-4.897c.308-.902 1.152-1.531 2.094-1.531 1.182 0 2.143.96 2.143 2.143A2.145 2.145 0 0 1 12 15.57a2.144 2.144 0 0 1-2.143-2.142c0-.21.031-.416.05-.612Z",
        fill: "currentColor"
      }
    )
  })
);
var Square6_default = SvgSquare6;

// src/Icon/icons/Square7.tsx
import { jsx as jsx1182 } from "react/jsx-runtime";
var SvgSquare7 = (props) => /* @__PURE__ */ jsx1182(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1182(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM15.214 6.286H8.786c-.59 0-1.072.482-1.072 1.071 0 .59.482 1.072 1.072 1.072h4.634l-4.15 7.705a1.07 1.07 0 0 0 .436 1.45c.165.09.334.13.468.13.382 0 .75-.203.945-.563l5-9.286c.178-.332.17-.734-.024-1.057-.153-.326-.506-.522-.88-.522Z",
        fill: "currentColor"
      }
    )
  })
);
var Square7_default = SvgSquare7;

// src/Icon/icons/Square8.tsx
import { jsx as jsx1183 } from "react/jsx-runtime";
var SvgSquare8 = (props) => /* @__PURE__ */ jsx1183(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1183(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM15.571 9.5a3.218 3.218 0 0 0-3.214-3.214h-.714A3.218 3.218 0 0 0 8.429 9.5c0 .704.234 1.35.62 1.88a3.546 3.546 0 0 0-1.335 2.763 3.576 3.576 0 0 0 3.572 3.571h1.428a3.575 3.575 0 0 0 3.572-3.571 3.55 3.55 0 0 0-1.335-2.762 3.19 3.19 0 0 0 .62-1.881Zm-3.928-1.071h.714c.59 0 1.072.482 1.072 1.071 0 .59-.483 1.071-1.072 1.071h-.714c-.59 0-1.072-.482-1.072-1.071 0-.59.483-1.071 1.072-1.071Zm1.071 7.142h-1.428a1.43 1.43 0 0 1 0-2.857h1.428a1.43 1.43 0 0 1 0 2.857Z",
        fill: "currentColor"
      }
    )
  })
);
var Square8_default = SvgSquare8;

// src/Icon/icons/Square9.tsx
import { jsx as jsx1184 } from "react/jsx-runtime";
var SvgSquare9 = (props) => /* @__PURE__ */ jsx1184(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1184(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM12 6.286a4.293 4.293 0 0 0-4.286 4.285c0 1.959 1.328 3.595 3.124 4.106L9.51 15.835a1.073 1.073 0 0 0 1.409 1.616l3.569-3.112c.57-.495 1.798-1.924 1.798-3.768A4.293 4.293 0 0 0 12 6.286Zm2.054 4.897A2.154 2.154 0 0 1 12 12.714a2.143 2.143 0 1 1 2.054-1.531Z",
        fill: "currentColor"
      }
    )
  })
);
var Square9_default = SvgSquare9;

// src/Icon/icons/SquareALock.tsx
import { jsx as jsx1185 } from "react/jsx-runtime";
var SvgSquareALock = (props) => /* @__PURE__ */ jsx1185(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1185(
      "path",
      {
        d: "M3.667 5.889V17c0 .306.248.556.555.556h8.89v1.666h-8.89A2.223 2.223 0 0 1 2 17V5.889c0-1.228.995-2.222 2.222-2.222h11.111c1.226 0 2.223.994 2.223 2.222v2.26a3.88 3.88 0 0 0-1.667.66v-2.92a.556.556 0 0 0-.556-.556H4.223a.555.555 0 0 0-.556.556Zm6.868 1.594 2.86 6.205c-.211.322-.284.694-.284 1.09v1.11a.837.837 0 0 1-.757-.482l-.416-.937h-4.32l-.417.937c-.194.417-.718.597-1.107.406-.417-.194-.597-.718-.407-1.107l3.334-7.222A.83.83 0 0 1 9.778 7a.83.83 0 0 1 .757.483Zm-2.177 5.32h2.809l-1.39-2.98-1.42 2.98Zm9.753-3.58A2.777 2.777 0 0 1 20.89 12v1.667A1.11 1.11 0 0 1 22 14.777v4.445a1.11 1.11 0 0 1-1.111 1.111h-5.556a1.11 1.11 0 0 1-1.11-1.11v-4.445a1.11 1.11 0 0 1 1.11-1.111V12a2.777 2.777 0 0 1 2.778-2.778Zm0 1.666A1.11 1.11 0 0 0 17 12v1.667h2.222V12a1.11 1.11 0 0 0-1.11-1.111Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareALock_default = SvgSquareALock;

// src/Icon/icons/SquareA.tsx
import { jsx as jsx1186 } from "react/jsx-runtime";
var SvgSquareA = (props) => /* @__PURE__ */ jsx1186(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1186(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM12.973 6.857c-.35-.762-1.596-.762-1.946 0l-4.286 9.33c-.248.54-.013 1.18.524 1.429a1.07 1.07 0 0 0 1.422-.526l.537-1.169h5.55l.536 1.17a1.07 1.07 0 0 0 1.423.525c.537-.248.771-.889.523-1.428l-4.283-9.33Zm-2.799 6.91L12 9.88l1.787 3.89h-3.613v-.001Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareA_default = SvgSquareA;

// src/Icon/icons/SquareAmpersand.tsx
import { jsx as jsx1187 } from "react/jsx-runtime";
var SvgSquareAmpersand = (props) => /* @__PURE__ */ jsx1187(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1187(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Zm-4.486-4.496 1.256-1.844a1.071 1.071 0 1 0-1.772-1.207l-.971 1.426-1.328-1.452.88-.71a2.567 2.567 0 0 0 .955-2.002 2.576 2.576 0 0 0-2.574-2.572h-1.031A2.58 2.58 0 0 0 8.21 8.862c0 .73.27 1.43.764 1.97l.462.506-1.329 1.073A2.978 2.978 0 0 0 7 14.732c0 1.643 1.3 2.982 2.982 2.982h1.45a3.489 3.489 0 0 0 2.685-1.258l.832.91c.212.232.502.348.792.348a1.072 1.072 0 0 0 .791-1.794l-1.162-1.273ZM10.785 8.43h1.032a.432.432 0 0 1 .27.766l-.98.792-.55-.603a.785.785 0 0 1-.205-.522c0-.241.196-.433.433-.433Zm1.763 6.553c-.25.37-.67.59-1.116.59h-1.45c-.46 0-.84-.38-.84-.84 0-.255.113-.494.312-.653l1.433-1.16 1.758 1.924-.097.14Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareAmpersand_default = SvgSquareAmpersand;

// src/Icon/icons/SquareArrowDownLeft.tsx
import { jsx as jsx1188 } from "react/jsx-runtime";
var SvgSquareArrowDownLeft = (props) => /* @__PURE__ */ jsx1188(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1188(
      "path",
      {
        d: "m15.17 7.313-6.027 6.03V8.997a1.072 1.072 0 0 0-2.143 0v6.933C7 16.52 7.48 17 8.071 17h6.934a1.072 1.072 0 0 0 0-2.143h-4.349l6.027-6.027a1.071 1.071 0 0 0-1.513-1.518ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareArrowDownLeft_default = SvgSquareArrowDownLeft;

// src/Icon/icons/SquareArrowDownRight.tsx
import { jsx as jsx1189 } from "react/jsx-runtime";
var SvgSquareArrowDownRight = (props) => /* @__PURE__ */ jsx1189(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1189(
      "path",
      {
        d: "M15.929 7.924c-.592 0-1.072.48-1.072 1.072v4.345L8.79 7.313a1.071 1.071 0 1 0-1.515 1.515l6.069 6.03H8.996a1.072 1.072 0 0 0 0 2.142h6.933C16.52 17 17 16.52 17 15.929V8.996c0-.59-.478-1.072-1.071-1.072ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareArrowDownRight_default = SvgSquareArrowDownRight;

// src/Icon/icons/SquareArrowDown.tsx
import { jsx as jsx1190 } from "react/jsx-runtime";
var SvgSquareArrowDown = (props) => /* @__PURE__ */ jsx1190(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1190(
      "path",
      {
        d: "m15.857 10.915-2.786 3V7.358a1.072 1.072 0 0 0-2.142 0v6.558l-2.786-3a1.071 1.071 0 0 0-1.571 1.455l4.642 5c.165.22.487.344.786.344.3 0 .582-.124.786-.341l4.643-5a1.07 1.07 0 1 0-1.571-1.457ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareArrowDown_default = SvgSquareArrowDown;

// src/Icon/icons/SquareArrowLeft.tsx
import { jsx as jsx1191 } from "react/jsx-runtime";
var SvgSquareArrowLeft = (props) => /* @__PURE__ */ jsx1191(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1191(
      "path",
      {
        d: "M16.643 10.929h-6.558l3-2.787a1.073 1.073 0 0 0-1.46-1.57l-5 4.642c-.215.165-.34.487-.34.786 0 .3.125.582.343.786l5 4.643a1.073 1.073 0 0 0 1.46-1.571l-3.003-2.787h6.558a1.072 1.072 0 0 0 0-2.142ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.858 2.858 0 0 0 4.857 22h14.286A2.858 2.858 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareArrowLeft_default = SvgSquareArrowLeft;

// src/Icon/icons/SquareArrowRight.tsx
import { jsx as jsx1192 } from "react/jsx-runtime";
var SvgSquareArrowRight = (props) => /* @__PURE__ */ jsx1192(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1192(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.858 2.858 0 0 0 4.857 22h14.286A2.858 2.858 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM12.371 6.57a1.073 1.073 0 0 0-1.46 1.571l3 2.787H7.358a1.072 1.072 0 0 0 0 2.142h6.558l-3 2.787a1.073 1.073 0 0 0 1.46 1.57l5-4.642a1.11 1.11 0 0 0 .34-.826c0-.34-.125-.582-.343-.786L12.37 6.571Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareArrowRight_default = SvgSquareArrowRight;

// src/Icon/icons/SquareArrowUpLeft.tsx
import { jsx as jsx1193 } from "react/jsx-runtime";
var SvgSquareArrowUpLeft = (props) => /* @__PURE__ */ jsx1193(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1193(
      "path",
      {
        d: "M10.656 9.143h4.346a1.072 1.072 0 0 0 0-2.143h-6.93C7.481 7 7 7.482 7 8.071v6.934a1.072 1.072 0 0 0 2.143 0v-4.349l6.027 6.027c.21.214.482.317.759.317a1.071 1.071 0 0 0 .758-1.83l-6.03-6.027ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareArrowUpLeft_default = SvgSquareArrowUpLeft;

// src/Icon/icons/SquareArrowUpRight.tsx
import { jsx as jsx1194 } from "react/jsx-runtime";
var SvgSquareArrowUpRight = (props) => /* @__PURE__ */ jsx1194(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1194(
      "path",
      {
        d: "M15.929 7H8.996a1.072 1.072 0 0 0 0 2.143h4.345L7.314 15.17a1.071 1.071 0 0 0 0 1.515c.208.212.48.315.757.315s.549-.105.758-.314l6.028-6.03v4.346a1.072 1.072 0 0 0 2.143 0v-6.93C17 7.481 16.522 7 15.929 7Zm3.214-5H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareArrowUpRight_default = SvgSquareArrowUpRight;

// src/Icon/icons/SquareArrowUp.tsx
import { jsx as jsx1195 } from "react/jsx-runtime";
var SvgSquareArrowUp = (props) => /* @__PURE__ */ jsx1195(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1195(
      "path",
      {
        d: "M12.786 6.63a1.099 1.099 0 0 0-.826-.344c-.34 0-.58.125-.746.343l-4.643 5a1.073 1.073 0 0 0 1.571 1.46l2.787-3v6.554a1.072 1.072 0 0 0 2.142 0v-6.558l2.787 3a1.073 1.073 0 0 0 1.57-1.46L12.787 6.63ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareArrowUp_default = SvgSquareArrowUp;

// src/Icon/icons/SquareB.tsx
import { jsx as jsx1196 } from "react/jsx-runtime";
var SvgSquareB = (props) => /* @__PURE__ */ jsx1196(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1196(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Zm-4.2-7.51a3.37 3.37 0 0 0 .629-1.954 3.397 3.397 0 0 0-3.393-3.393H8.786c-.59 0-1.072.482-1.072 1.071v9.286c0 .594.482 1.071 1.072 1.071h4.821A3.397 3.397 0 0 0 17 14.321a3.376 3.376 0 0 0-1.344-2.687Zm-5.8-3.204h3.036c.69 0 1.25.56 1.25 1.25 0 .689-.563 1.25-1.25 1.25H9.857v-2.5Zm3.75 7.142h-3.75v-2.5h3.75c.688 0 1.25.563 1.25 1.25 0 .688-.562 1.25-1.25 1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareB_default = SvgSquareB;

// src/Icon/icons/SquareBolt.tsx
import { jsx as jsx1197 } from "react/jsx-runtime";
var SvgSquareBolt = (props) => /* @__PURE__ */ jsx1197(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1197(
      "path",
      {
        d: "M14.571 6.429c.264.196.358.549.228.852l-1.714 4.005h2.844c.303 0 .571.187.674.473.098.245.013.603-.22.795l-6.07 5a.724.724 0 0 1-.884.017.714.714 0 0 1-.228-.852l1.714-4.045H8.071c-.303 0-.571-.147-.674-.433a.724.724 0 0 1 .22-.795l6.07-5c.255-.245.621-.214.884-.017ZM2 4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857Zm2.143 0v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714H4.857a.714.714 0 0 0-.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareBolt_default = SvgSquareBolt;

// src/Icon/icons/SquareC.tsx
import { jsx as jsx1198 } from "react/jsx-runtime";
var SvgSquareC = (props) => /* @__PURE__ */ jsx1198(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1198(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Zm-5.406-9.71a1.068 1.068 0 0 0 1.515.007c.421-.42.424-1.1.008-1.522-2.146-2.174-5.853-2.174-7.996 0-2.208 2.237-2.208 5.88 0 8.111a5.464 5.464 0 0 0 3.982 1.685 5.678 5.678 0 0 0 4.017-1.684 1.08 1.08 0 0 0-.007-1.523c-.42-.42-1.099-.415-1.515.006a3.476 3.476 0 0 1-2.495 1.048 3.479 3.479 0 0 1-2.494-1.048 3.629 3.629 0 0 1 0-5.08c1.333-1.353 3.655-1.353 4.985 0Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareC_default = SvgSquareC;

// src/Icon/icons/SquareCaretDown.tsx
import { jsx as jsx1199 } from "react/jsx-runtime";
var SvgSquareCaretDown = (props) => /* @__PURE__ */ jsx1199(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1199(
      "path",
      {
        d: "M16.286 9.143H7.714c-.424 0-.812.254-1.022.643-.13.388-.054.844.237 1.156l4.285 4.643a1.067 1.067 0 0 0 1.573-.001l4.285-4.643a1.073 1.073 0 0 0-.786-1.798ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareCaretDown_default = SvgSquareCaretDown;

// src/Icon/icons/SquareCaretLeft.tsx
import { jsx as jsx1200 } from "react/jsx-runtime";
var SvgSquareCaretLeft = (props) => /* @__PURE__ */ jsx1200(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1200(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.858 2.858 0 0 0 4.857 22h14.286A2.858 2.858 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Zm-5.643-12.41a1.073 1.073 0 0 0-1.156.194l-4.643 4.286a1.073 1.073 0 0 0 .001 1.574l4.643 4.285a1.073 1.073 0 0 0 1.798-.786V7.714c0-.424-.254-.812-.643-.982Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareCaretLeft_default = SvgSquareCaretLeft;

// src/Icon/icons/SquareCaretRight.tsx
import { jsx as jsx1201 } from "react/jsx-runtime";
var SvgSquareCaretRight = (props) => /* @__PURE__ */ jsx1201(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1201(
      "path",
      {
        d: "M10.942 6.929a1.071 1.071 0 0 0-1.156-.197c-.389.17-.643.558-.643.942v8.572c0 .464.254.852.643 1.022.389.17.844.093 1.156-.195l4.643-4.286a1.073 1.073 0 0 0-.001-1.574L10.942 6.93ZM19.142 2H4.858A2.857 2.857 0 0 0 2 4.857v14.286A2.858 2.858 0 0 0 4.857 22h14.286A2.858 2.858 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.715 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareCaretRight_default = SvgSquareCaretRight;

// src/Icon/icons/SquareCaretUp.tsx
import { jsx as jsx1202 } from "react/jsx-runtime";
var SvgSquareCaretUp = (props) => /* @__PURE__ */ jsx1202(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1202(
      "path",
      {
        d: "M12.786 8.415a1.067 1.067 0 0 0-1.572 0L6.93 13.058a1.073 1.073 0 0 0-.196 1.157c.169.388.557.642.941.642h8.572a1.073 1.073 0 0 0 .787-1.799l-4.247-4.643ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareCaretUp_default = SvgSquareCaretUp;

// src/Icon/icons/SquareCheck.tsx
import { jsx as jsx1203 } from "react/jsx-runtime";
var SvgSquareCheck = (props) => /* @__PURE__ */ jsx1203(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1203(
      "path",
      {
        d: "M11.455 15.741a1.253 1.253 0 0 1-1.768 0L6.83 12.884a1.25 1.25 0 0 1 1.768-1.768l1.973 1.973 4.83-4.83a1.253 1.253 0 0 1 1.769 0 1.253 1.253 0 0 1 0 1.768l-5.715 5.714ZM2 4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857Zm2.143 0v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714H4.857a.714.714 0 0 0-.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareCheck_default = SvgSquareCheck;

// src/Icon/icons/SquareChevronDown.tsx
import { jsx as jsx1204 } from "react/jsx-runtime";
var SvgSquareChevronDown = (props) => /* @__PURE__ */ jsx1204(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1204(
      "path",
      {
        d: "M16.241 9.813 12 14.058 7.719 9.813a1.071 1.071 0 1 0-1.515 1.515l5 5c.247.212.52.315.796.315.277 0 .548-.105.758-.314l5-5a1.071 1.071 0 1 0-1.517-1.517ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareChevronDown_default = SvgSquareChevronDown;

// src/Icon/icons/SquareChevronLeft.tsx
import { jsx as jsx1205 } from "react/jsx-runtime";
var SvgSquareChevronLeft = (props) => /* @__PURE__ */ jsx1205(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1205(
      "path",
      {
        d: "M14.147 16.241 9.942 12l4.242-4.242a1.071 1.071 0 1 0-1.515-1.516l-5 5a1.06 1.06 0 0 0-.312.758c0 .277.105.548.314.758l5 5a1.071 1.071 0 0 0 1.515 0 1.042 1.042 0 0 0-.039-1.517ZM22 19.143V4.857A2.857 2.857 0 0 0 19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.86 2.86 0 0 0 22 19.143Zm-17.143.714a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286c0 .394-.32.714-.714.714H4.857Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareChevronLeft_default = SvgSquareChevronLeft;

// src/Icon/icons/SquareChevronRight.tsx
import { jsx as jsx1206 } from "react/jsx-runtime";
var SvgSquareChevronRight = (props) => /* @__PURE__ */ jsx1206(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1206(
      "path",
      {
        d: "M11.29 6.241a1.071 1.071 0 1 0-1.515 1.515L14.058 12l-4.242 4.242a1.071 1.071 0 1 0 1.515 1.516l5-5c.21-.209.312-.481.312-.758s-.105-.548-.314-.758l-5.039-5ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.858 2.858 0 0 0 4.857 22h14.286A2.858 2.858 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareChevronRight_default = SvgSquareChevronRight;

// src/Icon/icons/SquareChevronUp.tsx
import { jsx as jsx1207 } from "react/jsx-runtime";
var SvgSquareChevronUp = (props) => /* @__PURE__ */ jsx1207(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1207(
      "path",
      {
        d: "M4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.857 2.857 0 0 0 19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.858 2.858 0 0 0 4.857 22ZM4.143 4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857Zm3.576 9.29L12 9.942l4.242 4.242a1.071 1.071 0 1 0 1.516-1.515l-5-5A1.06 1.06 0 0 0 12 7.357c-.277 0-.55.103-.759.313l-5 5a1.071 1.071 0 0 0 0 1.515c.419.419 1.098.418 1.478-.038Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareChevronUp_default = SvgSquareChevronUp;

// src/Icon/icons/SquareCode.tsx
import { jsx as jsx1208 } from "react/jsx-runtime";
var SvgSquareCode = (props) => /* @__PURE__ */ jsx1208(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1208(
      "path",
      {
        d: "m14.862 8.384 2.857 2.857c.455.42.455 1.098 0 1.478l-2.857 2.857c-.38.455-1.058.455-1.478 0-.415-.38-.415-1.058 0-1.478L15.487 12l-2.103-2.138c-.415-.38-.415-1.058 0-1.478.42-.415 1.098-.415 1.478 0ZM8.513 12l2.063 2.098c.455.42.455 1.098 0 1.478-.38.455-1.058.455-1.478 0l-2.856-2.857c-.418-.38-.418-1.058 0-1.478l2.856-2.857c.42-.415 1.098-.415 1.478 0 .455.42.455 1.098 0 1.478L8.513 12Zm10.63-10A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857A2.857 2.857 0 0 1 4.857 2h14.286Zm0 2.143H4.857a.714.714 0 0 0-.714.714v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareCode_default = SvgSquareCode;

// src/Icon/icons/SquareD.tsx
import { jsx as jsx1209 } from "react/jsx-runtime";
var SvgSquareD = (props) => /* @__PURE__ */ jsx1209(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1209(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM11.93 6.286H8.786c-.59 0-1.072.482-1.072 1.071v9.286c0 .594.482 1.071 1.072 1.071h3.143c3.191 0 5.785-2.562 5.785-5.714 0-3.152-2.593-5.714-5.785-5.714Zm0 9.285H9.857V8.43h2.072c2.008 0 3.642 1.602 3.642 3.571s-1.633 3.571-3.642 3.571Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareD_default = SvgSquareD;

// src/Icon/icons/SquareDashedCirclePlus.tsx
import { jsx as jsx1210 } from "react/jsx-runtime";
var SvgSquareDashedCirclePlus = (props) => /* @__PURE__ */ jsx1210(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1210(
      "path",
      {
        d: "M5.611 3.667h-.555A3.056 3.056 0 0 0 2 6.722v.556c0 .462.372.833.833.833a.831.831 0 0 0 .834-.833v-.556c0-.767.621-1.389 1.389-1.389h.555a.831.831 0 0 0 .833-.833.831.831 0 0 0-.833-.833ZM2 12.833c0 .462.372.834.833.834a.831.831 0 0 0 .834-.834v-2.777a.831.831 0 0 0-.834-.834.831.831 0 0 0-.833.834v2.777Zm.833 1.945A.831.831 0 0 0 2 15.61v.556a3.056 3.056 0 0 0 3.056 3.055h.555a.831.831 0 0 0 .833-.833.831.831 0 0 0-.833-.833h-.555a1.389 1.389 0 0 1-1.39-1.39v-.555a.831.831 0 0 0-.833-.833Zm13.89-5.556a.831.831 0 0 0 .833-.833V6.722A3.056 3.056 0 0 0 14.5 3.667h-.556a.831.831 0 0 0-.833.833c0 .462.372.833.833.833h.556c.767 0 1.389.622 1.389 1.39v1.666c0 .462.371.833.833.833Zm-5.834 9.167a.831.831 0 0 0-.833-.833H8.389a.831.831 0 0 0-.833.833c0 .462.371.833.833.833h1.667a.831.831 0 0 0 .833-.833Zm.278-13.056A.831.831 0 0 0 12 4.5a.831.831 0 0 0-.833-.833H8.389a.831.831 0 0 0-.833.833c0 .462.371.833.833.833h2.778Zm5.833 15a5 5 0 1 0 0-9.999 5 5 0 0 0 0 10Zm.556-7.222v1.667h1.666c.306 0 .556.25.556.555 0 .306-.25.556-.556.556h-1.666v1.667c0 .305-.25.555-.556.555a.557.557 0 0 1-.556-.555v-1.667h-1.666a.557.557 0 0 1-.556-.556c0-.305.25-.555.556-.555h1.666V13.11c0-.305.25-.555.556-.555.306 0 .556.25.556.555Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareDashedCirclePlus_default = SvgSquareDashedCirclePlus;

// src/Icon/icons/SquareDashed.tsx
import { jsx as jsx1211 } from "react/jsx-runtime";
var SvgSquareDashed = (props) => /* @__PURE__ */ jsx1211(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1211(
      "path",
      {
        d: "M5.929 2h.714a1.07 1.07 0 1 1 0 2.143h-.714c-.987 0-1.786.8-1.786 1.786v.714a1.07 1.07 0 1 1-2.143 0v-.714A3.929 3.929 0 0 1 5.929 2Zm-1.786 8.214v3.572a1.07 1.07 0 1 1-2.143 0v-3.572a1.07 1.07 0 1 1 2.143 0Zm17.857 0v3.572c0 .594-.478 1.071-1.071 1.071a1.069 1.069 0 0 1-1.072-1.071v-3.572c0-.593.478-1.071 1.072-1.071.593 0 1.071.478 1.071 1.071Zm-2.143-3.571v-.714c0-.987-.799-1.786-1.786-1.786h-.714a1.07 1.07 0 1 1 0-2.143h.714A3.929 3.929 0 0 1 22 5.929v.714c0 .594-.478 1.071-1.071 1.071a1.069 1.069 0 0 1-1.072-1.071ZM22 18.07A3.929 3.929 0 0 1 18.071 22h-.714a1.069 1.069 0 0 1-1.071-1.071c0-.594.477-1.072 1.071-1.072h.714c.987 0 1.786-.799 1.786-1.786v-.714c0-.594.478-1.071 1.072-1.071.593 0 1.071.477 1.071 1.071v.714Zm-17.857 0c0 .987.8 1.786 1.786 1.786h.714c.594 0 1.071.478 1.071 1.072 0 .593-.477 1.071-1.071 1.071h-.714A3.929 3.929 0 0 1 2 18.071v-.714a1.07 1.07 0 1 1 2.143 0v.714ZM10.214 22a1.069 1.069 0 0 1-1.071-1.071c0-.594.478-1.072 1.071-1.072h3.572c.594 0 1.071.478 1.071 1.072 0 .593-.477 1.071-1.071 1.071h-3.572Zm0-20h3.572a1.07 1.07 0 1 1 0 2.143h-3.572a1.07 1.07 0 1 1 0-2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareDashed_default = SvgSquareDashed;

// src/Icon/icons/SquareDownLeft.tsx
import { jsx as jsx1212 } from "react/jsx-runtime";
var SvgSquareDownLeft = (props) => /* @__PURE__ */ jsx1212(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1212(
      "path",
      {
        d: "M16.295 9.728a1.072 1.072 0 0 0 0-1.515l-.505-.508a1.072 1.072 0 0 0-1.515 0l-2.887 2.884-1.884-1.848c-.165-.205-.441-.312-.718-.312A1.068 1.068 0 0 0 7.715 9.5v5.714c0 .594.481 1.072 1.07 1.072H14.5a1.071 1.071 0 0 0 .758-1.83L13.41 12.61l2.884-2.881ZM22 19.143V4.857A2.857 2.857 0 0 0 19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.86 2.86 0 0 0 22 19.143Zm-2.143 0c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareDownLeft_default = SvgSquareDownLeft;

// src/Icon/icons/SquareDownRight.tsx
import { jsx as jsx1213 } from "react/jsx-runtime";
var SvgSquareDownRight = (props) => /* @__PURE__ */ jsx1213(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1213(
      "path",
      {
        d: "M10.59 12.612 8.74 14.455a1.072 1.072 0 0 0 .759 1.83h5.714c.592 0 1.072-.48 1.072-1.07V9.5a1.072 1.072 0 0 0-1.83-.758L12.61 10.59 9.728 7.705a1.071 1.071 0 0 0-1.515 0l-.508.505a1.08 1.08 0 0 0 0 1.518l2.884 2.884ZM4.856 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.857 2.857 0 0 0 19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.858 2.858 0 0 0 4.857 22ZM4.143 4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareDownRight_default = SvgSquareDownRight;

// src/Icon/icons/SquareDown.tsx
import { jsx as jsx1214 } from "react/jsx-runtime";
var SvgSquareDown = (props) => /* @__PURE__ */ jsx1214(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1214(
      "path",
      {
        d: "M15.929 11.286h-2.5V7.357c0-.59-.478-1.071-1.072-1.071h-.714c-.59 0-1.072.482-1.072 1.071v3.929h-2.5a1.072 1.072 0 0 0-.786 1.8l3.963 4.284a1.076 1.076 0 0 0 1.58-.006l3.895-4.286a1.072 1.072 0 0 0-.794-1.792ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareDown_default = SvgSquareDown;

// src/Icon/icons/SquareE.tsx
import { jsx as jsx1215 } from "react/jsx-runtime";
var SvgSquareE = (props) => /* @__PURE__ */ jsx1215(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1215(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM15.214 8.429c.594 0 1.072-.478 1.072-1.072 0-.594-.478-1.071-1.072-1.071H8.786c-.59 0-1.072.482-1.072 1.071v9.286c0 .594.482 1.071 1.072 1.071h6.428a1.072 1.072 0 0 0 0-2.143H9.857v-2.5h3.929c.594 0 1.071-.477 1.071-1.071a1.07 1.07 0 0 0-1.071-1.071H9.857v-2.5h5.357Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareE_default = SvgSquareE;

// src/Icon/icons/SquareEllipsisVertical.tsx
import { jsx as jsx1216 } from "react/jsx-runtime";
var SvgSquareEllipsisVertical = (props) => /* @__PURE__ */ jsx1216(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1216(
      "path",
      {
        d: "M10.571 12c0-.79.639-1.429 1.429-1.429s1.429.639 1.429 1.429-.639 1.429-1.429 1.429-1.429-.639-1.429-1.429Zm2.858-4.286c0 .79-.639 1.429-1.429 1.429s-1.429-.639-1.429-1.429S11.21 6.286 12 6.286s1.429.638 1.429 1.428Zm-2.858 8.572c0-.79.639-1.429 1.429-1.429s1.429.639 1.429 1.429-.639 1.428-1.429 1.428-1.429-.638-1.429-1.428ZM2 4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857Zm2.143 0v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714H4.857a.714.714 0 0 0-.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareEllipsisVertical_default = SvgSquareEllipsisVertical;

// src/Icon/icons/SquareEllipsis.tsx
import { jsx as jsx1217 } from "react/jsx-runtime";
var SvgSquareEllipsis = (props) => /* @__PURE__ */ jsx1217(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1217(
      "path",
      {
        d: "M12 13.429c-.79 0-1.429-.639-1.429-1.429s.639-1.429 1.429-1.429 1.429.639 1.429 1.429-.639 1.429-1.429 1.429ZM7.714 10.57c.79 0 1.429.639 1.429 1.429s-.639 1.429-1.429 1.429S6.286 12.79 6.286 12s.638-1.429 1.428-1.429Zm8.572 2.858c-.79 0-1.429-.639-1.429-1.429s.639-1.429 1.429-1.429 1.428.639 1.428 1.429-.638 1.429-1.428 1.429ZM4.857 22A2.858 2.858 0 0 1 2 19.143V4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857Zm0-2.143h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714H4.857a.714.714 0 0 0-.714.714v14.286c0 .393.32.714.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareEllipsis_default = SvgSquareEllipsis;

// src/Icon/icons/SquareEnvelope.tsx
import { jsx as jsx1218 } from "react/jsx-runtime";
var SvgSquareEnvelope = (props) => /* @__PURE__ */ jsx1218(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1218(
      "path",
      {
        d: "M12 13.429c-.13 0-.219-.018-.263-.05l-5.451-2.183v3.661c0 .789.64 1.429 1.428 1.429h8.572c.789 0 1.428-.64 1.428-1.429v-3.66l-5.45 2.179a.694.694 0 0 1-.264.053Zm4.286-5.715H7.714c-.79 0-1.428.639-1.428 1.429v.516L12 11.945l5.714-2.286v-.516c0-.79-.638-1.429-1.428-1.429ZM19.143 2H4.857A2.866 2.866 0 0 0 2 4.857v14.286A2.866 2.866 0 0 0 4.857 22h14.286A2.866 2.866 0 0 0 22 19.143V4.857A2.866 2.866 0 0 0 19.143 2Zm.714 17.143a.724.724 0 0 1-.714.714H4.857a.724.724 0 0 1-.714-.714V4.857c0-.387.327-.714.714-.714h14.286c.387 0 .714.327.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareEnvelope_default = SvgSquareEnvelope;

// src/Icon/icons/SquareExclamation.tsx
import { jsx as jsx1219 } from "react/jsx-runtime";
var SvgSquareExclamation = (props) => /* @__PURE__ */ jsx1219(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1219(
      "path",
      {
        d: "M12 15.62a1.404 1.404 0 1 0 0 2.808 1.404 1.404 0 0 0 0-2.808Zm0-1.477c.591 0 1.071-.48 1.071-1.072V7.357a1.072 1.072 0 0 0-2.142 0v5.714c0 .594.482 1.072 1.071 1.072ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareExclamation_default = SvgSquareExclamation;

// src/Icon/icons/SquareF.tsx
import { jsx as jsx1220 } from "react/jsx-runtime";
var SvgSquareF = (props) => /* @__PURE__ */ jsx1220(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1220(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM15.214 6.286H8.786c-.59 0-1.072.482-1.072 1.071v9.286a1.072 1.072 0 0 0 2.143 0v-3.214h3.929c.594 0 1.071-.478 1.071-1.072 0-.594-.477-1.071-1.071-1.071H9.857V8.429h5.357c.594 0 1.072-.478 1.072-1.072 0-.594-.478-1.071-1.072-1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareF_default = SvgSquareF;

// src/Icon/icons/SquareFull.tsx
import { jsx as jsx1221 } from "react/jsx-runtime";
var SvgSquareFull = (props) => /* @__PURE__ */ jsx1221(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1221(
      "path",
      {
        d: "M22 2v20H2V2h20Zm-1.875 1.875H3.875v16.25h16.25V3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareFull_default = SvgSquareFull;

// src/Icon/icons/SquareG.tsx
import { jsx as jsx1222 } from "react/jsx-runtime";
var SvgSquareG = (props) => /* @__PURE__ */ jsx1222(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1222(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Zm-3.214-7.857H13.07c-.589 0-1.071.482-1.071 1.071 0 .59.482 1.072 1.071 1.072h2.254c-.189.383-.46.757-.8 1.097-1.348 1.349-3.703 1.349-5.05 0a3.579 3.579 0 0 1 0-5.054c1.35-1.347 3.6-1.41 5.025-.133a1.071 1.071 0 0 0 1.429-1.596c-2.256-2.022-5.83-1.922-7.969.218a5.72 5.72 0 0 0 0 8.08A5.676 5.676 0 0 0 12 17.714a5.675 5.675 0 0 0 4.04-1.673c.872-.873 1.46-1.94 1.656-3.003a.911.911 0 0 0 .018-.194v-.487c0-.59-.477-1.071-1.071-1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareG_default = SvgSquareG;

// src/Icon/icons/SquareH.tsx
import { jsx as jsx1223 } from "react/jsx-runtime";
var SvgSquareH = (props) => /* @__PURE__ */ jsx1223(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1223(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM15.93 6.286c-.59 0-1.072.482-1.072 1.071v3.572H9.143V7.357a1.072 1.072 0 0 0-2.143 0v9.286a1.072 1.072 0 0 0 2.143 0V13.07h5.714v3.572a1.072 1.072 0 0 0 2.143 0V7.357c0-.59-.478-1.071-1.071-1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareH_default = SvgSquareH;

// src/Icon/icons/SquareI.tsx
import { jsx as jsx1224 } from "react/jsx-runtime";
var SvgSquareI = (props) => /* @__PURE__ */ jsx1224(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1224(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM15.214 8.429c.594 0 1.072-.478 1.072-1.072 0-.594-.478-1.071-1.072-1.071H8.786c-.59 0-1.072.482-1.072 1.071 0 .59.482 1.072 1.072 1.072h2.143v7.142H8.786c-.59 0-1.072.483-1.072 1.072 0 .59.482 1.071 1.072 1.071h6.428a1.072 1.072 0 0 0 0-2.143h-2.143V8.43h2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareI_default = SvgSquareI;

// src/Icon/icons/SquareInfo.tsx
import { jsx as jsx1225 } from "react/jsx-runtime";
var SvgSquareInfo = (props) => /* @__PURE__ */ jsx1225(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1225(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Zm-6.071-3.572h-.715v-3.928c0-.59-.477-1.072-1.071-1.072h-1.429c-.589 0-1.071.483-1.071 1.072 0 .59.482 1.071 1.071 1.071h.358v2.857h-.715c-.589 0-1.071.483-1.071 1.072 0 .59.482 1.071 1.071 1.071h3.572a1.072 1.072 0 0 0 0-2.143ZM12 9.143a1.429 1.429 0 1 0 0-2.858 1.429 1.429 0 0 0 0 2.858Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareInfo_default = SvgSquareInfo;

// src/Icon/icons/SquareJ.tsx
import { jsx as jsx1226 } from "react/jsx-runtime";
var SvgSquareJ = (props) => /* @__PURE__ */ jsx1226(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1226(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM14.5 6.286c-.59 0-1.071.482-1.071 1.071v6.192c0 1.116-.96 2.022-2.143 2.022-1.183 0-2.143-.906-2.143-2.022v-.478a1.072 1.072 0 0 0-2.143 0v.477c0 2.296 1.924 4.166 4.286 4.166 2.361 0 4.285-1.868 4.285-4.166v-6.19c0-.59-.477-1.072-1.071-1.072Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareJ_default = SvgSquareJ;

// src/Icon/icons/SquareK.tsx
import { jsx as jsx1227 } from "react/jsx-runtime";
var SvgSquareK = (props) => /* @__PURE__ */ jsx1227(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1227(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Zm-3.88-12.536a1.072 1.072 0 0 0-1.514-.011L9.857 11.13V7.357a1.072 1.072 0 0 0-2.143 0v9.286a1.072 1.072 0 0 0 2.143 0v-2.505l1.38-1.358 3.097 4.474a1.067 1.067 0 0 0 1.49.27 1.071 1.071 0 0 0 .27-1.49L12.88 11.39c-.032-.047-.08-.074-.119-.114l3.205-3.156a1.068 1.068 0 0 0 .012-1.513Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareK_default = SvgSquareK;

// src/Icon/icons/SquareKanban.tsx
import { jsx as jsx1228 } from "react/jsx-runtime";
var SvgSquareKanban = (props) => /* @__PURE__ */ jsx1228(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1228(
      "path",
      {
        d: "M7.714 13.429a1.069 1.069 0 0 1-1.071-1.072v-5c0-.594.478-1.071 1.071-1.071.594 0 1.072.477 1.072 1.071v5c0 .594-.478 1.072-1.072 1.072Zm7.5-6.072c0-.594.478-1.071 1.072-1.071.593 0 1.071.477 1.071 1.071v7.857c0 .594-.477 1.072-1.071 1.072a1.069 1.069 0 0 1-1.072-1.072V7.357ZM12 12a1.069 1.069 0 0 1-1.071-1.071V7.357c0-.594.477-1.071 1.071-1.071s1.071.477 1.071 1.071v3.572c0 .593-.477 1.071-1.071 1.071ZM2 4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857Zm2.857 15h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714H4.857a.714.714 0 0 0-.714.714v14.286c0 .393.32.714.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareKanban_default = SvgSquareKanban;

// src/Icon/icons/SquareL.tsx
import { jsx as jsx1229 } from "react/jsx-runtime";
var SvgSquareL = (props) => /* @__PURE__ */ jsx1229(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1229(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Zm-4.643-3.572H9.857V7.357a1.072 1.072 0 0 0-2.143 0v9.286c0 .594.482 1.071 1.072 1.071h6.428a1.072 1.072 0 0 0 0-2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareL_default = SvgSquareL;

// src/Icon/icons/SquareLeft.tsx
import { jsx as jsx1230 } from "react/jsx-runtime";
var SvgSquareLeft = (props) => /* @__PURE__ */ jsx1230(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1230(
      "path",
      {
        d: "M16.643 10.571h-3.929v-2.5a1.072 1.072 0 0 0-1.8-.786L6.63 11.249c-.22.203-.343.489-.343.788.014.347.128.591.35.792l4.286 3.895a1.072 1.072 0 0 0 1.792-.794v-2.5h3.929c.594 0 1.071-.478 1.071-1.072v-.714c0-.59-.477-1.072-1.071-1.072ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.858 2.858 0 0 0 4.857 22h14.286A2.858 2.858 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareLeft_default = SvgSquareLeft;

// src/Icon/icons/SquareList.tsx
import { jsx as jsx1231 } from "react/jsx-runtime";
var SvgSquareList = (props) => /* @__PURE__ */ jsx1231(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1231(
      "path",
      {
        d: "M7.714 9.143c-.79 0-1.428-.639-1.428-1.429s.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857Zm3.215-1.429c0-.593.477-1.071 1.071-1.071h4.286c.593 0 1.071.478 1.071 1.071 0 .594-.477 1.072-1.071 1.072H12a1.069 1.069 0 0 1-1.071-1.072Zm0 4.286c0-.594.477-1.071 1.071-1.071h4.286c.593 0 1.071.477 1.071 1.071s-.477 1.071-1.071 1.071H12A1.069 1.069 0 0 1 10.929 12Zm0 4.286c0-.594.477-1.072 1.071-1.072h4.286c.593 0 1.071.478 1.071 1.072 0 .593-.477 1.071-1.071 1.071H12a1.069 1.069 0 0 1-1.071-1.071ZM7.714 10.57c.79 0 1.429.639 1.429 1.429s-.639 1.429-1.429 1.429S6.286 12.79 6.286 12s.638-1.429 1.428-1.429Zm0 7.143c-.79 0-1.428-.638-1.428-1.428a1.427 1.427 0 1 1 2.857 0c0 .79-.639 1.428-1.429 1.428ZM2 4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857Zm2.143 0v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714H4.857a.714.714 0 0 0-.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareList_default = SvgSquareList;

// src/Icon/icons/SquareM.tsx
import { jsx as jsx1232 } from "react/jsx-runtime";
var SvgSquareM = (props) => /* @__PURE__ */ jsx1232(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1232(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM16.973 6.339a1.065 1.065 0 0 0-1.198.392L12 11.955 8.228 6.692a1.11 1.11 0 0 0-1.201-.353 1.07 1.07 0 0 0-.741 1.018v9.286a1.072 1.072 0 0 0 2.143 0V10.67l2.703 3.742c.403.558 1.334.558 1.737 0l2.702-3.742v5.973a1.072 1.072 0 0 0 2.143 0V7.357c0-.464-.299-.875-.74-1.018Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareM_default = SvgSquareM;

// src/Icon/icons/SquareMinus.tsx
import { jsx as jsx1233 } from "react/jsx-runtime";
var SvgSquareMinus = (props) => /* @__PURE__ */ jsx1233(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1233(
      "path",
      {
        d: "M15.929 10.929c.593 0 1.071.477 1.071 1.071s-.478 1.071-1.071 1.071H8.07A1.069 1.069 0 0 1 7 12c0-.594.478-1.071 1.071-1.071h7.858ZM2 4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857Zm2.143 0v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714H4.857a.714.714 0 0 0-.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareMinus_default = SvgSquareMinus;

// src/Icon/icons/SquareN.tsx
import { jsx as jsx1234 } from "react/jsx-runtime";
var SvgSquareN = (props) => /* @__PURE__ */ jsx1234(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1234(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM15.214 6.286c-.591 0-1.071.48-1.071 1.071v5.857L9.665 6.746a1.075 1.075 0 0 0-1.2-.413c-.447.14-.75.555-.75 1.024v9.286a1.072 1.072 0 0 0 2.142 0v-5.857l4.478 6.464a1.057 1.057 0 0 0 1.199.415c.448-.138.752-.553.752-1.022V7.357c0-.59-.478-1.071-1.072-1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareN_default = SvgSquareN;

// src/Icon/icons/SquareO.tsx
import { jsx as jsx1235 } from "react/jsx-runtime";
var SvgSquareO = (props) => /* @__PURE__ */ jsx1235(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1235(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM12 6.286A5.72 5.72 0 0 0 6.286 12 5.72 5.72 0 0 0 12 17.714 5.72 5.72 0 0 0 17.714 12 5.72 5.72 0 0 0 12 6.286Zm0 9.285A3.576 3.576 0 0 1 8.429 12 3.576 3.576 0 0 1 12 8.429 3.576 3.576 0 0 1 15.571 12 3.576 3.576 0 0 1 12 15.571Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareO_default = SvgSquareO;

// src/Icon/icons/SquareP.tsx
import { jsx as jsx1236 } from "react/jsx-runtime";
var SvgSquareP = (props) => /* @__PURE__ */ jsx1236(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1236(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM13.071 6.286H8.786c-.59 0-1.072.482-1.072 1.071v9.286a1.072 1.072 0 0 0 2.143 0v-2.5h3.214A3.933 3.933 0 0 0 17 10.214a3.934 3.934 0 0 0-3.929-3.928Zm0 5.714H9.857V8.429h3.214a1.785 1.785 0 1 1 0 3.571Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareP_default = SvgSquareP;

// src/Icon/icons/SquarePlus.tsx
import { jsx as jsx1237 } from "react/jsx-runtime";
var SvgSquarePlus = (props) => /* @__PURE__ */ jsx1237(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1237(
      "path",
      {
        d: "M10.929 15.929V13.07H8.07A1.069 1.069 0 0 1 7 12c0-.594.478-1.071 1.071-1.071h2.858V8.07C10.929 7.478 11.406 7 12 7s1.071.478 1.071 1.071v2.858h2.858c.593 0 1.071.477 1.071 1.071s-.478 1.071-1.071 1.071H13.07v2.858c0 .593-.477 1.071-1.071 1.071a1.069 1.069 0 0 1-1.071-1.071ZM2 4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857Zm2.143 0v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714H4.857a.714.714 0 0 0-.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquarePlus_default = SvgSquarePlus;

// src/Icon/icons/SquareQ.tsx
import { jsx as jsx1238 } from "react/jsx-runtime";
var SvgSquareQ = (props) => /* @__PURE__ */ jsx1238(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1238(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM12 6.286A5.72 5.72 0 0 0 6.286 12 5.72 5.72 0 0 0 12 17.714a5.68 5.68 0 0 0 3.209-.99l.676.676c.209.212.481.314.758.314s.548-.104.757-.314a1.071 1.071 0 0 0 0-1.515l-.676-.676c.624-.914.99-2.021.99-3.209A5.72 5.72 0 0 0 12 6.286Zm3.156 7.352-1.325-1.325a1.071 1.071 0 1 0-1.515 1.515l1.325 1.326A3.542 3.542 0 0 1 12 15.57 3.575 3.575 0 0 1 8.429 12 3.576 3.576 0 0 1 12 8.429 3.576 3.576 0 0 1 15.571 12c0 .594-.16 1.147-.415 1.638Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareQ_default = SvgSquareQ;

// src/Icon/icons/SquareQuestion.tsx
import { jsx as jsx1239 } from "react/jsx-runtime";
var SvgSquareQuestion = (props) => /* @__PURE__ */ jsx1239(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1239(
      "path",
      {
        d: "M13.478 6.286h-2.322c-1.7 0-3.085 1.384-3.085 3.125 0 .58.492 1.071 1.072 1.071.58 0 1.071-.49 1.071-1.071 0-.536.406-.982.942-.982h2.322c.535 0 1.022.446 1.022.982 0 .357-.179.67-.491.848l-2.545 1.518a1.1 1.1 0 0 0-.535.937v.715c0 .58.49 1.071 1.071 1.071.58 0 1.071-.491 1.071-1.071v-.09l2.014-1.25c.977-.58 1.558-1.607 1.558-2.678 0-1.741-1.384-3.125-3.165-3.125ZM12 15.57A1.41 1.41 0 0 0 10.571 17c0 .804.585 1.429 1.429 1.429.763 0 1.429-.625 1.429-1.429s-.666-1.429-1.429-1.429ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareQuestion_default = SvgSquareQuestion;

// src/Icon/icons/SquareQuote.tsx
import { jsx as jsx1240 } from "react/jsx-runtime";
var SvgSquareQuote = (props) => /* @__PURE__ */ jsx1240(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1240(
      "path",
      {
        d: "M15.214 7.714a2.5 2.5 0 1 0 0 5c.123 0 .24-.019.357-.036v.393c0 .591-.48 1.072-1.071 1.072-.59 0-1.071.482-1.071 1.071 0 .59.482 1.072 1.071 1.072a3.218 3.218 0 0 0 3.214-3.215v-2.857c0-1.38-1.12-2.5-2.5-2.5Zm-6.428 0c-1.38 0-2.5 1.12-2.5 2.5s1.12 2.5 2.5 2.5c.12 0 .24-.018.357-.035v.392c0 .59-.482 1.072-1.072 1.072a1.072 1.072 0 0 0 0 2.143 3.218 3.218 0 0 0 3.215-3.215v-2.857c0-1.38-1.12-2.5-2.5-2.5ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareQuote_default = SvgSquareQuote;

// src/Icon/icons/SquareR.tsx
import { jsx as jsx1241 } from "react/jsx-runtime";
var SvgSquareR = (props) => /* @__PURE__ */ jsx1241(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1241(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM17 9.857a3.576 3.576 0 0 0-3.571-3.571H8.786c-.59 0-1.072.482-1.072 1.071v9.286a1.072 1.072 0 0 0 2.143 0v-3.214h2.052l2.796 3.844a1.065 1.065 0 0 0 1.495.236 1.07 1.07 0 0 0 .236-1.496l-1.998-2.748C15.915 12.825 17 11.473 17 9.857Zm-3.571 1.429H9.857V8.429h3.572a1.429 1.429 0 0 1 0 2.857Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareR_default = SvgSquareR;

// src/Icon/icons/SquareRight.tsx
import { jsx as jsx1242 } from "react/jsx-runtime";
var SvgSquareRight = (props) => /* @__PURE__ */ jsx1242(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1242(
      "path",
      {
        d: "M13.08 7.277c-.317-.286-.808-.357-1.156-.183-.348.174-.638.553-.638.937v2.5l-3.929.04c-.59 0-1.071.483-1.071 1.072v.714c0 .594.482 1.072 1.071 1.072l3.929-.04v2.5a1.072 1.072 0 0 0 1.799.787l4.285-3.963c.22-.164.344-.45.344-.749-.014-.347-.128-.591-.35-.792L13.08 7.277ZM19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.858 2.858 0 0 0 4.857 22h14.286A2.858 2.858 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareRight_default = SvgSquareRight;

// src/Icon/icons/SquareRing.tsx
import { jsx as jsx1243 } from "react/jsx-runtime";
var SvgSquareRing = (props) => /* @__PURE__ */ jsx1243(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1243(
      "path",
      {
        d: "M19.143 2H4.857A2.856 2.856 0 0 0 2 4.857v14.286A2.856 2.856 0 0 0 4.857 22h14.286A2.856 2.856 0 0 0 22 19.143V4.857A2.855 2.855 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM12 6.286a5.714 5.714 0 1 0 0 11.427 5.714 5.714 0 0 0 0-11.427Zm0 9.285a3.571 3.571 0 1 1-.001-7.142A3.571 3.571 0 0 1 12 15.571Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareRing_default = SvgSquareRing;

// src/Icon/icons/SquareS.tsx
import { jsx as jsx1244 } from "react/jsx-runtime";
var SvgSquareS = (props) => /* @__PURE__ */ jsx1244(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1244(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Zm-7.571-8.174c-2.228-.616-2.532-.915-2.407-1.62a.892.892 0 0 1 .418-.608c.383-.248 1.376-.575 3.733.025a1.07 1.07 0 1 0 .53-2.075c-2.395-.612-4.217-.528-5.424.248a3.048 3.048 0 0 0-1.364 2.034c-.503 2.83 2.173 3.572 3.943 4.063 2.23.619 2.53.916 2.405 1.62-.058.327-.194.528-.452.673-.807.45-2.611.26-4.49-.478a1.071 1.071 0 1 0-.784 1.995c.817.32 2.45.87 4.045.87.804 0 1.598-.139 2.274-.517.82-.459 1.344-1.208 1.516-2.166.463-2.828-2.171-3.573-3.943-4.064Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareS_default = SvgSquareS;

// src/Icon/icons/SquareShareNodes.tsx
import { jsx as jsx1245 } from "react/jsx-runtime";
var SvgSquareShareNodes = (props) => /* @__PURE__ */ jsx1245(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1245(
      "path",
      {
        d: "M17.714 8.429c0 1.183-.96 2.142-2.143 2.142-.437 0-.843-.129-1.183-.352L10.826 12l3.562 1.781c.34-.223.746-.352 1.183-.352a2.143 2.143 0 0 1 0 4.285 2.146 2.146 0 0 1-2.138-2.013l-3.821-1.91c-.34.222-.746.352-1.183.352a2.143 2.143 0 1 1 1.183-3.933l3.821-1.91c.067-1.162 1-2.014 2.138-2.014 1.184 0 2.143.96 2.143 2.143ZM2 4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857Zm2.143 0v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714H4.857a.714.714 0 0 0-.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareShareNodes_default = SvgSquareShareNodes;

// src/Icon/icons/SquareSlidersVertical.tsx
import { jsx as jsx1246 } from "react/jsx-runtime";
var SvgSquareSlidersVertical = (props) => /* @__PURE__ */ jsx1246(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1246(
      "path",
      {
        d: "M8.429 6.286c.593 0 1.071.477 1.071 1.071v1.429h.714c.594 0 1.072.477 1.072 1.071s-.478 1.072-1.072 1.072H9.5v5.714c0 .594-.478 1.071-1.071 1.071a1.069 1.069 0 0 1-1.072-1.071v-5.714h-.714a1.07 1.07 0 1 1 0-2.143h.714V7.357c0-.594.478-1.071 1.072-1.071Zm8.214 6.785h.714c.594 0 1.072.478 1.072 1.072 0 .594-.478 1.071-1.072 1.071h-.714v1.429c0 .594-.478 1.071-1.072 1.071a1.069 1.069 0 0 1-1.071-1.071v-1.429h-.714a1.069 1.069 0 0 1-1.072-1.071c0-.594.478-1.072 1.072-1.072h.714V7.357c0-.594.478-1.071 1.071-1.071.594 0 1.072.477 1.072 1.071v5.714ZM19.143 2A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857A2.857 2.857 0 0 1 4.857 2h14.286Zm0 2.143H4.857a.714.714 0 0 0-.714.714v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareSlidersVertical_default = SvgSquareSlidersVertical;

// src/Icon/icons/SquareSliders.tsx
import { jsx as jsx1247 } from "react/jsx-runtime";
var SvgSquareSliders = (props) => /* @__PURE__ */ jsx1247(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1247(
      "path",
      {
        d: "M7.357 7.357h1.429v-.714c0-.594.477-1.072 1.071-1.072s1.072.478 1.072 1.072v.714h5.714c.594 0 1.071.478 1.071 1.072 0 .593-.477 1.071-1.071 1.071h-5.714v.714c0 .594-.478 1.072-1.072 1.072a1.069 1.069 0 0 1-1.071-1.072V9.5H7.357a1.069 1.069 0 0 1-1.071-1.071c0-.594.477-1.072 1.071-1.072Zm0 9.286a1.069 1.069 0 0 1-1.071-1.072c0-.593.477-1.071 1.071-1.071h5.714v-.714c0-.594.478-1.072 1.072-1.072.594 0 1.071.478 1.071 1.072v.714h1.429c.594 0 1.071.478 1.071 1.071 0 .594-.477 1.072-1.071 1.072h-1.429v.714c0 .594-.477 1.072-1.071 1.072a1.069 1.069 0 0 1-1.072-1.072v-.714H7.357ZM2 4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857Zm2.857 15h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714H4.857a.714.714 0 0 0-.714.714v14.286c0 .393.32.714.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareSliders_default = SvgSquareSliders;

// src/Icon/icons/SquareSmall.tsx
import { jsx as jsx1248 } from "react/jsx-runtime";
var SvgSquareSmall = (props) => /* @__PURE__ */ jsx1248(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1248(
      "path",
      {
        d: "M18 2c2.206 0 4 1.794 4 4v12c0 2.206-1.794 4-4 4H6c-2.21 0-4-1.794-4-4V6c0-2.206 1.79-4 4-4h12Zm0 3H6c-.553 0-1 .45-1 1v12c0 .55.447 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareSmall_default = SvgSquareSmall;

// src/Icon/icons/SquareStackSlashFill.tsx
import { jsx as jsx1249 } from "react/jsx-runtime";
var SvgSquareStackSlashFill = (props) => /* @__PURE__ */ jsx1249(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1249(
      "path",
      {
        d: "m5.127 7.188-3.006-1.74c-.242-.141-.418-.276-.527-.405a.731.731 0 0 1-.158-.469c0-.246.134-.47.404-.674l3.287 3.288Zm4.025.427-5.074-5.08L6.71 1.012c.156-.086.297-.15.422-.194.125-.047.25-.07.375-.07s.25.023.375.07c.129.043.27.108.422.194l4.552 2.642c.25.149.43.291.54.428.113.133.17.291.17.475a.747.747 0 0 1-.17.492c-.11.133-.29.271-.54.416l-3.703 2.15Zm-1.646 3.662a.798.798 0 0 1-.34-.076 5.014 5.014 0 0 1-.37-.193l-4.927-2.9a.997.997 0 0 1-.322-.3.642.642 0 0 1 .006-.732.925.925 0 0 1 .275-.252l5.344 3.1a.48.48 0 0 0 .217.076.432.432 0 0 0 .187-.07l.276-.159.902.914-.54.323c-.14.078-.265.142-.374.193a.785.785 0 0 1-.334.076Zm3.428-1.875-.803-.808 3.053-1.77a.863.863 0 0 1 .27.252.63.63 0 0 1 .116.375.667.667 0 0 1-.105.358.923.923 0 0 1-.322.298l-2.21 1.295Zm-3.428 4.606a.798.798 0 0 1-.34-.076 3.114 3.114 0 0 1-.37-.194l-4.927-2.9a.97.97 0 0 1-.322-.287.66.66 0 0 1 .006-.739.925.925 0 0 1 .275-.251l5.344 3.1c.066.034.125.064.176.087a.36.36 0 0 0 .31 0c.055-.023.115-.053.182-.088l1.822-1.06.815.808-2.262 1.33c-.14.082-.266.147-.375.194a.785.785 0 0 1-.334.076Zm5.15-2.883-.797-.797 1.325-.767a.863.863 0 0 1 .27.252.62.62 0 0 1 .116.369c0 .117-.029.228-.088.334a.807.807 0 0 1-.252.263l-.574.346Zm.123 2.508L1.031 1.896a.447.447 0 0 1-.135-.328c0-.132.045-.244.135-.334.09-.093.2-.138.328-.134.133 0 .245.045.334.134l11.748 11.743c.09.085.135.193.135.322s-.045.24-.135.334a.453.453 0 0 1-.334.135.434.434 0 0 1-.328-.135Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareStackSlashFill_default = SvgSquareStackSlashFill;

// src/Icon/icons/SquareT.tsx
import { jsx as jsx1250 } from "react/jsx-runtime";
var SvgSquareT = (props) => /* @__PURE__ */ jsx1250(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1250(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM16.643 6.286H7.357c-.59 0-1.071.482-1.071 1.071 0 .59.482 1.072 1.071 1.072h3.572v8.214a1.072 1.072 0 0 0 2.142 0V8.429h3.572c.594 0 1.071-.478 1.071-1.072 0-.594-.477-1.071-1.071-1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareT_default = SvgSquareT;

// src/Icon/icons/SquareTerminal.tsx
import { jsx as jsx1251 } from "react/jsx-runtime";
var SvgSquareTerminal = (props) => /* @__PURE__ */ jsx1251(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1251(
      "path",
      {
        d: "m8.08 7.281 4.286 3.929a1.072 1.072 0 0 1 0 1.58L8.08 16.72c-.437.397-1.111.33-1.513-.067a1.07 1.07 0 0 1 .067-1.514L10.058 12 6.634 8.862a1.07 1.07 0 1 1 1.446-1.58Zm8.563 8.29c.594 0 1.071.478 1.071 1.072 0 .594-.477 1.071-1.071 1.071h-5a1.069 1.069 0 0 1-1.072-1.071c0-.594.478-1.072 1.072-1.072h5ZM19.143 2A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857A2.857 2.857 0 0 1 4.857 2h14.286Zm0 2.143H4.857a.714.714 0 0 0-.714.714v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareTerminal_default = SvgSquareTerminal;

// src/Icon/icons/SquareThisWayUp.tsx
import { jsx as jsx1252 } from "react/jsx-runtime";
var SvgSquareThisWayUp = (props) => /* @__PURE__ */ jsx1252(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1252(
      "path",
      {
        d: "M16.643 16.286c.594 0 1.071.477 1.071 1.071s-.477 1.072-1.071 1.072H7.357a1.069 1.069 0 0 1-1.071-1.072c0-.594.477-1.071 1.071-1.071h9.286Zm0-7.143v4.643c0 .594-.478 1.071-1.072 1.071a1.069 1.069 0 0 1-1.071-1.071V9.143h-1.138a.648.648 0 0 1-.648-.647c0-.197.058-.313.165-.429l1.898-2.179c.205-.187.49-.317.794-.317.304 0 .59.13.795.317l1.897 2.179a.568.568 0 0 1 .166.429c0 .357-.29.647-.648.647h-1.138ZM5.735 8.067l1.899-2.179c.205-.187.491-.317.795-.317.303 0 .589.13.794.317l1.897 2.179a.568.568 0 0 1 .166.429c0 .357-.29.647-.648.647H9.5v4.643c0 .594-.478 1.071-1.071 1.071a1.069 1.069 0 0 1-1.072-1.071V9.143H6.218a.647.647 0 0 1-.647-.647c0-.197.058-.313.164-.429ZM2 4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857Zm2.143 0v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714H4.857a.714.714 0 0 0-.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareThisWayUp_default = SvgSquareThisWayUp;

// src/Icon/icons/SquareU.tsx
import { jsx as jsx1253 } from "react/jsx-runtime";
var SvgSquareU = (props) => /* @__PURE__ */ jsx1253(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1253(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM15.93 6.286c-.59 0-1.072.482-1.072 1.071v5.487c0 1.504-1.281 2.727-2.857 2.727-1.576 0-2.857-1.223-2.857-2.727V7.357a1.072 1.072 0 0 0-2.143 0v5.487c0 2.687 2.246 4.87 5 4.87 2.755 0 5-2.184 5-4.87V7.357c0-.59-.478-1.071-1.071-1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareU_default = SvgSquareU;

// src/Icon/icons/SquareUpLeft.tsx
import { jsx as jsx1254 } from "react/jsx-runtime";
var SvgSquareUpLeft = (props) => /* @__PURE__ */ jsx1254(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1254(
      "path",
      {
        d: "m13.41 11.388 1.848-1.847a1.07 1.07 0 0 0-.758-1.827H8.786c-.59 0-1.072.482-1.072 1.072V14.5a1.072 1.072 0 0 0 1.83.758l1.846-1.848 2.883 2.883a1.071 1.071 0 0 0 1.515 0l.505-.505a1.072 1.072 0 0 0 0-1.515l-2.882-2.885ZM19.144 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareUpLeft_default = SvgSquareUpLeft;

// src/Icon/icons/SquareUpRight.tsx
import { jsx as jsx1255 } from "react/jsx-runtime";
var SvgSquareUpRight = (props) => /* @__PURE__ */ jsx1255(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1255(
      "path",
      {
        d: "M7.705 14.272a1.072 1.072 0 0 0 0 1.515l.505.505a1.071 1.071 0 0 0 1.515 0l2.883-2.882 1.847 1.847a1.071 1.071 0 0 0 1.83-.757V8.786c0-.59-.477-1.072-1.07-1.072H9.5a1.07 1.07 0 0 0-.991.661c-.165.402-.072.862.232 1.13l1.847 1.847-2.883 2.92ZM2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.857 2.857 0 0 0 19.143 2H4.857A2.857 2.857 0 0 0 2 4.857Zm2.143 0c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareUpRight_default = SvgSquareUpRight;

// src/Icon/icons/SquareUp.tsx
import { jsx as jsx1256 } from "react/jsx-runtime";
var SvgSquareUp = (props) => /* @__PURE__ */ jsx1256(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1256(
      "path",
      {
        d: "M12.755 6.63a1.085 1.085 0 0 0-.79-.344c-.345.013-.63.13-.79.348L7.278 10.92c-.288.317-.36.768-.185 1.156.174.388.553.638.937.638h2.5l.04 3.929c0 .594.483 1.071 1.072 1.071h.714c.592 0 1.072-.48 1.072-1.071l-.04-3.929h2.5a1.072 1.072 0 0 0 .787-1.799L12.754 6.63ZM19.142 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.859 2.859 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareUp_default = SvgSquareUp;

// src/Icon/icons/SquareUser.tsx
import { jsx as jsx1257 } from "react/jsx-runtime";
var SvgSquareUser = (props) => /* @__PURE__ */ jsx1257(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1257(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2ZM7.07 19.857a3.577 3.577 0 0 1 3.5-2.857h2.858a3.578 3.578 0 0 1 3.5 2.857H7.07Zm12.786-.714c0 .394-.32.714-.714.714h-.072c-.357-2.817-2.732-5-5.642-5H10.57c-2.91 0-5.285 2.185-5.642 5h-.072a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM12 5.57a3.929 3.929 0 1 0 0 7.858 3.929 3.929 0 0 0 0-7.858Zm0 5.715a1.785 1.785 0 1 1-.001-3.572A1.785 1.785 0 0 1 12 11.285Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareUser_default = SvgSquareUser;

// src/Icon/icons/SquareV.tsx
import { jsx as jsx1258 } from "react/jsx-runtime";
var SvgSquareV = (props) => /* @__PURE__ */ jsx1258(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1258(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM17.121 6.397a1.073 1.073 0 0 0-1.438.48L12 14.245 8.317 6.878a1.072 1.072 0 1 0-1.918.956l4.642 9.285a1.071 1.071 0 0 0 1.917.001l4.643-9.285a1.073 1.073 0 0 0-.48-1.439Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareV_default = SvgSquareV;

// src/Icon/icons/SquareW.tsx
import { jsx as jsx1259 } from "react/jsx-runtime";
var SvgSquareW = (props) => /* @__PURE__ */ jsx1259(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1259(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM17.674 6.335a1.074 1.074 0 0 0-1.34.709l-1.767 5.733-1.534-5.697a1.07 1.07 0 0 0-2.069 0l-1.531 5.697L7.665 7.04a1.071 1.071 0 1 0-2.048.63l2.857 9.286c.142.46.566.718 1.044.758a1.071 1.071 0 0 0 1.015-.793L12 11.478l1.466 5.442a1.07 1.07 0 0 0 1.016.794h.018c.47 0 .886-.306 1.024-.756l2.857-9.286c.173-.565-.144-1.203-.707-1.337Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareW_default = SvgSquareW;

// src/Icon/icons/SquareX.tsx
import { jsx as jsx1260 } from "react/jsx-runtime";
var SvgSquareX = (props) => /* @__PURE__ */ jsx1260(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1260(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM16.621 6.54a1.07 1.07 0 0 0-1.51.126L12 10.34 8.888 6.665A1.07 1.07 0 0 0 7.38 6.54a1.07 1.07 0 0 0-.125 1.51L10.598 12l-3.343 3.95a1.072 1.072 0 0 0 .127 1.511c.198.169.444.253.65.253.303 0 .606-.129.818-.38L12 13.662l3.11 3.676a1.074 1.074 0 0 0 1.51.124 1.072 1.072 0 0 0 .126-1.51L13.402 12l3.343-3.95c.384-.452.326-1.13-.125-1.51Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareX_default = SvgSquareX;

// src/Icon/icons/SquareXmark.tsx
import { jsx as jsx1261 } from "react/jsx-runtime";
var SvgSquareXmark = (props) => /* @__PURE__ */ jsx1261(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1261(
      "path",
      {
        d: "M8.384 8.384c.42-.415 1.098-.415 1.478 0l2.098 2.103 2.138-2.103c.42-.415 1.098-.415 1.478 0 .455.42.455 1.098 0 1.478l-2.063 2.098 2.063 2.138c.455.42.455 1.098 0 1.478-.38.455-1.058.455-1.478 0l-2.138-2.063-2.098 2.063c-.38.455-1.058.455-1.478 0-.415-.38-.415-1.058 0-1.478l2.103-2.138-2.103-2.098c-.415-.38-.415-1.058 0-1.478ZM2 4.857A2.857 2.857 0 0 1 4.857 2h14.286A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857Zm2.143 0v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714H4.857a.714.714 0 0 0-.714.714Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareXmark_default = SvgSquareXmark;

// src/Icon/icons/SquareY.tsx
import { jsx as jsx1262 } from "react/jsx-runtime";
var SvgSquareY = (props) => /* @__PURE__ */ jsx1262(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1262(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286ZM15.83 6.66 12 11.13 8.17 6.66a1.069 1.069 0 0 0-1.51-.115 1.068 1.068 0 0 0-.115 1.509l4.384 5.116v3.473a1.072 1.072 0 0 0 2.142 0V13.17l4.385-5.116A1.071 1.071 0 1 0 15.83 6.66Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareY_default = SvgSquareY;

// src/Icon/icons/SquareZ.tsx
import { jsx as jsx1263 } from "react/jsx-runtime";
var SvgSquareZ = (props) => /* @__PURE__ */ jsx1263(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1263(
      "path",
      {
        d: "M19.143 2H4.857A2.857 2.857 0 0 0 2 4.857v14.286A2.857 2.857 0 0 0 4.857 22h14.286A2.857 2.857 0 0 0 22 19.143V4.857A2.858 2.858 0 0 0 19.143 2Zm.714 17.143c0 .394-.32.714-.714.714H4.857a.715.715 0 0 1-.714-.714V4.857c0-.394.32-.714.714-.714h14.286c.394 0 .714.32.714.714v14.286Zm-4.643-3.572H10.83l5.264-7.602c.227-.327.254-.754.068-1.107-.184-.393-.55-.576-.948-.576H8.786c-.59 0-1.072.482-1.072 1.071 0 .59.482 1.072 1.072 1.072h4.383L7.906 16.03a1.074 1.074 0 0 0 .88 1.683h6.428a1.072 1.072 0 0 0 0-2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var SquareZ_default = SvgSquareZ;

// src/Icon/icons/Square.tsx
import { jsx as jsx1264 } from "react/jsx-runtime";
var SvgSquare = (props) => /* @__PURE__ */ jsx1264(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1264(
      "path",
      {
        d: "M19.143 2A2.858 2.858 0 0 1 22 4.857v14.286A2.86 2.86 0 0 1 19.143 22H4.857A2.858 2.858 0 0 1 2 19.143V4.857A2.857 2.857 0 0 1 4.857 2h14.286Zm0 2.143H4.857a.714.714 0 0 0-.714.714v14.286c0 .393.32.714.714.714h14.286a.716.716 0 0 0 .714-.714V4.857a.715.715 0 0 0-.714-.714Z",
        fill: "currentColor"
      }
    )
  })
);
var Square_default = SvgSquare;

// src/Icon/icons/StarSharp.tsx
import { jsx as jsx1265 } from "react/jsx-runtime";
var SvgStarSharp = (props) => /* @__PURE__ */ jsx1265(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1265(
      "path",
      {
        d: "M12 2c.41 0 .77.264.895.653l1.98 6.222h6.188a.934.934 0 0 1 .574 1.676l-5.11 3.976 1.993 6.25a.936.936 0 0 1-1.469 1.024l-5.05-3.926-5.051 3.926a.934.934 0 0 1-1.111.031.94.94 0 0 1-.357-1.055l1.99-6.25-5.11-3.976a.936.936 0 0 1 .576-1.676h6.191l1.977-6.222A.942.942 0 0 1 12 2Zm0 4.031-1.293 4.067a.94.94 0 0 1-.894.652H5.67l3.467 2.7a.935.935 0 0 1 .32 1.023l-1.273 3.996 3.242-2.52a.927.927 0 0 1 1.149 0l3.242 2.52-1.274-3.996a.935.935 0 0 1 .32-1.024l3.47-2.699h-4.145a.94.94 0 0 1-.895-.652L12 6.03Z",
        fill: "currentColor"
      }
    )
  })
);
var StarSharp_default = SvgStarSharp;

// src/Icon/icons/Star.tsx
import { jsx as jsx1266 } from "react/jsx-runtime";
var SvgStar = (props) => /* @__PURE__ */ jsx1266(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1266(
      "path",
      {
        d: "M11.999 2.302c.348 0 .666.2.818.513l2.6 5.353 5.807.86a.91.91 0 0 1 .732.613c.106.33.018.69-.224.929l-4.213 4.175.996 5.891a.908.908 0 0 1-.367.89c-.28.201-.686.228-.959.065L12 18.818 6.778 21.59c-.273.163-.644.136-.929-.064-.28-.201-.42-.55-.397-.89l1.026-5.892L2.27 10.57a.907.907 0 0 1 .507-1.542l5.805-.86 2.6-5.353a.913.913 0 0 1 .818-.513Zm0 2.992-1.99 4.101a.925.925 0 0 1-.685.504l-4.483.66 3.255 3.224a.917.917 0 0 1 .254.799l-.765 4.531 3.985-2.129a.902.902 0 0 1 .857 0l3.986 2.13-.766-4.532a.919.919 0 0 1 .258-.8l3.254-3.224-4.482-.659a.911.911 0 0 1-.685-.504l-1.993-4.101Z",
        fill: "currentColor"
      }
    )
  })
);
var Star_default = SvgStar;

// src/Icon/icons/Stop.tsx
import { jsx as jsx1267 } from "react/jsx-runtime";
var SvgStop = (props) => /* @__PURE__ */ jsx1267(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1267(
      "path",
      {
        d: "M18.667 2.023H5.333A3.333 3.333 0 0 0 2 5.357v13.286a3.333 3.333 0 0 0 3.333 3.334h13.334A3.333 3.333 0 0 0 22 18.643V5.357a3.335 3.335 0 0 0-3.333-3.334ZM19.5 18.69c0 .46-.374.833-.833.833H5.333a.834.834 0 0 1-.833-.833V5.357c0-.46.374-.834.833-.834h13.334c.46 0 .833.374.833.834V18.69Z",
        fill: "currentColor"
      }
    )
  })
);
var Stop_default = SvgStop;

// src/Icon/icons/Stopwatch.tsx
import { jsx as jsx1268 } from "react/jsx-runtime";
var SvgStopwatch = (props) => /* @__PURE__ */ jsx1268(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1268(
      "path",
      {
        d: "M12.938 14.5c0 .52-.418.938-.938.938a.935.935 0 0 1-.938-.938v-4.063c0-.519.418-.937.938-.937s.938.418.938.938V14.5ZM8.875 2.937c0-.517.418-.937.938-.937h4.374a.937.937 0 1 1 0 1.875h-1.25v1.929a8.095 8.095 0 0 1 4.446 1.985l1.14-1.14c.368-.364.961-.364 1.293 0 .399.367.399.96 0 1.292l-1.18 1.247a8.084 8.084 0 0 1 1.489 4.687A8.124 8.124 0 0 1 12 22a8.126 8.126 0 0 1-.938-16.196V3.875h-1.25a.936.936 0 0 1-.937-.938ZM12 20.125a6.248 6.248 0 0 0 6.25-6.25A6.248 6.248 0 0 0 12 7.625a6.248 6.248 0 0 0-6.25 6.25 6.248 6.248 0 0 0 6.25 6.25Z",
        fill: "currentColor"
      }
    )
  })
);
var Stopwatch_default = SvgStopwatch;

// src/Icon/icons/Store.tsx
import { jsx as jsx1269 } from "react/jsx-runtime";
var SvgStore = (props) => /* @__PURE__ */ jsx1269(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1269(
      "path",
      {
        d: "M19.185 10.823a3.218 3.218 0 0 1-2.394-1.066 3.21 3.21 0 0 1-2.397 1.066c-.72 0-1.379-.235-1.912-.658a2.02 2.02 0 0 1-.485-.408 2.02 2.02 0 0 1-.486.408 3.044 3.044 0 0 1-1.911.659 3.05 3.05 0 0 1-1.912-.659 1.936 1.936 0 0 1-.482-.408 2.035 2.035 0 0 1-.489.408c-.53.423-1.22.625-1.908.659h-.002c-.149 0-.3-.012-.445-.03-2.034-.272-2.997-2.67-1.909-4.39L4.561 3.07c.188-.3.522-.482.88-.482H18.56c.356 0 .691.183.879.482l2.106 3.334c1.092 1.724.125 4.118-1.915 4.39-.144.018-.29-.004-.441.03h-.004Zm-1.022-6.47H5.838L3.945 7.348c-.213.335-.233.75-.083 1.107.144.338.405.544.732.588a1.45 1.45 0 0 0 1.3-.47c.334-.368.779-.582 1.312-.582.496 0 .974.214 1.309.581.268.298.65.486 1.085.486.437 0 .786-.188 1.088-.486.335-.367.809-.58 1.309-.58.5 0 .974.213 1.309.58a1.458 1.458 0 0 0 2.173 0 1.764 1.764 0 0 1 2.618 0 1.47 1.47 0 0 0 1.305.47c.33-.043.592-.25.735-.587.15-.386.132-.769-.08-1.107l-1.894-2.997Zm.308 10.588v-3c.232.04.471.059.714.059a4.563 4.563 0 0 0 1.051-.125v7.184a2.355 2.355 0 0 1-2.353 2.353H6.118a2.354 2.354 0 0 1-2.353-2.353v-7.184c.142.037.289.066.44.085h.004a4.559 4.559 0 0 0 1.32-.019v3h12.942Zm0 1.765H5.53v2.353a.59.59 0 0 0 .589.589h11.765a.59.59 0 0 0 .588-.589v-2.353Z",
        fill: "currentColor"
      }
    )
  })
);
var Store_default = SvgStore;

// src/Icon/icons/Strikethrough.tsx
import { jsx as jsx1270 } from "react/jsx-runtime";
var SvgStrikethrough = (props) => /* @__PURE__ */ jsx1270(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1270(
      "path",
      {
        d: "m21.063 11.371-7.844.004c-.323-.096-1.653-.477-1.653-.477-3.257-.94-4.16-1.757-3.855-3.488.38-2.164 3.192-2.52 5.488-2.165.655.1 1.436.31 2.455.657a.957.957 0 0 0 1.212-.58.934.934 0 0 0-.588-1.192c-1.13-.386-2.015-.62-2.785-.738-4.083-.627-7.161.859-7.659 3.698-.38 2.164.58 3.457 1.889 4.285l-4.785-.004c-.518 0-.938.42-.938.903 0 .482.42.902.938.902h18.125c.517 0 .937-.42.937-.902 0-.483-.418-.903-.938-.903Zm-4.934 3.754c.2.401.263.87.159 1.464-.38 2.163-3.192 2.519-5.497 2.165-1.011-.15-2.19-.568-3.23-.937l-.538-.188a.956.956 0 0 0-1.216.57.934.934 0 0 0 .58 1.198l.526.185c1.124.398 2.397.85 3.589 1.026.623.095 1.225.142 1.799.142 3.167 0 5.441-1.435 5.863-3.841.12-.678.102-1.264-.009-1.784H16.13Z",
        fill: "currentColor"
      }
    )
  })
);
var Strikethrough_default = SvgStrikethrough;

// src/Icon/icons/Subscript.tsx
import { jsx as jsx1271 } from "react/jsx-runtime";
var SvgSubscript = (props) => /* @__PURE__ */ jsx1271(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1271(
      "path",
      {
        d: "M14.813 5.125c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937H13.25a.936.936 0 0 0-.78.418l-3.595 5.39-3.595-5.39a.935.935 0 0 0-.78-.418H2.937a.938.938 0 0 0 0 1.875h1.061l3.75 5.625-3.75 5.625h-1.06a.939.939 0 0 0-.938.938c0 .515.42.937.938.937H4.5a.936.936 0 0 0 .78-.418l3.595-5.39 3.595 5.39a.894.894 0 0 0 .78.418h1.563a.938.938 0 0 0 0-1.875h-1.061l-3.75-5.625 3.75-5.625h1.06Zm6.25 13.75h-.625v-5.938A.938.938 0 0 0 19.5 12h-1.563a.94.94 0 0 0-.937.938c0 .515.42.937.938.937h.625v5h-.625a.938.938 0 0 0 0 1.875h3.125a.938.938 0 0 0 0-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var Subscript_default = SvgSubscript;

// src/Icon/icons/Suitcase.tsx
import { jsx as jsx1272 } from "react/jsx-runtime";
var SvgSuitcase = (props) => /* @__PURE__ */ jsx1272(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1272(
      "path",
      {
        d: "M7 6.375V4.812c0-1.208.98-2.187 2.188-2.187h5.624c1.208 0 2.188.98 2.188 2.188v1.562h2.5c1.379 0 2.5 1.121 2.5 2.5v10c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5v-10c0-1.379 1.12-2.5 2.5-2.5H7Zm1.875 0h6.25V4.812a.313.313 0 0 0-.313-.312H9.189a.313.313 0 0 0-.313.313v1.562ZM7.625 8.25V19.5h8.75V8.25h-8.75Zm-3.75.625v10c0 .344.28.625.625.625h1.25V8.25H4.5a.626.626 0 0 0-.625.625Zm16.25 10v-10a.627.627 0 0 0-.625-.625h-1.25V19.5h1.25a.627.627 0 0 0 .625-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var Suitcase_default = SvgSuitcase;

// src/Icon/icons/SunBright.tsx
import { jsx as jsx1273 } from "react/jsx-runtime";
var SvgSunBright = (props) => /* @__PURE__ */ jsx1273(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1273(
      "path",
      {
        d: "M12 7.625a4.375 4.375 0 1 0 0 8.75 4.375 4.375 0 0 0 0-8.75Zm0 6.875A2.503 2.503 0 0 1 9.5 12c0-1.379 1.121-2.5 2.5-2.5s2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5Zm0-8.125c.518 0 .938-.42.938-.938v-2.5a.937.937 0 1 0-1.876 0v2.5c0 .52.422.938.938.938Zm0 11.25a.938.938 0 0 0-.938.938v2.5a.938.938 0 0 0 1.876 0v-2.5a.938.938 0 0 0-.938-.938Zm9.063-6.563h-2.5a.938.938 0 0 0 0 1.876h2.5c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.938ZM6.374 12a.938.938 0 0 0-.938-.938h-2.5A.939.939 0 0 0 2 12c0 .516.42.938.938.938h2.5c.519 0 .937-.418.937-.938Zm10.93 3.977a.937.937 0 0 0-1.326 1.325l1.768 1.769a.934.934 0 0 0 1.325 0 .937.937 0 0 0 0-1.326l-1.767-1.768ZM6.695 8.023a.939.939 0 0 0 1.328-1.325l-1.77-1.77a.937.937 0 1 0-1.325 1.326l1.767 1.77Zm9.946.274c.24 0 .48-.092.663-.275l1.767-1.769a.937.937 0 1 0-1.326-1.325l-1.767 1.768a.937.937 0 0 0 .663 1.6Zm-9.946 7.68-1.767 1.768a.937.937 0 1 0 1.326 1.326l1.767-1.769a.937.937 0 1 0-1.326-1.325Z",
        fill: "currentColor"
      }
    )
  })
);
var SunBright_default = SvgSunBright;

// src/Icon/icons/Sun.tsx
import { jsx as jsx1274 } from "react/jsx-runtime";
var SvgSun = (props) => /* @__PURE__ */ jsx1274(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1274(
      "path",
      {
        d: "m21.734 14.687-1.865-2.686 1.866-2.688c.287-.415.343-.942.15-1.409a1.472 1.472 0 0 0-1.103-.887l-3.218-.581-.581-3.22a1.47 1.47 0 0 0-.887-1.102 1.482 1.482 0 0 0-1.41.15L12 4.13 9.312 2.262a1.484 1.484 0 0 0-1.41-.149 1.473 1.473 0 0 0-.887 1.102l-.581 3.22-3.217.58c-.497.09-.91.423-1.104.891-.193.465-.136.993.152 1.407l1.864 2.686-1.865 2.688a1.474 1.474 0 0 0-.15 1.409c.194.466.606.798 1.102.887l3.218.581.582 3.22a1.48 1.48 0 0 0 2.296.952L12 19.87l2.688 1.866c.253.173.546.263.839.263a1.473 1.473 0 0 0 1.455-1.215l.582-3.22 3.218-.581a1.47 1.47 0 0 0 1.103-.889 1.46 1.46 0 0 0-.151-1.408Zm-1.89.563-3.892.703-.703 3.892L12 17.59l-3.25 2.254-.702-3.892-3.891-.703 2.254-3.284L4.157 8.75l3.891-.703.703-3.892L12 6.41l3.248-2.256.704 3.893 3.89.703-2.253 3.215 2.254 3.285ZM12 7.59a4.337 4.337 0 0 0-4.34 4.34A4.338 4.338 0 0 0 12 16.27c2.38 0 4.34-1.96 4.34-4.34 0-2.348-1.926-4.34-4.34-4.34Zm0 6.875a2.503 2.503 0 0 1-2.5-2.5C9.5 10.587 10.62 9.5 12 9.5c1.379 0 2.5 1.121 2.5 2.465 0 1.343-1.121 2.5-2.5 2.5Z",
        fill: "currentColor"
      }
    )
  })
);
var Sun_default = SvgSun;

// src/Icon/icons/Superscript.tsx
import { jsx as jsx1275 } from "react/jsx-runtime";
var SvgSuperscript = (props) => /* @__PURE__ */ jsx1275(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1275(
      "path",
      {
        d: "M14.813 7.625c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937H13.25a.936.936 0 0 0-.78.418l-3.595 5.39-3.595-5.39a.935.935 0 0 0-.78-.418H2.937a.938.938 0 0 0 0 1.875h1.061l3.75 5.625-3.75 5.625h-1.06a.939.939 0 0 0-.938.938c0 .515.42.937.938.937H4.5a.936.936 0 0 0 .78-.418l3.595-5.39 3.595 5.39a.894.894 0 0 0 .78.418h1.563a.938.938 0 0 0 0-1.875h-1.061l-3.75-5.625 3.75-5.625h1.06Zm6.25 2.5h-.625V4.187a.937.937 0 0 0-.938-.937h-1.563a.938.938 0 0 0 0 1.875h.625v5h-.625a.94.94 0 0 0-.937.938.94.94 0 0 0 .938.937h3.125c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937Z",
        fill: "currentColor"
      }
    )
  })
);
var Superscript_default = SvgSuperscript;

// src/Icon/icons/Symbols.tsx
import { jsx as jsx1276 } from "react/jsx-runtime";
var SvgSymbols = (props) => /* @__PURE__ */ jsx1276(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1276(
      "path",
      {
        d: "M9.813 2c.52 0 .937.42.937.902a.915.915 0 0 1-.937.938H2.938A.916.916 0 0 1 2 2.902C2 2.42 2.42 2 2.938 2h6.875Zm0 3.09c.52 0 .937.455.937.937a.914.914 0 0 1-.937.938h-2.5v2.812a.914.914 0 0 1-.938.938.915.915 0 0 1-.937-.938V6.965h-2.5A.915.915 0 0 1 2 6.027c0-.482.42-.937.938-.937h6.875Zm5.937-.134v5.134c0 1.07-1.121 1.875-2.5 1.875s-2.5-.805-2.5-1.875c0-1 1.121-1.875 2.5-1.875.215 0 .426.055.625.094V4.7c0-.745.527-1.386 1.258-1.532l5-1A1.562 1.562 0 0 1 22 3.7v5.14c0 1.07-1.121 1.875-2.5 1.875S17 9.91 17 8.84c0-1 1.121-1.875 2.5-1.875.215 0 .426.055.625.094V4.08l-4.375.875Zm0 9.544c0 .691-.559 1.25-1.25 1.25s-1.25-.559-1.25-1.25.559-1.25 1.25-1.25 1.25.559 1.25 1.25Zm5.941-.976c.399.367.399.96 0 1.292l-6.875 6.875c-.332.399-.925.399-1.293 0-.363-.332-.363-.925 0-1.293l6.875-6.874c.368-.364.961-.364 1.293 0ZM19.5 20.75c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25S21.441 22 20.75 22s-1.25-.559-1.25-1.25ZM5.325 12a2.613 2.613 0 0 1 1.593 4.684l-.309.234 1.032.93 1.586-1.266c.406-.36.996-.258 1.316.145a.911.911 0 0 1-.18 1.316l-1.308 1.078 1.386 1.246a.938.938 0 0 1 .067 1.324c-.38.383-.938.415-1.324.067L7.57 20.305 6.152 21.44a2.557 2.557 0 0 1-4.152-2v-.054c0-.813.377-1.575 1.02-2.07l.662-.512-.174-.157a2.673 2.673 0 0 1-.883-1.984c0-1.46 1.184-2.7 2.656-2.7l.044.036Zm.738 2.613a.739.739 0 0 0-.738-.738h-.044a.788.788 0 0 0-.78.79c-.001.19.096.44.261.593l.432.387.58-.446a.742.742 0 0 0 .289-.586Zm-2.188 4.774v.054a.682.682 0 0 0 1.108.536l1.177-.942-1.06-.953-.937.719a.745.745 0 0 0-.288.586Z",
        fill: "currentColor"
      }
    )
  })
);
var Symbols_default = SvgSymbols;

// src/Icon/icons/SystemExtensions.tsx
import { jsx as jsx1277 } from "react/jsx-runtime";
var SvgSystemExtensions = (props) => /* @__PURE__ */ jsx1277(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1277(
      "path",
      {
        d: "M2.734 17.547v-3.438c0-.648.43-1.039.97-1.039.296 0 .6.125.905.399.383.344.813.562 1.274.562.89 0 1.64-.664 1.64-1.672 0-1.007-.75-1.671-1.64-1.671-.461 0-.89.21-1.274.554-.304.281-.609.406-.906.406-.539 0-.969-.39-.969-1.046V7.148c0-1.546.82-2.351 2.391-2.351h9.602c1.562 0 2.382.805 2.382 2.351v2.82c0 .126.086.188.235.087.492-.352 1.062-.602 1.718-.602 1.477 0 2.797 1.188 2.797 2.922 0 1.742-1.32 2.93-2.797 2.93-.656 0-1.226-.25-1.718-.602-.149-.101-.235-.039-.235.086v2.758c0 1.547-.82 2.351-2.382 2.351H5.125c-1.57 0-2.39-.804-2.39-2.351Zm1.258-.063c0 .75.43 1.157 1.156 1.157h9.555c.727 0 1.149-.407 1.149-1.157v-3.328c0-.656.43-1.07.968-1.07.297 0 .602.125.907.406.382.344.812.563 1.273.563.89 0 1.64-.664 1.64-1.68 0-1.008-.75-1.672-1.64-1.672-.46 0-.89.219-1.273.563-.305.28-.61.406-.907.406-.539 0-.968-.414-.968-1.07V7.21c0-.742-.422-1.156-1.149-1.156H5.148c-.726 0-1.156.414-1.156 1.156v2.625c0 .367.188.226.336.133.477-.305 1-.531 1.617-.531 1.47 0 2.797 1.18 2.797 2.921 0 1.743-1.328 2.922-2.797 2.922-.617 0-1.14-.226-1.617-.531-.148-.094-.336-.234-.336.133v2.601Z",
        fill: "currentColor"
      }
    )
  })
);
var SystemExtensions_default = SvgSystemExtensions;

// src/Icon/icons/T.tsx
import { jsx as jsx1278 } from "react/jsx-runtime";
var SvgT = (props) => /* @__PURE__ */ jsx1278(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1278(
      "path",
      {
        d: "M20.571 3.071c0 .592-.48 1.072-1.071 1.072H13.07v16.785a1.072 1.072 0 0 1-2.142 0V4.143H4.5A1.072 1.072 0 0 1 4.5 2h15c.594 0 1.071.48 1.071 1.071Z",
        fill: "currentColor"
      }
    )
  })
);
var T_default = SvgT;

// src/Icon/icons/TableCellsLarge.tsx
import { jsx as jsx1279 } from "react/jsx-runtime";
var SvgTableCellsLarge = (props) => /* @__PURE__ */ jsx1279(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1279(
      "path",
      {
        d: "M2 5.75a2.5 2.5 0 0 1 2.5-2.5h15c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75Zm10.938 5.313h7.187V5.75a.626.626 0 0 0-.625-.625h-6.563v5.938Zm-1.876-5.938H4.5a.625.625 0 0 0-.625.625v5.313h7.188V5.125Zm-7.187 7.813v5.312c0 .344.28.625.625.625h6.563v-5.938H3.875Zm9.063 5.937H19.5a.627.627 0 0 0 .625-.625v-5.313h-7.188v5.938Z",
        fill: "currentColor"
      }
    )
  })
);
var TableCellsLarge_default = SvgTableCellsLarge;

// src/Icon/icons/TableCells.tsx
import { jsx as jsx1280 } from "react/jsx-runtime";
var SvgTableCells = (props) => /* @__PURE__ */ jsx1280(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1280(
      "path",
      {
        d: "M2 5.75a2.5 2.5 0 0 1 2.5-2.5h15c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75Zm14.063 2.813h4.062V5.75a.626.626 0 0 0-.625-.625h-3.438v3.438Zm-1.875-3.438H9.811v3.438h4.376V5.124Zm-6.25 0H4.5a.625.625 0 0 0-.625.625v2.813h4.063V5.124Zm-4.063 5.313v3.124h4.063v-3.124H3.875Zm0 5v2.812c0 .344.28.625.625.625h3.438v-3.438H3.875Zm5.938 3.437h4.374v-3.438H9.814v3.438Zm6.25 0H19.5a.627.627 0 0 0 .625-.625v-2.813h-4.063v3.438Zm4.062-5.313v-3.124h-4.063v3.124h4.063Zm-5.938 0v-3.124H9.814v3.124h4.374Z",
        fill: "currentColor"
      }
    )
  })
);
var TableCells_default = SvgTableCells;

// src/Icon/icons/TableColumns.tsx
import { jsx as jsx1281 } from "react/jsx-runtime";
var SvgTableColumns = (props) => /* @__PURE__ */ jsx1281(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1281(
      "path",
      {
        d: "M19.5 3.25c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75a2.5 2.5 0 0 1 2.5-2.5h15Zm-15 15.625h6.563V8.25H3.875v10c0 .344.28.625.625.625Zm8.438 0H19.5a.627.627 0 0 0 .625-.625v-10h-7.188v10.625Z",
        fill: "currentColor"
      }
    )
  })
);
var TableColumns_default = SvgTableColumns;

// src/Icon/icons/TableLayout.tsx
import { jsx as jsx1282 } from "react/jsx-runtime";
var SvgTableLayout = (props) => /* @__PURE__ */ jsx1282(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1282(
      "path",
      {
        d: "M19.5 3.25c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75a2.5 2.5 0 0 1 2.5-2.5h15Zm0 1.875h-15a.625.625 0 0 0-.625.625v2.5h16.25v-2.5a.626.626 0 0 0-.625-.625Zm-15 13.75h3.125v-8.75h-3.75v8.125c0 .344.28.625.625.625Zm5 0h10a.627.627 0 0 0 .625-.625v-8.125H9.5v8.75Z",
        fill: "currentColor"
      }
    )
  })
);
var TableLayout_default = SvgTableLayout;

// src/Icon/icons/TableList.tsx
import { jsx as jsx1283 } from "react/jsx-runtime";
var SvgTableList = (props) => /* @__PURE__ */ jsx1283(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1283(
      "path",
      {
        d: "M2 5.75a2.5 2.5 0 0 1 2.5-2.5h15c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75Zm7.5 2.813h10.625V5.75a.626.626 0 0 0-.625-.625h-10v3.438ZM7.625 5.124H4.5a.625.625 0 0 0-.625.625v2.813h3.75V5.124Zm-3.75 5.313v3.124h3.75v-3.124h-3.75Zm0 5v2.812c0 .344.28.625.625.625h3.125v-3.438h-3.75ZM9.5 18.875h10a.627.627 0 0 0 .625-.625v-2.813H9.5v3.438Zm10.625-5.313v-3.124H9.5v3.124h10.625Z",
        fill: "currentColor"
      }
    )
  })
);
var TableList_default = SvgTableList;

// src/Icon/icons/TablePicnic.tsx
import { jsx as jsx1284 } from "react/jsx-runtime";
var SvgTablePicnic = (props) => /* @__PURE__ */ jsx1284(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1284(
      "path",
      {
        d: "M3.322 18.203a.935.935 0 0 0 .865 1.297.936.936 0 0 0 .866-.578L6.887 14.5h-2.03l-1.535 3.703ZM19.14 14.5h-2.029l1.833 4.422a.944.944 0 0 0 1.226.506.935.935 0 0 0 .507-1.224L19.141 14.5Zm1.922-3.125h-3.216l-2.074-5h2.79c.519 0 .937-.418.937-.938a.936.936 0 0 0-.938-.937H5.438a.937.937 0 1 0 0 1.875h2.79l-2.073 5H2.938a.937.937 0 1 0 0 1.875h18.125c.519 0 .937-.418.937-.938a.935.935 0 0 0-.938-.937Zm-12.88 0 2.074-5h3.49l2.072 5H8.184Z",
        fill: "currentColor"
      }
    )
  })
);
var TablePicnic_default = SvgTablePicnic;

// src/Icon/icons/TablePivot.tsx
import { jsx as jsx1285 } from "react/jsx-runtime";
var SvgTablePivot = (props) => /* @__PURE__ */ jsx1285(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1285(
      "path",
      {
        d: "M20.125 8.25H8.25v-5H19.5c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V9.5h5v9.375h12.5a.627.627 0 0 0 .625-.625v-10ZM4.5 3.25H7v5H2v-2.5a2.5 2.5 0 0 1 2.5-2.5Zm13.703 8.363a.625.625 0 0 1-.578.387H17v1.875c0 1.035-.84 1.875-1.875 1.875H13.25v.625a.625.625 0 0 1-1.066.441l-1.25-1.25a.62.62 0 0 1 0-.882l1.25-1.25a.62.62 0 0 1 .68-.137.615.615 0 0 1 .386.543v.625h1.875a.605.605 0 0 0 .625-.625v-1.875h-.625c-.254 0-.48-.117-.578-.352a.62.62 0 0 1 .137-.68l1.25-1.25a.62.62 0 0 1 .882 0l1.25 1.25a.62.62 0 0 1 .137.68Z",
        fill: "currentColor"
      }
    )
  })
);
var TablePivot_default = SvgTablePivot;

// src/Icon/icons/TableRows.tsx
import { jsx as jsx1286 } from "react/jsx-runtime";
var SvgTableRows = (props) => /* @__PURE__ */ jsx1286(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1286(
      "path",
      {
        d: "M2 5.75a2.5 2.5 0 0 1 2.5-2.5h15c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75Zm18.125 12.5v-5.313H7v5.938h12.5a.627.627 0 0 0 .625-.625Zm0-7.188V5.75a.626.626 0 0 0-.625-.625H7v5.938h13.125Z",
        fill: "currentColor"
      }
    )
  })
);
var TableRows_default = SvgTableRows;

// src/Icon/icons/TableTree.tsx
import { jsx as jsx1287 } from "react/jsx-runtime";
var SvgTableTree = (props) => /* @__PURE__ */ jsx1287(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1287(
      "path",
      {
        d: "M10.75 11.375c0-.344.281-.625.625-.625h6.25c.344 0 .625.281.625.625v1.25a.627.627 0 0 1-.625.625h-6.25a.627.627 0 0 1-.625-.625v-1.25Zm6.875 3.125c.344 0 .625.281.625.625v1.25a.627.627 0 0 1-.625.625h-3.75a.627.627 0 0 1-.625-.625v-1.25c0-.344.281-.625.625-.625h3.75ZM2 5.75a2.5 2.5 0 0 1 2.5-2.5h15c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75Zm1.875 2.5v10c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625v-10H7v2.5c0 .344.281.625.625.625h1.25c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625h-1.25c-.219 0-.43-.04-.625-.105v1.98c0 .344.281.625.625.625h3.75c.344 0 .625.281.625.625a.627.627 0 0 1-.625.625h-3.75A1.875 1.875 0 0 1 5.75 14.5V8.25H3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var TableTree_default = SvgTableTree;

// src/Icon/icons/Table.tsx
import { jsx as jsx1288 } from "react/jsx-runtime";
var SvgTable = (props) => /* @__PURE__ */ jsx1288(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1288(
      "path",
      {
        d: "M19.5 3.25c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75a2.5 2.5 0 0 1 2.5-2.5h15Zm-8.438 9.063V8.25H3.875v4.063h7.188Zm-7.187 1.874v4.063c0 .344.28.625.625.625h6.563v-4.688H3.875Zm9.063 4.688H19.5a.627.627 0 0 0 .625-.625v-4.063h-7.188v4.688Zm7.187-6.563V8.25h-7.188v4.063h7.188Z",
        fill: "currentColor"
      }
    )
  })
);
var Table_default = SvgTable;

// src/Icon/icons/TabletButton.tsx
import { jsx as jsx1289 } from "react/jsx-runtime";
var SvgTabletButton = (props) => /* @__PURE__ */ jsx1289(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1289(
      "path",
      {
        d: "M18.25 2H5.75a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5h12.5a2.5 2.5 0 0 0 2.5-2.5v-15c0-1.38-1.121-2.5-2.5-2.5Zm.625 17.5c0 .345-.28.625-.625.625H5.75a.626.626 0 0 1-.625-.625v-15c0-.345.28-.625.625-.625h12.5c.345 0 .625.28.625.625v15ZM12 17.312a.937.937 0 1 0 0 1.875.937.937 0 0 0 0-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var TabletButton_default = SvgTabletButton;

// src/Icon/icons/TabletRugged.tsx
import { jsx as jsx1290 } from "react/jsx-runtime";
var SvgTabletRugged = (props) => /* @__PURE__ */ jsx1290(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1290(
      "path",
      {
        d: "M20.409 8.42a.615.615 0 0 0 .341-.556V4.886a.615.615 0 0 0-.341-.557l-.909-.454C19.5 2.84 18.66 2 17.66 2H6.41c-1.035 0-1.875.84-1.875 1.875l-.944.453a.614.614 0 0 0-.341.557v2.979c0 .239.131.454.341.556l.909.454V9.5l-.909.453a.622.622 0 0 0-.341.559v2.979c0 .239.131.454.341.556l.909.454v.625l-.909.454a.615.615 0 0 0-.341.557v2.978c0 .24.131.455.341.557l.909.454C4.5 21.16 5.34 22 6.375 22h11.25c1.035 0 1.84-.84 1.84-1.875l.908-.454a.615.615 0 0 0 .342-.557v-2.978a.615.615 0 0 0-.342-.557l-.908-.454V14.5l.908-.454a.615.615 0 0 0 .342-.556v-2.98a.615.615 0 0 0-.342-.556l-.908-.454v-.625l.944-.454ZM17.63 19.5a.63.63 0 0 1-.625.625h-10a.63.63 0 0 1-.625-.625V4.499a.63.63 0 0 1 .625-.625h10a.63.63 0 0 1 .625.625v15Z",
        fill: "currentColor"
      }
    )
  })
);
var TabletRugged_default = SvgTabletRugged;

// src/Icon/icons/TabletScreenButton.tsx
import { jsx as jsx1291 } from "react/jsx-runtime";
var SvgTabletScreenButton = (props) => /* @__PURE__ */ jsx1291(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1291(
      "path",
      {
        d: "M18.261 2H5.739a2.504 2.504 0 0 0-2.504 2.504v15.027c0 1.383 1.12 2.469 2.504 2.469h12.522c1.383 0 2.504-1.121 2.504-2.47V4.505A2.505 2.505 0 0 0 18.261 2Zm.626 17.53c0 .346-.28.627-.626.627H5.739a.627.627 0 0 1-.626-.626V16.4h13.774v3.13Zm0-5.008H5.113V4.504c0-.345.28-.626.626-.626h12.522c.345 0 .626.281.626.626v10.018ZM12 19.218a.94.94 0 1 0 0-1.879.94.94 0 0 0 0 1.879Z",
        fill: "currentColor"
      }
    )
  })
);
var TabletScreenButton_default = SvgTabletScreenButton;

// src/Icon/icons/TabletScreen.tsx
import { jsx as jsx1292 } from "react/jsx-runtime";
var SvgTabletScreen = (props) => /* @__PURE__ */ jsx1292(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1292(
      "path",
      {
        d: "M18.261 2H5.739a2.504 2.504 0 0 0-2.504 2.504v15.027c0 1.383 1.12 2.469 2.504 2.469h12.522c1.383 0 2.504-1.121 2.504-2.47V4.505A2.505 2.505 0 0 0 18.261 2Zm.626 17.53c0 .346-.28.627-.626.627H5.739a.627.627 0 0 1-.626-.626V16.4h13.774v3.13Zm0-5.008H5.113V4.504c0-.345.28-.626.626-.626h12.522c.345 0 .626.281.626.626v10.018Zm-8.14 4.383h2.505a.626.626 0 1 0 0-1.253h-2.504a.626.626 0 0 0 0 1.253Z",
        fill: "currentColor"
      }
    )
  })
);
var TabletScreen_default = SvgTabletScreen;

// src/Icon/icons/Tablet.tsx
import { jsx as jsx1293 } from "react/jsx-runtime";
var SvgTablet = (props) => /* @__PURE__ */ jsx1293(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1293(
      "path",
      {
        d: "M18.25 2H5.75a2.5 2.5 0 0 0-2.5 2.5v15a2.5 2.5 0 0 0 2.5 2.5h12.5a2.5 2.5 0 0 0 2.5-2.5v-15c0-1.38-1.121-2.5-2.5-2.5Zm.625 17.5c0 .345-.28.625-.625.625H5.75a.626.626 0 0 1-.625-.625v-15c0-.345.28-.625.625-.625h12.5c.345 0 .625.28.625.625v15Zm-5.625-1.875h-2.5a.625.625 0 1 0 0 1.25h2.5a.625.625 0 1 0 0-1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var Tablet_default = SvgTablet;

// src/Icon/icons/Tablets.tsx
import { jsx as jsx1294 } from "react/jsx-runtime";
var SvgTablets = (props) => /* @__PURE__ */ jsx1294(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1294(
      "path",
      {
        d: "M20.535 5.464a5 5 0 1 0 0 7.072 5 5 0 0 0 0-7.072Zm-6.478 1.651 4.828 4.829c-3.14 2.015-6.853-1.679-4.828-4.829Zm5.89 3.766L15.12 6.053c3.141-2.02 6.85 1.681 4.829 4.828Zm-12.975-.91c-2.734 0-4.972 2.266-4.972 5 0 2.735 2.238 5.03 4.972 5.03C9.706 20 12 17.761 12 14.97c0-2.79-2.237-5-5.028-5Zm-3.386 5.75h6.828c-.801 3.657-6.027 3.676-6.828 0Zm0-1.5c.8-3.653 6.028-3.653 6.828 0H3.586Z",
        fill: "currentColor"
      }
    )
  })
);
var Tablets_default = SvgTablets;

// src/Icon/icons/Tag.tsx
import { jsx as jsx1295 } from "react/jsx-runtime";
var SvgTag = (props) => /* @__PURE__ */ jsx1295(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1295(
      "path",
      {
        d: "M5.658 7.12a1.462 1.462 0 1 1 2.924 0 1.462 1.462 0 0 1-2.924 0ZM11.03 2c.777 0 1.518.308 2.066.857l8.047 8.045a2.93 2.93 0 0 1 0 4.142l-6.1 6.099a2.93 2.93 0 0 1-4.141 0l-8.045-8.047A2.917 2.917 0 0 1 2 11.03V4.195C2 2.983 2.983 2 4.195 2h6.835Zm-6.621 9.546 8.047 8.047a.726.726 0 0 0 1.033 0l6.104-6.104a.726.726 0 0 0 0-1.033L11.546 4.41a.734.734 0 0 0-.516-.214H4.195v6.835c0 .192.077.38.214.516Z",
        fill: "currentColor"
      }
    )
  })
);
var Tag_default = SvgTag;

// src/Icon/icons/Tags.tsx
import { jsx as jsx1296 } from "react/jsx-runtime";
var SvgTags = (props) => /* @__PURE__ */ jsx1296(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1296(
      "path",
      {
        d: "M20.468 8.578a5.317 5.317 0 0 1 0 7.469l-4.375 4.425a.937.937 0 1 1-1.332-1.32l4.371-4.422a3.44 3.44 0 0 0 0-4.836l-4.988-5.047a.932.932 0 0 1 .008-1.326c.367-.364.96-.36 1.289.008l5.027 5.05ZM7.625 7.59c0 .726-.559 1.25-1.25 1.25-.69 0-1.25-.524-1.25-1.25 0-.656.56-1.25 1.25-1.25.691 0 1.25.594 1.25 1.25Zm10.417 2.953a2.504 2.504 0 0 1 0 3.539l-5.21 5.21a2.504 2.504 0 0 1-3.54 0l-6.56-6.562A2.492 2.492 0 0 1 2 10.965v-5.84C2 4.09 2.84 3.25 3.875 3.25h5.84c.664 0 1.296.263 1.765.733l6.562 6.56ZM3.875 5.09v5.875c0 .164.066.324.183.441l6.563 6.562a.62.62 0 0 0 .882 0l5.215-5.214a.62.62 0 0 0 0-.883l-6.562-6.563c-.117-.117-.277-.218-.442-.218h-5.84Z",
        fill: "currentColor"
      }
    )
  })
);
var Tags_default = SvgTags;

// src/Icon/icons/Tally1.tsx
import { jsx as jsx1297 } from "react/jsx-runtime";
var SvgTally1 = (props) => /* @__PURE__ */ jsx1297(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1297(
      "path",
      {
        d: "M12 2c.613 0 1.111.498 1.111 1.111V20.89a1.11 1.11 0 1 1-2.222 0V3.11C10.889 2.498 11.387 2 12 2Z",
        fill: "currentColor"
      }
    )
  })
);
var Tally1_default = SvgTally1;

// src/Icon/icons/Tally2.tsx
import { jsx as jsx1298 } from "react/jsx-runtime";
var SvgTally2 = (props) => /* @__PURE__ */ jsx1298(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1298(
      "path",
      {
        d: "M10.148 20.889a1.11 1.11 0 1 1-2.222 0V3.11a1.111 1.111 0 0 1 2.222 0V20.89Zm5.926 0c0 .616-.495 1.111-1.111 1.111a1.108 1.108 0 0 1-1.111-1.111V3.11a1.11 1.11 0 1 1 2.222 0V20.89Z",
        fill: "currentColor"
      }
    )
  })
);
var Tally2_default = SvgTally2;

// src/Icon/icons/Tally3.tsx
import { jsx as jsx1299 } from "react/jsx-runtime";
var SvgTally3 = (props) => /* @__PURE__ */ jsx1299(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1299(
      "path",
      {
        d: "M6.074 2c.614 0 1.111.498 1.111 1.111V20.89a1.11 1.11 0 1 1-2.222 0V3.11C4.963 2.498 5.461 2 6.074 2ZM12 2a1.11 1.11 0 0 1 1.111 1.111V20.89c0 .616-.495 1.111-1.111 1.111a1.108 1.108 0 0 1-1.111-1.111V3.11A1.11 1.11 0 0 1 12 2Zm7.037 18.889c0 .616-.495 1.111-1.111 1.111a1.108 1.108 0 0 1-1.111-1.111V3.11a1.11 1.11 0 1 1 2.222 0V20.89Z",
        fill: "currentColor"
      }
    )
  })
);
var Tally3_default = SvgTally3;

// src/Icon/icons/Tally4.tsx
import { jsx as jsx1300 } from "react/jsx-runtime";
var SvgTally4 = (props) => /* @__PURE__ */ jsx1300(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1300(
      "path",
      {
        d: "M4.222 20.889a1.11 1.11 0 1 1-2.222 0V3.11a1.111 1.111 0 0 1 2.222 0V20.89Zm5.926 0c0 .616-.495 1.111-1.111 1.111a1.108 1.108 0 0 1-1.111-1.111V3.11a1.11 1.11 0 1 1 2.222 0V20.89ZM14.963 2a1.11 1.11 0 0 1 1.111 1.111V20.89c0 .616-.495 1.111-1.111 1.111a1.108 1.108 0 0 1-1.111-1.111V3.11A1.11 1.11 0 0 1 14.963 2ZM22 20.889c0 .616-.495 1.111-1.111 1.111a1.108 1.108 0 0 1-1.111-1.111V3.11a1.11 1.11 0 1 1 2.222 0V20.89Z",
        fill: "currentColor"
      }
    )
  })
);
var Tally4_default = SvgTally4;

// src/Icon/icons/Tally.tsx
import { jsx as jsx1301 } from "react/jsx-runtime";
var SvgTally = (props) => /* @__PURE__ */ jsx1301(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1301(
      "path",
      {
        d: "M5.82 5.074c.455 0 .769.344.769.77v7.14l2.565-.856V5.843c0-.425.372-.77.77-.77.455 0 .77.345.77.77v5.772l2.593-.853V5.843a.769.769 0 1 1 1.54 0v4.406l2.565-.856v-3.55a.769.769 0 1 1 1.54 0V8.88l2.064-.69c.375-.134.84.084.975.488.106.375-.083.84-.487.975l-2.553.85v7.654c0 .426-.343.77-.77.77a.768.768 0 0 1-.769-.77v-7.141l-2.565.827v6.314c0 .426-.343.77-.77.77a.768.768 0 0 1-.77-.77v-5.801l-2.594.882v4.919a.75.75 0 0 1-.77.77.787.787 0 0 1-.769-.77V13.75l-2.565.856v3.55a.75.75 0 0 1-.77.77.787.787 0 0 1-.77-.77V15.12l-2.036.69c-.403.105-.839-.084-.973-.488a.771.771 0 0 1 .486-.975l2.524-.85V5.844c0-.425.372-.77.77-.77Z",
        fill: "currentColor"
      }
    )
  })
);
var Tally_default = SvgTally;

// src/Icon/icons/Tape.tsx
import { jsx as jsx1302 } from "react/jsx-runtime";
var SvgTape = (props) => /* @__PURE__ */ jsx1302(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1302(
      "path",
      {
        d: "M6.444 12a3.295 3.295 0 0 1 3.334-3.333A3.314 3.314 0 0 1 13.11 12a3.334 3.334 0 0 1-3.333 3.333A3.314 3.314 0 0 1 6.444 12Zm3.334 1.667a1.667 1.667 0 1 0-.001-3.335 1.667 1.667 0 0 0 0 3.335Zm11.389 4.444c.461 0 .833.372.833.833a.831.831 0 0 1-.833.834H9.777A7.778 7.778 0 1 1 17.557 12c0 2.48-1.16 4.656-2.966 6.111h6.577Zm-11.39 0a6.111 6.111 0 1 0 0-12.222 6.111 6.111 0 0 0 0 12.222Z",
        fill: "currentColor"
      }
    )
  })
);
var Tape_default = SvgTape;

// src/Icon/icons/Terminal.tsx
import { jsx as jsx1303 } from "react/jsx-runtime";
var SvgTerminal = (props) => /* @__PURE__ */ jsx1303(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1303(
      "path",
      {
        d: "M2.22 5.625a.833.833 0 0 1 .05-1.177c.338-.312.865-.32 1.177.049l6.39 6.946a.833.833 0 0 1 0 1.125l-6.39 6.944a.833.833 0 1 1-1.226-1.125l5.87-6.381-5.87-6.38Zm18.947 12.492c.461 0 .833.371.833.833a.831.831 0 0 1-.833.833H10.61a.831.831 0 0 1-.833-.833c0-.462.371-.833.833-.833h10.556Z",
        fill: "currentColor"
      }
    )
  })
);
var Terminal_default = SvgTerminal;

// src/Icon/icons/TextHeight.tsx
import { jsx as jsx1304 } from "react/jsx-runtime";
var SvgTextHeight = (props) => /* @__PURE__ */ jsx1304(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1304(
      "path",
      {
        d: "M12.278 4.222H2.833A.834.834 0 0 0 2 5.056v2.777a.832.832 0 1 0 1.667 0V5.89h3.055V18.11H5.056a.835.835 0 0 0-.834.834c0 .458.373.833.834.833h5a.831.831 0 0 0 .833-.833.831.831 0 0 0-.833-.834H8.389V5.89h3.055v1.944a.834.834 0 0 0 1.667 0V5.056a.832.832 0 0 0-.833-.834Zm8.298 11.632-1.076 1.08V7.066l1.077 1.077a.816.816 0 0 0 .59.246.833.833 0 0 0 .59-1.423l-2.501-2.5a.833.833 0 0 0-1.179 0l-2.5 2.5a.833.833 0 1 0 1.179 1.179l1.077-1.079v9.865l-1.077-1.078a.833.833 0 1 0-1.179 1.179l2.5 2.5a.828.828 0 0 0 1.178.002l2.5-2.5a.833.833 0 1 0-1.179-1.18Z",
        fill: "currentColor"
      }
    )
  })
);
var TextHeight_default = SvgTextHeight;

// src/Icon/icons/TextSize.tsx
import { jsx as jsx1305 } from "react/jsx-runtime";
var SvgTextSize = (props) => /* @__PURE__ */ jsx1305(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1305(
      "path",
      {
        d: "M12 11.75v1.5a.75.75 0 0 0 1.5 0v-.75h2.75v5h-1a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-1v-5h2.75v.75a.75.75 0 0 0 1.5 0v-1.5a.75.75 0 0 0-.75-.75h-8.5a.752.752 0 0 0-.75.75Zm-10-6v2.5a.75.75 0 1 0 1.5 0V6.5h3.75v11h-1.5a.752.752 0 0 0-.75.75c0 .413.338.75.75.75h4.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75h-1.5v-11h3.75v1.75a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75H2.75a.75.75 0 0 0-.75.75Z",
        fill: "currentColor"
      }
    )
  })
);
var TextSize_default = SvgTextSize;

// src/Icon/icons/TextSlash.tsx
import { jsx as jsx1306 } from "react/jsx-runtime";
var SvgTextSlash = (props) => /* @__PURE__ */ jsx1306(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1306(
      "path",
      {
        d: "m21.718 18.675-8.887-6.964 1.085-5.198h4.588v1.75a.75.75 0 0 0 1.5 0v-2.5a.75.75 0 0 0-.75-.75H6.752a.751.751 0 0 0-.75.75v.594L3.213 4.172a.75.75 0 1 0-.926 1.18l18.477 14.476a.75.75 0 0 0 1.053-.127c.285-.298.226-.77-.1-1.026ZM7.502 6.513h4.879l-.866 4.166-4.013-3.147v-1.02Zm6.501 11.752a.75.75 0 0 1-.75.75H8.752a.75.75 0 0 1 0-1.5h1.338l.754-3.62 1.318 1.033-.538 2.587h1.629a.75.75 0 0 1 .75.75Z",
        fill: "currentColor"
      }
    )
  })
);
var TextSlash_default = SvgTextSlash;

// src/Icon/icons/TextWidth.tsx
import { jsx as jsx1307 } from "react/jsx-runtime";
var SvgTextWidth = (props) => /* @__PURE__ */ jsx1307(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1307(
      "path",
      {
        d: "M20.928 2H3.072c-.591 0-1.07.48-1.07 1.071V5.93a1.07 1.07 0 1 0 2.142 0V4.143h6.786v7.143H9.5c-.59 0-1.071.482-1.071 1.071 0 .59.482 1.072 1.071 1.072h5a1.072 1.072 0 0 0 0-2.143h-1.429V4.143h6.786v1.786a1.072 1.072 0 0 0 2.143 0V3.07A1.07 1.07 0 0 0 20.928 2Zm-2.495 11.741a1.071 1.071 0 1 0-1.515 1.515l1.426 1.387H5.658l1.385-1.385a1.071 1.071 0 1 0-1.515-1.516l-3.214 3.215a1.071 1.071 0 0 0 0 1.515l3.214 3.214a1.067 1.067 0 0 0 1.515 0 1.071 1.071 0 0 0 0-1.515l-1.385-1.385h12.683l-1.385 1.385a1.071 1.071 0 1 0 1.516 1.515l3.214-3.215a1.071 1.071 0 0 0 0-1.515l-3.253-3.215Z",
        fill: "currentColor"
      }
    )
  })
);
var TextWidth_default = SvgTextWidth;

// src/Icon/icons/Text.tsx
import { jsx as jsx1308 } from "react/jsx-runtime";
var SvgText = (props) => /* @__PURE__ */ jsx1308(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1308(
      "path",
      {
        d: "M22 3.071v3.572c0 .594-.478 1.071-1.071 1.071a1.069 1.069 0 0 1-1.072-1.071v-2.5h-6.786v15.714h2.143a1.072 1.072 0 0 1 0 2.143H8.786a1.072 1.072 0 0 1 0-2.143h2.143V4.143H4.143v2.5a1.07 1.07 0 1 1-2.143 0V3.07C2 2.48 2.48 2 3.071 2H20.93C21.522 2 22 2.48 22 3.071Z",
        fill: "currentColor"
      }
    )
  })
);
var Text_default = SvgText;

// src/Icon/icons/ThoughtBubble.tsx
import { jsx as jsx1309 } from "react/jsx-runtime";
var SvgThoughtBubble = (props) => /* @__PURE__ */ jsx1309(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1309(
      "path",
      {
        d: "M3.25 19.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM7.625 17a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75Zm8.836-12.497A5.355 5.355 0 0 0 11.92 2a5.367 5.367 0 0 0-4.495 2.447C4.419 4.53 2 7.016 2 10.07c0 3.492 3.18 6.332 6.742 5.504a4.263 4.263 0 0 0 6.342.023c.443.114.89.171 1.334.171 3.078.002 5.582-2.534 5.582-5.64 0-3.093-2.48-5.601-5.54-5.625Zm-1.379 9.126a.926.926 0 0 0-1.114.365 2.429 2.429 0 0 1-2.047 1.129c-.83 0-1.596-.425-2.051-1.136-.174-.274-.472-.394-.781-.394a.924.924 0 0 0-.304.05c-.43.115-.82.189-1.203.189-2.052 0-3.721-1.684-3.721-3.755 0-2.064 1.658-3.745 3.787-3.745l.021.001.197.023a.919.919 0 0 0 .898-.508c.618-1.216 1.828-1.97 3.16-1.97 1.36 0 2.582.776 3.188 2.025.17.351.54.562.928.52l.189-.023c.063-.008.125-.02.19-.02 2.052 0 3.721 1.685 3.721 3.756 0 2.512-2.523 4.477-5.058 3.493Z",
        fill: "currentColor"
      }
    )
  })
);
var ThoughtBubble_default = SvgThoughtBubble;

// src/Icon/icons/Thumbtack.tsx
import { jsx as jsx1310 } from "react/jsx-runtime";
var SvgThumbtack = (props) => /* @__PURE__ */ jsx1310(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1310(
      "path",
      {
        d: "M11.063 15.75H5.751c-.385 0-.749-.176-.986-.48-.237-.305-.32-.7-.227-1.075l.244-.972a6.553 6.553 0 0 1 2.685-3.844l.423-5.504H6.688a.938.938 0 0 1 0-1.875h10.625a.937.937 0 1 1 0 1.875H16.11l.426 5.504a6.559 6.559 0 0 1 2.683 3.844l.242.972a1.247 1.247 0 0 1-1.21 1.555h-5.313v5.313c0 .519-.418.937-.973.937-.484 0-.937-.418-.937-.938l.035-5.312Zm-1.797-5.324-.746.508a4.658 4.658 0 0 0-1.919 2.742l-.05.199h4.512v-3.438c0-.519.418-.937.938-.937s.937.418.937.938v3.437h4.512l-.051-.2c-.285-1.152-1.02-2.113-1.918-2.741l-.781-.508-.469-6.551h-4.46l-.505 6.55Z",
        fill: "currentColor"
      }
    )
  })
);
var Thumbtack_default = SvgThumbtack;

// src/Icon/icons/Ticket.tsx
import { jsx as jsx1311 } from "react/jsx-runtime";
var SvgTicket = (props) => /* @__PURE__ */ jsx1311(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1311(
      "path",
      {
        d: "M6.444 9.778a1.11 1.11 0 0 1 1.112-1.111h8.888a1.11 1.11 0 0 1 1.112 1.11v4.445a1.11 1.11 0 0 1-1.112 1.111H7.556a1.11 1.11 0 0 1-1.112-1.11V9.777Zm9.445.555H8.11v3.334h7.778v-3.334ZM22 7.556v2.777a1.667 1.667 0 0 0 0 3.334v2.777a2.224 2.224 0 0 1-2.222 2.223H4.222A2.223 2.223 0 0 1 2 16.444v-2.777a1.667 1.667 0 0 0 0-3.334V7.556c0-1.228.995-2.223 2.222-2.223h15.556c1.226 0 2.222.995 2.222 2.223ZM3.667 9.11a3.336 3.336 0 0 1 0 5.778v1.555c0 .306.248.556.555.556h15.556c.305 0 .555-.25.555-.556V14.89a3.336 3.336 0 0 1 0-5.778V7.556A.557.557 0 0 0 19.778 7H4.222a.556.556 0 0 0-.555.556V9.11Z",
        fill: "currentColor"
      }
    )
  })
);
var Ticket_default = SvgTicket;

// src/Icon/icons/Tilde.tsx
import { jsx as jsx1312 } from "react/jsx-runtime";
var SvgTilde = (props) => /* @__PURE__ */ jsx1312(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1312(
      "path",
      {
        d: "M22 8.786v3.962a4.971 4.971 0 0 1-4.964 4.966 4.997 4.997 0 0 1-4.23-2.364L9.37 9.772A2.832 2.832 0 0 0 6.969 8.43a2.829 2.829 0 0 0-2.826 2.825v3.96a1.07 1.07 0 1 1-2.143 0v-3.96a4.973 4.973 0 0 1 4.969-4.968c1.711 0 3.333.905 4.23 2.364l3.432 5.576a2.828 2.828 0 0 0 2.405 1.345 2.827 2.827 0 0 0 2.821-2.821V8.786c0-.59.482-1.072 1.072-1.072.589 0 1.071.482 1.071 1.072Z",
        fill: "currentColor"
      }
    )
  })
);
var Tilde_default = SvgTilde;

// src/Icon/icons/TimelineArrow.tsx
import { jsx as jsx1313 } from "react/jsx-runtime";
var SvgTimelineArrow = (props) => /* @__PURE__ */ jsx1313(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1313(
      "path",
      {
        d: "M8.5 7a2.499 2.499 0 0 1-1.75 2.384v1.866h5.5V9.384A2.499 2.499 0 0 1 13 4.5a2.5 2.5 0 0 1 .75 4.884v1.866h5.581l-1.84-1.7c-.332-.281-.322-.753-.041-1.06.281-.33.753-.321 1.06-.04l3.246 2.997c.006.003.01.01.013.012.01-.018.019.02.028.029A.753.753 0 0 1 22 12a.753.753 0 0 1-.203.512l-.028.029c-.003.003-.006.009-.013.012L18.51 15.55a.75.75 0 0 1-1.059-.04c-.281-.307-.29-.779.04-1.06l1.841-1.7H9.75v1.866A2.499 2.499 0 0 1 9 19.5a2.5 2.5 0 0 1-.75-4.884V12.75h-5.5a.75.75 0 1 1 0-1.5h2.5V9.384A2.5 2.5 0 1 1 8.5 7ZM6 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm3 12a.999.999 0 1 0 0-2 .999.999 0 1 0 0 2Zm4-10a.999.999 0 1 0 0-2 1 1 0 1 0 0 2Z",
        fill: "currentColor"
      }
    )
  })
);
var TimelineArrow_default = SvgTimelineArrow;

// src/Icon/icons/Timeline.tsx
import { jsx as jsx1314 } from "react/jsx-runtime";
var SvgTimeline = (props) => /* @__PURE__ */ jsx1314(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1314(
      "path",
      {
        d: "M6.75 11.25h10.5V9.384A2.499 2.499 0 0 1 18 4.5a2.5 2.5 0 0 1 .75 4.884v1.866h2.5c.416 0 .75.334.75.75s-.334.75-.75.75h-8.5v1.866A2.499 2.499 0 0 1 12 19.5a2.5 2.5 0 0 1-.75-4.884V12.75h-8.5a.75.75 0 1 1 0-1.5h2.5V9.384a2.5 2.5 0 1 1 1.5 0v1.866ZM6 8a.999.999 0 1 0 0-2 1 1 0 1 0 0 2Zm6 8a.999.999 0 1 0 0 2 .999.999 0 1 0 0-2Zm6-10a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
        fill: "currentColor"
      }
    )
  })
);
var Timeline_default = SvgTimeline;

// src/Icon/icons/Timer.tsx
import { jsx as jsx1315 } from "react/jsx-runtime";
var SvgTimer = (props) => /* @__PURE__ */ jsx1315(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1315(
      "path",
      {
        d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12a9.96 9.96 0 0 1 1.725-5.617.938.938 0 0 1 1.55 1.054C4.391 8.739 3.84 10.31 3.84 12c0 4.488 3.672 8.125 8.125 8.125a8.124 8.124 0 0 0 .973-16.196v2.134c0 .519-.418.937-.973.937a.958.958 0 0 1-.938-.938V2.938c0-.517.454-.937.938-.937C17.523 2 22 6.477 22 12Zm-9.371-.664c.398.367.398.96 0 1.293-.332.398-.926.398-1.293 0L8.21 9.504c-.363-.332-.363-.926 0-1.293.367-.363.96-.363 1.293 0l3.125 3.125Z",
        fill: "currentColor"
      }
    )
  })
);
var Timer_default = SvgTimer;

// src/Icon/icons/ToggleLargeOff.tsx
import { jsx as jsx1316 } from "react/jsx-runtime";
var SvgToggleLargeOff = (props) => /* @__PURE__ */ jsx1316(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1316(
      "path",
      {
        d: "M2 12a6.648 6.648 0 0 1 6.667-6.667h6.666A6.648 6.648 0 0 1 22 12a6.668 6.668 0 0 1-6.667 6.667H8.667A6.668 6.668 0 0 1 2 12Zm6.667-5c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5Zm6.666 10a5.001 5.001 0 0 0 0-10h-2.288a6.57 6.57 0 0 1 2.288 5 6.57 6.57 0 0 1-2.288 5h2.288Z",
        fill: "currentColor"
      }
    )
  })
);
var ToggleLargeOff_default = SvgToggleLargeOff;

// src/Icon/icons/ToggleLargeOn.tsx
import { jsx as jsx1317 } from "react/jsx-runtime";
var SvgToggleLargeOn = (props) => /* @__PURE__ */ jsx1317(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1317(
      "path",
      {
        d: "M15.333 5.333A6.648 6.648 0 0 1 22 12a6.668 6.668 0 0 1-6.667 6.667H8.667A6.668 6.668 0 0 1 2 12a6.648 6.648 0 0 1 6.667-6.667h6.666Zm0 11.667a5.001 5.001 0 0 0 0-10c-2.76 0-5 2.24-5 5s2.24 5 5 5Z",
        fill: "currentColor"
      }
    )
  })
);
var ToggleLargeOn_default = SvgToggleLargeOn;

// src/Icon/icons/ToggleOff.tsx
import { jsx as jsx1318 } from "react/jsx-runtime";
var SvgToggleOff = (props) => /* @__PURE__ */ jsx1318(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1318(
      "path",
      {
        d: "M8.667 8.667A3.314 3.314 0 0 1 12 12a3.334 3.334 0 0 1-3.333 3.333A3.314 3.314 0 0 1 5.333 12a3.295 3.295 0 0 1 3.334-3.333ZM7 12a1.667 1.667 0 1 0 3.334 0A1.667 1.667 0 0 0 7 12Zm8.333 6.667H8.667A6.668 6.668 0 0 1 2 12a6.648 6.648 0 0 1 6.667-6.667h6.666A6.648 6.648 0 0 1 22 12a6.668 6.668 0 0 1-6.667 6.667Zm0-11.667H8.667c-2.76 0-5 2.24-5 5s2.24 5 5 5h6.666a5.001 5.001 0 0 0 0-10Z",
        fill: "currentColor"
      }
    )
  })
);
var ToggleOff_default = SvgToggleOff;

// src/Icon/icons/ToggleOn.tsx
import { jsx as jsx1319 } from "react/jsx-runtime";
var SvgToggleOn = (props) => /* @__PURE__ */ jsx1319(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1319(
      "path",
      {
        d: "M12 12a3.295 3.295 0 0 1 3.333-3.333A3.314 3.314 0 0 1 18.667 12a3.334 3.334 0 0 1-3.334 3.333A3.314 3.314 0 0 1 12 12ZM2 12a6.648 6.648 0 0 1 6.667-6.667h6.666A6.648 6.648 0 0 1 22 12a6.668 6.668 0 0 1-6.667 6.667H8.667A6.668 6.668 0 0 1 2 12Zm1.667 0c0 2.76 2.24 5 5 5h6.666a5.001 5.001 0 0 0 0-10H8.667c-2.76 0-5 2.24-5 5Z",
        fill: "currentColor"
      }
    )
  })
);
var ToggleOn_default = SvgToggleOn;

// src/Icon/icons/Toolbox.tsx
import { jsx as jsx1320 } from "react/jsx-runtime";
var SvgToolbox = (props) => /* @__PURE__ */ jsx1320(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1320(
      "path",
      {
        d: "m21.633 10.383-3.018-3.018A1.255 1.255 0 0 0 17.731 7H17V5.437a2.19 2.19 0 0 0-2.188-2.187H9.189A2.19 2.19 0 0 0 7 5.438V7h-.73c-.332 0-.652.133-.886.367l-3.018 3.016A1.256 1.256 0 0 0 2 11.27v6.98a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5v-6.98c0-.332-.133-.653-.367-.887ZM8.875 5.438c0-.173.14-.313.313-.313h5.624c.173 0 .313.14.313.313V7h-6.25V5.437ZM6.527 8.874h10.946l2.652 2.652v2.036h-3.438v-.66c0-.485-.418-.903-.937-.903-.52 0-.938.42-.938.902v.66H9.189v-.66c0-.484-.418-.902-.938-.902s-.938.418-.938.902v.66H3.876v-2.035l2.652-2.652Zm12.973 10h-15a.625.625 0 0 1-.625-.625v-2.813h3.438v.626c0 .519.417.937.902.937.555 0 .973-.418.973-.938v-.625h5.624v.626c0 .519.418.937.938.937s.938-.42.938-.902v-.66h3.437v2.812a.627.627 0 0 1-.625.625Z",
        fill: "currentColor"
      }
    )
  })
);
var Toolbox_default = SvgToolbox;

// src/Icon/icons/Trademark.tsx
import { jsx as jsx1321 } from "react/jsx-runtime";
var SvgTrademark = (props) => /* @__PURE__ */ jsx1321(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1321(
      "path",
      {
        d: "M9.25 7h-6.5a.751.751 0 0 0 0 1.5h2.52c-.004.034-.02.065-.02.1v7.65a.75.75 0 0 0 1.5 0V8.6c0-.035-.016-.066-.019-.1H9.25c.416 0 .75-.335.75-.75A.748.748 0 0 0 9.25 7Zm12.238.038a.759.759 0 0 0-.838.264l-4.15 5.567-4.15-5.57a.756.756 0 0 0-.838-.263.756.756 0 0 0-.512.714v8.5a.75.75 0 0 0 1.5 0v-6.238l3.4 4.535c.283.378.92.378 1.203 0l3.397-4.535v6.238a.75.75 0 0 0 1.5 0v-8.5a.752.752 0 0 0-.512-.712Z",
        fill: "currentColor"
      }
    )
  })
);
var Trademark_default = SvgTrademark;

// src/Icon/icons/Trophy.tsx
import { jsx as jsx1322 } from "react/jsx-runtime";
var SvgTrophy = (props) => /* @__PURE__ */ jsx1322(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx1322(
      "path",
      {
        d: "M21.865 5.971a.836.836 0 0 0-.813-.638h-3.5c.009-.432.004-.823-.005-1.146a1.103 1.103 0 0 0-1.11-1.076H7.564c-.605 0-1.094.473-1.112 1.076-.038.323-.013.714-.003 1.146H2.946a.834.834 0 0 0-.81.638c-.028.119-.682 2.946 1.151 5.678 1.3 1.939 3.493 3.3 6.51 4.077.65.167 1.37.772 1.37 1.442v2.054H8.389c-.46 0-.802.374-.802.834 0 .46.344.833.802.833h7.19c.461 0 .803-.373.803-.833 0-.46-.373-.834-.802-.834h-2.747v-2.057c.002-.67.72-1.273 1.369-1.44 3.02-.776 5.212-2.137 6.51-4.076 1.833-2.732 1.18-5.56 1.153-5.678ZM4.688 10.743C3.718 9.313 3.632 7.823 3.68 7H6.47c.186 2.07.707 4.552 2.003 6.566-1.703-.677-2.97-1.622-3.786-2.823ZM12 15.333C10.066 13.17 8.1 11.13 8.111 4.778h7.747c.041 6.347-1.924 8.389-3.858 10.555Zm7.313-4.59c-.814 1.201-2.082 2.144-3.785 2.82 1.295-2.01 1.816-4.494 2-6.563h2.791c.018.823-.038 2.316-1.006 3.743Z",
        fill: "currentColor"
      }
    )
  })
);
var Trophy_default = SvgTrophy;

// src/Icon/icons/TransparencyDatabase.tsx
import { jsx as jsx1323 } from "react/jsx-runtime";
var SvgTransparencyDatabase = (props) => /* @__PURE__ */ jsx1323(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1323(
      "path",
      {
        d: "M11.816 21.585c-4.52 0-7.535-1.708-7.535-4.127v-10.6c0-2.209 3.014-3.733 7.535-3.733 4.52 0 7.535 1.524 7.535 3.732v10.601c0 2.419-3.014 4.127-7.535 4.127Zm0-12.327c3.67 0 6.124-.99 6.124-2.4 0-1.473-2.453-2.498-6.124-2.498S5.692 5.385 5.692 6.857c0 1.41 2.453 2.4 6.124 2.4Zm0 1.323c-2.672 0-4.819-.526-6.124-1.42v3.987c1.445.937 3.785 1.55 6.124 1.55 2.34 0 4.678-.613 6.124-1.55V9.162c-1.305.893-3.452 1.419-6.124 1.419Zm0 5.44c-2.304 0-4.565-.534-6.124-1.384v2.821c0 1.621 2.453 2.804 6.124 2.804 3.67 0 6.124-1.183 6.124-2.804v-2.82c-1.56.85-3.829 1.384-6.124 1.384Z",
        fill: "currentColor"
      }
    )
  })
);
var TransparencyDatabase_default = SvgTransparencyDatabase;

// src/Icon/icons/TrashArrowUp.tsx
import { jsx as jsx1324 } from "react/jsx-runtime";
var SvgTrashArrowUp = (props) => /* @__PURE__ */ jsx1324(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1324(
      "path",
      {
        d: "M12 8.84c.25 0 .488.133.629.308l3.125 3.125c.398.368.398.961 0 1.293-.332.399-.926.399-1.293 0l-1.524-1.492v5.239c0 .519-.417.937-.937.937a.935.935 0 0 1-.938-.938v-5.238l-1.558 1.492c-.332.399-.926.399-1.293 0-.363-.332-.363-.925 0-1.293l3.125-3.125c.176-.175.414-.308.664-.308Zm3.652-5.866 1.434 2.151h2.727a.937.937 0 1 1 0 1.875h-.454l-.937 12.684A2.502 2.502 0 0 1 15.93 22H8.07a2.501 2.501 0 0 1-2.491-2.316L4.639 7h-.452a.936.936 0 1 1 0-1.875h2.728l1.433-2.15A2.19 2.19 0 0 1 10.168 2h3.664c.73 0 1.414.366 1.82.974ZM9.168 5.125h5.664l-.742-1.11a.314.314 0 0 0-.258-.14h-3.664c-.102 0-.234.052-.258.14l-.742 1.11ZM7.449 19.547a.626.626 0 0 0 .621.578h7.86a.626.626 0 0 0 .62-.578L17.48 7H6.52l.93 12.547Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashArrowUp_default = SvgTrashArrowUp;

// src/Icon/icons/TrashCanArrowUp.tsx
import { jsx as jsx1325 } from "react/jsx-runtime";
var SvgTrashCanArrowUp = (props) => /* @__PURE__ */ jsx1325(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1325(
      "path",
      {
        d: "M12 8.84c.25 0 .488.133.629.308l3.125 3.125c.398.368.398.961 0 1.293-.332.399-.926.399-1.293 0l-1.524-1.492v5.239c0 .519-.417.937-.937.937a.935.935 0 0 1-.938-.938v-5.238l-1.558 1.492c-.332.399-.926.399-1.293 0-.363-.332-.363-.925 0-1.293l3.125-3.125c.176-.175.414-.308.664-.308Zm3.652-5.866 1.434 2.151h2.727a.937.937 0 1 1 0 1.875H19.5v11.875A3.124 3.124 0 0 1 16.375 22h-8.75A3.125 3.125 0 0 1 4.5 18.875V7h-.313a.936.936 0 1 1 0-1.875h2.728l1.433-2.15A2.19 2.19 0 0 1 10.168 2h3.664c.73 0 1.414.366 1.82.974ZM9.168 5.125h5.664l-.742-1.11a.314.314 0 0 0-.258-.14h-3.664c-.102 0-.234.052-.258.14l-.742 1.11Zm-2.793 13.75c0 .691.56 1.25 1.25 1.25h8.75c.691 0 1.25-.559 1.25-1.25V7H6.375v11.875Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashCanArrowUp_default = SvgTrashCanArrowUp;

// src/Icon/icons/TrashCanCheck.tsx
import { jsx as jsx1326 } from "react/jsx-runtime";
var SvgTrashCanCheck = (props) => /* @__PURE__ */ jsx1326(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1326(
      "path",
      {
        d: "M11.523 16.523a1.096 1.096 0 0 1-1.546 0l-2.5-2.5a1.094 1.094 0 0 1 1.546-1.546l1.727 1.726 4.227-4.226a1.096 1.096 0 0 1 1.546 0 1.096 1.096 0 0 1 0 1.546l-5 5Zm4.13-13.549 1.433 2.151h2.727a.937.937 0 1 1 0 1.875H19.5v11.875A3.124 3.124 0 0 1 16.375 22h-8.75A3.125 3.125 0 0 1 4.5 18.875V7h-.313a.936.936 0 1 1 0-1.875h2.728l1.433-2.15A2.19 2.19 0 0 1 10.168 2h3.664c.73 0 1.414.366 1.82.974ZM9.167 5.125h5.664l-.742-1.11a.314.314 0 0 0-.258-.14h-3.664c-.102 0-.234.052-.258.14l-.742 1.11Zm-2.793 13.75c0 .691.56 1.25 1.25 1.25h8.75c.691 0 1.25-.559 1.25-1.25V7H6.375v11.875Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashCanCheck_default = SvgTrashCanCheck;

// src/Icon/icons/TrashCanClock.tsx
import { jsx as jsx1327 } from "react/jsx-runtime";
var SvgTrashCanClock = (props) => /* @__PURE__ */ jsx1327(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1327(
      "path",
      {
        d: "M13.024 3.977 14.3 5.89h2.423a.833.833 0 1 1 0 1.667h-.278v2.246a7.407 7.407 0 0 0-1.666.361V7.556H4.747V18.11c0 .615.528 1.111 1.11 1.111h6.022a6.12 6.12 0 0 0 1.607 1.667H5.89A2.777 2.777 0 0 1 3.11 18.11V7.556h-.278a.832.832 0 1 1 0-1.667h2.425L6.53 3.977a1.946 1.946 0 0 1 1.618-.866h3.257c.65 0 1.257.325 1.618.866ZM7.26 5.89h5.035l-.66-.988a.279.279 0 0 0-.229-.123H8.15c-.09 0-.208.046-.229.123l-.66.988Zm5.851 3.889v1.396c-.42.35-.795.753-1.142 1.201V9.778c0-.306.281-.556.587-.556.305 0 .555.25.555.556ZM7.524 17a.538.538 0 0 1-.555.556.579.579 0 0 1-.556-.556V9.778c0-.306.281-.556.556-.556.337 0 .555.25.555.556V17Zm2.778 0a.538.538 0 0 1-.555.556A.579.579 0 0 1 9.19 17V9.778c0-.306.281-.556.556-.556.336 0 .555.25.555.556V17ZM22 15.889c0 2.76-2.24 5-5 5s-5.031-2.24-5.031-5 2.27-5 5.031-5c2.76 0 5 2.24 5 5Zm-5.587-2.222v2.222c0 .305.281.555.556.555h1.698c.305 0 .555-.25.555-.555a.557.557 0 0 0-.555-.556h-1.143v-1.666a.538.538 0 0 0-.555-.556.579.579 0 0 0-.556.556Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashCanClock_default = SvgTrashCanClock;

// src/Icon/icons/TrashCanList.tsx
import { jsx as jsx1328 } from "react/jsx-runtime";
var SvgTrashCanList = (props) => /* @__PURE__ */ jsx1328(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1328(
      "path",
      {
        d: "M7 9.5c.275 0 .5.225.5.5v6.5c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5V10c0-.275.225-.5.5-.5Zm3 0c.275 0 .5.225.5.5v6.5c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5V10c0-.275.225-.5.5-.5Zm4.25-3a.75.75 0 1 1 0 1.5H14v9.5a2.5 2.5 0 0 1-2.5 2.5h-6A2.5 2.5 0 0 1 3 17.5V8h-.25a.75.75 0 1 1 0-1.5h1.682l1.146-1.72C5.903 4.291 6.45 4 7.034 4h2.932c.584 0 1.13.292 1.456.78l1.147 1.72h1.681Zm-7.216-1c-.08 0-.187.042-.206.111l-.594.889h4.532l-.594-.889a.251.251 0 0 0-.206-.111H7.034ZM12.5 8h-8v9.5a1 1 0 0 0 1 1h6c.553 0 1-.447 1-1V8Zm8.75 0c.416 0 .75.334.75.75s-.334.75-.75.75h-4.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h4.5Zm-1 4c.416 0 .75.334.75.75s-.334.75-.75.75h-3.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h3.5ZM16 16.75c0-.416.334-.75.75-.75h1.5c.416 0 .75.334.75.75s-.334.75-.75.75h-1.5a.748.748 0 0 1-.75-.75Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashCanList_default = SvgTrashCanList;

// src/Icon/icons/TrashCanPlus.tsx
import { jsx as jsx1329 } from "react/jsx-runtime";
var SvgTrashCanPlus = (props) => /* @__PURE__ */ jsx1329(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1329(
      "path",
      {
        d: "M11.063 16.688v-2.5h-2.5a.935.935 0 0 1-.938-.938c0-.52.418-.938.938-.938h2.5v-2.5c0-.519.417-.937.937-.937s.938.418.938.938v2.5h2.5c.519 0 .937.417.937.937s-.418.938-.938.938h-2.5v2.5c0 .519-.417.937-.937.937a.935.935 0 0 1-.938-.938Zm4.59-13.714 1.433 2.151h2.727a.937.937 0 1 1 0 1.875H19.5v11.875A3.124 3.124 0 0 1 16.375 22h-8.75A3.125 3.125 0 0 1 4.5 18.875V7h-.313a.936.936 0 1 1 0-1.875h2.728l1.433-2.15A2.19 2.19 0 0 1 10.168 2h3.664c.73 0 1.414.366 1.82.974ZM9.167 5.125h5.664l-.742-1.11a.314.314 0 0 0-.258-.14h-3.664c-.102 0-.234.052-.258.14l-.742 1.11Zm-2.793 13.75c0 .691.56 1.25 1.25 1.25h8.75c.691 0 1.25-.559 1.25-1.25V7H6.375v11.875Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashCanPlus_default = SvgTrashCanPlus;

// src/Icon/icons/TrashCanSlash.tsx
import { jsx as jsx1330 } from "react/jsx-runtime";
var SvgTrashCanSlash = (props) => /* @__PURE__ */ jsx1330(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1330(
      "path",
      {
        d: "M6.2 6.5h1.731l1.147-1.72c.325-.488.872-.78 1.456-.78h2.931c.585 0 1.132.292 1.457.78l1.147 1.72h2.153c.444 0 .75.336.75.75a.73.73 0 0 1-.75.75h-.25v7.722l3.74 2.937a.75.75 0 0 1-.925 1.181l-18.5-14.5a.75.75 0 1 1 .926-1.18L6.2 6.5ZM8.112 8l3.36 2.628V10c0-.275.253-.5.5-.5.303 0 .5.225.5.5v1.437l1.5 1.179V10c0-.275.253-.5.5-.5.303 0 .5.225.5.5v3.397l1.5 1.178V8h-8.36Zm2.422-2.5c-.084 0-.187.042-.206.111l-.594.889h4.531l-.593-.889a.251.251 0 0 0-.207-.111h-2.93ZM15.472 20h-7c-1.353 0-2.5-1.119-2.5-2.5v-7.347l1.5 1.181V17.5c0 .553.475 1 1 1h7c.281 0 .562-.116.743-.3l1.182.931c-.488.531-1.138.869-1.925.869Zm-5.5-6.697V16.5c0 .275-.197.5-.5.5a.52.52 0 0 1-.5-.5v-3.985l1 .788Zm2.5 1.969V16.5c0 .275-.197.5-.5.5a.52.52 0 0 1-.5-.5v-2.016l1 .788Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashCanSlash_default = SvgTrashCanSlash;

// src/Icon/icons/TrashCanUndo.tsx
import { jsx as jsx1331 } from "react/jsx-runtime";
var SvgTrashCanUndo = (props) => /* @__PURE__ */ jsx1331(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1331(
      "path",
      {
        d: "M12.074 9.504c.344.351.313.976-.078 1.32l-.969.864h1.598a3.438 3.438 0 0 1 3.438 3.437v.938c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938v-.937c0-.863-.699-1.563-1.562-1.563h-1.598l.97.864a.93.93 0 0 1 .077 1.32c-.344.39-.969.422-1.32.078l-2.813-2.5a.94.94 0 0 1-.316-.734c0-.235.113-.488.316-.664l2.813-2.5c.351-.344.976-.313 1.32.078Zm3.578-6.53 1.434 2.151h2.727a.937.937 0 1 1 0 1.875H19.5v11.875A3.124 3.124 0 0 1 16.375 22h-8.75A3.125 3.125 0 0 1 4.5 18.875V7h-.313a.936.936 0 1 1 0-1.875h2.728l1.433-2.15A2.19 2.19 0 0 1 10.168 2h3.664c.73 0 1.414.366 1.82.974ZM9.168 5.125h5.664l-.742-1.11a.314.314 0 0 0-.258-.14h-3.664c-.102 0-.234.052-.258.14l-.742 1.11Zm-2.793 13.75c0 .691.56 1.25 1.25 1.25h8.75c.691 0 1.25-.559 1.25-1.25V7H6.375v11.875Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashCanUndo_default = SvgTrashCanUndo;

// src/Icon/icons/TrashCanXmark.tsx
import { jsx as jsx1332 } from "react/jsx-runtime";
var SvgTrashCanXmark = (props) => /* @__PURE__ */ jsx1332(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1332(
      "path",
      {
        d: "M8.836 10.086c.367-.363.96-.363 1.293 0l1.836 1.84 1.87-1.84c.368-.363.962-.363 1.294 0 .398.367.398.96 0 1.293l-1.805 1.836 1.805 1.87c.398.368.398.962 0 1.294-.332.398-.926.398-1.293 0l-1.871-1.805-1.836 1.805c-.332.398-.926.398-1.293 0-.363-.332-.363-.926 0-1.293l1.84-1.871-1.84-1.836c-.363-.332-.363-.926 0-1.293Zm6.816-7.112 1.434 2.151h2.727a.937.937 0 1 1 0 1.875H19.5v11.875A3.124 3.124 0 0 1 16.375 22h-8.75A3.125 3.125 0 0 1 4.5 18.875V7h-.313a.936.936 0 1 1 0-1.875h2.728l1.433-2.15A2.19 2.19 0 0 1 10.168 2h3.664c.73 0 1.414.366 1.82.974ZM9.168 5.125h5.664l-.742-1.11a.314.314 0 0 0-.258-.14h-3.664c-.102 0-.234.052-.258.14l-.742 1.11Zm-2.793 13.75c0 .691.56 1.25 1.25 1.25h8.75c.691 0 1.25-.559 1.25-1.25V7H6.375v11.875Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashCanXmark_default = SvgTrashCanXmark;

// src/Icon/icons/TrashCan.tsx
import { jsx as jsx1333 } from "react/jsx-runtime";
var SvgTrashCan = (props) => /* @__PURE__ */ jsx1333(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1333(
      "path",
      {
        d: "M9.5 17.625a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625V9.5c0-.344.281-.625.625-.625s.625.281.625.625v8.125Zm3.125 0a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625V9.5c0-.344.281-.625.625-.625s.625.281.625.625v8.125Zm3.125 0a.627.627 0 0 1-.625.625.627.627 0 0 1-.625-.625V9.5c0-.344.281-.625.625-.625s.625.281.625.625v8.125Zm-.098-14.65 1.434 2.15h2.727a.937.937 0 1 1 0 1.875H19.5v11.875A3.124 3.124 0 0 1 16.375 22h-8.75A3.125 3.125 0 0 1 4.5 18.875V7h-.313a.936.936 0 1 1 0-1.875h2.728l1.433-2.15A2.19 2.19 0 0 1 10.168 2h3.664c.73 0 1.414.366 1.82.974Zm-6.484 2.15h5.664l-.742-1.11a.314.314 0 0 0-.258-.14h-3.664c-.102 0-.234.052-.258.14l-.742 1.11Zm-2.793 13.75c0 .691.56 1.25 1.25 1.25h8.75c.691 0 1.25-.559 1.25-1.25V7H6.375v11.875Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashCan_default = SvgTrashCan;

// src/Icon/icons/TrashCheck.tsx
import { jsx as jsx1334 } from "react/jsx-runtime";
var SvgTrashCheck = (props) => /* @__PURE__ */ jsx1334(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1334(
      "path",
      {
        d: "M11.523 15.898a1.096 1.096 0 0 1-1.546 0l-1.875-1.875a1.096 1.096 0 0 1 0-1.546 1.096 1.096 0 0 1 1.546 0l1.102 1.101 3.602-3.601a1.096 1.096 0 0 1 1.546 0 1.096 1.096 0 0 1 0 1.546l-4.375 4.375Zm4.13-12.924 1.433 2.151h2.727a.937.937 0 1 1 0 1.875h-.454l-.937 12.684A2.502 2.502 0 0 1 15.93 22H8.07a2.501 2.501 0 0 1-2.491-2.316L4.639 7h-.452a.936.936 0 1 1 0-1.875h2.728l1.433-2.15A2.19 2.19 0 0 1 10.168 2h3.664c.73 0 1.414.366 1.82.974ZM9.167 5.125h5.664l-.742-1.11a.314.314 0 0 0-.258-.14h-3.664c-.102 0-.234.052-.258.14l-.742 1.11ZM7.449 19.547a.626.626 0 0 0 .621.578h7.86a.626.626 0 0 0 .62-.578L17.48 7H6.52l.93 12.547Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashCheck_default = SvgTrashCheck;

// src/Icon/icons/TrashClock.tsx
import { jsx as jsx1335 } from "react/jsx-runtime";
var SvgTrashClock = (props) => /* @__PURE__ */ jsx1335(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1335(
      "path",
      {
        d: "M16.722 5.889a.833.833 0 1 1 0 1.667h-.403l-.166 2.28a5.997 5.997 0 0 0-1.709.5l.205-2.78H4.906l.827 11.152c.02.289.264.514.552.514h5.594c.42.65.961 1.212 1.593 1.656-.066.007-.135.01-.201.01H6.285c-1.163 0-2.13-.898-2.215-2.058L3.235 7.556h-.402a.832.832 0 1 1 0-1.667h2.425L6.53 3.977a1.946 1.946 0 0 1 1.618-.866h3.257c.65 0 1.257.325 1.618.866L14.3 5.89h2.423ZM8.15 4.778c-.09 0-.208.046-.229.123l-.66.988h5.035l-.66-.988a.279.279 0 0 0-.229-.123H8.15ZM22 15.888c0 2.761-2.24 5-5 5s-5-2.239-5-5c0-2.76 2.24-5 5-5s5 2.24 5 5Zm-5.587-2.221v2.222c0 .305.281.555.556.555h1.698c.305 0 .555-.25.555-.555a.557.557 0 0 0-.555-.556h-1.143v-1.666a.538.538 0 0 0-.555-.556.579.579 0 0 0-.556.556Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashClock_default = SvgTrashClock;

// src/Icon/icons/TrashList.tsx
import { jsx as jsx1336 } from "react/jsx-runtime";
var SvgTrashList = (props) => /* @__PURE__ */ jsx1336(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1336(
      "path",
      {
        d: "m10.922 4.78 1.147 1.72h2.181a.75.75 0 1 1 0 1.5h-.363l-.75 10.147A2.001 2.001 0 0 1 11.144 20H5.856a2.001 2.001 0 0 1-1.993-1.853L3.11 8H2.75a.75.75 0 1 1 0-1.5h2.182l1.146-1.72C6.403 4.291 6.95 4 7.534 4h1.932c.584 0 1.13.292 1.456.78ZM6.734 6.5h3.532l-.594-.889a.251.251 0 0 0-.206-.111H7.534c-.08 0-.187.042-.206.111l-.594.889ZM5.36 18.038a.5.5 0 0 0 .497.462h5.288a.5.5 0 0 0 .497-.462L12.384 8H4.615l.744 10.038ZM21.25 8c.416 0 .75.334.75.75s-.334.75-.75.75h-4.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h4.5Zm-1 4c.416 0 .75.334.75.75s-.334.75-.75.75h-3.5a.748.748 0 0 1-.75-.75c0-.416.334-.75.75-.75h3.5ZM16 16.75c0-.416.334-.75.75-.75h1.5c.416 0 .75.334.75.75s-.334.75-.75.75h-1.5a.748.748 0 0 1-.75-.75Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashList_default = SvgTrashList;

// src/Icon/icons/TrashPlus.tsx
import { jsx as jsx1337 } from "react/jsx-runtime";
var SvgTrashPlus = (props) => /* @__PURE__ */ jsx1337(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1337(
      "path",
      {
        d: "M11.063 16.688v-2.5h-2.5a.935.935 0 0 1-.938-.938c0-.52.418-.938.938-.938h2.5v-2.5c0-.519.417-.937.937-.937s.938.418.938.938v2.5h2.5c.519 0 .937.417.937.937s-.418.938-.938.938h-2.5v2.5c0 .519-.417.937-.937.937a.935.935 0 0 1-.938-.938Zm4.59-13.714 1.433 2.151h2.727a.937.937 0 1 1 0 1.875h-.454l-.937 12.684A2.502 2.502 0 0 1 15.93 22H8.07a2.501 2.501 0 0 1-2.491-2.316L4.639 7h-.452a.936.936 0 1 1 0-1.875h2.728l1.433-2.15A2.19 2.19 0 0 1 10.168 2h3.664c.73 0 1.414.366 1.82.974ZM9.167 5.125h5.664l-.742-1.11a.314.314 0 0 0-.258-.14h-3.664c-.102 0-.234.052-.258.14l-.742 1.11ZM7.449 19.547a.626.626 0 0 0 .621.578h7.86a.626.626 0 0 0 .62-.578L17.48 7H6.52l.93 12.547Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashPlus_default = SvgTrashPlus;

// src/Icon/icons/TrashSlash.tsx
import { jsx as jsx1338 } from "react/jsx-runtime";
var SvgTrashSlash = (props) => /* @__PURE__ */ jsx1338(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1338(
      "path",
      {
        d: "M6.2 6.5h1.731l1.147-1.72c.325-.488.872-.78 1.456-.78h2.931c.585 0 1.132.292 1.457.78l1.147 1.72h2.18a.75.75 0 1 1 0 1.5h-.362l-.534 7.244 4.36 3.415a.75.75 0 0 1-.926 1.181l-18.5-14.5a.75.75 0 1 1 .926-1.18L6.2 6.5ZM8.112 8l7.82 6.128L16.383 8H8.112Zm2.422-2.5c-.081 0-.187.042-.206.111l-.594.889h4.531l-.593-.889a.251.251 0 0 0-.207-.111h-2.93ZM6.862 18.147l-.575-7.769 1.597 1.26.475 6.4a.5.5 0 0 0 .497.462h6.288a.5.5 0 0 0 .496-.463l.022-.275 1.313 1.038c-.31.71-1.016 1.2-1.831 1.2H8.856a1.999 1.999 0 0 1-1.994-1.853Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashSlash_default = SvgTrashSlash;

// src/Icon/icons/TrashUndo.tsx
import { jsx as jsx1339 } from "react/jsx-runtime";
var SvgTrashUndo = (props) => /* @__PURE__ */ jsx1339(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1339(
      "path",
      {
        d: "M12.074 9.504c.344.351.313.976-.078 1.32l-.969.864h1.598a3.438 3.438 0 0 1 3.438 3.437v.938c0 .519-.418.937-.938.937a.935.935 0 0 1-.938-.938v-.937c0-.863-.699-1.563-1.562-1.563h-1.598l.97.864a.93.93 0 0 1 .077 1.32c-.344.39-.969.422-1.32.078l-2.813-2.5a.94.94 0 0 1-.316-.734c0-.235.113-.488.316-.664l2.813-2.5c.351-.344.976-.313 1.32.078Zm7.739-4.379a.937.937 0 1 1 0 1.875h-.454l-.937 12.684A2.502 2.502 0 0 1 15.93 22H8.07a2.501 2.501 0 0 1-2.491-2.316L4.639 7h-.452a.936.936 0 1 1 0-1.875h2.728l1.433-2.15A2.19 2.19 0 0 1 10.168 2h3.664c.73 0 1.414.366 1.82.974l1.434 2.151h2.727Zm-9.645-1.25c-.102 0-.234.052-.258.14l-.742 1.11h5.664l-.742-1.11a.314.314 0 0 0-.258-.14h-3.664ZM17.481 7H6.518l.93 12.547a.626.626 0 0 0 .621.578h7.86a.626.626 0 0 0 .62-.578L17.48 7Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashUndo_default = SvgTrashUndo;

// src/Icon/icons/TrashXmark.tsx
import { jsx as jsx1340 } from "react/jsx-runtime";
var SvgTrashXmark = (props) => /* @__PURE__ */ jsx1340(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1340(
      "path",
      {
        d: "M8.836 10.086c.367-.363.96-.363 1.293 0l1.836 1.84 1.87-1.84c.368-.363.962-.363 1.294 0 .398.367.398.96 0 1.293l-1.805 1.836 1.805 1.87c.398.368.398.962 0 1.294-.332.398-.926.398-1.293 0l-1.871-1.805-1.836 1.805c-.332.398-.926.398-1.293 0-.363-.332-.363-.926 0-1.293l1.84-1.871-1.84-1.836c-.363-.332-.363-.926 0-1.293Zm6.816-7.112 1.434 2.151h2.727a.937.937 0 1 1 0 1.875h-.454l-.937 12.684A2.502 2.502 0 0 1 15.93 22H8.07a2.501 2.501 0 0 1-2.491-2.316L4.639 7h-.452a.936.936 0 1 1 0-1.875h2.728l1.433-2.15A2.19 2.19 0 0 1 10.168 2h3.664c.73 0 1.414.366 1.82.974ZM9.168 5.125h5.664l-.742-1.11a.314.314 0 0 0-.258-.14h-3.664c-.102 0-.234.052-.258.14l-.742 1.11ZM7.449 19.547a.626.626 0 0 0 .621.578h7.86a.626.626 0 0 0 .62-.578L17.48 7H6.52l.93 12.547Z",
        fill: "currentColor"
      }
    )
  })
);
var TrashXmark_default = SvgTrashXmark;

// src/Icon/icons/Trash.tsx
import { jsx as jsx1341 } from "react/jsx-runtime";
var SvgTrash = (props) => /* @__PURE__ */ jsx1341(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1341(
      "path",
      {
        d: "M19.813 5.125a.937.937 0 1 1 0 1.875h-.454l-.937 12.684A2.502 2.502 0 0 1 15.93 22H8.07a2.501 2.501 0 0 1-2.491-2.316L4.639 7h-.452a.936.936 0 1 1 0-1.875h2.728l1.433-2.15A2.19 2.19 0 0 1 10.168 2h3.664c.73 0 1.414.366 1.82.974l1.434 2.151h2.727Zm-9.645-1.25c-.102 0-.234.052-.258.14l-.742 1.11h5.664l-.742-1.11a.314.314 0 0 0-.258-.14h-3.664ZM17.481 7H6.518l.93 12.547a.626.626 0 0 0 .621.578h7.86a.626.626 0 0 0 .62-.578L17.48 7Z",
        fill: "currentColor"
      }
    )
  })
);
var Trash_default = SvgTrash;

// src/Icon/icons/TriangleExclamation.tsx
import { jsx as jsx1342 } from "react/jsx-runtime";
var SvgTriangleExclamation = (props) => /* @__PURE__ */ jsx1342(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1342(
      "path",
      {
        d: "M21.777 18.284 13.45 4.076a1.656 1.656 0 0 0-1.444-.82c-.562 0-1.124.274-1.48.82L2.207 18.284c-.605 1.09.193 2.46 1.477 2.46h16.651c1.279 0 2.08-1.367 1.443-2.46Zm-17.71.586 7.905-13.552 7.974 13.552H4.066Zm7.94-3.704a1.227 1.227 0 1 0 0 2.454 1.227 1.227 0 0 0 0-2.454ZM11.07 9.19v3.747a.937.937 0 0 0 1.874 0V9.19a.937.937 0 0 0-1.874 0Z",
        fill: "currentColor"
      }
    )
  })
);
var TriangleExclamation_default = SvgTriangleExclamation;

// src/Icon/icons/Triangle.tsx
import { jsx as jsx1343 } from "react/jsx-runtime";
var SvgTriangle = (props) => /* @__PURE__ */ jsx1343(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1343(
      "path",
      {
        d: "M12 3.25c.555 0 1.066.294 1.348.771l8.437 14.377a1.56 1.56 0 0 1-1.348 2.352H3.563a1.56 1.56 0 0 1-1.348-2.352l8.438-14.377A1.564 1.564 0 0 1 12 3.25Zm0 2.18L4.108 18.875h15.783L12 5.43Zm.27-.459Zm0 0L12 4.812l.27.16Z",
        fill: "currentColor"
      }
    )
  })
);
var Triangle_default = SvgTriangle;

// src/Icon/icons/TurnDownRight.tsx
import { jsx as jsx1344 } from "react/jsx-runtime";
var SvgTurnDownRight = (props) => /* @__PURE__ */ jsx1344(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1344(
      "path",
      {
        d: "M16.312 19.422a.942.942 0 0 1-.563-.86v-3.16H2.937A.917.917 0 0 1 2 14.465V5.438a.938.938 0 0 1 1.875 0v8.09h11.874v-3.09a.936.936 0 0 1 1.574-.687l4.375 4.061a.934.934 0 0 1 0 1.375l-4.375 4.063a.936.936 0 0 1-1.011.172Z",
        fill: "currentColor"
      }
    )
  })
);
var TurnDownRight_default = SvgTurnDownRight;

// src/Icon/icons/TurnDown.tsx
import { jsx as jsx1345 } from "react/jsx-runtime";
var SvgTurnDown = (props) => /* @__PURE__ */ jsx1345(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1345(
      "path",
      {
        d: "M18 17.325 13.937 21.7a.938.938 0 0 1-1.374 0L8.5 17.325a.938.938 0 0 1 .687-1.574h3.126V3.875H6.686a.938.938 0 0 1 0-1.875h6.563c.518 0 .938.42.938.938V15.75h3.125A.937.937 0 0 1 18 17.325Z",
        fill: "currentColor"
      }
    )
  })
);
var TurnDown_default = SvgTurnDown;

// src/Icon/icons/TurnUp.tsx
import { jsx as jsx1346 } from "react/jsx-runtime";
var SvgTurnUp = (props) => /* @__PURE__ */ jsx1346(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1346(
      "path",
      {
        d: "M18.183 7.697a.939.939 0 0 1-.86.564l-3.132-.036v12.836a.94.94 0 0 1-.939.939H6.678a.94.94 0 0 1 0-1.878h5.635V8.225h-3.13a.939.939 0 0 1-.862-.564.88.88 0 0 1 .173-.978l4.07-4.383a.94.94 0 0 1 1.377 0l4.07 4.383c.254.274.32.67.172 1.014Z",
        fill: "currentColor"
      }
    )
  })
);
var TurnUp_default = SvgTurnUp;

// src/Icon/icons/Tv.tsx
import { jsx as jsx1347 } from "react/jsx-runtime";
var SvgTv = (props) => /* @__PURE__ */ jsx1347(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1347(
      "path",
      {
        d: "M18.25 18.5H5.75a.748.748 0 0 0-.75.75c0 .416.334.75.75.75h12.5a.75.75 0 0 0 0-1.5ZM20 4H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm.5 11a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5h16a.5.5 0 0 1 .5.5v9Z",
        fill: "currentColor"
      }
    )
  })
);
var Tv_default = SvgTv;

// src/Icon/icons/Underline.tsx
import { jsx as jsx1348 } from "react/jsx-runtime";
var SvgUnderline = (props) => /* @__PURE__ */ jsx1348(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1348(
      "path",
      {
        d: "M4.813 3.875h.937v7.5a6.257 6.257 0 0 0 6.25 6.25 6.257 6.257 0 0 0 6.25-6.25v-7.5h.938a.938.938 0 0 0 0-1.875h-3.75a.938.938 0 0 0 0 1.875h.937v7.5A4.38 4.38 0 0 1 12 15.75a4.379 4.379 0 0 1-4.375-4.375v-7.5h.938a.936.936 0 1 0 0-1.875h-3.75a.938.938 0 0 0 0 1.875Zm15 16.25H4.188a.939.939 0 0 0-.938.938c0 .515.42.937.938.937h15.625a.938.938 0 0 0 0-1.875Z",
        fill: "currentColor"
      }
    )
  })
);
var Underline_default = SvgUnderline;

// src/Icon/icons/Union.tsx
import { jsx as jsx1349 } from "react/jsx-runtime";
var SvgUnion = (props) => /* @__PURE__ */ jsx1349(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1349(
      "path",
      {
        d: "M3.411 13.452V3.074a1.074 1.074 0 0 1 2.148 0v10.378A6.448 6.448 0 0 0 12 19.893a6.448 6.448 0 0 0 6.442-6.441V3.074c0-.593.483-1.074 1.073-1.074s1.074.48 1.074 1.074v10.378C20.589 18.189 16.736 22 12 22c-4.736 0-8.589-3.811-8.589-8.548Z",
        fill: "currentColor"
      }
    )
  })
);
var Union_default = SvgUnion;

// src/Icon/icons/UniversalAccess.tsx
import { jsx as jsx1350 } from "react/jsx-runtime";
var SvgUniversalAccess = (props) => /* @__PURE__ */ jsx1350(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1350(
      "path",
      {
        d: "M12 8.875a1.563 1.563 0 1 0 0-3.125 1.563 1.563 0 0 0 0 3.125Zm4.117.035-2.314.662a6.56 6.56 0 0 1-3.606 0L7.883 8.91a.94.94 0 0 0-1.16.645.936.936 0 0 0 .643 1.158l2.315.663c.147.042.296.062.444.093v1.808l-1.197 3.412a.938.938 0 0 0 1.769.621l1.01-2.76a.313.313 0 0 1 .587 0l1.01 2.76a.937.937 0 1 0 1.768-.62l-1.197-3.413V11.47c.148-.031.297-.051.441-.094l2.315-.662a.936.936 0 1 0-.514-1.803ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 18.125c-4.48 0-8.125-3.645-8.125-8.125S7.52 3.875 12 3.875 20.125 7.52 20.125 12 16.48 20.125 12 20.125Z",
        fill: "currentColor"
      }
    )
  })
);
var UniversalAccess_default = SvgUniversalAccess;

// src/Icon/icons/UnlockKeyhole.tsx
import { jsx as jsx1351 } from "react/jsx-runtime";
var SvgUnlockKeyhole = (props) => /* @__PURE__ */ jsx1351(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1351(
      "path",
      {
        d: "M10.75 16.688a.935.935 0 0 1-.938-.938c0-.52.418-.938.938-.938h2.5c.52 0 .938.418.938.938s-.418.938-.938.938h-2.5ZM12 3.874A3.125 3.125 0 0 0 8.875 7v2.5h9.375c1.379 0 2.5 1.121 2.5 2.5v7.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V12c0-1.379 1.12-2.5 2.5-2.5H7V7a5 5 0 0 1 5-5c2.191 0 4.11 1.454 4.758 3.462.16.491-.145 1.022-.602 1.179-.496.16-1.023-.145-1.183-.602a3.131 3.131 0 0 0-3.008-2.164H12Zm-6.25 7.5a.626.626 0 0 0-.625.625v7.5c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625V12a.627.627 0 0 0-.625-.625H5.75Z",
        fill: "currentColor"
      }
    )
  })
);
var UnlockKeyhole_default = SvgUnlockKeyhole;

// src/Icon/icons/Unlock.tsx
import { jsx as jsx1352 } from "react/jsx-runtime";
var SvgUnlock = (props) => /* @__PURE__ */ jsx1352(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1352(
      "path",
      {
        d: "M8.875 9.5h9.375c1.379 0 2.5 1.121 2.5 2.5v7.5c0 1.379-1.121 2.5-2.5 2.5H5.75c-1.38 0-2.5-1.121-2.5-2.5V12c0-1.379 1.12-2.5 2.5-2.5H7V7a5 5 0 0 1 5-5c2.191 0 4.11 1.454 4.758 3.462.16.491-.145 1.022-.602 1.179-.496.16-1.023-.145-1.183-.602a3.131 3.131 0 0 0-3.008-2.164c-1.692 0-3.125 1.4-3.125 3.125l.035 2.5Zm-3.75 10c0 .344.28.625.625.625h12.5a.627.627 0 0 0 .625-.625V12a.627.627 0 0 0-.625-.625H5.75a.626.626 0 0 0-.625.625v7.5Z",
        fill: "currentColor"
      }
    )
  })
);
var Unlock_default = SvgUnlock;

// src/Icon/icons/UpDownLeftRight.tsx
import { jsx as jsx1353 } from "react/jsx-runtime";
var SvgUpDownLeftRight = (props) => /* @__PURE__ */ jsx1353(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1353(
      "path",
      {
        d: "M22 11.993a.94.94 0 0 1-.31.697l-3.125 2.812a.933.933 0 0 1-1.009.16.937.937 0 0 1-.556-.857V12.93h-4.063v4.063h1.84a.937.937 0 0 1 .697 1.565l-2.812 3.125c-.143.196-.396.31-.697.31a.886.886 0 0 1-.697-.31l-2.777-3.125a.939.939 0 0 1 .697-1.565h1.874V12.93H7v1.875a.937.937 0 0 1-1.565.697L2.31 12.69a.939.939 0 0 1 0-1.394l3.125-2.813a.942.942 0 0 1 1.01-.158A.935.935 0 0 1 7 9.18v1.875h4.063V6.993h-1.91a.937.937 0 0 1-.857-.556c-.15-.338-.054-.734.196-1.01l2.777-3.124c.357-.394 1.038-.394 1.395 0l2.812 3.125a.939.939 0 0 1-.697 1.565h-1.841v4.062H17V9.18a.937.937 0 0 1 1.565-.697l3.125 2.813a.94.94 0 0 1 .31.697Z",
        fill: "currentColor"
      }
    )
  })
);
var UpDownLeftRight_default = SvgUpDownLeftRight;

// src/Icon/icons/UpDown.tsx
import { jsx as jsx1354 } from "react/jsx-runtime";
var SvgUpDown = (props) => /* @__PURE__ */ jsx1354(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1354(
      "path",
      {
        d: "M16.93 16.318a.943.943 0 0 0-.861-.563h-3.13v-7.51h3.13c.373 0 .711-.221.825-.564a.94.94 0 0 0-.172-1.013l-4.068-4.381C12.509 2.096 12.255 2 12 2a.937.937 0 0 0-.688.287l-4.068 4.38a.94.94 0 0 0 .688 1.578h3.13v7.51h-3.13a.938.938 0 0 0-.688 1.577l4.032 4.381a.937.937 0 0 0 .689.287c.255 0 .51-.096.688-.287l4.068-4.38a.889.889 0 0 0 .207-1.015Z",
        fill: "currentColor"
      }
    )
  })
);
var UpDown_default = SvgUpDown;

// src/Icon/icons/UpFromBracket.tsx
import { jsx as jsx1355 } from "react/jsx-runtime";
var SvgUpFromBracket = (props) => /* @__PURE__ */ jsx1355(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1355(
      "path",
      {
        d: "M19.813 14.5c.519 0 .937.418.937.938v2.812c0 2.07-1.68 3.75-3.75 3.75H7a3.75 3.75 0 0 1-3.75-3.75v-2.813a.936.936 0 1 1 1.875 0v2.813A1.88 1.88 0 0 0 7 20.125h10a1.88 1.88 0 0 0 1.875-1.875v-2.813c0-.519.418-.937.938-.937ZM12.02 2c.27 0 .523.115.699.315l5.199 5.955c.219.242.297.554.297.867 0 .183-.004.37-.082.543-.207.46-.664.758-1.16.758h-2.196v4.687c0 .863-.668 1.563-1.562 1.563h-2.5c-.828 0-1.563-.7-1.563-1.563v-4.688H7.026c-.498 0-.953-.296-1.16-.757a1.316 1.316 0 0 1 .213-1.41l5.241-5.955c.176-.2.43-.315.7-.315Zm0 2.35L8.293 8.563h2.734v6.25h1.875v-6.25h2.77L12.02 4.35Z",
        fill: "currentColor"
      }
    )
  })
);
var UpFromBracket_default = SvgUpFromBracket;

// src/Icon/icons/UpFromDottedLine.tsx
import { jsx as jsx1356 } from "react/jsx-runtime";
var SvgUpFromDottedLine = (props) => /* @__PURE__ */ jsx1356(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1356(
      "path",
      {
        d: "m13.603 2.72 5.714 6.427c.558.63.696 1.532.353 2.304a2.148 2.148 0 0 1-1.956 1.263h-2.143v2.5c0 1.38-1.12 2.5-2.5 2.5h-2.183c-1.339 0-2.5-1.12-2.5-2.5v-2.5H6.246c-.804 0-1.57-.495-1.915-1.263a2.146 2.146 0 0 1 .353-2.304l5.713-6.428c.407-.457.991-.719 1.563-.719.652 0 1.236.262 1.643.72ZM6.246 10.57h4.285v4.643c0 .197.201.357.357.357h2.183c.197 0 .358-.16.358-.357v-4.643h4.285L11.96 4.143 6.246 10.57ZM2 20.571a1.428 1.428 0 1 1 2.856-.001A1.428 1.428 0 0 1 2 20.571Zm7.143 0c0 .79-.639 1.429-1.429 1.429s-1.428-.638-1.428-1.429c0-.79.638-1.428 1.428-1.428.79 0 1.429.638 1.429 1.428Zm1.428 0c0-.79.639-1.428 1.429-1.428s1.429.638 1.429 1.428c0 .79-.639 1.429-1.429 1.429s-1.429-.638-1.429-1.429Zm7.143 0a1.427 1.427 0 1 1-2.857 0c0-.79.638-1.428 1.429-1.428.79 0 1.428.638 1.428 1.428Zm1.429 0c0-.79.638-1.428 1.428-1.428a1.427 1.427 0 1 1 0 2.857c-.79 0-1.428-.638-1.428-1.429Z",
        fill: "currentColor"
      }
    )
  })
);
var UpFromDottedLine_default = SvgUpFromDottedLine;

// src/Icon/icons/UpFromLine.tsx
import { jsx as jsx1357 } from "react/jsx-runtime";
var SvgUpFromLine = (props) => /* @__PURE__ */ jsx1357(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1357(
      "path",
      {
        d: "M19.5 19.857h-15c-.591 0-1.071.482-1.071 1.072 0 .589.48 1.071 1.071 1.071h15a1.072 1.072 0 0 0 0-2.143ZM6.513 12.714h1.916v2.857c0 1.184.959 2.141 2.142 2.141h2.858a2.14 2.14 0 0 0 2.142-2.14v-2.858h1.933c1.858 0 2.836-2.204 1.588-3.581l-6.08-6.715a1.43 1.43 0 0 0-2.02 0l-6.07 6.716c-1.244 1.38-.266 3.58 1.591 3.58ZM12 4.44l5.42 6.132h-3.991v5H10.57v-5h-3.99L12 4.44Z",
        fill: "currentColor"
      }
    )
  })
);
var UpFromLine_default = SvgUpFromLine;

// src/Icon/icons/UpLeft.tsx
import { jsx as jsx1358 } from "react/jsx-runtime";
var SvgUpLeft = (props) => /* @__PURE__ */ jsx1358(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1358(
      "path",
      {
        d: "m14.704 4.626-3.8 3.8 8.496 8.497-2.454 2.454-8.493-8.5-3.8 3.799V4.626h10.051Zm2.045-2.603H3.735c-.958 0-1.686.776-1.686 1.686L2 16.772c0 .701.423 1.335 1.07 1.602.216.091.442.135.666.135.45 0 .893-.178 1.226-.51l3.439-3.44 6.653 6.653c.561.51 1.228.765 1.89.765.666 0 1.332-.254 1.84-.762l2.454-2.454a2.603 2.603 0 0 0 0-3.68l-6.653-6.654 3.44-3.44a1.735 1.735 0 0 0 .376-1.89c-.27-.652-.904-1.074-1.652-1.074Z",
        fill: "currentColor"
      }
    )
  })
);
var UpLeft_default = SvgUpLeft;

// src/Icon/icons/UpLong.tsx
import { jsx as jsx1359 } from "react/jsx-runtime";
var SvgUpLong = (props) => /* @__PURE__ */ jsx1359(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1359(
      "path",
      {
        d: "M16.897 7.69a.926.926 0 0 1-.825.564h-3.125v12.808a.938.938 0 0 1-1.875 0V8.253h-3.16a.937.937 0 0 1-.86-.563 1.018 1.018 0 0 1 .208-1.011l4.062-4.38a.938.938 0 0 1 1.375 0l4.063 4.38c.254.27.32.668.137 1.012Z",
        fill: "currentColor"
      }
    )
  })
);
var UpLong_default = SvgUpLong;

// src/Icon/icons/UpRightAndDownLeftFromCenter.tsx
import { jsx as jsx1360 } from "react/jsx-runtime";
var SvgUpRightAndDownLeftFromCenter = (props) => /* @__PURE__ */ jsx1360(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1360(
      "path",
      {
        d: "m9.15 13.523-3.18 3.179-1.836-1.837A1.25 1.25 0 0 0 2 15.749v5.277c.002.555.421.973.939.973h5.312a1.249 1.249 0 0 0 .884-2.133l-1.837-1.837 3.178-3.179a.937.937 0 1 0-1.327-1.327ZM21.026 2.001h-5.312a1.25 1.25 0 0 0-.883 2.133l1.837 1.837L13.49 9.15a.937.937 0 1 0 1.326 1.325l3.179-3.178 1.837 1.837a1.25 1.25 0 0 0 1.362.27c.501-.193.806-.65.806-1.189V2.903c0-.482-.418-.902-.973-.902Z",
        fill: "currentColor"
      }
    )
  })
);
var UpRightAndDownLeftFromCenter_default = SvgUpRightAndDownLeftFromCenter;

// src/Icon/icons/UpRightFromSquare.tsx
import { jsx as jsx1361 } from "react/jsx-runtime";
var SvgUpRightFromSquare = (props) => /* @__PURE__ */ jsx1361(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1361(
      "path",
      {
        d: "M13.873 3.603c0 .426.168.832.468 1.133l1.8 1.796-6.057 6.054a.937.937 0 0 0 1.324 1.324l6.054-6.054 1.804 1.8A1.6 1.6 0 0 0 22 8.524V3.565c0-.863-.7-1.562-1.562-1.562h-4.964a1.6 1.6 0 0 0-1.601 1.601Zm2.261.274h3.988v3.987l-3.988-3.987ZM4.812 3.252A2.81 2.81 0 0 0 2 6.064v13.122a2.81 2.81 0 0 0 2.812 2.812h13.122a2.81 2.81 0 0 0 2.812-2.812v-4.999a.935.935 0 0 0-.937-.937.935.935 0 0 0-.937.937v5c0 .518-.418.936-.938.936H4.812a.935.935 0 0 1-.937-.937V6.064c0-.52.418-.938.937-.938H9.81c.52 0 .937-.418.937-.937a.935.935 0 0 0-.937-.937H4.812Z",
        fill: "currentColor"
      }
    )
  })
);
var UpRightFromSquare_default = SvgUpRightFromSquare;

// src/Icon/icons/UpRight.tsx
import { jsx as jsx1362 } from "react/jsx-runtime";
var SvgUpRight = (props) => /* @__PURE__ */ jsx1362(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1362(
      "path",
      {
        d: "M19.39 4.609v10.076l-3.807-3.807-8.516 8.513-2.46-2.459 8.517-8.516-3.81-3.807H19.39ZM20.26 2H7.216a1.738 1.738 0 0 0-1.23 2.967l3.448 3.451-6.669 6.674a2.609 2.609 0 0 0 0 3.69l2.46 2.459a2.611 2.611 0 0 0 3.686-.005l6.669-6.669 3.447 3.448c.333.333.777.511 1.229.511a1.746 1.746 0 0 0 1.743-1.744V3.74c0-.961-.777-1.739-1.74-1.739Z",
        fill: "currentColor"
      }
    )
  })
);
var UpRight_default = SvgUpRight;

// src/Icon/icons/UpToDottedLine.tsx
import { jsx as jsx1363 } from "react/jsx-runtime";
var SvgUpToDottedLine = (props) => /* @__PURE__ */ jsx1363(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1363(
      "path",
      {
        d: "m13.603 7.004 5.714 6.429c.558.63.696 1.531.353 2.304A2.148 2.148 0 0 1 17.714 17h-2.143v2.5c0 1.38-1.12 2.5-2.5 2.5h-2.183c-1.339 0-2.5-1.12-2.5-2.5V17H6.246c-.804 0-1.57-.495-1.915-1.263a2.146 2.146 0 0 1 .353-2.304l5.713-6.429a2.133 2.133 0 0 1 1.563-.718c.652 0 1.236.263 1.643.718Zm-7.357 7.853h4.285V19.5c0 .196.201.357.357.357h2.183c.197 0 .358-.16.358-.357v-4.643h4.285L11.96 8.43l-5.714 6.428ZM22 3.43a1.428 1.428 0 1 1-2.856 0 1.428 1.428 0 0 1 2.856 0Zm-7.143 0a1.428 1.428 0 1 1 2.856-.002 1.428 1.428 0 0 1-2.856.002Zm-1.428 0a1.428 1.428 0 1 1-2.856 0 1.428 1.428 0 0 1 2.856 0Zm-7.143 0a1.428 1.428 0 1 1 2.856-.002 1.428 1.428 0 0 1-2.856.002Zm-1.429 0a1.429 1.429 0 1 1-2.857 0 1.429 1.429 0 0 1 2.857 0Z",
        fill: "currentColor"
      }
    )
  })
);
var UpToDottedLine_default = SvgUpToDottedLine;

// src/Icon/icons/UpToLine.tsx
import { jsx as jsx1364 } from "react/jsx-runtime";
var SvgUpToLine = (props) => /* @__PURE__ */ jsx1364(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1364(
      "path",
      {
        d: "M19.5 2h-15a1.072 1.072 0 0 0 0 2.143h15A1.07 1.07 0 1 0 19.5 2Zm-6.504 4.705a1.426 1.426 0 0 0-2.023 0L4.906 13.42C3.66 14.8 4.639 17 6.496 17h1.916v2.857c0 1.184.959 2.143 2.143 2.143h2.857c1.183 0 2.143-.96 2.143-2.143V17h1.932c1.859 0 2.836-2.204 1.589-3.582l-6.08-6.713Zm.415 8.152v5h-2.857v-5H6.565l5.42-6.134 5.377 6.134H13.41Z",
        fill: "currentColor"
      }
    )
  })
);
var UpToLine_default = SvgUpToLine;

// src/Icon/icons/Up.tsx
import { jsx as jsx1365 } from "react/jsx-runtime";
var SvgUp = (props) => /* @__PURE__ */ jsx1365(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1365(
      "path",
      {
        d: "M3.537 11.835c.222.531.742.88 1.32.88H8.43v7.142c0 1.184.959 2.143 2.142 2.143h2.858c1.183 0 2.142-.96 2.142-2.143v-7.143h3.572a1.429 1.429 0 0 0 1.01-2.439L13.01 2.418A1.422 1.422 0 0 0 12 2c-.366 0-.732.14-1.009.419l-7.143 7.857a1.429 1.429 0 0 0-.31 1.559ZM12 4.439l5.42 6.132h-3.991v9.286H10.57v-9.286h-3.99L12 4.44Z",
        fill: "currentColor"
      }
    )
  })
);
var Up_default = SvgUp;

// src/Icon/icons/Upload.tsx
import { jsx as jsx1366 } from "react/jsx-runtime";
var SvgUpload = (props) => /* @__PURE__ */ jsx1366(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1366(
      "path",
      {
        d: "M19.5 13.875h-5v1.875h5c.345 0 .625.28.625.625V19.5c0 .345-.28.625-.625.625h-15a.626.626 0 0 1-.625-.625v-3.125c0-.344.28-.625.625-.625h5v-1.875h-5a2.5 2.5 0 0 0-2.5 2.5V19.5A2.5 2.5 0 0 0 4.5 22h15a2.5 2.5 0 0 0 2.5-2.5v-3.125c0-1.379-1.121-2.5-2.5-2.5ZM7.316 8.879l3.747-3.678V15.75a.938.938 0 0 0 1.874 0V5.2l3.713 3.713c.182.185.42.275.662.275a.937.937 0 0 0 .663-1.6l-5.312-5.313a.937.937 0 0 0-1.326 0L6.025 7.587a.937.937 0 0 0 0 1.326c.366.366.96.364 1.291-.034Zm11.559 9.059a.938.938 0 1 0-1.875 0 .938.938 0 0 0 1.875 0Z",
        fill: "currentColor"
      }
    )
  })
);
var Upload_default = SvgUpload;

// src/Icon/icons/UsbDrive.tsx
import { jsx as jsx1367 } from "react/jsx-runtime";
var SvgUsbDrive = (props) => /* @__PURE__ */ jsx1367(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1367(
      "path",
      {
        d: "M15 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h11a1 1 0 0 0 1-1V8c0-.553-.447-1-1-1Zm-.5 8.5H4a.5.5 0 0 1-.5-.5V9a.5.5 0 0 1 .5-.5h10.5v7ZM21 8h-4v8h4a1 1 0 0 0 1-1V9c0-.553-.447-1-1-1Zm-.75 5.75c0 .277-.223.5-.5.5h-.5a.499.499 0 0 1-.5-.5v-.5c0-.277.223-.5.5-.5h.5c.277 0 .5.223.5.5v.5Zm0-3c0 .277-.223.5-.5.5h-.5a.499.499 0 0 1-.5-.5v-.5c0-.277.223-.5.5-.5h.5c.277 0 .5.223.5.5v.5Z",
        fill: "currentColor"
      }
    )
  })
);
var UsbDrive_default = SvgUsbDrive;

// src/Icon/icons/UserArrowRight.tsx
import { jsx as jsx1368 } from "react/jsx-runtime";
var SvgUserArrowRight = (props) => /* @__PURE__ */ jsx1368(
  "svg",
  __spreadProps(__spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1368(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.268 19.213a8.171 8.171 0 0 0 3.299.696c4.605 0 8.433-3.838 8.433-8.455C22 6.83 18.164 3 13.559 3 9.25 3 5.654 6.324 5.19 10.526a5.46 5.46 0 0 1 1.43-.058A6.963 6.963 0 0 1 13.56 4.41a7.022 7.022 0 0 1 7.036 7.045 6.942 6.942 0 0 1-1.811 4.717c-.81-.97-2.729-1.898-5.225-1.898-.794 0-1.522.099-2.175.257a5.299 5.299 0 0 1-1.116 4.683Zm.455-9.474c.008 1.773 1.248 3.108 2.835 3.124 1.588.017 2.836-1.342 2.836-3.124 0-1.675-1.256-3.059-2.835-3.059-1.588 0-2.853 1.384-2.836 3.059ZM2 15.789C2 18.11 3.902 20 6.2 20c2.274 0 4.2-1.906 4.2-4.21 0-2.313-1.893-4.211-4.2-4.211-2.298 0-4.2 1.906-4.2 4.21Zm5.91.48a.437.437 0 0 0 0-.534l-1.338-1.62c-.064-.078-.137-.115-.21-.115-.174 0-.293.147-.293.342 0 .11.039.194.094.259l.46.56.455.509-.448-.03H4.308c-.185 0-.308.145-.308.361 0 .215.123.362.308.362H6.63l.45-.03-.456.508-.46.558a.392.392 0 0 0-.095.26c0 .194.119.341.294.341.072 0 .145-.037.207-.112l1.34-1.62Z",
        fill: "currentColor"
      }
    )
  })
);
var UserArrowRight_default = SvgUserArrowRight;

// src/Icon/icons/UserCheck.tsx
import { jsx as jsx1369 } from "react/jsx-runtime";
var SvgUserCheck = (props) => /* @__PURE__ */ jsx1369(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1369(
      "path",
      {
        d: "M10.585 13.5h-3.17A5.416 5.416 0 0 0 2 18.916c0 .6.485 1.084 1.083 1.084h11.833c.6 0 1.084-.484 1.084-1.084a5.416 5.416 0 0 0-5.415-5.416Zm-7.063 5A3.92 3.92 0 0 1 7.416 15h3.169c2.019 0 3.66 1.535 3.893 3.5H3.523ZM9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-6.5c1.379 0 2.5 1.121 2.5 2.5 0 1.378-1.121 2.5-2.5 2.5A2.503 2.503 0 0 1 6.5 8C6.5 6.62 7.622 5.5 9 5.5Zm12.76 2.7a.75.75 0 0 0-1.06.04l-2.72 2.93-1.2-1.2a.75.75 0 1 0-1.06 1.06l1.75 1.75c.14.142.33.22.53.22h.014a.75.75 0 0 0 .536-.24l3.25-3.5a.751.751 0 0 0-.04-1.06Z",
        fill: "currentColor"
      }
    )
  })
);
var UserCheck_default = SvgUserCheck;

// src/Icon/icons/UserClock.tsx
import { jsx as jsx1370 } from "react/jsx-runtime";
var SvgUserClock = (props) => /* @__PURE__ */ jsx1370(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1370(
      "path",
      {
        d: "M17.5 11a4.496 4.496 0 0 0-4.5 4.5c0 2.488 2.012 4.5 4.5 4.5s4.5-2.012 4.5-4.5-2.012-4.5-4.5-4.5Zm1.5 5h-1.695a.306.306 0 0 1-.305-.303V13.5a.5.5 0 0 1 1 0V15h1c.276 0 .5.224.5.472 0 .248-.225.528-.5.528ZM9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-6.5c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5A2.503 2.503 0 0 1 6.5 8c0-1.378 1.122-2.5 2.5-2.5ZM14.344 20H3a1 1 0 0 1-1-1 5.5 5.5 0 0 1 5.5-5.5h3c.62 0 1.215.107 1.772.297a5.483 5.483 0 0 0-.262 1.505A3.938 3.938 0 0 0 10.5 15h-3a4.006 4.006 0 0 0-3.969 3.5h9.363a5.519 5.519 0 0 0 1.45 1.5Z",
        fill: "currentColor"
      }
    )
  })
);
var UserClock_default = SvgUserClock;

// src/Icon/icons/UserGear.tsx
import { jsx as jsx1371 } from "react/jsx-runtime";
var SvgUserGear = (props) => /* @__PURE__ */ jsx1371(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1371(
      "path",
      {
        d: "M21.078 15.666c.082-.438.082-.89 0-1.329l.805-.468a.225.225 0 0 0 .106-.266 4.748 4.748 0 0 0-1.04-1.793.225.225 0 0 0-.28-.043l-.805.465a3.651 3.651 0 0 0-1.153-.664v-.934c0-.105-.078-.199-.18-.218a4.686 4.686 0 0 0-2.07 0 .222.222 0 0 0-.176.218v.934a3.656 3.656 0 0 0-1.152.664l-.808-.466a.227.227 0 0 0-.281.043 4.69 4.69 0 0 0-1.035 1.793.228.228 0 0 0 .101.265l.805.47c-.078.437-.078.89 0 1.327l-.805.469a.224.224 0 0 0-.101.266 4.714 4.714 0 0 0 1.035 1.793.226.226 0 0 0 .281.043l.809-.465c.34.289.73.515 1.152.664v.934c0 .105.075.199.176.218.7.157 1.407.153 2.07 0a.226.226 0 0 0 .18-.218v-.934a3.656 3.656 0 0 0 1.153-.664l.805.465c.09.055.21.035.28-.043a4.745 4.745 0 0 0 1.04-1.793.225.225 0 0 0-.106-.266l-.806-.467Zm-3.578.85c-.836 0-1.515-.68-1.515-1.516s.68-1.516 1.515-1.516c.836 0 1.516.682 1.516 1.516s-.678 1.516-1.516 1.516Zm-2.215 2.853c0 .192.058.368.138.532-.129.058-.27.1-.423.1H3a1 1 0 0 1-1-1A5.5 5.5 0 0 1 7.5 13.5h2.972c.521 0 1.024.077 1.502.213.014.422.236.81.615 1.025l.24.14a4.57 4.57 0 0 0 0 .245l-.251.146a1.117 1.117 0 0 0-.254.203A3.747 3.747 0 0 0 10.5 15h-3a4.006 4.006 0 0 0-3.969 3.5h9.476c.096.125.193.25.3.367.245.258.57.398.905.398.216 0 .43-.057.617-.167l.244-.14c.07.043.141.084.213.123v.288h-.001ZM9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-6.5c1.378 0 2.5 1.121 2.5 2.5 0 1.378-1.121 2.5-2.5 2.5A2.503 2.503 0 0 1 6.5 8C6.5 6.62 7.622 5.5 9 5.5Z",
        fill: "currentColor"
      }
    )
  })
);
var UserGear_default = SvgUserGear;

// src/Icon/icons/UserGroup.tsx
import { jsx as jsx1372 } from "react/jsx-runtime";
var SvgUserGroup = (props) => /* @__PURE__ */ jsx1372(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1372(
      "path",
      {
        d: "M9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-6.5c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5A2.503 2.503 0 0 1 6.5 8c0-1.378 1.122-2.5 2.5-2.5Zm1.584 8H7.416A5.415 5.415 0 0 0 2 18.916c0 .6.485 1.084 1.083 1.084h11.833c.6 0 1.084-.484 1.084-1.084a5.416 5.416 0 0 0-5.416-5.416Zm-7.062 5A3.92 3.92 0 0 1 7.416 15h3.168c2.02 0 3.66 1.535 3.894 3.5H3.522Zm13.45-4.5h-2.308A6.33 6.33 0 0 1 17 18.916c0 .4-.119.768-.313 1.084H21c.553 0 1-.45 1-1.028C22 16.237 19.762 14 16.972 14ZM15.5 12c1.934 0 3.5-1.566 3.5-3.5S17.434 5 15.5 5c-.785 0-1.501.267-2.085.703C13.775 6.395 14 7.17 14 8c0 1.11-.373 2.13-.987 2.96A3.489 3.489 0 0 0 15.5 12Z",
        fill: "currentColor"
      }
    )
  })
);
var UserGroup_default = SvgUserGroup;

// src/Icon/icons/UserLargeSlash.tsx
import { jsx as jsx1373 } from "react/jsx-runtime";
var SvgUserLargeSlash = (props) => /* @__PURE__ */ jsx1373(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1373(
      "path",
      {
        d: "m21.712 18.66-7.796-6.11c1.52-.72 2.582-2.255 2.582-4.05a4.47 4.47 0 0 0-4.472-4.472 4.504 4.504 0 0 0-4.409 3.59L3.213 4.16a.749.749 0 0 0-1.053.128.75.75 0 0 0 .127 1.053l18.5 14.5a.75.75 0 1 0 .925-1.18ZM9.022 8.711C9.016 8.64 9 8.572 9 8.5c0-1.655 1.346-3 3-3s3 1.345 3 3a2.999 2.999 0 0 1-2.488 2.948l-3.49-2.736ZM5.534 18.5A3.506 3.506 0 0 1 9 15.5h3.819l-1.915-1.472H9.001c-2.761 0-5 2.238-5 4.972-.03.553.447 1 .97 1h13.56l-1.887-1.5H5.534Z",
        fill: "currentColor"
      }
    )
  })
);
var UserLargeSlash_default = SvgUserLargeSlash;

// src/Icon/icons/UserLarge.tsx
import { jsx as jsx1374 } from "react/jsx-runtime";
var SvgUserLarge = (props) => /* @__PURE__ */ jsx1374(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1374(
      "path",
      {
        d: "M12.018 13.25a5.625 5.625 0 1 0 0-11.25 5.625 5.625 0 0 0 0 11.25Zm0-9.375a3.754 3.754 0 0 1 3.75 3.75 3.754 3.754 0 0 1-3.75 3.75 3.754 3.754 0 0 1-3.75-3.75 3.755 3.755 0 0 1 3.75-3.75ZM15.732 14.5H8.267a6.25 6.25 0 0 0-6.25 6.25c0 .69.56 1.25 1.215 1.25h17.535c.69 0 1.215-.56 1.215-1.25.035-3.453-2.761-6.25-6.25-6.25ZM3.937 20.125a4.382 4.382 0 0 1 4.332-3.75h7.465c2.2 0 4.027 1.632 4.332 3.75H3.937Z",
        fill: "currentColor"
      }
    )
  })
);
var UserLarge_default = SvgUserLarge;

// src/Icon/icons/UserLock.tsx
import { jsx as jsx1375 } from "react/jsx-runtime";
var SvgUserLock = (props) => /* @__PURE__ */ jsx1375(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1375(
      "path",
      {
        d: "M20.5 13H20v-2.353c0-1.308-.938-2.501-2.24-2.634A2.574 2.574 0 0 0 17.5 8c-1.378-.028-2.5 1.122-2.5 2.5V13h-.5c-.825 0-1.5.675-1.5 1.5v4c0 .825.675 1.5 1.5 1.5h6c.825 0 1.5-.675 1.5-1.5v-4c0-.825-.675-1.5-1.5-1.5Zm-3 4.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Zm1-4.5h-2v-2.5c0-.55.45-1 1-1s1 .45 1 1V13ZM9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-6.5c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5A2.503 2.503 0 0 1 6.5 8c0-1.378 1.122-2.5 2.5-2.5Zm3 13c0 .565.195 1.08.513 1.5H3a1 1 0 0 1-1-1 5.5 5.5 0 0 1 5.5-5.5h3c.565 0 1.11.086 1.624.244-.077.24-.124.49-.124.756v.797A4.1 4.1 0 0 0 10.5 15h-3a4.006 4.006 0 0 0-3.969 3.5H12Z",
        fill: "currentColor"
      }
    )
  })
);
var UserLock_default = SvgUserLock;

// src/Icon/icons/UserMagnifyingGlass.tsx
import { jsx as jsx1376 } from "react/jsx-runtime";
var SvgUserMagnifyingGlass = (props) => /* @__PURE__ */ jsx1376(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1376(
      "path",
      {
        d: "M9.001 5.497a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 6.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM3.541 18.5a4.074 4.074 0 0 1 4.032-3.5h2.856a4.1 4.1 0 0 1 .685.055 5.116 5.116 0 0 1-.09-1.525 5.314 5.314 0 0 0-.595-.031H7.573A5.572 5.572 0 0 0 2 19.07c0 .513.416.929.928.929h12.146a.928.928 0 0 0 .928-.928v-.072a5.002 5.002 0 0 1-2.182-.5H3.54ZM16 11.5a2.502 2.502 0 0 1 .958 4.81 2.502 2.502 0 0 1-2.725-4.078 2.5 2.5 0 0 1 1.768-.732Zm0 6.5a3.99 3.99 0 0 0 2.248-.69l2.472 2.472a.75.75 0 0 0 1.06-1.06l-2.472-2.472a4 4 0 1 0-3.31 1.753l.003-.002Z",
        fill: "currentColor"
      }
    )
  })
);
var UserMagnifyingGlass_default = SvgUserMagnifyingGlass;

// src/Icon/icons/UserMinus.tsx
import { jsx as jsx1377 } from "react/jsx-runtime";
var SvgUserMinus = (props) => /* @__PURE__ */ jsx1377(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1377(
      "path",
      {
        d: "M10.584 13.5H7.416A5.416 5.416 0 0 0 2 18.916c0 .6.485 1.084 1.083 1.084h11.834c.599 0 1.083-.484 1.083-1.084a5.416 5.416 0 0 0-5.416-5.416Zm-7.062 5A3.92 3.92 0 0 1 7.416 15h3.168c2.02 0 3.66 1.535 3.894 3.5H3.522ZM9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-6.5c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5A2.503 2.503 0 0 1 6.5 8c0-1.378 1.122-2.5 2.5-2.5Zm12.25 4.75h-4.5a.751.751 0 0 0 0 1.5h4.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75Z",
        fill: "currentColor"
      }
    )
  })
);
var UserMinus_default = SvgUserMinus;

// src/Icon/icons/UserPen.tsx
import { jsx as jsx1378 } from "react/jsx-runtime";
var SvgUserPen = (props) => /* @__PURE__ */ jsx1378(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1378(
      "path",
      {
        d: "m17.522 13.228 2.25 2.25-3.915 3.916a.563.563 0 0 1-.288.154l-2.232.446a.281.281 0 0 1-.33-.33l.446-2.232a.562.562 0 0 1 .154-.288l3.915-3.916Zm4.15-1.237-.66-.66a1.125 1.125 0 0 0-1.59 0l-1.192 1.192 2.25 2.25 1.192-1.191a1.128 1.128 0 0 0 0-1.591ZM13.253 20a.293.293 0 0 0 .056-.006c-.037.008-.07.001-.105-.005.043.002.058.011.05.011ZM5 8c0-2.21 1.79-4 3.972-4 2.18 0 4 1.79 4 4a4 4 0 0 1-4 4C6.762 12 5 10.21 5 8Zm1.5 0c0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5S10.378 5.5 9 5.5A2.503 2.503 0 0 0 6.5 8Zm5.69 10.5H3.532A4.004 4.004 0 0 1 7.5 15h3c1.061 0 2.02.421 2.738 1.098l1.065-1.065A5.47 5.47 0 0 0 10.5 13.5h-3A5.5 5.5 0 0 0 2 19a1 1 0 0 0 1 1h9.034a1.276 1.276 0 0 1-.009-.532l.166-.968Z",
        fill: "currentColor"
      }
    )
  })
);
var UserPen_default = SvgUserPen;

// src/Icon/icons/UserPlus.tsx
import { jsx as jsx1379 } from "react/jsx-runtime";
var SvgUserPlus = (props) => /* @__PURE__ */ jsx1379(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1379(
      "path",
      {
        d: "M9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-6.5c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5A2.503 2.503 0 0 1 6.5 8c0-1.378 1.122-2.5 2.5-2.5Zm1.584 8H7.416A5.416 5.416 0 0 0 2 18.916c0 .6.485 1.084 1.083 1.084h11.834c.599 0 1.083-.484 1.083-1.084a5.416 5.416 0 0 0-5.416-5.416Zm-7.062 5A3.92 3.92 0 0 1 7.416 15h3.168c2.02 0 3.66 1.535 3.894 3.5H3.522Zm17.728-8.25h-1.5v-1.5a.75.75 0 0 0-1.5 0v1.5h-1.5a.751.751 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5c.416 0 .75-.334.75-.75a.748.748 0 0 0-.75-.75Z",
        fill: "currentColor"
      }
    )
  })
);
var UserPlus_default = SvgUserPlus;

// src/Icon/icons/UserShield.tsx
import { jsx as jsx1380 } from "react/jsx-runtime";
var SvgUserShield = (props) => /* @__PURE__ */ jsx1380(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1380(
      "path",
      {
        d: "m21.447 12.472-3.597-1.407a.959.959 0 0 0-.695 0l-3.599 1.407c-.337.128-.556.437-.556.75 0 3.487 2.148 5.9 4.153 6.684.3.117.563.051.695 0C19.45 19.31 22 17.141 22 13.222c0-.313-.219-.622-.553-.75ZM17.5 18.45v-5.912l2.984 1.168c-.175 2.725-1.903 4.232-2.984 4.744ZM9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-6.5c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5A2.503 2.503 0 0 1 6.5 8c0-1.378 1.122-2.5 2.5-2.5Zm6.213 14.456c-.072.016-.138.044-.213.044H3a1 1 0 0 1-1-1 5.5 5.5 0 0 1 5.5-5.5h3c.527 0 1.036.079 1.518.217a8.83 8.83 0 0 0 .252 1.714A3.971 3.971 0 0 0 10.5 15h-3a4.006 4.006 0 0 0-3.969 3.5h10.225a7.83 7.83 0 0 0 1.457 1.456Z",
        fill: "currentColor"
      }
    )
  })
);
var UserShield_default = SvgUserShield;

// src/Icon/icons/UserSlash.tsx
import { jsx as jsx1381 } from "react/jsx-runtime";
var SvgUserSlash = (props) => /* @__PURE__ */ jsx1381(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1381(
      "path",
      {
        d: "m21.712 18.66-8.659-6.81c1.71-.455 2.974-1.999 2.974-3.85-.055-2.21-1.818-4-4.055-4-2.153 0-3.919 1.748-3.963 3.918L3.216 4.16A.764.764 0 0 0 2.75 4a.75.75 0 0 0-.464 1.34l18.5 14.501a.75.75 0 1 0 .925-1.18Zm-10.646-8.345-1.079-.847A2.473 2.473 0 0 1 9.5 8c0-1.379 1.121-2.5 2.5-2.5 1.378 0 2.5 1.121 2.5 2.5 0 1.378-1.122 2.5-2.5 2.5-.331 0-.644-.069-.934-.185ZM6.503 18.5c.275-1.972 1.96-3.5 3.997-3.5h1.68l-1.902-1.49C7.316 13.596 5 16.036 5 19a1 1 0 0 0 1 1h12a.982.982 0 0 0 .427-.104L16.643 18.5H6.504Z",
        fill: "currentColor"
      }
    )
  })
);
var UserSlash_default = SvgUserSlash;

// src/Icon/icons/UserTag.tsx
import { jsx as jsx1382 } from "react/jsx-runtime";
var SvgUserTag = (props) => /* @__PURE__ */ jsx1382(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1382(
      "path",
      {
        d: "M3.522 18.5A3.92 3.92 0 0 1 7.416 15h3.169c.93 0 1.776.336 2.448.879-.018-.133-.039-.266-.039-.402v-1.378a5.077 5.077 0 0 0-2.41-.599H7.417A5.417 5.417 0 0 0 2 18.92c0 .596.485 1.08 1.083 1.08h11.835c.37 0 .682-.198.878-.482l-1.02-1.018H3.522ZM9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-6.5c1.379 0 2.5 1.121 2.5 2.5 0 1.378-1.121 2.5-2.5 2.5A2.503 2.503 0 0 1 6.5 8C6.5 6.62 7.622 5.5 9 5.5Zm12.707 9.9-2.822-2.813A2.004 2.004 0 0 0 17.47 12h-2.476c-.555 0-1 .445-1 1v2.475c0 .531.208 1.036.583 1.411l2.822 2.821a1 1 0 0 0 1.414 0l2.89-2.89a1 1 0 0 0 .005-1.417Zm-5.712-.653a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z",
        fill: "currentColor"
      }
    )
  })
);
var UserTag_default = SvgUserTag;

// src/Icon/icons/UserUnlock.tsx
import { jsx as jsx1383 } from "react/jsx-runtime";
var SvgUserUnlock = (props) => /* @__PURE__ */ jsx1383(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1383(
      "path",
      {
        d: "M9 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-6.5c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5A2.503 2.503 0 0 1 6.5 8c0-1.378 1.122-2.5 2.5-2.5ZM20.5 13h-4v-2.5c0-.55.45-1 1-1s1 .45 1 1v.5H20v-.353c0-1.308-.938-2.501-2.24-2.634A2.574 2.574 0 0 0 17.5 8c-1.378-.028-2.5 1.122-2.5 2.5V13h-.5c-.825 0-1.5.675-1.5 1.5v4c0 .825.675 1.5 1.5 1.5h6c.825 0 1.5-.675 1.5-1.5v-4c0-.825-.675-1.5-1.5-1.5Zm-3 4.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Zm-5.5 1c0 .565.195 1.08.513 1.5H3a1 1 0 0 1-1-1 5.5 5.5 0 0 1 5.5-5.5h3c.565 0 1.11.086 1.624.244-.077.24-.124.49-.124.756v.797A4.1 4.1 0 0 0 10.5 15h-3a4.006 4.006 0 0 0-3.969 3.5H12Z",
        fill: "currentColor"
      }
    )
  })
);
var UserUnlock_default = SvgUserUnlock;

// src/Icon/icons/UserXmark.tsx
import { jsx as jsx1384 } from "react/jsx-runtime";
var SvgUserXmark = (props) => /* @__PURE__ */ jsx1384(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1384(
      "path",
      {
        d: "M10.693 13.519H7.484A5.485 5.485 0 0 0 2 19.003c0 .608.491 1.098 1.097 1.098H15.08c.606 0 1.096-.49 1.096-1.098a5.485 5.485 0 0 0-5.484-5.484Zm-7.152 5.063a3.97 3.97 0 0 1 3.943-3.544h3.209c2.045 0 3.706 1.555 3.943 3.544H3.541ZM9.09 12a4.05 4.05 0 1 0 0-8.101 4.05 4.05 0 0 0 0 8.101Zm0-6.582a2.535 2.535 0 0 1 2.531 2.531 2.535 2.535 0 0 1-2.531 2.532 2.535 2.535 0 0 1-2.532-2.532 2.535 2.535 0 0 1 2.532-2.531Zm11.199 5.54 1.488-1.487a.76.76 0 1 0-1.074-1.074l-1.487 1.518-1.488-1.489A.76.76 0 1 0 16.653 9.5l1.488 1.489-1.488 1.488a.76.76 0 1 0 1.074 1.074l1.488-1.49 1.488 1.487a.76.76 0 1 0 1.075-1.074l-1.49-1.515Z",
        fill: "currentColor"
      }
    )
  })
);
var UserXmark_default = SvgUserXmark;

// src/Icon/icons/User.tsx
import { jsx as jsx1385 } from "react/jsx-runtime";
var SvgUser = (props) => /* @__PURE__ */ jsx1385(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1385(
      "path",
      {
        d: "M13.875 13.875h-3.75A6.875 6.875 0 0 0 3.25 20.75c0 .69.56 1.25 1.25 1.25h15c.69 0 1.25-.56 1.25-1.25a6.875 6.875 0 0 0-6.875-6.875Zm-8.711 6.25a5.005 5.005 0 0 1 4.961-4.375h3.75a5.008 5.008 0 0 1 4.96 4.375H5.165ZM12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-8.125A3.129 3.129 0 0 1 15.125 7 3.129 3.129 0 0 1 12 10.125 3.129 3.129 0 0 1 8.875 7 3.129 3.129 0 0 1 12 3.875Z",
        fill: "currentColor"
      }
    )
  })
);
var User_default = SvgUser;

// src/Icon/icons/UsersBetweenLines.tsx
import { jsx as jsx1386 } from "react/jsx-runtime";
var SvgUsersBetweenLines = (props) => /* @__PURE__ */ jsx1386(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1386(
      "path",
      {
        d: "M21.25 4a.75.75 0 1 1 0 1.5H2.75a.75.75 0 0 1 0-1.5h18.5Zm0 14.5c.416 0 .75.334.75.75s-.334.75-.75.75H2.75a.75.75 0 1 1 0-1.5h18.5Zm-11.09-5.475a3.24 3.24 0 0 1 .39-.025h3c.131 0 .262.01.39.025 1.473.166 2.61 1.45 2.61 2.975 0 .553-.447 1-1 1h-7c-.553 0-1-.447-1-1a3.008 3.008 0 0 1 2.234-2.903c.122-.031.247-.056.375-.072Zm4.112 1.66a1.567 1.567 0 0 0-.722-.185h-3c-.653 0-1.21.419-1.416 1h5.832c-.082-.228-.244-.431-.391-.622a.612.612 0 0 1-.303-.194ZM9.55 9.5a2.5 2.5 0 1 1 2.5 2.5c-.563 0-1.11-.188-1.5-.5a2.498 2.498 0 0 1-1-2Zm2.5 1a.999.999 0 1 0 0-2 .999.999 0 1 0 0 2ZM4.6 9c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2ZM8 12c.381 0 .74.106 1.044.294A4.012 4.012 0 0 0 6.675 15H4a1 1 0 0 1-1-1 2 2 0 0 1 2-2h3Zm12 3h-2.575c-.325-1.253-1.266-2.269-2.428-2.731A1.98 1.98 0 0 1 16 12h3c1.103 0 2 .897 2 2 0 .553-.447 1-1 1Zm-4.4-6c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2Z",
        fill: "currentColor"
      }
    )
  })
);
var UsersBetweenLines_default = SvgUsersBetweenLines;

// src/Icon/icons/UsersGear.tsx
import { jsx as jsx1387 } from "react/jsx-runtime";
var SvgUsersGear = (props) => /* @__PURE__ */ jsx1387(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1387(
      "path",
      {
        d: "M11.997 14c1.794 0 3.222-1.455 3.222-3.25S13.764 7.5 11.997 7.5c-1.794 0-3.222 1.455-3.222 3.25-.028 1.794 1.428 3.25 3.222 3.25Zm0-5c.964 0 1.749.785 1.749 1.75s-.787 1.75-1.75 1.75a1.751 1.751 0 0 1 0-3.5ZM6 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm12 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM7.747 10.75c0-.17.03-.332.05-.497-.34-.187-.716-.253-1.113-.253H4.753C3.233 10 2 11.306 2 12.916c0 .322.246.584.55.584h6.235a4.21 4.21 0 0 1-1.038-2.75Zm11.5-.75h-1.933c-.4 0-.777.095-1.12.258.018.164.05.323.05.492 0 .67-.176 1.293-.458 1.854A4.464 4.464 0 0 1 18 12c1.328 0 2.508.586 3.331 1.5h.118c.304 0 .551-.262.551-.584C22 11.306 20.769 10 19.247 10Zm-5.26 8.5H7.567c.327-1.149 1.48-2 2.848-2H13.5c0-.522.106-1.014.27-1.48-.073-.004-.139-.02-.21-.02h-3.12C7.989 15 6 16.866 6 19.166c0 .462.397.834.888.834h8.315a4.502 4.502 0 0 1-1.215-1.5Zm7.329-3.04a3.532 3.532 0 0 0-.774-1.335.168.168 0 0 0-.21-.032l-.598.346a2.72 2.72 0 0 0-.858-.495v-.722a.168.168 0 0 0-.134-.163 3.489 3.489 0 0 0-1.541 0c-.048.041-.104.113-.104.163v.695c-.314.11-.605.279-.858.494l-.602-.346a.169.169 0 0 0-.21.032c-.348.378-.616.835-.77 1.335a.17.17 0 0 0 .076.198l.599.349a2.827 2.827 0 0 0 0 .989l-.6.349a.166.166 0 0 0-.075.197c.154.5.422.954.77 1.335.056.058.14.073.21.032l.602-.346c.253.215.544.384.858.494v.695c0 .079.055.149.13.163a3.49 3.49 0 0 0 1.542 0 .168.168 0 0 0 .134-.163v-.695c.314-.11.605-.279.858-.494l.599.346c.067.04.157.026.209-.032.35-.378.617-.834.773-1.335a.168.168 0 0 0-.078-.197l-.6-.35a2.694 2.694 0 0 0 0-.988l.6-.35c.07-.01.102-.091.052-.17ZM18 17.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
        fill: "currentColor"
      }
    )
  })
);
var UsersGear_default = SvgUsersGear;

// src/Icon/icons/UsersLine.tsx
import { jsx as jsx1388 } from "react/jsx-runtime";
var SvgUsersLine = (props) => /* @__PURE__ */ jsx1388(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1388(
      "path",
      {
        d: "M4.6 7a2 2 0 0 1 4 0c0 1.103-.897 2-2 2s-2-.897-2-2ZM8 10c.772 0 1.44.41 1.775 1.075A4.006 4.006 0 0 0 7.085 13H4a1 1 0 0 1-1-1 2 2 0 0 1 2-2h3Zm12 3h-2.984a4.001 4.001 0 0 0-2.782-1.94c.338-.632 1-1.06 1.766-1.06h3c1.103 0 2 .897 2 2 0 .553-.447 1-1 1Zm-3.45 2c0 .553-.447 1-1 1h-7c-.553 0-1-.447-1-1 0-.769.288-1.497.763-2a3.03 3.03 0 0 1 1.659-.95c.078-.01.134-.019.187-.025A3.24 3.24 0 0 1 10.55 12h3c.131 0 .262.01.39.025.023.003.041-.022.06.01a2.993 2.993 0 0 1 1.787.965c.475.503.763 1.231.763 2Zm-1.584-.5c-.207-.581-.763-1-1.416-1h-3c-.653 0-1.21.419-1.416 1h5.832ZM15.6 7a2 2 0 0 1 4 0c0 1.103-.897 2-2 2s-2-.897-2-2ZM9.55 8.5a2.5 2.5 0 1 1 2.5 2.5c-.563 0-1.11-.188-1.5-.5a2.498 2.498 0 0 1-1-2Zm2.5 1a.999.999 0 1 0 0-2 .999.999 0 1 0 0 2ZM2 18.25a.75.75 0 0 1 .75-.75h18.5c.416 0 .75.334.75.75s-.334.75-.75.75H2.75a.75.75 0 0 1-.75-.75Z",
        fill: "currentColor"
      }
    )
  })
);
var UsersLine_default = SvgUsersLine;

// src/Icon/icons/UsersSlash.tsx
import { jsx as jsx1389 } from "react/jsx-runtime";
var SvgUsersSlash = (props) => /* @__PURE__ */ jsx1389(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1389(
      "path",
      {
        d: "M7.566 18.5c.327-1.149 1.48-2 2.848-2h3.145c.214 0 .42.027.62.067l-2-1.567H10.44C7.987 15 6 16.866 6 19.166c0 .462.397.834.888.834h10.225a.89.89 0 0 0 .81-.499l-1.28-1.001H7.567Zm6.828-5.578a3.2 3.2 0 0 0 .85-2.172c0-1.795-1.455-3.25-3.222-3.25-1.123 0-2.096.58-2.675 1.447L8.034 7.94c.291-.407.466-.902.466-1.441A2.5 2.5 0 0 0 6 4a2.46 2.46 0 0 0-1.876.873l-.911-.713a.749.749 0 0 0-1.053.127.75.75 0 0 0 .127 1.053L20.76 19.812a.75.75 0 1 0 .926-1.18l-7.291-5.71Zm-1.178-.95-2.722-2.106C10.8 9.35 11.354 9 11.997 9c.964 0 1.749.785 1.749 1.75-.002.49-.205.931-.53 1.222ZM18 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm-.684 1c-.4 0-.778.095-1.121.258.017.164.049.323.049.492 0 1.053-.4 2.007-1.037 2.75h6.241c.305 0 .552-.262.552-.584C22 11.306 20.769 10 19.247 10h-1.931Zm-9.5 1.6L5.8 10H4.753C3.233 10 2 11.306 2 12.916c0 .322.246.584.55.584h6.235a4.63 4.63 0 0 1-.97-1.9Z",
        fill: "currentColor"
      }
    )
  })
);
var UsersSlash_default = SvgUsersSlash;

// src/Icon/icons/Users.tsx
import { jsx as jsx1390 } from "react/jsx-runtime";
var SvgUsers = (props) => /* @__PURE__ */ jsx1390(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1390(
      "path",
      {
        d: "M11.997 14c1.794 0 3.222-1.455 3.222-3.25S13.764 7.5 11.997 7.5c-1.794 0-3.222 1.455-3.222 3.25-.028 1.794 1.428 3.25 3.222 3.25Zm0-5c.964 0 1.749.785 1.749 1.75s-.787 1.75-1.75 1.75a1.751 1.751 0 0 1 0-3.5ZM18 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm-4.44 6h-3.12C7.989 15 6 16.866 6 19.166c0 .462.397.834.888.834h10.225c.49 0 .887-.372.887-.834 0-2.3-1.988-4.166-4.44-4.166Zm-5.994 3.5c.327-1.149 1.48-2 2.848-2h3.145c1.368 0 2.521.851 2.848 2H7.566Zm11.68-8.5h-1.932c-.4 0-.777.095-1.12.258.018.164.05.323.05.492 0 1.053-.4 2.007-1.037 2.75h6.241c.305 0 .552-.262.552-.584C22 11.306 20.769 10 19.247 10Zm-11.5.75c0-.17.032-.332.051-.497-.34-.187-.716-.253-1.113-.253H4.753C3.233 10 2 11.306 2 12.916c0 .322.246.584.55.584h6.235a4.21 4.21 0 0 1-1.038-2.75ZM6 9a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
        fill: "currentColor"
      }
    )
  })
);
var Users_default = SvgUsers;

// src/Icon/icons/V.tsx
import { jsx as jsx1391 } from "react/jsx-runtime";
var SvgV = (props) => /* @__PURE__ */ jsx1391(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1391(
      "path",
      {
        d: "M12 22c-.432 0-.822-.259-.988-.657l-7.5-17.855a1.07 1.07 0 1 1 1.976-.83l6.511 15.503 6.513-15.503a1.07 1.07 0 1 1 1.975.83l-7.499 17.855A1.072 1.072 0 0 1 12 22Z",
        fill: "currentColor"
      }
    )
  })
);
var V_default = SvgV;

// src/Icon/icons/Vault.tsx
import { jsx as jsx1392 } from "react/jsx-runtime";
var SvgVault = (props) => /* @__PURE__ */ jsx1392(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1392(
      "path",
      {
        d: "M8.111 11.444a1.667 1.667 0 1 1 3.334.001 1.667 1.667 0 0 1-3.334 0Zm6.667 0a5.001 5.001 0 0 1-10 0c0-2.76 2.24-5 5-5s5 2.24 5 5Zm-5-3.333a3.295 3.295 0 0 0-3.334 3.333 3.314 3.314 0 0 0 3.334 3.334 3.334 3.334 0 0 0 3.333-3.334 3.314 3.314 0 0 0-3.333-3.333Zm9.444 1.111a1.67 1.67 0 0 1-.833 1.445V14.5a.831.831 0 0 1-.833.833.831.831 0 0 1-.834-.833v-3.833a1.667 1.667 0 1 1 2.5-1.444ZM2 5.333c0-1.227.995-2.222 2.222-2.222h15.556c1.226 0 2.222.995 2.222 2.222v12.223a2.224 2.224 0 0 1-2.222 2.222v.278a.831.831 0 0 1-.834.833.831.831 0 0 1-.833-.833v-.278H5.89v.278a.832.832 0 1 1-1.667 0v-.278A2.223 2.223 0 0 1 2 17.556V5.333Zm1.667 0v12.223c0 .305.248.555.555.555h15.556c.305 0 .555-.25.555-.555V5.333a.556.556 0 0 0-.555-.555H4.222a.555.555 0 0 0-.555.555Z",
        fill: "currentColor"
      }
    )
  })
);
var Vault_default = SvgVault;

// src/Icon/icons/VirusSlash.tsx
import { jsx as jsx1393 } from "react/jsx-runtime";
var SvgVirusSlash = (props) => /* @__PURE__ */ jsx1393(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1393(
      "path",
      {
        d: "M6.21 6.508c.037-.058.08-.114.106-.165.418-.39 1.05-.39 1.44 0l.256.255c1.104 1.102 2.96.322 2.96-1.237V5c0-.552.475-1 1-1C12.553 4 13 4.448 13 5v.36c0 1.56 1.884 2.34 2.987 1.238l.257-.255a.998.998 0 1 1 1.412 1.413l-.253.256C16.3 9.116 17.081 11 18.637 11H19a.999.999 0 1 1 0 2h-.36c-1.103 0-1.815.94-1.75 1.878l4.822 3.781a.75.75 0 0 1-.925 1.181l-18.5-14.5a.75.75 0 1 1 .926-1.18l2.996 2.348Zm2.809 2.204 1.697 1.329a.981.981 0 0 1 1.256.96v.046l3.472 2.7A3.391 3.391 0 0 1 16.709 12c-1.05-.74-1.597-2.09-1.381-3.328-1.266.215-2.587-.331-3.356-1.381-.647.953-1.797 1.493-2.953 1.421ZM5.359 11c.47 0 .866-.169 1.163-.438l1.269 1c-.15.163-.316.31-.5.438a3.416 3.416 0 0 1 1.38 3.328c1.238-.216 2.588.331 3.3 1.381a3.757 3.757 0 0 1 1.113-.978l1.45 1.166A1.74 1.74 0 0 0 13 18.64V19c0 .553-.447 1-1.028 1-.525 0-1-.447-1-1v-.36c0-1.559-1.856-2.34-2.96-1.237l-.256.253c-.39.39-1.022.39-1.44 0a1.053 1.053 0 0 1 0-1.412l.28-.257C7.7 14.884 6.92 13 5.36 13h-.387c-.524 0-1-.447-1-1 0-.553.476-1 1-1h.387Z",
        fill: "currentColor"
      }
    )
  })
);
var VirusSlash_default = SvgVirusSlash;

// src/Icon/icons/VirusTotal.tsx
import { jsx as jsx1394, jsxs as jsxs15 } from "react/jsx-runtime";
var SvgVirusTotal = (props) => /* @__PURE__ */ jsxs15(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsx1394(
        "circle",
        {
          cx: 512,
          cy: 512,
          r: 512,
          style: {
            fill: "#394eff"
          }
        }
      ),
      /* @__PURE__ */ jsx1394(
        "path",
        {
          d: "M256.1 300.7 468 512.2 256.1 723.3h467.8V300.7H256.1zM678.7 678h-316l167.1-165.8L362.7 346h315.9c.1 0 .1 332 .1 332z",
          style: {
            fill: "#fff"
          }
        }
      )
    ]
  })
);
var VirusTotal_default = SvgVirusTotal;

// src/Icon/icons/Virus.tsx
import { jsx as jsx1395 } from "react/jsx-runtime";
var SvgVirus = (props) => /* @__PURE__ */ jsx1395(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1395(
      "path",
      {
        d: "M12 10.75c0 .691-.559 1.25-1.25 1.25s-1.25-.559-1.25-1.25.559-1.25 1.25-1.25 1.25.559 1.25 1.25Zm.938 3.125c0-.52.417-.938.937-.938s.938.418.938.938-.418.938-.938.938a.935.935 0 0 1-.938-.938ZM6.694 4.929l.32.319c1.38 1.377 3.735.402 3.735-1.547V3.25a1.25 1.25 0 1 1 2.5 0v.451c0 1.949 2.355 2.924 3.734 1.547l.32-.32a1.248 1.248 0 1 1 1.766 1.766l-.316.322c-1.379 1.379-.402 3.734 1.547 3.734h.449c.691 0 1.25.559 1.25 1.25s-.559 1.25-1.25 1.25h-.45c-1.948 0-2.925 2.355-1.546 3.734l.316.32a1.247 1.247 0 0 1 0 1.766 1.247 1.247 0 0 1-1.765 0l-.32-.316c-1.38-1.379-3.735-.402-3.735 1.547v.449c0 .691-.559 1.25-1.25 1.25s-1.25-.559-1.25-1.25v-.45c0-1.948-2.355-2.925-3.734-1.546l-.32.316a1.248 1.248 0 1 1-1.767-1.765l.319-.32c1.377-1.38.402-3.735-1.547-3.735H3.25a1.25 1.25 0 1 1 0-2.5h.451c1.949 0 2.924-2.355 1.547-3.734l-.32-.32a1.248 1.248 0 1 1 1.767-1.767ZM12 6.113C11.074 7.426 9.387 8.11 7.84 7.84c.27 1.547-.414 3.234-1.727 4.16a4.27 4.27 0 0 1 1.727 4.16c1.547-.27 3.234.414 4.125 1.727.96-1.313 2.613-1.996 4.195-1.727A4.27 4.27 0 0 1 17.887 12c-1.313-.926-1.996-2.613-1.727-4.16-1.582.27-3.234-.414-4.195-1.727H12Z",
        fill: "currentColor"
      }
    )
  })
);
var Virus_default = SvgVirus;

// src/Icon/icons/Viruses.tsx
import { jsx as jsx1396 } from "react/jsx-runtime";
var SvgViruses = (props) => /* @__PURE__ */ jsx1396(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1396(
      "path",
      {
        d: "M9 10c-.275 0-.5.225-.5.5s.225.5.5.5a.5.5 0 0 0 0-1ZM7.5 8.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm14 6.25h-.379c-.89 0-1.337-1.077-.707-1.707l.268-.268a.5.5 0 1 0-.707-.707l-.268.268A1 1 0 0 1 18 11.878V11.5c0-.275-.225-.5-.5-.5s-.5.225-.5.5v.379a1 1 0 0 1-1.707.707l-.268-.268a.498.498 0 0 0-.707 0 .5.5 0 0 0 0 .707l.268.268c.63.629.183 1.707-.708 1.707H13.5a.5.5 0 1 0 0 1h.379c.89 0 1.337 1.077.707 1.707l-.268.268a.5.5 0 1 0 .707.707l.268-.268a1 1 0 0 1 1.707.708v.378a.5.5 0 1 0 1 0v-.379a1 1 0 0 1 1.707-.707l.268.268a.498.498 0 0 0 .707 0 .5.5 0 0 0 0-.707l-.268-.268c-.63-.629-.183-1.707.708-1.707h.378a.5.5 0 1 0 0-1Zm-5 1.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Zm-3.672-5.584h.505a.666.666 0 1 0 0-1.332h-.505c-1.187 0-1.782-1.437-.942-2.277l.357-.357a.667.667 0 1 0-.942-.943l-.357.357a1.308 1.308 0 0 1-.935.394c-.685 0-1.342-.532-1.342-1.336v-.505a.667.667 0 0 0-1.333 0v.505c0 .803-.657 1.336-1.342 1.336-.328 0-.662-.122-.934-.394L4.7 5.757a.665.665 0 0 0-.943 0 .667.667 0 0 0 0 .943l.357.357c.84.84.245 2.276-.942 2.276h-.505a.667.667 0 0 0 0 1.334h.505c1.187 0 1.782 1.436.942 2.276l-.357.357a.667.667 0 0 0 .943.943l.357-.359c.272-.271.606-.393.933-.393.686 0 1.343.532 1.343 1.336v.505a.667.667 0 1 0 1.334.001v-.505c0-.803.657-1.335 1.342-1.335.328 0 .662.121.934.393l.357.357a.664.664 0 0 0 .942 0 .667.667 0 0 0 0-.943l-.358-.356c-.837-.84-.243-2.278.944-2.278Zm-2.619.25c-.143.35-.215.715-.215 1.078A2.824 2.824 0 0 0 8 12.825a2.824 2.824 0 0 0-1.994-.831c0-.363-.072-.728-.215-1.078-.147-.35-.382-.66-.61-.916a2.84 2.84 0 0 0 .825-1.994C6.784 8.003 7.487 7.66 8 7.175c.511.51 1.216.827 1.993.832A2.84 2.84 0 0 0 10.82 10a2.845 2.845 0 0 0-.61.916Z",
        fill: "currentColor"
      }
    )
  })
);
var Viruses_default = SvgViruses;

// src/Icon/icons/VolumeHigh.tsx
import { jsx as jsx1397 } from "react/jsx-runtime";
var SvgVolumeHigh = (props) => /* @__PURE__ */ jsx1397(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1397(
      "path",
      {
        d: "M11.412 5.093a1.007 1.007 0 0 0-.41-.09c-.241 0-.479.09-.665.255L6.119 9.003H3.5A1.5 1.5 0 0 0 2 10.502v2.997A1.5 1.5 0 0 0 3.5 15h2.62l4.216 3.743a1.006 1.006 0 0 0 1.075.163.994.994 0 0 0 .589-.908V6.004a.995.995 0 0 0-.588-.91ZM10.5 16.878l-3.81-3.381H3.5v-2.995h3.19L10.5 7.12v9.758Zm4.394-7.19a.753.753 0 0 0-1.055.106.748.748 0 0 0 .105 1.054c.353.29.556.708.556 1.124 0 .443-.203.862-.557 1.15a.748.748 0 0 0 .475 1.33.75.75 0 0 0 .475-.168A2.9 2.9 0 0 0 16 11.972c0-.922-.403-1.71-1.106-2.284Zm1.89-2.307a.75.75 0 0 0-.95 1.159 4.405 4.405 0 0 1 1.666 3.432c0 1.332-.608 2.566-1.666 3.46a.749.749 0 1 0 .951 1.158A5.876 5.876 0 0 0 19 11.972c0-1.81-.806-3.44-2.216-4.59ZM18.7 5.044a.756.756 0 0 0-1.056.104.749.749 0 0 0 .104 1.054 7.454 7.454 0 0 1 2.752 5.77 7.507 7.507 0 0 1-2.752 5.797.749.749 0 0 0-.104 1.054.697.697 0 0 0 .581.302.748.748 0 0 0 .476-.17A8.977 8.977 0 0 0 22 11.972a8.948 8.948 0 0 0-3.3-6.928Z",
        fill: "currentColor"
      }
    )
  })
);
var VolumeHigh_default = SvgVolumeHigh;

// src/Icon/icons/VolumeLow.tsx
import { jsx as jsx1398 } from "react/jsx-runtime";
var SvgVolumeLow = (props) => /* @__PURE__ */ jsx1398(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1398(
      "path",
      {
        d: "M20.42 8.692a1.074 1.074 0 0 0-1.507.152 1.07 1.07 0 0 0 .15 1.508c.504.416.794 1.014.794 1.648 0 .633-.29 1.233-.795 1.646a1.07 1.07 0 1 0 1.356 1.66A4.26 4.26 0 0 0 22 12a4.27 4.27 0 0 0-1.58-3.308Zm-4.974-6.565a1.428 1.428 0 0 0-1.537.235L7.884 7.714H4.143C2.959 7.714 2 8.674 2 9.817v4.245c0 1.184.96 2.103 2.143 2.103h3.743l6.022 5.353c.266.357.605.482.95.482.197 0 .4-.042.587-.127.515-.23.84-.74.84-1.302V3.43c0-.562-.325-1.112-.839-1.302Zm-1.303 16.855L8.7 14.142H4.143V9.898H8.7l5.442-4.877v13.962Z",
        fill: "currentColor"
      }
    )
  })
);
var VolumeLow_default = SvgVolumeLow;

// src/Icon/icons/VolumeOff.tsx
import { jsx as jsx1399 } from "react/jsx-runtime";
var SvgVolumeOff = (props) => /* @__PURE__ */ jsx1399(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1399(
      "path",
      {
        d: "M18.303 2.127a1.43 1.43 0 0 0-1.537.235l-6.025 5.352H7c-1.183 0-2.143.96-2.143 2.103v4.245c0 1.184.96 2.103 2.143 2.103h3.743l6.022 5.353c.266.357.605.482.95.482.197 0 .4-.042.587-.127.515-.23.84-.74.84-1.302V3.43c0-.562-.325-1.112-.838-1.302ZM17 18.982l-5.442-4.84H7V9.898h4.558L17 5.02v13.962Z",
        fill: "currentColor"
      }
    )
  })
);
var VolumeOff_default = SvgVolumeOff;

// src/Icon/icons/VolumeSlash.tsx
import { jsx as jsx1400 } from "react/jsx-runtime";
var SvgVolumeSlash = (props) => /* @__PURE__ */ jsx1400(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1400(
      "path",
      {
        d: "m21.718 18.661-2.776-2.175c1.31-1.148 2.063-2.77 2.063-4.486a5.876 5.876 0 0 0-2.216-4.598.749.749 0 0 0-1.056.104.75.75 0 0 0 .105 1.056A4.378 4.378 0 0 1 19.504 12c0 1.335-.607 2.597-1.666 3.467-.033.026-.05.063-.077.094l-1.386-1.086c.016 0 .03.01.047.01a.75.75 0 0 0 .474-.169A2.986 2.986 0 0 0 18.005 12c0-.896-.404-1.739-1.108-2.315a.752.752 0 0 0-1.055.107.75.75 0 0 0 .106 1.056c.354.29.557.708.557 1.152 0 .444-.204.863-.557 1.153a.749.749 0 0 0-.245.793l-1.699-1.33V5.998a.997.997 0 0 0-1-1 1 1 0 0 0-.665.253l-3.62 3.22-5.505-4.313a.75.75 0 1 0-.926 1.18l18.477 14.476a.748.748 0 0 0 .463.188.75.75 0 0 0 .59-.287.724.724 0 0 0-.1-1.054Zm-9.215-7.224L9.918 9.412l2.585-2.3v4.325Zm0 5.452L8.693 13.5H5.5v-2.972h.938L4.774 9.196A1.46 1.46 0 0 0 4 10.5v3c0 .83.672 1.473 1.5 1.473h2.621l4.217 3.748a.906.906 0 0 0 .665.28.998.998 0 0 0 1-1v-1.573l-1.5-1.176v1.637Z",
        fill: "currentColor"
      }
    )
  })
);
var VolumeSlash_default = SvgVolumeSlash;

// src/Icon/icons/VolumeXmark.tsx
import { jsx as jsx1401 } from "react/jsx-runtime";
var SvgVolumeXmark = (props) => /* @__PURE__ */ jsx1401(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1401(
      "path",
      {
        d: "M12.606 4.26a1.127 1.127 0 0 0-1.213.185L6.64 8.668H3.69C2.756 8.667 2 9.424 2 10.326v3.348c0 .934.757 1.659 1.69 1.659h2.952l4.75 4.222a1.127 1.127 0 0 0 1.875-.842V5.287c-.031-.443-.256-.845-.661-1.026Zm-1.029 13.295-4.292-3.817H3.69v-3.349h3.595l4.292-3.847v11.013Zm8.518-5.54 1.656-1.655a.845.845 0 1 0-1.195-1.195L18.9 10.854l-1.686-1.659a.845.845 0 1 0-1.195 1.196l1.656 1.656-1.656 1.655a.845.845 0 1 0 1.195 1.196L18.9 13.24l1.656 1.656a.845.845 0 1 0 1.195-1.195l-1.657-1.686Z",
        fill: "currentColor"
      }
    )
  })
);
var VolumeXmark_default = SvgVolumeXmark;

// src/Icon/icons/Volume.tsx
import { jsx as jsx1402 } from "react/jsx-runtime";
var SvgVolume = (props) => /* @__PURE__ */ jsx1402(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1402(
      "path",
      {
        d: "M13.073 3.87a1.18 1.18 0 0 0-1.265.192L6.846 8.471H3.765C2.79 8.47 2 9.26 2 10.202V13.7c0 .974.79 1.731 1.765 1.731h3.082l4.96 4.408c.219.294.498.397.781.397a1.174 1.174 0 0 0 1.177-1.176V4.94c0-.463-.269-.915-.692-1.072ZM12 17.75l-4.482-3.985H3.765v-3.497h3.753L12 6.251V17.75Zm5.17-8.474a.885.885 0 0 0-1.242.125.882.882 0 0 0 .124 1.242c.415.342.654.835.654 1.357a1.75 1.75 0 0 1-.655 1.355.882.882 0 0 0 1.117 1.368A3.508 3.508 0 0 0 18.47 12a3.516 3.516 0 0 0-1.302-2.724Zm2.223-2.717a.881.881 0 0 0-1.242.123.882.882 0 0 0 .123 1.242c1.248 1.02 1.961 2.506 1.961 4.076 0 1.57-.714 3.055-1.96 4.077a.882.882 0 0 0 1.12 1.365C21.051 16.085 22 14.1 22 12c0-2.1-.948-4.085-2.607-5.441Z",
        fill: "currentColor"
      }
    )
  })
);
var Volume_default = SvgVolume;

// src/Icon/icons/W.tsx
import { jsx as jsx1403 } from "react/jsx-runtime";
var SvgW = (props) => /* @__PURE__ */ jsx1403(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1403(
      "path",
      {
        d: "M16.177 19.767h-.023a.832.832 0 0 1-.774-.593L12.016 7.96 8.622 19.174a.83.83 0 0 1-1.58.043L2.05 5.347a.831.831 0 0 1 .5-1.064c.463-.157.94.068 1.096.501L7.783 16.28l3.436-11.452a.834.834 0 0 1 1.594 0l3.436 11.452 4.136-11.494a.831.831 0 1 1 1.565.563l-4.992 13.87a.828.828 0 0 1-.781.549Z",
        fill: "currentColor"
      }
    )
  })
);
var W_default = SvgW;

// src/Icon/icons/Wallet.tsx
import { jsx as jsx1404 } from "react/jsx-runtime";
var SvgWallet = (props) => /* @__PURE__ */ jsx1404(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1404(
      "path",
      {
        d: "M19.813 3.25a.937.937 0 1 1 0 1.875H5.438c-.863 0-1.563.7-1.563 1.563v10.625c0 .863.7 1.562 1.563 1.562h13.125c.863 0 1.562-.7 1.562-1.563v-6.875c0-.863-.7-1.562-1.563-1.562H6.688a.935.935 0 0 1-.937-.938c0-.519.418-.937.938-.937h11.875A3.438 3.438 0 0 1 22 10.438v6.874a3.438 3.438 0 0 1-3.438 3.438H5.438A3.438 3.438 0 0 1 2 17.312V6.688A3.438 3.438 0 0 1 5.438 3.25h14.375ZM15.75 13.875c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25-.559 1.25-1.25 1.25-1.25-.559-1.25-1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var Wallet_default = SvgWallet;

// src/Icon/icons/WatchApple.tsx
import { jsx as jsx1405 } from "react/jsx-runtime";
var SvgWatchApple = (props) => /* @__PURE__ */ jsx1405(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1405(
      "path",
      {
        d: "M10.75 12c0-.691.559-1.25 1.25-1.25s1.25.559 1.25 1.25-.559 1.25-1.25 1.25-1.25-.559-1.25-1.25Zm3.75 2.813c0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938c0-.519.418-.937.938-.937.519 0 .937.418.937.938Zm-5 0c0-.52.418-.938.938-.938.519 0 .937.418.937.938 0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938Zm5-5.626c0 .52-.418.938-.938.938a.935.935 0 0 1-.937-.938c0-.519.418-.937.938-.937.519 0 .937.418.937.938Zm-5 0c0-.519.418-.937.938-.937.519 0 .937.418.937.938 0 .519-.418.937-.938.937a.935.935 0 0 1-.937-.938ZM10.125 12c0 .52-.418.938-.938.938A.935.935 0 0 1 8.25 12c0-.52.418-.938.938-.938.519 0 .937.418.937.938Zm3.75 0c0-.52.418-.938.938-.938.519 0 .937.418.937.938s-.418.938-.938.938a.935.935 0 0 1-.937-.938Zm1.238-10C16.156 2 17 2.845 17 3.888v.675c1.426.289 2.5 1.55 2.5 3.062v8.75c0 1.512-1.074 2.738-2.5 3.063v.687C17 21.16 16.16 22 15.125 22h-6.25A1.875 1.875 0 0 1 7 20.125v-.688c-1.427-.324-2.5-1.55-2.5-3.062v-8.75A3.126 3.126 0 0 1 7 4.562v-.675C7 2.846 7.845 2 8.887 2h6.226Zm1.262 4.375h-8.75c-.69 0-1.25.559-1.25 1.25v8.75c0 .691.56 1.25 1.25 1.25h8.75c.691 0 1.25-.559 1.25-1.25v-8.75c0-.691-.559-1.25-1.25-1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var WatchApple_default = SvgWatchApple;

// src/Icon/icons/WatchCalculator.tsx
import { jsx as jsx1406 } from "react/jsx-runtime";
var SvgWatchCalculator = (props) => /* @__PURE__ */ jsx1406(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1406(
      "path",
      {
        d: "M15.438 8.25c.343 0 .624.281.624.625v1.25a.627.627 0 0 1-.625.625H8.564a.626.626 0 0 1-.626-.625v-1.25c0-.344.28-.625.625-.625h6.876Zm-7.5 4.375a.937.937 0 1 1 1.875 0c0 .52-.418.938-.938.938a.937.937 0 0 1-.938-.938Zm5 0c0 .52-.418.938-.938.938a.935.935 0 0 1-.938-.938c0-.52.418-.938.938-.938s.938.418.938.938Zm1.25 0c0-.52.417-.938.937-.938s.938.418.938.938-.418.938-.938.938a.935.935 0 0 1-.938-.938Zm-4.376 2.5a.937.937 0 1 1-.938-.938c.52 0 .938.418.938.938Zm1.25 0c0-.52.418-.938.938-.938s.938.418.938.938-.418.938-.938.938a.935.935 0 0 1-.938-.938Zm5 0c0 .52-.418.938-.937.938a.935.935 0 0 1-.938-.938c0-.52.418-.938.938-.938s.938.418.938.938ZM15.114 2C16.156 2 17 2.845 17 3.888v.675c1.426.289 2.5 1.55 2.5 3.062v8.75c0 1.512-1.074 2.738-2.5 3.063v.687C17 21.16 16.16 22 15.125 22h-6.25A1.875 1.875 0 0 1 7 20.125v-.688c-1.427-.324-2.5-1.55-2.5-3.062v-8.75A3.126 3.126 0 0 1 7 4.562v-.675C7 2.846 7.845 2 8.887 2h6.226Zm1.262 4.375h-8.75c-.69 0-1.25.559-1.25 1.25v8.75c0 .691.56 1.25 1.25 1.25h8.75c.691 0 1.25-.559 1.25-1.25v-8.75c0-.691-.559-1.25-1.25-1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var WatchCalculator_default = SvgWatchCalculator;

// src/Icon/icons/WavePulse.tsx
import { jsx as jsx1407 } from "react/jsx-runtime";
var SvgWavePulse = (props) => /* @__PURE__ */ jsx1407(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1407(
      "path",
      {
        d: "M22 11.972c0 .444-.334.778-.75.778h-3.775l-1.797 3.819a.735.735 0 0 1-.75.426.745.745 0 0 1-.656-.559l-2.188-8.393-2.35 11.36a.75.75 0 0 1-.709.597H9a.752.752 0 0 1-.723-.55l-1.846-6.7h-3.71C2.337 12.75 2 12.416 2 12s.336-.75.722-.75H7a.75.75 0 0 1 .723.55l1.171 4.25 2.372-11.453A.756.756 0 0 1 11.984 4H12c.34 0 .64.23.727.563l2.476 9.496 1.117-2.378a.756.756 0 0 1 .68-.431h4.25c.416 0 .75.334.75.722Z",
        fill: "currentColor"
      }
    )
  })
);
var WavePulse_default = SvgWavePulse;

// src/Icon/icons/WaveSine.tsx
import { jsx as jsx1408 } from "react/jsx-runtime";
var SvgWaveSine = (props) => /* @__PURE__ */ jsx1408(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1408(
      "path",
      {
        d: "M21.966 12.694c-.188.597-1.944 5.806-5.366 5.806-2.976 0-4.222-3.322-5.319-6.253-.927-2.478-1.978-5.285-3.88-5.285-1.754 0-3.298 2.852-3.907 4.77-.121.382-.47.518-.733.518a.764.764 0 0 1-.675-.397.695.695 0 0 1-.052-.548C2.223 10.709 3.98 5.5 7.4 5.5c2.976 0 4.222 3.322 5.319 6.253.927 2.478 1.978 5.285 3.881 5.285 1.753 0 3.297-2.853 3.906-4.77.121-.381.473-.517.737-.517a.76.76 0 0 1 .672.395c.091.173.11.366.05.548Z",
        fill: "currentColor"
      }
    )
  })
);
var WaveSine_default = SvgWaveSine;

// src/Icon/icons/WaveSquare.tsx
import { jsx as jsx1409 } from "react/jsx-runtime";
var SvgWaveSquare = (props) => /* @__PURE__ */ jsx1409(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1409(
      "path",
      {
        d: "M15.75 19h-2.5c-1.1 0-2-.9-2-2V7a.5.5 0 0 0-.5-.5h-2.5a.5.5 0 0 0-.5.5v4.75c0 .55-.45 1-1 1h-4A.752.752 0 0 1 2 12c0-.412.337-.75.722-.75H6.25V7c0-1.1.9-2 2-2h2.5c1.1 0 2 .9 2 2v10a.5.5 0 0 0 .5.5h2.5a.5.5 0 0 0 .5-.5v-4.75c0-.55.45-1 1-1h4c.413 0 .75.338.75.75s-.337.75-.75.75h-3.5V17c0 1.1-.9 2-2 2Z",
        fill: "currentColor"
      }
    )
  })
);
var WaveSquare_default = SvgWaveSquare;

// src/Icon/icons/WaveTriangle.tsx
import { jsx as jsx1410 } from "react/jsx-runtime";
var SvgWaveTriangle = (props) => /* @__PURE__ */ jsx1410(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1410(
      "path",
      {
        d: "m21.856 12.194-4.722 6.5a.866.866 0 0 1-.663.306.757.757 0 0 1-.608-.312L7.497 7.028l-4.141 5.666a.751.751 0 0 1-1.211-.888l4.721-6.5A.846.846 0 0 1 7.5 5c.24.001.468.117.609.312l8.396 11.662 4.14-5.666a.749.749 0 1 1 1.21.886Z",
        fill: "currentColor"
      }
    )
  })
);
var WaveTriangle_default = SvgWaveTriangle;

// src/Icon/icons/WaveformLines.tsx
import { jsx as jsx1411 } from "react/jsx-runtime";
var SvgWaveformLines = (props) => /* @__PURE__ */ jsx1411(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1411(
      "path",
      {
        d: "M12 3.795c-.426 0-.77.344-.77.74v14.9c0 .427.344.77.741.77.398 0 .798-.343.798-.77v-14.9c0-.396-.343-.74-.769-.74ZM8.923 6.872c-.426 0-.77.343-.77.74v8.718c0 .455.344.798.741.798.398 0 .798-.343.798-.769V7.612c0-.397-.343-.74-.769-.74Zm6.154 1.025c-.426 0-.77.343-.77.74v6.668c0 .455.344.798.741.798s.798-.343.798-.77V8.638c0-.398-.343-.74-.77-.74Zm3.077-2.05c-.425 0-.77.344-.77.74v10.798c0 .426.344.769.741.769.455 0 .798-.343.798-.77V6.588c0-.396-.343-.74-.77-.74ZM5.846 9.948c-.426 0-.77.343-.77.74v2.593c0 .426.344.77.741.77.398 0 .798-.344.798-.77V10.69c0-.397-.343-.74-.769-.74ZM2.77 10.974c-.424 0-.769.343-.769.74v.542c0 .427.345.77.74.77.396 0 .798-.343.798-.77v-.541c0-.398-.344-.74-.769-.74Zm18.462 0c-.425 0-.77.345-.77.74v.542c0 .427.344.77.77.77.426 0 .769-.345.769-.74v-.571c0-.398-.343-.74-.77-.74Z",
        fill: "currentColor"
      }
    )
  })
);
var WaveformLines_default = SvgWaveformLines;

// src/Icon/icons/Waveform.tsx
import { jsx as jsx1412 } from "react/jsx-runtime";
var SvgWaveform = (props) => /* @__PURE__ */ jsx1412(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1412(
      "path",
      {
        d: "M22 12.973c0 .345-.28.623-.597.623h-1.875a.625.625 0 0 1-.61-.485l-.144-.597-1.137 4.972c-.07.309-.328.472-.637.485a.622.622 0 0 1-.59-.54l-.854-5.887-.933 7.9a.636.636 0 0 1-.625.555.616.616 0 0 1-.614-.543L12 9.323l-1.381 10.134a.619.619 0 0 1-.62.542.627.627 0 0 1-.618-.553l-.937-7.902-.828 5.916a.625.625 0 0 1-.586.535c-.328 0-.57-.18-.64-.484l-1.137-4.998-.144.625a.624.624 0 0 1-.609.485H2.625a.63.63 0 0 1-.625-.65c0-.345.28-.627.597-.627h1.407l.637-2.89c.066-.252.32-.483.609-.483.29 0 .543.199.61.484l.992 4.381 1.03-7.325a.624.624 0 0 1 1.24.012l.921 7.81 1.34-9.823A.602.602 0 0 1 12 4.001c.284 0 .574.23.617.539l1.34 9.822.922-7.81a.624.624 0 0 1 1.238-.015l1.031 7.331.993-4.381c.065-.29.322-.514.609-.514.29.004.543.203.61.484l.636 2.89h1.38c.343.026.624.307.624.626Z",
        fill: "currentColor"
      }
    )
  })
);
var Waveform_default = SvgWaveform;

// src/Icon/icons/WifiExclamation.tsx
import { jsx as jsx1413 } from "react/jsx-runtime";
var SvgWifiExclamation = (props) => /* @__PURE__ */ jsx1413(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1413(
      "path",
      {
        d: "M2.207 9.89c.283.3.76.313 1.06.027 1.7-1.615 3.987-2.692 6.484-3.102v-.941c0-.203.036-.395.086-.582-2.917.415-5.612 1.645-7.603 3.539a.748.748 0 0 0-.027 1.06Zm3.503 4.254a.75.75 0 0 0 1.06.022c.837-.803 1.856-1.413 2.981-1.716v-1.547c-1.519.369-2.903 1.106-4.02 2.182a.747.747 0 0 0-.021 1.06Zm8.542-3.241v1.547a7.236 7.236 0 0 1 2.981 1.718c.145.139.304.207.492.207a.75.75 0 0 0 .52-1.29c-1.09-1.076-2.474-1.813-3.993-2.182ZM21.77 8.83c-1.991-1.895-4.685-3.125-7.604-3.542.053.19.087.382.087.585v.941c2.496.41 4.785 1.486 6.486 3.103a.73.73 0 0 0 .487.207.745.745 0 0 0 .543-.234.724.724 0 0 0 .001-1.06Zm-9.767 7.545a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm0-1.75a1 1 0 0 0 1-1V6.123a1 1 0 1 0-2 0v7.501a1 1 0 0 0 1 1Z",
        fill: "currentColor"
      }
    )
  })
);
var WifiExclamation_default = SvgWifiExclamation;

// src/Icon/icons/WifiFair.tsx
import { jsx as jsx1414 } from "react/jsx-runtime";
var SvgWifiFair = (props) => /* @__PURE__ */ jsx1414(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1414(
      "path",
      {
        d: "M11.96 13.154c-1.443 0-2.65 1.207-2.65 2.693s1.205 2.693 2.65 2.693c1.444 0 2.736-1.207 2.736-2.693s-1.207-2.693-2.736-2.693Zm9.69-3.91c-2.535-2.442-5.964-3.784-9.647-3.784-3.684 0-7.113 1.343-9.647 3.784a1.153 1.153 0 1 0 1.598 1.664c2.105-2.024 4.961-3.14 8.049-3.14 3.087 0 5.944 1.115 8.05 3.14.221.217.466.323.755.323.302 0 .605-.12.832-.355.486-.458.471-1.19.01-1.632Z",
        fill: "currentColor"
      }
    )
  })
);
var WifiFair_default = SvgWifiFair;

// src/Icon/icons/WifiMac.tsx
import { jsx as jsx1415 } from "react/jsx-runtime";
var SvgWifiMac = (props) => /* @__PURE__ */ jsx1415(
  "svg",
  __spreadProps(__spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1415(
      "path",
      {
        d: "M3.313 10.739 2.114 9.39a.425.425 0 0 1-.026-.549C4.121 6.051 7.977 4 11.998 4c4.03 0 7.87 2.05 9.91 4.842a.415.415 0 0 1-.025.55l-1.199 1.328c-.174.182-.408.192-.565.019C18 8.226 15.17 6.889 12 6.889c-3.153 0-5.968 1.328-8.104 3.84-.165.193-.408.193-.582.01Zm3.604 4.024L5.571 13.27c-.148-.174-.156-.366-.026-.54 1.312-1.78 3.744-3.118 6.453-3.118 2.71 0 5.142 1.338 6.454 3.119a.41.41 0 0 1-.026.539l-1.346 1.482c-.192.193-.409.203-.565 0-1.06-1.28-2.762-2.243-4.517-2.233-1.737-.01-3.44.924-4.481 2.204-.174.212-.409.241-.6.039ZM11.998 20c-.19 0-.356-.106-.694-.462l-2.111-2.253c-.139-.144-.174-.317-.087-.471.565-.838 1.633-1.57 2.892-1.57 1.225 0 2.293.703 2.858 1.512a.419.419 0 0 1-.043.53l-2.12 2.252c-.338.366-.503.462-.695.462Z",
        fill: "currentColor"
      }
    )
  })
);
var WifiMac_default = SvgWifiMac;

// src/Icon/icons/WifiSlash.tsx
import { jsx as jsx1416 } from "react/jsx-runtime";
var SvgWifiSlash = (props) => /* @__PURE__ */ jsx1416(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1416(
      "path",
      {
        d: "M5.736 12.96a.75.75 0 1 0 1.04 1.082c.64-.64 1.455-1.14 2.315-1.485l-1.33-1.042a8.601 8.601 0 0 0-2.025 1.446ZM2.234 8.703A.75.75 0 1 0 3.269 9.79c.348-.331.728-.631 1.122-.916L3.16 7.91c-.323.25-.634.513-.927.792Zm9.752 6.775c-.939 0-1.725.813-1.725 1.78a1.753 1.753 0 0 0 3.505 0c0-.967-.785-1.78-1.78-1.78Zm1.399-3.358c1.473.253 2.815.912 3.868 1.924.143.141.303.21.49.21a.75.75 0 0 0 .521-1.293c-1.622-1.589-3.853-2.462-6.25-2.462-.217 0-.427.03-.641.045l-4.084-3.2a13.544 13.544 0 0 1 4.725-.85c3.355 0 6.54 1.201 8.747 3.298a.734.734 0 0 0 .488.206.75.75 0 0 0 .518-1.295c-2.452-2.36-6.017-3.712-9.781-3.712-2.119 0-4.2.457-6.059 1.285L3.214 4.15a.75.75 0 1 0-.926 1.182l18.526 14.52c.137.107.3.16.435.16a.751.751 0 0 0 .464-1.342l-8.328-6.55Z",
        fill: "currentColor"
      }
    )
  })
);
var WifiSlash_default = SvgWifiSlash;

// src/Icon/icons/WifiWeak.tsx
import { jsx as jsx1417 } from "react/jsx-runtime";
var SvgWifiWeak = (props) => /* @__PURE__ */ jsx1417(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1417(
      "path",
      {
        d: "M12 2.08c-5.523 0-10 4.477-10 9.84 0 5.362 4.477 10 9.84 10 5.362 0 10.16-4.322 10.16-9.84s-4.482-10-10-10Z",
        fill: "currentColor"
      }
    )
  })
);
var WifiWeak_default = SvgWifiWeak;

// src/Icon/icons/Wifi.tsx
import { jsx as jsx1418 } from "react/jsx-runtime";
var SvgWifi = (props) => /* @__PURE__ */ jsx1418(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1418(
      "path",
      {
        d: "M11.974 15.473c-.938 0-1.723.812-1.723 1.778s.784 1.75 1.723 1.75c.938 0 1.778-.784 1.778-1.75s-.784-1.779-1.778-1.779Zm9.795-6.767c-2.475-2.356-6.035-3.707-9.767-3.707-3.732 0-7.292 1.35-9.768 3.707a.749.749 0 1 0 1.034 1.086C5.44 7.699 8.65 6.499 12.001 6.499c3.35 0 6.532 1.2 8.736 3.294a.733.733 0 0 0 .487.207.745.745 0 0 0 .543-.234.724.724 0 0 0 .001-1.06Zm-9.767 1.79c-2.395 0-4.623.876-6.27 2.462a.75.75 0 1 0 1.039 1.083C8.139 12.725 9.995 12 12 12c2.007 0 3.864.725 5.233 2.041.144.14.303.21.49.21a.75.75 0 0 0 .52-1.292c-1.62-1.587-3.848-2.462-6.242-2.462Z",
        fill: "currentColor"
      }
    )
  })
);
var Wifi_default = SvgWifi;

// src/Icon/icons/WindowFlip.tsx
import { jsx as jsx1419 } from "react/jsx-runtime";
var SvgWindowFlip = (props) => /* @__PURE__ */ jsx1419(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1419(
      "path",
      {
        d: "M22 18.25c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75a2.5 2.5 0 0 1 2.5-2.5h15c1.379 0 2.5 1.12 2.5 2.5v12.5Zm-18.125 0c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625v-7.5H3.875v7.5ZM19.5 7c0-.691-.559-1.25-1.25-1.25S17 6.309 17 7s.559 1.25 1.25 1.25S19.5 7.691 19.5 7Zm-6.25 0c0 .691.559 1.25 1.25 1.25s1.25-.559 1.25-1.25-.559-1.25-1.25-1.25-1.25.559-1.25 1.25ZM12 7c0-.691-.559-1.25-1.25-1.25S9.5 6.309 9.5 7s.559 1.25 1.25 1.25S12 7.691 12 7Z",
        fill: "currentColor"
      }
    )
  })
);
var WindowFlip_default = SvgWindowFlip;

// src/Icon/icons/WindowFrameOpen.tsx
import { jsx as jsx1420 } from "react/jsx-runtime";
var SvgWindowFrameOpen = (props) => /* @__PURE__ */ jsx1420(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1420(
      "path",
      {
        d: "M21.063 20.125h-.313V14.5h-1.875v5.625H5.125V14.5H3.25v5.625h-.348a.922.922 0 0 0-.902.902c0 .485.42.973.902.973h18.16c.518 0 .938-.42.938-.902 0-.483-.418-.973-.938-.973ZM20.75 3.25c0-.688-.562-1.25-1.25-1.25h-15c-.688 0-1.25.562-1.25 1.25v9.375h17.5V3.25Zm-9.688 7.5H5.125V3.875h5.938v6.875Zm7.813 0h-5.938V3.875h5.938v6.875Z",
        fill: "currentColor"
      }
    )
  })
);
var WindowFrameOpen_default = SvgWindowFrameOpen;

// src/Icon/icons/WindowFrame.tsx
import { jsx as jsx1421 } from "react/jsx-runtime";
var SvgWindowFrame = (props) => /* @__PURE__ */ jsx1421(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1421(
      "path",
      {
        d: "M21.063 20.125h-.313V3.25c0-.688-.563-1.25-1.25-1.25h-15c-.688 0-1.25.563-1.25 1.25v16.875h-.348a.922.922 0 0 0-.902.902c0 .485.42.973.902.973h18.16c.518 0 .938-.42.938-.902 0-.483-.418-.973-.938-.973Zm-10 0H5.125v-7.5h5.938v7.5Zm0-9.375H5.125V3.875h5.938v6.875Zm7.812 9.375h-5.938v-7.5h5.938v7.5Zm0-9.375h-5.938V3.875h5.938v6.875Z",
        fill: "currentColor"
      }
    )
  })
);
var WindowFrame_default = SvgWindowFrame;

// src/Icon/icons/WindowMaximize.tsx
import { jsx as jsx1422 } from "react/jsx-runtime";
var SvgWindowMaximize = (props) => /* @__PURE__ */ jsx1422(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1422(
      "path",
      {
        d: "M2.302 4.558c.22-.405.55-.743.948-.974A2.482 2.482 0 0 1 4.5 3.25h15c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75a2.486 2.486 0 0 1 .302-1.192ZM3.875 18.25c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625v-7.5H3.875v7.5Z",
        fill: "currentColor"
      }
    )
  })
);
var WindowMaximize_default = SvgWindowMaximize;

// src/Icon/icons/WindowMinimize.tsx
import { jsx as jsx1423 } from "react/jsx-runtime";
var SvgWindowMinimize = (props) => /* @__PURE__ */ jsx1423(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1423(
      "path",
      {
        d: "M2 12c0-.52.42-.938.938-.938h18.125c.519 0 .937.418.937.938s-.418.938-.938.938H2.938A.937.937 0 0 1 2 12Z",
        fill: "currentColor"
      }
    )
  })
);
var WindowMinimize_default = SvgWindowMinimize;

// src/Icon/icons/WindowRestore.tsx
import { jsx as jsx1424 } from "react/jsx-runtime";
var SvgWindowRestore = (props) => /* @__PURE__ */ jsx1424(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1424(
      "path",
      {
        d: "M18.875 3.875h-8.75c-.691 0-1.25.56-1.25 1.25v.625H7v-.625A3.125 3.125 0 0 1 10.125 2h8.75C20.602 2 22 3.4 22 5.125v8.75A3.124 3.124 0 0 1 18.875 17h-.625v-1.875h.625c.691 0 1.25-.559 1.25-1.25v-8.75c0-.69-.559-1.25-1.25-1.25ZM14.5 7C15.879 7 17 8.121 17 9.5v10c0 1.379-1.121 2.5-2.5 2.5h-10C3.12 22 2 20.879 2 19.5v-10C2 8.121 3.12 7 4.5 7h10Zm-10 13.125h10a.627.627 0 0 0 .625-.625V12H3.875v7.5c0 .344.28.625.625.625Z",
        fill: "currentColor"
      }
    )
  })
);
var WindowRestore_default = SvgWindowRestore;

// src/Icon/icons/Window.tsx
import { jsx as jsx1425 } from "react/jsx-runtime";
var SvgWindow = (props) => /* @__PURE__ */ jsx1425(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1425(
      "path",
      {
        d: "M2 5.75a2.5 2.5 0 0 1 2.5-2.5h15c1.379 0 2.5 1.12 2.5 2.5v12.5c0 1.379-1.121 2.5-2.5 2.5h-15c-1.38 0-2.5-1.121-2.5-2.5V5.75Zm18.125 5H3.875v7.5c0 .344.28.625.625.625h15a.627.627 0 0 0 .625-.625v-7.5ZM5.75 8.25C6.441 8.25 7 7.691 7 7s-.559-1.25-1.25-1.25a1.25 1.25 0 1 0 0 2.5Zm3.75-2.5c-.691 0-1.25.559-1.25 1.25s.559 1.25 1.25 1.25 1.25-.559 1.25-1.25-.559-1.25-1.25-1.25Zm3.75 2.5c.691 0 1.25-.559 1.25-1.25s-.559-1.25-1.25-1.25S12 6.309 12 7s.559 1.25 1.25 1.25Z",
        fill: "currentColor"
      }
    )
  })
);
var Window_default = SvgWindow;

// src/Icon/icons/WindowsLogoCheck.tsx
import { jsx as jsx1426, jsxs as jsxs16 } from "react/jsx-runtime";
var SvgWindowsLogoCheck = (props) => /* @__PURE__ */ jsxs16(
  "svg",
  __spreadProps(__spreadValues({
    fill: "none",
    height: "42",
    viewBox: "0 0 42 42",
    width: "42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), {
    children: [
      /* @__PURE__ */ jsx1426("mask", { id: "svg-windows-logo-check-mask", fill: "#fff", children: /* @__PURE__ */ jsx1426(
        "path",
        {
          clipRule: "evenodd",
          d: "m22 42v-20h20v19c0 .553-.448 1-1 1zm15.5444-12.672c.6075-.4934.6075-1.3757 0-1.9214-.5062-.5421-1.4115-.5421-1.9713 0l-5.3773 5.2469-1.7557-1.7153c-.5581-.5399-1.4634-.5399-2.0215 0-.5581.5456-.5581 1.428 0 1.9214l2.7647 2.6963c.5599.5921 1.4651.5921 1.9714 0z",
          fill: "#fff",
          fillRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx1426(
        "path",
        {
          d: "m19 19h-18v-18h18zm22 0h-18v-18h18zm-40 22v-18h18v18z",
          stroke: "#35414e",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ jsxs16("g", { fill: "#35414e", children: [
        /* @__PURE__ */ jsx1426(
          "path",
          {
            clipRule: "evenodd",
            d: "m22 42v-20h20v19c0 .553-.448 1-1 1zm15.5444-12.672c.6075-.4934.6075-1.3757 0-1.9214-.5062-.5421-1.4115-.5421-1.9713 0l-5.3773 5.2469-1.7557-1.7153c-.5581-.5399-1.4634-.5399-2.0215 0-.5581.5456-.5581 1.428 0 1.9214l2.7647 2.6963c.5599.5921 1.4651.5921 1.9714 0z",
            fillRule: "evenodd"
          }
        ),
        /* @__PURE__ */ jsx1426(
          "path",
          {
            d: "m22 22v-2h-2v2zm0 20h-2v2h2zm20-20h2v-2h-2zm-4.4556 5.4066-1.4618 1.365.0599.0642.0654.0587zm0 1.9214-1.2609-1.5524-.0703.0571-.0648.0631zm-1.9713-1.9214-1.3914-1.4367-.0054.0053zm-5.3773 5.2469-1.3977 1.4306 1.3968 1.3646 1.3976-1.3637zm-1.7557-1.7153 1.3976-1.4306-.0071-.0069zm-2.0215 0-1.3905-1.4376-.0076.0074zm0 1.9214 1.3964-1.4318-.035-.0342-.0368-.0325zm2.7647 2.6963 1.4533-1.374-.0279-.0295-.029-.0283zm1.9714 0-1.396-1.4322-.0651.0634-.0591.0691zm-11.1547-13.5559v20h4v-20zm22-2h-20v4h20zm2 21v-19h-4v19zm-3 3c1.6553 0 3-1.3411 3-3h-4c0-.5529.4487-1 1-1zm-19 0h19v-4h-19zm14.2079-15.1055c-.1034-.0929-.2079-.2704-.2079-.5076 0-.2438.1134-.4732.2835-.6113l2.5218 3.1049c1.6399-1.332 1.5208-3.6636.0756-4.9618zm.7565-.0512c-.1102.1068-.2501.1567-.3856.1567-.1361 0-.3329-.0535-.4962-.2284l2.9236-2.7299c-1.3343-1.429-3.5306-1.3249-4.8245-.0718zm-5.3719 5.2417 5.3773-5.2469-2.7935-2.8629-5.3773 5.2468zm-4.5501-1.7163 1.7557 1.7154 2.7953-2.8612-1.7557-1.7153zm.7667.007c-.2171.2101-.5423.2102-.7596-.0001l2.7811-2.8749c-1.3334-1.2899-3.4691-1.2898-4.8025-.0001zm-.0659-1.0146c.3851.3404.2751.8101.0735 1.0072l-2.7962-2.8603c-1.3179 1.2884-1.4279 3.5228.0735 4.85zm2.8365 2.763-2.7647-2.6963-2.7928 2.8636 2.7647 2.6963zm-.9452.1321c.145-.1696.358-.2562.5546-.2562.1923 0 .351.0798.4475.1819l-2.9065 2.7481c1.3069 1.3823 3.6022 1.4959 4.9447-.0744zm6.5139-6.3604-6.3897 6.2279 2.7919 2.8645 6.3897-6.2279z",
            mask: "url(#svg-windows-logo-check-mask)"
          }
        )
      ] })
    ]
  })
);
var WindowsLogoCheck_default = SvgWindowsLogoCheck;

// src/Icon/icons/WrenchSimple.tsx
import { jsx as jsx1427 } from "react/jsx-runtime";
var SvgWrenchSimple = (props) => /* @__PURE__ */ jsx1427(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1427(
      "path",
      {
        d: "M15.437 22a.938.938 0 0 1-.938-.938v-6.398c0-.325.169-.626.444-.797 1.679-1.04 2.681-2.823 2.681-4.77a5.663 5.663 0 0 0-2.465-4.648V8.53c0 .224-.08.443-.228.613l-2.152 2.53c-.357.413-1.063.413-1.419 0l-2.224-2.53a1.018 1.018 0 0 1-.226-.613V4.448a5.578 5.578 0 0 0-2.465 4.648c0 1.949 1.002 3.73 2.68 4.77.276.17.444.472.444.797v6.399c-.034.516-.452.938-.972.938s-.902-.42-.902-.938v-5.894c-2.002-1.414-3.16-3.645-3.16-6.07a7.513 7.513 0 0 1 4.964-7.043.942.942 0 0 1 .855.118c.282.174.43.459.43.764v5.247l1.25 1.445 1.215-1.445V2.937c0-.306.148-.59.397-.766a.942.942 0 0 1 .855-.118 7.472 7.472 0 0 1 4.964 7.043 7.492 7.492 0 0 1-3.09 6.066v5.895c0 .521-.387.943-.938.943Z",
        fill: "currentColor"
      }
    )
  })
);
var WrenchSimple_default = SvgWrenchSimple;

// src/Icon/icons/Wrench.tsx
import { jsx as jsx1428 } from "react/jsx-runtime";
var SvgWrench = (props) => /* @__PURE__ */ jsx1428(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1428(
      "path",
      {
        d: "M21.823 6.576c-.082-.474-.483-.85-.957-.982-.473-.126-.98.005-1.293.352l-2.323 2.29-1.27-.211-.21-1.265 2.295-2.294c.342-.347.478-.855.346-1.324a1.382 1.382 0 0 0-.986-.962c-2.075-.512-4.183.083-5.726 1.592-1.469 1.47-2.055 3.57-1.591 5.597l-7.205 7.128c-.57.64-.902 1.445-.902 2.265 0 .82.332 1.66.902 2.265.57.606 1.446.973 2.266.973.854 0 1.66-.332 2.265-.937l7.163-7.16a5.993 5.993 0 0 0 5.605-1.601 6.006 6.006 0 0 0 1.621-5.726Zm-2.914 4.406a4.093 4.093 0 0 1-4.222.986l-.551-.186-7.956 7.953c-.498.503-1.377.503-1.84 0a1.3 1.3 0 0 1-.39-.938c0-.351.136-.688.39-.937l7.964-7.96-.18-.552c-.577-1.518-.237-3.147.9-4.25a4.121 4.121 0 0 1 2.894-1.221h.043l-2.2 2.242.591 3.535 3.535.59 2.24-2.235a4.173 4.173 0 0 1-1.218 2.973Zm-13.506 6.92c-.346 0-.59.28-.59.626s.279.625.59.625c.312 0 .59-.279.59-.625a.572.572 0 0 0-.59-.625Z",
        fill: "currentColor"
      }
    )
  })
);
var Wrench_default = SvgWrench;

// src/Icon/icons/XRay.tsx
import { jsx as jsx1429 } from "react/jsx-runtime";
var SvgXRay = (props) => /* @__PURE__ */ jsx1429(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1429(
      "path",
      {
        d: "M7 9.5h4.375v1.25H8.25a.627.627 0 0 0-.625.625c0 .344.281.625.625.625h3.125v1.25H8.668a1.25 1.25 0 0 0-1.04 1.943l.833 1.25c.23.35.621.557 1.039.557h4.965a1.25 1.25 0 0 0 1.04-.557l.833-1.25a1.227 1.227 0 0 0-1.006-1.943h-2.707V12h3.125a.627.627 0 0 0 .625-.625.627.627 0 0 0-.625-.625h-3.125V9.5H17a.627.627 0 0 0 .625-.625A.627.627 0 0 0 17 8.25h-4.375V7A.627.627 0 0 0 12 6.375a.627.627 0 0 0-.625.625v1.25H7a.627.627 0 0 0-.625.625c0 .344.281.625.625.625Zm2.813 6.25a.625.625 0 1 1 0-1.25.625.625 0 0 1 0 1.25Zm4.374-1.25a.625.625 0 1 1 0 1.25.625.625 0 0 1 0-1.25Zm6.876 4.375h-.313V5.125h.313a.937.937 0 1 0 0-1.875H2.938a.938.938 0 0 0 0 1.875h.312v13.75h-.313a.937.937 0 1 0 0 1.875h18.125a.937.937 0 1 0 0-1.875Zm-2.188 0H5.125V5.125h13.75v13.75Z",
        fill: "currentColor"
      }
    )
  })
);
var XRay_default = SvgXRay;

// src/Icon/icons/X.tsx
import { jsx as jsx1430 } from "react/jsx-runtime";
var SvgX = (props) => /* @__PURE__ */ jsx1430(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1430(
      "path",
      {
        d: "M20.32 20.241a1.071 1.071 0 1 1-1.642 1.377L12 13.666l-6.678 7.95a1.068 1.068 0 0 1-1.51.133 1.071 1.071 0 0 1-.132-1.51L10.602 12 3.68 3.761A1.071 1.071 0 0 1 5.32 2.383L12 10.335l6.678-7.95a1.07 1.07 0 1 1 1.64 1.378L13.397 12l6.924 8.241Z",
        fill: "currentColor"
      }
    )
  })
);
var X_default = SvgX;

// src/Icon/icons/XmarkLarge.tsx
import { jsx as jsx1431 } from "react/jsx-runtime";
var SvgXmarkLarge = (props) => /* @__PURE__ */ jsx1431(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1431(
      "path",
      {
        d: "m12.006 10.491 8.174-8.177c.42-.419 1.099-.419 1.478 0a1.012 1.012 0 0 1 0 1.516l-8.138 8.175 8.138 8.175c.456.42.456 1.099 0 1.478-.38.456-1.058.456-1.478 0l-8.174-8.138-8.176 8.138a1.012 1.012 0 0 1-1.516 0c-.419-.38-.419-1.058 0-1.478l8.177-8.175L2.314 3.83A1.072 1.072 0 0 1 3.83 2.314l8.176 8.177Z",
        fill: "currentColor"
      }
    )
  })
);
var XmarkLarge_default = SvgXmarkLarge;

// src/Icon/icons/Xmark.tsx
import { jsx as jsx1432 } from "react/jsx-runtime";
var SvgXmark = (props) => /* @__PURE__ */ jsx1432(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1432(
      "path",
      {
        d: "M21.483 19.446a1.496 1.496 0 0 1-2.116 2.116L12 14.142 4.583 21.56a1.496 1.496 0 0 1-2.116-2.116l7.42-7.416-7.422-7.474a1.496 1.496 0 0 1 2.116-2.116L12 9.915l7.418-7.418a1.496 1.496 0 0 1 2.116 2.115l-7.42 7.416 7.368 7.418Z",
        fill: "currentColor"
      }
    )
  })
);
var Xmark_default = SvgXmark;

// src/Icon/icons/XmarksLines.tsx
import { jsx as jsx1433 } from "react/jsx-runtime";
var SvgXmarksLines = (props) => /* @__PURE__ */ jsx1433(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1433(
      "path",
      {
        d: "M21.25 5a.75.75 0 1 1 0 1.5H2.75a.75.75 0 0 1 0-1.5h18.5Zm0 12.5c.416 0 .75.334.75.75s-.334.75-.75.75H2.75a.75.75 0 1 1 0-1.5h18.5ZM3.28 9.219 5 10.94l1.719-1.722c.293-.29.768-.29 1.034 0 .319.293.319.769 0 1.034L6.06 12l1.694 1.719c.319.293.319.769 0 1.034-.266.319-.74.319-1.034 0L5 13.06l-1.72 1.694a.708.708 0 0 1-1.06 0c-.293-.265-.293-.74 0-1.034L3.94 12l-1.72-1.747c-.293-.265-.293-.74 0-1.034a.754.754 0 0 1 1.06 0ZM12 10.94l1.719-1.722c.293-.29.769-.29 1.034 0 .319.293.319.769 0 1.034L13.06 12l1.694 1.719c.319.293.319.769 0 1.034-.265.319-.74.319-1.034 0L12 13.06l-1.747 1.694c-.265.319-.74.319-1.034 0-.29-.265-.29-.74 0-1.034L10.94 12l-1.722-1.747c-.29-.265-.29-.74 0-1.034.293-.29.769-.29 1.034 0L12 10.94Zm4.219-1.722c.293-.29.768-.29 1.034 0L19 10.94l1.719-1.722c.293-.29.768-.29 1.034 0 .319.293.319.769 0 1.034L20.06 12l1.694 1.719c.319.293.319.769 0 1.034-.265.319-.74.319-1.034 0L19 13.06l-1.747 1.694c-.265.319-.74.319-1.034 0-.29-.265-.29-.74 0-1.034L17.94 12l-1.722-1.747c-.29-.265-.29-.74 0-1.034Z",
        fill: "currentColor"
      }
    )
  })
);
var XmarksLines_default = SvgXmarksLines;

// src/Icon/icons/Y.tsx
import { jsx as jsx1434 } from "react/jsx-runtime";
var SvgY = (props) => /* @__PURE__ */ jsx1434(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1434(
      "path",
      {
        d: "m20.366 3.7-7.294 10.077v7.151a1.072 1.072 0 0 1-2.143 0v-7.151L3.633 3.7a1.07 1.07 0 1 1 1.735-1.257L12 11.603l6.634-9.16a1.073 1.073 0 0 1 1.495-.24c.478.348.585 1.018.237 1.497Z",
        fill: "currentColor"
      }
    )
  })
);
var Y_default = SvgY;

// src/Icon/icons/Z.tsx
import { jsx as jsx1435 } from "react/jsx-runtime";
var SvgZ = (props) => /* @__PURE__ */ jsx1435(
  "svg",
  __spreadProps(__spreadValues({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: /* @__PURE__ */ jsx1435(
      "path",
      {
        d: "M19.5 22h-15a1.07 1.07 0 0 1-.82-1.76L17.2 4.142H4.5A1.072 1.072 0 0 1 4.5 2h15a1.07 1.07 0 0 1 .82 1.76L6.8 19.858h12.7a1.072 1.072 0 0 1 0 2.143Z",
        fill: "currentColor"
      }
    )
  })
);
var Z_default = SvgZ;

// src/Icon/icons/Google.tsx
import { jsx as jsx1436, jsxs as jsxs17 } from "react/jsx-runtime";
var Google = (props) => /* @__PURE__ */ jsxs17(
  "svg",
  __spreadProps(__spreadValues({
    width: "32",
    height: "33",
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsx1436(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M31.3601 16.5724C31.3601 15.4381 31.2584 14.3466 31.0692 13.2998H16V19.489H24.6109C24.24 21.489 23.1126 23.1832 21.4183 24.3182V28.3324H26.5892C29.615 25.5466 31.3601 21.4449 31.3601 16.5724Z",
          fill: "#4285F4"
        }
      ),
      /* @__PURE__ */ jsx1436(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M16.0003 32.2091C20.3204 32.2091 23.9421 30.7765 26.5896 28.3325L21.4187 24.3182C19.9861 25.2782 18.1529 25.8457 16.0003 25.8457C11.8329 25.8457 8.30607 23.0314 7.04776 19.249H1.70197V23.3948C4.33452 28.624 9.7454 32.2091 16.0003 32.2091Z",
          fill: "#34A853"
        }
      ),
      /* @__PURE__ */ jsx1436(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M7.0475 19.2493C6.7275 18.2892 6.5458 17.2635 6.5458 16.2092C6.5458 15.155 6.7275 14.1292 7.0475 13.1692V9.02344H1.7017C0.618308 11.1834 0 13.6275 0 16.2092C0 18.7909 0.618308 21.235 1.7017 23.395L7.0475 19.2493Z",
          fill: "#FBBC05"
        }
      ),
      /* @__PURE__ */ jsx1436(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M16.0003 6.57241C18.3495 6.57241 20.4587 7.37987 22.117 8.96496L26.7062 4.37579C23.9346 1.79476 20.3129 0.208984 16.0003 0.208984C9.74607 0.208984 4.33452 3.79477 1.70197 9.02327L7.04775 13.1691C8.30607 9.38734 11.8335 6.57241 16.0003 6.57241Z",
          fill: "#EA4335"
        }
      )
    ]
  })
);
var Google_default = Google;

// src/Icon/icons/CustomSaml.tsx
import { jsx as jsx1437, jsxs as jsxs18 } from "react/jsx-runtime";
var CustomSaml = (props) => /* @__PURE__ */ jsxs18(
  "svg",
  __spreadProps(__spreadValues({
    width: "37",
    height: "34",
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsx1437(
        "path",
        {
          d: "M19.7637 7.43563C25.7637 7.1386 32.8924 18.7228 36.4568 24.2475C32.1202 13.4356 21.6053 2.62375 17.5657 0.0098877C13.8231 6.1881 11.0311 15.9307 10.6746 21.0396C11.9221 16.8218 13.7637 7.73266 19.7637 7.43563Z",
          fill: "#E91A1A"
        }
      ),
      /* @__PURE__ */ jsx1437(
        "path",
        {
          d: "M26.8432 27.4149C24.122 32.7706 10.5272 33.2071 3.96177 33.5581C15.5 35.1618 30.1057 31.4026 34.3803 29.1938C30.8756 22.8776 23.8049 15.6169 19.5471 12.7709C22.589 15.9479 29.5643 22.0592 26.8432 27.4149Z",
          fill: "#E91A1A"
        }
      ),
      /* @__PURE__ */ jsx1437(
        "path",
        {
          d: "M6.15554 23.5845C2.87857 18.5497 9.29949 6.55875 12.279 0.697836C5.11984 9.88751 1.07075 24.4155 0.845703 29.2218C8.06802 29.3456 17.8917 26.8538 22.4855 24.59C18.2131 25.6353 9.43252 28.6194 6.15554 23.5845Z",
          fill: "#E91A1A"
        }
      )
    ]
  })
);
var CustomSaml_default = CustomSaml;

// src/Icon/icons/AndroidLogo.tsx
import { jsx as jsx1438, jsxs as jsxs19 } from "react/jsx-runtime";
var SvgAndroidLogo = (props) => /* @__PURE__ */ jsxs19(
  "svg",
  __spreadProps(__spreadValues({
    width: 17,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    viewBox: "0 0 17 10"
  }, props), {
    children: [
      /* @__PURE__ */ jsxs19("g", { clipPath: "url(#android-logo_svg__a)", children: [
        /* @__PURE__ */ jsx1438(
          "mask",
          {
            id: "android-logo_svg__b",
            style: {
              maskType: "luminance"
            },
            maskUnits: "userSpaceOnUse",
            x: 0,
            y: 0,
            width: 17,
            height: 10,
            children: /* @__PURE__ */ jsx1438("path", { d: "M.97.62h15.05v8.77H.97V.62Z", fill: "#fff" })
          }
        ),
        /* @__PURE__ */ jsxs19("g", { mask: "url(#android-logo_svg__b)", children: [
          /* @__PURE__ */ jsx1438(
            "path",
            {
              d: "M15.977 9.06a7.57 7.57 0 0 0-.766-2.345 7.606 7.606 0 0 0-2.715-2.933l.009-.015.456-.787.445-.769.32-.552a.686.686 0 0 0-.005-.703.688.688 0 0 0-.77-.313.691.691 0 0 0-.421.321l-.32.552-.446.77-.456.786-.05.086-.068-.027a7.541 7.541 0 0 0-2.773-.493 7.545 7.545 0 0 0-2.671.515l-.047-.08-.456-.787-.445-.77a444.7 444.7 0 0 1-.32-.551.69.69 0 1 0-1.196.695l.32.552.445.769.456.787.003.006A7.605 7.605 0 0 0 1.78 6.716 7.545 7.545 0 0 0 .97 9.39h15.05a7.702 7.702 0 0 0-.043-.331h.001Z",
              fill: "#34A853"
            }
          ),
          /* @__PURE__ */ jsx1438(
            "path",
            {
              d: "M12.41 7.309c.3-.2.344-.665.097-1.037-.247-.372-.692-.51-.993-.31-.3.2-.345.665-.097 1.037.247.372.691.51.992.31Zm-6.825-.31c.248-.37.204-.835-.097-1.036-.301-.2-.746-.061-.993.31-.247.372-.203.836.098 1.037.3.2.745.062.992-.31Z",
              fill: "#202124"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ jsx1438("defs", { children: /* @__PURE__ */ jsx1438("clipPath", { id: "android-logo_svg__a", children: /* @__PURE__ */ jsx1438(
        "path",
        {
          fill: "#fff",
          transform: "translate(.925 .565)",
          d: "M0 0h15.15v8.871H0z"
        }
      ) }) })
    ]
  })
);
var AndroidLogo_default = SvgAndroidLogo;

// src/Icon/icons/AppleLogo.tsx
import { jsx as jsx1439, jsxs as jsxs20 } from "react/jsx-runtime";
var SvgAppleLogo = (props) => /* @__PURE__ */ jsxs20(
  "svg",
  __spreadProps(__spreadValues({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    role: "img"
  }, props), {
    children: [
      /* @__PURE__ */ jsx1439("g", { clipPath: "url(#apple-logo_svg__a)", children: /* @__PURE__ */ jsx1439(
        "path",
        {
          d: "M8.92 3.975c-.796 0-1.447.486-1.864.486-.443 0-1.02-.486-1.714-.486-1.32 0-2.654 1.121-2.654 3.172 0 1.282.49 2.633 1.105 3.503.523.737.983 1.33 1.645 1.33.651 0 .94-.422 1.752-.422.822 0 1.009.422 1.73.422.715 0 1.19-.657 1.645-1.303.502-.742.715-1.463.72-1.5-.042-.011-1.41-.572-1.41-2.137 0-1.356 1.074-1.965 1.138-2.013-.71-1.02-1.794-1.052-2.093-1.052Zm-.374-.866c.326-.395.555-.934.555-1.479 0-.075-.005-.15-.016-.208-.534.021-1.175.352-1.554.8-.304.343-.582.887-.582 1.432 0 .086.016.166.022.192.032.006.085.016.144.016.475 0 1.073-.32 1.431-.753Z",
          fill: "#1D1D1F"
        }
      ) }),
      /* @__PURE__ */ jsx1439("defs", { children: /* @__PURE__ */ jsx1439("clipPath", { id: "apple-logo_svg__a", children: /* @__PURE__ */ jsx1439(
        "path",
        {
          fill: "#fff",
          transform: "translate(2.688 1.422)",
          d: "M0 0h8.625v11.156H0z"
        }
      ) }) })
    ]
  })
);
var AppleLogo_default = SvgAppleLogo;

// src/Icon/icons/WindowsLogo.tsx
import { jsx as jsx1440, jsxs as jsxs21 } from "react/jsx-runtime";
var SvgWindowsLogo = (props) => /* @__PURE__ */ jsxs21(
  "svg",
  __spreadProps(__spreadValues({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    viewBox: "0 0 14 14"
  }, props), {
    children: [
      /* @__PURE__ */ jsx1440("g", { clipPath: "url(#windows-logo_svg__a)", children: /* @__PURE__ */ jsx1440(
        "path",
        {
          d: "M2.043 2.043h4.7v4.698h-4.7V2.043Zm5.214 0h4.7v4.698h-4.7V2.043ZM2.043 7.257h4.7v4.7h-4.7v-4.7Zm5.214 0h4.7v4.7h-4.7",
          fill: "#0078D4"
        }
      ) }),
      /* @__PURE__ */ jsx1440("defs", { children: /* @__PURE__ */ jsx1440("clipPath", { id: "windows-logo_svg__a", children: /* @__PURE__ */ jsx1440(
        "path",
        {
          fill: "#fff",
          transform: "translate(2.043 2.043)",
          d: "M0 0h9.914v9.914H0z"
        }
      ) }) })
    ]
  })
);
var WindowsLogo_default = SvgWindowsLogo;

// src/Icon/IconMap.ts
var IconMap = {
  "0": __default,
  "1": __default3,
  "2": __default4,
  "3": __default5,
  "4": __default6,
  "5": __default7,
  "6": __default8,
  "7": __default9,
  "8": __default10,
  "9": __default11,
  "00": __default2,
  a: A_default,
  "address-book": AddressBook_default,
  "address-card": AddressCard_default,
  "air-conditioner": AirConditioner_default,
  airplay: Airplay_default,
  "alarm-clock": AlarmClock_default,
  "alarm-exclamation": AlarmExclamation_default,
  "alarm-plus": AlarmPlus_default,
  "alarm-snooze": AlarmSnooze_default,
  "album-circle-plus": AlbumCirclePlus_default,
  "album-circle-user": AlbumCircleUser_default,
  "album-collection-circle-plus": AlbumCollectionCirclePlus_default,
  "album-collection-circle-user": AlbumCollectionCircleUser_default,
  "album-collection": AlbumCollection_default,
  album: Album_default,
  "align-center": AlignCenter_default,
  "align-justify": AlignJustify_default,
  "align-left": AlignLeft_default,
  "align-right": AlignRight_default,
  "align-slash": AlignSlash_default,
  alt: Alt_default,
  ampersand: Ampersand_default,
  "anchor-circle-check": AnchorCircleCheck_default,
  "anchor-circle-exclamation": AnchorCircleExclamation_default,
  "anchor-circle-xmark": AnchorCircleXmark_default,
  "anchor-lock": AnchorLock_default,
  anchor: Anchor_default,
  "angle-down": AngleDown_default,
  "angle-left": AngleLeft_default,
  "angle-right": AngleRight_default,
  "angle-up": AngleUp_default,
  angle: Angle_default,
  "angles-down": AnglesDown_default,
  "angles-left": AnglesLeft_default,
  "angles-right": AnglesRight_default,
  "angles-up": AnglesUp_default,
  apartment: Apartment_default,
  aperture: Aperture_default,
  "application-firewall": ApplicationFirewall_default,
  apps: Apps_default,
  "app-store": AppStore_default,
  "arrow-down-1-9": ArrowDown19_default,
  "arrow-down-9-1": ArrowDown91_default,
  "arrow-down-a-z": ArrowDownAZ_default,
  "arrow-down-arrow-up": ArrowDownArrowUp_default,
  "arrow-down-big-small": ArrowDownBigSmall_default,
  "arrow-down-from-dotted-line": ArrowDownFromDottedLine_default,
  "arrow-down-from-line": ArrowDownFromLine_default,
  "arrow-down-left-and-arrow-up-right-to-center": ArrowDownLeftAndArrowUpRightToCenter_default,
  "arrow-down-left": ArrowDownLeft_default,
  "arrow-down-long": ArrowDownLong_default,
  "arrow-down-right": ArrowDownRight_default,
  "arrow-down-short-wide": ArrowDownShortWide_default,
  "arrow-down-small-big": ArrowDownSmallBig_default,
  "arrow-down-square-triangle": ArrowDownSquareTriangle_default,
  "arrow-down-to-arc": ArrowDownToArc_default,
  "arrow-down-to-bracket": ArrowDownToBracket_default,
  "arrow-down-to-dotted-line": ArrowDownToDottedLine_default,
  "arrow-down-to-line": ArrowDownToLine_default,
  "arrow-down-to-square": ArrowDownToSquare_default,
  "arrow-down-triangle-square": ArrowDownTriangleSquare_default,
  "arrow-down-up-across-line": ArrowDownUpAcrossLine_default,
  "arrow-down-up-lock": ArrowDownUpLock_default,
  "arrow-down-wide-short": ArrowDownWideShort_default,
  "arrow-down-z-a": ArrowDownZA_default,
  "arrow-down": ArrowDown_default,
  "arrow-left-from-line": ArrowLeftFromLine_default,
  "arrow-left-long-to-line": ArrowLeftLongToLine_default,
  "arrow-left-long": ArrowLeftLong_default,
  "arrow-left-to-line": ArrowLeftToLine_default,
  "arrow-left": ArrowLeft_default,
  "arrow-pointer": ArrowPointer_default,
  "arrow-right-arrow-left": ArrowRightArrowLeft_default,
  "arrow-right-from-arc": ArrowRightFromArc_default,
  "arrow-right-from-bracket": ArrowRightFromBracket_default,
  "arrow-right-from-line": ArrowRightFromLine_default,
  "arrow-right-long-to-line": ArrowRightLongToLine_default,
  "arrow-right-long": ArrowRightLong_default,
  "arrow-right-to-arc": ArrowRightToArc_default,
  "arrow-right-to-bracket": ArrowRightToBracket_default,
  "arrow-right-to-city": ArrowRightToCity_default,
  "arrow-right-to-line": ArrowRightToLine_default,
  "arrow-right": ArrowRight_default,
  "arrow-rotate-left": ArrowRotateLeft_default,
  "arrow-rotate-right": ArrowRotateRight_default,
  "arrow-trend-down": ArrowTrendDown_default,
  "arrow-trend-up": ArrowTrendUp_default,
  "arrow-turn-down-left": ArrowTurnDownLeft_default,
  "arrow-turn-down-right": ArrowTurnDownRight_default,
  "arrow-turn-down": ArrowTurnDown_default,
  "arrow-turn-up": ArrowTurnUp_default,
  "arrow-up-1-9": ArrowUp19_default,
  "arrow-up-9-1": ArrowUp91_default,
  "arrow-up-a-z": ArrowUpAZ_default,
  "arrow-up-arrow-down": ArrowUpArrowDown_default,
  "arrow-up-big-small": ArrowUpBigSmall_default,
  "arrow-up-from-arc": ArrowUpFromArc_default,
  "arrow-up-from-bracket": ArrowUpFromBracket_default,
  "arrow-up-from-dotted-line": ArrowUpFromDottedLine_default,
  "arrow-up-from-ground-water": ArrowUpFromGroundWater_default,
  "arrow-up-from-line": ArrowUpFromLine_default,
  "arrow-up-from-square": ArrowUpFromSquare_default,
  "arrow-up-from-water-pump": ArrowUpFromWaterPump_default,
  "arrow-up-left-from-circle": ArrowUpLeftFromCircle_default,
  "arrow-up-left": ArrowUpLeft_default,
  "arrow-up-long": ArrowUpLong_default,
  "arrow-up-right-and-arrow-down-left-from-center": ArrowUpRightAndArrowDownLeftFromCenter_default,
  "arrow-up-right-dots": ArrowUpRightDots_default,
  "arrow-up-right-from-square": ArrowUpRightFromSquare_default,
  "arrow-up-right": ArrowUpRight_default,
  "arrow-up-short-wide": ArrowUpShortWide_default,
  "arrow-up-small-big": ArrowUpSmallBig_default,
  "arrow-up-square-triangle": ArrowUpSquareTriangle_default,
  "arrow-up-to-dotted-line": ArrowUpToDottedLine_default,
  "arrow-up-to-line": ArrowUpToLine_default,
  "arrow-up-triangle-square": ArrowUpTriangleSquare_default,
  "arrow-up-wide-short": ArrowUpWideShort_default,
  "arrow-up-z-a": ArrowUpZA_default,
  "arrow-up": ArrowUp_default,
  "arrows-cross": ArrowsCross_default,
  "arrows-down-to-line": ArrowsDownToLine_default,
  "arrows-down-to-people": ArrowsDownToPeople_default,
  "arrows-from-dotted-line": ArrowsFromDottedLine_default,
  "arrows-from-line": ArrowsFromLine_default,
  "arrows-left-right-to-line": ArrowsLeftRightToLine_default,
  "arrows-left-right": ArrowsLeftRight_default,
  "arrows-maximize": ArrowsMaximize_default,
  "arrows-minimize": ArrowsMinimize_default,
  "arrows-repeat-1": ArrowsRepeat1_default,
  "arrows-repeat": ArrowsRepeat_default,
  "arrows-retweet": ArrowsRetweet_default,
  "arrows-rotate": ArrowsRotate_default,
  "arrows-spin": ArrowsSpin_default,
  "arrows-split-up-and-left": ArrowsSplitUpAndLeft_default,
  "arrows-to-circle": ArrowsToCircle_default,
  "arrows-to-dot": ArrowsToDot_default,
  "arrows-to-dotted-line": ArrowsToDottedLine_default,
  "arrows-to-eye": ArrowsToEye_default,
  "arrows-to-line": ArrowsToLine_default,
  "arrows-turn-right": ArrowsTurnRight_default,
  "arrows-turn-to-dots": ArrowsTurnToDots_default,
  "arrows-up-down-left-right": ArrowsUpDownLeftRight_default,
  "arrows-up-down": ArrowsUpDown_default,
  "arrows-up-to-line": ArrowsUpToLine_default,
  asterisk: Asterisk_default,
  at: At_default,
  "atom-simple": AtomSimple_default,
  atom: Atom_default,
  "austral-sign": AustralSign_default,
  "award-simple": AwardSimple_default,
  award: Award_default,
  axe: Axe_default,
  b: B_default,
  backpack: Backpack_default,
  "backward-fast": BackwardFast_default,
  "backward-step": BackwardStep_default,
  backward: Backward_default,
  bacteria: Bacteria_default,
  bacterium: Bacterium_default,
  "badge-check": BadgeCheck_default,
  "badge-dollar": BadgeDollar_default,
  "badge-percent": BadgePercent_default,
  badge: Badge_default,
  ban: Ban_default,
  bandage: Bandage_default,
  "barcode-read": BarcodeRead_default,
  "barcode-scan": BarcodeScan_default,
  barcode: Barcode_default,
  "bars-filter": BarsFilter_default,
  "bars-progress": BarsProgress_default,
  "bars-sort": BarsSort_default,
  "bars-staggered": BarsStaggered_default,
  bars: Bars_default,
  baseball: Baseball_default,
  "basket-shopping-simple": BasketShoppingSimple_default,
  "basket-shopping": BasketShopping_default,
  "battery-bolt": BatteryBolt_default,
  "battery-empty": BatteryEmpty_default,
  "battery-exclamation": BatteryExclamation_default,
  "battery-full": BatteryFull_default,
  "battery-half": BatteryHalf_default,
  "battery-low": BatteryLow_default,
  "battery-quarter": BatteryQuarter_default,
  "battery-slash": BatterySlash_default,
  "battery-three-quarters": BatteryThreeQuarters_default,
  bee: Bee_default,
  "bell-concierge": BellConcierge_default,
  "bell-exclamation": BellExclamation_default,
  "bell-on": BellOn_default,
  "bell-plus": BellPlus_default,
  "bell-school-slash": BellSchoolSlash_default,
  "bell-school": BellSchool_default,
  "bell-slash": BellSlash_default,
  bell: Bell_default,
  bells: Bells_default,
  "binary-circle-check": BinaryCircleCheck_default,
  "binary-lock": BinaryLock_default,
  "binary-slash": BinarySlash_default,
  binary: Binary_default,
  binoculars: Binoculars_default,
  "blanket-fire": BlanketFire_default,
  blanket: Blanket_default,
  "block-brick-fire": BlockBrickFire_default,
  "block-brick": BlockBrick_default,
  "block-question": BlockQuestion_default,
  "block-quote": BlockQuote_default,
  block: Block_default,
  bluetooth: Bluetooth_default,
  bold: Bold_default,
  "bolt-auto": BoltAuto_default,
  "bolt-lightning": BoltLightning_default,
  "bolt-slash": BoltSlash_default,
  bolt: Bolt_default,
  "book-arrow-right": BookArrowRight_default,
  "book-arrow-up": BookArrowUp_default,
  "book-atlas": BookAtlas_default,
  "book-blank": BookBlank_default,
  "book-bookmark": BookBookmark_default,
  "book-circle-arrow-right": BookCircleArrowRight_default,
  "book-circle-arrow-up": BookCircleArrowUp_default,
  "book-copy": BookCopy_default,
  "book-font": BookFont_default,
  "book-open-cover": BookOpenCover_default,
  "book-open-reader": BookOpenReader_default,
  "book-open": BookOpen_default,
  "book-user": BookUser_default,
  book: Book_default,
  "bookmark-slash": BookmarkSlash_default,
  bookmark: Bookmark_default,
  books: Books_default,
  "border-all": BorderAll_default,
  "border-bottom-right": BorderBottomRight_default,
  "border-bottom": BorderBottom_default,
  "border-center-h": BorderCenterH_default,
  "border-center-v": BorderCenterV_default,
  "border-inner": BorderInner_default,
  "border-left": BorderLeft_default,
  "border-none": BorderNone_default,
  "border-outer": BorderOuter_default,
  "border-right": BorderRight_default,
  "border-top-left": BorderTopLeft_default,
  "border-top": BorderTop_default,
  "box-archive": BoxArchive_default,
  "box-ballot": BoxBallot_default,
  "box-check": BoxCheck_default,
  "box-circle-check": BoxCircleCheck_default,
  "box-dollar": BoxDollar_default,
  "box-open-full": BoxOpenFull_default,
  "box-open": BoxOpen_default,
  "box-taped": BoxTaped_default,
  "box-tissue": BoxTissue_default,
  box: Box_default,
  "boxes-packing": BoxesPacking_default,
  "boxes-stacked": BoxesStacked_default,
  "bracket-curly-right": BracketCurlyRight_default,
  "bracket-curly": BracketCurly_default,
  "bracket-round-right": BracketRoundRight_default,
  "bracket-round": BracketRound_default,
  "bracket-square-right": BracketSquareRight_default,
  "bracket-square": BracketSquare_default,
  "brackets-curly": BracketsCurly_default,
  "brackets-round": BracketsRound_default,
  "brackets-square": BracketsSquare_default,
  "brain-arrow-curved-right": BrainArrowCurvedRight_default,
  "brain-circuit": BrainCircuit_default,
  brain: Brain_default,
  "briefcase-blank": BriefcaseBlank_default,
  briefcase: Briefcase_default,
  "brightness-low": BrightnessLow_default,
  brightness: Brightness_default,
  "bring-forward": BringForward_default,
  "bring-front": BringFront_default,
  broom: Broom_default,
  browser: Browser_default,
  browsers: Browsers_default,
  brush: Brush_default,
  bucket: Bucket_default,
  "bug-slash": BugSlash_default,
  bug: Bug_default,
  bugs: Bugs_default,
  "building-circle-arrow-right": BuildingCircleArrowRight_default,
  "building-circle-check": BuildingCircleCheck_default,
  "building-circle-exclamation": BuildingCircleExclamation_default,
  "building-circle-xmark": BuildingCircleXmark_default,
  "building-columns": BuildingColumns_default,
  building: Building_default,
  buildings: Buildings_default,
  bullhorn: Bullhorn_default,
  "bullseye-arrow": BullseyeArrow_default,
  "bullseye-pointer": BullseyePointer_default,
  bullseye: Bullseye_default,
  burst: Burst_default,
  "business-time": BusinessTime_default,
  c: C_default,
  "cabinet-filing": CabinetFiling_default,
  "calculator-simple": CalculatorSimple_default,
  calculator: Calculator_default,
  "calendar-arrow-down": CalendarArrowDown_default,
  "calendar-arrow-up": CalendarArrowUp_default,
  "calendar-check": CalendarCheck_default,
  "calendar-circle-exclamation": CalendarCircleExclamation_default,
  "calendar-circle-minus": CalendarCircleMinus_default,
  "calendar-circle-plus": CalendarCirclePlus_default,
  "calendar-circle-user": CalendarCircleUser_default,
  "calendar-clock": CalendarClock_default,
  "calendar-day": CalendarDay_default,
  "calendar-days": CalendarDays_default,
  "calendar-exclamation": CalendarExclamation_default,
  "calendar-image": CalendarImage_default,
  "calendar-lines-pen": CalendarLinesPen_default,
  "calendar-lines": CalendarLines_default,
  "calendar-minus": CalendarMinus_default,
  "calendar-pen": CalendarPen_default,
  "calendar-plus": CalendarPlus_default,
  "calendar-range": CalendarRange_default,
  "calendar-star": CalendarStar_default,
  "calendar-week": CalendarWeek_default,
  "calendar-xmark": CalendarXmark_default,
  calendar: Calendar_default,
  calendars: Calendars_default,
  camcorder: Camcorder_default,
  "camera-cctv": CameraCctv_default,
  "camera-slash": CameraSlash_default,
  "camera-viewfinder": CameraViewfinder_default,
  "camera-web-slash": CameraWebSlash_default,
  "camera-web": CameraWeb_default,
  "caret-left": CaretLeft_default,
  "caret-right": CaretRight_default,
  "caret-up": CaretUp_default,
  cellular: Cellular_default,
  certificate: Certificate_default,
  certificates: Certificates_default,
  "chair-office": ChairOffice_default,
  chair: Chair_default,
  "chalkboard-user": ChalkboardUser_default,
  chalkboard: Chalkboard_default,
  "chart-area": ChartArea_default,
  "chart-bar": ChartBar_default,
  "chart-bullet": ChartBullet_default,
  "chart-candlestick": ChartCandlestick_default,
  "chart-column": ChartColumn_default,
  "chart-gantt": ChartGantt_default,
  "chart-line-down": ChartLineDown_default,
  "chart-line-up": ChartLineUp_default,
  "chart-line": ChartLine_default,
  "chart-mixed": ChartMixed_default,
  "chart-network": ChartNetwork_default,
  "chart-pie-simple": ChartPieSimple_default,
  "chart-pie": ChartPie_default,
  "chart-pyramid": ChartPyramid_default,
  "chart-radar": ChartRadar_default,
  "chart-scatter-3d": ChartScatter3D_default,
  "chart-scatter-bubble": ChartScatterBubble_default,
  "chart-scatter": ChartScatter_default,
  "chart-simple-horizontal": ChartSimpleHorizontal_default,
  "chart-simple": ChartSimple_default,
  "chart-tree-map": ChartTreeMap_default,
  "chart-user": ChartUser_default,
  "chart-waterfall": ChartWaterfall_default,
  "check-double": CheckDouble_default,
  "check-to-slot": CheckToSlot_default,
  check: Check_default,
  "check-circle": CheckCircle_default,
  "chevron-left": ChevronLeft_default,
  "chevron-right": ChevronRight_default,
  "chevron-up": ChevronUp_default,
  "chevrons-down": ChevronsDown_default,
  "chevrons-left": ChevronsLeft_default,
  "chevrons-right": ChevronsRight_default,
  "chevrons-up": ChevronsUp_default,
  "chevrons-up-down": ChevronsUpDown_default,
  "chrome-extensions": ChromeExtensions_default,
  "circle-0": Circle0_default,
  "circle-1": Circle1_default,
  "circle-2": Circle2_default,
  "circle-3": Circle3_default,
  "circle-4": Circle4_default,
  "circle-5": Circle5_default,
  "circle-6": Circle6_default,
  "circle-7": Circle7_default,
  "circle-8": Circle8_default,
  "circle-9": Circle9_default,
  "circle-a": CircleA_default,
  "circle-ampersand": CircleAmpersand_default,
  "circle-arrow-down-left": CircleArrowDownLeft_default,
  "circle-arrow-down-right": CircleArrowDownRight_default,
  "circle-arrow-down": CircleArrowDown_default,
  "circle-arrow-left": CircleArrowLeft_default,
  "circle-arrow-right": CircleArrowRight_default,
  "circle-arrow-up-left": CircleArrowUpLeft_default,
  "circle-arrow-up-right": CircleArrowUpRight_default,
  "circle-arrow-up": CircleArrowUp_default,
  "circle-b": CircleB_default,
  "circle-bolt": CircleBolt_default,
  "circle-book-open": CircleBookOpen_default,
  "circle-bookmark": CircleBookmark_default,
  "circle-c": CircleC_default,
  "circle-calendar": CircleCalendar_default,
  "circle-camera": CircleCamera_default,
  "circle-caret-down": CircleCaretDown_default,
  "circle-caret-left": CircleCaretLeft_default,
  "circle-caret-right": CircleCaretRight_default,
  "circle-caret-up": CircleCaretUp_default,
  "circle-check": CircleCheck_default,
  "circle-chevron-down": CircleChevronDown_default,
  "circle-chevron-left": CircleChevronLeft_default,
  "circle-chevron-right": CircleChevronRight_default,
  "circle-chevron-up": CircleChevronUp_default,
  "circle-d": CircleD_default,
  "circle-dashed": CircleDashed_default,
  "circle-divide": CircleDivide_default,
  "circle-dollar-to-slot": CircleDollarToSlot_default,
  "circle-dollar": CircleDollar_default,
  "circle-dot": CircleDot_default,
  "circle-down-left": CircleDownLeft_default,
  "circle-down-right": CircleDownRight_default,
  "circle-down": CircleDown_default,
  "circle-e": CircleE_default,
  "circle-ellipsis-vertical": CircleEllipsisVertical_default,
  "circle-ellipsis": CircleEllipsis_default,
  "circle-envelope": CircleEnvelope_default,
  "circle-exclamation-check": CircleExclamationCheck_default,
  "circle-exclamation": CircleExclamation_default,
  "circle-f": CircleF_default,
  "circle-g": CircleG_default,
  "circle-h": CircleH_default,
  "circle-half-stroke": CircleHalfStroke_default,
  "circle-half": CircleHalf_default,
  "circle-i": CircleI_default,
  "circle-info": CircleInfo_default,
  "circle-j": CircleJ_default,
  "circle-k": CircleK_default,
  "circle-l": CircleL_default,
  "circle-left": CircleLeft_default,
  "circle-location-arrow": CircleLocationArrow_default,
  "circle-m": CircleM_default,
  "circle-microphone-lines": CircleMicrophoneLines_default,
  "circle-microphone": CircleMicrophone_default,
  "circle-minus": CircleMinus_default,
  "circle-n": CircleN_default,
  "circle-nodes": CircleNodes_default,
  "circle-notch": CircleNotch_default,
  "circle-o": CircleO_default,
  "circle-p": CircleP_default,
  "circle-pause": CirclePause_default,
  "circle-phone-flip": CirclePhoneFlip_default,
  "circle-phone-hangup": CirclePhoneHangup_default,
  "circle-phone": CirclePhone_default,
  "circle-play": CirclePlay_default,
  "circle-plus": CirclePlus_default,
  "circle-q": CircleQ_default,
  "circle-quarter": CircleQuarter_default,
  "circle-quarters": CircleQuarters_default,
  "circle-question": CircleQuestion_default,
  "circle-r": CircleR_default,
  "circle-radiation": CircleRadiation_default,
  "circle-right": CircleRight_default,
  "circle-s": CircleS_default,
  "circle-small": CircleSmall_default,
  "circle-sort-down": CircleSortDown_default,
  "circle-sort-up": CircleSortUp_default,
  "circle-sort": CircleSort_default,
  "circle-star": CircleStar_default,
  "circle-stop": CircleStop_default,
  "circle-t": CircleT_default,
  "circle-three-quarters": CircleThreeQuarters_default,
  "circle-trash": CircleTrash_default,
  "circle-u": CircleU_default,
  "circle-up-left": CircleUpLeft_default,
  "circle-up-right": CircleUpRight_default,
  "circle-up": CircleUp_default,
  "circle-user": CircleUser_default,
  "circle-v": CircleV_default,
  "circle-video": CircleVideo_default,
  "circle-w": CircleW_default,
  "circle-waveform-lines": CircleWaveformLines_default,
  "circle-x": CircleX_default,
  "circle-xmark": CircleXmark_default,
  "circle-y": CircleY_default,
  "circle-z": CircleZ_default,
  circle: Circle_default,
  "clipboard-check": ClipboardCheck_default,
  "clipboard-list-check": ClipboardListCheck_default,
  "clipboard-list": ClipboardList_default,
  "clipboard-question": ClipboardQuestion_default,
  "clipboard-user": ClipboardUser_default,
  clipboard: Clipboard_default,
  "clock-eight-thirty": ClockEightThirty_default,
  "clock-eight": ClockEight_default,
  "clock-eleven-thirty": ClockElevenThirty_default,
  "clock-eleven": ClockEleven_default,
  "clock-five-thirty": ClockFiveThirty_default,
  "clock-five": ClockFive_default,
  "clock-four-thirty": ClockFourThirty_default,
  "clock-nine-thirty": ClockNineThirty_default,
  "clock-nine": ClockNine_default,
  "clock-one-thirty": ClockOneThirty_default,
  "clock-one": ClockOne_default,
  "clock-rotate-left": ClockRotateLeft_default,
  "clock-seven-thirty": ClockSevenThirty_default,
  "clock-seven": ClockSeven_default,
  "clock-six-thirty": ClockSixThirty_default,
  "clock-six": ClockSix_default,
  "clock-ten-thirty": ClockTenThirty_default,
  "clock-ten": ClockTen_default,
  "clock-three-thirty": ClockThreeThirty_default,
  "clock-three": ClockThree_default,
  "clock-twelve-thirty": ClockTwelveThirty_default,
  "clock-twelve": ClockTwelve_default,
  "clock-two-thirty": ClockTwoThirty_default,
  "clock-two": ClockTwo_default,
  clock: Clock_default,
  clone: Clone_default,
  "cloud-arrow-down": CloudArrowDown_default,
  "cloud-arrow-up": CloudArrowUp_default,
  "cloud-check": CloudCheck_default,
  "cloud-exclamation": CloudExclamation_default,
  "cloud-minus": CloudMinus_default,
  "cloud-plus": CloudPlus_default,
  "cloud-slash": CloudSlash_default,
  "cloud-xmark": CloudXmark_default,
  cloud: Cloud_default,
  "code-branch": CodeBranch_default,
  "code-simple": CodeSimple_default,
  code: Code_default,
  "columns-3": Columns3_default,
  command: Command_default,
  "comments-question": CommentsQuestion_default,
  comments: Comments_default,
  "compress-wide": CompressWide_default,
  compress: Compress_default,
  "computer-speaker": ComputerSpeaker_default,
  computer: Computer_default,
  "container-storage": ContainerStorage_default,
  "conveyor-belt-boxes": ConveyorBeltBoxes_default,
  "conveyor-belt-empty": ConveyorBeltEmpty_default,
  "conveyor-belt": ConveyorBelt_default,
  cookie: Cookie_default,
  copy: Copy_default,
  copyright: Copyright_default,
  "credit-card-blank": CreditCardBlank_default,
  "credit-card-front": CreditCardFront_default,
  "credit-card": CreditCard_default,
  "crop-simple": CropSimple_default,
  crop: Crop_default,
  "crosshairs-simple": CrosshairsSimple_default,
  crosshairs: Crosshairs_default,
  cube: Cube_default,
  "cubes-stacked": CubesStacked_default,
  cubes: Cubes_default,
  d: D_default,
  dash: Dash_default,
  database: Database_default,
  "delete-left": DeleteLeft_default,
  "delete-right": DeleteRight_default,
  "desktop-arrow-down": DesktopArrowDown_default,
  desktop: Desktop_default,
  devices: Devices_default,
  "device-mac": DeviceMac_default,
  "device-iphone": DeviceIphone_default,
  "device-ipad": DeviceIpad_default,
  "device-apple-tv": DeviceAppleTv_default,
  "device-vision": DeviceVision_default,
  "desktop-and-screensaver": DesktopAndScreensaver_default,
  "diagram-cells": DiagramCells_default,
  "diagram-lean-canvas": DiagramLeanCanvas_default,
  "diagram-nested": DiagramNested_default,
  "diagram-next": DiagramNext_default,
  "diagram-predecessor": DiagramPredecessor_default,
  "diagram-previous": DiagramPrevious_default,
  "diagram-project": DiagramProject_default,
  "diagram-sankey": DiagramSankey_default,
  "diagram-subtask": DiagramSubtask_default,
  "diagram-successor": DiagramSuccessor_default,
  "diagram-venn": DiagramVenn_default,
  "dial-high": DialHigh_default,
  "dial-low": DialLow_default,
  "dial-max": DialMax_default,
  "dial-med-low": DialMedLow_default,
  "dial-med": DialMed_default,
  "dial-min": DialMin_default,
  "dial-off": DialOff_default,
  dial: Dial_default,
  "diamond-exclamation": DiamondExclamation_default,
  "diamond-half-stroke": DiamondHalfStroke_default,
  "diamond-half": DiamondHalf_default,
  "diamond-turn-right": DiamondTurnRight_default,
  diamond: Diamond_default,
  diploma: Diploma_default,
  "display-arrow-down": DisplayArrowDown_default,
  "display-code": DisplayCode_default,
  "display-slash": DisplaySlash_default,
  display: Display_default,
  "distribute-spacing-horizontal": DistributeSpacingHorizontal_default,
  "distribute-spacing-vertical": DistributeSpacingVertical_default,
  divide: Divide_default,
  "do-not-enter": DoNotEnter_default,
  "door-closed": DoorClosed_default,
  "door-open": DoorOpen_default,
  dove: Dove_default,
  "down-from-dotted-line": DownFromDottedLine_default,
  "down-from-line": DownFromLine_default,
  "down-left-and-up-right-to-center": DownLeftAndUpRightToCenter_default,
  "down-left": DownLeft_default,
  "down-long": DownLong_default,
  "down-right": DownRight_default,
  "down-to-bracket": DownToBracket_default,
  "down-to-dotted-line": DownToDottedLine_default,
  "down-to-line": DownToLine_default,
  down: Down_default,
  download: Download_default,
  "draw-circle": DrawCircle_default,
  "draw-polygon": DrawPolygon_default,
  "draw-square": DrawSquare_default,
  e: E_default,
  eject: Eject_default,
  "ellipsis-stroke-vertical": EllipsisStrokeVertical_default,
  "ellipsis-stroke": EllipsisStroke_default,
  "ellipsis-vertical": EllipsisVertical_default,
  ellipsis: Ellipsis_default,
  "envelope-circle-check": EnvelopeCircleCheck_default,
  "envelope-dot": EnvelopeDot_default,
  "envelope-open-dollar": EnvelopeOpenDollar_default,
  "envelope-open-text": EnvelopeOpenText_default,
  "envelope-open": EnvelopeOpen_default,
  envelope: Envelope_default,
  "envelopes-bulk": EnvelopesBulk_default,
  envelopes: Envelopes_default,
  equals: Equals_default,
  eraser: Eraser_default,
  ethernet: Ethernet_default,
  "euro-sign": EuroSign_default,
  exclamation: Exclamation_default,
  "expand-wide": ExpandWide_default,
  expand: Expand_default,
  "eye-slash": EyeSlash_default,
  eye: Eye_default,
  f: F_default,
  "file-arrow-down": FileArrowDown_default,
  "file-arrow-up": FileArrowUp_default,
  "file-binary": FileBinary_default,
  "file-certificate": FileCertificate_default,
  "file-chart-column": FileChartColumn_default,
  "file-chart-pie": FileChartPie_default,
  "file-check": FileCheck_default,
  "file-circle-check": FileCircleCheck_default,
  "file-circle-exclamation": FileCircleExclamation_default,
  "file-circle-info": FileCircleInfo_default,
  "file-circle-minus": FileCircleMinus_default,
  "file-circle-plus": FileCirclePlus_default,
  "file-circle-question": FileCircleQuestion_default,
  "file-circle-xmark": FileCircleXmark_default,
  "file-code": FileCode_default,
  "file-contract": FileContract_default,
  "file-csv": FileCsv_default,
  "file-dashed-line": FileDashedLine_default,
  "file-excel": FileExcel_default,
  "file-exclamation": FileExclamation_default,
  "file-export": FileExport_default,
  "file-image": FileImage_default,
  "file-import": FileImport_default,
  "file-invoice": FileInvoice_default,
  "file-lines": FileLines_default,
  "file-lock": FileLock_default,
  "file-magnifying-glass": FileMagnifyingGlass_default,
  "file-minus": FileMinus_default,
  "file-music": FileMusic_default,
  "file-pdf": FilePdf_default,
  "file-pen": FilePen_default,
  "file-plus-minus": FilePlusMinus_default,
  "file-plus": FilePlus_default,
  "file-powerpoint": FilePowerpoint_default,
  "file-shield": FileShield_default,
  "file-signature": FileSignature_default,
  "file-slash": FileSlash_default,
  "file-spreadsheet": FileSpreadsheet_default,
  "file-user": FileUser_default,
  "file-video": FileVideo_default,
  "file-waveform": FileWaveform_default,
  "file-word": FileWord_default,
  "file-xmark": FileXmark_default,
  "file-zipper": FileZipper_default,
  file: File_default,
  files: Files_default,
  "filter-circle-dollar": FilterCircleDollar_default,
  "filter-circle-xmark": FilterCircleXmark_default,
  "filter-list": FilterList_default,
  "filter-slash": FilterSlash_default,
  filter: Filter_default,
  filters: Filters_default,
  fingerprint: Fingerprint_default,
  "flag-swallowtail": FlagSwallowtail_default,
  flag: Flag_default,
  flashlight: Flashlight_default,
  "flask-round-potion": FlaskRoundPotion_default,
  "flask-vial": FlaskVial_default,
  flask: Flask_default,
  "floppy-disk-circle-arrow-right": FloppyDiskCircleArrowRight_default,
  "floppy-disk-circle-xmark": FloppyDiskCircleXmark_default,
  "floppy-disk-pen": FloppyDiskPen_default,
  "floppy-disk": FloppyDisk_default,
  "floppy-disks": FloppyDisks_default,
  "folder-arrow-down": FolderArrowDown_default,
  "folder-arrow-up": FolderArrowUp_default,
  "folder-bookmark": FolderBookmark_default,
  "folder-closed": FolderClosed_default,
  "folder-gear-right": FolderGearRight_default,
  "folder-gear": FolderGear_default,
  "folder-grid": FolderGrid_default,
  "folder-heart": FolderHeart_default,
  "folder-image": FolderImage_default,
  "folder-magnifying-glass": FolderMagnifyingGlass_default,
  "folder-minus": FolderMinus_default,
  "folder-open": FolderOpen_default,
  "folder-plus": FolderPlus_default,
  "folder-tree": FolderTree_default,
  "folder-user": FolderUser_default,
  "folder-xmark": FolderXmark_default,
  folder: Folder_default,
  folders: Folders_default,
  "font-case": FontCase_default,
  font: Font_default,
  "forward-fast": ForwardFast_default,
  "forward-step": ForwardStep_default,
  forward: Forward_default,
  frame: Frame_default,
  g: G_default,
  "gallery-thumbnails": GalleryThumbnails_default,
  gavel: Gavel_default,
  gear: Gear_default,
  gears: Gears_default,
  gem: Gem_default,
  "glasses-round": GlassesRound_default,
  glasses: Glasses_default,
  globe: Globe_default,
  "greater-than-equal": GreaterThanEqual_default,
  "greater-than": GreaterThan_default,
  "grid-2-plus": Grid2Plus_default,
  "grid-2": Grid2_default,
  "grid-4": Grid4_default,
  "grid-5": Grid5_default,
  "grid-dividers": GridDividers_default,
  "grid-horizontal": GridHorizontal_default,
  grid: Grid_default,
  "grip-dots-vertical": GripDotsVertical_default,
  "grip-dots": GripDots_default,
  "grip-lines-vertical": GripLinesVertical_default,
  "grip-lines": GripLines_default,
  "grip-vertical": GripVertical_default,
  grip: Grip_default,
  "group-arrows-rotate": GroupArrowsRotate_default,
  h: H_default,
  h1: H1_default,
  h2: H2_default,
  h3: H3_default,
  h4: H4_default,
  h5: H5_default,
  h6: H6_default,
  hammer: Hammer_default,
  hashtag: Hashtag_default,
  heading: Heading_default,
  "headphones-simple": HeadphonesSimple_default,
  headphones: Headphones_default,
  headset: Headset_default,
  heart: Heart_default,
  "hexagon-check": HexagonCheck_default,
  "hexagon-divide": HexagonDivide_default,
  "hexagon-exclamation": HexagonExclamation_default,
  "hexagon-image": HexagonImage_default,
  "hexagon-minus": HexagonMinus_default,
  "hexagon-plus": HexagonPlus_default,
  "hexagon-xmark": HexagonXmark_default,
  hexagon: Hexagon_default,
  "highlighter-line": HighlighterLine_default,
  highlighter: Highlighter_default,
  "horizontal-rule": HorizontalRule_default,
  "house-blank": HouseBlank_default,
  "house-building": HouseBuilding_default,
  "house-chimney-blank": HouseChimneyBlank_default,
  "house-chimney-crack": HouseChimneyCrack_default,
  "house-chimney-user": HouseChimneyUser_default,
  "house-chimney-window": HouseChimneyWindow_default,
  "house-chimney": HouseChimney_default,
  "house-circle-check": HouseCircleCheck_default,
  "house-circle-exclamation": HouseCircleExclamation_default,
  "house-circle-xmark": HouseCircleXmark_default,
  "house-crack": HouseCrack_default,
  "house-day": HouseDay_default,
  "house-laptop": HouseLaptop_default,
  "house-lock": HouseLock_default,
  "house-user": HouseUser_default,
  house: House_default,
  hyphen: Hyphen_default,
  "i-cursor": ICursor_default,
  i: I_default,
  icons: Icons_default,
  "id-badge": IdBadge_default,
  "id-card-clip": IdCardClip_default,
  "id-card": IdCard_default,
  "image-landscape": ImageLandscape_default,
  "image-polaroid-user": ImagePolaroidUser_default,
  "image-polaroid": ImagePolaroid_default,
  "image-portrait": ImagePortrait_default,
  "image-slash": ImageSlash_default,
  "image-user": ImageUser_default,
  image: Image_default,
  "images-user": ImagesUser_default,
  images: Images_default,
  "inbox-full": InboxFull_default,
  "inbox-in": InboxIn_default,
  "inbox-out": InboxOut_default,
  inbox: Inbox_default,
  inboxes: Inboxes_default,
  indent: Indent_default,
  infinity: Infinity_default,
  info: Info_default,
  "input-numeric": InputNumeric_default,
  "input-pipe": InputPipe_default,
  "input-text": InputText_default,
  "install-once-16px": InstallOnce16Px_default,
  "installed-profiles": InstalledProfiles_default,
  intersection: Intersection_default,
  italic: Italic_default,
  k: K_default,
  "kandji-ai": KandjiAI_default,
  "kandji-logo": KandjiLogo_default,
  "kandji-blueprint": KandjiBlueprint_default,
  "kandji-blueprint-light": KandjiBlueprintLight_default,
  "kernel-extensions": KernelExtensions_default,
  "key-skeleton-left-right": KeySkeletonLeftRight_default,
  "key-skeleton": KeySkeleton_default,
  key: Key_default,
  "keyboard-brightness-low": KeyboardBrightnessLow_default,
  "keyboard-brightness": KeyboardBrightness_default,
  "keyboard-down": KeyboardDown_default,
  "keyboard-left": KeyboardLeft_default,
  keyboard: Keyboard_default,
  keynote: Keynote_default,
  l: L_default,
  "laptop-arrow-down": LaptopArrowDown_default,
  "laptop-code": LaptopCode_default,
  "laptop-file": LaptopFile_default,
  "laptop-mobile": LaptopMobile_default,
  "laptop-slash": LaptopSlash_default,
  laptop: Laptop_default,
  launchpad: Launchpad_default,
  "layer-group": LayerGroup_default,
  "layer-minus": LayerMinus_default,
  "layer-plus": LayerPlus_default,
  "left-from-line": LeftFromLine_default,
  "left-long-to-line": LeftLongToLine_default,
  "left-long": LeftLong_default,
  "left-right": LeftRight_default,
  "left-to-line": LeftToLine_default,
  left: Left_default,
  "less-than-equal": LessThanEqual_default,
  "less-than": LessThan_default,
  "library-grid-light": LibraryGridLight_default,
  "lightbulb-on": LightbulbOn_default,
  "lightbulb-slash": LightbulbSlash_default,
  lightbulb: Lightbulb_default,
  "line-columns": LineColumns_default,
  "line-height": LineHeight_default,
  "lines-leaning": LinesLeaning_default,
  "link-horizontal-slash": LinkHorizontalSlash_default,
  "link-horizontal": LinkHorizontal_default,
  "link-simple-slash": LinkSimpleSlash_default,
  "link-simple": LinkSimple_default,
  "link-slash": LinkSlash_default,
  link: Link_default,
  "list-check": ListCheck_default,
  "list-dropdown": ListDropdown_default,
  "list-ol": ListOl_default,
  "list-radio": ListRadio_default,
  "list-search": ListSearch_default,
  "list-timeline": ListTimeline_default,
  "list-tree": ListTree_default,
  "list-ul": ListUl_default,
  list: List_default,
  loader: Loader_default,
  "local-users": LocalUsers_default,
  "location-arrow": LocationArrow_default,
  "location-check": LocationCheck_default,
  "location-crosshairs-slash": LocationCrosshairsSlash_default,
  "location-crosshairs": LocationCrosshairs_default,
  "location-dot-slash": LocationDotSlash_default,
  "location-dot": LocationDot_default,
  "location-exclamation": LocationExclamation_default,
  "location-minus": LocationMinus_default,
  "location-pen": LocationPen_default,
  "location-pin-lock": LocationPinLock_default,
  "location-pin-slash": LocationPinSlash_default,
  "location-pin": LocationPin_default,
  "location-plus": LocationPlus_default,
  "location-question": LocationQuestion_default,
  "location-smile": LocationSmile_default,
  "location-xmark": LocationXmark_default,
  "lock-a": LockA_default,
  "lock-hashtag": LockHashtag_default,
  "lock-keyhole-open": LockKeyholeOpen_default,
  "lock-keyhole": LockKeyhole_default,
  "lock-open": LockOpen_default,
  lock: Lock_default,
  m: M_default,
  "magnifying-glass-arrow-right": MagnifyingGlassArrowRight_default,
  "magnifying-glass-chart": MagnifyingGlassChart_default,
  "magnifying-glass-dollar": MagnifyingGlassDollar_default,
  "magnifying-glass-location": MagnifyingGlassLocation_default,
  "magnifying-glass-list": MagnifyingGlassList_default,
  "magnifying-glass-minus": MagnifyingGlassMinus_default,
  "magnifying-glass-plus": MagnifyingGlassPlus_default,
  "magnifying-glass": MagnifyingGlass_default,
  "mailbox-flag-up": MailboxFlagUp_default,
  mailbox: Mailbox_default,
  malware: Malware_default,
  "map-location-dot": MapLocationDot_default,
  "map-location": MapLocation_default,
  "map-pin": MapPin_default,
  map: Map_default,
  marker: Marker_default,
  maximize: Maximize_default,
  medal: Medal_default,
  megaphone: Megaphone_default,
  "memo-circle-check": MemoCircleCheck_default,
  "memo-circle-info": MemoCircleInfo_default,
  "memo-pad": MemoPad_default,
  memo: Memo_default,
  memory: Memory_default,
  "message-arrow-down": MessageArrowDown_default,
  "message-arrow-up-right": MessageArrowUpRight_default,
  "message-arrow-up": MessageArrowUp_default,
  "message-captions": MessageCaptions_default,
  "message-check": MessageCheck_default,
  "message-code": MessageCode_default,
  "message-dots": MessageDots_default,
  "message-exclamation": MessageExclamation_default,
  "message-lines": MessageLines_default,
  "message-plus": MessagePlus_default,
  "message-question": MessageQuestion_default,
  "message-quote": MessageQuote_default,
  "message-slash": MessageSlash_default,
  "message-xmark": MessageXmark_default,
  message: Message_default,
  messages: Messages_default,
  "microchip-ai": MicrochipAi_default,
  microchip: Microchip_default,
  "microphone-lines-slash": MicrophoneLinesSlash_default,
  "microphone-lines": MicrophoneLines_default,
  "microphone-slash": MicrophoneSlash_default,
  "microphone-stand": MicrophoneStand_default,
  microphone: Microphone_default,
  minimize: Minimize_default,
  minus: Minus_default,
  "minus-hexagon": MinusHexagon_default,
  "mobile-button": MobileButton_default,
  "mobile-notch": MobileNotch_default,
  "mobile-screen-button": MobileScreenButton_default,
  "mobile-screen": MobileScreen_default,
  mobile: Mobile_default,
  "monitor-waveform": MonitorWaveform_default,
  n: N_default,
  "network-interfaces": NetworkInterfaces_default,
  "not-equal": NotEqual_default,
  "note-sticky": NoteSticky_default,
  note: Note_default,
  notebook: Notebook_default,
  nvd: Nvd_default,
  o: O_default,
  "object-exclude": ObjectExclude_default,
  "object-group": ObjectGroup_default,
  "object-intersect": ObjectIntersect_default,
  "object-subtract": ObjectSubtract_default,
  "object-ungroup": ObjectUngroup_default,
  "object-union": ObjectUnion_default,
  "objects-align-bottom": ObjectsAlignBottom_default,
  "objects-align-center-horizontal": ObjectsAlignCenterHorizontal_default,
  "objects-align-center-vertical": ObjectsAlignCenterVertical_default,
  "objects-align-left": ObjectsAlignLeft_default,
  "objects-align-right": ObjectsAlignRight_default,
  "objects-align-top": ObjectsAlignTop_default,
  "objects-column": ObjectsColumn_default,
  "octagon-check": OctagonCheck_default,
  "octagon-divide": OctagonDivide_default,
  "octagon-exclamation": OctagonExclamation_default,
  "octagon-exclamation-filled": OctagonExclamationFilled_default,
  "octagon-minus": OctagonMinus_default,
  "octagon-plus": OctagonPlus_default,
  "octagon-xmark": OctagonXmark_default,
  octagon: Octagon_default,
  option: Option_default,
  outdent: Outdent_default,
  p: P_default,
  "page-caret-down": PageCaretDown_default,
  "page-caret-up": PageCaretUp_default,
  page: Page_default,
  "paper-plane-top": PaperPlaneTop_default,
  "paper-plane": PaperPlane_default,
  "paperclip-vertical": PaperclipVertical_default,
  paperclip: Paperclip_default,
  "paragraph-left": ParagraphLeft_default,
  paragraph: Paragraph_default,
  "party-horn": PartyHorn_default,
  passport: Passport_default,
  paste: Paste_default,
  pause: Pause_default,
  "pen-circle": PenCircle_default,
  "pen-field": PenField_default,
  pen: Pen_default,
  "pencil-slash": PencilSlash_default,
  pencil: Pencil_default,
  "people-group": PeopleGroup_default,
  people: People_default,
  person: Person_default,
  phone: Phone_default,
  pipe: Pipe_default,
  "plane-up": PlaneUp_default,
  plane: Plane_default,
  "play-pause": PlayPause_default,
  play: Play_default,
  plug: Plug_default,
  "plus-large": PlusLarge_default,
  "plus-minus": PlusMinus_default,
  plus: Plus_default,
  podium: Podium_default,
  "power-off": PowerOff_default,
  "presentation-screen": PresentationScreen_default,
  print: Print_default,
  q: Q_default,
  qrcode: Qrcode_default,
  question: Question_default,
  "quote-left": QuoteLeft_default,
  "quote-right": QuoteRight_default,
  quotes: Quotes_default,
  r: R_default,
  radar: Radar_default,
  rectangle: Rectangle_default,
  "rectangle-vertical": RectangleVertical_default,
  "rectangle-barcode": RectangleBarcode_default,
  "rectangle-code": RectangleCode_default,
  "rectangle-terminal": RectangleTerminal_default,
  "repeat-1": Repeat1_default,
  repeat: Repeat_default,
  "reply-all": ReplyAll_default,
  reply: Reply_default,
  retweet: Retweet_default,
  ribbon: Ribbon_default,
  "right-from-bracket": RightFromBracket_default,
  "right-from-line": RightFromLine_default,
  "right-left": RightLeft_default,
  "right-long-to-line": RightLongToLine_default,
  "right-long": RightLong_default,
  "right-to-bracket": RightToBracket_default,
  "right-to-line": RightToLine_default,
  right: Right_default,
  "rotate-left": RotateLeft_default,
  "rotate-right": RotateRight_default,
  "rotate-right-one": RotateRightOne_default,
  rotate: Rotate_default,
  "ruler-horizontal": RulerHorizontal_default,
  "ruler-triangle": RulerTriangle_default,
  "ruler-vertical": RulerVertical_default,
  ruler: Ruler_default,
  "safari-extensions": SafariExtensions_default,
  scissors: Scissors_default,
  "screen-users": ScreenUsers_default,
  "screwdriver-wrench": ScrewdriverWrench_default,
  screwdriver: Screwdriver_default,
  scribble: Scribble_default,
  "scroll-old": ScrollOld_default,
  scroll: Scroll_default,
  "sd-card": SdCard_default,
  "sd-cards": SdCards_default,
  "seal-question": SealQuestion_default,
  seal: Seal_default,
  "send-back": SendBack_default,
  "send-backward": SendBackward_default,
  server: Server_default,
  "settings-gear": SettingsGear_default,
  "share-all": ShareAll_default,
  "share-from-square": ShareFromSquare_default,
  "share-nodes": ShareNodes_default,
  share: Share_default,
  sharing: Sharing_default,
  "shield-check": ShieldCheck_default,
  "shield-exclamation": ShieldExclamation_default,
  "shield-halved": ShieldHalved_default,
  "shield-keyhole": ShieldKeyhole_default,
  "shield-lock": ShieldLock_default,
  "shield-magnifying-glass-virus": ShieldMagnifyingGlassVirus_default,
  "shield-minus": ShieldMinus_default,
  "shield-plus": ShieldPlus_default,
  "shield-quartered": ShieldQuartered_default,
  "shield-slash": ShieldSlash_default,
  "shield-virus": ShieldVirus_default,
  "shield-xmark": ShieldXmark_default,
  shield: Shield_default,
  "sidebar-flip": SidebarFlip_default,
  sidebar: Sidebar_default,
  "signal-bars-fair": SignalBarsFair_default,
  "signal-bars-good": SignalBarsGood_default,
  "signal-bars-slash": SignalBarsSlash_default,
  "signal-bars-weak": SignalBarsWeak_default,
  "signal-bars": SignalBars_default,
  "signal-fair": SignalFair_default,
  "signal-good": SignalGood_default,
  "signal-slash": SignalSlash_default,
  "signal-stream-slash": SignalStreamSlash_default,
  "signal-stream": SignalStream_default,
  "signal-strong": SignalStrong_default,
  "signal-weak": SignalWeak_default,
  signal: Signal_default,
  signature: Signature_default,
  "signs-post": SignsPost_default,
  "sim-card": SimCard_default,
  "sim-cards": SimCards_default,
  sitemap: Sitemap_default,
  "slash-back": SlashBack_default,
  "slash-forward": SlashForward_default,
  slash: Slash_default,
  slider: Slider_default,
  "sliders-simple": SlidersSimple_default,
  "sliders-up": SlidersUp_default,
  sliders: Sliders_default,
  "sort-down": SortDown_default,
  "sort-up": SortUp_default,
  sort: Sort_default,
  sparkles: Sparkles_default,
  speaker: Speaker_default,
  speakers: Speakers_default,
  "spell-check": SpellCheck_default,
  "spinner-third": SpinnerThird_default,
  spinner: Spinner_default,
  split: Split_default,
  "square-0": Square0_default,
  "square-1": Square1_default,
  "square-2": Square2_default,
  "square-3": Square3_default,
  "square-4": Square4_default,
  "square-5": Square5_default,
  "square-6": Square6_default,
  "square-7": Square7_default,
  "square-8": Square8_default,
  "square-9": Square9_default,
  "square-a-lock": SquareALock_default,
  "square-a": SquareA_default,
  "square-ampersand": SquareAmpersand_default,
  "square-arrow-down-left": SquareArrowDownLeft_default,
  "square-arrow-down-right": SquareArrowDownRight_default,
  "square-arrow-down": SquareArrowDown_default,
  "square-arrow-left": SquareArrowLeft_default,
  "square-arrow-right": SquareArrowRight_default,
  "square-arrow-up-left": SquareArrowUpLeft_default,
  "square-arrow-up-right": SquareArrowUpRight_default,
  "square-arrow-up": SquareArrowUp_default,
  "square-b": SquareB_default,
  "square-bolt": SquareBolt_default,
  "square-c": SquareC_default,
  "square-caret-down": SquareCaretDown_default,
  "square-caret-left": SquareCaretLeft_default,
  "square-caret-right": SquareCaretRight_default,
  "square-caret-up": SquareCaretUp_default,
  "square-check": SquareCheck_default,
  "square-chevron-down": SquareChevronDown_default,
  "square-chevron-left": SquareChevronLeft_default,
  "square-chevron-right": SquareChevronRight_default,
  "square-chevron-up": SquareChevronUp_default,
  "square-code": SquareCode_default,
  "square-d": SquareD_default,
  "square-dashed-circle-plus": SquareDashedCirclePlus_default,
  "square-dashed": SquareDashed_default,
  "square-down-left": SquareDownLeft_default,
  "square-down-right": SquareDownRight_default,
  "square-down": SquareDown_default,
  "square-e": SquareE_default,
  "square-ellipsis-vertical": SquareEllipsisVertical_default,
  "square-ellipsis": SquareEllipsis_default,
  "square-envelope": SquareEnvelope_default,
  "square-exclamation": SquareExclamation_default,
  "square-f": SquareF_default,
  "square-full": SquareFull_default,
  "square-g": SquareG_default,
  "square-h": SquareH_default,
  "square-i": SquareI_default,
  "square-info": SquareInfo_default,
  "square-j": SquareJ_default,
  "square-k": SquareK_default,
  "square-kanban": SquareKanban_default,
  "square-l": SquareL_default,
  "square-left": SquareLeft_default,
  "square-list": SquareList_default,
  "square-m": SquareM_default,
  "square-minus": SquareMinus_default,
  "square-n": SquareN_default,
  "square-o": SquareO_default,
  "square-p": SquareP_default,
  "square-plus": SquarePlus_default,
  "square-q": SquareQ_default,
  "square-question": SquareQuestion_default,
  "square-quote": SquareQuote_default,
  "square-r": SquareR_default,
  "square-right": SquareRight_default,
  "square-ring": SquareRing_default,
  "square-s": SquareS_default,
  "square-share-nodes": SquareShareNodes_default,
  "square-sliders-vertical": SquareSlidersVertical_default,
  "square-sliders": SquareSliders_default,
  "square-small": SquareSmall_default,
  "square-stack-slash-fill": SquareStackSlashFill_default,
  "square-t": SquareT_default,
  "square-terminal": SquareTerminal_default,
  "square-this-way-up": SquareThisWayUp_default,
  "square-u": SquareU_default,
  "square-up-left": SquareUpLeft_default,
  "square-up-right": SquareUpRight_default,
  "square-up": SquareUp_default,
  "square-user": SquareUser_default,
  "square-v": SquareV_default,
  "square-w": SquareW_default,
  "square-x": SquareX_default,
  "square-xmark": SquareXmark_default,
  "square-y": SquareY_default,
  "square-z": SquareZ_default,
  square: Square_default,
  "star-sharp": StarSharp_default,
  star: Star_default,
  stop: Stop_default,
  stopwatch: Stopwatch_default,
  store: Store_default,
  strikethrough: Strikethrough_default,
  subscript: Subscript_default,
  suitcase: Suitcase_default,
  "sun-bright": SunBright_default,
  sun: Sun_default,
  superscript: Superscript_default,
  symbols: Symbols_default,
  "system-extensions": SystemExtensions_default,
  t: T_default,
  "table-cells-large": TableCellsLarge_default,
  "table-cells": TableCells_default,
  "table-columns": TableColumns_default,
  "table-layout": TableLayout_default,
  "table-list": TableList_default,
  "table-picnic": TablePicnic_default,
  "table-pivot": TablePivot_default,
  "table-rows": TableRows_default,
  "table-tree": TableTree_default,
  table: Table_default,
  "tablet-button": TabletButton_default,
  "tablet-rugged": TabletRugged_default,
  "tablet-screen-button": TabletScreenButton_default,
  "tablet-screen": TabletScreen_default,
  tablet: Tablet_default,
  tablets: Tablets_default,
  tag: Tag_default,
  tags: Tags_default,
  "tally-1": Tally1_default,
  "tally-2": Tally2_default,
  "tally-3": Tally3_default,
  "tally-4": Tally4_default,
  tally: Tally_default,
  tape: Tape_default,
  terminal: Terminal_default,
  "text-height": TextHeight_default,
  "text-size": TextSize_default,
  "text-slash": TextSlash_default,
  "text-width": TextWidth_default,
  text: Text_default,
  "thought-bubble": ThoughtBubble_default,
  thumbtack: Thumbtack_default,
  ticket: Ticket_default,
  tilde: Tilde_default,
  "timeline-arrow": TimelineArrow_default,
  timeline: Timeline_default,
  timer: Timer_default,
  "toggle-large-off": ToggleLargeOff_default,
  "toggle-large-on": ToggleLargeOn_default,
  "toggle-off": ToggleOff_default,
  "toggle-on": ToggleOn_default,
  toolbox: Toolbox_default,
  trademark: Trademark_default,
  trophy: Trophy_default,
  "transparency-database": TransparencyDatabase_default,
  "trash-arrow-up": TrashArrowUp_default,
  "trash-can-arrow-up": TrashCanArrowUp_default,
  "trash-can-check": TrashCanCheck_default,
  "trash-can-clock": TrashCanClock_default,
  "trash-can-list": TrashCanList_default,
  "trash-can-plus": TrashCanPlus_default,
  "trash-can-slash": TrashCanSlash_default,
  "trash-can-undo": TrashCanUndo_default,
  "trash-can-xmark": TrashCanXmark_default,
  "trash-can": TrashCan_default,
  "trash-check": TrashCheck_default,
  "trash-clock": TrashClock_default,
  "trash-list": TrashList_default,
  "trash-plus": TrashPlus_default,
  "trash-slash": TrashSlash_default,
  "trash-undo": TrashUndo_default,
  "trash-xmark": TrashXmark_default,
  trash: Trash_default,
  "triangle-exclamation": TriangleExclamation_default,
  triangle: Triangle_default,
  "turn-down-right": TurnDownRight_default,
  "turn-down": TurnDown_default,
  "turn-up": TurnUp_default,
  tv: Tv_default,
  underline: Underline_default,
  union: Union_default,
  "universal-access": UniversalAccess_default,
  "unlock-keyhole": UnlockKeyhole_default,
  unlock: Unlock_default,
  "up-down-left-right": UpDownLeftRight_default,
  "up-down": UpDown_default,
  "up-from-bracket": UpFromBracket_default,
  "up-from-dotted-line": UpFromDottedLine_default,
  "up-from-line": UpFromLine_default,
  "up-left": UpLeft_default,
  "up-long": UpLong_default,
  "up-right-and-down-left-from-center": UpRightAndDownLeftFromCenter_default,
  "up-right-from-square": UpRightFromSquare_default,
  "up-right": UpRight_default,
  "up-to-dotted-line": UpToDottedLine_default,
  "up-to-line": UpToLine_default,
  up: Up_default,
  upload: Upload_default,
  "usb-drive": UsbDrive_default,
  "user-arrow-right": UserArrowRight_default,
  "user-check": UserCheck_default,
  "user-clock": UserClock_default,
  "user-gear": UserGear_default,
  "user-group": UserGroup_default,
  "user-large-slash": UserLargeSlash_default,
  "user-large": UserLarge_default,
  "user-lock": UserLock_default,
  "user-magnifying-glass": UserMagnifyingGlass_default,
  "user-minus": UserMinus_default,
  "user-pen": UserPen_default,
  "user-plus": UserPlus_default,
  "user-shield": UserShield_default,
  "user-slash": UserSlash_default,
  "user-tag": UserTag_default,
  "user-unlock": UserUnlock_default,
  "user-xmark": UserXmark_default,
  user: User_default,
  "users-between-lines": UsersBetweenLines_default,
  "users-gear": UsersGear_default,
  "users-line": UsersLine_default,
  "users-slash": UsersSlash_default,
  users: Users_default,
  v: V_default,
  vault: Vault_default,
  "virus-slash": VirusSlash_default,
  "virus-total": VirusTotal_default,
  virus: Virus_default,
  viruses: Viruses_default,
  "volume-high": VolumeHigh_default,
  "volume-low": VolumeLow_default,
  "volume-off": VolumeOff_default,
  "volume-slash": VolumeSlash_default,
  "volume-xmark": VolumeXmark_default,
  volume: Volume_default,
  w: W_default,
  waad: Azure_default,
  wallet: Wallet_default,
  "watch-apple": WatchApple_default,
  "watch-calculator": WatchCalculator_default,
  "wave-pulse": WavePulse_default,
  "wave-sine": WaveSine_default,
  "wave-square": WaveSquare_default,
  "wave-triangle": WaveTriangle_default,
  "waveform-lines": WaveformLines_default,
  waveform: Waveform_default,
  "wifi-exclamation": WifiExclamation_default,
  "wifi-fair": WifiFair_default,
  "wifi-slash": WifiSlash_default,
  "wifi-weak": WifiWeak_default,
  wifi: Wifi_default,
  "wifi-mac": WifiMac_default,
  "window-flip": WindowFlip_default,
  "window-frame-open": WindowFrameOpen_default,
  "window-frame": WindowFrame_default,
  "window-maximize": WindowMaximize_default,
  "window-minimize": WindowMinimize_default,
  "window-restore": WindowRestore_default,
  window: Window_default,
  "wrench-simple": WrenchSimple_default,
  wrench: Wrench_default,
  "x-ray": XRay_default,
  x: X_default,
  "xmark-large": XmarkLarge_default,
  xmark: Xmark_default,
  "xmarks-lines": XmarksLines_default,
  y: Y_default,
  z: Z_default,
  "fa-angle-down-small": FaAngleDownSmall_default,
  "fa-angle-left-small": FaAngleLeftSmall_default,
  "fa-angle-right-small": FaAngleRightSmall_default,
  "fa-angle-up-small": FaAngleUpSmall_default,
  "fa-arrow-left-to-line-control": FaArrowLeftToLineControl_default,
  "fa-arrow-right-to-line-control": FaArrowRightToLineControl_default,
  "fa-caret-down-solid-small": FaCaretDownSolidSmall_default,
  "fa-caret-left-solid-small": FaCaretLeftSolidSmall_default,
  "fa-caret-right-solid-small": FaCaretRightSolidSmall_default,
  "fa-caret-up-solid-small": FaCaretUpSolidSmall_default,
  "fa-check-14px": FaCheck14Px_default,
  "fa-dash-14px": FaDash14Px_default,
  "fa-plus-minus-small": FaPlusMinusSmall_default,
  "fa-thumbtack": FaThumbtack_default,
  "fa-xmark-large-close": FaXmarkLargeClose_default,
  "fa-xmark-small": FaXmarkSmall_default,
  "sf-apple-tv": SfAppleTv_default,
  "sf-apple-vision-pro": SfAppleVisionPro_default,
  "sf-desktop-computer": SfDesktopComputer_default,
  "sf-ipad-portrait": SfIpadPortrait_default,
  "sf-ipad-landscape": SfIpadLandscape_default,
  "sf-iphone": SfIphone_default,
  "sf-laptop-computer": SfLaptopComputer_default,
  "sf-laptop-computer-and-iphone": SfLaptopComputerAndIphone_default,
  "sf-tv": SfTv_default,
  "sf-key": SfKey_default,
  "sf-startup-settings": SfStartupSettings_default,
  "cloud-lock": CloudLock_default,
  "shield-arrows": ShieldArrows_default,
  "google-apps": Google_default,
  samlp: CustomSaml_default,
  "android-logo": AndroidLogo_default,
  "windows-logo": WindowsLogo_default,
  "windows-logo-check": WindowsLogoCheck_default,
  "apple-logo": AppleLogo_default
};

// src/Icon/iconUtils.ts
function validateSize(size) {
  const sizeMap = {
    unset: void 0,
    xs: 12,
    sm: 16,
    md: 24,
    lg: 40
  };
  if (typeof size === "string") {
    if (!(size in sizeMap)) {
      console.warn(
        `Invalid size: ${size}. Defaulting to 'md'. Valid sizes are: ${Object.keys(
          sizeMap
        ).join(", ")}, or a number.`
      );
    } else {
      return sizeMap[size];
    }
  }
  if (typeof size === "number") {
    if (size <= 0) {
      console.warn("Invalid size: must be greater than 0. Defaulting to md.");
    } else {
      return size;
    }
  }
  return sizeMap.md;
}

// src/Icon/Icon.tsx
import { jsx as jsx1441 } from "react/jsx-runtime";
var Icon = (props) => {
  const {
    name,
    size = "md",
    color,
    className,
    onClick = () => {
    },
    onMouseOver = () => {
    },
    onMouseLeave = () => {
    },
    style = {}
  } = props;
  let icon = name;
  if (!IconMap[name]) {
    icon = "octagon-exclamation";
    console.error(
      `Icon named "${name}" not found. Using "${icon}" as fallback.`
    );
  }
  const IconComponent = IconMap[icon];
  const sizePixels = validateSize(size);
  const iconSizeProps = sizePixels ? {
    width: sizePixels,
    height: sizePixels
  } : {};
  return /* @__PURE__ */ jsx1441(
    IconComponent,
    __spreadValues({
      name: icon,
      title: icon,
      className,
      onClick,
      onMouseOver,
      onMouseLeave,
      color: color || "currentColor",
      style
    }, iconSizeProps)
  );
};
var Icon_default = Icon;

// src/@shared/css/utils.ts
var marginUtilConfig = [
  {
    utilKey: "m",
    cssPropKey: "margin"
  },
  {
    utilKey: "mt",
    cssPropKey: "marginTop"
  },
  {
    utilKey: "mr",
    cssPropKey: "marginRight"
  },
  {
    utilKey: "mb",
    cssPropKey: "marginBottom"
  },
  {
    utilKey: "ml",
    cssPropKey: "marginLeft"
  },
  {
    utilKey: "mx",
    cssPropKey: ["marginLeft", "marginRight"]
  },
  {
    utilKey: "my",
    cssPropKey: ["marginTop", "marginBottom"]
  }
];
var paddingUtilConfig = [
  {
    utilKey: "p",
    cssPropKey: "padding"
  },
  {
    utilKey: "pt",
    cssPropKey: "paddingTop"
  },
  {
    utilKey: "pr",
    cssPropKey: "paddingRight"
  },
  {
    utilKey: "pb",
    cssPropKey: "paddingBottom"
  },
  {
    utilKey: "pl",
    cssPropKey: "paddingLeft"
  },
  {
    utilKey: "px",
    cssPropKey: ["paddingLeft", "paddingRight"]
  },
  {
    utilKey: "py",
    cssPropKey: ["paddingTop", "paddingBottom"]
  }
];
var marginUtilVariants = marginUtilConfig.map(
  ({ utilKey, cssPropKey }) => Object.fromEntries(
    Object.entries(theme[config.themeMap.margin]).map(
      ([tokenKey, tokenData]) => {
        const cssUtilKey = `${utilKey}${tokenKey}`;
        const cssPropValue = Array.isArray(cssPropKey) ? {
          true: Object.fromEntries(
            cssPropKey.map((cssProp) => [cssProp, `$${tokenData.token}`])
          )
        } : {
          true: {
            [cssPropKey]: `$${tokenData.token}`
          }
        };
        return [cssUtilKey, cssPropValue];
      }
    )
  )
).reduce(
  (allUtils, currUtil) => __spreadValues(__spreadValues({}, allUtils), currUtil),
  {}
);
var paddingUtilVariants = paddingUtilConfig.map(
  ({ utilKey, cssPropKey }) => Object.fromEntries(
    Object.entries(theme[config.themeMap.padding]).map(
      ([tokenKey, tokenData]) => {
        const cssUtilKey = `${utilKey}${tokenKey}`;
        const cssPropValue = Array.isArray(cssPropKey) ? {
          true: Object.fromEntries(
            cssPropKey.map((cssProp) => [cssProp, `$${tokenData.token}`])
          )
        } : {
          true: {
            [cssPropKey]: `$${tokenData.token}`
          }
        };
        return [cssUtilKey, cssPropValue];
      }
    )
  )
).reduce(
  (allUtils, currUtil) => __spreadValues(__spreadValues({}, allUtils), currUtil),
  {}
);
var sizeUtilVariants = {
  wFull: { true: { width: "100%" } },
  hFull: {
    true: { height: "100%" }
  },
  wScreen: {
    true: { width: "100vw" }
  },
  hScreen: {
    true: { height: "100vh" }
  }
};
var stackingUtilVariants = {
  z1: { true: { zIndex: 1 } },
  z2: { true: { zIndex: 2 } },
  z3: { true: { zIndex: 3 } },
  z4: { true: { zIndex: 4 } },
  z5: { true: { zIndex: 5 } }
  // zIndices: {
  //   1: '100',
  //   2: '200',
  //   3: '300',
  //   4: '400',
  //   max: '999',
  // },
};
var cssUtils = css({
  variants: __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, marginUtilVariants), paddingUtilVariants), sizeUtilVariants), stackingUtilVariants)
});
var marginUtilValues = marginUtilConfig.map(({ cssPropKey }) => cssPropKey);
var paddingUtilValues = paddingUtilConfig.map(({ cssPropKey }) => cssPropKey);
var sizeUtilValues = ["width", "height"];
var cssUtilValues = [
  ...marginUtilValues,
  ...paddingUtilValues,
  ...sizeUtilValues
];
var cssUtilKeys = Object.keys(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, marginUtilVariants), paddingUtilVariants), sizeUtilVariants), stackingUtilVariants));
var isCssUtilKeyGuard = (key) => cssUtilKeys.includes(key);
var extractCssUtilsFromProps = (props) => {
  const groupedProps = Object.entries(props).reduce(
    (propsByType, currProp) => {
      const [propKey, propValue] = currProp;
      if (isCssUtilKeyGuard(propKey)) {
        return __spreadProps(__spreadValues({}, propsByType), {
          cssUtilProps: __spreadProps(__spreadValues({}, propsByType.cssUtilProps), {
            [propKey]: propValue
          })
        });
      }
      return __spreadProps(__spreadValues({}, propsByType), {
        restProps: __spreadProps(__spreadValues({}, propsByType.restProps), {
          [propKey]: propValue
        })
      });
    },
    {
      cssUtilProps: {},
      restProps: {}
    }
  );
  return [groupedProps.cssUtilProps, groupedProps.restProps];
};
function cn(classNameConfig, selectorPrefix, selectorPostfix) {
  const DEFAULT_SELECTOR_PREFIX = "&";
  let classNameArg = "";
  let selectorPrefixArg = "";
  let selectorPostfixArg = "";
  if (typeof classNameConfig === "string" && ["&", ">", "+", "~"].includes(classNameConfig)) {
    classNameArg = selectorPrefix;
    selectorPrefixArg = classNameConfig;
    selectorPostfixArg = selectorPostfix;
  } else {
    classNameArg = classNameConfig;
    selectorPrefixArg = DEFAULT_SELECTOR_PREFIX;
    selectorPostfixArg = selectorPrefix;
  }
  let className;
  if (typeof classNameArg === "string") {
    className = classNameArg.split(" ").map((c) => `.${c}`).join("");
  } else if (classNameArg && "className" in classNameArg) {
    className = classNameArg.className.split(" ").map((c) => `.${c}`).join("");
  }
  const prefix = selectorPrefixArg ? `${selectorPrefixArg} ` : "";
  const postfix = selectorPostfixArg != null ? selectorPostfixArg : "";
  return `${prefix}${className}${postfix}`;
}

// src/Box/Box.tsx
var Box = styled(
  "div",
  {
    // Reset
    boxSizing: "border-box"
  },
  cssUtils
);
var Box_default2 = Box;

// src/Flex/Flex.tsx
var flexGapVariants = {
  none: {
    gap: "$0"
  },
  xs: {
    gap: "$1"
  },
  sm: {
    gap: "$2"
  },
  md: {
    gap: "$3"
  },
  lg: {
    gap: "$4"
  },
  xl: {
    gap: "$5"
  }
};
var Flex = styled(Box_default2, {
  display: "flex",
  fontFamily: "$primary",
  variants: {
    wrap: {
      wrap: {
        flexWrap: "wrap"
      },
      "no-wrap": {
        flexWrap: "nowrap"
      },
      "wrap-reverse": {
        flexWrap: "wrap-reverse"
      }
    },
    flow: {
      row: {
        flexDirection: "row"
      },
      "row-reverse": {
        flexDirection: "row-reverse"
      },
      column: {
        flexDirection: "column"
      },
      "column-reverse": {
        flexDirection: "column-reverse"
      }
    },
    justifyContent: {
      start: {
        justifyContent: "flex-start"
      },
      center: {
        justifyContent: "center"
      },
      end: {
        justifyContent: "flex-end"
      },
      stretch: {
        justifyContent: "stretch"
      },
      "space-between": {
        justifyContent: "space-between"
      }
    },
    alignItems: {
      start: {
        alignItems: "flex-start"
      },
      center: {
        alignItems: "center"
      },
      end: {
        alignItems: "flex-end"
      },
      stretch: {
        alignItems: "stretch"
      }
    },
    gap: flexGapVariants,
    flex: {
      1: {
        flex: 1
      },
      none: {
        flex: "none"
      }
    }
  }
});

// src/Button/Button.tsx
import * as React from "react";

// src/Button/BaseButton.tsx
var BaseButton = styled("button", {
  // Reset
  all: "unset",
  alignItems: "center",
  boxSizing: "border-box",
  userSelect: "none",
  "&::before": {
    boxSizing: "border-box"
  },
  "&::after": {
    boxSizing: "border-box"
  },
  // Custom reset?
  display: "inline-flex",
  gap: "$1",
  flexShrink: 0,
  justifyContent: "center",
  lineHeight: "$2",
  WebkitTapHighlightColor: "rgba(0,0,0,0)",
  // Custom
  fontFamily: "$primary",
  fontSize: "$2",
  fontWeight: "$medium",
  fontVariantNumeric: "tabular-nums",
  borderRadius: "$rounded",
  padding: "8px 12px",
  variants: {
    compact: {
      true: {
        padding: "4px 8px"
      }
    },
    iconLeft: {
      true: {
        svg: {
          width: "$sizes$5",
          height: "$sizes$5"
        },
        paddingLeft: "8px"
      }
    },
    iconRight: {
      true: {
        svg: {
          width: "$sizes$5",
          height: "$sizes$5"
        },
        paddingRight: "8px"
      }
    },
    iconOnly: {
      true: {
        padding: "8px"
      }
    },
    modifiedRightBorder: {
      true: {
        borderRightWidth: "1px",
        borderRightStyle: "solid"
      }
    },
    variant: {
      primary: {
        backgroundColor: "$blue50",
        color: "$neutral0",
        "&:disabled": {
          backgroundColor: "$neutral20",
          color: "$neutral40",
          pointerEvents: "none"
        },
        "&:hover": {
          background: "linear-gradient(0deg, rgba(31, 37, 44, 0.16), rgba(31, 37, 44, 0.16)), $blue50"
        },
        "&:active": {
          background: "linear-gradient(0deg, rgba(239, 240, 245, 0.16), rgba(239, 240, 245, 0.16)), $blue50"
        },
        "&:focus": {
          boxShadow: "0px 0px 0px 2px $colors$blue30",
          background: "$blue50"
        }
      },
      default: {
        backgroundColor: "$neutral20",
        color: "$neutral80",
        "&:disabled": {
          backgroundColor: "$button_disabled_background",
          color: "$button_disabled_text",
          pointerEvents: "none"
        },
        "&:hover": {
          backgroundColor: "$button_default_background_hover"
        },
        "&:active": {
          backgroundColor: "$button_default_background_active"
        },
        "&:focus": {
          boxShadow: "0px 0px 0px 2px $colors$button_primary_border_focus",
          backgroundColor: "$neutral20"
        }
      },
      warning: {
        backgroundColor: "$yellow50",
        color: "$neutral80",
        "&:disabled": {
          backgroundColor: "$neutral20",
          color: "$neutral40",
          pointerEvents: "none"
        },
        "&:hover": {
          background: "linear-gradient(0deg, rgba(31, 37, 44, 0.16), rgba(31, 37, 44, 0.16)), $yellow50"
        },
        "&:active": {
          background: "linear-gradient(0deg, rgba(239, 240, 245, 0.16), rgba(239, 240, 245, 0.16)), $yellow50"
        },
        "&:focus": {
          boxShadow: "0px 0px 0px 2px $colors$yellow30",
          background: "$yellow50"
        }
      },
      danger: {
        backgroundColor: "$red50",
        color: "$neutral0",
        "&:disabled": {
          backgroundColor: "$neutral20",
          color: "$neutral40",
          pointerEvents: "none"
        },
        "&:hover": {
          background: "linear-gradient(0deg, rgba(31, 37, 44, 0.16), rgba(31, 37, 44, 0.16)), $red50"
        },
        "&:active": {
          background: "linear-gradient(0deg, rgba(239, 240, 245, 0.16), rgba(239, 240, 245, 0.16)), $red50"
        },
        "&:focus": {
          boxShadow: "0px 0px 0px 2px $colors$red30",
          background: "$red50"
        }
      },
      subtle: {
        backgroundColor: "$button_subtle_background_enabled",
        color: "$neutral70",
        "&:disabled": {
          backgroundColor: "rgba(255, 255, 255, 1e-05)",
          color: "$neutral40",
          pointerEvents: "none"
        },
        "&:hover": {
          background: "$button_subtle_background_hover"
        },
        "&:active": {
          background: "$button_subtle_background_active"
        },
        '&:where([data-state="open"])': {
          background: "$button_subtle_background_active"
        },
        "&:focus": {
          boxShadow: "0px 0px 0px 2px $colors$button_primary_border_focus",
          background: "$button_subtle_background_enabled"
        }
      },
      subtleDanger: {
        backgroundColor: "$button_subtle_background_enabled",
        color: "$neutral70",
        "&:disabled": {
          backgroundColor: "rgba(255, 255, 255, 1e-05)",
          color: "$neutral40",
          pointerEvents: "none"
        },
        "&:hover": {
          background: "$button_danger_background_hover",
          color: "$neutral0"
        },
        "&:active": {
          background: "$button_subtle_background_active",
          color: "$neutral0"
        },
        '&:where([data-state="open"])': {
          background: "$button_subtle_background_active"
        },
        "&:focus": {
          boxShadow: "0px 0px 0px 2px $colors$button_primary_border_focus",
          background: "$button_subtle_background_enabled"
        }
      },
      inverse: {
        backgroundColor: "$neutral0",
        color: "$neutral80",
        fontSize: "$2",
        fontStyle: "normal",
        lineHeight: "$2",
        border: "1px solid rgba(53, 65, 78, 0.24)",
        "&:hover": {
          background: "$blue10",
          color: "$blue50",
          border: "1px solid $blue50"
        }
        // TODO: We're using inverse in ButtonGroup, which is a bit of a hack.
        //       We should probably just use a different component for that.
        //       Commenting the psuedo states out for now so they don't override.
        // '&:active': {
        //   background: '$blue10',
        //   color: '$blue50',
        //   border: '1px solid $blue50',
        // },
        // '&:focus': {
        //   background: '$blue10',
        //   color: '$blue50',
        //   border: '1px solid $blue50',
        // },
      },
      inverted: {
        backgroundColor: "$neutral0",
        color: "$neutral80",
        fontSize: "$2",
        fontStyle: "normal",
        lineHeight: "$2",
        border: "1px solid rgba(53, 65, 78, 0.24)",
        "&:hover": {
          background: "$blue10",
          color: "$blue50",
          border: "1px solid $blue50"
        },
        "&:active": {
          background: "$blue10",
          color: "$blue50",
          border: "1px solid $blue50"
        },
        "&:focus": {
          boxShadow: "0px 0px 0px 2px rgba(16, 106, 242, 0.72)",
          border: "none"
        }
      },
      active: {
        backgroundColor: "$neutral0",
        fontSize: "$2",
        fontStyle: "normal",
        lineHeight: "$2",
        background: "$blue10",
        color: "$blue50",
        border: "1px solid $blue50"
      },
      filter: {
        boxSizing: "border-box",
        fontWeight: "$regular",
        border: "1px solid rgba(53, 65, 78, 0.24)",
        background: "$neutral0",
        color: "$neutral80",
        "&:hover": {
          background: "rgba(31, 37, 44, 0.08)"
        },
        "&:focus": {
          boxShadow: "0px 0px 0px 2px $colors$blue40",
          background: "$neutral0"
        },
        "&:focus:not(:active)": {
          borderColor: "$blue40",
          boxShadow: "0px 0px 0px 2px $colors$blue40",
          background: "$neutral0"
        },
        "&:active": {
          boxShadow: "none",
          background: "rgba(31, 37, 44, 0.12)"
        },
        "&:focus:active": {
          background: "rgba(31, 37, 44, 0.12)"
        },
        "&[data-state=open]": {
          background: "rgba(31, 37, 44, 0.12)"
        },
        "&[aria-expanded=true]": {
          background: "rgba(31, 37, 44, 0.12)"
        }
      },
      filterApplied: {
        fontWeight: "$medium",
        background: "rgba(170, 202, 255, 0.36)",
        border: "1px solid rgba(0, 61, 166, 0.24)",
        color: "$filter_button_filters_selected_color",
        "&:hover": {
          background: "rgba(170, 202, 255, 0.64)"
        },
        "&:focus": {
          background: "rgba(170, 202, 255, 0.36)"
        },
        "&:focus:not(:active)": {
          borderColor: "$blue40",
          background: "rgba(170, 202, 255, 0.36)"
        },
        "&:active": {
          background: "rgba(170, 202, 255, 0.72)"
        },
        "&:focus:active": {
          background: "rgba(170, 202, 255, 0.72)"
        },
        "&[data-state=open]": {
          background: "rgba(170, 202, 255, 0.72)"
        },
        "&[aria-expanded=true]": {
          background: "rgba(170, 202, 255, 0.72)"
        }
      },
      input: {
        fontWeight: "$regular",
        outline: "none",
        backgroundColor: "$input_background_enabled",
        color: "$input_default_text_enabled",
        fontVariantNumeric: "tabular-nums",
        border: "1px solid $colors$input_default_border_enabled",
        ".selectIcon": {
          color: "$input_default_text_enabled"
        },
        "&:focus": {
          boxShadow: "$primary_focus",
          borderColor: "$input_default_border_active"
        },
        "&[data-state=open]": {
          boxShadow: "$primary_focus",
          borderColor: "$input_default_border_active"
        },
        "&[aria-expanded=true]": {
          boxShadow: "$primary_focus",
          borderColor: "$input_default_border_active"
        },
        "&:disabled": {
          pointerEvents: "none",
          color: "$input_default_text_disabled",
          borderColor: "$text_input_default_border_disabled",
          cursor: "not-allowed",
          "&[readonly]": {
            color: "$input_default_text_enabled !important",
            svg: {
              color: "$input_default_text_disabled"
            }
          }
        }
      },
      link: {
        gap: "$1",
        padding: "0px",
        cursor: "pointer",
        backgroundColor: "$neutral0",
        color: "$blue50",
        "&:disabled": {
          backgroundColor: "$neutral0",
          color: "$neutral40",
          pointerEvents: "none"
        },
        "&:hover": {
          textDecoration: "underline"
        },
        "&:active": {
          color: "$blue70",
          textDecoration: "underline"
        },
        "&:focus": {
          textDecoration: "underline"
        }
      },
      primaryWhite: {
        backgroundColor: "$neutral0",
        color: "$blue60",
        "&:disabled": {
          backgroundColor: "$neutral20",
          color: "$neutral40",
          pointerEvents: "none"
        },
        "&:hover": {
          backgroundColor: "$button_primary_surface_hover",
          color: "$neutral0"
        },
        "&:active": {
          background: "$button_primary_surface_active",
          color: "$neutral0"
        },
        "&:focus": {
          boxShadow: "0px 0px 0px 2px $colors$blue30",
          background: "$blue50",
          color: "$neutral0"
        }
      }
    }
  },
  compoundVariants: [
    {
      variant: "link",
      compact: true,
      css: {
        padding: "0px",
        fontSize: "$1"
      }
    },
    {
      compact: true,
      iconLeft: true,
      css: {
        svg: {
          width: "$sizes$4",
          height: "$sizes$4"
        },
        paddingLeft: "4px"
      }
    },
    {
      compact: true,
      iconRight: true,
      css: {
        svg: {
          width: "$sizes$4",
          height: "$sizes$4"
        },
        paddingRight: "4px"
      }
    },
    {
      compact: true,
      iconOnly: true,
      css: {
        padding: "6px"
      }
    },
    {
      compact: true,
      variant: "filter",
      css: {
        padding: "$1 $1 $1 $2",
        height: 28
      }
    },
    {
      compact: true,
      variant: "filterApplied",
      css: {
        padding: "$1 $1 $1 $2",
        height: 28
      }
    },
    {
      modifiedRightBorder: true,
      variant: "primary",
      css: {
        borderRightColor: "$colors$blue40",
        "&:disabled": {
          borderRightColor: "$colors$neutral30"
        }
      }
    },
    {
      modifiedRightBorder: true,
      variant: "default",
      css: {
        borderRightColor: "$colors$neutral40",
        "&:disabled": {
          borderRightColor: "$colors$neutral30"
        }
      }
    }
  ],
  defaultVariants: {
    variant: "default"
  }
});

// src/Button/Button.tsx
import { jsx as jsx1442, jsxs as jsxs22 } from "react/jsx-runtime";
var Button = React.forwardRef(
  (props, ref) => {
    const _a = props, {
      children,
      variant = "default",
      compact = false,
      disabled = false,
      onClick,
      icon = null,
      modifiedRightBorder = false,
      loading = false
    } = _a, rest = __objRest(_a, [
      "children",
      "variant",
      "compact",
      "disabled",
      "onClick",
      "icon",
      "modifiedRightBorder",
      "loading"
    ]);
    return /* @__PURE__ */ jsxs22(
      BaseButton,
      __spreadProps(__spreadValues({
        ref,
        variant,
        compact,
        onClick,
        disabled: disabled || loading,
        iconLeft: !!icon && icon.position !== "right",
        iconRight: !!icon && icon.position === "right",
        iconOnly: !!icon && !children,
        modifiedRightBorder
      }, rest), {
        children: [
          icon && icon.position !== "right" && /* @__PURE__ */ jsx1442(Icon_default, { name: loading ? "arrows-rotate" : icon.name, size: "sm" }),
          children,
          icon && icon.position === "right" && /* @__PURE__ */ jsx1442(Icon_default, { name: loading ? "arrows-rotate" : icon.name, size: "sm" })
        ]
      })
    );
  }
);

// src/Text/Text.tsx
var Text = styled("span", {
  // Reset
  lineHeight: "$1",
  fontWeight: "$regular",
  margin: "0",
  display: "block",
  fontFamily: "$primary",
  "& b, & strong": {
    fontWeight: "$medium"
  },
  variants: {
    size: {
      1: { fontSize: "$1" },
      2: { fontSize: "$2" },
      3: { fontSize: "$3" },
      4: { fontSize: "$4" },
      5: { fontSize: "$5" },
      6: { fontSize: "$6" }
    },
    variant: {
      default: { color: "$neutral90" },
      description: { color: "$neutral60" },
      disabled: { color: "$neutral50" },
      subtle: { color: "$neutral40" },
      primary: { color: "$blue50" },
      secondary: { color: "$neutral70" },
      success: { color: "$green50" },
      warning: { color: "$yellow50" },
      danger: { color: "$red50" }
    }
  },
  defaultVariants: {
    size: "$3",
    variant: "$default"
  }
});

// src/Label/Label.tsx
import { t } from "@kandji-inc/nectar-i18n";
import * as React2 from "react";

// src/Label/BaseLabel.tsx
import * as LabelPrimitive from "@radix-ui/react-label";
var colorNeutral50 = {
  color: "$neutral50"
};
var BaseLabel = styled(LabelPrimitive.Root, Text, {
  display: "flex",
  alignItems: "center",
  gap: "4px",
  verticalAlign: "middle",
  cursor: "default",
  fontSize: "$2",
  color: "$neutral90",
  variants: {
    disabled: {
      true: colorNeutral50
    },
    viewOnly: {
      true: {
        color: "$input_default_text_enabled !important",
        svg: {
          color: "$input_default_text_disabled"
        }
      }
    },
    clickable: {
      true: {
        cursor: "pointer"
      }
    },
    above: {
      true: {
        color: "$neutral70",
        fontWeight: "$medium"
      }
    }
  },
  // This compund variant prioritizes the disabled color when both apply
  compoundVariants: [
    {
      above: true,
      disabled: true,
      css: colorNeutral50
    }
  ]
});
var OptionalText = styled(Text, {});

// src/Label/Label.tsx
import { jsx as jsx1443, jsxs as jsxs23 } from "react/jsx-runtime";
var Label = React2.forwardRef(
  (props, forwardedRef) => {
    const _a = props, { children, optional, optionalText } = _a, labelProps = __objRest(_a, ["children", "optional", "optionalText"]);
    return /* @__PURE__ */ jsxs23(BaseLabel, __spreadProps(__spreadValues({}, labelProps), { ref: forwardedRef, children: [
      /* @__PURE__ */ jsx1443("span", { children }),
      optional && /* @__PURE__ */ jsx1443(OptionalText, { variant: "disabled", children: optionalText || t("(optional)") })
    ] }));
  }
);

// src/Counter/Counter.tsx
var Counter = styled("span", {
  all: "unset",
  display: "inline-flex",
  alignItems: "center",
  padding: "2px 6px",
  borderRadius: "20px",
  fontFamily: "$primary",
  fontWeight: "$medium",
  lineHeight: "$1",
  fontSize: "$1",
  variants: {
    variant: {
      default: {
        backgroundColor: "$counter_default_background_enabled",
        color: "$counter_default_text_enabled"
      },
      disabled: {
        backgroundColor: "$counter_default_background_disabled",
        color: "$counter_default_text_disabled"
      },
      strong: {
        backgroundColor: "$counter_strong_background_enabled",
        color: "$counter_strong_text_enabled"
      }
    }
  },
  defaultVariants: {
    variant: "default"
  }
});

// src/DropdownMenu/BaseDropdown.tsx
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
var dropdownSizeTokens = {
  $$xxs: "80px",
  $$xs: "160px",
  $$sm: "240px",
  $$md: "320px",
  $$lg: "480px"
};
var DropdownMenuContent = styled(
  DropdownMenuPrimitive.Content,
  {
    height: "min-content",
    padding: "$1 0px",
    background: "$neutral0",
    filter: "drop-shadow($elevation2)",
    borderRadius: "$rounded"
  },
  cssUtils
);
var DropdownMenuArrow = styled(DropdownMenuPrimitive.Arrow, {
  fill: "$neutral0",
  width: "$3",
  height: "$2"
});
var DropdownMenuDivider = styled(DropdownMenuPrimitive.Separator, {
  height: "1px",
  backgroundColor: "$dropdown_default_divider_enabled",
  margin: "$1 0px"
});
var DropdownMenuItemControlStyles = {
  width: 14,
  height: 14,
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0
};
var DropdownMenuItemControl = styled(
  Flex,
  DropdownMenuItemControlStyles
);
var DropdownMenuItemIcon = styled(
  Icon_default,
  {
    fill: "$neutral90"
  },
  DropdownMenuItemControl
);
var DropdownMenuItem = styled(DropdownMenuPrimitive.Item, {
  all: "unset",
  padding: "6px $3",
  userSelect: "none",
  display: "flex",
  alignItems: "center",
  fontSize: "$2",
  gap: "$1",
  cursor: "pointer",
  // These are common across all theme variants
  backgroundColor: "$neutral0",
  "&[data-highlighted]": {
    backgroundColor: "#505E7129"
  },
  "&:active": {
    backgroundColor: "#505E713D"
  },
  "&[data-disabled]": {
    backgroundColor: "$neutral0",
    cursor: "not-allowed"
  },
  variants: {
    theme: {
      default: {
        color: "$neutral90",
        "&[data-disabled]": {
          color: "#35414E7A"
        }
      },
      danger: {
        color: "$red50",
        "&[data-disabled]": {
          color: "#DB30257A"
        }
      },
      action: {
        color: "$blue50",
        "&[data-disabled]": {
          color: "#106AF27A"
        }
      }
    },
    selected: {
      true: {
        background: "$dropdown_surface_selected_enabled",
        color: "$dropdown_content_selected",
        "&:hover": {
          background: "$dropdown_surface_selected_hover"
        },
        "&:active": {
          background: "$dropdown_surface_selected_active"
        }
      }
    },
    noHighlight: {
      true: {
        "&[data-highlighted]": {
          backgroundColor: "transparent"
        }
      }
    }
  },
  defaultVariants: {
    theme: "default"
  }
});
var DropdownMenuSubMenu = styled(DropdownMenuPrimitive.Sub, {});
var DropdownMenuSubMenuTrigger = styled(
  DropdownMenuPrimitive.SubTrigger,
  {
    all: "unset",
    padding: "6px $3",
    userSelect: "none",
    display: "flex",
    alignItems: "center",
    fontSize: "$2",
    gap: "$3",
    cursor: "pointer",
    variants: {
      theme: {
        default: {
          backgroundColor: "$neutral0",
          '&[data-state="open"]': {
            backgroundColor: "#505E7129"
          }
        },
        danger: {},
        action: {
          background: "$dropdown_surface_selected_enabled",
          color: "$blue50",
          '&[data-state="open"]': {
            background: "$dropdown_surface_selected_hover"
          }
        }
      }
    },
    defaultVariants: {
      theme: "default"
    }
  }
);
var DropdownMenuSubContent = styled(DropdownMenuPrimitive.SubContent, {
  height: "min-content",
  background: "$neutral0",
  filter: "drop-shadow($elevation3)",
  borderRadius: "$rounded",
  borderTopLeftRadius: "$none"
});
var DropdownMenuSectionLabel = styled(DropdownMenuPrimitive.Label, {
  fontFamily: "$primary",
  fontSize: "$1",
  fontWeight: 500,
  lineHeight: "$1",
  letterSpacing: "$3",
  textTransform: "uppercase",
  color: "$dropdown_default_sectiontext_enabled"
});
var DropdownMenuFooterContainer = styled(Flex, {
  justifyContent: "space-between",
  py: "$2",
  px: "$3",
  "& [data-action]": {
    fontWeight: "$medium"
  }
});
var DropdownMenuItemIndicator = styled(DropdownMenuPrimitive.ItemIndicator, {
  position: "absolute",
  right: 12,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center"
});
var DropdownMenuCheckboxItem = styled(
  DropdownMenuPrimitive.CheckboxItem,
  {
    display: "flex",
    padding: "6px 12px",
    alignItems: "center",
    gap: "4px",
    alignSelf: "stretch",
    fontSize: "$2",
    border: "2px solid transparent",
    "&[data-highlighted]": {
      border: "2px solid $colors$dropdown_ring_focus"
    },
    '&[data-state="checked"]': {
      background: "$dropdown_surface_selected_enabled",
      color: "$dropdown_content_selected",
      "&:hover": {
        background: "$dropdown_surface_selected_hover"
      },
      "&:active": {
        background: "$dropdown_surface_selected_active"
      }
    }
  }
);
var DropdownMenuPrimitives = {
  Content: DropdownMenuContent,
  Divider: DropdownMenuDivider,
  Item: DropdownMenuItem,
  SubMenu: DropdownMenuSubMenu,
  SubMenuTrigger: DropdownMenuSubMenuTrigger,
  SubMenuContent: DropdownMenuSubContent,
  Label: DropdownMenuSectionLabel,
  Arrow: DropdownMenuArrow,
  Root: DropdownMenuPrimitive.Root,
  Trigger: DropdownMenuPrimitive.Trigger,
  Portal: DropdownMenuPrimitive.Portal,
  CheckboxItem: DropdownMenuCheckboxItem,
  // RadioItemUnstyled: DropdownMenuPrimitive.RadioItem, // TODO: will add back in when we need it
  ItemIndicator: DropdownMenuItemIndicator
};

// src/Hint/Hint.tsx
import * as React3 from "react";

// src/Hint/BaseHint.tsx
var HintWrapper = styled("div", {
  display: "flex",
  alignItems: "start",
  justifyContent: "end",
  gap: "4px",
  variants: {
    variant: {
      default: {
        svg: {
          color: "$neutral60"
        }
      },
      error: {
        svg: {
          color: "$red50"
        }
      },
      success: {
        svg: {
          color: "$green50"
        }
      },
      warning: {
        span: {
          color: "$yellow60"
        },
        svg: {
          color: "$yellow60"
        }
      }
    }
  }
});
var CharacterCount = styled(Text, {});
var BaseHint = styled(Text, {
  width: "100%",
  wordWrap: "break-word"
});

// src/Hint/hintUtils.ts
function getIconName(variant) {
  switch (variant) {
    case "error":
      return "octagon-exclamation";
    case "success":
      return "circle-check";
    case "warning":
      return "diamond-exclamation";
    default:
      return "circle-info";
  }
}
function isCharCountReached(charCounter) {
  const { count = 0, max } = charCounter;
  return count >= max;
}

// src/Hint/Hint.tsx
import { Fragment, jsx as jsx1444, jsxs as jsxs24 } from "react/jsx-runtime";
var Hint = React3.forwardRef(
  (props, forwardedRef) => {
    const _a = props, { label, variant = "default", icon, charCounter } = _a, rest = __objRest(_a, ["label", "variant", "icon", "charCounter"]);
    const textVariant = {
      default: { "@initial": "description" },
      error: { "@initial": "danger" },
      success: { "@initial": "success" },
      warning: { "@initial": "warning" }
    };
    const wrapperVariant = {
      default: { "@initial": "default" },
      error: { "@initial": "error" },
      success: { "@initial": "success" },
      warning: { "@initial": "warning" }
    };
    return /* @__PURE__ */ jsxs24(HintWrapper, __spreadProps(__spreadValues({ variant: wrapperVariant[variant] }, rest), { children: [
      label && /* @__PURE__ */ jsxs24(Fragment, { children: [
        icon !== "omit" && /* @__PURE__ */ jsx1444(Icon_default, { size: "sm", name: icon || getIconName(variant) }),
        /* @__PURE__ */ jsx1444(
          BaseHint,
          {
            size: "1",
            variant: textVariant[variant],
            ref: forwardedRef,
            children: label
          }
        )
      ] }),
      charCounter && /* @__PURE__ */ jsxs24(
        CharacterCount,
        {
          size: "1",
          variant: isCharCountReached(charCounter) ? textVariant.error : textVariant.default,
          children: [
            charCounter.count,
            "/",
            charCounter.max
          ]
        }
      )
    ] }));
  }
);

// src/DropdownMenu/DropdownMenu.tsx
import { t as t2 } from "@kandji-inc/nectar-i18n";
import * as DropdownMenuPrimitive2 from "@radix-ui/react-dropdown-menu";
import React4, { useState } from "react";
import { Fragment as Fragment2, jsx as jsx1445, jsxs as jsxs25 } from "react/jsx-runtime";
var typeaheadSearchDisabler = {
  toLowerCase: () => ({
    startsWith: () => false
  })
};
var DropdownMenu = (props) => {
  const _a = props, {
    children,
    withArrow = true,
    defaultOpen,
    handleOpenChange,
    options,
    footer,
    contentProps = {
      align: "center",
      preventOutsideInteraction: false,
      container: void 0,
      side: void 0
    },
    portalProps = {},
    itemProps = {
      preventMenuCloseOnSelect: false,
      preventWithinItemFocus: false,
      preventLeaveItemBlur: false,
      disableTypeaheadSearch: false
    },
    testId,
    css: css2
  } = _a, rest = __objRest(_a, [
    "children",
    "withArrow",
    "defaultOpen",
    "handleOpenChange",
    "options",
    "footer",
    "contentProps",
    "portalProps",
    "itemProps",
    "testId",
    "css"
  ]);
  const [cssUtils2] = extractCssUtilsFromProps(rest);
  const [isOpen, setIsOpen] = useState(defaultOpen || false);
  const renderOption = (option) => {
    const _a2 = option, {
      render: RenderComp,
      label,
      icon,
      iconPosition = "left",
      onClick,
      theme: theme2,
      testId: optionTestId,
      subMenuProps
    } = _a2, renderProps = __objRest(_a2, [
      "render",
      "label",
      "icon",
      "iconPosition",
      "onClick",
      "theme",
      "testId",
      "subMenuProps"
    ]);
    if (!RenderComp) {
      return /* @__PURE__ */ jsxs25(Fragment2, { children: [
        icon && iconPosition === "left" && /* @__PURE__ */ jsx1445(DropdownMenuItemIcon, { name: icon }),
        /* @__PURE__ */ jsx1445(Text, { size: "2", css: { lineHeight: "$2", width: "100%" }, children: label }),
        subMenuProps && /* @__PURE__ */ jsxs25(Flex, { alignItems: "center", gap: "sm", children: [
          typeof (subMenuProps == null ? void 0 : subMenuProps.count) === "number" && /* @__PURE__ */ jsx1445(Counter, { variant: "strong", children: subMenuProps == null ? void 0 : subMenuProps.count }),
          (subMenuProps == null ? void 0 : subMenuProps.subMenu) && /* @__PURE__ */ jsx1445(Icon_default, { name: "fa-angle-right-small", size: "sm" })
        ] }),
        icon && iconPosition === "right" && !(subMenuProps == null ? void 0 : subMenuProps.subMenu) && /* @__PURE__ */ jsx1445(DropdownMenuItemIcon, { name: icon })
      ] });
    }
    const optionProps = { label, icon, onClick, theme: theme2, testId: optionTestId };
    return /* @__PURE__ */ jsx1445(RenderComp, __spreadValues(__spreadValues({}, optionProps), renderProps));
  };
  const renderFooter = () => {
    if (!(footer == null ? void 0 : footer.type) || typeof (footer == null ? void 0 : footer.type) !== "string") {
      return null;
    }
    switch (footer.type) {
      case "filter":
        return /* @__PURE__ */ jsx1445(
          DropdownMenuFilterFooter,
          {
            setIsOpen,
            handleApply: footer.handleApply,
            handleClear: footer.handleClear,
            handleCancel: footer.handleCancel,
            showApply: footer.showApply,
            showClear: footer.showClear,
            showCancel: footer.showCancel,
            applyDisabled: footer.applyDisabled,
            clearDisabled: footer.clearDisabled,
            cancelDisabled: footer.cancelDisabled,
            closeOnApply: footer.closeOnApply,
            closeOnClear: footer.closeOnClear,
            closeOnCancel: footer.closeOnCancel,
            applyLabel: footer.applyLabel,
            clearLabel: footer.clearLabel,
            cancelLabel: footer.cancelLabel,
            testId: footer.testId
          }
        );
      default:
        return null;
    }
  };
  return /* @__PURE__ */ jsxs25(
    DropdownMenuPrimitive2.Root,
    {
      open: isOpen,
      onOpenChange: (o) => {
        const continueToSetOpen = handleOpenChange == null ? void 0 : handleOpenChange(o, {
          setIsOpen
        });
        if (continueToSetOpen !== false) {
          setIsOpen(o);
        }
      },
      modal: false,
      children: [
        /* @__PURE__ */ jsx1445(DropdownMenuPrimitive2.Trigger, { asChild: true, children }),
        /* @__PURE__ */ jsx1445(DropdownMenuPrimitive2.Portal, __spreadProps(__spreadValues({}, portalProps), { children: /* @__PURE__ */ jsxs25(
          DropdownMenuContent,
          __spreadProps(__spreadValues({
            "data-testid": testId,
            css: css2,
            sideOffset: 4,
            align: contentProps == null ? void 0 : contentProps.align,
            side: contentProps == null ? void 0 : contentProps.side,
            onInteractOutside: (contentProps == null ? void 0 : contentProps.preventOutsideInteraction) ? (e) => e.preventDefault() : () => {
            }
          }, cssUtils2), {
            children: [
              options.map((opt, idx) => {
                const {
                  label = "",
                  icon = "",
                  theme: theme2 = "default",
                  onClick,
                  subMenuProps
                } = opt;
                if (subMenuProps == null ? void 0 : subMenuProps.subMenu) {
                  const { subMenu: SubMenu, count } = subMenuProps;
                  const hasCount = typeof count === "number";
                  const countTheme = hasCount ? "action" : "default";
                  return /* @__PURE__ */ jsxs25(DropdownMenuSubMenu, { children: [
                    /* @__PURE__ */ jsx1445(DropdownMenuSubMenuTrigger, { theme: countTheme || theme2, children: renderOption(opt) }),
                    /* @__PURE__ */ jsx1445(DropdownMenuPrimitive2.Portal, { children: /* @__PURE__ */ jsx1445(DropdownMenuSubContent, { children: SubMenu }) })
                  ] });
                }
                return /* @__PURE__ */ jsx1445(
                  DropdownMenuItem,
                  {
                    theme: theme2,
                    textValue: itemProps.disableTypeaheadSearch ? typeaheadSearchDisabler : void 0,
                    onSelect: (e) => {
                      if (itemProps == null ? void 0 : itemProps.preventMenuCloseOnSelect) {
                        e.preventDefault();
                      }
                    },
                    onPointerMove: (e) => {
                      if (itemProps == null ? void 0 : itemProps.preventWithinItemFocus) {
                        e.preventDefault();
                      }
                    },
                    onPointerLeave: (e) => {
                      if (itemProps == null ? void 0 : itemProps.preventLeaveItemBlur) {
                        e.preventDefault();
                      }
                    },
                    onClick: (e) => {
                      e.stopPropagation();
                      if (opt == null ? void 0 : opt.disabled) {
                        return;
                      }
                      onClick == null ? void 0 : onClick(e);
                    },
                    "data-testid": opt == null ? void 0 : opt.testId,
                    disabled: opt == null ? void 0 : opt.disabled,
                    selected: opt == null ? void 0 : opt.selected,
                    children: renderOption(opt)
                  },
                  `${label || idx}_${icon}_${theme2}`
                );
              }),
              withArrow && /* @__PURE__ */ jsx1445(DropdownMenuArrow, {}),
              renderFooter()
            ]
          })
        ) }))
      ]
    }
  );
};
var DropdownMenuFilterFooter = React4.forwardRef(
  ({
    setIsOpen = () => {
    },
    handleApply,
    handleClear,
    handleCancel,
    showApply = true,
    showClear = true,
    showCancel = true,
    applyDisabled = false,
    clearDisabled = false,
    cancelDisabled = false,
    closeOnApply = true,
    closeOnClear = false,
    closeOnCancel = true,
    applyLabel = t2("Apply"),
    clearLabel = t2("Reset"),
    cancelLabel = t2("Cancel"),
    testId,
    css: css2
  }, forwardedRef) => /* @__PURE__ */ jsxs25(
    DropdownMenuFooterContainer,
    {
      "data-testid": testId,
      ref: forwardedRef,
      css: css2,
      children: [
        showClear && /* @__PURE__ */ jsx1445(
          Button,
          {
            compact: true,
            variant: "subtle",
            "data-action": "clear",
            disabled: clearDisabled,
            onClick: (e) => {
              handleClear == null ? void 0 : handleClear(e, {
                setIsOpen
              });
              if (closeOnClear) {
                setIsOpen(false);
              }
            },
            children: clearLabel
          }
        ),
        /* @__PURE__ */ jsxs25(Flex, { gap: "xs", children: [
          showCancel && /* @__PURE__ */ jsx1445(
            Button,
            {
              compact: true,
              variant: "default",
              "data-action": "cancel",
              disabled: cancelDisabled,
              onClick: (e) => {
                handleCancel == null ? void 0 : handleCancel(e, {
                  setIsOpen
                });
                if (closeOnCancel) {
                  setIsOpen(false);
                }
              },
              children: cancelLabel
            }
          ),
          showApply && /* @__PURE__ */ jsx1445(
            Button,
            {
              compact: true,
              variant: "primary",
              "data-action": "apply",
              disabled: applyDisabled,
              onClick: (e) => {
                const continueToClose = handleApply == null ? void 0 : handleApply(e, {
                  setIsOpen
                });
                if (continueToClose === false) {
                  return;
                }
                if (closeOnApply) {
                  setIsOpen(false);
                }
              },
              children: applyLabel
            }
          )
        ] })
      ]
    }
  )
);

// src/TextField/TextField.tsx
import * as React5 from "react";

// src/TextField/BaseTextField.tsx
var BaseTextField = styled("input", {
  // Reset
  appearance: "none",
  borderWidth: "0",
  boxSizing: "border-box",
  fontFamily: "inherit",
  margin: "0",
  outline: "none",
  padding: "8px 12px 8px 8px",
  width: "100%",
  WebkitTapHighlightColor: "rgba(0,0,0,0)",
  "&::before": {
    boxSizing: "border-box"
  },
  "&::after": {
    boxSizing: "border-box"
  },
  // Custom
  backgroundColor: "$input_background_enabled",
  color: "$input_default_text_enabled",
  fontVariantNumeric: "tabular-nums",
  border: "1px solid $colors$input_default_border_enabled",
  borderRadius: "$rounded",
  "&:focus": {
    boxShadow: "$primary_focus",
    borderColor: "$input_default_border_active"
  },
  "&::placeholder": {
    color: "$input_secondary_text_enabled"
  },
  "&:disabled": {
    pointerEvents: "none",
    backgroundColor: "$input_background_disabled",
    color: "$input_default_text_disabled",
    cursor: "not-allowed"
  },
  "&:read-only": {
    backgroundColor: "$input_background_readonly"
  },
  variants: {
    iconLeft: {
      true: {
        paddingLeft: "28px"
      }
    },
    // TODO: Remove the following two variants. Will require updating
    // kandji-web.
    showLoader: {
      true: {}
    },
    showClearButton: {
      true: {}
    },
    dateField: {
      true: {
        "&:read-only": {
          backgroundColor: "$input_background_enabled"
        }
      }
    },
    compact: {
      true: {
        height: "28px"
      }
    },
    state: {
      default: {},
      error: {
        borderColor: "$input_danger_border_enabled",
        "&:focus": {
          borderColor: "$input_danger_border_enabled",
          boxShadow: "$danger_focus"
        }
      },
      success: {
        borderColor: "$input_success_border_enabled",
        "&:focus": {
          borderColor: "$input_success_border_enabled",
          boxShadow: "$success_focus"
        }
      },
      warning: {
        borderColor: "$input_warning_border_enabled",
        "&:focus": {
          borderColor: "$input_warning_border_enabled",
          boxShadow: "$warning_focus"
        }
      }
    }
  },
  defaultVariants: {
    state: "default"
  },
  compoundVariants: [
    {
      showClearButton: true,
      showLoader: true,
      css: {
        paddingRight: "48px",
        svg: {
          right: "24px"
        }
      }
    }
  ]
});

// src/TextField/components/TextFieldLayout.tsx
var InnerTextFieldWrapper = styled(Flex, {
  position: "relative",
  width: "100%",
  height: "100%"
});
var rotate = keyframes({
  "0%": { transform: "rotate(0deg)" },
  "100%": { transform: "rotate(360deg)" }
});
var LoaderCircle = styled(Box_default2, {
  top: "3px",
  right: "4px",
  transform: "translate(-50%, -50%)",
  width: "32px",
  height: "32px",
  borderRadius: "$rounded-full",
  border: "2.5px solid $input_default_icon_active",
  borderTopColor: "transparent",
  animation: `${rotate} 1s linear infinite`
});
var IconWrapper = styled(Box_default2, {
  display: "flex",
  alignItems: "center",
  svg: {
    color: "$input_default_icon_enabled",
    height: "13px",
    width: "13px"
  },
  variants: {
    position: {
      left: {
        position: "absolute",
        left: "8px"
      },
      right: {
        position: "absolute",
        right: "8px"
      }
    },
    clearButton: {
      true: {
        cursor: "pointer",
        svg: {
          height: "12px",
          width: "12px"
        }
      }
    }
  }
});
var SearchSeparator = styled(Box_default2, {
  height: "calc(100% - 2px)",
  width: "0.5px",
  margin: "1px 0",
  backgroundColor: "$neutral20"
});
var SearchPaginationWrapper = styled(Flex, {
  alignItems: "center",
  fontSize: "11px",
  color: "$neutral90",
  "& svg": {
    width: "20px",
    height: "20px",
    color: "$neutral70",
    cursor: "pointer",
    borderRadius: "$rounded",
    "&:hover": {
      backgroundColor: "$button_default_background_hover"
    },
    "&:active": {
      backgroundColor: "$button_default_background_active"
    }
  }
});
var SearchExtrasWrapper = styled("div", {
  display: "flex",
  position: "absolute",
  width: "fit-content",
  height: "100%",
  right: 0,
  gap: "$1",
  "&:not(:empty)": {
    paddingRight: "6px",
    paddingLeft: "8px"
  }
});

// src/TextField/TextField.tsx
import { jsx as jsx1446, jsxs as jsxs26 } from "react/jsx-runtime";
var defaultComponentCss = {
  input: void 0,
  icon: void 0
};
var TextField = React5.forwardRef(
  (props, forwardedRef) => {
    var _d;
    const _a = props, {
      label,
      isOptional,
      placeholder,
      state = "default",
      icon,
      iconPosition = "left",
      onIconClick,
      hint,
      loading = false,
      disabled,
      compact,
      showClearButton = false,
      onClear,
      pagination,
      css: css2 = {},
      componentCss = defaultComponentCss
    } = _a, rest = __objRest(_a, [
      "label",
      "isOptional",
      "placeholder",
      "state",
      "icon",
      "iconPosition",
      "onIconClick",
      "hint",
      "loading",
      "disabled",
      "compact",
      "showClearButton",
      "onClear",
      "pagination",
      "css",
      "componentCss"
    ]);
    const [cssUtils2, _b] = extractCssUtilsFromProps(rest), _c = _b, { testId } = _c, restProps = __objRest(_c, ["testId"]);
    const extrasRef = React5.useRef(null);
    const uid = React5.useId();
    const elementId = (_d = rest.id) != null ? _d : uid;
    const [extrasWidth, setExtrasWidth] = React5.useState(0);
    React5.useEffect(() => {
      const resizeObserver = new ResizeObserver((entries) => {
        for (const entry of entries) {
          setExtrasWidth(entry.target.offsetWidth);
        }
      });
      if (extrasRef.current) {
        resizeObserver.observe(extrasRef.current);
      }
      return () => {
        if (extrasRef.current) {
          resizeObserver.unobserve(extrasRef.current);
        }
      };
    }, []);
    const childrenCss = React5.useMemo(
      () => ({
        input: componentCss.input || {},
        icon: componentCss.icon || {}
      }),
      [componentCss.input]
    );
    const hasExtras = (pagination == null ? void 0 : pagination.visible) || loading || showClearButton;
    return /* @__PURE__ */ jsxs26(Flex, __spreadProps(__spreadValues({ flow: "column", gap: "xs" }, cssUtils2), { css: css2, children: [
      label && /* @__PURE__ */ jsx1446(
        Label,
        {
          htmlFor: elementId,
          disabled,
          optional: isOptional,
          above: true,
          children: label
        }
      ),
      /* @__PURE__ */ jsxs26(InnerTextFieldWrapper, { alignItems: "center", gap: "sm", children: [
        icon && iconPosition === "left" && /* @__PURE__ */ jsx1446(IconWrapper, { position: "left", css: childrenCss.icon, children: /* @__PURE__ */ jsx1446(Icon_default, { name: icon }) }),
        /* @__PURE__ */ jsx1446(
          BaseTextField,
          __spreadProps(__spreadValues({}, restProps), {
            id: elementId,
            ref: forwardedRef,
            placeholder,
            iconLeft: !!icon && iconPosition === "left",
            showLoader: loading,
            disabled,
            compact,
            state,
            showClearButton,
            css: hasExtras ? __spreadValues({ paddingRight: `${extrasWidth}px` }, childrenCss.input) : __spreadValues({}, childrenCss.input),
            "data-testid": testId || restProps["data-testid"],
            onBlur: (e) => {
              var _a2, _b2;
              if ((pagination == null ? void 0 : pagination.visible) && ((_a2 = extrasRef.current) == null ? void 0 : _a2.contains(e.relatedTarget))) {
                e.target.focus();
                return;
              }
              (_b2 = rest.onBlur) == null ? void 0 : _b2.call(rest, e);
            }
          })
        ),
        icon && iconPosition === "right" && /* @__PURE__ */ jsx1446(IconWrapper, { position: "right", css: childrenCss.icon, children: /* @__PURE__ */ jsx1446(Icon_default, { name: icon, onClick: onIconClick }) }),
        /* @__PURE__ */ jsxs26(SearchExtrasWrapper, { ref: extrasRef, children: [
          (pagination == null ? void 0 : pagination.visible) && /* @__PURE__ */ jsx1446(SearchPaginationWrapper, { tabIndex: 0, children: /* @__PURE__ */ jsxs26(Flex, { alignItems: "center", css: { gap: "6px" }, children: [
            /* @__PURE__ */ jsx1446(Text, { children: `${pagination.current}/${pagination.max}` }),
            /* @__PURE__ */ jsxs26(Flex, { alignItems: "center", children: [
              /* @__PURE__ */ jsx1446(
                Icon_default,
                {
                  name: "fa-angle-up-small",
                  onClick: pagination.onNext
                }
              ),
              /* @__PURE__ */ jsx1446(
                Icon_default,
                {
                  name: "fa-angle-down-small",
                  onClick: pagination.onPrev
                }
              )
            ] })
          ] }) }),
          (pagination == null ? void 0 : pagination.visible) && (showClearButton || loading) && /* @__PURE__ */ jsx1446(SearchSeparator, {}),
          loading && /* @__PURE__ */ jsx1446(IconWrapper, { children: /* @__PURE__ */ jsx1446(LoaderCircle, {}) }),
          showClearButton && // biome-ignore lint/a11y/noPositiveTabindex: fix
          /* @__PURE__ */ jsx1446(IconWrapper, { clearButton: true, tabIndex: 1, children: /* @__PURE__ */ jsx1446(Icon_default, { name: "xmark", onClick: onClear }) })
        ] })
      ] }),
      hint && /* @__PURE__ */ jsx1446(Hint, __spreadProps(__spreadValues({}, hint), { variant: state }))
    ] }));
  }
);

// src/Separator/Separator.tsx
import * as SeparatorPrimitive from "@radix-ui/react-separator";
var Separator2 = styled(SeparatorPrimitive.Root, {
  border: "none",
  margin: 0,
  flexShrink: 0,
  backgroundColor: "$neutral20",
  cursor: "default",
  variants: {
    size: {
      "1": {
        '&[data-orientation="horizontal"]': {
          height: "1px",
          width: "100%"
        },
        '&[data-orientation="vertical"]': {
          width: "1px",
          height: "100%"
        }
      },
      "2": {
        '&[data-orientation="horizontal"]': {
          height: "2px",
          width: "100%"
        },
        '&[data-orientation="vertical"]': {
          width: "2px",
          height: "100%"
        }
      }
    }
  },
  defaultVariants: {
    size: "1"
  }
});

export {
  __spreadValues,
  __spreadProps,
  __restKey,
  __objRest,
  __async,
  theme,
  styled,
  config,
  css,
  keyframes,
  Xmark_default,
  Icon_default,
  marginUtilVariants,
  paddingUtilVariants,
  sizeUtilVariants,
  stackingUtilVariants,
  cssUtils,
  isCssUtilKeyGuard,
  extractCssUtilsFromProps,
  cn,
  Box_default2 as Box_default,
  flexGapVariants,
  Flex,
  BaseButton,
  Button,
  Text,
  Label,
  Counter,
  dropdownSizeTokens,
  DropdownMenuContent,
  DropdownMenuDivider,
  DropdownMenuItemControlStyles,
  DropdownMenuItem,
  DropdownMenuSectionLabel,
  DropdownMenuPrimitives,
  BaseTextField,
  Hint,
  DropdownMenu,
  DropdownMenuFilterFooter,
  TextField,
  SeparatorPrimitive,
  Separator2 as Separator
};
